(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobxReact"), require("mobx"), require("ReactDOM"), require("ecCom"), require("loadjs"), require("antd"), require("jQuery"), require("ReactRouter"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "mobxReact", "mobx", "ReactDOM", "ecCom", "loadjs", "antd", "jQuery", "ReactRouter"], factory);
	else if(typeof exports === 'object')
		exports["weaWorkflowForm"] = factory(require("React"), require("mobxReact"), require("mobx"), require("ReactDOM"), require("ecCom"), require("loadjs"), require("antd"), require("jQuery"), require("ReactRouter"));
	else
		root["weaWorkflowForm"] = factory(root["React"], root["mobxReact"], root["mobx"], root["ReactDOM"], root["ecCom"], root["loadjs"], root["antd"], root["jQuery"], root["ReactRouter"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_51__, __WEBPACK_EXTERNAL_MODULE_83__, __WEBPACK_EXTERNAL_MODULE_87__, __WEBPACK_EXTERNAL_MODULE_127__, __WEBPACK_EXTERNAL_MODULE_188__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpweaWorkflowForm"];
/******/ 	window["webpackJsonpweaWorkflowForm"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = (window[__webpack_require__.v] || "") + __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + ".chunk.js?v=" + {"0":"74db1308","1":"4e6cbb7e","2":"0bb378bc"}[chunkId] + "";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/workflow/static4form/";
/******/
/******/ 	// __webpack_content_path__
/******/ 	__webpack_require__.v = "ecologyContentPath";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 287);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _defineProperty = __webpack_require__(16);
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor)
                descriptor.writable = true;
            (0, _defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(299), __esModule: true };


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _typeof2 = __webpack_require__(35);
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _setPrototypeOf = __webpack_require__(317);
var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
var _create = __webpack_require__(197);
var _create2 = _interopRequireDefault(_create);
var _typeof2 = __webpack_require__(35);
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }
    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var getAntd=exports.getAntd=function getAntd(){return typeof window.antd==="undefined"?{}:window.antd;};var getEcCom=exports.getEcCom=function getEcCom(){return typeof window.ecCom==="undefined"?window.ecComSmall:window.ecCom;};var getComsMobx=exports.getComsMobx=function getComsMobx(){return typeof window.comsMobx==="undefined"?{}:window.comsMobx;};var getLabel=exports.getLabel=function getLabel(){var _getEcCom=getEcCom(),WeaLocaleProvider=_getEcCom.WeaLocaleProvider;return WeaLocaleProvider.getLabel.apply(WeaLocaleProvider,arguments);};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _assign = __webpack_require__(65);
var _assign2 = _interopRequireDefault(_assign);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.chunk=exports.sortedUniq=exports.filter=exports.slice=exports.forEach=exports.concat=exports.findIndex=exports.dropWhile=exports.includes=exports.cloneDeep=exports.merge=exports.forIn=exports.indexOf=exports.size=exports.get=exports.has=exports.isEqual=exports.trim=exports.isEmpty=undefined;var _isEmpty=__webpack_require__(334);var _isEmpty2=_interopRequireDefault(_isEmpty);var _trim=__webpack_require__(112);var _trim2=_interopRequireDefault(_trim);var _isEqual=__webpack_require__(358);var _isEqual2=_interopRequireDefault(_isEqual);var _has=__webpack_require__(392);var _has2=_interopRequireDefault(_has);var _get=__webpack_require__(224);var _get2=_interopRequireDefault(_get);var _size=__webpack_require__(397);var _size2=_interopRequireDefault(_size);var _indexOf=__webpack_require__(401);var _indexOf2=_interopRequireDefault(_indexOf);var _forIn=__webpack_require__(404);var _forIn2=_interopRequireDefault(_forIn);var _merge=__webpack_require__(408);var _merge2=_interopRequireDefault(_merge);var _cloneDeep=__webpack_require__(236);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _includes=__webpack_require__(438);var _includes2=_interopRequireDefault(_includes);var _dropWhile=__webpack_require__(441);var _dropWhile2=_interopRequireDefault(_dropWhile);var _findIndex=__webpack_require__(451);var _findIndex2=_interopRequireDefault(_findIndex);var _concat=__webpack_require__(452);var _concat2=_interopRequireDefault(_concat);var _forEach=__webpack_require__(455);var _forEach2=_interopRequireDefault(_forEach);var _slice=__webpack_require__(458);var _slice2=_interopRequireDefault(_slice);var _filter=__webpack_require__(459);var _filter2=_interopRequireDefault(_filter);var _sortedUniq=__webpack_require__(461);var _sortedUniq2=_interopRequireDefault(_sortedUniq);var _chunk=__webpack_require__(463);var _chunk2=_interopRequireDefault(_chunk);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.isEmpty=_isEmpty2.default;exports.trim=_trim2.default;exports.isEqual=_isEqual2.default;exports.has=_has2.default;exports.get=_get2.default;exports.size=_size2.default;exports.indexOf=_indexOf2.default;exports.forIn=_forIn2.default;exports.merge=_merge2.default;exports.cloneDeep=_cloneDeep2.default;exports.includes=_includes2.default;exports.dropWhile=_dropWhile2.default;exports.findIndex=_findIndex2.default;exports.concat=_concat2.default;exports.forEach=_forEach2.default;exports.slice=_slice2.default;exports.filter=_filter2.default;exports.sortedUniq=_sortedUniq2.default;exports.chunk=_chunk2.default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.changeSecLevel=exports.appendDefaultPath=exports.loadWaterMark=exports.getWfImportParams=exports.scrollDom=exports.bindTagTypeShowEvent=exports.isShowRightBtn=exports.appendContinuationParams=exports.showChart=exports.switchFormTabFunc=exports.switchFormTab=exports.getIframeUrl=exports.setFormPic=exports.requestImport=exports.getIntervenorDefaultV=exports.doDefinitionCallBackFun=exports.delRow=exports.showPrompt=exports.printPreViewPage=exports.judgePrintLogList=exports.loadScript=exports.convertNull=exports.reloadListPage=exports.printDuration=exports.closeRequestPage=exports.buildUrlStr=exports.gotoPage=exports.reloadRequestPage=exports.getPageTitle=exports.getBrowserVersion=exports.convertKeyCode=exports.bindResizeEvent=undefined;var _promise=__webpack_require__(98);var _promise2=_interopRequireDefault(_promise);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _secLevelUtil=__webpack_require__(125);var SecLevelUtil=_interopRequireWildcard(_secLevelUtil);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _analyzeData=__webpack_require__(56);var AI=_interopRequireWildcard(_analyzeData);var _lockUtil=__webpack_require__(482);var _invoiceUtil=__webpack_require__(132);var _convert=__webpack_require__(6);var _mobx=__webpack_require__(9);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _wfWaterMark=__webpack_require__(498);var _wfWaterMark2=_interopRequireDefault(_wfWaterMark);var _continuationProcessUtil=__webpack_require__(131);var continuationProcessUtil=_interopRequireWildcard(_continuationProcessUtil);var _rightBtn=__webpack_require__(85);var _submit=__webpack_require__(57);var _linkageControl=__webpack_require__(84);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//绑定外层放大缩小事件
var bindResizeEvent=exports.bindResizeEvent=function bindResizeEvent(){jQuery(window).bind('resize',function(){var timer=setTimeout(function(){window.clearTimeout(timer);var height=jQuery(".wea-new-top-req-content").height()?jQuery(".wea-new-top-req-content").height():600;var tabKey=_base2.default.globalStore.tabKey;if(tabKey==="pic"){setFormPic(height-50);}else if(tabKey==="odoc"){jQuery(".wf-req-odoc").height(height-20);jQuery(".req-workflow-odoc").height(height-20);}},500);});};//根据event获取keycode(兼容火狐)
var convertKeyCode=exports.convertKeyCode=function convertKeyCode(e){e=e.nativeEvent?e.nativeEvent:e;e=e?e:window.event;var keyCode=e.nativeEvent?e.nativeEvent.keyCode:e.which;return keyCode;};//获取浏览器版本
var getBrowserVersion=exports.getBrowserVersion=function getBrowserVersion(){var userAgent=navigator.userAgent;//取得浏览器的userAgent字符串
var isChrome=userAgent.indexOf("Chrome")>-1&&userAgent.indexOf("Safari")>-1;//判断Chrome浏览器
if(isChrome)return"Chrome";var isIE=userAgent.indexOf("compatible")>-1&&userAgent.indexOf("MSIE")>-1;//判断是否IE<11浏览器  
var isEdge=userAgent.indexOf("Edge")>-1&&!isIE;//判断是否IE的Edge浏览器  
var isIE11=userAgent.indexOf('Trident')>-1&&userAgent.indexOf("rv:11.0")>-1;if(isEdge)return"Edge";if(isIE11)return"IE11";if(isIE){var reIE=new RegExp("MSIE (\\d+\\.\\d+);");reIE.test(userAgent);var fIEVersion=parseFloat(RegExp["$1"]);if(fIEVersion==7)return"IE7";else if(fIEVersion==8)return"IE8";else if(fIEVersion==9)return"IE9";else if(fIEVersion==10)return"IE10";else if(fIEVersion==11)return"IE11";else return"IE";}var isOpera=userAgent.indexOf("Opera")>-1;//判断是否Opera浏览器
var isFF=userAgent.indexOf("Firefox")>-1;//判断是否Firefox浏览器
var isSafari=userAgent.indexOf("Safari")>-1&&userAgent.indexOf("Chrome")==-1;//判断是否Safari浏览器  
if(isOpera)return"Opera";if(isFF)return"FF";if(isSafari)return"Safari";return"unident";};//页面标题
var getPageTitle=exports.getPageTitle=function getPageTitle(){var pageTitle="";var globalStore=_base2.default.globalStore,layoutStore=_base2.default.layoutStore;var commonParam=globalStore.commonParam,urlParams=globalStore.urlParams;if(urlParams.isPreView==="1")return(0,_convert.getLabel)(31568,'模板预览');var mainData=layoutStore.mainData;var iscreate=commonParam.iscreate,workflowname=commonParam.workflowname;if(!_.isEmpty(commonParam)&&parseInt(iscreate)===1){pageTitle=(0,_convert.getLabel)(83443,'创建')+' - '+workflowname;}else if(mainData.has("field-1")){pageTitle=mainData.get("field-1").value;}else{pageTitle=(0,_convert.getLabel)(553,'处理')+' - '+workflowname;}return pageTitle;};//刷新表单
var isRefreshAction=false;var reloadRequestPage=exports.reloadRequestPage=function reloadRequestPage(params){var appendUserStr=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var globalStore=_base2.default.globalStore;globalStore.setCloseNeedPrompt(false);if(appendUserStr===true){//扩展用户信息
var _globalStore$commonPa=globalStore.commonParam,f_weaver_belongto_userid=_globalStore$commonPa.f_weaver_belongto_userid,f_weaver_belongto_usertype=_globalStore$commonPa.f_weaver_belongto_usertype,wfTestStr=_globalStore$commonPa.wfTestStr;params=(0,_extends3.default)({f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,wfTestStr:wfTestStr},params);}//添加连续处理信息
var isOpenContinuationProcess=globalStore.urlParams.isOpenContinuationProcess;if(isOpenContinuationProcess){params=(0,_extends3.default)({isOpenContinuationProcess:isOpenContinuationProcess},params);}if(params.requestid==globalStore.commonParam.requestid){//刷新表单，将连续处理的信息传入url中
params.isRefresh='1';appendContinuationParams(params);}isRefreshAction=true;gotoPage((window.ecologyContentPath||'')+'/workflow/request/ViewRequestForwardSPA.jsp',params);};//跳转指定链接
var gotoPage=exports.gotoPage=function gotoPage(url){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};try{ReactDOM.unmountComponentAtNode(document.getElementById("container"));}catch(e){if(window.console)console.log(e);}window.location.href=appendDefaultPath(url+'?'+buildUrlStr(params));};//拼接url链接
var buildUrlStr=exports.buildUrlStr=function buildUrlStr(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var str="";_.forIn(params,function(value,key){str+='&'+key+'='+value;});if(str!=="")str=str.substring(1);return str;};//关闭页面,控制是否需要提示
var closeRequestPage=exports.closeRequestPage=function closeRequestPage(){var needPrompt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _params$requestid=params.requestid,requestid=_params$requestid===undefined?-1:_params$requestid;var globalStore=_base2.default.globalStore;var _globalStore$urlParam=globalStore.urlParams,urlParams=_globalStore$urlParam===undefined?{}:_globalStore$urlParam,_globalStore$continua=globalStore.continuationProcessInfo,continuationProcessInfo=_globalStore$continua===undefined?{}:_globalStore$continua;globalStore.setCloseNeedPrompt(needPrompt);reloadListPage();(0,_lockUtil.closeUnLock)();//流程编辑锁定关闭解锁
GlobalUtil.verifyCustomRegisterEvent(_interface2.default.OPER_CLOSE,function(){if(urlParams.isOpenContinuationProcess=='1'){try{//连续处理调用时切换下一条流程
continuationProcessUtil.switchRequest('next',true);return;}catch(e){}}try{window.top.close();}catch(e){window.close();}if(!window.opener){requestid>-1?reloadRequestPage({requestid:requestid}):window.location.reload();}},params);};window.onbeforeunload=function(e){e=e||window.event;var _base$globalStore=_base2.default.globalStore,closeNeedPrompt=_base$globalStore.closeNeedPrompt,commonParam=_base$globalStore.commonParam;var _base$layoutStore=_base2.default.layoutStore,existChangeFormData=_base$layoutStore.existChangeFormData,odocInfo=_base$layoutStore.odocInfo;var openIwebOffice2015NewModel=odocInfo.openIwebOffice2015NewModel;if(!isRefreshAction)(0,_lockUtil.closeUnLock)();//非刷新情况下解锁
isRefreshAction=false;if(openIwebOffice2015NewModel&&IwebOffice2015Util.isOpenIweboffice2015){var tipMsg='请确认金格浏览器内是否保存正文，真的要离开吗？';if(e)e.returnValue=tipMsg;return tipMsg;}if(closeNeedPrompt&&commonParam.requestType!==0&&existChangeFormData){var _tipMsg=(0,_convert.getLabel)(18877,"流程还没保存，如果离开，将会丢失数据，真的要离开吗？");if(e)e.returnValue=_tipMsg;return _tipMsg;}};//打印耗时
var printDuration=exports.printDuration=function printDuration(params){var needRecord=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;try{if(window.console){console.log('\u8BF7\u6C42id: '+params.requestid);console.log('js\u52A0\u8F7D\u8017\u65F6: '+(window.JS_LOAD_DURATION||0)+'\u6BEB\u79D2');console.log('\u4E2D\u8F6C\u8017\u65F6: '+(window.Route_DURATION||0)+'\u6BEB\u79D2');console.log('\u5F02\u6B65js\u8017\u65F6: '+(window.ASYNC_DURATION||0)+'\u6BEB\u79D2');console.log('\u670D\u52A1\u7AEF\u8017\u65F6: '+(window.SERVER_DURATION||0)+'\u6BEB\u79D2');console.log('\u63A5\u53E3\u8017\u65F6: '+(window.API_DURATION||0)+'\u6BEB\u79D2');console.log('\u6E32\u67D3\u8017\u65F6: '+(window.DISPATCH_DURATION||0)+'\u6BEB\u79D2');console.log('\u603B\u8017\u65F6: '+(window.REQ_LOAD_DURATION/1000||0)+'\u79D2');}var globalStore=_base2.default.globalStore,layoutStore=_base2.default.layoutStore;var propFileCfg=layoutStore.propFileCfg;var close_duration_storage=propFileCfg.close_duration_storage;var browserVersion=globalStore.browserVersion,commonParam=globalStore.commonParam,commonApiParam=globalStore.commonApiParam;if(needRecord===true&&!commonParam.belongTest&&close_duration_storage!=1){//耗时信息入库 close_duration_storage=1时不记录耗时信息入库
var _params={url:window.location.href,moduleType:14,clientType:browserVersion,interfaceTc:window.API_DURATION,serviceTc:window.SERVER_DURATION,renderTc:window.DISPATCH_DURATION,staticTc:window.JS_LOAD_DURATION,allTc:window.REQ_LOAD_DURATION,param:(0,_stringify2.default)(commonApiParam)};API_REQ.writeDurationTimeInfo(_params);}}catch(e){}};window.printDuration=printDuration;//刷新列表
var reloadListPage=exports.reloadListPage=function reloadListPage(params){var reloadParams={};try{//刷新待办列表
var baseParam=_base2.default.globalStore.baseParam;reloadParams=(0,_extends3.default)({},baseParam,params);window.opener._table.reLoad((0,_extends3.default)({},baseParam,params));}catch(e){}try{//刷新门户列表
jQuery(window.opener.document).find('#btnWfCenterReload').click();}catch(e){}try{//刷新流程中心待办列表元素
window.opener.backlogRefresh();}catch(e){}try{//刷新个人数据
window.opener.element_dataCenter_reLoad();}catch(e){}try{//刷新流程中心关注列表元素
window.opener.attentionRefresh();}catch(e){}try{//刷新流程中心新反馈列表元素
window.opener.refreshResponseList();}catch(e){}try{//从公文待办列表打开流程 刷新待办页面列表
window.opener&&window.opener.isOdocOpenWF&&window.opener.getOdocWFList();//公文中心元素
window.opener&&window.opener.reloadOdocElements&&window.opener.element_odoc_reLoad();}catch(e){}};//空值转换
var convertNull=exports.convertNull=function convertNull(value){var bool=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(value===null||typeof value==="undefined")return"";else return bool?value.toString():value;};//加载代码块及custompage
var loadScript=exports.loadScript=function loadScript(){var promiseList=GlobalUtil.generateScriptPromiseList();var _base$globalStore2=_base2.default.globalStore,isSourceLayout=_base$globalStore2.isSourceLayout,_base$globalStore2$co=_base$globalStore2.commonParam,commonParam=_base$globalStore2$co===undefined?{}:_base$globalStore2$co,controlVariableMap=_base$globalStore2.controlVariableMap;var useInvoiceCloud=commonParam.useInvoiceCloud;var layoutSourceInfo=_base2.default.layoutStore.layoutSourceInfo;(0,_linkageControl.setWfVerifiySource)("scriptCusSource","loading");//记录代码块/自定义页面 开始加载
_promise2.default.all(promiseList).then(function(result){var successFn=function successFn(){(0,_linkageControl.setWfVerifiySource)("scriptCusSource","loaded");//记录代码块/自定义页面 加载成功
jQuery("#customScriptDiv").html("");if(isSourceLayout)//源码模板代码块不发请求
result.push(layoutSourceInfo.script);result.forEach(function(item,index){try{var tempstr=GlobalUtil.manageScriptContent(item);jQuery("#customScriptDiv").append('<div class="_custom_script_'+index+'">'+tempstr+'</div>');if(!isSourceLayout&&index===result.length-1)AI.setScriptContent(tempstr);}catch(e){}});GlobalUtil.loadCustomFiles("js");GlobalUtil.loadFormulaResource();window.__Load_Script_Complete__=true;//标识代码块加载完成
_base2.default.globalStore.controlVariableMap("__Load_Script_Complete__",true);if(!judgePrintLogList()){//打印不包含意见弹打印预览，包含意见的情况再意见组件加载完弹出
printPreViewPage();var globalStore=_base2.default.globalStore;var _globalStore$urlParam2=globalStore.urlParams,urlParams=_globalStore$urlParam2===undefined?{}:_globalStore$urlParam2;if(urlParams.mulPrintMode==1&&top.window.printReqStore){top.window.printReqStore.setPrintBtnDisabled(true);}}//公文流程执行页面加载事件
var odocInfo=_base2.default.layoutStore.odocInfo;if(odocInfo&&odocInfo.docFlag===true){window.oDocUtil.loadOdocConfig();}};_base2.default.globalStore.pushJSCompleteEvent(successFn);},function(err){//公式/自定义页面，加载失败，记录日志
window.console&&console.log(err);controlVariableMap("scriptOrCustomPageError",(0,_stringify2.default)(err.msg));(0,_linkageControl.setWfVerifiySource)("scriptCusSource","fail");//记录代码块/自定义页面 加载失败
});if(useInvoiceCloud==true){(0,_invoiceUtil.bindOnMessage)();}};//打印判断是否打印签字意见列表
var judgePrintLogList=exports.judgePrintLogList=function judgePrintLogList(){var globalStore=_base2.default.globalStore,layoutStore=_base2.default.layoutStore;var commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu,isSourceLayout=globalStore.isSourceLayout;var isprint=commonParam.isprint,isHideArea=commonParam.isHideArea,printLogListFlag=commonParam.printLogListFlag;var forward=rightMenu.forward;var cellInfo=layoutStore.cellInfo;var printLogList=false;if(parseInt(isprint)==1&&isHideArea!="1"){if(printLogListFlag===0){//始终不打印
}else if(printLogListFlag===2){//始终打印
printLogList=true;}else{//默认为节点意见放入模板中不打印
if(isSourceLayout){var nodeMarkContent=cellInfo.nodeMarkContent||{};printLogList=_.isEmpty(nodeMarkContent);}else{printLogList=!cellInfo.existCurrentWfNodeMark;}}}return printLogList;};//弹出打印预览界面
var printPreViewPage=exports.printPreViewPage=function printPreViewPage(){var _base$globalStore3=_base2.default.globalStore,browserVersion=_base$globalStore3.browserVersion,urlParams=_base$globalStore3.urlParams,commonParam=_base$globalStore3.commonParam;if(parseInt(commonParam.isprint)!==1)return;if(urlParams.isBatchPrint==="true"){var begintime=new Date().getTime();var batchPrintTimer=window.setInterval(function(){//批量打印给iframe赋值高度
var requestid=commonParam.requestid;var printObj=jQuery(".wf-req-print");var iframeObj=jQuery("iframe#request_"+requestid,window.parent.document);iframeObj.css("height",printObj.height()+10);//至多循环等待3s
if(new Date().getTime()-begintime>3000)window.clearInterval(batchPrintTimer);},200);return;}if(urlParams.isPreView==="true")return;var printFn=function printFn(){var timeout=isNaN(parseInt(WfForm.printTimeout||""))?500:parseInt(WfForm.printTimeout);window.setTimeout(function(){if(browserVersion.indexOf("IE")>-1){try{//解决E9环境IE中不弹打印预览框的问题
if(jQuery(".wf-req-print")){jQuery(".wf-req-print").append('<object id="WebBrowser" height="0" width="0" classid="CLSID:8856F961-340A-11D0-A96B-00C04FD705A2" viewastext></object>');}//通过修改电脑注册表，控制IE下打印设置，默认勾选允许收缩到纸张大小
var hkey_root="HKEY_CURRENT_USER";var hkey_path="\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";var hkey_key="";var RegWsh=new ActiveXObject("WScript.Shell");hkey_key="Print_Background";RegWsh.RegWrite(hkey_root+hkey_path+hkey_key,"yes");hkey_key="Shrink_To_Fit";RegWsh.RegWrite(hkey_root+hkey_path+hkey_key,"yes");}catch(e){if(window.console)console.log("请设置IE下允许ActiveX插件运行,"+e);}try{document.all.WebBrowser.ExecWB(7,1);//IE下弹预览
}catch(e9){window.print();}}else{window.print();}},timeout);};var begTime=new Date().getTime();var printTimer=window.setInterval(function(){if(window.__Load_Script_Complete__===true||new Date().getTime()-begTime>10000){//至多等待10s弹预览
GlobalUtil.verifyCustomRegisterEvent(_interface2.default.OPER_PRINTPREVIEW,printFn);window.clearInterval(printTimer);}},200);};window.printPreViewPage=printPreViewPage;/**
 * 控制提示组件
 * @param {*} mark  提示字段则为field110_3、提示明细表则是detail_2
 * @param {*} promptType   1提示必填字段，2提示行规则赋值字段不可编辑，3提示未新增明细
 */var showPrompt=exports.showPrompt=function showPrompt(mark,promptType){if(!mark)return;var layoutStore=_base2.default.layoutStore;var fieldAttrMap=layoutStore.fieldAttrMap,cellInfo=layoutStore.cellInfo,variableMap=layoutStore.variableMap;var promptBox=variableMap.get("promptBox");if(promptBox&&promptBox.visible){return;}var fieldid="";var fieldAttr=null;var lableText="";if(promptType===1||promptType===2){fieldid=mark.indexOf("_")>-1?mark.substring(5,mark.indexOf("_")):mark.substring(5);fieldAttr=fieldAttrMap.get(fieldid);if(fieldid==-10){lableText=(0,_convert.getLabel)(531284,"密级或保密期限");}else{lableText=fieldAttr&&fieldAttr.fieldlabel||"";}}else if(promptType===3){lableText=''+(0,_convert.getLabel)(19325,'明细表')+mark.substring(7);}var changeInfo={};var changeTabMark="";changeInfo["promptBox"]={mark:mark,lableText:lableText,promptType:promptType,visible:true};if(promptType===1){if(fieldAttr&&fieldAttr.isonlyshow===1)changeInfo.promptBox.isFieldOnlyShow=true;else changeInfo["promptRequiredField"]=mark;//如果字段是标签页字段，需默认选择标签页
var belSymbol=_.get(cellInfo,["fieldCellInfo",fieldid,"symbol"])||"";if(belSymbol.indexOf("mc_")>-1||belSymbol.indexOf("detail_")>-1)//多字段、明细字段再取上一层
changeTabMark=_.get(cellInfo,["subPanelInfo",belSymbol,"symbol"])||"";else changeTabMark=belSymbol;}else if(promptType===3){changeTabMark=_.get(cellInfo,["subPanelInfo",mark,"symbol"])||"";}//提示区域在标签页中，需要切换标签页选中项
if(changeTabMark.indexOf("tab_")>-1){var tabPanelInfo=_.get(cellInfo,["subPanelInfo",changeTabMark])||{};if(!_.isEmpty(tabPanelInfo))changeInfo['tabarea_'+tabPanelInfo.rowid+'_'+tabPanelInfo.colid+'_showid']=changeTabMark;}layoutStore.batchControlVariableMap(changeInfo);var _getAntd=(0,_convert.getAntd)(),Modal=_getAntd.Modal;var _base$globalStore4=_base2.default.globalStore,dialogVisible=_base$globalStore4.dialogVisible,controlDialogVisible=_base$globalStore4.controlDialogVisible;var _dialogVisible=dialogVisible.has(type.FREE_WORKFLOW_SIMPLE)&&dialogVisible.get(type.FREE_WORKFLOW_SIMPLE);_dialogVisible&&Modal.warning({title:(0,_convert.getLabel)(28535,'\u4FE1\u606F\u63D0\u793A'),content:(0,_convert.getLabel)(513127,"表单有必填项未填写"),okText:(0,_convert.getLabel)(83446,'确定'),onOk:function onOk(){controlDialogVisible(type.FREE_WORKFLOW_SIMPLE,false);}});//延时清除状态
window.setTimeout(function(){var recoverData={};recoverData["promptBox"]={visible:false};if(promptType===1)recoverData["promptRequiredField"]="";layoutStore.batchControlVariableMap(recoverData);},1500);};//流转设定弹窗存在时弹出必填应该弹出提示
//删除明细行
var delRow=exports.delRow=function delRow(detailMark){var detailObj=DetailUtil.getDetailObj(detailMark);if(detailObj===null)return;var rowArr=DetailUtil.getDetailCheckedRowArr(detailObj);if(rowArr.length===0)return;var _getAntd2=(0,_convert.getAntd)(),Modal=_getAntd2.Modal;Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(15097,'确定要删除吗？'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){DetailUtil.delAssignRow(detailMark,rowArr);},onCancel:function onCancel(){}});};//调用客户自定义回掉函数
var doDefinitionCallBackFun=exports.doDefinitionCallBackFun=function doDefinitionCallBackFun(fieldid,rowIndex,ids,datas,fieldAttr){if(typeof wfbrowvaluechange==="function"){wfbrowvaluechange(null,fieldid,rowIndex);}var detailtype=fieldAttr.detailtype,isDetail=fieldAttr.isDetail;if(typeof __browVal4CustomCheck==="function"){var _base$globalStore$com=_base2.default.globalStore.commonParam,workflowid=_base$globalStore$com.workflowid,requestid=_base$globalStore$com.requestid;var fieldMark=isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;__browVal4CustomCheck(fieldid,workflowid,requestid,detailtype,ids,datas,fieldMark);}//报销费用类型
if(detailtype===22){try{var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;WeaTools.callApi('/api/fna/budgetfeeTypeBrowser/updateBudgetfeeTypeUsed','GET',{subjectId:ids});}catch(e){if(window.console)console.log(e);}}//报销费用类型
if(detailtype===300){var _getEcCom2=(0,_convert.getEcCom)(),_WeaTools=_getEcCom2.WeaTools;var _base$globalStore$com2=_base2.default.globalStore.commonParam,_workflowid=_base$globalStore$com2.workflowid,_requestid=_base$globalStore$com2.requestid;try{_WeaTools.callApi('/api/fnaMulDimensions/fnaWfDimTypeBrowserUser/updateWfDimTypeUsed','POST',{memberId:ids,fieldId:fieldid,workflowId:_workflowid});}catch(e){if(window.console)console.log(e);}}};//获取流程干预默认值
var getIntervenorDefaultV=exports.getIntervenorDefaultV=function getIntervenorDefaultV(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var updateinfo={Intervenorid:'',IntervenoridType:'',Intervenorid_crm:''};var _data$items=data.items,items=_data$items===undefined?[]:_data$items;var nodeOperators=data.replacedatas||[];var nodeOperators_crm=data.replacedatas_crm||[];//客户浏览按钮
if(items.length>0){items.map(function(item){var labelcol=item.labelcol,fieldcol=item.fieldcol,label=item.label,conditionType=item.conditionType,_item$domkey=item.domkey,domkey=_item$domkey===undefined?[]:_item$domkey,_item$browserConditio=item.browserConditionParam,browserConditionParam=_item$browserConditio===undefined?{}:_item$browserConditio,_item$options=item.options,options=_item$options===undefined?[]:_item$options;if(conditionType=='SELECT'){options.map(function(o){if(o.selected)updateinfo[domkey[0]]=o.key;});}else if(conditionType=='BROWSER'){var _browserConditionPara=browserConditionParam.replaceDatas,replaceDatas=_browserConditionPara===undefined?[]:_browserConditionPara;var ids=[];replaceDatas.map(function(o){ids.push(o.id);});updateinfo[domkey[0]]=ids.join(',');if('Intervenorid'==domkey[0])nodeOperators=replaceDatas;}});}if(nodeOperators&&nodeOperators.length>0){var ids=[];var operatortypes=[];nodeOperators.map(function(o){var id=o.id,_o$IntervenoridType=o.IntervenoridType,IntervenoridType=_o$IntervenoridType===undefined?'':_o$IntervenoridType;ids.push(id);operatortypes.push(IntervenoridType);//IntervenoridType会在后端进行计算
});updateinfo.Intervenorid=ids.join(',');updateinfo.IntervenoridType=operatortypes.join(',');}if(nodeOperators_crm&&nodeOperators_crm.length>0){var _ids=[];var _operatortypes=[];nodeOperators_crm.map(function(o){var id=o.id;_ids.push(id);});updateinfo.Intervenorid_crm=_ids.join(',');}return updateinfo;};//流程导入
var requestImport=exports.requestImport=function requestImport(imprequestid){var _base$globalStore5=_base2.default.globalStore,commonParam=_base$globalStore5.commonParam,setLoading=_base$globalStore5.setLoading;setLoading(true);var workflowid=commonParam.workflowid,formid=commonParam.formid,isbill=commonParam.isbill,nodeid=commonParam.nodeid,nodetype=commonParam.nodetype,isagent=commonParam.isagent,beagenter=commonParam.beagenter;var requestname='';var requestlevel='';var fieldObj=FieldUtil.getFieldValObj(-1,-1);var fieldObjReqLevel=FieldUtil.getFieldValObj(-2,-1);if(fieldObj){var _fieldObj$valueObj=fieldObj.valueObj,valueObj=_fieldObj$valueObj===undefined?{}:_fieldObj$valueObj;var _valueObj$value=valueObj.value,value=_valueObj$value===undefined?'':_valueObj$value;requestname=value;}if(fieldObjReqLevel){var _fieldObjReqLevel$val=fieldObjReqLevel.valueObj,_valueObj=_fieldObjReqLevel$val===undefined?{}:_fieldObjReqLevel$val;var _valueObj$value2=_valueObj.value,_value=_valueObj$value2===undefined?'':_valueObj$value2;requestlevel=_value;}var importParams={src:"import",imprequestid:imprequestid,workflowid:workflowid,formid:formid,isbill:isbill,nodeid:nodeid,"nodetype":nodetype,isagent:isagent,beagenter:beagenter,requestname:requestname,requestlevel:requestlevel};API_REQ.requestImport(importParams).then(function(data){reloadRequestPage({requestid:data.requestid});});};var setFormPic=exports.setFormPic=function setFormPic(height){var picUrl=getIframeUrl();if(jQuery('.wf-req-picture')){var containerHeight=jQuery('.wea-new-top-req-content').outerHeight()||height;jQuery('.wf-req-picture').height(containerHeight-50);}jQuery(".req-workflow-map").attr("src")!=picUrl&&jQuery(".req-workflow-map").attr("src",picUrl);//给ifream添加src
jQuery(".req-workflow-map").height(height-5);};var getIframeUrl=exports.getIframeUrl=function getIframeUrl(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _base$globalStore6=_base2.default.globalStore,baseParam=_base$globalStore6.baseParam,rightMenu=_base$globalStore6.rightMenu,variableMap=_base$globalStore6.variableMap,commonParam=_base$globalStore6.commonParam,urlParams=_base$globalStore6.urlParams;var picParams=(0,_extends3.default)({},(0,_mobx.toJS)(urlParams),(0,_mobx.toJS)(baseParam));var requestid=baseParam.requestid;var picHtml='readOnly-index.html';if(variableMap.get(type.FREEFLOW_SETTING)||requestid>0){var _commonParam$hasFreeN=commonParam.hasFreeNode,hasFreeNode=_commonParam$hasFreeN===undefined?false:_commonParam$hasFreeN;var _rightMenu$isFree=rightMenu.isFree,isFree=_rightMenu$isFree===undefined?'0':_rightMenu$isFree,_rightMenu$isAllowNod=rightMenu.isAllowNodeFreeFlow,isAllowNodeFreeFlow=_rightMenu$isAllowNod===undefined?'0':_rightMenu$isAllowNod;picParams['isFree']=isFree;picParams['isAllowNodeFreeFlow']=isAllowNodeFreeFlow;picParams['isReadOnlyModel']=true;picParams['isFlowModel']='0';picParams['hasFreeNode']=hasFreeNode?'1':'0';}picParams.authSignatureStr=commonParam.authSignatureStr;picParams.authStr=commonParam.authStr;picParams.wfTestStr=commonParam.wfTestStr;picParams=(0,_extends3.default)({},picParams,params);var picUrl=(window.ecologyContentPath||'')+'/workflow/workflowDesign/'+picHtml+'?'+buildUrlStr(picParams)+'&showE9Pic=1&isFromWfForm=true&_freekey='+variableMap.get('FREE_T_KEY');return picUrl;};//切换tab
var switchFormTab=exports.switchFormTab=function switchFormTab(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var jumpTab=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(!_base2.default.globalStore.JSComplete)return;if(key=='odoc'&&WfForm.getOdocConfig().openWpsJSAPI&&WfForm.getOdocConfig().extendName.indexOf('doc')>-1){beforeWpsOnlineEdit.createDoc();return;}if(key=='odoc'&&(jQuery(".req-workflow-odoc").length>0||jQuery(".wf-req-form-odoc-iframe")>0)&&WfForm.getOdocConfig().docParam.isTextInFormCanEdit&&WfForm.getOdocConfig().docParam.isTextInForm){return;}if(key=='odoc'&&WfForm.getOdocConfig().openIwebOffice2015NewModel&&WfForm.getOdocConfig().extendName.indexOf('doc')>-1){var isSupportIweboffice2015App=false;//判断当前浏览器是否支持金格插件（金格目前回复只需判断谷歌107版本以上）
var isSupportIweOffice2015App=function isSupportIweOffice2015App(){var userAgent=window.navigator.userAgent;var isSupport=false;try{if(/AppleWebKit\/([\d.]+)/.test(userAgent)){// 匹配Webkit内核（Chrome、Safari浏览器）
if(/Chrome\/([\d.]+)/.test(userAgent)){// 匹配Chrome浏览器
var version=parseFloat(RegExp.$1);if(version>107){isSupport=true;}}}}catch(error){if(window.console){console.log('error',error);}}return isSupport;};if(WfForm.getOdocConfig().openIwebOffice2015NewModel){if(WfForm.getOdocConfig().isIwebOffice2015Compatible){var isSupport=isSupportIweOffice2015App();if(isSupport){isSupportIweboffice2015App=true;}}else{if(window.navigator.userAgent.indexOf('Chrome')>-1){isSupportIweboffice2015App=true;}}}//且正文只读时、若开启预览服务、走预览服务查看正文，
if(WfForm.getOdocConfig().docParam.isEdit!='1'&&(WfForm.getOdocConfig().docParam.wpsView||WfForm.getOdocConfig().docParam.yozoView||WfForm.getOdocConfig().zbview||WfForm.getOdocConfig().lightReadView)){isSupportIweboffice2015App=false;}if(isSupportIweboffice2015App){window.oDocUtil.openIWebOffice2015App();return;}}if(WfForm.getOdocConfig()!=null&&WfForm.getOdocConfig().docParam!=null&&WfForm.getOdocConfig().docParam.saveDocRemind===true&&(getWebOfficeIsModify()===true||getWebOffice2015IsModify()===true)&&key!="odoc"&&_base2.default.globalStore.tabKey==="odoc"){//开启离开正文提醒，且公文未保存，离开正文页面，进行提醒
var _getAntd3=(0,_convert.getAntd)(),Modal=_getAntd3.Modal;showOrHideWeboffice(0);Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(19006,'文档还没保存，确定要离开吗？'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){switchFormTabFunc(key,jumpTab);showOrHideWeboffice(1);},onCancel:function onCancel(){showOrHideWeboffice(1);}});}else{switchFormTabFunc(key,jumpTab);}};//切换tab
var switchFormTabFunc=exports.switchFormTabFunc=function switchFormTabFunc(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var jumpTab=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(Number(key)>=0){key='form';}var oldTabKey=_base2.default.globalStore.tabKey;if($('#conflict-panel-box')&&$('#conflict-panel-box').css('visibility')=='visible'){//隐藏字段冲突确认面板
$('#conflict-panel-box').css({visibility:'hidden'});}if(key.indexOf('custom_dialog_')===-1&&jumpTab){_base2.default.globalStore.setTabKey(key);}var contentDiv=jQuery(".wea-new-top-req-content");contentDiv.css("overflow-y",key==="form"||key==="pic"||key==="resource"?"hidden":"auto");var height=0;if(key==='pic'){height=contentDiv.height()-50?contentDiv.height()-50:600;//处理流程图没有滚动条的问题
}else{height=contentDiv.height()?contentDiv.height():600;}//控制正文页签
jQuery(".wf-req-odoc").show();if(jQuery(".wf-req-odoc").length>0){if(key==="odoc"){jQuery(".wf-req-odoc").css('height','100%');showOrHideWeboffice(1);jQuery(".wf-req-odoc").css('marginTop','10px');jQuery(".wf-req-odoc").css('marginBottom','10px');jQuery(".req-workflow-odoc").css('width','100%');//解决正文切换回表单，正文+无法点击的问题
try{oDocUtil.uploadPDFCanClick=true;}catch(e){}}else if(key==="form"&&WfForm.getOdocConfig().docParam.isTextInForm&&!WfForm.getOdocConfig().docParam.isUseTempletNode&&!WfForm.getOdocConfig().docParam.wpsEditor){/**正文显示在表单时隐藏正文页签下控件，并重置样式 */showOrHideWeboffice(1);jQuery(".wf-req-odoc").css('marginTop','0px');jQuery(".wf-req-odoc").css('marginBottom','0px');reloadTextInForm();}else{jQuery(".wf-req-odoc").height(1);var marginTop=parseInt(jQuery(".wf-req-odoc").css('fontSize').replace('px',''),10);marginTop=marginTop>0?marginTop=(marginTop+1)*-1:-13;jQuery(".wf-req-odoc").css('marginTop',marginTop+'px');jQuery(".wf-req-odoc").css('marginBottom','0px');jQuery(".req-workflow-odoc").height(1);showOrHideWeboffice(0);reloadTextInForm();}}if(key==="form"){DetailUtil.fixedDetailHead();//window.formLoglistStore && window.formLoglistStore.updateLogParams({ pgnumber: 1 });
if(oldTabKey=='communication'){// 从相关交流切换到表单tab要刷新签字意见
window.formLoglistStore&&window.formLoglistStore.loadMarkInfo();}}else if(key==="pic"){setFormPic(height);if(!_base2.default.smartGuessWfStore.baseReqParams.requestid){_base2.default.smartGuessWfStore.init(_base2.default.globalStore.commonParam);}}else if(key==="odoc"){try{if((jQuery(".req-workflow-odoc").length>0||jQuery(".wf-req-form-odoc-iframe")>0)&&WfForm.getOdocConfig().docParam.isTextInFormCanEdit&&WfForm.getOdocConfig().docParam.isTextInForm){WfForm.switchTab("form");return;}//校验标题行必填
var docInfonew=WfForm.getOdocConfig();var documentFieldId=docInfonew.docParam.documentTitleField;if(documentFieldId===-3||documentFieldId===0)documentFieldId=-1;if(WfForm.getFieldValue("field"+documentFieldId)===""&&WfForm.getFieldCurViewAttr('field'+ +documentFieldId)>1){antd.message.error("\""+WfForm.getFieldInfo(documentFieldId).fieldlabel+"\""+ecCom.WeaLocaleProvider.getLabel(503020,'字段未填写'));oDocUtil.uploadPDFCanClick=true;WfForm.switchTab("form");return false;}//判断正文存放目录是否存在
if(docInfonew.docParam.secid&&docInfonew.docParam.secid<=0){antd.message.error(ecCom.WeaLocaleProvider.getLabel(519301,"正文存放目录未设置"));oDocUtil.uploadPDFCanClick=true;WfForm.switchTab("form");return false;}//是否开启分级保护，是否填写了流程密级，是否为新建正文
if(docInfonew.isOpenClassification&&window.oDocUtil.haveSecretLevel&&WfForm.getOdocConfig()&&WfForm.getOdocConfig().docParam&&WfForm.getOdocConfig().docParam.docid<0&&WfForm.getOdocConfig().docParam.isEdit==1){if(window.oDocUtil.needReconfirmSecretLevel){//是否需要重新确认密级
if(!window.oDocUtil.haveSecretLevel()){WfForm.switchTab("form");return;}else{showOrHideWeboffice(0);//加载弹窗前隐藏插件，避免遮挡
if(!window.weaOdoc){window.eventRegister&&window.eventRegister.loadModule('f_odoc',function(){window.oDocUtil.renderDialog(false,0,0,'clickOdocTab');},function(){window.console&&console.log("公文模块加载失败");});}else{window.oDocUtil.renderDialog(false,0,0,'clickOdocTab');}}}else{oDocUtil.setDocParam();}}else{oDocUtil.setDocParam();}jQuery(".req-workflow-odoc").height(height-20);}catch(e){}}else if(key.indexOf('custom_')>-1){if(key.indexOf('custom_iframe_workflowCusTab_')>-1){//公文流程表单页签管理
var _getEcCom3=(0,_convert.getEcCom)(),WeaLoadingGlobal=_getEcCom3.WeaLoadingGlobal;try{WeaLoadingGlobal.start({tip:"加载中..."});var timer=setInterval(function(){if(window.custom_iframe_workflowCusTab_bindEvent){clearInterval(timer);WeaLoadingGlobal.end();WeaLoadingGlobal.destroy();var fun=WfForm.customTabFunObj[key];if(typeof fun==='function'){fun();}}},300);}catch(e){WeaLoadingGlobal.end();WeaLoadingGlobal.destroy();if(window.console)console.log(e);}}else{try{var fun=WfForm.customTabFunObj[key];if(typeof fun==='function'){fun();}}catch(e){if(window.console)console.log(e);}}}//处理流程图操作者信息面板隐藏的问题
var obj=document.getElementById('wfFrontOperator-container');if(obj){if(key!=='pic'){obj.style.visibility='hidden';}}//后执行注册事件
window.WfForm.triggerAction(window.WfForm.ACTION_SWITCHTAB,[key,oldTabKey]);};//流程提交后显示流程图
var showChart=exports.showChart=function showChart(params){var requestid=params.requestid;var sessionkey=params.sessionkey;var globalStore=_base2.default.globalStore;var _globalStore$submitPa=globalStore.submitParam,submitParam=_globalStore$submitPa===undefined?{}:_globalStore$submitPa,rightMenu=globalStore.rightMenu,commonParam=globalStore.commonParam,urlParams=globalStore.urlParams;var workflowid=submitParam.workflowid,isbill=submitParam.isbill,formid=submitParam.formid,isfromtab=submitParam.isfromtab,f_weaver_belongto_userid=submitParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=submitParam.f_weaver_belongto_usertype;var urlParam=(0,_extends3.default)({},(0,_mobx.toJS)(urlParams),{requestid:requestid,workflowid:workflowid,isbill:isbill,formid:formid,isfromtab:isfromtab,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,showE9Pic:"1",isFromAutodirect:"1",isFromWfForm:true,authSignatureStr:commonParam.authSignatureStr,authStr:commonParam.authStr,wfTestStr:commonParam.wfTestStr,sessionkey:sessionkey});var _rightMenu$isFree2=rightMenu.isFree,isFree=_rightMenu$isFree2===undefined?'0':_rightMenu$isFree2,_rightMenu$isAllowNod2=rightMenu.isAllowNodeFreeFlow,isAllowNodeFreeFlow=_rightMenu$isAllowNod2===undefined?'0':_rightMenu$isAllowNod2;urlParam['isFree']=isFree;urlParam['isAllowNodeFreeFlow']=isAllowNodeFreeFlow;//跳转流程图，拼接连续处理参数
appendContinuationParams(urlParam);gotoPage((window.ecologyContentPath||'')+'/workflow/request/WorkflowDirectionNew.jsp',urlParam);};//拼接连续处理参数
var appendContinuationParams=exports.appendContinuationParams=function appendContinuationParams(){var urlParam=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var globalStore=_base2.default.globalStore;var continuationProcessInfo=globalStore.continuationProcessInfo;if(continuationProcessInfo.loaded){urlParam.isOpenContinuationProcess='1';urlParam.currentIndex=continuationProcessInfo.currentIndex;urlParam.counts=continuationProcessInfo.counts;urlParam.showSwitchBar=continuationProcessInfo.showSwitchBar;}return urlParam;};//右键按钮是否显示判断
var isShowRightBtn=exports.isShowRightBtn=function isShowRightBtn(){var btnInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var globalStore=_base2.default.globalStore;var tabKey=globalStore.tabKey;var type=btnInfo.type,menuName=btnInfo.menuName,menuIcon=btnInfo.menuIcon,isTest=btnInfo.isTest;var isShow=true;//导出
if(type=='BTN_EXCEL'&&tabKey!=='form'){isShow=false;}return isShow;};var bindTagTypeShowEvent=exports.bindTagTypeShowEvent=function bindTagTypeShowEvent(){jQuery("body").on("click",function(e){if(jQuery(e.target).parents(".icon-coms02-Label").length>0||jQuery(e.target).hasClass("icon-coms02-Label"))return;if(jQuery(e.target).parents(".ant-popover-content").length<1){//icon-coms02-Label
_base2.default.followSelectStore.followTypeSelectShow=false;}});};//滚动dom元素到页面可视区域
var scrollDom=exports.scrollDom=function scrollDom(){var dom=arguments.length>0&&arguments[0]!==undefined?arguments[0]:".wf-req-freeWorkflowSimple";var borderHeightLight=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var msg=arguments[2];var _getAntd4=(0,_convert.getAntd)(),message=_getAntd4.message;var remarktop=parseInt(jQuery(dom).offset().top);var scrolltop=0;//判断dom元素区域是否在可视区域
var isVisual=remarktop>0&&remarktop-jQuery('.wea-new-top-req').height()+200<jQuery('.wf-req-form-scroll').height();if(!isVisual){if(remarktop-jQuery('.wea-new-top-req').height()+200>jQuery('.wf-req-form-scroll').height()){scrolltop=remarktop+jQuery('.wf-req-form-scroll').scrollTop()-385;}if(remarktop<jQuery('.wea-new-top-req').height()){if(remarktop<0)remarktop=remarktop*-1;scrolltop=jQuery('.wf-req-form-scroll').scrollTop()-remarktop-jQuery('.wea-new-top-req').height()-350;// -100;
}jQuery('.wf-req-form-scroll').animate({scrollTop:scrolltop+"px"},0);}if(msg){message.warning(msg);}if(borderHeightLight){jQuery(dom).css("border","1px solid #2DB7F5");}};//获取流程导入需要的参数
var getWfImportParams=exports.getWfImportParams=function getWfImportParams(){var _base$globalStore7=_base2.default.globalStore,rightMenu=_base$globalStore7.rightMenu,commonParam=_base$globalStore7.commonParam;var rightMenus=rightMenu&&rightMenu.rightMenus||[];var params={};rightMenus instanceof Array&&rightMenus.map(function(m){var type=m.type,menuName=m.menuName,menuIcon=m.menuIcon,menuFun=m.menuFun,isTop=m.isTop,isLockShow=m.isLockShow,isTest=m.isTest;if(menuFun.indexOf("doImportWorkflow")>-1){var userId=commonParam.f_weaver_belongto_userid||"";var workflowid=commonParam.workflowid,formid=commonParam.formid,isbill=commonParam.isbill,belongTest=commonParam.belongTest;params={workflowid:workflowid,formid:formid,isbill:isbill,belongTest:belongTest,userId:userId,menuName:menuName};}});return params;};/**
 * 加载水印
 */var loadWaterMark=exports.loadWaterMark=function loadWaterMark(){var _base$globalStore8=_base2.default.globalStore,_base$globalStore8$co=_base$globalStore8.commonParam,commonParam=_base$globalStore8$co===undefined?{}:_base$globalStore8$co,_base$globalStore8$ur=_base$globalStore8.urlParams,urlParams=_base$globalStore8$ur===undefined?{}:_base$globalStore8$ur;var waterMarkInfo=commonParam.waterMarkInfo;var _window$ua=window.ua,_window$ua$browser=_window$ua.browser,browser=_window$ua$browser===undefined?'':_window$ua$browser,_window$ua$version=_window$ua.version,version=_window$ua$version===undefined?'0':_window$ua$version;if(browser==="IE"&&parseInt(version,10)<11)return;if(waterMarkInfo){var _waterMarkInfo$conten=waterMarkInfo.contentType,contentType=_waterMarkInfo$conten===undefined?0:_waterMarkInfo$conten,_waterMarkInfo$conten2=waterMarkInfo.content,content=_waterMarkInfo$conten2===undefined?"":_waterMarkInfo$conten2,_waterMarkInfo$width=waterMarkInfo.width,width=_waterMarkInfo$width===undefined?0:_waterMarkInfo$width,_waterMarkInfo$height=waterMarkInfo.height,height=_waterMarkInfo$height===undefined?0:_waterMarkInfo$height,_waterMarkInfo$transp=waterMarkInfo.transparency,transparency=_waterMarkInfo$transp===undefined?0:_waterMarkInfo$transp,_waterMarkInfo$rotati=waterMarkInfo.rotationAngle,rotationAngle=_waterMarkInfo$rotati===undefined?0:_waterMarkInfo$rotati;var waterMarkOptions={fontStyle:"font-size:18px;color:#000;",rotate:360-rotationAngle,alpha:transparency/100,width:width,height:height};if(contentType==1){var tempContent=content;var regx=/<span key=\"(.*?)\"><\/span>/g;while(regx.exec(content)!=null){var fieldMark=RegExp.$1;var valShowName=GlobalUtil.getWaterMarkFieldShowName(fieldMark);tempContent=tempContent.replace('<span key="'+fieldMark+'"></span>','<span>'+valShowName+'</span>');}waterMarkOptions.text=_wfWaterMark2.default.formatContent({text:tempContent});}if(contentType==2)waterMarkOptions.src=content;var _urlParams$isBatchPri=urlParams.isBatchPrint,isBatchPrint=_urlParams$isBatchPri===undefined?'false':_urlParams$isBatchPri,_urlParams$isPreView=urlParams.isPreView,isPreView=_urlParams$isPreView===undefined?'false':_urlParams$isPreView;var doc=null;if(isBatchPrint=='true'||isPreView=='true'){doc=window.document;var index=0;var timer=setInterval(function(){if(index<20){(0,_wfWaterMark2.default)(waterMarkOptions,doc);index++;}else{clearInterval(timer);}},200);}else{(0,_wfWaterMark2.default)(waterMarkOptions,doc);}}};/**
 * 为跳转URL拼接多级路径
 * @param url
 * @return {string|string}
 */var appendDefaultPath=exports.appendDefaultPath=function appendDefaultPath(){var url=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var tmpurl=url;if(window.ecologyContentPath&&url&&url.startsWith('/')&&!url.startsWith(window.ecologyContentPath)){tmpurl=''+window.ecologyContentPath+url;}return tmpurl;};//pc端修改密级值的唯一入口，联动代码块等修改都必须走此入口
var changeSecLevel=exports.changeSecLevel=function changeSecLevel(newsecLevel){var lastSecLevel=SecLevelUtil.getSecLevel();var _base$globalStore9=_base2.default.globalStore,_base$globalStore9$se=_base$globalStore9.secLevelInfo,secLevelInfo=_base$globalStore9$se===undefined?{}:_base$globalStore9$se,variableMap=_base$globalStore9.variableMap,controlVariableMap=_base$globalStore9.controlVariableMap;var _secLevelInfo$secVali=secLevelInfo.secValidityMap,secValidityMap=_secLevelInfo$secVali===undefined?{}:_secLevelInfo$secVali;var _base$layoutStore2=_base2.default.layoutStore,cellInfo=_base$layoutStore2.cellInfo,fieldAttrMap=_base$layoutStore2.fieldAttrMap;var _getAntd5=(0,_convert.getAntd)(),message=_getAntd5.message;var requestnameViewAttr=fieldAttrMap.has("-1")&&fieldAttrMap.get("-1").viewattr||0;var miniWfSecLevel=variableMap.get("miniWfSecLevel")||"";var secValidity="";if(newsecLevel<=2&&newsecLevel!=""){secValidity=secValidityMap[newsecLevel];}SecLevelUtil.changeSecLevelInfo(newsecLevel,secValidity);var onCancel=function onCancel(){var secValidity="";if(lastSecLevel<=2){secValidity=secValidityMap[lastSecLevel];}SecLevelUtil.changeSecLevelInfo(lastSecLevel,secValidity);};if(_.has(cellInfo,["fieldCellInfo","-1"])&&requestnameViewAttr>1&&(0,_submit.verifyRequestNameIsEmpty)()){showPrompt("field-1",1);message.warning((0,_convert.getLabel)(386187,'请求标题字段未填值！'));setTimeout(function(){onCancel();},50);return false;}if(miniWfSecLevel!=""&&miniWfSecLevel<newsecLevel){var _getAntd6=(0,_convert.getAntd)(),Modal=_getAntd6.Modal;//修改流程密级
Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(531285,"变更密级，高于当前流程密级的关联资源会被清除，高于当前流程密级的附件密级将自动调整为修改的密级，确定要调整吗？"),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){(0,_rightBtn.doSave_nNew)();},onCancel:onCancel});}else{if(newsecLevel!==""){controlVariableMap("miniWfSecLevel",newsecLevel);}}};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _field=__webpack_require__(147);var _field2=_interopRequireDefault(_field);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/************ index内调用init初始化，store内部就可实现互相调用 ************/var base={globalStore:{},layoutStore:{},ehOperatorStore:{},printLogStore:{},rejectStore:{},shareStore:{},overTimeStore:{},freeFlowStore:{},secondAuthStore:{},selectNextFlowStore:{},followSelectStore:{},freeWflowSimpleStore:{},ensureSubmitStore:{},smartGuessWfStore:{},requestWithdrawStore:{},showContentStore:{},conformRuleStore:null,init:function init(stores){this.globalStore=stores.globalStore;this.layoutStore=stores.layoutStore;this.ehOperatorStore=stores.ehOperatorStore;this.printLogStore=stores.printLogStore;this.rejectStore=stores.rejectStore;this.shareStore=stores.shareStore;this.selectNextFlowStore=stores.selectNextFlowStore;this.overTimeStore=stores.overTimeStore;this.freeFlowStore=stores.freeFlowStore;this.secondAuthStore=stores.secondAuthStore;this.followSelectStore=stores.followSelectStore;this.freeWflowSimpleStore=stores.freeWflowSimpleStore;this.ensureSubmitStore=stores.ensureSubmitStore;this.smartGuessWfStore=stores.smartGuessStore;this.requestWithdrawStore=stores.requestWithdrawStore;this.showContentStore=stores.showContentStore;this.conformRuleStore=stores.conformRuleStore;//公共util数据源source做初始化
_source2.default.init(stores.globalStore,stores.layoutStore,_field2.default,API_REQ,_convert.getLabel);}};exports.default=base;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number')
    __e = core; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.asyncLoadModule=exports.loadFullResource=exports.controlAsyncLoad=undefined;var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _fileConfig=__webpack_require__(18);var file=_interopRequireWildcard(_fileConfig);var _stores=__webpack_require__(176);var _stores2=_interopRequireDefault(_stores);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import loadjs from 'loadjs';
var controlAsyncLoad=exports.controlAsyncLoad=function controlAsyncLoad(){if(!_.isEmpty(_base2.default.globalStore.commonParam)){//此刻代表首屏渲染完成
if(!window.REQ_LOAD_DURATION){window.DISPATCH_DURATION=new Date().getTime()-window.API_LOAD_END;window.REQ_LOAD_DURATION=new Date().getTime()-window.REQ_PAGE_LOAD_START;}//非Chrome下等首屏只读渲染完，再加载全量组件库
window.__hasLoadFullResource__!==true&&loadFullResource();}_base2.default.globalStore.triggerJSCompleteEvent();};//加载全量组件库等资源
var loadFullResource=exports.loadFullResource=function loadFullResource(callback){if(window.__hasLoadFullResource__===true)return;window.__hasLoadFullResource__=true;var loadjs=window.loadjs;var globalStore=_stores2.default.globalStore;var loadFn=function loadFn(){window.ASYNC_BEGIN=new Date().getTime();//加载全量组件库资源
// const fileList = file.antdFiles.concat(file.ecComFiles, file.comMobxFiles, file.odocFiles);      //IE下async无法保证顺序
loadjs(file.antdFiles,function(){loadjs(file.ecComFiles,function(){loadjs(file.comMobxFiles.concat(file.odocFiles),function(){callback&&callback();window.ASYNC_DURATION=new Date().getTime()-window.ASYNC_BEGIN;//标识全量组件库加载完成，再加载其它依赖异步资源
globalStore.markJSComplete();//加载等待队列中的异步模块资源
loadWaitingModule();//加载依赖的文件列表
loadjs(file.dependFiles,'depend');//加载加密依赖文件
loadjs(file.escFiles,'esc');//触发一次图片懒加载
window.formImgLazyLoad(jQuery('.wf-req-form-scroll'));});});});};//可根据url参数控制异步加载延时时间，调试用
var delayLoadTime=0;var urlParams=globalStore.urlParams;if(!!urlParams.delayAsyncLoad){delayLoadTime=isNaN(parseInt(urlParams.delayAsyncLoad))?999999999:parseInt(urlParams.delayAsyncLoad);}else{if(globalStore.browserVersion!=="Chrome")delayLoadTime=300;}delayLoadTime>0?window.setTimeout(loadFn,delayLoadTime):loadFn();};var waitingModule={};//异步模块资源需要等到全量组件库加载完毕才加载
var asyncLoadModule=exports.asyncLoadModule=function asyncLoadModule(modulename){var files=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var callback=arguments[2];var async=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var loadjs=window.loadjs;var JSComplete=_base2.default.globalStore.JSComplete;if(JSComplete){//组件资源已加载完成，loadjs直接发请求
loadjs.isDefined(modulename)?loadjs.ready(modulename,callback):loadjs(files,modulename,{async:async,success:callback});}else{//组件资源未加载完成，插入等待队列，组件资源加载完成后请求等待队列发请求
var obj=modulename in waitingModule?waitingModule[modulename]:{files:files,async:async,callbacks:[]};obj.callbacks.push(callback);waitingModule[modulename]=obj;}};var loadWaitingModule=function loadWaitingModule(){var loadjs=window.loadjs;var _loop=function _loop(modulename){var moduleCfg=waitingModule[modulename];var files=moduleCfg.files||[];var async="async"in moduleCfg?moduleCfg.async:true;var callbacks=moduleCfg.callbacks||[];var loadComplateFun=function loadComplateFun(){callbacks.map(function(fun){if(typeof fun==="function")fun();});};loadjs.isDefined(modulename)?loadjs.ready(modulename,loadComplateFun):loadjs(files,modulename,{async:async,success:loadComplateFun});};for(var modulename in waitingModule){_loop(modulename);}};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getOdocTabManagerDatas=exports.writeFormErrlog=exports.conformCheck=exports.saveFreeNodeFormConfig=exports.getFreeNodeBrowserItem=exports.getNextNodeContent=exports.getBrowserInfo=exports.getFidOrEcid=exports.getInvoiceCloudToken=exports.saveDetailExpSet=exports.getDetailExpSet=exports.getContinnuationProcessInfo=exports.getThMouldList=exports.getThImageFileId=exports.getThPreviewUrl=exports.getTriggerSubWFList=exports.getFlowChartInfo=exports.getForecastInfo=exports.getRuleCondition=exports.getOperator=exports.getSimpleWfData=exports.loadCondition=exports.formulaCfg=exports.exportFieldSet=exports.fieldLinkageCfg=exports.checkJoin=exports.doTakEnd=exports.getFormAttentionTag=exports.isShowShareBtn=exports.getSendEmailInfo=exports.runCustomOperationAction=exports.getCustomOperation=exports.doTakeBack=exports.getExportedPDF=exports.getExportedExcel=exports.getFormulasNew=exports.getSelectFlowNodeInfo=exports.getSelectNextFlowCondition=exports.getFormTab=exports.doSupervise=exports.generatePrintLog=exports.loadPrintTemplates=exports.editLockOper=exports.freeFlowSave=exports.freeFlowRead=exports.getPrintLogData=exports.getPrintLogBase=exports.requestWithDraw=exports.overTimeSetting=exports.chooseExceptionOperator=exports.getInterventionUser=exports.getReqInterventionInfo=exports.requestImport=exports.getUploadFileInfo=exports.triggerSubWf=exports.reqOperate=exports.functionLink=exports.loadWfCodeFieldValueInfo=exports.createWfCode=exports.reqDateTimeResult=exports.reqFieldSqlResult=exports.reqDataInputResult=exports.updateUserTxStatus=exports.getWfStatusCount=exports.getWfStatus=exports.judgeRejectWay=exports.loadHrefTextContent=exports.loadInjectDevFile=exports.loadCustompage=exports.loadScriptContent=exports.updateReqInfo=exports.getRightMenu=exports.getNodeSignSet=exports.getSignInput=exports.updateRequestLogPageSize=exports.getRequestLogList=exports.getRequestLogBaseInfo=exports.loadRequestLog=exports.saveDetailPaging=exports.getDetailDataKeyIds=exports.loadDetailData=exports.writeDurationTimeInfo=exports.loadPreViewInfo=exports.loadBaseInfo=undefined;var _convert=__webpack_require__(6);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;var appendUserParams=function appendUserParams(params){var commonParam=_base2.default.globalStore.commonParam;var arr=["wfTestStr","f_weaver_belongto_userid","f_weaver_belongto_usertype"];arr.map(function(key){if(!(key in params)&&key in commonParam)params[key]=commonParam[key];});};var appendAuthParams=function appendAuthParams(params){var commonParam=_base2.default.globalStore.commonParam;var arr=["authStr","authSignatureStr"];arr.map(function(key){if(!(key in params)&&key in commonParam)params[key]=commonParam[key];});};//表单加载基础信息
var loadBaseInfo=exports.loadBaseInfo=function loadBaseInfo(params){return WeaTools.callApi('/api/workflow/reqform/loadForm','POST',params);};//模板预览加载数据
var loadPreViewInfo=exports.loadPreViewInfo=function loadPreViewInfo(params){return WeaTools.callApi('/api/workflow/reqform/loadPreView','POST',params);};//耗时信息入库
var writeDurationTimeInfo=exports.writeDurationTimeInfo=function writeDurationTimeInfo(params){return WeaTools.callApi('/api/systemViewLog/home/InsertSystemPageViewLog','POST',params);};//明细数据
var loadDetailData=exports.loadDetailData=function loadDetailData(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/detailData','POST',params);};//明细数据keyid
var getDetailDataKeyIds=exports.getDetailDataKeyIds=function getDetailDataKeyIds(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/detailDataKeyId','POST',params);};//改变明细分页条数
var saveDetailPaging=exports.saveDetailPaging=function saveDetailPaging(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/saveDetailPaging','POST',params);};//签字意见列表
var loadRequestLog=exports.loadRequestLog=function loadRequestLog(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/requestLog','POST',params);};//加载签字意见基本信息
var getRequestLogBaseInfo=exports.getRequestLogBaseInfo=function getRequestLogBaseInfo(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/getRequestLogBaseInfo','POST',params);};//加载签字意见列表数据
var getRequestLogList=exports.getRequestLogList=function getRequestLogList(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/getRequestLogList','POST',params);};//更新意见列表分页
var updateRequestLogPageSize=exports.updateRequestLogPageSize=function updateRequestLogPageSize(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/updateRequestLogPageSize','POST',params);};//意见输入框
var getSignInput=exports.getSignInput=function getSignInput(params){appendUserParams(params);appendAuthParams(params);return WeaTools.callApi('/api/workflow/reqform/signInput','POST',params);};//节点意见设置
var getNodeSignSet=exports.getNodeSignSet=function getNodeSignSet(params){appendUserParams(params);appendAuthParams(params);return WeaTools.callApi('/api/workflow/reqform/getNodeSignSet','GET',params);};//右键按钮
var getRightMenu=exports.getRightMenu=function getRightMenu(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/rightMenu','POST',params);};//请求状态更新(已读等)
var updateReqInfo=exports.updateReqInfo=function updateReqInfo(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/updateReqInfo','POST',params);};//加载代码块
var loadScriptContent=exports.loadScriptContent=function loadScriptContent(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/scripts','GET',params,'text');};//加载custompage
var loadCustompage=exports.loadCustompage=function loadCustompage(address,params){appendUserParams(params);params["__address__"]=address;return WeaTools.callApi('/workflow/request/CustomPageForward.jsp','POST',params,'text');};//加载自定义开发文件列表
var loadInjectDevFile=exports.loadInjectDevFile=function loadInjectDevFile(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/injectDev/loadFormDevFileList','POST',params);};//text方式加载指定路径内容
var loadHrefTextContent=exports.loadHrefTextContent=function loadHrefTextContent(address,params){appendUserParams(params);return WeaTools.callApi(address,'GET',params,'text');};//判断退回方式
var judgeRejectWay=exports.judgeRejectWay=function judgeRejectWay(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/judgeRejectWay','POST',params);};//加载流程状态
var getWfStatus=exports.getWfStatus=function getWfStatus(params){appendUserParams(params);appendAuthParams(params);return WeaTools.callApi('/api/workflow/reqform/wfstatusnew','POST',params);};//加载流程状态计数
var getWfStatusCount=exports.getWfStatusCount=function getWfStatusCount(params){appendUserParams(params);appendAuthParams(params);return WeaTools.callApi('/api/workflow/reqform/wfstatuscount','POST',params);};var updateUserTxStatus=exports.updateUserTxStatus=function updateUserTxStatus(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/updateUserTxStatus','POST',params);};//字段联动接口
var reqDataInputResult=exports.reqDataInputResult=function reqDataInputResult(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/linkage/reqDataInputResult','POST',params);};//SQL联动接口
var reqFieldSqlResult=exports.reqFieldSqlResult=function reqFieldSqlResult(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/linkage/reqFieldSqlResult','POST',params);};//日期时间计算接口
var reqDateTimeResult=exports.reqDateTimeResult=function reqDateTimeResult(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/linkage/reqDateTimeResult','POST',params);};//生成流程编号
var createWfCode=exports.createWfCode=function createWfCode(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/createWfCode','POST',params);};var loadWfCodeFieldValueInfo=exports.loadWfCodeFieldValueInfo=function loadWfCodeFieldValueInfo(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/loadWfCodeFieldValueInfo','POST',params);};var functionLink=exports.functionLink=function functionLink(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/functionLink','POST',params);};var reqOperate=exports.reqOperate=function reqOperate(actionType,params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/'+actionType,'POST',params);};var triggerSubWf=exports.triggerSubWf=function triggerSubWf(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/triggerSubWf','POST',params);};var getUploadFileInfo=exports.getUploadFileInfo=function getUploadFileInfo(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/getUploadFileInfo','POST',params);};var requestImport=exports.requestImport=function requestImport(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/requestImport','POST',params);};var getReqInterventionInfo=exports.getReqInterventionInfo=function getReqInterventionInfo(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/monitor/intervention','POST',params);};var getInterventionUser=exports.getInterventionUser=function getInterventionUser(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/monitor/getUsers','POST',params);};//异常处理选择操作者
var chooseExceptionOperator=exports.chooseExceptionOperator=function chooseExceptionOperator(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/chooseExceptionOperator','POST',params);};//超时设置
var overTimeSetting=exports.overTimeSetting=function overTimeSetting(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/overTimeSetting','POST',params);};//流程撤回
var requestWithDraw=exports.requestWithDraw=function requestWithDraw(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/requestWithdraw','POST',params);};//打印日志基础信息
var getPrintLogBase=exports.getPrintLogBase=function getPrintLogBase(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/getPrintLogBase','POST',params);};//打印日志数据信息
var getPrintLogData=exports.getPrintLogData=function getPrintLogData(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/getPrintLogData','POST',params);};//自由流转读取数据
var freeFlowRead=exports.freeFlowRead=function freeFlowRead(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/freeFlowRead','POST',params);};//自由流转保存数据
var freeFlowSave=exports.freeFlowSave=function freeFlowSave(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/freeFlowSave','POST',params);};//流程编辑锁定相关操作
var editLockOper=exports.editLockOper=function editLockOper(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/editLockOper','POST',params);};//表单打印获取打印模板信息
var loadPrintTemplates=exports.loadPrintTemplates=function loadPrintTemplates(params){// appendUserParams(params);
return WeaTools.callApi('/api/workflow/reqform/loadPrintTemplates','POST',params);};//表单打印获取打印模板信息
var generatePrintLog=exports.generatePrintLog=function generatePrintLog(params){// appendUserParams(params);
return WeaTools.callApi('/api/workflow/reqform/generatePrintLog','POST',params);};//流程督办
var doSupervise=exports.doSupervise=function doSupervise(params){return WeaTools.callApi('/api/workflow/supervise/doSupervise','POST',params);};//获取扩展TAB
var getFormTab=exports.getFormTab=function getFormTab(params){return WeaTools.callApi('/api/workflow/reqform/getFormTab','POST',params);};//获取指定下一节点操作者condition
var getSelectNextFlowCondition=exports.getSelectNextFlowCondition=function getSelectNextFlowCondition(params){return WeaTools.callApi('/api/workflow/reqform/getSelectNextFlowCondition','POST',params);};//获取指定下一节点流转节点信息
var getSelectFlowNodeInfo=exports.getSelectFlowNodeInfo=function getSelectFlowNodeInfo(params){return WeaTools.callApi('/api/workflow/reqform/getSelectFlowNodeInfo','POST',params);};//新版公式
var getFormulasNew=exports.getFormulasNew=function getFormulasNew(params){return WeaTools.callApi('/api/workflow/formula/getFormulas','POST',params);};//获取表单解析后生成的excel文件
var getExportedExcel=exports.getExportedExcel=function getExportedExcel(params){params=encodeURI(encodeURI(params));var formElement=$("<form>").attr("action",(window.ecologyContentPath||'')+'/api/workflow/formexport/formExport').attr("method","POST").attr("style","display:none");var inputElement1=$("<input>").attr("value",params).attr("name","json").attr("type","hidden");var inputElement2=$("<input>").attr("value",$("#requestid").val()).attr("name","requestid").attr("type","hidden");formElement.append(inputElement1).append(inputElement2);$(document.body).append(formElement);formElement.submit();$(formElement).remove();};//获取表单解析后生成的pdf文件
var getExportedPDF=exports.getExportedPDF=function getExportedPDF(params,requestid){params=encodeURI(encodeURI(params).replace(/\+/g,"%2B"));var formElement=$("<form>").attr("action",(window.ecologyContentPath||'')+'/api/workflow/formexport/formExportPDF').attr("method","POST").attr("style","display:none");var inputElement1=$("<input>").attr("value",params).attr("name","json").attr("type","hidden");var inputElement2=$("<input>").attr("value",requestid).attr("name","requestid").attr("type","hidden");formElement.append(inputElement1).append(inputElement2);$(document.body).append(formElement);formElement.submit();$(formElement).remove();};//意见征询收回
var doTakeBack=exports.doTakeBack=function doTakeBack(params){return WeaTools.callApi('/api/workflow/reqform/doTakeBack','POST',params);};//获取自定义操作菜单
var getCustomOperation=exports.getCustomOperation=function getCustomOperation(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/getCustomOperation','POST',params);};//获取自定义操作菜单
var runCustomOperationAction=exports.runCustomOperationAction=function runCustomOperationAction(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/runCustomOperationAction','GET',params);};//邮件催办信息
var getSendEmailInfo=exports.getSendEmailInfo=function getSendEmailInfo(params){return WeaTools.callApi('/api/workflow/supervise/getSendEmailInfo','POST',params);};//分享按钮是否显示
var isShowShareBtn=exports.isShowShareBtn=function isShowShareBtn(){return WeaTools.callApi('/api/systeminfo/appsetting/get','GET',{});};//请求当前流程拥有的关注标签
var getFormAttentionTag=exports.getFormAttentionTag=function getFormAttentionTag(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};params.src="getFormAttentionTag";return WeaTools.callApi('/api/workflow/requestAttention/getAttentionTypeSet','POST',params);};//结束意见征询
var doTakEnd=exports.doTakEnd=function doTakEnd(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return WeaTools.callApi('/api/workflow/reqform/doTakEnd','POST',params);};var checkJoin=exports.checkJoin=function checkJoin(){return WeaTools.callApi('/api/ec/dev/app/checkJoin','GET',{});};var fieldLinkageCfg=exports.fieldLinkageCfg=function fieldLinkageCfg(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};//
return WeaTools.callApi('/api/workflow/reqform/riggerFieldLinkageCfg','POST',params);};var exportFieldSet=exports.exportFieldSet=function exportFieldSet(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};//
return WeaTools.callApi('/api/workflow/reqform/exportFieldSet','POST',params);};var formulaCfg=exports.formulaCfg=function formulaCfg(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};//
return WeaTools.callApi('/api/workflow/reqform/riggerFormulaCfg','POST',params);};//加签简易模式
var loadCondition=exports.loadCondition=function loadCondition(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return WeaTools.callApi('/api/workflow/reqform/getTransferCondition','POST',params);};//获取智能预测流程图数据
var getSimpleWfData=exports.getSimpleWfData=function getSimpleWfData(params){return WeaTools.callApi('/api/workflow/layout/getSimpleModeData','POST',params);};//获取操作者信息
var getOperator=exports.getOperator=function getOperator(params){return WeaTools.callApi('/api/workflow/layout/getOperator',"POST",params);};//获取出口条件
var getRuleCondition=exports.getRuleCondition=function getRuleCondition(params){return WeaTools.callApi('/api/workflow/layout/getRuleCondition','POST',params);};//获取预测者信息
var getForecastInfo=exports.getForecastInfo=function getForecastInfo(params){return WeaTools.callApi('/api/workflow/layout/getForecastInfo','POST',params);};//获取流程图初始化信息
var getFlowChartInfo=exports.getFlowChartInfo=function getFlowChartInfo(params){return WeaTools.callApi('/api/workflow/layout/getFlowChartInfo','POST',params);};/**
 * 获取触发子流程的列表
 * @param params
 */var getTriggerSubWFList=exports.getTriggerSubWFList=function getTriggerSubWFList(params){return WeaTools.callApi('/api/workflow/pocseconddev/getTriggerSubWFList','POST',params);};//获取套红预览地址
var getThPreviewUrl=exports.getThPreviewUrl=function getThPreviewUrl(params){return WeaTools.callApi('/api/workflow/reqform/getThPreviewUrl','POST',params);};//获取套红预览地址
var getThImageFileId=exports.getThImageFileId=function getThImageFileId(params){return WeaTools.callApi('/api/odoc/odocFile/selectMouldForTemplate','POST',params);};//获取套红模板列表
var getThMouldList=exports.getThMouldList=function getThMouldList(params){return WeaTools.callApi('/api/workflow/reqform/getThMouldList','POST',params);};//获取连续处理信息
var getContinnuationProcessInfo=exports.getContinnuationProcessInfo=function getContinnuationProcessInfo(params){return WeaTools.callApi('/api/workflow/reqlist/continnuationProcessInfo','POST',params);};//明细导入设置
var getDetailExpSet=exports.getDetailExpSet=function getDetailExpSet(params){return WeaTools.callApi('/api/workflow/reqform/getDetailExpSet','GET',params);};//明细导入保存设置
var saveDetailExpSet=exports.saveDetailExpSet=function saveDetailExpSet(params){return WeaTools.callApi('/api/workflow/reqform/saveDetailExpSet','POST',params);};//获取发票云的基本信息
var getInvoiceCloudToken=exports.getInvoiceCloudToken=function getInvoiceCloudToken(params){return WeaTools.callApi('/api/fna/fnaEmbileMicroReport/getInvoiceCloudToken','GET',params);};//发票id转发票云id
var getFidOrEcid=exports.getFidOrEcid=function getFidOrEcid(params){return WeaTools.callApi('/api/fna/invoiceLedger/getFidOrEcid','GET',params);};//获取浏览按钮类型转换结果
var getBrowserInfo=exports.getBrowserInfo=function getBrowserInfo(params){return WeaTools.callApi('/api/workflow/formula/assignValue','POST',params);};//获取自动批准完后的下一节点
var getNextNodeContent=exports.getNextNodeContent=function getNextNodeContent(params){return WeaTools.callApi('/api/workflow/reqform/getNextNodeContent','POST',params);};var getFreeNodeBrowserItem=exports.getFreeNodeBrowserItem=function getFreeNodeBrowserItem(params){return WeaTools.callApi('/api/workflow/reqform/getFreeNodeBrowserItem','GET',params);};var saveFreeNodeFormConfig=exports.saveFreeNodeFormConfig=function saveFreeNodeFormConfig(params){return WeaTools.callApi('/api/workflow/reqform/saveFreeNodeFormConfig','POST',params);};//合规校验接口
var conformCheck=exports.conformCheck=function conformCheck(params){appendUserParams(params);return WeaTools.callApi('/api/workflow/reqform/conformCheck','POST',params);};//将异常加载的情况记录日志
var writeFormErrlog=exports.writeFormErrlog=function writeFormErrlog(params){return WeaTools.callApi('/api/workflow/reqform/writeFormErrlog','POST',params);};//获取自定义页签
var getOdocTabManagerDatas=exports.getOdocTabManagerDatas=function getOdocTabManagerDatas(params){return WeaTools.callApi('/api/odoc/odocMenuOperate/getOdocTabManagerDatas','GET',params);};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(301), __esModule: true };


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSecLevelName=exports.buildMultiUserGroupInfo=exports.spellResourceCondition=exports.calExpressionResult=exports.restoreSpeicalChar=exports.getFieldCurViewAttr=exports.convertTimeValue=exports.convertFloatValue=exports.judgeIsNumber=exports.convertNumberValue=exports.restoreSpeicalStr=exports.convertSpecialChar=exports.convertValueBeforeChangeStore=exports.managerValueObjBeforeChangeStore=exports.convertSystemFieldName=exports.getSelectShowName=exports.getRelateFieldShowName=exports.getRelateFieldValues=exports.getRelateFieldValue=exports.getDetailFieldObj=exports.getMainFieldObj=exports.getFieldObj=exports.getFieldValObj=exports.getFieldValue=exports.getFieldAttr=undefined;var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _mobx=__webpack_require__(9);var _inputUtil=__webpack_require__(81);var InputUtil=_interopRequireWildcard(_inputUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import ___Calculate from './caculate_wev8'
//获取字段ID
var getFieldid=function getFieldid(fieldMark){if(fieldMark.indexOf("_")>-1)fieldMark=fieldMark.substring(0,fieldMark.indexOf("_"));if(fieldMark.indexOf("field")>-1)fieldMark=fieldMark.substring(5);return fieldMark;};//获取字段基础信息
var getFieldAttr=exports.getFieldAttr=function getFieldAttr(fieldMark){var fieldid=getFieldid(fieldMark);var fieldAttr=null;var fieldAttrMap=_source2.default.layoutStore.fieldAttrMap;if(fieldAttrMap.has(fieldid))fieldAttr=fieldAttrMap.get(fieldid);return fieldAttr;};//获取字段值
var getFieldValue=exports.getFieldValue=function getFieldValue(fieldid,rowIndex,convertNum){var fieldObj=getFieldValObj(fieldid,rowIndex);return convertNum===true?fieldObj.numValue:fieldObj.value;};//获取字段值对象
var getFieldValObj=exports.getFieldValObj=function getFieldValObj(fieldid,rowIndex){var fieldAttrMap=_source2.default.layoutStore.fieldAttrMap;if(!fieldAttrMap.has(fieldid.toString())){/* eslint no-console: 0 */if(window.console)console.error('getFieldValObj '+fieldid+' Not Exist');return null;}var tableMark=fieldAttrMap.get(fieldid.toString()).tableMark;var fieldMark=tableMark.indexOf("detail")===-1?'field'+fieldid:'field'+fieldid+'_'+rowIndex;return getFieldObj(fieldMark,tableMark);};//获取字段值对象
var getFieldObj=exports.getFieldObj=function getFieldObj(fieldMark,tableMark){if(!tableMark)return null;if(tableMark.indexOf("detail")===-1)return getMainFieldObj(fieldMark);else return getDetailFieldObj(fieldMark,tableMark);};//获取主表字段值对象
var getMainFieldObj=exports.getMainFieldObj=function getMainFieldObj(fieldMark){var mainData=_source2.default.layoutStore.mainData;var fieldObj=null;if(mainData.has(fieldMark))fieldObj=mainData.get(fieldMark);else fieldObj=new _source2.default.FieldEntity();return fieldObj;};//获取明细表字段值对象
var getDetailFieldObj=exports.getDetailFieldObj=function getDetailFieldObj(fieldMark,tableMark){var detailMap=_source2.default.layoutStore.detailMap;var fieldObj=null;var detailObj=detailMap.get(tableMark);var detailData=detailObj.detailData;if(detailData.has(fieldMark))fieldObj=detailData.get(fieldMark);else fieldObj=new _source2.default.FieldEntity();return fieldObj;};//根据字段id取对应字段值
var getRelateFieldValue=exports.getRelateFieldValue=function getRelateFieldValue(fieldid,rowIndex){var fieldidArr=[fieldid];var relateFieldValues=getRelateFieldValues(fieldidArr,rowIndex);return relateFieldValues[fieldid]||"";};//根据字段id集合获取对应字段值
var getRelateFieldValues=exports.getRelateFieldValues=function getRelateFieldValues(){var fieldidArr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var rowIndex=arguments[1];var result={};var _src$layoutStore=_source2.default.layoutStore,mainData=_src$layoutStore.mainData,detailMap=_src$layoutStore.detailMap,fieldAttrMap=_src$layoutStore.fieldAttrMap;fieldidArr.map(function(fieldid){var fieldValue="";if(fieldAttrMap.has(fieldid.toString())){var tableMark=fieldAttrMap.get(fieldid.toString()).tableMark;if(tableMark==="main"){fieldValue=mainData.has('field'+fieldid)?mainData.get('field'+fieldid).value:"";}else if(tableMark.indexOf("detail_")>-1){var detailObj=detailMap.get(tableMark);var detailData=detailObj.detailData;fieldValue=detailData.has('field'+fieldid+'_'+rowIndex)?detailData.get('field'+fieldid+'_'+rowIndex).value:"";}}result[fieldid]=fieldValue.toString();});return result;};//根据字段id集合获取选择框字段对应显示值
var getRelateFieldShowName=exports.getRelateFieldShowName=function getRelateFieldShowName(){var fieldidArr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var rowIndex=arguments[1];var fieldAttrMap=_source2.default.layoutStore.fieldAttrMap;var result={};fieldidArr.forEach(function(field){var fieldid=field.split("_")[0];var info=fieldAttrMap.has(fieldid)?(0,_mobx.toJS)(fieldAttrMap.get(fieldid)):{};if(info.htmltype===5){//选择框
var fieldMark=info.isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;result[fieldMark+'_span']=getSelectShowName(fieldMark,",");}});return result;};//获取选择框字段类型的显示值
var getSelectShowName=exports.getSelectShowName=function getSelectShowName(fieldMark,splitChar){if(fieldMark.indexOf("field")===-1)return"";if(typeof splitChar==="undefined"||splitChar==="")splitChar=",";var showname="";var fieldAttrMap=_source2.default.layoutStore.fieldAttrMap;var index=fieldMark.indexOf("_");var fieldid=index>-1?fieldMark.substring(5,index):fieldMark.substring(5);var rowIndex=index>-1?fieldMark.substring(index+1):-1;var fieldValue=getFieldValue(fieldid,rowIndex);var info=fieldAttrMap.has(fieldid)?(0,_mobx.toJS)(fieldAttrMap.get(fieldid)):{};if(fieldid==-10&&fieldValue!=""){var valueArray=fieldValue.split(",");valueArray=valueArray.filter(function(v){return v!=="";});var _src$globalStore$secL=_source2.default.globalStore.secLevelInfo,secLevelInfo=_src$globalStore$secL===undefined?{}:_src$globalStore$secL;var _secLevelInfo$secLeve=secLevelInfo.secLevelOption,secLevelOption=_secLevelInfo$secLeve===undefined?[]:_secLevelInfo$secLeve;secLevelOption.map(function(item){if(item.key!==""&&_.indexOf(valueArray,item.key)>-1){if(showname!=="")showname+=splitChar;showname+=item.showname;}});}else if(fieldValue!==""&&info.htmltype===5&&info.selectattr){var selectitemlist=info.selectattr.selectitemlist||[];var _valueArray=fieldValue.split(",");_valueArray=_valueArray.filter(function(v){return v!=="";});selectitemlist.map(function(item){if(item.selectvalue!==""&&_.indexOf(_valueArray,item.selectvalue+"")>-1){if(showname!=="")showname+=splitChar;showname+=item.selectname;}});}return showname;};//转换系统字段名称 
var convertSystemFieldName=exports.convertSystemFieldName=function convertSystemFieldName(fieldname){switch(fieldname){case'field-1':return'requestname';case'field-2':return'requestlevel';case'field-3':return'messageType';case'field-5':return'chatsType';default:return fieldname;}};var managerValueObjBeforeChangeStore=exports.managerValueObjBeforeChangeStore=function managerValueObjBeforeChangeStore(){var valueobj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fieldAttr=arguments[1];if(_.isEmpty(fieldAttr))return;var htmltype=fieldAttr.htmltype;var detailtype=fieldAttr.detailtype;//自定义浏览按钮单选，限制只能返回一个数值，包括联动及修改
if(htmltype===3&&detailtype===161){var value=valueobj.value,specialobj=valueobj.specialobj;if(specialobj&&specialobj.length>1){var firstobj=specialobj.splice(0,1);valueobj.specialobj=firstobj;valueobj.value=firstobj[0].id;}}};//修改Store值前，做字段值处理
var convertValueBeforeChangeStore=exports.convertValueBeforeChangeStore=function convertValueBeforeChangeStore(value,fieldAttr){if(_.isEmpty(fieldAttr))return value;if(fieldAttr.encryptFlag>0)return value;var htmltype=fieldAttr.htmltype;var detailtype=fieldAttr.detailtype;var newValue=value;if(htmltype===1){if(detailtype===1){newValue=convertSpecialChar(newValue);}else{//数值字段格式化
newValue=convertNumberValue(newValue,fieldAttr);}}else if(htmltype===2&&detailtype===1){newValue=convertSpecialChar(newValue);}else if(htmltype===3&&detailtype===2){//日期字段格式化
var reg=/^\d{4}-\d{1,2}-\d{1,2}$/;if(!!newValue&&!reg.test(newValue))newValue="";}else if(htmltype===3&&detailtype===402){//年字段格式化
var _reg=/^\d{4}$/;if(!!newValue&&!_reg.test(newValue))newValue="";}else if(htmltype===3&&detailtype===403){//年月字段格式化
var _reg2=/^\d{4}-\d{1,2}$/;if(!!newValue&&!_reg2.test(newValue))newValue="";}else if(htmltype===3&&detailtype===19){//时间字段格式化
var _reg3=/^\d{1,2}:\d{1,2}(:\d{1,2})?$/;if(!!newValue&&!_reg3.test(newValue))newValue="";// //兼容客户自行改数据库时间支持秒varchar(8)情况
// if(fieldAttr.fielddbtype && parseInt(fieldAttr.fielddbtype.match(/\d+/)[0]) <= 5 && newValue.indexOf(":",3) > -1)
//     newValue = newValue.substring(0, newValue.indexOf(":",3));
}else if(htmltype===4){//check框只允许0/1值入库
if(!newValue||newValue.toString()!=="0"&&newValue.toString()!=="1")newValue="0";}return newValue;};//修改Store时，替换特殊字符,转换成提交时需要的格式
var convertSpecialChar=exports.convertSpecialChar=function convertSpecialChar(str,controlSpace){str=str.toString();str=str.replace(/<br>|<br( )?\/>/ig,"\n");if(controlSpace===true){str=str.replace(/((\&nbsp\;){1,})/ig,function(val){return" "+val.substring(6);});}else{str=str.replace(/&nbsp;/ig," ");}str=str.replace(/&lt;/ig,"<");str=str.replace(/&gt;/ig,">");str=str.replace(/&quot;/ig,"\"");str=str.replace(/&amp;/ig,"&");return str;};var restoreSpeicalStr=exports.restoreSpeicalStr=function restoreSpeicalStr(str){str=str.toString();//需先转译
str=str.replace(/&/ig,"&amp;");str=str.replace(/</ig,"&lt;");str=str.replace(/>/ig,"&gt;");//后转译
str=str.replace(/\n/ig,"<br>");//优化断行，多个空格中首个空格不转译，其余空格转&nbsp;
//str = str.replace(/ /ig, "&nbsp;");
//破IE，这样写报错，不支持零宽断言
//str = str.replace(/(?<= ) /ig,'&nbsp;');
str=str.replace(/( {2,})/ig,function(val){return" "+val.substring(1).replace(/ /ig,"&nbsp;");});if(str.charAt(0)===' ')str="&nbsp;"+str.substring(1);//第一个空格 需替换成字符串
str=str.replace(/\"/ig,"&quot;");return str;};//根据字段信息格式化字段值(浮点数位数、转千分位等)
var convertNumberValue=exports.convertNumberValue=function convertNumberValue(realval,fieldAttr){if(realval===null||typeof realval==="undefined")return"";var isqfw=fieldAttr.detailtype===5;if(isqfw)realval=realval.toString().replace(/,/g,"");if(!judgeIsNumber(realval))return"";return convertFloatValue(realval,fieldAttr.qfws,isqfw);};//判断值是否属于数字
var judgeIsNumber=exports.judgeIsNumber=InputUtil.judgeIsNumber;//浮点数值转换
var convertFloatValue=exports.convertFloatValue=InputUtil.convertFloatValue;//时间字段值补零
var convertTimeValue=exports.convertTimeValue=function convertTimeValue(value){var reg=/^\d{1,2}:\d{1,2}(:\d{1,2})?$/;if(!!value&&reg.test(value)){var arr=value.split(":");if(arr[0].length===1)arr[0]="0"+arr[0];if(arr[1].length===1)arr[1]="0"+arr[1];if(arr.length>2&&arr[2].length===1)arr[2]="0"+arr[2];value=arr[0]+":"+arr[1];if(arr.length>2)value+=":"+arr[2];}else value="";return value;};//计算字段当前时刻的只读/必填属性
var getFieldCurViewAttr=exports.getFieldCurViewAttr=function getFieldCurViewAttr(fieldMark,fieldObj){var fieldAttr=getFieldAttr(fieldMark);if(fieldAttr==null)return 0;var _src$layoutStore2=_source2.default.layoutStore,cellInfo=_src$layoutStore2.cellInfo,mainData=_src$layoutStore2.mainData,detailMap=_src$layoutStore2.detailMap;var tableMark=fieldAttr.tableMark;if(!fieldObj)fieldObj=getFieldObj(fieldMark,tableMark);var _fieldObj=fieldObj,variable=_fieldObj.variable;var fieldid=getFieldid(fieldMark);var viewAttr=parseInt(fieldAttr.viewattr)||0;//后台设置的字段属性
if(viewAttr===0&&_.has(cellInfo,["fieldCellInfo",fieldid]))//字段放在模板上但未设置属性的默认给只读属性
viewAttr=1;if(fieldAttr.isonlyshow===1)viewAttr=1;if(variable.has("viewAttr")){//显示属性联动改变的字段属性
var changeViewAttr=parseInt(variable.get("viewAttr"))||0;if(changeViewAttr===1||changeViewAttr===2||changeViewAttr===3)viewAttr=changeViewAttr;}if(viewAttr===2||viewAttr===3){var commonParam=_source2.default.globalStore.commonParam;//已办、提交确认置为只读，提交确认时位置字段需再获取一次，跟随原来的属性
if(parseInt(commonParam.isviewonly||0)===1||parseInt(commonParam.isaffirmance||0)===1&&fieldObj.fieldType!='9-1')viewAttr=1;//不允许修改已有明细置为只读
if(tableMark.indexOf("detail_")>-1){var detailObj=detailMap.get(tableMark);var attr=detailObj.attr,detailData=detailObj.detailData,rowInfo=detailObj.rowInfo;var rowIndex=parseInt(fieldMark.substring(fieldMark.indexOf("_")+1));if(isNaN(rowIndex))return-101;//明细字段被识别在主布局中
var rowAttr=rowInfo.get('row_'+rowIndex);var rowKeyid=rowAttr.get("keyid")||0;if(attr.isedit!==1&&rowKeyid>0)viewAttr=1;}}return viewAttr;};//渲染组件时，字符还原成可显示DOM格式
var restoreSpeicalChar=exports.restoreSpeicalChar=function restoreSpeicalChar(fieldid,str,htmltype,detailtype,viewAttr){if(viewAttr===1&&(htmltype===1&&detailtype===1||htmltype===2&&detailtype===1)){//只读时字符转换成DOM结构
//部分多行文本框由程序插入html源码，只读情况需显示转译后html内容
if((htmltype===1||htmltype===2)&&detailtype===1){var isbill=_source2.default.globalStore.commonParam.isbill;var propFileCfg=_source2.default.layoutStore.propFileCfg;var fieldKey='field'+fieldid+'_'+isbill;var support_html_textarea_field=propFileCfg.support_html_textarea_field||"";if(support_html_textarea_field.indexOf(fieldKey)>-1){str=str.replace(/\n/ig,"<br>");return str;}}str=restoreSpeicalStr(str);//QC966924 统计解决E7升E9单行、多行文本框历史数据乱码问题
str=str.replace(/&amp;#160;/g,'&nbsp;');}return str;};//计算表达式结果
var calExpressionResult=exports.calExpressionResult=function calExpressionResult(expression){var propFileCfg=_source2.default.layoutStore.propFileCfg;// const open_server_eval = propFileCfg && propFileCfg.open_server_eval == "1";
var open_server_eval=false;var result="";try{if(window.___Calculate&&!expression.includes("Math")){var calculate=new window.___Calculate();result=calculate.calculateResult(expression);}else{result=eval(expression);}}catch(e){/* eslint no-console: 0 */if(window.console)console.error("Eval Appear Exception:"+expression);}return result.toString();};//人力资源条件数据处理
var spellResourceCondition=exports.spellResourceCondition=function spellResourceCondition(datas){if(datas){var value=[];datas.map(function(item,index){var seclevel="";if(item.seclevel){var length=item.seclevel.match(/[-]/g).length;if(length==1){seclevel=item.seclevel.replace('-','|@|');}else if(length==2){if(item.seclevel.indexOf("-")==0){seclevel=item.seclevel.replace(/-/g,'|@|');seclevel=seclevel.replace("|@|",'-');}else{var seclevelArr=item.seclevel.split("-");seclevel=seclevelArr[0]+"|@|"+"-"+seclevelArr[2];}}else if(length==3){var _seclevelArr=item.seclevel.split("-");seclevel="-"+_seclevelArr[1]+"|@|"+"-"+_seclevelArr[3];}}if(item.sharetype=="1"){if(item.canDownload){value.push('1_'+item.relatedshare+'_0_0_'+(item.canDownload=='是'?1:0));}else{//移动端人力资源条件字段选完值后，没有回传canDownload属性，处理成默认为是。
value.push('1_'+item.relatedshare+'_0_0_1');}}else if(item.sharetype=="2"||item.sharetype=="3"){if(item.canDownload){value.push(item.sharetype+'_'+item.relatedshare+'_0_'+seclevel+'_'+(item.canDownload=='是'?1:0));}else{value.push(item.sharetype+'_'+item.relatedshare+'_0_'+seclevel+'_1');}}else if(item.sharetype=="4"){if(item.canDownload){value.push('4_'+item.relatedshare+'_'+item.rolelevel+'_'+seclevel+'_'+(item.canDownload=='是'?1:0));}else{value.push('4_'+item.relatedshare+'_'+item.rolelevel+'_'+seclevel+'_1');}}else if(item.sharetype=="5"){if(item.canDownload){value.push('5_0_0_'+seclevel+'_'+(item.canDownload=='是'?1:0));}else{value.push('5_0_0_'+seclevel+'_1');}}else if(item.sharetype=="6"){if(item.joblevel=='2'){if(item.canDownload){value.push('6_'+item.relatedshare+'_0_2|@|2_'+(item.canDownload=='是'?1:0));}else{value.push('6_'+item.relatedshare+'_0_2|@|2_1');}}else{if(item.canDownload){value.push('6_'+item.relatedshare+'_0_'+item.joblevel+'|@|'+item.jobfield+'_'+(item.canDownload=='是'?1:0));}else{value.push('6_'+item.relatedshare+'_0_'+item.joblevel+'|@|'+item.jobfield+'_1');}}}});return value.join('~');}return'';};//处理流程多人力操作组信息
var buildMultiUserGroupInfo=exports.buildMultiUserGroupInfo=function buildMultiUserGroupInfo(){var fieldValueObj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var ids=fieldValueObj.value;var datas=fieldValueObj.specialobj||[];var multiUserType={"subcom":2,"dept":3,"group":4,"virtual_subcom":5,"virtual_dept":7,"all":9};var groupInfo={};var i=0;datas&&datas.map(function(v,k){var type=v.type;var typeid=v.id||0;if(type=="subcom"||type=="dept"||type=="group"){var users=v.users;var userIds=[];users&&users.map(function(o){userIds.push(o.id);});groupInfo['group_'+i]=multiUserType[type]+"|"+typeid+"|"+userIds.join(",");i++;}else if(type=="all"){groupInfo['group_'+i]=multiUserType[type]+"|"+typeid+"|"+ids;i++;}});groupInfo.groupnum=i;return groupInfo;};var getSecLevelName=exports.getSecLevelName=function getSecLevelName(val){var _src$globalStore$secL2=_source2.default.globalStore.secLevelInfo,secLevelInfo=_src$globalStore$secL2===undefined?{}:_src$globalStore$secL2;var secLevelName="";if(secLevelInfo.secLevelOption){secLevelInfo.secLevelOption.map(function(item){if(item.key===val){secLevelName=item.showname;}});}return secLevelName;};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.excelDesignFiles=exports.emailFiles=exports.communicationFiles=exports.smsFiles=exports.fnaFiles=exports.hrmFiles=exports.portalFiles=exports.workflowFiles=exports.workflowPublicFiles=exports.escFiles=exports.dependFiles=exports.odocComsFiles=exports.odocFiles=exports.comMobxFiles=exports.ecComFiles=exports.antdFiles=undefined;var _convert=__webpack_require__(6);var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;var staticVersion="?v="+(WeaTools&&WeaTools.ls&&WeaTools.ls.getStr("staticVersion")||0);var antdFiles=exports.antdFiles=["/cloudstore/resource/pc/com/v1/index.min.js"+staticVersion];var ecComFiles=exports.ecComFiles=["/cloudstore/resource/pc/com/v1/ecCom.min.js"+staticVersion];var comMobxFiles=exports.comMobxFiles=["/spa/coms/index.mobx.js"+staticVersion];var odocFiles=exports.odocFiles=["/formmode/js/CryptoJS3.1.2/aes_wev8.js"+staticVersion,//加密预先加载
"/js/odoc/common/DocUtil_e9.js"+staticVersion,//公文模块对接
"/js/odoc/common/OdocRightBtn.js"+staticVersion,//公文模块对接
"/odoc/odoc/js/wps_sdk.js"+staticVersion,"/js/odoc/common/wpsJsApi.js"+staticVersion,//公文模块对接
"/js/odoc/common/iweboffice2015Util.js"+staticVersion//公文对接金格弹出框模式websocket
];var odocComsFiles=exports.odocComsFiles=["/spa/odoc/static/index.js"+staticVersion,//公文模块对接
"css!/spa/odoc/static/index.css"+staticVersion];var dependFiles=exports.dependFiles=["/spa/workflow/async/zDialog_wev8.js"+staticVersion,"/js/doc/workflow_form_doc_operation.js"+staticVersion,//文档模块对接
"/spa/hrm/eventListener.js"+staticVersion,//人力资源模块对接
"/social/js/drageasy/drageasy.js"+staticVersion,"/social/js/bootstrap/js/bootstrap.js"+staticVersion,"/social/im/js/IMUtil_wev8.js"+staticVersion,"/social/js/imcarousel/imcarousel.js"+staticVersion];var escFiles=exports.escFiles=["/formmode/js/CryptoJS3.1.2/mode_ecb_wev8.js"+staticVersion,"/js/weaver_encrypt/jsencrypt_wev.js"+staticVersion,"/js/weaver_encrypt/weaver_encrypt.js"+staticVersion,"/js/weaver_encrypt/weaver_encrypt_ctrl.js"+staticVersion];var workflowPublicFiles=exports.workflowPublicFiles=["/spa/workflow/static4public/index.js"+staticVersion,"css!/spa/workflow/static4public/index.css"+staticVersion];var workflowFiles=exports.workflowFiles=["/spa/workflow/static/index.js"+staticVersion,"css!/spa/workflow/static/index.css"+staticVersion];var portalFiles=exports.portalFiles=["/spa/portal/public/index.js"+staticVersion,"css!/spa/portal/public/index.css"+staticVersion,"/spa/portal/static/index.js"+staticVersion,"css!/spa/portal/static/index.css"+staticVersion];var hrmFiles=exports.hrmFiles=["/spa/hrm/static4enginePublic/engine.js"+staticVersion];var fnaFiles=exports.fnaFiles=["/spa/fna/fnaSpecial/index_mobx.js"+staticVersion,"/spa/fna/static/index.js"+staticVersion,"css!/spa/fna/static/index.css"+staticVersion];var smsFiles=exports.smsFiles=["/spa/smallApp/static/index.js"+staticVersion,"css!/spa/smallApp/static/index.css"+staticVersion];var communicationFiles=exports.communicationFiles=["css!/blog/js/weaverImgZoom/weaverImgZoom_wev8.css"+staticVersion,"/blog/js/weaverImgZoom/weaverImgZoom_wev8.js"+staticVersion];var emailFiles=exports.emailFiles=["/spa/email/static/index.js"+staticVersion,"css!/spa/email/static/index.css"+staticVersion];var excelDesignFiles=exports.excelDesignFiles=["/spa/workflow/excelDesign/engine.js"+staticVersion,"css!/spa/workflow/excelDesign/engine.css"+staticVersion];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Loading=function(_React$Component){(0,_inherits3.default)(Loading,_React$Component);function Loading(){(0,_classCallCheck3.default)(this,Loading);return(0,_possibleConstructorReturn3.default)(this,(Loading.__proto__||(0,_getPrototypeOf2.default)(Loading)).call(this));}(0,_createClass3.default)(Loading,[{key:'render',value:function render(){return _react2.default.createElement('div',null);}}]);return Loading;}(_react2.default.Component);exports.default=Loading;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
if (typeof __g == 'number')
    __g = global; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(13);
var ctx = __webpack_require__(36);
var hide = __webpack_require__(42);
var has = __webpack_require__(41);
var PROTOTYPE = 'prototype';
var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL)
        source = name;
    for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && has(exports, key))
            continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
            // bind timers to global for call from export context
            : IS_BIND && own ? ctx(out, global)
                // wrap global constructors for prevent change them in library
                : IS_WRAP && target[key] == out ? (function (C) {
                    var F = function (a, b, c) {
                        if (this instanceof C) {
                            switch (arguments.length) {
                                case 0: return new C();
                                case 1: return new C(a);
                                case 2: return new C(a, b);
                            }
                            return new C(a, b, c);
                        }
                        return C.apply(this, arguments);
                    };
                    F[PROTOTYPE] = C[PROTOTYPE];
                    return F;
                    // make static versions for prototype methods
                })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $export.R && expProto && !expProto[key])
                hide(expProto, key, out);
        }
    }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.controlSlidePrompt=exports.calculateDetailAreaStyle=exports.judgeLockedBtnRow=exports.controlDetailPosition=exports.syncLockedRowHeight=exports.syncLockedForDidMount=exports.syncDetailScrollXPosition=exports.syncFixedHeadWidth=exports.fixedDetailHead=exports.judgeDetailContainSum=exports.delAssignRow=exports.copyRow=exports.copyDetailRow=exports.addRow4Cp=exports.addRow=exports.setAllRowChecked=exports.setRowChecked=exports.getDetailCheckedRowArr=exports.judgeIsCardEdit=exports.getDetailObj=undefined;var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _globalUtil=__webpack_require__(30);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var jQuery=window.jQuery;//获取明细对象
var getDetailObj=exports.getDetailObj=function getDetailObj(detailMark){var detailMap=_source2.default.layoutStore.detailMap;if(!detailMap.has(detailMark)){/* eslint no-console: 0 */if(window.console)console.error('getDetailObj '+detailMark+' Not Exist');return null;}return detailMap.get(detailMark);};//判定移动端明细是否卡片编辑
var judgeIsCardEdit=exports.judgeIsCardEdit=function judgeIsCardEdit(detailObj){return!(detailObj&&detailObj.attr&&detailObj.attr.mobilecardedit===0);};//获取选中行数组
var getDetailCheckedRowArr=exports.getDetailCheckedRowArr=function getDetailCheckedRowArr(detailObj){var rowArr=[];detailObj.rowInfo.forEach(function(info,rowKey){if(info.get("checked"))rowArr.push(rowKey.substring(4));});return rowArr;};//选中单行
var setRowChecked=exports.setRowChecked=function setRowChecked(detailMark,rowIndex,bool){var detailObj=getDetailObj(detailMark);detailObj&&detailObj.controlRowChecked(rowIndex.toString(),bool);};//全部选中
var setAllRowChecked=exports.setAllRowChecked=function setAllRowChecked(detailMark,bool){var detailObj=getDetailObj(detailMark);detailObj&&detailObj.controlRowChecked(detailObj.currentPageRowIndexStr,bool);};//新增明细行(统一调用此方法)
var addRow=exports.addRow=function addRow(detailMark){var initAddRowData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var fromLinkage=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var isCopy=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var mergeLinkageCfg=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};var detailObj=getDetailObj(detailMark);if(detailObj===null)return;var detailIndex=parseInt(detailMark.substring(7));return(0,_globalUtil.verifyCustomRegisterEvent)(_interface2.default.OPER_ADDROW+detailIndex,function(){var addRowIndex=parseInt(detailObj.indexnum);//新增前取
detailObj.add_Row(initAddRowData,fromLinkage,isCopy);if(_.isEmpty(mergeLinkageCfg))_source2.default.layoutStore.triggerAllLinkage(3,detailMark,"",addRowIndex);else if(!mergeLinkageCfg.forbidLinkage){var mergeRowIndexStr=mergeLinkageCfg.rowIndexStr||"";if(mergeRowIndexStr&&mergeRowIndexStr.substring(mergeRowIndexStr.length-1)!==",")mergeRowIndexStr+=",";mergeRowIndexStr+=addRowIndex;_source2.default.layoutStore.triggerAllLinkage(3,detailMark,"",mergeRowIndexStr);}//执行自定义新增行接口，延时解决DOM先变更，函数体取新增行值情况
_interface2.default.triggerAction(_interface2.default.ACTION_ADDROW+detailIndex,[addRowIndex],100);window.setTimeout(function(){syncFixedHeadWidth(detailIndex-1);//需要延时，解决只读情况添加行为可编辑行又自撑问题
},50);return addRowIndex;});};//新增明细行(统一调用此方法)
var addRow4Cp=exports.addRow4Cp=function addRow4Cp(detailMark){var initAddRowData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var fromLinkage=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var isCopy=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var mergeLinkageCfg=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};var detailObj=getDetailObj(detailMark);if(detailObj===null)return;var detailIndex=parseInt(detailMark.substring(7));return(0,_globalUtil.verifyCustomRegisterEvent)(_interface2.default.OPER_ADDROW+detailIndex,function(){var addRowIndex=parseInt(detailObj.indexnum);//新增前取
detailObj.add_Row(initAddRowData,fromLinkage,isCopy);window.setTimeout(function(){syncFixedHeadWidth(detailIndex-1);//需要延时，解决只读情况添加行为可编辑行又自撑问题
},50);return addRowIndex;});};//复制明细行
var copyDetailRow=exports.copyDetailRow=function copyDetailRow(detailMark){var detailObj=getDetailObj(detailMark);if(detailObj===null)return;var rowArr=getDetailCheckedRowArr(detailObj);if(rowArr.length===0)return;copyRow(detailMark,rowArr);};//复制明细行(统一调用此方法)
var copyRow=exports.copyRow=function copyRow(detailMark){var rowArr=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var detailObj=getDetailObj(detailMark);var propFileCfg=_source2.default.layoutStore.propFileCfg;if(rowArr.length===0||detailObj===null)return;rowArr.sort(function(a,b){return a-b;});var rowInfo=detailObj.rowInfo,fieldInfo=detailObj.fieldInfo,detailData=detailObj.detailData;rowArr.map(function(destRow){if(parseInt(destRow)<0||!rowInfo.has('row_'+destRow))return true;var initData={};_.forIn(fieldInfo,function(v,k){if(detailData.has('field'+k+'_'+destRow)&&v.htmltype!==6&&v.encryptFlag===0)initData['field'+k]=detailData.get('field'+k+'_'+destRow).valueObj;});if(propFileCfg.detail_copy_skip_linkage==="1"){addRow4Cp(detailMark,initData,false,true);}else{addRow(detailMark,initData,false,true);}});// detailObj.clearAllRowChecked();
};//删除明细指定行(统一调用此方法)
var delAssignRow=exports.delAssignRow=function delAssignRow(detailMark,rowArr){var detailObj=getDetailObj(detailMark);if(detailObj===null)return;var detailIndex=parseInt(detailMark.substring(7));return(0,_globalUtil.verifyCustomRegisterEvent)(_interface2.default.OPER_DELROW+detailIndex,function(){detailObj.del_Row(rowArr);_source2.default.layoutStore.triggerAllLinkage(4,detailMark,'',rowArr.join(","));//执行自定义删除行接口
_interface2.default.triggerAction(_interface2.default.ACTION_DELROW+detailIndex,[rowArr],50);});};//判断明细是否含有合计字段(用于低级模式是否需要扩充合计行)
var judgeDetailContainSum=exports.judgeDetailContainSum=function judgeDetailContainSum(detailMark){var containSum=false;var _src$layoutStore=_source2.default.layoutStore,detailMap=_src$layoutStore.detailMap,cellInfo=_src$layoutStore.cellInfo,linkageCfg=_src$layoutStore.linkageCfg;var detailObj=detailMap.get(detailMark);_.forIn(detailObj.fieldInfo,function(v,fieldid){if(v.viewattr>0&&_.has(cellInfo,["fieldCellInfo",fieldid])&&_.has(linkageCfg,["colCalCfg",fieldid])){containSum=true;return false;}});return containSum;};//滚动过程中控制表头固定
var fixedDetailHead=exports.fixedDetailHead=function fixedDetailHead(){var container=_source2.default.isMobile?jQuery('.wf-req-content'):jQuery('.wf-req-form-scroll');var conOffsetTop=container.offset().top;container.find(".excelDetailTableDiv").each(function(){var groupid=jQuery(this).attr("data-groupid");var detailFixedDiv=jQuery(this).find("[class^=excelDetailFixedHead]");var detailTable=jQuery("#oTable"+groupid);var lockedBtn=jQuery(this).parent().find(".wf-detail-locked-btnrow");var existLockedBtn=lockedBtn.length>0;var detailHeight=detailTable.height();var unFixedFn=function unFixedFn(){if(existLockedBtn)lockedBtn.removeClass("wf-detail-locked-btnrow-fixed");detailFixedDiv.hide();};if(detailHeight<300){//此if不能后移，会导致部分ios滑动闪屏，why...
unFixedFn();return true;}var detailOffsetTop=detailTable.offset().top;var fixedHeadHeight=detailFixedDiv.height();var lockedBtnHeight=0;if(existLockedBtn){lockedBtnHeight=lockedBtn.height();detailHeight+=lockedBtnHeight;fixedHeadHeight+=lockedBtnHeight;}var fixedFn=function fixedFn(){if(existLockedBtn){lockedBtn.addClass("wf-detail-locked-btnrow-fixed");lockedBtn.find(".wf-detail-locked-btnrow-content").css("top",conOffsetTop);}detailFixedDiv.css("top",conOffsetTop+lockedBtnHeight).show();syncFixedHeadWidth(groupid);syncDetailScrollXPosition(groupid);};//冻结表头，明细表最低要求200px高度
//console.log("groupid",groupid,"detailHeight",detailHeight,"detailOffsetTop",detailOffsetTop,"conOffsetTop",conOffsetTop,"fixedHeadHeight",fixedHeadHeight);
if(detailOffsetTop<conOffsetTop&&detailOffsetTop+detailHeight>=fixedHeadHeight+conOffsetTop){fixedFn();}else{unFixedFn();}});};//同步列宽到固定表头,列锁定情况仅同步滚动区域
var syncFixedHeadWidth=exports.syncFixedHeadWidth=function syncFixedHeadWidth(groupid){try{var detailTable=jQuery("#oTable"+groupid);var detailFixedTable=jQuery("#oTable"+groupid+"_head");var detailFixedDiv=detailFixedTable.parent();if(!detailFixedDiv.is(":hidden")){detailFixedTable.width(detailTable.width());var fixedWidthRow=detailFixedTable.find("tr.detailControlWidth");detailTable.find("tr.detailControlWidth").children().each(function(index){fixedWidthRow.find("td:eq("+index+")").css("width",jQuery(this).width()+"px");});detailFixedDiv.css("width",detailFixedDiv.parent().width());}}catch(e){}};//同步横向滚动条位置到固定表头
var syncDetailScrollXPosition=exports.syncDetailScrollXPosition=function syncDetailScrollXPosition(groupid){try{var detailArea=window.jQuery("#dTableArea_"+groupid);detailArea.find(".excelDetailFixedHead").scrollLeft(detailArea.find(".excelDetailContent").scrollLeft());}catch(e){}};//锁定列情况，加载完同步一次高度宽度
var syncLockedForDidMount=exports.syncLockedForDidMount=function syncLockedForDidMount(groupid){var syncFn=function syncFn(){var dTableArea=jQuery("#dTableArea_"+groupid);if(dTableArea.attr("data-supportlockedcol")!=="true")return;var oTable=dTableArea.find("table#oTable"+groupid);var oTable_head=dTableArea.find("table#oTable"+groupid+"_head");var oTableLocked=dTableArea.find("table#oTable"+groupid+"_locked");var oTableLocked_head=dTableArea.find("table#oTable"+groupid+"_head_locked");if(oTable.length!==1||oTableLocked.length!==1)return;//解决隐藏列宽度变化问题,将数据层的隐藏列宽度总和赋值给锁定层
var lockedCount=oTableLocked.find(".detailControlWidth").children().length;var totalWidth=0;oTable.find(".detailControlWidth").children().each(function(index){if(index<lockedCount&&!jQuery(this).hasClass("detail_hide_col"))totalWidth+=jQuery(this).width();});if(Math.abs(oTable.height()-oTableLocked.height())<=3&&Math.abs(oTableLocked.width()-totalWidth)<=3)return;oTableLocked.find("tr[data-rowkey]").each(function(){var rowKey=jQuery(this).attr("data-rowkey");var lockedRow=oTableLocked.find("tr[data-rowkey="+rowKey+"]");var dataRow=oTable.find("tr[data-rowkey="+rowKey+"]");if(lockedRow.length===1&&dataRow.length===1){var dataRowHeight=dataRow[0].getBoundingClientRect().height;var lockedRowHeight=lockedRow[0].getBoundingClientRect().height;var maxHeight=dataRowHeight>=lockedRowHeight?dataRowHeight:lockedRowHeight;lockedRow.add(dataRow).css("height",maxHeight);oTable_head.add(oTableLocked_head).find("tr[data-rowkey="+rowKey+"]").css("height",maxHeight);}});if(Math.abs(oTableLocked.width()-totalWidth)>3){dTableArea.find("table#oTable"+groupid+"_head_locked").width(totalWidth);oTableLocked.width(totalWidth);}};var begintime=new Date().getTime();var didsynctimer=window.setInterval(function(){try{syncFn();var curtime=new Date().getTime();if(curtime-begintime>10000)window.clearInterval(didsynctimer);}catch(e){}},200);};//锁定列情况，字段值变化后，同步行高度
var detailSyncRowController={};var syncLockedRowHeight=exports.syncLockedRowHeight=function syncLockedRowHeight(fieldid,rowIndex){var fieldAttrMap=_source2.default.layoutStore.fieldAttrMap;if(rowIndex<0||!fieldAttrMap.has(fieldid))return;var fieldAttr=fieldAttrMap.get(fieldid);var tableMark=fieldAttr.tableMark,htmltype=fieldAttr.htmltype,detailtype=fieldAttr.detailtype;if(tableMark.indexOf("detail_")===-1||htmltype===1&&detailtype>1||htmltype===4)return;var groupid=parseInt(tableMark.substring(7))-1;var fieldMark='field'+fieldid+'_'+rowIndex;var dTableArea=jQuery("div#dTableArea_"+groupid);var fieldDom=dTableArea&&dTableArea.find("[data-fieldmark="+fieldMark+"]");if(fieldDom.length===0)return;var editTrDom=fieldDom.closest("tr");var rowKey=editTrDom.attr("data-rowkey");var rowDefHeight=fieldDom.closest("tr").attr("data-rowheight");if(!!rowKey&&!!rowDefHeight){//存在锁定列
var lockedRow=dTableArea.find(".excelDetailContent_locked").find("tr[data-rowkey="+rowKey+"]");var dataRow=dTableArea.find(".excelDetailContent").find("tr[data-rowkey="+rowKey+"]");if(lockedRow.length===1&&dataRow.length===1){var rowDom=lockedRow.add(dataRow);var maxHeight=dataRow.height()>=lockedRow.height()?dataRow.height():lockedRow.height();rowDom.css("height",maxHeight);//定时同步一次，实现高度递减等情况的同步,每200ms执行一次，至多3s取消定时，控制每行同一时刻仅存在一个定时器
var detailRowKey=tableMark+'_'+rowKey;if(!detailSyncRowController[detailRowKey]){var begintime=new Date().getTime();var synctimer=window.setInterval(function(){detailSyncRowController[detailRowKey]="1";var clearsynctimer=function clearsynctimer(){window.clearInterval(synctimer);detailSyncRowController[detailRowKey]="";};var maxChildHeight=0;rowDom.children().each(function(){var childHeight=jQuery(this).children(":first")&&jQuery(this).children(":first").height()||0;if(childHeight>maxChildHeight)maxChildHeight=childHeight;});if(Math.abs(maxHeight-maxChildHeight)>4){rowDom.css("height",maxChildHeight+4);clearsynctimer();}var curtime=new Date().getTime();if(curtime-begintime>3000)clearsynctimer();},200);}}}};//控制明细表位置，定位到表头滚动即将固定的状态
var controlDetailPosition=exports.controlDetailPosition=function controlDetailPosition(groupid){var container=_source2.default.isMobile?jQuery('.wf-req-content'):jQuery('.wf-req-form-scroll');var oTable=jQuery("#oTable"+groupid);var offset=oTable.offset().top;var scrollTop=container.scrollTop();var setOffsetTop=container.offset().top+10;var setScrollTop=offset+scrollTop-setOffsetTop;if(setScrollTop>0)container.scrollTop(setScrollTop);};/**
     * 判断是否将首行移到顶部，解决添加删除按钮跟着滚动问题
     * 需满足条件：
     * 1、开启横向滚动条、高级定制模式
     * 2、根据配置文件控制，默认开启
     * 3、首行包括添加删除按钮，且添加删除按钮不在锁定部分，且首行单元格不能包含除添加按钮、文字外其它类型，且首行单元格不能存在行合并
     */var judgeLockedBtnRow=exports.judgeLockedBtnRow=function judgeLockedBtnRow(allowXScroll,detailLayout){var propFileCfg=_source2.default.layoutStore.propFileCfg;var _detailLayout$seniors=detailLayout.seniorset,seniorset=_detailLayout$seniors===undefined?"0":_detailLayout$seniors,edtitleinrow=detailLayout.edtitleinrow,_detailLayout$edlocke=detailLayout.edlockedcol,edlockedcol=_detailLayout$edlocke===undefined?"":_detailLayout$edlocke,ec=detailLayout.ec;var lockedCol=_source2.default.isMobile||isNaN(parseInt(edlockedcol))?-1:parseInt(edlockedcol);if(!allowXScroll||propFileCfg.detail_locked_button_row!=="1"||parseInt(edtitleinrow)<=1||parseInt(seniorset)!==1)return false;var hasButton=false;var disabledLocked=false;ec.forEach(function(cell){var id=cell.id,_cell$rowspan=cell.rowspan,rowspan=_cell$rowspan===undefined?"1":_cell$rowspan,_cell$etype=cell.etype,etype=_cell$etype===undefined?"1":_cell$etype;var rowid=parseInt(id.split(",")[0]);var colid=parseInt(id.split(",")[1]);if(rowid===0){if((etype==="10"||etype==="23")&&colid>lockedCol)hasButton=true;if(etype===""||etype==="0"||etype==="1"||etype==="10"||etype==="23"){if(parseInt(rowspan)>1)disabledLocked=true;}else{disabledLocked=true;}}});return hasButton&&!disabledLocked;};//获取明细表锁定列数
var getLockedColumn=function getLockedColumn(dMark){var dataJson=_source2.default.layoutStore.dataJson;var detailLayout=dataJson.etables[dMark]||{};return parseInt(detailLayout.edlockedcol||-1);};//计算指定区域下明细表样式，兼容标签页内嵌明细情况
var calculateDetailAreaStyle=exports.calculateDetailAreaStyle=function calculateDetailAreaStyle(){var area=arguments.length>0&&arguments[0]!==undefined?arguments[0]:jQuery();var detailMap=_source2.default.layoutStore.detailMap;area.find(".wf-detail").each(function(){if(!jQuery(this).is(":visible"))return true;var excelDetailTableDiv=jQuery(this).find(".excelDetailTableDiv");var groupid=parseInt(excelDetailTableDiv.attr("data-groupid"));var swapWidth=excelDetailTableDiv.width();var dataAreaWidth=excelDetailTableDiv.find("#oTable"+groupid).width();var lockedAreaWidth=excelDetailTableDiv.find("#oTable"+groupid+"_locked")&&excelDetailTableDiv.find("#oTable"+groupid+"_locked").width()||0;var dMark="detail_"+(groupid+1);var detailObj=detailMap.get(dMark);if(swapWidth>=dataAreaWidth){//宽度不足，横向滚动条失效
detailObj.controlVariableMap("forceDisabledScrollX",true);}else if(swapWidth+(_source2.default.isMobile?-60:10)<=lockedAreaWidth){//锁定宽度过大，锁定列失效
var msg=_source2.default.getLabel(525843,"明细表$dt设置了前$col列为锁定列，但前$col列列宽总和已超过明细表可视区域宽度，锁定列自动失效");msg=msg.replace(/\$dt/i,groupid+1).replace(/\$col/g,getLockedColumn(dMark));window.WfForm.showMessage(msg,1,4);detailObj.controlVariableMap("forceDisabledLocked",true);}var lockedBtnRow=jQuery(this).find(".wf-detail-locked-btnrow");if(lockedBtnRow.length>0){var topRowHeight=lockedBtnRow.height();var topRowWidth=lockedBtnRow.parent().width()-1;lockedBtnRow.find(".wf-detail-locked-btnrow-content").width(topRowWidth);lockedBtnRow.find(".wf-detail-locked-btnrow-placeholder").height(topRowHeight);}syncLockedForDidMount(groupid);});};//移动端滚动过程中，控制锁定列滑动提示的位置与显示
var controlSlidePrompt=exports.controlSlidePrompt=function controlSlidePrompt(){var container=jQuery('.wf-req-content');var baseTop=container.offset().top+container.height();var detailMap=_source2.default.layoutStore.detailMap;jQuery('.wf-req-content').find(".excelDetailTableDiv").each(function(){if(jQuery(this).attr("data-supportlockedcol")!=="true")return true;var groupid=parseInt(jQuery(this).attr("data-groupid"));var lockedTable=jQuery(this).find("#oTable"+groupid+"_locked");var detailObj=detailMap.get('detail_'+(groupid+1));var variableMap=detailObj.variableMap;if(lockedTable.length!==1||variableMap.has("slideprompt_show")||lockedTable.offset().top+30>baseTop)return;//明细处于可视区域，滑动提示显示3s自动消失    
var lastHeadRow=lockedTable.find("tr[data-rowKey^=headRow]").last();var top=lastHeadRow.offset().top+lastHeadRow.height()/2-lockedTable.offset().top;var left=lockedTable.width()-2;detailObj.batchControlVariableMap({slideprompt_show:true,slideprompt_top:top,slideprompt_left:left});window.setTimeout(function(){detailObj.batchControlVariableMap({slideprompt_show:false});},2000);});};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(37)(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * @author liuzy 2018-09-05 
 * public目录下方法为PC端与移动端共用方法
 * public目录下文件不能import除此目录外任何文件，不能引入ecCom、antd组件，修改public目录需注意兼容PC端、移动端
 * 方法内部可能存在数据源、函数体等在两种终端逻辑不一致情况，统一通过此类过渡,不同终端先set进来，public方法内import此文件调用，达到两种终端适配
 */var src={isMobile:false,globalStore:{},layoutStore:{},FieldEntity:null,API_REQ:null,getLabel:null,setIsMobile:function setIsMobile(flag){this.isMobile=flag;},init:function init(globalStore,layoutStore,FieldEntity,API_REQ,getLabel){this.globalStore=globalStore;this.layoutStore=layoutStore;this.FieldEntity=FieldEntity;this.API_REQ=API_REQ;this.getLabel=getLabel;}};exports.default=src;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(467), __esModule: true };


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
module.exports = isArray;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var FORM_MODIFY_LOG=exports.FORM_MODIFY_LOG='form_modify_log';var IMPORT_WF_DETAIL_MODAL=exports.IMPORT_WF_DETAIL_MODAL='importWfDetailModal';var CHOOSE_EXCEPTION_OPERATOR=exports.CHOOSE_EXCEPTION_OPERATOR='choose_exception_operator';var REJECT_CHOOSE=exports.REJECT_CHOOSE='reject_choose';var OVERTIME_SETTING=exports.OVERTIME_SETTING='overtime_setting';var HRM_EMPLOYEE_SETTING=exports.HRM_EMPLOYEE_SETTING='HrmEmployeeSetting';var PRINT_LOG=exports.PRINT_LOG='print_log';var SEND_SMS=exports.SEND_SMS='send_sms';var SEND_SMS_PARAMS=exports.SEND_SMS_PARAMS='send_sms_params';var FREEFLOW_SETTING=exports.FREEFLOW_SETTING='freeflow_setting';var DO_SUPERVISE=exports.DO_SUPERVISE='do_supervise';var FORWARD_BACK=exports.FORWARD_BACK='forward_back';var SELECT_NEXTFLOW=exports.SELECT_NEXTFLOW='select_nextflow';var SELECT_NEXTFLOW_NODEINFO=exports.SELECT_NEXTFLOW_NODEINFO='select_nextflow_nodeinfo';var SHARE_WORKFLOW=exports.SHARE_WORKFLOW='share_workflow';var HANDLE_REMIND=exports.HANDLE_REMIND='handle_remind';var NEED_SHOW_CHART=exports.NEED_SHOW_CHART='need_show_chart';var SUBMIT_TYPE=exports.SUBMIT_TYPE='submit_type';var LOCATION_MAP=exports.LOCATION_MAP='location_map';var SEND_MAIL=exports.SEND_MAIL='send_mail';var SEND_MAIL_PARAMS=exports.SEND_MAIL_PARAMS='send_mail_params';var FREE_FLOW_SET=exports.FREE_FLOW_SET='free_flow_set';var FREE_WORKFLOW_SIMPLE=exports.FREE_WORKFLOW_SIMPLE='free_workflow_simple';var ENSURE_SUBMIT=exports.ENSURE_SUBMIT='ensure_submit';//流程提交二次确认
var WORKFLOW_WITHDRAW=exports.WORKFLOW_WITHDRAW='workflow_withdraw';//流程撤回
var FREE_FLOW_CHANGEFORM=exports.FREE_FLOW_CHANGEFORM='free_flow_changeform';//自由流程自定义更换表单
var FREE_FLOW_CHANGESTYLE=exports.FREE_FLOW_CHANGESTYLE='free_flow_changestyle';//自由流程自定义更换样式
var CONFORM_RULE=exports.CONFORM_RULE='conform_rule';

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(333), __esModule: true };


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getUpdateReqInfoFieldValue=exports.getWaterMarkFieldShowName=exports.loadCaculateResource=exports.handWritingHander=exports.imageStyleHander=exports.executeRightBtnClick=exports.verifyCustomRegisterEvent=exports.judgeExistXScrollDetail=exports.loadCssFileContent=exports.manageCssFilePollute=exports.manageScriptContent=exports.loadInjectDevFiles=exports.loadFormulaResource=exports.loadCustomFiles=exports.generateScriptPromiseList=exports.generateCustomPageList=exports.importantParamRange=exports.baseParamRange=exports.commonApiParamRange=exports.commonParamRange=undefined;var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _promise=__webpack_require__(98);var _promise2=_interopRequireDefault(_promise);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _map=__webpack_require__(242);var _map2=_interopRequireDefault(_map);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _loadjs=__webpack_require__(83);var _loadjs2=_interopRequireDefault(_loadjs);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _FormulaNew=__webpack_require__(248);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _mobx=__webpack_require__(9);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _linkageControl=__webpack_require__(84);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var commonParamRange=exports.commonParamRange=["verifyRight","requestid","workflowid","nodeid","formid","isbill","f_weaver_belongto_userid","f_weaver_belongto_usertype","authStr","authSignatureStr","signatureSecretKey","signatureAttributesStr","titlename","workflowname","currentnodetype","nodetype","nodename","iscreate","isviewonly","isaffirmance","isshared","iswfshare","ismode","modeid","isagent","beagenter","creater","creatertype","requestType","isSelfAuth","isprint","wfmonitor","isrequest","desrequestid","custompage","docViewUrl","fileViewUrl","layouttype","layoutversion","isFree",'isFreeCustomeForm',"isHideArea","isHideInput","intervenorright","isWorkflowDoc","flowDocFieldId","needconfirm","currentnodeid","isurger","newdocpath","belongTest","wfTestStr","billIncludePage","margin","printLogListFlag","helpdocid","isremark","takisremark","isOpenCommunication","hasNewCommunication","showDefaultSign","showDefaultLogList","agentType","agentorByAgentId","selectNextFlow","hasFreeNode","freeNodeExtendNodeId","isNeedFlowFreeNodeTips","canSubmitToRejectNode","billIncludePage4mobile","address","position","showLayoutSwitch","layoutAnalysisType","mobileSupportViewFileType","waterMarkInfo",//移动端独有
"apiResultCacheKey","selectNextFlowPattern","showFreeWfSimpleCom","existSynergy","languageid","lastname","msgSubmitFormAction","appDetachDisableAll","allowAllPersonGroup",'btnLabelName',"openAutoForecast","showAutoForecastResult","iscowork","coworkid","needReloadList","currentNodeAttribute","useInvoiceCloud","requestnamenew","requestname","linkageUUID",'freeStartNodeid',"showAI","openNodeCheck","wfFormFieldChangeCfg","openDataVerify","currentUserid"];var commonApiParamRange=exports.commonApiParamRange=["requestid","workflowid","nodeid","formid","isbill","f_weaver_belongto_userid","f_weaver_belongto_usertype","authStr","authSignatureStr","signatureSecretKey","signatureAttributesStr","nodetype","iscreate","isfromtab","isviewonly","isaffirmance","isshared","iswfshare","ismode","modeid","isagent","beagenter","toexcel","creater","needconfirm","creatertype","requestType","isSelfAuth","isprint","wfmonitor","isurger","intervenorright","isSubmitDirect","selectNextFlow","agentType","agentorByAgentId","layouttype","freeNodeExtendNodeId","apiResultCacheKey"];var baseParamRange=exports.baseParamRange=["requestid","workflowid","nodeid","formid","isbill","f_weaver_belongto_userid","f_weaver_belongto_usertype","languageid"];var importantParamRange=exports.importantParamRange=["requestid","workflowid","nodeid","formid","isbill","f_weaver_belongto_userid","f_weaver_belongto_usertype","src","remark","authStr","iscreate","authSignatureStr","signatureSecretKey","signatureAttributesStr"];//获取自定义页面列宽
var generateCustomPageList=exports.generateCustomPageList=function generateCustomPageList(){//先加载自定义页面，顺序：全局自定义页面、单据自定义页面、路径自定义页面
var commonParam=_source2.default.globalStore.commonParam;var _commonParam$billIncl=commonParam.billIncludePage,billIncludePage=_commonParam$billIncl===undefined?"":_commonParam$billIncl,custompage=commonParam.custompage;var customArr=custompage.jspPage||[];customArr.push(billIncludePage);var tmp=new _map2.default();customArr=customArr.filter(function(item){return item!==""&&!tmp.has(item)&&tmp.set(item,true);});//去重替空值
return customArr;};//获取模板代码开发Promise列表
var generateScriptPromiseList=exports.generateScriptPromiseList=function generateScriptPromiseList(){loadInjectDevFiles();//注入自定义开发文件列表
var API_REQ=_source2.default.API_REQ,globalStore=_source2.default.globalStore,layoutStore=_source2.default.layoutStore;var isSourceLayout=globalStore.isSourceLayout,urlParams=globalStore.urlParams,commonParam=globalStore.commonParam,commonApiParam=globalStore.commonApiParam;var customParam=(0,_extends3.default)({},urlParams,commonApiParam);var customArr=generateCustomPageList();/* eslint no-console: 0 */if(window.console)console.log("customPageArr:",customArr);var promiseList=[];customArr&&customArr.forEach(function(item){promiseList.push(API_REQ.loadCustompage(item,customParam));});//再加载代码块
if(!isSourceLayout){promiseList.push(API_REQ.loadScriptContent({layoutid:commonParam.modeid}));}else{promiseList.push(new _promise2.default(function(resolve){resolve("");}));}return promiseList;};//加载自定义的JS/CSS文件
var loadCustomFiles=exports.loadCustomFiles=function loadCustomFiles(flag){var commonParam=_source2.default.globalStore.commonParam;var custompage=commonParam.custompage;var files=flag==="css"?custompage.cssPage:flag==="js"?custompage.jsPage:[];(0,_loadjs2.default)(files||[],{success:function success(){/* eslint no-console: 0 */if(window.console)console.log("加载自定义开发文件:",files);}});};//加载新版公式JS资源并触发公式注册
var loadFormulaResource=exports.loadFormulaResource=function loadFormulaResource(){var linkageCfg=_source2.default.layoutStore.linkageCfg;var _ref=linkageCfg.formulaCfg||{},_ref$files=_ref.files,files=_ref$files===undefined?[]:_ref$files;var fn=function fn(){(0,_linkageControl.setWfVerifiySource)("formularSource","loaded");//记录公式资源加载成功
//加载完执行事件
(0,_FormulaNew.registerFormula)();};var i=0;(0,_linkageControl.setWfVerifiySource)("formularSource",files.length==0?"loaded":"loading");//记录公式资开始加载
var beginLoad=function beginLoad(newFiles){(0,_loadjs2.default)(newFiles?newFiles:files,'formula'+randomNum(),{success:function success(){fn();},async:false,// 可选的，设置为false将按照脚本顺序同步加载
error:function error(pathsNotFound){// 加载失败时执行的回调]
if(i>2){//连续加载两次
var _src$globalStore=_source2.default.globalStore,commonParam=_src$globalStore.commonParam,controlVariableMap=_src$globalStore.controlVariableMap;controlVariableMap("formulaPathsNotFound",(0,_stringify2.default)(pathsNotFound));(0,_linkageControl.setWfVerifiySource)("formularSource","fail");//记录公式资源加载失败
var cusFiles=files.filter(function(item){return item.includes("/workflow/exceldesign/js/formula/def/def_");});var sysFiles=files.filter(function(item){return!item.includes("/workflow/exceldesign/js/formula/def/def_");});//将自定义公式和系统公式拆分开加载
if(cusFiles.length>0){(0,_loadjs2.default)(cusFiles,'formula_cus'+randomNum(),{});}(0,_loadjs2.default)(sysFiles,'formula_sys'+randomNum(),{});}else{beginLoad();}i++;}});};_loadjs2.default.isDefined('formula')?_loadjs2.default.ready('formula',fn):beginLoad();};//加载二开注入的JS资源
var loadInjectDevFiles=exports.loadInjectDevFiles=function loadInjectDevFiles(){var commonApiParam=_source2.default.globalStore.commonApiParam;_source2.default.API_REQ.loadInjectDevFile((0,_extends3.default)({},commonApiParam)).then(function(data){var files=data.files;if(files&&files.length>0){var init=function init(){if(window.console)console.log("加载二开注入JS文件成功",files);};_loadjs2.default.isDefined('customDev')?_loadjs2.default.ready('customDev',init):(0,_loadjs2.default)(files,'customDev',init);}});};//代码块中<script id>标签转换处理
var manageScriptContent=exports.manageScriptContent=function manageScriptContent(content){if(!content)return"";var propFileCfg=_source2.default.layoutStore.propFileCfg;var script_debug=propFileCfg&&propFileCfg.script_debug=="1";//script标签存在自定义属性的，生成个空span兼容
var reg=new RegExp("<script .*?id=.*?></script>|<script .*?id=.*?/>","ig");var arr=content.match(reg);var appendScriptSpan="";arr&&arr.map(function(v){appendScriptSpan+=v.replace(new RegExp("(<|/)script","ig"),"$1span");});//document.write覆写Dom结构兼容
content=content.replace(/document.write/g,'jQuery("#scriptArea").append');//剔除html头等信息
content=content.replace(/<(\/?)(html|body|head)>/ig,"");//剔除部分JS文件引入导致异常
var filterSrcArr=["/wui/common/jquery/plugin/Listener_wev8.js","/js/workflow/VCEventHandle_wev8.js"];if(script_debug){//引入的JS文件单独拎出loadjs发请求，才能调试及报错提示
// <!-- script -->  这种注释代码不好正则抓取，先直接剔除
content=content.replace(new RegExp("<!--[\\s\\S]*?script[\\s\\S]*?-->","ig"),"");// const matchJSFile = new RegExp("(?<!<!--\s*?)(<script.*? src=.*?(></script>|/>))(\s*?)(?!-->)", "ig");
var matchJSFile=new RegExp("<script.*? src=.*?(></script>|/>)","ig");var matchJSSrc=new RegExp(" src *?= *?[\"|'](.*?)[\"|']","i");var JSFileArr=content.match(matchJSFile);var JSFileSrcArr=[];JSFileArr&&JSFileArr.forEach(function(item){var JSSrcArr=item.match(matchJSSrc);if(JSSrcArr&&JSSrcArr.length>=2){var JSSrc=JSSrcArr[1];content=content.replace(item,"");//满足loadjs条件，原JS引入剔除
if(!_.includes(filterSrcArr,JSSrc))JSFileSrcArr.push(JSSrc);}});var loadScriptFn=function loadScriptFn(){//需要JS文件加载完再加载script块，script块加载到head层，能抛出错误，在代码块内加上debugger标记才可定位调试
var matchScript=new RegExp("<script.*?>([\\s\\S]*?)</script>","ig");var scriptArr=content.match(matchScript);scriptArr&&scriptArr.forEach(function(item){content=content.replace(item,"");var source=item.replace(matchScript,"$1");var oHead=document.getElementsByTagName("HEAD").item(0);var oScript=document.createElement("script");oScript.language="javascript";oScript.type="text/javascript";oScript.id="custom_script_"+new Date().getTime();oScript.defer=true;oScript.text=source;oHead.appendChild(oScript);});};if(JSFileSrcArr.length>0){(0,_loadjs2.default)(JSFileSrcArr,{success:function success(){loadScriptFn();},error:function error(){/* eslint no-console: 0 */if(window.console.error)console.error("加载自定义开发引入的JS文件失败:",JSFileSrcArr);loadScriptFn();}});}else{loadScriptFn();}}else{filterSrcArr.forEach(function(item){content=content.replace(new RegExp("<script .*?"+item+".*?></script>|<script .*?"+item+".*?/>","ig"),"");});}return content+appendScriptSpan;};//将富文本中link引入的CSS文件单独提取出链接，改为text请求方式再包层作用域，解决CSS污染问题
//暂定只处理富文本字段污染，不处理代码块以及自定义页面，防止用户本身就是想更改表单布局外层
var manageCssFilePollute=exports.manageCssFilePollute=function manageCssFilePollute(content,swapClassName){if(!content||!swapClassName)return content;var reg=new RegExp("<link .*?href=(.*?\\.css).*?></link>|<link .*?href=(.*?\\.css).*?/>","ig");var cssFiles=[];var arr=content.match(reg);if(arr&&arr.length>0){content=content.replace(reg,"");//原样式请求替换为空
arr.map(function(item){reg.test(item);var href=RegExp.$1||RegExp.$2||"";if(href!==""){href=href.replace(new RegExp("\"|'","ig"),"");cssFiles.push(href);}});}loadCssFileContent(cssFiles,swapClassName);return content;};//加载css文件并限制作用域
var loadCssFileContent=exports.loadCssFileContent=function loadCssFileContent(){var cssFiles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var swapClassName=arguments[1];cssFiles&&cssFiles.map(function(href){var reqhref=href;var rootpath=window.ecologyContentPath||'';if(rootpath!==""&&reqhref.startsWith("/workflow/exceldesign/css"))reqhref=''+rootpath+reqhref;_source2.default.API_REQ.loadHrefTextContent(reqhref,{v:new Date().getTime()}).then(function(cssText){cssText=cssText.replace(new RegExp("/\\*[\\s\\S]*?\\*/","ig"),"");//注释剔除
cssText=cssText.replace(new RegExp("\}([\\s\\S]*?)\{","ig"),"}\n."+swapClassName+" $1{");cssText='<style>.'+swapClassName+' '+cssText+'</style>';window.jQuery("body").append(cssText);});});};//判断模板是否包含开启横向滚动条的明细
var judgeExistXScrollDetail=exports.judgeExistXScrollDetail=function judgeExistXScrollDetail(){var exist=false;var tableInfo=_source2.default.layoutStore.tableInfo;_.forIn(tableInfo,function(v,k){if(k.indexOf("detail")>-1){var _v$detailtableattr=v.detailtableattr,allowscroll=_v$detailtableattr.allowscroll,mobileallowscroll=_v$detailtableattr.mobileallowscroll;if(!_source2.default.isMobile&&allowscroll===1||_source2.default.isMobile&&mobileallowscroll===1){exist=true;return false;}}});return exist;};//自定义注册事件校验
var verifyCustomRegisterEvent=exports.verifyCustomRegisterEvent=function verifyCustomRegisterEvent(params,callback){var registerFnParams=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var eventList=arguments[3];var result=null;var opertype=convertOpertype(params);var eventArr=opertype===null?new Array():_interface2.default.eventList[opertype];if(!!eventList)eventArr=eventList[opertype];//存在注册事件
if((typeof eventArr==='undefined'?'undefined':(0,_typeof3.default)(eventArr))==="object"&&eventArr.length>0){var index=0;var executeVerify=function executeVerify(){if(index<eventArr.length){eventArr[index++](function(){executeVerify();},registerFnParams);}else{result=callback();}};executeVerify();}else{result=callback();}return result;};var convertOpertype=function convertOpertype(params){if(typeof params==="string")return params;var actiontype=params.actiontype;var src=params.src;if(params.isaffirmance=="1"&&params.isaffirmanceSrc!="reject")//确认动作
return actiontype==="requestOperation"&&src==="save"?_interface2.default.OPER_SUBMITCONFIRM:null;if(actiontype==="remarkOperation"&&src==="save")return _interface2.default.OPER_REMARK;else if(actiontype==="requestOperation"){if(src==="reject"||src==="save"&&params.isaffirmanceSrc==="reject")return _interface2.default.OPER_REJECT;else if(src==="submit")return _interface2.default.OPER_SUBMIT;else if(src==="intervenor")return _interface2.default.OPER_INTERVENE;else if(src==="save")return _interface2.default.OPER_SAVE;}return null;};/**
 * 执行表单右键事件
 * @param item btn对象
 * @param rightBtn
 */var executeRightBtnClick=exports.executeRightBtnClick=function executeRightBtnClick(){var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var rightBtn=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var clickFn=function clickFn(){var _toJS=(0,_mobx.toJS)(item),type=_toJS.type,menuFun=_toJS.menuFun,_toJS$funParams=_toJS.funParams,funParams=_toJS$funParams===undefined?{}:_toJS$funParams;var fn=menuFun.indexOf('this')>=0?menuFun.split('this')[0]+')':menuFun;var fnName=fn.substring(0,fn.indexOf("("));if(type&&type.indexOf("BTN_CUSTOMIZE")>-1){//window[fnName](fnParamArr);
eval(fn);}else{execOperateFun(fnName,funParams,rightBtn);}};verifyCustomRegisterEvent(_interface2.default.OPER_BEFORECLICKBTN,clickFn,(0,_mobx.toJS)(item));};//执行右键函数
var execOperateFun=function execOperateFun(){var fun=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var funParams=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var rightBtn=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(typeof rightBtn[fun]=="function"){if(fun==='doSubmit_Pre'){var _funParams$src=funParams.src,_src=_funParams$src===undefined?'submit':_funParams$src;rightBtn[fun](_src);}else if(fun==='doSubmitDirect'){var subfun=funParams.subfun;rightBtn[fun](subfun);}else if(fun==='aboutVersion'){var versionid=funParams.versionid;rightBtn[fun](versionid);}else if(fun==='triSubwf2'){var subwfid=funParams.subwfid,workflowNames=funParams.workflowNames,requestType=funParams.requestType;rightBtn[fun](subwfid,workflowNames,requestType);}else if(fun==='onCustomOpt'){var reqid=funParams.reqid,wfid=funParams.wfid,menuid=funParams.menuid,nodeid=funParams.nodeid;rightBtn[fun](reqid,wfid,menuid,nodeid);}else if(fun==='onNewRequest'){var workflowid=funParams.workflowid,requestid=funParams.requestid,agent=funParams.agent;rightBtn[fun](workflowid,requestid,agent);}else if(fun==='onNewRequest2'){var _workflowid=funParams.workflowid,_requestid=funParams.requestid,nodeId=funParams.nodeId,menuId=funParams.menuId,_requestType=funParams.requestType;rightBtn[fun](_workflowid,_requestid,nodeId,menuId,_requestType);}else if(fun==='onNewSms'){var _wfid=funParams.wfid,_nodeid=funParams.nodeid,_reqid=funParams.reqid,_menuid=funParams.menuid,isurger=funParams.isurger;rightBtn[fun](_wfid,_nodeid,_reqid,_menuid,isurger);}else if(fun==='onNewEmail'){var _reqid2=funParams.reqid;rightBtn[fun](_reqid2);}else if(fun==='onNewChats'){var _wfid2=funParams.wfid,_nodeid2=funParams.nodeid,_reqid3=funParams.reqid,_menuid2=funParams.menuid;rightBtn[fun](_wfid2,_nodeid2,_reqid3,_menuid2);}else if(fun==='onDocCompare'){var docId=funParams.docId,rightDocId=funParams.rightDocId,authStr=funParams.authStr,authSignatureStr=funParams.authSignatureStr;rightBtn[fun](docId,rightDocId,authStr,authSignatureStr);}else{if((0,_keys2.default)(funParams).length>0){rightBtn[fun](funParams);}else{rightBtn[fun]();}}}};//流转表单图片显示设置
var imageStyleHander=exports.imageStyleHander=function imageStyleHander(propFileCfg){var form_image_handWritingShowType=propFileCfg.form_image_handWritingShowType;var form_image_handWritingMaxHeight=propFileCfg.form_image_handWritingMaxHeight;var form_image_scalingRatio=propFileCfg.form_image_scalingRatio||90;var imgStyle="<style type=\"text/css\">\n .etype_5 img, .etype_3 .wf-form-textarea .wf-form-textarea-html-show img, .etype_3 .wf-richtext-view-text img {\n";imgStyle+="max-width:"+form_image_scalingRatio+"% !important\n}\n";if(form_image_handWritingShowType=="1"&&form_image_handWritingMaxHeight!=null&&form_image_handWritingMaxHeight!=""){imgStyle+=" .etype_5 img.handWrittenSign {\n max-height:"+form_image_handWritingMaxHeight+"px !important\n}\n";}imgStyle+="</style>";window.jQuery("body").append(imgStyle);};//手写签批，样式宽度单独计算
var handWritingHander=exports.handWritingHander=function handWritingHander(imgObj){var propFileCfg=_source2.default.layoutStore.propFileCfg;var form_image_handWritingShowType=propFileCfg.form_image_handWritingShowType;var form_image_handWritingMaxHeight=propFileCfg.form_image_handWritingMaxHeight;var form_image_handWritingMaxWidth=propFileCfg.form_image_handWritingMaxWidth;if(form_image_handWritingShowType=="1"&&form_image_handWritingMaxHeight!=null){return;}//既设置了最大宽度px，又设置了最大宽度百分比，则计算谁更小
if(form_image_handWritingShowType=="2"&&form_image_handWritingMaxWidth!=null){var imgStyle=window.jQuery(imgObj).attr("style")||"";if(";"!=imgStyle.charAt(imgStyle.length-1)){imgStyle+=";";}var imgWidth_td=window.jQuery(imgObj).closest("td.etype_5").width();var form_image_scalingRatio=propFileCfg.form_image_scalingRatio;var imgWidth_temp=imgWidth_td*form_image_scalingRatio/100;if(imgWidth_temp*10>form_image_handWritingMaxWidth*10){imgStyle+="max-width: "+form_image_handWritingMaxWidth+"px !important";}else{imgStyle+="max-width: "+form_image_scalingRatio+"% !important";}window.jQuery(imgObj).css("cssText",imgStyle);}};//加载计算方法的资源
var loadCaculateResource=exports.loadCaculateResource=function loadCaculateResource(){new _promise2.default(function(resolve){var loadjs=window.loadjs;loadjs(['/js/workflow/caculate_wev8.js'],function(){resolve(true);});}).then(function(res){_source2.default.globalStore.controlVariableMap("caculate_Complete",res);});};var getWaterMarkFieldShowName=exports.getWaterMarkFieldShowName=function getWaterMarkFieldShowName(fieldMark){if(fieldMark=='field-2'){var vObj=_interface2.default.getFieldValueObj(fieldMark);if(vObj){var _vObj$specialobj=vObj.specialobj,_specialobj=_vObj$specialobj===undefined?[]:_vObj$specialobj,_value=vObj.value;var result=(0,_mobx.toJS)(_specialobj).filter(function(item){return item.id==_value;});if(result&&result.length>0){return result[0].customname;}}}var fieldAttr=FieldUtil.getFieldAttr(fieldMark)||{};var _fieldAttr$htmltype=fieldAttr.htmltype,htmltype=_fieldAttr$htmltype===undefined?1:_fieldAttr$htmltype,tableMark=fieldAttr.tableMark,_fieldAttr$selectattr=fieldAttr.selectattr,selectattr=_fieldAttr$selectattr===undefined?{}:_fieldAttr$selectattr,_fieldAttr$detailtype=fieldAttr.detailtype,detailtype=_fieldAttr$detailtype===undefined?'':_fieldAttr$detailtype;var fieldObj=_interface2.default.getFieldValueObj(fieldMark)||{};var _fieldObj$value=fieldObj.value,value=_fieldObj$value===undefined?'':_fieldObj$value,specialobj=fieldObj.specialobj;if(fieldAttr&&fieldAttr.encryptFlag>0&&value!="")//加密格式的水印也密文
return"****";switch(htmltype){case 3:if(specialobj){var browValNames=[];specialobj.map(function(item){browValNames.push(item.name||'');});return browValNames.join(',');}else{return value;}case 5:var itemList=selectattr.selectitemlist;if(itemList){var valArr=value.split(',');var _result=[];(0,_mobx.toJS)(itemList).map(function(item){var _item$selectvalue=item.selectvalue,selectvalue=_item$selectvalue===undefined?'':_item$selectvalue,_item$selectname=item.selectname,selectname=_item$selectname===undefined?'':_item$selectname;if(valArr.indexOf(selectvalue.toString())>-1){_result.push(selectname);}});return _result.join(' ');}return value;case 6:if(specialobj){var _specialobj$filedatas=specialobj.filedatas,filedatas=_specialobj$filedatas===undefined?[]:_specialobj$filedatas;var fileNames=[];(0,_mobx.toJS)(filedatas).map(function(item){fileNames.push(item.filename||'');});return fileNames.join(',');}return value;default:return _interface2.default.getFieldValue(fieldMark);}};var getUpdateReqInfoFieldValue=exports.getUpdateReqInfoFieldValue=function getUpdateReqInfoFieldValue(){var fieldVals={};var _src$layoutStore=_source2.default.layoutStore,mainData=_src$layoutStore.mainData,fieldAttrMap=_src$layoutStore.fieldAttrMap;mainData.forEach(function(fieldObj,k){var fieldid=k.substring(5);if(fieldAttrMap.has(fieldid)){var fieldAttr=fieldAttrMap.get(fieldid);var _fieldAttr$fieldname=fieldAttr.fieldname,fieldname=_fieldAttr$fieldname===undefined?'':_fieldAttr$fieldname;if(fieldname=='manager')fieldVals[k]=fieldObj.value;}});return fieldVals;};function randomNum(){var randomNumber="";for(var i=0;i<6;i++){randomNumber+=Math.floor(Math.random()*10);}return randomNumber;}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(90)('wks');
var uid = __webpack_require__(71);
var Symbol = __webpack_require__(20).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';
var $exports = module.exports = function (name) {
    return store[name] || (store[name] =
        USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};
$exports.store = store;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(105);
var toPrimitive = __webpack_require__(92);
var dP = Object.defineProperty;
exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE)
        try {
            return dP(O, P, Attributes);
        }
        catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes)
        throw TypeError('Accessors not supported!');
    if ('value' in Attributes)
        O[P] = Attributes.value;
    return O;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
var _isPlaceholder = 
/*#__PURE__*/
__webpack_require__(134);
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry2(fn) {
    return function f2(a, b) {
        switch (arguments.length) {
            case 0:
                return f2;
            case 1:
                return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
                    return fn(a, _b);
                });
            default:
                return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
                    return fn(_a, b);
                }) : _isPlaceholder(b) ? _curry1(function (_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = _curry2;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it) {
    if (!isObject(it))
        throw TypeError(it + ' is not an object!');
    return it;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _iterator = __webpack_require__(303);
var _iterator2 = _interopRequireDefault(_iterator);
var _symbol = __webpack_require__(310);
var _symbol2 = _interopRequireDefault(_symbol);
var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(61);
module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined)
        return fn;
    switch (length) {
        case 1: return function (a) {
            return fn.call(that, a);
        };
        case 2: return function (a, b) {
            return fn.call(that, a, b);
        };
        case 3: return function (a, b, c) {
            return fn.call(that, a, b, c);
        };
    }
    return function ( /* ...args */) {
        return fn.apply(that, arguments);
    };
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (exec) {
    try {
        return !!exec();
    }
    catch (e) {
        return true;
    }
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(74);
var defined = __webpack_require__(70);
module.exports = function (it) {
    return IObject(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(82);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(55);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _secLevelUtil=__webpack_require__(125);var SecLevelUtil=_interopRequireWildcard(_secLevelUtil);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _formatUtil=__webpack_require__(126);__webpack_require__(469);var _mobx=__webpack_require__(9);var _analyzeData=__webpack_require__(56);var AI=_interopRequireWildcard(_analyzeData);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var jQuery=window.jQuery;jQuery.fn.extend({bindPropertyChange:function bindPropertyChange(funobj){return this.each(function(){var thisid=jQuery(this).attr('id');window.WfForm.addPropertyChangeFn(thisid,funobj);});}});var WfForm_Public={isMobile:function isMobile(){return _source2.default.isMobile;},__propertyChangeFnObj:{},__detailFieldChangeFnObj:{},getGlobalStore:function getGlobalStore(){return _source2.default.globalStore;},getLayoutStore:function getLayoutStore(){return _source2.default.layoutStore;},getBaseInfo:function getBaseInfo(){if(!_source2.default.globalStore||!_source2.default.globalStore.commonParam||(0,_keys2.default)(_source2.default.globalStore.commonParam).length===0){return{};}else{return _source2.default.globalStore.baseParam;}},getFnaConfig:function getFnaConfig(){return _source2.default.layoutStore.fnaInfo;},getOdocConfig:function getOdocConfig(){return _source2.default.layoutStore.odocInfo;},addPropertyChangeFn:function addPropertyChangeFn(key,funobj){if(!key||key.indexOf("field")===-1)return;var fnArr=this.__propertyChangeFnObj[key];if(!!!fnArr){fnArr=new Array();this.__propertyChangeFnObj[key]=fnArr;}fnArr.push(funobj);},/**
     * 控制表单按钮是否点击
     * @param flag : true 按钮全部置灰不可操作 false 恢复按钮可操作状态
     */controlBtnDisabled:function controlBtnDisabled(isDisabled){_source2.default.globalStore.setApiBtnDisabled(isDisabled);},judgeIsLoading:function judgeIsLoading(){return _source2.default.globalStore.btnDisabled;},/**
     * 字段值变化绑定事件
     * @params fieldMark(String) 绑定字段标示串，明细字段带下划线标示
     */bindFieldChangeEvent:function bindFieldChangeEvent(fieldMarkStr,funobj){var _this=this;!!fieldMarkStr&&fieldMarkStr.split(",").map(function(fieldMark){_this.addPropertyChangeFn(fieldMark,funobj);});},/**
     * 明细字段值变化绑定事件，绑定后对新添加的行也生效
     * @params fieldMark(String) 绑定的明细字段标示串，不带下划线标示
     */bindDetailFieldChangeEvent:function bindDetailFieldChangeEvent(fieldMarkStr,funobj){var _this2=this;var reg=/^field\d+$/;!!fieldMarkStr&&fieldMarkStr.split(",").map(function(key){if(!key||!reg.test(key))return"";var fnArr=_this2.__detailFieldChangeFnObj[key];if(!!!fnArr){fnArr=new Array();_this2.__detailFieldChangeFnObj[key]=fnArr;}fnArr.push(funobj);});},customTabFunObj:{},bindCustomTabEvnent:function bindCustomTabEvnent(key,fun){this.customTabFunObj[key]=fun;},/**
     * 触发开发代码绑定的字段值变更事件，layoutStore中调用
     */triggerFieldBindEvent:function triggerFieldBindEvent(fieldMark,newValue){if(fieldMark in this.__propertyChangeFnObj){this.__propertyChangeFnObj[fieldMark].map(function(fn){try{fn(jQuery("#"+fieldMark)[0],fieldMark,newValue);}catch(e){}});}var index=fieldMark.indexOf("_");var fieldid=index>-1?fieldMark.substring(5,index):fieldMark.substring(5);var rowIndex=index>-1?fieldMark.substring(index+1):-1;var fieldAttr=this.getFieldInfo(fieldid);if(fieldAttr.isDetail){//明细字段触发监听事件
if('field'+fieldid in this.__detailFieldChangeFnObj){this.__detailFieldChangeFnObj['field'+fieldid].map(function(fn){try{fn('field'+fieldid,rowIndex,newValue);}catch(e){}});}}},/**
     * 字段名称转换为字段id
     * @param symbol  主表/明细表标示，main/detail_1/detail_2，默认为main
     * @param prefix 是否需要field字符串前缀，默认为true
     */convertFieldNameToId:function convertFieldNameToId(fieldname,symbol,prefix){symbol=!!symbol?symbol:"main";prefix=typeof prefix==="undefined"?true:prefix;var fieldNameMap=_source2.default.layoutStore.fieldNameMap;var fieldKey=symbol+'.'+fieldname.toUpperCase();var fieldid="";if(fieldNameMap.has(fieldKey)){fieldid=fieldNameMap.get(fieldKey);fieldid=prefix?'field'+fieldid:fieldid;}return fieldid;},/**
     * 获取字段信息
     */getFieldInfo:function getFieldInfo(fieldid){fieldid=fieldid.toString();var fieldAttrMap=_source2.default.layoutStore.fieldAttrMap;return fieldAttrMap.has(fieldid)?(0,_mobx.toJS)(fieldAttrMap.get(fieldid)):{};},/**
     * 获取字段当前的字段属性
     */getFieldCurViewAttr:function getFieldCurViewAttr(fieldMark){return FieldUtil.getFieldCurViewAttr(fieldMark);},/**
     * 获取字段值
     * @params fieldMark(String)    字段标示,主表字段：field110，明细行字段需加上行标示：field110_4
     */getFieldValue:function getFieldValue(fieldMark){var fieldObj=this.getFieldObj(fieldMark);return fieldObj===null?"":fieldObj.value;},/**
     * 获取字段值对象
     */getFieldValueObj:function getFieldValueObj(fieldMark){var fieldObj=this.getFieldObj(fieldMark);return fieldObj===null?{}:fieldObj.valueObj;},getFieldObj:function getFieldObj(fieldMark){if(fieldMark.indexOf("field")===-1)return null;var index=fieldMark.indexOf("_");var fieldid=index>-1?fieldMark.substring(5,index):fieldMark.substring(5);var rowIndex=index>-1?fieldMark.substring(index+1):-1;return FieldUtil.getFieldValObj(fieldid,rowIndex);},/**
     * 获取选择框字段对应的显示值
     */getSelectShowName:function getSelectShowName(fieldMark,splitChar){return FieldUtil.getSelectShowName(fieldMark,splitChar);},/**
     * 获取浏览按钮字段对应的显示值
     */getBrowserShowName:function getBrowserShowName(fieldMark,splitChar){if(fieldMark.indexOf("field")===-1)return"";if(typeof splitChar==="undefined"||splitChar==="")splitChar=",";var showname="";var valueObj=this.getFieldValueObj(fieldMark);if(valueObj!==null&&"specialobj"in valueObj){valueObj.specialobj&&valueObj.specialobj.map(function(v,index){if(index!==0)showname+=splitChar;showname+=v.name;});}if(showname.includes("</span>"))showname=jQuery(showname).text();return showname;},/**
     * 控制日期选择范围
     */controlDateRange:function controlDateRange(fieldMark,start,end){var startDate=null;var endDate=null;var reg=/^(-?\d+)(\.\d+)?$/;if(typeof start!=="undefined"){startDate=start.toString();if(reg.test(startDate))startDate=(0,_formatUtil.formatDate)(new Date(new Date().getTime()+start*24*60*60*1000),"yyyy-MM-dd");}if(typeof end!=="undefined"){endDate=end.toString();if(reg.test(endDate))endDate=(0,_formatUtil.formatDate)(new Date(new Date().getTime()+end*24*60*60*1000),"yyyy-MM-dd");}this.changeSingleField(fieldMark,{},{startDate:startDate,endDate:endDate});},/**
     * 修改字段值，适用范围(单行文本、多行文本、选择框、浏览框、check框(0/1))
     * @params valueInfo(JSON)    非浏览框格式为：{value:"修改后的值"}，浏览按钮字段格式为：{value:"1,2,3",specialobj:[{id:"1",name:"张三"},{id:"2",name:"李四"},{id:"3",name:"王五"}...]}
     */changeFieldValue:function changeFieldValue(fieldMark,valueInfo){var isformula=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;this.changeSingleField(fieldMark,valueInfo,null,isformula);},/**
     * 修改字段只读/可编辑/必填/隐藏属性，此接口优先级低于标准功能显示属性联动(即设置了显示属性联动的可能覆盖此设置)
     * @params viewAttr(int)  1(变更为只读)/2(变更为可编辑)/3(变更为必填)/4(字段标签及名称都隐藏，同时不校验必填)
     */changeFieldAttr:function changeFieldAttr(fieldMark,viewAttr){var isformula=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;viewAttr=parseInt(viewAttr);var fieldVars={};var changeVars={};//显示属性联动隐藏不能存fieldObj对象中，优化性能
if(viewAttr===4||viewAttr===5){fieldVars[fieldMark]={viewAttr:-1};changeVars[fieldMark+'_viewAttr']=viewAttr;}else{fieldVars[fieldMark]={viewAttr:viewAttr};changeVars[fieldMark+'_viewAttr']=-1;}this.changeMoreField({},fieldVars,isformula);_source2.default.layoutStore.batchControlVariableMap(changeVars);},/**
     * 修改单个字段属性，修改值同时修改显示属性
     * @params valueInfo(obj) 可为空，变更的字段值
     */changeSingleField:function changeSingleField(fieldMark){var valueInfo=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var variableInfo=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var isformula=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var changeDatas={};if(!_.isEmpty(valueInfo))changeDatas[fieldMark]=valueInfo;var fieldVars={};if(!_.isEmpty(variableInfo)){if("viewAttr"in variableInfo){//单独处理viewAttr的变更
this.changeFieldAttr(fieldMark,variableInfo["viewAttr"]);delete variableInfo["viewAttr"];}fieldVars[fieldMark]=variableInfo;}this.changeMoreField(changeDatas,fieldVars,isformula);},/**
     * 批量修改多个字段值及属性
     * @params changeDatas(obj)  格式{field110:{value:"11"},field111_1:{value:"22"}
     * @params fieldVars(obj) 格式{field110:{viewAttr:1},field111_1:{viewAttr:3}}
     */changeMoreField:function changeMoreField(){var changeDatas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fieldVars=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var isformula=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var changeMoreFieldData=_source2.default.layoutStore.changeMoreFieldData;var stepid=AI.generateStepId(isformula?AI.TYPE_WFFORM_FORMULA:AI.TYPE_WFFORM_API);changeMoreFieldData(changeDatas,fieldVars,stepid);},/**
     * 触发指定字段涉及的所有联动
     */triggerFieldAllLinkage:function triggerFieldAllLinkage(fieldMark){if(fieldMark.indexOf("field")===-1)return null;var _src$layoutStore=_source2.default.layoutStore,triggerAllLinkage=_src$layoutStore.triggerAllLinkage,fieldAttrMap=_src$layoutStore.fieldAttrMap;var index=fieldMark.indexOf("_");var fieldid=index>-1?fieldMark.substring(5,index):fieldMark.substring(5);var rowIndex=index>-1?fieldMark.substring(index+1):-1;var fieldAttr=fieldAttrMap.has(fieldid)?fieldAttrMap.get(fieldid):{};triggerAllLinkage(1,fieldAttr.tableMark,fieldid,rowIndex);//同时触发开发代码绑定的监听函数(新版公式运算)
this.triggerFieldBindEvent(fieldMark,this.getFieldValue(fieldMark));},/**
     * 移除选择框字段选项(多次调用追加方式)
     */removeSelectOption:function removeSelectOption(fieldMark,optionKeys){var fieldObj=this.getFieldObj(fieldMark);var variable=fieldObj.variable;var filterOptionRange=variable.has("filterOptionRange")?variable.get("filterOptionRange"):[];filterOptionRange=filterOptionRange.concat(optionKeys.split(","));this.changeSingleField(fieldMark,null,{filterOptionRange:filterOptionRange});},/**
     * 控制选择框字段选项范围
     */controlSelectOption:function controlSelectOption(fieldMark,optionKeys){this.changeSingleField(fieldMark,null,{optionRange:optionKeys.split(","),filterOptionRange:[]});},/**
     * 添加明细行
     * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     * @params initAddRowData(JSON) 新增行设置的初始值，可不传；格式为{field110:{value:"11"},field112:{value:"22"},...},注意key不带下划线标示
     */addDetailRow:function addDetailRow(){return DetailUtil.addRow.apply(DetailUtil,arguments);},/**
     * 删除明细行,没有提示删除的确认框(会清空明细已选情况)
     * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     * @params rowIndexMark(String) 明细行标示，全部选中:all,选中部分："1，2，3"
     */delDetailRow:function delDetailRow(detailMark,rowIndexMark){if(rowIndexMark==="all")rowIndexMark=this.getDetailAllRowIndexStr(detailMark);DetailUtil.setAllRowChecked(detailMark,false);if(rowIndexMark!=="")DetailUtil.delAssignRow(detailMark,rowIndexMark.split(","));},/**
     * 选中明细行
     * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     * @params rowIndexMark(String) 明细行标示，全部选中:all,选中部分："1，2，3"
     * @params needClearBeforeChecked(Boolean) 是否需要清除已有选中，默认为false
     */checkDetailRow:function checkDetailRow(detailMark,rowIndexMark,needClearBeforeChecked){if(rowIndexMark==="all")rowIndexMark=this.getDetailAllRowIndexStr(detailMark);if(needClearBeforeChecked===true)//清除已选
DetailUtil.setAllRowChecked(detailMark,false);DetailUtil.setRowChecked(detailMark,rowIndexMark,true);},/**
     * 控制明细数据行的显示及隐藏
     * @param detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     * @param rowIndexMark(String) 明细行标示，全部行:all,部分行："1，2，3"
     * @param needHide 是否隐藏行，true:隐藏，false:显示
     */controlDetailRowDisplay:function controlDetailRowDisplay(detailMark,rowIndexMark){var needHide=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(rowIndexMark==="all")rowIndexMark=this.getDetailAllRowIndexStr(detailMark);var attr={};rowIndexMark!==""&&rowIndexMark.split(",").map(function(rowIndex){attr['row_'+rowIndex]={needHide:needHide};});var detailObj=DetailUtil.getDetailObj(detailMark);detailObj.controlDetailRowAttr(attr);},/**
     * 控制明细数据行check是否禁用勾选
     * @param detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     * @param rowIndexMark(String) 明细行标示，全部行:all,部分行："1，2，3"
     * @param disableCheck 是否禁用勾选
     */controlDetailRowDisableCheck:function controlDetailRowDisableCheck(detailMark,rowIndexMark){var disableCheck=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(rowIndexMark==="all")rowIndexMark=this.getDetailAllRowIndexStr(detailMark);var attr={};rowIndexMark!==""&&rowIndexMark.split(",").map(function(rowIndex){attr['row_'+rowIndex]={disableCheck:disableCheck};});var detailObj=DetailUtil.getDetailObj(detailMark);detailObj.controlDetailRowAttr(attr);},/**
     * 获取明细所有行标示，逗号分隔
     * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     */getDetailAllRowIndexStr:function getDetailAllRowIndexStr(detailMark){var detailObj=DetailUtil.getDetailObj(detailMark);return detailObj?detailObj.allRowIndexStr:'';},//获取明细选中行下标，逗号分隔
getDetailCheckedRowIndexStr:function getDetailCheckedRowIndexStr(detailMark){var detailObj=DetailUtil.getDetailObj(detailMark);var checkRowArr=DetailUtil.getDetailCheckedRowArr(detailObj);return checkRowArr.join(",");},//获取明细行总数
getDetailRowCount:function getDetailRowCount(detailMark){var allRowIndexStr=this.getDetailAllRowIndexStr(detailMark);return allRowIndexStr===""?0:allRowIndexStr.split(",").length;},//根据行号获取行序号
getDetailRowSerailNum:function getDetailRowSerailNum(mark){var rowIndex=arguments.length>1&&arguments[1]!==undefined?arguments[1]:-1;var _src$layoutStore2=_source2.default.layoutStore,fieldAttrMap=_src$layoutStore2.fieldAttrMap,detailMap=_src$layoutStore2.detailMap;var detailMark="";if(mark.startsWith("field")&&mark.indexOf("_")>-1){var fieldid=mark.substring(5,mark.indexOf("_"));detailMark=fieldAttrMap.has(fieldid)?fieldAttrMap.get(fieldid).tableMark:"";rowIndex=mark.substring(mark.indexOf("_")+1);}else if(mark.startsWith("detail_")){detailMark=mark;}var serialNum=-1;if(detailMark.indexOf("detail")===-1||!detailMap.has(detailMark)||parseInt(rowIndex)<0)return serialNum;var detailObj=DetailUtil.getDetailObj(detailMark);var rowInfoArr=detailObj.rowInfoArr;rowInfoArr&&rowInfoArr.forEach(function(item){if(item.rowIndex===parseInt(rowIndex))serialNum=item.serialNum;});return serialNum;},//根据字段id获取对应的明细行数据库key值
getDetailRowKey:function getDetailRowKey(fieldMark){if(fieldMark.indexOf("field")===-1||fieldMark.indexOf("_")===-1)return-1;var fieldid=fieldMark.substring(5,fieldMark.indexOf("_"));var rowIndex=fieldMark.substring(fieldMark.indexOf("_")+1);var _src$layoutStore3=_source2.default.layoutStore,fieldAttrMap=_src$layoutStore3.fieldAttrMap,detailMap=_src$layoutStore3.detailMap;var tableMark=fieldAttrMap.has(fieldid)?fieldAttrMap.get(fieldid).tableMark:"";if(tableMark.indexOf("detail")===-1||!detailMap.has(tableMark))return-1;var _detailMap$get=detailMap.get(tableMark),rowInfo=_detailMap$get.rowInfo;var rowAttr=rowInfo.has('row_'+rowIndex)?rowInfo.get('row_'+rowIndex):null;return rowAttr&&rowAttr.has("keyid")?parseInt(rowAttr.get("keyid")):-1;},/**
     * 添加明细时默认复制最后一行记录
     * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     * @params needCopy(Boolean)  true需要复制，false取消复制
     */setDetailAddUseCopy:function setDetailAddUseCopy(detailMark,needCopy){if(detailMark.indexOf("detail_")===-1||typeof needCopy!=="boolean")return;var detailObj=DetailUtil.getDetailObj(detailMark);detailObj.setAddDefaultCopy(needCopy);},/**
     * 文本字段可编辑状态，当值为空显示默认灰色提示信息，鼠标点击输入时消失
     */setTextFieldEmptyShowContent:function setTextFieldEmptyShowContent(fieldid,showContent){if(!fieldid||fieldid.indexOf("field")===-1)return;this.changeSingleField(fieldid,null,{emptyShowContent:showContent});},/**
     * 控制radio框字段打印时仅打印选中值名称
     */controlRadioPrintText:function controlRadioPrintText(fieldid){_source2.default.layoutStore.batchControlVariableMap((0,_defineProperty3.default)({},'radioPrintText_'+fieldid,true));},/**
     * 浏览按钮请求数据接口，支持传输自定义参数，联想输入及弹窗都支持
     */appendBrowserDataUrlParam:function appendBrowserDataUrlParam(fieldMark,jsonParam){var fieldid=fieldMark.indexOf("_")>-1?fieldMark.substring(5,fieldMark.indexOf("_")):fieldMark.substring(5);var fieldInfo=this.getFieldInfo(fieldid);if(fieldInfo&&fieldInfo.htmltype===3){//限制浏览框类型
this.changeSingleField(fieldMark,null,{customDataParam:jsonParam});}},/**
     * 复写浏览按钮属性
     */overrideBrowserProp:function overrideBrowserProp(fieldMark,jsonParam){var fieldid=fieldMark.indexOf("_")>-1?fieldMark.substring(5,fieldMark.indexOf("_")):fieldMark.substring(5);var fieldInfo=this.getFieldInfo(fieldid);if(fieldInfo&&fieldInfo.htmltype===3){//限制浏览框类型
this.changeSingleField(fieldMark,null,{customBrowserProp:jsonParam});}},/**
     * 扩展签字意见输入框底部按钮条
     */signBottomComps:[],appendSignEditorBottomBar:function appendSignEditorBottomBar(comps){this.signBottomComps=comps;},renderSignEditorBottomBar:function renderSignEditorBottomBar(){var bottomBarConfig=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];this.signBottomComps&&this.signBottomComps.map(function(item){bottomBarConfig.push({name:"Component",show:typeof item==="string"?_react2.default.createElement("div",{dangerouslySetInnerHTML:{__html:item}}):item});});},/**
     * 流程操作注册接口
     */OPER_SAVE:'oper_save',//保存
OPER_SUBMIT:'oper_submit',//提交
OPER_SUBMITCONFIRM:'oper_submitconfirm',//提交确认
OPER_REJECT:'oper_reject',//退回
OPER_REMARK:'oper_remark',//批注
OPER_INTERVENE:'oper_intervene',//干预
OPER_FORWARD:'oper_forward',//转发
OPER_TURNHANDLE:'oper_turnhandle',//转办
OPER_ASKOPINION:'oper_askopinion',//意见征询
OPER_TAKFROWARD:'oper_takforward',//征询转办
OPER_TURNREAD:'oper_turnread',//传阅
OPER_TAKEBACK:'oper_takeback',//强制收回
OPER_FORCEOVER:'oper_forceover',//强制归档
OPER_DELETE:'oper_delete',//删除
OPER_ADDROW:'oper_addrow',//添加明细行
OPER_DELROW:'oper_delrow',//删除明细行
OPER_EDITDETAILROW:'oper_editdetailrow',//编辑明细行跳转(仅移动端)
OPER_PRINTPREVIEW:'oper_printpreview',//打印预览
OPER_CLOSE:'oper_close',//窗口关闭
OPER_BEFOREVERIFY:'oper_beforeverify',//校验必填前触发事件
OPER_PRINT:'oper_print',//打印按钮事件
OPER_BEFORECLICKBTN:'oper_beforeClickBtn',//点右键按钮前置事件
OPER_SAVECOMPLETE:'oper_savecomplete',//保存后跳转事件拦截
OPER_APIRETURN:'oper_apiReturn',//走requestOperate请求返回后拦截事件
OPER_WITHDRAW:'oper_withDraw',//流程撤回
eventList:{},registerCheckEvent:function registerCheckEvent(types,fn){var _this3=this;if(typeof fn!=="function")return;var arr=types.split(",");arr&&arr.map(function(t){if(!(t in _this3.eventList))_this3.eventList[t]=new Array();_this3.eventList[t].push(fn);});},/**
     * @param type {onblur、onfocus、onclick、ondbclick、mouseover、mouseout}
     * 字段绑定公式触发动作事件
     */bindFieldAction:function bindFieldAction(type,fieldids,fn){var _this4=this;if(typeof fn!=="function")return;var reg=/^field\d+$/;var fieldArr=fieldids.split(",");fieldArr&&fieldArr.map(function(fieldKey){if(reg.test(fieldKey)){_this4.registerAction(fieldKey+'|'+type,fn);}});},triggerFieldAction:function triggerFieldAction(type,fieldMark){if(!fieldMark||fieldMark.indexOf("field")!==0)return;var index=fieldMark.indexOf("_");var fieldKey=index>0?fieldMark.substring(0,index):fieldMark;var rowIndex=index>0?parseInt(fieldMark.substring(index+1)):-1;this.triggerAction(fieldKey+'|'+type,[fieldKey,rowIndex]);},/**
     * 窗口滚动事件
     */bindScrollEvent:function bindScrollEvent(fn){this.registerAction(this.ACTION_SCROLL,fn);},triggerScrollEvent:function triggerScrollEvent(){this.triggerAction(this.ACTION_SCROLL);},/**
     * 字段组件自定义渲染
     * 单行文本类型，支持代理渲染原字段组件
     * 所有表单字段，支持换行追加组件
     */proxyComps:{},afterComps:{},proxyFieldComp:function proxyFieldComp(fieldMark,el,range){this.customFieldComp(fieldMark,el,range,1);},afterFieldComp:function afterFieldComp(fieldMark,el,range){this.customFieldComp(fieldMark,el,range,2);},customFieldComp:function customFieldComp(fieldMark,el,range,type){if(!fieldMark||fieldMark.indexOf("field")!==0)return;var fieldid=fieldMark.indexOf("_")>-1?fieldMark.substring(5,fieldMark.indexOf("_")):fieldMark.substring(5);var comp=typeof el==="string"?_react2.default.createElement("div",{dangerouslySetInnerHTML:{__html:el}}):el;var rangeArr=!!range?range.split(","):["1","2","3"];if(type===1){var fieldAttr=this.getFieldInfo(fieldid);if(fieldAttr.htmltype===1&&fieldAttr.detailtype===1){this.proxyComps[fieldMark]={comp:comp,rangeArr:rangeArr};this.forceRenderField(fieldMark);}}else if(type===2){this.afterComps[fieldMark]={comp:comp,rangeArr:rangeArr};this.forceRenderField(fieldMark);}},forceRenderField:function forceRenderField(fieldMark){this.changeSingleField(fieldMark,{},{forceRender:new Date().getTime()});},renderCustomComp:function renderCustomComp(fieldMark,viewAttr,type){var extendProps=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var customComps=type===1?this.proxyComps:this.afterComps;if(fieldMark in customComps){var customComp=customComps[fieldMark];var comp=customComp.comp,rangeArr=customComp.rangeArr;if(_.indexOf(rangeArr,viewAttr.toString())>-1){return type===1?_react2.default.cloneElement(comp,(0,_extends3.default)({},extendProps)):comp;}}return null;},/**
     * 代理组件渲染函数
     */proxyCompFn:{},proxyFieldContentComp:function proxyFieldContentComp(fieldid,fn){if(typeof fn==="function")this.proxyCompFn['FieldContent_'+fieldid]=fn;},// proxyCellTypeComp: function(cellClassName, fn){
//     if(typeof fn === "function")
//         this.proxyCompFn[`CellType_${cellClassName}`] = fn;
// },
getCustomProxyCompFn:function getCustomProxyCompFn(key){return key in this.proxyCompFn?this.proxyCompFn[key]:null;},/**
     * 钩子机制，指定动作触发注册函数
     */ACTION_ADDROW:"action_addrow_",ACTION_DELROW:"action_delrow_",ACTION_SCROLL:"action_scroll",ACTION_EDITDETAILROW:"action_editdetailrow",ACTION_SWITCHDETAILPAGING:"action_switchdetailpaging",ACTION_SWITCHTABLAYOUT:"action_switchtablayout",ACTION_TABCONFIG:"action_tabconfig",//控制顶部标签项
ACTION_SWITCHTAB:"action_switchtab",//切换Tab后执行事件
ACTION_SWITCHROUTINT:"action_switchrouting",//移动端换路由事件
ACTION_DETAIL_LOADCOMPLETE:"action_detail_loadcomplete",//明细表加载完成事件
actionFnList:{},registerAction:function registerAction(key,fn){if(typeof fn!=="function")return;if(!(key in this.actionFnList)||!(this.actionFnList[key]instanceof Array))this.actionFnList[key]=new Array();this.actionFnList[key].push(fn);if(key===this.ACTION_TABCONFIG)_source2.default.globalStore.controlVariableMap("forceRenderReq",(_source2.default.globalStore.variableMap.get("forceRender")||0)+1);//如果绑定的是明细表加载完成事件且明细表已经加载完了，主动执行一次完成事件
if(key===this.ACTION_DETAIL_LOADCOMPLETE&&window.window.__wfform__has__detail__data&&window.__wfform__detail__data__loaded){fn();}},triggerAction:function triggerAction(key){var _this5=this;var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var timeout=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var fnAction=function fnAction(){if(key.indexOf(_this5.ACTION_ADDROW)>-1){var detailIndex=parseInt(key.replace(_this5.ACTION_ADDROW,""))-1;try{eval("_customAddFun"+detailIndex+"("+args[0]+")");}catch(e){}}else if(key.indexOf(_this5.ACTION_DELROW)>-1){var _detailIndex=parseInt(key.replace(_this5.ACTION_DELROW,""))-1;try{eval("_customDelFun"+_detailIndex+"()");}catch(e){}}var fnArr=_this5.actionFnList[key]||[];fnArr&&fnArr.map(function(fn){try{fn.apply(undefined,(0,_toConsumableArray3.default)(args));}catch(e){}});};timeout>0?window.setTimeout(function(){fnAction();},timeout):fnAction();},overrideTabDatas:function overrideTabDatas(datas){var fnArr=this.actionFnList[this.ACTION_TABCONFIG]||[];var tabDatas=[].concat((0,_toConsumableArray3.default)(datas));fnArr.forEach(function(fn){try{tabDatas=fn(tabDatas);}catch(e){}});return tabDatas;},getSecAndValidity:SecLevelUtil.getSecAndValidity,controlSecFieldOptions:SecLevelUtil.controlSecFieldOptions};exports.default=WfForm_Public;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var errorMap = {
    'MARKER_ID_CONFLICT': 'Marker 的 id 属性重复',
    'MARKER_ID_REQUIRED': '每一个 Marker 必需有一个 id 属性',
    'MAP_INSTANCE_REQUIRED': '没有地图实例；组件必须作为 Map 的子组件使用',
    'CIRCLE_INSTANCE_REQUIRED': '',
    'CIRCLE_CENTER_REQUIRED': 'Circle 组件必需设置 center 属性',
    'CIRCLE_RADIUS_REQUIRED': 'Circle 组件必需设置 radius 属性',
    'SRC_REQUIRED': 'GroundImage 组件必需设置 src 属性',
    'BOUNDS_REQUIRED': 'GroundImage 组件必需设置 bounds 属性',
    'WINDOW_POSITION_REQUIRED': 'InfoWindow 组件必需设置 position 属性',
    'INVALID_AMAP_PLUGIN': 'plugins 属性不正确；目前支持的插件有\'Scale\', \'ToolBar\', \'MapType\', \'OverView\''
};
var getMessage = function getMessage(key) {
    return key in errorMap ? errorMap[key] : key;
};
var log = {
    // 开发者必须修正的问题，否则会影响其他程序运行
    error: function error(key) {
        throw new Error(getMessage(key));
    },
    // 是一个错误，导致本插件无法运行，但是不会影响开发者的其他功能
    warning: function warning(key) {
        // console.log(`%c${getMessage(key)}`, 'color:#f66;border-left: 2px solid red;padding-left: 4px;');
        console.warn(getMessage(key));
    },
    // 不影响使用，但不是本插件理想的使用方式
    optimize: function optimize(key) {
        console.log('%c' + getMessage(key), 'color:#d4d483;border-left: 2px solid #d4d483;padding-left: 4px;');
    }
};
exports.default = log;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var createDesc = __webpack_require__(62);
module.exports = __webpack_require__(23) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
    object[key] = value;
    return object;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(207);
/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(70);
module.exports = function (it) {
    return Object(defined(it));
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var DYNAMIC_PASSWORD=exports.DYNAMIC_PASSWORD=10;//动态密码
var DYNAMIC_TOKEN=exports.DYNAMIC_TOKEN=20;//动态令牌
var SECOND_AUTH_PASSWORD=exports.SECOND_AUTH_PASSWORD=30;//二次验证密码
var CA_AUTH=exports.CA_AUTH=40;//CA验证
var QYS=exports.QYS=50;//契约锁
var REAL_ID_AUTH=exports.REAL_ID_AUTH=60;//真实身份认证
var SECOND_AUTH_DIALOG=exports.SECOND_AUTH_DIALOG="secondAuthDialog";//二次验证的窗口
var AUTH_DETAIL_DIALOG=exports.AUTH_DETAIL_DIALOG="authDetailDialog";//篡改详情的窗口

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_48__;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(9), __webpack_require__(1), __webpack_require__(48)) :
        typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
            (factory((global.mobxReact = global.mobxReact || {}), global.mobx, global.React, global.ReactDOM));
}(this, (function (exports, mobx, React, ReactDOM) {
    'use strict';
    var React__default = 'default' in React ? React['default'] : React;
    var ReactDOM__default = 'default' in ReactDOM ? ReactDOM['default'] : ReactDOM;
    var empty = {};
    var empty_1 = empty.unstable_batchedUpdates;
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    };
    var createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function (Constructor, protoProps, staticProps) {
            if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
            if (staticProps)
                defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var inherits = function (subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass)
            Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    var possibleConstructorReturn = function (self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var EventEmitter = function () {
        function EventEmitter() {
            classCallCheck(this, EventEmitter);
            this.listeners = [];
        }
        createClass(EventEmitter, [{
                key: "on",
                value: function on(cb) {
                    var _this = this;
                    this.listeners.push(cb);
                    return function () {
                        var index = _this.listeners.indexOf(cb);
                        if (index !== -1)
                            _this.listeners.splice(index, 1);
                    };
                }
            }, {
                key: "emit",
                value: function emit(data) {
                    this.listeners.forEach(function (fn) {
                        return fn(data);
                    });
                }
            }]);
        return EventEmitter;
    }();
    // Copied from React.PropTypes
    function createChainableTypeChecker(validate) {
        function checkType(isRequired, props, propName, componentName, location, propFullName) {
            for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
                rest[_key - 6] = arguments[_key];
            }
            return mobx.untracked(function () {
                componentName = componentName || '<<anonymous>>';
                propFullName = propFullName || propName;
                if (props[propName] == null) {
                    if (isRequired) {
                        var actual = props[propName] === null ? 'null' : 'undefined';
                        return new Error('The ' + location + ' `' + propFullName + '` is marked as required ' + 'in `' + componentName + '`, but its value is `' + actual + '`.');
                    }
                    return null;
                }
                else {
                    return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
                }
            });
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    // Copied from React.PropTypes
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
            return true;
        }
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') {
            return true;
        }
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
            return true;
        }
        return false;
    }
    // Copied from React.PropTypes
    function getPropType(propValue) {
        var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
        if (Array.isArray(propValue)) {
            return 'array';
        }
        if (propValue instanceof RegExp) {
            // Old webkits (at least until Android 4.0) return 'function' rather than
            // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
            // passes PropTypes.object.
            return 'object';
        }
        if (isSymbol(propType, propValue)) {
            return 'symbol';
        }
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // Copied from React.PropTypes
    function getPreciseType(propValue) {
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) {
                return 'date';
            }
            else if (propValue instanceof RegExp) {
                return 'regexp';
            }
        }
        return propType;
    }
    function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
            return mobx.untracked(function () {
                if (allowNativeType) {
                    if (getPropType(props[propName]) === mobxType.toLowerCase())
                        return null;
                }
                var mobxChecker = void 0;
                switch (mobxType) {
                    case 'Array':
                        mobxChecker = mobx.isObservableArray;
                        break;
                    case 'Object':
                        mobxChecker = mobx.isObservableObject;
                        break;
                    case 'Map':
                        mobxChecker = mobx.isObservableMap;
                        break;
                    default:
                        throw new Error('Unexpected mobxType: ' + mobxType);
                }
                var propValue = props[propName];
                if (!mobxChecker(propValue)) {
                    var preciseType = getPreciseType(propValue);
                    var nativeTypeExpectationMessage = allowNativeType ? ' or javascript `' + mobxType.toLowerCase() + '`' : '';
                    return new Error('Invalid prop `' + propFullName + '` of type `' + preciseType + '` supplied to' + ' `' + componentName + '`, expected `mobx.Observable' + mobxType + '`' + nativeTypeExpectationMessage + '.');
                }
                return null;
            });
        });
    }
    function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
            for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
                rest[_key2 - 5] = arguments[_key2];
            }
            return mobx.untracked(function () {
                if (typeof typeChecker !== 'function') {
                    return new Error('Property `' + propFullName + '` of component `' + componentName + '` has ' + 'invalid PropType notation.');
                }
                var error = createObservableTypeCheckerCreator(allowNativeType, 'Array')(props, propName, componentName);
                if (error instanceof Error)
                    return error;
                var propValue = props[propName];
                for (var i = 0; i < propValue.length; i++) {
                    error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + '[' + i + ']'].concat(rest));
                    if (error instanceof Error)
                        return error;
                }
                return null;
            });
        });
    }
    var observableArray = createObservableTypeCheckerCreator(false, 'Array');
    var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
    var observableMap = createObservableTypeCheckerCreator(false, 'Map');
    var observableObject = createObservableTypeCheckerCreator(false, 'Object');
    var arrayOrObservableArray = createObservableTypeCheckerCreator(true, 'Array');
    var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
    var objectOrObservableObject = createObservableTypeCheckerCreator(true, 'Object');
    var propTypes = Object.freeze({
        observableArray: observableArray,
        observableArrayOf: observableArrayOf,
        observableMap: observableMap,
        observableObject: observableObject,
        arrayOrObservableArray: arrayOrObservableArray,
        arrayOrObservableArrayOf: arrayOrObservableArrayOf,
        objectOrObservableObject: objectOrObservableObject
    });
    /**
     * Copyright 2015, Yahoo! Inc.
     * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
     */
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        arguments: true,
        arity: true
    };
    var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
    var index = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            var keys = Object.getOwnPropertyNames(sourceComponent);
            /* istanbul ignore else */
            if (isGetOwnPropertySymbolsAvailable) {
                keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
            }
            for (var i = 0; i < keys.length; ++i) {
                if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                    try {
                        targetComponent[keys[i]] = sourceComponent[keys[i]];
                    }
                    catch (error) {
                    }
                }
            }
        }
        return targetComponent;
    };
    function isStateless(component) {
        return !component.prototype.render;
    }
    var injectorContextTypes = {
        mobxStores: objectOrObservableObject
    };
    Object.seal(injectorContextTypes);
    var proxiedInjectorProps = {
        contextTypes: {
            get: function get$$1() {
                return injectorContextTypes;
            },
            set: function set$$1(_) {
                console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
            },
            configurable: true,
            enumerable: false
        },
        isMobxInjector: {
            value: true,
            writable: true,
            configurable: true,
            enumerable: true
        }
    };
    /**
     * Store Injection
     */
    function createStoreInjector(grabStoresFn, component, injectNames) {
        var _class, _temp2;
        var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
        if (injectNames)
            displayName += "-with-" + injectNames;
        var Injector = (_temp2 = _class = function (_Component) {
            inherits(Injector, _Component);
            function Injector() {
                var _ref;
                var _temp, _this, _ret;
                classCallCheck(this, Injector);
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }
                return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                    _this.wrappedInstance = instance;
                }, _temp), possibleConstructorReturn(_this, _ret);
            }
            createClass(Injector, [{
                    key: 'render',
                    value: function render() {
                        // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                        // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                        // See this test: 'using a custom injector is not too reactive' in inject.js
                        var newProps = {};
                        for (var key in this.props) {
                            if (this.props.hasOwnProperty(key)) {
                                newProps[key] = this.props[key];
                            }
                        }
                        var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                        for (var _key2 in additionalProps) {
                            newProps[_key2] = additionalProps[_key2];
                        }
                        if (!isStateless(component)) {
                            newProps.ref = this.storeRef;
                        }
                        return React__default.createElement(component, newProps);
                    }
                }]);
            return Injector;
        }(React.Component), _class.displayName = displayName, _temp2);
        // Static fields from component should be visible on the generated Injector
        index(Injector, component);
        Injector.wrappedComponent = component;
        Object.defineProperties(Injector, proxiedInjectorProps);
        return Injector;
    }
    function grabStoresByName(storeNames) {
        return function (baseStores, nextProps) {
            storeNames.forEach(function (storeName) {
                if (storeName in nextProps) // prefer props over stores
                    return;
                if (!(storeName in baseStores))
                    throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
                nextProps[storeName] = baseStores[storeName];
            });
            return nextProps;
        };
    }
    /**
     * higher order component that injects stores to a child.
     * takes either a varargs list of strings, which are stores read from the context,
     * or a function that manually maps the available stores from the context to props:
     * storesToProps(mobxStores, props, context) => newProps
     */
    function inject() {
        var grabStoresFn = void 0;
        if (typeof arguments[0] === "function") {
            grabStoresFn = arguments[0];
            return function (componentClass) {
                var injected = createStoreInjector(grabStoresFn, componentClass);
                injected.isMobxInjector = false; // supress warning
                // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
                // see #111
                injected = observer(injected);
                injected.isMobxInjector = true; // restore warning
                return injected;
            };
        }
        else {
            var storeNames = [];
            for (var i = 0; i < arguments.length; i++) {
                storeNames[i] = arguments[i];
            }
            grabStoresFn = grabStoresByName(storeNames);
            return function (componentClass) {
                return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
            };
        }
    }
    /**
     * dev tool support
     */
    var isDevtoolsEnabled = false;
    var isUsingStaticRendering = false;
    var warnedAboutObserverInjectDeprecation = false;
    // WeakMap<Node, Object>;
    var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
    var renderReporter = new EventEmitter();
    function findDOMNode(component) {
        if (ReactDOM__default) {
            try {
                return ReactDOM__default.findDOMNode(component);
            }
            catch (e) {
                // findDOMNode will throw in react-test-renderer, see:
                // See https://github.com/mobxjs/mobx-react/issues/216
                // Is there a better heuristic?
                return null;
            }
        }
        return null;
    }
    function reportRendering(component) {
        var node = findDOMNode(component);
        if (node && componentByNodeRegistery)
            componentByNodeRegistery.set(node, component);
        renderReporter.emit({
            event: 'render',
            renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
            totalTime: Date.now() - component.__$mobRenderStart,
            component: component,
            node: node
        });
    }
    function trackComponents() {
        if (typeof WeakMap === "undefined")
            throw new Error("[mobx-react] tracking components is not supported in this browser.");
        if (!isDevtoolsEnabled)
            isDevtoolsEnabled = true;
    }
    function useStaticRendering(useStaticRendering) {
        isUsingStaticRendering = useStaticRendering;
    }
    /**
     * Errors reporter
     */
    var errorsReporter = new EventEmitter();
    /**
     * Utilities
     */
    function patch(target, funcName) {
        var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var base = target[funcName];
        var mixinFunc = reactiveMixin[funcName];
        var f = !base ? mixinFunc : runMixinFirst === true ? function () {
            mixinFunc.apply(this, arguments);
            base.apply(this, arguments);
        } : function () {
            base.apply(this, arguments);
            mixinFunc.apply(this, arguments);
        };
        // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
        // ...but that breaks react-hot-loader, see #231...
        target[funcName] = f;
    }
    function isObjectShallowModified(prev, next) {
        if (null == prev || null == next || (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) !== "object" || (typeof next === 'undefined' ? 'undefined' : _typeof(next)) !== "object") {
            return prev !== next;
        }
        var keys = Object.keys(prev);
        if (keys.length !== Object.keys(next).length) {
            return true;
        }
        var key = void 0;
        for (var i = keys.length - 1; i >= 0, key = keys[i]; i--) {
            if (next[key] !== prev[key]) {
                return true;
            }
        }
        return false;
    }
    /**
     * ReactiveMixin
     */
    var reactiveMixin = {
        componentWillMount: function componentWillMount() {
            var _this = this;
            if (isUsingStaticRendering === true)
                return;
            // Generate friendly name for debugging
            var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
            var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID;
            /**
             * If props are shallowly modified, react will render anyway,
             * so atom.reportChanged() should not result in yet another re-render
             */
            var skipRender = false;
            /**
             * forceUpdate will re-assign this.props. We don't want that to cause a loop,
             * so detect these changes
             */
            var isForcingUpdate = false;
            function makePropertyObservableReference(propName) {
                var valueHolder = this[propName];
                var atom = new mobx.Atom("reactive " + propName);
                Object.defineProperty(this, propName, {
                    configurable: true, enumerable: true,
                    get: function get$$1() {
                        atom.reportObserved();
                        return valueHolder;
                    },
                    set: function set$$1(v) {
                        if (!isForcingUpdate && isObjectShallowModified(valueHolder, v)) {
                            valueHolder = v;
                            skipRender = true;
                            atom.reportChanged();
                            skipRender = false;
                        }
                        else {
                            valueHolder = v;
                        }
                    }
                });
            }
            // make this.props an observable reference, see #124
            makePropertyObservableReference.call(this, "props");
            // make state an observable reference
            makePropertyObservableReference.call(this, "state");
            // wire up reactive render
            var baseRender = this.render.bind(this);
            var reaction = null;
            var isRenderingPending = false;
            var initialRender = function initialRender() {
                reaction = new mobx.Reaction(initialName + '#' + rootNodeID + '.render()', function () {
                    if (!isRenderingPending) {
                        // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                        // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                        // See #85 / Pull #44
                        isRenderingPending = true;
                        if (typeof _this.componentWillReact === "function")
                            _this.componentWillReact(); // TODO: wrap in action?
                        if (_this.__$mobxIsUnmounted !== true) {
                            // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                            // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                            // However, people also claim this migth happen during unit tests..
                            var hasError = true;
                            try {
                                isForcingUpdate = true;
                                if (!skipRender)
                                    React__default.Component.prototype.forceUpdate.call(_this);
                                hasError = false;
                            }
                            finally {
                                isForcingUpdate = false;
                                if (hasError)
                                    reaction.dispose();
                            }
                        }
                    }
                });
                reactiveRender.$mobx = reaction;
                _this.render = reactiveRender;
                return reactiveRender();
            };
            var reactiveRender = function reactiveRender() {
                isRenderingPending = false;
                var exception = undefined;
                var rendering = undefined;
                reaction.track(function () {
                    if (isDevtoolsEnabled) {
                        _this.__$mobRenderStart = Date.now();
                    }
                    try {
                        rendering = mobx.extras.allowStateChanges(false, baseRender);
                    }
                    catch (e) {
                        exception = e;
                    }
                    if (isDevtoolsEnabled) {
                        _this.__$mobRenderEnd = Date.now();
                    }
                });
                if (exception) {
                    errorsReporter.emit(exception);
                    throw exception;
                }
                return rendering;
            };
            this.render = initialRender;
        },
        componentWillUnmount: function componentWillUnmount() {
            if (isUsingStaticRendering === true)
                return;
            this.render.$mobx && this.render.$mobx.dispose();
            this.__$mobxIsUnmounted = true;
            if (isDevtoolsEnabled) {
                var node = findDOMNode(this);
                if (node && componentByNodeRegistery) {
                    componentByNodeRegistery.delete(node);
                }
                renderReporter.emit({
                    event: 'destroy',
                    component: this,
                    node: node
                });
            }
        },
        componentDidMount: function componentDidMount() {
            if (isDevtoolsEnabled) {
                reportRendering(this);
            }
        },
        componentDidUpdate: function componentDidUpdate() {
            if (isDevtoolsEnabled) {
                reportRendering(this);
            }
        },
        shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
            if (isUsingStaticRendering) {
                console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
            }
            // update on any state changes (as is the default)
            if (this.state !== nextState) {
                return true;
            }
            // update if props are shallowly not equal, inspired by PureRenderMixin
            // we could return just 'false' here, and avoid the `skipRender` checks etc
            // however, it is nicer if lifecycle events are triggered like usually,
            // so we return true here if props are shallowly modified.
            return isObjectShallowModified(this.props, nextProps);
        }
    };
    /**
     * Observer function / decorator
     */
    function observer(arg1, arg2) {
        if (typeof arg1 === "string") {
            throw new Error("Store names should be provided as array");
        }
        if (Array.isArray(arg1)) {
            // component needs stores
            if (!warnedAboutObserverInjectDeprecation) {
                warnedAboutObserverInjectDeprecation = true;
                console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
            }
            if (!arg2) {
                // invoked as decorator
                return function (componentClass) {
                    return observer(arg1, componentClass);
                };
            }
            else {
                return inject.apply(null, arg1)(observer(arg2));
            }
        }
        var componentClass = arg1;
        if (componentClass.isMobxInjector === true) {
            console.warn('Mobx observer: You are trying to use \'observer\' on a component that already has \'inject\'. Please apply \'observer\' before applying \'inject\'');
        }
        // Stateless function component:
        // If it is function but doesn't seem to be a react class constructor,
        // wrap it to a react class automatically
        if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React__default.Component.isPrototypeOf(componentClass)) {
            var _class, _temp;
            return observer((_temp = _class = function (_Component) {
                inherits(_class, _Component);
                function _class() {
                    classCallCheck(this, _class);
                    return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
                }
                createClass(_class, [{
                        key: 'render',
                        value: function render() {
                            return componentClass.call(this, this.props, this.context);
                        }
                    }]);
                return _class;
            }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
        }
        if (!componentClass) {
            throw new Error("Please pass a valid component to 'observer'");
        }
        var target = componentClass.prototype || componentClass;
        mixinLifecycleEvents(target);
        componentClass.isMobXReactObserver = true;
        return componentClass;
    }
    function mixinLifecycleEvents(target) {
        patch(target, "componentWillMount", true);
        ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
            patch(target, funcName);
        });
        if (!target.shouldComponentUpdate) {
            target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
        }
    }
    // TODO: support injection somehow as well?
    var Observer = observer(function (_ref) {
        var children = _ref.children;
        return children();
    });
    Observer.propTypes = {
        children: function children(propValue, key, componentName, location, propFullName) {
            if (typeof propValue[key] !== 'function')
                return new Error('Invalid prop `' + propFullName + '` of type `' + _typeof(propValue[key]) + '` supplied to' + ' `' + componentName + '`, expected `function`.');
        }
    };
    var _class;
    var _temp;
    var specialReactKeys = { children: true, key: true, ref: true };
    var Provider = (_temp = _class = function (_Component) {
        inherits(Provider, _Component);
        function Provider() {
            classCallCheck(this, Provider);
            return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
        }
        createClass(Provider, [{
                key: 'render',
                value: function render() {
                    return React__default.Children.only(this.props.children);
                }
            }, {
                key: 'getChildContext',
                value: function getChildContext() {
                    var stores = {};
                    // inherit stores
                    var baseStores = this.context.mobxStores;
                    if (baseStores)
                        for (var key in baseStores) {
                            stores[key] = baseStores[key];
                        }
                    // add own stores
                    for (var _key in this.props) {
                        if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning")
                            stores[_key] = this.props[_key];
                    }
                    return {
                        mobxStores: stores
                    };
                }
            }, {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    // Maybe this warning is too aggressive?
                    if (Object.keys(nextProps).length !== Object.keys(this.props).length)
                        console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
                    if (!nextProps.suppressChangedStoreWarning)
                        for (var key in nextProps) {
                            if (!specialReactKeys[key] && this.props[key] !== nextProps[key])
                                console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
                        }
                }
            }]);
        return Provider;
    }(React.Component), _class.contextTypes = {
        mobxStores: objectOrObservableObject
    }, _class.childContextTypes = {
        mobxStores: objectOrObservableObject.isRequired
    }, _temp);
    var TARGET_LIB_NAME = void 0;
    TARGET_LIB_NAME = 'mobx-react';
    if (!mobx)
        throw new Error(TARGET_LIB_NAME + ' requires the MobX package');
    if (!React__default)
        throw new Error(TARGET_LIB_NAME + ' requires React to be available');
    if ("browser" === 'browser' && typeof ReactDOM.unstable_batchedUpdates === "function")
        mobx.extras.setReactionScheduler(ReactDOM.unstable_batchedUpdates);
    if (false)
        mobx.extras.setReactionScheduler(empty_1);
    var onError = function onError(fn) {
        return errorsReporter.on(fn);
    };
    /* DevTool support */
    if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ? 'undefined' : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === 'object') {
        __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(exports, mobx);
    }
    exports.propTypes = propTypes;
    exports.PropTypes = propTypes;
    exports.onError = onError;
    exports['default'] = exports;
    exports.observer = observer;
    exports.Observer = Observer;
    exports.renderReporter = renderReporter;
    exports.componentByNodeRegistery = componentByNodeRegistery;
    exports.trackComponents = trackComponents;
    exports.useStaticRendering = useStaticRendering;
    exports.Provider = Provider;
    exports.inject = inject;
    Object.defineProperty(exports, '__esModule', { value: true });
})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; };
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _toCapitalString = __webpack_require__(697);
var _toCapitalString2 = _interopRequireDefault(_toCapitalString);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
function withPropsReactive(MapComponent) {
    return function (_React$Component) {
        _inherits(_class, _React$Component);
        function _class(props) {
            _classCallCheck(this, _class);
            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
            _this.instanceCreated = false;
            _this.myMapComponent = null;
            _this.registeredEvents = [];
            _this.onInstanceCreated = _this.onInstanceCreated.bind(_this);
            return _this;
        }
        _createClass(_class, [{
                key: 'onInstanceCreated',
                value: function onInstanceCreated() {
                    this.instanceCreated = true;
                    if ('events' in this.props) {
                        var instance = this.myMapComponent.instance;
                        if (this.props.events.created) {
                            this.props.events.created(instance);
                        }
                    }
                    this.reactivePropChange(this.props, false);
                }
            }, {
                key: 'createEventsProxy',
                value: function createEventsProxy(props) {
                    var self = this;
                    var instance = this.myMapComponent.instance;
                    var evs = Object.keys(props.events || {});
                    evs.length && evs.forEach(function (ev) {
                        if (self.registeredEvents.indexOf(ev) === -1) {
                            self.registeredEvents.push(ev);
                            instance.on(ev, function (ev) {
                                return function () {
                                    if (self.props.events && ev in self.props.events) {
                                        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                                            args[_key] = arguments[_key];
                                        }
                                        self.props.events[ev].apply(null, args);
                                    }
                                };
                            }(ev));
                        }
                    });
                }
            }, {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    this.reactivePropChange(nextProps, true);
                }
            }, {
                key: 'reactivePropChange',
                value: function reactivePropChange(nextProps) {
                    var _this2 = this;
                    var shouldDetectChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    if (!this.instanceCreated) {
                        return false;
                    }
                    var _myMapComponent = this.myMapComponent, _myMapComponent$sette = _myMapComponent.setterMap, setterMap = _myMapComponent$sette === undefined ? {} : _myMapComponent$sette, _myMapComponent$conve = _myMapComponent.converterMap, converterMap = _myMapComponent$conve === undefined ? {} : _myMapComponent$conve, _myMapComponent$insta = _myMapComponent.instance, instance = _myMapComponent$insta === undefined ? {} : _myMapComponent$insta;
                    var list = Object.keys(nextProps);
                    list.length && list.forEach(function (key) {
                        if (key === 'events') {
                            return _this2.createEventsProxy(nextProps);
                        }
                        var willReactive = true;
                        if (shouldDetectChange) {
                            willReactive = _this2.detectPropChange(key, nextProps, _this2.props);
                        }
                        if (!willReactive) {
                            return false;
                        }
                        var setterParam = nextProps[key];
                        if (key in converterMap) {
                            setterParam = converterMap[key](nextProps[key]);
                        }
                        if (key in setterMap) {
                            setterMap[key](setterParam);
                        }
                        else {
                            var trySetterName = 'set' + (0, _toCapitalString2.default)(key);
                            if (trySetterName in instance) {
                                instance[trySetterName](setterParam);
                            }
                        }
                    });
                }
            }, {
                key: 'detectPropChange',
                value: function detectPropChange(key, nextProps, oldProps) {
                    return nextProps[key] !== oldProps[key];
                }
            }, {
                key: 'render',
                value: function render() {
                    var _this3 = this;
                    return _react2.default.createElement(MapComponent, _extends({
                        onInstanceCreated: this.onInstanceCreated,
                        ref: function ref(comp) {
                            _this3.myMapComponent = comp;
                        }
                    }, this.props));
                }
            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    var instance = this.myMapComponent.instance;
                    if (!instance)
                        return;
                    if ('destroy' in instance) {
                        setTimeout(function () {
                            instance.destroy();
                        }, 10);
                    }
                    if ('hide' in instance) {
                        instance.hide();
                    }
                    if ('__map__' in this.props && 'setMap' in instance) {
                        instance.setMap(null);
                    }
                }
            }]);
        return _class;
    }(_react2.default.Component);
}
;
exports.default = withPropsReactive;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_51__;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(107);
var enumBugKeys = __webpack_require__(94);
module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(324), __esModule: true };


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(157), isLength = __webpack_require__(160);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _defineProperty = __webpack_require__(16);
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (obj, key, value) {
    if (key in obj) {
        (0, _defineProperty2.default)(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getLastStepData=exports.getFirstStepData=exports.getFieldStepInfo=exports.getFieldStepALLInfo=exports.getLinkageInfo=exports.openAIPage=exports.appendStepDetail=exports.generateStepId=exports.CHANGE_FIELD_VARS=exports.CHANGE_FIELD_VALUE=exports.TYPE_WFFORM_FORMULA=exports.TYPE_WFFORM_API=exports.TYPE_LINKAGE_ASYNC=exports.TYPE_LINKAGE_SYNC=exports.TYPE_FIELD_CHANGE=exports.TYPE_DETAIL_ADDROW=exports.TYPE_MAIN_INIT=exports.setScriptContent=exports.isShowAI=undefined;var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _common=__webpack_require__(10);var _analyzeUtil=__webpack_require__(481);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var isShowAI=exports.isShowAI=function isShowAI(){return _source2.default.globalStore.commonParam.showAI=="1";};var scriptContent="";var setScriptContent=exports.setScriptContent=function setScriptContent(){var str=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";if(!isShowAI())return;scriptContent=str;};//字段变更类型 
var TYPE_MAIN_INIT=exports.TYPE_MAIN_INIT="1";//主表字段初始值加载
var TYPE_DETAIL_ADDROW=exports.TYPE_DETAIL_ADDROW="2";//添加/生成明细行的默认值
var TYPE_FIELD_CHANGE=exports.TYPE_FIELD_CHANGE="3";//手动变更字段
var TYPE_LINKAGE_SYNC=exports.TYPE_LINKAGE_SYNC="4";//同步联动修改
var TYPE_LINKAGE_ASYNC=exports.TYPE_LINKAGE_ASYNC="5";//异步联动修改
var TYPE_WFFORM_API=exports.TYPE_WFFORM_API="6";//通过接口WfForm修改
var TYPE_WFFORM_FORMULA=exports.TYPE_WFFORM_FORMULA="7";//公式修改
var CHANGE_FIELD_VALUE=exports.CHANGE_FIELD_VALUE="c_value";//改变字段值
var CHANGE_FIELD_VARS=exports.CHANGE_FIELD_VARS="c_vars";//改变字段属性
var modifyStep={};var stepIndex=0;/**
 * 当开启智能分析showAI=1时，记录每个字段变更的详细修改日志
 * 包括加载页面初始值、明细生成行的初始值、手动修改值、联动修改的值、接口修改的值
 */var generateStepId=exports.generateStepId=function generateStepId(type){var otherinfo=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!isShowAI())return 0;stepIndex++;modifyStep['step_'+stepIndex]={type:type,datas:[],otherinfo:otherinfo,time:new Date().getTime()};return stepIndex;};var appendStepDetail=exports.appendStepDetail=function appendStepDetail(stepid,fieldMark,type){var result=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};if(!isShowAI())return;if(typeof stepid==="undefined"||stepid<=0||!modifyStep['step_'+stepid])return;var curStep=modifyStep['step_'+stepid];curStep.datas.push({fieldMark:fieldMark,type:type,result:result});};//显示分析页面
var openAIPage=exports.openAIPage=function openAIPage(){var commonParam=_source2.default.globalStore.commonParam;var custompage=commonParam.custompage;window.WfForm_analyzeData={custompage:{jsp:GlobalUtil.generateCustomPageList(),js:custompage.jsPage||[],css:custompage.cssPage||[]},scriptContent:scriptContent,modifyStep:modifyStep};window.open((window.ecologyContentPath||'')+'/spa/workflow/static/index.html#/main/workflow/analyze');};/**
 * 获取指定字段的联动信息
 * @param recordfieldids 指定的字段id
 * @returns {{}}
 */var getLinkageInfo=exports.getLinkageInfo=function getLinkageInfo(recordfieldids){var a=new Date();var layoutStore=_source2.default.layoutStore;var tableInfo=layoutStore.tableInfo;var changeFnObj=WfForm.__propertyChangeFnObj;var _layoutStore$linkageC=layoutStore.linkageCfg,rowCalCfg=_layoutStore$linkageC.rowCalCfg,fieldSqlCfg=_layoutStore$linkageC.fieldSqlCfg,fieldMathCfg=_layoutStore$linkageC.fieldMathCfg,dataInputCfg=_layoutStore$linkageC.dataInputCfg,fieldDateCfg=_layoutStore$linkageC.fieldDateCfg,viewAttrCfg=_layoutStore$linkageC.viewAttrCfg,mainCalCfg=_layoutStore$linkageC.mainCalCfg,formulaCfg=_layoutStore$linkageC.formulaCfg;var dataSource=[];rowCalCfg&&(0,_common.forIn)(rowCalCfg,function(value,key){key!=='rowCalAssignInfo'&&value.map(function(item){var trgField=key&&typeof key==='string'?key.split(","):key;var assignField=item.assignField&&typeof item.assignField==='string'?item.assignField.split(","):item.assignField;dataSource.push({linkageType:'行规则',//联动名称
trgField:trgField,//触发字段
assignField:assignField,//赋值字段
otherInfo:item.config});});});mainCalCfg&&(0,_common.forIn)(mainCalCfg,function(value,key){var trgField=key&&typeof key==='string'?key.split(","):key;var assignField=value&&typeof value==='string'?value.split(","):value;dataSource.push({linkageType:'列赋值',trgField:trgField,assignField:assignField,otherInfo:''});});fieldSqlCfg&&(0,_common.forIn)(fieldSqlCfg,function(value,key){if(key==='emptyTriField'){value.map(function(item){var assignField=item.assignField&&typeof item.assignField==='string'?item.assignField.split(","):item.assignField;dataSource.push({linkageType:'SQL联动',trgField:'无',assignField:assignField,otherInfo:''});});}else{value.map(function(item){var trgField=key&&typeof key==='string'?key.split(","):key;var assignField=item.assignField&&typeof item.assignField==='string'?item.assignField.split(","):item.assignField;dataSource.push({linkageType:'SQL联动',trgField:trgField,assignField:assignField,otherInfo:''});});}});fieldDateCfg&&(0,_common.forIn)(fieldDateCfg,function(value,key){value.map(function(item){var trgField=item.relateFields&&typeof item.relateFields==='string'?item.relateFields.split(","):item.relateFields;var assignField=item.assignField&&typeof item.assignField==='string'?item.assignField.split(","):item.assignField;dataSource.push({linkageType:'时间日期计算',trgField:trgField,assignField:assignField,otherInfo:''});});});fieldMathCfg&&(0,_common.forIn)(fieldMathCfg,function(value,key){value.map(function(item){var trgField=key&&typeof key==='string'?key.split(","):key;var assignField=item.assignField&&typeof item.assignField==='string'?item.assignField.split(","):item.assignField;dataSource.push({linkageType:'字段赋值',trgField:trgField,assignField:assignField,otherInfo:item.config});});});dataInputCfg&&(0,_common.forIn)(dataInputCfg,function(value,key){value.map(function(item){item.otherParams.assignfields.map(function(field){var trgField=key&&typeof key==='string'?key.split(","):key;var assignField=field&&typeof field==='string'?field.split(","):field;dataSource.push({linkageType:'字段联动',trgField:trgField,assignField:assignField,otherInfo:item.config});});});});viewAttrCfg&&(0,_common.forIn)(viewAttrCfg,function(value,key){var fieldArr=[];var trgField0=key.slice(0,-2);value.relateFields&&value.relateFields.map(function(item){fieldArr.push(item.slice(0,-2));});var trgField=trgField0&&typeof trgField0==='string'?trgField0.split(","):trgField0;dataSource.push({linkageType:'显示属性联动',trgField:trgField,assignField:fieldArr,otherInfo:''});});tableInfo&&(0,_common.forIn)(tableInfo,function(formInfo){formInfo.fieldinfomap&&(0,_common.forIn)(formInfo.fieldinfomap,function(value,key){if(value.htmltype==5&&value.selectattr.childfieldid>0){var trgField=key&&typeof key==='string'?key.split(","):key;var temp=value.selectattr.childfieldid.toString();var assignField=temp&&typeof temp==='string'?temp.split(","):temp;dataSource.push({linkageType:'选择框联动',trgField:trgField,assignField:assignField,otherInfo:''});}});});changeFnObj&&(0,_common.forIn)(changeFnObj,function(v,key){var trgField=key&&typeof key==='string'?key.split(","):key;dataSource.push({linkageType:'代码块/自定义页面',trgField:trgField,assignField:'',otherInfo:v.length+'条'});});formulaCfg&&(0,_common.forIn)(formulaCfg,function(value,key){if(key==='formulas'){value.map(function(item){var triFields=(0,_analyzeUtil.getTriFieldWithFormula)(item.triggers);var destfield=(0,_analyzeUtil.getAssignFieldWithFormula)(item.destfield);var assignField=destfield&&typeof destfield==='string'?destfield.split(","):destfield;dataSource.push({linkageType:'公式',trgField:triFields,assignField:assignField,otherInfo:''});});}});var cfjMap={};recordfieldids.map(function(fieldid){cfjMap[fieldid]=dataSource.filter(function(item){// let trgFieldArr = item.trgField;
// let assignFieldArr = item.assignField;
var reactionFieldArr=item.trgField.concat(item.assignField);var flag=false;for(var i=0;i<reactionFieldArr.length;i++){if(reactionFieldArr[i]===fieldid){flag=true;break;}}return flag;});});return cfjMap;};/**
 * 获取目标字段所有的变更步骤
 * @param fieldId
 */var getFieldStepALLInfo=exports.getFieldStepALLInfo=function getFieldStepALLInfo(fieldId){var dataSource=[];var _wfform$getFieldInfo=wfform.getFieldInfo(fieldId),htmltype=_wfform$getFieldInfo.htmltype;modifyStep&&(0,_common.forIn)(modifyStep,function(value,key){var rowData={};var step=key.substring(5);var type=value.type;var changedDatas=value.datas;var linkageInfo=value.otherinfo;rowData["key"]=step;rowData["step"]=step;rowData["type"]=(0,_analyzeUtil.getStepType)(type);(0,_common.isEmpty)(linkageInfo)?null:rowData["linkageInfo"]=linkageInfo;//联动信息
(0,_common.isEmpty)(changedDatas)?null:rowData["changedDatas"]=changedDatas;//变更数据
dataSource.push(rowData);});//根据字段查询
var fieldList=fieldId?fieldId.split(","):[];var resArr=fieldList.length===0?null:dataSource.filter(function(item){var newChangedDatas=[];newChangedDatas=item.changedDatas&&item.changedDatas.filter(function(o){return(0,_common.includes)(fieldList,(0,_analyzeUtil.getFieldid)(o.fieldMark));});if((htmltype===1||htmltype===2)&&typeof newChangedDatas!='undefined'){for(var i=0;i<newChangedDatas.length;i++){//排除改变类型为字段属性变更的情况
if(newChangedDatas[i].type!==CHANGE_FIELD_VARS){var stepValue=newChangedDatas[i].result.value;newChangedDatas[i].result.value=stepValue.length>100?stepValue.substr(0,100)+"...(文本超长部分已被截取)":stepValue;}}}item.changedDatas=newChangedDatas;return item.changedDatas&&item.changedDatas.length>0;});return resArr;};/**
 * 获取目标字段的第一步和最后两步变更数据，明细表需要获取目标列每一行的对应字段的第一步和最后两步数据
 * @param fieldId
 */var getFieldStepInfo=exports.getFieldStepInfo=function getFieldStepInfo(fieldId){var res=[];var fieldAllSteps=getFieldStepALLInfo(fieldId);var _wfform$getFieldInfo2=wfform.getFieldInfo(fieldId),isdetail=_wfform$getFieldInfo2.isdetail,tableMark=_wfform$getFieldInfo2.tableMark;if(isdetail){//第一步：按照下标过滤明细数据
var rows=parseInt(wfform.getDetailRowCount(tableMark));var indexArr=[];if(rows>10){for(var i=0;i<10;i++){var indexStepData1={detailIndex:i,detailFieldSetp:[]};for(var j=0;j<fieldAllSteps.length;j++){var index1=parseInt(fieldAllSteps[j].changedDatas[0].fieldMark.split("_")[1]);if(index1===i){indexStepData1.detailFieldSetp.push(fieldAllSteps[j]);}}indexArr.push(indexStepData1);}}else{for(var x=0;x<rows;x++){var indexStepData2={detailIndex:x,detailFieldSetp:[]};for(var y=0;y<fieldAllSteps.length;y++){var index2=parseInt(fieldAllSteps[y].changedDatas[0].fieldMark.split("_")[1]);if(index2===x){indexStepData2.detailFieldSetp.push(fieldAllSteps[y]);}}indexArr.push(indexStepData2);}}//第二部：过滤出对应明细行目标字段的第一步和最后两步变更数据
for(var z=0;z<indexArr.length;z++){if(indexArr[z].detailFieldSetp.length>3){var tempArr1=[];tempArr1.push(indexArr[z].detailFieldSetp[0]);tempArr1.push(indexArr[z].detailFieldSetp[indexArr[z].detailFieldSetp.length-2]);tempArr1.push(indexArr[z].detailFieldSetp[indexArr[z].detailFieldSetp.length-1]);indexArr[z].detailFieldSetp=tempArr1;}}res=indexArr;return res;}else{//主表字段的数据过滤，取第一步和最后两步的数据
if(fieldAllSteps.length>3){res.push(fieldAllSteps[0]);res.push(fieldAllSteps[fieldAllSteps.length-2]);res.push(fieldAllSteps[fieldAllSteps.length-1]);}else{res=fieldAllSteps;}}return res;};/**
 * 获取表单加载时字段的值
 */var getFirstStepData=exports.getFirstStepData=function getFirstStepData(stepInfo,isDetail){if(isDetail){//最多取前10行明细对应列字段的加载时数据
var res=[];for(var i=0;i<stepInfo.length;i++){var detailSteps=stepInfo[i].detailFieldSetp.length;if(detailSteps>0){res.push({detailIndex:stepInfo[i].detailIndex,firstStep:stepInfo[i].detailFieldSetp[0].changedDatas[0].result.value});}else{res.push({detailIndex:stepInfo[i].detailIndex,firstStep:"无变更步骤数据"});}}return res;}else{//主表字段
if(stepInfo.length>0){//区分值改变和字段属性改变
if(stepInfo[0].changedDatas[0].type===CHANGE_FIELD_VARS){return stepInfo[0].changedDatas[0].result.viewAttr;}else{return stepInfo[0].changedDatas[0].result.value;}}else{return"无变更步骤数据";}}};/**
 * 获取表单提交时字段的值
 */var getLastStepData=exports.getLastStepData=function getLastStepData(stepInfo,isDetail){if(isDetail){//最多取前10行明细对应列字段的加载时数据
var res=[];for(var i=0;i<stepInfo.length;i++){var detailSteps=stepInfo[i].detailFieldSetp.length;if(detailSteps>0){res.push({detailIndex:stepInfo[i].detailIndex,firstStep:stepInfo[i].detailFieldSetp[detailSteps-1].changedDatas[0].result.value});}else{res.push({detailIndex:stepInfo[i].detailIndex,firstStep:"无变更步骤数据"});}}return res;}else{//主表字段
if(stepInfo.length>0){//区分值改变和字段属性改变
if(stepInfo[stepInfo.length-1].changedDatas[0].type===CHANGE_FIELD_VARS){return stepInfo[stepInfo.length-1].changedDatas[0].result.viewAttr;}else{return stepInfo[stepInfo.length-1].changedDatas[0].result.value;}}else{return"无变更步骤数据";}}};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getRemarkQuoteData=exports.generateFreeNodeData=exports.generateFormData=exports.verifySecLevelIsFormat=exports.verifySecLevelIsEmpty=exports.verifyRequestNameIsEmpty=exports.verifyRequiredEmptyOtherParams=exports.verifyRequiredEmptyField=exports.verifyMustAddDetail=exports.verifyIntervenorInfo=exports.verifyCustomFun=exports.doSubmitPost=exports.doFileUpload=exports.doSubmitReady=exports.doSubmitForm=undefined;var _set=__webpack_require__(130);var _set2=_interopRequireDefault(_set);var _toConsumableArray2=__webpack_require__(82);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _regenerator=__webpack_require__(128);var _regenerator2=_interopRequireDefault(_regenerator);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _asyncToGenerator2=__webpack_require__(129);var _asyncToGenerator3=_interopRequireDefault(_asyncToGenerator2);var _promise=__webpack_require__(98);var _promise2=_interopRequireDefault(_promise);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _continuationProcessUtil=__webpack_require__(131);var continuationProcessUtil=_interopRequireWildcard(_continuationProcessUtil);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _signUtil=__webpack_require__(58);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _type2=__webpack_require__(27);var type=_interopRequireWildcard(_type2);var _objectAssign=__webpack_require__(88);var _objectAssign2=_interopRequireDefault(_objectAssign);var _convert=__webpack_require__(6);var _globalUtil=__webpack_require__(30);var _linkageControl=__webpack_require__(84);var LinkageControl=_interopRequireWildcard(_linkageControl);var _analyzeData=__webpack_require__(56);var _secondAuthUtil=__webpack_require__(86);var _secLevelUtil=__webpack_require__(125);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);var _secondAuth=__webpack_require__(249);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _conformRuleUtil=__webpack_require__(250);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//表单提交入口，先校验必填等信息
var doSubmitForm=exports.doSubmitForm=function doSubmitForm(para){var _para$isSelectNextFlo=para.isSelectNextFlow,isSelectNextFlow=_para$isSelectNextFlo===undefined?'0':_para$isSelectNextFlo,_para$type=para.type,type=_para$type===undefined?'':_para$type;if(isSelectNextFlow!='1'&&type!='ensuresubmit'){var secondAuthStore=_base2.default.secondAuthStore;secondAuthStore.setSecondAuthPop(false);}var _base$globalStore=_base2.default.globalStore,commonParam=_base$globalStore.commonParam,submitParam=_base$globalStore.submitParam,_base$globalStore$sec=_base$globalStore.secLevelInfo,secLevelInfo=_base$globalStore$sec===undefined?{}:_base$globalStore$sec,conflictFieldMap=_base$globalStore.conflictFieldMap,setTabKey=_base$globalStore.setTabKey,tabKey=_base$globalStore.tabKey;var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;var actiontype=para.actiontype,src=para.src,_para$isaffirmance=para.isaffirmance,isaffirmance=_para$isaffirmance===undefined?'':_para$isaffirmance,closePage=para.closePage;var isSubmitDirectNode=submitParam.isSubmitDirectNode,lastnodeid=submitParam.lastnodeid,isHideInput=submitParam.isHideInput,iscreate=submitParam.iscreate;var isFirstSubmit=iscreate=="1"?"":"0";var params=(0,_extends3.default)({},para,{isFirstSubmit:isFirstSubmit});if(src=='submit'||isaffirmance=='1'||src=='intervenor'){//提交前校验自定义函数
if(!verifyCustomFun(src,isaffirmance)){return false;}if(!verifyConflictField(conflictFieldMap)){return false;}var isViewOnly=parseInt(commonParam.isviewonly||0);var isAffirmanceSubmit=parseInt(commonParam.isaffirmance||0);var intervenorright=parseInt(commonParam.intervenorright||0);var needVerify=isViewOnly!==1&&isAffirmanceSubmit!==1;var submitFn=function submitFn(){if(needVerify){//校验必须新增明细
if(!verifyMustAddDetail())return false;//校验必填空值范围
var emptyField=verifyRequiredEmptyField();if(emptyField!==""){window.setTimeout(function(){Util.showPrompt(emptyField,1);//明细可能需要切页，延时提示
},50);if(window.wfform.getOdocConfig().docFlag&&tabKey=='odoc'){//正文页签下隐藏插件并返回表单
setTabKey("form");var contentDiv=jQuery(".wea-new-top-req-content");contentDiv.css("overflow-y","hidden");jQuery(".wf-req-odoc").height(1);var marginTop=parseInt(jQuery(".wf-req-odoc").css('fontSize').replace('px',''),10);marginTop=marginTop>0?marginTop=(marginTop+1)*-1:-13;jQuery(".wf-req-odoc").css('marginTop',marginTop+'px');jQuery(".wf-req-odoc").css('marginBottom','0px');jQuery(".req-workflow-odoc").height(1);showOrHideWeboffice(0);}return false;}}else{_base2.default.globalStore.changeSubmitParam({verifyRequiredRange:"field-9999,"});}if(verifySecLevelIsFormat()){var secValidity=secLevelInfo.secValidity;if(secValidity&&_.trim(secValidity)===''){message.warning((0,_convert.getLabel)(531286,'密级或保密期限未填写！'));}else{message.warning((0,_convert.getLabel)(528441,'保密期限不能为纯数字!'));}return;}if(isSubmitDirectNode=="1"){params.SubmitToNodeid=lastnodeid;}//流程干预验证必填
if(intervenorright>0){var result=verifyIntervenorInfo(submitParam);if(result.type==0){message.warning(result.msg);return false;}}//除表单字段外提交表单时的必填校验
var emptyOtherPramas=verifyRequiredEmptyOtherParams();if(emptyOtherPramas.msg){Util.scrollDom(emptyOtherPramas.dom,true,emptyOtherPramas.msg);return;}doSubmitReady(params);};//提交校验必填前，支持先执行自定义事件
return needVerify?(0,_globalUtil.verifyCustomRegisterEvent)(_interface2.default.OPER_BEFOREVERIFY,submitFn):submitFn();}else{//标题字段放置在模板上且不为只读，则保存校验必填，其它情况后台接收到requestname为空的直接生成默认标题
var _base$layoutStore=_base2.default.layoutStore,fieldAttrMap=_base$layoutStore.fieldAttrMap,cellInfo=_base$layoutStore.cellInfo;var requestnameViewAttr=fieldAttrMap.has("-1")&&fieldAttrMap.get("-1").viewattr||0;var secLevelViewAttr=fieldAttrMap.has("-10")&&fieldAttrMap.get("-10").viewattr||0;var canEdit=secLevelInfo.canSecChange&&secLevelViewAttr>1?3:1;if(src==="save"&&_.has(cellInfo,["fieldCellInfo","-1"])&&requestnameViewAttr>1&&verifyRequestNameIsEmpty()){Util.showPrompt("field-1",1);message.warning((0,_convert.getLabel)(386187,'请求标题字段未填值！'));return false;}else if(src==="save"&&_.has(cellInfo,["fieldCellInfo","-10"])&&canEdit&&verifySecLevelIsEmpty()){Util.showPrompt("field-10",1);message.warning((0,_convert.getLabel)(531286,'密级或保密期限未填写！'));return false;}else if(src==="save"&&verifySecLevelIsFormat()){message.warning((0,_convert.getLabel)(528441,'保密期限不能为纯数字!'));return false;}doSubmitReady(params);}};//校验通过，准备提交
var doSubmitReady=exports.doSubmitReady=function doSubmitReady(params){var src=params.src,actiontype=params.actiontype,isaffirmance=params.isaffirmance,_params$type=params.type,type=_params$type===undefined?'':_params$type,_params$isaffirmanceS=params.isaffirmanceSrc,isaffirmanceSrc=_params$isaffirmanceS===undefined?'':_params$isaffirmanceS;if(actiontype=='requestOperation'&&isaffirmanceSrc=='reject'){var secondAuthStore=_base2.default.secondAuthStore;secondAuthStore.setSecondAuthPop(false);}var commonParam=_base2.default.globalStore.commonParam;var hasCheckedConformRule=_base2.default.conformRuleStore.hasCheckedConformRule;if((0,_signUtil.verifyRemark)(params)){//校验自定义拦截事件并判断是否继续提交
(0,_globalUtil.verifyCustomRegisterEvent)(params,function(){//签字意见相关流程，相关文档
//暂时屏蔽接口
var needconfirm=commonParam.needconfirm,selectNextFlow=commonParam.selectNextFlow;var isNeedFlowFreeNodeTips=jundgeNeedFlowFreeNodeTips(src,needconfirm=='1',selectNextFlow);if((src=="intervenor"||commonParam.isremark==5)&&commonParam.openNodeCheck){//流程干预, 干预流程开启了合规校验
var content=React.createElement('p',null,React.createElement('span',null,(0,_convert.getLabel)(533651,'当前节点存在字段校验')),'(',React.createElement('span',{onClick:window.showRuleCompareResult,style:{color:'rgb(77, 122, 219)'}},React.createElement('span',{style:{cursor:'pointer'}},(0,_convert.getLabel)(533652,'查看详情'))),' )',React.createElement('span',null,(0,_convert.getLabel)(19990,"确认是否提交?")));(0,_convert.getAntd)().Modal.confirm({content:content,title:(0,_convert.getLabel)(131329,'信息确认'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){doFileUpload(params);},onCancel:function onCancel(){}});}else{if(actiontype=="remarkOperation"&&needconfirm=="1"||src=="intervenor"||isNeedFlowFreeNodeTips){var _content=(0,_convert.getLabel)(19990,"确认是否提交?");if(isNeedFlowFreeNodeTips){_content=getNeedFlowFreeNodeTips(params);}(0,_convert.getAntd)().Modal.confirm({content:_content,title:(0,_convert.getLabel)(131329,'信息确认'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){doFileUpload(params);},onCancel:function onCancel(){_base2.default.conformRuleStore.setHasCheckedConformRule(false);}});}else{//指定流转： 先走保存->需要校验 再提交-> 无需校验
//保存操作： 不做校验
//提交操作： 需校验
doFileUpload(params);}}});}};/**
 * 设置“提交到退回节点”的相关参数
 */var setParam4SubmitDirect=function setParam4SubmitDirect(){var globalStore=_base2.default.globalStore,secondAuthStore=_base2.default.secondAuthStore;var rightMenu=globalStore.rightMenu;var lastnodeid=rightMenu.lastnodeid;var isSubmitDirect=secondAuthStore.isSubmitDirect;if(isSubmitDirect==1){//说明是点击了"提交到退回节点"菜单/按钮
globalStore.changeSubmitParam({SubmitToNodeid:lastnodeid});}else{globalStore.setSubmitToNodeId();}};//提交的方法重新修改，提交时，先判断是否需要二次验证
var doFileUpload=exports.doFileUpload=function doFileUpload(params){var globalStore=_base2.default.globalStore,secondAuthStore=_base2.default.secondAuthStore;var submitParam=globalStore.submitParam;var workflowid=submitParam.workflowid,nodeid=submitParam.nodeid,requestid=submitParam.requestid,f_weaver_belongto_userid=submitParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=submitParam.f_weaver_belongto_usertype;var isAuthSuccess=secondAuthStore.isAuthSuccess,isProtectSuccess=secondAuthStore.isProtectSuccess;//已验证通过或者已数据保护通过
if(isAuthSuccess==1||isProtectSuccess==1){var isEnableAuth=secondAuthStore.isEnableAuth,secondAuthType=secondAuthStore.secondAuthType,isEnableProtect=secondAuthStore.isEnableProtect,protectType=secondAuthStore.protectType;var configParams=secondAuthStore.params;var authKey=configParams.authKey,_configParams$qysSign=configParams.qysSignWay,qysSignWay=_configParams$qysSign===undefined?2:_configParams$qysSign;//qysSignWay: 1,契约锁ukey签署，2，契约锁服务签署
if(isProtectSuccess!=1&&isEnableProtect==1){//仍然需要数据保护
if(protectType==authTypes.CA_AUTH||protectType==authTypes.QYS&&qysSignWay==1){//CA数据保护 或者 契约锁ukey
var isProtectDialog=1;//1表示打开的是CA数据保护的窗口
//先保存表单数据
var cakey=requestid+"_"+f_weaver_belongto_userid+"_"+f_weaver_belongto_usertype+"_"+new Date().getTime();globalStore.changeSubmitParam({isCAAuth:1,CAKey:cakey});secondAuthStore.setCAAuthData({isProtectDialog:isProtectDialog});secondAuthStore.saveDataToStorage(cakey);//将已经处理过的数据，存入localStorage
doFileUpload0(params);return;}else if(protectType==authTypes.QYS&&qysSignWay==2){//契约锁数据保护
var _isProtectDialog=1;//1表示打开的是契约锁数据保护的窗口
secondAuthStore.setCAAuthData({isProtectDialog:_isProtectDialog});//弹出验证或者数据保护的窗口
(0,_secondAuthUtil.showAuthDialog)(authTypes.SECOND_AUTH_DIALOG);return;}}//能运行到这里，说明已经做完了数据保护
if(isEnableProtect==1){if(protectType==authTypes.CA_AUTH||qysSignWay==1&&protectType==authTypes.QYS){globalStore.changeSubmitParam({authKey:authKey,isProtectSuccess:isProtectSuccess});}}//契约锁数据保护或者认证
if(protectType==authTypes.QYS||secondAuthType==authTypes.QYS){var authParams=secondAuthStore.params;var qysSealId=authParams.qysSealId,qysSealImg=authParams.qysSealImg,qysCertDetails=authParams.qysCertDetails;globalStore.changeSubmitParam({qysSealId:qysSealId,qysSealImg:qysSealImg,qysCertDetails:qysCertDetails,qysSignWay:qysSignWay});}globalStore.changeSubmitParam({protectType:protectType,secondAuthType:secondAuthType,isAuthSuccess:isAuthSuccess});//设置“提交到退回节点”的相关参数
var src=params.src,actiontype=params.actiontype;if(actiontype=="requestOperation"&&src=="submit"){setParam4SubmitDirect();}//验证签字意见，主要是需要将签字意见塞入到请求中，以及加入客户端的信息（ios，安卓等）
(0,_signUtil.verifyRemark)({'needCheck':true,'needPrompt':false});doFileUpload0(params);}else{//没有做过数据验证
var _src=params.src;(0,_secondAuth.getSecondAuthConfig)({workflowid:workflowid,nodeid:nodeid,requestid:requestid,src:_src}).then(function(data){//每个参数的数据都设置一个默认值，避免节点删除，取不到配置信息时会导致错误的问题
var _data$isEnableAuth=data.isEnableAuth,isEnableAuth=_data$isEnableAuth===undefined?0:_data$isEnableAuth,_data$secondAuthType=data.secondAuthType,secondAuthType=_data$secondAuthType===undefined?0:_data$secondAuthType,_data$isEnableProtect=data.isEnableProtect,isEnableProtect=_data$isEnableProtect===undefined?0:_data$isEnableProtect,_data$protectType=data.protectType,protectType=_data$protectType===undefined?0:_data$protectType,_data$qysSignWay=data.qysSignWay,qysSignWay=_data$qysSignWay===undefined?2:_data$qysSignWay,_data$authOperations=data.authOperations,authOperations=_data$authOperations===undefined?[]:_data$authOperations,_data$message=data.message,message=_data$message===undefined?"":_data$message,success=data.success;var _getAntd2=(0,_convert.getAntd)(),Modal=_getAntd2.Modal;if(success=="0"){if(!!message){Modal.warning({content:message,okText:(0,_convert.getLabel)(83446,'确定'),showClose:false});return;}}if((0,_secondAuthUtil.filterRequestAction)(params,submitParam,authOperations)){//判断流程的操作类型(提交、保存、退回等)是否需要二次提交验证
secondAuthStore.setDialogData({isEnableAuth:isEnableAuth,secondAuthType:secondAuthType,isEnableProtect:isEnableProtect,protectType:protectType});if(isEnableAuth==1){//二次认证
if(secondAuthType==authTypes.REAL_ID_AUTH){//真实身份认证
var reqParams={mouldCode:'WORKFLOW',// 模块名
itemCode:'NODE_SUBMIT',// 功能项,流程提交
requestid:requestid,workflowid:workflowid,nodeid:nodeid};//调用真实身份认证
window.doCheckSecondaryVerify4ec(reqParams,function(secondCheckResult){var secondAuthStatus=secondCheckResult.status;if(secondAuthStatus==='-1'){secondAuthStore.setIsSubmitDirect(0);return;}else{doFileUpload0(params);secondAuthStore.setSecondAuthPop();//表示当前流程已经成功进行过一次验证了
}});}else{secondAuthStore.setCallbackParam(params);secondAuthStore.setParams(data);if(isEnableProtect==1&&(secondAuthType==authTypes.CA_AUTH&&protectType==authTypes.CA_AUTH||secondAuthType==authTypes.QYS&&protectType==authTypes.QYS&&qysSignWay==1)){//如果同时还是CA数据保护或者 契约锁ukey签署
var _isProtectDialog2=10;//10表示打开的是 CA二次认证 + CA数据保护的窗口
//先保存流程表单的数据
var _cakey=requestid+"_"+f_weaver_belongto_userid+"_"+f_weaver_belongto_usertype+"_"+new Date().getTime();globalStore.changeSubmitParam({isCAAuth:1,CAKey:_cakey});secondAuthStore.setCAAuthData({isProtectDialog:_isProtectDialog2});secondAuthStore.saveDataToStorage(_cakey);//将已经处理过的数据，存入localStorage
doFileUpload0(params);return;}else if(secondAuthType==authTypes.QYS&&isEnableProtect==1&&protectType==authTypes.QYS&&qysSignWay==2){//如果同时还是契约锁数据保护
var _isProtectDialog3=10;//10表示打开的是 契约锁二次认证 + 契约锁数据保护的窗口
secondAuthStore.setCAAuthData({isProtectDialog:_isProtectDialog3});}//弹出验证或者数据保护的窗口
secondAuthStore.setCallbackFunc(doFileUpload);//运行到这，就说明认证的方式和数据保护的方式不一致，先做认证
if(secondAuthType==authTypes.QYS&&qysSignWay==1){window.QYSUKeyUtil.showSignWin(secondAuthStore);}else{(0,_secondAuthUtil.showAuthDialog)(authTypes.SECOND_AUTH_DIALOG);}}}else{//没有开启二次认证
if(isEnableProtect==1){secondAuthStore.setCallbackParam(params);secondAuthStore.setParams(data);//目前数据保护的方式只有2种：CA保护，契约锁保护
if(protectType==authTypes.CA_AUTH||protectType==authTypes.QYS&&qysSignWay==1){//CA认证的方式或者 契约锁ukey签署
var _isProtectDialog4=1;//1表示打开的是CA数据保护的窗口
//先保存流程表单的数据
var _cakey2=requestid+"_"+f_weaver_belongto_userid+"_"+f_weaver_belongto_usertype+"_"+new Date().getTime();globalStore.changeSubmitParam({isCAAuth:1,CAKey:_cakey2});secondAuthStore.setCAAuthData({isProtectDialog:_isProtectDialog4});secondAuthStore.saveDataToStorage(_cakey2);//将已经处理过的数据，存入localStorage
doFileUpload0(params);return;}else if(protectType==authTypes.QYS&&qysSignWay==2){//契约锁保护也需要弹出窗口
var _isProtectDialog5=1;//1表示打开的是契约锁数据保护的窗口
secondAuthStore.setCAAuthData({isProtectDialog:_isProtectDialog5});}//弹出验证或者数据保护的窗口
secondAuthStore.setCallbackFunc(doFileUpload);(0,_secondAuthUtil.showAuthDialog)(authTypes.SECOND_AUTH_DIALOG);}else{doFileUpload0(params);}}}else{doFileUpload0(params);}});}//二次验证完成
/*if (isAuthSuccess == 1) {
        const params0 = secondAuthStore.params;
        const {protectType} = params0;
        if (protectType == authTypes.CA_AUTH) {    //CA数据保护
            const {authKey} = params0;
            globalStore.changeSubmitParam({authKey, isAuthSuccess});
        }

        globalStore.changeSubmitParam({protectType});

        doFileUpload0(params);
    } else {
        getSecondAuthConfig({workflowid, nodeid, requestid}).then(data => {
            const {isEnableAuth, secondAuthType, isEnableProtect,protectType} = data;

            //如果CA保护数据，那么暂时认为数据验证也是CA
            if (isEnableProtect == 1 && protectType == authTypes.CA_AUTH) {
                let cakey = requestid + "_" + f_weaver_belongto_userid + "_" + f_weaver_belongto_usertype + "_" + new Date().getTime();
                globalStore.changeSubmitParam({isCAAuth: 1, CAKey: cakey});
                const {WeaTools} = getEcCom();
                const {ls} = WeaTools;
                ls.set(cakey, params);   //将流程提交的参数，存入localStorage
                doFileUpload0(params);
            } else if (isEnableAuth == 1) {     //如果只是二次认证，那么即使是CA认证，也是弹出窗口
                secondAuthStore.setCallbackFunc(doFileUpload);
                secondAuthStore.setCallbackParam(params);
                secondAuthStore.setParams(data);
                showAuthDialog(authTypes.SECOND_AUTH_DIALOG);
            } else {
                if(isEnableProtect == 1){
                    globalStore.changeSubmitParam({protectType});
                }
                doFileUpload0(params);
            }
        });
    }*/};//上传附件，上传完成后提交表单
var doFileUpload0=function doFileUpload0(params){var globalStore=_base2.default.globalStore,layoutStore=_base2.default.layoutStore;var btnDisabled=globalStore.btnDisabled,setBtnDisabled=globalStore.setBtnDisabled;if(btnDisabled){return false;}setBtnDisabled(true);globalStore.setLoading(true);if(typeof startUploadAll=="function"){startUploadAll();//上传附件
}var timer=setInterval(function(){//检测附件是否上传完成
var mainData=layoutStore.mainData,fieldAttrMap=layoutStore.fieldAttrMap;var uploadArr=new Array();mainData.forEach(function(fieldObj,k){var fieldid=k.substring(5);if(fieldAttrMap.has(fieldid)){var fieldAttr=fieldAttrMap.get(fieldid);var variable=fieldObj.variable;if(fieldAttr.htmltype===6&&variable.has("fileUploadStatus"))uploadArr.push(variable.get("fileUploadStatus"));}});var failedArr=uploadArr.filter(function(o){return o!=="uploaded";});//处理上传失败的情况
//正在上传中
var uploadingArr=uploadArr.filter(function(o){return o==="uploading";});//上传失败
var errorArr=uploadArr.filter(function(o){return o==="error";});if(uploadingArr.length===0&&errorArr.length>0){clearInterval(timer);setBtnDisabled(false);globalStore.setLoading(false);}if(failedArr.length===0){doSubmitPost(params);clearInterval(timer);}},100);};var ruleCheckConfirm=function ruleCheckConfirm(params,submitFunc){return new _promise2.default(function(resolve,reject){var _params$type2=params.type,type=_params$type2===undefined?'':_params$type2,_params$isaffirmance=params.isaffirmance,isaffirmance=_params$isaffirmance===undefined?'':_params$isaffirmance,_params$src=params.src,src=_params$src===undefined?'':_params$src,isaffirmanceSrc=params.isaffirmanceSrc;var _base$globalStore2=_base2.default.globalStore,_base$globalStore2$co=_base$globalStore2.commonParam,openNodeCheck=_base$globalStore2$co.openNodeCheck,isremark=_base$globalStore2$co.isremark,iscreate=_base$globalStore2$co.iscreate,setBtnDisabled=_base$globalStore2.setBtnDisabled,setLoading=_base$globalStore2.setLoading;var hasCheckedConformRule=_base2.default.conformRuleStore.hasCheckedConformRule;var needRuleCheckConfirm=openNodeCheck&&isremark=='0'&&src!='reject'&&src!='delete'&&(src=='save'&&isaffirmance=="1"&&isaffirmanceSrc!='reject'||src=='submit'&&!hasCheckedConformRule&&isremark!=5||type!='save'&&!hasCheckedConformRule&&isremark!=5||type=='ensuresubmit'&&!hasCheckedConformRule)||openNodeCheck&&iscreate=='1'&&type!='save'&&!hasCheckedConformRule;try{if(wfform&&wfform.getGlobalStore()&&wfform.getGlobalStore().submitParam&&wfform.getGlobalStore().submitParam.odocBtnFlag&&wfform.getGlobalStore().submitParam.odocBtnFlag=="odocReject"){needRuleCheckConfirm=false;}}catch(e){}if(needRuleCheckConfirm){//需要节点合规校验
(0,_conformRuleUtil.conformRule)(submitFunc);setBtnDisabled(false);setLoading(false);reject();}else{resolve();}});};//表单提交请求至后台
var doSubmitPost=exports.doSubmitPost=function doSubmitPost(params){LinkageControl.verifyLinkageFinished(function(){var submitFunc=function submitFunc(){var src=params.src,actiontype=params.actiontype,_params$isAddSign=params.isAddSign,isAddSign=_params$isAddSign===undefined?0:_params$isAddSign,saveCallFun=params.saveCallFun,needwfback=params.needwfback,saveType=params.saveType;delete params['saveCallFun'];(0,_signUtil.setRemarkContent)({isAddSign:isAddSign});var globalStore=_base2.default.globalStore,layoutStore=_base2.default.layoutStore;var browserVersion=globalStore.browserVersion,commonParam=globalStore.commonParam,submitParam=globalStore.submitParam,rightMenu=globalStore.rightMenu,changeSubmitParam=globalStore.changeSubmitParam,variableMap=globalStore.variableMap;var signatureAttributesStr=commonParam.signatureAttributesStr,signatureSecretKey=commonParam.signatureSecretKey,selectNextFlow=commonParam.selectNextFlow,openDataVerify=commonParam.openDataVerify,requestid=commonParam.requestid;var isFree=rightMenu.isFree;var formDatas=generateFormData();//表单字段参数
var remarkQuote=getRemarkQuoteData();var checkParams=null;var openDataVerifyTemp=openDataVerify;if(openDataVerifyTemp=='1'){checkParams=stepsToGetCfgFieldChanges();if(checkParams==null){openDataVerifyTemp='0';}}var allParams=(0,_objectAssign2.default)({},checkParams,submitParam,remarkQuote,params,formDatas,{src:src,signatureAttributesStr:signatureAttributesStr,signatureSecretKey:signatureSecretKey,selectNextFlow:selectNextFlow},{'openDataVerify':openDataVerifyTemp});if(isAddSign==1)allParams.selectNextFlow=0;if(requestid!=='-1'){allParams.requestid=requestid;}globalStore.setLoading(true);var submitBeginTime=new Date().getTime();API_REQ.reqOperate(actiontype,allParams).then(function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var interceptEventParams={src:src,actiontype:actiontype,result:result};globalStore.controlDialogVisible(type.CONFORM_RULE,false);//隐藏合规框
(0,_globalUtil.verifyCustomRegisterEvent)(_interface2.default.OPER_APIRETURN,(0,_asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var duration,propFileCfg,close_duration_storage,durationParams,data,_result$errorInfo,errorInfo,_result$errorType,errorType,_type,_data$resultInfo,resultInfo,_data$testParams,testParams,_requestid,doRefreshReq,doRemind,_resultInfo$isaffirma,isaffirmance,_resultInfo$isNextNod,isNextNodeOperator,_resultInfo$isShowCha,isShowChart,_resultInfo$isCAAuth,isCAAuth,_resultInfo$needRemin,needRemind,sendPage,msgcontent,controlVariableMap,_variableMap,needChooseOperator,ehnextnodeid,_getAntd3,Modal;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://记录耗时信息
duration=new Date().getTime()-submitBeginTime;propFileCfg=layoutStore.propFileCfg;close_duration_storage=propFileCfg.close_duration_storage;if(!commonParam.belongTest&&close_duration_storage!=1){//close_duration_storage=1时不记录耗时信息入库
try{durationParams={url:window.location.href,moduleType:6,clientType:browserVersion,allTc:duration,param:(0,_stringify2.default)(allParams)};API_REQ.writeDurationTimeInfo(durationParams);}catch(e){}}data=result.data,_result$errorInfo=result.errorInfo,errorInfo=_result$errorInfo===undefined?'系统错误，请联系管理员！':_result$errorInfo,_result$errorType=result.errorType,errorType=_result$errorType===undefined?'':_result$errorType;if(!data){_context.next=26;break;}_type=data.type,_data$resultInfo=data.resultInfo,resultInfo=_data$resultInfo===undefined?{}:_data$resultInfo,_data$testParams=data.testParams,testParams=_data$testParams===undefined?{}:_data$testParams;_requestid=parseInt(submitParam.requestid)<=0?resultInfo.requestid:submitParam.requestid;if(!(src==="submit"&&_type==="SUCCESS")){_context.next=11;break;}_context.next=11;return LinkageControl.setFormularErrorLog();case 11:if(!(params.continuationSwitchType&&src=="save"&&_type==="SUCCESS")){_context.next=14;break;}continuationProcessUtil.switchRequest(params.continuationSwitchType);return _context.abrupt('return');case 14:doRefreshReq=function doRefreshReq(){delete resultInfo.pcUrl;//刷新表单时需要去除掉自定义地址否则如果配置的自定义地址含路由地址会导致跳转异常
delete resultInfo.mobileUrl;var param={};if(resultInfo.isShowChart==3&&src=="intervenor"){param=(0,_extends3.default)({},testParams,resultInfo,{saveType:saveType,isintervenor:1});}else{param=(0,_extends3.default)({},testParams,resultInfo,{saveType:saveType});}//多个人同时操作表单,确认提交不会刷新页面,所以把isaffirmance设置为0
param=(0,_extends3.default)({},param,{isaffirmance:0});if(src=="intervenor"&&_type==="FAILD"){// 干预失败显示提示信息 并关闭页面
(0,_convert.getAntd)().Modal.warning({title:(0,_convert.getLabel)(15172,'系统提示'),content:React.createElement('div',{dangerouslySetInnerHTML:{__html:data.messageInfo?data.messageInfo.detail?data.messageInfo.detail:data.messageInfo.title:errorInfo}}),okText:(0,_convert.getLabel)(826,'确定'),onOk:function onOk(){Util.closeRequestPage(false,{requestid:_requestid});}});}else if(src=="save"){//保存后拦截事件
(0,_globalUtil.verifyCustomRegisterEvent)(_interface2.default.OPER_SAVECOMPLETE,function(){Util.reloadRequestPage(param,false);},result);}else{Util.reloadRequestPage(param,false);}};//编辑锁定保存操作关闭页面
if(!(actiontype=="requestOperation"&&src=="save"&&params.closePage===true)){_context.next=18;break;}Util.closeRequestPage(false,{requestid:_requestid});return _context.abrupt('return');case 18:if(!(actiontype=="requestOperation"&&src=="save"&&saveCallFun&&_type==="SUCCESS")){_context.next=21;break;}saveCallFun();return _context.abrupt('return');case 21:if(testParams.belongTest===true){try{window.parent.window.workflowAutoTestUtil.returnStatus(_type,_requestid);}catch(e){if(window.console)console.log(e);}}//更新操作信息
changeSubmitParam(data.submitParams);if(_type==="FAILD"){doRefreshReq();}else if(_type==="SUCCESS"){//关闭弹窗
closeAllDialog();//流程提醒
doRemind=function doRemind(reqId,callBack){var remindParams={};remindParams[_type2.HANDLE_REMIND]=true;remindParams[_type2.SUBMIT_TYPE]=src;remindParams['callBackActions']=callBack;globalStore.updateCommonParam('requestid',reqId);globalStore.batchControlVariableMap(remindParams);};_resultInfo$isaffirma=resultInfo.isaffirmance,isaffirmance=_resultInfo$isaffirma===undefined?'':_resultInfo$isaffirma,_resultInfo$isNextNod=resultInfo.isNextNodeOperator,isNextNodeOperator=_resultInfo$isNextNod===undefined?false:_resultInfo$isNextNod,_resultInfo$isShowCha=resultInfo.isShowChart,isShowChart=_resultInfo$isShowCha===undefined?'0':_resultInfo$isShowCha,_resultInfo$isCAAuth=resultInfo.isCAAuth,isCAAuth=_resultInfo$isCAAuth===undefined?'0':_resultInfo$isCAAuth,_resultInfo$needRemin=resultInfo.needRemind,needRemind=_resultInfo$needRemin===undefined?false:_resultInfo$needRemin;if(resultInfo.selectNextFlow=="1"&&(src!="save"||resultInfo.isaffirmance=="1")&&resultInfo.isaffirmanceSrc!='reject'&&src!='reject'){//用户选择下一节点流转
if(allParams.nodeid&&data.messageInfo&&(allParams.nodeid!=data.messageInfo.nodeIds||data.messageInfo.hasPassThisNode)&&!allParams.SubmitToNodeid){updateDetailKeyId(function(){showSelectNextFlowDialog(data);},data.insertDetailDatasInfo);}else{//能流转到下一节点才弹出流转设置弹框
//doSubmitReady({src: "submit", actiontype: "requestOperation", selectNextFlow: '1',selectNodeFlowNodeCanFlowNextNode:false});
updateDetailKeyId(function(){doSubmitReady({src:"submit",actiontype:"requestOperation",selectNextFlow:'1',selectNodeFlowNodeCanFlowNextNode:false});},data.insertDetailDatasInfo);}}else if(resultInfo.isaffirmance!="1"&&actiontype=="requestOperation"&&src=="save"||isNextNodeOperator||isCAAuth=="1"){//提交需确认
if(isNextNodeOperator&&needRemind){doRemind(_requestid,function(){doRefreshReq();});}else{doRefreshReq();}if(isNextNodeOperator)Util.reloadListPage();}else if(resultInfo.isaffirmance=="1"){if(isNextNodeOperator&&needRemind){doRemind(_requestid,function(){showEnsureSubitDialog(data);});}else{showEnsureSubitDialog(data);}if(isNextNodeOperator)Util.reloadListPage();}else{if(testParams.belongTest===true){//流程测试只刷页面
Util.reloadRequestPage(testParams,false);}else if(needRemind){doRemind(_requestid,function(){isShowChart==='1'&&Util.showChart({requestid:_requestid,sessionkey:resultInfo.sessionkey});isShowChart==='0'&&Util.closeRequestPage(false,{requestid:_requestid,source:"submit"});isShowChart==='3'&&doRefreshReq();});Util.reloadListPage();}else if(isShowChart==="1"){globalStore.setCloseNeedPrompt(false);//刷新流程图
Util.reloadListPage();Util.showChart({requestid:_requestid,sessionkey:resultInfo.sessionkey});}else if(isShowChart==="3"){globalStore.setCloseNeedPrompt(false);Util.reloadListPage({needReloadList:true});doRefreshReq();}else{Util.closeRequestPage(false,{requestid:_requestid,source:"submit"});}}}else if(_type==="SEND_PAGE"){//无权限
sendPage=data.sendPage;Util.gotoPage(sendPage,{requestid:_requestid});}else if(_type==="WF_LINK_TIP"){//出口提示
msgcontent=resultInfo.msgcontent||"";msgcontent=msgcontent.replace(/\\n/ig,"</br>");controlVariableMap=globalStore.controlVariableMap,_variableMap=globalStore.variableMap;controlVariableMap('wflinkTipOkCount',0);(0,_convert.getAntd)().Modal.confirm({content:React.createElement('div',{dangerouslySetInnerHTML:{__html:msgcontent}}),title:(0,_convert.getLabel)(131329,'信息确认'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){var wflinkTipOkCount=_variableMap.get('wflinkTipOkCount');if(wflinkTipOkCount==0){controlVariableMap('wflinkTipOkCount',1);changeSubmitParam({isFirstSubmit:1,requestid:resultInfo.requestid});doSubmitReady({src:src,actiontype:"requestOperation",needwfback:needwfback});}},onCancel:function onCancel(){doRefreshReq();_base2.default.conformRuleStore.setHasCheckedConformRule(false);//需要重新合规
}});}else if(_type==="R_CHROSE_OPERATOR"){//异常处理选人(后续替换)
needChooseOperator=resultInfo.needChooseOperator,ehnextnodeid=resultInfo.ehnextnodeid;if(needChooseOperator=="y")chooseExceptionOperator(ehnextnodeid);}else if(_type==="DELETE"){Util.reloadListPage();(0,_convert.getAntd)().Modal.warning({content:resultInfo.label,okText:(0,_convert.getLabel)(826,'确定'),title:(0,_convert.getLabel)(131329,'信息确认'),cancelText:(0,_convert.getLabel)(201,'取消'),showClose:false,onOk:function onOk(){Util.closeRequestPage(false,{source:"delete"});}});}else if(_type==="ASYNC_SUBMIT"){Util.closeRequestPage(false,{source:"submit"});}_context.next=27;break;case 26:if(errorType===''){_getAntd3=(0,_convert.getAntd)(),Modal=_getAntd3.Modal;Modal.error({content:errorInfo,okText:(0,_convert.getLabel)(826,'确定'),title:(0,_convert.getLabel)(15172,'系統提示')});}case 27:globalStore.setLoading(false);globalStore.setBtnDisabled(false);case 29:case'end':return _context.stop();}}},_callee,undefined);})),interceptEventParams);});};ruleCheckConfirm(params,submitFunc).then(submitFunc);});};var closeAllDialog=function closeAllDialog(){var controlDialogVisible=_base2.default.globalStore.controlDialogVisible;controlDialogVisible(type.FREE_WORKFLOW_SIMPLE,false);};//用户指定下一节点操作者
var showSelectNextFlowDialog=function showSelectNextFlowDialog(data){var selectNextFlowStore=_base2.default.selectNextFlowStore,globalStore=_base2.default.globalStore;var changeSubmitParam=globalStore.changeSubmitParam;var _data$testParams2=data.testParams,testParams=_data$testParams2===undefined?{}:_data$testParams2;var _getAntd4=(0,_convert.getAntd)(),message=_getAntd4.message;selectNextFlowStore.setBaseParams(globalStore.baseParam);var commonParam=globalStore.commonParam;if(commonParam.requestid==-1){commonParam.requestid=data.resultInfo.requestid;}selectNextFlowStore.setCommonParams(commonParam);selectNextFlowStore.setNextNodeIds(data.messageInfo.nodeIds);if(data.messageInfo.nodeIds){selectNextFlowStore.setCanFlowNextNode(true);}selectNextFlowStore.setConfirmEvent(function(nextNodeParams){changeSubmitParam(nextNodeParams);doSubmitForm({src:"submit",actiontype:"requestOperation",isSelectNextFlow:'1'});//if(testParams.belongTest === true) {
globalStore.controlDialogVisible(type.SELECT_NEXTFLOW,false);message.destroy();//}
});selectNextFlowStore.setCancelEvent(function(){Util.reloadRequestPage({requestid:data.resultInfo.requestid},true);globalStore.controlDialogVisible(type.SELECT_NEXTFLOW,false);});globalStore.controlDialogVisible(type.SELECT_NEXTFLOW,true);//需最后显示弹窗
};//提交需确认弹框
var showEnsureSubitDialog=function showEnsureSubitDialog(data){var ensureSubmitStore=_base2.default.ensureSubmitStore,globalStore=_base2.default.globalStore,smartGuessWfStore=_base2.default.smartGuessWfStore;var setPromptInfo=globalStore.setPromptInfo,controlDialogVisible=globalStore.controlDialogVisible;var _getAntd5=(0,_convert.getAntd)(),message=_getAntd5.message;globalStore.commonParam.requestid=data.submitParams.requestid;var commonParam=globalStore.commonParam;var srcSource=data.resultInfo&&data.resultInfo.isaffirmanceSrc||'submit';setPromptInfo(data.messageInfo);smartGuessWfStore.init((0,_extends3.default)({},commonParam,data.submitParams));//参数初始化
//打开窗口
var showDialogCallBack=function showDialogCallBack(){controlDialogVisible(type.ENSURE_SUBMIT,true);ensureSubmitStore.setConfirmEvent(function(){doSubmitForm({src:srcSource,actiontype:"requestOperation",type:'ensuresubmit'},function(){message.destroy();});//doSubmitForm({src: srcSource, actiontype: "requestOperation", type: 'ensuresubmit'});
globalStore.controlDialogVisible(type.ENSURE_SUBMIT,false);//message.destroy();
});ensureSubmitStore.setCancelEvent(function(){_base2.default.conformRuleStore.setHasCheckedConformRule(false);//需要重新合规
// Util.reloadRequestPage({requestid : data.resultInfo.requestid}, false);
globalStore.controlDialogVisible(type.ENSURE_SUBMIT,false);});};//保存表单后，需要将明细表的keyid同步回来，否则会出现明细重复保存的情况
updateDetailKeyId(showDialogCallBack,data.insertDetailDatasInfo);};//更新明细表的keyid
var updateDetailKeyId=function updateDetailKeyId(callback,dateilKeyDatas){var globalStore=_base2.default.globalStore,layoutStore=_base2.default.layoutStore;var commonParam=globalStore.commonParam;var detailMap=layoutStore.detailMap;var detailmark="";detailMap.keys().map(function(v){detailmark+=v+",";//已删除标示清除，解决提交确认表单修改日志记录多条
var detailObj=detailMap.get(v);detailObj&&(detailObj.deldtlid='');});if(detailmark!==""){detailmark=detailmark.substring(0,detailmark.length-1);}var needUpdate=commonParam.iscreate=='1';if(detailmark!==""&&!needUpdate){needUpdate=detailmark.split(",").some(function(detailMark){var detailObj=detailMap.get(detailMark);var rowInfo=detailObj.rowInfo,indexnum=detailObj.indexnum;return indexnum>0&&rowInfo.keys().some(function(rowkey){var rowData=rowInfo.get(rowkey);//存在无keyid的明细数据
return!rowData.get('keyid')||rowData.get('keyid')<=0;});});}if(detailmark!==""&&needUpdate){var shortRowKey=function shortRowKey(a,b){return a.substring(4)-b.substring(4);};detailMap.keys().map(function(detailKey){var idList=dateilKeyDatas[detailKey];var detailObj=detailMap.get(detailKey);var rowInfo=detailObj.rowInfo,indexnum=detailObj.indexnum;var existKeys=[];indexnum>0&&rowInfo.keys().sort(shortRowKey).map(function(rowkey,index){var rowData=mobx.toJS(rowInfo.get(rowkey));if((!rowData.keyid||rowData.keyid==0)&&existKeys.indexOf(rowData.keyid)==-1){layoutStore.detailMap.get(detailKey).rowInfo.get(rowkey).set('keyid',idList[index-existKeys.length]);}else{existKeys.push(rowData.keyid);}});});callback();}else{callback();}};//异常处理选择操作者弹窗
var chooseExceptionOperator=function chooseExceptionOperator(ehnextnodeid){var globalStore=_base2.default.globalStore,ehOperatorStore=_base2.default.ehOperatorStore;var changeSubmitParam=globalStore.changeSubmitParam,_globalStore$commonPa=globalStore.commonParam,commonParam=_globalStore$commonPa===undefined?{}:_globalStore$commonPa,_globalStore$secLevel=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel===undefined?{}:_globalStore$secLevel;ehOperatorStore.setBaseParams({ehnextnodeid:ehnextnodeid,requestid:commonParam.requestid,secLevel:secLevelInfo.secLevel});ehOperatorStore.setCallBackEvent(function(ehparams){globalStore.controlDialogVisible(_type2.CHOOSE_EXCEPTION_OPERATOR,false);changeSubmitParam(ehparams);doSubmitReady({src:"submit",actiontype:"requestOperation"});});globalStore.controlDialogVisible(_type2.CHOOSE_EXCEPTION_OPERATOR,true);};window.chooseExceptionOperator=chooseExceptionOperator;//校验自定义函数
var verifyCustomFun=exports.verifyCustomFun=function verifyCustomFun(src,isaffirmance){//post前调用公共方法
var ischeckok=true;// if(typeof(doBeforeReqSubmt) == "function"){
//     const { commonParam } = base.globalStore;
//     ischeckok = doBeforeReqSubmt(commonParam);
// }
//old
if(src==='submit'||isaffirmance==='1'){if(typeof checkCustomize=="function"){ischeckok=checkCustomize();}// if(typeof(checkCarSubmit) == "function"){
//     ischeckok = checkCarSubmit();
// }
}return ischeckok;};var verifyConflictField=function verifyConflictField(map){var conflictFieldInfo=_base2.default.globalStore.conflictFieldInfo;if(window.console){console.log(conflictFieldInfo);}for(var key in conflictFieldInfo){if(map.has(key)){if(window.console){console.log(map.get(key));}if(map.get(key).hasConfirm)continue;return false;}}return true;};//干预提交验证
var verifyIntervenorInfo=exports.verifyIntervenorInfo=function verifyIntervenorInfo(submitParam){var _submitParam$submitNo=submitParam.submitNodeId,submitNodeId=_submitParam$submitNo===undefined?'':_submitParam$submitNo,_submitParam$Interven=submitParam.Intervenorid,Intervenorid=_submitParam$Interven===undefined?'':_submitParam$Interven,_submitParam$Interven2=submitParam.Intervenorid_crm,Intervenorid_crm=_submitParam$Interven2===undefined?'':_submitParam$Interven2;var result={type:1};if(_.trim(submitNodeId).length===0){result.type=0;result.msg=(0,_convert.getLabel)(386188,'"流转至节点"未填写');}if(_.trim(Intervenorid).length===0&&_.trim(Intervenorid_crm).length===0){result.type=0;result.msg=(0,_convert.getLabel)(386189,'"流转至节点操作者"未填写');}return result;};//提交校验必须新增明细
var verifyMustAddDetail=exports.verifyMustAddDetail=function verifyMustAddDetail(){var needAddDetailMark="";var detailMap=_base2.default.layoutStore.detailMap;detailMap.forEach(function(detailObj,detailMark){var attr=detailObj.attr,rowInfoArr=detailObj.rowInfoArr;if(attr.isadd===1&&attr.isneed===1&&rowInfoArr.length===0&&needAddDetailMark===""){var detailIndex=parseInt(detailMark.replace("detail_",""))-1;var detailLocTr=window.jQuery("#oTable"+detailIndex).closest(".wf-detail").closest("tr");if(detailLocTr.length>0&&detailLocTr.css("display")!=="none"){needAddDetailMark=detailMark;return false;}}});if(needAddDetailMark!==""){Util.showPrompt(needAddDetailMark,3);return false;}else return true;};//提交校验字段必填范围
var verifyRequiredEmptyField=exports.verifyRequiredEmptyField=function verifyRequiredEmptyField(){var emptyField="";var _base$layoutStore2=_base2.default.layoutStore,fieldAttrMap=_base$layoutStore2.fieldAttrMap,cellInfo=_base$layoutStore2.cellInfo,mainData=_base$layoutStore2.mainData,detailMap=_base$layoutStore2.detailMap,variableMap=_base$layoutStore2.variableMap;//联动隐藏行中的其它字段，忽略校验必填
var ignoreVerifyRange=[];var reg=/^field\d+_viewAttr$/;variableMap.forEach(function(v,k){if(reg.test(k)){var fieldid=k.match(/\d+/)[0];if(v===4){//隐藏内容
ignoreVerifyRange.push(fieldid);}else if(v===5){//隐藏行
var rowMark=_.get(cellInfo,["fieldCellInfo",fieldid,"rowMark"]);rowMark&&rowMark.split(",").forEach(function(item){var rowFields=_.get(cellInfo,["mainRowFields",item])||[];ignoreVerifyRange=ignoreVerifyRange.concat(rowFields);});}}});//计算明细需要校验的行号
var detailVerifyRowIndexStr={};detailMap.forEach(function(detailObj,detailMark){var attr=detailObj.attr,rowInfo=detailObj.rowInfo;var rowIndexStr="";rowInfo.forEach(function(v,k){var keyid=v.has("keyid")?parseInt(v.get("keyid")):-1;if(keyid<=0||keyid>0&&attr.isedit===1)rowIndexStr+=k.substring(4)+",";});if(rowIndexStr!=="")rowIndexStr=rowIndexStr.substring(0,rowIndexStr.length-1);detailVerifyRowIndexStr[detailMark]=rowIndexStr;});//校验必填字段的范围
var verifyRange=[];var verifyRequiredRange="field-9999,";var fieldCellInfo=cellInfo.fieldCellInfo||{};_.forIn(fieldCellInfo,function(v,fieldid){var orderid=v.orderid||0;if(!fieldAttrMap.has(fieldid))return true;var fieldAttr=fieldAttrMap.get(fieldid);var isDetail=fieldAttr.isDetail;var tableMark=fieldAttr.tableMark;var htmltype=fieldAttr.htmltype,detailtype=fieldAttr.detailtype;//Check框等类型、联动隐藏的行字段不校验必填
if(htmltype===4||htmltype===7||htmltype===8||htmltype===9||fieldid==="-9"||!isDetail&&_.indexOf(ignoreVerifyRange,fieldid)>-1)return"";//附件上传未设置固定目录的不校验必填
if(htmltype===6&&_.get(fieldAttr,["fileattr","catelogType"])===0&&_.trim(_.get(fieldAttr,["fileattr","docCategory"]))==="")return"";//主字段，API隐藏的区域内字段不校验必填，兼容E8
if(!isDetail&&jQuery('.field'+fieldid+'_swapDiv').length>0){var fieldSwapObj=jQuery('.field'+fieldid+'_swapDiv');if(fieldSwapObj.is(".filter_required")||fieldSwapObj.closest("tr").is(".filter_required"))return"";}var rowIndexStr=isDetail?detailVerifyRowIndexStr[tableMark]:"-1";!!rowIndexStr&&rowIndexStr.split(",").map(function(rowIndex){var fieldMark=isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;var fieldObj=FieldUtil.getFieldObj(fieldMark,tableMark);var variable=fieldObj.variable;var needVerify=false;if(variable.has("viewAttr")&&variable.get("viewAttr")>0){//显示属性联动控制必填
needVerify=variable.get("viewAttr")===3;}else{needVerify=fieldAttr.viewattr===3;}if(needVerify){verifyRange.push({fieldid:fieldid,rowIndex:rowIndex,orderid:orderid+parseInt(isDetail?rowIndex:0),fieldObj:fieldObj,fieldAttr:fieldAttr});verifyRequiredRange+=fieldMark+',';}});});verifyRange=verifyRange.sort(function(a,b){return a.orderid-b.orderid;});_base2.default.globalStore.changeSubmitParam({verifyRequiredRange:verifyRequiredRange});//根据范围依次校验值是否填写
var emptyTableMark="";var emptyRowIndex="";for(var i=0;i<verifyRange.length;i++){var _verifyRange$i=verifyRange[i],fieldid=_verifyRange$i.fieldid,rowIndex=_verifyRange$i.rowIndex,fieldObj=_verifyRange$i.fieldObj,fieldAttr=_verifyRange$i.fieldAttr;var htmltype=fieldAttr.htmltype,detailtype=fieldAttr.detailtype,isDetail=fieldAttr.isDetail,tableMark=fieldAttr.tableMark;var fieldMark=isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;var fieldValue=fieldObj.value;if(fieldid==-4){fieldValue=window.CK_REF.remark.getData()||"";}else if(fieldid==-10){fieldValue=(0,_secLevelUtil.getSecAndValidity)();if(fieldValue.includes("#")&&fieldValue.endsWith("#"))fieldValue="";}else if(htmltype===2&&detailtype===2){if(window.FORM_CK_REF&&window.FORM_CK_REF['field'+fieldid]){fieldValue=window.FORM_CK_REF['field'+fieldid].getData()||"";fieldValue=fieldValue.replace(/<p>/ig,'').replace(/<\/p>/ig,'').replace(/ /ig,"").replace(/&nbsp;/ig,"").replace(/<br \/>/ig,"");}}else if(htmltype===6&&detailtype===1){//附件上传字段值排掉-1 认为未填写
if(fieldValue==='-1')fieldValue='';}fieldValue=_.trim(fieldValue);if(fieldValue===""){emptyField=fieldMark;emptyTableMark=tableMark;emptyRowIndex=rowIndex;break;}}//明细字段分页情况需跳转至指定页
if(emptyTableMark.indexOf("detail")>-1){var detailObj=DetailUtil.getDetailObj(emptyTableMark);detailObj.jumpPageByRowIndex(emptyRowIndex);}return emptyField;};//除表单字段外提交表单时的必填校验
var verifyRequiredEmptyOtherParams=exports.verifyRequiredEmptyOtherParams=function verifyRequiredEmptyOtherParams(){var _base$globalStore3=_base2.default.globalStore,commonParam=_base$globalStore3.commonParam,submitParam=_base$globalStore3.submitParam;var showFreeWfSimpleCom=commonParam.showFreeWfSimpleCom;var obj={};if(showFreeWfSimpleCom!=0){var _base$freeWflowSimple=_base2.default.freeWflowSimpleStore.conditionData,conditionData=_base$freeWflowSimple===undefined?{}:_base$freeWflowSimple;//判断节点操作者是否必填
var isMustInput=false;var _conditionData$condit=conditionData.conditioninfo,conditioninfo=_conditionData$condit===undefined?[]:_conditionData$condit;if(conditioninfo[0]){var _conditioninfo$0$item=conditioninfo[0].items,items=_conditioninfo$0$item===undefined?[]:_conditioninfo$0$item;items.map(function(item){if(item.domkey[0]==="nodeOperator"&&item.viewAttr==3)isMustInput=true;});if(Number(submitParam.isToNewAddSign)<2&&submitParam.operatorids==""&&isMustInput){obj.scrollDom='.wf-req-freeWorkflowSimple';obj.msg=(0,_convert.getLabel)(512971,"请选择节点操作者");}}}return obj;};//验证流程标题必填
var verifyRequestNameIsEmpty=exports.verifyRequestNameIsEmpty=function verifyRequestNameIsEmpty(){var mainData=_base2.default.layoutStore.mainData;var fieldValue=mainData.has("field-1")?mainData.get("field-1").value:"";return _.trim(fieldValue)==="";};//验证流程密级必填
var verifySecLevelIsEmpty=exports.verifySecLevelIsEmpty=function verifySecLevelIsEmpty(){var _base$globalStore$sec2=_base2.default.globalStore.secLevelInfo,secLevelInfo=_base$globalStore$sec2===undefined?{}:_base$globalStore$sec2;var secLevel=secLevelInfo.secLevel,secValidity=secLevelInfo.secValidity;if(_.trim(secLevel)===""){return true;}else if((secLevel==1||secLevel==2)&&_.trim(secValidity)===""){return true;}return false;};//验证流程期限格式
var verifySecLevelIsFormat=exports.verifySecLevelIsFormat=function verifySecLevelIsFormat(){var _base$layoutStore3=_base2.default.layoutStore,fieldAttrMap=_base$layoutStore3.fieldAttrMap,cellInfo=_base$layoutStore3.cellInfo;var _base$globalStore$sec3=_base2.default.globalStore.secLevelInfo,secLevelInfo=_base$globalStore$sec3===undefined?{}:_base$globalStore$sec3;var secLevel=secLevelInfo.secLevel,secValidity=secLevelInfo.secValidity;var secLevelViewAttr=fieldAttrMap.has("-10")&&fieldAttrMap.get("-10").viewattr||0;var canEdit=secLevelInfo.canSecChange&&secLevelViewAttr>1?3:1;if(_.has(cellInfo,["fieldCellInfo","-10"])&&canEdit&&(secLevel==1||secLevel==2)&&secValidity&&/^\d*$/ig.test(_.trim(secValidity))){return true;}return false;};//生成表单字段提交参数
var generateFormData=exports.generateFormData=function generateFormData(){var datas={};var mainFieldUnEmptyCount=0;var detailFieldUnEmptyCount=0;var _base$layoutStore4=_base2.default.layoutStore,fieldAttrMap=_base$layoutStore4.fieldAttrMap,mainData=_base$layoutStore4.mainData,detailMap=_base$layoutStore4.detailMap,existChangeRange=_base$layoutStore4.existChangeRange;var uniqueExistChangeRange=[].concat((0,_toConsumableArray3.default)(new _set2.default(existChangeRange)));datas.existChangeRange=uniqueExistChangeRange.join(",");mainData.forEach(function(fieldObj,k){var fieldid=k.substring(5);var fieldname=FieldUtil.convertSystemFieldName(k);if(window.FORM_CK_REF&&window.FORM_CK_REF[fieldname]){//富文本
if(!!window.FORM_CK_REF[fieldname])datas[fieldname]=window.FORM_CK_REF[fieldname].getData();else datas[fieldname]=fieldObj.value;}else{addCustomizeBrowserNames(datas,fieldAttrMap,fieldid,fieldObj,-1);datas[fieldname]=fieldObj.value;}if(parseInt(fieldid)>0&&datas[fieldname]!="")mainFieldUnEmptyCount++;//多人力分组信息
if(fieldAttrMap.has(k.substring(5))){var fieldAttr=fieldAttrMap.get(k.substring(5));if(fieldAttr.htmltype===3&&fieldAttr.detailtype===17){var groupInfo=FieldUtil.buildMultiUserGroupInfo(fieldObj);var groupnum=groupInfo.groupnum;for(var i=0;i<groupnum;i++){if('group_'+i in groupInfo)datas[fieldname+'group'+i]=groupInfo['group_'+i];}datas[fieldname+'groupnum']=groupnum;}}});datas["field-10"]=(0,_secLevelUtil.getSecAndValidity)();var detailFieldDatas={};//request请求参数个数有限制，重要参数往前提
detailMap.forEach(function(detailObj,detailMark){var detailIndex=parseInt(detailMark.substring(7))-1;var indexnum=detailObj.indexnum,deldtlid=detailObj.deldtlid,detailData=detailObj.detailData,rowInfo=detailObj.rowInfo,fieldInfo=detailObj.fieldInfo;var submitidArr=new Array();var nodesnum=0;rowInfo.forEach(function(info,rowKey){nodesnum++;var rowIndex=rowKey.substring(4);submitidArr.push(rowIndex);if(info.has("keyid"))datas['dtl_id_'+detailIndex+'_'+rowIndex]=info.get("keyid");_.forIn(fieldInfo,function(v,fieldid){var fieldMark='field'+fieldid+'_'+rowIndex;if(detailData.has(fieldMark)){var fieldObj=detailData.get(fieldMark);var fieldValue=fieldObj.value;detailFieldDatas[fieldMark]=fieldValue;if(fieldValue!="")detailFieldUnEmptyCount++;addCustomizeBrowserNames(detailFieldDatas,fieldAttrMap,fieldid,fieldObj,rowIndex);}});});datas['nodesnum'+detailIndex]=nodesnum;datas['indexnum'+detailIndex]=indexnum;var submitdtlid="";submitidArr.sort(function(a,b){return parseInt(a)-parseInt(b);}).map(function(_id){submitdtlid+=_id+",";});datas['submitdtlid'+detailIndex]=submitdtlid;datas['deldtlid'+detailIndex]=deldtlid;});datas.mainFieldUnEmptyCount=mainFieldUnEmptyCount;datas.detailFieldUnEmptyCount=detailFieldUnEmptyCount;return(0,_extends3.default)({},datas,detailFieldDatas);};var addCustomizeBrowserNames=function addCustomizeBrowserNames(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fieldAttrMap=arguments[1];var fieldid=arguments[2];var fieldObj=arguments[3];var rowIndex=arguments.length>4&&arguments[4]!==undefined?arguments[4]:-1;var fieldAttr=fieldAttrMap.get(fieldid);if(fieldAttr){if(fieldAttr.htmltype===3&&(fieldAttr.detailtype===161||fieldAttr.detailtype===162)){var specialobj=fieldObj.specialobj||[];if(specialobj&&specialobj.length>0){var namesplitstr='##~~@@~~##';var fieldnameArr=[];specialobj.forEach(function(vObj,index){fieldnameArr.push(vObj.name);});var key='field'+fieldid+'name';if(rowIndex>-1)key='field'+fieldid+'_'+rowIndex+'name';datas[key]=fieldnameArr.join(namesplitstr);}}}};//生成自由流程提交参数
var generateFreeNodeData=exports.generateFreeNodeData=function generateFreeNodeData(isFree){var freeNodeInfo={};if(isFree=="1"){jQuery('.freeNode').find('input').map(function(o,k){freeNodeInfo[k.name]=k.value;});}return freeNodeInfo;};var getRemarkQuoteData=exports.getRemarkQuoteData=function getRemarkQuoteData(){var _base$globalStore4=_base2.default.globalStore,submitParam=_base$globalStore4.submitParam,variableMap=_base$globalStore4.variableMap,dialogVisible=_base$globalStore4.dialogVisible;var remark=submitParam.remark||'';var remarkList=mobx.toJS(variableMap.get('remark_list')||{});if(dialogVisible.has(type.FREE_WORKFLOW_SIMPLE)&&dialogVisible.get(type.FREE_WORKFLOW_SIMPLE)){remarkList=mobx.toJS(variableMap.get('remark_list_freeWorkflowSimple')||{});}var remarkQuoteData=[];_.forIn(remarkList,function(v,k){remarkQuoteData.push(v);});var remarkTemp=remarkQuoteData.length>0?remarkQuoteData.join('')+"\n"+remark:remark;var updateParams={remark:remarkTemp};var remarkquoteSeparator='~~@#@$#$@#@~~';var remarkquote=remark;if(remarkQuoteData&&remarkQuoteData.length>0){remarkquote+=remarkquoteSeparator+remarkQuoteData.join('~~~~@@@@~~~~@@@@@~~~~');}return{remark:remarkTemp,remarkquote:remarkquote};};/**
 * 主干节点提交时确认是否走分支
 * @param params
 * @return {*}
 */var getNeedFlowFreeNodeTips=function getNeedFlowFreeNodeTips(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var changeSubmitParam=_base2.default.globalStore.changeSubmitParam;changeSubmitParam({'flowToNextFreeNode':'0'});var _getAntd6=(0,_convert.getAntd)(),Radio=_getAntd6.Radio;var RadioGroup=Radio.Group;return React.createElement('div',null,React.createElement('div',null,(0,_convert.getLabel)(507410,'请选择流转路径')+':'),React.createElement('div',{style:{'marginTop':'10px'}},React.createElement(RadioGroup,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_RadioGroup@thusyj',onChange:function onChange(e){return changeSubmitParam({'flowToNextFreeNode':e.target.value});},defaultValue:'0'},React.createElement(Radio,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Radio@1f0s3u',value:'0'},(0,_convert.getLabel)(507411,'流转至下一节点')),React.createElement(Radio,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Radio@o2uufy',value:'1'},(0,_convert.getLabel)(507412,'进入加签环节')))));};var jundgeNeedFlowFreeNodeTips=function jundgeNeedFlowFreeNodeTips(src){var needconfirm=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var selectNextFlow=arguments[2];if(selectNextFlow=='1')return false;var needTips=src=='submit'&&!needconfirm||src=='save'&&needconfirm;if(!needTips)return false;var _base$globalStore5=_base2.default.globalStore,commonParam=_base$globalStore5.commonParam,variableMap=_base$globalStore5.variableMap,submitParam=_base$globalStore5.submitParam;var _commonParam$isNeedFl=commonParam.isNeedFlowFreeNodeTips,isNeedFlowFreeNodeTips=_commonParam$isNeedFl===undefined?false:_commonParam$isNeedFl;var _submitParam$SubmitTo=submitParam.SubmitToNodeid,SubmitToNodeid=_submitParam$SubmitTo===undefined?'':_submitParam$SubmitTo;//提交至退回节点
if(SubmitToNodeid>0||SubmitToNodeid<-1){return false;}//流程图保存后返回的实时参数
if(variableMap.has('isNeedFlowFreeNodeTips')){isNeedFlowFreeNodeTips=variableMap.get('isNeedFlowFreeNodeTips');}if(isNeedFlowFreeNodeTips&&variableMap.has('wflinkTipOkCount')){isNeedFlowFreeNodeTips=variableMap.get('wflinkTipOkCount')==0;}return isNeedFlowFreeNodeTips;};/**
 * 获取配置字段的变更步骤
 */var stepsToGetCfgFieldChanges=function stepsToGetCfgFieldChanges(){var res={};try{var cfgMap=_base2.default.globalStore.commonParam.wfFormFieldChangeCfg;var _wfform=window.wfform;var modeid=_wfform.getGlobalStore().commonParam.modeid;var checkParams=[];for(var i=0;i<cfgMap.length;i++){var _wfform$getFieldInfo=_wfform.getFieldInfo(cfgMap[i].fieldid),isDetail=_wfform$getFieldInfo.isDetail,tableMark=_wfform$getFieldInfo.tableMark,viewattr=_wfform$getFieldInfo.viewattr;var controlType=cfgMap[i].type;if(!isDetail){var stepInfo=(0,_analyzeData.getFieldStepInfo)(cfgMap[i].fieldid);var linkageInfo=(0,_analyzeData.getLinkageInfo)([cfgMap[i].fieldid]);var firstStepData=(0,_analyzeData.getFirstStepData)(stepInfo,isDetail);var lastStepData=(0,_analyzeData.getLastStepData)(stepInfo,isDetail);var checkInfo={};checkInfo['fieldId']=parseInt(cfgMap[i].fieldid);checkInfo['linkageCfgInfo']=linkageInfo;checkInfo['firstStepData']=firstStepData;checkInfo['lastStepData']=lastStepData;checkInfo['stepInfo']=stepInfo;checkInfo['dbViewAttr']=viewattr;checkInfo['isDetail']=isDetail;checkInfo['controlType']=controlType;/**
                 * 保留明细字段字段过滤接口
                 *//*if (isDetail) {
                    let detailRows = wfform.getDetailRowCount(tableMark);
                    if (detailRows > 0) {
                        //有明细的情况下字段属性取第一行的属性
                        checkInfo['fieldCurAttr'] = wfform.getFieldCurViewAttr("field" + cfgMap[i].fieldid + "_0");
                    } else {
                        checkInfo['fieldCurAttr'] = -1;
                    }
                } else {
                    checkInfo['fieldCurAttr'] = wfform.getFieldCurViewAttr("field" + cfgMap[i].fieldid);
                }*/checkInfo['fieldCurAttr']=_wfform.getFieldCurViewAttr("field"+cfgMap[i].fieldid);checkParams.push(checkInfo);}}res['checkParamsStr']=(0,_stringify2.default)({checkParamsArr:checkParams});//参数加密
res['checkSecret']=__WEAVEREncrypt__.getKey();res.checkParamsStr=__WEAVEREncrypt__.weaver_encrypt(res.checkParamsStr);//添加模板id
res['modeId']=modeid;return res;}catch(e){if(window.console){console.log("数据过滤或加密异常...");}return null;}};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.handWritingHander=exports.convertSpecialChar=exports.needMustInputDot=exports.verifyRemarkMustInput=exports.chekcremark=exports.signMustInputTips=exports.appendDefaultSytle=exports.setRemarkContent=exports.verifyRemark=undefined;var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _convert=__webpack_require__(6);var _trim=__webpack_require__(112);var _trim2=_interopRequireDefault(_trim);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//校验签字意见并提示
var verifyRemark=exports.verifyRemark=function verifyRemark(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _params$needCheck=params.needCheck,needCheck=_params$needCheck===undefined?false:_params$needCheck,_params$src=params.src,src=_params$src===undefined?'':_params$src,_params$needPrompt=params.needPrompt,needPrompt=_params$needPrompt===undefined?true:_params$needPrompt,_params$isaffirmance=params.isaffirmance,isaffirmance=_params$isaffirmance===undefined?'0':_params$isaffirmance,_params$actiontype=params.actiontype,actiontype=_params$actiontype===undefined?'':_params$actiontype,isAddSign=params.isAddSign,isaffirmanceSrc=params.isaffirmanceSrc;var _base$globalStore=_base2.default.globalStore,commonParam=_base$globalStore.commonParam,markInfo=_base$globalStore.markInfo,submitParam=_base$globalStore.submitParam,changeSubmitParam=_base$globalStore.changeSubmitParam,setTabKey=_base$globalStore.setTabKey,tabKey=_base$globalStore.tabKey;var intervenorright=commonParam.intervenorright,isHideInput=commonParam.isHideInput;var isSignMustInput=markInfo.isSignMustInput,isFormSignature=markInfo.isFormSignature,signMustInputTypes=markInfo.signMustInputTypes;var needVeiryRequired=false;if(isHideInput!="1"||intervenorright>0){if(!needCheck)needCheck=!(src=='save'&&actiontype=='requestOperation')||isaffirmance=="1";if(isSignMustInput=="1"&&needCheck||isSignMustInput=='2'&&verifyRemarkMustInput(src,actiontype,needCheck,isaffirmanceSrc))needVeiryRequired=true;}//保存签章及验证必填
if(isFormSignature=="1"){return saveFormSignature(needVeiryRequired);}var CKHasLoad=!!(window.CK_REF&&window.CK_REF.remark);var CKHasLoad_freeWfSimple=!!(window.CK_REF&&window.CK_REF.freeWorkflowSimple);//验证签字意见必填
var result=setRemarkContent({isAddSign:isAddSign,needVeiryRequired:needVeiryRequired});if(result===false&&needPrompt){//直接提示签字意见未填写
var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;message.warning((0,_convert.getLabel)(386186,'"签字意见"未填写'),2);if(window.wfform.getOdocConfig().docFlag&&tabKey=='odoc'){//正文页签下隐藏插件并返回表单
setTabKey("form");var contentDiv=jQuery(".wea-new-top-req-content");contentDiv.css("overflow-y","hidden");jQuery(".wf-req-odoc").height(1);var marginTop=parseInt(jQuery(".wf-req-odoc").css('fontSize').replace('px',''),10);marginTop=marginTop>0?marginTop=(marginTop+1)*-1:-13;jQuery(".wf-req-odoc").css('marginTop',marginTop+'px');jQuery(".wf-req-odoc").css('marginBottom','0px');jQuery(".req-workflow-odoc").height(1);showOrHideWeboffice(0);}if(CKHasLoad&&isAddSign!=1){var controlVariableMap=_base2.default.globalStore.controlVariableMap;controlVariableMap('isShowSignInput',true);controlVariableMap('isEditorFocus',true);signMustInputTips();}}return result;};/**
 * 更新意见内容到submitParams
 * @param params
 * @return {boolean}
 */var setRemarkContent=exports.setRemarkContent=function setRemarkContent(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _base$globalStore2=_base2.default.globalStore,commonParam=_base$globalStore2.commonParam,changeSubmitParam=_base$globalStore2.changeSubmitParam,submitParam=_base$globalStore2.submitParam;var intervenorright=commonParam.intervenorright,isHideInput=commonParam.isHideInput;var result=true;if(isHideInput!="1"||intervenorright>0){var isAddSign=params.isAddSign,_params$needVeiryRequ=params.needVeiryRequired,needVeiryRequired=_params$needVeiryRequ===undefined?false:_params$needVeiryRequ;var CKHasLoad=!!(window.CK_REF&&window.CK_REF.remark);var CKHasLoad_freeWfSimple=!!(window.CK_REF&&window.CK_REF.freeWorkflowSimple);var remarkContent=CKHasLoad?window.CK_REF.remark.getData():submitParam.remark;if(isAddSign==1)remarkContent=CKHasLoad_freeWfSimple?window.CK_REF.freeWorkflowSimple.getData():submitParam.remark;if(needVeiryRequired){result=chekcremark(remarkContent);}if(result&&CKHasLoad){var _remark=appendDefaultSytle(remarkContent);changeSubmitParam({remark:_remark});}}return result;};//提交保存签章
var saveFormSignature=function saveFormSignature(needVeiryRequired){var changeSubmitParam=_base2.default.globalStore.changeSubmitParam;var result=true;var _getAntd2=(0,_convert.getAntd)(),message=_getAntd2.message;if((0,_typeof3.default)(window.saveAutographMul)==="object"){var requestlogid="";if(window.saveAutographMul&&window.saveAutographMul.wfWeaAutographCompremark){requestlogid=window.saveAutographMul.wfWeaAutographCompremark(needVeiryRequired);}if(requestlogid===true||requestlogid==-1&&needVeiryRequired==false){result=true;}else if(!isNaN(requestlogid)&&parseInt(requestlogid)>0){changeSubmitParam({workflowRequestLogId:requestlogid});}else{if(requestlogid=="-2")message.warning((0,_convert.getLabel)(386186,'"签字意见"未填写'),2);else message.warning((0,_convert.getLabel)(528568,"签章保存失败"),2);result=false;}}else{message.warning((0,_convert.getLabel)(528569,"签章组件未加载成功"));result=false;}return result;};/**
 * 设置默认字体
 */var appendDefaultSytle=exports.appendDefaultSytle=function appendDefaultSytle(){var _remark=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';if(_remark){var preReg=new RegExp(/^<div id=\"wea_rich_text_default_font\"[^>]+\>/);if(preReg.test(_remark))return _remark;var _base$globalStore$mar=_base2.default.globalStore.markInfo,markInfo=_base$globalStore$mar===undefined?{}:_base$globalStore$mar;var _markInfo$extendParam=markInfo.extendParams,extendParams=_markInfo$extendParam===undefined?{}:_markInfo$extendParam,_markInfo$use_textare=markInfo.use_textarea_signinput,use_textarea_signinput=_markInfo$use_textare===undefined?0:_markInfo$use_textare;var _extendParams$wfSignD=extendParams.wfSignDefaultFontFamily,wfSignDefaultFontFamily=_extendParams$wfSignD===undefined?'':_extendParams$wfSignD,_extendParams$wfSignD2=extendParams.wfSignDefaultFontSize,wfSignDefaultFontSize=_extendParams$wfSignD2===undefined?'':_extendParams$wfSignD2;//设置
var defaultStyle='';if(wfSignDefaultFontFamily&&wfSignDefaultFontFamily.indexOf('/')>-1){defaultStyle+='font-family:'+wfSignDefaultFontFamily.split('/')[1]+';';}if(wfSignDefaultFontSize&&wfSignDefaultFontSize.indexOf('/')>-1){defaultStyle+='font-size:'+wfSignDefaultFontSize.split('/')[1]+';';}if(defaultStyle){if(use_textarea_signinput==1){_remark='<span id="wea_rich_text_default_font" style="'+defaultStyle+'">'+_remark+'</span>';}else{_remark='<div id="wea_rich_text_default_font" style="'+defaultStyle+'">'+_remark+'</div>';}}}return _remark;};//签字意见获取光标，并滚动签字意见框到可视区域
var signMustInputTips=exports.signMustInputTips=function signMustInputTips(){//处理意见在表单和不在表单问题
var remarktop=parseInt(jQuery("#remark").offset().top);if(remarktop==0&&jQuery(".wf-req-sign-input")){remarktop=parseInt(jQuery(".wf-req-sign-input").offset().top);}var scrolltop=0;var scrollDom=jQuery('.wf-req-form-scroll');var topDom=jQuery('.wea-new-top-req');//判断意见框是否在可视区域
var isVisual=remarktop>0&&remarktop-topDom.height()+200<scrollDom.height();if(!isVisual){//意见输入框在底部要滚动到可视区域
if(remarktop-topDom.height()+200>scrollDom.height()){scrolltop=remarktop+scrollDom.scrollTop()-185;}//意见输入框在顶部要滚动到可视区域
if(remarktop<topDom.height()){if(remarktop<0)remarktop=remarktop*-1;scrolltop=scrollDom.scrollTop()-remarktop-topDom.height()-100;}console.log({scrolltop:scrolltop});setTimeout(function(){scrollDom.animate({scrollTop:scrolltop+"px"},0);},100);}window.CK_REF.remark.getEditor().focus();};//签字意见验证
var chekcremark=exports.chekcremark=function chekcremark(remarkcontent){var submitParam=_base2.default.globalStore.submitParam;var _submitParam$signwork=submitParam.signworkflowids,signworkflowids=_submitParam$signwork===undefined?"":_submitParam$signwork,_submitParam$signdoci=submitParam.signdocids,signdocids=_submitParam$signdoci===undefined?"":_submitParam$signdoci,_submitParam$handWrit=submitParam.handWrittenSign,handWrittenSign=_submitParam$handWrit===undefined?0:_submitParam$handWrit,_submitParam$remarkLo=submitParam.remarkLocation,remarkLocation=_submitParam$remarkLo===undefined?"":_submitParam$remarkLo;var hasvalue=true;if(signworkflowids.length>0||signdocids.length>0||(submitParam["field-annexupload"]||[]).length>0||handWrittenSign>0||remarkLocation.length>0){}else if(remarkcontent==null){hasvalue=false;}else{var _remarkcontent=remarkcontent;_remarkcontent=_remarkcontent.replace(/<p>/ig,'').replace(/<\/p>/ig,'').replace(/ /ig,"").replace(/&nbsp;/ig,"").replace(/<br \/>/ig,"");_remarkcontent=_remarkcontent.replace(/\\n/ig,"");if((0,_trim2.default)(_remarkcontent).length===0){hasvalue=false;}}return hasvalue;};//验证意见是否必填
var verifyRemarkMustInput=exports.verifyRemarkMustInput=function verifyRemarkMustInput(){var src=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var actionType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var needCheck=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var isaffirmanceSrc=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'submit';var _base$globalStore3=_base2.default.globalStore,_base$globalStore3$ma=_base$globalStore3.markInfo,markInfo=_base$globalStore3$ma===undefined?{}:_base$globalStore3$ma,_base$globalStore3$ri=_base$globalStore3.rightMenu,rightMenu=_base$globalStore3$ri===undefined?{}:_base$globalStore3$ri,_base$globalStore3$su=_base$globalStore3.submitParam,submitParam=_base$globalStore3$su===undefined?{}:_base$globalStore3$su;var odocBtnFlag=submitParam.odocBtnFlag;var _markInfo$signMustInp=markInfo.signMustInputTypes,signMustInputTypes=_markInfo$signMustInp===undefined?[]:_markInfo$signMustInp;if('save'===src){if(actionType==='requestOperation'){if(needCheck){return signMustInputTypes.indexOf(isaffirmanceSrc)>-1;}return false;}else{var _rightMenu$remarkOper=rightMenu.remarkOperationType,remarkOperationType=_rightMenu$remarkOper===undefined?'':_rightMenu$remarkOper;return signMustInputTypes.indexOf(remarkOperationType)>-1;}}// 没有设置退回意见必填的时候，这么处理
if(odocBtnFlag==='odocReject'){return signMustInputTypes.indexOf('reject')>-1;}return signMustInputTypes.indexOf(src)>-1;};/**
 * 意见框是否显示必填标识
 * @return {boolean}
 */var needMustInputDot=exports.needMustInputDot=function needMustInputDot(){var _base$globalStore4=_base2.default.globalStore,_base$globalStore4$ma=_base$globalStore4.markInfo,markInfo=_base$globalStore4$ma===undefined?{}:_base$globalStore4$ma,_base$globalStore4$ri=_base$globalStore4.rightMenu,rightMenu=_base$globalStore4$ri===undefined?{}:_base$globalStore4$ri;var _rightMenu$rightMenus=rightMenu.rightMenus,rightMenus=_rightMenu$rightMenus===undefined?[]:_rightMenu$rightMenus,_rightMenu$remarkOper2=rightMenu.remarkOperationType,remarkOperationType=_rightMenu$remarkOper2===undefined?'':_rightMenu$remarkOper2;var _markInfo$signMustInp2=markInfo.signMustInputTypes,signMustInputTypes=_markInfo$signMustInp2===undefined?[]:_markInfo$signMustInp2,isSignMustInput=markInfo.isSignMustInput;//['systemMenuType',]
var remarkOperationIndex=_.findIndex(rightMenus,function(o){if(o.type=='BTN_DOINTERVENOR')remarkOperationType='intervenor';return['POSTIL_FORWARD','POSTIL_CC','REPLY','CHUANYUE_REC'].indexOf(o.systemMenuType)>-1||o.type=='BTN_DOINTERVENOR';});var remarkMustInput=isSignMustInput=='1';if(isSignMustInput=='2'){//非批注操作
if(signMustInputTypes.indexOf('submit')>-1&&rightMenus.length>0&&remarkOperationIndex==-1){remarkMustInput=true;}//批注时必填
if(remarkOperationIndex>-1&&signMustInputTypes.indexOf(remarkOperationType)>-1){remarkMustInput=true;}}return remarkMustInput;};var convertSpecialChar=exports.convertSpecialChar=function convertSpecialChar(str){str=str.toString();str=str.replace(/<br>/gi,"\n");str=str.replace(/&nbsp;/gi," ");str=str.replace(/&lt;/gi,"<");str=str.replace(/&gt;/gi,">");str=str.replace(/&quot;/gi,'"');str=str.replace(/&amp;/gi,"&");return str;};/**
 * 处理打印模板中手写签批图片样式
 */var handWritingHander=exports.handWritingHander=function handWritingHander(){var nodeMark=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var nodeMarkTemp=nodeMark;var reg=/<img.*?(\/>|<\/img>)/g;var images=nodeMarkTemp.match(reg);images&&images.map(function(v){var oldclass="";if(/class=(\"|\')(.*?)(\"|\')/g.test(v)){oldclass=RegExp.$2;}if("handWrittenSign"==oldclass){var _v=v.replace(/<img/g,'<img onload=\'window.handWritingHander(this)\'');nodeMarkTemp=nodeMarkTemp.replace(v,_v);}});return nodeMarkTemp;};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = 
/*#__PURE__*/
__webpack_require__(134);
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder(a)) {
            return f1;
        }
        else {
            return fn.apply(this, arguments);
        }
    };
}
module.exports = _curry1;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function (it) {
    if (typeof it != 'function')
        throw TypeError(it + ' is not a function!');
    return it;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var toString = {}.toString;
module.exports = function (it) {
    return toString.call(it).slice(8, -1);
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(153), __esModule: true };


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(337), getValue = __webpack_require__(342);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(77), getRawTag = __webpack_require__(338), objectToString = __webpack_require__(339);
/** `Object#toString` result references. */
var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
}
module.exports = baseGetTag;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getDynamicFieldValueSrc=exports.buildCellAttr=exports.getRowAttr=exports.getMcCellAttr=exports.getCellAttr=exports.judgeDetailContainColHide=exports.judgeCellBelRowSpan=exports.parseLayoutImage=exports.convertEcMap=exports.convertColHeads=exports.convertRowHeads=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//布局解析时生成行头
/******* 模板布局解析相关Util ******/var convertRowHeads=exports.convertRowHeads=function convertRowHeads(rowHeads){var arr=[];_.forIn(rowHeads,function(v,k){arr.push({id:k.substring(4),height:v+"px"});});arr=arr.sort(function(a,b){return parseInt(a.id)-parseInt(b.id);});return arr;};//布局解析时生成列头并控制Table宽度
var convertColHeads=exports.convertColHeads=function convertColHeads(colHeads,symbol,layouttype,tableStyle,allowXScroll,isSeniorSet){var colattrs=arguments.length>6&&arguments[6]!==undefined?arguments[6]:{};if(typeof allowXScroll==="undefined")allowXScroll=false;var isMobileLayout=layouttype===2;var isDetail=symbol.indexOf("detail_")>-1;var isMain=symbol==="main";var hasPercent=false;var hasAutoAdapt=false;var totalPx=0;var totalPercent=0;_.forIn(colHeads,function(v,k){v=v.toString();if(v==="0%"||v.indexOf("*")>-1)v="*";if(v.indexOf("*")>-1){hasAutoAdapt=true;}else if(v.indexOf("%")>-1){hasPercent=true;totalPercent+=parseFloat(v.replace("%",""));}else{//绝对宽度
if(isDetail&&allowXScroll&&colattrs&&colattrs[k]&&colattrs[k].hide==="y")v="0";totalPx+=parseFloat(v);}});var needTransPercent=false;//标签页、明细表不开启横向滚动条、移动模板主界面等情况，需转百分比宽度
if(!hasAutoAdapt&&(symbol.indexOf("tab_")>-1||isMobileLayout&&isMain||isDetail&&!allowXScroll))needTransPercent=true;//批量打印特殊处理，列宽全转百分比，如是绝对宽度布局则把总宽度限定给iframe宽度
var _src$globalStore=_source2.default.globalStore,_src$globalStore$urlP=_src$globalStore.urlParams,urlParams=_src$globalStore$urlP===undefined?{}:_src$globalStore$urlP,baseParam=_src$globalStore.baseParam;if(layouttype===1&&isMain&&urlParams.isBatchPrint==="true"){needTransPercent=true;if(!hasAutoAdapt&&!hasPercent&&totalPx<=1000)window.jQuery('iframe#request_'+baseParam.requestid,window.parent.document).width(totalPx+20);}//外层table宽度设置
if(hasPercent||hasAutoAdapt||needTransPercent)tableStyle["width"]="100%";else if(isMain||allowXScroll)tableStyle["width"]=totalPx+"px";else tableStyle["width"]="auto";var validPercent=100;if(isDetail&&!allowXScroll&&!isSeniorSet)//低级模式预留6%给序号列
validPercent=94;var arr=[];_.forIn(colHeads,function(v,k){v=v.toString();var colWidth=v==="0%"||v.indexOf("*")>-1?"*":v;if(needTransPercent&&colWidth.indexOf("%")===-1){colWidth=parseFloat(colWidth)/totalPx*(validPercent-totalPercent);colWidth=colWidth.toFixed(2)+"%";}if(colWidth.indexOf("%")===-1&&colWidth!=="*")colWidth+="px";arr.push({id:k.substring(4),width:colWidth});});arr=arr.sort(function(a,b){return parseInt(a.id)-parseInt(b.id);});return arr;};//转换为单元格map
var convertEcMap=exports.convertEcMap=function convertEcMap(ecArr){var ecMap={};ecArr&&ecArr.map(function(v){ecMap[v.id]=v;});return ecMap;};//解析模板背景图、悬浮图
var parseLayoutImage=exports.parseLayoutImage=function parseLayoutImage(layout,tableStyle,trArr){if(!!layout.backgroundImage){//背景图
tableStyle["background-image"]='url('+convertImagePath(layout.backgroundImage)+')';tableStyle["background-repeat"]="no-repeat";}var floatImgArr=layout.floatingObjectArray&&layout.floatingObjectArray.floatingObjects;if(!!floatImgArr){//悬浮图
var imgArr=new Array();floatImgArr.map(function(imgInfo){var imgStyle={width:imgInfo.width,height:imgInfo.height,top:imgInfo.y,left:imgInfo.x};imgArr.push(_react2.default.createElement("img",{src:convertImagePath(imgInfo.src),className:"floatImg",style:imgStyle}));});var columnSize=(0,_keys2.default)(layout.colheads).length;trArr.push(_react2.default.createElement("tr",{style:{height:"0px"}},[_react2.default.createElement("td",{colSpan:columnSize,className:"floatImgTd"},imgArr)]));}};var convertImagePath=function convertImagePath(src){if(!src)return src;var rootpath=window.ecologyContentPath||'';if(rootpath!=="")src=src.replace(new RegExp("(?<!"+rootpath+")/workflow/exceldesign/image/","ig"),rootpath+'/workflow/exceldesign/image/');return src;};var cellBelRowSpan={};//判断单元格是否属于被行合并的单元格
var judgeCellBelRowSpan=exports.judgeCellBelRowSpan=function judgeCellBelRowSpan(symbol,rowid,colid,ecMap){var key=symbol+'_'+rowid+'_'+colid;if(key in cellBelRowSpan)return cellBelRowSpan[key];var belong=false;for(var j=colid;j>=0&&!belong;j--){for(var i=rowid-1;i>=0&&!belong;i--){var cellObj=ecMap[i+","+j];var rowSpan=cellObj?cellObj.rowspan||1:0;var colSpan=cellObj?cellObj.colspan||1:0;if(rowSpan>1&&rowSpan>=rowid-i+1&&colSpan>=colid-j+1)//单元格属于被上方行合并的单元格
belong=true;}}cellBelRowSpan[key]=belong;//缓存存储，降低布局很大时的遍历性能
return belong;};//判断明细布局是否含有列隐藏
var judgeDetailContainColHide=exports.judgeDetailContainColHide=function judgeDetailContainColHide(colattrs){var contain=false;_.forIn(colattrs,function(v,k){if(v&&v.hide==="y"){contain=true;return false;}});return contain;};var getCellAttr=exports.getCellAttr=function getCellAttr(cellObj,colCusAttr,rowHeight){var isCardEdit=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var cellAttr={};var tdStyle={};var divStyle={};var tdClass="";var financial=cellObj&&cellObj.financial;//财务格式所在单元格div增加高度100%
if(financial&&financial.indexOf("2-")>-1){tdStyle["height"]=rowHeight+"px";divStyle["height"]="100%";divStyle["padding"]="0px";}//列自定义属性
if(colCusAttr&&colCusAttr.hide==="y"&&(!isCardEdit||isCardEdit&&colCusAttr.isDetailCardShow!="1"))tdClass+=" detail_hide_col";if(colCusAttr&&colCusAttr.class)tdClass+=" "+colCusAttr.class;//单元格自定义属性(放最后可覆盖之前的CSS)
var cusattrs=cellObj&&cellObj.attrs;if(cusattrs&&cusattrs.class)tdClass+=" "+(cusattrs.class+'_swap');//水平居中属性生成classname
var fontObj=cellObj&&cellObj.font||{};var textAlign=(typeof fontObj==='undefined'?'undefined':(0,_typeof3.default)(fontObj))==="object"&&fontObj["text-align"]||"left";tdClass+=' td_textalign_'+textAlign;//拼自定义属性
cusattrs&&appendCusAttrObj(cellAttr,cusattrs,divStyle);cellAttr.tdStyle=tdStyle;cellAttr.tdClass=_.trim(tdClass);cellAttr.divStyle=divStyle;return cellAttr;};var getMcCellAttr=exports.getMcCellAttr=function getMcCellAttr(cellObj){var mcCellAttr={};var spanStyle={};//自定义属性
var cusattrs=cellObj&&cellObj.attrs;cusattrs&&appendCusAttrObj(mcCellAttr,cusattrs,spanStyle);mcCellAttr.spanStyle=spanStyle;return mcCellAttr;};var getRowAttr=exports.getRowAttr=function getRowAttr(rowHeight,rowCusAttr){var rowAttr={};rowAttr.id=rowCusAttr?rowCusAttr.id:"";rowAttr.name=rowCusAttr?rowCusAttr.name:"";rowAttr.trClass=rowCusAttr?rowCusAttr.class:"";var trStyle={};trStyle["height"]=rowHeight;if(rowCusAttr&&rowCusAttr.hide==="y")trStyle["display"]="none";if(rowCusAttr&&rowCusAttr.style)appendCusAttrStyle(trStyle,rowCusAttr.style);rowAttr.trStyle=trStyle;//行-自定义属性名称
var cusobj={};if(rowCusAttr&&(typeof rowCusAttr==='undefined'?'undefined':(0,_typeof3.default)(rowCusAttr))==="object"){var newRowCusAttr=(0,_extends3.default)({},rowCusAttr);delete newRowCusAttr.id;delete newRowCusAttr.name;delete newRowCusAttr.class;delete newRowCusAttr.hide;delete newRowCusAttr.style;cusobj=(0,_extends3.default)({},newRowCusAttr);}rowAttr.cusobj=cusobj;return rowAttr;};var appendCusAttrObj=function appendCusAttrObj(obj,cusattrs,styleObj){!_.isEmpty(cusattrs)&&_.forIn(cusattrs,function(v,k){if(k==="hide"){if(v==="y")styleObj["display"]="none";}else if(k==="id"||k==="name"||k==="class"||k==="title"){obj['cus'+k]=v;}else if(k==="style"){appendCusAttrStyle(styleObj,v);}else{//自定义属性加data-并且变小写
obj['data-'+k.toLowerCase()]=v;}});};var appendCusAttrStyle=function appendCusAttrStyle(styleObj,cusstylestr){var styleArr=cusstylestr.split(";");for(var i=0;i<styleArr.length;i++){var item=styleArr[i];var itemArr=item.split(":");if(itemArr.length>=2)styleObj[itemArr[0]]=itemArr[1];}return styleObj;};//根据解析的自定义属性生成单元格属性
var buildCellAttr=exports.buildCellAttr=function buildCellAttr(tdCellAttr,className,style){var cellAttr={};if(className)cellAttr["className"]=className;if(style)cellAttr["style"]=style;if(!tdCellAttr)return cellAttr;for(var key in tdCellAttr){var value=tdCellAttr[key];if(key==="cusid"||key==="cusname"||key==="custitle")cellAttr[key.replace("cus","")]=value;else if(key.length>5&&key.substring(0,5)==="data-")//自定义属性
cellAttr[key]=value;}return cellAttr;};//替换IFrame动态参数
var getDynamicFieldValueSrc=exports.getDynamicFieldValueSrc=function getDynamicFieldValueSrc(dynamicFieldnames,temp_src){var src=temp_src;_.forEach(dynamicFieldnames,function(value){var repalceReg='\\$\\['+value+'\\]\\$';src=src.replace(new RegExp(repalceReg,"gm"),_interface2.default.getFieldValue(_interface2.default.convertFieldNameToId(value)));});return src;};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var hasWindow = typeof window !== 'undefined';
/*
 * [lng, lat]
 * {lng, lat}
 * {longitude, latitude}
 */
var toLnglat = exports.toLnglat = function toLnglat(pos) {
    if (!pos) {
        return pos;
    }
    // 高德原生 AMap.LngLat 类
    if ('getLng' in pos && 'getLat' in pos) {
        return pos;
    }
    var lng = 0;
    var lat = 0;
    if ({}.toString.call(pos) === '[object Array]') {
        lng = pos[0];
        lat = pos[1];
    }
    else if ('lng' in pos && 'lat' in pos) {
        lng = pos.lng;
        lat = pos.lat;
    }
    else if ('longitude' in pos && 'latitude' in pos) {
        lng = pos.longitude;
        lat = pos.latitude;
    }
    return hasWindow ? new window.AMap.LngLat(lng, lat) : null;
};
var toPixel = exports.toPixel = function toPixel(ofst) {
    if (!ofst) {
        return ofst;
    }
    if ('getX' in ofst && 'getY' in ofst) {
        return ofst;
    }
    var x = 0;
    var y = 0;
    if ({}.toString.call(ofst) === '[object Array]') {
        x = ofst[0];
        y = ofst[1];
    }
    else if ('x' in ofst && 'y' in ofst) {
        x = ofst.x;
        y = ofst.y;
    }
    return hasWindow ? new window.AMap.Pixel(x, y) : null;
};
var toSize = exports.toSize = function toSize(size) {
    if (!size) {
        return size;
    }
    if ('getWidth' in size) {
        return size;
    }
    return hasWindow ? new window.AMap.Size(size.width, size.height) : null;
};
exports.default = {
    toLnglat: toLnglat,
    toPixel: toPixel,
    toSize: toSize
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
    if (it == undefined)
        throw TypeError("Can't call method on  " + it);
    return it;
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(305)(true);
// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(140)(String, 'String', function (iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
    // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length)
        return { value: undefined, done: true };
    point = $at(O, index);
    this._i += point.length;
    return { value: point, done: false };
});


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(63);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(73);
var min = Math.min;
module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(336), Map = __webpack_require__(159), Promise = __webpack_require__(343), Set = __webpack_require__(344), WeakMap = __webpack_require__(345), baseGetTag = __webpack_require__(67), toSource = __webpack_require__(208);
/** `Object#toString` result references. */
var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
    getTag = function (value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString: return dataViewTag;
                case mapCtorString: return mapTag;
                case promiseCtorString: return promiseTag;
                case setCtorString: return setTag;
                case weakMapCtorString: return weakMapTag;
            }
        }
        return result;
    };
}
module.exports = getTag;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);
/** Built-in value references. */
var Symbol = root.Symbol;
module.exports = Symbol;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
    return value === other || (value !== value && other !== other);
}
module.exports = eq;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(221), baseKeys = __webpack_require__(156), isArrayLike = __webpack_require__(54);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(221), baseKeysIn = __webpack_require__(406), isArrayLike = __webpack_require__(54);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.checkLength=exports.realLength=exports.convertAmountChinese=exports.convertFloatValue=exports.judgeIsExponential=exports.judgeIsNumber=undefined;var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//判断值是否属于数字
var judgeIsNumber=exports.judgeIsNumber=function judgeIsNumber(val){var judgeZero=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(val===null||typeof val==="undefined")return false;val=val.toString().trim();;var reg=/^(-?\d+)(\.\d+)?$/;var reg2=/^(-?)0\d+/;var isNum=reg.test(val);if(isNum&&judgeZero&&reg2.test(val))//判断0开头是否表示为数字
isNum=false;if(judgeIsExponential(val))//科学计数法也属于数字
isNum=true;return isNum;};//判断是否科学计数法，val需要本身为string类型,number转string整数会从科学计数法变为数值导致判断不准
var judgeIsExponential=exports.judgeIsExponential=function judgeIsExponential(val){if(val===null||typeof val!=="string"||val.indexOf("E")===-1&&val.indexOf("e")===-1)return false;var reg=/^-?\d+(\.\d+)?[E|e][+|-]\d+$/;return reg.test(val);};//科学技术法转化成常规数字
var convertExponential=function convertExponential(val){var decimal=arguments.length>1&&arguments[1]!==undefined?arguments[1]:4;if(!judgeIsExponential(val))return val;if(val.indexOf("+")>-1)return Number(val).toString();else return Number(val).toFixed(decimal);};/**
 * 数值转换(精度、千分位)等
 * @param {String} realval   真实值
 * @param {int} decimals  精度
 * @param {Boolean} transQfw  是否千分位
 * @param {Boolean} transAbs  是否绝对值
 */var convertFloatValue=exports.convertFloatValue=function convertFloatValue(realval,decimals,transQfw,transAbs){realval=realval.toString().trim();if(!judgeIsNumber(realval)){realval=realval.trim();}if(!judgeIsNumber(realval))//非数值直接返回原始值
return realval;realval=convertExponential(realval,decimals);var formatval="";if(decimals===0){//需取整
formatval=Math.round(parseFloat(realval)).toString();}else{var pindex=realval.indexOf(".");var pointLength=pindex>-1?realval.substr(pindex+1).length:0;//当前小数位数
if(pointLength>decimals){//四舍五入
formatval=toFixed(realval,decimals).toString();formatval=convertExponential(formatval,decimals);}else{formatval=realval;}pindex=formatval.indexOf(".");pointLength=pindex>-1?formatval.substr(pindex+1).length:0;//当前小数位数
if(decimals>pointLength){//需补零
if(pindex==-1)formatval+=".";for(var i=0;i<decimals-pointLength;i++){formatval+="0";}}}var index=formatval.indexOf(".");var intPar=index>-1?formatval.substring(0,index):formatval;intPar=intPar.replace(/^(-?)(0+)(\d+)/,'$1$3');//去掉数值首位的零
var pointPar=index>-1?formatval.substring(index):"";//取绝对值
if(transAbs===true){//取绝对值
intPar=Math.abs(intPar).toString();}if(transQfw===true){//整数位format成千分位
var reg1=/(-?\d+)(\d{3})/;while(reg1.test(intPar)){intPar=intPar.replace(reg1,"$1,$2");}}formatval=intPar+pointPar;return formatval;};window.convertFloatValue=convertFloatValue;var toFixed=function toFixed(value,decimals){if(decimals<=0||!judgeIsNumber(value))return value;if(window.___Calculate){//E8计算方法将小数点位数后添加了很多0，导致pointLength计算错误，所以要先转成float
value=parseFloat(value).toString();}var pindex=value.indexOf(".");var pointLength=pindex>-1?value.substr(pindex+1).length:0;//当前小数位数
var result="";//parseFloat整数位数不能超过15位，临时方案截取
if(pindex>15){if(pointLength>decimals){var subLength=pindex+1+decimals;result=value.substring(0,subLength);}else{result=value;}}else{var n=Math.pow(10,decimals);if(pointLength!=0){if(Number(value)>0){result=Math.round(parseFloat(value)*n+0.5*Math.pow(10,-pointLength))/n;}else{result=-Math.round(parseFloat(Math.abs(value))*n+0.5*Math.pow(10,-pointLength))/n;}}else{result=Number(value).toFixed(decimals);}}return result;};var convertAmountChinese=exports.convertAmountChinese=function convertAmountChinese(num){if(!judgeIsNumber(num))return"";var amount_convert_unit="元";var commonParam=_source2.default.globalStore.commonParam;var propFileCfg=_source2.default.layoutStore.propFileCfg;if(propFileCfg&&propFileCfg.amount_convert_unit==="1")amount_convert_unit="圆";if(typeof num==="string")num=parseFloat(num);var prefh="";if(num<0){prefh="负";num=Math.abs(num);}if(num>Math.pow(10,12))return"";var cn="零壹贰叁肆伍陆柒捌玖";var unit=new Array("拾佰仟","分角");var unit2=['拾','佰','仟','万','亿'];var unit1=new Array(commonParam.languageid=="9"?"萬億萬":"万亿万","");var numArray=num.toString().split(".");var start=new Array(numArray[0].length-1,2);function toChinese(num,index){var num=num.replace(/\d/g,function($1){return cn.charAt($1)+unit[index].charAt(start--%4?start%4:-1);});return num;}for(var i=0;i<numArray.length;i++){var tmp="";for(var j=0;j*4<numArray[i].length;j++){var strIndex=numArray[i].length-(j+1)*4;var str=numArray[i].substring(strIndex,strIndex+4);var start=i?2:str.length-1;var tmp1=toChinese(str,i);tmp1=tmp1.replace(/(零.)+/g,"零").replace(/零+$/,"");var last=tmp1.charAt(tmp1.length-1);var flag=unit[0];if(j==1&&tmp!=""){if(flag.indexOf(last)!=-1||tmp1==""){if(tmp.charAt(0)=="零"){tmp=tmp1+unit1[i].charAt(j-1)+tmp;}else{if(unit2.indexOf(tmp.charAt(tmp.length-1))-unit2.indexOf(unit1[i].charAt(j-1))>1){tmp=tmp1+unit1[i].charAt(j-1)+"零"+tmp;}else{tmp=tmp1+unit1[i].charAt(j-1)+tmp;}}}else{tmp=tmp1+unit1[i].charAt(j-1)+tmp;}}else{if(j==2){if(tmp.indexOf('万')>-1&&tmp.charAt(0)=='零'){tmp=tmp.substring(1);}else if(tmp.charAt(2)=='仟'&&tmp.charAt(1)!='零'){tmp=tmp.substring(0,1)+'零'+tmp.substring(1);}}tmp=tmp1+unit1[i].charAt(j-1)+tmp;}}numArray[i]=tmp;}numArray[1]=numArray[1]?numArray[1]:"";numArray[0]=numArray[0]?numArray[0]+amount_convert_unit:numArray[0];// numArray[1] = numArray[1].replace(/^零+/, "");
numArray[1]=numArray[1].match(/分/)?numArray[1]:numArray[1]+"整";var money=numArray[0]+numArray[1];money=money.replace(/(亿万)+/g,"亿");if(money=="整"){money="零"+amount_convert_unit+"整";}else{money=prefh+money;}return money;};window.convertAmountChinese=convertAmountChinese;var realLength=exports.realLength=function realLength(str){var j=0;for(var i=0;i<=str.length-1;i++){j=j+1;if(str.charCodeAt(i)>127){j=j+2;}}return j;};var checkLength=exports.checkLength=function checkLength(str,strLen,elMaxLen){if(strLen<=elMaxLen){return str;}var j=0;for(var i=0;i<=str.length-1;i++){j=j+1;if(str.charCodeAt(i)>127){j=j+2;}if(j>elMaxLen){return str.substring(0,i);}if(j==elMaxLen){return str.substring(0,i+1);}}return str;};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _from = __webpack_require__(124);
var _from2 = _interopRequireDefault(_from);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }
        return arr2;
    }
    else {
        return (0, _from2.default)(arr);
    }
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setFormularErrorLog=exports.judgeSubmitSource=exports.getWfVerifiySourceObj=exports.setWfVerifiySource=exports.initVerifiySource=exports.verifyLinkageFinished=exports.removeInvalidResponse=exports.generateKeyOrder=undefined;var _regenerator=__webpack_require__(128);var _regenerator2=_interopRequireDefault(_regenerator);var _asyncToGenerator2=__webpack_require__(129);var _asyncToGenerator3=_interopRequireDefault(_asyncToGenerator2);var _defineProperty2=__webpack_require__(55);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(7);var _extends4=_interopRequireDefault(_extends3);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * liuzy 异步联动控制器
 * 控制联动顺序、控制联动请求的结果需都正常返回才允许流程提交
*/var orderInfo={};//异步联动发请求前调用,生成异步联动key对象，以每个联动设置为维度
//同一个key下多个请求并发，最后一个请求的response才为有效结果
var generateKeyOrder=exports.generateKeyOrder=function generateKeyOrder(linkageType,reqParams){var keyOrder=[];var linkageidArr=reqParams.linkageid.split(",");linkageidArr&&linkageidArr.map(function(k){if(k!==""){var rowIndexStr=reqParams["rowIndexStr_"+k]||"-1";var keyid=linkageType+"_"+k+"_"+rowIndexStr;keyOrder.push({keyid:keyid,linkageid:k,orderid:appendOrderInfo(keyid)});}});return keyOrder;};//生成顺序
var appendOrderInfo=function appendOrderInfo(key){if(key in orderInfo)orderInfo[key].index++;else orderInfo[key]={index:0};orderInfo[key].time=new Date().getTime();orderInfo[key].finished=false;return orderInfo[key].index;};//联动结果response赋值前调用，移除无效的结果
var removeInvalidResponse=exports.removeInvalidResponse=function removeInvalidResponse(keyOrder,resData){keyOrder.map(function(item){var keyid=item.keyid,linkageid=item.linkageid,orderid=item.orderid;if(orderid>=orderInfo[keyid].index){//最新请求的response
orderInfo[keyid].finished=true;}else{//先发后置的无效response
if("assignInfo_"+linkageid in resData)delete resData["assignInfo_"+linkageid];}});return resData;};//流程提交时调用，判断异步联动结果是否都正常返回
//如果存在联动未返回，定时器扫描等待，超过2s给提示信息，超过10s作为联动失败处理允许继续提交
var verifyLinkageFinished=exports.verifyLinkageFinished=function verifyLinkageFinished(callback){var verifyLoadLinkageComplete=function verifyLoadLinkageComplete(cb){var verifyTime=new Date().getTime();var timer=window.setInterval(function(){var currentTime=new Date().getTime();var completeFn=function completeFn(){window.clearInterval(timer);cb();};if(window.Has_Trigger_Load_Linkage===true){completeFn();}else if(currentTime-verifyTime>5*1000&&window.Has_Trigger_Load_Linkage!==true){window.WfForm.showMessage("页面加载未正常触发联动，请联系管理员！",1,30);}},500);};var verifyFormulaLoadComplete=function verifyFormulaLoadComplete(cb){//提交前校验公式资源/明细表/代码块/自定义页面加载是否完毕 并给出提示
if(!judgeSubmitSource()){//不给出提示的场景下，若出现明细表未加载完成，直接放行提交，因为后续会记录日志
var _wfVerifiySourceObj=getWfVerifiySourceObj();if(_wfVerifiySourceObj.detailData==="loading"){cb();}else{verifyLoadLinkageComplete(cb);}};};try{var hasNotice=false;var timer=window.setInterval(function(){var linkageBegTime="";var unFinishedKey="";for(var key in orderInfo){if(!orderInfo[key].finished){linkageBegTime=orderInfo[key].time;unFinishedKey=key;break;}}var submitBegTime=new Date().getTime();if(linkageBegTime===""||submitBegTime-linkageBegTime>60*1000){window.clearInterval(timer);window.wfform.appendSubmitParam({"linkageUnFinishedKey":unFinishedKey});verifyFormulaLoadComplete(callback);}else if(submitBegTime-linkageBegTime>2*1000&&!hasNotice){window.WfForm.showMessage("存在联动请求未返回，请耐心等待...",1,60);hasNotice=true;}},200);}catch(e){verifyFormulaLoadComplete(callback);}};/**
 * "unload":资源未加载
 * "loading":资源加载中
 * "loaded":资源加载成功
 * "fail":资源加载失败
 */var wfVerifiySourceObj={formularSource:"unload",scriptCusSource:"unload",detailData:"unload"};var initVerifiySource=exports.initVerifiySource=function initVerifiySource(){var controlVariableMap=_source2.default.globalStore.controlVariableMap;controlVariableMap("wfVerifiySourceObj",wfVerifiySourceObj);};var setWfVerifiySource=exports.setWfVerifiySource=function setWfVerifiySource(sourceName,value){var _src$globalStore=_source2.default.globalStore,variableMap=_src$globalStore.variableMap,controlVariableMap=_src$globalStore.controlVariableMap;var wfVerifiySourceObj=variableMap.get("wfVerifiySourceObj");var new_wfVerifiySourceObj=(0,_extends4.default)({},wfVerifiySourceObj,(0,_defineProperty3.default)({},sourceName,value));controlVariableMap("wfVerifiySourceObj",new_wfVerifiySourceObj);};var getWfVerifiySourceObj=exports.getWfVerifiySourceObj=function getWfVerifiySourceObj(){var variableMap=_source2.default.globalStore.variableMap;var wfVerifiySourceObj=variableMap.get("wfVerifiySourceObj");return wfVerifiySourceObj;};/**
 * 拦截提交
 * 当没有开启开关才拦截提交
 */var judgeSubmitSource=exports.judgeSubmitSource=function judgeSubmitSource(){var propFileCfg=_source2.default.layoutStore.propFileCfg;var _src$globalStore2=_source2.default.globalStore,setBtnDisabled=_src$globalStore2.setBtnDisabled,setLoading=_src$globalStore2.setLoading;var _propFileCfg$enable_n=propFileCfg.enable_no_promptes_submit,enable_no_promptes_submit=_propFileCfg$enable_n===undefined?0:_propFileCfg$enable_n;var wfVerifiySourceObj=getWfVerifiySourceObj();console.log("wfVerifiySourceObj",wfVerifiySourceObj);if(!(enable_no_promptes_submit==1||window.code_enable_submit)){//给出提示，拦截提交，但不记录日志
var tip_content="";if(wfVerifiySourceObj.formularSource==="loading"){tip_content=_source2.default.getLabel(546602,"公式资源未加载完成，流程提交可能存在数据异常");}else if(wfVerifiySourceObj.scriptCusSource==="loading"){tip_content=_source2.default.getLabel(546603,"代码块/自定义页面资源未加载完成，流程提交可能存在数据异常");}else if(wfVerifiySourceObj.detailData==="loading"){tip_content=_source2.default.getLabel(546604,"明细表数据未加载完成，流程提交可能存在数据异常");}else if(wfVerifiySourceObj.formularSource==="fail"){tip_content=_source2.default.getLabel(546605,"公式资源加载失败，流程提交可能存在数据异常");}else if(wfVerifiySourceObj.scriptCusSource==="fail"){tip_content=_source2.default.getLabel(546606,"代码块/自定义页面资源加载失败，流程提交可能存在数据异常");}else if(wfVerifiySourceObj.detailData==="fail"){tip_content=_source2.default.getLabel(546607,"明细表数据加载失败，流程提交可能存在数据异常");}if(tip_content){window.WfForm.showMessage(tip_content,1,3);window.WfForm.controlBtnDisabled(false);//移动端按钮取消置灰
setBtnDisabled(false);//pc端按钮取消置灰
setLoading(false);return true;}}//否则不给出提示，但记录日志
return false;};/**
 * 记录日志
 * 当开启开关才记录日志
 */var setFormularErrorLog=exports.setFormularErrorLog=function(){var _ref=(0,_asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var propFileCfg,_src$globalStore3,commonParam,variableMap,requestid,workflowid,nodeid,currentUserid,_propFileCfg$enable_n2,enable_no_promptes_submit,wfVerifiySourceObj,errMsg,type;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:propFileCfg=_source2.default.layoutStore.propFileCfg;_src$globalStore3=_source2.default.globalStore,commonParam=_src$globalStore3.commonParam,variableMap=_src$globalStore3.variableMap;requestid=commonParam.requestid,workflowid=commonParam.workflowid,nodeid=commonParam.nodeid,currentUserid=commonParam.currentUserid;_propFileCfg$enable_n2=propFileCfg.enable_no_promptes_submit,enable_no_promptes_submit=_propFileCfg$enable_n2===undefined?0:_propFileCfg$enable_n2;wfVerifiySourceObj=getWfVerifiySourceObj();if(!(enable_no_promptes_submit==1||window.code_enable_submit)){_context.next=12;break;}//记录日志
errMsg="";type="";if(wfVerifiySourceObj.formularSource==="loading"){type=1;errMsg="公式资源未加载完成提交";}else if(wfVerifiySourceObj.scriptCusSource==="loading"){type=2;errMsg="代码块/自定义页面未加载完成提交";}else if(wfVerifiySourceObj.detailData==="loading"){type=3;errMsg="明细表数据未加载完成提交";}else if(wfVerifiySourceObj.formularSource==="fail"){type=1;errMsg=variableMap.get("formulaPathsNotFound")||"";}else if(wfVerifiySourceObj.scriptCusSource==="fail"){type=2;errMsg=variableMap.get("scriptOrCustomPageError")||"";}else if(wfVerifiySourceObj.detailData==="fail"){type=3;errMsg=variableMap.get("detailDataError")||"";}if(!errMsg){_context.next=12;break;}_context.next=12;return _source2.default.API_REQ.writeFormErrlog({requestid:requestid,workflowid:workflowid,nodeid:nodeid,operator:currentUserid,errlog:errMsg,type:type,isMobile:_source2.default.isMobile?1:-1});case 12:case"end":return _context.stop();}}},_callee,undefined);}));return function setFormularErrorLog(){return _ref.apply(this,arguments);};}();

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.doModifyForm=exports.doModifyStyle=exports.onDocCompare=exports.doImportWorkflow=exports.onCustomOpt=exports.toExcel=exports.doBack=exports.openProductSuggest=exports.doImportDetail=exports.doEdit=exports.doShare=exports.doEncryptShare=exports.doAffirmanceNoBack=exports.doAffirmanceBack=exports.triSubwf2=exports.doFreeWorkflow=exports.aboutVersion=exports.onNewChats=exports.onNewEmail=exports.onNewSms=exports.onNewRequest2=exports.onNewRequest=exports.doWithdraw=exports.onNewOverTime=exports.doTd253574=exports.doReviewnoback3=exports.doTakEnd=exports.doTakForward_noBack=exports.doTakForward_Back=exports.doMultiTak=exports.doReview2=exports.doReview3=exports.doReviewback3=exports.doTakeBack=exports.doReviewE9Back=exports.doChuanyue=exports.doReviewE9=exports.controlForward=exports.doSubmitDirect=exports.doDelete=exports.doViewModifyLog=exports.sureReject=exports.doReject_New=exports.doCreateTask=exports.openTaskList=exports.doPrintViewLog=exports.doDrawBack=exports.doRetract=exports.doRestart=exports.doCancel=exports.doStop=exports.doPrintRequest=exports.doRemark_nNoBack=exports.doRemark_nBack=exports.doIntervenor=exports.doSupervise=exports.doSubmit_Pre=exports.doSave_nNew=exports.doSubmitNoBack=exports.doSubmitBack=exports.openThPreview=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _submit=__webpack_require__(57);var _globalUtil=__webpack_require__(30);var _signUtil=__webpack_require__(58);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _convert=__webpack_require__(6);var _objectAssign=__webpack_require__(88);var _objectAssign2=_interopRequireDefault(_objectAssign);var _formExport=__webpack_require__(491);var _mobx=__webpack_require__(9);var _antd=__webpack_require__(87);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//金山 or 永中套红预览
var openThPreview=exports.openThPreview=function openThPreview(){var globalStore=_base2.default.globalStore,layoutStore=_base2.default.layoutStore;var commonParam=globalStore.commonParam,setLoading=globalStore.setLoading;var _toJS=(0,_mobx.toJS)(commonParam),requestid=_toJS.requestid,workflowid=_toJS.workflowid;var odocInfo=layoutStore.odocInfo;odocInfo=(0,_mobx.toJS)(odocInfo);var _odocInfo$docParam=odocInfo.docParam,_odocInfo$docParam$sh=_odocInfo$docParam.showMouldId,showMouldId=_odocInfo$docParam$sh===undefined?-1:_odocInfo$docParam$sh,_odocInfo$docParam$do=_odocInfo$docParam.docid,docid=_odocInfo$docParam$do===undefined?-1:_odocInfo$docParam$do,_odocInfo$docParam$im=_odocInfo$docParam.imagefileId,imagefileId=_odocInfo$docParam$im===undefined?-1:_odocInfo$docParam$im,_odocInfo$docParam$wp=_odocInfo$docParam.wpsView,wpsView=_odocInfo$docParam$wp===undefined?false:_odocInfo$docParam$wp,_odocInfo$docParam$yo=_odocInfo$docParam.yozoView,yozoView=_odocInfo$docParam$yo===undefined?false:_odocInfo$docParam$yo;if(showMouldId<0){_antd.message.error((0,_convert.getLabel)(23569,'套红模板没有设置，请和系统管理员联系！'));return;}else if(docid<=0||imagefileId<=0){_antd.message.error((0,_convert.getLabel)(515738,'获取正文失败'));return;}else if(!wpsView&&!yozoView){_antd.message.error((0,_convert.getLabel)(515745,'参数错误，请确认是否购买金山wps或者永中预览服务'));}else{// // window.open("/spa/odoc/static/index.html#/main/offical/docTemplate?workflowid="+workflowid+"&selectvalue=-1&requestid="+requestid+"&docid="+docid+"&imagefileId="+imagefileId+"&openyozo="+yozoView+"&wpsEditor="+wpsView+"&fullView=1&_key=lqutvh","thPreview")
// let iframe = document.createElement("iframe");
// iframe.setAttribute('width','100%');
// iframe.setAttribute('height','100%');
// iframe.setAttribute('id','openModelComponent');
// iframe.setAttribute("src","/spa/odoc/static/index.html#/main/offical/docTemplate?workflowid="+workflowid+"&selectvalue=-1&requestid="+requestid+"&docid="+docid+"&imagefileId="+imagefileId+"&openyozo="+yozoView+"&wpsEditor="+wpsView+"&fullView=1&_key=lqutvh");
// document.getElementById("container").appendChild(iframe);
oDocUtil.selectTemplate(false,1);}};//提交需反馈
var doSubmitBack=exports.doSubmitBack=function doSubmitBack(){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu,_globalStore$submitPa=globalStore.submitParam,submitParam=_globalStore$submitPa===undefined?{}:_globalStore$submitPa;var iscreate=commonParam.iscreate,selectNextFlowPattern=commonParam.selectNextFlowPattern;var isFree=rightMenu.isFree;//高级模式、简易模式，如果选了流转操作者直接提交
if(isFree=="1"&&iscreate=='1'&&(selectNextFlowPattern==0&&submitParam.operatorids==""||selectNextFlowPattern!=0)){doFreeWorkflow();}else{globalStore.setSubmitToNodeId();(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"submit",needwfback:"1"});}};//提交不需反馈
var doSubmitNoBack=exports.doSubmitNoBack=function doSubmitNoBack(){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu,_globalStore$submitPa2=globalStore.submitParam,submitParam=_globalStore$submitPa2===undefined?{}:_globalStore$submitPa2;var iscreate=commonParam.iscreate,selectNextFlowPattern=commonParam.selectNextFlowPattern;var isFree=rightMenu.isFree;if(isFree=="1"&&iscreate=='1'&&(selectNextFlowPattern==0&&submitParam.operatorids==""||selectNextFlowPattern!=0)){doFreeWorkflow();}else{globalStore.setSubmitToNodeId();(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"submit",needwfback:"0"});}};//流程保存
var doSave_nNew=exports.doSave_nNew=function doSave_nNew(){var closePage=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",closePage:closePage,type:'save'});};//提交后确认按钮
var doSubmit_Pre=exports.doSubmit_Pre=function doSubmit_Pre(src){(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:src||"submit"});};//流程督办
var doSupervise=exports.doSupervise=function doSupervise(){var globalStore=_base2.default.globalStore;globalStore.controlDialogVisible(type.DO_SUPERVISE,true);};//流程干预
var doIntervenor=exports.doIntervenor=function doIntervenor(){(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"intervenor"});};//批注需反馈
var doRemark_nBack=exports.doRemark_nBack=function doRemark_nBack(){(0,_submit.doSubmitForm)({actiontype:"remarkOperation",src:"save",needwfback:"1"});};//批注不需反馈
var doRemark_nNoBack=exports.doRemark_nNoBack=function doRemark_nNoBack(){(0,_submit.doSubmitForm)({actiontype:"remarkOperation",src:"save",needwfback:"0"});};//流程打印
var doPrintRequest=exports.doPrintRequest=function doPrintRequest(){(0,_globalUtil.verifyCustomRegisterEvent)(WfForm.OPER_PRINT,function(){var _base$globalStore=_base2.default.globalStore,commonParam=_base$globalStore.commonParam,_base$globalStore$url=_base$globalStore.urlParams,urlParams=_base$globalStore$url===undefined?{}:_base$globalStore$url;var requestid=commonParam.requestid,wfmonitor=commonParam.wfmonitor,isurger=commonParam.isurger,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,wfTestStr=commonParam.wfTestStr;var _urlParams$isrequest=urlParams.isrequest,isrequest=_urlParams$isrequest===undefined?'':_urlParams$isrequest,_urlParams$isfromrepo=urlParams.isfromreport,isfromreport=_urlParams$isfromrepo===undefined?'':_urlParams$isfromrepo,_urlParams$reportid=urlParams.reportid,reportid=_urlParams$reportid===undefined?'':_urlParams$reportid,_urlParams$isfromflow=urlParams.isfromflowreport,isfromflowreport=_urlParams$isfromflow===undefined?'':_urlParams$isfromflow,_urlParams$isfromchat=urlParams.isfromchatshare,isfromchatshare=_urlParams$isfromchat===undefined?'':_urlParams$isfromchat,_urlParams$fromModul=urlParams.fromModul,fromModul=_urlParams$fromModul===undefined?'':_urlParams$fromModul,_urlParams$modulResou=urlParams.modulResourceId,modulResourceId=_urlParams$modulResou===undefined?'':_urlParams$modulResou,_urlParams$desrequest=urlParams.desrequestid,desrequestid=_urlParams$desrequest===undefined?'':_urlParams$desrequest,_urlParams$fromCommun=urlParams.fromCommunication,fromCommunication=_urlParams$fromCommun===undefined?'':_urlParams$fromCommun;var _urlParams$authSignat=urlParams.authSignatureStr,authSignatureStr=_urlParams$authSignat===undefined?'':_urlParams$authSignat,_urlParams$authStr=urlParams.authStr,authStr=_urlParams$authStr===undefined?'':_urlParams$authStr;if(!authSignatureStr)authSignatureStr=commonParam.authSignatureStr;if(!authStr)authStr=commonParam.authStr;var ismonitor=wfmonitor?"1":"0";var urger=isurger?"1":"0";var printurl=(window.ecologyContentPath||'')+'/workflow/request/PrintRequestForward.jsp?';var printUrlParams='requestid='+requestid+'&ismonitor='+ismonitor+'&urger='+urger+'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype='+f_weaver_belongto_usertype+'&wfTestStr='+wfTestStr;if(authSignatureStr)printUrlParams+='&authSignatureStr='+authSignatureStr;if(authStr)printUrlParams+='&authStr='+authStr;if(isrequest)printUrlParams+='&isrequest='+isrequest;if(isfromreport)printUrlParams+='&isfromreport='+isfromreport;if(isfromflowreport)printUrlParams+='&isfromflowreport='+isfromflowreport;if(isfromchatshare)printUrlParams+='&isfromchatshare='+isfromchatshare;if(reportid)printUrlParams+='&reportid='+reportid;if(fromModul)printUrlParams+='&fromModul='+fromModul;if(modulResourceId)printUrlParams+='&modulResourceId='+modulResourceId;if(desrequestid)printUrlParams+='&desrequestid='+desrequestid;if(fromCommunication)printUrlParams+='&fromCommunication='+fromCommunication;openFullWindowHaveBar(printurl+printUrlParams);});};//流程暂停
var doStop=exports.doStop=function doStop(){doFunctionLink("stop");};//流程撤销
var doCancel=exports.doCancel=function doCancel(){doFunctionLink("cancel");};//流程启用
var doRestart=exports.doRestart=function doRestart(){doFunctionLink("restart");};var doFunctionLink=function doFunctionLink(flag){var _base$globalStore2=_base2.default.globalStore,commonParam=_base$globalStore2.commonParam,submitParam=_base$globalStore2.submitParam;var openByDefaultBrowser=submitParam.openByDefaultBrowser;var requestid=commonParam.requestid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype;var content="";switch(flag){case'stop':content=(0,_convert.getLabel)(26156,'您确定要暂停当前流程吗？');break;case'cancel':content=(0,_convert.getLabel)(26157,'您确定要撤销当前流程吗 ？');break;case'restart':content=(0,_convert.getLabel)(26158,'您确定要启用当前流程吗？');break;}(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:content,okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){API_REQ.functionLink({flag:flag,requestid:requestid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,openByDefaultBrowser:openByDefaultBrowser}).then(function(data){Util.closeRequestPage(false);});}});};//强制收回
var doRetract=exports.doRetract=function doRetract(){(0,_globalUtil.verifyCustomRegisterEvent)(WfForm.OPER_TAKEBACK,function(){var globalStore=_base2.default.globalStore;var _base$globalStore3=_base2.default.globalStore,commonParam=_base$globalStore3.commonParam,submitParam=_base$globalStore3.submitParam,setPromptInfos=_base$globalStore3.setPromptInfos;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype;var openByDefaultBrowser=submitParam.openByDefaultBrowser;globalStore.setLoading(true);globalStore.setBtnDisabled(true);API_REQ.functionLink({flag:"rb",requestid:requestid,workflowid:workflowid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,openByDefaultBrowser:openByDefaultBrowser}).then(function(data){globalStore.setLoading(false);globalStore.setBtnDisabled(false);if(data.success){// getAntd().message.success(data.msg,undefined,()=>{
//     Util.reloadRequestPage({requestid});
// });
Util.reloadRequestPage({requestid:requestid,sessionkey:data.sessionkey});}else{var promptInfo={bottom:'',detail:data.msg,prompttype:'errormsg',title:(0,_convert.getLabel)(529720,'流程强制收回失败')};setPromptInfos(promptInfo);}});});};//强制归档
var doDrawBack=exports.doDrawBack=function doDrawBack(){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,baseParam=globalStore.baseParam,continuationProcessInfo=globalStore.continuationProcessInfo;var requestid=commonParam.requestid,needconfirm=commonParam.needconfirm;var drawBackFun=function drawBackFun(){(0,_globalUtil.verifyCustomRegisterEvent)(WfForm.OPER_FORCEOVER,function(){if((0,_signUtil.verifyRemark)({src:'arichive'})){var formDatas=(0,_submit.generateFormData)();//表单字段参数
var submitParam=globalStore.submitParam;var allParams=(0,_extends3.default)({},submitParam,formDatas,{flag:"ov",fromflow:1});globalStore.setLoading(true);globalStore.setBtnDisabled(true);API_REQ.functionLink(allParams).then(function(data){globalStore.setLoading(false);globalStore.setBtnDisabled(false);if(commonParam.belongTest){//流程测试直接刷页面
Util.reloadRequestPage({requestid:requestid});try{window.parent.window.workflowAutoTestUtil.returnStatus("SUCCESS",requestid);}catch(e){if(window.console)console.log(e);}}else if(data.isShowChart&&data.isShowChart=="1"){globalStore.setCloseNeedPrompt(false);var urlParam=(0,_objectAssign2.default)({},baseParam,{isfromtab:submitParam.isfromtab,showE9Pic:"1",isFromAutodirect:"1",isFromWfForm:true});Util.reloadListPage();//跳转流程图，拼接连续处理参数
Util.appendContinuationParams(urlParam);Util.gotoPage((window.ecologyContentPath||'')+'/workflow/request/WorkflowDirectionNew.jsp',urlParam);}else{Util.closeRequestPage(false);}});}});};if(needconfirm=='1'){(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(24703,'您确定将该流程强制归档吗？'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){drawBackFun();},onCancel:function onCancel(){return;}});}else{drawBackFun();}};//打印日志
var doPrintViewLog=exports.doPrintViewLog=function doPrintViewLog(){var globalStore=_base2.default.globalStore,printLogStore=_base2.default.printLogStore;var baseParam=globalStore.baseParam;var requestid=baseParam.requestid,f_weaver_belongto_userid=baseParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=baseParam.f_weaver_belongto_usertype;printLogStore.setBaseParams({requestid:requestid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype});printLogStore.setCloseEvent(function(){globalStore.controlDialogVisible(type.PRINT_LOG,false);});globalStore.controlDialogVisible(type.PRINT_LOG,true);};//新建任务列表
var openTaskList=exports.openTaskList=function openTaskList(){var requestid=_base2.default.globalStore.baseParam.requestid;openWin("/spa/workrelate/static/index.html#/main/workrelate/task/otherTastList?requestids="+requestid);};//新建任务
var doCreateTask=exports.doCreateTask=function doCreateTask(){var requestid=_base2.default.globalStore.baseParam.requestid;openWin("/spa/workrelate/static/index.html#/main/workrelate/task/taskAdd?requestids="+requestid);};var openWin=function openWin(url,showw,showh){if(showw==null||typeof showw=="undefined")showw=900;if(showh==null||typeof showh=="undefined")showh=520;var redirectUrl=url;var height=window.screen.height;var width=window.screen.width;var top=(height-showh)/2;var left=(width-showw)/2;var szFeatures="top="+top+",";szFeatures+="left="+left+",";szFeatures+="width="+showw+",";szFeatures+="height="+showh+",";szFeatures+="directories=no,";szFeatures+="status=yes,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);};//退回确认节点
var doReject_New=exports.doReject_New=function doReject_New(){if((0,_signUtil.verifyRemark)({src:'reject'})){var globalStore=_base2.default.globalStore,rejectStore=_base2.default.rejectStore;var commonParam=globalStore.commonParam;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,nodeid=commonParam.nodeid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype;API_REQ.judgeRejectWay({requestid:requestid,workflowid:workflowid,nodeid:nodeid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype}).then(function(data){var rejecttype=data.rejecttype,params=data.params;if(rejecttype===0){sureReject();}else if(rejecttype===1){var RejectToNodeid=params.RejectToNodeid,_params$newRejectNode=params.newRejectNodeIds,newRejectNodeIds=_params$newRejectNode===undefined?'':_params$newRejectNode;sureReject({'RejectToNodeid':RejectToNodeid,'newRejectNodeIds':newRejectNodeIds});}else if(rejecttype===2){//弹窗选择退回节点及提醒节点
rejectStore.setBaseParams(params);rejectStore.setChooseInfo(data.chooseInfo);var _RejectToNodeid=params.RejectToNodeid,_params$newRejectNode2=params.newRejectNodeIds,_newRejectNodeIds=_params$newRejectNode2===undefined?'':_params$newRejectNode2;rejectStore.setConfirmEvent(function(rejectParams){if(!_.isEmpty(rejectParams)){var _rejectParams$rejectN=rejectParams.rejectNodeKey,rejectNodeKey=_rejectParams$rejectN===undefined?"":_rejectParams$rejectN,_rejectParams$remindN=rejectParams.remindNodeid,remindNodeid=_rejectParams$remindN===undefined?"":_rejectParams$remindN,_rejectParams$isSubmi=rejectParams.isSubmitDirect,isSubmitDirect=_rejectParams$isSubmi===undefined?"":_rejectParams$isSubmi;var appendParams={'RejectNodes':remindNodeid,'isSubmitDirect':isSubmitDirect};if(rejectNodeKey){var rejectNodeArr=rejectNodeKey.split("_");appendParams['RejectToNodeid']=rejectNodeArr[0];appendParams['RejectToType']=rejectNodeArr[1];}if(_RejectToNodeid){appendParams['RejectToNodeid']=_RejectToNodeid;}if(_newRejectNodeIds)appendParams['newRejectNodeIds']=_newRejectNodeIds;sureReject(appendParams);}globalStore.controlDialogVisible(type.REJECT_CHOOSE,false);});rejectStore.setCancelEvent(function(){globalStore.controlDialogVisible(type.REJECT_CHOOSE,false);});globalStore.controlDialogVisible(type.REJECT_CHOOSE,true);//需最后显示弹窗
}});}};//流程退回
var sureReject=exports.sureReject=function sureReject(){var rejectParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _base$globalStore4=_base2.default.globalStore,commonParam=_base$globalStore4.commonParam,changeSubmitParam=_base$globalStore4.changeSubmitParam;var needconfirm=commonParam.needconfirm;var params=(0,_objectAssign2.default)({},{src:"reject",actiontype:"requestOperation",'isFirstSubmit':'0'},rejectParams);changeSubmitParam({SubmitToNodeid:''});//退回不需要传递指定节点
if(needconfirm=="1")_.merge(params,{src:"save",isaffirmance:"1",isaffirmanceSrc:"reject",type:'save'});(0,_submit.doSubmitReady)(params);};//表单修改日志
var doViewModifyLog=exports.doViewModifyLog=function doViewModifyLog(){var globalStore=_base2.default.globalStore;globalStore.controlDialogVisible(type.FORM_MODIFY_LOG,true);};//流程删除
var doDelete=exports.doDelete=function doDelete(){var data="";var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;var requestid=_base2.default.globalStore.baseParam.requestid;var flag="0";//表示创建人删除单个流程。
var params={requestid:requestid,flag:flag};WeaTools.callApi('/api/workflow/reqform/delRequestVerify','POST',params).then(function(reVal){(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:reVal.mainrequestid==-1?(0,_convert.getLabel)(16667,' 你确定删除该工作流吗？ '):(0,_convert.getLabel)(533834,'当前流程为')+'：【'+reVal.requestname+'（'+reVal.mainrequestid+'）】,'+(0,_convert.getLabel)(533835,'触发的子流程，确定删除该工作流吗？'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){(0,_globalUtil.verifyCustomRegisterEvent)(WfForm.OPER_DELETE,function(){(0,_submit.doSubmitPost)({src:"delete",actiontype:"requestOperation"});});}});});};//提交
var doSubmitDirect=exports.doSubmitDirect=function doSubmitDirect(subfun){var globalStore=_base2.default.globalStore,secondAuthStore=_base2.default.secondAuthStore;var submitParam=globalStore.submitParam,rightMenu=globalStore.rightMenu,setSubmitToNodeId=globalStore.setSubmitToNodeId;var ifchangstatus=submitParam.ifchangstatus;var hasback=rightMenu.hasback,hasnoback=rightMenu.hasnoback,lastnodeid=rightMenu.lastnodeid;setSubmitToNodeId(true);secondAuthStore.setIsSubmitDirect(1);if(ifchangstatus!=""&&(hasback=="1"||hasback==""&&hasnoback=="")){if(subfun=="Affirmance"){doAffirmanceBack();}else{doSubmitBack();}}else{if(subfun=="Affirmance"){doAffirmanceNoBack();}else{doSubmitNoBack();}}};//转发、意见征询、转办等
var controlForward=exports.controlForward=function controlForward(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var forwardflag=params.forwardflag;var opertype=WfForm.OPER_FORWARD;if(forwardflag=="2")opertype=WfForm.OPER_ASKOPINION;else if(forwardflag=="3")opertype=WfForm.OPER_TURNHANDLE;else if(forwardflag=="4")opertype=WfForm.OPER_TURNREAD;else if(forwardflag=="5")opertype=WfForm.OPER_TAKFROWARD;(0,_globalUtil.verifyCustomRegisterEvent)(opertype,function(){var _base$globalStore5=_base2.default.globalStore,commonParam=_base$globalStore5.commonParam,submitParam=_base$globalStore5.submitParam,changeSubmitParam=_base$globalStore5.changeSubmitParam,setTabKey=_base$globalStore5.setTabKey,batchControlVariableMap=_base$globalStore5.batchControlVariableMap,controlDialogVisible=_base$globalStore5.controlDialogVisible,loadRightMenu=_base$globalStore5.loadRightMenu;var requestid=commonParam.requestid,nodeid=commonParam.nodeid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,workflowid=commonParam.workflowid;var agentType=submitParam.agentType,agentorByAgentId=submitParam.agentorByAgentId;params.requestid=requestid;params.nodeid=nodeid;params.workflowid=workflowid;params.fromform=true;params['f_weaver_belongto_userid']=f_weaver_belongto_userid;params['f_weaver_belongto_usertype']=f_weaver_belongto_usertype;params.agentType=agentType;params.agentorByAgentId=agentorByAgentId;var actions={'changeSubmitParam':changeSubmitParam,'setTabKey':setTabKey,'batchControlVariableMap':batchControlVariableMap,'controlDialogVisible':controlDialogVisible,'closeRequestPage':Util.closeRequestPage,'refreshRightMenu':loadRightMenu};batchControlVariableMap({'forwardParams':params,'callBackActions':actions,'isRelaodLogList':false});controlDialogVisible('isShowForwardDialog',true);});};//转发
var doReviewE9=exports.doReviewE9=function doReviewE9(){var destuserid=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';controlForward({showForward:true,forwardflag:"1",forwardOperators:destuserid});};//传阅
var doChuanyue=exports.doChuanyue=function doChuanyue(){var destuserid=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';controlForward({showForward:true,forwardflag:"4"});};//转发收回
var doReviewE9Back=exports.doReviewE9Back=function doReviewE9Back(){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,batchControlVariableMap=globalStore.batchControlVariableMap,_controlDialogVisible=globalStore.controlDialogVisible,loadRightMenu=globalStore.loadRightMenu;var requestid=commonParam.requestid;var actions={'refreshRightMenu':function refreshRightMenu(){//loadRightMenu({}); //刷新右键菜单
Util.reloadRequestPage({requestid:requestid});},"controlDialogVisible":function controlDialogVisible(isShow){_controlDialogVisible(type.FORWARD_BACK,isShow);// 关闭收回弹框
},'batchControlVariableMap':null//batchControlVariableMap,
};batchControlVariableMap({'callBackActions':actions});_controlDialogVisible(type.FORWARD_BACK,true);};/**
 * 意见征询收回
 */var doTakeBack=exports.doTakeBack=function doTakeBack(){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,submitParam=globalStore.submitParam;var requestid=commonParam.requestid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,workflowid=commonParam.workflowid;var agentType=submitParam.agentType,takisremark=submitParam.takisremark,agentorByAgentId=submitParam.agentorByAgentId,openByDefaultBrowser=submitParam.openByDefaultBrowser;API_REQ.doTakeBack({workflowid:workflowid,requestId:requestid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,agentType:agentType,takisremark:takisremark,agentorByAgentId:agentorByAgentId,openByDefaultBrowser:openByDefaultBrowser}).then(function(reVal){if(reVal.success){(0,_convert.getAntd)().message.success(reVal.msg);}else{(0,_convert.getAntd)().message.error(reVal.msg);}setTimeout(function(){Util.reloadRequestPage({requestid:requestid});},1500);});};//转办需反馈
var doReviewback3=exports.doReviewback3=function doReviewback3(resourceid){controlForward({showForward:true,forwardflag:"3",needwfback:"1"});};//转办
var doReview3=exports.doReview3=function doReview3(resourceid){controlForward({showForward:true,forwardflag:"3"});};//意见征询
var doReview2=exports.doReview2=function doReview2(resourceid){controlForward({showForward:true,forwardflag:"2"});};//多级意见征询
var doMultiTak=exports.doMultiTak=function doMultiTak(resourceid){controlForward({showForward:true,forwardflag:"2",isMulitTak:true});};//征询转办需反馈
var doTakForward_Back=exports.doTakForward_Back=function doTakForward_Back(resourceid){controlForward({showForward:true,forwardflag:"5",needwfback:'1'});};//征询转办不需反馈
var doTakForward_noBack=exports.doTakForward_noBack=function doTakForward_noBack(resourceid){controlForward({showForward:true,forwardflag:"5",needwfback:'0'});};//结束征询
var doTakEnd=exports.doTakEnd=function doTakEnd(){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,submitParam=globalStore.submitParam,_globalStore$rightMen=globalStore.rightMenu,rightMenu=_globalStore$rightMen===undefined?{}:_globalStore$rightMen;var _rightMenu$rightMenuN=rightMenu.rightMenuNames,rightMenuNames=_rightMenu$rightMenuN===undefined?{}:_rightMenu$rightMenuN;var requestid=commonParam.requestid,workflowid=commonParam.workflowid;var agentType=submitParam.agentType,agentorByAgentId=submitParam.agentorByAgentId,openByDefaultBrowser=submitParam.openByDefaultBrowser,f_weaver_belongto_userid=submitParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=submitParam.f_weaver_belongto_usertype;var label=(0,_convert.getLabel)(510675,'确定要结束意见征询吗？');if(rightMenuNames['TAKEND_0']){label=(0,_convert.getLabel)(519120,'确定要{1}吗？').replace("{1}",rightMenuNames['TAKEND_0']);}(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),content:label,onOk:function onOk(){API_REQ.doTakEnd({requestid:requestid,workflowid:workflowid,agentType:agentType,agentorByAgentId:agentorByAgentId,openByDefaultBrowser:openByDefaultBrowser,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype}).then(function(data){if(!data.result&&data.msg){(0,_convert.getAntd)().Modal.warning({content:data.msg,okText:(0,_convert.getLabel)(83446,'确定'),showClose:false,onOk:function onOk(){Util.reloadRequestPage({requestid:requestid});}});}else{Util.reloadRequestPage({requestid:requestid});}});}});};//转办不需反馈
var doReviewnoback3=exports.doReviewnoback3=function doReviewnoback3(resourceid){controlForward({showForward:true,forwardflag:"3",needwfback:"0"});};var doTd253574=exports.doTd253574=function doTd253574(){var funParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _funParams$forwardOpe=funParams.forwardOperators,forwardOperators=_funParams$forwardOpe===undefined?'':_funParams$forwardOpe;var params={showForward:true,forwardflag:"1",forwardOperators:forwardOperators,feedbacksign:"4"};controlForward(params);};//超时设置
var onNewOverTime=exports.onNewOverTime=function onNewOverTime(){var globalStore=_base2.default.globalStore,overTimeStore=_base2.default.overTimeStore;var baseParam=globalStore.baseParam;overTimeStore.setBaseParams(baseParam);overTimeStore.setCloseEvent(function(){globalStore.controlDialogVisible(type.OVERTIME_SETTING,false);});globalStore.controlDialogVisible(type.OVERTIME_SETTING,true);};//撤回
var doWithdraw=exports.doWithdraw=function doWithdraw(){var destuserid=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var globalStore=_base2.default.globalStore,requestWithdrawStore=_base2.default.requestWithdrawStore;var baseParam=globalStore.baseParam;requestWithdrawStore.doInit(baseParam);requestWithdrawStore.setCloseEvent(function(){globalStore.controlDialogVisible(type.WORKFLOW_WITHDRAW,false);});globalStore.controlDialogVisible(type.WORKFLOW_WITHDRAW,true);};//新建流程
var onNewRequest=exports.onNewRequest=function onNewRequest(workflowid,requestid,agent){var belongUserStr=_base2.default.globalStore.belongUserStr;var urlParam='workflowid='+workflowid+'&isagent='+agent+'&reqid='+requestid+belongUserStr;openFullWindowHaveBar((window.ecologyContentPath||'')+'/workflow/request/CreateRequestForward.jsp?'+urlParam);};/**
 * 新建流程
 * @param workflowid
 * @param requestid
 * @param nodeId
 * @param menuId
 */var onNewRequest2=exports.onNewRequest2=function onNewRequest2(workflowid,requestid,nodeId,menuId,requestType){var callFun=function callFun(){var urlParam='workflowid='+workflowid+'&reqid='+requestid+'&createFlowNodeid='+nodeId+'&nodecustomid='+menuId;openFullWindowHaveBar((window.ecologyContentPath||'')+'/workflow/request/CreateRequestForward.jsp?'+urlParam);Util.reloadRequestPage({requestid:requestid});};requestType!=0&&(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",saveCallFun:callFun,type:'save'});requestType==0&&callFun();};//新建短信
var onNewSms=exports.onNewSms=function onNewSms(wfid,nodeid,reqid,menuid,isurger){var globalStore=_base2.default.globalStore;var belongUserStr=globalStore.belongUserStr;var params={};if(isurger==1){//督办催办短信
params={src:'supervise',requestid:reqid};}else{params=(0,_extends3.default)({},belongUserStr,{workflowid:wfid,nodeid:nodeid,requestid:reqid,menuid:menuid});}globalStore.controlVariableMap(type.SEND_SMS_PARAMS,params);globalStore.controlDialogVisible(type.SEND_SMS,true);};//催办邮件
var onNewEmail=exports.onNewEmail=function onNewEmail(reqid){var globalStore=_base2.default.globalStore;API_REQ.getSendEmailInfo({requestid:reqid}).then(function(data){if(data.result){var params=data.fwquery||{};globalStore.controlVariableMap(type.SEND_MAIL_PARAMS,params);globalStore.controlDialogVisible(type.SEND_MAIL,true);}});};//新建微信
var onNewChats=exports.onNewChats=function onNewChats(wfid,nodeid,reqid,menuid){var belongUserStr=_base2.default.globalStore.belongUserStr;var urlParam='workflowid='+wfid+'&nodeid='+nodeid+'&reqid='+reqid+'&actionid=dialog&menuid='+menuid+belongUserStr;var dialog=new window.top.Dialog();dialog.currentWindow=window;dialog.Title=(0,_convert.getLabel)(32818,"新建微信 ");dialog.Width=1000;dialog.Height=350;dialog.Drag=true;dialog.maxiumnable=true;dialog.URL=(window.ecologyContentPath||'')+'/wechat/sendWechat.jsp?'+urlParam;dialog.show();};//关于版本
var aboutVersion=exports.aboutVersion=function aboutVersion(versionid){(0,_convert.getAntd)().Modal.warning({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(386181,'当前是')+"V"+versionid+"  "+(0,_convert.getLabel)(567,"版本"),okText:(0,_convert.getLabel)(826,'确定'),onOk:function onOk(){return;}});};//流转设定
var doFreeWorkflow=exports.doFreeWorkflow=function doFreeWorkflow(){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu,variableMap=globalStore.variableMap,batchControlVariableMap=globalStore.batchControlVariableMap,controlDialogVisible=globalStore.controlDialogVisible,baseParam=globalStore.baseParam;var iscreate=commonParam.iscreate,authSignatureStr=commonParam.authSignatureStr,authStr=commonParam.authStr,wfTestStr=commonParam.wfTestStr,belongTest=commonParam.belongTest,selectNextFlowPattern=commonParam.selectNextFlowPattern;var iscnodefree=rightMenu.iscnodefree,isFree=rightMenu.isFree,_rightMenu$freeNode=rightMenu.freeNode,freeNode=_rightMenu$freeNode===undefined?{}:_rightMenu$freeNode,isAllowNodeFreeFlow=rightMenu.isAllowNodeFreeFlow;if(iscreate=='1'&&selectNextFlowPattern!=0){window.localStorage.setItem('WfFormIsDefaultOpenFreeFlowSetDialog','1');(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",type:'save'});}else{if(selectNextFlowPattern==0){//简易模式 0才是建议模式
var tabKey=globalStore.tabKey,setTabKey=globalStore.setTabKey;if(tabKey!=="form"){setTabKey("form");setTimeout(function(){Util.scrollDom(".wf-req-freeWorkflowSimple",true,(0,_convert.getLabel)(520577,"请确认流转设定设置"));},500);}else{Util.scrollDom(".wf-req-freeWorkflowSimple",true,(0,_convert.getLabel)(520577,"请确认流转设定设置"));}}else{var _getEcCom2=(0,_convert.getEcCom)(),WeaTools=_getEcCom2.WeaTools;var chartParams=(0,_extends3.default)({},(0,_mobx.toJS)(baseParam),{isAllowNodeFreeFlow:isAllowNodeFreeFlow,isFree:isFree,authSignatureStr:authSignatureStr,authStr:authStr,wfTestStr:wfTestStr,'isFlowModel':0,'isReadOnlyModel':false,'showE9Pic':1,'isFromWfForm':true,belongTest:belongTest?1:0});var workflowFreeFlowSetDialog=WeaTools.createDialog({title:(0,_convert.getLabel)(21781,'流转设定'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',moduleName:"workflow",url:(window.ecologyContentPath||'')+'/workflow/workflowDesign/readOnly-index.html?'+Util.buildUrlStr(chartParams),style:{width:window.innerWidth*0.9,height:window.innerHeight*0.9},maxHeight:10000,callback:function callback(datas,dialog){(0,_convert.getAntd)().message.destroy();(0,_convert.getAntd)().message.success((0,_convert.getLabel)(83551,'保存成功！'));if(dialog)dialog.hide();var _datas$isNeedFlowFree=datas.isNeedFlowFreeNodeTips,isNeedFlowFreeNodeTips=_datas$isNeedFlowFree===undefined?false:_datas$isNeedFlowFree,_datas$canSubmitToRej=datas.canSubmitToRejectNode,canSubmitToRejectNode=_datas$canSubmitToRej===undefined?false:_datas$canSubmitToRej;batchControlVariableMap({'isNeedFlowFreeNodeTips':isNeedFlowFreeNodeTips,'canSubmitToRejectNode':canSubmitToRejectNode});},onCancel:function onCancel(a){var closeFunc=variableMap.get('FREE_FLOW_SET_CLOSE_FUNC');closeFunc&&closeFunc();}},undefined,function(dialog){var i=0;var timer=window.setInterval(function(){i++;var _dialog=workflowFreeFlowSetDialog;if(_dialog){_dialog.show();window.clearInterval(timer);}else{if(i>=3){window.clearInterval(timer);doFreeWorkflow();}}},500);});}}};/**
 *
 * @param subwfid
 * @param workflowNames
 * @param requestType 0：已办、1：待办
 */var triSubwf2=exports.triSubwf2=function triSubwf2(subwfid,workflowNames,requestType){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam;if(commonParam.belongTest){(0,_convert.getAntd)().Modal.warning({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(386182,"流程测试状态不允许手动触发子流程"),okText:(0,_convert.getLabel)(83446,'\u786E\u5B9A')});return;}workflowNames=workflowNames.replace(new RegExp(',',"gm"),'\n');(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),content:(0,_convert.getLabel)(25394,'确定触发')+":"+workflowNames+(0,_convert.getLabel)(386183,"流程吗?"),onOk:function onOk(){var callFun=function callFun(){globalStore.setLoading(true);var requestid=commonParam.requestid,nodeid=commonParam.nodeid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype;var params={requestId:requestid,nodeId:nodeid,paramSubwfSetId:subwfid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype};API_REQ.triggerSubWf(params).then(function(data){(0,_convert.getAntd)().Modal.warning({title:(0,_convert.getLabel)(131329,'信息确认'),content:data.msg,okText:(0,_convert.getLabel)(83446,'\u786E\u5B9A'),showClose:false,onOk:function onOk(){globalStore.setLoading(false);Util.reloadRequestPage({requestid:requestid});}});});};//先执行保存
requestType!=0&&(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",saveCallFun:callFun,type:'save'});requestType==0&&callFun();}});};var doAffirmanceBack=exports.doAffirmanceBack=function doAffirmanceBack(){_base2.default.globalStore.setSubmitToNodeId();(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",needwfback:"1",isaffirmance:"1"});};var doAffirmanceNoBack=exports.doAffirmanceNoBack=function doAffirmanceNoBack(){_base2.default.globalStore.setSubmitToNodeId();(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",needwfback:"0",isaffirmance:"1"});};// 加密分享
var doEncryptShare=exports.doEncryptShare=function doEncryptShare(){var commonParam=_base2.default.globalStore.commonParam;var requestid=commonParam.requestid;if(!window.setShare4ec){alert('PC端加密分享出现异常，请联系管理员');}window.setShare4ec({mouldCode:'WORKFLOW',// 模块名
itemCode:'SHAREBASE',// 功能项
targetid:requestid,// 加密对象，如流程或文档id
encrypt:'1'// 1.加密 0.解密
},function(data){console.log('doEncryptShare data',data);data.status=='1'&&doShare({serialid:data.serialid});});};// 分享到EM
var doShare=exports.doShare=function doShare(){var shareParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var isE9=true;if(isE9){var shareStore=_base2.default.shareStore,globalStore=_base2.default.globalStore;shareStore.setMsgInfo(shareParams);globalStore.controlDialogVisible(type.SHARE_WORKFLOW,true);}else{var commonParam=_base2.default.globalStore.commonParam;var requestid=commonParam.requestid,requestname=commonParam.requestname,requestnamenew=commonParam.requestnamenew;var returnjson='[{"sharetype":"workflow","sharetitle":"'+(requestnamenew?requestnamenew:requestname)+'","objectname":"FW:CustomShareMsg","shareid":"'+requestid+'"}]';var url=(window.ecologyContentPath||'')+'/social/im/SocialHrmBrowserForShare.jsp?sharejson='+encodeURIComponent(returnjson);var diag=new window.top.Dialog();diag.currentWindow=window;diag.Modal=true;diag.Drag=true;diag.Width=400;diag.Height=500;diag.ShowButtonRow=false;diag.Title=(0,_convert.getLabel)(129144,"分享");diag.URL=url;diag.openerWin=window;diag.show();document.body.click();}};//流程编辑
var doEdit=exports.doEdit=function doEdit(){var requestid=_base2.default.globalStore.commonParam.requestid;Util.reloadRequestPage({reEdit:"1",requestid:requestid});};//明细导入
var doImportDetail=exports.doImportDetail=function doImportDetail(){var _base$globalStore6=_base2.default.globalStore,commonParam=_base$globalStore6.commonParam,controlDialogVisible=_base$globalStore6.controlDialogVisible;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,nodeid=commonParam.nodeid;if(requestid=="-1"){(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(21798,"流程数据还未保存，现在保存吗? "),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",saveType:"doImportDetail",type:'save'});}});}else{controlDialogVisible(type.IMPORT_WF_DETAIL_MODAL,true);}};//正式系统--改进建议
var openProductSuggest=exports.openProductSuggest=function openProductSuggest(){var url=(window.ecologyContentPath||'')+'/formmode/view/AddFormMode.jsp?mainid=0&modeId=125&formId=-290&type=1';var dialog=new window.top.Dialog();dialog.currentWindow=window;dialog.Width=1200;dialog.Height=600;dialog.Modal=true;dialog.Title=(0,_convert.getLabel)(128666,'改进建议');dialog.URL=url;dialog.isIframe=false;dialog.show();var hasinit=false;var count=1;try{var timer=setInterval(function(){var doc1=$(window.top.document).find("iframe[id^=_DialogFrame_]");if(doc1&&doc1.length>0){var doc2=$(doc1[0].contentWindow.document).find("iframe[name='tabcontentframe']");if(doc2&&doc2.length>0){var _tempdocument=doc2[0].contentWindow.document;if(_tempdocument){var hbbox=$(_tempdocument).find('.hbBox');if(hbbox&&hbbox.length>0){hasinit=true;hbbox.css("padding","10px 40px");}}}}if(hasinit||count>20){clearInterval(timer);}count++;},20);}catch(e){}};//返回到待办
var doBack=exports.doBack=function doBack(){var globalStore=_base2.default.globalStore;globalStore.setCloseNeedPrompt(true);window.location.href=(window.ecologyContentPath||'')+'/spa/workflow/index_mobx.jsp#/main/workflow/listDoing';};//表单导出
var toExcel=exports.toExcel=function toExcel(){localStorage.setItem("fun",window.onbeforeunload);window.onbeforeunload=null;(0,_formExport.getStyleJson)().then(function(value){API_REQ.getExportedExcel(value);});window.onbeforeunload=localStorage.getItem("fun");};/**
 * 自定义操作菜单
 * @param reqid
 * @param wfid
 * @param menuid
 * @param nodeid
 */var onCustomOpt=exports.onCustomOpt=function onCustomOpt(reqid,wfid,menuid,nodeid){var globalStore=_base2.default.globalStore;var commonParam=globalStore.commonParam,_globalStore$urlParam=globalStore.urlParams,urlParams=_globalStore$urlParam===undefined?{}:_globalStore$urlParam;var requestid=commonParam.requestid,wfmonitor=commonParam.wfmonitor,isurger=commonParam.isurger,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,isremark=commonParam.isremark;var ismonitor=wfmonitor?"1":"0";var urger=isurger?"1":"0";//controlDialogVisible(type.IMPORT_WF_DETAIL_MODAL,true);
//alert("onCustomOpt"+" menuid = "+menuid);
var params={requestId:reqid,nodeId:nodeid,workflowId:wfid,setid:menuid,ismonitor:ismonitor,urger:urger,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype};try{API_REQ.getCustomOperation(params).then(function(data){var hassave=data.ismustsave;if(requestid=="-1"&&hassave==='1'){//需要保存
(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(21798,"流程数据还未保存，现在保存吗? "),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"save",type:'save'});}});}else{var actioniserror=false;var datalist=data.CustomOperationFunList;var _loop=function _loop(){var opttype=datalist[i].cusopttype;//操作方式
var actionname=datalist[i].actionname;//url or actionname
var actiontype=datalist[i].actiontype;//opentype or actiontype
var actionfrom=datalist[i].actionfrom;//action
var tempuserid=datalist[i].userid;//userid
if(actioniserror){return'break';}if(opttype==='0'){//打开URL
actionname=getCustomOptUrlValues(actionname,tempuserid);if(actiontype==='0'){//新建页
window.open(actionname,'divpage');}else if(actiontype==='1'){//弹出页
//openFullWindowHaveBar
window.openFullWindowForXtable(actionname);//window.open(actionname,'diypage2',params);
}else if(actiontype==='2'){//当前页
//top.location.href = actionname;
(0,_convert.getAntd)().Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(18877,"流程还没保存，如果离开，将会丢失数据，真的要离开吗？ "),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){window.top.location.href=actionname;}});return'break';}}else if(opttype==='1'){if((isremark==='2'||isremark==='4')&&actiontype!='0'&&actiontype!='3'&&actiontype!='10'){(0,_convert.getAntd)().message.error((0,_convert.getLabel)(132382,'没有权限，无法操作'),3);return'continue';}//流程相关操作
if(actiontype==='0'){//刷新表单数据
if(reqid>0){globalStore.setLoading(false);Util.reloadRequestPage({requestid:reqid});}else{window.location.reload();}}else if(actiontype==='1'){//"提交/批准"
(0,_submit.doSubmitForm)({actiontype:"requestOperation",src:"submit",needwfback:"1"});}else if(actiontype==='2'){//"提交至退回节点"
undefined.doSubmitDirect('submit');}else if(actiontype==='3'){//"转发"
//this.controlForward({'forwardflag': '1'});
doReviewE9();}else if(actiontype==='4'){//"保存"
undefined.doSave_nNew(false);}else if(actiontype==='5'){//"退回"
undefined.doReject_New();}else if(actiontype==='6'){//"转办"
//this.controlForward({'forwardflag': '3'});
doReview3();}else if(actiontype==='7'){//"意见征询"
//this.controlForward({'forwardflag': '2'});
doReview2();}else if(actiontype==='8'){//"超时设置"
onNewOverTime();}else if(actiontype==='9'){//"强制归档"
undefined.doDrawBack();}else if(actiontype==='10'){//"强制收回"
undefined.doRetract();}else if(actiontype==='11'){//传阅
//this.controlForward({'forwardflag': '4'});
doChuanyue();}}else if(opttype==='2'){//字段赋值
//TODO
}else if(opttype==='3'){//附加操作
var params1={requestId:reqid,nodeId:nodeid,workflowId:wfid,setid:menuid,actiontype:actiontype,actionname:actionname,actionfrom:actionfrom,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype};API_REQ.runCustomOperationAction(params1).then(function(actiondata){var flag=actiondata.CustomOperationActionResult.returnflag;var msg=actiondata.CustomOperationActionResult.returnmsg;if(flag==='false'){(0,_convert.getAntd)().message.error(msg,3);actioniserror=true;//出现异常后 后面的不执行
}else{(0,_convert.getAntd)().message.success(msg,2);}});}};_loop2:for(var i in datalist){var _ret=_loop();switch(_ret){case'break':break _loop2;case'continue':continue;}}}});}catch(e){if(window.console)console.log(e);}};var getCustomOptUrlValues=function getCustomOptUrlValues(url,userid){var commonParam=_base2.default.globalStore.commonParam;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,nodeid=commonParam.nodeid,formid=commonParam.formid;var regex=/\{[^\}]+\}/;//console.log("url = "+url);
try{while(regex.test(url)){//console.log("url = "+url);
var str=regex.exec(url)[0];var e="";//console.log("解析："+str);
if(str!=''&&str!='{}'){var strnew=str.replace(new RegExp("\\{","g"),"").replace(new RegExp("\\}","g"),"");//console.log("str = "+str);
if(strnew=='requestid'){e=requestid;}else if(strnew=='workflowid'){e=workflowid;}else if(strnew=='nodeid'){e=nodeid;}else if(strnew=='userid'){e=userid;}else if(strnew=='formid'){e=formid;}else{try{e=WfForm.getFieldValue("field"+strnew);}catch(e){e="";}//console.log("strnew = "+strnew+" e = "+e);
}try{url=url.replace(new RegExp("\\{"+strnew+"\\}","g"),e);}catch(e){//console.log(e);
}}}}catch(e){}//console.log(url);
return url;};var doImportWorkflow=exports.doImportWorkflow=function doImportWorkflow(){if(window.ImportWfBrowser&&window.ImportWfBrowser.openModal){window.ImportWfBrowser.openModal();}};var onDocCompare=exports.onDocCompare=function onDocCompare(docId,rightDocId,authStr,authSignatureStr){var docIdParm=typeof docId=="undefined"?'?docId':'?docId='+docId;var rightDocIdParm=typeof rightDocId=="undefined"?'&rightDocId':'&rightDocId='+rightDocId;// window.location.href = `/spa/compared/static/index.html#/main/compared/contractCompared${docIdParm}${rightDocIdParm}`;
openFullWindowHaveBar('/spa/compared/static/index.html#/main/compared/contractCompared'+docIdParm+rightDocIdParm+'&authStr='+authStr+'&authSignatureStr='+authSignatureStr);};var doModifyStyle=exports.doModifyStyle=function doModifyStyle(parm){var globalStore=_base2.default.globalStore;globalStore.controlDialogVisible(type.FREE_FLOW_CHANGESTYLE,true);var parm1={fromwhere:"init",layoutid:-1,layouttype:0,wfinitSetting:1,redirectUrl:'',wfid:globalStore.submitParam.workflowid||'',nodeid:globalStore.submitParam.nodeid||'',configid:globalStore.submitParam.configid||'',dialogTitlename:parm.formname||'',doModify:'1'};window.doBSExcelDesignAction&&window.doBSExcelDesignAction.openInitDialog(parm1);};var doModifyForm=exports.doModifyForm=function doModifyForm(parm){var globalStore=_base2.default.globalStore;var parm1={fromwhere:"init",layoutid:-1,layouttype:0,wfinitSetting:1,redirectUrl:'',wfid:globalStore.submitParam.workflowid||'',nodeid:globalStore.submitParam.nodeid||'',configid:globalStore.submitParam.configid||'',dialogTitlename:'',doModify:'1'};var _base$globalStore7=_base2.default.globalStore,setFreeflowChangeformParm=_base$globalStore7.setFreeflowChangeformParm,getFreeNodeBrowserItem=_base$globalStore7.getFreeNodeBrowserItem;getFreeNodeBrowserItem(parm1);//获取浏览按钮框
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getHostURLencode=exports.getHostURL=exports.filterRequest4Forward=exports.filterRequestAction=exports.closeAuthDetail=exports.showAuthDetail=exports.closeAuthDialog=exports.showAuthDialog=undefined;var _toConsumableArray2=__webpack_require__(82);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _set=__webpack_require__(130);var _set2=_interopRequireDefault(_set);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _convert=__webpack_require__(6);var _trim=__webpack_require__(112);var _trim2=_interopRequireDefault(_trim);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);var _requestActions=__webpack_require__(488);var actions=_interopRequireWildcard(_requestActions);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var showAuthDialog=exports.showAuthDialog=function showAuthDialog(authType){var globalStore=_base2.default.globalStore;globalStore.controlDialogVisible(authType,true);};var closeAuthDialog=exports.closeAuthDialog=function closeAuthDialog(authType){var globalStore=_base2.default.globalStore;globalStore.controlDialogVisible(authType,false);};var showAuthDetail=exports.showAuthDetail=function showAuthDetail(){var globalStore=_base2.default.globalStore;globalStore.controlDialogVisible(authTypes.AUTH_DETAIL_DIALOG,true);};var closeAuthDetail=exports.closeAuthDetail=function closeAuthDetail(){globalStore.controlDialogVisible(authTypes.AUTH_DETAIL_DIALOG,false);};var filterRequestAction=exports.filterRequestAction=function filterRequestAction(submitFuncParams,submitParam,authActions){var filterResult=false;var authActionset=new _set2.default([].concat((0,_toConsumableArray3.default)(authActions)));var src=submitFuncParams.src,actiontype=submitFuncParams.actiontype,_submitFuncParams$isa=submitFuncParams.isaffirmance,isaffirmance=_submitFuncParams$isa===undefined?'':_submitFuncParams$isa;var secondAuthStore=_base2.default.secondAuthStore;var _secondAuthStore$isSe=secondAuthStore.isSecondAuthPop,isSecondAuthPop=_secondAuthStore$isSe===undefined?false:_secondAuthStore$isSe;if(!isSecondAuthPop){//公文自由流程特殊处理
var odocBtnFlag=submitParam.odocBtnFlag,_submitParam$isOdocRe=submitParam.isOdocRequest,isOdocRequest=_submitParam$isOdocRe===undefined?"":_submitParam$isOdocRe;if(actiontype=="requestOperation"){if(src=="submit"&&!(isOdocRequest=="1"&&odocBtnFlag=="odocReject")){var _secondAuthStore=_base2.default.secondAuthStore;var isSubmitDirect=_secondAuthStore.isSubmitDirect;if(isSubmitDirect==1){//提交至退回节点
if(authActionset.has(actions.REQUEST_SUBMIT_BACK_NODE)){filterResult=true;}}else{//提交/批准
if(authActionset.has(actions.REQUEST_APPROVAL)){filterResult=true;}}}else if(src=="save"&&authActionset.has(actions.REQUEST_SAVE)&&isaffirmance!='1'){//保存
filterResult=true;}else if((src=="reject"||isOdocRequest=="1"&&odocBtnFlag=="odocReject")&&authActionset.has(actions.REQUEST_REJECT)){//退回
filterResult=true;}}else if(actiontype=="remarkOperation"){if(src=="save"){//批注
var isremark=submitParam.isremark,takisremark=submitParam.takisremark;if(isremark==1){if(takisremark==2){//意见征询批注
if(authActionset.has(actions.REQUEST_TPOSTIL)){filterResult=true;}}else{//转发批注
if(authActionset.has(actions.REQUEST_POSTIL)){filterResult=true;}}}else if(isremark==9){//抄送批注
if(authActionset.has(actions.REQUEST_RPOSTIL)){filterResult=true;}}}}}return filterResult;};var filterRequest4Forward=exports.filterRequest4Forward=function filterRequest4Forward(submitFuncParams,submitParam,authActions){var filterResult=false;var authActionset=new _set2.default([].concat((0,_toConsumableArray3.default)(authActions)));var forwardflag=submitFuncParams.forwardflag;if(forwardflag=="1"){//转发
if(authActionset.has(actions.REQUEST_FORWARD)){filterResult=true;}}else if(forwardflag=="2"){//意见征询
if(authActionset.has(actions.REQUEST_TAKING_OPINIONS)){filterResult=true;}}else if(forwardflag=="3"){if(authActionset.has(actions.REQUEST_HANDLE_FORWARD)){//转办
filterResult=true;}}return filterResult;};var getHostURL=exports.getHostURL=function getHostURL(){var hostURL="";if(window.location.origin){hostURL=window.location.origin;}else if(window.location.protocol&&window.location.host){hostURL=window.location.protocol+'//'+window.location.host;}return hostURL;};var getHostURLencode=exports.getHostURLencode=function getHostURLencode(){var Base64=(0,_convert.getEcCom)().WeaTools.Base64;return Base64.encode(getHostURL());// return window.encodeURI(getHostURL());
};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_87__;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) {
            return false;
        }
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
        }
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') {
            return false;
        }
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !==
            'abcdefghijklmnopqrst') {
            return false;
        }
        return true;
    }
    catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
            }
        }
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                }
            }
        }
    }
    return to;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(90)('keys');
var uid = __webpack_require__(71);
module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(13);
var global = __webpack_require__(20);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: core.version,
    mode: __webpack_require__(60) ? 'pure' : 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var document = __webpack_require__(20).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
    return is ? document.createElement(it) : {};
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
    if (!isObject(it))
        return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))
        return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))
        return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))
        return val;
    throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf').split(',');


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(32).f;
var has = __webpack_require__(41);
var TAG = __webpack_require__(31)('toStringTag');
module.exports = function (it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG))
        def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(308);
var global = __webpack_require__(20);
var hide = __webpack_require__(42);
var Iterators = __webpack_require__(93);
var TO_STRING_TAG = __webpack_require__(31)('toStringTag');
var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
    'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
    'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
    'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
    'TextTrackList,TouchList').split(',');
for (var i = 0; i < DOMIterables.length; i++) {
    var NAME = DOMIterables[i];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG])
        hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 97 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(326), __esModule: true };


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(36);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(199);
var anObject = __webpack_require__(34);
var toLength = __webpack_require__(75);
var getIterFn = __webpack_require__(150);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
    var f = ctx(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function')
        throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if (isArrayIter(iterFn))
        for (length = toLength(iterable.length); length > index; index++) {
            result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
            if (result === BREAK || result === RETURN)
                return result;
        }
    else
        for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN)
                return result;
        }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(346), isObjectLike = __webpack_require__(45);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () { return arguments; }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(43), stubFalse = __webpack_require__(347);
/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)(module)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(402);
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? (remainder ? result - remainder : result) : 0;
}
module.exports = toInteger;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(235), baseAssignValue = __webpack_require__(169);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
        var key = props[index];
        var newValue = customizer
            ? customizer(object[key], source[key], key, object, source)
            : undefined;
        if (newValue === undefined) {
            newValue = source[key];
        }
        if (isNew) {
            baseAssignValue(object, key, newValue);
        }
        else {
            assignValue(object, key, newValue);
        }
    }
    return object;
}
module.exports = copyObject;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var domelementtype_1 = __webpack_require__(566);
function isTag(node) {
    return domelementtype_1.isTag(node);
}
exports.isTag = isTag;
function isCDATA(node) {
    return node.type === "cdata" /* CDATA */;
}
exports.isCDATA = isCDATA;
function isText(node) {
    return node.type === "text" /* Text */;
}
exports.isText = isText;
function isComment(node) {
    return node.type === "comment" /* Comment */;
}
exports.isComment = isComment;
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(23) && !__webpack_require__(37)(function () {
    return Object.defineProperty(__webpack_require__(91)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(34);
var dPs = __webpack_require__(307);
var enumBugKeys = __webpack_require__(94);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
var Empty = function () { };
var PROTOTYPE = 'prototype';
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = __webpack_require__(91)('iframe');
    var i = enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    __webpack_require__(193).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (i--)
        delete createDict[PROTOTYPE][enumBugKeys[i]];
    return createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    }
    else
        result = createDict();
    return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(41);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(141)(false);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
module.exports = function (object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O)
        if (key != IE_PROTO)
            has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i)
        if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
        }
    return result;
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {



/***/ }),
/* 109 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
    var Ctor = value && value.constructor, proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
    return value === proto;
}
module.exports = isPrototype;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = function (module) {
    if (!module.webpackPolyfill) {
        module.deprecate = function () { };
        module.paths = [];
        // module.parent = undefined by default
        if (!module.children)
            module.children = [];
        Object.defineProperty(module, "loaded", {
            enumerable: true,
            get: function () {
                return module.l;
            }
        });
        Object.defineProperty(module, "id", {
            enumerable: true,
            get: function () {
                return module.i;
            }
        });
        module.webpackPolyfill = 1;
    }
    return module;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(348), baseUnary = __webpack_require__(161), nodeUtil = __webpack_require__(162);
/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(209), baseTrim = __webpack_require__(211), castSlice = __webpack_require__(350), charsEndIndex = __webpack_require__(351), charsStartIndex = __webpack_require__(354), stringToArray = __webpack_require__(355), toString = __webpack_require__(214);
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
    string = toString(string);
    if (string && (guard || chars === undefined)) {
        return baseTrim(string);
    }
    if (!string || !(chars = baseToString(chars))) {
        return string;
    }
    var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
    return castSlice(strSymbols, start, end).join('');
}
module.exports = trim;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(67), isObjectLike = __webpack_require__(45);
/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
}
module.exports = isSymbol;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
        start = -start > length ? 0 : (length + start);
    }
    end = end > length ? length : end;
    if (end < 0) {
        end += length;
    }
    length = start > end ? 0 : ((end - start) >>> 0);
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
        result[index] = array[index + start];
    }
    return result;
}
module.exports = baseSlice;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(212), baseIsNaN = __webpack_require__(352), strictIndexOf = __webpack_require__(353);
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
    return value === value
        ? strictIndexOf(array, value, fromIndex)
        : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(117), stackClear = __webpack_require__(365), stackDelete = __webpack_require__(366), stackGet = __webpack_require__(367), stackHas = __webpack_require__(368), stackSet = __webpack_require__(369);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(360), listCacheDelete = __webpack_require__(361), listCacheGet = __webpack_require__(362), listCacheHas = __webpack_require__(363), listCacheSet = __webpack_require__(364);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(78);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
        if (eq(array[length][0], key)) {
            return length;
        }
    }
    return -1;
}
module.exports = assocIndexOf;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(66);
/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(378);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
}
module.exports = getMapData;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
        array[offset + index] = values[index];
    }
    return array;
}
module.exports = arrayPush;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(113);
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
        return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}
module.exports = toKey;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
    return value;
}
module.exports = identity;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(464), __esModule: true };


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.controlSecFieldOptions=exports.getSecAndValidity=exports.getSecLevelInfo=exports.getSecLevel=exports.loadManagerSecLevelInfo=exports.changeSecLevelInfo=undefined;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _formatUtil=__webpack_require__(126);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//修改密级，统一入口，同时修改secLevelInfo和mainData
var changeSecLevelInfo=exports.changeSecLevelInfo=function changeSecLevelInfo(level,validity){var globalStore=_source2.default.globalStore;var setSecLevelInfo=globalStore.setSecLevelInfo;setSecLevelInfo({secLevel:level});var fieldObj=FieldUtil.getFieldObj("field-10","main");if(fieldObj)fieldObj.changeValueObj({value:level});if(typeof validity!=="undefined")setSecLevelInfo({secValidity:validity});//传参数才修改密级期限
};//表单加载时处理密级信息
var loadManagerSecLevelInfo=exports.loadManagerSecLevelInfo=function loadManagerSecLevelInfo(){var _src$globalStore=_source2.default.globalStore,commonParam=_src$globalStore.commonParam,_src$globalStore$secL=_src$globalStore.secLevelInfo,secLevelInfo=_src$globalStore$secL===undefined?{}:_src$globalStore$secL,controlVariableMap=_src$globalStore.controlVariableMap;var isOpenSec=secLevelInfo.isOpenSec;var _src$layoutStore=_source2.default.layoutStore,cellInfo=_src$layoutStore.cellInfo,tableInfo=_src$layoutStore.tableInfo;if(!isOpenSec)return;var viewAttr=tableInfo.main.fieldinfomap["-10"].viewattr;if(commonParam.iscreate=="1"&&_.has(cellInfo,["fieldCellInfo","-10"])&&viewAttr>1){//密级字段放入模版情况，创建默认为空
changeSecLevelInfo("","");}else{var secLevel=secLevelInfo.secLevel,secValidity=secLevelInfo.secValidity;secLevelInfo.secValidityMap[secLevel]=secValidity;//有默认值的，同步到maindata，避免升级后代码块从maindata获取不到
var fieldObj=FieldUtil.getFieldObj("field-10","main");if(fieldObj)fieldObj.changeValueObj({value:secLevelInfo.secLevel});if(secLevel!==""){controlVariableMap("miniWfSecLevel",secLevel);}}};//获取当前密级值，统一从secLevelInfo获取
var getSecLevel=exports.getSecLevel=function getSecLevel(){return _source2.default.globalStore.secLevelInfo&&_source2.default.globalStore.secLevelInfo.secLevel||"";};//获取当前密级对象，统一从secLevelInfo获取
var getSecLevelInfo=exports.getSecLevelInfo=function getSecLevelInfo(){return _source2.default.globalStore.secLevelInfo&&_source2.default.globalStore.secLevelInfo||{};};//获取密级和密级期限
var getSecAndValidity=exports.getSecAndValidity=function getSecAndValidity(){var _src$globalStore$secL2=_source2.default.globalStore.secLevelInfo,secLevelInfo=_src$globalStore$secL2===undefined?{}:_src$globalStore$secL2;var secLevel=secLevelInfo.secLevel,secValidity=secLevelInfo.secValidity;if(!secLevel){return"";}else if(secLevel>2){return secLevel;}else if(secLevel<=2){return secLevel+"#"+secValidity;}};//根据输入的密级，限制密级字段中下拉选项
var controlSecFieldOptions=exports.controlSecFieldOptions=function controlSecFieldOptions(){var _src$globalStore2=_source2.default.globalStore,_src$globalStore2$sec=_src$globalStore2.secLevelInfo,secLevelInfo=_src$globalStore2$sec===undefined?{}:_src$globalStore2$sec,setSecLevelInfo=_src$globalStore2.setSecLevelInfo;var secLevel=secLevelInfo.secLevel;if(secLevel=="")return;if(secLevelInfo.secLevelOption){var newSecLevelInfo=secLevelInfo.secLevelOption.filter(function(item){return item.key<=secLevel;});setSecLevelInfo({secLevelOption:newSecLevelInfo});}};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatDate=exports.formatToDate=exports.convertFormatValue_sum=exports.convertFormatValue=undefined;var _common=__webpack_require__(10);var _inputUtil=__webpack_require__(81);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var convertFormatValue=exports.convertFormatValue=function convertFormatValue(realval,formatJSON){try{var formatval="";var numberType=parseInt(formatJSON["numberType"]);if(numberType===1){//1常规
}else if(numberType===2){//2数值
var transQfw=parseInt(formatJSON["thousands"]||0)===1;var transAbs=formatJSON["formatPattern"]=="3"||formatJSON["formatPattern"]=="4";if(parseInt(formatJSON["decimals"])<0){return realval;}formatval=(0,_inputUtil.convertFloatValue)(realval,parseInt(formatJSON["decimals"]),transQfw,transAbs);}else if(numberType===3){//3日期
formatval=formatToDate(realval,formatJSON["formatPattern"]);// formatval = WeaTools.formatDate(realval,formatJSON["formatPattern"]);
}else if(numberType===4){//4时间
formatval=formatToTime(realval,formatJSON["formatPattern"]);// formatval = WeaTools.formatTime(realval,formatJSON["formatPattern"]);
}else if(numberType===5){//5百分比
formatval=formatToPercent(realval,formatJSON["decimals"]);}else if(numberType===6){//6科学计数
formatval=formatToScience(realval,formatJSON["decimals"]);}else if(numberType===7){//7文本
}else if(numberType===8){//8特殊
formatval=formatToSpecial(realval,formatJSON["formatPattern"]);}return formatval===""?realval:formatval;//冗错，避免文本类型字段设置格式化为日期导致值不显示
}catch(e){if(window.console)console.log("format error:"+e);return realval;}};var convertFormatValue_sum=exports.convertFormatValue_sum=function convertFormatValue_sum(sum,fieldid){fieldid=fieldid.toString();var _src$layoutStore=_source2.default.layoutStore,fieldCellMap=_src$layoutStore.fieldCellMap,fieldAttrMap=_src$layoutStore.fieldAttrMap;if(!(fieldid in fieldCellMap))return sum;if(fieldAttrMap.has(fieldid)&&fieldAttrMap.get(fieldid).htmltype===1&&fieldAttrMap.get(fieldid).detailtype!==4){}else return sum;var formatVal=sum;var formatCfg={};var _fieldCellMap$fieldid=fieldCellMap[fieldid],_fieldCellMap$fieldid2=_fieldCellMap$fieldid.format,format=_fieldCellMap$fieldid2===undefined?{}:_fieldCellMap$fieldid2,_fieldCellMap$fieldid3=_fieldCellMap$fieldid.financial,financial=_fieldCellMap$fieldid3===undefined?"":_fieldCellMap$fieldid3;if(financial=="4"){//转财务千分位
formatCfg={numberType:2,decimals:2,formatPattern:2,thousands:1};}else if(format.numberType=="2"||format.numberType=="5"){//数值类型格式化
formatCfg=format;}if(!(0,_common.isEmpty)(formatCfg)){sum=sum.replace(/,/g,"");formatVal=convertFormatValue(sum,formatCfg);}return formatVal;};var formatToDate=exports.formatToDate=function formatToDate(realVal,formatPattern){var pattern=new RegExp("^\\d{2,4}-\\d{1,2}-\\d{1,2}$");if(!pattern.test(realVal)){return realVal;}/**
	 * formatPattern
	 * 1：yyyy/MM/dd
	 * 2：yyyy-MM-dd
	 * 3：yyyy年MM月dd日
	 * 4：yyyy年MM月
	 * 5：MM月dd日
	 * 6：EEEE
	 * 7：日期大写
	 * 8：yyyy/MM/dd hh:mm a
	 * 9：yyyy/MM/dd HH:mm
	 */var arr=realVal.split("-");var year=arr[0];var month=arr[1];var day=arr[2];if(parseInt(month)>12||parseInt(day)>31||parseInt(year)<=0||parseInt(month)<=0||parseInt(day)<=0){return realVal;}if(year.length==2)year="00"+year;if(year.length==3)year="0"+year;if(month.length==1)month="0"+month;if(day.length==1)day="0"+day;realVal=year+"-"+month+"-"+day;if(new Date(realVal).toString().indexOf("undefined")>-1){//解决IE下类似不存在的日期2014-9-31通过new Date无法生成日期问题，chrome下默认取的下一天
return realVal;}switch(parseInt(formatPattern)){case 1:return formatDate(new Date(realVal),"yyyy/MM/dd");case 2:return formatDate(new Date(realVal),"yyyy-MM-dd");case 3:return formatDate(new Date(realVal),"yyyy年MM月dd日");case 4:return formatDate(new Date(realVal),"yyyy年MM月");case 5:return formatDate(new Date(realVal),"MM月dd日");case 6:return formatDate(new Date(realVal),"wwww");case 7:return dataToChinese(new Date(realVal));case 8:return formatDate(new Date(realVal),"yyyy/MM/dd 12:00 a");case 9:return formatDate(new Date(realVal),"yyyy/MM/dd 00:00");default:return realVal;}};var formatDate=exports.formatDate=function formatDate(date,fmt){fmt=fmt||'yyyy-MM-dd HH:mm:ss';var obj={'y':date.getFullYear(),// 年份，注意必须用getFullYear
'M':date.getMonth()+1,// 月份，注意是从0-11
'd':date.getDate(),// 日期
'q':Math.floor((date.getMonth()+3)/3),// 季度
'w':date.getDay(),// 星期，注意是0-6
'H':12,// 24小时制
'h':12,// 12小时制
'm':0,// 分钟
's':0,// 秒
'S':0,// 毫秒
'a':'AM'};var week=['天','一','二','三','四','五','六'];for(var i in obj){fmt=fmt.replace(new RegExp(i+'+','g'),function(m){var val=obj[i]+'';if(i=='a')return val;if(i=='w')return(m.length>2?'星期':'周')+week[val];for(var j=0,len=val.length;j<m.length-len;j++){val='0'+val;}return m.length==1?val:val.substring(val.length-m.length);});}return fmt;};var dataToChinese=function dataToChinese(date){var arr=["〇","一","二","三","四","五","六","七","八","九"];var year=date.getFullYear();var month=date.getMonth()+1;var day=date.getDate();var tempYear=year.toString().split('').map(function(o){return arr[parseInt(o)];}).toString();return(tempYear+"年"+convertNumToChinese(month)+"月"+convertNumToChinese(day)+"日").replace(/\,/g,'');};var convertNumToChinese=function convertNumToChinese(num){var arr1=["","","二","三"];var arr2=["","一","二","三","四","五","六","七","八","九"];num=num<10?"0"+num.toString():num.toString();var first=parseInt(num.toString().split("")[0]);var second=parseInt(num.toString().split("")[1]);return arr1[first]+(first>0?"十":"")+arr2[second];};var formatToTime=function formatToTime(realVal,formatPattern){var pattern=new RegExp("^(\\d{1,2}:\\d{1,2})(:\\d{1,2})?$");if(!pattern.test(realVal)){return realVal;}/**
	 * formatPattern
	 * 1：HH:MI:SS
	 * 2：HH:MI:SS AM/PM
	 * 3：HH:MI
	 * 4：HH:MI AM/PM
	 * 5：HH时MI分SS秒
	 * 6：HH时MI分
	 * 7：HH时MI分SS秒 AM/PM
	 * 8：HH时MI分 AM/PM
	 **/var realValArr=realVal.split(":");var hour=realValArr[0];var minute=realValArr[1];var separatorChar=":";var suffix=parseInt(hour)<12?" AM":" PM";switch(parseInt(formatPattern)){case 1:return hour+separatorChar+minute+separatorChar+"00";case 2:return hour+separatorChar+minute+separatorChar+"00"+suffix;case 3:return hour+separatorChar+minute;case 4:return hour+separatorChar+minute+suffix;case 5:return hour+"时"+minute+"分00秒";case 6:return hour+"时"+minute+"分";case 7:return hour+"时"+minute+"分00秒"+suffix;case 8:return hour+"时"+minute+"分"+suffix;default:return realVal;}};var formatToPercent=function formatToPercent(realVal,decimals){//转百分比
var pattern=new RegExp("^(-?\\d+)(\\.\\d+)?$");if(!pattern.test(realVal)){return realVal;}return(0,_inputUtil.convertFloatValue)(Number(realVal)*100,parseInt(decimals),false)+"%";};var formatToScience=function formatToScience(realVal,decimals){//转科学计数
var pattern=new RegExp("^(-?\\d+)(\\.\\d+)?$");if(!pattern.test(realVal)){return realVal;}var result=Number(realVal).toExponential(decimals).toUpperCase();result=result.replace(/E(\+|-)(\d){1}$/,"E$10$2");//补零
return result;};var formatToSpecial=function formatToSpecial(realVal,formatPattern){var pattern=new RegExp("^(-?\\d{1,12})(\\.\\d+)?$");if(!pattern.test(realVal)){return realVal;}if(parseInt(formatPattern)===1){var digit=["〇","一","二","三","四","五","六","七","八","九"];var unit=[["","万","亿"],["","十","百","千"]];return specialTrans(realVal,digit,unit);}else{var _digit=["零","壹","贰","叁","肆","伍","陆","柒","捌","玖"];var _unit=[["","万","亿"],["","拾","佰","仟"]];return specialTrans(realVal,_digit,_unit);}};var specialTrans=function specialTrans(realVal,digit,unit){realVal=parseFloat(realVal).toString();if(parseFloat(realVal)===0){return digit[0];}var headfix="";var intPar_t="";var pointPar_t="";if(parseFloat(realVal)<0){realVal=realVal.substring(1);headfix="-";}var realValArr=realVal.split(".");var intPar=(0,_common.trim)(realValArr[0]);while(intPar.length>0&&parseInt(intPar[0])===0){intPar=intPar.substr(1);}var pointPar=realValArr.length===2?(0,_common.trim)(realValArr[1]):"";var lastflag=false;var intParArr=intPar.length>0?intPar.toString().split(''):[];var pointParArr=pointPar.length>0?pointPar.toString().split(''):[];var j=0;pointPar_t=pointPar.length>0?".":pointPar_t;pointParArr.map(function(v){pointPar_t=pointPar_t+digit[parseInt(v)];});for(var i=intParArr.length-1;i>=0;i--,j++){var v=parseInt(intParArr[i]);var m=j%4;if(m===0){lastflag=false;intPar_t=unit[0][j/4]+intPar_t;}if(v===0){if(lastflag&&intPar_t[0]!==digit[0]){intPar_t=digit[v]+intPar_t;}}else{lastflag=true;intPar_t=digit[v]+unit[1][m]+intPar_t;}}intPar_t=intPar_t.replace("亿万","亿");intPar_t=(0,_common.trim)(intPar_t).length===0?digit[0]:intPar_t;return headfix+intPar_t+pointPar_t;};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_127__;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(479);


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _promise = __webpack_require__(98);
var _promise2 = _interopRequireDefault(_promise);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (fn) {
    return function () {
        var gen = fn.apply(this, arguments);
        return new _promise2.default(function (resolve, reject) {
            function step(key, arg) {
                try {
                    var info = gen[key](arg);
                    var value = info.value;
                }
                catch (error) {
                    reject(error);
                    return;
                }
                if (info.done) {
                    resolve(value);
                }
                else {
                    return _promise2.default.resolve(value).then(function (value) {
                        step("next", value);
                    }, function (err) {
                        step("throw", err);
                    });
                }
            }
            return step("next");
        });
    };
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(483), __esModule: true };


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.switchRequest=exports.showConProcessSwitchTip=exports.getContinuationProcessParams=undefined;var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _convert=__webpack_require__(6);var _submit=__webpack_require__(57);var _formUtil=__webpack_require__(11);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//获取连续处理相关参数
var getContinuationProcessParams=exports.getContinuationProcessParams=function getContinuationProcessParams(){var continuationProcessParams={};//获取查询参数
if(window.opener&&window.opener.continuationProcessQueryParams){continuationProcessParams=(0,_extends3.default)({},continuationProcessParams,window.opener.continuationProcessQueryParams);}//获取table排序参数
if(window.opener&&window.opener.WorkflowListDoingUtil&&window.opener.WorkflowListDoingUtil.getTableSortParams){var newContinuationProcessSortParams=[];var continuationProcessSortParams=window.opener.WorkflowListDoingUtil.getTableSortParams();if(continuationProcessSortParams&&continuationProcessSortParams.length>0){//IE下这个对象里有奇怪的东西，item遍历取出来放到一个新的对象里，不然下面SON.stringify会有问题
continuationProcessSortParams.map(function(item){newContinuationProcessSortParams.push(item);});continuationProcessParams['tableSortParams']=(0,_stringify2.default)(newContinuationProcessSortParams);}}(0,_keys2.default)(continuationProcessParams).map(function(key){if(continuationProcessParams[key]==undefined||continuationProcessParams[key]==null){delete continuationProcessParams[key];}});return continuationProcessParams;};//显示连续处理自动切换的提示
var showConProcessSwitchTip=exports.showConProcessSwitchTip=function showConProcessSwitchTip(queryParams){var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;if(queryParams.showConProcessSwitchTip=='1'){message.success((0,_convert.getLabel)(528806,'流程已处理，自动为您打开下一条'),3);//去除连续处理提示的参数，防止刷新表单时弹出提示
var newHref=window.location.href.replace("&showConProcessSwitchTip=1",'');window.history.pushState({},0,newHref);}};// 连续处理切换流程
var switchRequest=exports.switchRequest=function switchRequest(type,showConProcessSwitchTip){var continuationProcessInfo=_base2.default.globalStore.continuationProcessInfo;var currentIndex=continuationProcessInfo.currentIndex,requestId=continuationProcessInfo.requestId;var switchToRequestId='';//获取跳转的下一requestid
var continuationProcessParams=getContinuationProcessParams();API_REQ.getContinnuationProcessInfo((0,_extends3.default)({viewScope:"doing",switchType:type,currentIndex:currentIndex,currentRequestId:requestId},continuationProcessParams)).then(function(data){if(data.switchRequestId>0){switchToRequestId=data.switchRequestId;(0,_formUtil.reloadRequestPage)({requestid:switchToRequestId,isOpenContinuationProcess:'1',f_weaver_belongto_userid:data.userId,f_weaver_belongto_usertype:data.userType,showConProcessSwitchTip:showConProcessSwitchTip?'1':'0'});}else{try{window.top.close();}catch(e){window.close();}}});};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.unbindOnMessage=exports.bindOnMessage=exports.getInvoiceFid=exports.getInvoiceCloudToken=undefined;var _assign=__webpack_require__(65);var _assign2=_interopRequireDefault(_assign);var _promise=__webpack_require__(98);var _promise2=_interopRequireDefault(_promise);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _getWindow=__webpack_require__(253);var _getWindow2=_interopRequireDefault(_getWindow);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//获取发票云token
var getInvoiceCloudToken=exports.getInvoiceCloudToken=function getInvoiceCloudToken(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_source2.default.API_REQ.getInvoiceCloudToken(params).then(function(res){var _res$invoiceCloud=res.invoiceCloud,invoiceCloud=_res$invoiceCloud===undefined?false:_res$invoiceCloud,errorInfo=res.errorInfo,status=res.status;var setInvoiceCloudInfo=_source2.default.globalStore.setInvoiceCloudInfo;if(status!=='-1'){if(invoiceCloud){//发票云
if(errorInfo){//无权限
}else{setInvoiceCloudInfo({token:res.token,invoiceCloud:invoiceCloud,jsUrl:res.jsUrl,baseUrl:res.baseUrl});}}}});};//ecid转fid
var getInvoiceFid=exports.getInvoiceFid=function getInvoiceFid(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return new _promise2.default(function(resolve){_source2.default.API_REQ.getFidOrEcid(params).then(function(res){resolve(res);});});};//发票云页面选中数据后的回调函数
var selectedCallback=function selectedCallback(res){var _src$layoutStore=_source2.default.layoutStore,changeSingleFieldValue=_src$layoutStore.changeSingleFieldValue,fieldAttrMap=_src$layoutStore.fieldAttrMap;if(_source2.default.isMobile){//移动端发票云
var _res$originParams=res.originParams,originParams=_res$originParams===undefined?{}:_res$originParams;var fieldMark=originParams.fieldMark;var invoices=res.invoices;if(!fieldMark)return;if(res.type==="INVOICE"){var _invoices=res.invoices;var fieldid=fieldMark.substr(0,5);var rowIndex=-1;if(fieldid.indexOf("_")>-1){fieldid=fieldid.split("_")[0];rowIndex=fieldid.split("_")[1];}var fieldAttr=fieldAttrMap.get(fieldid);var valueInfo=getInvoiceObj(_invoices);changeSingleFieldValue(fieldMark,valueInfo,{});window.historyRoute.go(-1);}else if(res.type==="ON_SCAN_QRCODE"){//调用扫码
scanQRCod(res);}else if(res.type==="ON_SELECT_INVOICE"){//选择发票   类型：1 微信  2 支付宝
chooseInvoice(res);}else if(res.type==="ON_CHOOSE_IMAGE"){//拍照
takePicture({rid:res.rid});}else if(res.type==="ERROR"){if(res.ret=='-2'){sendResult('UPDATE_TOKEN');}}}else{//pc端发票云
var _res$seq=res.seq,seq=_res$seq===undefined?{}:_res$seq;var _fieldMark=seq.fieldMark;if(res.type==="retData"&&_fieldMark){var datas=res.datas;var _fieldid=_fieldMark.substr(0,5);var _rowIndex=-1;if(_fieldid.indexOf("_")>-1){_fieldid=_fieldid.split("_")[0];_rowIndex=_fieldid.split("_")[1];}var _fieldAttr=fieldAttrMap.get(_fieldid);var _valueInfo=getInvoiceObj(datas);changeSingleFieldValue(_fieldMark,_valueInfo,{});//关闭弹窗
window.invoiceBrowser.close();window.invoiceBrowser=null;}else if(res.type==="close"&&_fieldMark){window.invoiceBrowser.close();window.invoiceBrowser=null;}}if(res.type==="ERROR"){if(res.ret===-2){//token失效
getInvoiceCloudToken({tokenUnusual:1});}}};// 绑定发票云message事件，监听发票云页面回传的数据
var bindOnMessage=exports.bindOnMessage=function bindOnMessage(){_getWindow2.default.getTop().addEventListener('message',receiver,false);};//解除绑定发票云message事件
var unbindOnMessage=exports.unbindOnMessage=function unbindOnMessage(){_getWindow2.default.getTop().removeEventListener('message',receiver,false);};var receiver=function receiver(event){var returnData=event.data;selectedCallback(returnData);};var getInvoiceObj=function getInvoiceObj(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var ids=[];var names=[];var specialobj=[];if(_source2.default.isMobile){datas.map(function(item){ids.push(item.oaid);if(item.data&&item.data.number){names.push(item.data.number);}else{names.push(item.id);}specialobj.push({id:item.oaid,name:item.data&&item.data.number?item.data.number:item.id,prop:{cloudId:item.id}});});}else{datas.map(function(item){ids.push(item.oa.id);if(item.number){names.push(item.number);}else{names.push(item.id);}specialobj.push({id:item.oa.id,name:item.number?item.number:item.id,prop:{cloudId:item.id}});});}return{value:ids.join(","),name:names.join(","),specialobj:specialobj};};//移动端含sdk处理
//判断em方法是否存在
var checkFnaJsApi=function checkFnaJsApi(type){var isExist=window.em&&window.em.checkJsApi(type);if(!isExist&&window.WeaverMobile&&window.WeaverMobile.Toast){window.WeaverMobile.Toast.fail(_source2.default.getLabel(525804,'对不起,暂不支持该应用'));return false;}else{return true;}};//发送数据到 iframe
var sendResult=function sendResult(type,data){var invoiceCloudInfo=_source2.default.globalStore.invoiceCloudInfo;switch(type){case'UPDATE_TOKEN':getInvoiceCloudToken({tokenUnusual:1},function(){sendMessage({type:'UPDATE_TOKEN',token:invoiceCloudInfo.token});});break;case'SCAN_QRCODE':sendMessage(data);break;case'SELECT_INVOICE':sendMessage(data);break;}};//统一发送数据
var sendMessage=function sendMessage(data){var invoiceCloudInfo=_source2.default.globalStore.invoiceCloudInfo;var childFrame=document.getElementById("req_invoice_iframe");var url=invoiceCloudInfo.jsUrl;childFrame.contentWindow.postMessage(data,url);};//获取当前设备
var getEquipment=function getEquipment(){var u=window.navigator.userAgent;var isAndroid=u.indexOf('Android')>-1||u.indexOf('Adr')>-1;//android终端
var isiOS=!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);//ios终端
var isEMobile=u.indexOf('E-Mobile')>-1;var isDT=u.indexOf('DingTalk')>-1;var reg=/MicroMessenger/i;var isWx=reg.test(u);if(!isWx){isWx='';//和微信无关
}else{var isWxWork=u.match(/WxWork/i)=="wxwork";if(isWxWork){isWx=false;// 企业微信
}else{isWx=true;//微信
}}var devNum=0;//0：PC    1：IOS   2：ANDROID   3：H5   4：企业微信APP   5：企业微信PC   6：微信公众号
if(isWx===true){devNum=6;}else if(isWx===false){devNum=4;}else if(isAndroid||isiOS){devNum=3;}var equipment={isAndroid:isAndroid,isiOS:isiOS,isEMobile:isEMobile,dev:devNum,isWx:isWx,isDT:isDT};console.log('equipment',equipment);return equipment;};//调用扫码
var scanQRCod=function scanQRCod(res){if(!checkFnaJsApi("scanQRCode"))return;window.em.scanQRCode({needResult:1,scanType:["qrCode","barCode"],// 可以指定扫二维码还是一维码，默认二者都有
success:function success(value){console.log('value',value);var params={source:"ENTRY",type:"SCAN_QRCODE",rid:res.rid,// 发票云传过来的 id
result:value.resultStr// 扫码结果
};sendResult('SCAN_QRCODE',params);},fail:function fail(err){console.log('err',err);if(window.WeaverMobile&&window.WeaverMobile.Toast)window.WeaverMobile.Toast.fail(err);}});};//选择发票   类型：1 微信  2 支付宝
var chooseInvoice=function chooseInvoice(res){if(!checkFnaJsApi("chooseInvoice"))return;window.em.chooseInvoice({type:res.invoiceType,// 类型：1 微信  2 支付宝
success:function success(value){var params={source:"ENTRY",type:"SELECT_INVOICE",invoiceType:res.invoiceType,// 类型：1 微信  2 支付宝
rid:res.rid,// 发票云传过来的 id
list:value.setInvoiceList};var equipment=getEquipment();if(equipment.isWx===false){//不是微信
if(!checkFnaJsApi("getCpUser"))return;window.em.getCpUser({success:function success(res){params=(0,_assign2.default)(params,{appKey:res});sendResult('SELECT_INVOICE',params);},fail:function fail(err){params=(0,_assign2.default)(params,{appKey:err});sendResult('SELECT_INVOICE',params);}});}else{sendResult('SELECT_INVOICE',params);}},fail:function fail(err){if(window.WeaverMobile&&window.WeaverMobile.Toast)window.WeaverMobile.Toast.fail(err);}});};//拍照
var takePicture=function takePicture(params){if(!checkFnaJsApi("chooseImage"))return;var localIdArr=[];var num=0;window.em_ssoInit().then(function(){window.em.chooseImage({count:9,// 最大可选照片数，默认9
sourceType:['camera'],// 可以指定来源是相册还是相机，默认二者都有
success:function success(res){var localIds=res.localIds;// 返回选定照片的本地ID列表
localIds.forEach(function(localId){window.em.getLocalImgData({localId:localId,success:function success(res){num++;var data=res.localData;var base64PicData="data:image/jpeg;base64,"+data;var bool=localIds.length==num?true:false;var listEle={base64:base64PicData,fileName:''};localIdArr.push(listEle);getlocalIdData(params,localIdArr,bool);}});});}});}).catch(function(res){alert("连续拍照插件异常,使用原始插件");});};//获取所有 发票拍照数据
var getlocalIdData=function getlocalIdData(params,data,send){if(send){var localParams={source:"ENTRY",type:"CHOOSE_IMAGE",rid:params.rid,// 发票云传过来的 id,
list:data};sendMessage(localParams);}};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(82);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _SourceLayout=__webpack_require__(534);var _SourceLayout2=_interopRequireDefault(_SourceLayout);var _LayoutTr=__webpack_require__(187);var _LayoutTr2=_interopRequireDefault(_LayoutTr);var _CustomContent=__webpack_require__(632);var _CustomContent2=_interopRequireDefault(_CustomContent);var _HiddenArea=__webpack_require__(633);var _HiddenArea2=_interopRequireDefault(_HiddenArea);var _PromptBox=__webpack_require__(634);var _PromptBox2=_interopRequireDefault(_PromptBox);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _parseLayout=__webpack_require__(68);var Parse=_interopRequireWildcard(_parseLayout);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MainLayout=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(MainLayout,_React$Component);function MainLayout(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,MainLayout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=MainLayout.__proto__||(0,_getPrototypeOf2.default)(MainLayout)).call.apply(_ref,[this].concat(args))),_this),_this.getDomArr=function(_rowHeads,breakpage_row){var _this$props=_this.props,symbol=_this$props.symbol,globalStore=_this$props.globalStore;var _globalStore$urlParam=globalStore.urlParams,urlParams=_globalStore$urlParam===undefined?{}:_globalStore$urlParam;var isBatchPrint=urlParams.isBatchPrint;var rowHeads=[].concat((0,_toConsumableArray3.default)(_rowHeads));var domArr=[];if(symbol==="main"&&breakpage_row.length>0&&isBatchPrint!=="true"){breakpage_row.sort(function(a,b){return a-b;});var breakpageRow=breakpage_row[0];domArr.push({trArr_rowHeads:rowHeads.slice(0,breakpage_row[0]),flag:"table"});domArr.push({trArr_rowHeads:[rowHeads[breakpageRow]],flag:"pagebreak"});for(var i=1;i<breakpage_row.length;i++){breakpageRow=breakpage_row[i];domArr.push({trArr_rowHeads:rowHeads.slice(breakpage_row[i-1]+1,breakpageRow),flag:"table"});domArr.push({trArr_rowHeads:[rowHeads[breakpageRow]],flag:"pagebreak"});}domArr.push({trArr_rowHeads:rowHeads.slice(breakpage_row[breakpage_row.length-1]+1),flag:"table"});}else{domArr=[{trArr_rowHeads:rowHeads,flag:"table"}];}return domArr;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(MainLayout,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,symbol=_props.symbol,globalStore=_props.globalStore;var isMain=symbol==="main"?true:false;var JSComplete=globalStore.JSComplete,commonParam=globalStore.commonParam,urlParams=globalStore.urlParams;var isBatchPrint=urlParams.isBatchPrint;try{if(isMain){if(jQuery('.wf-req-form-content').css('display')=='none')return;//设置标题
var title=Util.getPageTitle();;document.title=title;if(window.top&&(window.top.location.pathname.indexOf("/spa/workflow/index_form.jsp")>-1||window.top.location.pathname.indexOf("/spa/workflow/static4form/index.html")>-1)){window.top.document.title=title;}if(isBatchPrint==="true"){//批量打印显示链接
window.top.document.title="";}//模板列宽超过一屏时，计算div宽度撑开body的横向滚动条
var layoutWidth=parseFloat(jQuery("table.excelMainTable").width());var wrapperDiv=jQuery("div.wf-req-form-main");if(layoutWidth>wrapperDiv.width()&&wrapperDiv.width()>0){wrapperDiv.width(layoutWidth+100);wrapperDiv.parent().css("overflow-x","auto");}//系统提醒工作流特殊处理
if(commonParam.workflowid==1)errorNoticeUtil.handleResetBtn();//图片懒加载
formImgLazyLoad(jQuery('.wea-new-top-req-content'));}}catch(e){if(window.console)console.log("MainLayout componentDidMount Exception");}}},{key:'render',value:function render(){var _props2=this.props,symbol=_props2.symbol,globalStore=_props2.globalStore,layoutStore=_props2.layoutStore;var isMain=symbol==="main"?true:false;var isSourceLayout=globalStore.isSourceLayout,_globalStore$urlParam2=globalStore.urlParams,urlParams=_globalStore$urlParam2===undefined?{}:_globalStore$urlParam2;var isBatchPrint=urlParams.isBatchPrint;var variableMap=layoutStore.variableMap,_layoutStore$propFile=layoutStore.propFileCfg,propFileCfg=_layoutStore$propFile===undefined?{}:_layoutStore$propFile;var batch_print_control_width=propFileCfg.batch_print_control_width;var promptBoxProp=variableMap.has("promptBox")?variableMap.get("promptBox"):{};var mainDom=[];if(isMain){mainDom.push(_react2.default.createElement(_CustomContent2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_CustomContent@4gt3x5'}));mainDom.push(_react2.default.createElement(_HiddenArea2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_HiddenArea@rsshkl'}));mainDom.push(_react2.default.createElement(_PromptBox2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_PromptBox@h72bxt'},promptBoxProp)));}var layout=null;if(isSourceLayout){layout=_react2.default.createElement(_SourceLayout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SourceLayout@yd276x'});}else{layout=this.renderExcelLayout();}var canControlWidth=parseInt(batch_print_control_width)>100;var tableStyle=isBatchPrint&&canControlWidth?{maxWidth:parseInt(batch_print_control_width)+"px",margin:"0 auto"}:{};return _react2.default.createElement('div',{className:isMain?"excelTempDiv":"",style:tableStyle},layout,mainDom);}},{key:'renderExcelLayout',value:function renderExcelLayout(){var _this2=this;var _props3=this.props,symbol=_props3.symbol,globalStore=_props3.globalStore,layoutStore=_props3.layoutStore;var isMain=symbol==="main"?true:false;var jsonKey=isMain?"emaintable":symbol;var browserVersion=globalStore.browserVersion,commonParam=globalStore.commonParam,_globalStore$urlParam3=globalStore.urlParams,urlParams=_globalStore$urlParam3===undefined?{}:_globalStore$urlParam3;var layouttype=commonParam.layouttype;var isBatchPrint=urlParams.isBatchPrint;var dataJson=layoutStore.dataJson,cellInfo=layoutStore.cellInfo;var breakpage_row=cellInfo.printBreakRowInfo||[];var etables=dataJson.etables;var etable=jsonKey in etables?etables[jsonKey]:null;if(etable==null)return _react2.default.createElement('div',{style:{"display":"none"}},'Layout error');var className=isMain?"excelMainTable":"excelTabTable";var tableStyle=isMain?{margin:"0px auto"}:{};if(cellInfo.isFixed=="1"||GlobalUtil.judgeExistXScrollDetail())tableStyle["table-layout"]="fixed";if(isMain&&browserVersion.indexOf("IE")>-1&&cellInfo.existTextArea===true)//IE下多行文本内容撑开问题
tableStyle["table-layout"]="fixed";var rowHeads=Parse.convertRowHeads(etable.rowheads);var colHeads=Parse.convertColHeads(etable.colheads,symbol,layouttype,tableStyle);var ecMap=Parse.convertEcMap(etable.ec);var rowattrs=etable.rowattrs;var colattrs=etable.colattrs;var domArr=this.getDomArr(rowHeads,breakpage_row);var renderDoms=[];var tablenum=0;domArr.map(function(item,index){var trArr_rowHeads=item.trArr_rowHeads;if(item.flag=="table"){var trArr=[];if(index===0)Parse.parseLayoutImage(etable,tableStyle,trArr);//解析背景图、悬浮图
trArr_rowHeads.map(function(o){var rowid=o.id;if(isBatchPrint==="true"&&breakpage_row.includes(parseInt(rowid)))return;var rowCusAttr=rowattrs?rowattrs["row_"+rowid]:null;//分组节点意见循环行、非意见默认循环一行
var nodeSignProps=_this2.calculateNodeSignProps(rowid);for(var i=0;i<nodeSignProps.total;i++){trArr.push(_react2.default.createElement(_LayoutTr2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_LayoutTr@ds2cqb@'+symbol+'_'+i,symbol:symbol,colNum:colHeads.length,rowid:rowid,rowHeight:o.height,rowCusAttr:rowCusAttr,colattrs:colattrs,ecMap:ecMap,nodeSignProps:(0,_extends3.default)({},nodeSignProps,{current:i})}));}});renderDoms.push(_react2.default.createElement('table',{className:className,style:(0,_extends3.default)({},tableStyle)},_react2.default.createElement('colgroup',null,colHeads.map(function(v){return _react2.default.createElement('col',{style:{width:v.width}});})),_react2.default.createElement('tbody',null,trArr)));}else{renderDoms.push(_react2.default.createElement('div',{style:{height:trArr_rowHeads[trArr_rowHeads.length-1].height,pageBreakAfter:"always"}}));}});return renderDoms;}},{key:'calculateNodeSignProps',value:function calculateNodeSignProps(rowid){var _props4=this.props,symbol=_props4.symbol,layoutStore=_props4.layoutStore;var cellInfo=layoutStore.cellInfo;var nodeMarkGroup=cellInfo.nodeMarkGroup,nodeMarkContent=cellInfo.nodeMarkContent;var key=symbol+'_'+rowid;var belong=false;var total=1;var cellKey="";nodeMarkGroup&&nodeMarkGroup.map(function(item){var rowKey=item.symbol+'_'+item.rowid;if(symbol+'_'+rowid===rowKey){belong=true;cellKey=item.symbol+'_'+item.rowid+'_'+item.colid;total=cellKey in nodeMarkContent&&nodeMarkContent[cellKey]instanceof Array?nodeMarkContent[cellKey].length:0;}});return{belong:belong,total:total,cellKey:cellKey};}}]);return MainLayout;}(_react2.default.Component))||_class)||_class);exports.default=MainLayout;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

function _isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = _isPlaceholder;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

function _has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = _has;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _DMain=__webpack_require__(594);var _DMain2=_interopRequireDefault(_DMain);var _DetailButton=__webpack_require__(598);var _DetailButton2=_interopRequireDefault(_DetailButton);var _McLayout=__webpack_require__(600);var _McLayout2=_interopRequireDefault(_McLayout);var _TabLayout=__webpack_require__(601);var _TabLayout2=_interopRequireDefault(_TabLayout);var _FieldContent=__webpack_require__(602);var _FieldContent2=_interopRequireDefault(_FieldContent);var _SystemField=__webpack_require__(628);var _SystemField2=_interopRequireDefault(_SystemField);var _InsertScanCode=__webpack_require__(629);var _InsertScanCode2=_interopRequireDefault(_InsertScanCode);var _InsertIframe=__webpack_require__(630);var _InsertIframe2=_interopRequireDefault(_InsertIframe);var _index=__webpack_require__(272);var _index2=_interopRequireDefault(_index);var _convert=__webpack_require__(6);var _Portal=__webpack_require__(275);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _formatUtil=__webpack_require__(126);var FormatUtil=_interopRequireWildcard(_formatUtil);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _signUtil=__webpack_require__(58);var _FnaInvoiceIdentify=__webpack_require__(631);var _FnaInvoiceIdentify2=_interopRequireDefault(_FnaInvoiceIdentify);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CellType=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(CellType,_React$Component);function CellType(){(0,_classCallCheck3.default)(this,CellType);return(0,_possibleConstructorReturn3.default)(this,(CellType.__proto__||(0,_getPrototypeOf2.default)(CellType)).apply(this,arguments));}(0,_createClass3.default)(CellType,[{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Checkbox=_getAntd.Checkbox;var _getEcCom=(0,_convert.getEcCom)(),WeaHelpfulTip=_getEcCom.WeaHelpfulTip;var _props=this.props,symbol=_props.symbol,cellObj=_props.cellObj,detailProps=_props.detailProps,_props$nodeSignProps=_props.nodeSignProps,nodeSignProps=_props$nodeSignProps===undefined?{}:_props$nodeSignProps;var cellid=cellObj.id;var cellMark=symbol+"_"+cellid.replace(",","_");var etype=parseInt(cellObj.etype||0);var evalue=cellObj.evalue;var _props2=this.props,globalStore=_props2.globalStore,layoutStore=_props2.layoutStore;var JSComplete=globalStore.JSComplete,isSourceLayout=globalStore.isSourceLayout,commonParam=globalStore.commonParam,commonApiParam=globalStore.commonApiParam,urlParams=globalStore.urlParams;var iscreate=commonApiParam.iscreate;var requestid=commonParam.requestid,workflowid=commonParam.workflowid;var cellInfo=layoutStore.cellInfo,detailMap=layoutStore.detailMap,variableMap=layoutStore.variableMap;var canEdit=parseInt(commonParam.isviewonly||0)!==1&&parseInt(commonParam.isaffirmance||0)!==1;//节点分组所在行非文本设置无效
if(nodeSignProps.belong===true&&!(etype===0||etype===1||etype===4||etype===5)){return this.renderDomObj(_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:(0,_convert.getLabel)(528409,"无效单元格，意见分组所在行不支持此类型设置")}}));}if(etype===0||etype===1||etype===6||etype===24){//文本、图片(可能有<br>)
if(etype===24)evalue=(0,_convert.getLabel)(15486,"序号");if(evalue==="")return this.renderDomObj(_react2.default.createElement('span',null," "));return this.renderDomObj(_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:this.convertText(evalue,etype===24)}}));}else if(etype===2||etype===3){//字段名、字段值
var fieldid=cellObj.field.toString();var fieldAttrMap=layoutStore.fieldAttrMap;if(!fieldAttrMap.has(fieldid))//模板字段被删除情况
return this.renderDomObj(_react2.default.createElement('span',{style:{display:"none"}},'Field UnExist!'));var fieldAttr=fieldAttrMap.get(fieldid);var isDetail=symbol.indexOf("detail_")>-1&&fieldAttr.isDetail;if(etype===2){var financialCfg=cellObj.financial;var fieldLabel=fieldAttr.fieldlabel;var fontSize=_.get(cellObj,["font","font-size"])||"9pt";if(financialCfg&&financialCfg.indexOf("1-")>-1){//财务表头
var finNum=parseInt(financialCfg.split("-")[1]||"3");return this.renderDomObj(_react2.default.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaWfFinancial@q1lval',type:1,finNum:finNum,label:fieldLabel,className:'finarea_'+fieldid,fontSize:fontSize}),"",{height:"100%",width:"100%"});}else{if(fieldLabel==="")return this.renderDomObj(_react2.default.createElement('span',null));return this.renderDomObj(_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:this.convertText(fieldLabel,etype===24,false)}}));}}else if(etype===3){var rowIndex=isDetail?parseInt(detailProps.rowIndex):-1;var fieldMark=isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;return this.renderDomObj(_react2.default.createElement(_FieldContent2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FieldContent@r045n3',symbol:symbol,cellObj:cellObj,isDetail:isDetail,rowIndex:rowIndex}),fieldMark);}}else if(etype===4){//流程意见节点名称
var nodeid=cellObj.field.toString();var nodeNameInfo=cellInfo.nodeNameInfo,nodeMarkContent=cellInfo.nodeMarkContent;var nodename="";if(nodeSignProps.belong===true){var groupNodeMark=nodeMarkContent[nodeSignProps.cellKey];nodename=groupNodeMark&&groupNodeMark[nodeSignProps.current].name||"";}else{nodename=nodeNameInfo[nodeid]||evalue;}if(nodename==="")return this.renderDomObj(_react2.default.createElement('span',null));return this.renderDomObj(_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:this.convertText(nodename)}}));}else if(etype===5){//流转意见
var _nodeMarkContent=cellInfo.nodeMarkContent;var nodeMark="";if(nodeSignProps.belong===true){var _groupNodeMark=_nodeMarkContent[nodeSignProps.cellKey];nodeMark=_groupNodeMark&&_groupNodeMark[nodeSignProps.current].content||"";}else{if(isSourceLayout)nodeMark=this.props.nodeMark||"";else{nodeMark=_nodeMarkContent&&_nodeMarkContent[cellMark]||"";if(symbol.indexOf("mc_")>-1&&Array.isArray(nodeMark))nodeMark=(0,_convert.getLabel)(528410,"分组节点意见不能置于多文本布局中，请调整模板设置！");}}var _globalStore$commonPa=globalStore.commonParam,authStr=_globalStore$commonPa.authStr,authSignatureStr=_globalStore$commonPa.authSignatureStr,docViewUrl=_globalStore$commonPa.docViewUrl,isprint=_globalStore$commonPa.isprint,f_weaver_belongto_userid=_globalStore$commonPa.f_weaver_belongto_userid,f_weaver_belongto_usertype=_globalStore$commonPa.f_weaver_belongto_usertype;//替换使相关流程走新的E9链接
nodeMark=nodeMark.replace(new RegExp("/workflow/request/ViewRequest(ForwardSPA)?\\.jsp\\?","g"),'/workflow/request/ViewRequestForwardSPA.jsp?authStr='+authStr+'&authSignatureStr='+authSignatureStr+'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype='+f_weaver_belongto_usertype+'&');nodeMark=nodeMark.replace(new RegExp("/docs/docs/DocDsp\\.jsp\\?","g"),docViewUrl+'?authStr='+authStr+'&authSignatureStr='+authSignatureStr+'&');if(isprint=="1")nodeMark=(0,_signUtil.handWritingHander)(nodeMark);//打印时，处理手写签批样式
return this.renderHtmlText(nodeMark,5);}else if(etype===7){//明细
return this.renderDomObj(_react2.default.createElement(_DMain2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_DetailLayout@ry4hmp',symbol:cellObj.detail}));}else if(etype===10){//明细增删按钮
return this.renderDomObj(_react2.default.createElement(_DetailButton2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_DetailButton@xyxazo',symbol:symbol}));}else if(etype===11){//链接
var fieldtype=cellObj.fieldtype,field=cellObj.field;var url="";url=fieldtype==1?"http://":url;url=fieldtype==2?"https://":url;url=fieldtype==3?"ftp://":url;url=fieldtype==4?"news://":url;url+=field;return this.renderDomObj(_react2.default.createElement('a',{target:'_blank',href:url,dangerouslySetInnerHTML:{__html:evalue===""?"":this.convertText(evalue)}}));}else if(etype===12){//标签页
var cellidMark=cellid.replace(",","_");var _variableMap=layoutStore.variableMap;var showid=_variableMap.get('tabarea_'+cellidMark+'_showid')||"";return this.renderDomObj(_react2.default.createElement(_TabLayout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_TabLayout@6udpjd',cellMark:cellidMark,tab:cellObj.tab,showid:showid}));}else if(etype===13){//多内容
return this.renderDomObj(_react2.default.createElement(_McLayout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_McLayout@q0bqjd',mcMark:cellObj.mcpoint}));}else if(etype===15){//门户元素
var jsonparam=cellObj.jsonparam||{};var hpid=jsonparam.hpid||"";if(hpid!==""){var trifields=jsonparam&&jsonparam.trifields||"";var relateformData={};var _fieldAttrMap=layoutStore.fieldAttrMap,mainData=layoutStore.mainData;!!trifields&&trifields.split(",").map(function(fieldid){var fieldValue="";var _fieldid=fieldid.substring(5);if(_fieldAttrMap.has(_fieldid)){fieldValue=mainData.has(fieldid)?mainData.get(fieldid).value:"";fieldValue=fieldValue.toString();var _fieldAttr=_fieldAttrMap.get(_fieldid);if(_fieldAttr.htmltype===1&&_fieldAttr.detailtype==="5")fieldValue=fieldValue.replace(/,/g,"");}relateformData[fieldid]=fieldValue;});return this.renderDomObj(_react2.default.createElement(_Portal.Homepage,{ecId:(this&&this.props&&this.props.ecId||'')+'_Homepage@rdfggz',hpid:hpid,workflowid:workflowid,requestid:requestid,formData:relateformData}));}}else if(etype===16){//iframe区域
var _jsonparam=cellObj.jsonparam||{};return JSComplete?_react2.default.createElement(_InsertIframe2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_InsertIframe@bcipl2',jsonparam:_jsonparam}):_react2.default.createElement('span',null);}else if(etype===17){//扫码区
var _jsonparam2=cellObj.jsonparam||{};var otherparam={iscreate:iscreate,isPreView:urlParams.isPreView};return JSComplete?this.renderDomObj(_react2.default.createElement(_InsertScanCode2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_InsertScanCode@rk7cyq',jsonparam:_jsonparam2,otherparam:otherparam})):this.renderDomObj(_react2.default.createElement('span',null));}else if(etype===18||etype===19){//合计名称、合计值
var _fieldid2=cellObj.field||"";var _fieldAttrMap2=layoutStore.fieldAttrMap,linkageCfg=layoutStore.linkageCfg,_variableMap2=layoutStore.variableMap;if(etype===18){var fieldlabel=_fieldAttrMap2.get(_fieldid2).fieldlabel||"";return this.renderDomObj(_react2.default.createElement('span',null,fieldlabel+"("+(0,_convert.getLabel)(358,'合计')+")"));}else{var sumValue="";if(_.has(linkageCfg,["colCalCfg",_fieldid2])){//设置了合计
if(_variableMap2.has('sum'+_fieldid2))sumValue=_variableMap2.get('sum'+_fieldid2);else sumValue="0";}return this.renderDomObj(_react2.default.createElement('span',null,FormatUtil.convertFormatValue_sum(sumValue,_fieldid2)));}}else if(etype===20){//明细全选
var detailObj=detailMap.get(symbol)||{};var attr=detailObj.attr,currentPageRowArr=detailObj.currentPageRowArr,dropBtnKey=detailObj.dropBtnKey;var isadd=attr.isadd,isdelete=attr.isdelete;var existCheckedRow=false;var existUnCheckedRow=false;if(canEdit&&currentPageRowArr.length>0&&(isadd===1||isdelete===1)){currentPageRowArr.map(function(info){if(existUnCheckedRow||dropBtnKey===1&&isdelete!==1&&parseInt(info.keyid||0)>0)//已有明细禁止删除情况不参与
return"";if(info.checked){existCheckedRow=true;}else{existUnCheckedRow=true;}});}var isDisabled=!(existCheckedRow||existUnCheckedRow);return this.renderDomObj(_react2.default.createElement(Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@mhglgu',onChange:function onChange(e){DetailUtil.setAllRowChecked(symbol,e.target.checked);},disabled:isDisabled,checked:existCheckedRow&&!existUnCheckedRow}));}else if(etype===21){//明细单选
var _rowIndex=detailProps.rowIndex;var _detailObj=detailMap.get(symbol)||{};var _attr=_detailObj.attr,rowInfo=_detailObj.rowInfo,_dropBtnKey=_detailObj.dropBtnKey;var _isdelete=_attr.isdelete;var info=rowInfo.get("row_"+_rowIndex);var checkProps={checked:!!info.get("checked")};if(_dropBtnKey===1){//禁止删除已有明细
if(!canEdit||_isdelete!==1&&parseInt(info.get("keyid")||0)>0)checkProps["disabled"]=true;}if(info.get("disableCheck")===true)checkProps["disabled"]=true;var detailIndex=parseInt(symbol.substring(7))-1;return this.renderDomObj(_react2.default.createElement('span',null,_react2.default.createElement(Checkbox,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@hj96fz',onChange:function onChange(e){DetailUtil.setRowChecked(symbol,_rowIndex,e.target.checked);}},checkProps)),_react2.default.createElement('input',{type:'hidden',name:'check_node_'+detailIndex,value:_rowIndex})));}else if(etype===22){//序号
return this.renderDomObj(_react2.default.createElement('span',null,detailProps.serialNum));}else if(etype===23){// 财务模块  发票识别
var _cellObj$jsonparam=cellObj.jsonparam,_jsonparam3=_cellObj$jsonparam===undefined?{}:_cellObj$jsonparam;var btnTitle=_jsonparam3.btn_title||evalue;return this.renderDomObj(_react2.default.createElement(_FnaInvoiceIdentify2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FnaInvoiceIdentify@4eg3yf',symbol:symbol,commonParam:commonParam,evalue:btnTitle}));}else if(etype===25){//问号说明
var _cellObj$jsonparam2=cellObj.jsonparam,_jsonparam4=_cellObj$jsonparam2===undefined?{}:_cellObj$jsonparam2;var msgValue=(_jsonparam4.value||"").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/(\r\n|\r|\n)/g,"<br/>").replace(/ /g,"&nbsp;");return JSComplete&&this.renderDomObj(_react2.default.createElement('span',null,_react2.default.createElement(WeaHelpfulTip,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaHelpfulTip@tdrnso',title:msgValue,placement:'top'})));}else if(etype===26){//多语言标签
var labelInfo=cellInfo.labelInfo;var _ref=cellObj.jsonparam||{},labelid=_ref.labelid;return this.renderDomObj(_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:''+(labelInfo[labelid]||"")}}));}else if(etype===28||etype===29){//系统字段
return this.renderDomObj(_react2.default.createElement(_SystemField2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SystemField@mxnixm',cellObj:cellObj}));}return this.renderDomObj(_react2.default.createElement('span',null,evalue));}},{key:'convertText',value:function convertText(str){var notConverSpace=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var convertltgt=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(str===null||typeof str==="undefined")return"";else{var _str=str;if(convertltgt)_str=_str.replace(/</g,"&lt;").replace(/>/g,"&gt;");_str=_str.replace(/(\r\n|\r|\n)/g,"</br>");if(!notConverSpace){// 优化断行，多个空格中首个空格不转译，其余空格转&nbsp;
// 单个空格不转换
_str=_str.replace(/( {2,})/ig,function(val){return" "+val.substring(1).replace(/ /ig,"&nbsp;");});}return _str;}}},{key:'renderDomObj',value:function renderDomObj(content,fieldMark){var swapStyle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var _props3=this.props,symbol=_props3.symbol,cellAttr=_props3.cellAttr,cellObj=_props3.cellObj,layoutStore=_props3.layoutStore;var fieldAttrMap=layoutStore.fieldAttrMap,variableMap=layoutStore.variableMap;var etype=parseInt(cellObj.etype)||0;var domProps=cellAttr?cellAttr:{};domProps["className"]=(domProps["className"]||"")+' etype_'+etype+'_swapDiv';domProps["data-cellmark"]=symbol+'_'+cellObj.id.replace(",","_");if(!_.isEmpty(swapStyle))domProps.style=(0,_extends3.default)({},swapStyle,domProps.style||{});if(etype===2||etype===3){var fieldid=cellObj.field||"";//DOM上体现下fieldid
if(etype===3){domProps["data-fieldmark"]=fieldMark;domProps["className"]=(domProps["className"]||"")+' '+fieldMark+'_swapDiv';if(fieldAttrMap.has(fieldid)){var fieldAttr=fieldAttrMap.get(fieldid);domProps["data-fieldname"]=fieldAttr.fieldname;if(fieldAttr.htmltype===4)//check框
domProps.style=(0,_extends3.default)({display:"inline-block"},domProps.style);}domProps.onClick=function(){WfForm.triggerFieldAction("onclick",fieldMark);};domProps.onDoubleClick=function(){WfForm.triggerFieldAction("ondbclick",fieldMark);};domProps.onMouseOver=function(){WfForm.triggerFieldAction("mouseover",fieldMark);};domProps.onMouseOut=function(){WfForm.triggerFieldAction("mouseout",fieldMark);};}else if(etype===2){domProps.style=(0,_extends3.default)({display:"inline-block"},domProps.style);}//显示属性联动隐藏内容
if(symbol.indexOf("detail_")===-1){var _className=domProps["className"]||"";if(variableMap.get('field'+fieldid+'_viewAttr')===4){_className+=" linkage_hide";}else{//多字段隐藏不rander McLayout固需要去除
_className=_className.replace(/linkage_hide/g,"");}domProps["className"]=_className;}}if(symbol.indexOf("mc_")>-1||etype===20||etype===21){//兼容低级模式勾选框使用span结构
return _react2.default.createElement('span',domProps,content);}else{return _react2.default.createElement('div',domProps,content);}}},{key:'renderHtmlText',value:function renderHtmlText(content,etype){var _props4=this.props,symbol=_props4.symbol,cellAttr=_props4.cellAttr,cellObj=_props4.cellObj;var scrollStyle=etype==5?{width:"100%",overflow:"auto hidden"}:{};//签字意见内容宽度超出表格宽度时，加个滚动效果
var domProps=cellAttr?{id:cellAttr.id,name:cellAttr.name,className:cellAttr.className,style:(0,_extends3.default)({},scrollStyle,cellAttr.style)}:(0,_extends3.default)({},scrollStyle);//没有内容不渲染，不占用高度
if(!content||content==''){domProps["className"]=(''+(domProps["className"]||"")).replace('span_mc ',' ').replace('span_mc_marginRight',' ');return _react2.default.createElement('span',domProps);}domProps["className"]=(domProps["className"]||"")+' etype_'+etype+'_swapDiv';if(etype===5)domProps["className"]=(domProps["className"]||"")+' node'+cellObj.field+'_swapDiv';if(symbol.indexOf("mc_")>-1){return _react2.default.createElement('span',(0,_extends3.default)({},domProps,{dangerouslySetInnerHTML:{__html:content===""?"":content}}));}else{return _react2.default.createElement('div',(0,_extends3.default)({},domProps,{dangerouslySetInnerHTML:{__html:content===""?"":content}}));}}}]);return CellType;}(_react2.default.Component))||_class)||_class);exports.default=CellType;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var isFun = function isFun(arg) {
    return !!arg && typeof arg === 'function';
};
exports.default = isFun;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (false) {
    var ReactIs = require('react-is');
    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
}
else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = __webpack_require__(293)();
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(21);
var core = __webpack_require__(13);
var fails = __webpack_require__(37);
module.exports = function (KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(60);
var $export = __webpack_require__(21);
var redefine = __webpack_require__(192);
var hide = __webpack_require__(42);
var Iterators = __webpack_require__(93);
var $iterCreate = __webpack_require__(306);
var setToStringTag = __webpack_require__(95);
var getPrototypeOf = __webpack_require__(191);
var ITERATOR = __webpack_require__(31)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';
var returnThis = function () { return this; };
module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);
    var getMethod = function (kind) {
        if (!BUGGY && kind in proto)
            return proto[kind];
        switch (kind) {
            case KEYS: return function keys() { return new Constructor(this, kind); };
            case VALUES: return function values() { return new Constructor(this, kind); };
        }
        return function entries() { return new Constructor(this, kind); };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function')
                hide(IteratorPrototype, ITERATOR, returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() { return $native.call(this); };
    }
    // Define iterator
    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
        hide(proto, ITERATOR, $default);
    }
    // Plug for library
    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
        };
        if (FORCED)
            for (key in methods) {
                if (!(key in proto))
                    redefine(proto, key, methods[key]);
            }
        else
            $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(75);
var toAbsoluteIndex = __webpack_require__(142);
module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el)
            while (length > index) {
                value = O[index++];
                // eslint-disable-next-line no-self-compare
                if (value != value)
                    return true;
                // Array#indexOf ignores holes, Array#includes - not
            }
        else
            for (; length > index; index++)
                if (IS_INCLUDES || index in O) {
                    if (O[index] === el)
                        return IS_INCLUDES || index || 0;
                }
        return !IS_INCLUDES && -1;
    };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(31);


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(71)('meta');
var isObject = __webpack_require__(28);
var has = __webpack_require__(41);
var setDesc = __webpack_require__(32).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
    return true;
};
var FREEZE = !__webpack_require__(37)(function () {
    return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
    setDesc(it, META, { value: {
            i: 'O' + ++id,
            w: {} // weak collections IDs
        } });
};
var fastKey = function (it, create) {
    // return primitive with prefix
    if (!isObject(it))
        return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it))
            return 'F';
        // not necessary to add metadata
        if (!create)
            return 'E';
        // add missing metadata
        setMeta(it);
        // return object ID
    }
    return it[META].i;
};
var getWeak = function (it, create) {
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it))
            return true;
        // not necessary to add metadata
        if (!create)
            return false;
        // add missing metadata
        setMeta(it);
        // return hash weak collections IDs
    }
    return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META))
        setMeta(it);
    return it;
};
var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(13);
var LIBRARY = __webpack_require__(60);
var wksExt = __webpack_require__(143);
var defineProperty = __webpack_require__(32).f;
module.exports = function (name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol))
        defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(64);
var createDesc = __webpack_require__(62);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(92);
var has = __webpack_require__(41);
var IE8_DOM_DEFINE = __webpack_require__(105);
var gOPD = Object.getOwnPropertyDescriptor;
exports.f = __webpack_require__(23) ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE)
        try {
            return gOPD(O, P);
        }
        catch (e) { /* empty */ }
    if (has(O, P))
        return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _dec,_desc,_value2,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _analyzeData=__webpack_require__(56);var AI=_interopRequireWildcard(_analyzeData);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Field=(_dec=(0,_mobx.action)('脱敏真实值存储'),(_class=function(){(0,_createClass3.default)(Field,[{key:'numValue',get:function get(){//字段值转换为数值类型
var _value=this.value.replace(/,/g,"");return FieldUtil.judgeIsNumber(_value)?parseFloat(_value):0;;}},{key:'valueObj',get:function get(){return{value:this.value,specialobj:this.specialobj};}}]);//字段可变区(viewattr、optionRange、customBrowserProp等)
function Field(){var fieldMark=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var valueObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var stepid=arguments[2];(0,_classCallCheck3.default)(this,Field);this.fieldMark="";_initDefineProp(this,'value',_descriptor,this);_initDefineProp(this,'decryptValue',_descriptor2,this);_initDefineProp(this,'specialobj',_descriptor3,this);_initDefineProp(this,'variable',_descriptor4,this);_initDefineProp(this,'changeValueObj',_descriptor5,this);_initDefineProp(this,'changeVariable',_descriptor6,this);_initDefineProp(this,'changeDecryptValue',_descriptor7,this);this.fieldMark=fieldMark;this.changeValueObj(valueObj);AI.appendStepDetail(stepid,this.fieldMark,AI.CHANGE_FIELD_VALUE,valueObj);}return Field;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'value',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'decryptValue',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'specialobj',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'numValue',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'numValue'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'valueObj',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'valueObj'),_class.prototype),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'variable',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'changeValueObj',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var valueObj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var stepid=arguments[1];_this.value=Util.convertNull(valueObj.value);_this.specialobj=valueObj.specialobj||null;AI.appendStepDetail(stepid,_this.fieldMark,AI.CHANGE_FIELD_VALUE,valueObj);};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'changeVariable',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var stepid=arguments[1];!_.isEmpty(obj)&&_.forIn(obj,function(value,key){_this2.variable.set(key,value);});AI.appendStepDetail(stepid,_this2.fieldMark,AI.CHANGE_FIELD_VARS,obj);};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'changeDecryptValue',[_dec],{enumerable:true,initializer:function initializer(){var _this3=this;return function(value){_this3.decryptValue=value;};}})),_class));exports.default=Field;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(63);
var TAG = __webpack_require__(31)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
    try {
        return it[key];
    }
    catch (e) { /* empty */ }
};
module.exports = function (it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
        // @@toStringTag case
        : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
            // builtinTag case
            : ARG ? cof(O)
                // ES3 arguments fallback
                : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
        throw TypeError(name + ': incorrect invocation!');
    }
    return it;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(148);
var ITERATOR = __webpack_require__(31)('iterator');
var Iterators = __webpack_require__(93);
module.exports = __webpack_require__(13).getIteratorMethod = function (it) {
    if (it != undefined)
        return it[ITERATOR]
            || it['@@iterator']
            || Iterators[classof(it)];
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(61);
function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined)
            throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = aFunction(resolve);
    this.reject = aFunction(reject);
}
module.exports.f = function (C) {
    return new PromiseCapability(C);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(42);
module.exports = function (target, src, safe) {
    for (var key in src) {
        if (safe && target[key])
            target[key] = src[key];
        else
            hide(target, key, src[key]);
    }
    return target;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154);
module.exports = __webpack_require__(13).Object.assign;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(21);
$export($export.S + $export.F, 'Object', { assign: __webpack_require__(155) });


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(23);
var getKeys = __webpack_require__(52);
var gOPS = __webpack_require__(97);
var pIE = __webpack_require__(64);
var toObject = __webpack_require__(46);
var IObject = __webpack_require__(74);
var $assign = Object.assign;
// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(37)(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) { B[k] = k; });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;
    while (aLen > index) {
        var S = IObject(arguments[index++]);
        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while (length > j) {
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key))
                T[key] = S[key];
        }
    }
    return T;
} : $assign;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(109), nativeKeys = __webpack_require__(335);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
    if (!isPrototype(object)) {
        return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
        }
    }
    return result;
}
module.exports = baseKeys;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(67), isObject = __webpack_require__(44);
/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

var g;
// This works in non-strict mode
g = (function () {
    return this;
})();
try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
}
catch (e) {
    // This works if the window reference is available
    if (typeof window === "object")
        g = window;
}
// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}
module.exports = g;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(66), root = __webpack_require__(43);
/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');
module.exports = Map;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
    return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
    return function (value) {
        return func(value);
    };
}
module.exports = baseUnary;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(207);
/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */
var nodeUtil = (function () {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
            return types;
        }
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    }
    catch (e) { }
}());
module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)(module)))

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(359), isObjectLike = __webpack_require__(45);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
        return true;
    }
    if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(370), mapCacheDelete = __webpack_require__(377), mapCacheGet = __webpack_require__(379), mapCacheHas = __webpack_require__(380), mapCacheSet = __webpack_require__(381);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(219), stubArray = __webpack_require__(220);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
        return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length &&
        (type == 'number' ||
            (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}
module.exports = isIndex;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26), isSymbol = __webpack_require__(113);
/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
    if (isArray(value)) {
        return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol(value)) {
        return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
}
module.exports = isKey;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(405);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();
module.exports = baseFor;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(230);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
        });
    }
    else {
        object[key] = value;
    }
}
module.exports = baseAssignValue;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(216);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
        array[index] = source[index];
    }
    return array;
}
module.exports = copyArray;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(206);
/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(78), isArrayLike = __webpack_require__(54), isIndex = __webpack_require__(166), isObject = __webpack_require__(44);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
        return false;
    }
    var type = typeof index;
    if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)) {
        return eq(object[index], value);
    }
    return false;
}
module.exports = isIterateeCall;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(442), baseMatchesProperty = __webpack_require__(445), identity = __webpack_require__(123), isArray = __webpack_require__(26), property = __webpack_require__(448);
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
        return value;
    }
    if (value == null) {
        return identity;
    }
    if (typeof value == 'object') {
        return isArray(value)
            ? baseMatchesProperty(value[0], value[1])
            : baseMatches(value);
    }
    return property(value);
}
module.exports = baseIteratee;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it, TYPE) {
    if (!isObject(it) || it._t !== TYPE)
        throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _global=__webpack_require__(499);var _layout=__webpack_require__(501);var _status=__webpack_require__(505);var _ehOperator=__webpack_require__(506);var _reject=__webpack_require__(507);var _share=__webpack_require__(508);var _overTime=__webpack_require__(509);var _requestWithdraw=__webpack_require__(510);var _printLog=__webpack_require__(511);var _freeFlow=__webpack_require__(512);var _printReq=__webpack_require__(513);var _secondAuth=__webpack_require__(514);var _secondAuth2=_interopRequireDefault(_secondAuth);var _selectNextFlow=__webpack_require__(515);var _remindSet=__webpack_require__(516);var _locationMap=__webpack_require__(517);var _followSelect=__webpack_require__(518);var _followSelect2=_interopRequireDefault(_followSelect);var _importFieldLinkageCfg=__webpack_require__(519);var _freeWorkflowSimple=__webpack_require__(520);var _conformRule=__webpack_require__(521);var _ensureSubmit=__webpack_require__(522);var _smartGuessWfStore=__webpack_require__(523);var _smartGuessWfStore2=_interopRequireDefault(_smartGuessWfStore);var _showContentStore=__webpack_require__(524);var _showContentStore2=_interopRequireDefault(_showContentStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//智能预测流程图strore
module.exports={globalStore:new _global.GlobalStore(),layoutStore:new _layout.LayoutStore(),statusStore:new _status.StatusStore(),ehOperatorStore:new _ehOperator.EhOperatorStore(),rejectStore:new _reject.RejectStore(),shareStore:new _share.ShareStore(),overTimeStore:new _overTime.OverTimeStore(),printLogStore:new _printLog.PrintLogStore(),freeFlowStore:new _freeFlow.FreeFlowStore(),printReqStore:new _printReq.PrintReqStore(),secondAuthStore:new _secondAuth2.default(),selectNextFlowStore:new _selectNextFlow.SelectNextFlowStore(),remindSetStore:new _remindSet.RemindSetStore(),locationMapStore:new _locationMap.LocationMapStore(),followSelectStore:new _followSelect2.default(),importFieldLinkageStore:new _importFieldLinkageCfg.FieldLinkageCfg(),freeWflowSimpleStore:new _freeWorkflowSimple.FreeWflowSimple(),ensureSubmitStore:new _ensureSubmit.ensureSubmit(),smartGuessStore:new _smartGuessWfStore2.default(),requestWithdrawStore:new _requestWithdraw.RequestWithdrawStore(),showContentStore:new _showContentStore2.default(),conformRuleStore:new _conformRule.conformRules()};//流程提交二次确认弹框

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _dec,_dec2,_dec3,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BaseStore=(_dec=(0,_mobx.action)('批量控制变量区'),_dec2=(0,_mobx.action)('控制变量区'),_dec3=(0,_mobx.action)('重置变量区'),(_class=function(){function BaseStore(){(0,_classCallCheck3.default)(this,BaseStore);_initDefineProp(this,'variableMap',_descriptor,this);_initDefineProp(this,'batchControlVariableMap',_descriptor2,this);_initDefineProp(this,'controlVariableMap',_descriptor3,this);this.controlVariableMap=this.controlVariableMap;this.batchControlVariableMap=this.batchControlVariableMap;// this.changeState = this.changeState.bind(this);
}(0,_createClass3.default)(BaseStore,[{key:'resetVariableMap',value:function resetVariableMap(){this.variableMap=_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}// @action('自由改变store状态，太暴力，不建议使用，只有改变不常用的状态可以考虑偶尔用用')
// changeState(params = {}) {
//     Object.keys(params).forEach(key => {
//         this[key] = params[key];
//     });
//     return this;
// }
}]);return BaseStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'variableMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'batchControlVariableMap',[_dec],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};(0,_keys2.default)(obj).forEach(function(key){_this.controlVariableMap(key,obj[key]);});};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'controlVariableMap',[_dec2],{enumerable:true,initializer:function initializer(){var _this2=this;return function(key,value){_this2.variableMap.set(key,value);};}}),_applyDecoratedDescriptor(_class.prototype,'resetVariableMap',[_dec3],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'resetVariableMap'),_class.prototype)),_class));exports.default=BaseStore;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
module.exports = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = 
/*#__PURE__*/
__webpack_require__(178);
var _isTransformer = 
/*#__PURE__*/
__webpack_require__(540);
/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
function _dispatchable(methodNames, xf, fn) {
    return function () {
        if (arguments.length === 0) {
            return fn();
        }
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!_isArray(obj)) {
            var idx = 0;
            while (idx < methodNames.length) {
                if (typeof obj[methodNames[idx]] === 'function') {
                    return obj[methodNames[idx]].apply(obj, args);
                }
                idx += 1;
            }
            if (_isTransformer(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}
module.exports = _dispatchable;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = {
    init: function () {
        return this.xf['@@transducer/init']();
    },
    result: function (result) {
        return this.xf['@@transducer/result'](result);
    }
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = 
/*#__PURE__*/
__webpack_require__(548);
var _xwrap = 
/*#__PURE__*/
__webpack_require__(550);
var bind = 
/*#__PURE__*/
__webpack_require__(551);
function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while (!step.done) {
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
}
var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
        fn = _xwrap(fn);
    }
    if (_isArrayLike(list)) {
        return _arrayReduce(fn, acc, list);
    }
    if (typeof list['fantasy-land/reduce'] === 'function') {
        return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }
    if (list[symIterator] != null) {
        return _iterableReduce(fn, acc, list[symIterator]());
    }
    if (typeof list.next === 'function') {
        return _iterableReduce(fn, acc, list);
    }
    if (typeof list.reduce === 'function') {
        return _methodReduce(fn, acc, list, 'reduce');
    }
    throw new TypeError('reduce: list must be array or iterable');
}
module.exports = _reduce;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

function _arity(n, fn) {
    /* eslint-disable no-unused-vars */
    switch (n) {
        case 0:
            return function () {
                return fn.apply(this, arguments);
            };
        case 1:
            return function (a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function (a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function (a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function (a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function (a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function (a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function (a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function (a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = _arity;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
var _has = 
/*#__PURE__*/
__webpack_require__(135);
var _isArguments = 
/*#__PURE__*/
__webpack_require__(553); // cover IE < 9 keys issues
var hasEnumBug = !
/*#__PURE__*/
{
    toString: null
}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug
var hasArgsEnumBug = 
/*#__PURE__*/
function () {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var contains = function contains(list, item) {
    var idx = 0;
    while (idx < list.length) {
        if (list[idx] === item) {
            return true;
        }
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ?
    /*#__PURE__*/
    _curry1(function keys(obj) {
        return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    /*#__PURE__*/
    _curry1(function keys(obj) {
        if (Object(obj) !== obj) {
            return [];
        }
        var prop, nIdx;
        var ks = [];
        var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
        for (prop in obj) {
            if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
                ks[ks.length] = prop;
            }
        }
        if (hasEnumBug) {
            nIdx = nonEnumerableProps.length - 1;
            while (nIdx >= 0) {
                prop = nonEnumerableProps[nIdx];
                if (_has(prop, obj) && !contains(ks, prop)) {
                    ks[ks.length] = prop;
                }
                nIdx -= 1;
            }
        }
        return ks;
    });
module.exports = keys;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var node_1 = __webpack_require__(563);
exports.Node = node_1.Node;
exports.Element = node_1.Element;
exports.DataNode = node_1.DataNode;
exports.NodeWithChildren = node_1.NodeWithChildren;
var reWhitespace = /\s+/g;
// Default options
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false
};
var DomHandler = /** @class */ (function () {
    /**
     * Initiate a new DomHandler.
     *
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The constructed DOM */
        this.dom = [];
        /** Indicated whether parsing has been completed. */
        this._done = false;
        /** Stack of open tags. */
        this._tagStack = [];
        /** A data node that is still being written to. */
        this._lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this._parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this._callback = callback || null;
        this._options = options || defaultOpts;
        this._elementCB = elementCB || null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this._parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this._done = false;
        this._tagStack = [];
        this._lastNode = null;
        this._parser = this._parser || null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this._done)
            return;
        this._done = true;
        this._parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this._lastNode = null;
        // If(this._tagStack.pop().name !== name) this.handleCallback(Error("Tagname didn't match!"));
        var elem = this._tagStack.pop();
        if (!elem || !this._parser) {
            return;
        }
        if (this._options.withEndIndices) {
            elem.endIndex = this._parser.endIndex;
        }
        if (this._elementCB)
            this._elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var element = new node_1.Element(name, attribs);
        this.addNode(element);
        this._tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalize = this._options.normalizeWhitespace;
        var _lastNode = this._lastNode;
        if (_lastNode && _lastNode.type === "text" /* Text */) {
            if (normalize) {
                _lastNode.data = (_lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                _lastNode.data += data;
            }
        }
        else {
            if (normalize) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.DataNode("text" /* Text */, data);
            this.addNode(node);
            this._lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this._lastNode && this._lastNode.type === "comment" /* Comment */) {
            this._lastNode.data += data;
            return;
        }
        var node = new node_1.DataNode("comment" /* Comment */, data);
        this.addNode(node);
        this._lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this._lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.DataNode("text" /* Text */, "");
        var node = new node_1.NodeWithChildren("cdata" /* CDATA */, [text]);
        this.addNode(node);
        text.parent = node;
        this._lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this._lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this._callback === "function") {
            this._callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this._tagStack[this._tagStack.length - 1];
        var siblings = parent ? parent.children : this.dom;
        var previousSibling = siblings[siblings.length - 1];
        if (this._parser) {
            if (this._options.withStartIndices) {
                node.startIndex = this._parser.startIndex;
            }
            if (this._options.withEndIndices) {
                node.endIndex = this._parser.endIndex;
            }
        }
        siblings.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        if (parent) {
            node.parent = parent;
        }
        this._lastNode = null;
    };
    DomHandler.prototype.addDataNode = function (node) {
        this.addNode(node);
        this._lastNode = node;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports.default = DomHandler;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _CellType=__webpack_require__(136);var _CellType2=_interopRequireDefault(_CellType);var _parseLayout=__webpack_require__(68);var Parse=_interopRequireWildcard(_parseLayout);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _convert=__webpack_require__(6);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LayoutTr=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(LayoutTr,_React$Component);function LayoutTr(){(0,_classCallCheck3.default)(this,LayoutTr);return(0,_possibleConstructorReturn3.default)(this,(LayoutTr.__proto__||(0,_getPrototypeOf2.default)(LayoutTr)).apply(this,arguments));}(0,_createClass3.default)(LayoutTr,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(this.props.symbol===nextProps.symbol&&this.props.symbol.indexOf("detail")>-1){//明细特殊处理，解决选中、添加行渲染所有字段问题
return!_.isEqual(this.props.detailProps,nextProps.detailProps)||!_.isEqual(this.props.rowMergeInfo,nextProps.rowMergeInfo);}return true;}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,symbol=_props.symbol,_props$detailProps=_props.detailProps,detailProps=_props$detailProps===undefined?{}:_props$detailProps;if(symbol.indexOf("detail_")>-1){//明细锁定列，加载时渲染完最后一行，则同步一次高度宽度
var groupid=parseInt(symbol.substring(7))-1;var lockedFlag=detailProps.lockedFlag,isLastRow=detailProps.isLastRow;if(lockedFlag===2&&isLastRow===true)DetailUtil.syncLockedForDidMount(groupid);}}},{key:'render',value:function render(){var JSComplete=this.props.globalStore.JSComplete;var _props2=this.props,symbol=_props2.symbol,colNum=_props2.colNum,rowid=_props2.rowid,rowHeight=_props2.rowHeight,rowCusAttr=_props2.rowCusAttr,colattrs=_props2.colattrs,ecMap=_props2.ecMap,_props2$detailProps=_props2.detailProps,detailProps=_props2$detailProps===undefined?{}:_props2$detailProps,_props2$nodeSignProps=_props2.nodeSignProps,nodeSignProps=_props2$nodeSignProps===undefined?{}:_props2$nodeSignProps,dataRows=_props2.dataRows,rowMergeInfo=_props2.rowMergeInfo;var rowType=detailProps.rowType,addColType=detailProps.addColType,_detailProps$rowIndex=detailProps.rowIndex,rowIndex=_detailProps$rowIndex===undefined?"":_detailProps$rowIndex,serialNum=detailProps.serialNum,needHide=detailProps.needHide,_detailProps$lockedFl=detailProps.lockedFlag,lockedFlag=_detailProps$lockedFl===undefined?0:_detailProps$lockedFl,_detailProps$lockedCo=detailProps.lockedColumn,lockedColumn=_detailProps$lockedCo===undefined?-1:_detailProps$lockedCo;//明细解析相关
var isDetail=symbol.indexOf("detail_")>-1;var colid=0;var cellArr=new Array();var isVirtualSum=isDetail&&addColType===4;//低级模式，虚拟生成合计行
while(colid<colNum){//从行第一列正序解析
var isVirtualSerial=isDetail&&colid===0&&addColType>0;//低级模式，虚拟生成的序号列
var isRowMergeCell=Parse.judgeCellBelRowSpan(symbol,rowid,colid,ecMap);//是否行合并单元格
var isLockedHoverCell=lockedFlag===2&&colid<=lockedColumn;//属于锁定列被遮罩的单元格
var cellObj=ecMap[rowid+","+colid];if((isRowMergeCell||!cellObj)&&!isVirtualSerial&&!isVirtualSum){if(!isRowMergeCell){//行合并单元格不生成td
var colCusAttr=colattrs?colattrs["col_"+colid]:null;var tdCellAttr=Parse.getCellAttr(null,colCusAttr,rowHeight);cellArr.push(_react2.default.createElement('td',{className:tdCellAttr.tdClass,style:tdCellAttr.tdStyle}));}colid+=1;}else{var tdClassName=(symbol==="main"?"mainTd":symbol)+'_'+rowid+'_'+colid;//低级模式扩展序号列
if(isVirtualSerial){if(isRowMergeCell||!cellObj)//扩展序号单元格为空时虚拟个CellObj对象
cellObj={id:rowid+',0',etype:"1"};if(addColType===1){cellArr.push(_react2.default.createElement('td',{className:tdClassName}));}else if(addColType===2){//全选，模拟高级模式etype=20
var cellObjNew=_.cloneDeep(cellObj);cellObjNew.etype="20";tdClassName+=" detailtitle_td_swap";cellArr.push(_react2.default.createElement('td',{className:tdClassName},_react2.default.createElement(_CellType2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_CellType@z4ezjy@'+symbol+'_20',symbol:symbol,cellObj:cellObjNew,detailProps:detailProps}),_react2.default.createElement('span',null,(0,_convert.getLabel)(15486,'序号'))));}else if(addColType===3){//单选，模拟高级模式etype=21
var _cellObjNew=_.cloneDeep(cellObj);_cellObjNew.etype="21";cellArr.push(_react2.default.createElement('td',{className:tdClassName},_react2.default.createElement(_CellType2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_CellType@7zuihp@'+symbol+'_21',symbol:symbol,cellObj:_cellObjNew,detailProps:detailProps}),_react2.default.createElement('span',{className:'detailSerial'},serialNum)));}else if(addColType===4){//合计行
cellArr.push(_react2.default.createElement('td',{className:tdClassName},_react2.default.createElement('span',null,'\u5408\u8BA1')));}if(isRowMergeCell&&addColType!==4){colid+=1;continue;}}if(isVirtualSum){//取字段内容行模拟生成合计字段
cellObj=_.cloneDeep(ecMap[rowid+2+","+colid]);_.merge(cellObj,{"etype":"19","rowspan":"1","colspan":"1"});}var rowSpan=parseInt(cellObj.rowspan||1);var colSpan=parseInt(cellObj.colspan||1);//字段行合并
if(rowSpan===dataRows&&cellObj.etype=="3"&&rowMergeInfo){var mergeKey='field'+cellObj.field.toString();if(mergeKey in rowMergeInfo){rowSpan=rowSpan*parseInt(rowMergeInfo[mergeKey]);if(rowSpan===0){colid+=parseInt(colSpan);continue;}}}var _colCusAttr=colattrs?colattrs["col_"+colid]:null;var _tdCellAttr=Parse.getCellAttr(cellObj,_colCusAttr,rowHeight);tdClassName+=' etype_'+cellObj.etype;if(_tdCellAttr.tdClass)tdClassName+=" "+_tdCellAttr.tdClass;if(isVirtualSum)_tdCellAttr.divStyle["color"]="#FF0000";var cellAttr=Parse.buildCellAttr(_tdCellAttr,_tdCellAttr.cusclass,_tdCellAttr.divStyle);cellArr.push(_react2.default.createElement('td',{rowSpan:rowSpan,colSpan:colSpan,className:tdClassName,style:_tdCellAttr.tdStyle},!isLockedHoverCell&&_react2.default.createElement(_CellType2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_CellType@27chqt@'+symbol+'_'+rowid+'_'+colid,symbol:symbol,cellAttr:cellAttr,cellObj:cellObj,detailProps:detailProps,nodeSignProps:nodeSignProps})));colid+=parseInt(colSpan);}}var rowAttr=Parse.getRowAttr(rowHeight,rowCusAttr);var trClass=rowAttr["trClass"]||"";if(isDetail){if(!!serialNum)//明细奇偶行加class方便二开重写
trClass+=" "+(serialNum%2===0?"detail_even_row detail_data_row":"detail_odd_row detail_data_row");if(needHide===true)trClass+=" interface_hide";}else{if(this.judgeNeedHideRow())trClass+=" linkage_hide";if(this.judgePrintHideEmptyDetail())trClass+=" printEmptyDetail_hide";}var trProps={id:rowAttr.id,name:rowAttr.name,className:trClass,style:rowAttr.trStyle};if(isDetail){if(rowType===2)trProps["data-rowindex"]=rowIndex;if(lockedFlag>0){if(rowType===2)trProps["data-rowkey"]=rowIndex+'_'+rowid;else trProps["data-rowkey"]=(rowType===1?"headRow":"tailRow")+'_'+rowid;trProps["data-rowheight"]=trProps.style.height||"30px";}}return _react2.default.createElement('tr',(0,_extends3.default)({},rowAttr.cusobj,trProps),cellArr);}},{key:'judgeNeedHideRow',value:function judgeNeedHideRow(){//显示属性联动隐藏行
var _props3=this.props,symbol=_props3.symbol,rowid=_props3.rowid,layoutStore=_props3.layoutStore;var cellInfo=layoutStore.cellInfo,variableMap=layoutStore.variableMap;var mainRowFields=cellInfo.mainRowFields||{};var rowKey=symbol+'_row_'+rowid;var hide=false;rowKey in mainRowFields&&mainRowFields[rowKey].map(function(fieldid){if(variableMap.get('field'+fieldid+'_viewAttr')===5)//直接取map具体值优化性能
hide=true;});return hide;}},{key:'judgePrintHideEmptyDetail',value:function judgePrintHideEmptyDetail(){//打印隐藏空明细
var hide=false;var _props4=this.props,globalStore=_props4.globalStore,layoutStore=_props4.layoutStore;var commonParam=globalStore.commonParam;if(_.isEmpty(commonParam)||parseInt(commonParam.isprint)!=1)return false;var rowSubPanelMap=layoutStore.rowSubPanelMap,detailMap=layoutStore.detailMap;var _props5=this.props,symbol=_props5.symbol,rowid=_props5.rowid;if(_.has(rowSubPanelMap,symbol+'_'+rowid)){var panelSymbol=rowSubPanelMap[symbol+'_'+rowid];if(panelSymbol.indexOf("detail_")>-1){var detailObj=detailMap.get(panelSymbol);if(detailObj&&detailObj.attr.ishidenull!==1&&detailObj.indexnum===0)hide=true;}}return hide;}}]);return LayoutTr;}(_react2.default.Component))||_class)||_class);exports.default=LayoutTr;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_188__;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
function _interopDefault(ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
var React = __webpack_require__(1);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(138));
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};
var createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var defineProperty = function (obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
};
var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function (self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var createAsyncContext = (function () {
    var idPointer = 0;
    var registry = {};
    var errors = {};
    return {
        getNextId: function getNextId() {
            idPointer += 1;
            return idPointer;
        },
        resolved: function resolved(id) {
            registry[id] = true;
        },
        failed: function failed(id, error) {
            errors[id] = error;
        },
        getState: function getState() {
            return {
                resolved: Object.keys(registry).reduce(function (acc, cur) {
                    return Object.assign(acc, defineProperty({}, cur, true));
                }, {}),
                errors: errors
            };
        }
    };
});
var AsyncComponentProvider = function (_Component) {
    inherits(AsyncComponentProvider, _Component);
    function AsyncComponentProvider() {
        classCallCheck(this, AsyncComponentProvider);
        return possibleConstructorReturn(this, (AsyncComponentProvider.__proto__ || Object.getPrototypeOf(AsyncComponentProvider)).apply(this, arguments));
    }
    createClass(AsyncComponentProvider, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.asyncContext = this.props.asyncContext || createAsyncContext();
                this.rehydrateState = this.props.rehydrateState;
            }
        }, {
            key: 'getChildContext',
            value: function getChildContext() {
                var _this2 = this;
                return {
                    asyncComponents: {
                        getNextId: this.asyncContext.getNextId,
                        resolved: this.asyncContext.resolved,
                        failed: this.asyncContext.failed,
                        shouldRehydrate: function shouldRehydrate(id) {
                            var resolved = _this2.rehydrateState.resolved[id];
                            delete _this2.rehydrateState.resolved[id];
                            return resolved;
                        },
                        getError: function getError(id) {
                            return _this2.rehydrateState.errors && _this2.rehydrateState.errors[id];
                        }
                    }
                };
            }
        }, {
            key: 'render',
            value: function render() {
                return React__default.Children.only(this.props.children);
            }
        }]);
    return AsyncComponentProvider;
}(React.Component);
AsyncComponentProvider.propTypes = {
    children: PropTypes.node.isRequired,
    asyncContext: PropTypes.shape({
        getNextId: PropTypes.func.isRequired,
        resolved: PropTypes.func.isRequired,
        failed: PropTypes.func.isRequired,
        getState: PropTypes.func.isRequired
    }),
    rehydrateState: PropTypes.shape({
        resolved: PropTypes.object
    })
};
AsyncComponentProvider.defaultProps = {
    asyncContext: undefined,
    rehydrateState: {
        resolved: {}
    }
};
AsyncComponentProvider.childContextTypes = {
    asyncComponents: PropTypes.shape({
        getNextId: PropTypes.func.isRequired,
        resolved: PropTypes.func.isRequired,
        failed: PropTypes.func.isRequired,
        shouldRehydrate: PropTypes.func.isRequired,
        getError: PropTypes.func.isRequired
    }).isRequired
};
var validSSRModes = ['resolve', 'defer', 'boundary'];
function asyncComponent(config) {
    var _class, _temp;
    var name = config.name, resolve = config.resolve, _config$autoResolveES = config.autoResolveES2015Default, autoResolveES2015Default = _config$autoResolveES === undefined ? true : _config$autoResolveES, _config$serverMode = config.serverMode, serverMode = _config$serverMode === undefined ? 'resolve' : _config$serverMode, LoadingComponent = config.LoadingComponent, ErrorComponent = config.ErrorComponent;
    if (validSSRModes.indexOf(serverMode) === -1) {
        throw new Error('Invalid serverMode provided to asyncComponent');
    }
    var env = ['node', 'browser'].indexOf(config.env) > -1 ? config.env : typeof window === 'undefined' ? 'node' : 'browser';
    var state = {
        // A unique id we will assign to our async component which is especially
        // useful when rehydrating server side rendered async components.
        id: null,
        // This will be use to hold the resolved module allowing sharing across
        // instances.
        // NOTE: When using React Hot Loader this reference will become null.
        module: null,
        // If an error occurred during a resolution it will be stored here.
        error: null,
        // Allows us to share the resolver promise across instances.
        resolver: null,
        // Indicates whether resolving is taking place
        resolving: false,
        // Handle on the contexts so we don't lose it during async resolution
        asyncComponents: null,
        asyncComponentsAncestor: null
    };
    var needToResolveOnBrowser = function needToResolveOnBrowser() {
        return state.module == null && state.error == null && !state.resolving && typeof window !== 'undefined';
    };
    // Takes the given module and if it has a ".default" the ".default" will
    // be returned. i.e. handy when you could be dealing with es6 imports.
    var es6Resolve = function es6Resolve(x) {
        return autoResolveES2015Default && x != null && (typeof x === 'function' || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object') && x.default ? x.default : x;
    };
    var getResolver = function getResolver() {
        if (state.resolver == null) {
            state.resolving = true;
            try {
                state.resolver = Promise.resolve(resolve());
            }
            catch (err) {
                state.resolver = Promise.reject(err);
            }
        }
        return state.resolver;
    };
    return _temp = _class = function (_React$Component) {
        inherits(AsyncComponent, _React$Component);
        function AsyncComponent() {
            classCallCheck(this, AsyncComponent);
            return possibleConstructorReturn(this, (AsyncComponent.__proto__ || Object.getPrototypeOf(AsyncComponent)).apply(this, arguments));
        }
        createClass(AsyncComponent, [{
                key: 'getChildContext',
                value: function getChildContext() {
                    return {
                        asyncComponentsAncestor: state.asyncComponents == null ? null : {
                            isBoundary: serverMode === 'boundary'
                        }
                    };
                }
            }, {
                key: 'componentWillMount',
                value: function componentWillMount() {
                    if (this.context.asyncComponents != null) {
                        state.asyncComponents = this.context.asyncComponents;
                        state.asyncComponentsAncestor = this.context.asyncComponentsAncestor;
                        if (!state.id) {
                            state.id = this.context.asyncComponents.getNextId();
                        }
                    }
                }
                // react-async-bootstrapper
            }, {
                key: 'bootstrap',
                value: function bootstrap() {
                    var _this2 = this;
                    var doResolve = function doResolve() {
                        return _this2.resolveModule().then(function (module) {
                            return module === undefined ? false : undefined;
                        });
                    };
                    // browser
                    if (env === 'browser') {
                        var _state$asyncComponent = state.asyncComponents, shouldRehydrate = _state$asyncComponent.shouldRehydrate, getError = _state$asyncComponent.getError;
                        var error = getError(state.id);
                        if (error) {
                            state.error = error;
                            return false;
                        }
                        return shouldRehydrate(state.id) ? doResolve() : false;
                    }
                    // node
                    var isChildOfBoundary = state.asyncComponentsAncestor != null && state.asyncComponentsAncestor.isBoundary;
                    return serverMode === 'defer' || isChildOfBoundary ? false : doResolve();
                }
            }, {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (needToResolveOnBrowser()) {
                        this.resolveModule();
                    }
                }
            }, {
                key: 'resolveModule',
                value: function resolveModule() {
                    var _this3 = this;
                    return getResolver().then(function (module) {
                        if (state.asyncComponents != null) {
                            state.asyncComponents.resolved(state.id);
                        }
                        state.module = module;
                        state.error = null;
                        state.resolving = false;
                        return module;
                    }).catch(function (_ref) {
                        var message = _ref.message, stack = _ref.stack;
                        var error = { message: message, stack: stack };
                        if (state.asyncComponents != null) {
                            state.asyncComponents.failed(state.id, error);
                        }
                        state.error = error;
                        state.resolving = false;
                        if (!ErrorComponent) {
                            // eslint-disable-next-line no-console
                            console.error(error);
                        }
                    }).then(function (result) {
                        if (_this3.unmounted) {
                            return undefined;
                        }
                        if (!_this3.context.reactAsyncBootstrapperRunning && env === 'browser') {
                            _this3.forceUpdate();
                        }
                        return result;
                    });
                }
            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.unmounted = true;
                }
            }, {
                key: 'render',
                value: function render() {
                    var module = state.module, error = state.error;
                    if (error) {
                        return ErrorComponent ? React__default.createElement(ErrorComponent, _extends({}, this.props, { error: error })) : null;
                    }
                    var Component = es6Resolve(module);
                    return Component ? React__default.createElement(Component, this.props) : LoadingComponent ? React__default.createElement(LoadingComponent, this.props) : null;
                }
            }]);
        return AsyncComponent;
    }(React__default.Component), _class.displayName = name || 'AsyncComponent', _class.contextTypes = {
        asyncComponentsAncestor: PropTypes.shape({
            isBoundary: PropTypes.bool
        }),
        asyncComponents: PropTypes.shape({
            getNextId: PropTypes.func.isRequired,
            resolved: PropTypes.func.isRequired,
            shouldRehydrate: PropTypes.func.isRequired
        })
    }, _class.childContextTypes = {
        asyncComponentsAncestor: PropTypes.shape({
            isBoundary: PropTypes.bool
        })
    }, _temp;
}
exports.AsyncComponentProvider = AsyncComponentProvider;
exports.createAsyncContext = createAsyncContext;
exports.asyncComponent = asyncComponent;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var PolyEditor = function (_React$Component) {
    _inherits(PolyEditor, _React$Component);
    function PolyEditor(props) {
        _classCallCheck(this, PolyEditor);
        var _this = _possibleConstructorReturn(this, (PolyEditor.__proto__ || Object.getPrototypeOf(PolyEditor)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!(props.__map__ && props.__poly__)) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                var self = _this;
                _this.setterMap = {
                    active: function active(val) {
                        self.toggleActive(val);
                    }
                };
                _this.map = props.__map__;
                _this.poly = props.__poly__;
                _this.editorActive = false;
                _this.createEditorInstance().then(function () {
                    _this.props.onInstanceCreated && _this.props.onInstanceCreated();
                });
            }
        }
        return _this;
    }
    _createClass(PolyEditor, [{
            key: 'toggleActive',
            value: function toggleActive(active) {
                if (active) {
                    if (!this.editorActive) {
                        this.activeEditor();
                    }
                }
                else {
                    if (this.editorActive) {
                        this.inactiveEditor();
                    }
                }
            }
        }, {
            key: 'activeEditor',
            value: function activeEditor() {
                if (this.polyEditor) {
                    this.editorActive = true;
                    this.polyEditor.open();
                }
            }
        }, {
            key: 'inactiveEditor',
            value: function inactiveEditor() {
                this.editorActive = false;
                if (this.polyEditor) {
                    this.polyEditor.close();
                }
            }
        }, {
            key: 'createEditorInstance',
            value: function createEditorInstance() {
                var _this2 = this;
                if (this.polyEditor) {
                    return Promise.resolve(this.polyEditor);
                }
                return new Promise(function (resolve) {
                    _this2.map.plugin(['AMap.PolyEditor'], function () {
                        _this2.polyEditor = new window.AMap.PolyEditor(_this2.map, _this2.poly);
                        resolve(_this2.polyEditor);
                    });
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.polyEditor;
            }
        }]);
    return PolyEditor;
}(_react2.default.Component);
exports.default = (0, _withPropsReactive2.default)(PolyEditor);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(41);
var toObject = __webpack_require__(46);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
var ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO))
        return O[IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
    }
    return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(42);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(20).document;
module.exports = document && document.documentElement;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
    return { value: value, done: !!done };
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(63);
module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(107);
var hiddenKeys = __webpack_require__(94).concat('length', 'prototype');
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(321), __esModule: true };


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(34);
module.exports = function (iterator, fn, value, entries) {
    try {
        return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        // 7.4.6 IteratorClose(iterator, completion)
    }
    catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined)
            anObject(ret.call(iterator));
        throw e;
    }
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(93);
var ITERATOR = __webpack_require__(31)('iterator');
var ArrayProto = Array.prototype;
module.exports = function (it) {
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(34);
var aFunction = __webpack_require__(61);
var SPECIES = __webpack_require__(31)('species');
module.exports = function (O, D) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(36);
var invoke = __webpack_require__(328);
var html = __webpack_require__(193);
var cel = __webpack_require__(91);
var global = __webpack_require__(20);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if (queue.hasOwnProperty(id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
    }
};
var listener = function (event) {
    run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
    setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while (arguments.length > i)
            args.push(arguments[i++]);
        queue[++counter] = function () {
            // eslint-disable-next-line no-new-func
            invoke(typeof fn == 'function' ? fn : Function(fn), args);
        };
        defer(counter);
        return counter;
    };
    clearTask = function clearImmediate(id) {
        delete queue[id];
    };
    // Node.js 0.8-
    if (__webpack_require__(63)(process) == 'process') {
        defer = function (id) {
            process.nextTick(ctx(run, id, 1));
        };
        // Sphere (JS game engine) Dispatch API
    }
    else if (Dispatch && Dispatch.now) {
        defer = function (id) {
            Dispatch.now(ctx(run, id, 1));
        };
        // Browsers with MessageChannel, includes WebWorkers
    }
    else if (MessageChannel) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = listener;
        defer = ctx(port.postMessage, port, 1);
        // Browsers with postMessage, skip WebWorkers
        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    }
    else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
        defer = function (id) {
            global.postMessage(id + '', '*');
        };
        global.addEventListener('message', listener, false);
        // IE8-
    }
    else if (ONREADYSTATECHANGE in cel('script')) {
        defer = function (id) {
            html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
                html.removeChild(this);
                run.call(id);
            };
        };
        // Rest old browsers
    }
    else {
        defer = function (id) {
            setTimeout(ctx(run, id, 1), 0);
        };
    }
}
module.exports = {
    set: setTask,
    clear: clearTask
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = function (exec) {
    try {
        return { e: false, v: exec() };
    }
    catch (e) {
        return { e: true, v: e };
    }
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(34);
var isObject = __webpack_require__(28);
var newPromiseCapability = __webpack_require__(151);
module.exports = function (C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C)
        return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var core = __webpack_require__(13);
var dP = __webpack_require__(32);
var DESCRIPTORS = __webpack_require__(23);
var SPECIES = __webpack_require__(31)('species');
module.exports = function (KEY) {
    var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
    if (DESCRIPTORS && C && !C[SPECIES])
        dP.f(C, SPECIES, {
            configurable: true,
            get: function () { return this; }
        });
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(31)('iterator');
var SAFE_CLOSING = false;
try {
    var riter = [7][ITERATOR]();
    riter['return'] = function () { SAFE_CLOSING = true; };
    // eslint-disable-next-line no-throw-literal
    Array.from(riter, function () { throw 2; });
}
catch (e) { /* empty */ }
module.exports = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING)
        return false;
    var safe = false;
    try {
        var arr = [7];
        var iter = arr[ITERATOR]();
        iter.next = function () { return { done: safe = true }; };
        arr[ITERATOR] = function () { return iter; };
        exec(arr);
    }
    catch (e) { /* empty */ }
    return safe;
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
    return function (arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(158)))

/***/ }),
/* 208 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        }
        catch (e) { }
        try {
            return (func + '');
        }
        catch (e) { }
    }
    return '';
}
module.exports = toSource;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(77), arrayMap = __webpack_require__(210), isArray = __webpack_require__(26), isSymbol = __webpack_require__(113);
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
        return value;
    }
    if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}
module.exports = baseToString;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while (++index < length) {
        result[index] = iteratee(array[index], index, array);
    }
    return result;
}
module.exports = arrayMap;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(349);
/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
    return string
        ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
        : string;
}
module.exports = baseTrim;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while ((fromRight ? index-- : ++index < length)) {
        if (predicate(array[index], index, array)) {
            return index;
        }
    }
    return -1;
}
module.exports = baseFindIndex;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(209);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(382), arraySome = __webpack_require__(385), cacheHas = __webpack_require__(386);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
    }
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
    }
    var index = -1, result = true, seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while (++index < arrLength) {
        var arrValue = array[index], othValue = other[index];
        if (customizer) {
            var compared = isPartial
                ? customizer(othValue, arrValue, index, other, array, stack)
                : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
            if (compared) {
                continue;
            }
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function (othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    return seen.push(othIndex);
                }
            })) {
                result = false;
                break;
            }
        }
        else if (!(arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);
/** Built-in value references. */
var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(218), getSymbols = __webpack_require__(165), keys = __webpack_require__(79);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(121), isArray = __webpack_require__(26);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
            result[resIndex++] = value;
        }
    }
    return result;
}
module.exports = arrayFilter;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
    return [];
}
module.exports = stubArray;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(391), isArguments = __webpack_require__(100), isArray = __webpack_require__(26), isBuffer = __webpack_require__(101), isIndex = __webpack_require__(166), isTypedArray = __webpack_require__(111);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
            // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' ||
                // Node.js 0.10 has enumerable non-index properties on buffers.
                (isBuff && (key == 'offset' || key == 'parent')) ||
                // PhantomJS 2 has enumerable non-index properties on typed arrays.
                (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                // Skip index properties.
                isIndex(key, length)))) {
            result.push(key);
        }
    }
    return result;
}
module.exports = arrayLikeKeys;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(223), isArguments = __webpack_require__(100), isArray = __webpack_require__(26), isIndex = __webpack_require__(166), isLength = __webpack_require__(160), toKey = __webpack_require__(122);
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
            break;
        }
        object = object[key];
    }
    if (result || ++index != length) {
        return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
}
module.exports = hasPath;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26), isKey = __webpack_require__(167), stringToPath = __webpack_require__(394), toString = __webpack_require__(214);
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
    if (isArray(value)) {
        return value;
    }
    return isKey(value, object) ? [value] : stringToPath(toString(value));
}
module.exports = castPath;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(225);
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(223), toKey = __webpack_require__(122);
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while (object != null && index < length) {
        object = object[toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
}
module.exports = baseGet;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(67), isArray = __webpack_require__(26), isObjectLike = __webpack_require__(45);
/** `Object#toString` result references. */
var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}
module.exports = isString;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
    return function (object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(123);
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
    return typeof value == 'function' ? value : identity;
}
module.exports = castFunction;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(169), eq = __webpack_require__(78);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
    if ((value !== undefined && !eq(object[key], value)) ||
        (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
    }
}
module.exports = assignMergeValue;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(66);
var defineProperty = (function () {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    }
    catch (e) { }
}());
module.exports = defineProperty;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(43);
/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
        return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)(module)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(170);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(411), getPrototype = __webpack_require__(172), isPrototype = __webpack_require__(109);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
    return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
}
module.exports = initCloneObject;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') {
        return;
    }
    if (key == '__proto__') {
        return;
    }
    return object[key];
}
module.exports = safeGet;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(169), eq = __webpack_require__(78);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
        (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
    }
}
module.exports = assignValue;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(423);
/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
            break;
        }
    }
    return array;
}
module.exports = arrayEach;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(121), getPrototype = __webpack_require__(172), getSymbols = __webpack_require__(165), stubArray = __webpack_require__(220);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
    var result = [];
    while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(44);
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
    return function (object) {
        if (object == null) {
            return false;
        }
        return object[key] === srcValue &&
            (srcValue !== undefined || (key in Object(object)));
    };
}
module.exports = matchesStrictComparable;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(456), createBaseEach = __webpack_require__(457);
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(470), __esModule: true };


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(32).f;
var create = __webpack_require__(106);
var redefineAll = __webpack_require__(152);
var ctx = __webpack_require__(36);
var anInstance = __webpack_require__(149);
var forOf = __webpack_require__(99);
var $iterDefine = __webpack_require__(140);
var step = __webpack_require__(194);
var setSpecies = __webpack_require__(204);
var DESCRIPTORS = __webpack_require__(23);
var fastKey = __webpack_require__(144).fastKey;
var validate = __webpack_require__(175);
var SIZE = DESCRIPTORS ? '_s' : 'size';
var getEntry = function (that, key) {
    // fast case
    var index = fastKey(key);
    var entry;
    if (index !== 'F')
        return that._i[index];
    // frozen object case
    for (entry = that._f; entry; entry = entry.n) {
        if (entry.k == key)
            return entry;
    }
};
module.exports = {
    getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = create(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[SIZE] = 0; // size
            if (iterable != undefined)
                forOf(iterable, IS_MAP, that[ADDER], that);
        });
        redefineAll(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
                    entry.r = true;
                    if (entry.p)
                        entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function (key) {
                var that = validate(this, NAME);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev)
                        prev.n = next;
                    if (next)
                        next.p = prev;
                    if (that._f == entry)
                        that._f = next;
                    if (that._l == entry)
                        that._l = prev;
                    that[SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */) {
                validate(this, NAME);
                var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while (entry = entry ? entry.n : this._f) {
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while (entry && entry.r)
                        entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!getEntry(validate(this, NAME), key);
            }
        });
        if (DESCRIPTORS)
            dP(C.prototype, 'size', {
                get: function () {
                    return validate(this, NAME)[SIZE];
                }
            });
        return C;
    },
    def: function (that, key, value) {
        var entry = getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) {
            entry.v = value;
            // create new entry
        }
        else {
            that._l = entry = {
                i: index = fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f)
                that._f = entry;
            if (prev)
                prev.n = entry;
            that[SIZE]++;
            // add to index
            if (index !== 'F')
                that._i[index] = entry;
        }
        return that;
    },
    getEntry: getEntry,
    setStrong: function (C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $iterDefine(C, NAME, function (iterated, kind) {
            this._t = validate(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function () {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while (entry && entry.r)
                entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return step(1);
            }
            // return step by kind
            if (kind == 'keys')
                return step(0, entry.k);
            if (kind == 'values')
                return step(0, entry.v);
            return step(0, [entry.k, entry.v]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        setSpecies(NAME);
    }
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var $export = __webpack_require__(21);
var meta = __webpack_require__(144);
var fails = __webpack_require__(37);
var hide = __webpack_require__(42);
var redefineAll = __webpack_require__(152);
var forOf = __webpack_require__(99);
var anInstance = __webpack_require__(149);
var isObject = __webpack_require__(28);
var setToStringTag = __webpack_require__(95);
var dP = __webpack_require__(32).f;
var each = __webpack_require__(472)(0);
var DESCRIPTORS = __webpack_require__(23);
module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = global[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        redefineAll(C.prototype, methods);
        meta.NEED = true;
    }
    else {
        C = wrapper(function (target, iterable) {
            anInstance(target, C, NAME, '_c');
            target._c = new Base();
            if (iterable != undefined)
                forOf(iterable, IS_MAP, target[ADDER], target);
        });
        each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
            var IS_ADDER = KEY == 'add' || KEY == 'set';
            if (KEY in proto && !(IS_WEAK && KEY == 'clear'))
                hide(C.prototype, KEY, function (a, b) {
                    anInstance(this, C, KEY);
                    if (!IS_ADDER && IS_WEAK && !isObject(a))
                        return KEY == 'get' ? undefined : false;
                    var result = this._c[KEY](a === 0 ? 0 : a, b);
                    return IS_ADDER ? this : result;
                });
        });
        IS_WEAK || dP(C.prototype, 'size', {
            get: function () {
                return this._c.size;
            }
        });
    }
    setToStringTag(C, NAME);
    O[NAME] = C;
    $export($export.G + $export.W + $export.F, O);
    if (!IS_WEAK)
        common.setStrong(C, NAME, IS_MAP);
    return C;
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(148);
var from = __webpack_require__(476);
module.exports = function (NAME) {
    return function toJSON() {
        if (classof(this) != NAME)
            throw TypeError(NAME + "#toJSON isn't generic");
        return from(this);
    };
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(21);
module.exports = function (COLLECTION) {
    $export($export.S, COLLECTION, { of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while (length--)
                A[length] = arguments[length];
            return new this(A);
        } });
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(21);
var aFunction = __webpack_require__(61);
var ctx = __webpack_require__(36);
var forOf = __webpack_require__(99);
module.exports = function (COLLECTION) {
    $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            aFunction(this);
            mapping = mapFn !== undefined;
            if (mapping)
                aFunction(mapFn);
            if (source == undefined)
                return new this();
            A = [];
            if (mapping) {
                n = 0;
                cb = ctx(mapFn, arguments[2], 2);
                forOf(source, false, function (nextItem) {
                    A.push(cb(nextItem, n++));
                });
            }
            else {
                forOf(source, false, A.push, A);
            }
            return new this(A);
        } });
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.calculateDetailFormulaNew=exports.bindFormulaEvent=exports.registerFormula=undefined;var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}//新版公式注册入口
var registerFormula=exports.registerFormula=function registerFormula(){var commonParam=_source2.default.globalStore.commonParam;var ismode=commonParam.ismode;if(ismode==2){var linkageCfg=_source2.default.layoutStore.linkageCfg;var _ref=linkageCfg.formulaCfg||{},_ref$formulas=_ref.formulas,formulas=_ref$formulas===undefined?[]:_ref$formulas,_ref$systemdatas=_ref.systemdatas,systemdatas=_ref$systemdatas===undefined?{}:_ref$systemdatas;bindFormulaEvent(formulas,systemdatas);window.has_load_formula=true;}};//绑定公式事件
var bindFormulaEvent=exports.bindFormulaEvent=function bindFormulaEvent(datas,systemdata){var _src$layoutStore=_source2.default.layoutStore,dataJson=_src$layoutStore.dataJson,fieldAttrMap=_src$layoutStore.fieldAttrMap,mainData=_src$layoutStore.mainData,detailMap=_src$layoutStore.detailMap,_src$layoutStore$exis=_src$layoutStore.existChangeRange,existChangeRange=_src$layoutStore$exis===undefined?[]:_src$layoutStore$exis;var importDetail=_source2.default.globalStore.urlParams.importDetail;if(datas){datas.map(function(data){//formula:"[sys.-1]=1",formuladesc:"[系统.请求标题]=1",formulakey:"1533908594972#new#",
//name:"",triggerdesc:"值改变时 (触发字段: 主表.申请人)##载入时",triggers:"1#21934##21",
try{//1#21934##21
var triggers=data.triggers;if(triggers){//1#21934
//21
var triggersArray=triggers.split("##");triggersArray&&triggersArray.map(function(trigger){var triggerArray=trigger.split("#");if(triggerArray&&triggerArray.length>0&&triggerArray[0]){//触发动作
var action=triggerArray[0];//触发字段
var fieldid="";var tableMark="";var fieldMark="";if(triggerArray.length>1){fieldid=triggerArray[1];tableMark=fieldAttrMap.get(fieldid).tableMark;fieldMark='field'+fieldid;}var triInfo={};if(data.formulatxt){triInfo.formulatxt=eval(data.formulatxt);}triInfo.formulakey=data.formulakey;if(data.destcell){triInfo.destcell=eval(data.destcell);}if(data.destfield){triInfo.destfield=eval(data.destfield);}if(data.cellrange){triInfo.cellrange=eval(data.cellrange);}var triggerGroupid=void 0;if(tableMark&&tableMark.indexOf("_")>=0){triggerGroupid=tableMark.substring(tableMark.indexOf("_")+1);}triInfo.triggerGroupid=triggerGroupid;triInfo.systemdata=systemdata;triInfo.workflowid=_source2.default.globalStore.commonParam.workflowid;triInfo.formid=_source2.default.globalStore.commonParam.formid;triInfo.isbill=_source2.default.globalStore.commonParam.isbill;triInfo.requestid=_source2.default.globalStore.commonParam.requestid;//值改变时
if(action==1){if(tableMark.indexOf("detail")===-1){//主表
//(主字段变更)
window.WfForm.bindFieldChangeEvent(fieldMark,function(obj,id,value){triInfo.newValue=value;triInfo.triggerFieldid=id;//调用formulaNew_wev8.js中的formulaTrigger方法
window.formulaTrigger(triInfo);});}else{//明细表
//(明细字段变更)
window.WfForm.bindDetailFieldChangeEvent(fieldMark,function(id,rowIndex,value){triInfo.newValue=value;triInfo.triggerFieldid=id;triInfo.triggerRowIndex=rowIndex;window.formulaTrigger(triInfo);});//明细导入后表单加载时，所有触发字段为明细字段的公式都执行
if(importDetail=="1"){triInfo.triggerFieldid=fieldid;triInfo.importDetail='1';window.formulaTrigger(triInfo);}}//判断触发字段的值是否改变，如果改变过，直接触发一次公式。
existChangeRange.map(function(item){//公式这边的fieldMark是不带下划线的，所以如果是明细字段,需要截掉下划线后再比较
var fieldMark_temp=item.indexOf("_")>-1?item.substring(0,item.indexOf("_")):item;if(fieldMark==fieldMark_temp){window.WfForm.triggerFieldBindEvent(fieldMark,window.WfForm.getFieldValue(fieldMark));}});}//获取输入焦点时
else if(action==2){window.WfForm.bindFieldAction('onfocus',fieldMark,function(id,rowIndex){triInfo.triggerFieldid=id;triInfo.triggerRowIndex=rowIndex;window.formulaTrigger(triInfo);});}//失去输入焦点时
else if(action==3){window.WfForm.bindFieldAction('onblur',fieldMark,function(id,rowIndex){triInfo.triggerFieldid=id;triInfo.triggerRowIndex=rowIndex;window.formulaTrigger(triInfo);});}//鼠标单击时
else if(action==4){window.WfForm.bindFieldAction('onclick',fieldMark,function(id,rowIndex){triInfo.triggerFieldid=id;triInfo.triggerRowIndex=rowIndex;window.formulaTrigger(triInfo);});}//鼠标双击时
else if(action==5){window.WfForm.bindFieldAction('ondbclick',fieldMark,function(id,rowIndex){triInfo.triggerFieldid=id;triInfo.triggerRowIndex=rowIndex;window.formulaTrigger(triInfo);});}//鼠标移入时
else if(action==6){window.WfForm.bindFieldAction('mouseover',fieldMark,function(id,rowIndex){triInfo.triggerFieldid=id;triInfo.triggerRowIndex=rowIndex;window.formulaTrigger(triInfo);});}//鼠标移出时
else if(action==7){window.WfForm.bindFieldAction('mouseout',fieldMark,function(id,rowIndex){triInfo.triggerFieldid=id;triInfo.triggerRowIndex=rowIndex;window.formulaTrigger(triInfo);});}//载入时
else if(action==21){window.formulaTrigger(triInfo);}//窗口滚动时
else if(action==22){window.WfForm.bindScrollEvent(function(){window.formulaTrigger(triInfo);});}//提交/批准时
else if(action==51){window.WfForm.registerCheckEvent(window.WfForm.OPER_SUBMIT,function(callback){var ret=window.formulaTrigger(triInfo);if(ret){window.WfForm.showMessage(ret,1,5);}else{callback();}});}//保存时
else if(action==52){window.WfForm.registerCheckEvent(window.WfForm.OPER_SAVE,function(callback){var ret=window.formulaTrigger(triInfo);if(ret){window.WfForm.showMessage(ret,1,5);}else{callback();}});}//退回时
else if(action==53){window.WfForm.registerCheckEvent(window.WfForm.OPER_REJECT,function(callback){var ret=window.formulaTrigger(triInfo);if(ret){window.WfForm.showMessage(ret,1,5);}else{callback();}});}//转办时
else if(action==54){window.WfForm.registerCheckEvent(window.WfForm.OPER_TURNHANDLE,function(callback){var ret=window.formulaTrigger(triInfo);if(ret){window.WfForm.showMessage(ret,1,5);}else{callback();}});}//转发时
else if(action==56){window.WfForm.registerCheckEvent(window.WfForm.OPER_FORWARD,function(callback){var ret=window.formulaTrigger(triInfo);if(ret){window.WfForm.showMessage(ret,1,5);}else{callback();}});}//意见征询时
else if(action==57){window.WfForm.registerCheckEvent(window.WfForm.OPER_ASKOPINION,function(callback){var ret=window.formulaTrigger(triInfo);if(ret){window.WfForm.showMessage(ret,1,5);}else{callback();}});}//传阅时
else if(action==58){window.WfForm.registerCheckEvent(window.WfForm.OPER_TURNREAD,function(callback){var ret=window.formulaTrigger(triInfo);if(ret){window.WfForm.showMessage(ret,1,5);}else{callback();}});}}});}}catch(ex){if(window.console)console.log("Formula calculate error: "+ex);}});}};//新增和删除明细行时执行公式
var calculateDetailFormulaNew=exports.calculateDetailFormulaNew=function calculateDetailFormulaNew(triggerTableMark,rowIndex){var _src$layoutStore2=_source2.default.layoutStore,dataJson=_src$layoutStore2.dataJson,fieldAttrMap=_src$layoutStore2.fieldAttrMap,mainData=_src$layoutStore2.mainData,detailMap=_src$layoutStore2.detailMap,linkageCfg=_src$layoutStore2.linkageCfg;var _linkageCfg$formulaCf=linkageCfg.formulaCfg,formulas=_linkageCfg$formulaCf.formulas,systemdatas=_linkageCfg$formulaCf.systemdatas;if(formulas){formulas.map(function(data){//formula:"[sys.-1]=1",formuladesc:"[系统.请求标题]=1",formulakey:"1533908594972#new#",
//name:"",triggerdesc:"值改变时 (触发字段: 主表.申请人)##载入时",triggers:"1#21934##21",
try{var newRowIndex=rowIndex.split(",");for(var i=0;i<newRowIndex.length;i++){var oneRowIndex=newRowIndex[i];//1#21934##21
var triggers=data.triggers;if(triggers){//1#21934
//21
var triggersArray=triggers.split("##");triggersArray&&triggersArray.map(function(trigger){var triggerArray=trigger.split("#");if(triggerArray&&triggerArray.length>0&&triggerArray[0]){//触发动作
var action=triggerArray[0];if(action==1||action==2||action==3||action==4||action==5||action==6||action==7||action==21){//触发字段
var tableMark="";if(triggerArray.length>1){tableMark=fieldAttrMap.get(triggerArray[1]).tableMark;}if(triggerTableMark==tableMark||data.formulatxt&&data.formulatxt.indexOf(triggerTableMark+".")>-1||data.formula&&data.formula.indexOf(triggerTableMark+".")>-1||data.destcell&&data.destcell.indexOf(triggerTableMark+".")>-1||data.destfield&&data.destfield.indexOf(triggerTableMark+".")>-1||data.cellrange&&data.cellrange.indexOf(triggerTableMark+".")>-1){var triInfo={};if(data.formulatxt){triInfo.formulatxt=eval(data.formulatxt);}triInfo.formulakey=data.formulakey;if(data.destcell){triInfo.destcell=eval(data.destcell);}if(data.destfield){triInfo.destfield=eval(data.destfield);}if(data.cellrange){triInfo.cellrange=eval(data.cellrange);}var triggerGroupid=void 0;if(triggerTableMark&&triggerTableMark.indexOf("_")>=0){triggerGroupid=triggerTableMark.substring(triggerTableMark.indexOf("_")+1);}triInfo.triggerGroupid=triggerGroupid;triInfo.systemdata=systemdatas;triInfo.workflowid=_source2.default.globalStore.commonParam.workflowid;triInfo.formid=_source2.default.globalStore.commonParam.formid;triInfo.isbill=_source2.default.globalStore.commonParam.isbill;triInfo.requestid=_source2.default.globalStore.commonParam.requestid;triInfo.triggerRowIndex=oneRowIndex;//执行公式
window.formulaTrigger(triInfo);}}}});}}}catch(ex){if(window.console)console.log("Formula calculate error: "+ex);}});}};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.saveCAAuthResult=exports.checkCAAuth=exports.sendCAMessage=exports.doSecondAuth=exports.getDynamicPassword=exports.getSecondAuthConfig=undefined;var _assign=__webpack_require__(65);var _assign2=_interopRequireDefault(_assign);var _convert=__webpack_require__(6);var _secondAuthUtil=__webpack_require__(86);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;//获取二次验证的配置信息
var getSecondAuthConfig=exports.getSecondAuthConfig=function getSecondAuthConfig(params){(0,_assign2.default)(params,{"__weaver_request_url__":(0,_secondAuthUtil.getHostURLencode)()});return WeaTools.callApi('/api/workflow/secondauth/getSecondAuthConfig','POST',params);};//获取动态密码
var getDynamicPassword=exports.getDynamicPassword=function getDynamicPassword(params){return WeaTools.callApi('/api/workflow/secondauth/getDynamicPassword','POST',params);};//二次验证，主要是二次密码，动态令牌，动态密码的验证
var doSecondAuth=exports.doSecondAuth=function doSecondAuth(params){return WeaTools.callApi('/api/workflow/secondauth/doSecondAuth','POST',params);};//发送CA认证的消息
var sendCAMessage=exports.sendCAMessage=function sendCAMessage(params){return WeaTools.callApi('/api/workflow/secondauth/sendCAMessage','POST',params);};//验证CA认证
var checkCAAuth=exports.checkCAAuth=function checkCAAuth(params){return WeaTools.callApi('/api/workflow/secondauth/checkCAAuth','POST',params);};//保存CA认证的结果
var saveCAAuthResult=exports.saveCAAuthResult=function saveCAAuthResult(params){return WeaTools.callApi('/api/workflow/secondauth/saveCAAuthResult','POST',params);};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.conformRule=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _submit=__webpack_require__(57);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _conformRule=__webpack_require__(251);var _conformRule2=_interopRequireDefault(_conformRule);var _reactDom=__webpack_require__(48);var _reactDom2=_interopRequireDefault(_reactDom);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var conformRule=exports.conformRule=function conformRule(callback){//设置合规校验事件
// window.WfForm.registerCheckEvent(window.WfForm.OPER_SUBMIT, function(callback){  //提交按钮上注册合规校验
var formParams=(0,_submit.generateFormData)();var isFirstRequest=true,needStop=false;var params=(0,_extends3.default)({},formParams,_base2.default.globalStore.baseParam,_base2.default.globalStore.submitParam,{useThread:1});var getConformFunc=function getConformFunc(){if(isFirstRequest){isFirstRequest=false;params=(0,_extends3.default)({},params,{isReset:1});}else{delete params.isReset;}if(needStop)return;if(_base2.default.globalStore.commonParam.freeNodeExtendNodeId&&_base2.default.globalStore.commonParam.freeNodeExtendNodeId>0){params.nodeid=_base2.default.globalStore.commonParam.freeNodeExtendNodeId;}API_REQ.conformCheck(params).then(function(data){var result=data.result;if(!result.end){var _this=window;_this.timer=setTimeout(function(){_this.timer&&clearTimeout(_this.timer);if(needStop){_base2.default.globalStore.controlDialogVisible(type.CONFORM_RULE,false);return;}getConformFunc();},1000);}else{if(result.allPass){var _this2=window;_this2.timer=setTimeout(function(){_this2.timer&&clearTimeout(_this2.timer);_base2.default.conformRuleStore.setHasCheckedConformRule(true);},500);_base2.default.globalStore.changeSubmitParam({needConformCheck:'0'});callback();}}_base2.default.conformRuleStore.setHasCheckedConformRule(false);_base2.default.conformRuleStore.setConformRuleInfo(data);!needStop&&_base2.default.globalStore.controlDialogVisible(type.CONFORM_RULE,true);_base2.default.conformRuleStore.setConformRuleSubmitEvent(callback,function(){needStop=true;_base2.default.globalStore.controlDialogVisible(type.CONFORM_RULE,false);});});};getConformFunc();// });
};var showRuleCompareResult=function showRuleCompareResult(){var formParams=(0,_submit.generateFormData)();var params=(0,_extends3.default)({},formParams,_base2.default.globalStore.baseParam,_base2.default.globalStore.submitParam);var obj=null;if(!document.getElementById('conform-rule-container')){obj=document.createElement('div');obj.setAttribute('id','conform-rule-container');document.body.appendChild(obj);}else{obj=document.getElementById('conform-rule-container');}_reactDom2.default.render(_react2.default.createElement(_conformRule2.default,{conformRuleStore:_base2.default.conformRuleStore,isFromCheckResult:true,formParams:params}),obj);};window.showRuleCompareResult=showRuleCompareResult;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(48);var _reactDom2=_interopRequireDefault(_reactDom);var _ecCom=__webpack_require__(51);var _convert=__webpack_require__(6);var _type=__webpack_require__(27);__webpack_require__(489);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var _cloneDeep=__webpack_require__(236);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ConformRuleDialog=(_dec=(0,_mobxReact.inject)('conformRuleStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(ConformRuleDialog,_React$Component);function ConformRuleDialog(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ConformRuleDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ConformRuleDialog.__proto__||(0,_getPrototypeOf2.default)(ConformRuleDialog)).call.apply(_ref,[this].concat(args))),_this),_this.varTemp={btns:[]},_this.state={visible:true},_this.getHeader=function(){var _this$props$conformRu=_this.props.conformRuleStore,status=_this$props$conformRu.status,title=_this$props$conformRu.title;var _this$props$isFromChe=_this.props.isFromCheckResult,isFromCheckResult=_this$props$isFromChe===undefined?false:_this$props$isFromChe;return _react2.default.createElement('p',{className:'top-word'},status?title:getLabel(533549,'正在检测，请稍候')+'...');},_this.reformData=function(datas){var endDatas=(0,_cloneDeep2.default)((0,_mobx.toJS)(datas));endDatas.map(function(item){if(item.key=='status'){item.render=function(r,obj,i){var dom=[];switch(obj.status){case 0:{dom=[_react2.default.createElement('div',{className:'content-wrap'},_react2.default.createElement('img',{src:'/images/ecology9/workflow/loading.gif'}))];};break;//对比中
case 1:{dom.push(_react2.default.createElement('div',{className:'content-wrap'},_react2.default.createElement('i',{className:'icon-coms02-icon-Completion pass',title:getLabel(533550,'校验通过')})));};break;//对比成功
case 2:{dom.push(_react2.default.createElement('div',{className:'content-wrap'},_react2.default.createElement('i',{className:'icon-coms-Clear failed',title:getLabel(533551,'不满足规则时禁止提交流程')})));};break;//对比失败，禁止提交
case 3:{dom.push(_react2.default.createElement('div',{className:'content-wrap'},_react2.default.createElement('i',{className:'icon-coms02-Warning-01 remind',title:getLabel(533552,'不满足规则时仅提醒')})));};break;//对比失败，仅提醒
}return dom;};}});return endDatas;},_this.getContent=function(){var _getEcCom=(0,_convert.getEcCom)(),WeaTable=_getEcCom.WeaTable;var _this$props$conformRu2=_this.props.conformRuleStore.conformRuleInfo,columns=_this$props$conformRu2.columns,datas=_this$props$conformRu2.datas;var newColumns=[];if(columns){newColumns=_this.reformData((0,_mobx.toJS)(columns));}return _react2.default.createElement(WeaTable,{columns:newColumns,dataSource:(0,_mobx.toJS)(datas),pagination:false,scroll:{y:360}});},_this.onSubmit=function(){var _this$props$conformRu3=_this.props.conformRuleStore,conformRuleSubmitEvent=_this$props$conformRu3.conformRuleSubmitEvent,conformRuleCancelEvent=_this$props$conformRu3.conformRuleCancelEvent,setHasCheckedConformRule=_this$props$conformRu3.setHasCheckedConformRule;_base2.default.globalStore.changeSubmitParam({needConformCheck:'0'});typeof conformRuleSubmitEvent=='function'&&conformRuleSubmitEvent();conformRuleCancelEvent();setHasCheckedConformRule(true);_this.setState({visible:false});},_this.onCancel=function(){var conformRuleCancelEvent=_this.props.conformRuleStore.conformRuleCancelEvent;conformRuleCancelEvent();_this.setState({visible:false});},_this.breakCheck=function(){var _this$props$conformRu4=_this.props.conformRuleStore,conformRuleStopRequestEvent=_this$props$conformRu4.conformRuleStopRequestEvent,conformRuleCancelEvent=_this$props$conformRu4.conformRuleCancelEvent;conformRuleStopRequestEvent();_this.onCancel();},_this.getButtons=function(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var result=_this.props.conformRuleStore.conformRuleInfo.result;var buttons=[];if(!_this.props.isFromCheckResult){if(!result.end){//检测中
buttons=[_react2.default.createElement(Button,{onClick:_this.breakCheck},getLabel(31129,'取消'))];}else if(result.allPass){buttons=[_react2.default.createElement(Button,{onClick:_this.breakCheck,disabled:true},getLabel(31129,'取消'))];}else if(result.processType==0){//禁止提交
buttons=[_react2.default.createElement(Button,{type:'primary',onClick:_this.onCancel},getLabel(533553,'修改表单'))];}else if(result.processType==1){//允许提交
buttons=[_react2.default.createElement(Button,{type:'primary',onClick:_this.onSubmit},getLabel(533554,'继续提交流程')),_react2.default.createElement(Button,{onClick:_this.onCancel},getLabel(31129,'取消'))];}}else{buttons=[_react2.default.createElement(Button,{type:'primary',onClick:_this.setDialogHidden},getLabel(826,'\u786E\u5B9A'))];}return buttons;},_this.setDialogHidden=function(){_reactDom2.default.unmountComponentAtNode(document.getElementById('conform-rule-container'));_base2.default.globalStore.changeSubmitParam({needConformCheck:'0'});_this.setState({visible:false});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ConformRuleDialog,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,_props$isFromCheckRes=_props.isFromCheckResult,isFromCheckResult=_props$isFromCheckRes===undefined?false:_props$isFromCheckRes,getCheckResult=_props.conformRuleStore.getCheckResult;var _base$globalStore$com=_base2.default.globalStore.commonParam,nodeid=_base$globalStore$com.nodeid,requestid=_base$globalStore$com.requestid;if(isFromCheckResult){getCheckResult((0,_extends3.default)({isReset:1,nodeid:nodeid,requestid:requestid},this.props.formParams,{needConformCheck:0}));}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({visible:true});}},{key:'render',value:function render(){var _getEcCom2=(0,_convert.getEcCom)(),WeaDialog=_getEcCom2.WeaDialog;var conformDialogvisible=this.props.conformRuleStore.conformDialogvisible;var _props$isFromCheckRes2=this.props.isFromCheckResult,isFromCheckResult=_props$isFromCheckRes2===undefined?false:_props$isFromCheckRes2;var visible=this.state.visible;this.varTemp.btns=this.getButtons();return _react2.default.createElement(WeaDialog,{className:'conform-rule-prompt',title:!isFromCheckResult?getLabel(513004,'信息确认'):getLabel(533555,'节点字段校验结果'),icon:'icon-coms02-Warning',iconBgcolor:'#F2A945',buttons:this.varTemp.btns,visible:visible,style:{width:"563px",height:'447px'},onCancel:!isFromCheckResult?this.breakCheck:this.setDialogHidden,layout:document.getElementById('container')||document.body},this.getHeader(),this.getContent());}}]);return ConformRuleDialog;}(_react2.default.Component))||_class)||_class);exports.default=ConformRuleDialog;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(496), __esModule: true };


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WindowFunc=function(){function WindowFunc(){(0,_classCallCheck3.default)(this,WindowFunc);}(0,_createClass3.default)(WindowFunc,[{key:"getTop",value:function getTop(){var current=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;try{var topWindow=window.top;topWindow.canSet="canSet";if(!topWindow.ecodeSDK){return window.self;}return topWindow;}catch(error){if(current===null){current=window.self;}if(current.setTopWindow){return current.setTopWindow;}else{try{var parentWindow=current.parent;parentWindow.canSet="canSet";return this.getTop(parentWindow);}catch(error){current.setTopWindow=current;return current;}}}}},{key:"getParent",value:function getParent(){try{var parent=window.parent;if(!parent.ecodeSDK){return window.self;}return parent;}catch(error){return window.self;}}}]);return WindowFunc;}();exports.default=new WindowFunc();

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.verifySecondAuth=exports.verifyEncryptShare=exports.judgeDecryptFormat=exports.calculateEncryptFlag=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 字段加密、脱敏展示标示
 * 默认为0
 * 1: 加密字段，非参与人查看***格式
 * 2: 脱敏字段，只读情况，****带小眼睛
 * 3: 脱敏格式，打印查看 以及 非参与人监控查看即加密又脱敏字段情况，仅显示***不带小眼睛
 */var calculateEncryptFlag=exports.calculateEncryptFlag=function calculateEncryptFlag(fieldAttr){var htmltype=fieldAttr.htmltype;if(htmltype!==1&&htmltype!==2)return 0;var _src$globalStore=_source2.default.globalStore,commonParam=_src$globalStore.commonParam,urlParams=_src$globalStore.urlParams;var isSelfAuth=commonParam.isSelfAuth,isprint=commonParam.isprint,iscreate=commonParam.iscreate;var isPreView=urlParams.isPreView;var isPart=isSelfAuth===1||iscreate=="1"||isPreView=="1";//参与权限
var isviewonly=parseInt(commonParam.isviewonly);var _fieldAttr$encryptatt=fieldAttr.encryptattr,encryptattr=_fieldAttr$encryptatt===undefined?{}:_fieldAttr$encryptatt;var desensitization=encryptattr.desensitization,isEncrypt=encryptattr.isEncrypt;//加密字段，非参与人查看密文显示***
if(isEncrypt==="1"&&!isPart)return 1;//脱敏字段
if(desensitization==="1"){//打印脱敏不显示小眼睛
if(isprint=="1")return 3;//只读情况，脱敏格式显示***带小眼睛
if(isviewonly===1||isviewonly===0&&fieldAttr.viewattr<=1)return 2;}return 0;};var judgeDecryptFormat=exports.judgeDecryptFormat=function judgeDecryptFormat(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";return value.startsWith("desensitization__")&&value.length==59||value.startsWith("encryption__")&&value.length==54;};/**
 * 表单加载数据前，加密分享拦截器
 */var verifyEncryptShare=exports.verifyEncryptShare=function verifyEncryptShare(queryParams,callback){if(queryParams.isfromchatshare=="1"&&!!queryParams.serialid){var resourcetype=queryParams.resourcetype,resourceid=queryParams.resourceid,sharer=queryParams.sharer,serialid=queryParams.serialid;var params={mouldCode:'WORKFLOW',// 模块名
itemCode:'SHAREBASE',// 功能项
targetid:resourceid,// 加密对象，如流程或文档id
serialid:serialid,sharer:sharer,//分享人
resourcetype:resourcetype,//分享资源所属模块类型
encrypt:'0'};var execFn=_source2.default.isMobile?window.setShare4em:window.setShare4ec;if(typeof execFn!=="function"){alert('分享打开识别解密方法出现异常，请联系管理员');return;}var verifyFn=function verifyFn(){execFn(params,function(data){data.status=='1'&&callback();});};if(_source2.default.isMobile){verifyFn();}else{_source2.default.globalStore.pushJSCompleteEvent(verifyFn);}}else callback();};/**
 * 表单加载前，二次身份认证拦截
 */var verifySecondAuth=exports.verifySecondAuth=function verifySecondAuth(){var queryParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var beforeFn=arguments[1];var afterFn=arguments[2];var urlParams=(0,_extends3.default)({},queryParams);var isCreate=urlParams.iscreate=="1";beforeFn();_source2.default.API_REQ.loadBaseInfo(urlParams).then(function(data1){delete urlParams["preloadkey"];if(!isCreate&&data1.needSecondAuth===true){_source2.default.globalStore.setLoading(false);//打开表单需要二次身份验证
var verifyFn=_source2.default.isMobile?window.doCheckSecondaryVerify4em:window.doCheckSecondaryVerify4ec;var _data1$params=data1.params,requestid=_data1$params.requestid,workflowid=_data1$params.workflowid,nodeid=_data1$params.nodeid;var verifyParams={mouldCode:'WORKFLOW',// 模块名
itemCode:'NODE',// 功能项
requestid:requestid,workflowid:workflowid,nodeid:nodeid};var execFn=function execFn(){if(window.console)console.log("verifyParams --1",verifyParams);verifyFn(verifyParams,function(verifydata){if(window.console)console.log("verifydata--2",verifydata);if(verifydata.status=="1"){urlParams.hasVerifyAuth=1;urlParams.token=verifydata.token||"";window.API_LOAD_BEGIN=new Date().getTime();beforeFn();if(window.console)console.log("urlParams--3",urlParams);_source2.default.API_REQ.loadBaseInfo(urlParams).then(function(data2){afterFn(data2);});}});};if(_source2.default.isMobile){execFn();}else{loadFullResource(execFn);}}else{afterFn(data1);}});};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;
(function () {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */
    var undefined;
    /** Used as the semantic version number. */
    var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */
    var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */
    var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */
    var wrapFlags = [
        ['ary', WRAP_ARY_FLAG],
        ['bind', WRAP_BIND_FLAG],
        ['bindKey', WRAP_BIND_KEY_FLAG],
        ['curry', WRAP_CURRY_FLAG],
        ['curryRight', WRAP_CURRY_RIGHT_FLAG],
        ['flip', WRAP_FLIP_FLAG],
        ['partial', WRAP_PARTIAL_FLAG],
        ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
        ['rearg', WRAP_REARG_FLAG]
    ];
    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */
    var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */
    var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
     * Used to validate the `validate` option in `_.template` variable.
     *
     * Forbids characters which could potentially change the meaning of the function argument definition:
     * - "()," (modification of function parameters)
     * - "=" (default value)
     * - "[]{}" (destructuring of function parameters)
     * - "/" (beginning of a comment)
     * - whitespace
     */
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;
    /**
     * Used to match
     * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
     */
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */
    var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */
    var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */
    var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */
    var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */
    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
    /** Used to match apostrophes. */
    var reApos = RegExp(rsApos, 'g');
    /**
     * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
     * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
     */
    var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */
    var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */
    var contextProps = [
        'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
        'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
        'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
        'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
        '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */
    var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
        typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
            typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
                typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
                    typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
        typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
            typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
                typedArrayTags[errorTag] = typedArrayTags[funcTag] =
                    typedArrayTags[mapTag] = typedArrayTags[numberTag] =
                        typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
                            typedArrayTags[setTag] = typedArrayTags[stringTag] =
                                typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] =
        cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
            cloneableTags[boolTag] = cloneableTags[dateTag] =
                cloneableTags[float32Tag] = cloneableTags[float64Tag] =
                    cloneableTags[int8Tag] = cloneableTags[int16Tag] =
                        cloneableTags[int32Tag] = cloneableTags[mapTag] =
                            cloneableTags[numberTag] = cloneableTags[objectTag] =
                                cloneableTags[regexpTag] = cloneableTags[setTag] =
                                    cloneableTags[stringTag] = cloneableTags[symbolTag] =
                                        cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
                                            cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] =
        cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */
    var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
        '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
        '\xc7': 'C', '\xe7': 'c',
        '\xd0': 'D', '\xf0': 'd',
        '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
        '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
        '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
        '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
        '\xd1': 'N', '\xf1': 'n',
        '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
        '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
        '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
        '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
        '\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
        '\xc6': 'Ae', '\xe6': 'ae',
        '\xde': 'Th', '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
        '\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
        '\u0106': 'C', '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
        '\u0107': 'c', '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
        '\u010e': 'D', '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
        '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
        '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
        '\u011c': 'G', '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
        '\u011d': 'g', '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
        '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
        '\u0128': 'I', '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
        '\u0129': 'i', '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
        '\u0134': 'J', '\u0135': 'j',
        '\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
        '\u0139': 'L', '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
        '\u013a': 'l', '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
        '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
        '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
        '\u014c': 'O', '\u014e': 'O', '\u0150': 'O',
        '\u014d': 'o', '\u014f': 'o', '\u0151': 'o',
        '\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
        '\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
        '\u015a': 'S', '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
        '\u015b': 's', '\u015d': 's', '\u015f': 's', '\u0161': 's',
        '\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
        '\u0163': 't', '\u0165': 't', '\u0167': 't',
        '\u0168': 'U', '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
        '\u0169': 'u', '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
        '\u0174': 'W', '\u0175': 'w',
        '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
        '\u0179': 'Z', '\u017b': 'Z', '\u017d': 'Z',
        '\u017a': 'z', '\u017c': 'z', '\u017e': 'z',
        '\u0132': 'IJ', '\u0133': 'ij',
        '\u0152': 'Oe', '\u0153': 'oe',
        '\u0149': "'n", '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */
    var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */
    var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */
    var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */
    var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */
    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */
    var nodeUtil = (function () {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) {
                return types;
            }
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        }
        catch (e) { }
    }());
    /* Node.js helper references. */
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
        switch (args.length) {
            case 0: return func.call(thisArg);
            case 1: return func.call(thisArg, args[0]);
            case 2: return func.call(thisArg, args[0], args[1]);
            case 3: return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
     * A specialized version of `baseAggregator` for arrays.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
            if (iteratee(array[index], index, array) === false) {
                break;
            }
        }
        return array;
    }
    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
            if (iteratee(array[length], length, array) === false) {
                break;
            }
        }
        return array;
    }
    /**
     * A specialized version of `_.every` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
            if (!predicate(array[index], index, array)) {
                return false;
            }
        }
        return true;
    }
    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
                result[resIndex++] = value;
            }
        }
        return result;
    }
    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
            if (comparator(value, array[index])) {
                return true;
            }
        }
        return false;
    }
    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
            result[index] = iteratee(array[index], index, array);
        }
        return result;
    }
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
            array[offset + index] = values[index];
        }
        return array;
    }
    /**
     * A specialized version of `_.reduce` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the first element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
            accumulator = array[++index];
        }
        while (++index < length) {
            accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
    }
    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the last element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
            accumulator = array[--length];
        }
        while (length--) {
            accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
    }
    /**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
            if (predicate(array[index], index, array)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Gets the size of an ASCII `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    var asciiSize = baseProperty('length');
    /**
     * Converts an ASCII `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function asciiToArray(string) {
        return string.split('');
    }
    /**
     * Splits an ASCII `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
     * The base implementation of methods like `_.findKey` and `_.findLastKey`,
     * without support for iteratee shorthands, which iterates over `collection`
     * using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function (value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while ((fromRight ? index-- : ++index < length)) {
            if (predicate(array[index], index, array)) {
                return index;
            }
        }
        return -1;
    }
    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOf(array, value, fromIndex) {
        return value === value
            ? strictIndexOf(array, value, fromIndex)
            : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
     * This function is like `baseIndexOf` except that it accepts a comparator.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
            if (comparator(array[index], value)) {
                return index;
            }
        }
        return -1;
    }
    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */
    function baseIsNaN(value) {
        return value !== value;
    }
    /**
     * The base implementation of `_.mean` and `_.meanBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the mean.
     */
    function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? (baseSum(array, iteratee) / length) : NAN;
    }
    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function baseProperty(key) {
        return function (object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
     * The base implementation of `_.propertyOf` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyOf(object) {
        return function (key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
     * The base implementation of `_.reduce` and `_.reduceRight`, without support
     * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initAccum Specify using the first or last element of
     *  `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function (value, index, collection) {
            accumulator = initAccum
                ? (initAccum = false, value)
                : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define the
     * sort order of `array` and replaces criteria objects with their corresponding
     * values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
            array[length] = array[length].value;
        }
        return array;
    }
    /**
     * The base implementation of `_.sum` and `_.sumBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
            var current = iteratee(array[index]);
            if (current !== undefined) {
                result = result === undefined ? current : (result + current);
            }
        }
        return result;
    }
    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
            result[index] = iteratee(index);
        }
        return result;
    }
    /**
     * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
     * of key-value pairs for `object` corresponding to the property names of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the key-value pairs.
     */
    function baseToPairs(object, props) {
        return arrayMap(props, function (key) {
            return [key, object[key]];
        });
    }
    /**
     * The base implementation of `_.trim`.
     *
     * @private
     * @param {string} string The string to trim.
     * @returns {string} Returns the trimmed string.
     */
    function baseTrim(string) {
        return string
            ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
            : string;
    }
    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
        return function (value) {
            return func(value);
        };
    }
    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
        return arrayMap(props, function (key) {
            return object[key];
        });
    }
    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
     * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the first unmatched string symbol.
     */
    function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { }
        return index;
    }
    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the last unmatched string symbol.
     */
    function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { }
        return index;
    }
    /**
     * Gets the number of `placeholder` occurrences in `array`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} placeholder The placeholder to search for.
     * @returns {number} Returns the placeholder count.
     */
    function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
            if (array[length] === placeholder) {
                ++result;
            }
        }
        return result;
    }
    /**
     * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
     * letters to basic Latin letters.
     *
     * @private
     * @param {string} letter The matched letter to deburr.
     * @returns {string} Returns the deburred letter.
     */
    var deburrLetter = basePropertyOf(deburredLetters);
    /**
     * Used by `_.escape` to convert characters to HTML entities.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
     * Used by `_.template` to escape characters for inclusion in compiled string literals.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
     * Checks if `string` contains Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a symbol is found, else `false`.
     */
    function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
     * Checks if `string` contains a word composed of Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a word is found, else `false`.
     */
    function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
     * Converts `iterator` to an array.
     *
     * @private
     * @param {Object} iterator The iterator to convert.
     * @returns {Array} Returns the converted array.
     */
    function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
            result.push(data.value);
        }
        return result;
    }
    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */
    function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function (value, key) {
            result[++index] = [key, value];
        });
        return result;
    }
    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
        return function (arg) {
            return func(transform(arg));
        };
    }
    /**
     * Replaces all `placeholder` elements in `array` with an internal placeholder
     * and returns an array of their indexes.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {*} placeholder The placeholder to replace.
     * @returns {Array} Returns the new array of placeholder indexes.
     */
    function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */
    function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function (value) {
            result[++index] = value;
        });
        return result;
    }
    /**
     * Converts `set` to its value-value pairs.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the value-value pairs.
     */
    function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function (value) {
            result[++index] = [value, value];
        });
        return result;
    }
    /**
     * A specialized version of `_.indexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
            if (array[index] === value) {
                return index;
            }
        }
        return -1;
    }
    /**
     * A specialized version of `_.lastIndexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
            if (array[index] === value) {
                return index;
            }
        }
        return index;
    }
    /**
     * Gets the number of symbols in `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the string size.
     */
    function stringSize(string) {
        return hasUnicode(string)
            ? unicodeSize(string)
            : asciiSize(string);
    }
    /**
     * Converts `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function stringToArray(string) {
        return hasUnicode(string)
            ? unicodeToArray(string)
            : asciiToArray(string);
    }
    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
     * character of `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the index of the last non-whitespace character.
     */
    function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) { }
        return index;
    }
    /**
     * Used by `_.unescape` to convert HTML entities to characters.
     *
     * @private
     * @param {string} chr The matched character to unescape.
     * @returns {string} Returns the unescaped character.
     */
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
     * Gets the size of a Unicode `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
            ++result;
        }
        return result;
    }
    /**
     * Converts a Unicode `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
     * Splits a Unicode `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/
    /**
     * Create a new pristine `lodash` function using the `context` object.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Util
     * @param {Object} [context=root] The context object.
     * @returns {Function} Returns a new `lodash` function.
     * @example
     *
     * _.mixin({ 'foo': _.constant('foo') });
     *
     * var lodash = _.runInContext();
     * lodash.mixin({ 'bar': lodash.constant('bar') });
     *
     * _.isFunction(_.foo);
     * // => true
     * _.isFunction(_.bar);
     * // => false
     *
     * lodash.isFunction(lodash.foo);
     * // => false
     * lodash.isFunction(lodash.bar);
     * // => true
     *
     * // Create a suped-up `defer` in Node.js.
     * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
     */
    var runInContext = (function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */
        var Array = context.Array, Date = context.Date, Error = context.Error, Function = context.Function, Math = context.Math, Object = context.Object, RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */
        var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
        /** Used to detect overreaching core-js shims. */
        var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */
        var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */
        var idCounter = 0;
        /** Used to detect methods masquerading as native. */
        var maskSrcKey = (function () {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? ('Symbol(src)_1.' + uid) : '';
        }());
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */
        var objectCtorString = funcToString.call(Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */
        var oldDash = root._;
        /** Used to detect if a method is native. */
        var reIsNative = RegExp('^' +
            funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
                .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */
        var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = (function () {
            try {
                var func = getNative(Object, 'defineProperty');
                func({}, '', {});
                return func;
            }
            catch (e) { }
        }());
        /** Mocked built-ins. */
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object.keys, Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */
        var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object, 'create');
        /** Used to store function metadata. */
        var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */
        var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */
        var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/
        /**
         * Creates a `lodash` object which wraps `value` to enable implicit method
         * chain sequences. Methods that operate on and return arrays, collections,
         * and functions can be chained together. Methods that retrieve a single value
         * or may return a primitive value will automatically end the chain sequence
         * and return the unwrapped value. Otherwise, the value must be unwrapped
         * with `_#value`.
         *
         * Explicit chain sequences, which must be unwrapped with `_#value`, may be
         * enabled using `_.chain`.
         *
         * The execution of chained methods is lazy, that is, it's deferred until
         * `_#value` is implicitly or explicitly called.
         *
         * Lazy evaluation allows several methods to support shortcut fusion.
         * Shortcut fusion is an optimization to merge iteratee calls; this avoids
         * the creation of intermediate arrays and can greatly reduce the number of
         * iteratee executions. Sections of a chain sequence qualify for shortcut
         * fusion if the section is applied to an array and iteratees accept only
         * one argument. The heuristic for whether a section qualifies for shortcut
         * fusion is subject to change.
         *
         * Chaining is supported in custom builds as long as the `_#value` method is
         * directly or indirectly included in the build.
         *
         * In addition to lodash methods, wrappers have `Array` and `String` methods.
         *
         * The wrapper `Array` methods are:
         * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
         *
         * The wrapper `String` methods are:
         * `replace` and `split`
         *
         * The wrapper methods that support shortcut fusion are:
         * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
         * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
         * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
         *
         * The chainable wrapper methods are:
         * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
         * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
         * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
         * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
         * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
         * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
         * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
         * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
         * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
         * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
         * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
         * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
         * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
         * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
         * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
         * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
         * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
         * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
         * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
         * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
         * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
         * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
         * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
         * `zipObject`, `zipObjectDeep`, and `zipWith`
         *
         * The wrapper methods that are **not** chainable by default are:
         * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
         * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
         * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
         * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
         * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
         * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
         * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
         * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
         * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
         * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
         * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
         * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
         * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
         * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
         * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
         * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
         * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
         * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
         * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
         * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
         * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
         * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
         * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
         * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
         * `upperFirst`, `value`, and `words`
         *
         * @name _
         * @constructor
         * @category Seq
         * @param {*} value The value to wrap in a `lodash` instance.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var wrapped = _([1, 2, 3]);
         *
         * // Returns an unwrapped value.
         * wrapped.reduce(_.add);
         * // => 6
         *
         * // Returns a wrapped value.
         * var squares = wrapped.map(square);
         *
         * _.isArray(squares);
         * // => false
         *
         * _.isArray(squares.value());
         * // => true
         */
        function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) {
                    return value;
                }
                if (hasOwnProperty.call(value, '__wrapped__')) {
                    return wrapperClone(value);
                }
            }
            return new LodashWrapper(value);
        }
        /**
         * The base implementation of `_.create` without support for assigning
         * properties to the created object.
         *
         * @private
         * @param {Object} proto The object to inherit from.
         * @returns {Object} Returns the new object.
         */
        var baseCreate = (function () {
            function object() { }
            return function (proto) {
                if (!isObject(proto)) {
                    return {};
                }
                if (objectCreate) {
                    return objectCreate(proto);
                }
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }());
        /**
         * The function whose prototype chain sequence wrappers inherit from.
         *
         * @private
         */
        function baseLodash() {
            // No operation performed.
        }
        /**
         * The base constructor for creating `lodash` wrapper objects.
         *
         * @private
         * @param {*} value The value to wrap.
         * @param {boolean} [chainAll] Enable explicit method chain sequences.
         */
        function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
         * By default, the template delimiters used by lodash are like those in
         * embedded Ruby (ERB) as well as ES2015 template strings. Change the
         * following template settings to use alternative delimiters.
         *
         * @static
         * @memberOf _
         * @type {Object}
         */
        lodash.templateSettings = {
            /**
             * Used to detect `data` property values to be HTML-escaped.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            'escape': reEscape,
            /**
             * Used to detect code to be evaluated.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            'evaluate': reEvaluate,
            /**
             * Used to detect `data` property values to inject.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            'interpolate': reInterpolate,
            /**
             * Used to reference the data object in the template text.
             *
             * @memberOf _.templateSettings
             * @type {string}
             */
            'variable': '',
            /**
             * Used to import variables into the compiled template.
             *
             * @memberOf _.templateSettings
             * @type {Object}
             */
            'imports': {
                /**
                 * A reference to the `lodash` function.
                 *
                 * @memberOf _.templateSettings.imports
                 * @type {Function}
                 */
                '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/
        /**
         * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
         *
         * @private
         * @constructor
         * @param {*} value The value to wrap.
         */
        function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
         * Creates a clone of the lazy wrapper object.
         *
         * @private
         * @name clone
         * @memberOf LazyWrapper
         * @returns {Object} Returns the cloned `LazyWrapper` object.
         */
        function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
         * Reverses the direction of lazy iteration.
         *
         * @private
         * @name reverse
         * @memberOf LazyWrapper
         * @returns {Object} Returns the new reversed `LazyWrapper` object.
         */
        function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            }
            else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
         * Extracts the unwrapped value from its lazy wrapper.
         *
         * @private
         * @name value
         * @memberOf LazyWrapper
         * @returns {*} Returns the unwrapped value.
         */
        function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : (start - 1), iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
                return baseWrapperValue(array, this.__actions__);
            }
            var result = [];
            outer: while (length-- && resIndex < takeCount) {
                index += dir;
                var iterIndex = -1, value = array[index];
                while (++iterIndex < iterLength) {
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) {
                        value = computed;
                    }
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) {
                            continue outer;
                        }
                        else {
                            break outer;
                        }
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/
        /**
         * Creates a hash object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
         * Removes all key-value entries from the hash.
         *
         * @private
         * @name clear
         * @memberOf Hash
         */
        function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
         * Removes `key` and its value from the hash.
         *
         * @private
         * @name delete
         * @memberOf Hash
         * @param {Object} hash The hash to modify.
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
         * Gets the hash value for `key`.
         *
         * @private
         * @name get
         * @memberOf Hash
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
         * Checks if a hash value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Hash
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
        }
        /**
         * Sets the hash `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Hash
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the hash instance.
         */
        function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/
        /**
         * Creates an list cache object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
         * Removes all key-value entries from the list cache.
         *
         * @private
         * @name clear
         * @memberOf ListCache
         */
        function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
         * Removes `key` and its value from the list cache.
         *
         * @private
         * @name delete
         * @memberOf ListCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                return false;
            }
            var lastIndex = data.length - 1;
            if (index == lastIndex) {
                data.pop();
            }
            else {
                splice.call(data, index, 1);
            }
            --this.size;
            return true;
        }
        /**
         * Gets the list cache value for `key`.
         *
         * @private
         * @name get
         * @memberOf ListCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
         * Checks if a list cache value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf ListCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
         * Sets the list cache `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf ListCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the list cache instance.
         */
        function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([key, value]);
            }
            else {
                data[index][1] = value;
            }
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/
        /**
         * Creates a map cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
         * Removes all key-value entries from the map.
         *
         * @private
         * @name clear
         * @memberOf MapCache
         */
        function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
         * Removes `key` and its value from the map.
         *
         * @private
         * @name delete
         * @memberOf MapCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
         * Gets the map value for `key`.
         *
         * @private
         * @name get
         * @memberOf MapCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
         * Checks if a map value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf MapCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
         * Sets the map `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf MapCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the map cache instance.
         */
        function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/
        /**
         *
         * Creates an array cache object to store unique values.
         *
         * @private
         * @constructor
         * @param {Array} [values] The values to cache.
         */
        function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while (++index < length) {
                this.add(values[index]);
            }
        }
        /**
         * Adds `value` to the array cache.
         *
         * @private
         * @name add
         * @memberOf SetCache
         * @alias push
         * @param {*} value The value to cache.
         * @returns {Object} Returns the cache instance.
         */
        function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
         * Checks if `value` is in the array cache.
         *
         * @private
         * @name has
         * @memberOf SetCache
         * @param {*} value The value to search for.
         * @returns {number} Returns `true` if `value` is found, else `false`.
         */
        function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/
        /**
         * Creates a stack cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
         * Removes all key-value entries from the stack.
         *
         * @private
         * @name clear
         * @memberOf Stack
         */
        function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
         * Removes `key` and its value from the stack.
         *
         * @private
         * @name delete
         * @memberOf Stack
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
         * Gets the stack value for `key`.
         *
         * @private
         * @name get
         * @memberOf Stack
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
         * Checks if a stack value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Stack
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
         * Sets the stack `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Stack
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the stack cache instance.
         */
        function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
                    pairs.push([key, value]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/
        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */
        function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for (var key in value) {
                if ((inherited || hasOwnProperty.call(value, key)) &&
                    !(skipIndexes && (
                    // Safari 9 has enumerable `arguments.length` in strict mode.
                    key == 'length' ||
                        // Node.js 0.10 has enumerable non-index properties on buffers.
                        (isBuff && (key == 'offset' || key == 'parent')) ||
                        // PhantomJS 2 has enumerable non-index properties on typed arrays.
                        (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                        // Skip index properties.
                        isIndex(key, length)))) {
                    result.push(key);
                }
            }
            return result;
        }
        /**
         * A specialized version of `_.sample` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @returns {*} Returns the random element.
         */
        function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
         * A specialized version of `_.sampleSize` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */
        function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
         * A specialized version of `_.shuffle` for arrays.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @returns {Array} Returns the new shuffled array.
         */
        function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
         * This function is like `assignValue` except that it doesn't assign
         * `undefined` values.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function assignMergeValue(object, key, value) {
            if ((value !== undefined && !eq(object[key], value)) ||
                (value === undefined && !(key in object))) {
                baseAssignValue(object, key, value);
            }
        }
        /**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
                (value === undefined && !(key in object))) {
                baseAssignValue(object, key, value);
            }
        }
        /**
         * Gets the index at which the `key` is found in `array` of key-value pairs.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} key The key to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function assocIndexOf(array, key) {
            var length = array.length;
            while (length--) {
                if (eq(array[length][0], key)) {
                    return length;
                }
            }
            return -1;
        }
        /**
         * Aggregates elements of `collection` on `accumulator` with keys transformed
         * by `iteratee` and values set by `setter`.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform keys.
         * @param {Object} accumulator The initial aggregated object.
         * @returns {Function} Returns `accumulator`.
         */
        function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function (value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
         * The base implementation of `_.assign` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */
        function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
         * The base implementation of `_.assignIn` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */
        function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
         * The base implementation of `assignValue` and `assignMergeValue` without
         * value checks.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) {
                defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                });
            }
            else {
                object[key] = value;
            }
        }
        /**
         * The base implementation of `_.at` without support for individual paths.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {string[]} paths The property paths to pick.
         * @returns {Array} Returns the picked elements.
         */
        function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array(length), skip = object == null;
            while (++index < length) {
                result[index] = skip ? undefined : get(object, paths[index]);
            }
            return result;
        }
        /**
         * The base implementation of `_.clamp` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         */
        function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) {
                    number = number <= upper ? number : upper;
                }
                if (lower !== undefined) {
                    number = number >= lower ? number : lower;
                }
            }
            return number;
        }
        /**
         * The base implementation of `_.clone` and `_.cloneDeep` which tracks
         * traversed objects.
         *
         * @private
         * @param {*} value The value to clone.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Deep clone
         *  2 - Flatten inherited properties
         *  4 - Clone symbols
         * @param {Function} [customizer] The function to customize cloning.
         * @param {string} [key] The key of `value`.
         * @param {Object} [object] The parent object of `value`.
         * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
         * @returns {*} Returns the cloned value.
         */
        function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) {
                result = object ? customizer(value, key, object, stack) : customizer(value);
            }
            if (result !== undefined) {
                return result;
            }
            if (!isObject(value)) {
                return value;
            }
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) {
                    return copyArray(value, result);
                }
            }
            else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) {
                    return cloneBuffer(value, isDeep);
                }
                if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
                    result = (isFlat || isFunc) ? {} : initCloneObject(value);
                    if (!isDeep) {
                        return isFlat
                            ? copySymbolsIn(value, baseAssignIn(result, value))
                            : copySymbols(value, baseAssign(result, value));
                    }
                }
                else {
                    if (!cloneableTags[tag]) {
                        return object ? value : {};
                    }
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) {
                return stacked;
            }
            stack.set(value, result);
            if (isSet(value)) {
                value.forEach(function (subValue) {
                    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                });
            }
            else if (isMap(value)) {
                value.forEach(function (subValue, key) {
                    result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
            }
            var keysFunc = isFull
                ? (isFlat ? getAllKeysIn : getAllKeys)
                : (isFlat ? keysIn : keys);
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function (subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
         * The base implementation of `_.conforms` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         */
        function baseConforms(source) {
            var props = keys(source);
            return function (object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
         * The base implementation of `_.conformsTo` which accepts `props` to check.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         */
        function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) {
                return !length;
            }
            object = Object(object);
            while (length--) {
                var key = props[length], predicate = source[key], value = object[key];
                if ((value === undefined && !(key in object)) || !predicate(value)) {
                    return false;
                }
            }
            return true;
        }
        /**
         * The base implementation of `_.delay` and `_.defer` which accepts `args`
         * to provide to `func`.
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @param {Array} args The arguments to provide to `func`.
         * @returns {number|Object} Returns the timer id or timeout object.
         */
        function baseDelay(func, wait, args) {
            if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            return setTimeout(function () { func.apply(undefined, args); }, wait);
        }
        /**
         * The base implementation of methods like `_.difference` without support
         * for excluding multiple arrays or iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Array} values The values to exclude.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         */
        function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) {
                return result;
            }
            if (iteratee) {
                values = arrayMap(values, baseUnary(iteratee));
            }
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            }
            else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while (++index < length) {
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = (comparator || value !== 0) ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while (valuesIndex--) {
                        if (values[valuesIndex] === computed) {
                            continue outer;
                        }
                    }
                    result.push(value);
                }
                else if (!includes(values, computed, comparator)) {
                    result.push(value);
                }
            }
            return result;
        }
        /**
         * The base implementation of `_.forEach` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */
        var baseEach = createBaseEach(baseForOwn);
        /**
         * The base implementation of `_.forEachRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
         * The base implementation of `_.every` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if all elements pass the predicate check,
         *  else `false`
         */
        function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function (value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
         * The base implementation of methods like `_.max` and `_.min` which accepts a
         * `comparator` to determine the extremum value.
         *
         * @private
         * @param {Array} array The array to iterate over.
         * @param {Function} iteratee The iteratee invoked per iteration.
         * @param {Function} comparator The comparator used to compare values.
         * @returns {*} Returns the extremum value.
         */
        function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while (++index < length) {
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined
                    ? (current === current && !isSymbol(current))
                    : comparator(current, computed))) {
                    var computed = current, result = value;
                }
            }
            return result;
        }
        /**
         * The base implementation of `_.fill` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         */
        function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) {
                start = -start > length ? 0 : (length + start);
            }
            end = (end === undefined || end > length) ? length : toInteger(end);
            if (end < 0) {
                end += length;
            }
            end = start > end ? 0 : toLength(end);
            while (start < end) {
                array[start++] = value;
            }
            return array;
        }
        /**
         * The base implementation of `_.filter` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         */
        function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function (value, index, collection) {
                if (predicate(value, index, collection)) {
                    result.push(value);
                }
            });
            return result;
        }
        /**
         * The base implementation of `_.flatten` with support for restricting flattening.
         *
         * @private
         * @param {Array} array The array to flatten.
         * @param {number} depth The maximum recursion depth.
         * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
         * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
         * @param {Array} [result=[]] The initial result value.
         * @returns {Array} Returns the new flattened array.
         */
        function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while (++index < length) {
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) {
                        // Recursively flatten arrays (susceptible to call stack limits).
                        baseFlatten(value, depth - 1, predicate, isStrict, result);
                    }
                    else {
                        arrayPush(result, value);
                    }
                }
                else if (!isStrict) {
                    result[result.length] = value;
                }
            }
            return result;
        }
        /**
         * The base implementation of `baseForOwn` which iterates over `object`
         * properties returned by `keysFunc` and invokes `iteratee` for each property.
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */
        var baseFor = createBaseFor();
        /**
         * This function is like `baseFor` except that it iterates over properties
         * in the opposite order.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */
        var baseForRight = createBaseFor(true);
        /**
         * The base implementation of `_.forOwn` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */
        function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
         * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */
        function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
         * The base implementation of `_.functions` which creates an array of
         * `object` function property names filtered from `props`.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Array} props The property names to filter.
         * @returns {Array} Returns the function names.
         */
        function baseFunctions(object, props) {
            return arrayFilter(props, function (key) {
                return isFunction(object[key]);
            });
        }
        /**
         * The base implementation of `_.get` without support for default values.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @returns {*} Returns the resolved value.
         */
        function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while (object != null && index < length) {
                object = object[toKey(path[index++])];
            }
            return (index && index == length) ? object : undefined;
        }
        /**
         * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
         * `keysFunc` and `symbolsFunc` to get the enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @param {Function} symbolsFunc The function to get the symbols of `object`.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        function baseGetTag(value) {
            if (value == null) {
                return value === undefined ? undefinedTag : nullTag;
            }
            return (symToStringTag && symToStringTag in Object(value))
                ? getRawTag(value)
                : objectToString(value);
        }
        /**
         * The base implementation of `_.gt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         */
        function baseGt(value, other) {
            return value > other;
        }
        /**
         * The base implementation of `_.has` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */
        function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
         * The base implementation of `_.hasIn` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */
        function baseHasIn(object, key) {
            return object != null && key in Object(object);
        }
        /**
         * The base implementation of `_.inRange` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to check.
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         */
        function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
         * The base implementation of methods like `_.intersection`, without support
         * for iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of shared values.
         */
        function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
            while (othIndex--) {
                var array = arrays[othIndex];
                if (othIndex && iteratee) {
                    array = arrayMap(array, baseUnary(iteratee));
                }
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
                    ? new SetCache(othIndex && array)
                    : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while (++index < length && result.length < maxLength) {
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = (comparator || value !== 0) ? value : 0;
                if (!(seen
                    ? cacheHas(seen, computed)
                    : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while (--othIndex) {
                        var cache = caches[othIndex];
                        if (!(cache
                            ? cacheHas(cache, computed)
                            : includes(arrays[othIndex], computed, comparator))) {
                            continue outer;
                        }
                    }
                    if (seen) {
                        seen.push(computed);
                    }
                    result.push(value);
                }
            }
            return result;
        }
        /**
         * The base implementation of `_.invert` and `_.invertBy` which inverts
         * `object` with values transformed by `iteratee` and set by `setter`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform values.
         * @param {Object} accumulator The initial inverted object.
         * @returns {Function} Returns `accumulator`.
         */
        function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function (value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
         * The base implementation of `_.invoke` without support for individual
         * method arguments.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the method to invoke.
         * @param {Array} args The arguments to invoke the method with.
         * @returns {*} Returns the result of the invoked method.
         */
        function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */
        function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
         * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         */
        function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
         * The base implementation of `_.isDate` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         */
        function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
         * The base implementation of `_.isEqual` which supports partial comparisons
         * and tracks traversed objects.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Unordered comparison
         *  2 - Partial comparison
         * @param {Function} [customizer] The function to customize comparisons.
         * @param {Object} [stack] Tracks traversed `value` and `other` objects.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         */
        function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) {
                return true;
            }
            if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
                return value !== value && other !== other;
            }
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
         * A specialized version of `baseIsEqual` for arrays and objects which performs
         * deep comparisons and tracks traversed objects enabling objects with circular
         * references to be compared.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} [stack] Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) {
                    return false;
                }
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return (objIsArr || isTypedArray(object))
                    ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
                    : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) {
                return false;
            }
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
         * The base implementation of `_.isMap` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         */
        function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
         * The base implementation of `_.isMatch` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Array} matchData The property names, values, and compare flags to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         */
        function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) {
                return !length;
            }
            object = Object(object);
            while (index--) {
                var data = matchData[index];
                if ((noCustomizer && data[2])
                    ? data[1] !== object[data[0]]
                    : !(data[0] in object)) {
                    return false;
                }
            }
            while (++index < length) {
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) {
                        return false;
                    }
                }
                else {
                    var stack = new Stack;
                    if (customizer) {
                        var result = customizer(objValue, srcValue, key, object, source, stack);
                    }
                    if (!(result === undefined
                        ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                        : result)) {
                        return false;
                    }
                }
            }
            return true;
        }
        /**
         * The base implementation of `_.isNative` without bad shim checks.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         */
        function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) {
                return false;
            }
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
         * The base implementation of `_.isRegExp` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         */
        function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
         * The base implementation of `_.isSet` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         */
        function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */
        function baseIsTypedArray(value) {
            return isObjectLike(value) &&
                isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
         * The base implementation of `_.iteratee`.
         *
         * @private
         * @param {*} [value=_.identity] The value to convert to an iteratee.
         * @returns {Function} Returns the iteratee.
         */
        function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') {
                return value;
            }
            if (value == null) {
                return identity;
            }
            if (typeof value == 'object') {
                return isArray(value)
                    ? baseMatchesProperty(value[0], value[1])
                    : baseMatches(value);
            }
            return property(value);
        }
        /**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function baseKeys(object) {
            if (!isPrototype(object)) {
                return nativeKeys(object);
            }
            var result = [];
            for (var key in Object(object)) {
                if (hasOwnProperty.call(object, key) && key != 'constructor') {
                    result.push(key);
                }
            }
            return result;
        }
        /**
         * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function baseKeysIn(object) {
            if (!isObject(object)) {
                return nativeKeysIn(object);
            }
            var isProto = isPrototype(object), result = [];
            for (var key in object) {
                if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
                    result.push(key);
                }
            }
            return result;
        }
        /**
         * The base implementation of `_.lt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         */
        function baseLt(value, other) {
            return value < other;
        }
        /**
         * The base implementation of `_.map` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */
        function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
            baseEach(collection, function (value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
         * The base implementation of `_.matches` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         */
        function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) {
                return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            }
            return function (object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
         * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
         *
         * @private
         * @param {string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */
        function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) {
                return matchesStrictComparable(toKey(path), srcValue);
            }
            return function (object) {
                var objValue = get(object, path);
                return (objValue === undefined && objValue === srcValue)
                    ? hasIn(object, path)
                    : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
         * The base implementation of `_.merge` without support for multiple sources.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} [customizer] The function to customize merged values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */
        function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) {
                return;
            }
            baseFor(source, function (srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) {
                    baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                }
                else {
                    var newValue = customizer
                        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
                        : undefined;
                    if (newValue === undefined) {
                        newValue = srcValue;
                    }
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
         * A specialized version of `baseMerge` for arrays and objects which performs
         * deep merges and tracks traversed objects enabling objects with circular
         * references to be merged.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {string} key The key of the value to merge.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} mergeFunc The function to merge values.
         * @param {Function} [customizer] The function to customize assigned values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer
                ? customizer(objValue, srcValue, (key + ''), object, source, stack)
                : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) {
                        newValue = objValue;
                    }
                    else if (isArrayLikeObject(objValue)) {
                        newValue = copyArray(objValue);
                    }
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    }
                    else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    }
                    else {
                        newValue = [];
                    }
                }
                else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) {
                        newValue = toPlainObject(objValue);
                    }
                    else if (!isObject(objValue) || isFunction(objValue)) {
                        newValue = initCloneObject(srcValue);
                    }
                }
                else {
                    isCommon = false;
                }
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
         * The base implementation of `_.nth` which doesn't coerce arguments.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {number} n The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         */
        function baseNth(array, n) {
            var length = array.length;
            if (!length) {
                return;
            }
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
         * The base implementation of `_.orderBy` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
         * @param {string[]} orders The sort orders of `iteratees`.
         * @returns {Array} Returns the new sorted array.
         */
        function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) {
                iteratees = arrayMap(iteratees, function (iteratee) {
                    if (isArray(iteratee)) {
                        return function (value) {
                            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                        };
                    }
                    return iteratee;
                });
            }
            else {
                iteratees = [identity];
            }
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function (value, key, collection) {
                var criteria = arrayMap(iteratees, function (iteratee) {
                    return iteratee(value);
                });
                return { 'criteria': criteria, 'index': ++index, 'value': value };
            });
            return baseSortBy(result, function (object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
         * The base implementation of `_.pick` without support for individual
         * property identifiers.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @returns {Object} Returns the new object.
         */
        function basePick(object, paths) {
            return basePickBy(object, paths, function (value, path) {
                return hasIn(object, path);
            });
        }
        /**
         * The base implementation of  `_.pickBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @param {Function} predicate The function invoked per property.
         * @returns {Object} Returns the new object.
         */
        function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while (++index < length) {
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) {
                    baseSet(result, castPath(path, object), value);
                }
            }
            return result;
        }
        /**
         * A specialized version of `baseProperty` which supports deep paths.
         *
         * @private
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         */
        function basePropertyDeep(path) {
            return function (object) {
                return baseGet(object, path);
            };
        }
        /**
         * The base implementation of `_.pullAllBy` without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         */
        function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) {
                values = copyArray(values);
            }
            if (iteratee) {
                seen = arrayMap(array, baseUnary(iteratee));
            }
            while (++index < length) {
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
                    if (seen !== array) {
                        splice.call(seen, fromIndex, 1);
                    }
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
         * The base implementation of `_.pullAt` without support for individual
         * indexes or capturing the removed elements.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {number[]} indexes The indexes of elements to remove.
         * @returns {Array} Returns `array`.
         */
        function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while (length--) {
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) {
                        splice.call(array, index, 1);
                    }
                    else {
                        baseUnset(array, index);
                    }
                }
            }
            return array;
        }
        /**
         * The base implementation of `_.random` without support for returning
         * floating-point numbers.
         *
         * @private
         * @param {number} lower The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the random number.
         */
        function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
         * The base implementation of `_.range` and `_.rangeRight` which doesn't
         * coerce arguments.
         *
         * @private
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @param {number} step The value to increment or decrement by.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the range of numbers.
         */
        function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
            while (length--) {
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
         * The base implementation of `_.repeat` which doesn't coerce arguments.
         *
         * @private
         * @param {string} string The string to repeat.
         * @param {number} n The number of times to repeat the string.
         * @returns {string} Returns the repeated string.
         */
        function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
                return result;
            }
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) {
                    result += string;
                }
                n = nativeFloor(n / 2);
                if (n) {
                    string += string;
                }
            } while (n);
            return result;
        }
        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */
        function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
         * The base implementation of `_.sample`.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         */
        function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
         * The base implementation of `_.sampleSize` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */
        function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
         * The base implementation of `_.set`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */
        function baseSet(object, path, value, customizer) {
            if (!isObject(object)) {
                return object;
            }
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while (nested != null && ++index < length) {
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
                    return object;
                }
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) {
                        newValue = isObject(objValue)
                            ? objValue
                            : (isIndex(path[index + 1]) ? [] : {});
                    }
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
         * The base implementation of `setData` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */
        var baseSetData = !metaMap ? identity : function (func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
         * The base implementation of `setToString` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var baseSetToString = !defineProperty ? identity : function (func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
         * The base implementation of `_.shuffle`.
         *
         * @private
         * @param {Array|Object} collection The collection to shuffle.
         * @returns {Array} Returns the new shuffled array.
         */
        function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
         * The base implementation of `_.slice` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */
        function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) {
                start = -start > length ? 0 : (length + start);
            }
            end = end > length ? length : end;
            if (end < 0) {
                end += length;
            }
            length = start > end ? 0 : ((end - start) >>> 0);
            start >>>= 0;
            var result = Array(length);
            while (++index < length) {
                result[index] = array[index + start];
            }
            return result;
        }
        /**
         * The base implementation of `_.some` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         */
        function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function (value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
         * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
         * performs a binary search of `array` to determine the index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */
        function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while (low < high) {
                    var mid = (low + high) >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) &&
                        (retHighest ? (computed <= value) : (computed < value))) {
                        low = mid + 1;
                    }
                    else {
                        high = mid;
                    }
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
         * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
         * which invokes `iteratee` for `value` and each element of `array` to compute
         * their sort ranking. The iteratee is invoked with one argument; (value).
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} iteratee The iteratee invoked per element.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */
        function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) {
                return 0;
            }
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while (low < high) {
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) {
                    var setLow = retHighest || othIsReflexive;
                }
                else if (valIsUndefined) {
                    setLow = othIsReflexive && (retHighest || othIsDefined);
                }
                else if (valIsNull) {
                    setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                }
                else if (valIsSymbol) {
                    setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                }
                else if (othIsNull || othIsSymbol) {
                    setLow = false;
                }
                else {
                    setLow = retHighest ? (computed <= value) : (computed < value);
                }
                if (setLow) {
                    low = mid + 1;
                }
                else {
                    high = mid;
                }
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
         * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
         * support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */
        function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while (++index < length) {
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
         * The base implementation of `_.toNumber` which doesn't ensure correct
         * conversions of binary, hexadecimal, or octal string values.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         */
        function baseToNumber(value) {
            if (typeof value == 'number') {
                return value;
            }
            if (isSymbol(value)) {
                return NAN;
            }
            return +value;
        }
        /**
         * The base implementation of `_.toString` which doesn't convert nullish
         * values to empty strings.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {string} Returns the string.
         */
        function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') {
                return value;
            }
            if (isArray(value)) {
                // Recursively convert values (susceptible to call stack limits).
                return arrayMap(value, baseToString) + '';
            }
            if (isSymbol(value)) {
                return symbolToString ? symbolToString.call(value) : '';
            }
            var result = (value + '');
            return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
        }
        /**
         * The base implementation of `_.uniqBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */
        function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            }
            else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) {
                    return setToArray(set);
                }
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            }
            else {
                seen = iteratee ? [] : result;
            }
            outer: while (++index < length) {
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = (comparator || value !== 0) ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while (seenIndex--) {
                        if (seen[seenIndex] === computed) {
                            continue outer;
                        }
                    }
                    if (iteratee) {
                        seen.push(computed);
                    }
                    result.push(value);
                }
                else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) {
                        seen.push(computed);
                    }
                    result.push(value);
                }
            }
            return result;
        }
        /**
         * The base implementation of `_.unset`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The property path to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         */
        function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
         * The base implementation of `_.update`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to update.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */
        function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
         * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
         * without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {Function} predicate The function invoked per iteration.
         * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the slice of `array`.
         */
        function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while ((fromRight ? index-- : ++index < length) &&
                predicate(array[index], index, array)) { }
            return isDrop
                ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
                : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
        }
        /**
         * The base implementation of `wrapperValue` which returns the result of
         * performing a sequence of actions on the unwrapped `value`, where each
         * successive action is supplied the return value of the previous.
         *
         * @private
         * @param {*} value The unwrapped value.
         * @param {Array} actions Actions to perform to resolve the unwrapped value.
         * @returns {*} Returns the resolved value.
         */
        function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) {
                result = result.value();
            }
            return arrayReduce(actions, function (result, action) {
                return action.func.apply(action.thisArg, arrayPush([result], action.args));
            }, result);
        }
        /**
         * The base implementation of methods like `_.xor`, without support for
         * iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of values.
         */
        function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) {
                return length ? baseUniq(arrays[0]) : [];
            }
            var index = -1, result = Array(length);
            while (++index < length) {
                var array = arrays[index], othIndex = -1;
                while (++othIndex < length) {
                    if (othIndex != index) {
                        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                    }
                }
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
         * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
         *
         * @private
         * @param {Array} props The property identifiers.
         * @param {Array} values The property values.
         * @param {Function} assignFunc The function to assign values.
         * @returns {Object} Returns the new object.
         */
        function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while (++index < length) {
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
         * Casts `value` to an empty array if it's not an array like object.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Array|Object} Returns the cast array-like object.
         */
        function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
         * Casts `value` to `identity` if it's not a function.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Function} Returns cast function.
         */
        function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
         * Casts `value` to a path array if it's not one.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {Object} [object] The object to query keys on.
         * @returns {Array} Returns the cast property path array.
         */
        function castPath(value, object) {
            if (isArray(value)) {
                return value;
            }
            return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        /**
         * A `baseRest` alias which can be replaced with `identity` by module
         * replacement plugins.
         *
         * @private
         * @type {Function}
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */
        var castRest = baseRest;
        /**
         * Casts `array` to a slice if it's needed.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {number} start The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the cast slice.
         */
        function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return (!start && end >= length) ? array : baseSlice(array, start, end);
        }
        /**
         * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
         *
         * @private
         * @param {number|Object} id The timer id or timeout object of the timer to clear.
         */
        var clearTimeout = ctxClearTimeout || function (id) {
            return root.clearTimeout(id);
        };
        /**
         * Creates a clone of  `buffer`.
         *
         * @private
         * @param {Buffer} buffer The buffer to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Buffer} Returns the cloned buffer.
         */
        function cloneBuffer(buffer, isDeep) {
            if (isDeep) {
                return buffer.slice();
            }
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
         * Creates a clone of `arrayBuffer`.
         *
         * @private
         * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
         * @returns {ArrayBuffer} Returns the cloned array buffer.
         */
        function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
         * Creates a clone of `dataView`.
         *
         * @private
         * @param {Object} dataView The data view to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned data view.
         */
        function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
         * Creates a clone of `regexp`.
         *
         * @private
         * @param {Object} regexp The regexp to clone.
         * @returns {Object} Returns the cloned regexp.
         */
        function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
         * Creates a clone of the `symbol` object.
         *
         * @private
         * @param {Object} symbol The symbol object to clone.
         * @returns {Object} Returns the cloned symbol object.
         */
        function cloneSymbol(symbol) {
            return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
        }
        /**
         * Creates a clone of `typedArray`.
         *
         * @private
         * @param {Object} typedArray The typed array to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned typed array.
         */
        function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
         * Compares values to sort them in ascending order.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {number} Returns the sort order indicator for `value`.
         */
        function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
                    (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
                    (valIsNull && othIsDefined && othIsReflexive) ||
                    (!valIsDefined && othIsReflexive) ||
                    !valIsReflexive) {
                    return 1;
                }
                if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
                    (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
                    (othIsNull && valIsDefined && valIsReflexive) ||
                    (!othIsDefined && valIsReflexive) ||
                    !othIsReflexive) {
                    return -1;
                }
            }
            return 0;
        }
        /**
         * Used by `_.orderBy` to compare multiple properties of a value to another
         * and stable sort them.
         *
         * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
         * specify an order of "desc" for descending or "asc" for ascending sort order
         * of corresponding values.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {boolean[]|string[]} orders The order to sort by for each property.
         * @returns {number} Returns the sort order indicator for `object`.
         */
        function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while (++index < length) {
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) {
                        return result;
                    }
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
         * Creates an array that is the composition of partially applied arguments,
         * placeholders, and provided arguments into a single array of arguments.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to prepend to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */
        function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
            while (++leftIndex < leftLength) {
                result[leftIndex] = partials[leftIndex];
            }
            while (++argsIndex < holdersLength) {
                if (isUncurried || argsIndex < argsLength) {
                    result[holders[argsIndex]] = args[argsIndex];
                }
            }
            while (rangeLength--) {
                result[leftIndex++] = args[argsIndex++];
            }
            return result;
        }
        /**
         * This function is like `composeArgs` except that the arguments composition
         * is tailored for `_.partialRight`.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to append to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */
        function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
            while (++argsIndex < rangeLength) {
                result[argsIndex] = args[argsIndex];
            }
            var offset = argsIndex;
            while (++rightIndex < rightLength) {
                result[offset + rightIndex] = partials[rightIndex];
            }
            while (++holdersIndex < holdersLength) {
                if (isUncurried || argsIndex < argsLength) {
                    result[offset + holders[holdersIndex]] = args[argsIndex++];
                }
            }
            return result;
        }
        /**
         * Copies the values of `source` to `array`.
         *
         * @private
         * @param {Array} source The array to copy values from.
         * @param {Array} [array=[]] The array to copy values to.
         * @returns {Array} Returns `array`.
         */
        function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array(length));
            while (++index < length) {
                array[index] = source[index];
            }
            return array;
        }
        /**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */
        function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while (++index < length) {
                var key = props[index];
                var newValue = customizer
                    ? customizer(object[key], source[key], key, object, source)
                    : undefined;
                if (newValue === undefined) {
                    newValue = source[key];
                }
                if (isNew) {
                    baseAssignValue(object, key, newValue);
                }
                else {
                    assignValue(object, key, newValue);
                }
            }
            return object;
        }
        /**
         * Copies own symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */
        function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
         * Copies own and inherited symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */
        function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
         * Creates a function like `_.groupBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} [initializer] The accumulator object initializer.
         * @returns {Function} Returns the new aggregator function.
         */
        function createAggregator(setter, initializer) {
            return function (collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */
        function createAssigner(assigner) {
            return baseRest(function (object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = (assigner.length > 3 && typeof customizer == 'function')
                    ? (length--, customizer)
                    : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object(object);
                while (++index < length) {
                    var source = sources[index];
                    if (source) {
                        assigner(object, source, index, customizer);
                    }
                }
                return object;
            });
        }
        /**
         * Creates a `baseEach` or `baseEachRight` function.
         *
         * @private
         * @param {Function} eachFunc The function to iterate over a collection.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseEach(eachFunc, fromRight) {
            return function (collection, iteratee) {
                if (collection == null) {
                    return collection;
                }
                if (!isArrayLike(collection)) {
                    return eachFunc(collection, iteratee);
                }
                var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
                while ((fromRight ? index-- : ++index < length)) {
                    if (iteratee(iterable[index], index, iterable) === false) {
                        break;
                    }
                }
                return collection;
            };
        }
        /**
         * Creates a base function for methods like `_.forIn` and `_.forOwn`.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseFor(fromRight) {
            return function (object, iteratee, keysFunc) {
                var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
                while (length--) {
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) {
                        break;
                    }
                }
                return object;
            };
        }
        /**
         * Creates a function that wraps `func` to invoke it with the optional `this`
         * binding of `thisArg`.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
         * Creates a function like `_.lowerFirst`.
         *
         * @private
         * @param {string} methodName The name of the `String` case method to use.
         * @returns {Function} Returns the new case function.
         */
        function createCaseFirst(methodName) {
            return function (string) {
                string = toString(string);
                var strSymbols = hasUnicode(string)
                    ? stringToArray(string)
                    : undefined;
                var chr = strSymbols
                    ? strSymbols[0]
                    : string.charAt(0);
                var trailing = strSymbols
                    ? castSlice(strSymbols, 1).join('')
                    : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
         * Creates a function like `_.camelCase`.
         *
         * @private
         * @param {Function} callback The function to combine each word.
         * @returns {Function} Returns the new compounder function.
         */
        function createCompounder(callback) {
            return function (string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
         * Creates a function that produces an instance of `Ctor` regardless of
         * whether it was invoked as part of a `new` expression or by `call` or `apply`.
         *
         * @private
         * @param {Function} Ctor The constructor to wrap.
         * @returns {Function} Returns the new wrapped function.
         */
        function createCtor(Ctor) {
            return function () {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch (args.length) {
                    case 0: return new Ctor;
                    case 1: return new Ctor(args[0]);
                    case 2: return new Ctor(args[0], args[1]);
                    case 3: return new Ctor(args[0], args[1], args[2]);
                    case 4: return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
         * Creates a function that wraps `func` to enable currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {number} arity The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array(length), index = length, placeholder = getHolder(wrapper);
                while (index--) {
                    args[index] = arguments[index];
                }
                var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
                    ? []
                    : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) {
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                }
                var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
         * Creates a `_.find` or `_.findLast` function.
         *
         * @private
         * @param {Function} findIndexFunc The function to find the collection index.
         * @returns {Function} Returns the new find function.
         */
        function createFind(findIndexFunc) {
            return function (collection, predicate, fromIndex) {
                var iterable = Object(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function (key) { return iteratee(iterable[key], key, iterable); };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
         * Creates a `_.flow` or `_.flowRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new flow function.
         */
        function createFlow(fromRight) {
            return flatRest(function (funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) {
                    funcs.reverse();
                }
                while (index--) {
                    var func = funcs[index];
                    if (typeof func != 'function') {
                        throw new TypeError(FUNC_ERROR_TEXT);
                    }
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                        var wrapper = new LodashWrapper([], true);
                    }
                }
                index = wrapper ? index : length;
                while (++index < length) {
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) &&
                        data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                        !data[4].length && data[9] == 1) {
                        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    }
                    else {
                        wrapper = (func.length == 1 && isLaziable(func))
                            ? wrapper[funcName]()
                            : wrapper.thru(func);
                    }
                }
                return function () {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) {
                        return wrapper.plant(value).value();
                    }
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while (++index < length) {
                        result = funcs[index].call(this, result);
                    }
                    return result;
                };
            });
        }
        /**
         * Creates a function that wraps `func` to invoke it with optional `this`
         * binding of `thisArg`, partial application, and currying.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [partialsRight] The arguments to append to those provided
         *  to the new function.
         * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array(length), index = length;
                while (index--) {
                    args[index] = arguments[index];
                }
                if (isCurried) {
                    var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                }
                if (partials) {
                    args = composeArgs(args, partials, holders, isCurried);
                }
                if (partialsRight) {
                    args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                }
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) {
                    args = reorder(args, argPos);
                }
                else if (isFlip && length > 1) {
                    args.reverse();
                }
                if (isAry && ary < length) {
                    args.length = ary;
                }
                if (this && this !== root && this instanceof wrapper) {
                    fn = Ctor || createCtor(fn);
                }
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
         * Creates a function like `_.invertBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} toIteratee The function to resolve iteratees.
         * @returns {Function} Returns the new inverter function.
         */
        function createInverter(setter, toIteratee) {
            return function (object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
         * Creates a function that performs a mathematical operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @param {number} [defaultValue] The value used for `undefined` arguments.
         * @returns {Function} Returns the new mathematical operation function.
         */
        function createMathOperation(operator, defaultValue) {
            return function (value, other) {
                var result;
                if (value === undefined && other === undefined) {
                    return defaultValue;
                }
                if (value !== undefined) {
                    result = value;
                }
                if (other !== undefined) {
                    if (result === undefined) {
                        return other;
                    }
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    }
                    else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
         * Creates a function like `_.over`.
         *
         * @private
         * @param {Function} arrayFunc The function to iterate over iteratees.
         * @returns {Function} Returns the new over function.
         */
        function createOver(arrayFunc) {
            return flatRest(function (iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function (args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function (iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
         * Creates the padding for `string` based on `length`. The `chars` string
         * is truncated if the number of characters exceeds `length`.
         *
         * @private
         * @param {number} length The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padding for `string`.
         */
        function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) {
                return charsLength ? baseRepeat(chars, length) : chars;
            }
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars)
                ? castSlice(stringToArray(result), 0, length).join('')
                : result.slice(0, length);
        }
        /**
         * Creates a function that wraps `func` to invoke it with the `this` binding
         * of `thisArg` and `partials` prepended to the arguments it receives.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} partials The arguments to prepend to those provided to
         *  the new function.
         * @returns {Function} Returns the new wrapped function.
         */
        function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
                while (++leftIndex < leftLength) {
                    args[leftIndex] = partials[leftIndex];
                }
                while (argsLength--) {
                    args[leftIndex++] = arguments[++argsIndex];
                }
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
         * Creates a `_.range` or `_.rangeRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new range function.
         */
        function createRange(fromRight) {
            return function (start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
                    end = step = undefined;
                }
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                }
                else {
                    end = toFinite(end);
                }
                step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
         * Creates a function that performs a relational operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @returns {Function} Returns the new relational operation function.
         */
        function createRelationalOperation(operator) {
            return function (value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
         * Creates a function that wraps `func` to continue currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {Function} wrapFunc The function to create the `func` wrapper.
         * @param {*} placeholder The placeholder value.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
                bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            }
            var newData = [
                func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
                newHoldersRight, argPos, ary, arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) {
                setData(result, newData);
            }
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
         * Creates a function like `_.round`.
         *
         * @private
         * @param {string} methodName The name of the `Math` method to use when rounding.
         * @returns {Function} Returns the new round function.
         */
        function createRound(methodName) {
            var func = Math[methodName];
            return function (number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
         * Creates a set object of `values`.
         *
         * @private
         * @param {Array} values The values to add to the set.
         * @returns {Object} Returns the new set.
         */
        var createSet = !(Set && (1 / setToArray(new Set([, -0]))[1]) == INFINITY) ? noop : function (values) {
            return new Set(values);
        };
        /**
         * Creates a `_.toPairs` or `_.toPairsIn` function.
         *
         * @private
         * @param {Function} keysFunc The function to get the keys of a given object.
         * @returns {Function} Returns the new pairs function.
         */
        function createToPairs(keysFunc) {
            return function (object) {
                var tag = getTag(object);
                if (tag == mapTag) {
                    return mapToArray(object);
                }
                if (tag == setTag) {
                    return setToPairs(object);
                }
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
         * Creates a function that either curries or invokes `func` with optional
         * `this` binding and partially applied arguments.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags.
         *    1 - `_.bind`
         *    2 - `_.bindKey`
         *    4 - `_.curry` or `_.curryRight` of a bound function
         *    8 - `_.curry`
         *   16 - `_.curryRight`
         *   32 - `_.partial`
         *   64 - `_.partialRight`
         *  128 - `_.rearg`
         *  256 - `_.ary`
         *  512 - `_.flip`
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to be partially applied.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
                argPos, ary, arity
            ];
            if (data) {
                mergeData(newData, data);
            }
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined
                ? (isBindKey ? 0 : func.length)
                : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
                bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            }
            if (!bitmask || bitmask == WRAP_BIND_FLAG) {
                var result = createBind(func, bitmask, thisArg);
            }
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
                result = createCurry(func, bitmask, arity);
            }
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
                result = createPartial(func, bitmask, thisArg, partials);
            }
            else {
                result = createHybrid.apply(undefined, newData);
            }
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
         * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
         * of source objects to the destination object for all destination properties
         * that resolve to `undefined`.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to assign.
         * @param {Object} object The parent object of `objValue`.
         * @returns {*} Returns the value to assign.
         */
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined ||
                (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
                return srcValue;
            }
            return objValue;
        }
        /**
         * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
         * objects into destination objects that are passed thru.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to merge.
         * @param {Object} object The parent object of `objValue`.
         * @param {Object} source The parent object of `srcValue`.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         * @returns {*} Returns the value to assign.
         */
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
         * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
         * objects.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {string} key The key of the property to inspect.
         * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
         */
        function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
         * A specialized version of `baseIsEqualDeep` for arrays with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Array} array The array to compare.
         * @param {Array} other The other array to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `array` and `other` objects.
         * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
         */
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
                return false;
            }
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) {
                return arrStacked == other && othStacked == array;
            }
            var index = -1, result = true, seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while (++index < arrLength) {
                var arrValue = array[index], othValue = other[index];
                if (customizer) {
                    var compared = isPartial
                        ? customizer(othValue, arrValue, index, other, array, stack)
                        : customizer(arrValue, othValue, index, array, other, stack);
                }
                if (compared !== undefined) {
                    if (compared) {
                        continue;
                    }
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function (othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) &&
                            (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                            return seen.push(othIndex);
                        }
                    })) {
                        result = false;
                        break;
                    }
                }
                else if (!(arrValue === othValue ||
                    equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
         * A specialized version of `baseIsEqualDeep` for comparing objects of
         * the same `toStringTag`.
         *
         * **Note:** This function only supports comparing values with tags of
         * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {string} tag The `toStringTag` of the objects to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch (tag) {
                case dataViewTag:
                    if ((object.byteLength != other.byteLength) ||
                        (object.byteOffset != other.byteOffset)) {
                        return false;
                    }
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if ((object.byteLength != other.byteLength) ||
                        !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                        return false;
                    }
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == (other + '');
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) {
                        return false;
                    }
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) {
                        return stacked == other;
                    }
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) {
                        return symbolValueOf.call(object) == symbolValueOf.call(other);
                    }
            }
            return false;
        }
        /**
         * A specialized version of `baseIsEqualDeep` for objects with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) {
                return false;
            }
            var index = objLength;
            while (index--) {
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                    return false;
                }
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) {
                return objStacked == other && othStacked == object;
            }
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while (++index < objLength) {
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) {
                    var compared = isPartial
                        ? customizer(othValue, objValue, key, other, object, stack)
                        : customizer(objValue, othValue, key, object, other, stack);
                }
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined
                    ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
                    : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor &&
                    ('constructor' in object && 'constructor' in other) &&
                    !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
                        typeof othCtor == 'function' && othCtor instanceof othCtor)) {
                    result = false;
                }
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
         * A specialized version of `baseRest` which flattens the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */
        function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
         * Creates an array of own enumerable property names and symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
         * Creates an array of own and inherited enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
         * Gets metadata for `func`.
         *
         * @private
         * @param {Function} func The function to query.
         * @returns {*} Returns the metadata for `func`.
         */
        var getData = !metaMap ? noop : function (func) {
            return metaMap.get(func);
        };
        /**
         * Gets the name of `func`.
         *
         * @private
         * @param {Function} func The function to query.
         * @returns {string} Returns the function name.
         */
        function getFuncName(func) {
            var result = (func.name + ''), array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while (length--) {
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) {
                    return data.name;
                }
            }
            return result;
        }
        /**
         * Gets the argument placeholder value for `func`.
         *
         * @private
         * @param {Function} func The function to inspect.
         * @returns {*} Returns the placeholder value.
         */
        function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
         * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
         * this function returns the custom method, otherwise it returns `baseIteratee`.
         * If arguments are provided, the chosen function is invoked with them and
         * its result is returned.
         *
         * @private
         * @param {*} [value] The value to convert to an iteratee.
         * @param {number} [arity] The arity of the created iteratee.
         * @returns {Function} Returns the chosen function or its result.
         */
        function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
         * Gets the data for `map`.
         *
         * @private
         * @param {Object} map The map to query.
         * @param {string} key The reference key.
         * @returns {*} Returns the map data.
         */
        function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key)
                ? data[typeof key == 'string' ? 'string' : 'hash']
                : data.map;
        }
        /**
         * Gets the property names, values, and compare flags of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the match data of `object`.
         */
        function getMatchData(object) {
            var result = keys(object), length = result.length;
            while (length--) {
                var key = result[length], value = object[key];
                result[length] = [key, value, isStrictComparable(value)];
            }
            return result;
        }
        /**
         * Gets the native function at `key` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the method to get.
         * @returns {*} Returns the function if it's native, else `undefined`.
         */
        function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */
        function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            }
            catch (e) { }
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) {
                    value[symToStringTag] = tag;
                }
                else {
                    delete value[symToStringTag];
                }
            }
            return result;
        }
        /**
         * Creates an array of the own enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */
        var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
            if (object == null) {
                return [];
            }
            object = Object(object);
            return arrayFilter(nativeGetSymbols(object), function (symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
         * Creates an array of the own and inherited enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
            var result = [];
            while (object) {
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
         * Gets the `toStringTag` of `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
            (Map && getTag(new Map) != mapTag) ||
            (Promise && getTag(Promise.resolve()) != promiseTag) ||
            (Set && getTag(new Set) != setTag) ||
            (WeakMap && getTag(new WeakMap) != weakMapTag)) {
            getTag = function (value) {
                var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
                if (ctorString) {
                    switch (ctorString) {
                        case dataViewCtorString: return dataViewTag;
                        case mapCtorString: return mapTag;
                        case promiseCtorString: return promiseTag;
                        case setCtorString: return setTag;
                        case weakMapCtorString: return weakMapTag;
                    }
                }
                return result;
            };
        }
        /**
         * Gets the view, applying any `transforms` to the `start` and `end` positions.
         *
         * @private
         * @param {number} start The start of the view.
         * @param {number} end The end of the view.
         * @param {Array} transforms The transformations to apply to the view.
         * @returns {Object} Returns an object containing the `start` and `end`
         *  positions of the view.
         */
        function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while (++index < length) {
                var data = transforms[index], size = data.size;
                switch (data.type) {
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return { 'start': start, 'end': end };
        }
        /**
         * Extracts wrapper details from the `source` body comment.
         *
         * @private
         * @param {string} source The source to inspect.
         * @returns {Array} Returns the wrapper details.
         */
        function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
         * Checks if `path` exists on `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @param {Function} hasFunc The function to check properties.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         */
        function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while (++index < length) {
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) {
                    break;
                }
                object = object[key];
            }
            if (result || ++index != length) {
                return result;
            }
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) &&
                (isArray(object) || isArguments(object));
        }
        /**
         * Initializes an array clone.
         *
         * @private
         * @param {Array} array The array to clone.
         * @returns {Array} Returns the initialized clone.
         */
        function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
         * Initializes an object clone.
         *
         * @private
         * @param {Object} object The object to clone.
         * @returns {Object} Returns the initialized clone.
         */
        function initCloneObject(object) {
            return (typeof object.constructor == 'function' && !isPrototype(object))
                ? baseCreate(getPrototype(object))
                : {};
        }
        /**
         * Initializes an object clone based on its `toStringTag`.
         *
         * **Note:** This function only supports cloning values with tags of
         * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
         *
         * @private
         * @param {Object} object The object to clone.
         * @param {string} tag The `toStringTag` of the object to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the initialized clone.
         */
        function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch (tag) {
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
         * Inserts wrapper `details` in a comment at the top of the `source` body.
         *
         * @private
         * @param {string} source The source to modify.
         * @returns {Array} details The details to insert.
         * @returns {string} Returns the modified source.
         */
        function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) {
                return source;
            }
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
         * Checks if `value` is a flattenable `arguments` object or array.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
         */
        function isFlattenable(value) {
            return isArray(value) || isArguments(value) ||
                !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */
        function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length &&
                (type == 'number' ||
                    (type != 'symbol' && reIsUint.test(value))) &&
                (value > -1 && value % 1 == 0 && value < length);
        }
        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */
        function isIterateeCall(value, index, object) {
            if (!isObject(object)) {
                return false;
            }
            var type = typeof index;
            if (type == 'number'
                ? (isArrayLike(object) && isIndex(index, object.length))
                : (type == 'string' && index in object)) {
                return eq(object[index], value);
            }
            return false;
        }
        /**
         * Checks if `value` is a property name and not a property path.
         *
         * @private
         * @param {*} value The value to check.
         * @param {Object} [object] The object to query keys on.
         * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
         */
        function isKey(value, object) {
            if (isArray(value)) {
                return false;
            }
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' ||
                value == null || isSymbol(value)) {
                return true;
            }
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
                (object != null && value in Object(object));
        }
        /**
         * Checks if `value` is suitable for use as unique object key.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
         */
        function isKeyable(value) {
            var type = typeof value;
            return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
                ? (value !== '__proto__')
                : (value === null);
        }
        /**
         * Checks if `func` has a lazy counterpart.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
         *  else `false`.
         */
        function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
                return false;
            }
            if (func === other) {
                return true;
            }
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
         * Checks if `func` has its source masked.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` is masked, else `false`.
         */
        function isMasked(func) {
            return !!maskSrcKey && (maskSrcKey in func);
        }
        /**
         * Checks if `func` is capable of being masked.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
         */
        var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */
        function isPrototype(value) {
            var Ctor = value && value.constructor, proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
            return value === proto;
        }
        /**
         * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` if suitable for strict
         *  equality comparisons, else `false`.
         */
        function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
         * A specialized version of `matchesProperty` for source values suitable
         * for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */
        function matchesStrictComparable(key, srcValue) {
            return function (object) {
                if (object == null) {
                    return false;
                }
                return object[key] === srcValue &&
                    (srcValue !== undefined || (key in Object(object)));
            };
        }
        /**
         * A specialized version of `_.memoize` which clears the memoized function's
         * cache when it exceeds `MAX_MEMOIZE_SIZE`.
         *
         * @private
         * @param {Function} func The function to have its output memoized.
         * @returns {Function} Returns the new memoized function.
         */
        function memoizeCapped(func) {
            var result = memoize(func, function (key) {
                if (cache.size === MAX_MEMOIZE_SIZE) {
                    cache.clear();
                }
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
         * Merges the function metadata of `source` into `data`.
         *
         * Merging metadata reduces the number of wrappers used to invoke a function.
         * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
         * may be applied regardless of execution order. Methods like `_.ary` and
         * `_.rearg` modify function arguments, making the order in which they are
         * executed important, preventing the merging of metadata. However, we make
         * an exception for a safe combined case where curried functions have `_.ary`
         * and or `_.rearg` applied.
         *
         * @private
         * @param {Array} data The destination metadata.
         * @param {Array} source The source metadata.
         * @returns {Array} Returns `data`.
         */
        function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
                ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
                ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) {
                return data;
            }
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) {
                data[7] = value;
            }
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) {
                data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            }
            // Use source `arity` if one is not provided.
            if (data[9] == null) {
                data[9] = source[9];
            }
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
         * This function is like
         * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * except that it includes inherited enumerable properties.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function nativeKeysIn(object) {
            var result = [];
            if (object != null) {
                for (var key in Object(object)) {
                    result.push(key);
                }
            }
            return result;
        }
        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */
        function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
         * A specialized version of `baseRest` which transforms the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @param {Function} transform The rest array transform.
         * @returns {Function} Returns the new function.
         */
        function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
            return function () {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
                while (++index < length) {
                    array[index] = args[start + index];
                }
                index = -1;
                var otherArgs = Array(start + 1);
                while (++index < start) {
                    otherArgs[index] = args[index];
                }
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
         * Gets the parent value at `path` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array} path The path to get the parent value of.
         * @returns {*} Returns the parent value.
         */
        function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
         * Reorder `array` according to the specified indexes where the element at
         * the first index is assigned as the first element, the element at
         * the second index is assigned as the second element, and so on.
         *
         * @private
         * @param {Array} array The array to reorder.
         * @param {Array} indexes The arranged array indexes.
         * @returns {Array} Returns `array`.
         */
        function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while (length--) {
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
         * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the property to get.
         * @returns {*} Returns the property value.
         */
        function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') {
                return;
            }
            if (key == '__proto__') {
                return;
            }
            return object[key];
        }
        /**
         * Sets metadata for `func`.
         *
         * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
         * period of time, it will trip its breaker and transition to an identity
         * function to avoid garbage collection pauses in V8. See
         * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
         * for more details.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */
        var setData = shortOut(baseSetData);
        /**
         * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @returns {number|Object} Returns the timer id or timeout object.
         */
        var setTimeout = ctxSetTimeout || function (func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
         * Sets the `toString` method of `func` to return `string`.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var setToString = shortOut(baseSetToString);
        /**
         * Sets the `toString` method of `wrapper` to mimic the source of `reference`
         * with wrapper details in a comment at the top of the source body.
         *
         * @private
         * @param {Function} wrapper The function to modify.
         * @param {Function} reference The reference function.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Function} Returns `wrapper`.
         */
        function setWrapToString(wrapper, reference, bitmask) {
            var source = (reference + '');
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
         * Creates a function that'll short out and invoke `identity` instead
         * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
         * milliseconds.
         *
         * @private
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new shortable function.
         */
        function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function () {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) {
                        return arguments[0];
                    }
                }
                else {
                    count = 0;
                }
                return func.apply(undefined, arguments);
            };
        }
        /**
         * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @param {number} [size=array.length] The size of `array`.
         * @returns {Array} Returns `array`.
         */
        function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while (++index < size) {
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
         * Converts `string` to a property path array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the property path array.
         */
        var stringToPath = memoizeCapped(function (string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */) {
                result.push('');
            }
            string.replace(rePropName, function (match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
            });
            return result;
        });
        /**
         * Converts `value` to a string key if it's not a string or symbol.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {string|symbol} Returns the key.
         */
        function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) {
                return value;
            }
            var result = (value + '');
            return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
        }
        /**
         * Converts `func` to its source code.
         *
         * @private
         * @param {Function} func The function to convert.
         * @returns {string} Returns the source code.
         */
        function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                }
                catch (e) { }
                try {
                    return (func + '');
                }
                catch (e) { }
            }
            return '';
        }
        /**
         * Updates wrapper `details` based on `bitmask` flags.
         *
         * @private
         * @returns {Array} details The details to modify.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Array} Returns `details`.
         */
        function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function (pair) {
                var value = '_.' + pair[0];
                if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
                    details.push(value);
                }
            });
            return details.sort();
        }
        /**
         * Creates a clone of `wrapper`.
         *
         * @private
         * @param {Object} wrapper The wrapper to clone.
         * @returns {Object} Returns the cloned wrapper.
         */
        function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) {
                return wrapper.clone();
            }
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/
        /**
         * Creates an array of elements split into groups the length of `size`.
         * If `array` can't be split evenly, the final chunk will be the remaining
         * elements.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to process.
         * @param {number} [size=1] The length of each chunk
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the new array of chunks.
         * @example
         *
         * _.chunk(['a', 'b', 'c', 'd'], 2);
         * // => [['a', 'b'], ['c', 'd']]
         *
         * _.chunk(['a', 'b', 'c', 'd'], 3);
         * // => [['a', 'b', 'c'], ['d']]
         */
        function chunk(array, size, guard) {
            if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
                size = 1;
            }
            else {
                size = nativeMax(toInteger(size), 0);
            }
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) {
                return [];
            }
            var index = 0, resIndex = 0, result = Array(nativeCeil(length / size));
            while (index < length) {
                result[resIndex++] = baseSlice(array, index, (index += size));
            }
            return result;
        }
        /**
         * Creates an array with all falsey values removed. The values `false`, `null`,
         * `0`, `""`, `undefined`, and `NaN` are falsey.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to compact.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.compact([0, 1, false, 2, '', 3]);
         * // => [1, 2, 3]
         */
        function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while (++index < length) {
                var value = array[index];
                if (value) {
                    result[resIndex++] = value;
                }
            }
            return result;
        }
        /**
         * Creates a new array concatenating `array` with any additional arrays
         * and/or values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to concatenate.
         * @param {...*} [values] The values to concatenate.
         * @returns {Array} Returns the new concatenated array.
         * @example
         *
         * var array = [1];
         * var other = _.concat(array, 2, [3], [[4]]);
         *
         * console.log(other);
         * // => [1, 2, 3, [4]]
         *
         * console.log(array);
         * // => [1]
         */
        function concat() {
            var length = arguments.length;
            if (!length) {
                return [];
            }
            var args = Array(length - 1), array = arguments[0], index = length;
            while (index--) {
                args[index - 1] = arguments[index];
            }
            return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        /**
         * Creates an array of `array` values not included in the other given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * **Note:** Unlike `_.pullAll`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.without, _.xor
         * @example
         *
         * _.difference([2, 1], [2, 3]);
         * // => [1]
         */
        var difference = baseRest(function (array, values) {
            return isArrayLikeObject(array)
                ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
                : [];
        });
        /**
         * This method is like `_.difference` except that it accepts `iteratee` which
         * is invoked for each element of `array` and `values` to generate the criterion
         * by which they're compared. The order and references of result values are
         * determined by the first array. The iteratee is invoked with one argument:
         * (value).
         *
         * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
         * // => [{ 'x': 2 }]
         */
        var differenceBy = baseRest(function (array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) {
                iteratee = undefined;
            }
            return isArrayLikeObject(array)
                ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
                : [];
        });
        /**
         * This method is like `_.difference` except that it accepts `comparator`
         * which is invoked to compare elements of `array` to `values`. The order and
         * references of result values are determined by the first array. The comparator
         * is invoked with two arguments: (arrVal, othVal).
         *
         * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         *
         * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
         * // => [{ 'x': 2, 'y': 1 }]
         */
        var differenceWith = baseRest(function (array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) {
                comparator = undefined;
            }
            return isArrayLikeObject(array)
                ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
                : [];
        });
        /**
         * Creates a slice of `array` with `n` elements dropped from the beginning.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to drop.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.drop([1, 2, 3]);
         * // => [2, 3]
         *
         * _.drop([1, 2, 3], 2);
         * // => [3]
         *
         * _.drop([1, 2, 3], 5);
         * // => []
         *
         * _.drop([1, 2, 3], 0);
         * // => [1, 2, 3]
         */
        function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return [];
            }
            n = (guard || n === undefined) ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
         * Creates a slice of `array` with `n` elements dropped from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to drop.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.dropRight([1, 2, 3]);
         * // => [1, 2]
         *
         * _.dropRight([1, 2, 3], 2);
         * // => [1]
         *
         * _.dropRight([1, 2, 3], 5);
         * // => []
         *
         * _.dropRight([1, 2, 3], 0);
         * // => [1, 2, 3]
         */
        function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return [];
            }
            n = (guard || n === undefined) ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
         * Creates a slice of `array` excluding elements dropped from the end.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.dropRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropRightWhile(users, ['active', false]);
         * // => objects for ['barney']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropRightWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */
        function dropRightWhile(array, predicate) {
            return (array && array.length)
                ? baseWhile(array, getIteratee(predicate, 3), true, true)
                : [];
        }
        /**
         * Creates a slice of `array` excluding elements dropped from the beginning.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.dropWhile(users, function(o) { return !o.active; });
         * // => objects for ['pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropWhile(users, ['active', false]);
         * // => objects for ['pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */
        function dropWhile(array, predicate) {
            return (array && array.length)
                ? baseWhile(array, getIteratee(predicate, 3), true)
                : [];
        }
        /**
         * Fills elements of `array` with `value` from `start` up to, but not
         * including, `end`.
         *
         * **Note:** This method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Array
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.fill(array, 'a');
         * console.log(array);
         * // => ['a', 'a', 'a']
         *
         * _.fill(Array(3), 2);
         * // => [2, 2, 2]
         *
         * _.fill([4, 6, 8, 10], '*', 1, 3);
         * // => [4, '*', '*', 10]
         */
        function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return [];
            }
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
         * This method is like `_.find` except that it returns the index of the first
         * element `predicate` returns truthy for instead of the element itself.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.findIndex(users, function(o) { return o.user == 'barney'; });
         * // => 0
         *
         * // The `_.matches` iteratee shorthand.
         * _.findIndex(users, { 'user': 'fred', 'active': false });
         * // => 1
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findIndex(users, ['active', false]);
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.findIndex(users, 'active');
         * // => 2
         */
        function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return -1;
            }
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) {
                index = nativeMax(length + index, 0);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
         * This method is like `_.findIndex` except that it iterates over elements
         * of `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
         * // => 2
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastIndex(users, { 'user': 'barney', 'active': true });
         * // => 0
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastIndex(users, ['active', false]);
         * // => 2
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastIndex(users, 'active');
         * // => 0
         */
        function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return -1;
            }
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0
                    ? nativeMax(length + index, 0)
                    : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
         * Flattens `array` a single level deep.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flatten([1, [2, [3, [4]], 5]]);
         * // => [1, 2, [3, [4]], 5]
         */
        function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
         * Recursively flattens `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flattenDeep([1, [2, [3, [4]], 5]]);
         * // => [1, 2, 3, 4, 5]
         */
        function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
         * Recursively flatten `array` up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * var array = [1, [2, [3, [4]], 5]];
         *
         * _.flattenDepth(array, 1);
         * // => [1, 2, [3, [4]], 5]
         *
         * _.flattenDepth(array, 2);
         * // => [1, 2, 3, [4], 5]
         */
        function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return [];
            }
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
         * The inverse of `_.toPairs`; this method returns an object composed
         * from key-value `pairs`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} pairs The key-value pairs.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.fromPairs([['a', 1], ['b', 2]]);
         * // => { 'a': 1, 'b': 2 }
         */
        function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while (++index < length) {
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
         * Gets the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias first
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the first element of `array`.
         * @example
         *
         * _.head([1, 2, 3]);
         * // => 1
         *
         * _.head([]);
         * // => undefined
         */
        function head(array) {
            return (array && array.length) ? array[0] : undefined;
        }
        /**
         * Gets the index at which the first occurrence of `value` is found in `array`
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. If `fromIndex` is negative, it's used as the
         * offset from the end of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.indexOf([1, 2, 1, 2], 2);
         * // => 1
         *
         * // Search from the `fromIndex`.
         * _.indexOf([1, 2, 1, 2], 2, 2);
         * // => 3
         */
        function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return -1;
            }
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) {
                index = nativeMax(length + index, 0);
            }
            return baseIndexOf(array, value, index);
        }
        /**
         * Gets all but the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.initial([1, 2, 3]);
         * // => [1, 2]
         */
        function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
         * Creates an array of unique values that are included in all given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersection([2, 1], [2, 3]);
         * // => [2]
         */
        var intersection = baseRest(function (arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return (mapped.length && mapped[0] === arrays[0])
                ? baseIntersection(mapped)
                : [];
        });
        /**
         * This method is like `_.intersection` except that it accepts `iteratee`
         * which is invoked for each element of each `arrays` to generate the criterion
         * by which they're compared. The order and references of result values are
         * determined by the first array. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [2.1]
         *
         * // The `_.property` iteratee shorthand.
         * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }]
         */
        var intersectionBy = baseRest(function (arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) {
                iteratee = undefined;
            }
            else {
                mapped.pop();
            }
            return (mapped.length && mapped[0] === arrays[0])
                ? baseIntersection(mapped, getIteratee(iteratee, 2))
                : [];
        });
        /**
         * This method is like `_.intersection` except that it accepts `comparator`
         * which is invoked to compare elements of `arrays`. The order and references
         * of result values are determined by the first array. The comparator is
         * invoked with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.intersectionWith(objects, others, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }]
         */
        var intersectionWith = baseRest(function (arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) {
                mapped.pop();
            }
            return (mapped.length && mapped[0] === arrays[0])
                ? baseIntersection(mapped, undefined, comparator)
                : [];
        });
        /**
         * Converts all elements in `array` into a string separated by `separator`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to convert.
         * @param {string} [separator=','] The element separator.
         * @returns {string} Returns the joined string.
         * @example
         *
         * _.join(['a', 'b', 'c'], '~');
         * // => 'a~b~c'
         */
        function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
         * Gets the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the last element of `array`.
         * @example
         *
         * _.last([1, 2, 3]);
         * // => 3
         */
        function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
         * This method is like `_.indexOf` except that it iterates over elements of
         * `array` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.lastIndexOf([1, 2, 1, 2], 2);
         * // => 3
         *
         * // Search from the `fromIndex`.
         * _.lastIndexOf([1, 2, 1, 2], 2, 2);
         * // => 1
         */
        function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return -1;
            }
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value
                ? strictLastIndexOf(array, value, index)
                : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
         * Gets the element at index `n` of `array`. If `n` is negative, the nth
         * element from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.11.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=0] The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         *
         * _.nth(array, 1);
         * // => 'b'
         *
         * _.nth(array, -2);
         * // => 'c';
         */
        function nth(array, n) {
            return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
         * Removes all given values from `array` using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
         * to remove elements from an array by predicate.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...*} [values] The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pull(array, 'a', 'c');
         * console.log(array);
         * // => ['b', 'b']
         */
        var pull = baseRest(pullAll);
        /**
         * This method is like `_.pull` except that it accepts an array of values to remove.
         *
         * **Note:** Unlike `_.difference`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pullAll(array, ['a', 'c']);
         * console.log(array);
         * // => ['b', 'b']
         */
        function pullAll(array, values) {
            return (array && array.length && values && values.length)
                ? basePullAll(array, values)
                : array;
        }
        /**
         * This method is like `_.pullAll` except that it accepts `iteratee` which is
         * invoked for each element of `array` and `values` to generate the criterion
         * by which they're compared. The iteratee is invoked with one argument: (value).
         *
         * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
         *
         * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
         * console.log(array);
         * // => [{ 'x': 2 }]
         */
        function pullAllBy(array, values, iteratee) {
            return (array && array.length && values && values.length)
                ? basePullAll(array, values, getIteratee(iteratee, 2))
                : array;
        }
        /**
         * This method is like `_.pullAll` except that it accepts `comparator` which
         * is invoked to compare elements of `array` to `values`. The comparator is
         * invoked with two arguments: (arrVal, othVal).
         *
         * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
         *
         * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
         * console.log(array);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
         */
        function pullAllWith(array, values, comparator) {
            return (array && array.length && values && values.length)
                ? basePullAll(array, values, undefined, comparator)
                : array;
        }
        /**
         * Removes elements from `array` corresponding to `indexes` and returns an
         * array of removed elements.
         *
         * **Note:** Unlike `_.at`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...(number|number[])} [indexes] The indexes of elements to remove.
         * @returns {Array} Returns the new array of removed elements.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         * var pulled = _.pullAt(array, [1, 3]);
         *
         * console.log(array);
         * // => ['a', 'c']
         *
         * console.log(pulled);
         * // => ['b', 'd']
         */
        var pullAt = flatRest(function (array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function (index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
         * Removes all elements from `array` that `predicate` returns truthy for
         * and returns an array of the removed elements. The predicate is invoked
         * with three arguments: (value, index, array).
         *
         * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
         * to pull elements from an array by value.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new array of removed elements.
         * @example
         *
         * var array = [1, 2, 3, 4];
         * var evens = _.remove(array, function(n) {
         *   return n % 2 == 0;
         * });
         *
         * console.log(array);
         * // => [1, 3]
         *
         * console.log(evens);
         * // => [2, 4]
         */
        function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) {
                return result;
            }
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while (++index < length) {
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
         * Reverses `array` so that the first element becomes the last, the second
         * element becomes the second to last, and so on.
         *
         * **Note:** This method mutates `array` and is based on
         * [`Array#reverse`](https://mdn.io/Array/reverse).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.reverse(array);
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */
        function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
         * Creates a slice of `array` from `start` up to, but not including, `end`.
         *
         * **Note:** This method is used instead of
         * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
         * returned.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */
        function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return [];
            }
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            }
            else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
         * Uses a binary search to determine the lowest index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedIndex([30, 50], 40);
         * // => 1
         */
        function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
         * This method is like `_.sortedIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
         * // => 0
         */
        function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
         * This method is like `_.indexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
         * // => 1
         */
        function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) {
                    return index;
                }
            }
            return -1;
        }
        /**
         * This method is like `_.sortedIndex` except that it returns the highest
         * index at which `value` should be inserted into `array` in order to
         * maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
         * // => 4
         */
        function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
         * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 1
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
         * // => 1
         */
        function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
         * This method is like `_.lastIndexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
         * // => 3
         */
        function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) {
                    return index;
                }
            }
            return -1;
        }
        /**
         * This method is like `_.uniq` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniq([1, 1, 2]);
         * // => [1, 2]
         */
        function sortedUniq(array) {
            return (array && array.length)
                ? baseSortedUniq(array)
                : [];
        }
        /**
         * This method is like `_.uniqBy` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
         * // => [1.1, 2.3]
         */
        function sortedUniqBy(array, iteratee) {
            return (array && array.length)
                ? baseSortedUniq(array, getIteratee(iteratee, 2))
                : [];
        }
        /**
         * Gets all but the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.tail([1, 2, 3]);
         * // => [2, 3]
         */
        function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
         * Creates a slice of `array` with `n` elements taken from the beginning.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.take([1, 2, 3]);
         * // => [1]
         *
         * _.take([1, 2, 3], 2);
         * // => [1, 2]
         *
         * _.take([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.take([1, 2, 3], 0);
         * // => []
         */
        function take(array, n, guard) {
            if (!(array && array.length)) {
                return [];
            }
            n = (guard || n === undefined) ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
         * Creates a slice of `array` with `n` elements taken from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.takeRight([1, 2, 3]);
         * // => [3]
         *
         * _.takeRight([1, 2, 3], 2);
         * // => [2, 3]
         *
         * _.takeRight([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.takeRight([1, 2, 3], 0);
         * // => []
         */
        function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) {
                return [];
            }
            n = (guard || n === undefined) ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
         * Creates a slice of `array` with elements taken from the end. Elements are
         * taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.takeRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeRightWhile(users, ['active', false]);
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeRightWhile(users, 'active');
         * // => []
         */
        function takeRightWhile(array, predicate) {
            return (array && array.length)
                ? baseWhile(array, getIteratee(predicate, 3), false, true)
                : [];
        }
        /**
         * Creates a slice of `array` with elements taken from the beginning. Elements
         * are taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.takeWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeWhile(users, ['active', false]);
         * // => objects for ['barney', 'fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeWhile(users, 'active');
         * // => []
         */
        function takeWhile(array, predicate) {
            return (array && array.length)
                ? baseWhile(array, getIteratee(predicate, 3))
                : [];
        }
        /**
         * Creates an array of unique values, in order, from all given arrays using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.union([2], [1, 2]);
         * // => [2, 1]
         */
        var union = baseRest(function (arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
         * This method is like `_.union` except that it accepts `iteratee` which is
         * invoked for each element of each `arrays` to generate the criterion by
         * which uniqueness is computed. Result values are chosen from the first
         * array in which the value occurs. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.unionBy([2.1], [1.2, 2.3], Math.floor);
         * // => [2.1, 1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }, { 'x': 2 }]
         */
        var unionBy = baseRest(function (arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) {
                iteratee = undefined;
            }
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
         * This method is like `_.union` except that it accepts `comparator` which
         * is invoked to compare elements of `arrays`. Result values are chosen from
         * the first array in which the value occurs. The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.unionWith(objects, others, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
         */
        var unionWith = baseRest(function (arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
         * Creates a duplicate-free version of an array, using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons, in which only the first occurrence of each element
         * is kept. The order of result values is determined by the order they occur
         * in the array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.uniq([2, 1, 2]);
         * // => [2, 1]
         */
        function uniq(array) {
            return (array && array.length) ? baseUniq(array) : [];
        }
        /**
         * This method is like `_.uniq` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * uniqueness is computed. The order of result values is determined by the
         * order they occur in the array. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
         * // => [2.1, 1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }, { 'x': 2 }]
         */
        function uniqBy(array, iteratee) {
            return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
         * This method is like `_.uniq` except that it accepts `comparator` which
         * is invoked to compare elements of `array`. The order of result values is
         * determined by the order they occur in the array.The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.uniqWith(objects, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
         */
        function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
        }
        /**
         * This method is like `_.zip` except that it accepts an array of grouped
         * elements and creates an array regrouping the elements to their pre-zip
         * configuration.
         *
         * @static
         * @memberOf _
         * @since 1.2.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
         * // => [['a', 1, true], ['b', 2, false]]
         *
         * _.unzip(zipped);
         * // => [['a', 'b'], [1, 2], [true, false]]
         */
        function unzip(array) {
            if (!(array && array.length)) {
                return [];
            }
            var length = 0;
            array = arrayFilter(array, function (group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function (index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
         * This method is like `_.unzip` except that it accepts `iteratee` to specify
         * how regrouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  regrouped values.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
         * // => [[1, 10, 100], [2, 20, 200]]
         *
         * _.unzipWith(zipped, _.add);
         * // => [3, 30, 300]
         */
        function unzipWith(array, iteratee) {
            if (!(array && array.length)) {
                return [];
            }
            var result = unzip(array);
            if (iteratee == null) {
                return result;
            }
            return arrayMap(result, function (group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
         * Creates an array excluding all given values using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.pull`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...*} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.xor
         * @example
         *
         * _.without([2, 1, 2, 3], 1, 2);
         * // => [3]
         */
        var without = baseRest(function (array, values) {
            return isArrayLikeObject(array)
                ? baseDifference(array, values)
                : [];
        });
        /**
         * Creates an array of unique values that is the
         * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
         * of the given arrays. The order of result values is determined by the order
         * they occur in the arrays.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.without
         * @example
         *
         * _.xor([2, 1], [2, 3]);
         * // => [1, 3]
         */
        var xor = baseRest(function (arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
         * This method is like `_.xor` except that it accepts `iteratee` which is
         * invoked for each element of each `arrays` to generate the criterion by
         * which by which they're compared. The order of result values is determined
         * by the order they occur in the arrays. The iteratee is invoked with one
         * argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [1.2, 3.4]
         *
         * // The `_.property` iteratee shorthand.
         * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 2 }]
         */
        var xorBy = baseRest(function (arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) {
                iteratee = undefined;
            }
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
         * This method is like `_.xor` except that it accepts `comparator` which is
         * invoked to compare elements of `arrays`. The order of result values is
         * determined by the order they occur in the arrays. The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.xorWith(objects, others, _.isEqual);
         * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
         */
        var xorWith = baseRest(function (arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
         * Creates an array of grouped elements, the first of which contains the
         * first elements of the given arrays, the second of which contains the
         * second elements of the given arrays, and so on.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to process.
         * @returns {Array} Returns the new array of grouped elements.
         * @example
         *
         * _.zip(['a', 'b'], [1, 2], [true, false]);
         * // => [['a', 1, true], ['b', 2, false]]
         */
        var zip = baseRest(unzip);
        /**
         * This method is like `_.fromPairs` except that it accepts two arrays,
         * one of property identifiers and one of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 0.4.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObject(['a', 'b'], [1, 2]);
         * // => { 'a': 1, 'b': 2 }
         */
        function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
         * This method is like `_.zipObject` except that it supports property paths.
         *
         * @static
         * @memberOf _
         * @since 4.1.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
         * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
         */
        function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
         * This method is like `_.zip` except that it accepts `iteratee` to specify
         * how grouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {...Array} [arrays] The arrays to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  grouped values.
         * @returns {Array} Returns the new array of grouped elements.
         * @example
         *
         * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
         *   return a + b + c;
         * });
         * // => [111, 222]
         */
        var zipWith = baseRest(function (arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/
        /**
         * Creates a `lodash` wrapper instance that wraps `value` with explicit method
         * chain sequences enabled. The result of such sequences must be unwrapped
         * with `_#value`.
         *
         * @static
         * @memberOf _
         * @since 1.3.0
         * @category Seq
         * @param {*} value The value to wrap.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36 },
         *   { 'user': 'fred',    'age': 40 },
         *   { 'user': 'pebbles', 'age': 1 }
         * ];
         *
         * var youngest = _
         *   .chain(users)
         *   .sortBy('age')
         *   .map(function(o) {
         *     return o.user + ' is ' + o.age;
         *   })
         *   .head()
         *   .value();
         * // => 'pebbles is 1'
         */
        function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
         * This method invokes `interceptor` and returns `value`. The interceptor
         * is invoked with one argument; (value). The purpose of this method is to
         * "tap into" a method chain sequence in order to modify intermediate results.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns `value`.
         * @example
         *
         * _([1, 2, 3])
         *  .tap(function(array) {
         *    // Mutate input array.
         *    array.pop();
         *  })
         *  .reverse()
         *  .value();
         * // => [2, 1]
         */
        function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
         * This method is like `_.tap` except that it returns the result of `interceptor`.
         * The purpose of this method is to "pass thru" values replacing intermediate
         * results in a method chain sequence.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns the result of `interceptor`.
         * @example
         *
         * _('  abc  ')
         *  .chain()
         *  .trim()
         *  .thru(function(value) {
         *    return [value];
         *  })
         *  .value();
         * // => ['abc']
         */
        function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
         * This method is the wrapper version of `_.at`.
         *
         * @name at
         * @memberOf _
         * @since 1.0.0
         * @category Seq
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
         *
         * _(object).at(['a[0].b.c', 'a[1]']).value();
         * // => [3, 4]
         */
        var wrapperAt = flatRest(function (paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function (object) { return baseAt(object, paths); };
            if (length > 1 || this.__actions__.length ||
                !(value instanceof LazyWrapper) || !isIndex(start)) {
                return this.thru(interceptor);
            }
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [interceptor],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function (array) {
                if (length && !array.length) {
                    array.push(undefined);
                }
                return array;
            });
        });
        /**
         * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
         *
         * @name chain
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36 },
         *   { 'user': 'fred',   'age': 40 }
         * ];
         *
         * // A sequence without explicit chaining.
         * _(users).head();
         * // => { 'user': 'barney', 'age': 36 }
         *
         * // A sequence with explicit chaining.
         * _(users)
         *   .chain()
         *   .head()
         *   .pick('user')
         *   .value();
         * // => { 'user': 'barney' }
         */
        function wrapperChain() {
            return chain(this);
        }
        /**
         * Executes the chain sequence and returns the wrapped result.
         *
         * @name commit
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2];
         * var wrapped = _(array).push(3);
         *
         * console.log(array);
         * // => [1, 2]
         *
         * wrapped = wrapped.commit();
         * console.log(array);
         * // => [1, 2, 3]
         *
         * wrapped.last();
         * // => 3
         *
         * console.log(array);
         * // => [1, 2, 3]
         */
        function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
         * Gets the next value on a wrapped object following the
         * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
         *
         * @name next
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the next iterator value.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 1 }
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 2 }
         *
         * wrapped.next();
         * // => { 'done': true, 'value': undefined }
         */
        function wrapperNext() {
            if (this.__values__ === undefined) {
                this.__values__ = toArray(this.value());
            }
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return { 'done': done, 'value': value };
        }
        /**
         * Enables the wrapper to be iterable.
         *
         * @name Symbol.iterator
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the wrapper object.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped[Symbol.iterator]() === wrapped;
         * // => true
         *
         * Array.from(wrapped);
         * // => [1, 2]
         */
        function wrapperToIterator() {
            return this;
        }
        /**
         * Creates a clone of the chain sequence planting `value` as the wrapped value.
         *
         * @name plant
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @param {*} value The value to plant.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var wrapped = _([1, 2]).map(square);
         * var other = wrapped.plant([3, 4]);
         *
         * other.value();
         * // => [9, 16]
         *
         * wrapped.value();
         * // => [1, 4]
         */
        function wrapperPlant(value) {
            var result, parent = this;
            while (parent instanceof baseLodash) {
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) {
                    previous.__wrapped__ = clone;
                }
                else {
                    result = clone;
                }
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
         * This method is the wrapper version of `_.reverse`.
         *
         * **Note:** This method mutates the wrapped array.
         *
         * @name reverse
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _(array).reverse().value()
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */
        function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) {
                    wrapped = new LazyWrapper(this);
                }
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [reverse],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
         * Executes the chain sequence to resolve the unwrapped value.
         *
         * @name value
         * @memberOf _
         * @since 0.1.0
         * @alias toJSON, valueOf
         * @category Seq
         * @returns {*} Returns the resolved unwrapped value.
         * @example
         *
         * _([1, 2, 3]).value();
         * // => [1, 2, 3]
         */
        function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/
        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The corresponding value of
         * each key is the number of times the key was returned by `iteratee`. The
         * iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.countBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': 1, '6': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.countBy(['one', 'two', 'three'], 'length');
         * // => { '3': 2, '5': 1 }
         */
        var countBy = createAggregator(function (result, value, key) {
            if (hasOwnProperty.call(result, key)) {
                ++result[key];
            }
            else {
                baseAssignValue(result, key, 1);
            }
        });
        /**
         * Checks if `predicate` returns truthy for **all** elements of `collection`.
         * Iteration is stopped once `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index|key, collection).
         *
         * **Note:** This method returns `true` for
         * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
         * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
         * elements of empty collections.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {boolean} Returns `true` if all elements pass the predicate check,
         *  else `false`.
         * @example
         *
         * _.every([true, 1, null, 'yes'], Boolean);
         * // => false
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': false },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.every(users, { 'user': 'barney', 'active': false });
         * // => false
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.every(users, ['active', false]);
         * // => true
         *
         * // The `_.property` iteratee shorthand.
         * _.every(users, 'active');
         * // => false
         */
        function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) {
                predicate = undefined;
            }
            return func(collection, getIteratee(predicate, 3));
        }
        /**
         * Iterates over elements of `collection`, returning an array of all elements
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * **Note:** Unlike `_.remove`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.reject
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * _.filter(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, { 'age': 36, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.filter(users, 'active');
         * // => objects for ['barney']
         *
         * // Combining several predicates using `_.overEvery` or `_.overSome`.
         * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
         * // => objects for ['fred', 'barney']
         */
        function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
         * Iterates over elements of `collection`, returning the first element
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': true },
         *   { 'user': 'fred',    'age': 40, 'active': false },
         *   { 'user': 'pebbles', 'age': 1,  'active': true }
         * ];
         *
         * _.find(users, function(o) { return o.age < 40; });
         * // => object for 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.find(users, { 'age': 1, 'active': true });
         * // => object for 'pebbles'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.find(users, ['active', false]);
         * // => object for 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.find(users, 'active');
         * // => object for 'barney'
         */
        var find = createFind(findIndex);
        /**
         * This method is like `_.find` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=collection.length-1] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * _.findLast([1, 2, 3, 4], function(n) {
         *   return n % 2 == 1;
         * });
         * // => 3
         */
        var findLast = createFind(findLastIndex);
        /**
         * Creates a flattened array of values by running each element in `collection`
         * thru `iteratee` and flattening the mapped results. The iteratee is invoked
         * with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [n, n];
         * }
         *
         * _.flatMap([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */
        function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDeep([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */
        function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDepth([1, 2], duplicate, 2);
         * // => [[1, 1], [2, 2]]
         */
        function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
         * Iterates over elements of `collection` and invokes `iteratee` for each element.
         * The iteratee is invoked with three arguments: (value, index|key, collection).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * **Note:** As with other "Collections" methods, objects with a "length"
         * property are iterated like arrays. To avoid this behavior use `_.forIn`
         * or `_.forOwn` for object iteration.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias each
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEachRight
         * @example
         *
         * _.forEach([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `1` then `2`.
         *
         * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */
        function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
         * This method is like `_.forEach` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @alias eachRight
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEach
         * @example
         *
         * _.forEachRight([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `2` then `1`.
         */
        function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The order of grouped values
         * is determined by the order they occur in `collection`. The corresponding
         * value of each key is an array of elements responsible for generating the
         * key. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.groupBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': [4.2], '6': [6.1, 6.3] }
         *
         * // The `_.property` iteratee shorthand.
         * _.groupBy(['one', 'two', 'three'], 'length');
         * // => { '3': ['one', 'two'], '5': ['three'] }
         */
        var groupBy = createAggregator(function (result, value, key) {
            if (hasOwnProperty.call(result, key)) {
                result[key].push(value);
            }
            else {
                baseAssignValue(result, key, [value]);
            }
        });
        /**
         * Checks if `value` is in `collection`. If `collection` is a string, it's
         * checked for a substring of `value`, otherwise
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * is used for equality comparisons. If `fromIndex` is negative, it's used as
         * the offset from the end of `collection`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {boolean} Returns `true` if `value` is found, else `false`.
         * @example
         *
         * _.includes([1, 2, 3], 1);
         * // => true
         *
         * _.includes([1, 2, 3], 1, 2);
         * // => false
         *
         * _.includes({ 'a': 1, 'b': 2 }, 1);
         * // => true
         *
         * _.includes('abcd', 'bc');
         * // => true
         */
        function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) {
                fromIndex = nativeMax(length + fromIndex, 0);
            }
            return isString(collection)
                ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
                : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
        }
        /**
         * Invokes the method at `path` of each element in `collection`, returning
         * an array of the results of each invoked method. Any additional arguments
         * are provided to each invoked method. If `path` is a function, it's invoked
         * for, and `this` bound to, each element in `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array|Function|string} path The path of the method to invoke or
         *  the function invoked per iteration.
         * @param {...*} [args] The arguments to invoke each method with.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
         * // => [[1, 5, 7], [1, 2, 3]]
         *
         * _.invokeMap([123, 456], String.prototype.split, '');
         * // => [['1', '2', '3'], ['4', '5', '6']]
         */
        var invokeMap = baseRest(function (collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array(collection.length) : [];
            baseEach(collection, function (value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The corresponding value of
         * each key is the last element responsible for generating the key. The
         * iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * var array = [
         *   { 'dir': 'left', 'code': 97 },
         *   { 'dir': 'right', 'code': 100 }
         * ];
         *
         * _.keyBy(array, function(o) {
         *   return String.fromCharCode(o.code);
         * });
         * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
         *
         * _.keyBy(array, 'dir');
         * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
         */
        var keyBy = createAggregator(function (result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
         * Creates an array of values by running each element in `collection` thru
         * `iteratee`. The iteratee is invoked with three arguments:
         * (value, index|key, collection).
         *
         * Many lodash methods are guarded to work as iteratees for methods like
         * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
         *
         * The guarded methods are:
         * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
         * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
         * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
         * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * _.map([4, 8], square);
         * // => [16, 64]
         *
         * _.map({ 'a': 4, 'b': 8 }, square);
         * // => [16, 64] (iteration order is not guaranteed)
         *
         * var users = [
         *   { 'user': 'barney' },
         *   { 'user': 'fred' }
         * ];
         *
         * // The `_.property` iteratee shorthand.
         * _.map(users, 'user');
         * // => ['barney', 'fred']
         */
        function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
         * This method is like `_.sortBy` except that it allows specifying the sort
         * orders of the iteratees to sort by. If `orders` is unspecified, all values
         * are sorted in ascending order. Otherwise, specify an order of "desc" for
         * descending or "asc" for ascending sort order of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @param {string[]} [orders] The sort orders of `iteratees`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 34 },
         *   { 'user': 'fred',   'age': 40 },
         *   { 'user': 'barney', 'age': 36 }
         * ];
         *
         * // Sort by `user` in ascending order and by `age` in descending order.
         * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
         */
        function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) {
                return [];
            }
            if (!isArray(iteratees)) {
                iteratees = iteratees == null ? [] : [iteratees];
            }
            orders = guard ? undefined : orders;
            if (!isArray(orders)) {
                orders = orders == null ? [] : [orders];
            }
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
         * Creates an array of elements split into two groups, the first of which
         * contains elements `predicate` returns truthy for, the second of which
         * contains elements `predicate` returns falsey for. The predicate is
         * invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of grouped elements.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': false },
         *   { 'user': 'fred',    'age': 40, 'active': true },
         *   { 'user': 'pebbles', 'age': 1,  'active': false }
         * ];
         *
         * _.partition(users, function(o) { return o.active; });
         * // => objects for [['fred'], ['barney', 'pebbles']]
         *
         * // The `_.matches` iteratee shorthand.
         * _.partition(users, { 'age': 1, 'active': false });
         * // => objects for [['pebbles'], ['barney', 'fred']]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.partition(users, ['active', false]);
         * // => objects for [['barney', 'pebbles'], ['fred']]
         *
         * // The `_.property` iteratee shorthand.
         * _.partition(users, 'active');
         * // => objects for [['fred'], ['barney', 'pebbles']]
         */
        var partition = createAggregator(function (result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function () { return [[], []]; });
        /**
         * Reduces `collection` to a value which is the accumulated result of running
         * each element in `collection` thru `iteratee`, where each successive
         * invocation is supplied the return value of the previous. If `accumulator`
         * is not given, the first element of `collection` is used as the initial
         * value. The iteratee is invoked with four arguments:
         * (accumulator, value, index|key, collection).
         *
         * Many lodash methods are guarded to work as iteratees for methods like
         * `_.reduce`, `_.reduceRight`, and `_.transform`.
         *
         * The guarded methods are:
         * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
         * and `sortBy`
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @returns {*} Returns the accumulated value.
         * @see _.reduceRight
         * @example
         *
         * _.reduce([1, 2], function(sum, n) {
         *   return sum + n;
         * }, 0);
         * // => 3
         *
         * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
         *   (result[value] || (result[value] = [])).push(key);
         *   return result;
         * }, {});
         * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
         */
        function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
         * This method is like `_.reduce` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @returns {*} Returns the accumulated value.
         * @see _.reduce
         * @example
         *
         * var array = [[0, 1], [2, 3], [4, 5]];
         *
         * _.reduceRight(array, function(flattened, other) {
         *   return flattened.concat(other);
         * }, []);
         * // => [4, 5, 2, 3, 0, 1]
         */
        function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
         * The opposite of `_.filter`; this method returns the elements of `collection`
         * that `predicate` does **not** return truthy for.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.filter
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': false },
         *   { 'user': 'fred',   'age': 40, 'active': true }
         * ];
         *
         * _.reject(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.reject(users, { 'age': 40, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.reject(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.reject(users, 'active');
         * // => objects for ['barney']
         */
        function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
         * Gets a random element from `collection`.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         * @example
         *
         * _.sample([1, 2, 3, 4]);
         * // => 2
         */
        function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
         * Gets `n` random elements at unique keys from `collection` up to the
         * size of `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @param {number} [n=1] The number of elements to sample.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the random elements.
         * @example
         *
         * _.sampleSize([1, 2, 3], 2);
         * // => [3, 1]
         *
         * _.sampleSize([1, 2, 3], 4);
         * // => [2, 3, 1]
         */
        function sampleSize(collection, n, guard) {
            if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
                n = 1;
            }
            else {
                n = toInteger(n);
            }
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
         * Creates an array of shuffled values, using a version of the
         * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to shuffle.
         * @returns {Array} Returns the new shuffled array.
         * @example
         *
         * _.shuffle([1, 2, 3, 4]);
         * // => [4, 1, 3, 2]
         */
        function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
         * Gets the size of `collection` by returning its length for array-like
         * values or the number of own enumerable string keyed properties for objects.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @returns {number} Returns the collection size.
         * @example
         *
         * _.size([1, 2, 3]);
         * // => 3
         *
         * _.size({ 'a': 1, 'b': 2 });
         * // => 2
         *
         * _.size('pebbles');
         * // => 7
         */
        function size(collection) {
            if (collection == null) {
                return 0;
            }
            if (isArrayLike(collection)) {
                return isString(collection) ? stringSize(collection) : collection.length;
            }
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) {
                return collection.size;
            }
            return baseKeys(collection).length;
        }
        /**
         * Checks if `predicate` returns truthy for **any** element of `collection`.
         * Iteration is stopped once `predicate` returns truthy. The predicate is
         * invoked with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         * @example
         *
         * _.some([null, 0, 'yes', false], Boolean);
         * // => true
         *
         * var users = [
         *   { 'user': 'barney', 'active': true },
         *   { 'user': 'fred',   'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.some(users, { 'user': 'barney', 'active': false });
         * // => false
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.some(users, ['active', false]);
         * // => true
         *
         * // The `_.property` iteratee shorthand.
         * _.some(users, 'active');
         * // => true
         */
        function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) {
                predicate = undefined;
            }
            return func(collection, getIteratee(predicate, 3));
        }
        /**
         * Creates an array of elements, sorted in ascending order by the results of
         * running each element in a collection thru each iteratee. This method
         * performs a stable sort, that is, it preserves the original sort order of
         * equal elements. The iteratees are invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 36 },
         *   { 'user': 'fred',   'age': 30 },
         *   { 'user': 'barney', 'age': 34 }
         * ];
         *
         * _.sortBy(users, [function(o) { return o.user; }]);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
         *
         * _.sortBy(users, ['user', 'age']);
         * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
         */
        var sortBy = baseRest(function (collection, iteratees) {
            if (collection == null) {
                return [];
            }
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
                iteratees = [];
            }
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
                iteratees = [iteratees[0]];
            }
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/
        /**
         * Gets the timestamp of the number of milliseconds that have elapsed since
         * the Unix epoch (1 January 1970 00:00:00 UTC).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Date
         * @returns {number} Returns the timestamp.
         * @example
         *
         * _.defer(function(stamp) {
         *   console.log(_.now() - stamp);
         * }, _.now());
         * // => Logs the number of milliseconds it took for the deferred invocation.
         */
        var now = ctxNow || function () {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/
        /**
         * The opposite of `_.before`; this method creates a function that invokes
         * `func` once it's called `n` or more times.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {number} n The number of calls before `func` is invoked.
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * var saves = ['profile', 'settings'];
         *
         * var done = _.after(saves.length, function() {
         *   console.log('done saving!');
         * });
         *
         * _.forEach(saves, function(type) {
         *   asyncSave({ 'type': type, 'complete': done });
         * });
         * // => Logs 'done saving!' after the two async saves have completed.
         */
        function after(n, func) {
            if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            n = toInteger(n);
            return function () {
                if (--n < 1) {
                    return func.apply(this, arguments);
                }
            };
        }
        /**
         * Creates a function that invokes `func`, with up to `n` arguments,
         * ignoring any additional arguments.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @param {number} [n=func.length] The arity cap.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.ary(parseInt, 1));
         * // => [6, 8, 10]
         */
        function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = (func && n == null) ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
         * Creates a function that invokes `func`, with the `this` binding and arguments
         * of the created function, while it's called less than `n` times. Subsequent
         * calls to the created function return the result of the last `func` invocation.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {number} n The number of calls at which `func` is no longer invoked.
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * jQuery(element).on('click', _.before(5, addContactToList));
         * // => Allows adding up to 4 contacts to the list.
         */
        function before(n, func) {
            var result;
            if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            n = toInteger(n);
            return function () {
                if (--n > 0) {
                    result = func.apply(this, arguments);
                }
                if (n <= 1) {
                    func = undefined;
                }
                return result;
            };
        }
        /**
         * Creates a function that invokes `func` with the `this` binding of `thisArg`
         * and `partials` prepended to the arguments it receives.
         *
         * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
         * may be used as a placeholder for partially applied arguments.
         *
         * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
         * property of bound functions.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to bind.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new bound function.
         * @example
         *
         * function greet(greeting, punctuation) {
         *   return greeting + ' ' + this.user + punctuation;
         * }
         *
         * var object = { 'user': 'fred' };
         *
         * var bound = _.bind(greet, object, 'hi');
         * bound('!');
         * // => 'hi fred!'
         *
         * // Bound with placeholders.
         * var bound = _.bind(greet, object, _, '!');
         * bound('hi');
         * // => 'hi fred!'
         */
        var bind = baseRest(function (func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
         * Creates a function that invokes the method at `object[key]` with `partials`
         * prepended to the arguments it receives.
         *
         * This method differs from `_.bind` by allowing bound functions to reference
         * methods that may be redefined or don't yet exist. See
         * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
         * for more details.
         *
         * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Function
         * @param {Object} object The object to invoke the method on.
         * @param {string} key The key of the method.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new bound function.
         * @example
         *
         * var object = {
         *   'user': 'fred',
         *   'greet': function(greeting, punctuation) {
         *     return greeting + ' ' + this.user + punctuation;
         *   }
         * };
         *
         * var bound = _.bindKey(object, 'greet', 'hi');
         * bound('!');
         * // => 'hi fred!'
         *
         * object.greet = function(greeting, punctuation) {
         *   return greeting + 'ya ' + this.user + punctuation;
         * };
         *
         * bound('!');
         * // => 'hiya fred!'
         *
         * // Bound with placeholders.
         * var bound = _.bindKey(object, 'greet', _, '!');
         * bound('hi');
         * // => 'hiya fred!'
         */
        var bindKey = baseRest(function (object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
         * Creates a function that accepts arguments of `func` and either invokes
         * `func` returning its result, if at least `arity` number of arguments have
         * been provided, or returns a function that accepts the remaining `func`
         * arguments, and so on. The arity of `func` may be specified if `func.length`
         * is not sufficient.
         *
         * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
         * may be used as a placeholder for provided arguments.
         *
         * **Note:** This method doesn't set the "length" property of curried functions.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Function
         * @param {Function} func The function to curry.
         * @param {number} [arity=func.length] The arity of `func`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new curried function.
         * @example
         *
         * var abc = function(a, b, c) {
         *   return [a, b, c];
         * };
         *
         * var curried = _.curry(abc);
         *
         * curried(1)(2)(3);
         * // => [1, 2, 3]
         *
         * curried(1, 2)(3);
         * // => [1, 2, 3]
         *
         * curried(1, 2, 3);
         * // => [1, 2, 3]
         *
         * // Curried with placeholders.
         * curried(1)(_, 3)(2);
         * // => [1, 2, 3]
         */
        function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
         * This method is like `_.curry` except that arguments are applied to `func`
         * in the manner of `_.partialRight` instead of `_.partial`.
         *
         * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for provided arguments.
         *
         * **Note:** This method doesn't set the "length" property of curried functions.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to curry.
         * @param {number} [arity=func.length] The arity of `func`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new curried function.
         * @example
         *
         * var abc = function(a, b, c) {
         *   return [a, b, c];
         * };
         *
         * var curried = _.curryRight(abc);
         *
         * curried(3)(2)(1);
         * // => [1, 2, 3]
         *
         * curried(2, 3)(1);
         * // => [1, 2, 3]
         *
         * curried(1, 2, 3);
         * // => [1, 2, 3]
         *
         * // Curried with placeholders.
         * curried(3)(1, _)(2);
         * // => [1, 2, 3]
         */
        function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */
        function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing
                    ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
                    : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
                    (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) {
                    return trailingEdge(time);
                }
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) {
                    return invokeFunc(time);
                }
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) {
                    clearTimeout(timerId);
                }
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) {
                        return leadingEdge(lastCallTime);
                    }
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) {
                    timerId = setTimeout(timerExpired, wait);
                }
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
         * Defers invoking the `func` until the current call stack has cleared. Any
         * additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to defer.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {number} Returns the timer id.
         * @example
         *
         * _.defer(function(text) {
         *   console.log(text);
         * }, 'deferred');
         * // => Logs 'deferred' after one millisecond.
         */
        var defer = baseRest(function (func, args) {
            return baseDelay(func, 1, args);
        });
        /**
         * Invokes `func` after `wait` milliseconds. Any additional arguments are
         * provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {number} Returns the timer id.
         * @example
         *
         * _.delay(function(text) {
         *   console.log(text);
         * }, 1000, 'later');
         * // => Logs 'later' after one second.
         */
        var delay = baseRest(function (func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
         * Creates a function that invokes `func` with arguments reversed.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to flip arguments for.
         * @returns {Function} Returns the new flipped function.
         * @example
         *
         * var flipped = _.flip(function() {
         *   return _.toArray(arguments);
         * });
         *
         * flipped('a', 'b', 'c', 'd');
         * // => ['d', 'c', 'b', 'a']
         */
        function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
         * Creates a function that memoizes the result of `func`. If `resolver` is
         * provided, it determines the cache key for storing the result based on the
         * arguments provided to the memoized function. By default, the first argument
         * provided to the memoized function is used as the map cache key. The `func`
         * is invoked with the `this` binding of the memoized function.
         *
         * **Note:** The cache is exposed as the `cache` property on the memoized
         * function. Its creation may be customized by replacing the `_.memoize.Cache`
         * constructor with one whose instances implement the
         * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
         * method interface of `clear`, `delete`, `get`, `has`, and `set`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to have its output memoized.
         * @param {Function} [resolver] The function to resolve the cache key.
         * @returns {Function} Returns the new memoized function.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         * var other = { 'c': 3, 'd': 4 };
         *
         * var values = _.memoize(_.values);
         * values(object);
         * // => [1, 2]
         *
         * values(other);
         * // => [3, 4]
         *
         * object.a = 2;
         * values(object);
         * // => [1, 2]
         *
         * // Modify the result cache.
         * values.cache.set(object, ['a', 'b']);
         * values(object);
         * // => ['a', 'b']
         *
         * // Replace `_.memoize.Cache`.
         * _.memoize.Cache = WeakMap;
         */
        function memoize(func, resolver) {
            if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            var memoized = function () {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) {
                    return cache.get(key);
                }
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
         * Creates a function that negates the result of the predicate `func`. The
         * `func` predicate is invoked with the `this` binding and arguments of the
         * created function.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} predicate The predicate to negate.
         * @returns {Function} Returns the new negated function.
         * @example
         *
         * function isEven(n) {
         *   return n % 2 == 0;
         * }
         *
         * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
         * // => [1, 3, 5]
         */
        function negate(predicate) {
            if (typeof predicate != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            return function () {
                var args = arguments;
                switch (args.length) {
                    case 0: return !predicate.call(this);
                    case 1: return !predicate.call(this, args[0]);
                    case 2: return !predicate.call(this, args[0], args[1]);
                    case 3: return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
         * Creates a function that is restricted to invoking `func` once. Repeat calls
         * to the function return the value of the first invocation. The `func` is
         * invoked with the `this` binding and arguments of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * var initialize = _.once(createApplication);
         * initialize();
         * initialize();
         * // => `createApplication` is invoked once
         */
        function once(func) {
            return before(2, func);
        }
        /**
         * Creates a function that invokes `func` with its arguments transformed.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Function
         * @param {Function} func The function to wrap.
         * @param {...(Function|Function[])} [transforms=[_.identity]]
         *  The argument transforms.
         * @returns {Function} Returns the new function.
         * @example
         *
         * function doubled(n) {
         *   return n * 2;
         * }
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var func = _.overArgs(function(x, y) {
         *   return [x, y];
         * }, [square, doubled]);
         *
         * func(9, 3);
         * // => [81, 6]
         *
         * func(10, 5);
         * // => [100, 10]
         */
        var overArgs = castRest(function (func, transforms) {
            transforms = (transforms.length == 1 && isArray(transforms[0]))
                ? arrayMap(transforms[0], baseUnary(getIteratee()))
                : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function (args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while (++index < length) {
                    args[index] = transforms[index].call(this, args[index]);
                }
                return apply(func, this, args);
            });
        });
        /**
         * Creates a function that invokes `func` with `partials` prepended to the
         * arguments it receives. This method is like `_.bind` except it does **not**
         * alter the `this` binding.
         *
         * The `_.partial.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * **Note:** This method doesn't set the "length" property of partially
         * applied functions.
         *
         * @static
         * @memberOf _
         * @since 0.2.0
         * @category Function
         * @param {Function} func The function to partially apply arguments to.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new partially applied function.
         * @example
         *
         * function greet(greeting, name) {
         *   return greeting + ' ' + name;
         * }
         *
         * var sayHelloTo = _.partial(greet, 'hello');
         * sayHelloTo('fred');
         * // => 'hello fred'
         *
         * // Partially applied with placeholders.
         * var greetFred = _.partial(greet, _, 'fred');
         * greetFred('hi');
         * // => 'hi fred'
         */
        var partial = baseRest(function (func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
         * This method is like `_.partial` except that partially applied arguments
         * are appended to the arguments it receives.
         *
         * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * **Note:** This method doesn't set the "length" property of partially
         * applied functions.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Function
         * @param {Function} func The function to partially apply arguments to.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new partially applied function.
         * @example
         *
         * function greet(greeting, name) {
         *   return greeting + ' ' + name;
         * }
         *
         * var greetFred = _.partialRight(greet, 'fred');
         * greetFred('hi');
         * // => 'hi fred'
         *
         * // Partially applied with placeholders.
         * var sayHelloTo = _.partialRight(greet, 'hello', _);
         * sayHelloTo('fred');
         * // => 'hello fred'
         */
        var partialRight = baseRest(function (func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
         * Creates a function that invokes `func` with arguments arranged according
         * to the specified `indexes` where the argument value at the first index is
         * provided as the first argument, the argument value at the second index is
         * provided as the second argument, and so on.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to rearrange arguments for.
         * @param {...(number|number[])} indexes The arranged argument indexes.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var rearged = _.rearg(function(a, b, c) {
         *   return [a, b, c];
         * }, [2, 0, 1]);
         *
         * rearged('b', 'c', 'a')
         * // => ['a', 'b', 'c']
         */
        var rearg = flatRest(function (func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
         * Creates a function that invokes `func` with the `this` binding of the
         * created function and arguments from `start` and beyond provided as
         * an array.
         *
         * **Note:** This method is based on the
         * [rest parameter](https://mdn.io/rest_parameters).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var say = _.rest(function(what, names) {
         *   return what + ' ' + _.initial(names).join(', ') +
         *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
         * });
         *
         * say('hello', 'fred', 'barney', 'pebbles');
         * // => 'hello fred, barney, & pebbles'
         */
        function rest(func, start) {
            if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
         * Creates a function that invokes `func` with the `this` binding of the
         * create function and an array of arguments much like
         * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
         *
         * **Note:** This method is based on the
         * [spread operator](https://mdn.io/spread_operator).
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Function
         * @param {Function} func The function to spread arguments over.
         * @param {number} [start=0] The start position of the spread.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var say = _.spread(function(who, what) {
         *   return who + ' says ' + what;
         * });
         *
         * say(['fred', 'hello']);
         * // => 'fred says hello'
         *
         * var numbers = Promise.all([
         *   Promise.resolve(40),
         *   Promise.resolve(36)
         * ]);
         *
         * numbers.then(_.spread(function(x, y) {
         *   return x + y;
         * }));
         * // => a Promise of 76
         */
        function spread(func, start) {
            if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function (args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) {
                    arrayPush(otherArgs, array);
                }
                return apply(func, this, otherArgs);
            });
        }
        /**
         * Creates a throttled function that only invokes `func` at most once per
         * every `wait` milliseconds. The throttled function comes with a `cancel`
         * method to cancel delayed `func` invocations and a `flush` method to
         * immediately invoke them. Provide `options` to indicate whether `func`
         * should be invoked on the leading and/or trailing edge of the `wait`
         * timeout. The `func` is invoked with the last arguments provided to the
         * throttled function. Subsequent calls to the throttled function return the
         * result of the last `func` invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the throttled function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.throttle` and `_.debounce`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to throttle.
         * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=true]
         *  Specify invoking on the leading edge of the timeout.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new throttled function.
         * @example
         *
         * // Avoid excessively updating the position while scrolling.
         * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
         *
         * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
         * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
         * jQuery(element).on('click', throttled);
         *
         * // Cancel the trailing throttled invocation.
         * jQuery(window).on('popstate', throttled.cancel);
         */
        function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
            }
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
         * Creates a function that accepts up to one argument, ignoring any
         * additional arguments.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.unary(parseInt));
         * // => [6, 8, 10]
         */
        function unary(func) {
            return ary(func, 1);
        }
        /**
         * Creates a function that provides `value` to `wrapper` as its first
         * argument. Any additional arguments provided to the function are appended
         * to those provided to the `wrapper`. The wrapper is invoked with the `this`
         * binding of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {*} value The value to wrap.
         * @param {Function} [wrapper=identity] The wrapper function.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var p = _.wrap(_.escape, function(func, text) {
         *   return '<p>' + func(text) + '</p>';
         * });
         *
         * p('fred, barney, & pebbles');
         * // => '<p>fred, barney, &amp; pebbles</p>'
         */
        function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/
        /**
         * Casts `value` as an array if it's not one.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Lang
         * @param {*} value The value to inspect.
         * @returns {Array} Returns the cast array.
         * @example
         *
         * _.castArray(1);
         * // => [1]
         *
         * _.castArray({ 'a': 1 });
         * // => [{ 'a': 1 }]
         *
         * _.castArray('abc');
         * // => ['abc']
         *
         * _.castArray(null);
         * // => [null]
         *
         * _.castArray(undefined);
         * // => [undefined]
         *
         * _.castArray();
         * // => []
         *
         * var array = [1, 2, 3];
         * console.log(_.castArray(array) === array);
         * // => true
         */
        function castArray() {
            if (!arguments.length) {
                return [];
            }
            var value = arguments[0];
            return isArray(value) ? value : [value];
        }
        /**
         * Creates a shallow clone of `value`.
         *
         * **Note:** This method is loosely based on the
         * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
         * and supports cloning arrays, array buffers, booleans, date objects, maps,
         * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
         * arrays. The own enumerable properties of `arguments` objects are cloned
         * as plain objects. An empty object is returned for uncloneable values such
         * as error objects, functions, DOM nodes, and WeakMaps.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to clone.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeep
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var shallow = _.clone(objects);
         * console.log(shallow[0] === objects[0]);
         * // => true
         */
        function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
         * This method is like `_.clone` except that it accepts `customizer` which
         * is invoked to produce the cloned value. If `customizer` returns `undefined`,
         * cloning is handled by the method instead. The `customizer` is invoked with
         * up to four arguments; (value [, index|key, object, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeepWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(false);
         *   }
         * }
         *
         * var el = _.cloneWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 0
         */
        function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
         * This method is like `_.clone` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @returns {*} Returns the deep cloned value.
         * @see _.clone
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var deep = _.cloneDeep(objects);
         * console.log(deep[0] === objects[0]);
         * // => false
         */
        function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
         * This method is like `_.cloneWith` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the deep cloned value.
         * @see _.cloneWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(true);
         *   }
         * }
         *
         * var el = _.cloneDeepWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 20
         */
        function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
         * Checks if `object` conforms to `source` by invoking the predicate
         * properties of `source` with the corresponding property values of `object`.
         *
         * **Note:** This method is equivalent to `_.conforms` when `source` is
         * partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
         * // => true
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
         * // => false
         */
        function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */
        function eq(value, other) {
            return value === other || (value !== value && other !== other);
        }
        /**
         * Checks if `value` is greater than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         * @see _.lt
         * @example
         *
         * _.gt(3, 1);
         * // => true
         *
         * _.gt(3, 3);
         * // => false
         *
         * _.gt(1, 3);
         * // => false
         */
        var gt = createRelationalOperation(baseGt);
        /**
         * Checks if `value` is greater than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than or equal to
         *  `other`, else `false`.
         * @see _.lte
         * @example
         *
         * _.gte(3, 1);
         * // => true
         *
         * _.gte(3, 3);
         * // => true
         *
         * _.gte(1, 3);
         * // => false
         */
        var gte = createRelationalOperation(function (value, other) {
            return value >= other;
        });
        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */
        var isArguments = baseIsArguments(function () { return arguments; }()) ? baseIsArguments : function (value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
                !propertyIsEnumerable.call(value, 'callee');
        };
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */
        var isArray = Array.isArray;
        /**
         * Checks if `value` is classified as an `ArrayBuffer` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         * @example
         *
         * _.isArrayBuffer(new ArrayBuffer(2));
         * // => true
         *
         * _.isArrayBuffer(new Array(2));
         * // => false
         */
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */
        function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */
        function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
         * Checks if `value` is classified as a boolean primitive or object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
         * @example
         *
         * _.isBoolean(false);
         * // => true
         *
         * _.isBoolean(null);
         * // => false
         */
        function isBoolean(value) {
            return value === true || value === false ||
                (isObjectLike(value) && baseGetTag(value) == boolTag);
        }
        /**
         * Checks if `value` is a buffer.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
         * @example
         *
         * _.isBuffer(new Buffer(2));
         * // => true
         *
         * _.isBuffer(new Uint8Array(2));
         * // => false
         */
        var isBuffer = nativeIsBuffer || stubFalse;
        /**
         * Checks if `value` is classified as a `Date` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         * @example
         *
         * _.isDate(new Date);
         * // => true
         *
         * _.isDate('Mon April 23 2012');
         * // => false
         */
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
         * Checks if `value` is likely a DOM element.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
         * @example
         *
         * _.isElement(document.body);
         * // => true
         *
         * _.isElement('<body>');
         * // => false
         */
        function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
         * Checks if `value` is an empty object, collection, map, or set.
         *
         * Objects are considered empty if they have no own enumerable string keyed
         * properties.
         *
         * Array-like values such as `arguments` objects, arrays, buffers, strings, or
         * jQuery-like collections are considered empty if they have a `length` of `0`.
         * Similarly, maps and sets are considered empty if they have a `size` of `0`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is empty, else `false`.
         * @example
         *
         * _.isEmpty(null);
         * // => true
         *
         * _.isEmpty(true);
         * // => true
         *
         * _.isEmpty(1);
         * // => true
         *
         * _.isEmpty([1, 2, 3]);
         * // => false
         *
         * _.isEmpty({ 'a': 1 });
         * // => false
         */
        function isEmpty(value) {
            if (value == null) {
                return true;
            }
            if (isArrayLike(value) &&
                (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
                    isBuffer(value) || isTypedArray(value) || isArguments(value))) {
                return !value.length;
            }
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) {
                return !value.size;
            }
            if (isPrototype(value)) {
                return !baseKeys(value).length;
            }
            for (var key in value) {
                if (hasOwnProperty.call(value, key)) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Performs a deep comparison between two values to determine if they are
         * equivalent.
         *
         * **Note:** This method supports comparing arrays, array buffers, booleans,
         * date objects, error objects, maps, numbers, `Object` objects, regexes,
         * sets, strings, symbols, and typed arrays. `Object` objects are compared
         * by their own, not inherited, enumerable properties. Functions and DOM
         * nodes are compared by strict equality, i.e. `===`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.isEqual(object, other);
         * // => true
         *
         * object === other;
         * // => false
         */
        function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
         * This method is like `_.isEqual` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with up to
         * six arguments: (objValue, othValue [, index|key, object, other, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, othValue) {
         *   if (isGreeting(objValue) && isGreeting(othValue)) {
         *     return true;
         *   }
         * }
         *
         * var array = ['hello', 'goodbye'];
         * var other = ['hi', 'goodbye'];
         *
         * _.isEqualWith(array, other, customizer);
         * // => true
         */
        function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
         * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
         * `SyntaxError`, `TypeError`, or `URIError` object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
         * @example
         *
         * _.isError(new Error);
         * // => true
         *
         * _.isError(Error);
         * // => false
         */
        function isError(value) {
            if (!isObjectLike(value)) {
                return false;
            }
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag ||
                (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
        }
        /**
         * Checks if `value` is a finite primitive number.
         *
         * **Note:** This method is based on
         * [`Number.isFinite`](https://mdn.io/Number/isFinite).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
         * @example
         *
         * _.isFinite(3);
         * // => true
         *
         * _.isFinite(Number.MIN_VALUE);
         * // => true
         *
         * _.isFinite(Infinity);
         * // => false
         *
         * _.isFinite('3');
         * // => false
         */
        function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */
        function isFunction(value) {
            if (!isObject(value)) {
                return false;
            }
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
         * Checks if `value` is an integer.
         *
         * **Note:** This method is based on
         * [`Number.isInteger`](https://mdn.io/Number/isInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
         * @example
         *
         * _.isInteger(3);
         * // => true
         *
         * _.isInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isInteger(Infinity);
         * // => false
         *
         * _.isInteger('3');
         * // => false
         */
        function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */
        function isLength(value) {
            return typeof value == 'number' &&
                value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
         * Checks if `value` is classified as a `Map` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         * @example
         *
         * _.isMap(new Map);
         * // => true
         *
         * _.isMap(new WeakMap);
         * // => false
         */
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
         * Performs a partial deep comparison between `object` and `source` to
         * determine if `object` contains equivalent property values.
         *
         * **Note:** This method is equivalent to `_.matches` when `source` is
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.isMatch(object, { 'b': 2 });
         * // => true
         *
         * _.isMatch(object, { 'b': 1 });
         * // => false
         */
        function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
         * This method is like `_.isMatch` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with five
         * arguments: (objValue, srcValue, index|key, object, source).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, srcValue) {
         *   if (isGreeting(objValue) && isGreeting(srcValue)) {
         *     return true;
         *   }
         * }
         *
         * var object = { 'greeting': 'hello' };
         * var source = { 'greeting': 'hi' };
         *
         * _.isMatchWith(object, source, customizer);
         * // => true
         */
        function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
         * Checks if `value` is `NaN`.
         *
         * **Note:** This method is based on
         * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
         * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
         * `undefined` and other non-number values.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
         * @example
         *
         * _.isNaN(NaN);
         * // => true
         *
         * _.isNaN(new Number(NaN));
         * // => true
         *
         * isNaN(undefined);
         * // => true
         *
         * _.isNaN(undefined);
         * // => false
         */
        function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
         * Checks if `value` is a pristine native function.
         *
         * **Note:** This method can't reliably detect native functions in the presence
         * of the core-js package because core-js circumvents this kind of detection.
         * Despite multiple requests, the core-js maintainer has made it clear: any
         * attempt to fix the detection will be obstructed. As a result, we're left
         * with little choice but to throw an error. Unfortunately, this also affects
         * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
         * which rely on core-js.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         * @example
         *
         * _.isNative(Array.prototype.push);
         * // => true
         *
         * _.isNative(_);
         * // => false
         */
        function isNative(value) {
            if (isMaskable(value)) {
                throw new Error(CORE_ERROR_TEXT);
            }
            return baseIsNative(value);
        }
        /**
         * Checks if `value` is `null`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
         * @example
         *
         * _.isNull(null);
         * // => true
         *
         * _.isNull(void 0);
         * // => false
         */
        function isNull(value) {
            return value === null;
        }
        /**
         * Checks if `value` is `null` or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
         * @example
         *
         * _.isNil(null);
         * // => true
         *
         * _.isNil(void 0);
         * // => true
         *
         * _.isNil(NaN);
         * // => false
         */
        function isNil(value) {
            return value == null;
        }
        /**
         * Checks if `value` is classified as a `Number` primitive or object.
         *
         * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
         * classified as numbers, use the `_.isFinite` method.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a number, else `false`.
         * @example
         *
         * _.isNumber(3);
         * // => true
         *
         * _.isNumber(Number.MIN_VALUE);
         * // => true
         *
         * _.isNumber(Infinity);
         * // => true
         *
         * _.isNumber('3');
         * // => false
         */
        function isNumber(value) {
            return typeof value == 'number' ||
                (isObjectLike(value) && baseGetTag(value) == numberTag);
        }
        /**
         * Checks if `value` is a plain object, that is, an object created by the
         * `Object` constructor or one with a `[[Prototype]]` of `null`.
         *
         * @static
         * @memberOf _
         * @since 0.8.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * _.isPlainObject(new Foo);
         * // => false
         *
         * _.isPlainObject([1, 2, 3]);
         * // => false
         *
         * _.isPlainObject({ 'x': 0, 'y': 0 });
         * // => true
         *
         * _.isPlainObject(Object.create(null));
         * // => true
         */
        function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
                return false;
            }
            var proto = getPrototype(value);
            if (proto === null) {
                return true;
            }
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor &&
                funcToString.call(Ctor) == objectCtorString;
        }
        /**
         * Checks if `value` is classified as a `RegExp` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         * @example
         *
         * _.isRegExp(/abc/);
         * // => true
         *
         * _.isRegExp('/abc/');
         * // => false
         */
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
         * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
         * double precision number which isn't the result of a rounded unsafe integer.
         *
         * **Note:** This method is based on
         * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
         * @example
         *
         * _.isSafeInteger(3);
         * // => true
         *
         * _.isSafeInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isSafeInteger(Infinity);
         * // => false
         *
         * _.isSafeInteger('3');
         * // => false
         */
        function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
         * Checks if `value` is classified as a `Set` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         * @example
         *
         * _.isSet(new Set);
         * // => true
         *
         * _.isSet(new WeakSet);
         * // => false
         */
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
         * Checks if `value` is classified as a `String` primitive or object.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a string, else `false`.
         * @example
         *
         * _.isString('abc');
         * // => true
         *
         * _.isString(1);
         * // => false
         */
        function isString(value) {
            return typeof value == 'string' ||
                (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
        }
        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */
        function isSymbol(value) {
            return typeof value == 'symbol' ||
                (isObjectLike(value) && baseGetTag(value) == symbolTag);
        }
        /**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
         * Checks if `value` is `undefined`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
         * @example
         *
         * _.isUndefined(void 0);
         * // => true
         *
         * _.isUndefined(null);
         * // => false
         */
        function isUndefined(value) {
            return value === undefined;
        }
        /**
         * Checks if `value` is classified as a `WeakMap` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
         * @example
         *
         * _.isWeakMap(new WeakMap);
         * // => true
         *
         * _.isWeakMap(new Map);
         * // => false
         */
        function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
         * Checks if `value` is classified as a `WeakSet` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
         * @example
         *
         * _.isWeakSet(new WeakSet);
         * // => true
         *
         * _.isWeakSet(new Set);
         * // => false
         */
        function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
         * Checks if `value` is less than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         * @see _.gt
         * @example
         *
         * _.lt(1, 3);
         * // => true
         *
         * _.lt(3, 3);
         * // => false
         *
         * _.lt(3, 1);
         * // => false
         */
        var lt = createRelationalOperation(baseLt);
        /**
         * Checks if `value` is less than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than or equal to
         *  `other`, else `false`.
         * @see _.gte
         * @example
         *
         * _.lte(1, 3);
         * // => true
         *
         * _.lte(3, 3);
         * // => true
         *
         * _.lte(3, 1);
         * // => false
         */
        var lte = createRelationalOperation(function (value, other) {
            return value <= other;
        });
        /**
         * Converts `value` to an array.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Array} Returns the converted array.
         * @example
         *
         * _.toArray({ 'a': 1, 'b': 2 });
         * // => [1, 2]
         *
         * _.toArray('abc');
         * // => ['a', 'b', 'c']
         *
         * _.toArray(1);
         * // => []
         *
         * _.toArray(null);
         * // => []
         */
        function toArray(value) {
            if (!value) {
                return [];
            }
            if (isArrayLike(value)) {
                return isString(value) ? stringToArray(value) : copyArray(value);
            }
            if (symIterator && value[symIterator]) {
                return iteratorToArray(value[symIterator]());
            }
            var tag = getTag(value), func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
            return func(value);
        }
        /**
         * Converts `value` to a finite number.
         *
         * @static
         * @memberOf _
         * @since 4.12.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted number.
         * @example
         *
         * _.toFinite(3.2);
         * // => 3.2
         *
         * _.toFinite(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toFinite(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toFinite('3.2');
         * // => 3.2
         */
        function toFinite(value) {
            if (!value) {
                return value === 0 ? value : 0;
            }
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = (value < 0 ? -1 : 1);
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
         * Converts `value` to an integer.
         *
         * **Note:** This method is loosely based on
         * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toInteger(3.2);
         * // => 3
         *
         * _.toInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toInteger(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toInteger('3.2');
         * // => 3
         */
        function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? (remainder ? result - remainder : result) : 0;
        }
        /**
         * Converts `value` to an integer suitable for use as the length of an
         * array-like object.
         *
         * **Note:** This method is based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toLength(3.2);
         * // => 3
         *
         * _.toLength(Number.MIN_VALUE);
         * // => 0
         *
         * _.toLength(Infinity);
         * // => 4294967295
         *
         * _.toLength('3.2');
         * // => 3
         */
        function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */
        function toNumber(value) {
            if (typeof value == 'number') {
                return value;
            }
            if (isSymbol(value)) {
                return NAN;
            }
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? (other + '') : other;
            }
            if (typeof value != 'string') {
                return value === 0 ? value : +value;
            }
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return (isBinary || reIsOctal.test(value))
                ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
                : (reIsBadHex.test(value) ? NAN : +value);
        }
        /**
         * Converts `value` to a plain object flattening inherited enumerable string
         * keyed properties of `value` to own properties of the plain object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Object} Returns the converted plain object.
         * @example
         *
         * function Foo() {
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.assign({ 'a': 1 }, new Foo);
         * // => { 'a': 1, 'b': 2 }
         *
         * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
         * // => { 'a': 1, 'b': 2, 'c': 3 }
         */
        function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
         * Converts `value` to a safe integer. A safe integer can be compared and
         * represented correctly.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toSafeInteger(3.2);
         * // => 3
         *
         * _.toSafeInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toSafeInteger(Infinity);
         * // => 9007199254740991
         *
         * _.toSafeInteger('3.2');
         * // => 3
         */
        function toSafeInteger(value) {
            return value
                ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
                : (value === 0 ? value : 0);
        }
        /**
         * Converts `value` to a string. An empty string is returned for `null`
         * and `undefined` values. The sign of `-0` is preserved.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.toString(null);
         * // => ''
         *
         * _.toString(-0);
         * // => '-0'
         *
         * _.toString([1, 2, 3]);
         * // => '1,2,3'
         */
        function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/
        /**
         * Assigns own enumerable string keyed properties of source objects to the
         * destination object. Source objects are applied from left to right.
         * Subsequent sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object` and is loosely based on
         * [`Object.assign`](https://mdn.io/Object/assign).
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assignIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assign({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'c': 3 }
         */
        var assign = createAssigner(function (object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for (var key in source) {
                if (hasOwnProperty.call(source, key)) {
                    assignValue(object, key, source[key]);
                }
            }
        });
        /**
         * This method is like `_.assign` except that it iterates over own and
         * inherited source properties.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias extend
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assign
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assignIn({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
         */
        var assignIn = createAssigner(function (object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
         * This method is like `_.assignIn` except that it accepts `customizer`
         * which is invoked to produce the assigned values. If `customizer` returns
         * `undefined`, assignment is handled by the method instead. The `customizer`
         * is invoked with five arguments: (objValue, srcValue, key, object, source).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias extendWith
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @see _.assignWith
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   return _.isUndefined(objValue) ? srcValue : objValue;
         * }
         *
         * var defaults = _.partialRight(_.assignInWith, customizer);
         *
         * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
         * This method is like `_.assign` except that it accepts `customizer`
         * which is invoked to produce the assigned values. If `customizer` returns
         * `undefined`, assignment is handled by the method instead. The `customizer`
         * is invoked with five arguments: (objValue, srcValue, key, object, source).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @see _.assignInWith
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   return _.isUndefined(objValue) ? srcValue : objValue;
         * }
         *
         * var defaults = _.partialRight(_.assignWith, customizer);
         *
         * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
         * Creates an array of values corresponding to `paths` of `object`.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Array} Returns the picked values.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
         *
         * _.at(object, ['a[0].b.c', 'a[1]']);
         * // => [3, 4]
         */
        var at = flatRest(baseAt);
        /**
         * Creates an object that inherits from the `prototype` object. If a
         * `properties` object is given, its own enumerable string keyed properties
         * are assigned to the created object.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Object
         * @param {Object} prototype The object to inherit from.
         * @param {Object} [properties] The properties to assign to the object.
         * @returns {Object} Returns the new object.
         * @example
         *
         * function Shape() {
         *   this.x = 0;
         *   this.y = 0;
         * }
         *
         * function Circle() {
         *   Shape.call(this);
         * }
         *
         * Circle.prototype = _.create(Shape.prototype, {
         *   'constructor': Circle
         * });
         *
         * var circle = new Circle;
         * circle instanceof Circle;
         * // => true
         *
         * circle instanceof Shape;
         * // => true
         */
        function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
         * Assigns own and inherited enumerable string keyed properties of source
         * objects to the destination object for all destination properties that
         * resolve to `undefined`. Source objects are applied from left to right.
         * Once a property is set, additional values of the same property are ignored.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaultsDeep
         * @example
         *
         * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var defaults = baseRest(function (object, sources) {
            object = Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                length = 1;
            }
            while (++index < length) {
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while (++propsIndex < propsLength) {
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined ||
                        (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
                        object[key] = source[key];
                    }
                }
            }
            return object;
        });
        /**
         * This method is like `_.defaults` except that it recursively assigns
         * default properties.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaults
         * @example
         *
         * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
         * // => { 'a': { 'b': 2, 'c': 3 } }
         */
        var defaultsDeep = baseRest(function (args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
         * This method is like `_.find` except that it returns the key of the first
         * element `predicate` returns truthy for instead of the element itself.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {string|undefined} Returns the key of the matched element,
         *  else `undefined`.
         * @example
         *
         * var users = {
         *   'barney':  { 'age': 36, 'active': true },
         *   'fred':    { 'age': 40, 'active': false },
         *   'pebbles': { 'age': 1,  'active': true }
         * };
         *
         * _.findKey(users, function(o) { return o.age < 40; });
         * // => 'barney' (iteration order is not guaranteed)
         *
         * // The `_.matches` iteratee shorthand.
         * _.findKey(users, { 'age': 1, 'active': true });
         * // => 'pebbles'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findKey(users, ['active', false]);
         * // => 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.findKey(users, 'active');
         * // => 'barney'
         */
        function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
         * This method is like `_.findKey` except that it iterates over elements of
         * a collection in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {string|undefined} Returns the key of the matched element,
         *  else `undefined`.
         * @example
         *
         * var users = {
         *   'barney':  { 'age': 36, 'active': true },
         *   'fred':    { 'age': 40, 'active': false },
         *   'pebbles': { 'age': 1,  'active': true }
         * };
         *
         * _.findLastKey(users, function(o) { return o.age < 40; });
         * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastKey(users, { 'age': 36, 'active': true });
         * // => 'barney'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastKey(users, ['active', false]);
         * // => 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastKey(users, 'active');
         * // => 'pebbles'
         */
        function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
         * Iterates over own and inherited enumerable string keyed properties of an
         * object and invokes `iteratee` for each property. The iteratee is invoked
         * with three arguments: (value, key, object). Iteratee functions may exit
         * iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forInRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forIn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
         */
        function forIn(object, iteratee) {
            return object == null
                ? object
                : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
         * This method is like `_.forIn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forInRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
         */
        function forInRight(object, iteratee) {
            return object == null
                ? object
                : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
         * Iterates over own enumerable string keyed properties of an object and
         * invokes `iteratee` for each property. The iteratee is invoked with three
         * arguments: (value, key, object). Iteratee functions may exit iteration
         * early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwnRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */
        function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
         * This method is like `_.forOwn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwnRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
         */
        function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
         * Creates an array of function property names from own enumerable properties
         * of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functionsIn
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functions(new Foo);
         * // => ['a', 'b']
         */
        function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
         * Creates an array of function property names from own and inherited
         * enumerable properties of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functions
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functionsIn(new Foo);
         * // => ['a', 'b', 'c']
         */
        function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
         * Gets the value at `path` of `object`. If the resolved value is
         * `undefined`, the `defaultValue` is returned in its place.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.get(object, 'a[0].b.c');
         * // => 3
         *
         * _.get(object, ['a', '0', 'b', 'c']);
         * // => 3
         *
         * _.get(object, 'a.b.c', 'default');
         * // => 'default'
         */
        function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
         * Checks if `path` is a direct property of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = { 'a': { 'b': 2 } };
         * var other = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.has(object, 'a');
         * // => true
         *
         * _.has(object, 'a.b');
         * // => true
         *
         * _.has(object, ['a', 'b']);
         * // => true
         *
         * _.has(other, 'a');
         * // => false
         */
        function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
         * Checks if `path` is a direct or inherited property of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.hasIn(object, 'a');
         * // => true
         *
         * _.hasIn(object, 'a.b');
         * // => true
         *
         * _.hasIn(object, ['a', 'b']);
         * // => true
         *
         * _.hasIn(object, 'b');
         * // => false
         */
        function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
         * Creates an object composed of the inverted keys and values of `object`.
         * If `object` contains duplicate values, subsequent values overwrite
         * property assignments of previous values.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Object
         * @param {Object} object The object to invert.
         * @returns {Object} Returns the new inverted object.
         * @example
         *
         * var object = { 'a': 1, 'b': 2, 'c': 1 };
         *
         * _.invert(object);
         * // => { '1': 'c', '2': 'b' }
         */
        var invert = createInverter(function (result, value, key) {
            if (value != null &&
                typeof value.toString != 'function') {
                value = nativeObjectToString.call(value);
            }
            result[value] = key;
        }, constant(identity));
        /**
         * This method is like `_.invert` except that the inverted object is generated
         * from the results of running each element of `object` thru `iteratee`. The
         * corresponding inverted value of each inverted key is an array of keys
         * responsible for generating the inverted value. The iteratee is invoked
         * with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.1.0
         * @category Object
         * @param {Object} object The object to invert.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Object} Returns the new inverted object.
         * @example
         *
         * var object = { 'a': 1, 'b': 2, 'c': 1 };
         *
         * _.invertBy(object);
         * // => { '1': ['a', 'c'], '2': ['b'] }
         *
         * _.invertBy(object, function(value) {
         *   return 'group' + value;
         * });
         * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
         */
        var invertBy = createInverter(function (result, value, key) {
            if (value != null &&
                typeof value.toString != 'function') {
                value = nativeObjectToString.call(value);
            }
            if (hasOwnProperty.call(result, value)) {
                result[value].push(key);
            }
            else {
                result[value] = [key];
            }
        }, getIteratee);
        /**
         * Invokes the method at `path` of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the method to invoke.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {*} Returns the result of the invoked method.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
         *
         * _.invoke(object, 'a[0].b.c.slice', 1, 3);
         * // => [2, 3]
         */
        var invoke = baseRest(baseInvoke);
        /**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */
        function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
         * Creates an array of the own and inherited enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keysIn(new Foo);
         * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
         */
        function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
         * The opposite of `_.mapValues`; this method creates an object with the
         * same values as `object` and keys generated by running each own enumerable
         * string keyed property of `object` thru `iteratee`. The iteratee is invoked
         * with three arguments: (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapValues
         * @example
         *
         * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
         *   return key + value;
         * });
         * // => { 'a1': 1, 'b2': 2 }
         */
        function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function (value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
         * Creates an object with the same keys as `object` and values generated
         * by running each own enumerable string keyed property of `object` thru
         * `iteratee`. The iteratee is invoked with three arguments:
         * (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapKeys
         * @example
         *
         * var users = {
         *   'fred':    { 'user': 'fred',    'age': 40 },
         *   'pebbles': { 'user': 'pebbles', 'age': 1 }
         * };
         *
         * _.mapValues(users, function(o) { return o.age; });
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         *
         * // The `_.property` iteratee shorthand.
         * _.mapValues(users, 'age');
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         */
        function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function (value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
         * This method is like `_.assign` except that it recursively merges own and
         * inherited enumerable string keyed properties of source objects into the
         * destination object. Source properties that resolve to `undefined` are
         * skipped if a destination value exists. Array and plain object properties
         * are merged recursively. Other objects and value types are overridden by
         * assignment. Source objects are applied from left to right. Subsequent
         * sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {
         *   'a': [{ 'b': 2 }, { 'd': 4 }]
         * };
         *
         * var other = {
         *   'a': [{ 'c': 3 }, { 'e': 5 }]
         * };
         *
         * _.merge(object, other);
         * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
         */
        var merge = createAssigner(function (object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
         * This method is like `_.merge` except that it accepts `customizer` which
         * is invoked to produce the merged values of the destination and source
         * properties. If `customizer` returns `undefined`, merging is handled by the
         * method instead. The `customizer` is invoked with six arguments:
         * (objValue, srcValue, key, object, source, stack).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} customizer The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   if (_.isArray(objValue)) {
         *     return objValue.concat(srcValue);
         *   }
         * }
         *
         * var object = { 'a': [1], 'b': [2] };
         * var other = { 'a': [3], 'b': [4] };
         *
         * _.mergeWith(object, other, customizer);
         * // => { 'a': [1, 3], 'b': [2, 4] }
         */
        var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
         * The opposite of `_.pick`; this method creates an object composed of the
         * own and inherited enumerable property paths of `object` that are not omitted.
         *
         * **Note:** This method is considerably slower than `_.pick`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [paths] The property paths to omit.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.omit(object, ['a', 'c']);
         * // => { 'b': '2' }
         */
        var omit = flatRest(function (object, paths) {
            var result = {};
            if (object == null) {
                return result;
            }
            var isDeep = false;
            paths = arrayMap(paths, function (path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) {
                result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            }
            var length = paths.length;
            while (length--) {
                baseUnset(result, paths[length]);
            }
            return result;
        });
        /**
         * The opposite of `_.pickBy`; this method creates an object composed of
         * the own and inherited enumerable string keyed properties of `object` that
         * `predicate` doesn't return truthy for. The predicate is invoked with two
         * arguments: (value, key).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The source object.
         * @param {Function} [predicate=_.identity] The function invoked per property.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.omitBy(object, _.isNumber);
         * // => { 'b': '2' }
         */
        function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
         * Creates an object composed of the picked `object` properties.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pick(object, ['a', 'c']);
         * // => { 'a': 1, 'c': 3 }
         */
        var pick = flatRest(function (object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
         * Creates an object composed of the `object` properties `predicate` returns
         * truthy for. The predicate is invoked with two arguments: (value, key).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The source object.
         * @param {Function} [predicate=_.identity] The function invoked per property.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pickBy(object, _.isNumber);
         * // => { 'a': 1, 'c': 3 }
         */
        function pickBy(object, predicate) {
            if (object == null) {
                return {};
            }
            var props = arrayMap(getAllKeysIn(object), function (prop) {
                return [prop];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function (value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
         * This method is like `_.get` except that if the resolved value is a
         * function it's invoked with the `this` binding of its parent object and
         * its result is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to resolve.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
         *
         * _.result(object, 'a[0].b.c1');
         * // => 3
         *
         * _.result(object, 'a[0].b.c2');
         * // => 4
         *
         * _.result(object, 'a[0].b.c3', 'default');
         * // => 'default'
         *
         * _.result(object, 'a[0].b.c3', _.constant('default'));
         * // => 'default'
         */
        function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while (++index < length) {
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
         * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
         * it's created. Arrays are created for missing index properties while objects
         * are created for all other missing properties. Use `_.setWith` to customize
         * `path` creation.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.set(object, 'a[0].b.c', 4);
         * console.log(object.a[0].b.c);
         * // => 4
         *
         * _.set(object, ['x', '0', 'y', 'z'], 5);
         * console.log(object.x[0].y.z);
         * // => 5
         */
        function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
         * This method is like `_.set` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.setWith(object, '[0][1]', 'a', Object);
         * // => { '0': { '1': 'a' } }
         */
        function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
         * Creates an array of own enumerable string keyed-value pairs for `object`
         * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
         * entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entries
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairs(new Foo);
         * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
         */
        var toPairs = createToPairs(keys);
        /**
         * Creates an array of own and inherited enumerable string keyed-value pairs
         * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
         * or set, its entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entriesIn
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairsIn(new Foo);
         * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
         */
        var toPairsIn = createToPairs(keysIn);
        /**
         * An alternative to `_.reduce`; this method transforms `object` to a new
         * `accumulator` object which is the result of running each of its own
         * enumerable string keyed properties thru `iteratee`, with each invocation
         * potentially mutating the `accumulator` object. If `accumulator` is not
         * provided, a new object with the same `[[Prototype]]` will be used. The
         * iteratee is invoked with four arguments: (accumulator, value, key, object).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 1.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The custom accumulator value.
         * @returns {*} Returns the accumulated value.
         * @example
         *
         * _.transform([2, 3, 4], function(result, n) {
         *   result.push(n *= n);
         *   return n % 2 == 0;
         * }, []);
         * // => [4, 9]
         *
         * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
         *   (result[value] || (result[value] = [])).push(key);
         * }, {});
         * // => { '1': ['a', 'c'], '2': ['b'] }
         */
        function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) {
                    accumulator = isArr ? new Ctor : [];
                }
                else if (isObject(object)) {
                    accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                }
                else {
                    accumulator = {};
                }
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
         * Removes the property at `path` of `object`.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 7 } }] };
         * _.unset(object, 'a[0].b.c');
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         *
         * _.unset(object, ['a', '0', 'b', 'c']);
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         */
        function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
         * This method is like `_.set` except that accepts `updater` to produce the
         * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
         * is invoked with one argument: (value).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.update(object, 'a[0].b.c', function(n) { return n * n; });
         * console.log(object.a[0].b.c);
         * // => 9
         *
         * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
         * console.log(object.x[0].y.z);
         * // => 0
         */
        function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
         * This method is like `_.update` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.updateWith(object, '[0][1]', _.constant('a'), Object);
         * // => { '0': { '1': 'a' } }
         */
        function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
         * Creates an array of the own enumerable string keyed property values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.values(new Foo);
         * // => [1, 2] (iteration order is not guaranteed)
         *
         * _.values('hi');
         * // => ['h', 'i']
         */
        function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
         * Creates an array of the own and inherited enumerable string keyed property
         * values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.valuesIn(new Foo);
         * // => [1, 2, 3] (iteration order is not guaranteed)
         */
        function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/
        /**
         * Clamps `number` within the inclusive `lower` and `upper` bounds.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Number
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         * @example
         *
         * _.clamp(-10, -5, 5);
         * // => -5
         *
         * _.clamp(10, -5, 5);
         * // => 5
         */
        function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
         * Checks if `n` is between `start` and up to, but not including, `end`. If
         * `end` is not specified, it's set to `start` with `start` then set to `0`.
         * If `start` is greater than `end` the params are swapped to support
         * negative ranges.
         *
         * @static
         * @memberOf _
         * @since 3.3.0
         * @category Number
         * @param {number} number The number to check.
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         * @see _.range, _.rangeRight
         * @example
         *
         * _.inRange(3, 2, 4);
         * // => true
         *
         * _.inRange(4, 8);
         * // => true
         *
         * _.inRange(4, 2);
         * // => false
         *
         * _.inRange(2, 2);
         * // => false
         *
         * _.inRange(1.2, 2);
         * // => true
         *
         * _.inRange(5.2, 4);
         * // => false
         *
         * _.inRange(-3, -2, -6);
         * // => true
         */
        function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            }
            else {
                end = toFinite(end);
            }
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
         * Produces a random number between the inclusive `lower` and `upper` bounds.
         * If only one argument is provided a number between `0` and the given number
         * is returned. If `floating` is `true`, or either `lower` or `upper` are
         * floats, a floating-point number is returned instead of an integer.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Number
         * @param {number} [lower=0] The lower bound.
         * @param {number} [upper=1] The upper bound.
         * @param {boolean} [floating] Specify returning a floating-point number.
         * @returns {number} Returns the random number.
         * @example
         *
         * _.random(0, 5);
         * // => an integer between 0 and 5
         *
         * _.random(5);
         * // => also an integer between 0 and 5
         *
         * _.random(5, true);
         * // => a floating-point number between 0 and 5
         *
         * _.random(1.2, 5.2);
         * // => a floating-point number between 1.2 and 5.2
         */
        function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
                upper = floating = undefined;
            }
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                }
                else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            }
            else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                }
                else {
                    upper = toFinite(upper);
                }
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/
        /**
         * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the camel cased string.
         * @example
         *
         * _.camelCase('Foo Bar');
         * // => 'fooBar'
         *
         * _.camelCase('--foo-bar--');
         * // => 'fooBar'
         *
         * _.camelCase('__FOO_BAR__');
         * // => 'fooBar'
         */
        var camelCase = createCompounder(function (result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
         * Converts the first character of `string` to upper case and the remaining
         * to lower case.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to capitalize.
         * @returns {string} Returns the capitalized string.
         * @example
         *
         * _.capitalize('FRED');
         * // => 'Fred'
         */
        function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
         * Deburrs `string` by converting
         * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
         * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
         * letters to basic Latin letters and removing
         * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to deburr.
         * @returns {string} Returns the deburred string.
         * @example
         *
         * _.deburr('déjà vu');
         * // => 'deja vu'
         */
        function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
         * Checks if `string` ends with the given target string.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {string} [target] The string to search for.
         * @param {number} [position=string.length] The position to search up to.
         * @returns {boolean} Returns `true` if `string` ends with `target`,
         *  else `false`.
         * @example
         *
         * _.endsWith('abc', 'c');
         * // => true
         *
         * _.endsWith('abc', 'b');
         * // => false
         *
         * _.endsWith('abc', 'b', 2);
         * // => true
         */
        function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined
                ? length
                : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
         * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
         * corresponding HTML entities.
         *
         * **Note:** No other characters are escaped. To escape additional
         * characters use a third-party library like [_he_](https://mths.be/he).
         *
         * Though the ">" character is escaped for symmetry, characters like
         * ">" and "/" don't need escaping in HTML and have no special meaning
         * unless they're part of a tag or unquoted attribute value. See
         * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
         * (under "semi-related fun fact") for more details.
         *
         * When working with HTML you should always
         * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
         * XSS vectors.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escape('fred, barney, & pebbles');
         * // => 'fred, barney, &amp; pebbles'
         */
        function escape(string) {
            string = toString(string);
            return (string && reHasUnescapedHtml.test(string))
                ? string.replace(reUnescapedHtml, escapeHtmlChar)
                : string;
        }
        /**
         * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
         * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escapeRegExp('[lodash](https://lodash.com/)');
         * // => '\[lodash\]\(https://lodash\.com/\)'
         */
        function escapeRegExp(string) {
            string = toString(string);
            return (string && reHasRegExpChar.test(string))
                ? string.replace(reRegExpChar, '\\$&')
                : string;
        }
        /**
         * Converts `string` to
         * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the kebab cased string.
         * @example
         *
         * _.kebabCase('Foo Bar');
         * // => 'foo-bar'
         *
         * _.kebabCase('fooBar');
         * // => 'foo-bar'
         *
         * _.kebabCase('__FOO_BAR__');
         * // => 'foo-bar'
         */
        var kebabCase = createCompounder(function (result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
         * Converts `string`, as space separated words, to lower case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the lower cased string.
         * @example
         *
         * _.lowerCase('--Foo-Bar--');
         * // => 'foo bar'
         *
         * _.lowerCase('fooBar');
         * // => 'foo bar'
         *
         * _.lowerCase('__FOO_BAR__');
         * // => 'foo bar'
         */
        var lowerCase = createCompounder(function (result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
         * Converts the first character of `string` to lower case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.lowerFirst('Fred');
         * // => 'fred'
         *
         * _.lowerFirst('FRED');
         * // => 'fRED'
         */
        var lowerFirst = createCaseFirst('toLowerCase');
        /**
         * Pads `string` on the left and right sides if it's shorter than `length`.
         * Padding characters are truncated if they can't be evenly divided by `length`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.pad('abc', 8);
         * // => '  abc   '
         *
         * _.pad('abc', 8, '_-');
         * // => '_-abc_-_'
         *
         * _.pad('abc', 3);
         * // => 'abc'
         */
        function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) {
                return string;
            }
            var mid = (length - strLength) / 2;
            return (createPadding(nativeFloor(mid), chars) +
                string +
                createPadding(nativeCeil(mid), chars));
        }
        /**
         * Pads `string` on the right side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padEnd('abc', 6);
         * // => 'abc   '
         *
         * _.padEnd('abc', 6, '_-');
         * // => 'abc_-_'
         *
         * _.padEnd('abc', 3);
         * // => 'abc'
         */
        function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return (length && strLength < length)
                ? (string + createPadding(length - strLength, chars))
                : string;
        }
        /**
         * Pads `string` on the left side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padStart('abc', 6);
         * // => '   abc'
         *
         * _.padStart('abc', 6, '_-');
         * // => '_-_abc'
         *
         * _.padStart('abc', 3);
         * // => 'abc'
         */
        function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return (length && strLength < length)
                ? (createPadding(length - strLength, chars) + string)
                : string;
        }
        /**
         * Converts `string` to an integer of the specified radix. If `radix` is
         * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
         * hexadecimal, in which case a `radix` of `16` is used.
         *
         * **Note:** This method aligns with the
         * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category String
         * @param {string} string The string to convert.
         * @param {number} [radix=10] The radix to interpret `value` by.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.parseInt('08');
         * // => 8
         *
         * _.map(['6', '08', '10'], _.parseInt);
         * // => [6, 8, 10]
         */
        function parseInt(string, radix, guard) {
            if (guard || radix == null) {
                radix = 0;
            }
            else if (radix) {
                radix = +radix;
            }
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
         * Repeats the given string `n` times.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to repeat.
         * @param {number} [n=1] The number of times to repeat the string.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the repeated string.
         * @example
         *
         * _.repeat('*', 3);
         * // => '***'
         *
         * _.repeat('abc', 2);
         * // => 'abcabc'
         *
         * _.repeat('abc', 0);
         * // => ''
         */
        function repeat(string, n, guard) {
            if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
                n = 1;
            }
            else {
                n = toInteger(n);
            }
            return baseRepeat(toString(string), n);
        }
        /**
         * Replaces matches for `pattern` in `string` with `replacement`.
         *
         * **Note:** This method is based on
         * [`String#replace`](https://mdn.io/String/replace).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to modify.
         * @param {RegExp|string} pattern The pattern to replace.
         * @param {Function|string} replacement The match replacement.
         * @returns {string} Returns the modified string.
         * @example
         *
         * _.replace('Hi Fred', 'Fred', 'Barney');
         * // => 'Hi Barney'
         */
        function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
         * Converts `string` to
         * [snake case](https://en.wikipedia.org/wiki/Snake_case).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the snake cased string.
         * @example
         *
         * _.snakeCase('Foo Bar');
         * // => 'foo_bar'
         *
         * _.snakeCase('fooBar');
         * // => 'foo_bar'
         *
         * _.snakeCase('--FOO-BAR--');
         * // => 'foo_bar'
         */
        var snakeCase = createCompounder(function (result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
         * Splits `string` by `separator`.
         *
         * **Note:** This method is based on
         * [`String#split`](https://mdn.io/String/split).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to split.
         * @param {RegExp|string} separator The separator pattern to split by.
         * @param {number} [limit] The length to truncate results to.
         * @returns {Array} Returns the string segments.
         * @example
         *
         * _.split('a-b-c', '-', 2);
         * // => ['a', 'b']
         */
        function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
                separator = limit = undefined;
            }
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) {
                return [];
            }
            string = toString(string);
            if (string && (typeof separator == 'string' ||
                (separator != null && !isRegExp(separator)))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) {
                    return castSlice(stringToArray(string), 0, limit);
                }
            }
            return string.split(separator, limit);
        }
        /**
         * Converts `string` to
         * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
         *
         * @static
         * @memberOf _
         * @since 3.1.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the start cased string.
         * @example
         *
         * _.startCase('--foo-bar--');
         * // => 'Foo Bar'
         *
         * _.startCase('fooBar');
         * // => 'Foo Bar'
         *
         * _.startCase('__FOO_BAR__');
         * // => 'FOO BAR'
         */
        var startCase = createCompounder(function (result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
         * Checks if `string` starts with the given target string.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {string} [target] The string to search for.
         * @param {number} [position=0] The position to search from.
         * @returns {boolean} Returns `true` if `string` starts with `target`,
         *  else `false`.
         * @example
         *
         * _.startsWith('abc', 'a');
         * // => true
         *
         * _.startsWith('abc', 'b');
         * // => false
         *
         * _.startsWith('abc', 'b', 1);
         * // => true
         */
        function startsWith(string, target, position) {
            string = toString(string);
            position = position == null
                ? 0
                : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
         * Creates a compiled template function that can interpolate data properties
         * in "interpolate" delimiters, HTML-escape interpolated data properties in
         * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
         * properties may be accessed as free variables in the template. If a setting
         * object is given, it takes precedence over `_.templateSettings` values.
         *
         * **Note:** In the development build `_.template` utilizes
         * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
         * for easier debugging.
         *
         * For more information on precompiling templates see
         * [lodash's custom builds documentation](https://lodash.com/custom-builds).
         *
         * For more information on Chrome extension sandboxes see
         * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The template string.
         * @param {Object} [options={}] The options object.
         * @param {RegExp} [options.escape=_.templateSettings.escape]
         *  The HTML "escape" delimiter.
         * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
         *  The "evaluate" delimiter.
         * @param {Object} [options.imports=_.templateSettings.imports]
         *  An object to import into the template as free variables.
         * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
         *  The "interpolate" delimiter.
         * @param {string} [options.sourceURL='lodash.templateSources[n]']
         *  The sourceURL of the compiled template.
         * @param {string} [options.variable='obj']
         *  The data object variable name.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the compiled template function.
         * @example
         *
         * // Use the "interpolate" delimiter to create a compiled template.
         * var compiled = _.template('hello <%= user %>!');
         * compiled({ 'user': 'fred' });
         * // => 'hello fred!'
         *
         * // Use the HTML "escape" delimiter to escape data property values.
         * var compiled = _.template('<b><%- value %></b>');
         * compiled({ 'value': '<script>' });
         * // => '<b>&lt;script&gt;</b>'
         *
         * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
         * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the internal `print` function in "evaluate" delimiters.
         * var compiled = _.template('<% print("hello " + user); %>!');
         * compiled({ 'user': 'barney' });
         * // => 'hello barney!'
         *
         * // Use the ES template literal delimiter as an "interpolate" delimiter.
         * // Disable support by replacing the "interpolate" delimiter.
         * var compiled = _.template('hello ${ user }!');
         * compiled({ 'user': 'pebbles' });
         * // => 'hello pebbles!'
         *
         * // Use backslashes to treat delimiters as plain text.
         * var compiled = _.template('<%= "\\<%- value %\\>" %>');
         * compiled({ 'value': 'ignored' });
         * // => '<%- value %>'
         *
         * // Use the `imports` option to import `jQuery` as `jq`.
         * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
         * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the `sourceURL` option to specify a custom sourceURL for the template.
         * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
         * compiled(data);
         * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
         *
         * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
         * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
         * compiled.source;
         * // => function(data) {
         * //   var __t, __p = '';
         * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
         * //   return __p;
         * // }
         *
         * // Use custom template delimiters.
         * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
         * var compiled = _.template('hello {{ user }}!');
         * compiled({ 'user': 'mustache' });
         * // => 'hello mustache!'
         *
         * // Use the `source` property to inline compiled templates for meaningful
         * // line numbers in error messages and stack traces.
         * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
         *   var JST = {\
         *     "main": ' + _.template(mainText).source + '\
         *   };\
         * ');
         */
        function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) {
                options = undefined;
            }
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' +
                interpolate.source + '|' +
                (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
                (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' +
                (hasOwnProperty.call(options, 'sourceURL')
                    ? (options.sourceURL + '').replace(/\s/g, ' ')
                    : ('lodash.templateSources[' + (++templateCounter) + ']')) + '\n';
            string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) {
                    source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                }
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) {
                source = 'with (obj) {\n' + source + '\n}\n';
            }
            // Throw an error if a forbidden character was found in `variable`, to prevent
            // potential command injection attacks.
            else if (reForbiddenIdentifierChars.test(variable)) {
                throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            }
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
                .replace(reEmptyStringMiddle, '$1')
                .replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' +
                (variable
                    ? ''
                    : 'obj || (obj = {});\n') +
                "var __t, __p = ''" +
                (isEscaping
                    ? ', __e = _.escape'
                    : '') +
                (isEvaluating
                    ? ', __j = Array.prototype.join;\n' +
                        "function print() { __p += __j.call(arguments, '') }\n"
                    : ';\n') +
                source +
                'return __p\n}';
            var result = attempt(function () {
                return Function(importsKeys, sourceURL + 'return ' + source)
                    .apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) {
                throw result;
            }
            return result;
        }
        /**
         * Converts `string`, as a whole, to lower case just like
         * [String#toLowerCase](https://mdn.io/toLowerCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the lower cased string.
         * @example
         *
         * _.toLower('--Foo-Bar--');
         * // => '--foo-bar--'
         *
         * _.toLower('fooBar');
         * // => 'foobar'
         *
         * _.toLower('__FOO_BAR__');
         * // => '__foo_bar__'
         */
        function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
         * Converts `string`, as a whole, to upper case just like
         * [String#toUpperCase](https://mdn.io/toUpperCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.toUpper('--foo-bar--');
         * // => '--FOO-BAR--'
         *
         * _.toUpper('fooBar');
         * // => 'FOOBAR'
         *
         * _.toUpper('__foo_bar__');
         * // => '__FOO_BAR__'
         */
        function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
         * Removes leading and trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trim('  abc  ');
         * // => 'abc'
         *
         * _.trim('-_-abc-_-', '_-');
         * // => 'abc'
         *
         * _.map(['  foo  ', '  bar  '], _.trim);
         * // => ['foo', 'bar']
         */
        function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) {
                return baseTrim(string);
            }
            if (!string || !(chars = baseToString(chars))) {
                return string;
            }
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
         * Removes trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimEnd('  abc  ');
         * // => '  abc'
         *
         * _.trimEnd('-_-abc-_-', '_-');
         * // => '-_-abc'
         */
        function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) {
                return string.slice(0, trimmedEndIndex(string) + 1);
            }
            if (!string || !(chars = baseToString(chars))) {
                return string;
            }
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
         * Removes leading whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimStart('  abc  ');
         * // => 'abc  '
         *
         * _.trimStart('-_-abc-_-', '_-');
         * // => 'abc-_-'
         */
        function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) {
                return string.replace(reTrimStart, '');
            }
            if (!string || !(chars = baseToString(chars))) {
                return string;
            }
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
         * Truncates `string` if it's longer than the given maximum string length.
         * The last characters of the truncated string are replaced with the omission
         * string which defaults to "...".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to truncate.
         * @param {Object} [options={}] The options object.
         * @param {number} [options.length=30] The maximum string length.
         * @param {string} [options.omission='...'] The string to indicate text is omitted.
         * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
         * @returns {string} Returns the truncated string.
         * @example
         *
         * _.truncate('hi-diddly-ho there, neighborino');
         * // => 'hi-diddly-ho there, neighbo...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': ' '
         * });
         * // => 'hi-diddly-ho there,...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': /,? +/
         * });
         * // => 'hi-diddly-ho there...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'omission': ' [...]'
         * });
         * // => 'hi-diddly-ho there, neig [...]'
         */
        function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) {
                return string;
            }
            var end = length - stringSize(omission);
            if (end < 1) {
                return omission;
            }
            var result = strSymbols
                ? castSlice(strSymbols, 0, end).join('')
                : string.slice(0, end);
            if (separator === undefined) {
                return result + omission;
            }
            if (strSymbols) {
                end += (result.length - end);
            }
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) {
                        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                    }
                    separator.lastIndex = 0;
                    while ((match = separator.exec(substring))) {
                        var newEnd = match.index;
                    }
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            }
            else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) {
                    result = result.slice(0, index);
                }
            }
            return result + omission;
        }
        /**
         * The inverse of `_.escape`; this method converts the HTML entities
         * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
         * their corresponding characters.
         *
         * **Note:** No other HTML entities are unescaped. To unescape additional
         * HTML entities use a third-party library like [_he_](https://mths.be/he).
         *
         * @static
         * @memberOf _
         * @since 0.6.0
         * @category String
         * @param {string} [string=''] The string to unescape.
         * @returns {string} Returns the unescaped string.
         * @example
         *
         * _.unescape('fred, barney, &amp; pebbles');
         * // => 'fred, barney, & pebbles'
         */
        function unescape(string) {
            string = toString(string);
            return (string && reHasEscapedHtml.test(string))
                ? string.replace(reEscapedHtml, unescapeHtmlChar)
                : string;
        }
        /**
         * Converts `string`, as space separated words, to upper case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.upperCase('--foo-bar');
         * // => 'FOO BAR'
         *
         * _.upperCase('fooBar');
         * // => 'FOO BAR'
         *
         * _.upperCase('__foo_bar__');
         * // => 'FOO BAR'
         */
        var upperCase = createCompounder(function (result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
         * Converts the first character of `string` to upper case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.upperFirst('fred');
         * // => 'Fred'
         *
         * _.upperFirst('FRED');
         * // => 'FRED'
         */
        var upperFirst = createCaseFirst('toUpperCase');
        /**
         * Splits `string` into an array of its words.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {RegExp|string} [pattern] The pattern to match words.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the words of `string`.
         * @example
         *
         * _.words('fred, barney, & pebbles');
         * // => ['fred', 'barney', 'pebbles']
         *
         * _.words('fred, barney, & pebbles', /[^, ]+/g);
         * // => ['fred', 'barney', '&', 'pebbles']
         */
        function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) {
                return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            }
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/
        /**
         * Attempts to invoke `func`, returning either the result or the caught error
         * object. Any additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Function} func The function to attempt.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {*} Returns the `func` result or error object.
         * @example
         *
         * // Avoid throwing errors for invalid selectors.
         * var elements = _.attempt(function(selector) {
         *   return document.querySelectorAll(selector);
         * }, '>_>');
         *
         * if (_.isError(elements)) {
         *   elements = [];
         * }
         */
        var attempt = baseRest(function (func, args) {
            try {
                return apply(func, undefined, args);
            }
            catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
         * Binds methods of an object to the object itself, overwriting the existing
         * method.
         *
         * **Note:** This method doesn't set the "length" property of bound functions.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {Object} object The object to bind and assign the bound methods to.
         * @param {...(string|string[])} methodNames The object method names to bind.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var view = {
         *   'label': 'docs',
         *   'click': function() {
         *     console.log('clicked ' + this.label);
         *   }
         * };
         *
         * _.bindAll(view, ['click']);
         * jQuery(element).on('click', view.click);
         * // => Logs 'clicked docs' when clicked.
         */
        var bindAll = flatRest(function (object, methodNames) {
            arrayEach(methodNames, function (key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
         * Creates a function that iterates over `pairs` and invokes the corresponding
         * function of the first predicate to return truthy. The predicate-function
         * pairs are invoked with the `this` binding and arguments of the created
         * function.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {Array} pairs The predicate-function pairs.
         * @returns {Function} Returns the new composite function.
         * @example
         *
         * var func = _.cond([
         *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
         *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
         *   [_.stubTrue,                      _.constant('no match')]
         * ]);
         *
         * func({ 'a': 1, 'b': 2 });
         * // => 'matches A'
         *
         * func({ 'a': 0, 'b': 1 });
         * // => 'matches B'
         *
         * func({ 'a': '1', 'b': '2' });
         * // => 'no match'
         */
        function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function (pair) {
                if (typeof pair[1] != 'function') {
                    throw new TypeError(FUNC_ERROR_TEXT);
                }
                return [toIteratee(pair[0]), pair[1]];
            });
            return baseRest(function (args) {
                var index = -1;
                while (++index < length) {
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) {
                        return apply(pair[1], this, args);
                    }
                }
            });
        }
        /**
         * Creates a function that invokes the predicate properties of `source` with
         * the corresponding property values of a given object, returning `true` if
         * all predicates return truthy, else `false`.
         *
         * **Note:** The created function is equivalent to `_.conformsTo` with
         * `source` partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 2, 'b': 1 },
         *   { 'a': 1, 'b': 2 }
         * ];
         *
         * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
         * // => [{ 'a': 1, 'b': 2 }]
         */
        function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that returns `value`.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {*} value The value to return from the new function.
         * @returns {Function} Returns the new constant function.
         * @example
         *
         * var objects = _.times(2, _.constant({ 'a': 1 }));
         *
         * console.log(objects);
         * // => [{ 'a': 1 }, { 'a': 1 }]
         *
         * console.log(objects[0] === objects[1]);
         * // => true
         */
        function constant(value) {
            return function () {
                return value;
            };
        }
        /**
         * Checks `value` to determine whether a default value should be returned in
         * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
         * or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Util
         * @param {*} value The value to check.
         * @param {*} defaultValue The default value.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * _.defaultTo(1, 10);
         * // => 1
         *
         * _.defaultTo(undefined, 10);
         * // => 10
         */
        function defaultTo(value, defaultValue) {
            return (value == null || value !== value) ? defaultValue : value;
        }
        /**
         * Creates a function that returns the result of invoking the given functions
         * with the `this` binding of the created function, where each successive
         * invocation is supplied the return value of the previous.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flowRight
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flow([_.add, square]);
         * addSquare(1, 2);
         * // => 9
         */
        var flow = createFlow();
        /**
         * This method is like `_.flow` except that it creates a function that
         * invokes the given functions from right to left.
         *
         * @static
         * @since 3.0.0
         * @memberOf _
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flow
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flowRight([square, _.add]);
         * addSquare(1, 2);
         * // => 9
         */
        var flowRight = createFlow(true);
        /**
         * This method returns the first argument it receives.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {*} value Any value.
         * @returns {*} Returns `value`.
         * @example
         *
         * var object = { 'a': 1 };
         *
         * console.log(_.identity(object) === object);
         * // => true
         */
        function identity(value) {
            return value;
        }
        /**
         * Creates a function that invokes `func` with the arguments of the created
         * function. If `func` is a property name, the created function returns the
         * property value for a given element. If `func` is an array or object, the
         * created function returns `true` for elements that contain the equivalent
         * source properties, otherwise it returns `false`.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Util
         * @param {*} [func=_.identity] The value to convert to a callback.
         * @returns {Function} Returns the callback.
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
         * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, _.iteratee(['user', 'fred']));
         * // => [{ 'user': 'fred', 'age': 40 }]
         *
         * // The `_.property` iteratee shorthand.
         * _.map(users, _.iteratee('user'));
         * // => ['barney', 'fred']
         *
         * // Create custom iteratee shorthands.
         * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
         *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
         *     return func.test(string);
         *   };
         * });
         *
         * _.filter(['abc', 'def'], /ef/);
         * // => ['def']
         */
        function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that performs a partial deep comparison between a given
         * object and `source`, returning `true` if the given object has equivalent
         * property values, else `false`.
         *
         * **Note:** The created function is equivalent to `_.isMatch` with `source`
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * **Note:** Multiple values can be checked by combining several matchers
         * using `_.overSome`
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
         * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
         *
         * // Checking for several possible values
         * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
         * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
         */
        function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that performs a partial deep comparison between the
         * value at `path` of a given object to `srcValue`, returning `true` if the
         * object value is equivalent, else `false`.
         *
         * **Note:** Partial comparisons will match empty array and empty object
         * `srcValue` values against any array or object value, respectively. See
         * `_.isEqual` for a list of supported value comparisons.
         *
         * **Note:** Multiple values can be checked by combining several matchers
         * using `_.overSome`
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.find(objects, _.matchesProperty('a', 4));
         * // => { 'a': 4, 'b': 5, 'c': 6 }
         *
         * // Checking for several possible values
         * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
         * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
         */
        function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
         * Creates a function that invokes the method at `path` of a given object.
         * Any additional arguments are provided to the invoked method.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Util
         * @param {Array|string} path The path of the method to invoke.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {Function} Returns the new invoker function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': _.constant(2) } },
         *   { 'a': { 'b': _.constant(1) } }
         * ];
         *
         * _.map(objects, _.method('a.b'));
         * // => [2, 1]
         *
         * _.map(objects, _.method(['a', 'b']));
         * // => [2, 1]
         */
        var method = baseRest(function (path, args) {
            return function (object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
         * The opposite of `_.method`; this method creates a function that invokes
         * the method at a given path of `object`. Any additional arguments are
         * provided to the invoked method.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Util
         * @param {Object} object The object to query.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {Function} Returns the new invoker function.
         * @example
         *
         * var array = _.times(3, _.constant),
         *     object = { 'a': array, 'b': array, 'c': array };
         *
         * _.map(['a[2]', 'c[0]'], _.methodOf(object));
         * // => [2, 0]
         *
         * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
         * // => [2, 0]
         */
        var methodOf = baseRest(function (object, args) {
            return function (path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
         * Adds all own enumerable string keyed function properties of a source
         * object to the destination object. If `object` is a function, then methods
         * are added to its prototype as well.
         *
         * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
         * avoid conflicts caused by modifying the original.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {Function|Object} [object=lodash] The destination object.
         * @param {Object} source The object of functions to add.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
         * @returns {Function|Object} Returns `object`.
         * @example
         *
         * function vowels(string) {
         *   return _.filter(string, function(v) {
         *     return /[aeiou]/i.test(v);
         *   });
         * }
         *
         * _.mixin({ 'vowels': vowels });
         * _.vowels('fred');
         * // => ['e']
         *
         * _('fred').vowels().value();
         * // => ['e']
         *
         * _.mixin({ 'vowels': vowels }, { 'chain': false });
         * _('fred').vowels();
         * // => ['e']
         */
        function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null &&
                !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function (methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) {
                    object.prototype[methodName] = function () {
                        var chainAll = this.__chain__;
                        if (chain || chainAll) {
                            var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                            actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                            result.__chain__ = chainAll;
                            return result;
                        }
                        return func.apply(object, arrayPush([this.value()], arguments));
                    };
                }
            });
            return object;
        }
        /**
         * Reverts the `_` variable to its previous value and returns a reference to
         * the `lodash` function.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @returns {Function} Returns the `lodash` function.
         * @example
         *
         * var lodash = _.noConflict();
         */
        function noConflict() {
            if (root._ === this) {
                root._ = oldDash;
            }
            return this;
        }
        /**
         * This method returns `undefined`.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Util
         * @example
         *
         * _.times(2, _.noop);
         * // => [undefined, undefined]
         */
        function noop() {
            // No operation performed.
        }
        /**
         * Creates a function that gets the argument at index `n`. If `n` is negative,
         * the nth argument from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [n=0] The index of the argument to return.
         * @returns {Function} Returns the new pass-thru function.
         * @example
         *
         * var func = _.nthArg(1);
         * func('a', 'b', 'c', 'd');
         * // => 'b'
         *
         * var func = _.nthArg(-2);
         * func('a', 'b', 'c', 'd');
         * // => 'c'
         */
        function nthArg(n) {
            n = toInteger(n);
            return baseRest(function (args) {
                return baseNth(args, n);
            });
        }
        /**
         * Creates a function that invokes `iteratees` with the arguments it receives
         * and returns their results.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to invoke.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.over([Math.max, Math.min]);
         *
         * func(1, 2, 3, 4);
         * // => [4, 1]
         */
        var over = createOver(arrayMap);
        /**
         * Creates a function that checks if **all** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * Following shorthands are possible for providing predicates.
         * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
         * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overEvery([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => false
         *
         * func(NaN);
         * // => false
         */
        var overEvery = createOver(arrayEvery);
        /**
         * Creates a function that checks if **any** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * Following shorthands are possible for providing predicates.
         * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
         * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overSome([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => true
         *
         * func(NaN);
         * // => false
         *
         * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
         * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
         */
        var overSome = createOver(arraySome);
        /**
         * Creates a function that returns the value at `path` of a given object.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': 2 } },
         *   { 'a': { 'b': 1 } }
         * ];
         *
         * _.map(objects, _.property('a.b'));
         * // => [2, 1]
         *
         * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
         * // => [1, 2]
         */
        function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
         * The opposite of `_.property`; this method creates a function that returns
         * the value at a given path of `object`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} object The object to query.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var array = [0, 1, 2],
         *     object = { 'a': array, 'b': array, 'c': array };
         *
         * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
         * // => [2, 0]
         *
         * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
         * // => [2, 0]
         */
        function propertyOf(object) {
            return function (path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
         * Creates an array of numbers (positive and/or negative) progressing from
         * `start` up to, but not including, `end`. A step of `-1` is used if a negative
         * `start` is specified without an `end` or `step`. If `end` is not specified,
         * it's set to `start` with `start` then set to `0`.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.rangeRight
         * @example
         *
         * _.range(4);
         * // => [0, 1, 2, 3]
         *
         * _.range(-4);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 5);
         * // => [1, 2, 3, 4]
         *
         * _.range(0, 20, 5);
         * // => [0, 5, 10, 15]
         *
         * _.range(0, -4, -1);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.range(0);
         * // => []
         */
        var range = createRange();
        /**
         * This method is like `_.range` except that it populates values in
         * descending order.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.range
         * @example
         *
         * _.rangeRight(4);
         * // => [3, 2, 1, 0]
         *
         * _.rangeRight(-4);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 5);
         * // => [4, 3, 2, 1]
         *
         * _.rangeRight(0, 20, 5);
         * // => [15, 10, 5, 0]
         *
         * _.rangeRight(0, -4, -1);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.rangeRight(0);
         * // => []
         */
        var rangeRight = createRange(true);
        /**
         * This method returns a new empty array.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Array} Returns the new empty array.
         * @example
         *
         * var arrays = _.times(2, _.stubArray);
         *
         * console.log(arrays);
         * // => [[], []]
         *
         * console.log(arrays[0] === arrays[1]);
         * // => false
         */
        function stubArray() {
            return [];
        }
        /**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */
        function stubFalse() {
            return false;
        }
        /**
         * This method returns a new empty object.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Object} Returns the new empty object.
         * @example
         *
         * var objects = _.times(2, _.stubObject);
         *
         * console.log(objects);
         * // => [{}, {}]
         *
         * console.log(objects[0] === objects[1]);
         * // => false
         */
        function stubObject() {
            return {};
        }
        /**
         * This method returns an empty string.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {string} Returns the empty string.
         * @example
         *
         * _.times(2, _.stubString);
         * // => ['', '']
         */
        function stubString() {
            return '';
        }
        /**
         * This method returns `true`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `true`.
         * @example
         *
         * _.times(2, _.stubTrue);
         * // => [true, true]
         */
        function stubTrue() {
            return true;
        }
        /**
         * Invokes the iteratee `n` times, returning an array of the results of
         * each invocation. The iteratee is invoked with one argument; (index).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.times(3, String);
         * // => ['0', '1', '2']
         *
         *  _.times(4, _.constant(0));
         * // => [0, 0, 0, 0]
         */
        function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) {
                return [];
            }
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while (++index < n) {
                iteratee(index);
            }
            return result;
        }
        /**
         * Converts `value` to a property path array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {*} value The value to convert.
         * @returns {Array} Returns the new property path array.
         * @example
         *
         * _.toPath('a.b.c');
         * // => ['a', 'b', 'c']
         *
         * _.toPath('a[0].b.c');
         * // => ['a', '0', 'b', 'c']
         */
        function toPath(value) {
            if (isArray(value)) {
                return arrayMap(value, toKey);
            }
            return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        /**
         * Generates a unique ID. If `prefix` is given, the ID is appended to it.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {string} [prefix=''] The value to prefix the ID with.
         * @returns {string} Returns the unique ID.
         * @example
         *
         * _.uniqueId('contact_');
         * // => 'contact_104'
         *
         * _.uniqueId();
         * // => '105'
         */
        function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/
        /**
         * Adds two numbers.
         *
         * @static
         * @memberOf _
         * @since 3.4.0
         * @category Math
         * @param {number} augend The first number in an addition.
         * @param {number} addend The second number in an addition.
         * @returns {number} Returns the total.
         * @example
         *
         * _.add(6, 4);
         * // => 10
         */
        var add = createMathOperation(function (augend, addend) {
            return augend + addend;
        }, 0);
        /**
         * Computes `number` rounded up to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round up.
         * @param {number} [precision=0] The precision to round up to.
         * @returns {number} Returns the rounded up number.
         * @example
         *
         * _.ceil(4.006);
         * // => 5
         *
         * _.ceil(6.004, 2);
         * // => 6.01
         *
         * _.ceil(6040, -2);
         * // => 6100
         */
        var ceil = createRound('ceil');
        /**
         * Divide two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} dividend The first number in a division.
         * @param {number} divisor The second number in a division.
         * @returns {number} Returns the quotient.
         * @example
         *
         * _.divide(6, 4);
         * // => 1.5
         */
        var divide = createMathOperation(function (dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
         * Computes `number` rounded down to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round down.
         * @param {number} [precision=0] The precision to round down to.
         * @returns {number} Returns the rounded down number.
         * @example
         *
         * _.floor(4.006);
         * // => 4
         *
         * _.floor(0.046, 2);
         * // => 0.04
         *
         * _.floor(4060, -2);
         * // => 4000
         */
        var floor = createRound('floor');
        /**
         * Computes the maximum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * _.max([4, 2, 8, 6]);
         * // => 8
         *
         * _.max([]);
         * // => undefined
         */
        function max(array) {
            return (array && array.length)
                ? baseExtremum(array, identity, baseGt)
                : undefined;
        }
        /**
         * This method is like `_.max` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.maxBy(objects, function(o) { return o.n; });
         * // => { 'n': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.maxBy(objects, 'n');
         * // => { 'n': 2 }
         */
        function maxBy(array, iteratee) {
            return (array && array.length)
                ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
                : undefined;
        }
        /**
         * Computes the mean of the values in `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {number} Returns the mean.
         * @example
         *
         * _.mean([4, 2, 8, 6]);
         * // => 5
         */
        function mean(array) {
            return baseMean(array, identity);
        }
        /**
         * This method is like `_.mean` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be averaged.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the mean.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.meanBy(objects, function(o) { return o.n; });
         * // => 5
         *
         * // The `_.property` iteratee shorthand.
         * _.meanBy(objects, 'n');
         * // => 5
         */
        function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
         * Computes the minimum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * _.min([4, 2, 8, 6]);
         * // => 2
         *
         * _.min([]);
         * // => undefined
         */
        function min(array) {
            return (array && array.length)
                ? baseExtremum(array, identity, baseLt)
                : undefined;
        }
        /**
         * This method is like `_.min` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.minBy(objects, function(o) { return o.n; });
         * // => { 'n': 1 }
         *
         * // The `_.property` iteratee shorthand.
         * _.minBy(objects, 'n');
         * // => { 'n': 1 }
         */
        function minBy(array, iteratee) {
            return (array && array.length)
                ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
                : undefined;
        }
        /**
         * Multiply two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} multiplier The first number in a multiplication.
         * @param {number} multiplicand The second number in a multiplication.
         * @returns {number} Returns the product.
         * @example
         *
         * _.multiply(6, 4);
         * // => 24
         */
        var multiply = createMathOperation(function (multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
         * Computes `number` rounded to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round.
         * @param {number} [precision=0] The precision to round to.
         * @returns {number} Returns the rounded number.
         * @example
         *
         * _.round(4.006);
         * // => 4
         *
         * _.round(4.006, 2);
         * // => 4.01
         *
         * _.round(4060, -2);
         * // => 4100
         */
        var round = createRound('round');
        /**
         * Subtract two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {number} minuend The first number in a subtraction.
         * @param {number} subtrahend The second number in a subtraction.
         * @returns {number} Returns the difference.
         * @example
         *
         * _.subtract(6, 4);
         * // => 2
         */
        var subtract = createMathOperation(function (minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
         * Computes the sum of the values in `array`.
         *
         * @static
         * @memberOf _
         * @since 3.4.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {number} Returns the sum.
         * @example
         *
         * _.sum([4, 2, 8, 6]);
         * // => 20
         */
        function sum(array) {
            return (array && array.length)
                ? baseSum(array, identity)
                : 0;
        }
        /**
         * This method is like `_.sum` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be summed.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the sum.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.sumBy(objects, function(o) { return o.n; });
         * // => 20
         *
         * // The `_.property` iteratee shorthand.
         * _.sumBy(objects, 'n');
         * // => 20
         */
        function sumBy(array, iteratee) {
            return (array && array.length)
                ? baseSum(array, getIteratee(iteratee, 2))
                : 0;
        }
        /*------------------------------------------------------------------------*/
        // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/
        // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, (function () {
            var source = {};
            baseForOwn(lodash, function (func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) {
                    source[methodName] = func;
                }
            });
            return source;
        }()), { 'chain': false });
        /*------------------------------------------------------------------------*/
        /**
         * The semantic version number.
         *
         * @static
         * @memberOf _
         * @type {string}
         */
        lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach(['drop', 'take'], function (methodName, index) {
            LazyWrapper.prototype[methodName] = function (n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = (this.__filtered__ && !index)
                    ? new LazyWrapper(this)
                    : this.clone();
                if (result.__filtered__) {
                    result.__takeCount__ = nativeMin(n, result.__takeCount__);
                }
                else {
                    result.__views__.push({
                        'size': nativeMin(n, MAX_ARRAY_LENGTH),
                        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                    });
                }
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function (n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function (iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach(['head', 'last'], function (methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function () {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach(['initial', 'tail'], function (methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function () {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function () {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function (predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function (predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
            if (typeof path == 'function') {
                return new LazyWrapper(this);
            }
            return this.map(function (value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function (predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function (start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) {
                return new LazyWrapper(result);
            }
            if (start < 0) {
                result = result.takeRight(-start);
            }
            else if (start) {
                result = result.drop(start);
            }
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function (predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function () {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) {
                return;
            }
            lodash.prototype[methodName] = function () {
                var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function (value) {
                    var result = lodashFunc.apply(lodash, arrayPush([value], args));
                    return (isTaker && chainAll) ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
                    // Avoid lazy use if the iteratee has a "length" value other than `1`.
                    isLazy = useLazy = false;
                }
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) {
                    return func.apply(this, args);
                }
                result = this.thru(interceptor);
                return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function () {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function (value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) {
                    realNames[key] = [];
                }
                realNames[key].push({ 'name': methodName, 'func': lodashFunc });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
                'name': 'wrapper',
                'func': undefined
            }];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
            lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
    });
    /*--------------------------------------------------------------------------*/
    // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (true) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return _;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    // Check for `exports` after `define` in case a build optimizer adds it.
    else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    }
    else {
        // Export to the global object.
        root._ = _;
    }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(158), __webpack_require__(110)(module)))

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(526);__webpack_require__(527);__webpack_require__(528);__webpack_require__(529);__webpack_require__(530);__webpack_require__(531);__webpack_require__(532);__webpack_require__(533);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = 
/*#__PURE__*/
__webpack_require__(182);
var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _curryN = 
/*#__PURE__*/
__webpack_require__(556);
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */
var curryN = 
/*#__PURE__*/
_curry2(function curryN(length, fn) {
    if (length === 1) {
        return _curry1(fn);
    }
    return _arity(length, _curryN(length, [], fn));
});
module.exports = curryN;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tokenizer_1 = __importDefault(__webpack_require__(259));
var events_1 = __webpack_require__(562);
var formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var pTag = new Set(["p"]);
var openImpliesClose = {
    tr: new Set(["tr", "th", "td"]),
    th: new Set(["th"]),
    td: new Set(["thead", "th", "td"]),
    body: new Set(["head", "link", "script"]),
    li: new Set(["li"]),
    p: pTag,
    h1: pTag,
    h2: pTag,
    h3: pTag,
    h4: pTag,
    h5: pTag,
    h6: pTag,
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: new Set(["option"]),
    optgroup: new Set(["optgroup", "option"]),
    dd: new Set(["dt", "dd"]),
    dt: new Set(["dt", "dd"]),
    address: pTag,
    article: pTag,
    aside: pTag,
    blockquote: pTag,
    details: pTag,
    div: pTag,
    dl: pTag,
    fieldset: pTag,
    figcaption: pTag,
    figure: pTag,
    footer: pTag,
    form: pTag,
    header: pTag,
    hr: pTag,
    main: pTag,
    nav: pTag,
    ol: pTag,
    pre: pTag,
    section: pTag,
    table: pTag,
    ul: pTag,
    rt: new Set(["rt", "rp"]),
    rp: new Set(["rt", "rp"]),
    tbody: new Set(["thead", "tbody"]),
    tfoot: new Set(["thead", "tbody"])
};
var voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var reNameEnd = /\s|\//;
var Parser = /** @class */ (function (_super) {
    __extends(Parser, _super);
    function Parser(cbs, options) {
        var _this = _super.call(this) || this;
        _this._tagname = "";
        _this._attribname = "";
        _this._attribvalue = "";
        _this._attribs = null;
        _this._stack = [];
        _this._foreignContext = [];
        _this.startIndex = 0;
        _this.endIndex = null;
        // Aliases for backwards compatibility
        _this.parseChunk = Parser.prototype.write;
        _this.done = Parser.prototype.end;
        _this._options = options || {};
        _this._cbs = cbs || {};
        _this._tagname = "";
        _this._attribname = "";
        _this._attribvalue = "";
        _this._attribs = null;
        _this._stack = [];
        _this._foreignContext = [];
        _this.startIndex = 0;
        _this.endIndex = null;
        _this._lowerCaseTagNames =
            "lowerCaseTags" in _this._options
                ? !!_this._options.lowerCaseTags
                : !_this._options.xmlMode;
        _this._lowerCaseAttributeNames =
            "lowerCaseAttributeNames" in _this._options
                ? !!_this._options.lowerCaseAttributeNames
                : !_this._options.xmlMode;
        _this._tokenizer = new (_this._options.Tokenizer || Tokenizer_1.default)(_this._options, _this);
        if (_this._cbs.onparserinit)
            _this._cbs.onparserinit(_this);
        return _this;
    }
    Parser.prototype._updatePosition = function (initialOffset) {
        if (this.endIndex === null) {
            if (this._tokenizer._sectionStart <= initialOffset) {
                this.startIndex = 0;
            }
            else {
                this.startIndex = this._tokenizer._sectionStart - initialOffset;
            }
        }
        else
            this.startIndex = this.endIndex + 1;
        this.endIndex = this._tokenizer.getAbsoluteIndex();
    };
    //Tokenizer event handlers
    Parser.prototype.ontext = function (data) {
        this._updatePosition(1);
        // @ts-ignore
        this.endIndex--;
        if (this._cbs.ontext)
            this._cbs.ontext(data);
    };
    Parser.prototype.onopentagname = function (name) {
        if (this._lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        this._tagname = name;
        if (!this._options.xmlMode &&
            Object.prototype.hasOwnProperty.call(openImpliesClose, name)) {
            for (var el = void 0; 
            // @ts-ignore
            openImpliesClose[name].has((el = this._stack[this._stack.length - 1])); this.onclosetag(el))
                ;
        }
        if (this._options.xmlMode || !voidElements.has(name)) {
            this._stack.push(name);
            if (foreignContextElements.has(name)) {
                this._foreignContext.push(true);
            }
            else if (htmlIntegrationElements.has(name)) {
                this._foreignContext.push(false);
            }
        }
        if (this._cbs.onopentagname)
            this._cbs.onopentagname(name);
        if (this._cbs.onopentag)
            this._attribs = {};
    };
    Parser.prototype.onopentagend = function () {
        this._updatePosition(1);
        if (this._attribs) {
            if (this._cbs.onopentag) {
                this._cbs.onopentag(this._tagname, this._attribs);
            }
            this._attribs = null;
        }
        if (!this._options.xmlMode &&
            this._cbs.onclosetag &&
            voidElements.has(this._tagname)) {
            this._cbs.onclosetag(this._tagname);
        }
        this._tagname = "";
    };
    Parser.prototype.onclosetag = function (name) {
        this._updatePosition(1);
        if (this._lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) ||
            htmlIntegrationElements.has(name)) {
            this._foreignContext.pop();
        }
        if (this._stack.length &&
            (this._options.xmlMode || !voidElements.has(name))) {
            var pos = this._stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this._cbs.onclosetag) {
                    pos = this._stack.length - pos;
                    // @ts-ignore
                    while (pos--)
                        this._cbs.onclosetag(this._stack.pop());
                }
                else
                    this._stack.length = pos;
            }
            else if (name === "p" && !this._options.xmlMode) {
                this.onopentagname(name);
                this._closeCurrentTag();
            }
        }
        else if (!this._options.xmlMode && (name === "br" || name === "p")) {
            this.onopentagname(name);
            this._closeCurrentTag();
        }
    };
    Parser.prototype.onselfclosingtag = function () {
        if (this._options.xmlMode ||
            this._options.recognizeSelfClosing ||
            this._foreignContext[this._foreignContext.length - 1]) {
            this._closeCurrentTag();
        }
        else {
            this.onopentagend();
        }
    };
    Parser.prototype._closeCurrentTag = function () {
        var name = this._tagname;
        this.onopentagend();
        //self-closing tags will be on the top of the stack
        //(cheaper check than in onclosetag)
        if (this._stack[this._stack.length - 1] === name) {
            if (this._cbs.onclosetag) {
                this._cbs.onclosetag(name);
            }
            this._stack.pop();
        }
    };
    Parser.prototype.onattribname = function (name) {
        if (this._lowerCaseAttributeNames) {
            name = name.toLowerCase();
        }
        this._attribname = name;
    };
    Parser.prototype.onattribdata = function (value) {
        this._attribvalue += value;
    };
    Parser.prototype.onattribend = function () {
        if (this._cbs.onattribute)
            this._cbs.onattribute(this._attribname, this._attribvalue);
        if (this._attribs &&
            !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)) {
            this._attribs[this._attribname] = this._attribvalue;
        }
        this._attribname = "";
        this._attribvalue = "";
    };
    Parser.prototype._getInstructionName = function (value) {
        var idx = value.search(reNameEnd);
        var name = idx < 0 ? value : value.substr(0, idx);
        if (this._lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        return name;
    };
    Parser.prototype.ondeclaration = function (value) {
        if (this._cbs.onprocessinginstruction) {
            var name_1 = this._getInstructionName(value);
            this._cbs.onprocessinginstruction("!" + name_1, "!" + value);
        }
    };
    Parser.prototype.onprocessinginstruction = function (value) {
        if (this._cbs.onprocessinginstruction) {
            var name_2 = this._getInstructionName(value);
            this._cbs.onprocessinginstruction("?" + name_2, "?" + value);
        }
    };
    Parser.prototype.oncomment = function (value) {
        this._updatePosition(4);
        if (this._cbs.oncomment)
            this._cbs.oncomment(value);
        if (this._cbs.oncommentend)
            this._cbs.oncommentend();
    };
    Parser.prototype.oncdata = function (value) {
        this._updatePosition(1);
        if (this._options.xmlMode || this._options.recognizeCDATA) {
            if (this._cbs.oncdatastart)
                this._cbs.oncdatastart();
            if (this._cbs.ontext)
                this._cbs.ontext(value);
            if (this._cbs.oncdataend)
                this._cbs.oncdataend();
        }
        else {
            this.oncomment("[CDATA[" + value + "]]");
        }
    };
    Parser.prototype.onerror = function (err) {
        if (this._cbs.onerror)
            this._cbs.onerror(err);
    };
    Parser.prototype.onend = function () {
        if (this._cbs.onclosetag) {
            for (var i = this._stack.length; i > 0; this._cbs.onclosetag(this._stack[--i]))
                ;
        }
        if (this._cbs.onend)
            this._cbs.onend();
    };
    //Resets the parser to a blank state, ready to parse a new HTML document
    Parser.prototype.reset = function () {
        if (this._cbs.onreset)
            this._cbs.onreset();
        this._tokenizer.reset();
        this._tagname = "";
        this._attribname = "";
        this._attribs = null;
        this._stack = [];
        if (this._cbs.onparserinit)
            this._cbs.onparserinit(this);
    };
    //Parses a complete HTML document and pushes it to the handler
    Parser.prototype.parseComplete = function (data) {
        this.reset();
        this.end(data);
    };
    Parser.prototype.write = function (chunk) {
        this._tokenizer.write(chunk);
    };
    Parser.prototype.end = function (chunk) {
        this._tokenizer.end(chunk);
    };
    Parser.prototype.pause = function () {
        this._tokenizer.pause();
    };
    Parser.prototype.resume = function () {
        this._tokenizer.resume();
    };
    return Parser;
}(events_1.EventEmitter));
exports.Parser = Parser;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decode_codepoint_1 = __importDefault(__webpack_require__(260));
var entities_json_1 = __importDefault(__webpack_require__(184));
var legacy_json_1 = __importDefault(__webpack_require__(261));
var xml_json_1 = __importDefault(__webpack_require__(185));
function whitespace(c) {
    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}
function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();
    if (upper === lower) {
        return function (t, c) {
            if (c === lower) {
                t._state = SUCCESS;
            }
            else {
                t._state = FAILURE;
                t._index--;
            }
        };
    }
    else {
        return function (t, c) {
            if (c === lower || c === upper) {
                t._state = SUCCESS;
            }
            else {
                t._state = FAILURE;
                t._index--;
            }
        };
    }
}
function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();
    return function (t, c) {
        if (c === lower || c === upper) {
            t._state = NEXT_STATE;
        }
        else {
            t._state = 3 /* InTagName */;
            t._index--; //consume the token again
        }
    };
}
var stateBeforeCdata1 = ifElseState("C", 23 /* BeforeCdata2 */, 16 /* InDeclaration */);
var stateBeforeCdata2 = ifElseState("D", 24 /* BeforeCdata3 */, 16 /* InDeclaration */);
var stateBeforeCdata3 = ifElseState("A", 25 /* BeforeCdata4 */, 16 /* InDeclaration */);
var stateBeforeCdata4 = ifElseState("T", 26 /* BeforeCdata5 */, 16 /* InDeclaration */);
var stateBeforeCdata5 = ifElseState("A", 27 /* BeforeCdata6 */, 16 /* InDeclaration */);
var stateBeforeScript1 = consumeSpecialNameChar("R", 34 /* BeforeScript2 */);
var stateBeforeScript2 = consumeSpecialNameChar("I", 35 /* BeforeScript3 */);
var stateBeforeScript3 = consumeSpecialNameChar("P", 36 /* BeforeScript4 */);
var stateBeforeScript4 = consumeSpecialNameChar("T", 37 /* BeforeScript5 */);
var stateAfterScript1 = ifElseState("R", 39 /* AfterScript2 */, 1 /* Text */);
var stateAfterScript2 = ifElseState("I", 40 /* AfterScript3 */, 1 /* Text */);
var stateAfterScript3 = ifElseState("P", 41 /* AfterScript4 */, 1 /* Text */);
var stateAfterScript4 = ifElseState("T", 42 /* AfterScript5 */, 1 /* Text */);
var stateBeforeStyle1 = consumeSpecialNameChar("Y", 44 /* BeforeStyle2 */);
var stateBeforeStyle2 = consumeSpecialNameChar("L", 45 /* BeforeStyle3 */);
var stateBeforeStyle3 = consumeSpecialNameChar("E", 46 /* BeforeStyle4 */);
var stateAfterStyle1 = ifElseState("Y", 48 /* AfterStyle2 */, 1 /* Text */);
var stateAfterStyle2 = ifElseState("L", 49 /* AfterStyle3 */, 1 /* Text */);
var stateAfterStyle3 = ifElseState("E", 50 /* AfterStyle4 */, 1 /* Text */);
var stateBeforeEntity = ifElseState("#", 52 /* BeforeNumericEntity */, 53 /* InNamedEntity */);
var stateBeforeNumericEntity = ifElseState("X", 55 /* InHexEntity */, 54 /* InNumericEntity */);
var Tokenizer = /** @class */ (function () {
    function Tokenizer(options, cbs) {
        /** The current state the tokenizer is in. */
        this._state = 1 /* Text */;
        /** The read buffer. */
        this._buffer = "";
        /** The beginning of the section that is currently being read. */
        this._sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */
        this._index = 0;
        /**
         * Data that has already been processed will be removed from the buffer occasionally.
         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
         */
        this._bufferOffset = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
        this._baseState = 1 /* Text */;
        /** For special parsing behavior inside of script and style tags. */
        this._special = 1 /* None */;
        /** Indicates whether the tokenizer has been paused. */
        this._running = true;
        /** Indicates whether the tokenizer has finished running / `.end` has been called. */
        this._ended = false;
        this._cbs = cbs;
        this._xmlMode = !!(options && options.xmlMode);
        this._decodeEntities = !!(options && options.decodeEntities);
    }
    Tokenizer.prototype.reset = function () {
        this._state = 1 /* Text */;
        this._buffer = "";
        this._sectionStart = 0;
        this._index = 0;
        this._bufferOffset = 0;
        this._baseState = 1 /* Text */;
        this._special = 1 /* None */;
        this._running = true;
        this._ended = false;
    };
    Tokenizer.prototype._stateText = function (c) {
        if (c === "<") {
            if (this._index > this._sectionStart) {
                this._cbs.ontext(this._getSection());
            }
            this._state = 2 /* BeforeTagName */;
            this._sectionStart = this._index;
        }
        else if (this._decodeEntities &&
            this._special === 1 /* None */ &&
            c === "&") {
            if (this._index > this._sectionStart) {
                this._cbs.ontext(this._getSection());
            }
            this._baseState = 1 /* Text */;
            this._state = 51 /* BeforeEntity */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateBeforeTagName = function (c) {
        if (c === "/") {
            this._state = 5 /* BeforeClosingTagName */;
        }
        else if (c === "<") {
            this._cbs.ontext(this._getSection());
            this._sectionStart = this._index;
        }
        else if (c === ">" ||
            this._special !== 1 /* None */ ||
            whitespace(c)) {
            this._state = 1 /* Text */;
        }
        else if (c === "!") {
            this._state = 15 /* BeforeDeclaration */;
            this._sectionStart = this._index + 1;
        }
        else if (c === "?") {
            this._state = 17 /* InProcessingInstruction */;
            this._sectionStart = this._index + 1;
        }
        else {
            this._state =
                !this._xmlMode && (c === "s" || c === "S")
                    ? 31 /* BeforeSpecial */
                    : 3 /* InTagName */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateInTagName = function (c) {
        if (c === "/" || c === ">" || whitespace(c)) {
            this._emitToken("onopentagname");
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
    };
    Tokenizer.prototype._stateBeforeClosingTagName = function (c) {
        if (whitespace(c)) {
            // ignore
        }
        else if (c === ">") {
            this._state = 1 /* Text */;
        }
        else if (this._special !== 1 /* None */) {
            if (c === "s" || c === "S") {
                this._state = 32 /* BeforeSpecialEnd */;
            }
            else {
                this._state = 1 /* Text */;
                this._index--;
            }
        }
        else {
            this._state = 6 /* InClosingTagName */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateInClosingTagName = function (c) {
        if (c === ">" || whitespace(c)) {
            this._emitToken("onclosetag");
            this._state = 7 /* AfterClosingTagName */;
            this._index--;
        }
    };
    Tokenizer.prototype._stateAfterClosingTagName = function (c) {
        //skip everything until ">"
        if (c === ">") {
            this._state = 1 /* Text */;
            this._sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype._stateBeforeAttributeName = function (c) {
        if (c === ">") {
            this._cbs.onopentagend();
            this._state = 1 /* Text */;
            this._sectionStart = this._index + 1;
        }
        else if (c === "/") {
            this._state = 4 /* InSelfClosingTag */;
        }
        else if (!whitespace(c)) {
            this._state = 9 /* InAttributeName */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateInSelfClosingTag = function (c) {
        if (c === ">") {
            this._cbs.onselfclosingtag();
            this._state = 1 /* Text */;
            this._sectionStart = this._index + 1;
        }
        else if (!whitespace(c)) {
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
    };
    Tokenizer.prototype._stateInAttributeName = function (c) {
        if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
            this._cbs.onattribname(this._getSection());
            this._sectionStart = -1;
            this._state = 10 /* AfterAttributeName */;
            this._index--;
        }
    };
    Tokenizer.prototype._stateAfterAttributeName = function (c) {
        if (c === "=") {
            this._state = 11 /* BeforeAttributeValue */;
        }
        else if (c === "/" || c === ">") {
            this._cbs.onattribend();
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
        else if (!whitespace(c)) {
            this._cbs.onattribend();
            this._state = 9 /* InAttributeName */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateBeforeAttributeValue = function (c) {
        if (c === '"') {
            this._state = 12 /* InAttributeValueDq */;
            this._sectionStart = this._index + 1;
        }
        else if (c === "'") {
            this._state = 13 /* InAttributeValueSq */;
            this._sectionStart = this._index + 1;
        }
        else if (!whitespace(c)) {
            this._state = 14 /* InAttributeValueNq */;
            this._sectionStart = this._index;
            this._index--; //reconsume token
        }
    };
    Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function (c) {
        if (c === '"') {
            this._emitToken("onattribdata");
            this._cbs.onattribend();
            this._state = 8 /* BeforeAttributeName */;
        }
        else if (this._decodeEntities && c === "&") {
            this._emitToken("onattribdata");
            this._baseState = this._state;
            this._state = 51 /* BeforeEntity */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateInAttributeValueSingleQuotes = function (c) {
        if (c === "'") {
            this._emitToken("onattribdata");
            this._cbs.onattribend();
            this._state = 8 /* BeforeAttributeName */;
        }
        else if (this._decodeEntities && c === "&") {
            this._emitToken("onattribdata");
            this._baseState = this._state;
            this._state = 51 /* BeforeEntity */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateInAttributeValueNoQuotes = function (c) {
        if (whitespace(c) || c === ">") {
            this._emitToken("onattribdata");
            this._cbs.onattribend();
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
        else if (this._decodeEntities && c === "&") {
            this._emitToken("onattribdata");
            this._baseState = this._state;
            this._state = 51 /* BeforeEntity */;
            this._sectionStart = this._index;
        }
    };
    Tokenizer.prototype._stateBeforeDeclaration = function (c) {
        this._state =
            c === "["
                ? 22 /* BeforeCdata1 */
                : c === "-"
                    ? 18 /* BeforeComment */
                    : 16 /* InDeclaration */;
    };
    Tokenizer.prototype._stateInDeclaration = function (c) {
        if (c === ">") {
            this._cbs.ondeclaration(this._getSection());
            this._state = 1 /* Text */;
            this._sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype._stateInProcessingInstruction = function (c) {
        if (c === ">") {
            this._cbs.onprocessinginstruction(this._getSection());
            this._state = 1 /* Text */;
            this._sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype._stateBeforeComment = function (c) {
        if (c === "-") {
            this._state = 19 /* InComment */;
            this._sectionStart = this._index + 1;
        }
        else {
            this._state = 16 /* InDeclaration */;
        }
    };
    Tokenizer.prototype._stateInComment = function (c) {
        if (c === "-")
            this._state = 20 /* AfterComment1 */;
    };
    Tokenizer.prototype._stateAfterComment1 = function (c) {
        if (c === "-") {
            this._state = 21 /* AfterComment2 */;
        }
        else {
            this._state = 19 /* InComment */;
        }
    };
    Tokenizer.prototype._stateAfterComment2 = function (c) {
        if (c === ">") {
            //remove 2 trailing chars
            this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
            this._state = 1 /* Text */;
            this._sectionStart = this._index + 1;
        }
        else if (c !== "-") {
            this._state = 19 /* InComment */;
        }
        // else: stay in AFTER_COMMENT_2 (`--->`)
    };
    Tokenizer.prototype._stateBeforeCdata6 = function (c) {
        if (c === "[") {
            this._state = 28 /* InCdata */;
            this._sectionStart = this._index + 1;
        }
        else {
            this._state = 16 /* InDeclaration */;
            this._index--;
        }
    };
    Tokenizer.prototype._stateInCdata = function (c) {
        if (c === "]")
            this._state = 29 /* AfterCdata1 */;
    };
    Tokenizer.prototype._stateAfterCdata1 = function (c) {
        if (c === "]")
            this._state = 30 /* AfterCdata2 */;
        else
            this._state = 28 /* InCdata */;
    };
    Tokenizer.prototype._stateAfterCdata2 = function (c) {
        if (c === ">") {
            //remove 2 trailing chars
            this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
            this._state = 1 /* Text */;
            this._sectionStart = this._index + 1;
        }
        else if (c !== "]") {
            this._state = 28 /* InCdata */;
        }
        //else: stay in AFTER_CDATA_2 (`]]]>`)
    };
    Tokenizer.prototype._stateBeforeSpecial = function (c) {
        if (c === "c" || c === "C") {
            this._state = 33 /* BeforeScript1 */;
        }
        else if (c === "t" || c === "T") {
            this._state = 43 /* BeforeStyle1 */;
        }
        else {
            this._state = 3 /* InTagName */;
            this._index--; //consume the token again
        }
    };
    Tokenizer.prototype._stateBeforeSpecialEnd = function (c) {
        if (this._special === 2 /* Script */ && (c === "c" || c === "C")) {
            this._state = 38 /* AfterScript1 */;
        }
        else if (this._special === 3 /* Style */ &&
            (c === "t" || c === "T")) {
            this._state = 47 /* AfterStyle1 */;
        }
        else
            this._state = 1 /* Text */;
    };
    Tokenizer.prototype._stateBeforeScript5 = function (c) {
        if (c === "/" || c === ">" || whitespace(c)) {
            this._special = 2 /* Script */;
        }
        this._state = 3 /* InTagName */;
        this._index--; //consume the token again
    };
    Tokenizer.prototype._stateAfterScript5 = function (c) {
        if (c === ">" || whitespace(c)) {
            this._special = 1 /* None */;
            this._state = 6 /* InClosingTagName */;
            this._sectionStart = this._index - 6;
            this._index--; //reconsume the token
        }
        else
            this._state = 1 /* Text */;
    };
    Tokenizer.prototype._stateBeforeStyle4 = function (c) {
        if (c === "/" || c === ">" || whitespace(c)) {
            this._special = 3 /* Style */;
        }
        this._state = 3 /* InTagName */;
        this._index--; //consume the token again
    };
    Tokenizer.prototype._stateAfterStyle4 = function (c) {
        if (c === ">" || whitespace(c)) {
            this._special = 1 /* None */;
            this._state = 6 /* InClosingTagName */;
            this._sectionStart = this._index - 5;
            this._index--; //reconsume the token
        }
        else
            this._state = 1 /* Text */;
    };
    //for entities terminated with a semicolon
    Tokenizer.prototype._parseNamedEntityStrict = function () {
        //offset = 1
        if (this._sectionStart + 1 < this._index) {
            var entity = this._buffer.substring(this._sectionStart + 1, this._index), map = this._xmlMode ? xml_json_1.default : entities_json_1.default;
            if (Object.prototype.hasOwnProperty.call(map, entity)) {
                // @ts-ignore
                this._emitPartial(map[entity]);
                this._sectionStart = this._index + 1;
            }
        }
    };
    //parses legacy entities (without trailing semicolon)
    Tokenizer.prototype._parseLegacyEntity = function () {
        var start = this._sectionStart + 1;
        var limit = this._index - start;
        if (limit > 6)
            limit = 6; // The max length of legacy entities is 6
        while (limit >= 2) {
            // The min length of legacy entities is 2
            var entity = this._buffer.substr(start, limit);
            if (Object.prototype.hasOwnProperty.call(legacy_json_1.default, entity)) {
                // @ts-ignore
                this._emitPartial(legacy_json_1.default[entity]);
                this._sectionStart += limit + 1;
                return;
            }
            else {
                limit--;
            }
        }
    };
    Tokenizer.prototype._stateInNamedEntity = function (c) {
        if (c === ";") {
            this._parseNamedEntityStrict();
            if (this._sectionStart + 1 < this._index && !this._xmlMode) {
                this._parseLegacyEntity();
            }
            this._state = this._baseState;
        }
        else if ((c < "a" || c > "z") &&
            (c < "A" || c > "Z") &&
            (c < "0" || c > "9")) {
            if (this._xmlMode || this._sectionStart + 1 === this._index) {
                // ignore
            }
            else if (this._baseState !== 1 /* Text */) {
                if (c !== "=") {
                    this._parseNamedEntityStrict();
                }
            }
            else {
                this._parseLegacyEntity();
            }
            this._state = this._baseState;
            this._index--;
        }
    };
    Tokenizer.prototype._decodeNumericEntity = function (offset, base) {
        var sectionStart = this._sectionStart + offset;
        if (sectionStart !== this._index) {
            //parse entity
            var entity = this._buffer.substring(sectionStart, this._index);
            var parsed = parseInt(entity, base);
            this._emitPartial(decode_codepoint_1.default(parsed));
            this._sectionStart = this._index;
        }
        else {
            this._sectionStart--;
        }
        this._state = this._baseState;
    };
    Tokenizer.prototype._stateInNumericEntity = function (c) {
        if (c === ";") {
            this._decodeNumericEntity(2, 10);
            this._sectionStart++;
        }
        else if (c < "0" || c > "9") {
            if (!this._xmlMode) {
                this._decodeNumericEntity(2, 10);
            }
            else {
                this._state = this._baseState;
            }
            this._index--;
        }
    };
    Tokenizer.prototype._stateInHexEntity = function (c) {
        if (c === ";") {
            this._decodeNumericEntity(3, 16);
            this._sectionStart++;
        }
        else if ((c < "a" || c > "f") &&
            (c < "A" || c > "F") &&
            (c < "0" || c > "9")) {
            if (!this._xmlMode) {
                this._decodeNumericEntity(3, 16);
            }
            else {
                this._state = this._baseState;
            }
            this._index--;
        }
    };
    Tokenizer.prototype._cleanup = function () {
        if (this._sectionStart < 0) {
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        }
        else if (this._running) {
            if (this._state === 1 /* Text */) {
                if (this._sectionStart !== this._index) {
                    this._cbs.ontext(this._buffer.substr(this._sectionStart));
                }
                this._buffer = "";
                this._bufferOffset += this._index;
                this._index = 0;
            }
            else if (this._sectionStart === this._index) {
                //the section just started
                this._buffer = "";
                this._bufferOffset += this._index;
                this._index = 0;
            }
            else {
                //remove everything unnecessary
                this._buffer = this._buffer.substr(this._sectionStart);
                this._index -= this._sectionStart;
                this._bufferOffset += this._sectionStart;
            }
            this._sectionStart = 0;
        }
    };
    //TODO make events conditional
    Tokenizer.prototype.write = function (chunk) {
        if (this._ended)
            this._cbs.onerror(Error(".write() after done!"));
        this._buffer += chunk;
        this._parse();
    };
    // Iterates through the buffer, calling the function corresponding to the current state.
    // States that are more likely to be hit are higher up, as a performance improvement.
    Tokenizer.prototype._parse = function () {
        while (this._index < this._buffer.length && this._running) {
            var c = this._buffer.charAt(this._index);
            if (this._state === 1 /* Text */) {
                this._stateText(c);
            }
            else if (this._state === 12 /* InAttributeValueDq */) {
                this._stateInAttributeValueDoubleQuotes(c);
            }
            else if (this._state === 9 /* InAttributeName */) {
                this._stateInAttributeName(c);
            }
            else if (this._state === 19 /* InComment */) {
                this._stateInComment(c);
            }
            else if (this._state === 8 /* BeforeAttributeName */) {
                this._stateBeforeAttributeName(c);
            }
            else if (this._state === 3 /* InTagName */) {
                this._stateInTagName(c);
            }
            else if (this._state === 6 /* InClosingTagName */) {
                this._stateInClosingTagName(c);
            }
            else if (this._state === 2 /* BeforeTagName */) {
                this._stateBeforeTagName(c);
            }
            else if (this._state === 10 /* AfterAttributeName */) {
                this._stateAfterAttributeName(c);
            }
            else if (this._state === 13 /* InAttributeValueSq */) {
                this._stateInAttributeValueSingleQuotes(c);
            }
            else if (this._state === 11 /* BeforeAttributeValue */) {
                this._stateBeforeAttributeValue(c);
            }
            else if (this._state === 5 /* BeforeClosingTagName */) {
                this._stateBeforeClosingTagName(c);
            }
            else if (this._state === 7 /* AfterClosingTagName */) {
                this._stateAfterClosingTagName(c);
            }
            else if (this._state === 31 /* BeforeSpecial */) {
                this._stateBeforeSpecial(c);
            }
            else if (this._state === 20 /* AfterComment1 */) {
                this._stateAfterComment1(c);
            }
            else if (this._state === 14 /* InAttributeValueNq */) {
                this._stateInAttributeValueNoQuotes(c);
            }
            else if (this._state === 4 /* InSelfClosingTag */) {
                this._stateInSelfClosingTag(c);
            }
            else if (this._state === 16 /* InDeclaration */) {
                this._stateInDeclaration(c);
            }
            else if (this._state === 15 /* BeforeDeclaration */) {
                this._stateBeforeDeclaration(c);
            }
            else if (this._state === 21 /* AfterComment2 */) {
                this._stateAfterComment2(c);
            }
            else if (this._state === 18 /* BeforeComment */) {
                this._stateBeforeComment(c);
            }
            else if (this._state === 32 /* BeforeSpecialEnd */) {
                this._stateBeforeSpecialEnd(c);
            }
            else if (this._state === 38 /* AfterScript1 */) {
                stateAfterScript1(this, c);
            }
            else if (this._state === 39 /* AfterScript2 */) {
                stateAfterScript2(this, c);
            }
            else if (this._state === 40 /* AfterScript3 */) {
                stateAfterScript3(this, c);
            }
            else if (this._state === 33 /* BeforeScript1 */) {
                stateBeforeScript1(this, c);
            }
            else if (this._state === 34 /* BeforeScript2 */) {
                stateBeforeScript2(this, c);
            }
            else if (this._state === 35 /* BeforeScript3 */) {
                stateBeforeScript3(this, c);
            }
            else if (this._state === 36 /* BeforeScript4 */) {
                stateBeforeScript4(this, c);
            }
            else if (this._state === 37 /* BeforeScript5 */) {
                this._stateBeforeScript5(c);
            }
            else if (this._state === 41 /* AfterScript4 */) {
                stateAfterScript4(this, c);
            }
            else if (this._state === 42 /* AfterScript5 */) {
                this._stateAfterScript5(c);
            }
            else if (this._state === 43 /* BeforeStyle1 */) {
                stateBeforeStyle1(this, c);
            }
            else if (this._state === 28 /* InCdata */) {
                this._stateInCdata(c);
            }
            else if (this._state === 44 /* BeforeStyle2 */) {
                stateBeforeStyle2(this, c);
            }
            else if (this._state === 45 /* BeforeStyle3 */) {
                stateBeforeStyle3(this, c);
            }
            else if (this._state === 46 /* BeforeStyle4 */) {
                this._stateBeforeStyle4(c);
            }
            else if (this._state === 47 /* AfterStyle1 */) {
                stateAfterStyle1(this, c);
            }
            else if (this._state === 48 /* AfterStyle2 */) {
                stateAfterStyle2(this, c);
            }
            else if (this._state === 49 /* AfterStyle3 */) {
                stateAfterStyle3(this, c);
            }
            else if (this._state === 50 /* AfterStyle4 */) {
                this._stateAfterStyle4(c);
            }
            else if (this._state === 17 /* InProcessingInstruction */) {
                this._stateInProcessingInstruction(c);
            }
            else if (this._state === 53 /* InNamedEntity */) {
                this._stateInNamedEntity(c);
            }
            else if (this._state === 22 /* BeforeCdata1 */) {
                stateBeforeCdata1(this, c);
            }
            else if (this._state === 51 /* BeforeEntity */) {
                stateBeforeEntity(this, c);
            }
            else if (this._state === 23 /* BeforeCdata2 */) {
                stateBeforeCdata2(this, c);
            }
            else if (this._state === 24 /* BeforeCdata3 */) {
                stateBeforeCdata3(this, c);
            }
            else if (this._state === 29 /* AfterCdata1 */) {
                this._stateAfterCdata1(c);
            }
            else if (this._state === 30 /* AfterCdata2 */) {
                this._stateAfterCdata2(c);
            }
            else if (this._state === 25 /* BeforeCdata4 */) {
                stateBeforeCdata4(this, c);
            }
            else if (this._state === 26 /* BeforeCdata5 */) {
                stateBeforeCdata5(this, c);
            }
            else if (this._state === 27 /* BeforeCdata6 */) {
                this._stateBeforeCdata6(c);
            }
            else if (this._state === 55 /* InHexEntity */) {
                this._stateInHexEntity(c);
            }
            else if (this._state === 54 /* InNumericEntity */) {
                this._stateInNumericEntity(c);
            }
            else if (this._state === 52 /* BeforeNumericEntity */) {
                stateBeforeNumericEntity(this, c);
            }
            else {
                this._cbs.onerror(Error("unknown _state"), this._state);
            }
            this._index++;
        }
        this._cleanup();
    };
    Tokenizer.prototype.pause = function () {
        this._running = false;
    };
    Tokenizer.prototype.resume = function () {
        this._running = true;
        if (this._index < this._buffer.length) {
            this._parse();
        }
        if (this._ended) {
            this._finish();
        }
    };
    Tokenizer.prototype.end = function (chunk) {
        if (this._ended)
            this._cbs.onerror(Error(".end() after done!"));
        if (chunk)
            this.write(chunk);
        this._ended = true;
        if (this._running)
            this._finish();
    };
    Tokenizer.prototype._finish = function () {
        //if there is remaining data, emit it in a reasonable way
        if (this._sectionStart < this._index) {
            this._handleTrailingData();
        }
        this._cbs.onend();
    };
    Tokenizer.prototype._handleTrailingData = function () {
        var data = this._buffer.substr(this._sectionStart);
        if (this._state === 28 /* InCdata */ ||
            this._state === 29 /* AfterCdata1 */ ||
            this._state === 30 /* AfterCdata2 */) {
            this._cbs.oncdata(data);
        }
        else if (this._state === 19 /* InComment */ ||
            this._state === 20 /* AfterComment1 */ ||
            this._state === 21 /* AfterComment2 */) {
            this._cbs.oncomment(data);
        }
        else if (this._state === 53 /* InNamedEntity */ && !this._xmlMode) {
            this._parseLegacyEntity();
            if (this._sectionStart < this._index) {
                this._state = this._baseState;
                this._handleTrailingData();
            }
        }
        else if (this._state === 54 /* InNumericEntity */ && !this._xmlMode) {
            this._decodeNumericEntity(2, 10);
            if (this._sectionStart < this._index) {
                this._state = this._baseState;
                this._handleTrailingData();
            }
        }
        else if (this._state === 55 /* InHexEntity */ && !this._xmlMode) {
            this._decodeNumericEntity(3, 16);
            if (this._sectionStart < this._index) {
                this._state = this._baseState;
                this._handleTrailingData();
            }
        }
        else if (this._state !== 3 /* InTagName */ &&
            this._state !== 8 /* BeforeAttributeName */ &&
            this._state !== 11 /* BeforeAttributeValue */ &&
            this._state !== 10 /* AfterAttributeName */ &&
            this._state !== 9 /* InAttributeName */ &&
            this._state !== 13 /* InAttributeValueSq */ &&
            this._state !== 12 /* InAttributeValueDq */ &&
            this._state !== 14 /* InAttributeValueNq */ &&
            this._state !== 6 /* InClosingTagName */) {
            this._cbs.ontext(data);
        }
        //else, ignore remaining data
        //TODO add a way to remove current tag
    };
    Tokenizer.prototype.getAbsoluteIndex = function () {
        return this._bufferOffset + this._index;
    };
    Tokenizer.prototype._getSection = function () {
        return this._buffer.substring(this._sectionStart, this._index);
    };
    Tokenizer.prototype._emitToken = function (name) {
        this._cbs[name](this._getSection());
        this._sectionStart = -1;
    };
    Tokenizer.prototype._emitPartial = function (value) {
        if (this._baseState !== 1 /* Text */) {
            this._cbs.onattribdata(value); //TODO implement the new event
        }
        else {
            this._cbs.ontext(value);
        }
    };
    return Tokenizer;
}());
exports.default = Tokenizer;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decode_json_1 = __importDefault(__webpack_require__(561));
// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    if (codePoint in decode_json_1.default) {
        codePoint = decode_json_1.default[codePoint];
    }
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }
    output += String.fromCharCode(codePoint);
    return output;
}
exports.default = decodeCodePoint;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule)
        return mod;
    var result = {};
    if (mod != null)
        for (var k in mod)
            if (Object.hasOwnProperty.call(mod, k))
                result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var domhandler_1 = __importDefault(__webpack_require__(186));
var DomUtils = __importStar(__webpack_require__(263));
var Parser_1 = __webpack_require__(258);
//TODO: Consume data as it is coming in
var FeedHandler = /** @class */ (function (_super) {
    __extends(FeedHandler, _super);
    /**
     *
     * @param callback
     * @param options
     */
    function FeedHandler(callback, options) {
        var _this = this;
        if (typeof callback === "object" && callback !== null) {
            callback = undefined;
            options = callback;
        }
        _this = _super.call(this, callback, options) || this;
        return _this;
    }
    FeedHandler.prototype.onend = function () {
        var feed = {};
        var feedRoot = getOneElement(isValidFeed, this.dom);
        if (feedRoot) {
            if (feedRoot.name === "feed") {
                var childs = feedRoot.children;
                feed.type = "atom";
                addConditionally(feed, "id", "id", childs);
                addConditionally(feed, "title", "title", childs);
                var href = getAttribute("href", getOneElement("link", childs));
                if (href) {
                    feed.link = href;
                }
                addConditionally(feed, "description", "subtitle", childs);
                var updated = fetch("updated", childs);
                if (updated) {
                    feed.updated = new Date(updated);
                }
                addConditionally(feed, "author", "email", childs, true);
                feed.items = getElements("entry", childs).map(function (item) {
                    var entry = {};
                    var children = item.children;
                    addConditionally(entry, "id", "id", children);
                    addConditionally(entry, "title", "title", children);
                    var href = getAttribute("href", getOneElement("link", children));
                    if (href) {
                        entry.link = href;
                    }
                    var description = fetch("summary", children) ||
                        fetch("content", children);
                    if (description) {
                        entry.description = description;
                    }
                    var pubDate = fetch("updated", children);
                    if (pubDate) {
                        entry.pubDate = new Date(pubDate);
                    }
                    return entry;
                });
            }
            else {
                var childs = getOneElement("channel", feedRoot.children)
                    .children;
                feed.type = feedRoot.name.substr(0, 3);
                feed.id = "";
                addConditionally(feed, "title", "title", childs);
                addConditionally(feed, "link", "link", childs);
                addConditionally(feed, "description", "description", childs);
                var updated = fetch("lastBuildDate", childs);
                if (updated) {
                    feed.updated = new Date(updated);
                }
                addConditionally(feed, "author", "managingEditor", childs, true);
                feed.items = getElements("item", feedRoot.children).map(function (item) {
                    var entry = {};
                    var children = item.children;
                    addConditionally(entry, "id", "guid", children);
                    addConditionally(entry, "title", "title", children);
                    addConditionally(entry, "link", "link", children);
                    addConditionally(entry, "description", "description", children);
                    var pubDate = fetch("pubDate", children);
                    if (pubDate)
                        entry.pubDate = new Date(pubDate);
                    return entry;
                });
            }
        }
        this.feed = feed;
        this.handleCallback(feedRoot ? null : Error("couldn't find root of feed"));
    };
    return FeedHandler;
}(domhandler_1.default));
exports.FeedHandler = FeedHandler;
function getElements(what, where) {
    return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where) {
    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse) {
    if (recurse === void 0) {
        recurse = false;
    }
    return DomUtils.getText(DomUtils.getElementsByTagName(what, where, recurse, 1)).trim();
}
function getAttribute(name, elem) {
    if (!elem) {
        return null;
    }
    var attribs = elem.attribs;
    return attribs[name];
}
function addConditionally(obj, prop, what, where, recurse) {
    if (recurse === void 0) {
        recurse = false;
    }
    var tmp = fetch(what, where, recurse);
    // @ts-ignore
    if (tmp)
        obj[prop] = tmp;
}
function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}
var defaultOptions = { xmlMode: true };
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this option, you probably want to set `xmlMode` to `true`.
 */
function parseFeed(feed, options) {
    if (options === void 0) {
        options = defaultOptions;
    }
    var handler = new FeedHandler(options);
    new Parser_1.Parser(handler, options).end(feed);
    return handler.feed;
}
exports.parseFeed = parseFeed;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m)
        if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(565));
__export(__webpack_require__(571));
__export(__webpack_require__(572));
__export(__webpack_require__(266));
__export(__webpack_require__(573));
__export(__webpack_require__(574));
__export(__webpack_require__(104));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
var entities_json_1 = __importDefault(__webpack_require__(184));
var legacy_json_1 = __importDefault(__webpack_require__(261));
var xml_json_1 = __importDefault(__webpack_require__(185));
var decode_codepoint_1 = __importDefault(__webpack_require__(260));
exports.decodeXML = getStrictDecoder(xml_json_1.default);
exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
function getStrictDecoder(map) {
    var keys = Object.keys(map).join("|");
    var replace = getReplacer(map);
    keys += "|#[xX][\\da-fA-F]+|#\\d+";
    var re = new RegExp("&(?:" + keys + ");", "g");
    return function (str) { return String(str).replace(re, replace); };
}
var sorter = function (a, b) { return (a < b ? 1 : -1); };
exports.decodeHTML = (function () {
    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
    var keys = Object.keys(entities_json_1.default).sort(sorter);
    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        }
        else {
            keys[i] += ";";
        }
    }
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = getReplacer(entities_json_1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";")
            str += ";";
        return replace(str);
    }
    //TODO consider creating a merged map
    return function (str) { return String(str).replace(re, replacer); };
})();
function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") {
                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
            }
            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        return map[str.slice(1, -1)];
    };
}


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.escape = exports.encodeHTML = exports.encodeXML = void 0;
var xml_json_1 = __importDefault(__webpack_require__(185));
var inverseXML = getInverseObj(xml_json_1.default);
var xmlReplacer = getInverseReplacer(inverseXML);
exports.encodeXML = getInverse(inverseXML, xmlReplacer);
var entities_json_1 = __importDefault(__webpack_require__(184));
var inverseHTML = getInverseObj(entities_json_1.default);
var htmlReplacer = getInverseReplacer(inverseHTML);
exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function (inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
        var k = _a[_i];
        if (k.length === 1) {
            // Add value to single array
            single.push("\\" + k);
        }
        else {
            // Add value to multiple array
            multiple.push(k);
        }
    }
    // Add ranges to single characters.
    single.sort();
    for (var start = 0; start < single.length - 1; start++) {
        // Find the end of a run of characters
        var end = start;
        while (end < single.length - 1 &&
            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
            end += 1;
        }
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3)
            continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
function singleCharReplacer(c) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return "&#x" + c.codePointAt(0).toString(16).toUpperCase() + ";";
}
function getInverse(inverse, re) {
    return function (data) {
        return data
            .replace(re, function (name) { return inverse[name]; })
            .replace(reNonASCII, singleCharReplacer);
    };
}
var reXmlChars = getInverseReplacer(inverseXML);
function escape(data) {
    return data
        .replace(reXmlChars, singleCharReplacer)
        .replace(reNonASCII, singleCharReplacer);
}
exports.escape = escape;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tagtypes_1 = __webpack_require__(104);
/**
 * Search a node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param element Element to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 */
function filter(test, node, recurse, limit) {
    if (recurse === void 0) {
        recurse = true;
    }
    if (limit === void 0) {
        limit = Infinity;
    }
    if (!Array.isArray(node))
        node = [node];
    return find(test, node, recurse, limit);
}
exports.filter = filter;
/**
 * Like `filter`, but only works on an array of nodes.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 */
function find(test, nodes, recurse, limit) {
    var result = [];
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var elem = nodes_1[_i];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0)
                break;
        }
        if (recurse && tagtypes_1.hasChildren(elem) && elem.children.length > 0) {
            var children = find(test, elem.children, recurse, limit);
            result.push.apply(result, children);
            limit -= children.length;
            if (limit <= 0)
                break;
        }
    }
    return result;
}
exports.find = find;
/**
 * Finds the first element inside of an array that matches a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 */
function findOneChild(test, nodes) {
    return nodes.find(test);
}
exports.findOneChild = findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 */
function findOne(test, nodes, recurse) {
    if (recurse === void 0) {
        recurse = true;
    }
    var elem = null;
    for (var i = 0; i < nodes.length && !elem; i++) {
        var checked = nodes[i];
        if (!tagtypes_1.isTag(checked)) {
            continue;
        }
        else if (test(checked)) {
            elem = checked;
        }
        else if (recurse && checked.children.length > 0) {
            elem = findOne(test, checked.children);
        }
    }
    return elem;
}
exports.findOne = findOne;
/**
 * Returns whether a tree of nodes contains at least one node passing a test.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 */
function existsOne(test, nodes) {
    return nodes.some(function (checked) {
        return tagtypes_1.isTag(checked) &&
            (test(checked) ||
                (checked.children.length > 0 &&
                    existsOne(test, checked.children)));
    });
}
exports.existsOne = existsOne;
/**
 * Search and array of nodes and its children for nodes passing a test function.
 *
 * Same as `find`, only with less options, leading to reduced complexity.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 */
function findAll(test, nodes) {
    var _a;
    var result = [];
    var stack = nodes.filter(tagtypes_1.isTag);
    var elem;
    while ((elem = stack.shift())) {
        var children = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(tagtypes_1.isTag);
        if (children && children.length > 0) {
            stack.unshift.apply(stack, children);
        }
        if (test(elem))
            result.push(elem);
    }
    return result;
}
exports.findAll = findAll;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ShouldProcessNodeDefinitions = __webpack_require__(578);
var ProcessNodeDefinitions = __webpack_require__(268);
function ProcessingInstructions() {
    var processNodeDefinitions = new ProcessNodeDefinitions();
    return {
        defaultProcessingInstructions: [{
                shouldProcessNode: ShouldProcessNodeDefinitions.shouldProcessEveryNode,
                processNode: processNodeDefinitions.processDefaultNode,
            },],
    };
}
;
module.exports = ProcessingInstructions;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(269);
// eslint-disable-next-line max-len
// https://github.com/facebook/react/blob/15.0-stable/src/renderers/dom/shared/ReactDOMComponent.js#L457
var voidElementTags = [
    'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param',
    'source', 'track', 'wbr', 'menuitem', 'textarea',
];
function ProcessNodeDefinitions() {
    function processDefaultNode(node, children, index) {
        if (node.type === 'text') {
            return node.data;
        }
        else if (node.type === 'comment') {
            // FIXME: The following doesn't work as the generated HTML results in
            // "&lt;!--  This is a comment  --&gt;"
            // return '<!-- ' + node.data + ' -->';
            return false;
        }
        if (voidElementTags.indexOf(node.name) > -1) {
            return utils.createElement(node, index);
        }
        else {
            return utils.createElement(node, index, node.data, children);
        }
    }
    return {
        processDefaultNode: processDefaultNode,
    };
}
module.exports = ProcessNodeDefinitions;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var camelCase = __webpack_require__(579);
var toPairs = __webpack_require__(580);
var reduce = __webpack_require__(581);
var React = __webpack_require__(1);
var includes = __webpack_require__(583);
var camelCaseAttrMap = __webpack_require__(593);
function createStyleJsonFromString(styleString) {
    styleString = styleString || '';
    var styles = styleString.split(/;(?!base64)/);
    var singleStyle, key, value, jsonStyles = {};
    for (var i = 0; i < styles.length; ++i) {
        singleStyle = styles[i].split(':');
        if (singleStyle.length > 2) {
            singleStyle[1] = singleStyle.slice(1).join(':');
        }
        key = singleStyle[0];
        value = singleStyle[1];
        if (typeof value === 'string') {
            value = value.trim();
        }
        if (key != null && value != null && key.length > 0 && value.length > 0) {
            jsonStyles[camelCase(key)] = value;
        }
    }
    return jsonStyles;
}
// Boolean HTML attributes, copied from https://meiert.com/en/blog/boolean-attributes-of-html/
var booleanAttrs = [
    'allowfullscreen',
    'allowpaymentrequest',
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'disabled',
    'formnovalidate',
    'hidden',
    'ismap',
    'itemscope',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'selected',
    'truespeed',
];
function createElement(node, index, data, children) {
    var elementProps = {
        key: index,
    };
    if (node.attribs) {
        elementProps = reduce(function (result, keyAndValue) {
            var key = keyAndValue[0];
            var value = keyAndValue[1];
            key = camelCaseAttrMap[key.replace(/[-:]/, '')] || key;
            if (key === 'style') {
                value = createStyleJsonFromString(value);
            }
            else if (key === 'class') {
                key = 'className';
            }
            else if (key === 'for') {
                key = 'htmlFor';
            }
            if (includes(key, booleanAttrs) && (value || '') === '') {
                value = key;
            }
            result[key] = value;
            return result;
        }, elementProps, toPairs(node.attribs));
    }
    children = children || [];
    var allChildren = data != null ? [data,].concat(children) : children;
    return React.createElement.apply(null, [node.name, elementProps,].concat(allChildren));
}
module.exports = {
    createElement: createElement,
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function alwaysValid() {
    return true;
}
module.exports = {
    alwaysValid: alwaysValid,
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _convert=__webpack_require__(6);var _index=__webpack_require__(272);var _index2=_interopRequireDefault(_index);var _common=__webpack_require__(10);var _fieldUtil=__webpack_require__(17);var _formatUtil=__webpack_require__(126);__webpack_require__(607);var _inputUtil=__webpack_require__(81);var InputUtil=_interopRequireWildcard(_inputUtil);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.setInputText=function(e){var _this$props=_this.props,detailtype=_this$props.detailtype,length=_this$props.length,fieldlabel=_this$props.fieldlabel;var value=e.target.value;if(detailtype===1){var valLen=InputUtil.realLength(value);if(length&&valLen>length){message.warning(''+fieldlabel+(0,_convert.getLabel)(20246,'文本长度不能超过')+length+'('+(0,_convert.getLabel)(124962,'1个中文字符等于3个长度')+')');value=InputUtil.checkLength(value,valLen,length);}}_this.setState({value:value});};_this.doKeyPressCheckInteger=function(e){var keyCode=Util.convertKeyCode(e);var value=_this.state.value;var length=_this.props.length;var isNumber=keyCode>=48&&keyCode<=57||keyCode===45;var selectLen=(0,_common.trim)(_this.getSelectionText(e).toString()).length;if((0,_common.trim)(value).length>0&&value.charCodeAt(0)===45)length=length+1;if(keyCode===45&&(0,_common.trim)(value).length===length){var carePos=_this.getCursortPosition();if(carePos===0){length=length+1;}}if(!isNumber||(0,_common.trim)(value).length-selectLen>=length){e.preventDefault();}};_this.doKeyDown=function(e){var _this$props2=_this.props,enableInput=_this$props2.enableInput,onDisablePrompt=_this$props2.onDisablePrompt;if(enableInput===false){typeof onDisablePrompt==="function"&&onDisablePrompt();e.preventDefault();return;}var keyCode=Util.convertKeyCode(e);if(keyCode===13){e.preventDefault();//阻止enter键导致表单提交
}e.stopPropagation();//阻止冒泡
};_this.doKeyPressCheckFloat=function(e){var _this$props3=_this.props,length=_this$props3.length,qfws=_this$props3.qfws,detailtype=_this$props3.detailtype;var keyCode=Util.convertKeyCode(e);var tmpvalue=_this.state.value;if(detailtype!==1){tmpvalue=(0,_common.trim)(tmpvalue).length>0?tmpvalue.replace(/\,/g,''):'';}var selectVal=_this.getSelectionText(e).toString();if(selectVal.length>0&&(0,_common.trim)(tmpvalue).length>0){var curPosition=_this.getCursortPosition();tmpvalue=tmpvalue.substr(0,curPosition)+tmpvalue.substr(curPosition+selectVal.length);}// 排除backspance 和del
if(keyCode==8){return;}if((0,_common.trim)(tmpvalue).length===0&&keyCode==46){e.preventDefault();}var dotCount=0;var integerCount=0;var afterDotCount=0;var hasDot=false;var len=(0,_common.trim)(tmpvalue).length;for(var i=0;i<len;i++){if(tmpvalue.charAt(i)=="."){dotCount++;hasDot=true;}else{if(hasDot){afterDotCount++;}else{integerCount++;}}}//只能输入一个"."
if(keyCode==46&&(hasDot||qfws===0)){e.preventDefault();}//console.log("dotCount",dotCount,"integerCount",integerCount,"hasDot",hasDot,"afterDotCount",afterDotCount,"keyCode",keyCode);
var isNumber=keyCode>=48&&keyCode<=57;var checkInput=isNumber||keyCode==46||keyCode==45||keyCode==46&&dotCount==1;if(!checkInput){e.preventDefault();}var checkInteger=integerCount>=length-qfws&&hasDot==false&&isNumber;if(checkInteger){e.preventDefault();}var checkLen=afterDotCount>=qfws&&integerCount>=length-qfws;if(checkLen){e.preventDefault();}if(hasDot){var carePos=_this.getCursortPosition();var dotIndex=(0,_common.trim)(tmpvalue).indexOf('.');if(carePos<=dotIndex){if(integerCount>=length-qfws){e.preventDefault();}}else{if(afterDotCount>=qfws){e.preventDefault();}}}};var formatvalue=_this.transFormatValue(props.value,props);_this.state={value:props.value?props.value:'',formatvalue:formatvalue,isonfocus:false,location:-1};return _this;}(0,_createClass3.default)(Main,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.value!==nextProps.value||this.props.format!==nextProps.format||nextProps.defaultFocus){var formatShowValue=this.transFormatValue(nextProps.value,nextProps);var _state={value:nextProps.value,formatvalue:formatShowValue};if(nextProps.defaultFocus!==this.props.defaultFocus&&nextProps.defaultFocus){_state.isonfocus=true;}this.setState(_state);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(this.props.defaultFocus&&this.props.defaultFocus!==nextProps.defaultFocus)//延时失去焦点时不渲染组件
return false;return nextProps.value!==this.props.value||nextProps.viewAttr!==this.props.viewAttr||nextState.value!==this.state.value||nextState.isonfocus!==this.state.isonfocus||nextState.formatvalue!==this.state.formatvalue||nextProps.format!==this.props.format||nextProps.showhtml!==this.props.showhtml||nextProps.emptyShowContent!==this.props.emptyShowContent||nextProps.fieldName!==this.props.fieldName||nextProps.closeAutoComplete!==this.props.closeAutoComplete||nextProps.autocomplete_change_name!==this.props.autocomplete_change_name;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.state.isonfocus===true&&prevState.isonfocus===false)this.setLocation();}},{key:'render',value:function render(){var _state2=this.state,isonfocus=_state2.isonfocus,formatvalue=_state2.formatvalue;var _props=this.props,viewAttr=_props.viewAttr,fieldid=_props.fieldid,fieldName=_props.fieldName,detailtype=_props.detailtype,qfws=_props.qfws,format=_props.format,isDetail=_props.isDetail,emptyShowContent=_props.emptyShowContent,showhtml=_props.showhtml,closeAutoComplete=_props.closeAutoComplete,autocomplete_change_name=_props.autocomplete_change_name;var style=(0,_extends3.default)({},this.props.style);var value=this.state.value;if(detailtype!==1){value=(0,_common.trim)(value).length>0?value.replace(/\,/g,''):'';}var numberType=parseInt(format.numberType)||0;if(!isonfocus&&numberType===100){//财务表览
return React.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaWfFinancial@gfss8j',type:2,finNum:format.finaNum,className:'finarea_'+fieldid,viewAttr:viewAttr,value:value,clickEvent:this.doFocusEvent.bind(this,true)});}if(numberType===2&&(format.formatPattern=="1"||format.formatPattern=="4")){//格式化值负数则变为红色
style["color"]=!isonfocus&&InputUtil.judgeIsNumber(value)&&parseFloat(value)<0?"#FF0000":"inherit";}var chinglish=detailtype===4?InputUtil.convertAmountChinese(value):"";var domArr=new Array();var new_fieldName=autocomplete_change_name==1?"fieldwf"+fieldid:fieldName;var autocomplete=closeAutoComplete==1?"off":"on";if(viewAttr===1){if(detailtype===4){if(!isDetail){domArr.push(React.createElement('span',{style:style},formatvalue));domArr.push(React.createElement('br',null));}domArr.push(React.createElement('span',{id:fieldName+'span',style:style},chinglish));}else{if(!!showhtml)formatvalue=showhtml;domArr.push(React.createElement('span',{id:fieldName+'span',style:style,dangerouslySetInnerHTML:{__html:formatvalue}}));}return React.createElement('span',null,domArr,React.createElement('input',{autocomplete:autocomplete,type:'hidden',id:fieldName,name:new_fieldName,value:value}));}else{var className='wf-input wf-input-'+detailtype+' '+(isDetail?"wf-input-detail":"wf-input-main")+' wf-input-field'+fieldid;var onKeyPressEvent="";if(detailtype===2)onKeyPressEvent=this.doKeyPressCheckInteger;else if(detailtype===3||detailtype===4||detailtype===5)onKeyPressEvent=this.doKeyPressCheckFloat;if(detailtype===4){//金额转换字段
domArr.push(React.createElement('input',{ref:'inputEle',type:'text',className:className,id:fieldName,name:new_fieldName,value:isonfocus?value:isDetail?chinglish:formatvalue,onChange:this.setInputText,onKeyDown:this.doKeyDown,onKeyPress:onKeyPressEvent,onFocus:this.doFocusEvent.bind(this,true),onBlur:this.doFocusEvent.bind(this,false),autocomplete:autocomplete,style:style}));if(!isDetail){domArr.push(React.createElement('br',null));domArr.push(React.createElement('input',{autocomplete:autocomplete,type:'text',disabled:true,value:chinglish,className:className+' wf-input-chinese',style:style}));}}else{//支持可编辑无值时显示灰色默认值
emptyShowContent=emptyShowContent||"";if(!isonfocus&&emptyShowContent!==""&&formatvalue.toString()===""){style["color"]="#A5A5A5";// if(Util.getBrowserVersion() === "IE9"){
formatvalue=emptyShowContent;// }
}else{if(!"color"in style)style["color"]="inherit";}domArr.push(React.createElement('input',{ref:'inputEle',type:'text',className:className,id:fieldName,name:new_fieldName,value:isonfocus?value:formatvalue// placeholder={emptyShowContent}
,onChange:this.setInputText,onKeyDown:this.doKeyDown,onKeyPress:onKeyPressEvent,onFocus:this.doFocusEvent.bind(this,true),onBlur:this.doFocusEvent.bind(this,false),autocomplete:autocomplete,style:style}));}var isRequired=viewAttr===3&&(0,_common.trim)(value).length===0;domArr.push(React.createElement('span',{id:fieldName+'span',className:'wf-input-required'},isRequired?React.createElement('img',{src:(window.ecologyContentPath||'')+'/images/BacoError_wev9.png',align:'absmiddle'}):""));return React.createElement('div',{className:'wf-form-input'},domArr);}}},{key:'doFocusEvent',value:function doFocusEvent(bool,e){var _props2=this.props,fieldName=_props2.fieldName,viewAttr=_props2.viewAttr;if(viewAttr===1)return;if(bool){//获取焦点
this.setState({isonfocus:bool,location:this.getLocation()});WfForm.triggerFieldAction("onfocus",fieldName);}else{//失去焦点
var value=this.checkLen(e.target.value);//验证长度
var realValue=this.transRealValue(value);var formatValue=this.transFormatValue(value,this.props);this.setState({value:realValue,formatvalue:formatValue,isonfocus:bool});WfForm.triggerFieldAction("onblur",fieldName);}}},{key:'transRealValue',value:function transRealValue(value){var _props3=this.props,detailtype=_props3.detailtype,qfws=_props3.qfws;var realValue=value;if(detailtype!==1){var isqfw=detailtype===5;realValue=(0,_fieldUtil.convertFloatValue)(value.trim(),qfws,isqfw);}this.props.onChange&&this.props.onChange(realValue);//失去焦点触发修改Redux
return realValue;}},{key:'transFormatValue',value:function transFormatValue(value,props){var detailtype=props.detailtype,qfws=props.qfws,format=props.format;if(detailtype!==1){value=(0,_common.trim)(value).length>0?value.replace(/\,/g,''):'';}var formatvalue=value;var numberType=parseInt(format.numberType)||0;//失去焦点
if(numberType>0){if(numberType===100){//财务预览
}else if(numberType===101){//财务金额大写
formatvalue=InputUtil.convertAmountChinese(value);}else{formatvalue=(0,_formatUtil.convertFormatValue)(value,format);}}else{if(detailtype!==1){var isqfw=false;if(detailtype===4||detailtype===5){isqfw=true;}formatvalue=(0,_fieldUtil.convertFloatValue)(value,qfws,isqfw);}}return formatvalue;}},{key:'checkLen',value:function checkLen(val){var _props4=this.props,detailtype=_props4.detailtype,length=_props4.length,qfws=_props4.qfws,fieldlabel=_props4.fieldlabel;if(detailtype===1){var valLen=InputUtil.realLength(val);if(length&&valLen>length){message.warning(''+fieldlabel+(0,_convert.getLabel)(20246,'文本长度不能超过')+length+',('+(0,_convert.getLabel)(124962,'1个中文字符等于3个长度')+')');val=InputUtil.checkLength(val,valLen,length);}return val;}if((0,_common.trim)(val).length===0)return"";if((0,_common.trim)(val).length===1&&val.charCodeAt(0)===45)return val;if(!InputUtil.judgeIsNumber(val))return"";if(val.charCodeAt(0)===45)length=length+1;var arr=val.toString().split(".");if((0,_common.trim)(arr[0]).length>length-qfws){message.warning(''+(0,_convert.getLabel)(385128,'整数位数长度不能超过')+(length-qfws)+(0,_convert.getLabel)(386375,'位，请重新输入！'),5);return"";}return val;}//整数
//检测小数输入
},{key:'getSelectionText',value:function getSelectionText(e){if(document.selection){//IE
return document.selection.createRange().text;}else if(window.getSelection().toString()){//Chrome
return window.getSelection().toString();}else if(e.selectionStart!=undefined&&e.selectionEnd!=undefined){//其它情况
var start=e.selectionStart;var end=e.selectionEnd;return e.value.substring(start,end);}return"";}},{key:'getCursortPosition',value:function getCursortPosition(){var input=this.refs.inputEle;var CaretPos=0;if(input.selection){input.focus();var Sel=input.selection.createRange();if(Sel.text.length<1){Sel.moveStart('character',-input.value.length);CaretPos=Sel.text.length;}}else if(input.selectionStart||input.selectionStart=='0'){//ff
CaretPos=input.selectionStart;}return CaretPos;}},{key:'getLocation',value:function getLocation(){try{//计算鼠标焦点位置
var elm=this.refs.inputEle;if(elm.createTextRange){// IE
var range=document.selection.createRange();range.setEndPoint('StartToStart',elm.createTextRange());return range.text.length;}else if(typeof elm.selectionStart==='number'){return elm.selectionStart;}}catch(e){return-1;}}},{key:'setLocation',value:function setLocation(){var elm=this.refs.inputEle;var location=this.state.location;if(location<0||location>elm.value.length)//定位到最后
location=elm.value.length;if(elm.createTextRange){//IE
var textRange=elm.createTextRange();textRange.moveStart('character',location);textRange.collapse();textRange.select();}else if(elm.setSelectionRange){elm.setSelectionRange(location,location);elm.focus();}}}]);return Main;}(React.Component);exports.default=Main;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);__webpack_require__(606);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(){(0,_classCallCheck3.default)(this,main);return(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).apply(this,arguments));}(0,_createClass3.default)(main,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.props.type!==nextProps.type||this.props.className!==nextProps.className||this.props.viewAttr!==nextProps.viewAttr||this.props.value!==nextProps.value;}},{key:'render',value:function render(){var _props=this.props,type=_props.type,finNum=_props.finNum,className=_props.className;var showTds=new Array();if(type===1){//财务表头
var _props2=this.props,fontSize=_props2.fontSize,label=_props2.label;if(!fontSize)fontSize="9pt";//字体大小为pt单位，默认9pt
var headArr=["分","角","元","十","百","千","万","十","百","千","亿","十"];for(var i=finNum-1;i>=0;i--){var itemBorder="fborder1";if(i===0)itemBorder="";else if(i===2)itemBorder="fborder2";else if((i-2)%3===0)itemBorder="fborder3";itemBorder="finborder "+itemBorder;showTds.push(React.createElement('td',{className:itemBorder},headArr[i]));}return React.createElement('div',{className:'wf-findiv'},React.createElement('div',{className:'fintop'},label),React.createElement('div',{className:'finbottom'},React.createElement('table',{className:'fintable '+className},React.createElement('tr',null,showTds))),React.createElement('style',null,'.'+className+' td{width:'+parseInt(fontSize.replace("pt",""))*2+'px;}'));}else if(type===2){//财务表览
var _props3=this.props,viewAttr=_props3.viewAttr,value=_props3.value,clickEvent=_props3.clickEvent;var valArr=this.transFinancialArr(value);for(var _i=finNum-1;_i>=0;_i--){var _itemBorder="fborder1";if(_i===0)_itemBorder="";else if(_i===2)_itemBorder="fborder2";else if((_i-2)%3===0)_itemBorder="fborder3";_itemBorder="finborder "+_itemBorder;showTds.push(React.createElement('td',{className:_itemBorder},valArr[_i]||""));}return React.createElement('div',{className:'wf-findiv',onClick:clickEvent},React.createElement('table',{className:'fintable '+className},React.createElement('tr',null,showTds)));}else return React.createElement('span',null);}},{key:'transFinancialArr',value:function transFinancialArr(fieldVal){var valArr=new Array();if(fieldVal===""||fieldVal===null){if(this.props.viewAttr===3)//必填标示
valArr.push(React.createElement('span',{style:{color:"red !important",fontSize:"14px !important"}},'*'));return valArr;}fieldVal=fieldVal.replace(/,/g,"");var reg1=/^(-?\d+)(\.\d+)?$/;var reg2=/^(-?\d*)(\.\d+)$/;//解决类型-.22这种格式
if(reg1.test(fieldVal)||reg2.test(fieldVal)){fieldVal=parseFloat(fieldVal).toFixed(2);if(fieldVal.length>2&&fieldVal.substring(0,2)=="0."||fieldVal.length>3&&fieldVal.substring(0,3)=="-0."){fieldVal=fieldVal.replace("0.",".");}for(var i=fieldVal.length-1;i>=0;i--){var valc=fieldVal.charAt(i);if(valc!=".")valArr.push(valc);}}return valArr;}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _mobx=__webpack_require__(9);var _index=__webpack_require__(49);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _convert=__webpack_require__(6);var _signUtil=__webpack_require__(58);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _jquery=__webpack_require__(127);var _jquery2=_interopRequireDefault(_jquery);__webpack_require__(608);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormSignInput=(_dec=(0,_index.inject)('globalStore','layoutStore'),_dec(_class=(0,_index.observer)(_class=function(_React$Component){(0,_inherits3.default)(FormSignInput,_React$Component);function FormSignInput(){(0,_classCallCheck3.default)(this,FormSignInput);var _this=(0,_possibleConstructorReturn3.default)(this,(FormSignInput.__proto__||(0,_getPrototypeOf2.default)(FormSignInput)).call(this));_this.contentUtil=function(str){var hea=str.substr(0,str.indexOf("<div _quotoContent='true'"));str=str.slice(str.indexOf("<div _quotoContent='true'"));var pic='['+(0,_convert.getLabel)(528760,'图片')+']';str=str.replace(/<img.*?>/g,pic);str=str.replace(/<[^>]*>|<\/[^>]*>/gm,"");str=str.replace(/\r|\n|\\s/gm,"");str='<div class=\'remark-quote\'>'+str+'</div>';str=hea+str+"</div>";return str;};_this.deleteItem=function(key,event){var src=_this.props.src;var variableMap=_this.props.globalStore.variableMap;var remark_list_mark=src=="freeWorkflowSimple"?"remark_list_freeWorkflowSimple":"remark_list";var remark_list=variableMap.get(remark_list_mark);remark_list.delete(key);};_this.getRemarkDom=function(isInForm){var _getAntd=(0,_convert.getAntd)(),Icon=_getAntd.Icon;var variableMap=_this.props.globalStore.variableMap;var src=_this.props.src;var remark_list_mark=src=="freeWorkflowSimple"?"remark_list_freeWorkflowSimple":"remark_list";var remarkMap=variableMap.get(remark_list_mark)||(_mobx.observable.map?_mobx.observable.map({}):asMap({}));var arr=[];remarkMap.forEach(function(value,key,map){var item=_react2.default.createElement('div',{className:'remark_list_dom',style:{position:"relative",marginLeft:isInForm?"10px":"0"}},_react2.default.createElement('div',{style:{width:"100%"},dangerouslySetInnerHTML:{__html:_this.contentUtil(value)}}),_react2.default.createElement(Icon,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Icon@f6g057@'+key,type:'cross',title:'\u5220\u9664',style:{position:"absolute",right:"10px",top:"10px",cursor:"pointer",color:"#333"},onClick:_this.deleteItem.bind(_this,key)}));if((0,_mobx.toJS)(value)!==''){arr.push(item);}});return arr;};_this.initRemark=function(){var batchControlVariableMap=_this.props.globalStore.batchControlVariableMap;batchControlVariableMap({'isShowSignInput':true,'isEditorFocus':true});};_this.changeRemarkInfo=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var src=_this.props.src;var _this$props$globalSto=_this.props.globalStore,changeSubmitParam=_this$props$globalSto.changeSubmitParam,controlVariableMap=_this$props$globalSto.controlVariableMap;if(src=="freeWorkflowSimple"){controlVariableMap("freeWorkflowSimple_submitData",params);}else{changeSubmitParam(params);}};_this.onSingInputLoadReady=function(){var _this$props=_this.props,globalStore=_this$props.globalStore,layoutStore=_this$props.layoutStore;var _globalStore$commonPa=globalStore.commonParam,commonParam=_globalStore$commonPa===undefined?{}:_globalStore$commonPa;var _commonParam$belongTe=commonParam.belongTest,belongTest=_commonParam$belongTe===undefined?false:_commonParam$belongTe,requestid=commonParam.requestid;if(belongTest){try{window.parent.window.workflowAutoTestUtil.returnStatus('signInputReady',requestid);}catch(e){if(window.console)console.log(e);}}globalStore.setBtnDisabled(false);};_this.state={hasLoad:false,width:0};return _this;}(0,_createClass3.default)(FormSignInput,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};var width=(0,_jquery2.default)("table tbody tr:nth-child(2) td:first-child").width();this.setState({"width":(0,_jquery2.default)("table").width()-width-20});asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var hasLoad=this.state.hasLoad;if(hasLoad&&typeof window.REMARK_CK_REF==="undefined"){window.REMARK_CK_REF=this.refs.remarkCK;var width=(0,_jquery2.default)("table tbody tr:nth-child(2) td:first-child").width();this.setState({"width":(0,_jquery2.default)("table").width()-width-20});}}// 点击删除一个签字意见
//渲染引用签字意见列表
},{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaPopoverHrm=_getEcCom.WeaPopoverHrm;var hasLoad=this.state.hasLoad;if(hasLoad){var WfSignInput=window.weaWorkflowPublic.WfSignInput;var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var commonParam=globalStore.commonParam,_globalStore$markInfo=globalStore.markInfo,markInfo=_globalStore$markInfo===undefined?{}:_globalStore$markInfo,variableMap=globalStore.variableMap,controlVariableMap=globalStore.controlVariableMap,loadMarkInfo=globalStore.loadMarkInfo,_globalStore$secLevel=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel===undefined?{}:_globalStore$secLevel;var _layoutStore$containS=layoutStore.containSignInput,containSignInput=_layoutStore$containS===undefined?false:_layoutStore$containS,propFileCfg=layoutStore.propFileCfg;var _props2=this.props,onChangeEvent=_props2.onChangeEvent,onAutographBlur=_props2.onAutographBlur,_props2$isInForm=_props2.isInForm,isInForm=_props2$isInForm===undefined?false:_props2$isInForm,_props2$isPropOpenSig=_props2.isPropOpenSignInput,isPropOpenSignInput=_props2$isPropOpenSig===undefined?false:_props2$isPropOpenSig,_props2$src=_props2.src,src=_props2$src===undefined?"":_props2$src;var isShowSignInput=variableMap.get("isShowSignInput");//签字意见
var remark_list_mark=src=="freeWorkflowSimple"?"remark_list_freeWorkflowSimple":"remark_list";var isEditorFocus=variableMap.get('isEditorFocus');var remark_list=variableMap.get(remark_list_mark);var requestid=commonParam.requestid,requestType=commonParam.requestType,intervenorright=commonParam.intervenorright,belongTest=commonParam.belongTest;var _markInfo$remarkInfo=markInfo.remarkInfo,remarkInfo=_markInfo$remarkInfo===undefined?{}:_markInfo$remarkInfo,isHideInput=markInfo.isHideInput,tempbeagenter=markInfo.tempbeagenter,fileuserid=markInfo.fileuserid,tempbeagentername=markInfo.tempbeagentername,use_textarea_signinput=markInfo.use_textarea_signinput,workflowRequestLogId=markInfo.workflowRequestLogId;var remark=remarkInfo.remark;var isshowsigninputdiv=(requestType>0||intervenorright>0)&&isHideInput=='0';var defaultshowsigninput=isshowsigninputdiv&&_.trim(remark).length>0||remark_list&&remark_list.size>1;var isBeagent=tempbeagenter!=fileuserid;var agent=_react2.default.createElement('span',{style:{lineHeight:"36px",paddingLeft:"10px"}},(0,_convert.getLabel)(388045,"您当前正在代理"),_react2.default.createElement(WeaPopoverHrm,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPopoverHrm@lvs1ya'}),_react2.default.createElement('a',{href:'javaScript:openhrm('+tempbeagenter+');',onClick:function onClick(e){return window.pointerXY(e);},title:tempbeagentername},_react2.default.createElement('span',{style:{color:"#4D7AD8",cursor:"pointer"}},tempbeagentername)),(0,_convert.getLabel)(84398,"进行操作"));//开启了提交必填，且无批注操作才显示意见必填标识
var remarkMustInput=(0,_signUtil.needMustInputDot)();var isopen=isShowSignInput===undefined?defaultshowsigninput:isShowSignInput;if(isPropOpenSignInput)isopen=isPropOpenSignInput;if(propFileCfg&&propFileCfg.always_show_signinput==="1")isopen=true;var className="wf-req-signInput";if(isopen)className+=" wf-req-signInput-isOpen";if(remarkMustInput)className+=" wf-req-signInput-mustInput";var secLevel=FieldUtil.getRelateFieldValue(-10,-1)||"";var secLevelName=FieldUtil.getSecLevelName(secLevel);var allowEditFileSec=!(requestid&&requestid>0);return isInForm?_react2.default.createElement('div',{id:'remark_div'},_react2.default.createElement('div',{className:'wf-req-sign-input',onClick:this.initRemark},isBeagent&&agent,this.getRemarkDom(isInForm)),_react2.default.createElement(WfSignInput,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WfSignInput@dnyipz',ref:"remarkCK",isInForm:isInForm,markInfo:markInfo,requestType:requestType,requestid:requestid,isShowSignInput:true,editorId:'remark',workflowRequestLogId:workflowRequestLogId},remarkInfo,{loadReady:this.onSingInputLoadReady,onChange:onChangeEvent,onAutographBlur:onAutographBlur,isEditorFocus:isEditorFocus,controlVariableMap:controlVariableMap,changeRemarkInfo:this.changeRemarkInfo,saveCallBack:function saveCallBack(){return loadMarkInfo(false);},layout:window,belongTest:belongTest,secLevelInfo:(0,_extends3.default)({},secLevelInfo,{secLevel:secLevel,secLevelName:secLevelName,allowEditFileSec:allowEditFileSec})}))):_react2.default.createElement('div',{id:'remark_div',className:className},_react2.default.createElement('div',{className:'wf-req-sign-input',style:{background:!isopen?"#ffffff":"#F9F8F7",cursor:!isopen?"pointer":"default"},onClick:src?function(){}:this.initRemark},_react2.default.createElement('i',{className:'icon-coms-Need-feedback',style:{marginRight:"10px",fontSize:"15px",color:"#AFAFAF ",lineHeight:"40px",display:"inline-block",verticalAlign:"bottom"}}),_react2.default.createElement('span',{className:'sign-label',style:{color:"#A0A0A0"}},(0,_convert.getLabel)(17614,'签字意见')),remarkMustInput&&isopen&&_react2.default.createElement('span',{style:{color:"red",marginLeft:"10px"}},'(',(0,_convert.getLabel)(30036,"必填").trim(),')'),_react2.default.createElement('span',{style:{marginLeft:"15px"}},isBeagent&&agent),this.getRemarkDom()),_react2.default.createElement(WfSignInput,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WfSignInput@4xn04t',ref:"remarkCK",markInfo:markInfo,requestType:requestType,requestid:requestid,isInForm:isInForm,isShowSignInput:isopen,editorId:src?src:'remark'},remarkInfo,{remark:this.props.remark?this.props.remark:remark,workflowRequestLogId:workflowRequestLogId,loadReady:this.onSingInputLoadReady,isEditorFocus:isEditorFocus,controlVariableMap:controlVariableMap,changeRemarkInfo:this.changeRemarkInfo,saveCallBack:function saveCallBack(){return loadMarkInfo(false);},layout:window,visible:this.props.visible,belongTest:belongTest,secLevelInfo:(0,_extends3.default)({},secLevelInfo,{secLevel:secLevel,secLevelName:secLevelName,allowEditFileSec:allowEditFileSec})})));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@1bk8be'});}}//点击签字意见，打开签字意见编辑器
}]);return FormSignInput;}(_react2.default.Component))||_class)||_class);exports.default=FormSignInput;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.createDoc=exports.showDoc=exports.getoDocTopButtons=undefined;var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// export const getoDocIframeUrl = (info) =>{
//     let url = info.docUrl+"?";
//     for(const key in info.docParam){
//         url += key+"="+encodeURIComponent(info.docParam[key])+"&"
//     }
//     return url;
// }
/**
 * 节流函数，用于正文页签上方按钮的点击事件比较频繁，进行优化
 */var throttle=function throttle(fun){var wait=arguments.length>1&&arguments[1]!==undefined?arguments[1]:2500;var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;var pre=Date.now()-2500;return function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var now=Date.now();if(now-pre>=wait){fun.apply(undefined,args);pre=Date.now();}else{message.warn((0,_convert.getLabel)('524062','操作频繁，请稍后再试'));}};};var getoDocTopButtons=exports.getoDocTopButtons=function getoDocTopButtons(info){var btnDisabled=_base2.default.globalStore.btnDisabled;var _getAntd2=(0,_convert.getAntd)(),Button=_getAntd2.Button;var btnArr=[];info&&info.buttons&&info.buttons.map(function(btn){if(btn.isshow===true)btnArr.push(React.createElement(Button,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Button@lvg4jk@odocbtn',type:'primary',disabled:btnDisabled,onClick:throttle(function(){window.oDocUtil.odocBtnEvent(btn.key);})},btn.title));});return btnArr;};//显示文档 、正文
/**
 * params：
 * docid: 文档id
 * requestid:请求id
 * type:0 公文，1 文档
 */window.addDocReadTag=function(docId){//DocReadTagUtil.addDocReadTag(docId,<%=user.getUID()%>,<%=user.getLogintype()%>,"<%=request.getRemoteAddr()%>",returnTrue);
};var showDoc=exports.showDoc=function showDoc(params){workflow_form_doc_operation.showDoc(params);};//创建文档、正文
var createDoc=exports.createDoc=function createDoc(fieldMark,commonParam){var _getAntd3=(0,_convert.getAntd)(),message=_getAntd3.message;var workflowid=commonParam.workflowid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,newdocpath=commonParam.newdocpath,secretLevel=commonParam.secretLevel,_commonParam$secLevel=commonParam.secLevelInfo,secLevelInfo=_commonParam$secLevel===undefined?{}:_commonParam$secLevel;if(secLevelInfo.isOpenSec&&secretLevel==""){message.error(secLevelInfo.tip);return;}var params={};params.wfid=workflowid;params.f_weaver_belongto_userid=f_weaver_belongto_userid;params.f_weaver_belongto_usertype=f_weaver_belongto_usertype;params.docfileid=fieldMark.substring(5);params.secid=newdocpath;params._secretLevel=secretLevel;workflow_form_doc_operation.createDoc(params);};if(window.location.hash&&window.location.hash.indexOf("#/main/workflow/req")==0&&window.location.hash.indexOf("isOdocChangeType=1")>0){try{var nod=document.createElement('style');var str='.wea-right-menu{display: none !important;}.wea-new-top-req-wapper{padding-top: 0;}.wea-new-top-req-wapper .wea-new-top-req{display:none;}.wf-req-form-wrapper>div{display:none;}'+'.wf-req-form-wrapper>div.wf-req-form{display:block;}#odocmask{position: absolute;left: 0;top: 0;width: 100%;height: 100%;z-index: 999;}}';nod.type='text/css';if(nod.styleSheet){//ie下
nod.styleSheet.cssText=str;}else{nod.innerHTML=str;}document.getElementsByTagName('head')[0].appendChild(nod);var i=0;var timer=setInterval(function(){if(window.WfForm&&WfForm.getGlobalStore&&WfForm.getGlobalStore().JSComplete==true&&window.jQuery){if(jQuery("#odocmask").length<=0&&jQuery(".wf-req-form").length>0){var height=jQuery(".wf-req-form").eq(0).height();jQuery(".wf-req-form").eq(0).append("<div id='odocmask' style='height:"+(height+100)+"px'></div>");}else if(jQuery("#odocmask").length>0){var _height=jQuery(".wf-req-form").eq(0).height();var marginTop=parseInt(jQuery(".wf-req-form-wrapper").eq(0).css("marginTop"))+10;jQuery("#odocmask").css({height:_height+marginTop+"px"});}i++;if(i==10){clearInterval(timer);}}},1000);}catch(e){if(window.console){console.log(e);}}}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Homepage=exports.Synergy=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Synergy=function(_React$Component){(0,_inherits3.default)(Synergy,_React$Component);function Synergy(){(0,_classCallCheck3.default)(this,Synergy);var _this=(0,_possibleConstructorReturn3.default)(this,(Synergy.__proto__||(0,_getPrototypeOf2.default)(Synergy)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(Synergy,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('portal',_fileConfig.portalFiles,init,false);}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(hasLoad){var _Synergy=window.weaPortal.Synergy;return _react2.default.createElement(_Synergy,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Synergy@q03t9g'},this.props));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@hxddjz'});}}}]);return Synergy;}(_react2.default.Component);var Homepage=function(_React$Component2){(0,_inherits3.default)(Homepage,_React$Component2);function Homepage(){(0,_classCallCheck3.default)(this,Homepage);var _this3=(0,_possibleConstructorReturn3.default)(this,(Homepage.__proto__||(0,_getPrototypeOf2.default)(Homepage)).call(this));_this3.state={hasLoad:false};return _this3;}(0,_createClass3.default)(Homepage,[{key:'componentDidMount',value:function componentDidMount(){var _this4=this;var init=function init(){_this4.setState({hasLoad:true});};asyncLoad.asyncLoadModule('portal',_fileConfig.portalFiles,init,false);}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(hasLoad){var _Homepage=window.weaPortal.Homepage;return _react2.default.createElement(_Homepage,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Homepage@6uptr1'},this.props));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@cmj7an'});}}}]);return Homepage;}(_react2.default.Component);exports.Synergy=Synergy;exports.Homepage=Homepage;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _rightBtn=__webpack_require__(85);var RigthBtn=_interopRequireWildcard(_rightBtn);var _secondAuthUtil=__webpack_require__(86);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LogList=function(_React$Component){(0,_inherits3.default)(LogList,_React$Component);function LogList(){(0,_classCallCheck3.default)(this,LogList);var _this=(0,_possibleConstructorReturn3.default)(this,(LogList.__proto__||(0,_getPrototypeOf2.default)(LogList)).call(this));_this.state={hasLoad:false,store:null,store1:null};return _this;}(0,_createClass3.default)(LogList,[{key:'getUrlParams',value:function getUrlParams(url){var result={};var idx=url.lastIndexOf('?');if(idx>0){var params=url.substring(idx+1).split('&');for(var i=0;i<params.length;i++){idx=params[i].indexOf('=');if(idx>0){result[params[i].substring(0,idx)]=params[i].substring(idx+1);}}}return result;}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var commonParam=_this2.props.commonParam;var _window$weaWorkflowPu=window.weaWorkflowPublic,SecondAuthStore=_window$weaWorkflowPu.SecondAuthStore,WfFormLogListStore=_window$weaWorkflowPu.WfFormLogListStore;var store=new WfFormLogListStore();var urlParams=_this2.getUrlParams(window.location.href);if(urlParams.hasOwnProperty('fromCommunication')){store.initLog((0,_extends3.default)({},commonParam,{fromCommunication:urlParams.fromCommunication}));}else{store.initLog((0,_extends3.default)({},commonParam));}_this2.setState({hasLoad:true,store:store,store1:SecondAuthStore});window.formLoglistStore=store;//公共模块的签字意见store抛出，处理tab切换至表单刷新签字意见的问题
};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _nextProps$isRelaodLo=nextProps.isRelaodLogList,isRelaodLogList=_nextProps$isRelaodLo===undefined?false:_nextProps$isRelaodLo,_nextProps$reloadLogL=nextProps.reloadLogListParams,reloadLogListParams=_nextProps$reloadLogL===undefined?{}:_nextProps$reloadLogL;if(isRelaodLogList){var store=this.state.store;store.updateLogParams(reloadLogListParams,true);}}},{key:'render',value:function render(){var setTabKey=this.props.setTabKey;var _state=this.state,hasLoad=_state.hasLoad,store=_state.store,store1=_state.store1;if(hasLoad){var WfFormLogListCom=window.weaWorkflowPublic.WfFormLogListCom;var _props=this.props,forward=_props.forward,controlVariableMap=_props.controlVariableMap,commonParam=_props.commonParam,variableMap=_props.variableMap;var isOpenCommunication=commonParam.isOpenCommunication;if(commonParam.belongTest){forward='0';}store1.setCommonParam(commonParam);return _react2.default.createElement(WfFormLogListCom,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfFormLogListCom@o3006d',isOpenCommunication:isOpenCommunication,setTabKey:setTabKey,logListStore:store,controlVariableMap:controlVariableMap,variableMap:variableMap,forward:forward,forwardEvent:RigthBtn.doReviewE9,showAuthDetail:_secondAuthUtil.showAuthDetail,closeAuthDetail:_secondAuthUtil.closeAuthDetail,secondAuthStore:store1});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@iy0jv7'});}}}]);return LogList;}(_react2.default.Component);exports.default=LogList;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _convert=__webpack_require__(6);__webpack_require__(639);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Group=function(_React$Component){(0,_inherits3.default)(Group,_React$Component);function Group(props){(0,_classCallCheck3.default)(this,Group);var _this=(0,_possibleConstructorReturn3.default)(this,(Group.__proto__||(0,_getPrototypeOf2.default)(Group)).call(this,props));_this.state={showGroup:true};return _this;}(0,_createClass3.default)(Group,[{key:'render',value:function render(){var _this2=this;var _getAntd=(0,_convert.getAntd)(),Row=_getAntd.Row,Col=_getAntd.Col,Icon=_getAntd.Icon;var _props=this.props,title=_props.title,items=_props.items,_props$needTigger=_props.needTigger,needTigger=_props$needTigger===undefined?true:_props$needTigger,_props$col=_props.col,col=_props$col===undefined?2:_props$col,_props$customComponen=_props.customComponent,customComponent=_props$customComponen===undefined?'':_props$customComponen,_props$groupBodyCompo=_props.groupBodyComponent,groupBodyComponent=_props$groupBodyCompo===undefined?'':_props$groupBodyCompo;var _state$showGroup=this.state.showGroup,showGroup=_state$showGroup===undefined?false:_state$showGroup;//console.log("items:",items);
return React.createElement('div',{className:'wea-group'},React.createElement(Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@7l4naa',className:'wea-title-row'},React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@vv2yyx',span:'19'},React.createElement('div',{className:'wea-title'},title)),customComponent&&React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@k2w91x',span:4,style:{textAlign:"right",paddingRight:10,fontSize:12}},customComponent),needTigger&&React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@6me260',span:customComponent?1:5,style:{textAlign:"right",paddingRight:10,fontSize:12}},React.createElement('i',{className:showGroup?'icon-coms-up':'icon-coms-down',onClick:function onClick(){return _this2.setState({showGroup:!showGroup});}}))),React.createElement('div',{className:'wea-group-content',style:{display:showGroup?"block":"none"}},groupBodyComponent));}},{key:'setShowGroup',value:function setShowGroup(bool){this.setState({showGroup:bool});}}]);return Group;}(React.Component);exports.default=Group;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var OdocModelAndSensitive=function(_React$Component){(0,_inherits3.default)(OdocModelAndSensitive,_React$Component);function OdocModelAndSensitive(){(0,_classCallCheck3.default)(this,OdocModelAndSensitive);var _this=(0,_possibleConstructorReturn3.default)(this,(OdocModelAndSensitive.__proto__||(0,_getPrototypeOf2.default)(OdocModelAndSensitive)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(OdocModelAndSensitive,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.timer&&window.clearInterval(this.timer);}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};if(!window.weaOdoc){this.timer=window.setInterval(function(){if(window.weaOdoc){init();window.clearInterval(_this2.timer);}},300);}else{init();}}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(hasLoad&&window.weaOdoc){var _props=this.props,commonParam=_props.commonParam,odocInfo=_props.odocInfo,tabKey=_props.tabKey;var _ref=window.weaOdoc.components||{},OdocModelAndSensitiveCom=_ref.OdocModelAndSensitiveCom;var _ref2=window.weaOdoc.store||{},odocModelAndSensitiveStore=_ref2.odocModelAndSensitiveStore;return _react2.default.createElement(OdocModelAndSensitiveCom,{odocModelAndSensitiveStore:odocModelAndSensitiveStore,commonParam:commonParam,odocInfo:odocInfo,tabKey:tabKey});}else{return _react2.default.createElement(_Loading2.default,null);}}}]);return OdocModelAndSensitive;}(_react2.default.Component);exports.default=OdocModelAndSensitive;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _ErrorMsg=__webpack_require__(642);var _ErrorMsg2=_interopRequireDefault(_ErrorMsg);var _ConfirmInfo=__webpack_require__(643);var _ConfirmInfo2=_interopRequireDefault(_ConfirmInfo);var _EditLock=__webpack_require__(644);var _EditLock2=_interopRequireDefault(_EditLock);var _SubmitInfo=__webpack_require__(645);var _SubmitInfo2=_interopRequireDefault(_SubmitInfo);var _RejectInfo=__webpack_require__(646);var _RejectInfo2=_interopRequireDefault(_RejectInfo);var _AgentInfo=__webpack_require__(647);var _AgentInfo2=_interopRequireDefault(_AgentInfo);var _SecondAuthInfo=__webpack_require__(280);var _SecondAuthInfo2=_interopRequireDefault(_SecondAuthInfo);var _SubmitShowInfo=__webpack_require__(648);var _SubmitShowInfo2=_interopRequireDefault(_SubmitShowInfo);var _FreeWorkflowSimpleInfo=__webpack_require__(649);var _FreeWorkflowSimpleInfo2=_interopRequireDefault(_FreeWorkflowSimpleInfo);var _antd=__webpack_require__(87);__webpack_require__(650);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$promptInfos=_props.promptInfos,promptInfos=_props$promptInfos===undefined?[]:_props$promptInfos,secondAuthInfo=_props.secondAuthInfo;var domarr=[];if(secondAuthInfo){domarr.push(_react2.default.createElement(_SecondAuthInfo2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_SecondAuthInfo@gufzb3@c1'},mobx.toJS(secondAuthInfo))));}promptInfos.map(function(item){var prompttype=item.prompttype;prompttype==="errormsg"&&domarr.push(_react2.default.createElement(_ErrorMsg2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_ErrorMsg@w7f7d4@c2'},item)));// prompttype === "confirminfo" && domarr.push(<ConfirmInfo {...item} />);
prompttype==="editlock"&&domarr.push(_react2.default.createElement(_EditLock2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_EditLock@hx8ss9@c3'},item)));prompttype==="submitinfo"&&domarr.push(_react2.default.createElement(_SubmitInfo2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_SubmitInfo@z123uj@c4'},item)));prompttype==="rejectinfo"&&domarr.push(_react2.default.createElement(_RejectInfo2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_RejectInfo@h8irmr@c5'},item)));prompttype==="agentinfo"&&domarr.push(_react2.default.createElement(_AgentInfo2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_AgentInfo@amke2a@c6'},item)));prompttype==="showContent"&&domarr.push(_react2.default.createElement(_SubmitShowInfo2.default,item));prompttype==="freeWorkflowSimpleInfo"&&domarr.push(_react2.default.createElement(_FreeWorkflowSimpleInfo2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_FreeWorkflowSimpleInfo@ugnx8b@c7'},item)));});return domarr;}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _secondAuthUtil=__webpack_require__(86);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:'openAuthDetail',value:function openAuthDetail(){(0,_secondAuthUtil.showAuthDialog)(authTypes.AUTH_DETAIL_DIALOG);}},{key:'getMsgContent',value:function getMsgContent(){var msgContent=_react2.default.createElement('span',null);var _props=this.props,msgtype=_props.msgtype,detail=_props.detail;if(msgtype=="0"){msgContent=_react2.default.createElement('span',null,detail);}else if(msgtype=="2"){msgContent=_react2.default.createElement('div',null,_react2.default.createElement('span',null,(0,_convert.getLabel)(514319,"保护数据被篡改"),'\uFF01'),_react2.default.createElement('a',{href:'javascript:void(0);',onClick:this.openAuthDetail},(0,_convert.getLabel)(512307,"查看详情")));}return msgContent;}},{key:'render',value:function render(){var _props2=this.props,msgtype=_props2.msgtype,detail=_props2.detail;if(msgtype!="0"&&msgtype!="2"){return _react2.default.createElement('div',null);}else{return _react2.default.createElement('div',{className:'wf-error-msg'},_react2.default.createElement('div',{className:'wf-error-msg-left'},_react2.default.createElement('i',{className:'icon-coms-Prompt icon-coms02-Warning-01'})),_react2.default.createElement('div',{className:'wf-error-msg-right'},this.getMsgContent()));}}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _NodeInfoContent=__webpack_require__(691);var _NodeInfoContent2=_interopRequireDefault(_NodeInfoContent);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('selectNextFlowStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doCancel=function(){var selectNextFlowStore=_this.props.selectNextFlowStore;selectNextFlowStore.nodeInfoCancelEvent();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var _props=this.props,visible=_props.visible,selectNextFlowStore=_props.selectNextFlowStore;var _selectNextFlowStore$=selectNextFlowStore.baseParams,baseParams=_selectNextFlowStore$===undefined?{}:_selectNextFlowStore$,showNodeInfo=selectNextFlowStore.showNodeInfo;var dialogHeight='500px';return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@hest5d',visible:visible,loadCss:true,initLoadCss:true,title:(0,_convert.getLabel)(390987,'选择下一节点'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:this.doCancel,style:{width:'720px',height:dialogHeight}},_react2.default.createElement(_NodeInfoContent2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_NodeInfoContent@8p636d'},this.props)));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderMarkerComponent = exports.getPropValue = exports.MarkerAllProps = exports.MarkerConfigurableProps = undefined;
var _common = __webpack_require__(69);
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _reactDom = __webpack_require__(48);
var _isFun = __webpack_require__(137);
var _isFun2 = _interopRequireDefault(_isFun);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MarkerConfigurableProps = exports.MarkerConfigurableProps = ['position', 'offset', 'icon', 'content', 'draggable', 'visible', 'zIndex', 'angle', 'animation', 'shadow', 'title', 'clickable', 'extData', 'label'];
var MarkerAllProps = exports.MarkerAllProps = MarkerConfigurableProps.concat(['topWhenClick', 'bubble', 'raiseOnDrag', 'cursor', 'autoRotation', 'shape']);
var getPropValue = exports.getPropValue = function getPropValue(key, value) {
    if (MarkerAllProps.indexOf(key) === -1) {
        return null;
    }
    if (key === 'position') {
        return (0, _common.toLnglat)(value);
    }
    else if (key === 'offset') {
        return (0, _common.toPixel)(value);
    }
    return value;
};
var renderMarkerComponent = exports.renderMarkerComponent = function renderMarkerComponent(component, marker) {
    var child = component;
    if ((0, _isFun2.default)(component)) {
        var extData = marker.getExtData();
        child = component(extData);
    }
    if (child) {
        (0, _reactDom.render)(_react2.default.createElement('div', null, child), marker.getContent());
    }
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _continuationProcessUtil=__webpack_require__(131);var Util=_interopRequireWildcard(_continuationProcessUtil);var _submit=__webpack_require__(57);__webpack_require__(710);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this));_this.switchRequestNeedConfirm=function(type){var existChangeFormDataByUser=_base2.default.layoutStore.existChangeFormDataByUser;var _base$globalStore=_base2.default.globalStore,commonParam=_base$globalStore.commonParam,closeNeedPrompt=_base$globalStore.closeNeedPrompt;var _getAntd=(0,_convert.getAntd)(),Modal=_getAntd.Modal;var _getEcCom=(0,_convert.getEcCom)(),WeaCheckbox=_getEcCom.WeaCheckbox;var that=_this;if(existChangeFormDataByUser&&closeNeedPrompt&&commonParam.requestType!==0){Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:_react2.default.createElement('div',null,_react2.default.createElement('div',null,(0,_convert.getLabel)(528822,'流程表单信息已被手动或系统自动修改，确定要离开当前页面吗？')),commonParam.isviewonly==0&&_react2.default.createElement(WeaCheckbox,{id:'saveData',content:(0,_convert.getLabel)(528821,'离开时保存当前数据'),style:{paddingTop:'20px'},value:_this.state.saveData,onChange:function onChange(v){_this.setState({saveData:v});}})),okText:(0,_convert.getLabel)(826,'确定'),cancelText:(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){if(that.state.saveData==1&&commonParam.isviewonly==0){(0,_submit.doSubmitForm)({actiontype:'requestOperation',src:'save',closePage:false,continuationSwitchType:type});}else{Util.switchRequest(type);}},onCancel:function onCancel(){}});}else{Util.switchRequest(type);}};_this.getIframeUrl=function(){var _this$props$location=_this.props.location,location=_this$props$location===undefined?{}:_this$props$location;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var url=query.url;var urlParams='?';(0,_keys2.default)(query).map(function(key){if(key!='url'){urlParams+=key+"="+query[key]+"&";}});if(urlParams.length>1){urlParams=urlParams.substring(0,urlParams.length-1);}return url+urlParams;};_this.state={continuationProcessInfo:{},saveData:1};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var _props$location=this.props.location,location=_props$location===undefined?{}:_props$location;var _location$query2=location.query,query=_location$query2===undefined?{}:_location$query2;//单页进来，从query中取数据
if(query.isSingle){var newContinuationProcessInfo={isSingle:'1',currentIndex:query.currentIndex,counts:query.counts,requestId:query.requestId};_base2.default.globalStore.continuationProcessInfo=newContinuationProcessInfo;this.setState({continuationProcessInfo:newContinuationProcessInfo});}}},{key:'render',value:function render(){var _this2=this;var _props$location2=this.props.location,location=_props$location2===undefined?{}:_props$location2;var _location$query3=location.query,query=_location$query3===undefined?{}:_location$query3;var continuationProcessInfo=query.isSingle?this.state.continuationProcessInfo:this.props.continuationProcessInfo;var _continuationProcessI=continuationProcessInfo.currentIndex,currentIndex=_continuationProcessI===undefined?0:_continuationProcessI,_continuationProcessI2=continuationProcessInfo.counts,counts=_continuationProcessI2===undefined?0:_continuationProcessI2;var spanLabel=(0,_convert.getLabel)(517273,'第{current}条（共{counts}条）');spanLabel=spanLabel.replace(/{current}/,parseInt(currentIndex)+1);spanLabel=spanLabel.replace(/{counts}/,counts);return _react2.default.createElement('div',{className:'wf-continuationProcess-div'},_react2.default.createElement('div',{className:'wf-continuationProcess-title'},_react2.default.createElement('span',null,spanLabel),_react2.default.createElement('div',{className:'wf-continuationProcess-title-pageSwitch'},_react2.default.createElement('span',{className:currentIndex!=0?'icon-coms02-backward first':'icon-coms02-backward first disabled',onClick:function onClick(){currentIndex!=0&&_this2.switchRequestNeedConfirm('first');}}),_react2.default.createElement('span',{className:currentIndex!=0?'prePage':'pre-disabled',onClick:function onClick(){currentIndex!=0&&_this2.switchRequestNeedConfirm('pre');}},(0,_convert.getLabel)(515115,'上一条')),_react2.default.createElement('span',{className:currentIndex!=counts-1?'nextPage':'disabled',onClick:function onClick(){currentIndex!=counts-1&&_this2.switchRequestNeedConfirm('next');}},(0,_convert.getLabel)(515116,'下一条')),_react2.default.createElement('span',{className:currentIndex!=counts-1?'icon-coms02-Forward-1 last':'icon-coms02-Forward-1 last disabled',onClick:function onClick(){currentIndex!=counts-1&&_this2.switchRequestNeedConfirm('last');}}))),query.isSingle&&_react2.default.createElement('iframe',{className:'wf-continuationProcess-iframe',src:this.getIframeUrl()}));}// 连续处理切换流程（需确认）
}]);return Main;}(_react2.default.Component))||_class;exports.default=Main;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _toConsumableArray2=__webpack_require__(82);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(87);var _ecCom=__webpack_require__(51);var _Panel=__webpack_require__(653);var _Panel2=_interopRequireDefault(_Panel);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Cell=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Cell,_React$Component);function Cell(){(0,_classCallCheck3.default)(this,Cell);return(0,_possibleConstructorReturn3.default)(this,(Cell.__proto__||(0,_getPrototypeOf2.default)(Cell)).apply(this,arguments));}(0,_createClass3.default)(Cell,[{key:'componentDidMount',value:function componentDidMount(){this.adjustWrapHeight();this.adjustWrapWidth();if(window.location.href.indexOf('isFromMobile')>-1&&window.parent&&window.parent.cancelLodingMask){window.parent.cancelLodingMask('none');}}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.adjustWrapWidth();this.adjustWrapHeight();}//移动端调整外层包裹元素的高度，防止出现背景空白的情况
},{key:'adjustWrapHeight',value:function adjustWrapHeight(){var _props=this.props,islastArr=_props.islastArr,wrapBoxCount=_props.wrapBoxCount;if(window.location.href.indexOf('isFromMobile')>-1&&islastArr){var wrapBoxHeight=(wrapBoxCount-1)*147+72;var container=document.getElementById('container');var containerHeight=container.offsetHeight;var wrapBox=document.getElementById('smartGuessPicBox');var parentDiv=wrapBox.parentNode.parentNode;parentDiv.onscroll=function(){var obj=document.getElementById('wfFrontOperator-container');if(obj){obj.style.visibility='hidden';}};if(containerHeight>wrapBoxHeight){parentDiv.setAttribute('class','smart-wrap-div');parentDiv.style.overflowY='auto';parentDiv.style.backgroundColor='#f4f4f4';wrapBox.style.height=containerHeight+10+'px';}else{parentDiv.setAttribute('class','smart-wrap-div');parentDiv.style.overflowY='auto';parentDiv.style.backgroundColor='#f4f4f4';wrapBox.style.height=wrapBoxHeight+10+'px';}}}//pc端调整外层包裹元素的宽度，不让智能预测图样式跑飞
},{key:'adjustWrapWidth',value:function adjustWrapWidth(){var islastArr=this.props.islastArr;var _props2=this.props,cellCount=_props2.cellCount,_props2$smartGuessSto=_props2.smartGuessStore,smartGuessStatus=_props2$smartGuessSto.smartGuessStatus,allMapshow=_props2$smartGuessSto.allMapshow;var screenWidth=document.body.clientWidth;var wfMapContainer=document.getElementById('smartGuessPicBox');var objWidth=cellCount*156+(cellCount-1)*75+40;var header=document.getElementsByClassName('wf-map-header')[0];var smartMapWrap=document.getElementById('smart-map-wrap');if(header&&smartMapWrap){var a=header.offsetHeight+30;var b='calc(100% - '+a+'px)';smartMapWrap.style.height=b;smartMapWrap.style.overflow='auto';}if(wfMapContainer.offsetWidth!=objWidth&&smartGuessStatus&&!allMapshow){//防止包裹元素相同宽度重复触发宽高设置
wfMapContainer.style.width=objWidth+'px';wfMapContainer.style.minWidth=objWidth+'px';wfMapContainer.style.marginLeft='60px';}if(window.location.href.indexOf('isFromMobile')>-1&&islastArr){wfMapContainer.style.width=objWidth+'px';wfMapContainer.style.minWidth=objWidth+'px';if(screenWidth>400){wfMapContainer.style.marginLeft='40px';}}}//选择框选项选择具体项
},{key:'optionItemClick',value:function optionItemClick(obj,index){var smartGuessStore=this.props.smartGuessStore;var setOptionItem=smartGuessStore.setOptionItem,setLoadingWrap=smartGuessStore.setLoadingWrap;if(window.parent.cancelLodingMask){window.parent.cancelLodingMask('flex',true);setOptionItem(obj,index,window.parent.cancelLodingMask.bind(this,'none'));}else{setLoadingWrap(true);setOptionItem(obj,index);}}//设置下拉选项
},{key:'setOptions',value:function setOptions(that,num,obj){var _this2=this;var smartGuessStore=this.props.smartGuessStore;var setLoadingWrap=smartGuessStore.setLoadingWrap;var arr=[];for(var i=1;i<=num;i++){var spanLabel=getLabel(528194,'第{num}条');spanLabel=spanLabel.replace(/{num}/,i);var _obj={key:i+'',selected:false,showname:spanLabel};arr.push(_obj);}return arr.map(function(item,index){return _react2.default.createElement('li',{key:'option'+index,onClick:that.optionItemClick.bind(_this2,obj,index)},item.showname);});}//设置弹出的操作者信息面板
},{key:'setinfoPanel',value:function setinfoPanel(info,e){var screenWidth=document.body.clientWidth;var _props$smartGuessStor=this.props.smartGuessStore,getOperator=_props$smartGuessStor.getOperator,clearOperatorArr=_props$smartGuessStor.clearOperatorArr,setHiddenSelectPanel=_props$smartGuessStor.setHiddenSelectPanel;var isFromMobile=false;if(window.location.href.indexOf('isFromMobile')>-1){isFromMobile=true;}clearOperatorArr();setHiddenSelectPanel();if(info.nodeOperatorName==''){return;}var isGroup=info.nodeOperatorName&&info.nodeOperatorName.slice(0,1);if(isGroup!='1'){//未流经的节点不需要请求接口
getOperator(info.nodeid,{cnodeid:info.nodeid,nodeType:info.nodeType});}e.stopPropagation();var props=info||{};var obj=null;if(!document.getElementById('wfFrontOperator-container')){obj=document.createElement('div');obj.setAttribute('id','wfFrontOperator-container');document.body.appendChild(obj);}else{obj=document.getElementById('wfFrontOperator-container');obj.style.visibility='visible';}if(isGroup=='1'){ReactDOM.render(_react2.default.createElement(_Panel2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Panel@99moe8',clickposX:e.pageX,clickposY:e.pageY,isForOperator:true,info:props,isGroup:true,setoperator:this.setoperator,isFromMobile:isFromMobile,store:this.props.smartGuessStore}),obj);}else{ReactDOM.render(_react2.default.createElement(_Panel2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Panel@mmbz0m',clickposX:e.pageX,clickposY:e.pageY,isForOperator:true,info:props,isGroup:false,isFromMobile:isFromMobile,setoperator:this.setoperator,store:this.props.smartGuessStore}),obj);}}//分叉节点，查看其他分支
},{key:'checkClick',value:function checkClick(data,e){var smartGuessStore=this.props.smartGuessStore;var setShowSelectPanel=smartGuessStore.setShowSelectPanel,isloading=smartGuessStore.isloading;var obj=document.getElementById('wfFrontOperator-container');e.stopPropagation();setShowSelectPanel(data.nodeRemark);if(obj){obj.style.visibility='hidden';}}},{key:'getIcon',value:function getIcon(item){if(item.nodeattribute=='1'){return _react2.default.createElement('i',{className:'icon-coms02-coms-right-branch'});}if(item.nodeattribute>='3'){return _react2.default.createElement('i',{className:'icon-coms02-coms-left-branch'});}if(item.ntype=='0'){return _react2.default.createElement('i',{className:'icon-coms-organization-right',style:{fontSize:'20px'}});}if(item.ntype=='1'){return _react2.default.createElement('i',{className:'icon-coms02-coms-node'});}if(item.ntype=='2'){return _react2.default.createElement('i',{className:'icon-coms-Update-synchronization',style:{fontSize:'15px'}});}if(item.ntype=='3'){return _react2.default.createElement('i',{className:'icon-coms-Tile-o'});}if(item.ntype=='5'){//等待
return _react2.default.createElement('i',{className:'Icon-coms03-Robot-node'});}if(item.ntype=='6'){return _react2.default.createElement('i',{className:'icon-coms02-coms-node'});}}//画矩形
},{key:'drawRectangel',value:function drawRectangel(item,showStatus,checkItem){var _this3=this;var _props3=this.props,isFromMobile=_props3.isFromMobile,smartGuessStore=_props3.smartGuessStore;var isEnd=smartGuessStore.isEnd;var spanLabel=getLabel(528191,'共{branchnumber}条分支，当前第{totalnum}条');spanLabel=spanLabel.toLowerCase();spanLabel=spanLabel.replace(/{branchnumber}/,parseInt(item.branchNumber));spanLabel=spanLabel.replace(/{totalnum}/,checkItem);switch(item.nodeid){case-1:{return _react2.default.createElement('div',{className:'rectangle',style:{border:'1px solid '+item.strokeColor}},_react2.default.createElement('div',{className:'content-wrap'},_react2.default.createElement('div',{className:'area left-area',style:{backgroundColor:item.nodeColor,borderRight:'1px solid '+item.strokeColor}},_react2.default.createElement('img',{src:(window.ecologyContentPath||'')+'/images/ecology9/workflow/loading.gif'})),_react2.default.createElement('div',{className:'area right-area loading-word'},_react2.default.createElement('div',{className:'info-content'},_react2.default.createElement('span',null,getLabel(513959,'智能预测中'))))));}break;case-2:{return _react2.default.createElement('div',{className:'rectangle  unKnownNode'},_react2.default.createElement('span',null),_react2.default.createElement('span',null),_react2.default.createElement('span',null));}break;default:{return _react2.default.createElement('div',{className:'rectangle',style:{border:'1px solid '+item.strokeColor}},_react2.default.createElement('div',{className:'content-wrap',onClick:function onClick(event){_this3.setinfoPanel(item,event);}},_react2.default.createElement('div',{className:'area left-area',style:{backgroundColor:item.nodeColor,borderRight:'1px solid '+item.strokeColor}},this.getIcon(item)),_react2.default.createElement('div',{className:'area right-area'},_react2.default.createElement('div',{className:'info-content'},_react2.default.createElement('span',{title:item.nodeName},item.nodeName),item.ntype!='5'&&item.ntype!='6'&&_react2.default.createElement('span',{title:this.setoperator(item.nodeOperatorName)},this.setoperator(item.nodeOperatorName)),item.ntype=='5'&&_react2.default.createElement('i',{className:'icon-coms-overtime icon-span'}),item.ntype=='6'&&_react2.default.createElement('i',{className:'Icon-coms03-Release-preparation icon-span'})))),isEnd&&item.branchNumber>1&&_react2.default.createElement('div',{className:'select-node '+isFromMobile},_react2.default.createElement('span',{className:'current-wf',title:spanLabel},spanLabel),_react2.default.createElement('a',{className:'check-others',onClick:function onClick(event){_this3.checkClick(item,event);}},getLabel(528167,'查看其他分支')),_react2.default.createElement('div',{className:showStatus?'select-box show-panel':'select-box'},_react2.default.createElement('ul',{className:'select-content'},this.setOptions(this,item.branchNumber,item)))));}}}//获取出口线条的颜色
},{key:'getLinkColor',value:function getLinkColor(obj){var _props$smartGuessStor2=this.props.smartGuessStore.data,forecastLinkColor=_props$smartGuessStor2.forecastLinkColor,passedLinkColor=_props$smartGuessStor2.passedLinkColor;switch(obj.nodeType){case 0:{return passedLinkColor;};break;//已经流转过的节点
default:{return forecastLinkColor;//预测节点
}}}//画流向箭头
},{key:'drawFlowPoint',value:function drawFlowPoint(obj,index,arrLength,color){var _props4=this.props,arrowPoint=_props4.arrowPoint,arrowTurn=_props4.arrowTurn,islastArr=_props4.islastArr,isFromMobile=_props4.isFromMobile;return _react2.default.createElement(_react2.default.Fragment,{ecId:(this&&this.props&&this.props.ecId||'')+'_undefined@pa0uvw'},index!==arrLength&&_react2.default.createElement('div',{className:'arrow-box  '+isFromMobile},_react2.default.createElement('div',{className:'line',style:{borderBottom:'1px solid '+color}}),_react2.default.createElement('div',{className:'arrow arrow-point-'+arrowPoint},_react2.default.createElement('i',{className:'jiantou icon-coms-organization-right',style:{color:color}}))),index==arrLength&&!islastArr?_react2.default.createElement('div',{className:'arrow-last-box  '+isFromMobile},_react2.default.createElement('div',{className:'turn-arrow arrow-turn-'+arrowTurn,style:{border:'2px solid '+color}},_react2.default.createElement('i',{className:'jiantou icon-coms-organization-right',style:{color:color}}))):null);}//获取操作者面板信息
},{key:'setoperator',value:function setoperator(str){var operatorArr=[];var operator='';if(!str)return' ';if(str.indexOf('->')>-1){// 处理节点被代理的情况
var index=str.indexOf('->');var operatorA=str.slice(0,index);var operatorB=str.slice(index+2);operatorArr=[].concat((0,_toConsumableArray3.default)(operatorArr),[operatorA,operatorB]);}else{operatorArr=[str];}operatorArr.length!==0&&operatorArr.map(function(v,index){var arr=[];arr=v.split('_#WFSPSTR_OPTTP#_');if(index!==operatorArr.length-1){operator+=arr[arr.length-1]+'->';}else{operator+=arr[arr.length-1];}});return operator;}},{key:'render',value:function render(){var _this4=this;var _props5=this.props,_props5$cellInfo=_props5.cellInfo,cellInfo=_props5$cellInfo===undefined?[]:_props5$cellInfo,_props5$prefixCls=_props5.prefixCls,prefixCls=_props5$prefixCls===undefined?'':_props5$prefixCls,isFromMobile=_props5.isFromMobile;var smartGuessStore=this.props.smartGuessStore;var setShowSelectPanel=smartGuessStore.setShowSelectPanel,_smartGuessStore$divi=smartGuessStore.divideNodeArr,divideNodeArr=_smartGuessStore$divi===undefined?[]:_smartGuessStore$divi;return _react2.default.createElement('div',{'class':'outer-wrap-box  '+prefixCls+' '+isFromMobile},cellInfo.map(function(item,index){var showStatus=false,checkItem=1;if((0,_mobx.toJS)(divideNodeArr).length!==0){(0,_mobx.toJS)(divideNodeArr).filter(function(v){if(v.remark===item.nodeRemark){showStatus=v.showStatus;checkItem=v.checkItem;}});}var showColor=_this4.getLinkColor(item);return _react2.default.createElement(_react2.default.Fragment,{ecId:(_this4&&_this4.props&&_this4.props.ecId||'')+'_undefined@l3241b@'+index},_this4.drawRectangel(item,showStatus,checkItem),_this4.drawFlowPoint(item,index,cellInfo.length-1,showColor));}));}}]);return Cell;}(_react2.default.Component))||_class;exports.default=Cell;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _Cell=__webpack_require__(285);var _Cell2=_interopRequireDefault(_Cell);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _mobxReact=__webpack_require__(8);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=(_dec=(0,_mobxReact.inject)('smartGuessStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Container,_React$Component);function Container(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Container);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Container.__proto__||(0,_getPrototypeOf2.default)(Container)).call.apply(_ref,[this].concat(args))),_this),_this.setPanelVisible=function(){var setHiddenSelectPanel=_this.props.smartGuessStore.setHiddenSelectPanel;setHiddenSelectPanel();var obj=document.getElementById('wfFrontOperator-container');if(obj){obj.style.visibility='hidden';}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Container,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,_props$commonParam=_props.commonParam,commonParam=_props$commonParam===undefined?{}:_props$commonParam,smartGuessStore=_props.smartGuessStore;var getCellArr=smartGuessStore.getCellArr,setState=smartGuessStore.setState,init=smartGuessStore.init;var _props$location=this.props.location,location=_props$location===undefined?{}:_props$location;//处理来自移动端单页访问请求
if(location.query&&(0,_keys2.default)(location.query).length>0&&window.location.href.indexOf('isFromMobile')>-1){var clientWidth=document.body.clientWidth;var callbackFun=window.parent.changeBtnStatus;init(location.query);getCellArr({},callbackFun);setState({clientWidth:clientWidth});}}},{key:'componentDidMount',value:function componentDidMount(){var smartGuessStore=this.props.smartGuessStore;var getCellArr=smartGuessStore.getCellArr,stopResetFlag=smartGuessStore.stopResetFlag,setState=smartGuessStore.setState,getResetForecast=smartGuessStore.getResetForecast;//抛出重新预测方法至全局window
window.getForecast=function(){if(!stopResetFlag){var callbackFun=window.parent&&window.parent.changeBtnStatus||null;getResetForecast(callbackFun);setState({stopResetFlag:true});}};}},{key:'componentDidUpdate',value:function componentDidUpdate(){var smartGuessStore=this.props.smartGuessStore;var getCellArr=smartGuessStore.getCellArr,stopGetArrFlag=smartGuessStore.stopGetArrFlag,isloading=smartGuessStore.isloading;var that=this;if(!isloading&&!stopGetArrFlag){this.Timer=setTimeout(function(){that.Timer&&clearTimeout(that.Timer);that.getArr({});},1000);}}},{key:'getArr',value:function getArr(){var callbackFun=window.parent.changeBtnStatus;var getCellArr=this.props.smartGuessStore.getCellArr;getCellArr({},callbackFun);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var clearStore=this.props.smartGuessStore.clearStore;clearStore();}},{key:'insertCell',value:function insertCell(arr){var _this2=this;var smartGuessStore=this.props.smartGuessStore;var clientWidth=smartGuessStore.clientWidth;var screenWidth=0;if(window.location.href.indexOf('isFromMobile')>-1){//处理智能预测中，移动端智能预测按钮关闭
screenWidth=clientWidth;}else{screenWidth=document.body.clientWidth;}var isFromMobile=false;if(screenWidth<400){isFromMobile=true;}var rowCellCount=Math.floor(screenWidth/(156+76));var maxCellCount=Math.min(rowCellCount,6);//设置每行最多放置6个矩形，也可以不设置最大放置值，随屏幕自适应
var wrapBoxCount=Math.ceil(arr.length/maxCellCount);//将元素节点分组
var cellArr=[],newArr=arr;while(newArr.length>maxCellCount){//由于获取不到屏幕宽度，进入死循环卡死(内存溢出)的问题
var _arr=newArr.slice(0,maxCellCount);newArr.splice(0,maxCellCount);newArr=newArr;cellArr.push(_arr);}cellArr.push(newArr);//移动端与PC端做显示适配
if(!isFromMobile){return cellArr.map(function(item,index){if(index%2==0){if(index!==cellArr.length-1){return _react2.default.createElement(_Cell2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Cell@yn3elt@'+index,isFromMobile:'notFromMobile',smartGuessStore:smartGuessStore,cellCount:maxCellCount,islastArr:false,arrowPoint:'right',arrowTurn:'left',cellInfo:item,prefixCls:'wrap-box-flex-left'});}else{return _react2.default.createElement(_Cell2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Cell@gw3jyj@'+index,isFromMobile:'notFromMobile',smartGuessStore:smartGuessStore,cellCount:maxCellCount,islastArr:true,arrowPoint:'right',cellInfo:item,prefixCls:'wrap-box-flex-left'});}}else{if(index!==cellArr.length-1){return _react2.default.createElement(_Cell2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Cell@5ikwyb@'+index,isFromMobile:'notFromMobile',smartGuessStore:smartGuessStore,cellCount:maxCellCount,islastArr:false,arrowPoint:'left',arrowTurn:'right',cellInfo:item,prefixCls:'wrap-box-flex-right'});}else{return _react2.default.createElement(_Cell2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Cell@kb9qw3@'+index,isFromMobile:'notFromMobile',smartGuessStore:smartGuessStore,cellCount:maxCellCount,islastArr:true,arrowPoint:'left',cellInfo:item,prefixCls:'wrap-box-flex-right'});}}});}else{return cellArr.map(function(item,index){if(index!==cellArr.length-1){return _react2.default.createElement(_Cell2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Cell@rd3y9o@'+index,isFromMobile:'isFromMobile',wrapBoxCount:wrapBoxCount,smartGuessStore:smartGuessStore,cellCount:maxCellCount,islastArr:false,arrowPoint:'down',arrowTurn:'down',cellInfo:item,prefixCls:'wrap-box-flex-down'});}else{return _react2.default.createElement(_Cell2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Cell@ydktcr@'+index,isFromMobile:'isFromMobile',wrapBoxCount:wrapBoxCount,smartGuessStore:smartGuessStore,cellCount:1,islastArr:true,arrowPoint:'down',arrowTurn:'down',cellInfo:item,prefixCls:'wrap-box-flex-down'});}});}}//设置操作者信息面板隐藏
},{key:'render',value:function render(){var smartGuessStore=this.props.smartGuessStore;var smartGuessStatus=smartGuessStore.smartGuessStatus,allMapshow=smartGuessStore.allMapshow,_smartGuessStore$node=smartGuessStore.nodeArr,nodeArr=_smartGuessStore$node===undefined?[]:_smartGuessStore$node;return _react2.default.createElement('div',{id:'smart-map-wrap',onClick:this.setPanelVisible},_react2.default.createElement('div',{id:'smartGuessPicBox',style:{paddingBottom:'10px'}},nodeArr&&nodeArr.length!==0&&this.insertCell((0,_mobx.toJS)(nodeArr))));}}]);return Container;}(_react2.default.Component))||_class)||_class);exports.default=Container;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _Route=__webpack_require__(288);var _Route2=_interopRequireDefault(_Route);var _Home=__webpack_require__(298);var _Home2=_interopRequireDefault(_Home);var _AsyncLoad=__webpack_require__(323);var _AsyncLoad2=_interopRequireDefault(_AsyncLoad);var _ReqNoRight=__webpack_require__(711);var _ReqNoRight2=_interopRequireDefault(_ReqNoRight);var _AsyncLoad3=__webpack_require__(712);var _AsyncLoad4=_interopRequireDefault(_AsyncLoad3);var _AnalyzeAsync=__webpack_require__(716);var _AnalyzeAsync2=_interopRequireDefault(_AnalyzeAsync);var _SmartGuessPic=__webpack_require__(286);var _SmartGuessPic2=_interopRequireDefault(_SmartGuessPic);var _ContinuationProcess=__webpack_require__(284);var _ContinuationProcess2=_interopRequireDefault(_ContinuationProcess);var _index=__webpack_require__(176);var _index2=_interopRequireDefault(_index);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);__webpack_require__(717);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_base2.default.init(_index2.default);__webpack_require__(723);var WorkflowFormRoute=React.createElement(_Route2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@t2zh74',breadcrumbName:'\u6D41\u7A0B\u8868\u5355',path:'workflow',component:_Home2.default},React.createElement(_Route2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@vmt0lk',breadcrumbName:'\u6D41\u7A0B\u8868\u5355\u8BE6\u60C5',path:'req',component:_AsyncLoad2.default}),React.createElement(_Route2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@4puh9a',breadcrumbName:'\u8868\u5355\u65E0\u6743\u9650',path:'reqNoRight',component:_ReqNoRight2.default}),React.createElement(_Route2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@zf1bp2',breadcrumbName:'\u6253\u5370\u8868\u5355',path:'printReq',component:_AsyncLoad4.default}),React.createElement(_Route2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@vtxpfv',breadcrumbName:'\u667A\u80FD\u5206\u6790',path:'analyze',component:_AnalyzeAsync2.default}),React.createElement(_Route2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@w84bkx',breadcrumbName:'\u6D41\u7A0B\u56FE\u667A\u80FD\u9884\u6D4B',path:'smartGuess',component:_SmartGuessPic2.default}),React.createElement(_Route2.default,{breadcrumbName:'\u6D41\u7A0B\u8FDE\u7EED\u5904\u7406',path:'ContinuationProcess',component:_ContinuationProcess2.default}));module.exports={Route:WorkflowFormRoute,store:_index2.default/***** window方法与store通信统一规范 *****/};var doWorkflowFormAction={};window.doWorkflowFormAction=doWorkflowFormAction;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _createReactClass = __webpack_require__(289);
var _createReactClass2 = _interopRequireDefault(_createReactClass);
var _propTypes = __webpack_require__(138);
var _invariant = __webpack_require__(295);
var _invariant2 = _interopRequireDefault(_invariant);
var _RouteUtils = __webpack_require__(296);
var _InternalPropTypes = __webpack_require__(297);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = (0, _createReactClass2.default)({
    displayName: 'Route',
    statics: {
        createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
    },
    propTypes: {
        path: _propTypes.string,
        component: _InternalPropTypes.component,
        components: _InternalPropTypes.components,
        getComponent: _propTypes.func,
        getComponents: _propTypes.func
    },
    /* istanbul ignore next: sanity check */
    render: function render() {
         true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
    }
});
exports.default = Route;
module.exports = exports['default'];


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var React = __webpack_require__(1);
var factory = __webpack_require__(290);
if (typeof React === 'undefined') {
    throw Error('create-react-class could not find the React object. If you are using script tags, ' +
        'make sure that React is being loaded before create-react-class.');
}
// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;
module.exports = factory(React.Component, React.isValidElement, ReactNoopUpdateQueue);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var _assign = __webpack_require__(88);
var emptyObject = __webpack_require__(291);
var _invariant = __webpack_require__(292);
if (false) {
    var warning = require('fbjs/lib/warning');
}
var MIXINS_KEY = 'mixins';
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
    return fn;
}
var ReactPropTypeLocationNames;
if (false) {
    ReactPropTypeLocationNames = {
        prop: 'prop',
        context: 'context',
        childContext: 'child context'
    };
}
else {
    ReactPropTypeLocationNames = {};
}
function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
     * Policies that describe methods in `ReactClassInterface`.
     */
    var injectedMixins = [];
    /**
     * Composite components are higher-level components that compose other composite
     * or host components.
     *
     * To create a new type of `ReactClass`, pass a specification of
     * your new class to `React.createClass`. The only requirement of your class
     * specification is that you implement a `render` method.
     *
     *   var MyComponent = React.createClass({
     *     render: function() {
     *       return <div>Hello World</div>;
     *     }
     *   });
     *
     * The class specification supports a specific protocol of methods that have
     * special meaning (e.g. `render`). See `ReactClassInterface` for
     * more the comprehensive protocol. Any other properties and methods in the
     * class specification will be available on the prototype.
     *
     * @interface ReactClassInterface
     * @internal
     */
    var ReactClassInterface = {
        /**
         * An array of Mixin objects to include when defining your component.
         *
         * @type {array}
         * @optional
         */
        mixins: 'DEFINE_MANY',
        /**
         * An object containing properties and methods that should be defined on
         * the component's constructor instead of its prototype (static methods).
         *
         * @type {object}
         * @optional
         */
        statics: 'DEFINE_MANY',
        /**
         * Definition of prop types for this component.
         *
         * @type {object}
         * @optional
         */
        propTypes: 'DEFINE_MANY',
        /**
         * Definition of context types for this component.
         *
         * @type {object}
         * @optional
         */
        contextTypes: 'DEFINE_MANY',
        /**
         * Definition of context types this component sets for its children.
         *
         * @type {object}
         * @optional
         */
        childContextTypes: 'DEFINE_MANY',
        // ==== Definition methods ====
        /**
         * Invoked when the component is mounted. Values in the mapping will be set on
         * `this.props` if that prop is not specified (i.e. using an `in` check).
         *
         * This method is invoked before `getInitialState` and therefore cannot rely
         * on `this.state` or use `this.setState`.
         *
         * @return {object}
         * @optional
         */
        getDefaultProps: 'DEFINE_MANY_MERGED',
        /**
         * Invoked once before the component is mounted. The return value will be used
         * as the initial value of `this.state`.
         *
         *   getInitialState: function() {
         *     return {
         *       isOn: false,
         *       fooBaz: new BazFoo()
         *     }
         *   }
         *
         * @return {object}
         * @optional
         */
        getInitialState: 'DEFINE_MANY_MERGED',
        /**
         * @return {object}
         * @optional
         */
        getChildContext: 'DEFINE_MANY_MERGED',
        /**
         * Uses props from `this.props` and state from `this.state` to render the
         * structure of the component.
         *
         * No guarantees are made about when or how often this method is invoked, so
         * it must not have side effects.
         *
         *   render: function() {
         *     var name = this.props.name;
         *     return <div>Hello, {name}!</div>;
         *   }
         *
         * @return {ReactComponent}
         * @required
         */
        render: 'DEFINE_ONCE',
        // ==== Delegate methods ====
        /**
         * Invoked when the component is initially created and about to be mounted.
         * This may have side effects, but any external subscriptions or data created
         * by this method must be cleaned up in `componentWillUnmount`.
         *
         * @optional
         */
        componentWillMount: 'DEFINE_MANY',
        /**
         * Invoked when the component has been mounted and has a DOM representation.
         * However, there is no guarantee that the DOM node is in the document.
         *
         * Use this as an opportunity to operate on the DOM when the component has
         * been mounted (initialized and rendered) for the first time.
         *
         * @param {DOMElement} rootNode DOM element representing the component.
         * @optional
         */
        componentDidMount: 'DEFINE_MANY',
        /**
         * Invoked before the component receives new props.
         *
         * Use this as an opportunity to react to a prop transition by updating the
         * state using `this.setState`. Current props are accessed via `this.props`.
         *
         *   componentWillReceiveProps: function(nextProps, nextContext) {
         *     this.setState({
         *       likesIncreasing: nextProps.likeCount > this.props.likeCount
         *     });
         *   }
         *
         * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
         * transition may cause a state change, but the opposite is not true. If you
         * need it, you are probably looking for `componentWillUpdate`.
         *
         * @param {object} nextProps
         * @optional
         */
        componentWillReceiveProps: 'DEFINE_MANY',
        /**
         * Invoked while deciding if the component should be updated as a result of
         * receiving new props, state and/or context.
         *
         * Use this as an opportunity to `return false` when you're certain that the
         * transition to the new props/state/context will not require a component
         * update.
         *
         *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
         *     return !equal(nextProps, this.props) ||
         *       !equal(nextState, this.state) ||
         *       !equal(nextContext, this.context);
         *   }
         *
         * @param {object} nextProps
         * @param {?object} nextState
         * @param {?object} nextContext
         * @return {boolean} True if the component should update.
         * @optional
         */
        shouldComponentUpdate: 'DEFINE_ONCE',
        /**
         * Invoked when the component is about to update due to a transition from
         * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
         * and `nextContext`.
         *
         * Use this as an opportunity to perform preparation before an update occurs.
         *
         * NOTE: You **cannot** use `this.setState()` in this method.
         *
         * @param {object} nextProps
         * @param {?object} nextState
         * @param {?object} nextContext
         * @param {ReactReconcileTransaction} transaction
         * @optional
         */
        componentWillUpdate: 'DEFINE_MANY',
        /**
         * Invoked when the component's DOM representation has been updated.
         *
         * Use this as an opportunity to operate on the DOM when the component has
         * been updated.
         *
         * @param {object} prevProps
         * @param {?object} prevState
         * @param {?object} prevContext
         * @param {DOMElement} rootNode DOM element representing the component.
         * @optional
         */
        componentDidUpdate: 'DEFINE_MANY',
        /**
         * Invoked when the component is about to be removed from its parent and have
         * its DOM representation destroyed.
         *
         * Use this as an opportunity to deallocate any external resources.
         *
         * NOTE: There is no `componentDidUnmount` since your component will have been
         * destroyed by that point.
         *
         * @optional
         */
        componentWillUnmount: 'DEFINE_MANY',
        /**
         * Replacement for (deprecated) `componentWillMount`.
         *
         * @optional
         */
        UNSAFE_componentWillMount: 'DEFINE_MANY',
        /**
         * Replacement for (deprecated) `componentWillReceiveProps`.
         *
         * @optional
         */
        UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
        /**
         * Replacement for (deprecated) `componentWillUpdate`.
         *
         * @optional
         */
        UNSAFE_componentWillUpdate: 'DEFINE_MANY',
        // ==== Advanced methods ====
        /**
         * Updates the component's currently mounted DOM representation.
         *
         * By default, this implements React's rendering and reconciliation algorithm.
         * Sophisticated clients may wish to override this.
         *
         * @param {ReactReconcileTransaction} transaction
         * @internal
         * @overridable
         */
        updateComponent: 'OVERRIDE_BASE'
    };
    /**
     * Similar to ReactClassInterface but for static methods.
     */
    var ReactClassStaticInterface = {
        /**
         * This method is invoked after a component is instantiated and when it
         * receives new props. Return an object to update state in response to
         * prop changes. Return null to indicate no change to state.
         *
         * If an object is returned, its keys will be merged into the existing state.
         *
         * @return {object || null}
         * @optional
         */
        getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
    };
    /**
     * Mapping from class specification keys to special processing functions.
     *
     * Although these are declared like instance properties in the specification
     * when defining classes using `React.createClass`, they are actually static
     * and are accessible on the constructor instead of the prototype. Despite
     * being static, they must be defined outside of the "statics" key under
     * which all other static methods are defined.
     */
    var RESERVED_SPEC_KEYS = {
        displayName: function (Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function (Constructor, mixins) {
            if (mixins) {
                for (var i = 0; i < mixins.length; i++) {
                    mixSpecIntoComponent(Constructor, mixins[i]);
                }
            }
        },
        childContextTypes: function (Constructor, childContextTypes) {
            if (false) {
                validateTypeDef(Constructor, childContextTypes, 'childContext');
            }
            Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function (Constructor, contextTypes) {
            if (false) {
                validateTypeDef(Constructor, contextTypes, 'context');
            }
            Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
        },
        /**
         * Special case getDefaultProps which should move into statics but requires
         * automatic merging.
         */
        getDefaultProps: function (Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) {
                Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            }
            else {
                Constructor.getDefaultProps = getDefaultProps;
            }
        },
        propTypes: function (Constructor, propTypes) {
            if (false) {
                validateTypeDef(Constructor, propTypes, 'prop');
            }
            Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
        },
        statics: function (Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function () { }
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for (var propName in typeDef) {
            if (typeDef.hasOwnProperty(propName)) {
                // use a warning instead of an _invariant so components
                // don't show up in prod but only in __DEV__
                if (false) {
                    warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' +
                        'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
                }
            }
        }
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name)
            ? ReactClassInterface[name]
            : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) {
            _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' +
                '`%s` from your class specification. Ensure that your method names ' +
                'do not overlap with React methods.', name);
        }
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) {
            _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' +
                '`%s` on your component more than once. This conflict may be due ' +
                'to a mixin.', name);
        }
    }
    /**
     * Mixin helper which handles policy validation and reserved
     * specification keys when building React classes.
     */
    function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            if (false) {
                var typeofSpec = typeof spec;
                var isMixinValid = typeofSpec === 'object' && spec !== null;
                if (process.env.NODE_ENV !== 'production') {
                    warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " +
                        'or not an object. Check the mixins included by the component, ' +
                        'as well as any mixins they include themselves. ' +
                        'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
                }
            }
            return;
        }
        _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " +
            'use a component class or function as a mixin. Instead, just use a ' +
            'regular object.');
        _invariant(!isValidElement(spec), "ReactClass: You're attempting to " +
            'use a component as a mixin. Instead, just use a regular object.');
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty(MIXINS_KEY)) {
            RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        }
        for (var name in spec) {
            if (!spec.hasOwnProperty(name)) {
                continue;
            }
            if (name === MIXINS_KEY) {
                // We have already handled mixins in a special case above.
                continue;
            }
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
                RESERVED_SPEC_KEYS[name](Constructor, property);
            }
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === 'function';
                var shouldAutoBind = isFunction &&
                    !isReactClassMethod &&
                    !isAlreadyDefined &&
                    spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                }
                else {
                    if (isAlreadyDefined) {
                        var specPolicy = ReactClassInterface[name];
                        // These cases should already be caught by validateMethodOverride.
                        _invariant(isReactClassMethod &&
                            (specPolicy === 'DEFINE_MANY_MERGED' ||
                                specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' +
                            'when mixing in component specs.', specPolicy, name);
                        // For methods which are defined more than once, call the existing
                        // methods before calling the new property, merging if appropriate.
                        if (specPolicy === 'DEFINE_MANY_MERGED') {
                            proto[name] = createMergedResultFunction(proto[name], property);
                        }
                        else if (specPolicy === 'DEFINE_MANY') {
                            proto[name] = createChainedFunction(proto[name], property);
                        }
                    }
                    else {
                        proto[name] = property;
                        if (false) {
                            // Add verbose displayName to the function, which helps when looking
                            // at profiling tools.
                            if (typeof property === 'function' && spec.displayName) {
                                proto[name].displayName = spec.displayName + '_' + name;
                            }
                        }
                    }
                }
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) {
            return;
        }
        for (var name in statics) {
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) {
                continue;
            }
            var isReserved = name in RESERVED_SPEC_KEYS;
            _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' +
                'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
                'as an instance property instead; it will still be accessible on the ' +
                'constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
                    ? ReactClassStaticInterface[name]
                    : null;
                _invariant(specPolicy === 'DEFINE_MANY_MERGED', 'ReactClass: You are attempting to define ' +
                    '`%s` on your component more than once. This conflict may be ' +
                    'due to a mixin.', name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
     * Merge two objects, but throw if both contain the same key.
     *
     * @param {object} one The first object, which is mutated.
     * @param {object} two The second object
     * @return {object} one after it has been mutated to contain everything in two.
     */
    function mergeIntoWithNoDuplicateKeys(one, two) {
        _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
        for (var key in two) {
            if (two.hasOwnProperty(key)) {
                _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' +
                    'Tried to merge two objects with the same key: `%s`. This conflict ' +
                    'may be due to a mixin; in particular, this may be caused by two ' +
                    'getInitialState() or getDefaultProps() methods returning objects ' +
                    'with clashing keys.', key);
                one[key] = two[key];
            }
        }
        return one;
    }
    /**
     * Creates a function that invokes two functions and merges their return values.
     *
     * @param {function} one Function to invoke first.
     * @param {function} two Function to invoke second.
     * @return {function} Function that invokes the two argument functions.
     * @private
     */
    function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) {
                return b;
            }
            else if (b == null) {
                return a;
            }
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
     * Creates a function that invokes two functions and ignores their return vales.
     *
     * @param {function} one Function to invoke first.
     * @param {function} two Function to invoke second.
     * @return {function} Function that invokes the two argument functions.
     * @private
     */
    function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
     * Binds a method to the component.
     *
     * @param {object} component Component whose method is going to be bound.
     * @param {function} method Method to be bound.
     * @return {function} The bound method.
     */
    function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        if (false) {
            boundMethod.__reactBoundContext = component;
            boundMethod.__reactBoundMethod = method;
            boundMethod.__reactBoundArguments = null;
            var componentName = component.constructor.displayName;
            var _bind = boundMethod.bind;
            boundMethod.bind = function (newThis) {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }
                // User is trying to bind() an autobound method; we effectively will
                // ignore the value of "this" that the user is trying to use, so
                // let's warn.
                if (newThis !== component && newThis !== null) {
                    if (process.env.NODE_ENV !== 'production') {
                        warning(false, 'bind(): React component methods may only be bound to the ' +
                            'component instance. See %s', componentName);
                    }
                }
                else if (!args.length) {
                    if (process.env.NODE_ENV !== 'production') {
                        warning(false, 'bind(): You are binding a component method to the component. ' +
                            'React does this for you automatically in a high-performance ' +
                            'way, so you can safely remove this call. See %s', componentName);
                    }
                    return boundMethod;
                }
                var reboundMethod = _bind.apply(boundMethod, arguments);
                reboundMethod.__reactBoundContext = component;
                reboundMethod.__reactBoundMethod = method;
                reboundMethod.__reactBoundArguments = args;
                return reboundMethod;
            };
        }
        return boundMethod;
    }
    /**
     * Binds all auto-bound methods in a component.
     *
     * @param {object} component Component whose method is going to be bound.
     */
    function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for (var i = 0; i < pairs.length; i += 2) {
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function () {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function () {
            this.__isMounted = false;
        }
    };
    /**
     * Add more to the ReactClass base class. These are all legacy features and
     * therefore not already part of the modern ReactComponent.
     */
    var ReactClassMixin = {
        /**
         * TODO: This will be deprecated because state should always keep a consistent
         * type signature and the only use case for this, is to avoid that.
         */
        replaceState: function (newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
         * Checks whether or not this composite component is mounted.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function () {
            if (false) {
                warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' +
                    'subscriptions and pending requests in componentWillUnmount to ' +
                    'prevent memory leaks.', (this.constructor && this.constructor.displayName) ||
                    this.name ||
                    'Component');
                this.__didWarnIsMounted = true;
            }
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function () { };
    _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
     * Creates a composite component class given a class specification.
     * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
     *
     * @param {object} spec Class specification (which must define `render`).
     * @return {function} Component constructor function.
     * @public
     */
    function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = identity(function (props, context, updater) {
            // This constructor gets overridden by mocks. The argument is used
            // by mocks to assert on what gets mounted.
            if (false) {
                warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' +
                    'JSX instead. See: https://fb.me/react-legacyfactory');
            }
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) {
                bindAutoBindMethods(this);
            }
            this.props = props;
            this.context = context;
            this.refs = emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            if (false) {
                // We allow auto-mocks to proceed as if they're returning null.
                if (initialState === undefined &&
                    this.getInitialState._isMockFunction) {
                    // This is probably bad practice. Consider warning here and
                    // deprecating this convenience.
                    initialState = null;
                }
            }
            _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) {
            Constructor.defaultProps = Constructor.getDefaultProps();
        }
        if (false) {
            // This is a tag to indicate that the use of these method names is ok,
            // since it's used with createClass. If it's not, then it's likely a
            // mistake so we'll warn you to use the static property, property
            // initializer or constructor respectively.
            if (Constructor.getDefaultProps) {
                Constructor.getDefaultProps.isReactClassApproved = {};
            }
            if (Constructor.prototype.getInitialState) {
                Constructor.prototype.getInitialState.isReactClassApproved = {};
            }
        }
        _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
        if (false) {
            warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' +
                'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
                'The name is phrased as a question because the function is ' +
                'expected to return a value.', spec.displayName || 'A component');
            warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' +
                'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
            warning(!Constructor.prototype.UNSAFE_componentWillRecieveProps, '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
                'Did you mean UNSAFE_componentWillReceiveProps()?', spec.displayName || 'A component');
        }
        // Reduce time spent doing lookups by setting these on the prototype.
        for (var methodName in ReactClassInterface) {
            if (!Constructor.prototype[methodName]) {
                Constructor.prototype[methodName] = null;
            }
        }
        return Constructor;
    }
    return createClass;
}
module.exports = factory;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var emptyObject = {};
if (false) {
    Object.freeze(emptyObject);
}
module.exports = emptyObject;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
var validateFormat = function validateFormat(format) { };
if (false) {
    validateFormat = function validateFormat(format) {
        if (format === undefined) {
            throw new Error('invariant requires an error message argument');
        }
    };
}
function invariant(condition, format, a, b, c, d, e, f) {
    validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        }
        else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
module.exports = invariant;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = __webpack_require__(294);
function emptyFunction() { }
function emptyFunctionWithReset() { }
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
            // It is still safe when called from React.
            return;
        }
        var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use PropTypes.checkPropTypes() to call them. ' +
            'Read more at http://fb.me/use-check-prop-types');
        err.name = 'Invariant Violation';
        throw err;
    }
    ;
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    ;
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
var invariant = function (condition, format, a, b, c, d, e, f) {
    if (false) {
        if (format === undefined) {
            throw new Error('invariant requires an error message argument');
        }
    }
    if (!condition) {
        var error;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' +
                'for the full error message and additional helpful warnings.');
        }
        else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () { return args[argIndex++]; }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; };
exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function isValidChild(object) {
    return object == null || _react2.default.isValidElement(object);
}
function isReactChildren(object) {
    return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}
function createRoute(defaultProps, props) {
    return _extends({}, defaultProps, props);
}
function createRouteFromReactElement(element) {
    var type = element.type;
    var route = createRoute(type.defaultProps, element.props);
    if (route.children) {
        var childRoutes = createRoutesFromReactChildren(route.children, route);
        if (childRoutes.length)
            route.childRoutes = childRoutes;
        delete route.children;
    }
    return route;
}
/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
    var routes = [];
    _react2.default.Children.forEach(children, function (element) {
        if (_react2.default.isValidElement(element)) {
            // Component classes may have a static create* method.
            if (element.type.createRouteFromReactElement) {
                var route = element.type.createRouteFromReactElement(element, parentRoute);
                if (route)
                    routes.push(route);
            }
            else {
                routes.push(createRouteFromReactElement(element));
            }
        }
    });
    return routes;
}
/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
    if (isReactChildren(routes)) {
        routes = createRoutesFromReactChildren(routes);
    }
    else if (routes && !Array.isArray(routes)) {
        routes = [routes];
    }
    return routes;
}


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;
var _propTypes = __webpack_require__(138);
function falsy(props, propName, componentName) {
    if (props[propName])
        return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}
var history = exports.history = (0, _propTypes.shape)({
    listen: _propTypes.func.isRequired,
    push: _propTypes.func.isRequired,
    replace: _propTypes.func.isRequired,
    go: _propTypes.func.isRequired,
    goBack: _propTypes.func.isRequired,
    goForward: _propTypes.func.isRequired
});
var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Home=function(_React$Component){(0,_inherits3.default)(Home,_React$Component);function Home(){(0,_classCallCheck3.default)(this,Home);var _this=(0,_possibleConstructorReturn3.default)(this,(Home.__proto__||(0,_getPrototypeOf2.default)(Home)).call(this));_this.state={loadedLocaleProvider:false};return _this;}(0,_createClass3.default)(Home,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;var _getEcCom=(0,_convert.getEcCom)(),WeaLocaleProvider=_getEcCom.WeaLocaleProvider;WeaLocaleProvider.getLocaleLabel("workflowForm",null,null,function(){_this2.setState({loadedLocaleProvider:true});});}},{key:"render",value:function render(){var _getEcCom2=(0,_convert.getEcCom)(),WeaLocaleProvider=_getEcCom2.WeaLocaleProvider;var loadedLocaleProvider=this.state.loadedLocaleProvider;return React.createElement("div",{style:{height:"100%"}},loadedLocaleProvider&&React.createElement(WeaLocaleProvider,{ecId:(this&&this.props&&this.props.ecId||'')+"_WeaLocaleProvider@uf3vn2"},this.props.children));}}]);return Home;}(React.Component);exports.default=Home;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(300);
module.exports = __webpack_require__(13).Object.getPrototypeOf;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(46);
var $getPrototypeOf = __webpack_require__(191);
__webpack_require__(139)('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
        return $getPrototypeOf(toObject(it));
    };
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302);
var $Object = __webpack_require__(13).Object;
module.exports = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(21);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperty: __webpack_require__(32).f });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(304), __esModule: true };


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
__webpack_require__(96);
module.exports = __webpack_require__(143).f('iterator');


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var defined = __webpack_require__(70);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
    return function (that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l)
            return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
            ? TO_STRING ? s.charAt(i) : a
            : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(106);
var descriptor = __webpack_require__(62);
var setToStringTag = __webpack_require__(95);
var IteratorPrototype = {};
// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(42)(IteratorPrototype, __webpack_require__(31)('iterator'), function () { return this; });
module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
    setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var anObject = __webpack_require__(34);
var getKeys = __webpack_require__(52);
module.exports = __webpack_require__(23) ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while (length > i)
        dP.f(O, P = keys[i++], Properties[P]);
    return O;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(309);
var step = __webpack_require__(194);
var Iterators = __webpack_require__(93);
var toIObject = __webpack_require__(38);
// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(140)(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
    // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
    }
    if (kind == 'keys')
        return step(0, index);
    if (kind == 'values')
        return step(0, O[index]);
    return step(0, [index, O[index]]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = function () { };


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(311), __esModule: true };


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(312);
__webpack_require__(108);
__webpack_require__(315);
__webpack_require__(316);
module.exports = __webpack_require__(13).Symbol;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(20);
var has = __webpack_require__(41);
var DESCRIPTORS = __webpack_require__(23);
var $export = __webpack_require__(21);
var redefine = __webpack_require__(192);
var META = __webpack_require__(144).KEY;
var $fails = __webpack_require__(37);
var shared = __webpack_require__(90);
var setToStringTag = __webpack_require__(95);
var uid = __webpack_require__(71);
var wks = __webpack_require__(31);
var wksExt = __webpack_require__(143);
var wksDefine = __webpack_require__(145);
var enumKeys = __webpack_require__(313);
var isArray = __webpack_require__(195);
var anObject = __webpack_require__(34);
var isObject = __webpack_require__(28);
var toObject = __webpack_require__(46);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(92);
var createDesc = __webpack_require__(62);
var _create = __webpack_require__(106);
var gOPNExt = __webpack_require__(314);
var $GOPD = __webpack_require__(146);
var $GOPS = __webpack_require__(97);
var $DP = __webpack_require__(32);
var $keys = __webpack_require__(52);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
    return _create(dP({}, 'a', {
        get: function () { return dP(this, 'a', { value: 7 }).a; }
    })).a != 7;
}) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc)
        delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto)
        dP(ObjectProto, key, protoDesc);
} : dP;
var wrap = function (tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
} : function (it) {
    return it instanceof $Symbol;
};
var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto)
        $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);
    if (has(AllSymbols, key)) {
        if (!D.enumerable) {
            if (!has(it, HIDDEN))
                dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
        }
        else {
            if (has(it, HIDDEN) && it[HIDDEN][key])
                it[HIDDEN][key] = false;
            D = _create(D, { enumerable: createDesc(0, false) });
        }
        return setSymbolDesc(it, key, D);
    }
    return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while (l > i)
        $defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))
        return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))
        return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))
        D.enumerable = true;
    return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
        if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)
            result.push(key);
    }
    return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
        if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))
            result.push(AllSymbols[key]);
    }
    return result;
};
// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
    $Symbol = function Symbol() {
        if (this instanceof $Symbol)
            throw TypeError('Symbol is not a constructor!');
        var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function (value) {
            if (this === ObjectProto)
                $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag))
                this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
        };
        if (DESCRIPTORS && setter)
            setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
        return wrap(tag);
    };
    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    __webpack_require__(196).f = gOPNExt.f = $getOwnPropertyNames;
    __webpack_require__(64).f = $propertyIsEnumerable;
    $GOPS.f = $getOwnPropertySymbols;
    if (DESCRIPTORS && !__webpack_require__(60)) {
        redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }
    wksExt.f = function (name) {
        return wrap(wks(name));
    };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
for (var es6Symbols = (
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables').split(','), j = 0; es6Symbols.length > j;)
    wks(es6Symbols[j++]);
for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;)
    wksDefine(wellKnownSymbols[k++]);
$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function (key) {
        return has(SymbolRegistry, key += '')
            ? SymbolRegistry[key]
            : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!isSymbol(sym))
            throw TypeError(sym + ' is not a symbol!');
        for (var key in SymbolRegistry)
            if (SymbolRegistry[key] === sym)
                return key;
    },
    useSetter: function () { setter = true; },
    useSimple: function () { setter = false; }
});
$export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $GOPS.f(toObject(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [it];
        var i = 1;
        var replacer, $replacer;
        while (arguments.length > i)
            args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!isObject(replacer) && it === undefined || isSymbol(it))
            return; // IE8 returns string on undefined
        if (!isArray(replacer))
            replacer = function (key, value) {
                if (typeof $replacer == 'function')
                    value = $replacer.call(this, key, value);
                if (!isSymbol(value))
                    return value;
            };
        args[1] = replacer;
        return _stringify.apply($JSON, args);
    }
});
// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(42)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(52);
var gOPS = __webpack_require__(97);
var pIE = __webpack_require__(64);
module.exports = function (it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = pIE.f;
        var i = 0;
        var key;
        while (symbols.length > i)
            if (isEnum.call(it, key = symbols[i++]))
                result.push(key);
    }
    return result;
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(196).f;
var toString = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function (it) {
    try {
        return gOPN(it);
    }
    catch (e) {
        return windowNames.slice();
    }
};
module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145)('asyncIterator');


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145)('observable');


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(318), __esModule: true };


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(319);
module.exports = __webpack_require__(13).Object.setPrototypeOf;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(21);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(320).set });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(28);
var anObject = __webpack_require__(34);
var check = function (O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null)
        throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
        function (test, buggy, set) {
            try {
                set = __webpack_require__(36)(Function.call, __webpack_require__(146).f(Object.prototype, '__proto__').set, 2);
                set(test, []);
                buggy = !(test instanceof Array);
            }
            catch (e) {
                buggy = true;
            }
            return function setPrototypeOf(O, proto) {
                check(O, proto);
                if (buggy)
                    O.__proto__ = proto;
                else
                    set(O, proto);
                return O;
            };
        }({}, false) : undefined),
    check: check
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(322);
var $Object = __webpack_require__(13).Object;
module.exports = function create(P, D) {
    return $Object.create(P, D);
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(21);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(106) });


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _asyncLoad=__webpack_require__(14);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('globalStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this));}(0,_createClass3.default)(Main,[{key:'componentWillMount',value:function componentWillMount(){window.JS_LOAD_DURATION=window.JS_LOAD_END-window.JS_LOAD_START;//html静态资源耗时
window.Route_DURATION=new Date().getTime()-window.JS_LOAD_END;//中转耗时(路由跳转耗时、多语言加载耗时等)
//发送loadForm异步接口
var _props=this.props,location=_props.location,globalStore=_props.globalStore;var urlParams=location.query||{};globalStore.loadBaseInfo(urlParams);//Chrome下优先加载全量组件库
var calLoadTime=urlParams.calLoadTime||"1";if(globalStore.browserVersion==="Chrome"||globalStore.browserVersion!=="Chrome"&&calLoadTime!=="1")(0,_asyncLoad.loadFullResource)();}},{key:'render',value:function render(){var location=this.props.location||{};var isPrint=location.query&&location.query.isprint=="1";var isPreView=location.query&&location.query.isPreView=="1";var Comp=null;if(isPreView)Comp=__webpack_require__(525).default;else if(isPrint)Comp=__webpack_require__(635).default;else Comp=__webpack_require__(636).default;return _react2.default.createElement(Comp,{ecId:(this&&this.props&&this.props.ecId||'')+'_Comp@upn4fo',location:this.props.location});}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(325);
var $Object = __webpack_require__(13).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(38);
var $getOwnPropertyDescriptor = __webpack_require__(146).f;
__webpack_require__(139)('getOwnPropertyDescriptor', function () {
    return function getOwnPropertyDescriptor(it, key) {
        return $getOwnPropertyDescriptor(toIObject(it), key);
    };
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(72);
__webpack_require__(96);
__webpack_require__(327);
__webpack_require__(331);
__webpack_require__(332);
module.exports = __webpack_require__(13).Promise;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(60);
var global = __webpack_require__(20);
var ctx = __webpack_require__(36);
var classof = __webpack_require__(148);
var $export = __webpack_require__(21);
var isObject = __webpack_require__(28);
var aFunction = __webpack_require__(61);
var anInstance = __webpack_require__(149);
var forOf = __webpack_require__(99);
var speciesConstructor = __webpack_require__(200);
var task = __webpack_require__(201).set;
var microtask = __webpack_require__(329)();
var newPromiseCapabilityModule = __webpack_require__(151);
var perform = __webpack_require__(202);
var userAgent = __webpack_require__(330);
var promiseResolve = __webpack_require__(203);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
var USE_NATIVE = !!function () {
    try {
        // correct subclassing with @@species support
        var promise = $Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[__webpack_require__(31)('species')] = function (exec) {
            exec(empty, empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return (isNode || typeof PromiseRejectionEvent == 'function')
            && promise.then(empty) instanceof FakePromise
            // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
            // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
            // we can't detect it synchronously, so just check versions
            && v8.indexOf('6.6') !== 0
            && userAgent.indexOf('Chrome/66') === -1;
    }
    catch (e) { /* empty */ }
}();
// helpers
var isThenable = function (it) {
    var then;
    return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
    if (promise._n)
        return;
    promise._n = true;
    var chain = promise._c;
    microtask(function () {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function (reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2)
                            onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true)
                        result = value;
                    else {
                        if (domain)
                            domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) {
                        reject(TypeError('Promise-chain cycle'));
                    }
                    else if (then = isThenable(result)) {
                        then.call(result, resolve, reject);
                    }
                    else
                        resolve(result);
                }
                else
                    reject(value);
            }
            catch (e) {
                if (domain && !exited)
                    domain.exit();
                reject(e);
            }
        };
        while (chain.length > i)
            run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h)
            onUnhandled(promise);
    });
};
var onUnhandled = function (promise) {
    task.call(global, function () {
        var value = promise._v;
        var unhandled = isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = perform(function () {
                if (isNode) {
                    process.emit('unhandledRejection', value, promise);
                }
                else if (handler = global.onunhandledrejection) {
                    handler({ promise: promise, reason: value });
                }
                else if ((console = global.console) && console.error) {
                    console.error('Unhandled promise rejection', value);
                }
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e)
            throw result.v;
    });
};
var isUnhandled = function (promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
    task.call(global, function () {
        var handler;
        if (isNode) {
            process.emit('rejectionHandled', promise);
        }
        else if (handler = global.onrejectionhandled) {
            handler({ promise: promise, reason: promise._v });
        }
    });
};
var $reject = function (value) {
    var promise = this;
    if (promise._d)
        return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a)
        promise._a = promise._c.slice();
    notify(promise, true);
};
var $resolve = function (value) {
    var promise = this;
    var then;
    if (promise._d)
        return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value)
            throw TypeError("Promise can't be resolved itself");
        if (then = isThenable(value)) {
            microtask(function () {
                var wrapper = { _w: promise, _d: false }; // wrap
                try {
                    then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
                }
                catch (e) {
                    $reject.call(wrapper, e);
                }
            });
        }
        else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
        }
    }
    catch (e) {
        $reject.call({ _w: promise, _d: false }, e); // wrap
    }
};
// constructor polyfill
if (!USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $Promise = function Promise(executor) {
        anInstance(this, $Promise, PROMISE, '_h');
        aFunction(executor);
        Internal.call(this);
        try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
        }
        catch (err) {
            $reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    Internal.prototype = __webpack_require__(152)($Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = isNode ? process.domain : undefined;
            this._c.push(reaction);
            if (this._a)
                this._a.push(reaction);
            if (this._s)
                notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function (onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    OwnPromiseCapability = function () {
        var promise = new Internal();
        this.promise = promise;
        this.resolve = ctx($resolve, promise, 1);
        this.reject = ctx($reject, promise, 1);
    };
    newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
        return C === $Promise || C === Wrapper
            ? new OwnPromiseCapability(C)
            : newGenericPromiseCapability(C);
    };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(95)($Promise, PROMISE);
__webpack_require__(204)(PROMISE);
Wrapper = __webpack_require__(13)[PROMISE];
// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
    }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(205)(function (iter) {
    $Promise.all(iter)['catch'](empty);
})), PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform(function () {
            var values = [];
            var index = 0;
            var remaining = 1;
            forOf(iterable, false, function (promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                    if (alreadyCalled)
                        return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e)
            reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var reject = capability.reject;
        var result = perform(function () {
            forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e)
            reject(result.v);
        return capability.promise;
    }
});


/***/ }),
/* 328 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
    var un = that === undefined;
    switch (args.length) {
        case 0: return un ? fn()
            : fn.call(that);
        case 1: return un ? fn(args[0])
            : fn.call(that, args[0]);
        case 2: return un ? fn(args[0], args[1])
            : fn.call(that, args[0], args[1]);
        case 3: return un ? fn(args[0], args[1], args[2])
            : fn.call(that, args[0], args[1], args[2]);
        case 4: return un ? fn(args[0], args[1], args[2], args[3])
            : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var macrotask = __webpack_require__(201).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(63)(process) == 'process';
module.exports = function () {
    var head, last, notify;
    var flush = function () {
        var parent, fn;
        if (isNode && (parent = process.domain))
            parent.exit();
        while (head) {
            fn = head.fn;
            head = head.next;
            try {
                fn();
            }
            catch (e) {
                if (head)
                    notify();
                else
                    last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent)
            parent.enter();
    };
    // Node.js
    if (isNode) {
        notify = function () {
            process.nextTick(flush);
        };
        // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
    }
    else if (Observer && !(global.navigator && global.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
        notify = function () {
            node.data = toggle = !toggle;
        };
        // environments with maybe non-completely correct, but existent Promise
    }
    else if (Promise && Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = Promise.resolve(undefined);
        notify = function () {
            promise.then(flush);
        };
        // for other environments - macrotask based on:
        // - setImmediate
        // - MessageChannel
        // - window.postMessag
        // - onreadystatechange
        // - setTimeout
    }
    else {
        notify = function () {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
        };
    }
    return function (fn) {
        var task = { fn: fn, next: undefined };
        if (last)
            last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var navigator = global.navigator;
module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(21);
var core = __webpack_require__(13);
var global = __webpack_require__(20);
var speciesConstructor = __webpack_require__(200);
var promiseResolve = __webpack_require__(203);
$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
        var C = speciesConstructor(this, core.Promise || global.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function (x) {
            return promiseResolve(C, onFinally()).then(function () { return x; });
        } : onFinally, isFunction ? function (e) {
            return promiseResolve(C, onFinally()).then(function () { throw e; });
        } : onFinally);
    } });


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(21);
var newPromiseCapability = __webpack_require__(151);
var perform = __webpack_require__(202);
$export($export.S, 'Promise', { 'try': function (callbackfn) {
        var promiseCapability = newPromiseCapability.f(this);
        var result = perform(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    } });


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(13);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) {
    return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(156), getTag = __webpack_require__(76), isArguments = __webpack_require__(100), isArray = __webpack_require__(26), isArrayLike = __webpack_require__(54), isBuffer = __webpack_require__(101), isPrototype = __webpack_require__(109), isTypedArray = __webpack_require__(111);
/** `Object#toString` result references. */
var mapTag = '[object Map]', setTag = '[object Set]';
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
    if (value == null) {
        return true;
    }
    if (isArrayLike(value) &&
        (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
    }
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) {
        return !value.size;
    }
    if (isPrototype(value)) {
        return !baseKeys(value).length;
    }
    for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
            return false;
        }
    }
    return true;
}
module.exports = isEmpty;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(206);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(66), root = __webpack_require__(43);
/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');
module.exports = DataView;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(157), isMasked = __webpack_require__(340), isObject = __webpack_require__(44), toSource = __webpack_require__(208);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */
var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
        return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(77);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;
/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    }
    catch (e) { }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        }
        else {
            delete value[symToStringTag];
        }
    }
    return result;
}
module.exports = getRawTag;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(341);
/** Used to detect methods masquerading as native. */
var maskSrcKey = (function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
}());
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
}
module.exports = isMasked;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);
/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(66), root = __webpack_require__(43);
/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');
module.exports = Promise;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(66), root = __webpack_require__(43);
/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');
module.exports = Set;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(66), root = __webpack_require__(43);
/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(67), isObjectLike = __webpack_require__(45);
/** `Object#toString` result references. */
var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
    return false;
}
module.exports = stubFalse;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(67), isLength = __webpack_require__(160), isObjectLike = __webpack_require__(45);
/** `Object#toString` result references. */
var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
    typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
        typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
            typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
                typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
    typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
        typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
            typedArrayTags[errorTag] = typedArrayTags[funcTag] =
                typedArrayTags[mapTag] = typedArrayTags[numberTag] =
                    typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
                        typedArrayTags[setTag] = typedArrayTags[stringTag] =
                            typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) { }
    return index;
}
module.exports = trimmedEndIndex;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(114);
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return (!start && end >= length) ? array : baseSlice(array, start, end);
}
module.exports = castSlice;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(115);
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { }
    return index;
}
module.exports = charsEndIndex;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
        if (array[index] === value) {
            return index;
        }
    }
    return -1;
}
module.exports = strictIndexOf;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(115);
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { }
    return index;
}
module.exports = charsStartIndex;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(356), hasUnicode = __webpack_require__(213), unicodeToArray = __webpack_require__(357);
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
    return hasUnicode(string)
        ? unicodeToArray(string)
        : asciiToArray(string);
}
module.exports = stringToArray;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
    return string.split('');
}
module.exports = asciiToArray;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(163);
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(116), equalArrays = __webpack_require__(215), equalByTag = __webpack_require__(387), equalObjects = __webpack_require__(390), getTag = __webpack_require__(76), isArray = __webpack_require__(26), isBuffer = __webpack_require__(101), isTypedArray = __webpack_require__(111);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */
var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
            return false;
        }
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
            ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
            : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) {
        return false;
    }
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(118);
/** Used for built-in method references. */
var arrayProto = Array.prototype;
/** Built-in value references. */
var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
        data.pop();
    }
    else {
        splice.call(data, index, 1);
    }
    --this.size;
    return true;
}
module.exports = listCacheDelete;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(118);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(118);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(118);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([key, value]);
    }
    else {
        data[index][1] = value;
    }
    return this;
}
module.exports = listCacheSet;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(117);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(117), Map = __webpack_require__(159), MapCache = __webpack_require__(164);
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(371), ListCache = __webpack_require__(117), Map = __webpack_require__(159);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(372), hashDelete = __webpack_require__(373), hashGet = __webpack_require__(374), hashHas = __webpack_require__(375), hashSet = __webpack_require__(376);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}
module.exports = hashHas;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(119);
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
}
module.exports = isKeyable;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(120);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(164), setCacheAdd = __webpack_require__(383), setCacheHas = __webpack_require__(384);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while (++index < length) {
        this.add(values[index]);
    }
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
        if (predicate(array[index], index, array)) {
            return true;
        }
    }
    return false;
}
module.exports = arraySome;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(77), Uint8Array = __webpack_require__(216), eq = __webpack_require__(78), equalArrays = __webpack_require__(215), mapToArray = __webpack_require__(388), setToArray = __webpack_require__(389);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */
var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
        case dataViewTag:
            if ((object.byteLength != other.byteLength) ||
                (object.byteOffset != other.byteOffset)) {
                return false;
            }
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if ((object.byteLength != other.byteLength) ||
                !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
            }
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == (other + '');
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
                return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) {
                return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
    }
    return false;
}
module.exports = equalByTag;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function (value, key) {
        result[++index] = [key, value];
    });
    return result;
}
module.exports = mapToArray;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function (value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(217);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
        return false;
    }
    var index = objLength;
    while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
        }
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) {
            var compared = isPartial
                ? customizer(othValue, objValue, key, other, object, stack)
                : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
            ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
            : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
                typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
        }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
        result[index] = iteratee(index);
    }
    return result;
}
module.exports = baseTimes;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(393), hasPath = __webpack_require__(222);
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
    return object != null && hasPath(object, path, baseHas);
}
module.exports = has;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
    return object != null && hasOwnProperty.call(object, key);
}
module.exports = baseHas;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(395);
/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
    }
    string.replace(rePropName, function (match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
});
module.exports = stringToPath;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(396);
/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
    var result = memoize(func, function (key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
        }
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(164);
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
    if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function () {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) {
            return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(156), getTag = __webpack_require__(76), isArrayLike = __webpack_require__(54), isString = __webpack_require__(226), stringSize = __webpack_require__(398);
/** `Object#toString` result references. */
var mapTag = '[object Map]', setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
    if (collection == null) {
        return 0;
    }
    if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
    }
    var tag = getTag(collection);
    if (tag == mapTag || tag == setTag) {
        return collection.size;
    }
    return baseKeys(collection).length;
}
module.exports = size;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(399), hasUnicode = __webpack_require__(213), unicodeSize = __webpack_require__(400);
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
    return hasUnicode(string)
        ? unicodeSize(string)
        : asciiSize(string);
}
module.exports = stringSize;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(227);
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');
module.exports = asciiSize;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
        ++result;
    }
    return result;
}
module.exports = unicodeSize;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(115), toInteger = __webpack_require__(102);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;
/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
        return -1;
    }
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) {
        index = nativeMax(length + index, 0);
    }
    return baseIndexOf(array, value, index);
}
module.exports = indexOf;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(403);
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
    if (!value) {
        return value === 0 ? value : 0;
    }
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(211), isObject = __webpack_require__(44), isSymbol = __webpack_require__(113);
/** Used as references for various `Number` constants. */
var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
    if (typeof value == 'number') {
        return value;
    }
    if (isSymbol(value)) {
        return NAN;
    }
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
        return value === 0 ? value : +value;
    }
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
}
module.exports = toNumber;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(168), castFunction = __webpack_require__(228), keysIn = __webpack_require__(80);
/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
    return object == null
        ? object
        : baseFor(object, castFunction(iteratee), keysIn);
}
module.exports = forIn;


/***/ }),
/* 405 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
                break;
            }
        }
        return object;
    };
}
module.exports = createBaseFor;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(44), isPrototype = __webpack_require__(109), nativeKeysIn = __webpack_require__(407);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
    if (!isObject(object)) {
        return nativeKeysIn(object);
    }
    var isProto = isPrototype(object), result = [];
    for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
        }
    }
    return result;
}
module.exports = baseKeysIn;


/***/ }),
/* 407 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
        for (var key in Object(object)) {
            result.push(key);
        }
    }
    return result;
}
module.exports = nativeKeysIn;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(409), createAssigner = __webpack_require__(415);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(116), assignMergeValue = __webpack_require__(229), baseFor = __webpack_require__(168), baseMergeDeep = __webpack_require__(410), isObject = __webpack_require__(44), keysIn = __webpack_require__(80), safeGet = __webpack_require__(234);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
        return;
    }
    baseFor(source, function (srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
            var newValue = customizer
                ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
                : undefined;
            if (newValue === undefined) {
                newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(229), cloneBuffer = __webpack_require__(231), cloneTypedArray = __webpack_require__(232), copyArray = __webpack_require__(171), initCloneObject = __webpack_require__(233), isArguments = __webpack_require__(100), isArray = __webpack_require__(26), isArrayLikeObject = __webpack_require__(412), isBuffer = __webpack_require__(101), isFunction = __webpack_require__(157), isObject = __webpack_require__(44), isPlainObject = __webpack_require__(413), isTypedArray = __webpack_require__(111), safeGet = __webpack_require__(234), toPlainObject = __webpack_require__(414);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
                newValue = objValue;
            }
            else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
            }
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            }
            else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            }
            else {
                newValue = [];
            }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
            }
            else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
            }
        }
        else {
            isCommon = false;
        }
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(44);
/** Built-in value references. */
var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function () {
    function object() { }
    return function (proto) {
        if (!isObject(proto)) {
            return {};
        }
        if (objectCreate) {
            return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}());
module.exports = baseCreate;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(54), isObjectLike = __webpack_require__(45);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(67), getPrototype = __webpack_require__(172), isObjectLike = __webpack_require__(45);
/** `Object#toString` result references. */
var objectTag = '[object Object]';
/** Used for built-in method references. */
var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
        return true;
    }
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(103), keysIn = __webpack_require__(80);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(416), isIterateeCall = __webpack_require__(173);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
    return baseRest(function (object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = (assigner.length > 3 && typeof customizer == 'function')
            ? (length--, customizer)
            : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while (++index < length) {
            var source = sources[index];
            if (source) {
                assigner(object, source, index, customizer);
            }
        }
        return object;
    });
}
module.exports = createAssigner;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(123), overRest = __webpack_require__(417), setToString = __webpack_require__(419);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(418);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
    return function () {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index < length) {
            array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
            otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
    switch (args.length) {
        case 0: return func.call(thisArg);
        case 1: return func.call(thisArg, args[0]);
        case 2: return func.call(thisArg, args[0], args[1]);
        case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(420), shortOut = __webpack_require__(422);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);
module.exports = setToString;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(421), defineProperty = __webpack_require__(230), identity = __webpack_require__(123);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
    return function () {
        return value;
    };
}
module.exports = constant;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function () {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) {
                return arguments[0];
            }
        }
        else {
            count = 0;
        }
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(116), arrayEach = __webpack_require__(237), assignValue = __webpack_require__(235), baseAssign = __webpack_require__(424), baseAssignIn = __webpack_require__(425), cloneBuffer = __webpack_require__(231), copyArray = __webpack_require__(171), copySymbols = __webpack_require__(426), copySymbolsIn = __webpack_require__(427), getAllKeys = __webpack_require__(217), getAllKeysIn = __webpack_require__(428), getTag = __webpack_require__(76), initCloneArray = __webpack_require__(429), initCloneByTag = __webpack_require__(430), initCloneObject = __webpack_require__(233), isArray = __webpack_require__(26), isBuffer = __webpack_require__(101), isMap = __webpack_require__(434), isObject = __webpack_require__(44), isSet = __webpack_require__(436), keys = __webpack_require__(79), keysIn = __webpack_require__(80);
/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */
var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
    cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
        cloneableTags[boolTag] = cloneableTags[dateTag] =
            cloneableTags[float32Tag] = cloneableTags[float64Tag] =
                cloneableTags[int8Tag] = cloneableTags[int16Tag] =
                    cloneableTags[int32Tag] = cloneableTags[mapTag] =
                        cloneableTags[numberTag] = cloneableTags[objectTag] =
                            cloneableTags[regexpTag] = cloneableTags[setTag] =
                                cloneableTags[stringTag] = cloneableTags[symbolTag] =
                                    cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
                                        cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
    cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== undefined) {
        return result;
    }
    if (!isObject(value)) {
        return value;
    }
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
            return copyArray(value, result);
        }
    }
    else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
            result = (isFlat || isFunc) ? {} : initCloneObject(value);
            if (!isDeep) {
                return isFlat
                    ? copySymbolsIn(value, baseAssignIn(result, value))
                    : copySymbols(value, baseAssign(result, value));
            }
        }
        else {
            if (!cloneableTags[tag]) {
                return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) {
        return stacked;
    }
    stack.set(value, result);
    if (isSet(value)) {
        value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
    }
    else if (isMap(value)) {
        value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
    }
    var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function (subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(103), keys = __webpack_require__(79);
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(103), keysIn = __webpack_require__(80);
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(103), getSymbols = __webpack_require__(165);
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(103), getSymbolsIn = __webpack_require__(238);
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(218), getSymbolsIn = __webpack_require__(238), keysIn = __webpack_require__(80);
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(170), cloneDataView = __webpack_require__(431), cloneRegExp = __webpack_require__(432), cloneSymbol = __webpack_require__(433), cloneTypedArray = __webpack_require__(232);
/** `Object#toString` result references. */
var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(170);
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(77);
/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(435), baseUnary = __webpack_require__(161), nodeUtil = __webpack_require__(162);
/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(76), isObjectLike = __webpack_require__(45);
/** `Object#toString` result references. */
var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(437), baseUnary = __webpack_require__(161), nodeUtil = __webpack_require__(162);
/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(76), isObjectLike = __webpack_require__(45);
/** `Object#toString` result references. */
var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(115), isArrayLike = __webpack_require__(54), isString = __webpack_require__(226), toInteger = __webpack_require__(102), values = __webpack_require__(439);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike(collection) ? collection : values(collection);
    fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
    }
    return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}
module.exports = includes;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(440), keys = __webpack_require__(79);
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(210);
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
    return arrayMap(props, function (key) {
        return object[key];
    });
}
module.exports = baseValues;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(174), baseWhile = __webpack_require__(450);
/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
    return (array && array.length)
        ? baseWhile(array, baseIteratee(predicate, 3), true)
        : [];
}
module.exports = dropWhile;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(443), getMatchData = __webpack_require__(444), matchesStrictComparable = __webpack_require__(240);
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function (object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(116), baseIsEqual = __webpack_require__(163);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
        return !length;
    }
    object = Object(object);
    while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
            ? data[1] !== object[data[0]]
            : !(data[0] in object)) {
            return false;
        }
    }
    while (++index < length) {
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) {
                return false;
            }
        }
        else {
            var stack = new Stack;
            if (customizer) {
                var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result)) {
                return false;
            }
        }
    }
    return true;
}
module.exports = baseIsMatch;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(239), keys = __webpack_require__(79);
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object), length = result.length;
    while (length--) {
        var key = result[length], value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}
module.exports = getMatchData;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(163), get = __webpack_require__(224), hasIn = __webpack_require__(446), isKey = __webpack_require__(167), isStrictComparable = __webpack_require__(239), matchesStrictComparable = __webpack_require__(240), toKey = __webpack_require__(122);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
    }
    return function (object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
            ? hasIn(object, path)
            : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(447), hasPath = __webpack_require__(222);
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(227), basePropertyDeep = __webpack_require__(449), isKey = __webpack_require__(167), toKey = __webpack_require__(122);
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(225);
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
    return function (object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(114);
/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) { }
    return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}
module.exports = baseWhile;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(212), baseIteratee = __webpack_require__(174), toInteger = __webpack_require__(102);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
        return -1;
    }
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) {
        index = nativeMax(length + index, 0);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(121), baseFlatten = __webpack_require__(453), copyArray = __webpack_require__(171), isArray = __webpack_require__(26);
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
    var length = arguments.length;
    if (!length) {
        return [];
    }
    var args = Array(length - 1), array = arguments[0], index = length;
    while (index--) {
        args[index - 1] = arguments[index];
    }
    return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}
module.exports = concat;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(121), isFlattenable = __webpack_require__(454);
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) {
                // Recursively flatten arrays (susceptible to call stack limits).
                baseFlatten(value, depth - 1, predicate, isStrict, result);
            }
            else {
                arrayPush(result, value);
            }
        }
        else if (!isStrict) {
            result[result.length] = value;
        }
    }
    return result;
}
module.exports = baseFlatten;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(77), isArguments = __webpack_require__(100), isArray = __webpack_require__(26);
/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
    return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(237), baseEach = __webpack_require__(241), castFunction = __webpack_require__(228), isArray = __webpack_require__(26);
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
    var func = isArray(collection) ? arrayEach : baseEach;
    return func(collection, castFunction(iteratee));
}
module.exports = forEach;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(168), keys = __webpack_require__(79);
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(54);
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
    return function (collection, iteratee) {
        if (collection == null) {
            return collection;
        }
        if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
        }
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while ((fromRight ? index-- : ++index < length)) {
            if (iteratee(iterable[index], index, iterable) === false) {
                break;
            }
        }
        return collection;
    };
}
module.exports = createBaseEach;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(114), isIterateeCall = __webpack_require__(173), toInteger = __webpack_require__(102);
/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
        return [];
    }
    if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
    }
    else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
    }
    return baseSlice(array, start, end);
}
module.exports = slice;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(219), baseFilter = __webpack_require__(460), baseIteratee = __webpack_require__(174), isArray = __webpack_require__(26);
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
    var func = isArray(collection) ? arrayFilter : baseFilter;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = filter;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(241);
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
    var result = [];
    baseEach(collection, function (value, index, collection) {
        if (predicate(value, index, collection)) {
            result.push(value);
        }
    });
    return result;
}
module.exports = baseFilter;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedUniq = __webpack_require__(462);
/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
    return (array && array.length)
        ? baseSortedUniq(array)
        : [];
}
module.exports = sortedUniq;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(78);
/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while (++index < length) {
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
        }
    }
    return result;
}
module.exports = baseSortedUniq;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(114), isIterateeCall = __webpack_require__(173), toInteger = __webpack_require__(102);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
    if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
    }
    else {
        size = nativeMax(toInteger(size), 0);
    }
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) {
        return [];
    }
    var index = 0, resIndex = 0, result = Array(nativeCeil(length / size));
    while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
    }
    return result;
}
module.exports = chunk;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
__webpack_require__(465);
module.exports = __webpack_require__(13).Array.from;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(36);
var $export = __webpack_require__(21);
var toObject = __webpack_require__(46);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(199);
var toLength = __webpack_require__(75);
var createProperty = __webpack_require__(466);
var getIterFn = __webpack_require__(150);
$export($export.S + $export.F * !__webpack_require__(205)(function (iter) { Array.from(iter); }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
        var O = toObject(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = getIterFn(O);
        var length, result, step, iterator;
        if (mapping)
            mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
            for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
            }
        }
        else {
            length = toLength(O.length);
            for (result = new C(length); length > index; index++) {
                createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
            }
        }
        result.length = index;
        return result;
    }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(32);
var createDesc = __webpack_require__(62);
module.exports = function (object, index, value) {
    if (index in object)
        $defineProperty.f(object, index, createDesc(0, value));
    else
        object[index] = value;
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(468);
module.exports = __webpack_require__(13).Object.keys;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(46);
var $keys = __webpack_require__(52);
__webpack_require__(139)('keys', function () {
    return function keys(it) {
        return $keys(toObject(it));
    };
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _jquery=__webpack_require__(127);var _jquery2=_interopRequireDefault(_jquery);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}var document=window.document;/**
 * 日期字段选择限制范围
 * @param {fieldid} 	日期字段ID
 * @param {floorday} 	下限天数(与当前日期比较)，空值代表不限制
 * @param {upperday} 	上限天数(与当前日期比较)，空值代表不限制
 * @return 返回true表示在范围内，false表示超出限定范围或日期置为空
 */window.cus_judgeDateRange=function(fieldid,floorday,upperday){var fieldval=window.WfForm.getFieldValue(fieldid);if(!!!fieldval)return false;floorday=floorday===""?-99999:parseInt(floorday);upperday=upperday===""?99999:parseInt(upperday);var curdate=new Date();var defdate=curdate.getFullYear()+"-"+(curdate.getMonth()+1)+"-"+curdate.getDate();var diffdays=(new Date(fieldval.replace(/-/g,"/")).getTime()-new Date(defdate.replace(/-/g,"/")).getTime())/(24*3600*1000);diffdays=Math.ceil(diffdays);if(diffdays>=floorday&&diffdays<=upperday)return true;else return false;};/**
 * 计算时间差
 * @param {begfields} 开始时间
 * @param {endfields} 结束时间
 * @param {unit} 	计量结果单位1(天)、2(小时)、3(分钟)、4(秒)，默认为天
 * @param {digit} 	计算结果保留小数位数，默认2位小数
 * @return 以endfields字段值减去beginfields字段值得到时间差值
 * 注：begfields/endfields结构，可为单独日期字段、单独时间字段、日期+时间组合字段(以英文逗号隔开);日期字段空值默认取今天，时间字段空值默认为00:00
 */window.cus_CalTimeDiff=function(begfields,endfields,unit,digit){if(!!!begfields||!!!endfields)return"ParamsError";var diffmillsecond=window.cus_GetTimeDiffMillSecond(begfields,endfields);var diffsecond=diffmillsecond/1000;unit=!!unit?parseInt(unit):1;digit=!!digit||digit==0?parseInt(digit):2;var retdiff=0;if(unit===1)retdiff=diffsecond/(3600*24);else if(unit===2)retdiff=diffsecond/3600;else if(unit===3)retdiff=diffsecond/60;else if(unit===4)retdiff=diffsecond;if(digit===0)retdiff=Math.floor(retdiff);//向下取整
else retdiff=retdiff.toFixed(digit);return retdiff;};/**
 * 比较timefield1与timefield2两字段时间大小
 * @param {timefield1} 字段1(开始时间)
 * @param {timefield2} 字段2(结束时间)
 * @return 返回true表示timefield2较大，false表示timefield1较大或相等
 * 注：timefield1/timefield2结构，可为单独日期字段、单独时间字段、日期+时间组合字段(以英文逗号隔开);日期字段空值默认取今天，时间字段空值默认为00:00
 */window.cus_CompareTime=function(timefield1,timefield2){var diffmillsecond=window.cus_GetTimeDiffMillSecond(timefield1,timefield2);return diffmillsecond>0;};//计算两时间字段相差毫秒数
window.cus_GetTimeDiffMillSecond=function(field1,field2){var timeval1=window.cus_getTimeValueByField(field1);var timeval2=window.cus_getTimeValueByField(field2);var diffmillsecond=new Date(timeval2.replace(/-/g,"/")).getTime()-new Date(timeval1.replace(/-/g,"/")).getTime();return diffmillsecond;};//根据日期/时间字段ID取标准格式时间值
window.cus_getTimeValueByField=function(fields){var timeval=void 0;var fieldArr=fields.split(",");if(fieldArr.length===1)timeval=window.WfForm.getFieldValue(fieldArr[0]);else if(fieldArr.length>1)timeval=window.WfForm.getFieldValue(fieldArr[0])+" "+window.WfForm.getFieldValue(fieldArr[1]);var curdate=new Date();var defdate=curdate.getFullYear()+"-"+(curdate.getMonth()+1)+"-"+curdate.getDate();if(timeval.indexOf("-")==-1)timeval=defdate+" "+timeval;return timeval;};/**
 * 显示指定区域
 * @param {areanames} 自定义属性中设置的name属性区域集合，多个以逗号隔开
 */window.cus_ShowAreaByName=function(areanames){var arr=areanames.split(",");arr&&arr.map(function(item){window.jQuery("[name="+item+"]").show().removeClass("filter_required");});};/**
 * 隐藏指定区域，隐藏的区域不校验必填
 * @param {areanames} 自定义属性中设置的name属性区域集合，多个以逗号隔开
 */window.cus_HideAreaByName=function(areanames){var arr=areanames.split(",");arr&&arr.map(function(item){window.jQuery("[name="+item+"]").hide().addClass("filter_required");});};/**
 * 控制明细列隐藏/显示
 * @param {cusclassname}  列自定义class属性
 * @param {status}  1为显示，2为隐藏
 */window.cus_ControlDetailColumnByClass=function(cusclassname,status){if(status===1)window.jQuery("td."+cusclassname).show();else if(status===2)window.jQuery("td."+cusclassname).hide();};/**
 * 校验字段是否必填，不满足弹出提示
 * @param {fieldid} 需校验的字段ID，多个以逗号分隔
 * @param {alertmsg} 存在未必填字段时弹出提示信息，空则不提示
 * @return true代表存在未填写字段，false表示校验通过
 */window.cus_verifyExistNullField=function(fieldids,alertmsg){var existNullField=false;var fieldArr=fieldids.split(",");fieldArr&&fieldArr.map(function(fieldid){var fieldInfo=window.WfForm.getFieldInfo(fieldid.substring(5));if(_.isEmpty(fieldInfo)||fieldInfo.htmltype===4)return true;var fieldval=window.WfForm.getFieldValue(fieldid);if(fieldval===""){existNullField=true;return false;}});if(existNullField&&!!alertmsg)alert(alertmsg);return existNullField;};/**
 * 根据字段ID取字段值
 * @param {fieldid} 字段ID
 * @return 字段对应值
 * 注：支持文本、多行文本框、浏览框(ID值)、选择框、check框(选中为1未选中为0)
 */window.cus_getFieldValue=function(fieldid){return window.WfForm.getFieldValue(fieldid);};/**
 * 给文本字段赋值，支持只读/编辑情况
 * @param {fieldid} 字段ID
 * @param {fieldvalue}	字段值 
 */window.cus_setInputFieldValue=function(fieldid,fieldvalue){window.WfForm.changeFieldValue(fieldid,{value:fieldvalue});};window.$G=function(identity,_document){return window.$GetEle(identity,_document);};window.$GetEle=function(identity,_document){var rtnEle=null;if(_document==undefined||_document==null)_document=document;rtnEle=_document.getElementById(identity);if(rtnEle==undefined||rtnEle==null){rtnEle=_document.getElementsByName(identity);if(rtnEle.length>0)rtnEle=rtnEle[0];else rtnEle=null;}return rtnEle;};window.$GetEles=function(identity){var rtnEle=null;rtnEle=document.getElementsByName(identity);if(rtnEle.length==1){return rtnEle[0];}else if(rtnEle.length==0){return document.getElementById(identity);}return rtnEle;};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(72);
__webpack_require__(96);
__webpack_require__(471);
__webpack_require__(475);
__webpack_require__(477);
__webpack_require__(478);
module.exports = __webpack_require__(13).Map;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(243);
var validate = __webpack_require__(175);
var MAP = 'Map';
// 23.1 Map Objects
module.exports = __webpack_require__(244)(MAP, function (get) {
    return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
        var entry = strong.getEntry(validate(this, MAP), key);
        return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
        return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
    }
}, strong, true);


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(36);
var IObject = __webpack_require__(74);
var toObject = __webpack_require__(46);
var toLength = __webpack_require__(75);
var asc = __webpack_require__(473);
module.exports = function (TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || asc;
    return function ($this, callbackfn, that) {
        var O = toObject($this);
        var self = IObject(O);
        var f = ctx(callbackfn, that, 3);
        var length = toLength(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for (; length > index; index++)
            if (NO_HOLES || index in self) {
                val = self[index];
                res = f(val, index, O);
                if (TYPE) {
                    if (IS_MAP)
                        result[index] = res; // map
                    else if (res)
                        switch (TYPE) {
                            case 3: return true; // some
                            case 5: return val; // find
                            case 6: return index; // findIndex
                            case 2: result.push(val); // filter
                        }
                    else if (IS_EVERY)
                        return false; // every
                }
            }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(474);
module.exports = function (original, length) {
    return new (speciesConstructor(original))(length);
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var isArray = __webpack_require__(195);
var SPECIES = __webpack_require__(31)('species');
module.exports = function (original) {
    var C;
    if (isArray(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || isArray(C.prototype)))
            C = undefined;
        if (isObject(C)) {
            C = C[SPECIES];
            if (C === null)
                C = undefined;
        }
    }
    return C === undefined ? Array : C;
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(21);
$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(245)('Map') });


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(99);
module.exports = function (iter, ITERATOR) {
    var result = [];
    forOf(iter, false, result.push, result, ITERATOR);
    return result;
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(246)('Map');


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(247)('Map');


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function () { return this; })() || Function("return this")();
// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
    Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;
// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;
module.exports = __webpack_require__(480);
if (hadRuntime) {
    // Restore the original runtime.
    g.regeneratorRuntime = oldRuntime;
}
else {
    // Remove the global property added by runtime.js.
    try {
        delete g.regeneratorRuntime;
    }
    catch (e) {
        g.regeneratorRuntime = undefined;
    }
}


/***/ }),
/* 480 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
!(function (global) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var inModule = typeof module === "object";
    var runtime = global.regeneratorRuntime;
    if (runtime) {
        if (inModule) {
            // If regeneratorRuntime is defined globally and we're in a module,
            // make the exports object identical to regeneratorRuntime.
            module.exports = runtime;
        }
        // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.
        return;
    }
    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global.regeneratorRuntime = inModule ? module.exports : {};
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
    }
    runtime.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return { type: "normal", arg: fn.call(obj, arg) };
        }
        catch (err) {
            return { type: "throw", arg: err };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() { }
    function GeneratorFunction() { }
    function GeneratorFunctionPrototype() { }
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
        return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype &&
        NativeIteratorPrototype !== Op &&
        hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype =
        Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] =
        GeneratorFunction.displayName = "GeneratorFunction";
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
            prototype[method] = function (arg) {
                return this._invoke(method, arg);
            };
        });
    }
    runtime.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor
            ? ctor === GeneratorFunction ||
                // For the native GeneratorFunction constructor, the best we can
                // do is to check its .name property.
                (ctor.displayName || ctor.name) === "GeneratorFunction"
            : false;
    };
    runtime.mark = function (genFun) {
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        }
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
            }
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function (arg) {
        return { __await: arg };
    };
    function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") {
                reject(record.arg);
            }
            else {
                var result = record.arg;
                var value = result.value;
                if (value &&
                    typeof value === "object" &&
                    hasOwn.call(value, "__await")) {
                    return Promise.resolve(value.__await).then(function (value) {
                        invoke("next", value, resolve, reject);
                    }, function (err) {
                        invoke("throw", err, resolve, reject);
                    });
                }
                return Promise.resolve(value).then(function (unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration. If the Promise is rejected, however, the
                    // result for this iteration will be rejected with the same
                    // reason. Note that rejections of yielded Promises are not
                    // thrown back into the generator function, as is the case
                    // when an awaited Promise is rejected. This difference in
                    // behavior between yield and await is important, because it
                    // allows the consumer to decide what to do with the yielded
                    // rejection (swallow it and continue, manually .throw it back
                    // into the generator, abandon iteration, whatever). With
                    // await, by contrast, there is no opportunity to examine the
                    // rejection reason outside the generator function, so the
                    // only option is to throw it from the await expression, and
                    // let the generator function handle the exception.
                    result.value = unwrapped;
                    resolve(result);
                }, reject);
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise =
                // If enqueue has been called before, then we want to wait until
                // all previous Promises have been resolved before calling invoke,
                // so that results are always delivered in the correct order. If
                // enqueue has not been called before, then it is important to
                // call invoke immediately, without waiting on a callback to fire,
                // so that the async generator function has the opportunity to do
                // any necessary setup in a predictable way. This predictability
                // is why the Promise constructor synchronously invokes its
                // executor callback, and why async functions synchronously
                // execute code before the first await. Since we implement simple
                // async functions in terms of async generators, it is especially
                // important to get this right, even though it requires care.
                previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, 
                // Avoid propagating failures to Promises returned by later
                // invocations of the iterator.
                callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
        return this;
    };
    runtime.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function (innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return runtime.isGeneratorFunction(outerFn)
            ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
                return result.done ? result.value : iter.next();
            });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
            }
            if (state === GenStateCompleted) {
                if (method === "throw") {
                    throw arg;
                }
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while (true) {
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel)
                            continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") {
                    // Setting context._sent for legacy support of Babel's
                    // function.sent implementation.
                    context.sent = context._sent = context.arg;
                }
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                }
                else if (context.method === "return") {
                    context.abrupt("return", context.arg);
                }
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done
                        ? GenStateCompleted
                        : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) {
                        continue;
                    }
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                if (delegate.iterator.return) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") {
                        // If maybeInvokeDelegate(context) changed context.method from
                        // "return" to "throw", let that override the TypeError below.
                        return ContinueSentinel;
                    }
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        }
        else {
            // Re-yield the result returned by the delegate method.
            return info;
        }
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function () {
        return this;
    };
    Gp.toString = function () {
        return "[object Generator]";
    };
    function pushTryEntry(locs) {
        var entry = { tryLoc: locs[0] };
        if (1 in locs) {
            entry.catchLoc = locs[1];
        }
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{ tryLoc: "root" }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    runtime.keys = function (object) {
        var keys = [];
        for (var key in object) {
            keys.push(key);
        }
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while (keys.length) {
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) {
                return iteratorMethod.call(iterable);
            }
            if (typeof iterable.next === "function") {
                return iterable;
            }
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while (++i < iterable.length) {
                        if (hasOwn.call(iterable, i)) {
                            next.value = iterable[i];
                            next.done = false;
                            return next;
                        }
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return { next: doneResult };
    }
    runtime.values = values;
    function doneResult() {
        return { value: undefined, done: true };
    }
    Context.prototype = {
        constructor: Context,
        reset: function (skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for (var name in this) {
                    // Not sure about the optimal order of these conditions:
                    if (name.charAt(0) === "t" &&
                        hasOwn.call(this, name) &&
                        !isNaN(+name.slice(1))) {
                        this[name] = undefined;
                    }
                }
            }
        },
        stop: function () {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") {
                throw rootRecord.arg;
            }
            return this.rval;
        },
        dispatchException: function (exception) {
            if (this.done) {
                throw exception;
            }
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") {
                    // Exception thrown outside of any try block that could handle
                    // it, so set the completion value of the entire function to
                    // throw the exception.
                    return handle("end");
                }
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) {
                            return handle(entry.catchLoc, true);
                        }
                        else if (this.prev < entry.finallyLoc) {
                            return handle(entry.finallyLoc);
                        }
                    }
                    else if (hasCatch) {
                        if (this.prev < entry.catchLoc) {
                            return handle(entry.catchLoc, true);
                        }
                    }
                    else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) {
                            return handle(entry.finallyLoc);
                        }
                    }
                    else {
                        throw new Error("try statement without catch or finally");
                    }
                }
            }
        },
        abrupt: function (type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev &&
                    hasOwn.call(entry, "finallyLoc") &&
                    this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry &&
                (type === "break" ||
                    type === "continue") &&
                finallyEntry.tryLoc <= arg &&
                arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
            }
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function (record, afterLoc) {
            if (record.type === "throw") {
                throw record.arg;
            }
            if (record.type === "break" ||
                record.type === "continue") {
                this.next = record.arg;
            }
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            }
            else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
            }
            return ContinueSentinel;
        },
        finish: function (finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function (tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function (iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
            }
            return ContinueSentinel;
        }
    };
})(
// In sloppy mode, unbound `this` refers to the global object, fallback to
// Function constructor if we're in global strict mode. That is sadly a form
// of indirect eval which violates Content Security Policy.
(function () { return this; })() || Function("return this")());


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var conver2name=exports.conver2name=function conver2name(tableMark,rowIndex){var _name='';if(tableMark==='main')_name='主表';else{_name=rowIndex?'明细'+tableMark.toString().substring(7)+('\u3010\u884C\u53F7:'+(parseInt(rowIndex)+1)+'\u3011'):'明细'+tableMark.toString().substring(7);}return _name;};var singleConvert=exports.singleConvert=function singleConvert(fieldid,fieldMap,showMark,rowIndex){var retStr='';if(showMark){retStr=fieldid;}else{if(fieldid.indexOf('_')==-1){var fieldObj=fieldMap.get(fieldid);retStr=fieldObj&&fieldObj.tableMark?conver2name(fieldObj.tableMark,rowIndex)+'.'+fieldObj.fieldlabel:'field'+fieldid;}else{fieldid=fieldid&&fieldid.substring(0,fieldid.indexOf('_'));var _fieldObj=fieldMap.get(fieldid);retStr=_fieldObj&&_fieldObj.tableMark?conver2name(_fieldObj.tableMark,rowIndex)+'.'+_fieldObj.fieldlabel:'field'+fieldid;}}return retStr;};var multiConvert=exports.multiConvert=function multiConvert(fieldArr,fieldMap,showMark,rowIndex){var arr=[];fieldArr&&fieldArr.map(function(fieldid,index){arr.push(React.createElement('span',{className:index%2==1?"wf-heightLight":""},singleConvert(fieldid,fieldMap,showMark)));});return arr;};var getRowIndex=exports.getRowIndex=function getRowIndex(fieldMark){var retStr=null;if(fieldMark.indexOf('_')==-1){retStr='/';}else{retStr=parseInt(fieldMark.substring(fieldMark.indexOf('_')+1))+1;}return retStr;};var getStepType=exports.getStepType=function getStepType(type){var retStr='';switch(type){case'1':retStr='初始加载';break;case'2':retStr='添加明细行';break;case'3':retStr='手动变更';break;case'4':retStr='同步联动';break;case'5':retStr='异步联动';break;case'7':retStr='公式修改';break;default:retStr='接口修改';}return retStr;};var getTriType=exports.getTriType=function getTriType(type){var retStr='';switch(type){case 1:retStr='字段值变化';break;case 2:retStr='页面加载触发';break;case 3:retStr='新增行触发';break;case 4:retStr='删除行触发';break;case'c_value':retStr='字段值变更';break;case'c_vars':retStr='字段属性变更';break;}return retStr;};var getLinkageType=exports.getLinkageType=function getLinkageType(type){var retStr='';if(type=='fieldsql')retStr='SQL联动';else if(type=='datainput')retStr='字段联动';else retStr='时间日期计算';return retStr;};var getFieldid=exports.getFieldid=function getFieldid(fieldMark){var retStr=null;if(fieldMark.indexOf('_')==-1){retStr=fieldMark.substring(5);}else{retStr=fieldMark.substring(5,fieldMark.indexOf('_'));}return retStr;};var doDuplicate=exports.doDuplicate=function doDuplicate(dataArr){var retArr=[];retArr=dataArr.filter(function(x,index,arr){var trgFields=[];var assignFields=[];arr.forEach(function(item,i){trgFields.push(item.trgField);assignFields.push(item.assignField);});return trgFields.indexOf(x.trgField)===index&&assignFields.indexOf(x.assignField)===index;});return retArr;};/**
 * 获取公式触发字段的field数组
 * @param {*} triString 公式触发字段字符串
 */var getTriFieldWithFormula=exports.getTriFieldWithFormula=function getTriFieldWithFormula(triString){var res=[];if(typeof triString!='undefined'&&triString!=null){var triSet=triString.split("##");for(var i=0;i<triSet.length;i++){triSet[i].indexOf("#")>0&&res.push(triSet[i].split("#")[1]);}return res;}return res;};/**
 * 获取公式的赋值字段
 * @param assignField 公式串
 * @returns {string}
 */var getAssignFieldWithFormula=exports.getAssignFieldWithFormula=function getAssignFieldWithFormula(assignField){var res='';if(typeof assignField=='string'&&assignField.length>4){res=assignField.substring(assignField.indexOf(".")+1,assignField.indexOf("]")-1);return res;}return res;};var getTriTiming=exports.getTriTiming=function getTriTiming(timing){var retStr='';timing=parseInt(timing);switch(timing){case 1:retStr='值改变时';break;case 2:retStr='获取输入焦点时';break;case 3:retStr='失去输入焦点时';break;case 4:retStr='鼠标单击时';break;case 5:retStr='鼠标双击时';break;case 6:retStr='鼠标移入时';break;case 7:retStr='鼠标移出时';break;case 21:retStr='载入时';break;case 22:retStr='窗口滚动时';break;case 51:retStr='提交/批准时';break;case 52:retStr='保存时';break;case 53:retStr='退回时';break;case 54:retStr='转办时';break;case 56:retStr='转发时';break;case 57:retStr='意见征询时';break;case 58:retStr='传阅时';break;}return retStr;};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getLockParams=exports.closeUnLock=exports.verifyEffictive=exports.doActivate=exports.doUnLock=exports.judgeOpenLock=exports.bindLockEvent=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _req=__webpack_require__(15);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _rightBtn=__webpack_require__(85);var _formUtil=__webpack_require__(11);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//加载绑定相关事件
var bindLockEvent=exports.bindLockEvent=function bindLockEvent(){}// if (window.addEventListener){
//     window.addEventListener("unload", closeUnLock, false);
// }else if (window.attachEvent){
//     window.attachEvent("onunload", closeUnLock);
// }else{
//     window.onuload = closeUnLock;
// }
//判断当前请求是否开启锁定
;var judgeOpenLock=exports.judgeOpenLock=function judgeOpenLock(){var promptInfo=_base2.default.globalStore.promptInfo;return promptInfo&&promptInfo.prompttype==="editlock";};//手动点击解锁
var doUnLock=exports.doUnLock=function doUnLock(){var _getAntd=(0,_convert.getAntd)(),Modal=_getAntd.Modal,message=_getAntd.message;var commonParam=_base2.default.globalStore.commonParam;if(commonParam.belongTest){message.warning((0,_convert.getLabel)(386177,"流程测试不允许解除锁定操作"));return;}Modal.confirm({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(128824,'是否保存当前流程数据？'),okText:(0,_convert.getLabel)(83446,'确定'),cancelText:(0,_convert.getLabel)(31129,'取消'),onOk:function onOk(){closeUnLock(function(){(0,_rightBtn.doSave_nNew)(true);});},onCancel:function onCancel(){(0,_formUtil.closeRequestPage)(false);}});};//手动点击激活当前页面，失效已打开同请求页面
var doActivate=exports.doActivate=function doActivate(){(0,_req.editLockOper)(getLockParams("doActivate")).then(function(data){var urlParams=_base2.default.globalStore.urlParams;delete urlParams["timestamp"];(0,_formUtil.reloadRequestPage)(urlParams,false);});};//校验当前页面是否有效
var verifyEffictive=exports.verifyEffictive=function verifyEffictive(callback){if(!judgeOpenLock())return;(0,_req.editLockOper)(getLockParams("verifyEffictive")).then(function(data){typeof callback==="function"&&data.flag=="true"&&callback();});};//关闭页面解锁此流程
var closeUnLock=exports.closeUnLock=function closeUnLock(callback){if(!judgeOpenLock())return;(0,_req.editLockOper)(getLockParams("unlock")).then(function(data){typeof callback==="function"&&callback();});};var getLockParams=exports.getLockParams=function getLockParams(opertype){var _base$globalStore=_base2.default.globalStore,urlParams=_base$globalStore.urlParams,baseParam=_base$globalStore.baseParam;return(0,_extends3.default)({opertype:opertype},urlParams,baseParam);};window.lockUtil={doUnLock:doUnLock,doActivate:doActivate};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(72);
__webpack_require__(96);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
module.exports = __webpack_require__(13).Set;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(243);
var validate = __webpack_require__(175);
var SET = 'Set';
// 23.2 Set Objects
module.exports = __webpack_require__(244)(SET, function (get) {
    return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
        return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
    }
}, strong);


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(21);
$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(245)('Set') });


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(246)('Set');


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(247)('Set');


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * 提交/批准
 */var REQUEST_APPROVAL=exports.REQUEST_APPROVAL="viewtype_approve";/**
 * 提交到退回节点
 */var REQUEST_SUBMIT_BACK_NODE=exports.REQUEST_SUBMIT_BACK_NODE="viewtype_submitbacknode";/**
 *  保存
 */var REQUEST_SAVE=exports.REQUEST_SAVE="viewtype_save";/**
 *  转发
 */var REQUEST_FORWARD=exports.REQUEST_FORWARD="viewtype_forward";/**
 * 转发接收人批注
 */var REQUEST_POSTIL=exports.REQUEST_POSTIL="viewtype_postil";/**
 *  转办
 */var REQUEST_HANDLE_FORWARD=exports.REQUEST_HANDLE_FORWARD="view_handleForward";/**
 *  意见征询
 */var REQUEST_TAKING_OPINIONS=exports.REQUEST_TAKING_OPINIONS="view_takingOpinions";/**
 *  意见征询批注
 */var REQUEST_TPOSTIL=exports.REQUEST_TPOSTIL="viewtype_tpostil";/**
 *  抄送接收人批注
 */var REQUEST_RPOSTIL=exports.REQUEST_RPOSTIL="viewtype_rpostil";/**
 *  退回
 */var REQUEST_REJECT=exports.REQUEST_REJECT="viewtype_reject";

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */
module.exports = function (css) {
    // get current location
    var location = typeof window !== "undefined" && window.location;
    if (!location) {
        throw new Error("fixUrls requires window.location");
    }
    // blank or null?
    if (!css || typeof css !== "string") {
        return css;
    }
    var baseUrl = location.protocol + "//" + location.host;
    var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
    // convert each url(...)
    /*
    This regular expression is just a way to recursively match brackets within
    a string.

     /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
       (  = Start a capturing group
         (?:  = Start a non-capturing group
             [^)(]  = Match anything that isn't a parentheses
             |  = OR
             \(  = Match a start parentheses
                 (?:  = Start another non-capturing groups
                     [^)(]+  = Match anything that isn't a parentheses
                     |  = OR
                     \(  = Match a start parentheses
                         [^)(]*  = Match anything that isn't a parentheses
                     \)  = Match a end parentheses
                 )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
     \)  = Match a close parens

     /gi  = Get all matches, not the first.  Be case insensitive.
     */
    var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
        // strip quotes (if they exist)
        var unquotedOrigUrl = origUrl
            .trim()
            .replace(/^"(.*)"$/, function (o, $1) { return $1; })
            .replace(/^'(.*)'$/, function (o, $1) { return $1; });
        // already a full url? no change
        if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
            return fullMatch;
        }
        // convert the url to a full url
        var newUrl;
        if (unquotedOrigUrl.indexOf("//") === 0) {
            //TODO: should we add protocol?
            newUrl = unquotedOrigUrl;
        }
        else if (unquotedOrigUrl.indexOf("/") === 0) {
            // path should be relative to the base url
            newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
        }
        else {
            // path should be relative to current directory
            newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
        }
        // send back the fixed url(...)
        return "url(" + JSON.stringify(newUrl) + ")";
    });
    // send back the fixed css
    return fixedCss;
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getStyleJson=undefined;var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _regenerator=__webpack_require__(128);var _regenerator2=_interopRequireDefault(_regenerator);var _asyncToGenerator2=__webpack_require__(129);var _asyncToGenerator3=_interopRequireDefault(_asyncToGenerator2);var _create=__webpack_require__(197);var _create2=_interopRequireDefault(_create);var _entries=__webpack_require__(492);var _entries2=_interopRequireDefault(_entries);var _getIterator2=__webpack_require__(252);var _getIterator3=_interopRequireDefault(_getIterator2);var _from=__webpack_require__(124);var _from2=_interopRequireDefault(_from);var _map=__webpack_require__(242);var _map2=_interopRequireDefault(_map);// 初始化
var init=function(){var _ref=(0,_asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee(){var _iteratorNormalCompletion12,_didIteratorError12,_iteratorError12,_iterator12,_step12,td;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:table=new _map2.default();mainMap=new _map2.default();detailMap=new _map2.default();dtRow=0;tabsCount=0;tabsRow=0;table.set("maintable",mainMap);/*$(".prependImg").remove();
    let element = $($("div.wf-req-form")[0]).find("td");
    for (let i=0; i<element.size(); i++) {
        let url = $(element[i]).css("background-image");
        if (/url\(.+\)/.test(url)) {
            let base64 = await getCanvasBase64(url.replace("url(\"","").replace("\")", ""));
            let img = $("<img></img>").attr("src", base64).attr("class", "prependImg").css("display", "none");
            $(element[i]).prepend(img);
        }
    }*/if($("#reqIframe").size()===0){_WfForm=_interface2.default;store=_WfForm.getLayoutStore();}else{_WfForm=document.getElementById("reqIframe").contentWindow.WfForm;store=_WfForm.getLayoutStore();}if(!(store.dataJson===undefined)){_context.next=10;break;}return _context.abrupt('return');case 10:_iteratorNormalCompletion12=true;_didIteratorError12=false;_iteratorError12=undefined;_context.prev=13;for(_iterator12=(0,_getIterator3.default)(store.dataJson.etables.emaintable.ec);!(_iteratorNormalCompletion12=(_step12=_iterator12.next()).done);_iteratorNormalCompletion12=true){td=_step12.value;mainEc.set(td.id,td);}_context.next=21;break;case 17:_context.prev=17;_context.t0=_context['catch'](13);_didIteratorError12=true;_iteratorError12=_context.t0;case 21:_context.prev=21;_context.prev=22;if(!_iteratorNormalCompletion12&&_iterator12.return){_iterator12.return();}case 24:_context.prev=24;if(!_didIteratorError12){_context.next=27;break;}throw _iteratorError12;case 27:return _context.finish(24);case 28:return _context.finish(21);case 29:mainEc.set("colheads",new _map2.default((0,_entries2.default)(store.dataJson.etables.emaintable.colheads)));mainEc.set("rowheads",new _map2.default((0,_entries2.default)(store.dataJson.etables.emaintable.rowheads)));case 31:case'end':return _context.stop();}}},_callee,this,[[13,17,21,29],[22,,24,28]]);}));return function init(){return _ref.apply(this,arguments);};}();var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _inputUtil=__webpack_require__(81);var InputUtil=_interopRequireWildcard(_inputUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var table="";var mainMap="";var detailMap="";var dtRow="";var tabsCount="";var tabsRow="";var mainEc=new _map2.default();var detailEc=new _map2.default();var store="";var _WfForm="";// 获取元素的值
function getText(cell,attrs,fieldmark){var text="";var fieldid="0";var cellTd=void 0;if(cell){cellTd=$(cell);fieldmark=cellTd.find("[data-fieldmark*=field]").attr("data-fieldmark");if(!fieldmark&&(cell.className.includes("etype_13")||cell.className.includes("etype_17"))){var arr=[];for(var i in store.cellInfo){arr.push(i);}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=(0,_getIterator3.default)(arr),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var mark=_step.value;if(/mc_\d_\d_\d_nodemark/.test(mark)){text+=store.cellInfo[mark];}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(cellTd.find("img").size()>0){var imgs=(0,_from2.default)(cellTd.find("img"));var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=(0,_getIterator3.default)(imgs),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var img=_step2.value;var base64image=getBase64Image(img);text+=base64image+"&&";}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}attrs.set("text",text.replace(/\n/g,""));return;}else if(fieldmark===undefined){text+=cellTd[0].innerText;attrs.set("text",text);return;}if(!cellTd.find("[data-fieldmark*=field]").is(":visible")){return;}}if(/field\d+_\d+/.test(fieldmark)){fieldid=fieldmark.substring(5,fieldmark.indexOf("_"));}else{fieldid=fieldmark.substring(5);}var fieldAttr=_interface2.default.getFieldInfo(fieldid);var htmltype=fieldAttr.htmltype,detailtype=fieldAttr.detailtype;var fieldValue=_interface2.default.getFieldValue(fieldmark);// 可编辑的单行文本
if(fieldid<0){if(fieldid==="-1"||fieldid==="-9"){text=fieldValue;}else if(fieldid==="-2"){if(fieldValue==="0"){text+="正常";}else if(fieldValue==="1"){text+="重要";}else{text+="紧急";}}else{text="";}}else if(htmltype===1){if(detailtype===4){text+=fieldValue;text+="<br>";text+=InputUtil.convertAmountChinese(fieldValue);}else{if(cellTd&&cellTd.find("table[class*=fintable]").size()>0){// 财务表头（每一位数字之前补一个 | ）
var finborder=(0,_from2.default)(cellTd.find("td.finborder"));var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=(0,_getIterator3.default)(finborder),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var fin=_step3.value;if($(fin).text()===""){text+=" ";}text+=$(fin).text()+"|";}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}text=text.substring(0,text.lastIndexOf("|"));}else{text+=fieldValue;}}}else if(htmltype===2){var img_text=[];if(cellTd&&cellTd.find("img").size()>0){var _imgs=(0,_from2.default)(cellTd.find("img"));var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=(0,_getIterator3.default)(_imgs),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var _img=_step4.value;var _base64image=getBase64Image(_img);img_text.push(_base64image);}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}var arr_text=_WfForm.getFieldValue(fieldmark).split(/<img.[^<]+>/);for(var _i=0;_i<arr_text.length;_i++){text+=arr_text[_i];if(_i<img_text.length){text+=img_text[_i];}}// 浏览按钮
}else if(htmltype===3){if(detailtype===2||detailtype===19){// 日期与时间
text+=_WfForm.getFieldValue(fieldmark);}else{text+=_WfForm.getBrowserShowName(fieldmark);text=text.replace(/,/g," ");}}else if(htmltype===4){var selected=_WfForm.getFieldValue(fieldmark);selected=selected===""?"-1":selected;text+=Number(selected)===1?"☑":"☐";}else if(htmltype===5){var _selected=_WfForm.getFieldValue(fieldmark);_selected=_selected===""?"-1":_selected;if(detailtype===1){// select
text+=_WfForm.getSelectShowName(fieldmark);}else if(detailtype===2){// 多个checkbox
var itemlist=_WfForm.getFieldInfo(fieldid).selectattr.selectitemlist;var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=(0,_getIterator3.default)(itemlist),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var item=_step5.value;text+=_selected.indexOf(item.selectvalue)>-1?"☑":"☐";text+=item.selectname;}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}else if(detailtype===3){// radio
var _itemlist=_WfForm.getFieldInfo(fieldid).selectattr.selectitemlist;var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=(0,_getIterator3.default)(_itemlist),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var _item=_step6.value;text+=Number(_selected)===_item.selectvalue?"●":"○";text+=_item.selectname;}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}}// 附件/图片上传
}else if(htmltype===6){if(detailtype===1){// 附件上传
if(mobx.toJS(_WfForm.getFieldObj(fieldmark)).specialobj){var files=mobx.toJS(_WfForm.getFieldObj(fieldmark)).specialobj.filedatas;var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=(0,_getIterator3.default)(files),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var file=_step7.value;text+=file.filename+"<br/>";}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}}}else if(detailtype===2){if(cellTd){var _imgs2=(0,_from2.default)(cellTd.find("img"));var _iteratorNormalCompletion8=true;var _didIteratorError8=false;var _iteratorError8=undefined;try{for(var _iterator8=(0,_getIterator3.default)(_imgs2),_step8;!(_iteratorNormalCompletion8=(_step8=_iterator8.next()).done);_iteratorNormalCompletion8=true){var _img2=_step8.value;var _base64image2=getBase64Image(_img2);text+=_base64image2+"&&";}}catch(err){_didIteratorError8=true;_iteratorError8=err;}finally{try{if(!_iteratorNormalCompletion8&&_iterator8.return){_iterator8.return();}}finally{if(_didIteratorError8){throw _iteratorError8;}}}}}}else if(htmltype===7){if(detailtype===1){if(""!==_WfForm.getFieldInfo(fieldid).specialattr.linkaddress){text+=_WfForm.getFieldInfo(fieldid).specialattr.displayname+"@HYPERLINK@"+_WfForm.getFieldInfo(fieldid).specialattr.linkaddress;}}else if(detailtype===2){// 描述性文字
text+=_WfForm.getFieldInfo(fieldid).specialattr.descriptivetext;}}else if(htmltype===9){if(detailtype===1){// 位置字段
var specialobj=(0,_from2.default)(store.mainData.get(fieldmark).specialobj);var _iteratorNormalCompletion9=true;var _didIteratorError9=false;var _iteratorError9=undefined;try{for(var _iterator9=(0,_getIterator3.default)(specialobj),_step9;!(_iteratorNormalCompletion9=(_step9=_iterator9.next()).done);_iteratorNormalCompletion9=true){var obj=_step9.value;text+=obj.flowNum+"    ";var locationlist=(0,_from2.default)(obj.locationList);var _iteratorNormalCompletion10=true;var _didIteratorError10=false;var _iteratorError10=undefined;try{for(var _iterator10=(0,_getIterator3.default)(locationlist),_step10;!(_iteratorNormalCompletion10=(_step10=_iterator10.next()).done);_iteratorNormalCompletion10=true){var location=_step10.value;text+=location.nodeName+"    ";text+=location.userName+"    ";text+=location.time+"    ";text+=location.address+"    ";}}catch(err){_didIteratorError10=true;_iteratorError10=err;}finally{try{if(!_iteratorNormalCompletion10&&_iterator10.return){_iterator10.return();}}finally{if(_didIteratorError10){throw _iteratorError10;}}}text+="\n";}}catch(err){_didIteratorError9=true;_iteratorError9=err;}finally{try{if(!_iteratorNormalCompletion9&&_iterator9.return){_iterator9.return();}}finally{if(_didIteratorError9){throw _iteratorError9;}}}}}if(text.endsWith("<br>")){text=text.substring(0,text.lastIndexOf("<br>"));}attrs.set("text",text);}// 解析明细表
function detailTableAnalysis(element,detailId){var rowCount=_WfForm.getDetailRowCount("detail_"+detailId);var fieldMap=new _map2.default((0,_entries2.default)(_interface2.default.getLayoutStore().detailMap.get("detail_"+detailId).fieldInfo));var fieldNum=fieldMap.size;var colHeads=Array(fieldNum+1);var controlWidthObj=jQuery(element).find("tr.detailControlWidth");for(var i=1;i<=fieldNum+1;i++){colHeads[i]=controlWidthObj.find("td:eq("+i+")").width();}var rowHeadnum=detailEc.get("rowheads").size;var edtitleinrow=Number(store.dataJson.etables["detail_"+detailId].edtitleinrow);//明细表头所在行数
var flag=true;for(var headrow=0;headrow<edtitleinrow;headrow++){var coloumn=new _map2.default();for(var col=1;col<=fieldNum+1;col++){var attrs=new _map2.default();var id=headrow+","+col;var col0id=headrow+",0";//第一列id
try{attrs=new _map2.default((0,_entries2.default)(detailEc.get(id)));attrs.set("width",colHeads[col]);attrs.set("height",detailEc.get("rowheads").get("row_"+headrow));}catch(e){}if(detailEc.get(col0id)&&detailEc.get(col0id).etype==10){flag=false;}if(detailEc.get(id)){if(detailEc.get(id).etype==10){//复制粘贴行
flag=false;}attrs.set("text",detailEc.get(id).evalue);}coloumn.set(""+(col-1),attrs);}if(!flag){flag=true;}else{detailMap.set(""+dtRow,coloumn);dtRow++;}}var datarow=edtitleinrow+1;//数据的第一行
for(var row=edtitleinrow;row<edtitleinrow+rowCount;row++){var _coloumn=new _map2.default();for(var _col=1;_col<=fieldNum+1;_col++){var _attrs=new _map2.default();var _id=datarow+","+_col;try{_attrs=new _map2.default((0,_entries2.default)(detailEc.get(_id)));_attrs.set("width",colHeads[_col]);_attrs.set("height",detailEc.get("rowheads").get("row_"+datarow));}catch(e){}if(_col==1){_attrs.set("text",row-edtitleinrow+1+"");}else{if(detailEc.get(datarow+","+_col)){getText(false,_attrs,"field"+detailEc.get(datarow+","+_col).field+"_"+(row-edtitleinrow));}}_coloumn.set(""+(_col-1),_attrs);}detailMap.set(""+dtRow,_coloumn);dtRow++;}//表尾后的行 （合计）
var edtailinrow=Number(store.dataJson.etables["detail_"+detailId].edtailinrow);//明细表尾所在行数
for(var _row=edtailinrow+1;_row<rowHeadnum;_row++){var _coloumn2=new _map2.default();var co11value="";for(var _col2=1;_col2<=fieldNum+1;_col2++){var _attrs2=new _map2.default();var _id2=_row+","+_col2;try{_attrs2=new _map2.default((0,_entries2.default)(detailEc.get(_id2)));_attrs2.set("width",colHeads[_col2]);_attrs2.set("height",detailEc.get("rowheads").get("row_"+_row));var colspan=Number(detailEc.get(_id2).colspan);if(_col2==0&&colspan>1){//第一列colspan特殊处理下
_attrs2.set("colspan",colspan-1);}}catch(e){}if(detailEc.get(_id2)){if(_col2==1){//如果序号列也有数据 那把选择列数据合并到序号列
co11value=detailEc.get(_id2).evalue;}if(detailEc.get(_id2).etype==19){//合计数据
//detail_1_5_2
var sumtd="detail_"+detailId+"_"+_row+"_"+_col2;var sumfieldtd=jQuery(element).find("td."+sumtd).find("span").text();_attrs2.set("text",sumfieldtd);}else{_attrs2.set("text",detailEc.get(_id2).evalue);}}_coloumn2.set(""+(_col2-1),_attrs2);}//选择列有value的情况
var id0=_row+",0";var attrs0=new _map2.default();try{var ec0=detailEc.get(id0);var _colspan=Number(ec0.colspan);if(_colspan>1){//第一列colspan特殊处理下
ec0['colspan']=_colspan-1;}ec0['id']=edtailinrow+1+",1";attrs0=new _map2.default((0,_entries2.default)(ec0));attrs0=new _map2.default(Object.set("width",colHeads[0]));attrs0.set("height",detailEc.get("rowheads").get("row_"+(edtailinrow+1)));}catch(e){}var col0value="";if(detailEc.get(id0)){if(detailEc.get(id0).etype==19){//合计数据
//detail_1_5_2
// let sumtd = "detail_"+detailId+"_"+(edtailinrow+1) +"_"+col;
// const sumfieldtd = jQuery(element).find("td."+sumtd).find("span").text();
// attrs0.set("text",sumfieldtd);
}else{if(detailEc.get(id0).evalue&&detailEc.get(id0).evalue!=""){col0value=detailEc.get(id0).evalue;}if(co11value!=""&&col0value!=""){co11value=" | "+co11value;}attrs0.set("text",col0value+""+co11value);}}if(col0value!=""){_coloumn2.set("0",attrs0);}detailMap.set(""+dtRow,_coloumn2);dtRow++;}// console.log("detailmap"+JSON.stringify(detailMap));
}// 解析主表
function recursiveDFS(element){if(element.tagName==="TABLE"&&element.className==="excelDetailTable"&&$(element).is(":visible")){if(/oTable\d+_head/.test(element.id)){return;}detailMap=new _map2.default();var detailId=Number(element.id.replace("oTable",""))+1;if(isNaN(detailId)){return;}table.set("detail_"+detailId,detailMap);dtRow=0;var _iteratorNormalCompletion11=true;var _didIteratorError11=false;var _iteratorError11=undefined;try{for(var _iterator11=(0,_getIterator3.default)(store.dataJson.etables["detail_"+detailId].ec),_step11;!(_iteratorNormalCompletion11=(_step11=_iterator11.next()).done);_iteratorNormalCompletion11=true){var td=_step11.value;detailEc.set(td.id,td);}// let colheads = new Map(Object.entries(store.dataJson.etables["detail_" + detailId].colheads));
}catch(err){_didIteratorError11=true;_iteratorError11=err;}finally{try{if(!_iteratorNormalCompletion11&&_iterator11.return){_iterator11.return();}}finally{if(_didIteratorError11){throw _iteratorError11;}}}var rowheads=new _map2.default((0,_entries2.default)(store.dataJson.etables["detail_"+detailId].rowheads));// handleWidth(colheads);
// detailEc.set("colheads", colheads);
detailEc.set("rowheads",rowheads);detailTableAnalysis(element,detailId);return;}if(element.tagName==='TR'&&$(element).is(":visible")){// 一行
var coloumn=new _map2.default();var coordinate=null;for(var j=0;j<element.children.length;j++){var cell=element.children[j];if(cell.tagName==="TD"&&$(cell).is(":visible")&&!(cell.className.includes("_hide_")||cell.className.includes("tab_"))){// 一个单元格
var attrs=new _map2.default();var cellTd=$(cell);var classname="";if(cellTd.attr("class")!==undefined&&cellTd.attr("class")!==null&&cellTd.attr("class").includes("etype")){classname=cellTd.attr("class").substring(0,cellTd.attr("class").indexOf("etype")-1);}if(classname!==""){coordinate=classname.substring(7).split("_");var id=coordinate[0]+","+coordinate[1];try{attrs=new _map2.default((0,_entries2.default)(mainEc.get(id)));attrs.set("width",cellTd.css("width").replace("px",""));attrs.set("height",cellTd.css("height").replace("px",""));attrs.set("colspan",cellTd.attr("colspan"));attrs.set("rowspan",cellTd.attr("rowspan"));}catch(e){}if(undefined!==mainEc.get(id)&&undefined!==mainEc.get(id).mcpoint){attrs.set("mcpoint",store.dataJson.etables[mainEc.get(id).mcpoint].ec);}}else{if(cellTd.children().length>0){continue;}attrs.set("colspan",cellTd.attr("colspan"));attrs.set("rowspan",cellTd.attr("rowspan"));attrs.set("height",cellTd.css("height").substring(0,cellTd.css("height").indexOf("px")));if(coloumn.size===0){coloumn.set(j+"",attrs);attrs.set("width",mainEc.get("colheads").get("col_"+j));}else{var key=Number((0,_from2.default)(coloumn.keys()).pop());attrs.set("width",cellTd.css("width").replace("px",""));attrs.set("height",cellTd.css("height").replace("px",""));if(coloumn.get(key+"").get("colspan")===undefined){coloumn.set(key+1+"",attrs);}else{coloumn.set(key+Number(coloumn.get(key+"").get("colspan"))+"",attrs);}}continue;}getText(cell,attrs,"");var items=cellTd.find("table[class=excelDetailTable]");if(items.size()>0){var _id3=0;for(var i=0;i<items.size();i++){if(/oTable\d+$/.test(items[i].id)){_id3=Number(items[i].id.replace("oTable",""))+1;break;}}attrs.set("text","明细表"+_id3);attrs.set("font-weight","400");attrs.set("link","'明细表"+_id3+"'!A1");attrs.set("height","40");coloumn.set(coordinate[1],attrs);continue;}if(cellTd.find("table[class*=ViewForm]").size()>0&&cellTd.find("table[class*=ViewForm]").size()===cellTd.find("table").size()){attrs.set("text","内部或外部链接");attrs.set("font-weight","400");attrs.set("height","40");}if(cellTd.attr("class").includes("etype_12")){tabsCount=cellTd.find("table.excelDetailTable").size();tabsRow=Number(coordinate[0]);}coloumn.set(coordinate[1],attrs);}}if(coordinate!==null){if(tabsRow!==0&&Number(coordinate[0])>tabsRow){coordinate[0]=tabsCount-1+Number(coordinate[0]);}mainMap.set(coordinate[0],coloumn);}}for(var _i2=0;_i2<element.children.length;_i2++){recursiveDFS(element.children[_i2]);}}// map转为json
function mapToObject(table){var out=(0,_create2.default)(null);table.forEach(function(value,key){if(value instanceof _map2.default){out[key]=mapToObject(value);}else{out[key]=value;}});return out;}function getCanvasBase64(img){var image=new Image();image.crossOrigin='';image.src=img;var deferred=$.Deferred();if(img){image.onload=function(){deferred.resolve(getBase64Image(image));};return deferred.promise();}}// get base64 url with a img object
function getBase64Image(img){var c=document.createElement("canvas");c.width=img.naturalWidth;c.height=img.naturalHeight;var ctx=c.getContext("2d");ctx.drawImage(img,0,0,c.width,c.height);return c.toDataURL();}// 方法入口
var getStyleJson=exports.getStyleJson=function(){var _ref2=(0,_asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var element,i,detailRowMap;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return init();case 2:element="";if($("#reqIframe").size()===0){element=$(".wf-req-form")[0];}else{element=document.getElementById("reqIframe").contentWindow.document.getElementsByClassName("wf-req-form")[0];}recursiveDFS(element);for(i=1;i<tabsCount;i++){detailRowMap=new _map2.default(table.get("maintable").get(""+tabsRow));table.get("maintable").set(""+(tabsRow+i),detailRowMap);}return _context2.abrupt('return',(0,_stringify2.default)(mapToObject(table)));case 7:case'end':return _context2.stop();}}},_callee2,undefined);}));return function getStyleJson(){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(493), __esModule: true };


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(494);
module.exports = __webpack_require__(13).Object.entries;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(21);
var $entries = __webpack_require__(495)(true);
$export($export.S, 'Object', {
    entries: function entries(it) {
        return $entries(it);
    }
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(23);
var getKeys = __webpack_require__(52);
var toIObject = __webpack_require__(38);
var isEnum = __webpack_require__(64).f;
module.exports = function (isEntries) {
    return function (it) {
        var O = toIObject(it);
        var keys = getKeys(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while (length > i) {
            key = keys[i++];
            if (!DESCRIPTORS || isEnum.call(O, key)) {
                result.push(isEntries ? [key, O[key]] : O[key]);
            }
        }
        return result;
    };
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
__webpack_require__(72);
module.exports = __webpack_require__(497);


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(34);
var get = __webpack_require__(150);
module.exports = __webpack_require__(13).getIterator = function (it) {
    var iterFn = get(it);
    if (typeof iterFn != 'function')
        throw TypeError(it + ' is not iterable!');
    return anObject(iterFn.call(it));
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _class,_temp,_initialiseProps;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var instance=null;var WaterMark=(_temp=_class=function WaterMark(options,doc){(0,_classCallCheck3.default)(this,WaterMark);_initialiseProps.call(this);this.setOptions(options,doc);this.update();}// 判断重新生成dom条件
,_initialiseProps=function _initialiseProps(){var _this=this;this.doc=window.top.document;this.type="text";this.len=0;this.html="";this.timer=null;this.options={// text / img
text:"WATERMARK",fontStyle:"font-size:18px;color:#000;",src:"",width:200,height:150,rotate:-15,alpha:0.15,interval:2000,intervalCheck:true,clickCheck:true};this.handleClick=function(){if(_this.checkChange()){_this.update();}};this.des=function(){clearInterval(_this.timer);window.top.onresize=undefined;_this.doc.removeEventListener("click",_this.handleClick);var wmWrap=_this.doc.getElementById("wf_watremark_wrap");if(wmWrap){_this.doc.body.removeChild(wmWrap);}};this.checkChange=function(){var wrap=_this.doc.getElementById("wf_watremark_wrap");return!wrap||wrap.innerHTML!==_this.html;};this.setOptions=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var doc=arguments[1];if(doc)_this.doc=doc;_this.options=(0,_extends3.default)({},_this.options,options);var _options=_this.options,intervalCheck=_options.intervalCheck,interval=_options.interval,clickCheck=_options.clickCheck;if(_this.timer){clearInterval(_this.timer);}if(intervalCheck){_this.timer=setInterval(function(){return _this.handleClick();},interval);}if(clickCheck){_this.doc.addEventListener("click",_this.handleClick);}else{_this.doc.removeEventListener("click",_this.handleClick);}window.top.onresize=function(){_this.update(options);};};this.isUpdate=function(marks){var _options2=_this.options,alpha=_options2.alpha,rotate=_options2.rotate;if(!marks||marks.length===0){// 初始化
return true;}else if(marks.length!=_this.len){// 修改宽高的值
return true;}else if(marks[0].style.transform!=="rotate("+rotate+"deg)"){// 修改旋转角度
return true;}else if(marks[0].style.opacity!==alpha){// 修改透明度
return true;}return false;};this.update=function(type){var _options3=_this.options,src=_options3.src,alpha=_options3.alpha,rotate=_options3.rotate,text=_options3.text,fontStyle=_options3.fontStyle;var _options4=_this.options,width=_options4.width,height=_options4.height;width=width>0?width:200;height=height>0?height:150;var wrap=_this.doc.getElementById("wf_watremark_wrap");if(!wrap){wrap=_this.doc.createElement("div");wrap.id="wf_watremark_wrap";_this.doc.body.appendChild(wrap);}var bg=_this.doc.getElementById("wf_watremark");if(!bg){bg=_this.doc.createElement("div");bg.id="wf_watremark";bg.style.display="block";bg.style.pointerEvents="none";bg.style.position="fixed";bg.style.width="100%";bg.style.height="100%";bg.style.zIndex=999999;bg.style.top=0;bg.style.left=0;bg.style.textAlign="center";bg.style.overflow='hidden';wrap.appendChild(bg);}// 检测图片是否有效
if(src&&type!=="text"){_this.type="img";var img=_this.doc.getElementById("wf_watremark_img_test");if(!img){img=_this.doc.createElement("img");img.id="wf_watremark_img_test";img.style.display="none";img.onerror=function(){_this.type="text";_this.update(_this.type);};_this.doc.body.appendChild(img);}img.src=src;}else{_this.type="text";}var w=_this.doc.documentElement.clientWidth;var h=_this.doc.documentElement.clientHeight;var x=Math.ceil(w/width);var y=Math.ceil(h/height);_this.len=x*y+2;var marks=_this.doc.querySelectorAll(".wf-watremark-mark");if(_this.isUpdate(marks)){bg.innerHTML="";for(var i=0;i<_this.len;i++){var mark=_this.doc.createElement("div");mark.className="wf-watremark-mark";mark.style.width=width+"px";mark.style.height=height+"px";mark.style.pointerEvents="none";mark.style.zIndex=-1;mark.style.float="left";mark.style.overflow="visible";mark.style.opacity=alpha;mark.style.transform="rotate("+rotate+"deg)";mark.style["-ms-transform"]="rotate("+rotate+"deg)";mark.style.position="relative";bg.appendChild(mark);}marks=_this.doc.querySelectorAll(".wf-watremark-mark");}Array.prototype.forEach.call(marks,function(m,i){if(x!==1&&(i+1)%x===0){m.style.marginRight="-"+width+"px";}else{m.style.marginRight="0";}if(_this.type==="text"){m.innerHTML="<div style=\"width:100%;position:absolute;top:50%;transform:translateY(-50%);\"><p style=\"pointer-events:none;"+fontStyle+"\">"+text+"</p></div>";}else{m.innerHTML="<img alt=\"\" src=\""+src+"\" style=\"position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);pointer-events:none;max-width:100%;max-height:100%;\"></img>";}});_this.html=wrap.innerHTML;};},_temp);var WfWaterMark=function WfWaterMark(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var doc=arguments[1];if(instance){instance.setOptions(options,doc);instance.update();}else{instance=new WaterMark(options,doc);}};// 清除水印
WfWaterMark.destory=function(){if(instance){instance.des();instance=null;}};// 格式化文档水印文本内容
function formatContent(options){var text=options.text||"";var fontStyle="font-family:"+(options.familyname||"微软雅黑")+";font-size:"+(options.fontsize||14)+"px;color:"+(options.color||"#000")+";";var lines="";// 处理多行文本的换行
text.split("\n").forEach(function(line){return lines+="<p style=\""+fontStyle+"\">"+line+"</p>";});text=lines;return text;}// 处理水印设置内容
var handleWMSetting=function handleWMSetting(){var wmSetting=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var rotate=-Number(wmSetting.rotate);var alpha=Number(wmSetting.opacity)/100;var options={src:wmSetting.watermarktype=="2"?"/weaver/weaver.file.FileDownload?fileid="+wmSetting.imageid:"",text:wmSetting.watermarktype=="1"?params&&params.document?formatContent(wmSetting):wmSetting.wmcontent:"",width:wmSetting.wmwidth>0?wmSetting.wmwidth:200,height:wmSetting.wmheight>0?wmSetting.wmheight:150,rotate:rotate,alpha:alpha};return options;};// 处理水印黑白名单规则
var handleSettingByHash=function handleSettingByHash(wmSetting){var pathname=window.location.pathname||"";var hash=window.location.hash||"";var index=hash.indexOf("?");index=index!==-1?index:hash.length-1;var href=pathname+hash.substring(0,index);if(wmSetting){var isopen=wmSetting.isopen,whitelist=wmSetting.whitelist,blacklist=wmSetting.blacklist;var list=isopen===1||isopen==="1"?blacklist:whitelist;var match=(list||[]).findIndex(function(value){return new RegExp(value).test(href);});if(match!==-1){isopen===1||isopen==="1"?WfWaterMark.destory():WfWaterMark(handleWMSetting(wmSetting));}else{isopen===1||isopen==="1"?WfWaterMark(handleWMSetting(wmSetting)):WfWaterMark.destory();}}};// 处理hash变化
var handleHashChange=function handleHashChange(){handleSettingByHash(WfWaterMark.wmSetting);};// 监听哈希变化
if("onhashchange"in window){if(window.addEventListener){window.removeEventListener("hashchange",handleHashChange);window.addEventListener("hashchange",handleHashChange);}else if(window.attachEvent){window.detachEvent("onhashchange",handleHashChange);window.attachEvent("onhashchange",handleHashChange);}else{window.onhashchange=handleHashChange;}}WfWaterMark.handleHashChange=handleHashChange;WfWaterMark.handleWMSetting=handleWMSetting;WfWaterMark.handleSettingByHash=handleSettingByHash;WfWaterMark.formatContent=formatContent;exports.default=WfWaterMark;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.GlobalStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_dec3,_dec4,_dec5,_dec6,_dec7,_dec8,_dec9,_dec10,_dec11,_dec12,_dec13,_dec14,_dec15,_dec16,_dec17,_dec18,_dec19,_dec20,_dec21,_dec22,_dec23,_dec24,_dec25,_dec26,_dec27,_dec28,_dec29,_dec30,_dec31,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35,_descriptor36,_descriptor37,_descriptor38,_descriptor39,_descriptor40,_descriptor41,_descriptor42,_descriptor43,_descriptor44,_descriptor45,_descriptor46,_descriptor47,_descriptor48,_descriptor49,_descriptor50,_descriptor51,_descriptor52,_descriptor53,_descriptor54,_descriptor55,_descriptor56,_descriptor57,_descriptor58,_descriptor59,_descriptor60,_descriptor61,_descriptor62,_descriptor63,_descriptor64;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _base=__webpack_require__(177);var _base2=_interopRequireDefault(_base);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _base3=__webpack_require__(12);var _base4=_interopRequireDefault(_base3);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _continuationProcessUtil=__webpack_require__(131);var continuationProcessUtil=_interopRequireWildcard(_continuationProcessUtil);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _invoiceUtil=__webpack_require__(132);var _encryptUtil=__webpack_require__(254);var EncryptUtil=_interopRequireWildcard(_encryptUtil);var _loadjs=__webpack_require__(83);var _loadjs2=_interopRequireDefault(_loadjs);var _objectAssign=__webpack_require__(88);var _objectAssign2=_interopRequireDefault(_objectAssign);var _convert=__webpack_require__(6);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);var _submit=__webpack_require__(57);var _rightBtn=__webpack_require__(85);var _odocUtil=__webpack_require__(500);var _lodash=__webpack_require__(255);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _conformRuleUtil=__webpack_require__(250);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools,WeaLocaleProvider=_getEcCom.WeaLocaleProvider;var ls=WeaTools.ls;//useStrict(true);
var GlobalStore=exports.GlobalStore=(_dec=(0,_mobx.action)('控制JS是否异步加载完成'),_dec2=(0,_mobx.action)('添加全量组件库加载完后才能执行的事件'),_dec3=(0,_mobx.action)('执行加载完事件，仅触发一次，触发完立即清除'),_dec4=(0,_mobx.action)('控制加载条'),_dec5=(0,_mobx.action)('控制按钮置灰'),_dec6=(0,_mobx.action)('API控制按钮置灰'),_dec7=(0,_mobx.action)("控制发票云参数"),_dec8=(0,_mobx.action)('控制当前显示tab'),_dec9=(0,_mobx.action)('发送接口加载数据'),_dec10=(0,_mobx.action)('加载表单信息'),_dec11=(0,_mobx.action)('模板预览加载数据'),_dec12=(0,_mobx.action)('加载右键菜单'),_dec13=(0,_mobx.action)('加载流程连续处理信息'),_dec14=(0,_mobx.action)('设置右键菜单'),_dec15=(0,_mobx.action)('改变提交参数'),_dec16=(0,_mobx.action)('设置提交到指定节点'),_dec17=(0,_mobx.action)('设置关闭是否需要提示'),_dec18=(0,_mobx.action)('控制右键弹窗'),_dec19=(0,_mobx.action)('加载签字意见输入信息'),_dec20=(0,_mobx.action)("加载流程干预信息"),_dec21=(0,_mobx.action)("流程干预切换节点"),_dec22=(0,_mobx.action)("流程干预切换节点"),_dec23=(0,_mobx.action)("重置状态"),_dec24=(0,_mobx.action)("获取扩展Tab"),_dec25=(0,_mobx.action)("修改表单密级信息"),_dec26=(0,_mobx.action)("更新commonParam值"),_dec27=(0,_mobx.action)("更新remindInfo"),_dec28=(0,_mobx.action)("请求当前流程拥有的关注标签"),_dec29=(0,_mobx.action)("获取手写签批内容并放入变量区"),_dec30=(0,_mobx.action)('设置流程二次确认提示信息'),_dec31=(0,_mobx.action)('冲突字段值记录'),(_class=function(_BaseStore){(0,_inherits3.default)(GlobalStore,_BaseStore);(0,_createClass3.default)(GlobalStore,[{key:'baseParam',get:function get(){var _this3=this;//基础参数
var baseParam={};GlobalUtil.baseParamRange.map(function(k){baseParam[k]=_this3.commonParam[k];});return baseParam;}//标识完整组件库资源是否加载完成
},{key:'commonApiParam',get:function get(){var _this4=this;//常用参数，供后端API接口调用
var apiParam={};GlobalUtil.commonApiParamRange.map(function(k){apiParam[k]=_this4.commonParam[k];});return apiParam;}},{key:'belongUserStr',get:function get(){var _commonParam=this.commonParam,f_weaver_belongto_userid=_commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=_commonParam.f_weaver_belongto_usertype;return'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype='+f_weaver_belongto_usertype;}},{key:'isSourceLayout',get:function get(){var layoutversion=this.commonParam.layoutversion;return layoutversion===0||layoutversion===1;}//常用有效参数
//剩余无效参数,后期去掉
//签字意见输入框相关信息
//离开表单是否提示
//右键菜单
//弹窗显示属性
//流程干预
//顶部提示信息
//提醒信息
//数据保护验证的信息
//密级信息
//流程连续处理信息
//表单冲突字段
}]);//签字意见框按钮显示名称
function GlobalStore(){(0,_classCallCheck3.default)(this,GlobalStore);var _this2=(0,_possibleConstructorReturn3.default)(this,(GlobalStore.__proto__||(0,_getPrototypeOf2.default)(GlobalStore)).call(this));_initDefineProp(_this2,'JSComplete',_descriptor,_this2);_this2.JSCompleteEvent=[];_this2.browserVersion="";_this2.urlParams={};_initDefineProp(_this2,'loading',_descriptor2,_this2);_initDefineProp(_this2,'tabKey',_descriptor3,_this2);_initDefineProp(_this2,'btnDisabled',_descriptor4,_this2);_initDefineProp(_this2,'apiBtnDisabled',_descriptor5,_this2);_this2.commonParam={};_this2.invalidParam={};_initDefineProp(_this2,'submitParam',_descriptor6,_this2);_initDefineProp(_this2,'markInfo',_descriptor7,_this2);_this2.closeNeedPrompt=true;_initDefineProp(_this2,'rightMenu',_descriptor8,_this2);_initDefineProp(_this2,'dialogVisible',_descriptor9,_this2);_initDefineProp(_this2,'invertionInfo',_descriptor10,_this2);_initDefineProp(_this2,'promptInfo',_descriptor11,_this2);_initDefineProp(_this2,'remindInfo',_descriptor12,_this2);_initDefineProp(_this2,'secondAuthInfo',_descriptor13,_this2);_initDefineProp(_this2,'secLevelInfo',_descriptor14,_this2);_initDefineProp(_this2,'continuationProcessInfo',_descriptor15,_this2);_initDefineProp(_this2,'conflictFieldMap',_descriptor16,_this2);_initDefineProp(_this2,'odocIframeUrl',_descriptor17,_this2);_initDefineProp(_this2,'btnLabelName',_descriptor18,_this2);_initDefineProp(_this2,'markJSComplete',_descriptor19,_this2);_initDefineProp(_this2,'pushJSCompleteEvent',_descriptor20,_this2);_initDefineProp(_this2,'triggerJSCompleteEvent',_descriptor21,_this2);_initDefineProp(_this2,'setLoading',_descriptor22,_this2);_initDefineProp(_this2,'setBtnDisabled',_descriptor23,_this2);_initDefineProp(_this2,'setApiBtnDisabled',_descriptor24,_this2);_initDefineProp(_this2,'setInvoiceCloudInfo',_descriptor25,_this2);_initDefineProp(_this2,'setTabKey',_descriptor26,_this2);_initDefineProp(_this2,'loadBaseInfo',_descriptor27,_this2);_initDefineProp(_this2,'doInit',_descriptor28,_this2);_initDefineProp(_this2,'loadPreViewInfo',_descriptor29,_this2);_this2.showCAAuthDialog=function(data){var isCAAuth=_this2.urlParams.isCAAuth;var CAKey=_this2.urlParams.CAKey;if(isCAAuth=="1"){var secondAuthStore=_base4.default.secondAuthStore;var secondAuthConfig=data.secondAuthConfig;var _secondAuthConfig$qys=secondAuthConfig.qysSignWay,qysSignWay=_secondAuthConfig$qys===undefined?2:_secondAuthConfig$qys,protectType=secondAuthConfig.protectType;secondAuthStore.setCallbackFunc(_submit.doFileUpload);if(!!CAKey){//从缓存中先读取之前的数据
secondAuthStore.readDataFromStorage(CAKey);}secondAuthStore.setParams(secondAuthConfig);if(protectType==authTypes.QYS&&qysSignWay==1){window.QYSUKeyUtil.showSignWin(secondAuthStore);}else if(protectType==authTypes.CA_AUTH){_this2.controlDialogVisible(authTypes.SECOND_AUTH_DIALOG,true);}}};_initDefineProp(_this2,'loadRightMenu',_descriptor30,_this2);_initDefineProp(_this2,'loadContinuationProcessInfo',_descriptor31,_this2);_this2.checkShareBtn=function(data){var fn=function fn(){ecCom.WeaTools.checkJoin().then(function(res){var _res$dingTalkShareSwi=res.dingTalkShareSwitch,dingTalkShareSwitch=_res$dingTalkShareSwi===undefined?0:_res$dingTalkShareSwi,_res$emSwitch=res.emSwitch,emSwitch=_res$emSwitch===undefined?0:_res$emSwitch,_res$joinStatus=res.joinStatus,joinStatus=_res$joinStatus===undefined?false:_res$joinStatus,msgShowType=res.msgShowType,status=res.status,_res$webSwitch=res.webSwitch,webSwitch=_res$webSwitch===undefined?0:_res$webSwitch,_res$wxWorkShareSwitc=res.wxWorkShareSwitch,wxWorkShareSwitch=_res$wxWorkShareSwitc===undefined?0:_res$wxWorkShareSwitc,_res$shareWorkflow=res.shareWorkflow,shareWorkflow=_res$shareWorkflow===undefined?0:_res$shareWorkflow;var ua=window.navigator.userAgent;shareWorkflow=joinStatus==true&&shareWorkflow==1;if(/.*E-Mobile7.*/.test(ua)||/.*E-Mobile\/7.*/.test(ua)){//Emobile7环境
shareWorkflow=shareWorkflow&&emSwitch==1;}else if(/.*MicroMessenger.*/.test(ua)){//微信
shareWorkflow=shareWorkflow&&wxWorkShareSwitch==1;}else if(/.*DingTalk.*/.test(ua)){//钉钉
shareWorkflow=shareWorkflow&&dingTalkShareSwitch==1;}_this2.setRightMenu(data,shareWorkflow);});};_this2.pushJSCompleteEvent(fn);};_initDefineProp(_this2,'setRightMenu',_descriptor32,_this2);_initDefineProp(_this2,'changeSubmitParam',_descriptor33,_this2);_initDefineProp(_this2,'setSubmitToNodeId',_descriptor34,_this2);_initDefineProp(_this2,'setCloseNeedPrompt',_descriptor35,_this2);_initDefineProp(_this2,'controlDialogVisible',_descriptor36,_this2);_initDefineProp(_this2,'loadMarkInfo',_descriptor37,_this2);_initDefineProp(_this2,'setMarkInfo',_descriptor38,_this2);_initDefineProp(_this2,'loadInterventionInfo',_descriptor39,_this2);_initDefineProp(_this2,'setInvertionInfo',_descriptor40,_this2);_initDefineProp(_this2,'getInterventionUser',_descriptor41,_this2);_initDefineProp(_this2,'setInterventionUserReplacedata',_descriptor42,_this2);_initDefineProp(_this2,'resetStore',_descriptor43,_this2);_initDefineProp(_this2,'loadCustomTab',_descriptor44,_this2);_initDefineProp(_this2,'setSecLevelInfo',_descriptor45,_this2);_initDefineProp(_this2,'updateCommonParam',_descriptor46,_this2);_initDefineProp(_this2,'updateRemindInfo',_descriptor47,_this2);_initDefineProp(_this2,'getFormAttentionTag',_descriptor48,_this2);_initDefineProp(_this2,'changeHandWritingData',_descriptor49,_this2);_initDefineProp(_this2,'setPromptInfo',_descriptor50,_this2);_initDefineProp(_this2,'setPromptInfos',_descriptor51,_this2);_initDefineProp(_this2,'jumpTab',_descriptor52,_this2);_initDefineProp(_this2,'changeConflictFieldMap',_descriptor53,_this2);_initDefineProp(_this2,'addInnerChangeBtn',_descriptor54,_this2);_initDefineProp(_this2,'innerChangeDialog',_descriptor55,_this2);_initDefineProp(_this2,'setInnerChangeDialog',_descriptor56,_this2);_initDefineProp(_this2,'FreeflowChangeformParm',_descriptor57,_this2);_initDefineProp(_this2,'freeflowChangeformParmfixedForm',_descriptor58,_this2);_initDefineProp(_this2,'FreeflowChangeformParmconditions',_descriptor59,_this2);_initDefineProp(_this2,'setFreeflowChangeformParm',_descriptor60,_this2);_initDefineProp(_this2,'getFreeNodeBrowserItem',_descriptor61,_this2);_initDefineProp(_this2,'odocCustomTabs',_descriptor62,_this2);_initDefineProp(_this2,'isDefaultOpenOdoc',_descriptor63,_this2);_initDefineProp(_this2,'getOdocTabManagerDatas',_descriptor64,_this2);_this2.browserVersion=Util.getBrowserVersion();return _this2;}//打开CA认证的窗口
//判断是否显示分享按钮
/*-------------公文交换----------------*///是否加载公文交换右键菜单
//内部交换弹窗显隐
//自由流程设置表单后台配置信息
//自由流程设置表单后台配置信息
//自由流程设置表单后台配置信息
/**---------------公文自定义页签------------------- *///获取自定义页签
return GlobalStore;}(_base2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'JSComplete',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'tabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"form";}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'btnDisabled',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'apiBtnDisabled',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'baseParam',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'baseParam'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'commonApiParam',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'commonApiParam'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'belongUserStr',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'belongUserStr'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isSourceLayout',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'isSourceLayout'),_class.prototype),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'submitParam',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'markInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'rightMenu',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'dialogVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'invertionInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'promptInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'remindInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'secondAuthInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'secLevelInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'continuationProcessInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'conflictFieldMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'odocIframeUrl',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'btnLabelName',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'markJSComplete',[_dec],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.JSComplete=true;};}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'pushJSCompleteEvent',[_dec2],{enumerable:true,initializer:function initializer(){var _this6=this;return function(fn){if(typeof fn==="function"){if(_this6.JSCompleteEvent instanceof Array)_this6.JSCompleteEvent.push(fn);else//已经执行过一次的情况，直接触发
fn();}};}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'triggerJSCompleteEvent',[_dec3],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){if(_this7.JSComplete===true&&_this7.JSCompleteEvent instanceof Array){_this7.JSCompleteEvent.map(function(fn){fn();});_this7.JSCompleteEvent=null;//赋值非数组，标识已执行过
}};}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'setLoading',[_dec4],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){var bool=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this8.loading=bool;};}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'setBtnDisabled',[_dec5],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){var bool=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this9.btnDisabled=bool;};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'setApiBtnDisabled',[_dec6],{enumerable:true,initializer:function initializer(){var _this10=this;return function(){var bool=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this10.apiBtnDisabled=bool;};}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'setInvoiceCloudInfo',[_dec7],{enumerable:true,initializer:function initializer(){var _this11=this;return function(invoiceCloudInfo){_this11.invoiceCloudInfo=invoiceCloudInfo;};}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'setTabKey',[_dec8],{enumerable:true,initializer:function initializer(){var _this12=this;return function(key){if(_.isEmpty(_this12.commonParam))return;_this12.signReplyFlag=false;//清空回复的状态
_this12.signReplyInfo={};//清空被回复人的信息
_this12.tabKey=key;//记录tab项是否已点击过
var variableKey='haveClick_'+key;!_this12.variableMap.has(variableKey)&&_this12.controlVariableMap(variableKey,true);};}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'loadBaseInfo',[_dec9],{enumerable:true,initializer:function initializer(){var _this13=this;return function(queryParams){delete queryParams["_key"];_this13.urlParams=queryParams;if(_this13.urlParams.isPreView==="1")return _this13.loadPreViewInfo();var beforeFn=function beforeFn(){//弹出连续处理切换提示
_this13.pushJSCompleteEvent(function(){continuationProcessUtil.showConProcessSwitchTip(queryParams);});_this13.setLoading(true);window.API_LOAD_BEGIN=new Date().getTime();};var afterFn=function afterFn(data){window.API_LOAD_END=new Date().getTime();window.API_DURATION=window.API_LOAD_END-window.API_LOAD_BEGIN;window.SERVER_DURATION=data.durationTime;_this13.doInit(queryParams,data);if(data.conflictFieldInfo&&(0,_typeof3.default)(data.conflictFieldInfo)=='object'){_this13.changeConflictFieldMap(data.conflictFieldInfo);}// if (data.odocInfo.docFlag && data.odocInfo.isInnerChange == '1') {
//     this.addInnerChangeBtn = true;
// }
};EncryptUtil.verifyEncryptShare(_this13.urlParams,function(){EncryptUtil.verifySecondAuth(_this13.urlParams,beforeFn,afterFn);});};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'doInit',[_dec10],{enumerable:true,initializer:function initializer(){var _this14=this;return function(queryParams,data){_this14.setLoading(false);var params=data.params;//无权限跳转
if(params.verifyRight===false){weaWfFormHistory&&weaWfFormHistory.push("/main/workflow/ReqNoRight?isSecNoRight="+params.isSecNoRight+"&isDelete="+params.requestIsDelete+"&isTest="+params.isTest);return;}//设置有效常用参数
GlobalUtil.commonParamRange.map(function(v){if(v in params){_this14.commonParam[v]=params[v];delete params[v];}});//剩余无效参数(后期逐步去掉)
_this14.invalidParam=params;//加载自定义样式文件
GlobalUtil.loadCustomFiles("css");_this14.submitParam=data.submitParams;//密级信息
_this14.secLevelInfo=data.secLevelInfo;//初始化模板及表单内容
_base4.default.layoutStore.doInitLayout(data);Util.printDuration(_this14.commonParam,true);//更新请求信息及刷新待办，快速处理信息加载完毕后，再执行
var updateReqInfoFunc=function updateReqInfoFunc(){var _commonParam2=_this14.commonParam,requestid=_commonParam2.requestid,iscreate=_commonParam2.iscreate,nodetype=_commonParam2.nodetype,wfmonitor=_commonParam2.wfmonitor,isurger=_commonParam2.isurger,isprint=_commonParam2.isprint;if(iscreate!="1"&&isprint!='1'){var _data$submitParams=data.submitParams,submitParams=_data$submitParams===undefined?{}:_data$submitParams;var updateReqInfoParams=(0,_extends3.default)({},submitParams,{requestid:requestid,currentnodetype:nodetype,wfmonitor:wfmonitor,isurger:isurger},GlobalUtil.getUpdateReqInfoFieldValue());API_REQ.updateReqInfo(updateReqInfoParams).then(function(data){//传参刷新列表，列表再依赖参数判断是否刷新
_this14.pushJSCompleteEvent(function(){Util.reloadListPage({from:"openReq",needReloadList:_this14.commonParam.needReloadList});});});}};//加载公文自定义页签
_this14.getOdocTabManagerDatas();//加载顶部快速处理信息
_this14.loadContinuationProcessInfo(queryParams,updateReqInfoFunc);//设置顶部提示信息
_this14.promptInfos=data.promptInfos;//设置提醒类型信息
_this14.remindInfo=data.remindInfo;//数据保护的验证信息
_this14.secondAuthInfo=data.secondAuthInfo;//加载右键菜单
_this14.loadRightMenu(queryParams);//加载签字意见输入框信息
_this14.loadMarkInfo();//加载流程干预
_this14.loadInterventionInfo();//tab扩展
_this14.loadCustomTab();//显示CA认证的窗口
_this14.showCAAuthDialog(data);//请求当前流程拥有的关注标签
_this14.getFormAttentionTag();//加载水印
_this14.pushJSCompleteEvent(Util.loadWaterMark);//加载发票云token
if(_this14.commonParam.useInvoiceCloud==true){(0,_invoiceUtil.getInvoiceCloudToken)();}// if(params.openNodeCheck) {
//   conformRule(); // 绑定合规
// }
var showSelectOtherEditMould=false;//有编辑模板替换时不走这里
if(data.odocInfo.docFlag&&data.odocInfo.docParam.docid<0&&data.odocInfo.docParam.editmouldCount>1||data.odocInfo.docFlag&&data.odocInfo.docParam.docid>0&&data.odocInfo.docParam.reSelectMould){showSelectOtherEditMould=true;}if(data.odocInfo.docFlag&&data.odocInfo.opentextdefaultnode&&!data.odocInfo.docParam.isUseTempletNode&&!showSelectOtherEditMould&&data.odocInfo.docParam.docid>0&&!data.odocInfo.docParam.isTextInFormCanEdit&&data.odocInfo.docParam.isEdit!=1){(0,_odocUtil.setDocParam)(WfForm.getOdocConfig());_this14.tabKey='odoc';}};}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'loadPreViewInfo',[_dec11],{enumerable:true,initializer:function initializer(){var _this15=this;return function(){var preViewKey=_this15.urlParams.preViewKey;if(window.sessionStorage.getItem(preViewKey)){var preViewData=JSON.parse(window.sessionStorage.getItem(preViewKey));API_REQ.loadPreViewInfo(preViewData).then(function(data){console.log("preViewData",preViewData,"data",data);_this15.commonParam=data.params;_base4.default.layoutStore.doInitLayout(data);});}else{alert('loadPreViewInfo Catch Exception: '+preViewKey);}};}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'loadRightMenu',[_dec12],{enumerable:true,initializer:function initializer(){var _this16=this;return function(queryParams){var params=(0,_extends3.default)({},_this16.commonApiParam);//提交确认参数
params.isaffirmanceSrc=queryParams.isaffirmanceSrc||"";params.isaffirmance=queryParams.isaffirmance||"";params.reEdit=queryParams.reEdit||"";API_REQ.getRightMenu(params).then(function(data){data.rightMenus&&data.rightMenus.sort(function(o1,o2){return o1.order-o2.order;});var _data=(0,_lodash.cloneDeep)(data);_this16.checkShareBtn(_data);_this16.setRightMenu(data,false);});};}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'loadContinuationProcessInfo',[_dec13],{enumerable:true,initializer:function initializer(){var _this17=this;return function(queryParams,updateReqInfoFunc){if(queryParams.isOpenContinuationProcess=='1'&&!queryParams.isRefresh=='1'){//连续处理进来，且不是刷新表单，获取连续处理信息
var continuationProcessParams=continuationProcessUtil.getContinuationProcessParams();API_REQ.getContinnuationProcessInfo((0,_extends3.default)({viewScope:"doing",currentRequestId:queryParams.requestid},continuationProcessParams)).then(function(data){if(data.isOpenContinuationProcess&&data.currentIndex>=0){_this17.continuationProcessInfo={loaded:true,showSwitchBar:data.showSwitchBar,currentIndex:data.currentIndex,counts:data.count,requestId:queryParams.requestid};}else{_this17.urlParams.isOpenContinuationProcess='0';}//更新请求信息及刷新待办，这里加3S延时，防止前一条流程提交完毕时，刷列表的事件被覆盖
window.setTimeout(function(){updateReqInfoFunc();},3000);});}else{//更新请求信息及刷新待办
updateReqInfoFunc();}//连续处理保存表单刷新流程，直接取上次的连续处理信息显示
if(queryParams.isOpenContinuationProcess=='1'&&queryParams.isRefresh=='1'){_this17.continuationProcessInfo={loaded:true,isRefresh:'1',currentIndex:queryParams.currentIndex,counts:queryParams.counts,requestId:queryParams.requestid,showSwitchBar:queryParams.showSwitchBar};}};}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'setRightMenu',[_dec14],{enumerable:true,initializer:function initializer(){var _this18=this;return function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var shareWorkflow=arguments[1];if(!shareWorkflow){//屏蔽分享按钮
data.rightMenus&&data.rightMenus.length>0?data.rightMenus=data.rightMenus.filter(function(item){return item.type!=="BTN_SHARE";}):"";}var rightMenuNames={};//右键菜单对应的自定义名称
data.rightMenus&&data.rightMenus.length>0&&data.rightMenus.map(function(item){var _item$systemMenuType=item.systemMenuType,systemMenuType=_item$systemMenuType===undefined?'':_item$systemMenuType,_item$systemSmallType=item.systemSmallType,systemSmallType=_item$systemSmallType===undefined?0:_item$systemSmallType,_item$menuName=item.menuName,menuName=_item$menuName===undefined?'':_item$menuName;if(systemMenuType.length>0&&menuName.length>0){rightMenuNames[systemMenuType+'_'+systemSmallType]=menuName;}});data.rightMenuNames=rightMenuNames;_this18.rightMenu=data;var isImportDetail=data.isImportDetail;if(isImportDetail&&_this18.urlParams.saveType==="doImportDetail"){_this18.controlDialogVisible(type.IMPORT_WF_DETAIL_MODAL,true);}//流程点击流转设置保存流程时，重新打开流转设置
var _commonParam$requesti=_this18.commonParam.requestid,requestid=_commonParam$requesti===undefined?-1:_commonParam$requesti;var isAllowNodeFreeFlow=data.isAllowNodeFreeFlow,isFree=data.isFree;var isDefaultOpenFreeFlowSetDialog=window.localStorage.getItem('WfFormIsDefaultOpenFreeFlowSetDialog');if(requestid>0&&isDefaultOpenFreeFlowSetDialog=='1'&&(isAllowNodeFreeFlow=='1'||isFree=='1')){window.localStorage.removeItem('WfFormIsDefaultOpenFreeFlowSetDialog');if(_this18.JSComplete){(0,_rightBtn.doFreeWorkflow)();}else{_this18.JSCompleteEvent.push(_rightBtn.doFreeWorkflow);}}};}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'changeSubmitParam',[_dec15],{enumerable:true,initializer:function initializer(){var _this19=this;return function(){var param=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this19.submitParam=(0,_extends3.default)({},_this19.submitParam,param);};}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'setSubmitToNodeId',[_dec16],{enumerable:true,initializer:function initializer(){var _this20=this;return function(){var isFromSubmitToReject=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var _rightMenu=_this20.rightMenu,isSubmitDirectNode=_rightMenu.isSubmitDirectNode,lastnodeid=_rightMenu.lastnodeid;var _commonParam$canSubmi=_this20.commonParam.canSubmitToRejectNode,canSubmitToRejectNode=_commonParam$canSubmi===undefined?true:_commonParam$canSubmi;if(_this20.variableMap.has('canSubmitToRejectNode')){canSubmitToRejectNode=_this20.variableMap.get('canSubmitToRejectNode');}if((isSubmitDirectNode=='1'||isFromSubmitToReject)&&canSubmitToRejectNode){_this20.changeSubmitParam({SubmitToNodeid:lastnodeid});}};}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'setCloseNeedPrompt',[_dec17],{enumerable:true,initializer:function initializer(){var _this21=this;return function(){var bool=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this21.closeNeedPrompt=bool;};}}),_descriptor36=_applyDecoratedDescriptor(_class.prototype,'controlDialogVisible',[_dec18],{enumerable:true,initializer:function initializer(){var _this22=this;return function(key,value){_this22.dialogVisible.set(key,value);};}}),_descriptor37=_applyDecoratedDescriptor(_class.prototype,'loadMarkInfo',[_dec19],{enumerable:true,initializer:function initializer(){var _this23=this;return function(){var isInit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var _commonParam3=_this23.commonParam,_commonParam3$isHideI=_commonParam3.isHideInput,isHideInput=_commonParam3$isHideI===undefined?'0':_commonParam3$isHideI,wfTestStr=_commonParam3.wfTestStr,requestType=_commonParam3.requestType,intervenorright=_commonParam3.intervenorright;var signInputParams=(0,_extends3.default)({},_this23.baseParam);signInputParams.wfTestStr=wfTestStr;if(isHideInput!='1'&&(requestType>0||intervenorright>0)){_this23.setBtnDisabled(true);API_REQ.getSignInput(signInputParams).then(function(data){data.hasLoadMarkInfo=true;var _data$remarkquote=data.remarkquote,remarkquote=_data$remarkquote===undefined?[]:_data$remarkquote;_this23.setMarkInfo(data);if(isInit){var _data$remarkInfo=data.remarkInfo,remarkInfo=_data$remarkInfo===undefined?{}:_data$remarkInfo;//设置默认值到submitParams
var updateParams={'remark':remarkInfo['remark'],'field-annexupload':remarkInfo['field-annexupload'],'signdocids':remarkInfo['signdocids'],'signworkflowids':remarkInfo['signworkflowids'],'remarkLocation':remarkInfo['remarkLocation']};_this23.changeSubmitParam(updateParams);var remarkQuoteDatas=_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});;remarkquote.forEach(function(v,i){remarkQuoteDatas.set('key_'+i,v);});_this23.controlVariableMap('remark_list',remarkQuoteDatas);_this23.controlVariableMap('remark_list_index',remarkquote.length);_this23.btnLabelName=data.btnLabelName;}_this23.setBtnDisabled(false);});}else{API_REQ.getNodeSignSet(signInputParams).then(function(data){_this23.setMarkInfo(data);});_this23.setBtnDisabled(false);}};}}),_descriptor38=_applyDecoratedDescriptor(_class.prototype,'setMarkInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this24=this;return function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this24.markInfo=data;};}}),_descriptor39=_applyDecoratedDescriptor(_class.prototype,'loadInterventionInfo',[_dec20],{enumerable:true,initializer:function initializer(){var _this25=this;return function(){var _commonParam$interven=_this25.commonParam.intervenorright,intervenorright=_commonParam$interven===undefined?0:_commonParam$interven;if(intervenorright>0){API_REQ.getReqInterventionInfo(_this25.commonApiParam).then(function(data){_this25.setInvertionInfo(data);_this25.changeSubmitParam(Util.getIntervenorDefaultV(data));_this25.setInterventionUserReplacedata(data);});}};}}),_descriptor40=_applyDecoratedDescriptor(_class.prototype,'setInvertionInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this26=this;return function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this26.invertionInfo=(0,_extends3.default)({},_this26.invertionInfo,data);};}}),_descriptor41=_applyDecoratedDescriptor(_class.prototype,'getInterventionUser',[_dec21],{enumerable:true,initializer:function initializer(){var _this27=this;return function(){var selectednodeinfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};API_REQ.getInterventionUser((0,_extends3.default)({},_this27.commonApiParam,selectednodeinfo)).then(function(data){_this27.setInvertionInfo(data);_this27.changeSubmitParam(Util.getIntervenorDefaultV(data));_this27.setInterventionUserReplacedata(data);});};}}),_descriptor42=_applyDecoratedDescriptor(_class.prototype,'setInterventionUserReplacedata',[_dec22],{enumerable:true,initializer:function initializer(){var _this28=this;return function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _data$items=data.items,items=_data$items===undefined?[]:_data$items;var nodeOperators=data.replacedatas||[];var nodeOperators_crm=data.replacedatas_crm||[];//客户浏览按钮
if(items.length>0){items.map(function(item){var conditionType=item.conditionType,_item$domkey=item.domkey,domkey=_item$domkey===undefined?[]:_item$domkey,_item$browserConditio=item.browserConditionParam,browserConditionParam=_item$browserConditio===undefined?{}:_item$browserConditio;if(conditionType=='BROWSER'){var _browserConditionPara=browserConditionParam.replaceDatas,replaceDatas=_browserConditionPara===undefined?[]:_browserConditionPara;if('Intervenorid'==domkey[0])nodeOperators=replaceDatas;if('Intervenorid_crm'==domkey[0])nodeOperators_crm=replaceDatas;}});}var viewAttr=3;console.log(nodeOperators,nodeOperators_crm);if(nodeOperators.length>0||nodeOperators_crm.length>0)viewAttr=2;_this28.controlVariableMap("Intervenorid_replaceDatas",nodeOperators);_this28.controlVariableMap("Intervenorid_crm_replaceDatas",nodeOperators_crm);_this28.controlVariableMap("Intervenorid_viewAttr",viewAttr);_this28.controlVariableMap("Intervenorid_crm_viewAttr",viewAttr);};}}),_descriptor43=_applyDecoratedDescriptor(_class.prototype,'resetStore',[_dec23],{enumerable:true,initializer:function initializer(){var _this29=this;return function(){_this29.promptInfo={};};}}),_descriptor44=_applyDecoratedDescriptor(_class.prototype,'loadCustomTab',[_dec24],{enumerable:true,initializer:function initializer(){var _this30=this;return function(){var _this=_this30;API_REQ.getFormTab(_this30.commonApiParam).then(function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _data$customTabs=data.customTabs,customTabs=_data$customTabs===undefined?[]:_data$customTabs;var customFiles=[];customTabs.map(function(){var tab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var index=arguments[1];var _tab$filePath=tab.filePath,filePath=_tab$filePath===undefined?'':_tab$filePath;if(filePath.endsWith(".js")){customFiles.push(filePath);}});if(customTabs.length>0){_this.controlVariableMap("customTabs",customTabs);var init=function init(){if(window.console)console.log("customFiles加载成功！");};_loadjs2.default.isDefined('workflowCustomTab')?_loadjs2.default.ready('workflowCustomTab',init):(0,_loadjs2.default)(customFiles,'workflowCustomTab',init);}});};}}),_descriptor45=_applyDecoratedDescriptor(_class.prototype,'setSecLevelInfo',[_dec25],{enumerable:true,initializer:function initializer(){var _this31=this;return function(obj){_this31.secLevelInfo=(0,_extends3.default)({},_this31.secLevelInfo,obj);if(window.oDocUtil)window.oDocUtil.needReconfirmSecretLevel=true;//流程密级改变时，需重新确认正文密级
};}}),_descriptor46=_applyDecoratedDescriptor(_class.prototype,'updateCommonParam',[_dec26],{enumerable:true,initializer:function initializer(){var _this32=this;return function(k,v){_this32.commonParam[k]=v;};}}),_descriptor47=_applyDecoratedDescriptor(_class.prototype,'updateRemindInfo',[_dec27],{enumerable:true,initializer:function initializer(){var _this33=this;return function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this33.remindInfo=(0,_extends3.default)({},data);};}}),_descriptor48=_applyDecoratedDescriptor(_class.prototype,'getFormAttentionTag',[_dec28],{enumerable:true,initializer:function initializer(){var _this34=this;return function(){var _commonParam4=_this34.commonParam,requestid=_commonParam4.requestid,wfmonitor=_commonParam4.wfmonitor,f_weaver_belongto_userid=_commonParam4.f_weaver_belongto_userid,f_weaver_belongto_usertype=_commonParam4.f_weaver_belongto_usertype,authSignatureStr=_commonParam4.authSignatureStr,authStr=_commonParam4.authStr,signatureAttributesStr=_commonParam4.signatureAttributesStr,signatureSecretKey=_commonParam4.signatureSecretKey;if(wfmonitor)return;var params={requestid:requestid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,authSignatureStr:authSignatureStr,authStr:authStr,signatureAttributesStr:signatureAttributesStr,signatureSecretKey:signatureSecretKey};API_REQ.getFormAttentionTag(params).then(function(result){//把结果跟在标题的后面
var titlename=result.titlename;_this34.controlVariableMap("attention_titlename",titlename);});};}}),_descriptor49=_applyDecoratedDescriptor(_class.prototype,'changeHandWritingData',[_dec29],{enumerable:true,initializer:function initializer(){var _this35=this;return function(type){var val=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];_this35.controlVariableMap(type,val);};}}),_descriptor50=_applyDecoratedDescriptor(_class.prototype,'setPromptInfo',[_dec30],{enumerable:true,initializer:function initializer(){var _this36=this;return function(val){_this36.promptInfo=val;};}}),_descriptor51=_applyDecoratedDescriptor(_class.prototype,'setPromptInfos',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this37=this;return function(val){_this37.promptInfos=[val];_this37.controlVariableMap("forceRenderReq",(_this37.variableMap.get("forceRender")||0)+1);};}}),_descriptor52=_applyDecoratedDescriptor(_class.prototype,'jumpTab',[_mobx.action],{enumerable:true,initializer:function initializer(){return function(){var queryParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var commonParam=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};//如果指定了tab,加载完成后跳到对应的tab
if(queryParams.jumpTab){if(queryParams.jumpTab=='communication'&&commonParam.isOpenCommunication==0){}else{Util.switchFormTabFunc(queryParams.jumpTab);}}};}}),_descriptor53=_applyDecoratedDescriptor(_class.prototype,'changeConflictFieldMap',[_dec31],{enumerable:true,initializer:function initializer(){var _this38=this;return function(obj){if((typeof obj==='undefined'?'undefined':(0,_typeof3.default)(obj))!='object')return;var keys=(0,_keys2.default)(obj);keys.length>0&&keys.map(function(key){_this38.conflictFieldMap.set(key,obj[key]);});};}}),_descriptor54=_applyDecoratedDescriptor(_class.prototype,'addInnerChangeBtn',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor55=_applyDecoratedDescriptor(_class.prototype,'innerChangeDialog',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor56=_applyDecoratedDescriptor(_class.prototype,'setInnerChangeDialog',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this39=this;return function(bool){_this39.innerChangeDialog=bool;};}}),_descriptor57=_applyDecoratedDescriptor(_class.prototype,'FreeflowChangeformParm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor58=_applyDecoratedDescriptor(_class.prototype,'freeflowChangeformParmfixedForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor59=_applyDecoratedDescriptor(_class.prototype,'FreeflowChangeformParmconditions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor60=_applyDecoratedDescriptor(_class.prototype,'setFreeflowChangeformParm',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this40=this;return function(obj){_this40.FreeflowChangeformParm=obj;};}}),_descriptor61=_applyDecoratedDescriptor(_class.prototype,'getFreeNodeBrowserItem',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this41=this;return function(parm){_this41.FreeflowChangeformParm=parm;var _getComsMobx=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx.WeaForm;_this41.freeflowChangeformParmfixedForm=new WeaForm();API_REQ.getFreeNodeBrowserItem({workflowid:parm.wfid}).then(function(data){if(data){var addFormConditions1=[{"defaultshow":true,"items":[],"title":""}];addFormConditions1[0].items.push(data.data[0]);_this41.freeflowChangeformParmfixedForm.initFormFields(addFormConditions1);_this41.FreeflowChangeformParmconditions=addFormConditions1;_this41.controlDialogVisible(type.FREE_FLOW_CHANGEFORM,true);}}).catch(function(){var addFormConditions1=[{"defaultshow":true,"items":[{"belong":"PC","checkbox":false,"checkboxValue":false,"colSpan":2,"conditionType":"SELECT","dateGroup":false,"defaultDisplayInBar":false,"detailtype":1,"domkey":["defaultStyle"],"entSearch":false,"fieldcol":18,"hasBorder":false,"helpfulTipProps":{},"hide":false,"isBase64":false,"isQuickSearch":false,"label":"浏览类型字段格式","labelcol":6,"length":0,"maxFilesNumber":0,"maxUploadSize":0,"multiSelection":false,"multiple":false,"options":[{"disabled":false,"key":"0","selected":true,"showname":"名称","visible":true},{"disabled":false,"key":"1","selected":false,"showname":"##主键","visible":true},{"disabled":false,"key":"2","selected":false,"showname":"名称##主键","visible":true}],"precision":0,"showOrder":0,"showTime":false,"stringLength":0,"supportCancel":false,"tipPosition":"bottom","valueList":[],"viewAttr":2}],"title":"默认设置"},{"defaultshow":true,"items":[{"belong":"PC","checkbox":false,"checkboxValue":false,"colSpan":2,"conditionType":"SELECT_LINKAGE","dateGroup":false,"defaultDisplayInBar":false,"detailtype":1,"domkey":["resourceStyle"],"entSearch":false,"fieldcol":18,"hasBorder":false,"helpfulTipProps":{},"hide":false,"isBase64":false,"isQuickSearch":false,"label":"人力资源字段格式","labelcol":6,"length":0,"maxFilesNumber":0,"maxUploadSize":0,"multiSelection":false,"multiple":false,"options":[{"disabled":false,"key":"0","selected":true,"showname":"默认设置","visible":true},{"disabled":false,"key":"1","selected":false,"showname":"自定义设置","visible":true}],"precision":0,"selectLinkageDatas":{"1":{"belong":"PC","checkbox":false,"checkboxValue":false,"colSpan":2,"conditionType":"SELECT","dateGroup":false,"defaultDisplayInBar":false,"detailtype":1,"domkey":["resourceChild"],"entSearch":false,"fieldcol":18,"hasBorder":false,"helpfulTipProps":{},"hide":false,"isBase64":false,"isQuickSearch":false,"labelcol":6,"length":0,"maxFilesNumber":0,"maxUploadSize":0,"multiSelection":false,"multiple":false,"options":[{"disabled":false,"key":"0","selected":true,"showname":"名称","visible":true},{"disabled":false,"key":"1","selected":false,"showname":"##主键","visible":true},{"disabled":false,"key":"2","selected":false,"showname":"名称##主键","visible":true},{"disabled":false,"key":"3","selected":false,"showname":"deptcode_具体编号","visible":true},{"disabled":false,"key":"4","selected":false,"showname":"名称deptcode_具体编号","visible":true},{"disabled":false,"key":"5","selected":false,"showname":"组织全路径","visible":true}],"precision":0,"showOrder":0,"showTime":false,"stringLength":0,"supportCancel":false,"tipPosition":"bottom","valueList":[],"viewAttr":2}},"showOrder":0,"showTime":false,"stringLength":0,"supportCancel":false,"tipPosition":"bottom","valueList":[],"viewAttr":2},{"belong":"PC","checkbox":false,"checkboxValue":false,"colSpan":2,"conditionType":"SELECT_LINKAGE","dateGroup":false,"defaultDisplayInBar":false,"detailtype":1,"domkey":["departStyle"],"entSearch":false,"fieldcol":18,"hasBorder":false,"helpfulTipProps":{},"hide":false,"isBase64":false,"isQuickSearch":false,"label":"部门字段格式","labelcol":6,"length":0,"maxFilesNumber":0,"maxUploadSize":0,"multiSelection":false,"multiple":false,"options":[{"disabled":false,"key":"0","selected":true,"showname":"默认设置","visible":true},{"disabled":false,"key":"1","selected":false,"showname":"自定义设置","visible":true}],"precision":0,"selectLinkageDatas":{"1":{"belong":"PC","checkbox":false,"checkboxValue":false,"colSpan":2,"conditionType":"SELECT","dateGroup":false,"defaultDisplayInBar":false,"detailtype":1,"domkey":["departChild"],"entSearch":false,"fieldcol":18,"hasBorder":false,"helpfulTipProps":{},"hide":false,"isBase64":false,"isQuickSearch":false,"labelcol":6,"length":0,"maxFilesNumber":0,"maxUploadSize":0,"multiSelection":false,"multiple":false,"options":[{"disabled":false,"key":"0","selected":true,"showname":"名称","visible":true},{"disabled":false,"key":"1","selected":false,"showname":"##主键","visible":true},{"disabled":false,"key":"2","selected":false,"showname":"名称##主键","visible":true},{"disabled":false,"key":"3","selected":false,"showname":"deptcode_具体编号","visible":true},{"disabled":false,"key":"4","selected":false,"showname":"名称deptcode_具体编号","visible":true},{"disabled":false,"key":"5","selected":false,"showname":"组织全路径","visible":true}],"precision":0,"showOrder":0,"showTime":false,"stringLength":0,"supportCancel":false,"tipPosition":"bottom","valueList":[],"viewAttr":2}},"showOrder":0,"showTime":false,"stringLength":0,"supportCancel":false,"tipPosition":"bottom","valueList":[],"viewAttr":2},{"belong":"PC","checkbox":false,"checkboxValue":false,"colSpan":2,"conditionType":"SELECT_LINKAGE","dateGroup":false,"defaultDisplayInBar":false,"detailtype":1,"domkey":["subCompanyStyle"],"entSearch":false,"fieldcol":18,"hasBorder":false,"helpfulTipProps":{},"hide":false,"isBase64":false,"isQuickSearch":false,"label":"分部字段格式","labelcol":6,"length":0,"maxFilesNumber":0,"maxUploadSize":0,"multiSelection":false,"multiple":false,"options":[{"disabled":false,"key":"0","selected":true,"showname":"默认设置","visible":true},{"disabled":false,"key":"1","selected":false,"showname":"自定义设置","visible":true}],"precision":0,"selectLinkageDatas":{"1":{"belong":"PC","checkbox":false,"checkboxValue":false,"colSpan":2,"conditionType":"SELECT","dateGroup":false,"defaultDisplayInBar":false,"detailtype":1,"domkey":["subCompanyChild"],"entSearch":false,"fieldcol":18,"hasBorder":false,"helpfulTipProps":{},"hide":false,"isBase64":false,"isQuickSearch":false,"labelcol":6,"length":0,"maxFilesNumber":0,"maxUploadSize":0,"multiSelection":false,"multiple":false,"options":[{"disabled":false,"key":"0","selected":true,"showname":"名称","visible":true},{"disabled":false,"key":"1","selected":false,"showname":"##主键","visible":true},{"disabled":false,"key":"2","selected":false,"showname":"名称##主键","visible":true},{"disabled":false,"key":"3","selected":false,"showname":"deptcode_具体编号","visible":true},{"disabled":false,"key":"4","selected":false,"showname":"名称deptcode_具体编号","visible":true},{"disabled":false,"key":"5","selected":false,"showname":"组织全路径","visible":true}],"precision":0,"showOrder":0,"showTime":false,"stringLength":0,"supportCancel":false,"tipPosition":"bottom","valueList":[],"viewAttr":2}},"showOrder":0,"showTime":false,"stringLength":0,"supportCancel":false,"tipPosition":"bottom","valueList":[],"viewAttr":2}],"title":"组织字段自定义设置"}];_this41.freeflowChangeformParmfixedForm.initFormFields(addFormConditions1);_this41.FreeflowChangeformParmconditions=addFormConditions1;_this41.controlDialogVisible(type.FREE_FLOW_CHANGEFORM,true);});};}}),_descriptor62=_applyDecoratedDescriptor(_class.prototype,'odocCustomTabs',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor63=_applyDecoratedDescriptor(_class.prototype,'isDefaultOpenOdoc',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor64=_applyDecoratedDescriptor(_class.prototype,'getOdocTabManagerDatas',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this42=this;return function(){var _commonParam5=_this42.commonParam,requestid=_commonParam5.requestid,workflowid=_commonParam5.workflowid,f_weaver_belongto_userid=_commonParam5.f_weaver_belongto_userid,f_weaver_belongto_usertype=_commonParam5.f_weaver_belongto_usertype;API_REQ.getOdocTabManagerDatas({requestid:requestid,workflowid:workflowid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype}).then(function(data){if(data.api_status&&data.api_status==true){_this42.odocCustomTabs=data.customTabs;_this42.isDefaultOpenOdoc=data.isDefaultOpenOdoc||false;}});};}})),_class));

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSecondPath=exports.getFromFieldValue=exports.loadMouldInfoByField=exports.setDocParam=exports.CHANGE_FIELD_VARS=exports.CHANGE_FIELD_VALUE=exports.TYPE_WFFORM_API=exports.TYPE_LINKAGE_ASYNC=exports.TYPE_LINKAGE_SYNC=exports.TYPE_FIELD_CHANGE=exports.TYPE_DETAIL_ADDROW=exports.TYPE_MAIN_INIT=undefined;var _regenerator=__webpack_require__(128);var _regenerator2=_interopRequireDefault(_regenerator);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _asyncToGenerator2=__webpack_require__(129);var _asyncToGenerator3=_interopRequireDefault(_asyncToGenerator2);var _convert=__webpack_require__(6);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _lodash=__webpack_require__(255);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//字段变更类型 
var TYPE_MAIN_INIT=exports.TYPE_MAIN_INIT="1";//主表字段初始值加载
var TYPE_DETAIL_ADDROW=exports.TYPE_DETAIL_ADDROW="2";//添加/生成明细行的默认值
var TYPE_FIELD_CHANGE=exports.TYPE_FIELD_CHANGE="3";//手动变更字段
var TYPE_LINKAGE_SYNC=exports.TYPE_LINKAGE_SYNC="4";//同步联动修改
var TYPE_LINKAGE_ASYNC=exports.TYPE_LINKAGE_ASYNC="5";//异步联动修改
var TYPE_WFFORM_API=exports.TYPE_WFFORM_API="6";//通过接口WfForm修改(包括公式)
var CHANGE_FIELD_VALUE=exports.CHANGE_FIELD_VALUE="c_value";//改变字段值
var CHANGE_FIELD_VARS=exports.CHANGE_FIELD_VARS="c_vars";//改变字段属性
/**
 *
 */var setDocParam=exports.setDocParam=function(){var _ref=(0,_asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee(odocInfo){var docInfonew,editOrShowMouldfieldid,formFieldList,fieldTotalList,i,fieldid,fieldTotalObj,fieldInfo,formFieldObj,_fieldInfo,url,count,router,key,dataJson,_getEcCom,WeaTools,result;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:docInfonew=odocInfo;if(docInfonew.docParam&&!docInfonew.docParam.authStr){docInfonew.docParam.authStr=wfform.getGlobalStore().commonParam.authStr;}if(docInfonew.docParam&&!docInfonew.docParam.authSignatureStr){docInfonew.docParam.authSignatureStr=wfform.getGlobalStore().commonParam.authSignatureStr;}if(docInfonew.docParam&&!docInfonew.docParam.f_weaver_belongto_userid){docInfonew.docParam.f_weaver_belongto_userid=wfform.getBaseInfo().f_weaver_belongto_userid;}if(docInfonew.docParam&&!docInfonew.docParam.f_weaver_belongto_usertype){docInfonew.docParam.f_weaver_belongto_usertype=wfform.getBaseInfo().f_weaver_belongto_usertype;}_context.next=7;return loadMouldInfoByField();case 7:editOrShowMouldfieldid="field"+docInfonew.docParam.editMouldFieldid+","+"field"+docInfonew.docParam.showMouldFieldid;WfForm.bindFieldChangeEvent(editOrShowMouldfieldid,function(obj,id,value){loadMouldInfoByField();});formFieldList=docInfonew.formFieldList;fieldTotalList=new Array();//编辑模板字段
i=0;case 12:if(!(formFieldList&&i<formFieldList.length)){_context.next=20;break;}fieldid=formFieldList[i];if(!(jQuery.inArray(fieldid,fieldTotalList)>=0)){_context.next=16;break;}return _context.abrupt("continue",17);case 16:fieldTotalList.push(fieldid);case 17:i++;_context.next=12;break;case 20://选择框字段
if(jQuery.inArray(docInfonew.docParam.secFieldid,fieldTotalList)==-1){fieldTotalList.push(docInfonew.docParam.secFieldid);}//编辑模板字段
if(jQuery.inArray(docInfonew.docParam.editMouldfieldid,fieldTotalList)==-1){fieldTotalList.push(docInfonew.docParam.editMouldFieldid);}//套红模板字段
if(jQuery.inArray(docInfonew.docParam.showMouldFieldid,fieldTotalList)==-1){fieldTotalList.push(docInfonew.docParam.showMouldFieldid);}//文档标题
if(jQuery.inArray(docInfonew.docParam.documentTitleField,fieldTotalList)==-1){fieldTotalList.push(docInfonew.docParam.documentTitleField);}fieldTotalObj=getFromFieldValue(fieldTotalList);//保留需要带入URL参数的内容
docInfonew.nowDocParam=new Object();docInfonew.nowDocParam=(0,_lodash.cloneDeep)(mobx.toJS(docInfonew.docParam));for(fieldInfo in fieldTotalObj){//不使用过滤
docInfonew.nowDocParam[fieldInfo]=fieldTotalObj[fieldInfo];}//模板书签对应字段
formFieldObj=getFromFieldValue(formFieldList?formFieldList:[]);//模板书签对应，不需要带入URL参数中，但是需要记录变化
for(_fieldInfo in formFieldObj){docInfonew.nowDocParam[_fieldInfo]=formFieldObj[_fieldInfo];}//是否需要重新加载url
docInfonew.needReload=false;if(!(0,_lodash.isEqual)(mobx.toJS(docInfonew.nowDocParam),mobx.toJS(docInfonew.lasttimeDocParam))){docInfonew.needReload=true;//开启默认预览正文，且点了编辑按钮之后，不做重新加载
if(docInfonew.docParam.useyozoorwps=="1"&&docInfonew.docParam.onEditDoc==true){docInfonew.needReload=false;}docInfonew.lasttimeDocParam=new Object();docInfonew.lasttimeDocParam=(0,_lodash.cloneDeep)(mobx.toJS(docInfonew.nowDocParam));}else{docInfonew.needReload=false;}WfForm.changeOdocConfig(docInfonew);if(!docInfonew.needReload){_context.next=62;break;}url=docInfonew.docUrl+"?";count=0;router=docInfonew.docParam.router;if(docInfonew.docParam.isEdit==1){router="#/main/document/edit";}else{router="#/main/document/detail";}_context.t0=_regenerator2.default.keys(docInfonew.docParam);case 39:if((_context.t1=_context.t0()).done){_context.next=50;break;}key=_context.t1.value;if(!(key=="router")){_context.next=43;break;}return _context.abrupt("continue",39);case 43:if(docInfonew.docParam[key]){_context.next=45;break;}return _context.abrupt("continue",39);case 45:if(count>0)url+="&";url+=key+"="+encodeURIComponent(docInfonew.docParam[key]);count++;_context.next=39;break;case 50:dataJson=(0,_lodash.cloneDeep)(mobx.toJS(docInfonew.nowDocParam));dataJson.action='setUrlParams';_getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;_context.next=55;return WeaTools.callApi('/api/odoc/odocWorkflow/setUrlParams?date='+new Date().getTime(),'POST',(0,_extends3.default)({},dataJson));case 55:result=_context.sent;if(result.success){url+="&uuid="+result.uuid;}url+=router;try{document.getElementsByClassName("req-workflow-odoc")[0].contentWindow.onbeforeunload=null;}catch(e){}_base2.default.globalStore.odocIframeUrl=getSecondPath(url);docInfonew.iframeUrl=getSecondPath(url);odocInfo=docInfonew;case 62:case"end":return _context.stop();}}},_callee,undefined);}));return function setDocParam(_x){return _ref.apply(this,arguments);};}();//根据模板区分字段，获取编辑、套红模板信息
var loadMouldInfoByField=exports.loadMouldInfoByField=function(){var _ref2=(0,_asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee2(){var docInfo,_docInfo$docParam,editMouldFieldid,showMouldFieldid,isSelectField,isShowSelectField,workflowid,requestid,_docInfo$docParam$sel,selectFieldType,newEditMouldfieldid,newShowMouldfieldid,editfieldvalue,showfieldvalue,_getEcCom2,WeaTools,params,res;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:docInfo=WfForm.getOdocConfig();_docInfo$docParam=docInfo.docParam,editMouldFieldid=_docInfo$docParam.editMouldFieldid,showMouldFieldid=_docInfo$docParam.showMouldFieldid,isSelectField=_docInfo$docParam.isSelectField,isShowSelectField=_docInfo$docParam.isShowSelectField,workflowid=_docInfo$docParam.workflowid,requestid=_docInfo$docParam.requestid,_docInfo$docParam$sel=_docInfo$docParam.selectFieldType,selectFieldType=_docInfo$docParam$sel===undefined?0:_docInfo$docParam$sel;//获取编辑模板对应字段选择模板
newEditMouldfieldid=editMouldFieldid==-1?-1:"field"+editMouldFieldid;//获取套红模板对应字段选择模板
newShowMouldfieldid=showMouldFieldid==-1?-1:"field"+showMouldFieldid;editfieldvalue=-1;if(newEditMouldfieldid!=-1){editfieldvalue=WfForm.getFieldValue(newEditMouldfieldid);if(isSelectField=='false'&&editfieldvalue!=""){editfieldvalue=Number(editfieldvalue)+100;}}showfieldvalue=-1;if(newShowMouldfieldid!=-1){showfieldvalue=WfForm.getFieldValue(newShowMouldfieldid);if(isShowSelectField=='false'&&showfieldvalue!=""){if(selectFieldType==324){showfieldvalue=-1*Number(showfieldvalue)-100;}else{showfieldvalue=Number(showfieldvalue)+100;}}}_getEcCom2=(0,_convert.getEcCom)(),WeaTools=_getEcCom2.WeaTools;params={workflowid:workflowid,editfieldvalue:editfieldvalue,showfieldvalue:showfieldvalue,selectFieldType:selectFieldType,requestid:requestid,action:"getMouldInfo"};_context2.next=12;return WeaTools.callApi('/odoc/docs/odocCommonAjax.jsp',"POST",params);case 12:res=_context2.sent;docInfo.docParam=(0,_extends3.default)({},docInfo.docParam,{editmouldCount:res.editmouldCount,showmouldCount:res.showmouldCount,editMouldId:res.editMouldId,showMouldId:res.showMouldId,formFieldList:res.formFieldList,onlyOfficeEditor:res.onlyOfficeEditor});case 14:case"end":return _context2.stop();}}},_callee2,undefined);}));return function loadMouldInfoByField(){return _ref2.apply(this,arguments);};}();var getFromFieldValue=exports.getFromFieldValue=function getFromFieldValue(fieldList){var retObj=new Object();for(var i=0;i<fieldList.length;i++){var fieldid=fieldList[i];if(fieldid=="-3"){var fieldvalue=WfForm.getFieldValue("field-1");retObj["requestname"]=fieldvalue;}else{var fieldvalue=WfForm.getFieldValue("field"+fieldid);retObj["field"+fieldid]=fieldvalue;}}retObj["requestname"]=WfForm.getFieldValue("field-1");return retObj;};//获取二级路径
var getSecondPath=exports.getSecondPath=function getSecondPath(url){var ecologyContentPath=window.ecologyContentPath||'';//二级路径
if(ecologyContentPath!=""&&url&&url!=""){if(url.indexOf("/")==0&&url.indexOf(ecologyContentPath)!=0){url=ecologyContentPath+url;}else if(url.indexOf("http")==0){var origin=window.location.origin;if(!origin){origin=window.location.protocol+"//"+window.location.hostname+(window.location.port?':'+window.location.port:'');}if(url.indexOf(origin)==0&&url.indexOf(origin+ecologyContentPath)!=0){url=url.replace(origin,origin+ecologyContentPath);}}}return url;};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LayoutStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_dec3,_dec4,_dec5,_dec6,_dec7,_dec8,_dec9,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _base=__webpack_require__(177);var _base2=_interopRequireDefault(_base);var _field=__webpack_require__(147);var _field2=_interopRequireDefault(_field);var _detail=__webpack_require__(502);var _detail2=_interopRequireDefault(_detail);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _base3=__webpack_require__(12);var _base4=_interopRequireDefault(_base3);var _detailUtil=__webpack_require__(22);var _encryptUtil=__webpack_require__(254);var EncryptUtil=_interopRequireWildcard(_encryptUtil);var _linkage=__webpack_require__(503);var _linkage2=_interopRequireDefault(_linkage);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _analyzeData=__webpack_require__(56);var AI=_interopRequireWildcard(_analyzeData);var _secLevelUtil=__webpack_require__(125);var SecLevelUtil=_interopRequireWildcard(_secLevelUtil);var _convert=__webpack_require__(6);var _linkageControl=__webpack_require__(84);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var LayoutStore=exports.LayoutStore=(_dec=_mobx.observable.ref,_dec2=(0,_mobx.action)('初始化布局'),_dec3=(0,_mobx.action)('初始化源码源码'),_dec4=(0,_mobx.action)('加载明细数据'),_dec5=(0,_mobx.action)('字段值不存在时需初始化字段值对象'),_dec6=(0,_mobx.action)('修改单个字段值信息'),_dec7=(0,_mobx.action)('修改字段值的唯一入口，统一此处做字段值变更的联动总控'),_dec8=(0,_mobx.action)('触发联动总控'),_dec9=(0,_mobx.action)('改变公文参数'),(_class=function(_BaseStore){(0,_inherits3.default)(LayoutStore,_BaseStore);(0,_createClass3.default)(LayoutStore,[{key:'containSignInput',get:function get(){//表单是否包含签字意见输入框
return _.has(this.cellInfo,["fieldCellInfo","-4"])&&_.has(this.tableInfo,["main","fieldinfomap","-4","viewattr"])&&_.get(this.tableInfo,["main","fieldinfomap","-4","viewattr"])>=0;}},{key:'fieldAttrMap',get:function get(){var attrMap=_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});!_.isEmpty(this.tableInfo)&&_.forIn(this.tableInfo,function(v,k){v.fieldinfomap&&_.forIn(v.fieldinfomap,function(attr,fieldid){attr["tableMark"]=k;attr["isDetail"]=k.indexOf("detail_")>-1;attr["tableName"]=v.tablename;attr["encryptFlag"]=EncryptUtil.calculateEncryptFlag(attr);attrMap.set(fieldid.toString(),attr);});});return attrMap;}},{key:'fieldNameMap',get:function get(){var nameMap=_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});!_.isEmpty(this.tableInfo)&&_.forIn(this.tableInfo,function(v,k){v.fieldinfomap&&_.forIn(v.fieldinfomap,function(attr,fieldid){if(!!attr.fieldname)nameMap.set(k+'.'+attr.fieldname.toUpperCase(),fieldid);});});return nameMap;}},{key:'fieldCellMap',get:function get(){var cellMap={};_.forIn(this.dataJson.etables,function(v,k){v.ec.forEach(function(cellObj){if(cellObj.etype=="3")cellMap[cellObj.field]=cellObj;});});return cellMap;}},{key:'rowSubPanelMap',get:function get(){var rowMap={};var subPanelInfo=this.cellInfo.subPanelInfo||{};_.forIn(subPanelInfo,function(v,k){rowMap[v.symbol+'_'+v.rowid]=k;});return rowMap;}}]);function LayoutStore(){(0,_classCallCheck3.default)(this,LayoutStore);var _this=(0,_possibleConstructorReturn3.default)(this,(LayoutStore.__proto__||(0,_getPrototypeOf2.default)(LayoutStore)).call(this));_initDefineProp(_this,'dataJson',_descriptor,_this);_this.layoutSourceInfo={};_this.tableInfo={};_this.browserInfo={};_this.linkageCfg={};_this.propFileCfg={};_this.cellInfo={};_this.codeInfo={};_this.fnaInfo={};_this.hrmInfo={};_initDefineProp(_this,'odocInfo',_descriptor2,_this);_this.existChangeFormDataByUser=false;_this.existChangeFormData=false;_this.existChangeRange=[];_initDefineProp(_this,'mainData',_descriptor3,_this);_initDefineProp(_this,'detailMap',_descriptor4,_this);_initDefineProp(_this,'doInitLayout',_descriptor5,_this);_initDefineProp(_this,'doInitSourceLayout',_descriptor6,_this);_initDefineProp(_this,'loadDetailData',_descriptor7,_this);_initDefineProp(_this,'initFieldObj',_descriptor8,_this);_initDefineProp(_this,'changeSingleFieldValue',_descriptor9,_this);_initDefineProp(_this,'changeMoreFieldData',_descriptor10,_this);_initDefineProp(_this,'triggerAllLinkage',_descriptor11,_this);_initDefineProp(_this,'setOdocInfo',_descriptor12,_this);return _this;}//triType（1：字段值变化触发  2：页面加载触发  3：新增行触发  4、删除行触发）
return LayoutStore;}(_base2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'dataJson',[_dec],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'odocInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'mainData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'detailMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_applyDecoratedDescriptor(_class.prototype,'containSignInput',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'containSignInput'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'fieldAttrMap',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'fieldAttrMap'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'fieldNameMap',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'fieldNameMap'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'fieldCellMap',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'fieldCellMap'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'rowSubPanelMap',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'rowSubPanelMap'),_class.prototype),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'doInitLayout',[_dec2],{enumerable:true,initializer:function initializer(){var _this2=this;return function(data){var _base$globalStore=_base4.default.globalStore,isSourceLayout=_base$globalStore.isSourceLayout,urlParams=_base$globalStore.urlParams;//样式信息，必须render模板前append到body，否则IE下保存后跳转异常
if(!_.isEmpty(data.propFileCfg))GlobalUtil.imageStyleHander(data.propFileCfg);if(!isSourceLayout&&!_.isEmpty(data.cellInfo))jQuery("body").append(data.cellInfo.style.layoutStyle).append(data.cellInfo.style.scriptStyle);_this2.tableInfo=data.tableInfo;_this2.browserInfo=data.browserInfo;_this2.linkageCfg=data.linkageCfg;_this2.propFileCfg=data.propFileCfg;_this2.cellInfo=data.cellInfo;_this2.codeInfo=data.codeInfo;_this2.fnaInfo=data.fnaInfo||{};_this2.hrmInfo=data.hrmInfo||{};_this2.odocInfo=data.odocInfo||{};var commonParam=_base4.default.globalStore.commonParam;var stepid=AI.generateStepId(AI.TYPE_MAIN_INIT);data.maindata&&_.forIn(data.maindata,function(v,k){var fieldid=k.substring(5);if(_this2.fieldAttrMap.has(fieldid)&&commonParam.isviewonly==1){var fieldAttr=_this2.fieldAttrMap.get(fieldid);if(fieldAttr.htmltype===2&&fieldAttr.detailtype===2)v.value=GlobalUtil.manageCssFilePollute(v.value,'field'+fieldid+'_swapDiv');}var newFieldObj=new _field2.default(k,v,stepid);newFieldObj.changeVariable({initValue:v.value});_this2.mainData.set(k,newFieldObj);});data.tableInfo&&_.forIn(data.tableInfo,function(v,k){if(k.indexOf("detail_")>-1)_this2.detailMap.set(k,new _detail2.default(v.detailtableattr,v.fieldinfomap));});//最后一步渲染布局信息
if(isSourceLayout){//E7源码html模板
_this2.doInitSourceLayout(data.layoutSourceInfo);}else{_this2.dataJson=data.datajson&&data.datajson.eformdesign;}//加载处理密级值
_this2.initFieldObj("main","field-10");SecLevelUtil.loadManagerSecLevelInfo();//加载明细数据
if(urlParams.isPreView!=="1")_this2.loadDetailData();};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'doInitSourceLayout',[_dec3],{enumerable:true,initializer:function initializer(){var _this3=this;return function(layoutSourceInfo){if(_.isEmpty(layoutSourceInfo))return;var datajson=layoutSourceInfo.datajson,styleStr=layoutSourceInfo.styleStr,cssFiles=layoutSourceInfo.cssFiles,fieldCellInfo=layoutSourceInfo.fieldCellInfo,nodeMarkContent=layoutSourceInfo.nodeMarkContent;jQuery("body").append(styleStr||"");GlobalUtil.loadCssFileContent(cssFiles,"excelTempDiv");delete layoutSourceInfo.datajson;_this3.layoutSourceInfo=layoutSourceInfo;_this3.cellInfo.fieldCellInfo=fieldCellInfo;_this3.cellInfo.nodeMarkContent=nodeMarkContent;_this3.dataJson=datajson;//最后渲染布局
};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'loadDetailData',[_dec4],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var isSourceLayout=_base4.default.globalStore.isSourceLayout;var detailmark="";_this4.detailMap.keys().map(function(v){if(_.has(_this4.cellInfo,["subPanelInfo",v])||isSourceLayout)detailmark+=v+",";});if(detailmark!=="")detailmark=detailmark.substring(0,detailmark.length-1);var _base$globalStore2=_base4.default.globalStore,commonParam=_base$globalStore2.commonParam,urlParams=_base$globalStore2.urlParams,commonApiParam=_base$globalStore2.commonApiParam,setApiBtnDisabled=_base$globalStore2.setApiBtnDisabled,controlVariableMap=_base$globalStore2.controlVariableMap;var _propFileCfg$enable_n=_this4.propFileCfg.enable_no_promptes_submit,enable_no_promptes_submit=_propFileCfg$enable_n===undefined?0:_propFileCfg$enable_n;window.__wfform__has__detail__data=!!(detailmark!=="");//标识当前是否有明细表
if(detailmark!==""){var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;var apiParams=(0,_extends3.default)({},urlParams);if(commonParam.iscreate!="1")apiParams["requestid"]=commonParam.requestid;apiParams["detailmark"]=detailmark;apiParams["reqParams"]=(0,_stringify2.default)(commonApiParam);//开关打开｜ 代码块｜ecode指定 不拦截提交
if(!(enable_no_promptes_submit==1||window.code_enable_submit)){setApiBtnDisabled(true);}var startTime=new Date().getTime();var timer=window.setInterval(function(){var endTime=new Date().getTime();if(endTime-startTime>=5000&&window.has_load_detail!=true){message.loading((0,_convert.getLabel)(546600,"明细数据解析加载中，请稍候"),0);window.clearInterval(timer);}},100);(0,_linkageControl.setWfVerifiySource)("detailData","loading");//记录明细表加载中
API_REQ.loadDetailData(apiParams).then(function(data){window.has_load_detail=true;setApiBtnDisabled(false);message.destroy();if((typeof data==='undefined'?'undefined':(0,_typeof3.default)(data))!=="object"||_.isEmpty(data)){//明细数据接口异常阻断
alert((0,_convert.getLabel)(546601,"加载明细数据发生异常，请联系管理员"));window.Has_Trigger_Load_Linkage=true;//这样处理目的是放行提交时的拦截、
controlVariableMap("detailDataError",(0,_stringify2.default)(data));(0,_linkageControl.setWfVerifiySource)("detailData","fail");//记录明细表加载失败
return;}(0,_linkageControl.setWfVerifiySource)("detailData","loaded");//记录明细表加载成功
_.forIn(data,function(v,detailMark){if(_this4.detailMap.has(detailMark)){var detailObj=_this4.detailMap.get(detailMark);detailObj.initDetailData(v);}});//延时加载，非当前页字段转换信息(浏览按钮转name)
if("delayCacheKey"in data&&!!data.delayCacheKey){var delayApiParams=(0,_extends3.default)({},apiParams,{isDelayConvertName:"1",delayCacheKey:data.delayCacheKey});API_REQ.loadDetailData(delayApiParams).then(function(delaydatas){_.forIn(delaydatas.datas,function(v,detailMark){var detailObj=_this4.detailMap.get(detailMark);var detailData=detailObj.detailData;_.forIn(v,function(valueObj,fieldMark){if(detailData.has(fieldMark)){var fieldObj=detailData.get(fieldMark);if(fieldObj.value===valueObj.value){//延时请求过程中此字段值没变过才改变
fieldObj.changeValueObj(valueObj);}}});});window.__wfform__detail__data__loaded=true;//标识明细表数据加载完毕
window.WfForm.triggerAction(window.WfForm.ACTION_DETAIL_LOADCOMPLETE,[]);});}else{window.__wfform__detail__data__loaded=true;//标识明细表数据加载完毕
window.WfForm.triggerAction(window.WfForm.ACTION_DETAIL_LOADCOMPLETE,[]);}//页面加载触发联动应在默认新增明细前，新增加的行联动在添加时会自动触发
_this4.triggerAllLinkage(2);//节点操作者-默认新增空明细
if(parseInt(commonParam.isviewonly||0)!==1){detailmark.split(",").map(function(detailMark){var detailObj=_this4.detailMap.get(detailMark);var attr=detailObj.attr,indexnum=detailObj.indexnum;var isdefault=attr.isdefault,isadd=attr.isadd,defaultrows=attr.defaultrows;if(indexnum===0&&isdefault===1){//无数据情况触发默认新增空明细
for(var i=0;i<parseInt(defaultrows);i++){(0,_detailUtil.addRow)(detailMark);}}});}//加载代码块,触发代码块内ready等事件
Util.loadScript();});}else{_this4.triggerAllLinkage(2);Util.loadScript();}};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'initFieldObj',[_dec5],{enumerable:true,initializer:function initializer(){var _this5=this;return function(tableMark,fieldMark){var dataObj=null;if(tableMark.indexOf("detail")===-1)dataObj=_this5.mainData;else dataObj=_this5.detailMap.get(tableMark).detailData;if(dataObj&&!dataObj.has(fieldMark)){dataObj.set(fieldMark,new _field2.default(fieldMark));}return dataObj.get(fieldMark);};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'changeSingleFieldValue',[_dec6],{enumerable:true,initializer:function initializer(){var _this6=this;return function(fieldMark){var valueInfo=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var variableInfo=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var changeDatas={};_this6.existChangeFormDataByUser=true;if(!_.isEmpty(valueInfo))changeDatas[fieldMark]=valueInfo;var fieldVars={};if(!_.isEmpty(variableInfo))fieldVars[fieldMark]=variableInfo;var stepid=AI.generateStepId(AI.TYPE_FIELD_CHANGE);_this6.changeMoreFieldData(changeDatas,fieldVars,stepid);};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'changeMoreFieldData',[_dec7],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){var changeDatas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fieldVars=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var stepid=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var fieldKeys=(0,_keys2.default)(changeDatas);(0,_keys2.default)(fieldVars).map(function(fieldMark){if(_.indexOf(fieldKeys,fieldMark)===-1)fieldKeys.push(fieldMark);});var changeMap={};var encryptChangeInfo=[];//加密格式存在修改的情况给提示
fieldKeys.map(function(fieldMark){var fieldAttr=FieldUtil.getFieldAttr(fieldMark);if(!fieldAttr)return true;if(fieldMark.indexOf("_")>-1&&parseInt(fieldMark.substring(fieldMark.indexOf("_")+1))<0)return true;//明细字段非法格式
var tableMark=fieldAttr.tableMark;_this7.initFieldObj(tableMark,fieldMark);//需先初始化
var fieldObj=FieldUtil.getFieldObj(fieldMark,tableMark);if(fieldMark in changeDatas){var valueObj=changeDatas[fieldMark];FieldUtil.managerValueObjBeforeChangeStore(valueObj,fieldAttr);var oldValue=fieldObj.value;var newValue=Util.convertNull(valueObj.value);newValue=FieldUtil.convertValueBeforeChangeStore(newValue,fieldAttr);if(fieldAttr.htmltype===1&&fieldAttr.detailtype!=1){oldValue=oldValue.toString();newValue=newValue.toString();}var existChange=!((typeof oldValue==='undefined'?'undefined':(0,_typeof3.default)(oldValue))===(typeof newValue==='undefined'?'undefined':(0,_typeof3.default)(newValue))&&oldValue==newValue);//类型一致且两等号判断
if(existChange&&fieldAttr.encryptFlag>0){//加密展示情况不允许修改
encryptChangeInfo.push(fieldAttr);}else{//修改字段值为脱敏格式，无效并清空
if(EncryptUtil.judgeDecryptFormat(newValue))newValue="";//修改单个字段值
if(fieldMark=='field-10'){//修改密级字段
Util.changeSecLevel(newValue);}else{fieldObj.changeValueObj((0,_extends3.default)({},valueObj,{value:newValue}),stepid);}changeMap[fieldMark]={existChange:existChange,newValue:newValue};}}if(fieldMark in fieldVars){fieldObj.changeVariable(fieldVars[fieldMark],stepid);}});//修改字段值完成后触发字段值变更联动
_.forIn(changeMap,function(obj,fieldMark){if(obj.existChange===true){_this7.existChangeFormData=true;//表单字段值修改过，用于关闭时提示信息判断
_this7.existChangeRange.push(fieldMark);var isDetail=fieldMark.indexOf("_")>-1;var fieldid=isDetail?fieldMark.substring(5,fieldMark.indexOf("_")):fieldMark.substring(5);var rowIndex=isDetail?fieldMark.substring(fieldMark.indexOf("_")+1):"-1";var tableMark="";if(_this7.fieldAttrMap.has(fieldid))tableMark=_this7.fieldAttrMap.get(fieldid).tableMark;_this7.triggerAllLinkage(1,tableMark,fieldid,rowIndex);//最后触发开发代码绑定的监听函数
WfForm.triggerFieldBindEvent(fieldMark,obj.newValue);}});//存在修改加密字段的提示
if(encryptChangeInfo.length>0){var msg="";encryptChangeInfo.forEach(function(item,ii){msg+=' \u201C'+item.fieldlabel+'\u201D '+(ii>0?"、":"");});WfForm.showMessage(''+msg+(0,_convert.getLabel)(531809,'为加密/脱敏字段，只读属性下联动修改无效'));}};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'triggerAllLinkage',[_dec8],{enumerable:true,initializer:function initializer(){return function(triType,tableMark,triFieldid,rowIndex){var variableMap=_base4.default.globalStore.variableMap;var startTime=new Date().getTime();var fun=function fun(){var caculate_Complete=variableMap.get("caculate_Complete")||false;var interval=new Date().getTime()-startTime;if(!caculate_Complete&&interval<3000){setTimeout(function(){fun();},200);}else{new _linkage2.default(triType).doTrigger(tableMark,triFieldid,rowIndex);}};fun();};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'setOdocInfo',[_dec9],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this8.odocInfo=obj;};}})),_class));

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _defineProperty4=__webpack_require__(55);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _extends4=__webpack_require__(7);var _extends5=_interopRequireDefault(_extends4);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_dec2,_dec3,_dec4,_dec5,_dec6,_dec7,_dec8,_dec9,_dec10,_dec11,_dec12,_dec13,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _field=__webpack_require__(147);var _field2=_interopRequireDefault(_field);var _base=__webpack_require__(177);var _base2=_interopRequireDefault(_base);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _req=__webpack_require__(15);var API=_interopRequireWildcard(_req);var _base3=__webpack_require__(12);var _base4=_interopRequireDefault(_base3);var _fieldUtil=__webpack_require__(17);var _analyzeData=__webpack_require__(56);var AI=_interopRequireWildcard(_analyzeData);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Detail=(_dec=(0,_mobx.action)('初始化明细已有行数据'),_dec2=(0,_mobx.action)('指定行记录选中/不选中'),_dec3=(0,_mobx.action)('清除所有行记录的选中状态'),_dec4=(0,_mobx.action)('控制明细行属性对象'),_dec5=(0,_mobx.action)('新增明细行'),_dec6=(0,_mobx.action)('删除明细行'),_dec7=(0,_mobx.action)('行数据转换并赋值'),_dec8=(0,_mobx.action)('设置新增是否默认复制数据'),_dec9=(0,_mobx.action)('控制分页信息'),_dec10=(0,_mobx.action)('改变每页条数'),_dec11=(0,_mobx.action)('跳转至最后一页'),_dec12=(0,_mobx.action)('根据行标跳转页'),_dec13=(0,_mobx.action)('切换按钮'),(_class=function(_BaseStore){(0,_inherits3.default)(Detail,_BaseStore);(0,_createClass3.default)(Detail,[{key:'rowInfoArr',//获取排序后的行信息
get:function get(){var arr=[];var index=0;this.rowInfo.forEach(function(info,rowKey){var _info=mobx.toJS(info);_info["rowIndex"]=parseInt(rowKey.substring(4));arr.push(_info);});arr.sort(function(a,b){return a.rowIndex-b.rowIndex;});//排序完成后计算序号
arr.map(function(_info,index){_info["serialNum"]=index+1;});return arr;}//获取所有行的行标拼接成串
},{key:'allRowIndexStr',get:function get(){var str="";this.rowInfoArr.map(function(item,index){str+=''+(index>0?",":"")+item.rowIndex;});return str;}//获取当前页显示的行信息
},{key:'currentPageRowArr',get:function get(){var rowInfoArr=this.rowInfoArr;var _pagingInfo=this.pagingInfo,enabled=_pagingInfo.enabled,current=_pagingInfo.current,pagesize=_pagingInfo.pagesize;if(enabled){var begin=(current-1)*pagesize;return rowInfoArr.slice(begin,begin+pagesize);}else{return rowInfoArr;}}//获取当前页所有行的行标拼接成串
},{key:'currentPageRowIndexStr',get:function get(){var str="";this.currentPageRowArr.map(function(item,index){str+=''+(index>0?",":"")+item.rowIndex;});return str;}//计算配置行合并字段的合并信息
},{key:'currentPageRowMergeInfo',get:function get(){var _this2=this;var mergeResult=_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});var _attr=this.attr,isedit=_attr.isedit,_attr$mergefields=_attr.mergefields,mergefields=_attr$mergefields===undefined?[]:_attr$mergefields;var mergeFieldArr=_.trim(mergefields).split(",").filter(function(item){return item!=="";});if(mergeFieldArr.length===0||this.currentPageRowArr.length===0)return mergeResult;var commonParam=_base4.default.globalStore.commonParam;var pageViewOnly=parseInt(commonParam.isviewonly||0)===1||parseInt(commonParam.isaffirmance||0)===1;mergeFieldArr.forEach(function(fieldid){if(!(fieldid in _this2.fieldInfo))return true;var fieldAttr=_this2.fieldInfo[fieldid];if(fieldAttr.htmltype===6)return true;//第一步：算只读属性、字段值
var mergeInfo=[];_this2.currentPageRowArr.forEach(function(rowInfo){var rowIndex=rowInfo.rowIndex,keyid=rowInfo.keyid;var fieldMark='field'+fieldid+'_'+rowIndex;var fieldObj=_this2.detailData.has(fieldMark)?_this2.detailData.get(fieldMark):null;//算字段是否只读
var fieldViewOnly=pageViewOnly||rowViewOnly;if(!fieldViewOnly){var viewAttr_tmp=-1;if(fieldObj!==null&&fieldObj.variable.has("viewAttr"))viewAttr_tmp=parseInt(fieldObj.variable.get("viewAttr"))||0;fieldViewOnly=viewAttr_tmp>0?viewAttr_tmp===1:fieldAttr.viewattr===1;}//算字段值
var rowViewOnly=isedit!==1&&parseInt(keyid||0)>0;var fieldValue=fieldObj===null?"":fieldObj.value;if(fieldAttr.htmltype===4)fieldValue=fieldValue=="1";//check框类型1选中其它均为未选中
mergeInfo.push({rowIndex:rowIndex,fieldValue:fieldValue,fieldViewOnly:fieldViewOnly});});//第二步，reduce算法比较得出合并结果
mergeInfo.reduce(function(pre,cur,index){var isSame=pre.fieldViewOnly===true&&cur.fieldViewOnly===true&&pre.fieldValue!==""&&pre.fieldValue===cur.fieldValue;var fieldKey='field'+fieldid;var preRow=mergeResult.get('row_'+pre.rowIndex)||{};var curRow=mergeResult.get('row_'+cur.rowIndex)||{};var preRowSpan=index===1?1:preRow[fieldKey];var curRowSpan=1;if(isSame){preRowSpan++;curRowSpan=0;}mergeResult.set('row_'+pre.rowIndex,(0,_extends5.default)({},preRow,(0,_defineProperty5.default)({},fieldKey,preRowSpan)));mergeResult.set('row_'+cur.rowIndex,(0,_extends5.default)({},curRow,(0,_defineProperty5.default)({},fieldKey,curRowSpan)));return isSame?pre:cur;});});return mergeResult;}}]);function Detail(){var attr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fieldInfo=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};(0,_classCallCheck3.default)(this,Detail);var _this=(0,_possibleConstructorReturn3.default)(this,(Detail.__proto__||(0,_getPrototypeOf2.default)(Detail)).call(this));_this.attr={};_this.fieldInfo={};_this.addRowDefValue={};_this.addDefaultCopy=false;_initDefineProp(_this,'indexnum',_descriptor,_this);_initDefineProp(_this,'deldtlid',_descriptor2,_this);_initDefineProp(_this,'detailData',_descriptor3,_this);_initDefineProp(_this,'rowInfo',_descriptor4,_this);_initDefineProp(_this,'pagingInfo',_descriptor5,_this);_initDefineProp(_this,'dropBtnKey',_descriptor6,_this);_initDefineProp(_this,'initDetailData',_descriptor7,_this);_initDefineProp(_this,'controlRowChecked',_descriptor8,_this);_initDefineProp(_this,'clearAllRowChecked',_descriptor9,_this);_initDefineProp(_this,'controlDetailRowAttr',_descriptor10,_this);_initDefineProp(_this,'add_Row',_descriptor11,_this);_initDefineProp(_this,'del_Row',_descriptor12,_this);_initDefineProp(_this,'convertSetRowData',_descriptor13,_this);_initDefineProp(_this,'setAddDefaultCopy',_descriptor14,_this);_initDefineProp(_this,'controlPagingInfo',_descriptor15,_this);_initDefineProp(_this,'changePageSize',_descriptor16,_this);_initDefineProp(_this,'jumpLastPage',_descriptor17,_this);_initDefineProp(_this,'jumpPageByRowIndex',_descriptor18,_this);_initDefineProp(_this,'setDropBtnKey',_descriptor19,_this);_this.attr=attr;_this.fieldInfo=fieldInfo;if(attr.isopenpaging===1){_this.pagingInfo={enabled:true,current:1,pagesize:attr.pagesize};}return _this;}return Detail;}(_base2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'indexnum',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'deldtlid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'detailData',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'rowInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'pagingInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{enabled:false};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'dropBtnKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_applyDecoratedDescriptor(_class.prototype,'rowInfoArr',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'rowInfoArr'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'allRowIndexStr',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'allRowIndexStr'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currentPageRowArr',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'currentPageRowArr'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currentPageRowIndexStr',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'currentPageRowIndexStr'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currentPageRowMergeInfo',[_mobx.computed],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'currentPageRowMergeInfo'),_class.prototype),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'initDetailData',[_dec],{enumerable:true,initializer:function initializer(){var _this3=this;return function(data){_this3.addRowDefValue=data.addRowDefValue||{};_this3.indexnum=data.indexnum;!_.isEmpty(data.rowDatas)&&_.forIn(data.rowDatas,function(rowData,rowKey){_this3.convertSetRowData(rowKey.substring(4),rowData);});};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'controlRowChecked',[_dec2],{enumerable:true,initializer:function initializer(){var _this4=this;return function(rowIndexStr){var checked=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;rowIndexStr.split(",").map(function(rowid){if(_this4.rowInfo.has('row_'+rowid)){var info=_this4.rowInfo.get('row_'+rowid);var rowChecked=checked;if(_this4.dropBtnKey===1&&_this4.attr.isdelete!==1&&parseInt(info.get("keyid")||0)>0)//已有明细行禁止选中
rowChecked=false;if(info.get("disableCheck")===true)rowChecked=false;info.set("checked",rowChecked);}});};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'clearAllRowChecked',[_dec3],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.controlRowChecked(_this5.allRowIndexStr,false);};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'controlDetailRowAttr',[_dec4],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};(0,_keys2.default)(obj).map(function(rowKey){if(!_this6.rowInfo.has(rowKey))return true;var info=_this6.rowInfo.get(rowKey);var addAttr=obj[rowKey]||{};_.forIn(addAttr,function(v,k){info.set(k,v);});});};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'add_Row',[_dec5],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){var initData=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fromLinkage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var isCopy=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var rowData=_.cloneDeep(_this7.addRowDefValue);//联动含初始值情况
_.forIn(initData,function(v,k){if(k.indexOf("field")>-1){rowData[k]=v;}});//新增行同时复制指定行数据
if(!fromLinkage&&!isCopy&&_this7.addDefaultCopy){var lastRowIndex=_this7.rowInfoArr.length>0?_this7.rowInfoArr[_this7.rowInfoArr.length-1].rowIndex:-1;lastRowIndex>-1&&_.forIn(_this7.fieldInfo,function(v,k){if(_this7.detailData.has('field'+k+'_'+lastRowIndex)&&v.htmltype!==6&&v.encryptFlag===0)rowData['field'+k]=_this7.detailData.get('field'+k+'_'+lastRowIndex).valueObj;});}_this7.jumpLastPage();_this7.convertSetRowData(_this7.indexnum,rowData,fromLinkage);_this7.indexnum=parseInt(_this7.indexnum)+1;};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'del_Row',[_dec6],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var delRowKeys="";arr.map(function(rowIndex){var info=_this8.rowInfo.get('row_'+rowIndex);//已有数据行记录删除行key
if(info.has("keyid")&&parseInt(info.get("keyid"))>0)delRowKeys+=","+info.get("keyid");_this8.rowInfo.delete('row_'+rowIndex);//清除被删除行数据
_.forIn(_this8.fieldInfo,function(v,k){var fieldMark='field'+k+'_'+rowIndex;//删除时需触发被删除字段的绑定事件
WfForm.triggerFieldBindEvent(fieldMark,"");_this8.detailData.delete(fieldMark);});});if(delRowKeys!=="")delRowKeys=delRowKeys.substring(1);_this8.deldtlid=_this8.deldtlid===""?delRowKeys:_this8.deldtlid+','+delRowKeys;//分页情况，删除完如果无数据，跳转至前一页
if(_this8.pagingInfo.enabled&&_this8.currentPageRowArr.length===0&&_this8.rowInfoArr.length>0){_this8.jumpLastPage(false);}};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'convertSetRowData',[_dec7],{enumerable:true,initializer:function initializer(){var _this9=this;return function(rowIndex){var rowData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var fromLinkage=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var info=_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});info.set("fromLinkage",fromLinkage);var stepid=AI.generateStepId(AI.TYPE_DETAIL_ADDROW);!_.isEmpty(rowData)&&_.forIn(rowData,function(v,k){if(k.indexOf("field")>-1){var fieldid=k.substring(5);if(fieldid in _this9.fieldInfo){//限制属于本明细的字段
var newValue=(0,_fieldUtil.convertValueBeforeChangeStore)(v.value,_this9.fieldInfo[fieldid]);v=(0,_extends5.default)({},v,{value:newValue});_this9.detailData.set(k+'_'+rowIndex,new _field2.default(k+'_'+rowIndex,v,stepid));}}else info.set(k,v);});_this9.rowInfo.set('row_'+rowIndex,info);};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'setAddDefaultCopy',[_dec8],{enumerable:true,initializer:function initializer(){var _this10=this;return function(){var bool=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this10.addDefaultCopy=bool;};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'controlPagingInfo',[_dec9],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this11.pagingInfo=(0,_extends5.default)({},_this11.pagingInfo,params);};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'changePageSize',[_dec10],{enumerable:true,initializer:function initializer(){var _this12=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(_this12.pagingInfo.pagesize===params.pagesize)return;_this12.clearAllRowChecked();_this12.controlPagingInfo({pagesize:params.pagesize,current:1});API.saveDetailPaging(params);};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'jumpLastPage',[_dec11],{enumerable:true,initializer:function initializer(){var _this13=this;return function(){var needAddOne=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var _pagingInfo2=_this13.pagingInfo,enabled=_pagingInfo2.enabled,current=_pagingInfo2.current,pagesize=_pagingInfo2.pagesize;if(enabled){var total=_this13.rowInfoArr.length;if(needAddOne)total++;var last=Math.ceil(total/pagesize);_this13.controlPagingInfo({current:last});}};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'jumpPageByRowIndex',[_dec12],{enumerable:true,initializer:function initializer(){var _this14=this;return function(rowindex){var _pagingInfo3=_this14.pagingInfo,enabled=_pagingInfo3.enabled,current=_pagingInfo3.current,pagesize=_pagingInfo3.pagesize;if(enabled){var allRowIndexStr=_this14.allRowIndexStr;var indexArr=allRowIndexStr.split(",");var position=_.indexOf(indexArr,rowindex)+1;var pageindex=Math.ceil(position/pagesize);if(current!==pageindex)_this14.controlPagingInfo({current:pageindex});}};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'setDropBtnKey',[_dec13],{enumerable:true,initializer:function initializer(){var _this15=this;return function(key){_this15.clearAllRowChecked();_this15.dropBtnKey=key;};}})),_class));exports.default=Detail;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _defineProperty2=__webpack_require__(55);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _formula=__webpack_require__(504);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _linkageControl=__webpack_require__(84);var LinkageControl=_interopRequireWildcard(_linkageControl);var _FormulaNew=__webpack_require__(248);var _analyzeData=__webpack_require__(56);var AI=_interopRequireWildcard(_analyzeData);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//联动触发逻辑
var Linkage=//1：字段值变化触发  2：页面加载触发  3：新增行触发  4、删除行触发
function Linkage(triType){var _this=this;(0,_classCallCheck3.default)(this,Linkage);this.triType=-1;this.layoutStore={};this.commonParam={};this.showAI=false;this.triInfo={};this.doTrigger=function(tableMark,triFieldid,rowIndex){if(_this.triType===2)window.Has_Trigger_Load_Linkage=true;triFieldid=triFieldid==null||typeof triFieldid==="undefined"?"":triFieldid.toString();rowIndex=rowIndex==null||typeof rowIndex==="undefined"?"-1":rowIndex.toString();var nodetype=parseInt(_this.commonParam.nodetype||0);//获取当前节点的节点类型
if((_this.triType===3||_this.triType===4)&&tableMark.indexOf("detail_")===-1)//如果触发类型为新增和删除行，但不是明细表，则阻断
return;if(nodetype===3&&_this.triType!==2)//归档节点除页面加载执行部分联动外其它都不执行
return;_this.triInfo={triType:_this.triType,tableMark:tableMark,triFieldid:triFieldid,rowIndex:rowIndex};//初始化联动的触发信息
var _layoutStore=_this.layoutStore,propFileCfg=_layoutStore.propFileCfg,linkageCfg=_layoutStore.linkageCfg,fieldAttrMap=_layoutStore.fieldAttrMap;//仅显示，不允许编辑
var onlyShow=parseInt(_this.commonParam.isviewonly||0)===1||parseInt(_this.commonParam.isaffirmance||0)===1;var iscreate=parseInt(_this.commonParam.iscreate||0);/************ 是否触发联动判断 *************/var needTriRowRule=false;var needTriColRule=false;var needTriFieldMath=false;var needTriFormula=false;var needTriSelectChange=false;var needTriViewAttr=false;var needTriFieldSql=false;var needTriDateTime=false;var needTriDataInput=false;if(_this.triType===1){//字段值变更
if(tableMark==="main"){needTriFieldMath=true;}else if(tableMark.indexOf("detail_")>-1){var triFieldAttr=fieldAttrMap.get(triFieldid);if(triFieldAttr.htmltype===1&&triFieldAttr.detailtype!==1){//数值字段触发行列规则
needTriRowRule=true;needTriColRule=true;}}needTriFormula=true;needTriSelectChange=true;needTriViewAttr=true;needTriFieldSql=true;needTriDateTime=true;needTriDataInput=true;}else if(_this.triType===2){//页面加载
if(!onlyShow&&propFileCfg.tri_rowRule_edit==="1"||onlyShow&&propFileCfg.tri_rowRule_view==="1")needTriRowRule=true;if(!onlyShow){needTriFieldMath=true;needTriFormula=true;needTriFieldSql=true;needTriDateTime=true;needTriDataInput=true;}needTriColRule=true;needTriViewAttr=true;//已办也需要执行显示属性联动隐藏
needTriSelectChange=true;//已办需要执行复选框相关联动显示
}else if(_this.triType===3){//新增行
needTriRowRule=true;needTriColRule=true;needTriFormula=true;needTriSelectChange=true;needTriViewAttr=true;needTriFieldSql=true;needTriDateTime=true;needTriDataInput=true;}else if(_this.triType===4){//删除行
needTriColRule=true;needTriFormula=true;}/************ 分发执行各类联动 *************/var changeDatas={};var fieldVars={};var changeVars={};if(needTriRowRule){//行规则
var rowRule_result=_this.executeRowRule(tableMark,triFieldid,rowIndex)||{};_.merge(changeDatas,rowRule_result);}if(needTriColRule){//列规则
var colRule_result=_this.executeColRule(tableMark,triFieldid)||{};_.merge(changeDatas,colRule_result["changeDatas"]);_.merge(changeVars,colRule_result["changeVars"]);}if(needTriFieldMath){//字段赋值
var fieldMath_result=_this.executeFieldMath(triFieldid)||{};_.merge(changeDatas,fieldMath_result);}if(needTriFormula){//公式
var formula_result=_this.executeFormula(tableMark,triFieldid,rowIndex)||{};_.merge(changeDatas,formula_result);}if(needTriSelectChange){//选择框联动
var selectChange_result=_this.controlSelectChange(tableMark,triFieldid,rowIndex)||{};_.merge(changeDatas,selectChange_result["changeDatas"]);_.merge(fieldVars,selectChange_result["fieldVars"]);}if(needTriViewAttr){//显示属性联动
var viewAttr_result=_this.controlViewAttr(tableMark,triFieldid,rowIndex)||{};_.merge(fieldVars,viewAttr_result["fieldVars"]);_.merge(changeVars,viewAttr_result["changeVars"]);}//控制字段类型变更联动
var fieldTypeChange_result=_this.controlFieldTypeChange(tableMark,triFieldid,rowIndex)||{};_.merge(changeDatas,fieldTypeChange_result["changeDatas"]);_.merge(fieldVars,fieldTypeChange_result["fieldVars"]);/************ 非异步联动统一修改 *************///console.log("---linkageResult---", changeDatas, fieldVars, changeVars);
if(!_.isEmpty(changeVars))_this.layoutStore.batchControlVariableMap(changeVars);//必须先赋合计值再赋字段修改值，解决添加行动作的行规则赋值字段再合计，线程顺序问题
if(!_.isEmpty(changeDatas)||!_.isEmpty(fieldVars)){var stepid=AI.generateStepId(AI.TYPE_LINKAGE_SYNC,(0,_extends3.default)({},_this.triInfo));_this.layoutStore.changeMoreFieldData(changeDatas,fieldVars,stepid);}/***************** 触发异步联动 **************/if(needTriFieldSql){//SQL联动
var fieldSql_triInfo=_this.generateFieldSqlTriInfo(tableMark,triFieldid,rowIndex);_this.sendLinkageAjax(fieldSql_triInfo,"fieldsql");}if(needTriDateTime){//日期时间计算
var dateTime_triInfo=_this.generateDateTimeTriInfo(tableMark,triFieldid,rowIndex);_this.sendLinkageAjax(dateTime_triInfo,"datetime");}if(needTriDataInput){//字段联动
var dataInput_triInfo=_this.generateDataInputTriInfo(tableMark,triFieldid,rowIndex);_this.sendLinkageAjax(dataInput_triInfo,"datainput");}};this.judgeDetailUnExistTemplate=function(detailMark){var cellInfo=_this.layoutStore.cellInfo;var isSourceLayout=_source2.default.globalStore.isSourceLayout;if(isSourceLayout){var detailIndex=parseInt(detailMark.substring(7))-1;return window.jQuery("table#oTable"+detailIndex).length===0;}else{return!_.has(cellInfo,["subPanelInfo",detailMark]);}};this.judgeFieldUnExistTemplate=function(fieldid){var _layoutStore2=_this.layoutStore,fieldAttrMap=_layoutStore2.fieldAttrMap,cellInfo=_layoutStore2.cellInfo;if(_.has(cellInfo,["fieldCellInfo",fieldid])&&fieldAttrMap.has(fieldid)&&fieldAttrMap.get(fieldid).viewattr>0)return false;else return true;};this.getDetailFieldSumValue=function(tableMark,fieldid){//let sum = 0;
var expression="0";var detailMap=_this.layoutStore.detailMap;var _detailMap$get=detailMap.get(tableMark),rowInfoArr=_detailMap$get.rowInfoArr,detailData=_detailMap$get.detailData;rowInfoArr.map(function(info){var fieldNumValue=0;if(detailData.has('field'+fieldid+'_'+info.rowIndex)){fieldNumValue=detailData.get('field'+fieldid+'_'+info.rowIndex).numValue;if(fieldNumValue.toString().indexOf("e-")>-1){//let dig = fieldNumValue.toString().substring(fieldNumValue.toString().indexOf("-")+1);
fieldNumValue=fieldNumValue.toFixed(15);}}//sum += fieldNumValue;
if(fieldNumValue<0){expression+=fieldNumValue;}else{expression=expression+"+"+fieldNumValue;}});var result=FieldUtil.calExpressionResult(expression);return result;};this.executeRowRule=function(tableMark,triFieldid,rowIndex){var _layoutStore3=_this.layoutStore,linkageCfg=_layoutStore3.linkageCfg,fieldAttrMap=_layoutStore3.fieldAttrMap,detailMap=_layoutStore3.detailMap,propFileCfg=_layoutStore3.propFileCfg;var rowCalCfg=linkageCfg.rowCalCfg||{};var triInfo={};if(_this.triType===1){triFieldid in rowCalCfg&&rowCalCfg[triFieldid].map(function(cfg){triInfo[cfg.assignField]={expression:cfg.config,tableMark:tableMark,rowIndexStr:rowIndex};});}else if(_this.triType===2){_.forIn(rowCalCfg,function(v,k){if(k==="rowCalAssignInfo")return true;v&&v.map(function(cfg){var assignField=cfg.assignField;if(assignField in triInfo||!fieldAttrMap.has(assignField))return true;//不需要重复添加
var detailMark=fieldAttrMap.get(assignField).tableMark;var detailObj=detailMap.get(detailMark);triInfo[assignField]={expression:cfg.config,tableMark:detailMark,rowIndexStr:detailObj.allRowIndexStr};});});}else if(_this.triType===3){_.forIn(rowCalCfg,function(v,k){if(k==="rowCalAssignInfo")return true;v&&v.map(function(cfg){var assignField=cfg.assignField;if(!fieldAttrMap.has(assignField))return true;var detailMark=fieldAttrMap.get(assignField).tableMark;if(assignField in triInfo||tableMark!==detailMark)return true;//不需要重复添加，只触发当前明细涉及的行规则
triInfo[assignField]={expression:cfg.config,tableMark:tableMark,rowIndexStr:rowIndex};});});}var changeDatas={};!_.isEmpty(triInfo)&&_.forIn(triInfo,function(v,key){//循环配置
var tableMark=v.tableMark,expression=v.expression,rowIndexStr=v.rowIndexStr;if(_this.judgeFieldUnExistTemplate(key))//赋值字段不在模板不计算行规则
return true;var needCal=true;expression.match(/detailfield_\d+/g).map(function(fieldstr){if(_this.judgeFieldUnExistTemplate(fieldstr.substring(12)))//任一取值字段不在模板的不计算行规则
needCal=false;});needCal&&!!rowIndexStr&&rowIndexStr.split(",").map(function(rowIndex){//循环行
var curExpression=expression;var reg=new RegExp("detailfield_\\d+","g");curExpression.match(reg).map(function(fieldstr){var fieldval=FieldUtil.getFieldValue(fieldstr.substring(12),rowIndex,true);if(fieldval<0)fieldval='('+fieldval+')';//负数参与计算加括号
var reg1=new RegExp(fieldstr+"(?!\d)","g");//正向否定预查，后面跟的不是数字才匹配
curExpression=curExpression.replace(reg1,fieldval);});var result=FieldUtil.calExpressionResult(curExpression);if(_this.triType===3&&parseFloat(result)===0&&propFileCfg.rowRule_addRow_empty!=="1"){//新增行触发的行规则计算结果为0的赋空值
result="";}else if(_this.triType===3&&propFileCfg.rowRule_addRow_empty=="1"&&parseFloat(result)===0||result==""){result=0;}changeDatas['field'+key+'_'+rowIndex]={value:result};});});return changeDatas;};this.executeColRule=function(tableMark,triFieldid){var _layoutStore4=_this.layoutStore,linkageCfg=_layoutStore4.linkageCfg,fieldAttrMap=_layoutStore4.fieldAttrMap,detailMap=_layoutStore4.detailMap,propFileCfg=_layoutStore4.propFileCfg;var colCalCfg=linkageCfg.colCalCfg||{};var mainCalCfg=linkageCfg.mainCalCfg||{};var triInfo={};if(_this.triType===1){var needSum=triFieldid in colCalCfg;var sumMainFieldid=mainCalCfg[triFieldid];if(needSum||!!sumMainFieldid)triInfo[triFieldid]={tableMark:tableMark,needSum:needSum,sumMainFieldid:sumMainFieldid};}else if(_this.triType===2||_this.triType===3||_this.triType===4){detailMap.forEach(function(detailObj,detailMark){if(_this.triType===2||(_this.triType===3||_this.triType===4)&&detailMark===tableMark){_.forIn(detailObj.fieldInfo,function(v,fieldid){if(v.htmltype===1&&v.detailtype!==1){var _needSum=fieldid in colCalCfg;var _sumMainFieldid=mainCalCfg[fieldid];if(_needSum||!!_sumMainFieldid)triInfo[fieldid]={tableMark:detailMark,needSum:_needSum,sumMainFieldid:_sumMainFieldid};}});}});}var changeDatas={};var changeVars={};!_.isEmpty(triInfo)&&_.forIn(triInfo,function(v,fieldid){var tableMark=v.tableMark,needSum=v.needSum,sumMainFieldid=v.sumMainFieldid;if(_this.judgeDetailUnExistTemplate(tableMark))return true;//明细表不存在模板上不计算列规则
if(_this.judgeFieldUnExistTemplate(fieldid))return true;//字段不在模板不计算列规则
var sum=_this.getDetailFieldSumValue(tableMark,fieldid);//明细列合计
if(needSum){var formatSumValue=FieldUtil.convertNumberValue(sum,fieldAttrMap.get(fieldid));changeVars['sum'+fieldid]=formatSumValue;}//合计赋值主字段
if(!!sumMainFieldid){var _detailMap$get2=detailMap.get(tableMark),rowInfoArr=_detailMap$get2.rowInfoArr;if(sum==0&&rowInfoArr.length===0&&propFileCfg.colRule_noRow_empty!=="1")//明细无数据时，提示必填用
sum="";changeDatas['field'+sumMainFieldid]={value:sum};}});return{changeDatas:changeDatas,changeVars:changeVars};};this.executeFieldMath=function(triFieldid){var _layoutStore5=_this.layoutStore,linkageCfg=_layoutStore5.linkageCfg,fieldAttrMap=_layoutStore5.fieldAttrMap;var fieldMathCfg=linkageCfg.fieldMathCfg||{};var triInfo={};if(_this.triType===1){triFieldid in fieldMathCfg&&fieldMathCfg[triFieldid].map(function(cfg){triInfo[cfg.assignField]={expression:cfg.config,relateFields:cfg.relateFields};});}else if(_this.triType===2){_.forIn(fieldMathCfg,function(v,k){v&&v.map(function(cfg){triInfo[cfg.assignField]={expression:cfg.config,relateFields:cfg.relateFields};});});}var changeDatas={};_.forIn(triInfo,function(v,assignField){if(_this.judgeFieldUnExistTemplate(assignField))return true;var expression=v.expression;v.relateFields&&v.relateFields.map(function(fieldid){if(!fieldAttrMap.has(fieldid))//字段不存在时不替换，执行时做抛错处理
return"";var fieldval=FieldUtil.getFieldValue(fieldid,-1,true);if(fieldval<0)fieldval='('+fieldval+')';//负数参与计算加括号
var reg=new RegExp("\\$"+fieldid+"\\$","g");expression=expression.replace(reg,fieldval);});var result=FieldUtil.calExpressionResult(expression);changeDatas['field'+assignField]={value:result};});return changeDatas;};this.executeFormula=function(tableMark,triFieldid,rowIndex){var _layoutStore6=_this.layoutStore,dataJson=_layoutStore6.dataJson,cellInfo=_layoutStore6.cellInfo,propFileCfg=_layoutStore6.propFileCfg;var formulaCfg=dataJson.formula||{};if(_this.triType===3||_this.triType===4){//新增和删除明细行时触发执行新版公式
setTimeout(function(){(0,_FormulaNew.calculateDetailFormulaNew)(tableMark,rowIndex);},50);}if(_.isEmpty(formulaCfg))return;var triInfo=[];if(_this.triType===1){var relateFormula=_.get(cellInfo,["fieldCellInfo",triFieldid,"relateFormula"]);relateFormula&&relateFormula.map(function(formulaKey){if(formulaKey in formulaCfg){var cfg=formulaCfg[formulaKey];//触发字段为主表，赋值字段为明细需计算明细所有行公式
var triRowMark=parseInt(rowIndex)===-1&&cfg["destcell"].indexOf("DETAIL_")>-1?"all":rowIndex;triInfo.push({formulaKey:formulaKey,triRowMark:triRowMark});}});}else if(_this.triType===2&&propFileCfg.tri_formula_all==="1"){_.forIn(formulaCfg,function(cfg,formulaKey){var triRowMark=formulaKey.indexOf("DETAIL_")>-1?"all":-1;triInfo.push({formulaKey:formulaKey,triRowMark:triRowMark});});}else if(_this.triType===3){//新增明细触发
_.forIn(formulaCfg,function(cfg,formulaKey){if(formulaKey.indexOf(tableMark.toUpperCase())>-1){triInfo.push({formulaKey:formulaKey,triRowMark:rowIndex});}else if(formulaKey.indexOf("DETAIL_")===-1&&cfg["formulatxt"].indexOf(tableMark.toUpperCase())>-1){//当前明细字段参与公式计算同时赋值给主字段  
triInfo.push({formulaKey:formulaKey,triRowMark:-1});}});}else if(_this.triType===4){//删除明细触发
_.forIn(formulaCfg,function(cfg,formulaKey){if(formulaKey.indexOf("DETAIL_")===-1&&cfg["formulatxt"].indexOf(tableMark.toUpperCase())>-1){//当前明细字段参与公式计算同时赋值给主字段  
triInfo.push({formulaKey:formulaKey,triRowMark:-1});}});}if(triInfo.length===0)return;var changeDatas=(0,_formula.calculateFormula)(triInfo);return changeDatas;};this.controlSelectChange=function(tableMark,triFieldid,rowIndex){var onlyShow=parseInt(_this.commonParam.isviewonly||0)===1||parseInt(_this.commonParam.isaffirmance||0)===1;var _layoutStore7=_this.layoutStore,fieldAttrMap=_layoutStore7.fieldAttrMap,detailMap=_layoutStore7.detailMap;var triInfo={};if(_this.triType===1){var attr=fieldAttrMap.get(triFieldid);if(!attr||attr.htmltype!==5||_.get(attr,["selectattr","childfieldid"])===0)return;triInfo[triFieldid]={attr:attr,rowIndexStr:rowIndex};}else if(_this.triType===2){fieldAttrMap.forEach(function(attr,fieldid){if(attr.htmltype!==5||_.get(attr,["selectattr","childfieldid"])===0)return true;var tableMark=attr.tableMark;var rowIndexStr=tableMark.indexOf("detail")>-1?detailMap.get(tableMark).allRowIndexStr:"-1";triInfo[fieldid]={attr:attr,rowIndexStr:rowIndexStr};});}else if(_this.triType===3){var detailObj=detailMap.get(tableMark);_.forIn(detailObj.fieldInfo,function(attr,fieldid){if(attr.htmltype!==5||_.get(attr,["selectattr","childfieldid"])===0)return true;triInfo[fieldid]={attr:attr,rowIndexStr:rowIndex};});}var changeDatas={};var fieldVars={};!_.isEmpty(triInfo)&&_.forIn(triInfo,function(v,triFieldid){if(_this.judgeFieldUnExistTemplate(triFieldid))return true;var attr=v.attr,rowIndexStr=v.rowIndexStr;var tableMark=attr.tableMark;var childFieldid=_.get(attr,["selectattr","childfieldid"]);var childFieldObj=fieldAttrMap.get(childFieldid.toString());var childFieldItemList=childFieldObj&&_.get(childFieldObj,["selectattr","selectitemlist"]);if(!childFieldItemList||_.isEmpty(childFieldItemList)||rowIndexStr==="")return true;rowIndexStr.split(",").map(function(rowIndex){var childitemid="";var triFieldValue=FieldUtil.getFieldValue(triFieldid,rowIndex);triFieldValue!==""&&_.get(attr,["selectattr","selectitemlist"]).map(function(item){if(item.selectvalue===parseInt(triFieldValue))childitemid=item.childitemid;});var optionRange=childitemid.split(",");//IE下可变数组不支持includes方法
//计算联动子字段选中值逻辑：有效值且在range范围内直接选中，无有效值则找range范围内的选择框默认值，无默认值则置空
var childFieldValue=FieldUtil.getFieldValue(childFieldid,rowIndex);//联动前子字段选中的值
if(childFieldValue!==""){var childValueArr=childFieldValue.split(",");var childValueNew="";childValueArr.map(function(value){if(_.indexOf(optionRange,value)===-1)return true;//不在选项范围内选中值无效
var isValid=false;//校验封存逻辑
childFieldItemList.map(function(item){if(item.selectvalue.toString()===value&&(item.cancel!==1||item.cancel===1&&(onlyShow||childFieldObj.viewattr===1)))isValid=true;});if(isValid)childValueNew+=','+value;});childFieldValue=childValueNew;}childFieldValue===""&&childFieldItemList.map(function(item){//空值取range范围内选择框默认值
var selectvalue=item.selectvalue.toString();if(item.isdefault===1&&item.cancel!==1&&_.indexOf(optionRange,selectvalue)>-1)childFieldValue+=','+selectvalue;});if(childFieldValue.length>0&&childFieldValue.substring(0,1)===",")childFieldValue=childFieldValue.substring(1);var fieldMark=tableMark.indexOf("detail_")>-1?'field'+childFieldid+'_'+rowIndex:'field'+childFieldid;changeDatas[fieldMark]={value:childFieldValue};fieldVars[fieldMark]={optionRange:optionRange};});});return{changeDatas:changeDatas,fieldVars:fieldVars};};this.controlViewAttr=function(tableMark,triFieldid,rowIndex){var _layoutStore8=_this.layoutStore,linkageCfg=_layoutStore8.linkageCfg,fieldAttrMap=_layoutStore8.fieldAttrMap,detailMap=_layoutStore8.detailMap;var viewAttrCfg=linkageCfg.viewAttrCfg||{};var triInfo={};if(_this.triType===1){var fieldMark=triFieldid+'_'+(tableMark.indexOf("detail_")>-1?1:0);if(fieldMark in viewAttrCfg)triInfo[triFieldid]={cfg:viewAttrCfg[fieldMark],rowIndexStr:rowIndex};}else if(_this.triType===2){_.forIn(viewAttrCfg,function(cfg,k){var fieldid=k.split("_")[0];var isDetail=k.split("_")[1]==="1";//区分主表和明细表字段，0：主表，1：明细表
if(!fieldAttrMap.has(fieldid))return true;var belTableMark=fieldAttrMap.get(fieldid).tableMark;var rowIndexStr=isDetail?detailMap.get(belTableMark).allRowIndexStr:"-1";triInfo[fieldid]={cfg:cfg,rowIndexStr:rowIndexStr};});}else if(_this.triType===3){_.forIn(viewAttrCfg,function(cfg,k){var fieldid=k.split("_")[0];var isDetail=k.split("_")[1]==="1";if(!fieldAttrMap.has(fieldid))return true;var belTableMark=fieldAttrMap.get(fieldid).tableMark;if(belTableMark===tableMark&&isDetail)triInfo[fieldid]={cfg:cfg,rowIndexStr:rowIndex};});}var fieldVars={};var changeVars={};!_.isEmpty(triInfo)&&_.forIn(triInfo,function(v,triFieldid){var cfg=v.cfg,rowIndexStr=v.rowIndexStr;!!rowIndexStr&&rowIndexStr.split(",").map(function(rowIndex){var triFieldValue=FieldUtil.getFieldValue(triFieldid,rowIndex);var triAction={};//触发动作
_.forIn(cfg,function(curAction,triKey){if(triKey==="relateFields")return true;if(_this.judgeViewAttrTriCondition(triKey,triFieldValue))triAction=(0,_extends3.default)({},triAction,curAction);});cfg["relateFields"].map(function(field){var fieldid=field.split("_")[0];var isDetail=field.split("_")[1]=="1";var fieldMark=isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;var changeViewAttr=-1;if(_.has(triAction,field)){//更改字段属性
changeViewAttr=parseInt(_.get(triAction,field)||-1);if(changeViewAttr===1)//可编辑
changeViewAttr=2;else if(changeViewAttr===2)//必填
changeViewAttr=3;else if(changeViewAttr===3)//只读
changeViewAttr=1;}fieldVars[fieldMark]={viewAttr:-1};changeVars[fieldMark+'_viewAttr']=-1;if(changeViewAttr<=3)fieldVars[fieldMark]={viewAttr:changeViewAttr};//显示属性联动隐藏不能存fieldObj对象中，优化性能
if(changeViewAttr===4||changeViewAttr===5)changeVars[fieldMark+'_viewAttr']=changeViewAttr;});});});return{fieldVars:fieldVars,changeVars:changeVars};};this.judgeViewAttrTriCondition=function(triKey,fieldvalue){var pass=false;var triArr=triKey.split("|");if(triArr.length!=2)return false;var relation=triArr[0];var triValue=','+triArr[1]+',';var realValue=','+fieldvalue+',';switch(parseInt(relation)){case 0://属于
pass=triValue.indexOf(realValue)>-1;break;case 1://不属于
pass=triValue.indexOf(realValue)===-1;break;case 2://包含
pass=realValue.indexOf(triValue)>-1;break;case 3://不包含
pass=realValue.indexOf(triValue)===-1;break;case 4://选中
pass=fieldvalue=="1";break;case 5://不选中
pass=fieldvalue!="1";break;}return pass;};this.controlFieldTypeChange=function(tableMark,triFieldid,rowIndex){var linkageCfg={};var _layoutStore9=_this.layoutStore,fnaInfo=_layoutStore9.fnaInfo,hrmInfo=_layoutStore9.hrmInfo,fieldAttrMap=_layoutStore9.fieldAttrMap,detailMap=_layoutStore9.detailMap;if(fnaInfo&&fnaInfo.belFna===true)linkageCfg=(0,_extends3.default)({},linkageCfg,fnaInfo.linkageCfg);if(hrmInfo&&hrmInfo.belHrm===true)linkageCfg=(0,_extends3.default)({},linkageCfg,hrmInfo.linkageCfg);if(_.isEmpty(linkageCfg))return;var triInfo=[];if(_this.triType===1){var isDetail=tableMark.indexOf("detail_")>-1;var triFieldMark=isDetail?triFieldid+'_1':triFieldid+'_0';if(triFieldMark in linkageCfg)triInfo.push({triFieldMark:triFieldMark,rowIndexStr:rowIndex});}else if(_this.triType===2){_.forIn(linkageCfg,function(v,triFieldMark){var triFieldid=triFieldMark.split("_")[0];var isDetail=triFieldMark.split("_")[1]==="1";if(!fieldAttrMap.has(triFieldid))return true;var belTableMark=fieldAttrMap.get(triFieldid).tableMark;if(isDetail&&!detailMap.has(belTableMark))return true;var rowIndexStr=isDetail?detailMap.get(belTableMark).allRowIndexStr:"-1";triInfo.push({triFieldMark:triFieldMark,rowIndexStr:rowIndexStr});});}else if(_this.triType===3){_.forIn(linkageCfg,function(v,triFieldMark){var triFieldid=triFieldMark.split("_")[0];var isDetail=triFieldMark.split("_")[1]==="1";if(!fieldAttrMap.has(triFieldid))return true;var belTableMark=fieldAttrMap.get(triFieldid).tableMark;if(belTableMark===tableMark&&isDetail)triInfo.push({triFieldMark:triFieldMark,rowIndexStr:rowIndex});});}var iscreate=parseInt(_this.commonParam.iscreate||0);var changeDatas={};var fieldVars={};triInfo.length>0&&triInfo.map(function(triCfg){var triFieldMark=triCfg.triFieldMark,rowIndexStr=triCfg.rowIndexStr;var triFieldid=triFieldMark.split("_")[0];var isDetail=triFieldMark.split("_")[1]==="1";!!rowIndexStr&&rowIndexStr.split(",").map(function(rowIndex){var fieldvalue=FieldUtil.getFieldValue(triFieldid,rowIndex);if(fieldvalue===""||!_.has(linkageCfg,[triFieldMark,fieldvalue]))return"";_.get(linkageCfg,[triFieldMark,fieldvalue]).map(function(cfg){//数组，可以多个
var fieldid=cfg.fieldid,_cfg$defValueObj=cfg.defValueObj,defValueObj=_cfg$defValueObj===undefined?"":_cfg$defValueObj,changeType=cfg.changeType,selectOption=cfg.selectOption;var _fieldid=fieldid.split("_")[0];var fieldMark=isDetail?'field'+_fieldid+'_'+rowIndex:'field'+_fieldid;if(_this.triType===1&&!hrmInfo.belHrm)//只有值变更才读取默认值，新增行默认值后端运算好
changeDatas[fieldMark]=defValueObj;var changeFieldType=changeType.indexOf("-")>-1?changeType:'3-'+changeType;//默认为浏览按钮类型兼容财务
var changeFieldTypeSelectOption=selectOption||{};fieldVars[fieldMark]={changeFieldType:changeFieldType,changeFieldTypeSelectOption:changeFieldTypeSelectOption};});});});return{changeDatas:changeDatas,fieldVars:fieldVars};};this.generateFieldSqlTriInfo=function(tableMark,triFieldid,rowIndex){var _layoutStore10=_this.layoutStore,linkageCfg=_layoutStore10.linkageCfg,propFileCfg=_layoutStore10.propFileCfg,fieldAttrMap=_layoutStore10.fieldAttrMap,detailMap=_layoutStore10.detailMap;var triInfo={};var fieldSqlCfg=linkageCfg.fieldSqlCfg||{};if(_.isEmpty(fieldSqlCfg))return{};if(_this.triType===1){triFieldid in fieldSqlCfg&&fieldSqlCfg[triFieldid].map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields;if(_this.judgeFieldUnExistTemplate(assignField))return true;var rowIndexStr=rowIndex;var assignFieldBelMark=fieldAttrMap.get(assignField).tableMark;if(tableMark==="main"&&assignFieldBelMark.indexOf("detail_")>-1)//明细SQL取主表字段需联动所有明细行
rowIndexStr=detailMap.get(assignFieldBelMark).allRowIndexStr;var otherParams={assignfields:[assignField]};triInfo[config]={triFieldid:triFieldid,relateFields:relateFields,rowIndexStr:rowIndexStr,triTableMark:tableMark,otherParams:otherParams};});}else if(_this.triType===2){_.forIn(fieldSqlCfg,function(v,k){v&&v.map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields;if(_this.judgeFieldUnExistTemplate(assignField))return true;var belTableMark=fieldAttrMap.get(assignField).tableMark;if(belTableMark==="main"||propFileCfg.tri_fieldSql_detail==="1"){var rowIndexStr=belTableMark.indexOf("detail_")>-1?detailMap.get(belTableMark).allRowIndexStr:"-1";var otherParams={assignfields:[assignField]};triInfo[config]={triFieldid:"",relateFields:relateFields,rowIndexStr:rowIndexStr,triTableMark:belTableMark,otherParams:otherParams};}});});}else if(_this.triType===3){_.forIn(fieldSqlCfg,function(v,k){v&&v.map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields;if(_this.judgeFieldUnExistTemplate(assignField))return true;var belTableMark=fieldAttrMap.get(assignField).tableMark;if(belTableMark===tableMark){var otherParams={assignfields:[assignField]};triInfo[config]={triFieldid:"",relateFields:relateFields,rowIndexStr:rowIndex,triTableMark:belTableMark,otherParams:otherParams};}});});}return triInfo;};this.generateDateTimeTriInfo=function(tableMark,triFieldid,rowIndex){var _layoutStore11=_this.layoutStore,linkageCfg=_layoutStore11.linkageCfg,propFileCfg=_layoutStore11.propFileCfg,fieldAttrMap=_layoutStore11.fieldAttrMap,detailMap=_layoutStore11.detailMap;var triInfo={};var fieldDateCfg=linkageCfg.fieldDateCfg||{};if(_.isEmpty(fieldDateCfg))return{};if(_this.triType===1){triFieldid in fieldDateCfg&&fieldDateCfg[triFieldid].map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields;if(_this.judgeFieldUnExistTemplate(assignField))return true;triInfo[config]={triFieldid:triFieldid,relateFields:relateFields,rowIndexStr:rowIndex,triTableMark:tableMark};});}else if(_this.triType===2){_.forIn(fieldDateCfg,function(v,k){v&&v.map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields;if(_this.judgeFieldUnExistTemplate(assignField))return true;var belTableMark=fieldAttrMap.get(assignField).tableMark;if(belTableMark==="main"||propFileCfg.tri_dateTime_detail==="1"){var rowIndexStr=belTableMark.indexOf("detail_")>-1?detailMap.get(belTableMark).allRowIndexStr:"-1";triInfo[config]={triFieldid:"",relateFields:relateFields,rowIndexStr:rowIndexStr,triTableMark:belTableMark};}});});}else if(_this.triType===3){_.forIn(fieldDateCfg,function(v,k){v&&v.map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields;if(_this.judgeFieldUnExistTemplate(assignField))return true;var belTableMark=fieldAttrMap.get(assignField).tableMark;if(belTableMark===tableMark)triInfo[config]={triFieldid:"",relateFields:relateFields,rowIndexStr:rowIndex,triTableMark:belTableMark};});});}return triInfo;};this.generateDataInputTriInfo=function(tableMark,triFieldid,rowIndex){var _layoutStore12=_this.layoutStore,linkageCfg=_layoutStore12.linkageCfg,propFileCfg=_layoutStore12.propFileCfg,fieldAttrMap=_layoutStore12.fieldAttrMap,detailMap=_layoutStore12.detailMap;var triInfo={};var dataInputCfg=linkageCfg.dataInputCfg||{};if(_.isEmpty(dataInputCfg))return{};if(_this.triType===1){triFieldid in dataInputCfg&&dataInputCfg[triFieldid].map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields,otherParams=cfg.otherParams;triInfo[config]={triFieldid:triFieldid,relateFields:relateFields,rowIndexStr:rowIndex,triTableMark:tableMark,otherParams:otherParams};});}else if(_this.triType===2){var iscreate=parseInt(_this.commonParam.iscreate||0);_.forIn(dataInputCfg,function(v,triFieldid){if(!fieldAttrMap.has(triFieldid))return true;var belTableMark=fieldAttrMap.get(triFieldid).tableMark;var isDetail=belTableMark.indexOf("detail_")>-1;if(iscreate===1||!isDetail&&propFileCfg.tri_dataInput_main==="1"||isDetail&&propFileCfg.tri_dataInput_detail==="1"){var rowIndexStr=isDetail?detailMap.get(belTableMark).allRowIndexStr:"-1";v&&v.map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields,otherParams=cfg.otherParams;triInfo[config]={triFieldid:triFieldid,relateFields:relateFields,rowIndexStr:rowIndexStr,triTableMark:belTableMark,otherParams:otherParams};});}});}else if(_this.triType===3){_.forIn(dataInputCfg,function(v,triFieldid){if(!fieldAttrMap.has(triFieldid))return true;var belTableMark=fieldAttrMap.get(triFieldid).tableMark;if(belTableMark===tableMark){v&&v.map(function(cfg){var assignField=cfg.assignField,config=cfg.config,relateFields=cfg.relateFields,otherParams=cfg.otherParams;triInfo[config]={triFieldid:triFieldid,relateFields:relateFields,rowIndexStr:rowIndex,triTableMark:belTableMark,otherParams:otherParams};});}});}return triInfo;};this.generateReqLinkageParams=function(triInfo,linkageType){var fieldAttrMap=_this.layoutStore.fieldAttrMap;var params={requestid:_this.commonParam.requestid,workflowid:_this.commonParam.workflowid,nodeid:_this.commonParam.nodeid,formid:_this.commonParam.formid,isbill:_this.commonParam.isbill,triSource:_this.triType,showAI:_this.showAI?"1":"0"};var linkageid="";!_.isEmpty(triInfo)&&_.forIn(triInfo,function(v,key){var triFieldid=v.triFieldid,relateFields=v.relateFields,rowIndexStr=v.rowIndexStr,triTableMark=v.triTableMark,otherParams=v.otherParams;if(rowIndexStr==="")return true;var assignfields=otherParams&&otherParams.assignfields||[];linkageid+=key+",";params['triFieldid_'+key]=triFieldid;//params[`relateField_${key}`] = relateFields.toString();
params['rowIndexStr_'+key]=rowIndexStr;params['triTableMark_'+key]=triTableMark;rowIndexStr.split(",").map(function(rowIndex){//存在计算明细所有行情况
//字段联动,需要触发字段值
if(linkageType==="datainput"){var triFieldMark=triTableMark.indexOf("detail_")>-1?'field'+triFieldid+'_'+rowIndex:'field'+triFieldid;params[triFieldMark]=FieldUtil.getFieldValue(triFieldid,rowIndex);}//相关参与计算字段值
relateFields.map(function(fieldid){if(!fieldAttrMap.has(fieldid))return true;var fieldAttr=fieldAttrMap.get(fieldid);var fieldMark=fieldAttr.isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;if(fieldMark in params)//已取值不重复获取
return true;params[fieldMark]=FieldUtil.getFieldValue(fieldid,rowIndex);});//赋值字段为自定义浏览框的需要传依赖字段值
params=(0,_extends3.default)({},params,_this.generateCustomBrowserDependParams(assignfields,rowIndex));});});params["linkageid"]=linkageid!==""?linkageid.substring(0,linkageid.length-1):"";if(_this.commonParam.linkageUUID)params["linkageUUID"]=_this.commonParam.linkageUUID;return params;};this.generateCustomBrowserDependParams=function(fieldidArr,rowIndex){var customParams={};var fieldAttrMap=_this.layoutStore.fieldAttrMap;fieldidArr&&fieldidArr.forEach(function(fieldid){var fieldAttr=fieldAttrMap.get(fieldid)||{};var htmltype=fieldAttr.htmltype,detailtype=fieldAttr.detailtype,browserattr=fieldAttr.browserattr,isDetail=fieldAttr.isDetail;if(htmltype===3&&(detailtype===161||detailtype===162)){if(browserattr&&browserattr.hasOwnProperty('cusDependShip')&&browserattr.cusDependShip.length>0){var fieldMark=isDetail&&parseInt(rowIndex)>=0?'field'+fieldid+'_'+rowIndex:'field'+fieldid;var dependValues={};browserattr.cusDependShip.forEach(function(item){var dependFieldValue=FieldUtil.getFieldValue(item.fieldid,rowIndex);dependValues[item.key]=dependFieldValue;});customParams['customDepend_'+fieldMark]=(0,_stringify2.default)(dependValues);}}});return customParams;};this.sendLinkageAjax=function(triInfo,linkageType){if(_.isEmpty(triInfo))return;var _layoutStore13=_this.layoutStore,fieldAttrMap=_layoutStore13.fieldAttrMap,propFileCfg=_layoutStore13.propFileCfg,detailMap=_layoutStore13.detailMap;var iscreate=parseInt(_this.commonParam.iscreate||0);var reqInfoArr=new Array();//页面加载触发时，配置项控制是否拆分请求发送
if(_this.triType===2&&propFileCfg.split_req_linkageData==="1"){_.forIn(triInfo,function(cfg,key){var singleTriInfo=(0,_defineProperty3.default)({},key,cfg);reqInfoArr.push(_this.generateReqLinkageParams(singleTriInfo,linkageType));});}else{reqInfoArr.push(_this.generateReqLinkageParams(triInfo,linkageType));}reqInfoArr.length>0&&reqInfoArr.map(function(params){if(!params.linkageid)return true;var orderInfo=LinkageControl.generateKeyOrder(linkageType,params);var API_FUNCTION=null;if(linkageType==="datainput")API_FUNCTION=_source2.default.API_REQ.reqDataInputResult(params);else if(linkageType==="fieldsql")API_FUNCTION=_source2.default.API_REQ.reqFieldSqlResult(params);else if(linkageType==="datetime")API_FUNCTION=_source2.default.API_REQ.reqDateTimeResult(params);API_FUNCTION.then(function(data){try{data=LinkageControl.removeInvalidResponse(orderInfo,data);//字段联动，主表联动明细，是否先删除已有明细
if(linkageType==="datainput"&&_this.triType===1){var delDetailMap={};!_.isEmpty(data)&&_.forIn(data,function(v,k){//主表联动明细
var addRows=v["addDetailRow"]||{};var entryid=k.replace("assignInfo_","");var needDelRow=triInfo[entryid].otherParams&&triInfo[entryid].otherParams.isdel=="1";if(needDelRow&&!_.isEmpty(addRows)){//先删除新增的明细行
var detailMarkArr=(0,_keys2.default)(addRows);detailMarkArr.length>0&&detailMarkArr.map(function(detailMark){var delRowArr=[];var detailObj=detailMap.get(detailMark);var rowInfo=detailObj.rowInfo;!_.isEmpty(rowInfo)&&rowInfo.forEach(function(info,rowKey){if(parseInt(info.get("keyid")||0)<=0&&info.get("fromLinkage")===true)delRowArr.push(rowKey.substring(4));});if(delRowArr.length>0){delDetailMap[detailMark]=delRowArr;}});}});if((0,_keys2.default)(delDetailMap).length>0){_.forIn(delDetailMap,function(delRowArr,detailMark){DetailUtil.delAssignRow(detailMark,delRowArr);});}}//联动结果赋值，字段联动需先给主字段赋值再添加明细行
var changeDatas={};var addRowInfo=[];var linkageSql=[];!_.isEmpty(data)&&_.forIn(data,function(v,k){if(_.isEmpty(v))return true;var changeValue=v["changeValue"];//字段联动,主表联动明细
if(linkageType==="datainput"&&(_this.triType===1||_this.triType===2&&iscreate===1)){var addRows=v["addDetailRow"];!_.isEmpty(addRows)&&_.forIn(addRows,function(rowDatas,detailMark){rowDatas&&rowDatas.map(function(rowData){addRowInfo.push({detailMark:detailMark,rowData:rowData});});});}//联动赋值
_.forIn(changeValue,function(valueInfo,key){var fieldArr=key.split("_");var fieldid=fieldArr[0].substring(5);var rowIndex=fieldArr.length>1?fieldArr[1]:"-1";if(fieldAttrMap.has(fieldid)){var fieldAttr=fieldAttrMap.get(fieldid);var fieldMark=fieldAttr.isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;changeDatas[fieldMark]=valueInfo;}});//联动执行过的SQL集合
if(_this.showAI&&!!v.linkageSql)linkageSql.push(v.linkageSql);if(v.resultOutOfLimit==true){if(linkageType==="datainput"){window.WfForm.showMessage(_source2.default.getLabel(529187,"联动结果集数量超出限制，请检查字段联动设置！"),1,3);}else{window.WfForm.showMessage(_source2.default.getLabel(529188,"字段赋值SQL结果集数量超出限制，请检查设置！"),1,3);}}});//字段值赋值
var stepid=0;if(_this.showAI){var asyncParams={linkageType:linkageType,linkageSql:linkageSql,reqParams:params,reqResult:data};stepid=AI.generateStepId(AI.TYPE_LINKAGE_ASYNC,(0,_extends3.default)({},_this.triInfo,asyncParams));}_this.layoutStore.changeMoreFieldData(changeDatas,{},stepid);//记录主表联动明细的数据，行号+行数据
var addRowConvertInfo=[];//添加明细行
//针对主表联动明细，明细再触发联动，瞬时请求过多，做合并请求处理
var minDtRowEnableMerge=propFileCfg.minDtRowEnableMerge||30;//大于30行才启用请求合并
var enableMerge=addRowInfo.length>minDtRowEnableMerge;var mergeLinkageRowCount=propFileCfg.mergeLinkageRowCount||20;//每20行合并成一个请求
var count=0;var mergeRowIndexStr="";var detailMark="";addRowInfo.map(function(item,index){count++;var mergeLinkageCfg={};if(enableMerge){if(count<mergeLinkageRowCount&&index!==addRowInfo.length-1&&(detailMark==""||addRowInfo[index+1].detailMark==item.detailMark)){//未满并且非最后一行
mergeLinkageCfg={forbidLinkage:true,isLastRow:index===addRowInfo.length-1};}else{mergeLinkageCfg={forbidLinkage:false,rowIndexStr:mergeRowIndexStr};count=0;mergeRowIndexStr="";}}detailMark=item.detailMark;var detailIndex=DetailUtil.addRow(item.detailMark,item.rowData,true,false,mergeLinkageCfg);if(enableMerge&&count<mergeLinkageRowCount)mergeRowIndexStr+=detailIndex+",";var convertInfo={'detailIndex':detailIndex,'rowData':item.rowData};addRowConvertInfo.push(convertInfo);});//联动赋值完成后，浏览按钮类型变更，异步请求重新赋值
_this.generateConvertDatas(changeDatas,addRowConvertInfo);}catch(e){/* eslint no-console: 0 */if(window.console)console.error("sendLinkageAjax "+linkageType+" Exception:",params,data,e);}});});};this.generateConvertDatas=function(){var changeDatas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var addRowConvertInfo=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var convertDatas=[];//非主表联动明细数据
var fieldMark="";for(fieldMark in changeDatas){_this.getConvertDatas(fieldMark,changeDatas[fieldMark].value,convertDatas);}//主表联动明细数据
addRowConvertInfo&&addRowConvertInfo.map(function(item){!_.isEmpty(item.rowData)&&_.forIn(item.rowData,function(v,k){if(k.indexOf("field")>-1){var _fieldMark=k+"_"+item.detailIndex;_this.getConvertDatas(_fieldMark,v.value,convertDatas);}});});//浏览按钮类型变更数据不为空，则异步请求重新赋值
if(!_.isEmpty(convertDatas)){_this.sendConvertTypeAjax(convertDatas);}};this.getConvertDatas=function(){var fieldMark=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var fieldvalue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var convertDatas=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var fieldAttr=FieldUtil.getFieldAttr(fieldMark);if(_.isEmpty(fieldAttr))return;var tableMark=fieldAttr.tableMark;var fieldObj=FieldUtil.getFieldObj(fieldMark,tableMark);var fieldid=_this.getFieldid(fieldMark);if(fieldObj&&fieldObj.variable.has("changeFieldType")){var changeFieldType=fieldObj.variable.get("changeFieldType");var convertInfo={requestid:_this.commonParam.requestid,formid:_this.commonParam.formid,isbill:_this.commonParam.isbill,fieldid:fieldid,fieldvalue:fieldvalue,destFieldid:fieldMark,browserType:changeFieldType};convertDatas.push(convertInfo);}};this.sendConvertTypeAjax=function(){var convertDatas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(_.isEmpty(convertDatas))return;var params={arrayInfo:(0,_stringify2.default)(convertDatas)};_source2.default.API_REQ.getBrowserInfo(params).then(function(data){if(data&&data.result){var jsonMsgs=JSON.parse(data.result);for(var idx=0;idx<jsonMsgs.length;idx++){var jsonMsg=jsonMsgs[idx];var fieldMark=jsonMsg.destFieldid;var valueInfo=jsonMsg.destFieldValue;if(valueInfo.value){valueInfo.value=valueInfo.value.trim();}var changeDatas={};changeDatas[fieldMark]=valueInfo;var stepid=AI.generateStepId(AI.TYPE_LINKAGE_ASYNC);_this.layoutStore.changeMoreFieldData(changeDatas,{},stepid);}}});};this.getFieldid=function(fieldMark){if(fieldMark.indexOf("_")>-1)fieldMark=fieldMark.substring(0,fieldMark.indexOf("_"));if(fieldMark.indexOf("field")>-1)fieldMark=fieldMark.substring(5);return fieldMark;};this.triType=parseInt(triType);this.layoutStore=_source2.default.layoutStore;this.commonParam=_source2.default.globalStore.commonParam;this.showAI=_source2.default.globalStore.commonParam&&_source2.default.globalStore.commonParam.showAI=="1";}/************ 联动总控,触发入口,非异步联动全部计算完后只做一次结果变更，单类型异步联动只发一次请求，联动考虑明细单行及所有行情况 ************///判断明细表是否不在模板上
//判断字段是否不在模板上
//计算明细字段合计值
//执行行规则运算
//执行列规则运算
//执行字段赋值运算
//执行公式运算
//控制选择框联动
//控制显示属性联动
//显示属性联动判断条件是否满足
//联动控制字段类型(财务选择框联动浏览按钮、人力将时间变为选择框等等)
//生成SQL联动触发信息
//生成日期时间计算触发信息
//生成字段联动触发信息
//生成联动后台请求参数
//生成自定义浏览按钮字段依赖的字段值信息，传递给接口算出名称
//发送ajax异步请求服务器，获取联动结果并赋值
//生成浏览按钮类型转换信息
//发送ajax异步请求服务器，获取浏览按钮类型转换结果，并赋值
//获取字段ID
;exports.default=Linkage;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.calculateFormula=undefined;var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _fieldUtil=__webpack_require__(17);var _inputUtil=__webpack_require__(81);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//公式运算入口
var calculateFormula=exports.calculateFormula=function calculateFormula(triInfo){var _src$layoutStore=_source2.default.layoutStore,dataJson=_src$layoutStore.dataJson,fieldAttrMap=_src$layoutStore.fieldAttrMap,detailMap=_src$layoutStore.detailMap;var formulaCfg=dataJson.formula||{};var changeDatas={};triInfo.map(function(info){try{var cfg=formulaCfg[info.formulaKey];if(!cfg||!_.has(cfg,"destfield")||!_.has(cfg,"formulatxt")||!_.has(cfg,"cellrange"))return true;var destCell=cfg["destcell"];var destField=cfg["destfield"];var formulaTxt=_.trim(cfg["formulatxt"]).substring(1);//公式解析分如下几种情况
if(destCell.indexOf("DETAIL_")===-1){//赋值给主表字段
var result='';if(/DETAIL_\d+\./.test(formulaTxt)){//取值字段包含明细表字段
var reg=/^(EXCEL_AVERAGE|EXCEL_MIN|EXCEL_MAX)\((\s*(MAIN|TAB_\d+|DETAIL_\d+)\.[A-Z]+\d+\s*(\,)?)+\)$/;if(reg.test(formulaTxt)){//求平均、最大、最小特殊处理(例：AVG(明细字段或主字段))
result=calculate_detail_special(formulaTxt);}else{result=calculate_detail_sum(formulaTxt);}}else{//取值字段全部为主表字段
result=calculate_single(formulaTxt,-1);}changeDatas['field'+destField]={value:result};}else{//赋值给明细字段
var destTableMark=fieldAttrMap.get(destField).tableMark;var rowIndexStr=info.triRowMark==="all"?getDetailAllRowIndexStr(destTableMark):info.triRowMark.toString();!!rowIndexStr&&rowIndexStr.split(",").map(function(rowIndex){var result=calculate_single(formulaTxt,rowIndex);changeDatas['field'+destField+'_'+rowIndex]={value:result};});}}catch(ex){/* eslint no-console: 0 */if(window.console)console.error("Formula calculate error: "+ex);}});return changeDatas;};//获取明细表全部行id拼接成串
var getDetailAllRowIndexStr=function getDetailAllRowIndexStr(detailMark){var detailMap=_source2.default.layoutStore.detailMap;return detailMap.has(detailMark)?detailMap.get(detailMark).allRowIndexStr:"";};//单条/单行公式计算
var calculate_single=function calculate_single(formulaTxt,rowMark){return evalFormual(replaceFormula(formulaTxt,rowMark));};//明细列求平均/最大赋值主字段，特殊公式处理
var calculate_detail_special=function calculate_detail_special(formulaTxt){return evalFormual(replaceFormula(formulaTxt,"all"));};//明细作为取值字段的公式，计算明细每一行公式结果，再合计赋值主字段
var calculate_detail_sum=function calculate_detail_sum(formulaTxt){var sumResult="";var detailMark=formulaTxt.match(/(DETAIL_\d+)/g)[0].toLowerCase();var allRowIndex=getDetailAllRowIndexStr(detailMark);!!allRowIndex&&allRowIndex.split(",").map(function(rowIndex){try{var singleRowResult=evalFormual(replaceFormula(formulaTxt,rowIndex));sumResult=EXCEL_SUM(sumResult,singleRowResult);}catch(ev){}});return sumResult;};var evalFormual=function evalFormual(expression){var result="";try{result=eval(expression);}catch(e){/* eslint no-console: 0 */if(window.console)console.error("evalFormual Appear Exception:"+expression);}return result.toString();};//替换公式，单元格标示替换成对应字段值
var replaceFormula=function replaceFormula(formulaTxt,rowMark){if(rowMark!=="all"&&isNaN(rowMark))throw new Error("RowMark Parameter Illegal");var cellInfo=_source2.default.layoutStore.cellInfo;var fieldCellInfo=cellInfo.fieldCellInfo||{};var reg=/(MAIN|TAB_\d+|DETAIL_\d+)\.[A-Z]+\d+/g;formulaTxt.match(reg).map(function(cellAttr){var fieldValue="";var fieldid=convertCellAttrToFieldid(fieldCellInfo,cellAttr);if(!!fieldid){//单元格非字段情况作为空值处理
var isDetail=cellAttr.indexOf("DETAIL_")>-1;var tableMark=isDetail?cellAttr.split(".")[0].toLowerCase():"main";if(isDetail&&rowMark==="all"){//求明细列最大等情况，需取明细所有行值参与计算
var allRowIndex=getDetailAllRowIndexStr(tableMark);!!allRowIndex&&allRowIndex.split(",").map(function(rowIndex,index){if(index>0)fieldValue+=",";fieldValue+=getSingleFieldValue(fieldid,rowIndex,tableMark);});}else{fieldValue=getSingleFieldValue(fieldid,rowMark,tableMark);}}//表达式替换
var reg1=new RegExp(cellAttr+"(?!\\d)","g");if(fieldValue.startsWith("-"))fieldValue='('+fieldValue+')';formulaTxt=formulaTxt.replace(reg1,fieldValue);});return formulaTxt;};//获取单个字段值
var getSingleFieldValue=function getSingleFieldValue(fieldid,rowIndex,tableMark){var fieldAttrMap=_source2.default.layoutStore.fieldAttrMap;var fieldValue=(0,_fieldUtil.getFieldValue)(fieldid,rowIndex);var fieldAttr=fieldAttrMap.get(fieldid);if(fieldAttr.htmltype===1&&fieldAttr.detailtype===5)fieldValue=fieldValue.toString().replace(/,/g,"");//非数值结果作为字符串处理
if(fieldValue===""||!(0,_inputUtil.judgeIsNumber)(fieldValue,true))fieldValue="\""+fieldValue+"\"";return fieldValue;};//公式标示转换成单元格标示(例：DETAIL_1.C4------>detail_1_4_3)
var convertCellAttrToFieldid=function convertCellAttrToFieldid(fieldCellInfo,cellAttr){var symbol=cellAttr.split(".")[0].toLowerCase();var letter=cellAttr.split(".")[1];var rowid=parseInt(letter.match(/\d+$/)[0])-1;var colid=convertCharToInt(letter.match(/^[a-zA-Z]+/)[0])-1;var fieldid="";_.forIn(fieldCellInfo,function(v,k){if(v.rowid===rowid&&v.colid===colid&&v.symbol===symbol){fieldid=k;return false;}});return fieldid;};//字母转数字(例：AB---->27)
var convertCharToInt=function convertCharToInt(value){var rtn=0;var powIndex=0;for(var i=value.length-1;i>=0;i--){var tmpInt=value[i].charCodeAt()-64;rtn+=Math.pow(26,powIndex)*tmpInt;powIndex++;}return rtn;};//是否是纯数字、整数
function isInt(str){var reg=/^[0-9]+$/;return reg.test(str);}//是否是数值类型
//JS parseFloat求和精度不一致问题解决
function rewrite_add(arg1,arg2){var r1=0,r2=0;try{r1=arg1.toString().split(".")[1].length;}catch(e){}try{r2=arg2.toString().split(".")[1].length;}catch(e){}var m=Math.pow(10,Math.max(r1,r2));return(arg1*m+arg2*m)/m;}//求和
function EXCEL_SUM(){var result="";for(var i=0;i<arguments.length;i++){var par=arguments[i];if(!isNaN(parseFloat(par))){if(result==="")result=0;result=rewrite_add(result,par);}}return result;}//求平均数
function EXCEL_AVERAGE(){var count=0;var sumVal=0;for(var i=0;i<arguments.length;i++){var par=arguments[i];if(!isNaN(parseFloat(par))){//sumVal += parseFloat(par);
sumVal=rewrite_add(sumVal,par);count++;}}if(count>0){return parseFloat(sumVal/count);}else{throw new Error("EXCEL_AVERAGE divisor is zero");}}//求绝对值
function EXCEL_ABS(){if(arguments.length==1){var par=arguments[0];if(!isNaN(parseFloat(par))){var result=Math.abs(parseFloat(par));return result;}else{throw new Error("EXCEL_ABS arguments value is not a number");}}else{throw new Error("EXCEL_ABS arguments number must equal one");}}//精度计算
function EXCEL_ROUND(){if(arguments.length==2){var par1=arguments[0];var par2=arguments[1];if(!isNaN(parseFloat(par1))){par1=parseFloat(par1);}else{throw new Error("EXCEL_ROUND first argument value is not a number");}if(isInt(par2)){par2=parseInt(par2);}else{throw new Error("EXCEL_ROUND second argument value is not a int");}return(0,_inputUtil.convertFloatValue)(par1,par2);}else{throw new Error("EXCEL_ROUND arguments number must equal two");}}//条件判断
function EXCEL_IF(){if(arguments.length==3){if(eval(arguments[0])){return arguments[1];}else{return arguments[2];}}else{throw new Error("EXCEL_IF arguments number must equal three");}}//求最大值
function EXCEL_MAX(){var result;for(var i=0;i<arguments.length;i++){var par=arguments[i];if(!isNaN(parseFloat(par))){if(result==null){result=parseFloat(par);}else{if(parseFloat(par)>result)result=parseFloat(par);}}}if(result!=null){return result;}else{throw new Error("EXCEL_MAX arguments value must contain a number");}}//求最小值
function EXCEL_MIN(){var result;for(var i=0;i<arguments.length;i++){var par=arguments[i];if(!isNaN(parseFloat(par))){if(result==null){result=parseFloat(par);}else{if(parseFloat(par)<result)result=parseFloat(par);}}}if(result!=null){return result;}else{throw new Error("EXCEL_MIN arguments value must contain a number");}}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.StatusStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _dec,_dec2,_dec3,_dec4,_dec5,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var StatusStore=exports.StatusStore=(_dec=(0,_mobx.action)('切换卡片类型'),_dec2=(0,_mobx.action)('加载流程状态数据'),_dec3=(0,_mobx.action)('加载计数信息'),_dec4=(0,_mobx.action)('控制显示/隐藏的行节点'),_dec5=(0,_mobx.action)('控制显示/隐藏全部的行节点'),(_class=function(){//选择的节点
function StatusStore(){var _this=this;(0,_classCallCheck3.default)(this,StatusStore);this.baseParam={};_initDefineProp(this,'cardid',_descriptor,this);_initDefineProp(this,'counts',_descriptor2,this);_initDefineProp(this,'dataMap',_descriptor3,this);this.paramMap=_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});_initDefineProp(this,'hideRowKeys',_descriptor4,this);_initDefineProp(this,'nodeOptions',_descriptor5,this);_initDefineProp(this,'selectedNode',_descriptor6,this);_initDefineProp(this,'selectedOperator',_descriptor7,this);_initDefineProp(this,'isHideAll',_descriptor8,this);_initDefineProp(this,'setBaseParam',_descriptor9,this);_initDefineProp(this,'setCounts',_descriptor10,this);_initDefineProp(this,'setSelectedNode',_descriptor11,this);_initDefineProp(this,'setSelectedOperator',_descriptor12,this);_initDefineProp(this,'appendDataMap',_descriptor13,this);_initDefineProp(this,'switchCard',_descriptor14,this);_initDefineProp(this,'loadData',_descriptor15,this);_initDefineProp(this,'loadCounts',_descriptor16,this);_initDefineProp(this,'controlHideRow',_descriptor17,this);_initDefineProp(this,'controlHideAllRow',_descriptor18,this);this.getHasAdSearch=function(){return _this.selectedOperator!=""||_this.selectedNode!="-1";};_initDefineProp(this,'clearnSearchStatus',_descriptor19,this);this.switchCard=this.switchCard;this.loadData=this.loadData;this.loadCounts=this.loadCounts;this.controlHideRow=this.controlHideRow;this.controlHideAllRow=this.controlHideAllRow;this.setSelectedNode=this.setSelectedNode;this.setSelectedOperator=this.setSelectedOperator;this.clearnSearchStatus=this.clearnSearchStatus;}//选择的操作者
//节点选项
(0,_createClass3.default)(StatusStore,[{key:'getUrlParams',value:function getUrlParams(){var url=window.location.href;var result={};var idx=url.lastIndexOf('?');if(idx>0){var params=url.substring(idx+1).split('&');for(var i=0;i<params.length;i++){idx=params[i].indexOf('=');if(idx>0){result[params[i].substring(0,idx)]=params[i].substring(idx+1);}}}return result;}}]);return StatusStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'cardid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'counts',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'dataMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({});}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'hideRowKeys',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'nodeOptions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[{key:"-1",selected:false,showname:""}];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'selectedNode',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"-1";}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'selectedOperator',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'isHideAll',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'setBaseParam',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var param=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this2.baseParam=param;};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'setCounts',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(counts){_this3.counts=counts;};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'setSelectedNode',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(id){_this4.selectedNode=id;};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'setSelectedOperator',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(id){_this5.selectedOperator=id;};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'appendDataMap',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(data){_this6.dataMap.set(_this6.cardid,data);};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'switchCard',[_dec],{enumerable:true,initializer:function initializer(){var _this7=this;return function(cardid){if(cardid.indexOf("_")>-1){//有搜索条件的情况
cardid=cardid.substring(0,cardid.indexOf("_"));}if(_this7.getHasAdSearch()){cardid=cardid+"_"+_this7.selectedNode+"_"+_this7.selectedOperator;}_this7.cardid=cardid;if(!_this7.dataMap.has(cardid))_this7.loadData(true);};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'loadData',[_dec2],{enumerable:true,initializer:function initializer(){var _this8=this;return function(isfirst){var params=(0,_extends3.default)({},_this8.baseParam,{desremark:_this8.cardid,isfirst:isfirst,pageSize:50,selectedNode:_this8.selectedNode,selectedOperator:_this8.selectedOperator});var urlParams=_this8.getUrlParams();if(!isfirst)params["parameter"]=(0,_stringify2.default)(_this8.paramMap.get(_this8.cardid));_base2.default.globalStore.setLoading(true);if(urlParams.hasOwnProperty('fromCommunication')){params=(0,_extends3.default)({},params,{fromCommunication:urlParams.fromCommunication});}var isAdSearch=_this8.getHasAdSearch();API_REQ.getWfStatus(params).then(function(data){_base2.default.globalStore.setLoading(false);var datas=data.datas,parameter=data.parameter;var newData=_this8.dataMap.has(_this8.cardid)?_.cloneDeep(mobx.toJS(_this8.dataMap.get(_this8.cardid))):{};!_.isEmpty(datas)&&_.forIn(datas,function(nodeData,key){if(key in newData){//同节点追加数据
newData[key].list=_.concat(newData[key].list||[],nodeData.list||[]);}else{newData[key]=nodeData;}});if(isAdSearch&&isfirst){if(!_this8.counts[_this8.cardid+"count"]){_this8.counts[_this8.cardid+"count"]=data.count;}}_this8.appendDataMap(newData);_this8.paramMap.set(_this8.cardid,parameter);});};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'loadCounts',[_dec3],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){var urlParams=_this9.getUrlParams();var params=_this9.baseParam;if(urlParams.hasOwnProperty('fromCommunication')){params=(0,_extends3.default)({},params,{fromCommunication:urlParams.fromCommunication});}API_REQ.getWfStatusCount(params).then(function(data){_this9.setCounts(data);_this9.nodeOptions=data.selectNodeOptions;});};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'controlHideRow',[_dec4],{enumerable:true,initializer:function initializer(){var _this10=this;return function(key){var index=_.indexOf(_this10.hideRowKeys,key);if(index===-1)_this10.hideRowKeys.push(key);else _this10.hideRowKeys.splice(index,1);//删除一项
};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'controlHideAllRow',[_dec5],{enumerable:true,initializer:function initializer(){var _this11=this;return function(size){_this11.isHideAll=!_this11.isHideAll;_this11.hideRowKeys=[];if(_this11.isHideAll){for(var i=0;i<size;i++){_this11.hideRowKeys.push('rowDataHead_'+(i+1));}}};}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'clearnSearchStatus',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this12=this;return function(){_this12.selectedNode="-1";_this12.selectedOperator="";_this12.isHideAll=false;_this12.hideRowKeys=[];};}})),_class));

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.EhOperatorStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var EhOperatorStore=exports.EhOperatorStore=(_class=function EhOperatorStore(){var _this=this;(0,_classCallCheck3.default)(this,EhOperatorStore);this.baseParams={};this.fields=[];_initDefineProp(this,'ehform',_descriptor,this);this.callBackEvent=null;_initDefineProp(this,'setBaseParams',_descriptor2,this);this.doInit=function(){(0,_req.chooseExceptionOperator)(_this.baseParams).then(function(data){var fields=data.fields,formValue=data.formValue;_this.fields=fields;var _getComsMobx=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx.WeaForm;_this.ehform=new WeaForm();_this.ehform.initFormFieldObj(fields);_this.ehform.updateFields(formValue);});};this.setCallBackEvent=function(fun){_this.callBackEvent=fun;};this.doCancel=function(){var ehparams={eh_setoperator:"n",isFirstSubmit:1,ehnextnodeid:_this.baseParams.ehnextnodeid};_this.callBackEvent(ehparams);};this.setBaseParams=this.setBaseParams;this.doInit=this.doInit;this.setCallBackEvent=this.setCallBackEvent;this.doCancel=this.doCancel;},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'ehform',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'setBaseParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this2.baseParams=params;};}})),_class);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RejectStore=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _defineProperty4=__webpack_require__(55);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _extends4=__webpack_require__(7);var _extends5=_interopRequireDefault(_extends4);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var RejectStore=exports.RejectStore=(_class=function RejectStore(){var _this=this;(0,_classCallCheck3.default)(this,RejectStore);this.baseParams={};this.chooseInfo={};_initDefineProp(this,'rejectNodeList',_descriptor,this);_initDefineProp(this,'remindNodeList',_descriptor2,this);_initDefineProp(this,'rejectNodeOperators',_descriptor3,this);_initDefineProp(this,'showAllRejectNodeOperators',_descriptor4,this);_initDefineProp(this,'remindNodeOperators',_descriptor5,this);_initDefineProp(this,'showAllRemindNodeOperators',_descriptor6,this);_initDefineProp(this,'isSubmitDirectOptions',_descriptor7,this);this.confirmEvent=null;this.cancelEvent=null;_initDefineProp(this,'result',_descriptor8,this);_initDefineProp(this,'setBaseParams',_descriptor9,this);_initDefineProp(this,'setChooseInfo',_descriptor10,this);this.doInit=function(){_this.result={};var _chooseInfo=_this.chooseInfo,checkedRejectNodeKey=_chooseInfo.checkedRejectNodeKey,rejectNodeList=_chooseInfo.rejectNodeList,remindNodeList=_chooseInfo.remindNodeList,submitDirectNodeOptions=_chooseInfo.submitDirectNodeOptions,rejectNodeOperators=_chooseInfo.rejectNodeOperators,remindNodeOperators=_chooseInfo.remindNodeOperators;var remindNodeid="";remindNodeList&&remindNodeList.map(function(item,index){remindNodeid+=(index>0?",":"")+item.key;});_this.appendResult({rejectNodeKey:checkedRejectNodeKey,remindNodeid:remindNodeid});_this.rejectNodeList=rejectNodeList;_this.remindNodeList=remindNodeList;_this.rejectNodeOperators=rejectNodeOperators;_this.remindNodeOperators=remindNodeOperators;_this.showAllRejectNodeOperators={};_this.showAllRemindNodeOperators={};_this.isSubmitDirectOptions=submitDirectNodeOptions;_this.isSubmitDirectOptions&&_this.isSubmitDirectOptions.map(function(option){if(option.selected==true){_this.appendResult({isSubmitDirect:option.key});}});};this.setConfirmEvent=function(fun){_this.confirmEvent=fun;};this.setCancelEvent=function(fun){_this.cancelEvent=fun;};this.appendResult=function(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.result=(0,_extends5.default)({},_this.result,obj);};this.setShowAllRejectNodeOperators=function(key){var showAllRejectNodeOperators=(0,_extends5.default)({},_this.showAllRejectNodeOperators,(0,_defineProperty5.default)({},key,!_this.showAllRejectNodeOperators[key]));_this.showAllRejectNodeOperators=showAllRejectNodeOperators;};this.setShowAllRemindNodeOperators=function(key){var showAllRemindNodeOperators=(0,_extends5.default)({},_this.showAllRemindNodeOperators,(0,_defineProperty5.default)({},key,!_this.showAllRemindNodeOperators[key]));_this.showAllRemindNodeOperators=showAllRemindNodeOperators;};this.setBaseParams=this.setBaseParams;this.doInit=this.doInit;this.setConfirmEvent=this.setConfirmEvent;this.setCancelEvent=this.setCancelEvent;this.appendResult=this.appendResult;this.setShowAllRejectNodeOperators=this.setShowAllRejectNodeOperators;this.setShowAllRemindNodeOperators=this.setShowAllRemindNodeOperators;}//用户选择退回后再提交的处理方式选项
//提醒节点的操作者
//退回节点的操作者
,(_descriptor=_applyDecoratedDescriptor(_class.prototype,'rejectNodeList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'remindNodeList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'rejectNodeOperators',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'showAllRejectNodeOperators',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'remindNodeOperators',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'showAllRemindNodeOperators',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'isSubmitDirectOptions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'result',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'setBaseParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this2.baseParams=params;};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'setChooseInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this3.chooseInfo=info;};}})),_class);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ShareStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ShareStore=exports.ShareStore=(_class=function ShareStore(){(0,_classCallCheck3.default)(this,ShareStore);_initDefineProp(this,'msginfo',_descriptor,this);this.shareParams={};_initDefineProp(this,'setMsgInfo',_descriptor2,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'msginfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'setMsgInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var shareParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _base$globalStore=_base2.default.globalStore,commonParam=_base$globalStore.commonParam,invalidParam=_base$globalStore.invalidParam,urlParams=_base$globalStore.urlParams;var requestid=commonParam.requestid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,requestnamenew=commonParam.requestnamenew,requestname=commonParam.requestname,currentUserid=commonParam.currentUserid;var firstSharer=urlParams.firstSharer;var serialid=shareParams.serialid?shareParams.serialid:urlParams.serialid||"";var cur_sharer=f_weaver_belongto_userid;var first_sharer=firstSharer||f_weaver_belongto_userid;var urlstr='?resourcetype=0&resourceid='+requestid+'&isfromchatshare=1&sharer='+currentUserid+'&firstSharer='+first_sharer+'&serialid='+serialid+'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype='+f_weaver_belongto_usertype;_this.shareParams={"resourcetype":152,"resourceid":requestid,"serialid":serialid,"firstSharer":first_sharer,"f_weaver_belongto_userid":f_weaver_belongto_userid,"f_weaver_belongto_usertype":f_weaver_belongto_usertype};_this.msginfo=[{sharetitle:requestnamenew?requestnamenew:requestname,linkurl:'/common/chatResource/view.html'+urlstr,objectName:'FW:CustomShareMsg',canforward:1,callbackurl:'/api/common/chatResource/addshare'+urlstr,sharetype:'workflow',shareid:''+requestid,serialid:serialid,opentype:1,opentype_pc:2}];_this.joinerParams={showJoiner:true,joinerUrl:"/api/workflow/forward/getReqWfNodeOperatorsNew",joinerUrlParams:{requestid:requestid}};};}})),_class);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.OverTimeStore=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _defineProperty4=__webpack_require__(55);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _extends3=__webpack_require__(7);var _extends4=_interopRequireDefault(_extends3);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var OverTimeStore=exports.OverTimeStore=(_class=function OverTimeStore(){var _this=this;(0,_classCallCheck3.default)(this,OverTimeStore);this.baseParams={};this.columns=[];_initDefineProp(this,'nodeList',_descriptor,this);_initDefineProp(this,'nodeDatas',_descriptor2,this);this.closeEvent=null;_initDefineProp(this,'setBaseParams',_descriptor3,this);this.doInit=function(){(0,_req.overTimeSetting)((0,_extends4.default)({},_this.baseParams,{opertype:"get"})).then(function(data){_this.nodeList=data.nodeList;_this.nodeDatas=data.nodeDatas;});};this.doSave=function(){var nodeids="";_this.nodeList.length>0&&_this.nodeList.map(function(key,index){nodeids+=''+(index>0?",":"")+key;});var params={opertype:"save",nodeids:nodeids};params=(0,_extends4.default)({},params,_this.baseParams,mobx.toJS(_this.nodeDatas));(0,_req.overTimeSetting)(params).then(function(data){_this.closeEvent();});};this.changeDatas=function(key,value){_this.nodeDatas=(0,_extends4.default)({},_this.nodeDatas,(0,_defineProperty5.default)({},key,value));};this.setCloseEvent=function(fun){_this.closeEvent=fun;};this.setBaseParams=this.setBaseParams;this.doInit=this.doInit;this.doSave=this.doSave;this.changeDatas=this.changeDatas;this.setCloseEvent=this.setCloseEvent;},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'nodeList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'nodeDatas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'setBaseParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this2.baseParams=params;};}})),_class);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RequestWithdrawStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _dec,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);var _antd=__webpack_require__(87);var _convert=__webpack_require__(6);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var RequestWithdrawStore=exports.RequestWithdrawStore=(_dec=(0,_mobx.action)('修改store中的属性'),(_class=function RequestWithdrawStore(){var _this=this;(0,_classCallCheck3.default)(this,RequestWithdrawStore);_initDefineProp(this,'loading',_descriptor,this);this.baseParams={};this.allowRemind='';this.isRemind='1';this.recallNodeId="";this.recallNodeName="";this.doPreOperate="";this.remarkRequired="";this.lastOperateTime="";this.lastOperateDate="";this.currentdate="";this.currenttime="";this.closeEvent=function(){};_initDefineProp(this,'doInit',_descriptor2,this);this.doSubmit=function(){var remark=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var submitParams={actionType:'submit','isRemind':_this.isRemind,'remark':remark,'recallNodeId':_this.recallNodeId,'doPreOperate':_this.doPreOperate,'lastOperateDate':_this.lastOperateDate,'lastOperateTime':_this.lastOperateTime,'currentdate':_this.currentdate,'currenttime':_this.currenttime};GlobalUtil.verifyCustomRegisterEvent(_interface2.default.OPER_WITHDRAW,function(){_this.loading=true;_antd.message.loading((0,_convert.getLabel)(515991,'撤回中...，请稍候'),0);(0,_req.requestWithDraw)((0,_extends3.default)({},_this.baseParams,submitParams)).then(function(data){_antd.message.destroy();var msg=data.msg;if(data.result=="success"){_antd.message.success(msg);_this.closeEvent();Util.reloadRequestPage((0,_extends3.default)({},_this.baseParams));}else{_antd.message.error(msg);}_this.loading=false;});});};this.setCloseEvent=function(fun){_this.closeEvent=fun;};this.setIsRemind=function(isRemind){_this.isRemind=isRemind;};_initDefineProp(this,'setState',_descriptor3,this);this.doInit=this.doInit;this.doSubmit=this.doSubmit;this.setCloseEvent=this.setCloseEvent;this.setIsRemind=this.setIsRemind;},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'doInit',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this2.baseParams=params;(0,_req.requestWithDraw)((0,_extends3.default)({},_this2.baseParams,{actionType:'getSettings'})).then(function(data){_this2.allowRemind=data.allowRemind;_this2.recallNodeId=data.recallNodeId;_this2.recallNodeName=data.recallNodeName;_this2.doPreOperate=data.doPreOperate;_this2.remarkRequired=data.remarkRequired;_this2.loading=false;});};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'setState',[_dec],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var toJS=mobx.toJS;console.log("state",state);var keys=(0,_keys2.default)(state);keys.forEach(function(key){_this3[key]=state[key];});};}})),_class));

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.PrintLogStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var PrintLogStore=exports.PrintLogStore=(_class=function PrintLogStore(){var _this=this;(0,_classCallCheck3.default)(this,PrintLogStore);this.baseParams={};this.closeEvent=null;_initDefineProp(this,'tabKey',_descriptor,this);_initDefineProp(this,'topTab',_descriptor2,this);_initDefineProp(this,'showSearchAd',_descriptor3,this);this.conditions=[];_initDefineProp(this,'form',_descriptor4,this);_initDefineProp(this,'tableStore',_descriptor5,this);_initDefineProp(this,'setBaseParams',_descriptor6,this);this.switchTab=function(key){_this.tabKey=key;};this.loadBaseInfo=function(){(0,_req.getPrintLogBase)(_this.baseParams).then(function(data){var tabs=data.tabs,conditions=data.conditions;var _getComsMobx=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx.WeaForm;_this.form=new WeaForm();_this.topTab=tabs;_this.conditions=conditions;_this.form.initFormFieldObj(conditions);});};this.doSearch=function(){var formParams=_this.form&&_this.form.getFormParams()||{};var params=(0,_extends3.default)({},_this.baseParams,formParams,{viewcondition:_this.tabKey});(0,_req.getPrintLogData)(params).then(function(data){_this.tableStore.getDatas(data.sessionkey);});};this.setShowSearchAd=function(bool){_this.showSearchAd=bool;};this.appendFormFields=function(value){_this.form&&_this.form.updateFields(value,false);};this.clearFormFields=function(){_this.form&&_this.form.resetConditionValue();//清除查询条件值
};this.setCloseEvent=function(fun){_this.closeEvent=fun;};this.resetStatus=function(){_this.baseParams={};_this.tabKey="0";_this.showSearchAd=false;};this.setBaseParams=this.setBaseParams;this.switchTab=this.switchTab;this.loadBaseInfo=this.loadBaseInfo;this.doSearch=this.doSearch;this.setShowSearchAd=this.setShowSearchAd;this.appendFormFields=this.appendFormFields;this.clearFormFields=this.clearFormFields;this.setCloseEvent=this.setCloseEvent;this.resetStatus=this.resetStatus;},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'tabKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"0";}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'topTab',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'showSearchAd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'tableStore',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'setBaseParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _getComsMobx2=(0,_convert.getComsMobx)(),WeaTableNew=_getComsMobx2.WeaTableNew;_this2.tableStore=new WeaTableNew.TableStore();_this2.baseParams=params;};}})),_class);

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FreeFlowStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var FreeFlowStore=exports.FreeFlowStore=(_class=function FreeFlowStore(){var _this=this;(0,_classCallCheck3.default)(this,FreeFlowStore);this.baseParams={};_initDefineProp(this,'loading',_descriptor,this);_initDefineProp(this,'columns',_descriptor2,this);_initDefineProp(this,'datas',_descriptor3,this);this.stepindex=0;this.saveEvent=null;this.closeEvent=null;_initDefineProp(this,'setBaseParams',_descriptor4,this);this.doInit=function(){_this.loading=true;(0,_req.freeFlowRead)(_this.baseParams).then(function(data){_this.loading=false;var columns=data.columns,datas=data.datas;_this.columns=columns;_this.datas=datas;_this.stepindex=_this.datas.length;});};this.addStepIndex=function(){_this.stepindex++;};this.setDatas=function(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];_this.datas=datas;};this.doSave=function(){var directSubmit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var params=(0,_extends3.default)({},_this.baseParams);var rownum=_this.datas.length;rownum>0&&_this.datas.map(function(row,index){params['floworder_'+index]=index;params['nodename_'+index]=row.stepname;params['Signtype_'+index]=row.signtype;params['operators_'+index]=row.operators;});params["rownum"]=rownum;params["indexnum"]=rownum;_this.loading=true;(0,_req.freeFlowSave)(params).then(function(data){_this.loading=false;_this.saveEvent(directSubmit);});};this.setSaveEvent=function(fun){_this.saveEvent=fun;};this.setCloseEvent=function(fun){_this.closeEvent=fun;};this.resetStore=function(){_this.baseParams={};_this.stepindex=0;_this.datas=[];};this.setBaseParams=this.setBaseParams;this.doInit=this.doInit;this.addStepIndex=this.addStepIndex;this.setDatas=this.setDatas;this.setSaveEvent=this.setSaveEvent;this.setCloseEvent=this.setCloseEvent;this.resetStore=this.resetStore;},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'loading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'columns',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'datas',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'setBaseParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this2.baseParams=params;};}})),_class);

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.PrintReqStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _dec,_dec2,_dec3,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var PrintReqStore=exports.PrintReqStore=(_dec=(0,_mobx.action)('加载模板列表'),_dec2=(0,_mobx.action)('选中模板'),_dec3=(0,_mobx.action)("修改printBtnDisabled"),(_class=function PrintReqStore(){(0,_classCallCheck3.default)(this,PrintReqStore);this.urlParams={};_initDefineProp(this,'needChoose',_descriptor,this);this.templates=[];_initDefineProp(this,'templateKey',_descriptor2,this);_initDefineProp(this,'printBtnDisabled',_descriptor3,this);_initDefineProp(this,'loadTemplates',_descriptor4,this);_initDefineProp(this,'chooseTemplate',_descriptor5,this);_initDefineProp(this,'setPrintBtnDisabled',_descriptor6,this);this.loadTemplates=this.loadTemplates;this.chooseTemplate=this.chooseTemplate;},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'needChoose',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'templateKey',[_mobx.observable],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'printBtnDisabled',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'loadTemplates',[_dec],{enumerable:true,initializer:function initializer(){var _this=this;return function(urlParams){_this.urlParams=urlParams;API_REQ.loadPrintTemplates(urlParams).then(function(data){var needChoose=data.needChoose,templates=data.templates;_this.needChoose=needChoose;_this.templates=templates;if(templates.length>0)_this.chooseTemplate(templates[0].key);});};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'chooseTemplate',[_dec2],{enumerable:true,initializer:function initializer(){var _this2=this;return function(key){_this2.templateKey=key;};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'setPrintBtnDisabled',[_dec3],{enumerable:true,initializer:function initializer(){var _this3=this;return function(val){_this3.printBtnDisabled=!!!val;};}})),_class));

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _assign=__webpack_require__(65);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _dec,_dec2,_dec3,_dec4,_dec5,_dec6,_dec7,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;var ls=WeaTools.ls;var SecondAuthStore=(_dec=(0,_mobx.action)("验证成功后提交流程的参数"),_dec2=(0,_mobx.action)("验证或者数据保护的窗口需要的数据"),_dec3=(0,_mobx.action)("设置CA认证或者保护时的数据"),_dec4=(0,_mobx.action)("设置验证或者数据保护的结果"),_dec5=(0,_mobx.action)("将数据存入localStorage"),_dec6=(0,_mobx.action)("从localStorage中读取数据"),_dec7=(0,_mobx.action)("重置所有值为初始化"),(_class=/**
     * 是否是提交到退回节点
     *//**
     * 保护数据成功
     *//**
     *  数据保护的类型
     *//**
     * 二次验证的类型
     *//**
     * 二次验证窗口需要的一些参数，比如authType等
     *//**
     * 二次验证成功后，确认时，调用的流程提交方法
     */function SecondAuthStore(){var _this=this;(0,_classCallCheck3.default)(this,SecondAuthStore);this.callbackFunc=null;this.callbackParam={};this.params={};this.isEnableAuth=0;this.secondAuthType=0;this.isEnableProtect=0;this.protectType=0;this.isAuthSuccess=0;this.isProtectSuccess=0;this.isProtectDialog=0;this.isSubmitDirect=0;this.isSecondAuthPop=false;_initDefineProp(this,'setSecondAuthPop',_descriptor,this);_initDefineProp(this,'setCallbackFunc',_descriptor2,this);_initDefineProp(this,'setCallbackParam',_descriptor3,this);_initDefineProp(this,'setParams',_descriptor4,this);this.setIsSubmitDirect=function(){var val=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;_this.isSubmitDirect=val;};_initDefineProp(this,'setDialogData',_descriptor5,this);_initDefineProp(this,'setCAAuthData',_descriptor6,this);_initDefineProp(this,'setDialogResult',_descriptor7,this);_initDefineProp(this,'saveDataToStorage',_descriptor8,this);_initDefineProp(this,'readDataFromStorage',_descriptor9,this);_initDefineProp(this,'resetStore',_descriptor10,this);this.setCallbackFunc=this.setCallbackFunc;this.setCallbackParam=this.setCallbackParam;this.setParams=this.setParams;this.setIsSubmitDirect=this.setIsSubmitDirect;this.setDialogData=this.setDialogData;this.setDialogResult=this.setDialogResult;this.saveDataToStorage=this.saveDataToStorage;this.readDataFromStorage=this.readDataFromStorage;this.resetStore=this.resetStore;this.callbackFunc=function(){};this.callbackParam={};}/**
     *  本次页面是否已经弹出过，只要本次页面表单没有刷新，就不重复弹出
     *//**
     *  0：表示二次验证的窗口
     *  1：表示是CA数据保护
     *  10：表示是CA认证和数据保护一起弹出的窗口
     *//**
     * 二次验证成功
     *//**
     *  是否启用了数据保护
     *//**
     * 是否需要二次验证
     *//**
     *  流程提交时的参数
     *//**
     *  设置二次验证后提交流程时的参数
     *  这个是从流程提交时的方法中设置的
     */,(_descriptor=_applyDecoratedDescriptor(_class.prototype,'setSecondAuthPop',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var val=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this2.isSecondAuthPop=val;};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'setCallbackFunc',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(func){_this3.callbackFunc=func;};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'setCallbackParam',[_dec],{enumerable:true,initializer:function initializer(){var _this4=this;return function(param){_this4.callbackParam=(0,_extends3.default)({},_this4.callbackParam,param);};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'setParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(paras){_this5.params=paras;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'setDialogData',[_dec2],{enumerable:true,initializer:function initializer(){var _this6=this;return function(data){/*
        this.isEnableAuth = data.isEnableAuth || this.isEnableAuth;
         this.secondAuthType = data.secondAuthType || this.secondAuthType;
         this.isEnableProtect = data.isEnableProtect || this.isEnableProtect;
         this.protectType = data.protectType || this.protectType;
         *//**
         * isEnableAuth, secondAuthType, isEnableProtect, protectType参数的值
         */(0,_assign2.default)(_this6,data);};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'setCAAuthData',[_dec3],{enumerable:true,initializer:function initializer(){var _this7=this;return function(data){/**
         * 设置isProtectDialog,authKey,sourcestr参数的值
         */var isProtectDialog=data.isProtectDialog;var sourcestr=data.sourcestr;if(isProtectDialog==0&&!sourcestr){sourcestr=Math.random();data.sourcestr=sourcestr;}(0,_assign2.default)(_this7,data);};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'setDialogResult',[_dec4],{enumerable:true,initializer:function initializer(){var _this8=this;return function(data){/*
        this.isAuthSuccess = data.isAuthSuccess || this.isAuthSuccess;
         this.isProtectSuccess = data.isProtectSuccess || this.isProtectSuccess;
         *//**
         * 设置isAuthSuccess,isProtectSuccess参数的值
         */(0,_assign2.default)(_this8,data);};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'saveDataToStorage',[_dec5],{enumerable:true,initializer:function initializer(){var _this9=this;return function(authKey){var callbackParam=_this9.callbackParam;var isEnableAuth=_this9.isEnableAuth;var secondAuthType=_this9.secondAuthType;var isEnableProtect=_this9.isEnableProtect;var protectType=_this9.protectType;var isAuthSuccess=_this9.isAuthSuccess;var isProtectSuccess=_this9.isProtectSuccess;var isProtectDialog=_this9.isProtectDialog;var isSubmitDirect=_this9.isSubmitDirect;var obj={callbackParam:callbackParam,isEnableAuth:isEnableAuth,secondAuthType:secondAuthType,isEnableProtect:isEnableProtect,protectType:protectType,isAuthSuccess:isAuthSuccess,isProtectSuccess:isProtectSuccess,isProtectDialog:isProtectDialog,isSubmitDirect:isSubmitDirect};ls.set(authKey,(0,_stringify2.default)(obj));};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'readDataFromStorage',[_dec6],{enumerable:true,initializer:function initializer(){var _this10=this;return function(authKey){var obj=ls.getJSONObj(authKey);var callbackParam=obj.callbackParam,isEnableAuth=obj.isEnableAuth,secondAuthType=obj.secondAuthType,isEnableProtect=obj.isEnableProtect,protectType=obj.protectType,isAuthSuccess=obj.isAuthSuccess,isProtectSuccess=obj.isProtectSuccess,isProtectDialog=obj.isProtectDialog,isSubmitDirect=obj.isSubmitDirect;_this10.callbackParam=callbackParam;_this10.isEnableAuth=isEnableAuth;_this10.secondAuthType=secondAuthType;_this10.isEnableProtect=isEnableProtect;_this10.protectType=protectType;_this10.isAuthSuccess=isAuthSuccess;_this10.isProtectSuccess=isProtectSuccess;_this10.isProtectDialog=isProtectDialog;_this10.isSubmitDirect=isSubmitDirect;};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'resetStore',[_dec7],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.callbackFunc=function(){};_this11.callbackParam={};_this11.isEnableAuth=0;_this11.secondAuthType=0;_this11.isEnableProtect=0;_this11.protectType=0;_this11.isAuthSuccess=0;_this11.isProtectSuccess=0;_this11.isProtectDialog=0;_this11.isSubmitDirect=0;};}})),_class));exports.default=SecondAuthStore;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SelectNextFlowStore=undefined;var _defineProperty2=__webpack_require__(16);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _defineProperty4=__webpack_require__(55);var _defineProperty5=_interopRequireDefault(_defineProperty4);var _extends3=__webpack_require__(7);var _extends4=_interopRequireDefault(_extends3);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _dec,_dec2,_dec3,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _req=__webpack_require__(15);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty3.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SelectNextFlowStore=exports.SelectNextFlowStore=(_dec=(0,_mobx.action)('初始化表单相关信息'),_dec2=(0,_mobx.action)('切换下一节点'),_dec3=(0,_mobx.action)('获取指定流转的节点信息'),(_class=function SelectNextFlowStore(){var _this=this;(0,_classCallCheck3.default)(this,SelectNextFlowStore);this.baseParams={};this.commonParams={};this.canFlowNextNode=false;_initDefineProp(this,'nextNodeIds',_descriptor,this);this.preNextNodeIds='';this.confirmEvent=null;this.cancelEvent=null;_initDefineProp(this,'condition',_descriptor2,this);_initDefineProp(this,'groupList',_descriptor3,this);_initDefineProp(this,'form',_descriptor4,this);_initDefineProp(this,'nodeInfo',_descriptor5,this);_initDefineProp(this,'nodeInfoMap',_descriptor6,this);_initDefineProp(this,'nodeScope',_descriptor7,this);this.nodeInfoConfirmEvent=null;this.nodeInfoCancelEvent=null;_initDefineProp(this,'showAllNodeOperators',_descriptor8,this);_initDefineProp(this,'operatorChangeDisable',_descriptor9,this);this.needDefaultNode='1';this.needDefaultoperator='1';this.branchNodesMap={};this.mustPassNodeIds=[];_initDefineProp(this,'nodeAttribute',_descriptor10,this);_initDefineProp(this,'setBaseParams',_descriptor11,this);_initDefineProp(this,'setCommonParams',_descriptor12,this);this.doInit=function(){var that=_this;(0,_req.getSelectNextFlowCondition)((0,_extends4.default)({},_this.baseParams,_this.commonParams)).then(function(data){var conditioninfo=data.conditioninfo;_this.operatorChangeDisable=data.operatorChangeDisable;_this.needDefaultNode=data.needDefaultNode;_this.needDefaultoperator=data.needDefaultoperator;_this.nodeAttribute=data.nodeattribute;_this.condition=conditioninfo;var _getComsMobx=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx.WeaForm;// this.form = new WeaForm();
// this.form.initFormFieldObj(conditioninfo);
_this.groupList=[];that.getNodeInfo();});};_initDefineProp(this,'processGroupListInfo',_descriptor13,this);this.appendHrmSqlWhere=function(condition,nodeInfo){//传入对应节点操作者范围
if(condition.domkey=='nodeOperator'||condition.domkey=='ccOperator'){if(nodeInfo&&nodeInfo.hrmSqlWhere){condition.browserConditionParam.completeParams['sqlwhere']=nodeInfo.hrmCompleteSqlWhere;condition.browserConditionParam.dataParams['sqlwhere']=nodeInfo.hrmSqlWhere;condition.browserConditionParam.destDataParams['sqlwhere']=nodeInfo.hrmSqlWhere;}}};_initDefineProp(this,'updateFormByNodeInfo',_descriptor14,this);_initDefineProp(this,'changeNextNode',_descriptor15,this);_initDefineProp(this,'getResultParams',_descriptor16,this);_initDefineProp(this,'getNodeInfo',_descriptor17,this);this.setShowAllNodeOperators=function(id){var showAllNodeOperators=(0,_extends4.default)({},_this.showAllNodeOperators,(0,_defineProperty5.default)({},id,!_this.showAllNodeOperators[id]));_this.showAllNodeOperators=showAllNodeOperators;};this.setConfirmEvent=function(fun){_this.confirmEvent=fun;};this.setCancelEvent=function(fun){_this.cancelEvent=fun;};this.setNodeInfoConfirmEvent=function(fun){_this.nodeInfoConfirmEvent=fun;};this.setNodeInfoCancelEvent=function(fun){_this.nodeInfoCancelEvent=fun;};this.setCanFlowNextNode=function(bool){_this.canFlowNextNode=bool;};this.setNextNodeIds=function(nodeIds){if(nodeIds.startsWith(',')){nodeIds=nodeIds.substring(1,nodeIds.length);}if(nodeIds.endsWith(',')){nodeIds=nodeIds.substring(0,nodeIds.length-1);}_this.preNextNodeIds=_this.nextNodeIds;_this.nextNodeIds=nodeIds;};}// 是否能流到下一节点
// 可选择节点的范围
// 是否需默认选中下一节点
// 是否需要带出默认操作者
//流程分支信息
//分叉起始点指定流转时，必须通过的分支第一个中间点
// 当前节点属性
,(_descriptor=_applyDecoratedDescriptor(_class.prototype,'nextNodeIds',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'groupList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'nodeInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'nodeInfoMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'nodeScope',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'showAllNodeOperators',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'operatorChangeDisable',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'nodeAttribute',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'0';}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'setBaseParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this2.baseParams=params;};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'setCommonParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this3.commonParams=params;};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'processGroupListInfo',[_dec],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var _getComsMobx2=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx2.WeaForm;_this4.groupList=[];if(_this4.nodeAttribute!='1'){// 不是分叉起始点
var conditions=_.cloneDeep((0,_mobx.toJS)(_this4.condition));var nodeInfo=_this4.nodeInfoMap[_this4.nextNodeIds]||{};conditions.map(function(condition){_this4.appendHrmSqlWhere(condition,nodeInfo);if(condition.domkey!='nextNode'){condition.domkey=[condition.domkey+'_'+0];}});_this4.groupList[0]={items:conditions};}else{// 分叉起始点
// 基本信息group
_this4.groupList[0]={title:(0,_convert.getLabel)(1361,'基本信息'),items:[_.cloneDeep((0,_mobx.toJS)(_this4.condition)[0])]};// 每个选中节点的group
_this4.nextNodeIds&&_this4.nextNodeIds.split(',').map(function(nodeId,index){var nodeInfo=_this4.nodeInfoMap[nodeId]||{};var nodeName=nodeInfo.nodeName?nodeInfo.nodeName:'';var conditions=_.cloneDeep((0,_mobx.toJS)(_this4.condition));// 过滤“下一节点”item
conditions=conditions.filter(function(item){return item.domkey[0]!='nextNode';});conditions.map(function(condition){_this4.appendHrmSqlWhere(condition,nodeInfo);condition.domkey=[condition.domkey+'_'+index];});_this4.groupList[index+1]={title:(0,_convert.getLabel)(15586,'节点')+'\uFF1A'+nodeName,items:conditions};});}_this4.form=new WeaForm();_this4.form.initFormFields(_this4.groupList);};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'updateFormByNodeInfo',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){//获取修改下一节点之前，记录的表单值
var preFormDatas={};var preNextNodeIdArray=_this5.preNextNodeIds!==''?_this5.preNextNodeIds.split(','):[];if(_this5.form){preFormDatas=_this5.form.getFormDatas();}_this5.processGroupListInfo();_this5.nextNodeIds.split(',').map(function(nextNodeId,index){var operatorValueObj=[];var operatorValue='';var operatorValueSpan='';var ccOperatorValueObj=[];var ccOperatorValue='';var ccOperatorValueSpan='';var nodeInfo=_this5.nodeInfoMap[nextNodeId];// 默认带出操作者
if(_this5.needDefaultoperator=='1'){// 操作者
nodeInfo&&nodeInfo.operators&&nodeInfo.operators.map(function(operator){operatorValueObj.push({id:operator.operatorid,name:operator.operatorname});operatorValue+=','+operator.operatorid;operatorValueSpan+=','+operator.operatorname;});if(operatorValue.length>1){operatorValue=operatorValue.slice(1,operatorValue.length);}if(operatorValueSpan.length>1){operatorValueSpan=operatorValueSpan.slice(1,operatorValueSpan.length);}// 抄送人
nodeInfo&&nodeInfo.ccOperators&&nodeInfo.ccOperators.map(function(operator){ccOperatorValueObj.push({id:operator.operatorid,name:operator.operatorname});ccOperatorValue+=','+operator.operatorid;ccOperatorValueSpan+=','+operator.operatorname;});if(ccOperatorValue.length>1){ccOperatorValue=ccOperatorValue.slice(1,ccOperatorValue.length);}if(ccOperatorValueSpan.length>1){ccOperatorValueSpan=ccOperatorValueSpan.slice(1,ccOperatorValueSpan.length);}}var updateParams={};var preIndex=preNextNodeIdArray&&preNextNodeIdArray.indexOf(nextNodeId);if(preIndex>=0){//之前已选择的节点，使用已修改的值
updateParams['nodeOperator_'+index]=preFormDatas['nodeOperator_'+preIndex];updateParams['ccOperator_'+index]=preFormDatas['ccOperator_'+preIndex];updateParams['SignType_'+index]=preFormDatas['SignType_'+preIndex];updateParams['canSubmit_'+index]=preFormDatas['canSubmit_'+preIndex];}else{updateParams['nodeOperator_'+index]={value:operatorValue,valueSpan:operatorValueSpan,valueObj:operatorValueObj};updateParams['ccOperator_'+index]={value:ccOperatorValue,valueSpan:ccOperatorValueSpan,valueObj:ccOperatorValueObj};updateParams['SignType_'+index]=nodeInfo&&nodeInfo.signType!==undefined?nodeInfo.signType:'1';updateParams['canSubmit_'+index]=nodeInfo&&nodeInfo.ccSignType!==undefined?nodeInfo.ccSignType:'-4';}_this5.form.updateFields(updateParams);});};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'changeNextNode',[_dec2],{enumerable:true,initializer:function initializer(){var _this6=this;return function(nextNode){_this6.setNextNodeIds(nextNode);_this6.updateFormByNodeInfo();};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'getResultParams',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){var result={};var formParams=_this7.form.getFormParams();var formDatas=_this7.form.getFormDatas();result=(0,_extends4.default)({},formParams);_this7.nextNodeIds.split(',').map(function(key,index){var nextNodeInfo=_this7.nodeInfoMap[key];result['selectNodeFlow_nodeId_'+index]=nextNodeInfo.id+'_'+nextNodeInfo.nodeType+'_'+nextNodeInfo.nodeAttribute;result['selectNodeFlow_operator_'+index]=formParams['nodeOperator_'+index];});result.selectNodeFlow_canFlowNextNode=_this7.canFlowNextNode?'1':'0';result.selectNodeFlow_nodeIds=_this7.nextNodeIds;if(_this7.operatorChangeDisable=='1'){//不可修改操作者，指定流转为选择节点模式，操作者由后台计算
result['selectNextFlowMode']=2;}else{//前台用户指定节点和操作者
result['selectNextFlowMode']=1;}delete result.nextNode;return result;};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'getNodeInfo',[_dec3],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){(0,_req.getSelectFlowNodeInfo)(_this8.commonParams).then(function(data){_this8.nodeInfo=data.nodeInfo;_this8.branchNodesMap=data.branchNodesMap;_this8.mustPassNodeIds=data.mustPassNodeIds;_this8.nodeScope=data.nodeScope;var newNextNodeIds='';var nodeAttributes=[];_this8.nodeInfo.map(function(node){_this8.nodeInfoMap[node.key]=node;//需过滤不在可选择范围中的节点
if((","+_this8.nextNodeIds+",").indexOf(node.id)>-1){newNextNodeIds+=","+node.id;if(nodeAttributes.indexOf(node.nodeAttribute)==-1){nodeAttributes.push(node.nodeAttribute);}}});if(newNextNodeIds!=''){newNextNodeIds=newNextNodeIds.substring(1);//默认下一节点有多个，且节点属性不全为分叉中间点，视为不合法数据，不显示默认节点
if(nodeAttributes.length>1||newNextNodeIds.split(',').length>1&&nodeAttributes.length==1&&nodeAttributes[0]!='2'){newNextNodeIds='';}//非分叉起始点，且下一节点有多个，不显示默认节点
if(_this8.nodeAttribute!='1'&&newNextNodeIds.split(',').length>1){newNextNodeIds='';}}_this8.nextNodeIds=newNextNodeIds;// 如果未设置自动带出节点，则清空
if(_this8.needDefaultNode!='1'){_this8.nextNodeIds='';}_this8.updateFormByNodeInfo();});};}})),_class));

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RemindSetStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _convert=__webpack_require__(6);var _mobx=__webpack_require__(9);var _req=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var _getComsMobx=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx.WeaForm;var RemindSetStore=exports.RemindSetStore=(_class=function(){function RemindSetStore(){(0,_classCallCheck3.default)(this,RemindSetStore);_initDefineProp(this,'form',_descriptor,this);_initDefineProp(this,'condition',_descriptor2,this);_initDefineProp(this,'isSubmiting',_descriptor3,this);}(0,_createClass3.default)(RemindSetStore,[{key:'getRemindData',/**
     * 初始数据
     */value:function getRemindData(){var _this=this;var para=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};(0,_req.getRemindData)(para).then(function(reVal){_this.condition=reVal.condition;_this.form.initFormFields(reVal.condition);});}/**
     * 提醒
     */},{key:'doRemind',value:function doRemind(){var _this2=this;var para=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!this.isSubmiting){this.isSubmiting=true;(0,_req.doRemind)(para).then(function(reVal){_this2.isSubmiting=false;});}}}]);return RemindSetStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return new WeaForm();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'condition',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isSubmiting',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'getRemindData',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getRemindData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'doRemind',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'doRemind'),_class.prototype)),_class);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LocationMapStore=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor;var _mobx=__webpack_require__(9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var LocationMapStore=exports.LocationMapStore=(_class=function LocationMapStore(){var _this=this;(0,_classCallCheck3.default)(this,LocationMapStore);_initDefineProp(this,'locationInfos',_descriptor,this);this.cancelEvent=null;this.setCancelEvent=function(fun){_this.cancelEvent=fun;};this.setLocationInfos=function(locationInfos){_this.locationInfos=locationInfos;};}//位置信息
,(_descriptor=_applyDecoratedDescriptor(_class.prototype,'locationInfos',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}})),_class);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var FollowSelectStore=(_class=function(){function FollowSelectStore(){(0,_classCallCheck3.default)(this,FollowSelectStore);_initDefineProp(this,'clickPotion',_descriptor,this);_initDefineProp(this,'followTypeSelectShow',_descriptor2,this);_initDefineProp(this,'FollowRequestid',_descriptor3,this);}(0,_createClass3.default)(FollowSelectStore,[{key:'setClickPotion',value:function setClickPotion(params){this.clickPotion=params;}}]);return FollowSelectStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'clickPotion',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'followTypeSelectShow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'FollowRequestid',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'setClickPotion',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'setClickPotion'),_class.prototype)),_class);exports.default=FollowSelectStore;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FieldLinkageCfg=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor=__webpack_require__(53);var _getOwnPropertyDescriptor2=_interopRequireDefault(_getOwnPropertyDescriptor);var _assign=__webpack_require__(65);var _assign2=_interopRequireDefault(_assign);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _convert=__webpack_require__(6);var _mobx=__webpack_require__(9);var _req=__webpack_require__(15);var _ecCom=__webpack_require__(51);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var FieldLinkageCfg=exports.FieldLinkageCfg=(_class=function(){function FieldLinkageCfg(){(0,_classCallCheck3.default)(this,FieldLinkageCfg);_initDefineProp(this,'isFieldTrigger',_descriptor,this);_initDefineProp(this,'exportFieldType',_descriptor2,this);_initDefineProp(this,'tips13',_descriptor3,this);_initDefineProp(this,'isFormula',_descriptor4,this);_initDefineProp(this,'conditions',_descriptor5,this);_initDefineProp(this,'fixedForm',_descriptor6,this);_initDefineProp(this,'SettingDialogVisible',_descriptor7,this);_initDefineProp(this,'getDetailExpSetFn',_descriptor8,this);_initDefineProp(this,'saveDetailExpSetFn',_descriptor9,this);_initDefineProp(this,'changeSettingDialogVisibleFn',_descriptor10,this);}(0,_createClass3.default)(FieldLinkageCfg,[{key:'riggerFieldLinkageCfg',/**
     * 初始数据
     */value:function riggerFieldLinkageCfg(){var _this=this;var para=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};para=(0,_assign2.default)(para,{optype:'get'});(0,_req.fieldLinkageCfg)(para).then(function(reVal){if(reVal.success){_this.isFieldTrigger=reVal.isFieldTrigger;_this.tips13=reVal.tips13;}});}/**
     * update exportFieldType
     */},{key:'updateExportFieldType',value:function updateExportFieldType(){var param=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.exportFieldType=param.exportFieldType;param=(0,_assign2.default)(param,{optype:'save'});(0,_req.exportFieldSet)(param).then(function(){});}/**
     * init exportFieldType
     */},{key:'getExportFieldType',value:function getExportFieldType(){var _this2=this;var param=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};param=(0,_assign2.default)(param,{optype:'get'});(0,_req.exportFieldSet)(param).then(function(data){_this2.exportFieldType=data.exportFieldType;});}/**
     * update isFieldTrigger
     */},{key:'updateIsFieldTrigger',value:function updateIsFieldTrigger(){var para=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.isFieldTrigger=para.isFieldTrigger;para=(0,_assign2.default)(para,{optype:'save'});(0,_req.fieldLinkageCfg)(para).then(function(reVal){});}/**
     * 初始数据
     */},{key:'riggerFormulaCfg',value:function riggerFormulaCfg(){var _this3=this;var para=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};para=(0,_assign2.default)(para,{optype:'get'});(0,_req.formulaCfg)(para).then(function(reVal){if(reVal.success){_this3.isFormula=reVal.isFormula;}});}/**
     * update isFieldTrigger
     */},{key:'updateIsFormula',value:function updateIsFormula(){var para=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.isFormula=para.isFormula;para=(0,_assign2.default)(para,{optype:'save'});(0,_req.formulaCfg)(para).then(function(reVal){});}/**
     * 流程导入设置condition
     */}]);return FieldLinkageCfg;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'isFieldTrigger',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'exportFieldType',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'tips13',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'isFormula',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'conditions',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'fixedForm',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'SettingDialogVisible',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'riggerFieldLinkageCfg',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'riggerFieldLinkageCfg'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateExportFieldType',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateExportFieldType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getExportFieldType',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'getExportFieldType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateIsFieldTrigger',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateIsFieldTrigger'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'riggerFormulaCfg',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'riggerFormulaCfg'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateIsFormula',[_mobx.action],(0,_getOwnPropertyDescriptor2.default)(_class.prototype,'updateIsFormula'),_class.prototype),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'getDetailExpSetFn',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var para=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _getComsMobx=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx.WeaForm;_this4.fixedForm=new WeaForm();(0,_req.getDetailExpSet)(para).then(function(res){console.log(res);_this4.fixedForm.initFormFields(res.addFormConditions);_this4.conditions=res.addFormConditions;});};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'saveDetailExpSetFn',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this5=this;return function(para){var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;(0,_req.saveDetailExpSet)(para).then(function(res){console.log('接口返回数据');message.success(res.message||'保存成功');_this5.changeSettingDialogVisibleFn(false);});};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'changeSettingDialogVisibleFn',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this6=this;return function(flage){_this6.SettingDialogVisible=flage;};}})),_class);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FreeWflowSimple=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _dec,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _submit=__webpack_require__(57);var _req=__webpack_require__(15);var API=_interopRequireWildcard(_req);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var FreeWflowSimple=exports.FreeWflowSimple=(_dec=(0,_mobx.action)("控制变量"),(_class=function FreeWflowSimple(){var _this=this;(0,_classCallCheck3.default)(this,FreeWflowSimple);_initDefineProp(this,'showCollect',_descriptor,this);_initDefineProp(this,'form',_descriptor2,this);this.toNewFormData={};_initDefineProp(this,'setState',_descriptor3,this);this.onCloseDialog=function(){var controlDialogVisible=_base2.default.globalStore.controlDialogVisible;controlDialogVisible(type.FREE_WORKFLOW_SIMPLE,false);};this.loadCondition=function(params){API.loadCondition(params).then(function(data){var _getComsMobx=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx.WeaForm;_this.conditionData=data;var conditioninfo=data.conditioninfo,_data$default_prefix=data.default_prefix,default_prefix=_data$default_prefix===undefined?'':_data$default_prefix,_data$default_datas=data.default_datas,default_datas=_data$default_datas===undefined?{}:_data$default_datas;var condition=_this.setDefaultData(conditioninfo,default_prefix,default_datas);_this.conditioninfo=condition;_this.form=new WeaForm();_this.form.setCondition(condition);_this.form.initFormFields(condition);_this.getFormSubmitDatas();var formParams=_this.form.getFormParams();if(formParams.hasOwnProperty("isToNewAddSign")&&formParams.isToNewAddSign==1){_this.toNewFormData=_this.form.getFormDatas();}});};this.setDefaultData=function(){var conditioninfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var default_prefix=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var default_datas=arguments[2];//if(default_prefix == '') return conditioninfo;
var _conditioninfo$0$item=conditioninfo[0].items,items=_conditioninfo$0$item===undefined?[]:_conditioninfo$0$item;var tempDefault_prefix=default_prefix;if(default_prefix=='curr'&&!_.has(default_datas,'curr_isvalild')){tempDefault_prefix='last';}var default_nodeOperator=default_datas[tempDefault_prefix+'_nodeOperator']||[];var default_endTransfer=default_datas[tempDefault_prefix+'_endTransfer']||0;var default_countersignAttribute=default_datas[tempDefault_prefix+'_countersignAttribute']||0;var default_approvalSettings=default_datas[tempDefault_prefix+'_approvalSettings']||'';var _base$globalStore$url=_base2.default.globalStore.urlParams.isaffirmance,isaffirmance=_base$globalStore$url===undefined?'':_base$globalStore$url;var viewAttr=2;if(isaffirmance==1){viewAttr=1;}else{if(default_prefix=='curr'&&_.has(default_datas,'last_isvalild'))viewAttr=3;if(default_prefix=='last')viewAttr=1;}items.map(function(item){if(isaffirmance==1||item.domkey[0]!=='isToNewAddSign'){item.viewAttr=viewAttr;}if(item.domkey[0]=='nodeOperator'){item.browserConditionParam.replaceDatas=default_nodeOperator;}else if(item.domkey[0]=='endTransfer'){item.options.map(function(option){option.selected=option.key==default_endTransfer;});}else if(item.domkey[0]=='countersignAttribute'){item.options.map(function(option){option.selected=option.key==default_countersignAttribute;});}else if(item.domkey[0]=='approvalSettings'){item.value=default_datas['_approvalSettings']||'';//签批设置一个都不选也是一种选择，所以不需要必选
if(viewAttr==3){item.viewAttr=2;}}});return conditioninfo;};this.changeForm=function(v){if(v<2){var _getComsMobx2=(0,_convert.getComsMobx)(),WeaForm=_getComsMobx2.WeaForm;var _mobx$toJS=mobx.toJS(_this.conditionData),conditioninfo=_mobx$toJS.conditioninfo,_mobx$toJS$default_da=_mobx$toJS.default_datas,default_datas=_mobx$toJS$default_da===undefined?{}:_mobx$toJS$default_da;var condition=_this.setDefaultData(conditioninfo,v==0?'last':'curr',default_datas);_this.conditioninfo=condition;_this.form=new WeaForm();_this.form.setCondition(condition);_this.form.initFormFields(condition);if(v==1){_this.form.updateFields(_this.toNewFormData);}}_this.form.updateFields({"isToNewAddSign":v},false);_this.getFormSubmitDatas();};this.getFormSubmitDatas=function(){var formParams=_this.form.getFormParams()||{};var submitParams={operatorids:formParams.nodeOperator||"",countersignAttribute:formParams.countersignAttribute||"",isFlowToNext:formParams.endTransfer||"",isToNewAddSign:formParams.isToNewAddSign||"3",approvalSettings:formParams.approvalSettings||''};_this.chengeSubmitParams(submitParams);};this.chengeSubmitParams=function(){var submitParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var changeSubmitParam=_base2.default.globalStore.changeSubmitParam;changeSubmitParam(submitParams);};this.synchronousRemarkData=function(){var _base$globalStore=_base2.default.globalStore,controlVariableMap=_base$globalStore.controlVariableMap,variableMap=_base$globalStore.variableMap;var remark_list=variableMap.get("remark_list")||[];var remark_list_freeWorkflowSimple=_mobx.observable.map?_mobx.observable.map(remark_list):(0,_mobx.asMap)(remark_list);controlVariableMap("remark_list_freeWorkflowSimple",remark_list_freeWorkflowSimple);};this.updateFormFields=function(){var updateParams=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.form.updateFields(updateParams);};}/**
     * 设置默认值
     * @param conditioninfo
     * @param default_prefix
     * @param default_datas
     * @returns {Array}
     */,(_descriptor=_applyDecoratedDescriptor(_class.prototype,'showCollect',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'form',[_mobx.observable],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'setState',[_dec],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};(0,_keys2.default)(state).forEach(function(key){_this2[key]=state[key];});};}})),_class));

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.conformRules=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _dec,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(9);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _req=__webpack_require__(15);var API=_interopRequireWildcard(_req);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var conformRules=exports.conformRules=(_dec=(0,_mobx.action)('设置合规提示信息'),(_class=function conformRules(){var _this=this;(0,_classCallCheck3.default)(this,conformRules);_initDefineProp(this,'conformRuleInfo',_descriptor,this);this.conformRuleSubmitEvent=null;this.conformRuleStopRequestEvent=null;_initDefineProp(this,'title',_descriptor2,this);_initDefineProp(this,'status',_descriptor3,this);_initDefineProp(this,'setConformRuleInfo',_descriptor4,this);this.hasCheckedConformRule=false;_initDefineProp(this,'setHasCheckedConformRule',_descriptor5,this);_initDefineProp(this,'getCheckResult',_descriptor6,this);this.setConformRuleSubmitEvent=function(fun,stopFun){_this.conformRuleSubmitEvent=fun;_this.conformRuleStopRequestEvent=stopFun;};this.conformRuleCancelEvent=function(){_base2.default.globalStore.controlDialogVisible(type.CONFORM_RULE,false);};},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'conformRuleInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'title',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'status',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'setConformRuleInfo',[_dec],{enumerable:true,initializer:function initializer(){var _this2=this;return function(info){_this2.conformRuleInfo=info;if(info.result){_this2.title=info.result.title;_this2.status=info.result.end;}};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'setHasCheckedConformRule',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(bool){_this3.hasCheckedConformRule=bool;};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'getCheckResult',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this4=this;return function(params){API.conformCheck(params).then(function(data){_this4.setConformRuleInfo(data);});};}})),_class));

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ensureSubmit=undefined;var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _mobx=__webpack_require__(9);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ensureSubmit=exports.ensureSubmit=function ensureSubmit(){var _this=this;(0,_classCallCheck3.default)(this,ensureSubmit);this.confirmEvent=null;this.cancelEvent=null;this.setConfirmEvent=function(fun){_this.confirmEvent=fun;};this.setCancelEvent=function(fun){_this.cancelEvent=fun;};};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _toConsumableArray2=__webpack_require__(82);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getIterator2=__webpack_require__(252);var _getIterator3=_interopRequireDefault(_getIterator2);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _dec,_dec2,_dec3,_dec4,_dec5,_dec6,_dec7,_dec8,_dec9,_dec10,_dec11,_dec12,_dec13,_dec14,_dec15,_dec16,_dec17,_dec18,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35,_descriptor36,_descriptor37,_descriptor38,_descriptor39,_descriptor40,_descriptor41;var _mobx=__webpack_require__(9);var _req=__webpack_require__(15);var API=_interopRequireWildcard(_req);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _formUtil=__webpack_require__(11);var formUtil=_interopRequireWildcard(_formUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var wfSmartGuessStore=(_dec=(0,_mobx.action)('初始化请求接口的params参数'),_dec2=(0,_mobx.action)('设置iframe的src'),_dec3=(0,_mobx.action)('开启智能预测功能'),_dec4=(0,_mobx.action)('修改变量值'),_dec5=(0,_mobx.action)('模拟智能预测按钮点击'),_dec6=(0,_mobx.action)('获取前预测者操作信息'),_dec7=(0,_mobx.action)('获取流程图出事化信息'),_dec8=(0,_mobx.action)('获取预测节点数据'),_dec9=(0,_mobx.action)('设置loading加载图'),_dec10=(0,_mobx.action)('重新预测节点'),_dec11=(0,_mobx.action)('开启智能预测与否'),_dec12=(0,_mobx.action)('设置下拉选择框显隐'),_dec13=(0,_mobx.action)('隐藏所有显示的下拉框'),_dec14=(0,_mobx.action)('切换分支'),_dec15=(0,_mobx.action)('获取弹出面板操作者'),_dec16=(0,_mobx.action)('清理操作者信息数组'),_dec17=(0,_mobx.action)('清理store'),_dec18=(0,_mobx.action)('记录按钮被点击'),(_class=function wfSmartGuessStore(){(0,_classCallCheck3.default)(this,wfSmartGuessStore);_initDefineProp(this,'smartGuessStatus',_descriptor,this);_initDefineProp(this,'allMapshow',_descriptor2,this);_initDefineProp(this,'baseReqParams',_descriptor3,this);_initDefineProp(this,'divideNodeArr',_descriptor4,this);_initDefineProp(this,'nodeArr',_descriptor5,this);_initDefineProp(this,'stopGetArrFlag',_descriptor6,this);_initDefineProp(this,'needloading',_descriptor7,this);this.data={};_initDefineProp(this,'forecastInfoMap',_descriptor8,this);_initDefineProp(this,'controlWranWrapFlag',_descriptor9,this);_initDefineProp(this,'needShowTip',_descriptor10,this);_initDefineProp(this,'operatorInfo',_descriptor11,this);_initDefineProp(this,'operatorMap',_descriptor12,this);_initDefineProp(this,'needForecastFunc',_descriptor13,this);_initDefineProp(this,'stopResetFlag',_descriptor14,this);_initDefineProp(this,'clickedMap',_descriptor15,this);_initDefineProp(this,'justdoOnce',_descriptor16,this);_initDefineProp(this,'needBtnMask',_descriptor17,this);_initDefineProp(this,'showDescriptWord',_descriptor18,this);_initDefineProp(this,'endflage',_descriptor19,this);this.clientWidth=0;_initDefineProp(this,'isEnd',_descriptor20,this);_initDefineProp(this,'forecastUrl',_descriptor21,this);_initDefineProp(this,'hasResultFlag',_descriptor22,this);_initDefineProp(this,'flowChartInfo',_descriptor23,this);this.iframeHeight=0;this.switchStatus={"openAutoForecast":'0',//是否开启智能预测
"showAutoForecastResult":'0'//默认显示智能预测视图 '1': pc端 '2': 移动端
};_initDefineProp(this,'init',_descriptor24,this);_initDefineProp(this,'setIframeSrc',_descriptor25,this);_initDefineProp(this,'openForecastFunc',_descriptor26,this);_initDefineProp(this,'setState',_descriptor27,this);_initDefineProp(this,'clickSmartBtn',_descriptor28,this);_initDefineProp(this,'getForecastInfo',_descriptor29,this);_initDefineProp(this,'getFlowChartInfo',_descriptor30,this);_initDefineProp(this,'getCellArr',_descriptor31,this);_initDefineProp(this,'setLoadingWrap',_descriptor32,this);_initDefineProp(this,'getResetForecast',_descriptor33,this);_initDefineProp(this,'changSmartGuessStatus',_descriptor34,this);_initDefineProp(this,'setShowSelectPanel',_descriptor35,this);_initDefineProp(this,'setHiddenSelectPanel',_descriptor36,this);_initDefineProp(this,'setOptionItem',_descriptor37,this);_initDefineProp(this,'getOperator',_descriptor38,this);_initDefineProp(this,'clearOperatorArr',_descriptor39,this);_initDefineProp(this,'clearStore',_descriptor40,this);_initDefineProp(this,'setRecordClicked',_descriptor41,this);}//智能预测开启，展开简易视图
//完整视图
//分叉节点状态存储器
//节点数据
//getsimpleData接口获取的数据
//是否需要显示已经预测者的信息
//操作者信息
,(_descriptor=_applyDecoratedDescriptor(_class.prototype,'smartGuessStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'allMapshow',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'baseReqParams',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'divideNodeArr',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'nodeArr',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'stopGetArrFlag',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'needloading',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'forecastInfoMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):asMap({});}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'controlWranWrapFlag',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'needShowTip',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'operatorInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'operatorMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):asMap({});}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'needForecastFunc',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'stopResetFlag',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'clickedMap',[_mobx.observable],{enumerable:true,initializer:function initializer(){return _mobx.observable.map?_mobx.observable.map({}):asMap({});}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'justdoOnce',[_mobx.observable],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'needBtnMask',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'showDescriptWord',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'endflage',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'isEnd',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'forecastUrl',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'hasResultFlag',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'flowChartInfo',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'init',[_dec],{enumerable:true,initializer:function initializer(){var _this=this;return function(){var commonParam=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var logParams={};var _base$globalStore$com=_base2.default.globalStore.commonParam,isFree=_base$globalStore$com.isFree,currentnodetype=_base$globalStore$com.currentnodetype;var baseParamKey=["requestid","requestType","workflowid"];var switchParamsKey=["openAutoForecast","showAutoForecastResult"];baseParamKey.map(function(v){logParams[v]=commonParam[v];});switchParamsKey.map(function(v){_this.switchStatus[v]=commonParam[v];});_this.baseReqParams=logParams;if(logParams.requestid&&logParams.requestid!=-1&&isFree!=1&&currentnodetype&&currentnodetype!='3'&&_this.switchStatus['openAutoForecast']&&_this.switchStatus['openAutoForecast']=='1'){_this.openForecastFunc(true);//显示智能预测功能按钮
if(_this.switchStatus['showAutoForecastResult']&&_this.switchStatus['showAutoForecastResult'].indexOf('1')>-1){_this.clickSmartBtn();//显示智能预测结果
}}};}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'setIframeSrc',[_dec2],{enumerable:true,initializer:function initializer(){var _this2=this;return function(clearUrlFlag){if(clearUrlFlag){_this2.forecastUrl='';}else{_this2.forecastUrl=formUtil.getIframeUrl({requestid:_this2.baseReqParams.requestid})+'&showForecastNode=1';}_this2.iframeHeight=jQuery('.map-box-show').height()-jQuery('.wf-map-header').outerHeight()-5+'px';};}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'openForecastFunc',[_dec3],{enumerable:true,initializer:function initializer(){var _this3=this;return function(bool){_this3.needForecastFunc=bool;};}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'setState',[_dec4],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var keys=(0,_keys2.default)(obj);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=(0,_getIterator3.default)(keys),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var key=_step.value;_this4[key]=obj[key];}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'clickSmartBtn',[_dec5],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.smartGuessStatus=true;_this5.allMapshow=false;_this5.setRecordClicked('smart-btn-click');_this5.justdoOnce=false;_this5.getForecastInfo();_this5.getCellArr();};}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'getForecastInfo',[_dec6],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){var params={requestid:_this6.baseReqParams.requestid};API.getForecastInfo(params).then(function(data){_this6.needShowTip=data.showTip;if(data.forecastInfo&&_this6.baseReqParams.requestid>0){_this6.forecastInfoMap.set(_this6.baseReqParams.requestid,data.forecastInfo);}});};}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'getFlowChartInfo',[_dec7],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){API.getFlowChartInfo().then(function(data){_this7.flowChartInfo=(0,_extends3.default)({},data,{loaded:true});});};}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'getCellArr',[_dec8],{enumerable:true,initializer:function initializer(){var _this8=this;return function(params,callbackFun){var newParams=(0,_extends3.default)({},_this8.baseReqParams,params);API.getSimpleWfData(newParams).then(function(data){_this8.data=data;_this8.hasResultFlag=true;_this8.isEnd=data.forecastInfo.isEnd;if(!data.forecastInfo){_this8.stopGetArrFlag=true;_this8.needBtnMask=false;return _this8.nodeArr=[];}if(data.forecastInfo.isEnd){_this8.needloading=false;_this8.stopGetArrFlag=true;_this8.needBtnMask=false;callbackFun&&callbackFun();}else{_this8.stopGetArrFlag=false;}//分叉节点的遍历
data.nodeInfo&&data.nodeInfo.map(function(item){if(item.branchNumber>1){if(_this8.divideNodeArr.length==0){_this8.divideNodeArr.push({id:item.nodeid,remark:item.nodeRemark,checkItem:item.currentBranch,showStatus:false});}else{if(_this8.divideNodeArr.every(function(v){if(v.remark==item.nodeRemark){v.checkItem=item.currentBranch;return false;}return true;})){_this8.divideNodeArr=[].concat((0,_toConsumableArray3.default)(_this8.divideNodeArr),[{id:item.nodeid,remark:item.nodeRemark,checkItem:item.currentBranch,showStatus:false}]);}}}});_this8.nodeArr=data.nodeInfo||[];});};}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'setLoadingWrap',[_dec9],{enumerable:true,initializer:function initializer(){var _this9=this;return function(bool){_this9.needloading=bool;};}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'getResetForecast',[_dec10],{enumerable:true,initializer:function initializer(){var _this10=this;return function(callbackFun){_this10.getCellArr({resetForecast:1},callbackFun);};}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'changSmartGuessStatus',[_dec11],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){_this11.smartGuessStatus=!_this11.smartGuessStatus;};}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'setShowSelectPanel',[_dec12],{enumerable:true,initializer:function initializer(){var _this12=this;return function(obj){_this12.divideNodeArr.map(function(v){if(v.remark==obj)v.showStatus=!v.showStatus;});};}}),_descriptor36=_applyDecoratedDescriptor(_class.prototype,'setHiddenSelectPanel',[_dec13],{enumerable:true,initializer:function initializer(){var _this13=this;return function(){_this13.divideNodeArr.map(function(v){if(v.showStatus){v.showStatus=false;}});};}}),_descriptor37=_applyDecoratedDescriptor(_class.prototype,'setOptionItem',[_dec14],{enumerable:true,initializer:function initializer(){var _this14=this;return function(obj,val,callback){var arr=[];_this14.divideNodeArr.map(function(v,index){if(v.remark==obj.nodeRemark){_this14.divideNodeArr[index].checkItem=val+1;_this14.divideNodeArr[index].showStatus=false;}arr=[].concat((0,_toConsumableArray3.default)(arr),[v.remark+'_'+v.checkItem]);});if(arr.length==0)return;var str=arr.join(',');_this14.getCellArr({choicedBranch:str},callback);};}}),_descriptor38=_applyDecoratedDescriptor(_class.prototype,'getOperator',[_dec15],{enumerable:true,initializer:function initializer(){var _this15=this;return function(nodeid){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var newParams=(0,_extends3.default)({},params,_this15.baseReqParams);if(params.nodeType==3){newParams.isForecastNode=1;}var key=nodeid+"_"+params.nodeType;if(!_this15.operatorMap.has(key)){API.getOperator(newParams).then(function(data){//预测的节点和真实走过的节点，分开显示
_this15.operatorMap.set(key,data.nodes);_this15.operatorInfo=data.nodes;});}else{_this15.operatorInfo=_this15.operatorMap.get(key);}};}}),_descriptor39=_applyDecoratedDescriptor(_class.prototype,'clearOperatorArr',[_dec16],{enumerable:true,initializer:function initializer(){var _this16=this;return function(){_this16.operatorInfo=[];_this16.operatorMap=_mobx.observable.map?_mobx.observable.map({}):asMap({});};}}),_descriptor40=_applyDecoratedDescriptor(_class.prototype,'clearStore',[_dec17],{enumerable:true,initializer:function initializer(){var _this17=this;return function(){_this17.forecastInfoMap=_mobx.observable.map?_mobx.observable.map({}):asMap({});_this17.smartGuessStatus=false;_this17.allMapshow=false;_this17.divideNodeArr=[];_this17.isEnd=false;_this17.needloading=false;};}}),_descriptor41=_applyDecoratedDescriptor(_class.prototype,'setRecordClicked',[_dec18],{enumerable:true,initializer:function initializer(){var _this18=this;return function(key){if(!_this18.clickedMap.has(key))_this18.clickedMap.set(key,true);};}})),_class));exports.default=wfSmartGuessStore;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty=__webpack_require__(16);var _defineProperty2=_interopRequireDefault(_defineProperty);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(9);var _req=__webpack_require__(15);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;(0,_defineProperty2.default)(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ShowContentStore=(_class=function ShowContentStore(){var _this=this;(0,_classCallCheck3.default)(this,ShowContentStore);_initDefineProp(this,'spinning',_descriptor,this);this.auto2NextNodeNames="";this.auto2Operators=[];this.auto2NextNodeids="";_initDefineProp(this,'changeSpining4True',_descriptor2,this);this.changeSpining4False=function(){_this.spinning=false;};this.startInterval=function(requestid,nodeid,sessionkey){_this.timer=setInterval(function(){_this.getNextNode(requestid,nodeid,sessionkey);},200);setTimeout(function(){clearInterval(_this.timer);_this.changeSpining4False();},7000);};this.getNextNode=function(requestid,nodeid,sessionkey){var params={requestid:requestid,nodeid:nodeid,sessionkey:sessionkey};(0,_req.getNextNodeContent)(params).then(function(data){if(data&&!data.isAutoApprove){_this.auto2NextNodeNames=data.auto2NextNodeNames;_this.auto2Operators=data.auto2Operators;_this.auto2NextNodeids=data.auto2NextNodeids;clearInterval(_this.timer);_this.changeSpining4False();Util.reloadRequestPage({requestid:requestid,sessionkey:sessionkey});}}).catch(function(){clearInterval(_this.timer);_this.changeSpining4False();});};this.changeSpining4True=this.changeSpining4True.bind(this);this.changeSpining4False=this.changeSpining4False.bind(this);this.getNextNode=this.getNextNode.bind(this);this.startInterval=this.startInterval.bind(this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'spinning',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'changeSpining4True',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.spinning=true;};}})),_class);exports.default=ShowContentStore;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);__webpack_require__(256);var _MainLayout=__webpack_require__(133);var _MainLayout2=_interopRequireDefault(_MainLayout);var _asyncLoad=__webpack_require__(14);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _getEcCom=(0,_convert.getEcCom)(),WeaReqTop=_getEcCom.WeaReqTop;var PreView=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(PreView,_React$Component);function PreView(){(0,_classCallCheck3.default)(this,PreView);return(0,_possibleConstructorReturn3.default)(this,(PreView.__proto__||(0,_getPrototypeOf2.default)(PreView)).call(this));}(0,_createClass3.default)(PreView,[{key:'componentDidMount',value:function componentDidMount(){jQuery("body").attr("class","bodyOverflowHidden");Util.bindResizeEvent();(0,_asyncLoad.controlAsyncLoad)();GlobalUtil.loadCaculateResource();}},{key:'componentDidUpdate',value:function componentDidUpdate(){(0,_asyncLoad.controlAsyncLoad)();}},{key:'render',value:function render(){var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var commonParam=globalStore.commonParam;var layouttype=commonParam.layouttype;var dataJson=layoutStore.dataJson;var hasLoad=!_.isEmpty(commonParam)&&!_.isEmpty(dataJson);if(hasLoad)return layouttype===1||layouttype===2?this.renderPrint():this.renderShow();return null;}},{key:'renderShow',value:function renderShow(){var margin=this.props.globalStore.commonParam.margin;var tabDatas=[{title:(0,_convert.getLabel)(34130,"流程表单"),key:"form"}];return _react2.default.createElement('div',{className:'wf-req'},_react2.default.createElement(WeaReqTop,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaReqTop@7go64i',title:_react2.default.createElement('div',null,(0,_convert.getLabel)(31568,'模板预览')),icon:_react2.default.createElement('i',{className:'icon-coms-workflow'}),iconBgcolor:'#0079DE',tabDatas:tabDatas,selectedKey:'form'},_react2.default.createElement('div',{className:'wf-req-form-content'},_react2.default.createElement('div',{className:'wf-req-form-scroll'},_react2.default.createElement('div',{className:'wf-req-form-main'},_react2.default.createElement('div',{className:'wf-req-form-wrapper',style:{margin:margin}},_react2.default.createElement('div',{className:'wf-req-form',style:{margin:"0 auto",marginBottom:'20px'}},_react2.default.createElement(_MainLayout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MainLayout@ql61lr',symbol:'main'})))))),_react2.default.createElement('div',null)));}},{key:'renderPrint',value:function renderPrint(){jQuery("body").css("overflow","auto");return _react2.default.createElement('div',{className:'wf-req-print',style:{margin:"10px 6px"}},_react2.default.createElement('div',{className:'wf-req-form',style:{margin:"0 auto",marginBottom:'20px'}},_react2.default.createElement(_MainLayout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MainLayout@kc5s6f',symbol:'main'})));}}]);return PreView;}(_react2.default.Component))||_class)||_class);exports.default=PreView;

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _htmlToReact=__webpack_require__(535);var HtmlToReactParser=_interopRequireWildcard(_htmlToReact);var HtmlToReact=_interopRequireWildcard(_htmlToReact);var _CellType=__webpack_require__(136);var _CellType2=_interopRequireDefault(_CellType);var _jquery=__webpack_require__(127);var _jquery2=_interopRequireDefault(_jquery);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var htmlToReactParser=new HtmlToReactParser.Parser();var processNodeDefinitions=new HtmlToReact.ProcessNodeDefinitions(_react2.default);var SourceLayout=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SourceLayout,_React$Component);function SourceLayout(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,SourceLayout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=SourceLayout.__proto__||(0,_getPrototypeOf2.default)(SourceLayout)).call.apply(_ref,[this].concat(args))),_this),_this.isValidNode=function(){return true;},_this.processingInstructions=function(){var layoutSourceInfo=_this.props.layoutStore.layoutSourceInfo;var fieldReg=new RegExp(/^\$(label|field|node)(-?\d+)\$$/);var detailReg=new RegExp(/^oTable(\d+)$/);return[{shouldProcessNode:function shouldProcessNode(node){return node.name==="input"&&node.attribs&&node.attribs.id&&node.attribs.id.match(fieldReg);},processNode:function processNode(node,children){var fieldArr=node.attribs.id.match(fieldReg);var type=fieldArr[1];var etype=0;etype=type==="label"?2:etype;etype=type==="field"?3:etype;etype=type==="node"?5:etype;var field=fieldArr[2];var cellObj={id:"0,0",field:field,etype:etype};var extendProps={};if(etype===5)extendProps.nodeMark=layoutSourceInfo.nodeMarkContent&&layoutSourceInfo.nodeMarkContent['node'+field];return _react2.default.createElement(_CellType2.default,(0,_extends3.default)({ecId:(_this&&_this.props&&_this.props.ecId||'')+'_CellType@2jq516@'+etype+'_'+field,symbol:'main',cellObj:cellObj},extendProps));}},{shouldProcessNode:function shouldProcessNode(node){return node.name==="div"&&node.attribs&&node.attribs.id&&node.attribs.id.match(detailReg);},processNode:function processNode(node){var detailIndex=parseInt(node.attribs.id.match(detailReg)[1]);var dMark='detail_'+(detailIndex+1);var cellObj={id:"0,0",etype:"7",detail:dMark};return _react2.default.createElement(_CellType2.default,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_CellType@x298pa@'+dMark,symbol:'main',cellObj:cellObj});}},{shouldProcessNode:function shouldProcessNode(){return true;},processNode:processNodeDefinitions.processDefaultNode//非匹配节点取默认，必须
}];},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(SourceLayout,[{key:'componentDidMount',value:function componentDidMount(){(0,_jquery2.default)(".excelTempDiv").find("button[name^=addbutton],input[name^=addbutton]").each(function(){var name=(0,_jquery2.default)(this).attr("name");var detailIndex=parseInt(name.replace("addbutton",""));var detailMark="detail_"+(detailIndex+1);var detailObj=DetailUtil.getDetailObj(detailMark);if(detailObj==null)return true;var _detailObj$attr=detailObj.attr,isadd=_detailObj$attr.isadd,isdelete=_detailObj$attr.isdelete;if(isadd===1){(0,_jquery2.default)(this).removeAttr("onclick");(0,_jquery2.default)(this).bind("click",function(){DetailUtil.addRow(detailMark);});}else{(0,_jquery2.default)(this).remove();}});(0,_jquery2.default)(".excelTempDiv").find("button[name^=delbutton],input[name^=delbutton]").each(function(){var name=(0,_jquery2.default)(this).attr("name");var detailIndex=parseInt(name.replace("delbutton",""));var detailMark="detail_"+(detailIndex+1);var detailObj=DetailUtil.getDetailObj(detailMark);if(detailObj==null)return true;var _detailObj$attr2=detailObj.attr,isadd=_detailObj$attr2.isadd,isdelete=_detailObj$attr2.isdelete;if(isadd===1||isdelete===1){(0,_jquery2.default)(this).removeAttr("onclick");(0,_jquery2.default)(this).bind("click",function(){Util.delRow(detailMark);});}else{(0,_jquery2.default)(this).remove();}});}},{key:'render',value:function render(){var layoutStore=this.props.layoutStore;var htmlStr=layoutStore.layoutSourceInfo.html;var reactComponent=htmlToReactParser.parseWithInstructions(htmlStr,this.isValidNode,this.processingInstructions());// console.log("htmlStr", htmlStr, "reactComponent", reactComponent);
return reactComponent;}}]);return SourceLayout;}(_react2.default.Component))||_class)||_class);exports.default=SourceLayout;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parser = __webpack_require__(536);
var processingInstructions = __webpack_require__(267);
var isValidNodeDefinitions = __webpack_require__(270);
var processNodeDefinitions = __webpack_require__(268);
module.exports = {
    Parser: parser,
    ProcessingInstructions: processingInstructions,
    IsValidNodeDefinitions: isValidNodeDefinitions,
    ProcessNodeDefinitions: processNodeDefinitions,
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var forEach = __webpack_require__(537);
var find = __webpack_require__(539);
var reject = __webpack_require__(543);
var addIndex = __webpack_require__(554);
var map = __webpack_require__(557);
var HtmlParser = __webpack_require__(560).Parser;
var DomHandler = __webpack_require__(186).DomHandler;
var ProcessingInstructions = __webpack_require__(267);
var IsValidNodeDefinitions = __webpack_require__(270);
var utils = __webpack_require__(269);
function Html2ReactParser(options) {
    function parseHtmlToTree(html) {
        options = options || {};
        options.decodeEntities = true;
        var handler = new DomHandler();
        var parser = new HtmlParser(handler, options);
        parser.parseComplete(html);
        return handler.dom.filter(function (element) {
            return element.type !== 'directive';
        });
    }
    ;
    function traverseDom(node, isValidNode, processingInstructions, preprocessingInstructions, index) {
        if (isValidNode(node)) {
            forEach(function (preprocessingInstruction) {
                if (preprocessingInstruction.shouldPreprocessNode(node)) {
                    preprocessingInstruction.preprocessNode(node, index);
                }
            }, preprocessingInstructions || []);
            var processingInstruction = find(function (processingInstruction) {
                return processingInstruction.shouldProcessNode(node);
            }, processingInstructions || []);
            if (processingInstruction != null) {
                var children = reject(function (x) { return x == null || x === false; }, addIndex(map)(function (child, i) {
                    return traverseDom(child, isValidNode, processingInstructions, preprocessingInstructions, i);
                }, node.children || []));
                if (processingInstruction.replaceChildren) {
                    return utils.createElement(node, index, node.data, [
                        processingInstruction.processNode(node, children, index),
                    ]);
                }
                else {
                    return processingInstruction.processNode(node, children, index);
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    ;
    function parseWithInstructions(html, isValidNode, processingInstructions, preprocessingInstructions) {
        var domTree = parseHtmlToTree(html);
        var list = domTree.map(function (domTreeItem, index) {
            return traverseDom(domTreeItem, isValidNode, processingInstructions, preprocessingInstructions, index);
        });
        return list.length <= 1 ? list[0] : list;
    }
    ;
    function parse(html) {
        var processingInstructions = new ProcessingInstructions();
        return parseWithInstructions(html, IsValidNodeDefinitions.alwaysValid, processingInstructions.defaultProcessingInstructions);
    }
    ;
    return {
        parse: parse,
        parseWithInstructions: parseWithInstructions,
    };
}
;
module.exports = Html2ReactParser;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = 
/*#__PURE__*/
__webpack_require__(538);
var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */
var forEach = 
/*#__PURE__*/
_curry2(
/*#__PURE__*/
_checkForMethod('forEach', function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while (idx < len) {
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
module.exports = forEach;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = 
/*#__PURE__*/
__webpack_require__(178);
/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
function _checkForMethod(methodname, fn) {
    return function () {
        var length = arguments.length;
        if (length === 0) {
            return fn();
        }
        var obj = arguments[length - 1];
        return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}
module.exports = _checkForMethod;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _dispatchable = 
/*#__PURE__*/
__webpack_require__(179);
var _xfind = 
/*#__PURE__*/
__webpack_require__(541);
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */
var find = 
/*#__PURE__*/
_curry2(
/*#__PURE__*/
_dispatchable(['find'], _xfind, function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
        if (fn(list[idx])) {
            return list[idx];
        }
        idx += 1;
    }
}));
module.exports = find;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

function _isTransformer(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}
module.exports = _isTransformer;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _reduced = 
/*#__PURE__*/
__webpack_require__(542);
var _xfBase = 
/*#__PURE__*/
__webpack_require__(180);
var XFind = 
/*#__PURE__*/
function () {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype['@@transducer/init'] = _xfBase.init;
    XFind.prototype['@@transducer/result'] = function (result) {
        if (!this.found) {
            result = this.xf['@@transducer/step'](result, void 0);
        }
        return this.xf['@@transducer/result'](result);
    };
    XFind.prototype['@@transducer/step'] = function (result, input) {
        if (this.f(input)) {
            this.found = true;
            result = _reduced(this.xf['@@transducer/step'](result, input));
        }
        return result;
    };
    return XFind;
}();
var _xfind = 
/*#__PURE__*/
_curry2(function _xfind(f, xf) {
    return new XFind(f, xf);
});
module.exports = _xfind;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

function _reduced(x) {
    return x && x['@@transducer/reduced'] ? x : {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}
module.exports = _reduced;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var _complement = 
/*#__PURE__*/
__webpack_require__(544);
var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var filter = 
/*#__PURE__*/
__webpack_require__(545);
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var reject = 
/*#__PURE__*/
_curry2(function reject(pred, filterable) {
    return filter(_complement(pred), filterable);
});
module.exports = reject;


/***/ }),
/* 544 */
/***/ (function(module, exports) {

function _complement(f) {
    return function () {
        return !f.apply(this, arguments);
    };
}
module.exports = _complement;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _dispatchable = 
/*#__PURE__*/
__webpack_require__(179);
var _filter = 
/*#__PURE__*/
__webpack_require__(546);
var _isObject = 
/*#__PURE__*/
__webpack_require__(547);
var _reduce = 
/*#__PURE__*/
__webpack_require__(181);
var _xfilter = 
/*#__PURE__*/
__webpack_require__(552);
var keys = 
/*#__PURE__*/
__webpack_require__(183);
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var filter = 
/*#__PURE__*/
_curry2(
/*#__PURE__*/
_dispatchable(['filter'], _xfilter, function (pred, filterable) {
    return _isObject(filterable) ? _reduce(function (acc, key) {
        if (pred(filterable[key])) {
            acc[key] = filterable[key];
        }
        return acc;
    }, {}, keys(filterable)) : // else
        _filter(pred, filterable);
}));
module.exports = filter;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

function _filter(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while (idx < len) {
        if (fn(list[idx])) {
            result[result.length] = list[idx];
        }
        idx += 1;
    }
    return result;
}
module.exports = _filter;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

function _isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}
module.exports = _isObject;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
var _isArray = 
/*#__PURE__*/
__webpack_require__(178);
var _isString = 
/*#__PURE__*/
__webpack_require__(549);
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
var _isArrayLike = 
/*#__PURE__*/
_curry1(function isArrayLike(x) {
    if (_isArray(x)) {
        return true;
    }
    if (!x) {
        return false;
    }
    if (typeof x !== 'object') {
        return false;
    }
    if (_isString(x)) {
        return false;
    }
    if (x.nodeType === 1) {
        return !!x.length;
    }
    if (x.length === 0) {
        return true;
    }
    if (x.length > 0) {
        return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    }
    return false;
});
module.exports = _isArrayLike;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

function _isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}
module.exports = _isString;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

var XWrap = 
/*#__PURE__*/
function () {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function () {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function (acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function (acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function _xwrap(fn) {
    return new XWrap(fn);
}
module.exports = _xwrap;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = 
/*#__PURE__*/
__webpack_require__(182);
var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
var bind = 
/*#__PURE__*/
_curry2(function bind(fn, thisObj) {
    return _arity(fn.length, function () {
        return fn.apply(thisObj, arguments);
    });
});
module.exports = bind;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _xfBase = 
/*#__PURE__*/
__webpack_require__(180);
var XFilter = 
/*#__PURE__*/
function () {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype['@@transducer/init'] = _xfBase.init;
    XFilter.prototype['@@transducer/result'] = _xfBase.result;
    XFilter.prototype['@@transducer/step'] = function (result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
    };
    return XFilter;
}();
var _xfilter = 
/*#__PURE__*/
_curry2(function _xfilter(f, xf) {
    return new XFilter(f, xf);
});
module.exports = _xfilter;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var _has = 
/*#__PURE__*/
__webpack_require__(135);
var toString = Object.prototype.toString;
var _isArguments = 
/*#__PURE__*/
function () {
    return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return _has('callee', x);
    };
}();
module.exports = _isArguments;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = 
/*#__PURE__*/
__webpack_require__(555);
var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
var curryN = 
/*#__PURE__*/
__webpack_require__(257);
/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
var addIndex = 
/*#__PURE__*/
_curry1(function addIndex(fn) {
    return curryN(fn.length, function () {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function () {
            var result = origFn.apply(this, _concat(arguments, [idx, list]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
module.exports = addIndex;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while (idx < len1) {
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while (idx < len2) {
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}
module.exports = _concat;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = 
/*#__PURE__*/
__webpack_require__(182);
var _isPlaceholder = 
/*#__PURE__*/
__webpack_require__(134);
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curryN(length, received, fn) {
    return function () {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while (combinedIdx < received.length || argsIdx < arguments.length) {
            var result;
            if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
                result = received[combinedIdx];
            }
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!_isPlaceholder(result)) {
                left -= 1;
            }
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
    };
}
module.exports = _curryN;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _dispatchable = 
/*#__PURE__*/
__webpack_require__(179);
var _map = 
/*#__PURE__*/
__webpack_require__(558);
var _reduce = 
/*#__PURE__*/
__webpack_require__(181);
var _xmap = 
/*#__PURE__*/
__webpack_require__(559);
var curryN = 
/*#__PURE__*/
__webpack_require__(257);
var keys = 
/*#__PURE__*/
__webpack_require__(183);
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
var map = 
/*#__PURE__*/
_curry2(
/*#__PURE__*/
_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
    switch (Object.prototype.toString.call(functor)) {
        case '[object Function]':
            return curryN(functor.length, function () {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return _reduce(function (acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, keys(functor));
        default:
            return _map(fn, functor);
    }
}));
module.exports = map;


/***/ }),
/* 558 */
/***/ (function(module, exports) {

function _map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while (idx < len) {
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}
module.exports = _map;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _xfBase = 
/*#__PURE__*/
__webpack_require__(180);
var XMap = 
/*#__PURE__*/
function () {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = _xfBase.init;
    XMap.prototype['@@transducer/result'] = _xfBase.result;
    XMap.prototype['@@transducer/step'] = function (result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var _xmap = 
/*#__PURE__*/
_curry2(function _xmap(f, xf) {
    return new XMap(f, xf);
});
module.exports = _xmap;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m)
        if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule)
        return mod;
    var result = {};
    if (mod != null)
        for (var k in mod)
            if (Object.hasOwnProperty.call(mod, k))
                result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Parser_1 = __webpack_require__(258);
exports.Parser = Parser_1.Parser;
var domhandler_1 = __webpack_require__(186);
exports.DomHandler = domhandler_1.DomHandler;
exports.DefaultHandler = domhandler_1.DomHandler;
// Helper methods
/**
 * Parses data, returns the resulting DOM.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */
function parseDOM(data, options) {
    var handler = new domhandler_1.DomHandler(void 0, options);
    new Parser_1.Parser(handler, options).end(data);
    return handler.dom;
}
exports.parseDOM = parseDOM;
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param cb A callback that will be called once parsing has been completed.
 * @param options Optional options for the parser and DOM builder.
 * @param elementCb An optional callback that will be called every time a tag has been completed inside of the DOM.
 */
function createDomStream(cb, options, elementCb) {
    var handler = new domhandler_1.DomHandler(cb, options, elementCb);
    return new Parser_1.Parser(handler, options);
}
exports.createDomStream = createDomStream;
var Tokenizer_1 = __webpack_require__(259);
exports.Tokenizer = Tokenizer_1.default;
var ElementType = __importStar(__webpack_require__(564));
exports.ElementType = ElementType;
/**
 * List of all events that the parser emits.
 *
 * Format: eventname: number of arguments.
 */
exports.EVENTS = {
    attribute: 2,
    cdatastart: 0,
    cdataend: 0,
    text: 1,
    processinginstruction: 2,
    comment: 1,
    commentend: 0,
    closetag: 1,
    opentag: 2,
    opentagname: 1,
    error: 1,
    end: 0
};
/*
    All of the following exports exist for backwards-compatibility.
    They should probably be removed eventually.
*/
__export(__webpack_require__(262));
__export(__webpack_require__(575));
__export(__webpack_require__(576));
var DomUtils = __importStar(__webpack_require__(263));
exports.DomUtils = DomUtils;
var FeedHandler_1 = __webpack_require__(262);
exports.RssHandler = FeedHandler_1.FeedHandler;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function'
    ? R.apply
    : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
    ReflectOwnKeys = R.ownKeys;
}
else if (Object.getOwnPropertySymbols) {
    ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target)
            .concat(Object.getOwnPropertySymbols(target));
    };
}
else {
    ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
}
function ProcessEmitWarning(warning) {
    if (console && console.warn)
        console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function () {
        return defaultMaxListeners;
    },
    set: function (arg) {
        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
            throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        }
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function () {
    if (this._events === undefined ||
        this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    }
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined)
        return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for (var i = 1; i < arguments.length; i++)
        args.push(arguments[i]);
    var doError = (type === 'error');
    var events = this._events;
    if (events !== undefined)
        doError = (doError && events.error === undefined);
    else if (!doError)
        return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0)
            er = args[0];
        if (er instanceof Error) {
            // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
        }
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined)
        return false;
    if (typeof handler === 'function') {
        ReflectApply(handler, this, args);
    }
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
            ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    }
    else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    }
    else {
        if (typeof existing === 'function') {
            // Adding the second element, need to change to array.
            existing = events[type] =
                prepend ? [listener, existing] : [existing, listener];
            // If we've already got an array, just append.
        }
        else if (prepend) {
            existing.unshift(listener);
        }
        else {
            existing.push(listener);
        }
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' +
                existing.length + ' ' + String(type) + ' listeners ' +
                'added. Use emitter.setMaxListeners() to ' +
                'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0)
            return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
        checkListener(listener);
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    };
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        checkListener(listener);
        events = this._events;
        if (events === undefined)
            return this;
        list = events[type];
        if (list === undefined)
            return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0)
                this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener)
                    this.emit('removeListener', type, list.listener || listener);
            }
        }
        else if (typeof list !== 'function') {
            position = -1;
            for (i = list.length - 1; i >= 0; i--) {
                if (list[i] === listener || list[i].listener === listener) {
                    originalListener = list[i].listener;
                    position = i;
                    break;
                }
            }
            if (position < 0)
                return this;
            if (position === 0)
                list.shift();
            else {
                spliceOne(list, position);
            }
            if (list.length === 1)
                events[type] = list[0];
            if (events.removeListener !== undefined)
                this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined)
            return this;
        // not listening for removeListener, no need to emit
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            }
            else if (events[type] !== undefined) {
                if (--this._eventsCount === 0)
                    this._events = Object.create(null);
                else
                    delete events[type];
            }
            return this;
        }
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for (i = 0; i < keys.length; ++i) {
                key = keys[i];
                if (key === 'removeListener')
                    continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') {
            this.removeListener(type, listeners);
        }
        else if (listeners !== undefined) {
            // LIFO order
            for (i = listeners.length - 1; i >= 0; i--) {
                this.removeListener(type, listeners[i]);
            }
        }
        return this;
    };
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined)
        return [];
    var evlistener = events[type];
    if (evlistener === undefined)
        return [];
    if (typeof evlistener === 'function')
        return unwrap ? [evlistener.listener || evlistener] : [evlistener];
    return unwrap ?
        unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function (emitter, type) {
    if (typeof emitter.listenerCount === 'function') {
        return emitter.listenerCount(type);
    }
    else {
        return listenerCount.call(emitter, type);
    }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') {
            return 1;
        }
        else if (evlistener !== undefined) {
            return evlistener.length;
        }
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for (var i = 0; i < n; ++i)
        copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for (; index + 1 < list.length; index++)
        list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for (var i = 0; i < ret.length; ++i) {
        ret[i] = arr[i].listener || arr[i];
    }
    return ret;
}


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var nodeTypes = new Map([
    ["tag" /* Tag */, 1],
    ["script" /* Script */, 1],
    ["style" /* Style */, 1],
    ["directive" /* Directive */, 1],
    ["text" /* Text */, 3],
    ["cdata" /* CDATA */, 4],
    ["comment" /* Comment */, 8]
]);
// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var Node = /** @class */ (function () {
    /**
     *
     * @param type The type of the node.
     */
    function Node(type) {
        this.type = type;
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        get: function () {
            return nodeTypes.get(this.type) || 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        get: function () {
            return this.parent || null;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        get: function () {
            return this.prev || null;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        get: function () {
            return this.next || null;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: true,
        configurable: true
    });
    return Node;
}());
exports.Node = Node;
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     *
     * @param type The type of the node
     * @param data The content of the data node
     */
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: true,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, "directive" /* Directive */, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     *
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        get: function () {
            return this.children[0] || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        get: function () {
            return this.children[this.children.length - 1] || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: true,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     *
     * @param name Name of the tag, eg. `div`, `span`
     * @param attribs Object mapping attribute names to attribute values
     */
    function Element(name, attribs) {
        var _this = _super.call(this, name === "script"
            ? "script" /* Script */
            : name === "style"
                ? "style" /* Style */
                : "tag" /* Tag */, []) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: true,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === "tag" /* Tag */ ||
        elem.type === "script" /* Script */ ||
        elem.type === "style" /* Style */);
}
exports.isTag = isTag;
// Exports for backwards compatibility
exports.Text = "text" /* Text */; //Text
exports.Directive = "directive" /* Directive */; //<? ... ?>
exports.Comment = "comment" /* Comment */; //<!-- ... -->
exports.Script = "script" /* Script */; //<script> tags
exports.Style = "style" /* Style */; //<style> tags
exports.Tag = "tag" /* Tag */; //Any tag
exports.CDATA = "cdata" /* CDATA */; //<![CDATA[ ... ]]>
exports.Doctype = "doctype" /* Doctype */;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tagtypes_1 = __webpack_require__(104);
var dom_serializer_1 = __importDefault(__webpack_require__(567));
function getOuterHTML(node, options) {
    return dom_serializer_1.default(node, options);
}
exports.getOuterHTML = getOuterHTML;
function getInnerHTML(node, options) {
    return tagtypes_1.hasChildren(node)
        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
        : "";
}
exports.getInnerHTML = getInnerHTML;
function getText(node) {
    if (Array.isArray(node))
        return node.map(getText).join("");
    if (tagtypes_1.isTag(node))
        return node.name === "br" ? "\n" : getText(node.children);
    if (tagtypes_1.isCDATA(node))
        return getText(node.children);
    if (tagtypes_1.isText(node))
        return node.data;
    return "";
}
exports.getText = getText;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === "tag" /* Tag */ ||
        elem.type === "script" /* Script */ ||
        elem.type === "style" /* Style */);
}
exports.isTag = isTag;
// Exports for backwards compatibility
exports.Text = "text" /* Text */; //Text
exports.Directive = "directive" /* Directive */; //<? ... ?>
exports.Comment = "comment" /* Comment */; //<!-- ... -->
exports.Script = "script" /* Script */; //<script> tags
exports.Style = "style" /* Style */; //<style> tags
exports.Tag = "tag" /* Tag */; //Any tag
exports.CDATA = "cdata" /* CDATA */; //<![CDATA[ ... ]]>
exports.Doctype = "doctype" /* Doctype */;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Module dependencies
*/
var ElementType = __webpack_require__(568);
var entities = __webpack_require__(569);
/* mixed-case SVG and MathML tags & attributes
   recognized by the HTML parser, see
   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
*/
var foreignNames = __webpack_require__(570);
foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
foreignNames.attributeNames.__proto__ = null;
var unencodedElements = {
    __proto__: null,
    style: true,
    script: true,
    xmp: true,
    iframe: true,
    noembed: true,
    noframes: true,
    plaintext: true,
    noscript: true
};
/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
    if (!attributes)
        return;
    var output = '';
    var value;
    // Loop through the attributes
    for (var key in attributes) {
        value = attributes[key];
        if (output) {
            output += ' ';
        }
        if (opts.xmlMode === 'foreign') {
            /* fix up mixed-case attribute names */
            key = foreignNames.attributeNames[key] || key;
        }
        output += key;
        if ((value !== null && value !== '') || opts.xmlMode) {
            output +=
                '="' +
                    (opts.decodeEntities
                        ? entities.encodeXML(value)
                        : value.replace(/\"/g, '&quot;')) +
                    '"';
        }
    }
    return output;
}
/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
    __proto__: null,
    area: true,
    base: true,
    basefont: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    isindex: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
};
var render = (module.exports = function (dom, opts) {
    if (!Array.isArray(dom) && !dom.cheerio)
        dom = [dom];
    opts = opts || {};
    var output = '';
    for (var i = 0; i < dom.length; i++) {
        var elem = dom[i];
        if (elem.type === 'root')
            output += render(elem.children, opts);
        else if (ElementType.isTag(elem))
            output += renderTag(elem, opts);
        else if (elem.type === ElementType.Directive)
            output += renderDirective(elem);
        else if (elem.type === ElementType.Comment)
            output += renderComment(elem);
        else if (elem.type === ElementType.CDATA)
            output += renderCdata(elem);
        else
            output += renderText(elem, opts);
    }
    return output;
});
var foreignModeIntegrationPoints = [
    'mi',
    'mo',
    'mn',
    'ms',
    'mtext',
    'annotation-xml',
    'foreignObject',
    'desc',
    'title'
];
function renderTag(elem, opts) {
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === 'foreign') {
        /* fix up mixed-case element names */
        elem.name = foreignNames.elementNames[elem.name] || elem.name;
        /* exit foreign mode at integration points */
        if (elem.parent &&
            foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0)
            opts = Object.assign({}, opts, { xmlMode: false });
    }
    if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
        opts = Object.assign({}, opts, { xmlMode: 'foreign' });
    }
    var tag = '<' + elem.name;
    var attribs = formatAttrs(elem.attribs, opts);
    if (attribs) {
        tag += ' ' + attribs;
    }
    if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
        tag += '/>';
    }
    else {
        tag += '>';
        if (elem.children) {
            tag += render(elem.children, opts);
        }
        if (!singleTag[elem.name] || opts.xmlMode) {
            tag += '</' + elem.name + '>';
        }
    }
    return tag;
}
function renderDirective(elem) {
    return '<' + elem.data + '>';
}
function renderText(elem, opts) {
    var data = elem.data || '';
    // if entities weren't decoded, no need to encode them back
    if (opts.decodeEntities &&
        !(elem.parent && elem.parent.name in unencodedElements)) {
        data = entities.encodeXML(data);
    }
    return data;
}
function renderCdata(elem) {
    return '<![CDATA[' + elem.children[0].data + ']]>';
}
function renderComment(elem) {
    return '<!--' + elem.data + '-->';
}


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === "tag" /* Tag */ ||
        elem.type === "script" /* Script */ ||
        elem.type === "style" /* Style */);
}
exports.isTag = isTag;
// Exports for backwards compatibility
exports.Text = "text" /* Text */; //Text
exports.Directive = "directive" /* Directive */; //<? ... ?>
exports.Comment = "comment" /* Comment */; //<!-- ... -->
exports.Script = "script" /* Script */; //<script> tags
exports.Style = "style" /* Style */; //<style> tags
exports.Tag = "tag" /* Tag */; //Any tag
exports.CDATA = "cdata" /* CDATA */; //<![CDATA[ ... ]]>
exports.Doctype = "doctype" /* Doctype */;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = exports.decodeStrict = exports.decode = void 0;
var decode_1 = __webpack_require__(264);
var encode_1 = __webpack_require__(265);
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 */
function decode(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
}
exports.decode = decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 */
function decodeStrict(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
}
exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 */
function encode(data, level) {
    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
}
exports.encode = encode;
var encode_2 = __webpack_require__(265);
Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
// Legacy aliases
Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
var decode_2 = __webpack_require__(264);
Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
// Legacy aliases
Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });


/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = {"elementNames":{"altglyph":"altGlyph","altglyphdef":"altGlyphDef","altglyphitem":"altGlyphItem","animatecolor":"animateColor","animatemotion":"animateMotion","animatetransform":"animateTransform","clippath":"clipPath","feblend":"feBlend","fecolormatrix":"feColorMatrix","fecomponenttransfer":"feComponentTransfer","fecomposite":"feComposite","feconvolvematrix":"feConvolveMatrix","fediffuselighting":"feDiffuseLighting","fedisplacementmap":"feDisplacementMap","fedistantlight":"feDistantLight","fedropshadow":"feDropShadow","feflood":"feFlood","fefunca":"feFuncA","fefuncb":"feFuncB","fefuncg":"feFuncG","fefuncr":"feFuncR","fegaussianblur":"feGaussianBlur","feimage":"feImage","femerge":"feMerge","femergenode":"feMergeNode","femorphology":"feMorphology","feoffset":"feOffset","fepointlight":"fePointLight","fespecularlighting":"feSpecularLighting","fespotlight":"feSpotLight","fetile":"feTile","feturbulence":"feTurbulence","foreignobject":"foreignObject","glyphref":"glyphRef","lineargradient":"linearGradient","radialgradient":"radialGradient","textpath":"textPath"},"attributeNames":{"definitionurl":"definitionURL","attributename":"attributeName","attributetype":"attributeType","basefrequency":"baseFrequency","baseprofile":"baseProfile","calcmode":"calcMode","clippathunits":"clipPathUnits","diffuseconstant":"diffuseConstant","edgemode":"edgeMode","filterunits":"filterUnits","glyphref":"glyphRef","gradienttransform":"gradientTransform","gradientunits":"gradientUnits","kernelmatrix":"kernelMatrix","kernelunitlength":"kernelUnitLength","keypoints":"keyPoints","keysplines":"keySplines","keytimes":"keyTimes","lengthadjust":"lengthAdjust","limitingconeangle":"limitingConeAngle","markerheight":"markerHeight","markerunits":"markerUnits","markerwidth":"markerWidth","maskcontentunits":"maskContentUnits","maskunits":"maskUnits","numoctaves":"numOctaves","pathlength":"pathLength","patterncontentunits":"patternContentUnits","patterntransform":"patternTransform","patternunits":"patternUnits","pointsatx":"pointsAtX","pointsaty":"pointsAtY","pointsatz":"pointsAtZ","preservealpha":"preserveAlpha","preserveaspectratio":"preserveAspectRatio","primitiveunits":"primitiveUnits","refx":"refX","refy":"refY","repeatcount":"repeatCount","repeatdur":"repeatDur","requiredextensions":"requiredExtensions","requiredfeatures":"requiredFeatures","specularconstant":"specularConstant","specularexponent":"specularExponent","spreadmethod":"spreadMethod","startoffset":"startOffset","stddeviation":"stdDeviation","stitchtiles":"stitchTiles","surfacescale":"surfaceScale","systemlanguage":"systemLanguage","tablevalues":"tableValues","targetx":"targetX","targety":"targetY","textlength":"textLength","viewbox":"viewBox","viewtarget":"viewTarget","xchannelselector":"xChannelSelector","ychannelselector":"yChannelSelector","zoomandpan":"zoomAndPan"}}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getChildren(elem) {
    return elem.children || null;
}
exports.getChildren = getChildren;
function getParent(elem) {
    return elem.parent || null;
}
exports.getParent = getParent;
function getSiblings(elem) {
    var parent = getParent(elem);
    return parent ? getChildren(parent) : [elem];
}
exports.getSiblings = getSiblings;
function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
exports.getAttributeValue = getAttributeValue;
function hasAttrib(elem, name) {
    return (!!elem.attribs &&
        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
        elem.attribs[name] != null);
}
exports.hasAttrib = hasAttrib;
/***
 * Returns the name property of an element
 *
 * @param elem The element to get the name for
 */
function getName(elem) {
    return elem.name;
}
exports.getName = getName;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/***
 * Remove an element from the dom
 *
 * @param elem The element to be removed
 */
function removeElement(elem) {
    if (elem.prev)
        elem.prev.next = elem.next;
    if (elem.next)
        elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        childs.splice(childs.lastIndexOf(elem), 1);
    }
}
exports.removeElement = removeElement;
/***
 * Replace an element in the dom
 *
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */
function replaceElement(elem, replacement) {
    var prev = (replacement.prev = elem.prev);
    if (prev) {
        prev.next = replacement;
    }
    var next = (replacement.next = elem.next);
    if (next) {
        next.prev = replacement;
    }
    var parent = (replacement.parent = elem.parent);
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
    }
}
exports.replaceElement = replaceElement;
/***
 * Append a child to an element
 *
 * @param elem The element to append to
 * @param child The element to be added as a child
 */
function appendChild(elem, child) {
    child.parent = elem;
    if (elem.children.push(child) !== 1) {
        var sibling = elem.children[elem.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
        child.next = null;
    }
}
exports.appendChild = appendChild;
/***
 * Append an element after another
 *
 * @param elem The element to append to
 * @param next The element be added
 */
function append(elem, next) {
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    }
    else if (parent) {
        parent.children.push(next);
    }
}
exports.append = append;
/***
 * Prepend an element before another
 *
 * @param elem The element to append to
 * @param prev The element be added
 */
function prepend(elem, prev) {
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.lastIndexOf(elem), 0, prev);
    }
    if (elem.prev) {
        elem.prev.next = prev;
    }
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}
exports.prepend = prepend;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var querying_1 = __webpack_require__(266);
var tagtypes_1 = __webpack_require__(104);
function isTextNode(node) {
    return node.type === "text" /* Text */;
}
/* eslint-disable @typescript-eslint/camelcase */
var Checks = {
    tag_name: function (name) {
        if (typeof name === "function") {
            return function (elem) { return tagtypes_1.isTag(elem) && name(elem.name); };
        }
        else if (name === "*") {
            return tagtypes_1.isTag;
        }
        else {
            return function (elem) { return tagtypes_1.isTag(elem) && elem.name === name; };
        }
    },
    tag_type: function (type) {
        if (typeof type === "function") {
            return function (elem) { return type(elem.type); };
        }
        else {
            return function (elem) { return elem.type === type; };
        }
    },
    tag_contains: function (data) {
        if (typeof data === "function") {
            return function (elem) { return isTextNode(elem) && data(elem.data); };
        }
        else {
            return function (elem) { return isTextNode(elem) && elem.data === data; };
        }
    },
};
/* eslint-enable @typescript-eslint/camelcase */
function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
        return function (elem) { return tagtypes_1.isTag(elem) && value(elem.attribs[attrib]); };
    }
    else {
        return function (elem) { return tagtypes_1.isTag(elem) && elem.attribs[attrib] === value; };
    }
}
function combineFuncs(a, b) {
    return function (elem) { return a(elem) || b(elem); };
}
function compileTest(options) {
    var funcs = Object.keys(options).map(function (key) {
        var value = options[key];
        return key in Checks
            ? Checks[key](value)
            : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
function testElement(options, element) {
    var test = compileTest(options);
    return test ? test(element) : true;
}
exports.testElement = testElement;
function getElements(options, element, recurse, limit) {
    if (limit === void 0) {
        limit = Infinity;
    }
    var test = compileTest(options);
    return test ? querying_1.filter(test, element, recurse, limit) : [];
}
exports.getElements = getElements;
function getElementById(id, element, recurse) {
    if (recurse === void 0) {
        recurse = true;
    }
    if (!Array.isArray(element))
        element = [element];
    return querying_1.findOne(getAttribCheck("id", id), element, recurse);
}
exports.getElementById = getElementById;
function getElementsByTagName(name, element, recurse, limit) {
    if (limit === void 0) {
        limit = Infinity;
    }
    return querying_1.filter(Checks.tag_name(name), element, recurse, limit);
}
exports.getElementsByTagName = getElementsByTagName;
function getElementsByTagType(type, element, recurse, limit) {
    if (recurse === void 0) {
        recurse = true;
    }
    if (limit === void 0) {
        limit = Infinity;
    }
    return querying_1.filter(Checks.tag_type(type), element, recurse, limit);
}
exports.getElementsByTagType = getElementsByTagType;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tagtypes_1 = __webpack_require__(104);
/**
 * Given an array of nodes, remove any member that is contained by another.
 *
 * @param nodes Nodes to filter.
 */
function removeSubsets(nodes) {
    var idx = nodes.length;
    // Check if each node (or one of its ancestors) is already contained in the
    // array.
    while (--idx >= 0) {
        var node = nodes[idx];
        // Remove the node if it is not unique.
        // We are going through the array from the end, so we only
        // have to check nodes that preceed the node under consideration in the array.
        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
            if (nodes.indexOf(ancestor) > -1) {
                nodes.splice(idx, 1);
                break;
            }
        }
    }
    return nodes;
}
exports.removeSubsets = removeSubsets;
/***
 * Compare the position of one node against another node in any other document.
 * The return value is a bitmask with the following values:
 *
 * document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent./
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 * @param nodaA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 *
 * @return A bitmask describing the input nodes' relative position.
 *
 *        See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 *        a description of these values.
 */
function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
        return 0;
    }
    var current = tagtypes_1.hasChildren(nodeA) ? nodeA : nodeA.parent;
    while (current) {
        aParents.unshift(current);
        current = current.parent;
    }
    current = tagtypes_1.hasChildren(nodeB) ? nodeB : nodeB.parent;
    while (current) {
        bParents.unshift(current);
        current = current.parent;
    }
    var idx = 0;
    while (aParents[idx] === bParents[idx]) {
        idx++;
    }
    if (idx === 0) {
        return 1 /* DISCONNECTED */;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
            return 4 /* FOLLOWING */ | 16 /* CONTAINED_BY */;
        }
        return 4 /* FOLLOWING */;
    }
    else {
        if (sharedParent === nodeA) {
            return 2 /* PRECEDING */ | 8 /* CONTAINS */;
        }
        return 2 /* PRECEDING */;
    }
}
exports.compareDocumentPosition = compareDocumentPosition;
/***
 * Sort an array of nodes based on their relative position in the document and
 * remove any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @param nodes Array of DOM nodes
 * @returns collection of unique nodes, sorted in document order
 */
function uniqueSort(nodes) {
    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
    nodes.sort(function (a, b) {
        var relative = compareDocumentPosition(a, b);
        if (relative & 2 /* PRECEDING */) {
            return -1;
        }
        else if (relative & 4 /* FOLLOWING */) {
            return 1;
        }
        return 0;
    });
    return nodes;
}
exports.uniqueSort = uniqueSort;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MultiplexHandler_1 = __importDefault(__webpack_require__(577));
var CollectingHandler = /** @class */ (function (_super) {
    __extends(CollectingHandler, _super);
    function CollectingHandler(cbs) {
        if (cbs === void 0) {
            cbs = {};
        }
        var _this = _super.call(this, function (name) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            _this.events.push([name].concat(args));
            // @ts-ignore
            if (_this._cbs[name])
                (_a = _this._cbs)[name].apply(_a, args);
        }) || this;
        _this._cbs = cbs;
        _this.events = [];
        return _this;
    }
    CollectingHandler.prototype.onreset = function () {
        this.events = [];
        if (this._cbs.onreset)
            this._cbs.onreset();
    };
    CollectingHandler.prototype.restart = function () {
        var _a;
        if (this._cbs.onreset)
            this._cbs.onreset();
        for (var i = 0; i < this.events.length; i++) {
            var _b = this.events[i], name_1 = _b[0], args = _b.slice(1);
            if (!this._cbs[name_1]) {
                continue;
            }
            // @ts-ignore
            (_a = this._cbs)[name_1].apply(_a, args);
        }
    };
    return CollectingHandler;
}(MultiplexHandler_1.default));
exports.CollectingHandler = CollectingHandler;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Calls a specific handler function for all events that are encountered.
 *
 * @param func — The function to multiplex all events to.
 */
var MultiplexHandler = /** @class */ (function () {
    function MultiplexHandler(func) {
        this._func = func;
    }
    /* Format: eventname: number of arguments */
    MultiplexHandler.prototype.onattribute = function (name, value) {
        this._func("onattribute", name, value);
    };
    MultiplexHandler.prototype.oncdatastart = function () {
        this._func("oncdatastart");
    };
    MultiplexHandler.prototype.oncdataend = function () {
        this._func("oncdataend");
    };
    MultiplexHandler.prototype.ontext = function (text) {
        this._func("ontext", text);
    };
    MultiplexHandler.prototype.onprocessinginstruction = function (name, value) {
        this._func("onprocessinginstruction", name, value);
    };
    MultiplexHandler.prototype.oncomment = function (comment) {
        this._func("oncomment", comment);
    };
    MultiplexHandler.prototype.oncommentend = function () {
        this._func("oncommentend");
    };
    MultiplexHandler.prototype.onclosetag = function (name) {
        this._func("onclosetag", name);
    };
    MultiplexHandler.prototype.onopentag = function (name, attribs) {
        this._func("onopentag", name, attribs);
    };
    MultiplexHandler.prototype.onopentagname = function (name) {
        this._func("onopentagname", name);
    };
    MultiplexHandler.prototype.onerror = function (error) {
        this._func("onerror", error);
    };
    MultiplexHandler.prototype.onend = function () {
        this._func("onend");
    };
    MultiplexHandler.prototype.onparserinit = function (parser) {
        this._func("onparserinit", parser);
    };
    MultiplexHandler.prototype.onreset = function () {
        this._func("onreset");
    };
    return MultiplexHandler;
}());
exports.default = MultiplexHandler;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function shouldProcessEveryNode(node) {
    return true;
}
module.exports = {
    shouldProcessEveryNode: shouldProcessEveryNode,
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;
/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', rsComboSymbolsRange = '\\u20d0-\\u20f0', rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')', rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
    rsUpper + '+' + rsOptUpperContr,
    rsDigits,
    rsEmoji
].join('|'), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C', '\xe7': 'c',
    '\xd0': 'D', '\xf0': 'd',
    '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N', '\xf1': 'n',
    '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C', '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c', '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D', '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G', '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g', '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I', '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i', '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J', '\u0135': 'j',
    '\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L', '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l', '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O', '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o', '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S', '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's', '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't', '\u0165': 't', '\u0167': 't',
    '\u0168': 'U', '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u', '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W', '\u0175': 'w',
    '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z', '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z', '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 'ss'
};
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) {
        accumulator = array[++index];
    }
    while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
    return string.split('');
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
    return function (key) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
    return reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
    return hasUnicode(string)
        ? unicodeToArray(string)
        : asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}
/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;
/** Built-in value references. */
var Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
        start = -start > length ? 0 : (length + start);
    }
    end = end > length ? length : end;
    if (end < 0) {
        end += length;
    }
    length = start > end ? 0 : ((end - start) >>> 0);
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
        result[index] = array[index + start];
    }
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
        return value;
    }
    if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return (!start && end >= length) ? array : baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
    return function (string) {
        string = toString(string);
        var strSymbols = hasUnicode(string)
            ? stringToArray(string)
            : undefined;
        var chr = strSymbols
            ? strSymbols[0]
            : string.charAt(0);
        var trailing = strSymbols
            ? castSlice(strSymbols, 1).join('')
            : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
    return function (string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' ||
        (isObjectLike(value) && objectToString.call(value) == symbolTag);
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function (result, word, index) {
    word = word.toLowerCase();
    return result + (index ? capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
    return upperFirst(toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    }
    return string.match(pattern) || [];
}
module.exports = camelCase;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(158)))

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
var _has = 
/*#__PURE__*/
__webpack_require__(135);
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */
var toPairs = 
/*#__PURE__*/
_curry1(function toPairs(obj) {
    var pairs = [];
    for (var prop in obj) {
        if (_has(prop, obj)) {
            pairs[pairs.length] = [prop, obj[prop]];
        }
    }
    return pairs;
});
module.exports = toPairs;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = 
/*#__PURE__*/
__webpack_require__(582);
var _reduce = 
/*#__PURE__*/
__webpack_require__(181);
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
var reduce = 
/*#__PURE__*/
_curry3(_reduce);
module.exports = reduce;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _isPlaceholder = 
/*#__PURE__*/
__webpack_require__(134);
/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry3(fn) {
    return function f3(a, b, c) {
        switch (arguments.length) {
            case 0:
                return f3;
            case 1:
                return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
                    return fn(_a, b, _c);
                }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
                    return fn(a, _b, _c);
                }) : _curry1(function (_c) {
                    return fn(a, b, _c);
                });
            default:
                return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
                    return fn(_a, _b, c);
                }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
                    return fn(_a, b, _c);
                }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
                    return fn(a, _b, _c);
                }) : _isPlaceholder(a) ? _curry1(function (_a) {
                    return fn(_a, b, c);
                }) : _isPlaceholder(b) ? _curry1(function (_b) {
                    return fn(a, _b, c);
                }) : _isPlaceholder(c) ? _curry1(function (_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}
module.exports = _curry3;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var _includes = 
/*#__PURE__*/
__webpack_require__(584);
var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */
var includes = 
/*#__PURE__*/
_curry2(_includes);
module.exports = includes;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var _indexOf = 
/*#__PURE__*/
__webpack_require__(585);
function _includes(a, list) {
    return _indexOf(list, a, 0) >= 0;
}
module.exports = _includes;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var equals = 
/*#__PURE__*/
__webpack_require__(586);
function _indexOf(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === 'function') {
        switch (typeof a) {
            case 'number':
                if (a === 0) {
                    // manually crawl the list to distinguish between +0 and -0
                    inf = 1 / a;
                    while (idx < list.length) {
                        item = list[idx];
                        if (item === 0 && 1 / item === inf) {
                            return idx;
                        }
                        idx += 1;
                    }
                    return -1;
                }
                else if (a !== a) {
                    // NaN
                    while (idx < list.length) {
                        item = list[idx];
                        if (typeof item === 'number' && item !== item) {
                            return idx;
                        }
                        idx += 1;
                    }
                    return -1;
                } // non-zero numbers can utilise Set
                return list.indexOf(a, idx);
            // all these types can utilise Set
            case 'string':
            case 'boolean':
            case 'function':
            case 'undefined':
                return list.indexOf(a, idx);
            case 'object':
                if (a === null) {
                    // null can utilise Set
                    return list.indexOf(a, idx);
                }
        }
    } // anything else not covered above, defer to R.equals
    while (idx < list.length) {
        if (equals(list[idx], a)) {
            return idx;
        }
        idx += 1;
    }
    return -1;
}
module.exports = _indexOf;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = 
/*#__PURE__*/
__webpack_require__(33);
var _equals = 
/*#__PURE__*/
__webpack_require__(587);
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
var equals = 
/*#__PURE__*/
_curry2(function equals(a, b) {
    return _equals(a, b, [], []);
});
module.exports = equals;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var _arrayFromIterator = 
/*#__PURE__*/
__webpack_require__(588);
var _includesWith = 
/*#__PURE__*/
__webpack_require__(589);
var _functionName = 
/*#__PURE__*/
__webpack_require__(590);
var _has = 
/*#__PURE__*/
__webpack_require__(135);
var _objectIs = 
/*#__PURE__*/
__webpack_require__(591);
var keys = 
/*#__PURE__*/
__webpack_require__(183);
var type = 
/*#__PURE__*/
__webpack_require__(592);
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = _arrayFromIterator(aIterator);
    var b = _arrayFromIterator(bIterator);
    function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !_includesWith(function (b, aItem) {
        return !_includesWith(eq, aItem, b);
    }, b, a);
}
function _equals(a, b, stackA, stackB) {
    if (_objectIs(a, b)) {
        return true;
    }
    var typeA = type(a);
    if (typeA !== type(b)) {
        return false;
    }
    if (a == null || b == null) {
        return false;
    }
    if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
        return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
    }
    if (typeof a.equals === 'function' || typeof b.equals === 'function') {
        return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
    }
    switch (typeA) {
        case 'Arguments':
        case 'Array':
        case 'Object':
            if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
                return a === b;
            }
            break;
        case 'Boolean':
        case 'Number':
        case 'String':
            if (!(typeof a === typeof b && _objectIs(a.valueOf(), b.valueOf()))) {
                return false;
            }
            break;
        case 'Date':
            if (!_objectIs(a.valueOf(), b.valueOf())) {
                return false;
            }
            break;
        case 'Error':
            return a.name === b.name && a.message === b.message;
        case 'RegExp':
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
                return false;
            }
            break;
    }
    var idx = stackA.length - 1;
    while (idx >= 0) {
        if (stackA[idx] === a) {
            return stackB[idx] === b;
        }
        idx -= 1;
    }
    switch (typeA) {
        case 'Map':
            if (a.size !== b.size) {
                return false;
            }
            return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
        case 'Set':
            if (a.size !== b.size) {
                return false;
            }
            return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = keys(a);
    if (keysA.length !== keys(b).length) {
        return false;
    }
    var extendedStackA = stackA.concat([a]);
    var extendedStackB = stackB.concat([b]);
    idx = keysA.length - 1;
    while (idx >= 0) {
        var key = keysA[idx];
        if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
            return false;
        }
        idx -= 1;
    }
    return true;
}
module.exports = _equals;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

function _arrayFromIterator(iter) {
    var list = [];
    var next;
    while (!(next = iter.next()).done) {
        list.push(next.value);
    }
    return list;
}
module.exports = _arrayFromIterator;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

function _includesWith(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
        if (pred(x, list[idx])) {
            return true;
        }
        idx += 1;
    }
    return false;
}
module.exports = _includesWith;


/***/ }),
/* 590 */
/***/ (function(module, exports) {

function _functionName(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? '' : match[1];
}
module.exports = _functionName;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs(a, b) {
    // SameValue algorithm
    if (a === b) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return a !== 0 || 1 / a === 1 / b;
    }
    else {
        // Step 6.a: NaN == NaN
        return a !== a && b !== b;
    }
}
module.exports = typeof Object.is === 'function' ? Object.is : _objectIs;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = 
/*#__PURE__*/
__webpack_require__(59);
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */
var type = 
/*#__PURE__*/
_curry1(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
module.exports = type;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// These are all sourced from https://facebook.github.io/react/docs/tags-and-attributes.html -
// all attributes regardless of whether they have a different case to their HTML equivalents are
// listed to reduce the chance of human error and make it easier to just copy-paste the new list if
// it changes.

var HTML_ATTRIBUTES = [
    'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency',
    'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding',
    'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className',
    'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords',
    'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download',
    'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate',
    'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang',
    'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType',
    'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth',
    'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted',
    'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster',
    'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role',
    'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected',
    'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start',
    'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width',
    'wmode', 'wrap', 'onClick',
];
var NON_STANDARD_ATTRIBUTES = [
    'autoCapitalize', 'autoCorrect', 'color', 'itemProp', 'itemScope', 'itemType', 'itemRef',
    'itemID', 'security', 'unselectable', 'results', 'autoSave',
];
var SVG_ATTRIBUTES = [
    'accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic',
    'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth',
    'baseFrequency', 'baseProfile', 'baselineShift', 'bbox', 'begin', 'bias', 'by', 'calcMode',
    'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation',
    'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType',
    'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant',
    'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode',
    'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill',
    'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity',
    'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle',
    'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName',
    'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef',
    'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'ideographic',
    'imageRendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kernelMatrix',
    'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust',
    'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight',
    'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits',
    'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order',
    'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness',
    'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform',
    'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ',
    'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY',
    'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures',
    'restart', 'result', 'rotate', 'rx', 'ry', 'scale', 'seed', 'shapeRendering', 'slope',
    'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset',
    'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity',
    'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray',
    'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity',
    'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY',
    'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1',
    'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange',
    'unitsPerEm', 'vAlphabetic', 'vHanging', 'vIdeographic', 'vMathematical', 'values',
    'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'viewBox',
    'viewTarget', 'visibility', 'widths', 'wordSpacing', 'writingMode', 'x', 'x1', 'x2',
    'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole',
    'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlns', 'xmlnsXlink', 'xmlBase', 'xmlLang',
    'xmlSpace', 'y', 'y1', 'y2', 'yChannelSelector', 'z', 'zoomAndPan',
];
var camelCaseMap = HTML_ATTRIBUTES
    .concat(NON_STANDARD_ATTRIBUTES)
    .concat(SVG_ATTRIBUTES)
    .reduce(function (soFar, attr) {
    var lower = attr.toLowerCase();
    if (lower !== attr) {
        soFar[lower] = attr;
    }
    return soFar;
}, {});
module.exports = camelCaseMap;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _convert=__webpack_require__(6);var _DTable=__webpack_require__(595);var _DTable2=_interopRequireDefault(_DTable);var _DTop=__webpack_require__(596);var _DTop2=_interopRequireDefault(_DTop);var _DPaging=__webpack_require__(597);var _DPaging2=_interopRequireDefault(_DPaging);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DMain=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(DMain,_React$Component);function DMain(){(0,_classCallCheck3.default)(this,DMain);var _this=(0,_possibleConstructorReturn3.default)(this,(DMain.__proto__||(0,_getPrototypeOf2.default)(DMain)).call(this));_this.dref=_react2.default.createRef();return _this;}(0,_createClass3.default)(DMain,[{key:'componentDidMount',value:function componentDidMount(){var node=this.dref.current;DetailUtil.calculateDetailAreaStyle(jQuery(node).parent());}},{key:'render',value:function render(){var _this2=this;var _props=this.props,symbol=_props.symbol,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var groupid=parseInt(symbol.substring(7))-1;var JSComplete=globalStore.JSComplete,commonParam=globalStore.commonParam;var isprint=commonParam.isprint;var dataJson=layoutStore.dataJson,detailMap=layoutStore.detailMap;if(!detailMap.has(symbol)){return _react2.default.createElement('div',null,(0,_convert.getLabel)(514716,"表单中不存在明细表$s，请检查模板配置！").replace("$s",groupid+1));}var detailObj=detailMap.get(symbol);var attr=detailObj.attr,variableMap=detailObj.variableMap;var allowXScroll=attr.allowscroll===1&&isprint!=="1"&&variableMap.get("forceDisabledScrollX")!==true;var detailLayout=dataJson.etables[symbol]||{};var supportLockedCol=allowXScroll&&parseInt(detailLayout.edlockedcol||-1)>-1&&detailLayout.seniorset==="1"&&variableMap.get("forceDisabledLocked")!==true;//存在锁定列，需要解析为左右两部分
var lockedBtnRow=DetailUtil.judgeLockedBtnRow(allowXScroll,detailLayout);var tableDomArr=[];var lockedFlagArr=supportLockedCol?[1,2]:[0];lockedFlagArr.forEach(function(dflag){tableDomArr.push(_react2.default.createElement(_DTable2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_DTable@d7u1di@'+symbol,symbol:symbol,lockedFlag:dflag,allowXScroll:allowXScroll,lockedBtnRow:lockedBtnRow}));});return _react2.default.createElement('div',{ref:this.dref,className:'wf-detail '+(isprint!=="1"?"wf-detail-view":"wf-detail-print")+' wf-detail-'+groupid},lockedBtnRow&&_react2.default.createElement(_DTop2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_DTop@46ealm',symbol:symbol,detailLayout:detailLayout}),_react2.default.createElement('div',{className:'excelDetailTableDiv',id:'dTableArea_'+groupid,'data-groupid':groupid,'data-allowxscroll':allowXScroll,'data-supportLockedCol':supportLockedCol},tableDomArr),_react2.default.createElement(_DPaging2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_DPaging@xn5bs3',symbol:symbol}));}}]);return DMain;}(_react2.default.Component))||_class)||_class);exports.default=DMain;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _LayoutTr=__webpack_require__(187);var _LayoutTr2=_interopRequireDefault(_LayoutTr);var _parseLayout=__webpack_require__(68);var Parse=_interopRequireWildcard(_parseLayout);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DTable=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(DTable,_React$Component);function DTable(){(0,_classCallCheck3.default)(this,DTable);var _this=(0,_possibleConstructorReturn3.default)(this,(DTable.__proto__||(0,_getPrototypeOf2.default)(DTable)).call(this));_this.doScrollXEvent=function(vthis){var symbol=_this.props.symbol;var groupid=parseInt(symbol.substring(7))-1;var detailObj=jQuery("#dTableArea_"+groupid);if(detailObj.find(".excelDetailContent").scrollLeft()>0)detailObj.find(".excelDetailTableArea_locked").addClass("wf-detail-scrollx-fixed");else detailObj.find(".excelDetailTableArea_locked").removeClass("wf-detail-scrollx-fixed");DetailUtil.syncDetailScrollXPosition(groupid);};return _this;}(0,_createClass3.default)(DTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore,symbol=_props.symbol,allowXScroll=_props.allowXScroll,lockedFlag=_props.lockedFlag,lockedBtnRow=_props.lockedBtnRow;var groupid=parseInt(symbol.substring(7))-1;var JSComplete=globalStore.JSComplete,commonParam=globalStore.commonParam,browserVersion=globalStore.browserVersion;var layouttype=commonParam.layouttype,isprint=commonParam.isprint;var dataJson=layoutStore.dataJson,detailMap=layoutStore.detailMap,propFileCfg=layoutStore.propFileCfg;var detailLayout=dataJson.etables[symbol]||{};var headRow=parseInt(detailLayout.edtitleinrow||0);var tailRow=parseInt(detailLayout.edtailinrow||0);if(headRow==0||tailRow==0||tailRow<=headRow){return _react2.default.createElement('div',null,(0,_convert.getLabel)(386148,'对不起，表头标识、表尾标识设置异常，无法渲染明细！'));}var detailObj=detailMap.get(symbol);var detailAttr=detailObj.attr;var printDetailEveryPageHead=isprint=="1"&&detailAttr.isprintthead===1;var isSeniorSet=detailLayout.seniorset==="1";var lockedColumn=parseInt(detailLayout.edlockedcol||-1);var rowattrs=detailLayout.rowattrs,colattrs=detailLayout.colattrs,rowheads=detailLayout.rowheads,ec=detailLayout.ec;var colheads=(0,_extends3.default)({},detailLayout.colheads);if(lockedFlag===1){//冻结区域，只解析部分列
_.forIn(colheads,function(v,k){if(parseInt(k.substring(4))>lockedColumn)delete colheads[k];});}var divStyle=allowXScroll&&lockedFlag!==1?{"overflow-x":browserVersion==="IE9"?"scroll":"auto"}:{};//锁定列情况，隐藏列情况，明细fix住，解决浏览按钮自撑宽度异常
var tableStyle=Parse.judgeDetailContainColHide(colattrs)?{"table-layout":"fixed"}:{};var rowHeads=Parse.convertRowHeads(rowheads);var colHeads=Parse.convertColHeads(colheads,symbol,layouttype,tableStyle,allowXScroll,isSeniorSet,colattrs);var ecMap=Parse.convertEcMap(ec);var buildSerialCol=!isSeniorSet&&(isprint!="1"||detailAttr.isprintserial===1);//解析列宽
var colTdArr=new Array();if(!isSeniorSet)colTdArr.push(_react2.default.createElement('td',{style:{width:allowXScroll?"60px":"6%"}}));colHeads.map(function(o){var colStyle={width:o.width};var colCusAttr=colattrs&&colattrs['col_'+o.id]||{};var colClassName="";if(colCusAttr.hide==="y")colClassName+=" detail_hide_col";if(!!colCusAttr.class)colClassName+=" "+colCusAttr.class;colTdArr.push(_react2.default.createElement('td',{style:colStyle,className:colClassName}));});//解析数据行
var trHeadArr=new Array();//头部行
trHeadArr.push(_react2.default.createElement('tr',{className:'detailControlWidth'},colTdArr));Parse.parseLayoutImage(detailLayout,tableStyle,trHeadArr);//解析背景图、悬浮图,置于头部行
var trDataArr=new Array();//数据行
var trTailArr=new Array();//尾部行
var currentPageRowArr=detailObj.currentPageRowArr,rowInfo=detailObj.rowInfo,currentPageRowMergeInfo=detailObj.currentPageRowMergeInfo;rowHeads.map(function(row){var rowid=parseInt(row.id);var rowCusAttr=rowattrs?rowattrs["row_"+rowid]:null;var addColType=0;var dataRows=tailRow-headRow-1;if(rowid===headRow+1){//明细数据行
if(!isSeniorSet)addColType=3;currentPageRowArr.length>0&&currentPageRowArr.map(function(_info,index){var rowIndex=_info.rowIndex,serialNum=_info.serialNum;var rowAttr=rowInfo.get('row_'+rowIndex);var isLastRow=index===currentPageRowArr.length-1;var detailProps={rowType:2,addColType:addColType,rowIndex:rowIndex,serialNum:serialNum,lockedFlag:lockedFlag,lockedColumn:lockedColumn,needHide:rowAttr.get("needHide"),isLastRow:isLastRow};for(var i=rowid;i<tailRow;i++){//高级模式可多行
var rowCusAttr_tailRow=rowattrs?rowattrs["row_"+i]:null;trDataArr.push(_react2.default.createElement(_LayoutTr2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_LayoutTr@k1jxa4@'+symbol+'_'+i,symbol:symbol,colNum:colHeads.length,rowid:i,rowHeight:(rowheads['row_'+i]||30)+'px',rowCusAttr:rowCusAttr_tailRow,colattrs:colattrs,ecMap:ecMap,detailProps:detailProps,dataRows:dataRows,rowMergeInfo:currentPageRowMergeInfo&&currentPageRowMergeInfo.get('row_'+rowIndex)}));}});}else if(rowid<headRow||isSeniorSet&&rowid>tailRow){//头尾非数据行
if(lockedBtnRow&&rowid===0)return true;if(!isSeniorSet)addColType=rowid===headRow-1?2:1;var detailProps={rowType:rowid<headRow?1:3,addColType:addColType,lockedFlag:lockedFlag,lockedColumn:lockedColumn,lockedBtnRow:lockedBtnRow};var detailTr=_react2.default.createElement(_LayoutTr2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_LayoutTr@df6bc7@'+symbol+'_'+rowid,symbol:symbol,colNum:colHeads.length,rowid:rowid,rowHeight:(rowheads['row_'+rowid]||30)+'px',rowCusAttr:rowCusAttr,colattrs:colattrs,ecMap:ecMap,detailProps:detailProps});if(rowid<headRow)trHeadArr.push(detailTr);else trTailArr.push(detailTr);}});if(!isSeniorSet&&DetailUtil.judgeDetailContainSum(symbol)){//扩充添加合计行
trTailArr.push(_react2.default.createElement(_LayoutTr2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LayoutTr@pdoiz3@'+symbol+'_sumRow',symbol:symbol,colNum:colHeads.length,rowid:headRow-1//合计行样式取字段标签所在行
,rowHeight:'30px',colattrs:colattrs,ecMap:ecMap,detailProps:{addColType:4}}));}var diffClass=lockedFlag===1?"_locked":"";return _react2.default.createElement('div',{className:'excelDetailTableArea'+diffClass},isprint!="1"&&_react2.default.createElement('div',{className:'excelDetailFixedHead'+diffClass},_react2.default.createElement('table',{className:'excelDetailTable',id:'oTable'+groupid+'_head'+diffClass,style:tableStyle},_react2.default.createElement('tbody',null,trHeadArr))),_react2.default.createElement('div',{className:'excelDetailContent'+diffClass,style:divStyle,onScroll:this.doScrollXEvent},_react2.default.createElement('table',{className:'excelDetailTable',id:'oTable'+groupid+diffClass,name:'oTable'+groupid+diffClass,style:tableStyle},printDetailEveryPageHead&&_react2.default.createElement('thead',null,trHeadArr),_react2.default.createElement('tbody',null,printDetailEveryPageHead?[]:trHeadArr,trDataArr,trTailArr))));}}]);return DTable;}(_react2.default.Component))||_class)||_class);exports.default=DTable;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _LayoutTr=__webpack_require__(187);var _LayoutTr2=_interopRequireDefault(_LayoutTr);var _parseLayout=__webpack_require__(68);var Parse=_interopRequireWildcard(_parseLayout);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DTop=(_dec=(0,_mobxReact.inject)('globalStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(DTop,_React$Component);function DTop(){(0,_classCallCheck3.default)(this,DTop);return(0,_possibleConstructorReturn3.default)(this,(DTop.__proto__||(0,_getPrototypeOf2.default)(DTop)).call(this));}(0,_createClass3.default)(DTop,[{key:'render',value:function render(){var _props=this.props,symbol=_props.symbol,detailLayout=_props.detailLayout,globalStore=_props.globalStore;var commonParam=globalStore.commonParam;var layouttype=commonParam.layouttype;var groupid=parseInt(symbol.substring(7))-1;var tableStyle={};var rowattrs=detailLayout.rowattrs,colattrs=detailLayout.colattrs,rowheads=detailLayout.rowheads,ec=detailLayout.ec;var colheads=(0,_extends3.default)({},detailLayout.colheads);var colHeads=Parse.convertColHeads(colheads,symbol,layouttype,tableStyle,false,true,colattrs);var ecMap=Parse.convertEcMap(ec);var rowCusAttr=rowattrs?rowattrs["row_0"]:null;//解析列宽
var colTdArr=new Array();colHeads.map(function(o){var colStyle={width:o.width};var colCusAttr=colattrs&&colattrs['col_'+o.id]||{};var colClassName="";if(colCusAttr.hide==="y")colClassName+=" detail_hide_col";if(!!colCusAttr.class)colClassName+=" "+colCusAttr.class;colTdArr.push(_react2.default.createElement('td',{style:colStyle,className:colClassName}));});//解析数据行
var arr=new Array();//头部行
arr.push(_react2.default.createElement('tr',{className:'detailControlWidth'},colTdArr));arr.push(_react2.default.createElement(_LayoutTr2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LayoutTr@hputw8@'+symbol+'_lockedRow',symbol:symbol,colNum:colHeads.length,rowid:0,rowHeight:(rowheads['row_0']||30)+'px',rowCusAttr:rowCusAttr,colattrs:colattrs,ecMap:ecMap,detailProps:{}}));return _react2.default.createElement('div',{className:'wf-detail-locked-btnrow'},_react2.default.createElement('div',{className:'wf-detail-locked-btnrow-content'},_react2.default.createElement('table',{className:'wf-detail-locked-btnrow-table'},_react2.default.createElement('tbody',null,arr))),_react2.default.createElement('div',{className:'wf-detail-locked-btnrow-placeholder'}));}}]);return DTop;}(_react2.default.Component))||_class)||_class);exports.default=DTop;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _parseLayout=__webpack_require__(68);var Parse=_interopRequireWildcard(_parseLayout);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DPaging=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(DPaging,_React$Component);function DPaging(){(0,_classCallCheck3.default)(this,DPaging);return(0,_possibleConstructorReturn3.default)(this,(DPaging.__proto__||(0,_getPrototypeOf2.default)(DPaging)).call(this));}(0,_createClass3.default)(DPaging,[{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Pagination=_getAntd.Pagination;var _props=this.props,symbol=_props.symbol,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var JSComplete=globalStore.JSComplete;var workflowid=globalStore.commonParam.workflowid;var dataJson=layoutStore.dataJson,detailMap=layoutStore.detailMap;var detailLayout=dataJson.etables[symbol]||{};var headRow=parseInt(detailLayout.edtitleinrow||0);var detailObj=detailMap.get(symbol);var groupid=detailObj.attr.groupid-1;var pagingInfo=detailObj.pagingInfo,rowInfoArr=detailObj.rowInfoArr;var total=rowInfoArr.length;var enabled=pagingInfo.enabled,current=pagingInfo.current,pagesize=pagingInfo.pagesize;if(!enabled)return null;return _react2.default.createElement('div',{className:'wf-detail-paging'},_react2.default.createElement(Pagination,{ecId:(this&&this.props&&this.props.ecId||'')+'_Pagination@4tzss0',symbol:symbol,showSizeChanger:true,showQuickJumper:true,total:total,current:current,showTotal:function showTotal(total){return(0,_convert.getLabel)(385617,"共$s条").replace("$s",total);},pageSize:pagesize,pageSizeOptions:['5','10','20','30','50','100','150','200'],onChange:function onChange(current){detailObj.controlPagingInfo({current:current});DetailUtil.controlDetailPosition(groupid);window.WfForm.triggerAction(window.WfForm.ACTION_SWITCHDETAILPAGING,[groupid],200);},onShowSizeChange:function onShowSizeChange(current,pagesize){var params={workflowid:workflowid,groupid:groupid,pagesize:pagesize};detailObj.changePageSize(params);DetailUtil.controlDetailPosition(groupid);window.WfForm.triggerAction(window.WfForm.ACTION_SWITCHDETAILPAGING,[groupid],200);}}));}}]);return DPaging;}(_react2.default.Component))||_class)||_class);exports.default=DPaging;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _multi=__webpack_require__(599);var _multi2=_interopRequireDefault(_multi);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _convert=__webpack_require__(6);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DetailButton=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(DetailButton,_React$Component);function DetailButton(props){(0,_classCallCheck3.default)(this,DetailButton);var _this=(0,_possibleConstructorReturn3.default)(this,(DetailButton.__proto__||(0,_getPrototypeOf2.default)(DetailButton)).call(this,props));_this.doSapBrowAddRow=function(datas){var symbol=_this.props.symbol;datas&&datas.map(function(addRowData){DetailUtil.addRow(symbol,addRowData,false);});};return _this;}(0,_createClass3.default)(DetailButton,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDropdown=_getEcCom.WeaDropdown;var ButtonSelect=WeaDropdown.ButtonSelect;var _props=this.props,symbol=_props.symbol,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var JSComplete=globalStore.JSComplete,commonParam=globalStore.commonParam;var requestid=commonParam.requestid,workflowid=commonParam.workflowid;var canEdit=parseInt(commonParam.isviewonly||0)!==1&&parseInt(commonParam.isaffirmance||0)!==1;if(!canEdit)return _react2.default.createElement('div',{className:'detailButtonDiv'});var detailMap=layoutStore.detailMap,mainData=layoutStore.mainData;var detailObj=detailMap.get(symbol)||{};var checkedRowArr=DetailUtil.getDetailCheckedRowArr(detailObj);var disabledClassName=checkedRowArr.length>0?"":"detailBtnDisabled";var attr=detailObj.attr,dropBtnKey=detailObj.dropBtnKey;var isadd=attr.isadd,iscopy=attr.iscopy,isdelete=attr.isdelete,isopensapmul=attr.isopensapmul,sapProps=attr.sapProps;var showSap=isopensapmul===1&&!_.isEmpty(sapProps);var dataParams={requestid:requestid,workflowid:workflowid};if(showSap){var fielddbtype=sapProps.fielddbtype,relateFields=sapProps.relateFields,displaySearchAdInBar=sapProps.displaySearchAdInBar,scrollx=sapProps.scrollx,browTitle=sapProps.browTitle,enableSearchValidFirst=sapProps.enableSearchValidFirst;dataParams["fielddbtype"]=fielddbtype;dataParams["displaySearchAdInBar"]=displaySearchAdInBar;dataParams["enableSearchValidFirst"]=enableSearchValidFirst;dataParams["scrollx"]=scrollx;dataParams["browTitle"]=browTitle;relateFields&&relateFields.map(function(fid){var fieldKey='field'+fid;var fieldValue=mainData.has(fieldKey)?mainData.get(fieldKey).value:"";dataParams[fieldKey]=fieldValue;});if(relateFields)dataParams=(0,_extends3.default)({},dataParams,FieldUtil.getRelateFieldShowName(relateFields,-1));}var detailIndex=parseInt(symbol.substring(7))-1;var addBtn=_react2.default.createElement('i',{id:'addbutton'+detailIndex,name:'addbutton'+detailIndex,className:'icon-coms-Add-to-hot detailBtn',title:(0,_convert.getLabel)(611,"添加"),onClick:function onClick(){DetailUtil.addRow(symbol);}});var delBtn=_react2.default.createElement('i',{id:'delbutton'+detailIndex,name:'delbutton'+detailIndex,className:'icon-coms-form-delete-hot detailBtn '+disabledClassName,title:(0,_convert.getLabel)(91,"删除"),onClick:function onClick(){Util.delRow(symbol);}});var copyBtn=_react2.default.createElement('i',{id:'copybutton'+detailIndex,name:'copybutton'+detailIndex,className:'icon-coms-copy-hot detailBtn '+disabledClassName,title:(0,_convert.getLabel)(77,"复制"),onClick:function onClick(){DetailUtil.copyDetailRow(symbol);}});var btns=[];if(showSap)btns.push(_react2.default.createElement(_multi2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSapBrowser@gmr42n@'+symbol,dataParams:dataParams,onChange:this.doSapBrowAddRow}));if(isadd===1){btns.push(addBtn);if(iscopy===1&&isdelete!==1){var dropBtns=[{key:"1",text:(0,_convert.getLabel)(91,"删除"),show:_react2.default.createElement('span',{className:'icon-coms-form-delete-hot detailBtn '+disabledClassName})},{key:"2",text:(0,_convert.getLabel)(77,"复制"),show:_react2.default.createElement('span',{className:'icon-coms-copy-hot detailBtn '+disabledClassName})}];btns.push(_react2.default.createElement(ButtonSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_ButtonSelect@zcycki@'+symbol,type:'small',selectedKey:dropBtnKey.toString(),btnProps:{style:{padding:0,background:'transparent',border:'none',color:'#dadada'}},datas:dropBtns,btnOnClick:function btnOnClick(key){if(key=="1"){Util.delRow(symbol);}else if(key=="2"){DetailUtil.copyDetailRow(symbol);}},menuOnClick:function menuOnClick(key,e){detailObj.setDropBtnKey(parseInt(key));}}));}else{btns.push(delBtn);iscopy===1&&btns.push(copyBtn);}}else if(isdelete===1){btns.push(delBtn);}return _react2.default.createElement('div',{className:'detailButtonDiv'},btns);}}]);return DetailButton;}(_react2.default.Component))||_class)||_class);exports.default=DetailButton;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSapBrowser=function(_React$Component){(0,_inherits3.default)(WeaSapBrowser,_React$Component);function WeaSapBrowser(){(0,_classCallCheck3.default)(this,WeaSapBrowser);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaSapBrowser.__proto__||(0,_getPrototypeOf2.default)(WeaSapBrowser)).call(this));_this.doBrowserChange=function(_ids,_names,_datas){var _this$props=_this.props,dataParams=_this$props.dataParams,onChange=_this$props.onChange;var requestid=dataParams.requestid,fielddbtype=dataParams.fielddbtype;var params={fromNodeorReport:"0",requestid:requestid,fielddbtype:fielddbtype};params["datas"]=(0,_stringify2.default)(_datas);//此接口由SAP模块提供，将浏览按钮选中数据转换为流程识别的数据
var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;WeaTools.callApi('/api/SapIntegration/browser/assignToBill','POST',params).then(function(result){onChange&&onChange(result.datas);});};return _this;}(0,_createClass3.default)(WeaSapBrowser,[{key:'render',value:function render(){var _getEcCom2=(0,_convert.getEcCom)(),WeaBrowser=_getEcCom2.WeaBrowser;var dataParams=this.props.dataParams;console.log(mobx.toJS(dataParams));return _react2.default.createElement(WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@szz87v',type:'227',title:dataParams.browTitle,isSingle:false,isMultCheckbox:true,hasAdvanceSerach:true,sap:true,customized:true,dataParams:dataParams,completeParams:dataParams,conditionDataParams:dataParams,searchParams:{issearch:true},onChange:this.doBrowserChange,displaySearchAdInBar:dataParams.displaySearchAdInBar,enableSearchValidFirst:dataParams.enableSearchValidFirst,scrollx:true,browserModalProps:{hideClear:true}},_react2.default.createElement('i',{className:'icon-workflow-form-sap detailBtn',title:'SAP'}));}}]);return WeaSapBrowser;}(_react2.default.Component);exports.default=WeaSapBrowser;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _CellType=__webpack_require__(136);var _CellType2=_interopRequireDefault(_CellType);var _parseLayout=__webpack_require__(68);var Parse=_interopRequireWildcard(_parseLayout);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var McLayout=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(McLayout,_React$Component);function McLayout(){(0,_classCallCheck3.default)(this,McLayout);return(0,_possibleConstructorReturn3.default)(this,(McLayout.__proto__||(0,_getPrototypeOf2.default)(McLayout)).apply(this,arguments));}(0,_createClass3.default)(McLayout,[{key:'render',value:function render(){var _props=this.props,mcMark=_props.mcMark,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var JSComplete=globalStore.JSComplete;var etables=layoutStore.dataJson.etables||{};var mcLayout=etables[mcMark];if(mcLayout==null)return _react2.default.createElement('div',{style:{display:"none"}},'`Render $',mcMark,' Exception`');var rowcount=mcLayout.rowcount,ec=mcLayout.ec;var ecMap=Parse.convertEcMap(ec);var mcCells=new Array();for(var r=0;r<rowcount;r++){var cellObj=ecMap[r+",0"];if(cellObj){var brObj=ecMap[r+",1"];var needBr=brObj&&brObj.etype==="14"&&brObj.brsign==="Y"&&parseInt(cellObj.etype||0)!=5;var className=mcMark+'_'+r+'_0 span_mc etype_'+cellObj.etype;var mcCellAttr=Parse.getMcCellAttr(cellObj);if(mcCellAttr.cusclass)className+=" "+mcCellAttr.cusclass;if(!needBr)className+=" span_mc_marginRight";var cellAttr=Parse.buildCellAttr(mcCellAttr,className,mcCellAttr.spanStyle);mcCells.push(_react2.default.createElement(_CellType2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_CellType@pka2nh@'+mcMark+'_'+r,symbol:mcMark,cellAttr:cellAttr,cellObj:cellObj}));needBr&&mcCells.push(_react2.default.createElement('br',null));}}return _react2.default.createElement('div',null,mcCells);}}]);return McLayout;}(_react2.default.Component))||_class)||_class);exports.default=McLayout;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _MainLayout=__webpack_require__(133);var _MainLayout2=_interopRequireDefault(_MainLayout);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _formUtil=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TabLayout=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(TabLayout,_React$Component);function TabLayout(){(0,_classCallCheck3.default)(this,TabLayout);return(0,_possibleConstructorReturn3.default)(this,(TabLayout.__proto__||(0,_getPrototypeOf2.default)(TabLayout)).apply(this,arguments));}(0,_createClass3.default)(TabLayout,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,cellMark=_props.cellMark,layoutStore=_props.layoutStore;var cellInfo=layoutStore.cellInfo;var style=cellInfo['main_'+cellMark+'_stylejson'];var tabBar=jQuery(this.refs.tabBar);var tab_head=tabBar.parent();var tab_top=tab_head.parent();var tab_turnleft=tab_top.find(".tab_turnleft");var tab_turnright=tab_top.find(".tab_turnright");var totalWidth=0;var tabTopWidth=tab_top.width();tabBar.children().each(function(){var thisWidth=jQuery(this)[0].getBoundingClientRect().width;if(thisWidth>=tabTopWidth){var className="";if(jQuery(this)[0]&&jQuery(this)[0].className){className=jQuery(this)[0].className;}if(className.includes("t_unsel")){thisWidth=thisWidth+Number(style.unsel_bgrightwidth)+Number(style.unsel_bgleftwidth);}else if(className.includes("t_sel")){thisWidth=thisWidth+Number(style.sel_bgrightwidth)+Number(style.unsel_bgleftwidth);}}totalWidth+=thisWidth;});if(totalWidth>tab_top.width()){tab_top.find(".tab_movebtn").css("display","block");tab_head.width(tab_top.width()-tab_turnleft.width()-tab_turnright.width()-5);tabBar.width(totalWidth+1);}else{tab_top.find(".tab_movebtn").css("display","none");tab_head.width("100%");tabBar.width("100%");}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var showid=this.props.showid;if(showid!==prevProps.showid){//切换了标签显示区域
//window.formImgLazyLoad(jQuery(`div#${showid}_content`));    //执行图片懒加载
window.formImgLazyLoad(jQuery('.wf-req-form-scroll'));DetailUtil.calculateDetailAreaStyle(jQuery("#"+showid+"_content"));window.WfForm.triggerAction(window.WfForm.ACTION_SWITCHTABLAYOUT,[showid]);}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,cellMark=_props2.cellMark,tab=_props2.tab,showid=_props2.showid,globalStore=_props2.globalStore,layoutStore=_props2.layoutStore;var JSComplete=globalStore.JSComplete,_globalStore$commonPa=globalStore.commonParam,commonParam=_globalStore$commonPa===undefined?{}:_globalStore$commonPa;var isprint=commonParam.isprint;var dataJson=layoutStore.dataJson,cellInfo=layoutStore.cellInfo,_layoutStore$propFile=layoutStore.propFileCfg,propFileCfg=_layoutStore$propFile===undefined?{}:_layoutStore$propFile;var print_show_allTabs=propFileCfg.print_show_allTabs;var style=cellInfo['main_'+cellMark+'_stylejson'];if(!style)return _react2.default.createElement('div',null,'Empty TabArea Style');var contentStyle={};var areaheight=tab.areaheight;if(areaheight&&areaheight.indexOf("2,")>-1){//固定高度
contentStyle["height"]=areaheight.split(",")[1]+"px";contentStyle["overflow-y"]="auto";}var tabArr=new Array();_.forIn(tab,function(v,k){if(k.indexOf("order_")===0&&v&&v.indexOf(",")>-1){var arr=v.split(",");tabArr.push({id:arr[0],name:arr[1],order:parseInt(k.substring(6))});}});tabArr=tabArr.sort(function(a,b){return a.order-b.order;});var defShowIndex=parseInt(tab.defshow||0);if(defShowIndex>=tabArr.length)defShowIndex=0;var tabShowSymbol=showid===""?tabArr[defShowIndex].id:showid;var tabHeadBar=new Array();var tabContent=new Array();tabArr.map(function(v,k){var tabid=v.id;//拼标签头部bar
var sel=tabid===tabShowSymbol?"sel":"unsel";var middleStyle={backgroundImage:"url('"+(0,_formUtil.appendDefaultPath)(style[sel+"_bgmiddle"])+"')",fontSize:style[sel+"_fontsize"]+"px",color:style[sel+"_color"],fontFamily:style[sel+"_family"]};if(style&&style[sel+"_bold"]=="1")middleStyle["font-weight"]="bold";if(style&&style[sel+"_italic"]=="1")middleStyle["font-style"]="italic";tabHeadBar.push(_react2.default.createElement('div',{id:tabid,className:"t_"+sel,onClick:_this2.changeTab.bind(_this2,tabid)},_react2.default.createElement('div',{className:"t_"+sel+"_left norepeat",style:{backgroundImage:"url('"+(0,_formUtil.appendDefaultPath)(style[sel+"_bgleft"])+"')",width:style[sel+"_bgleftwidth"]+"px"}}),_react2.default.createElement('div',{className:"t_"+sel+"_middle xrepeat lineheight30",style:middleStyle},_react2.default.createElement('span',{style:{"whiteSpace":"nowrap"}},v.name)),_react2.default.createElement('div',{className:"t_"+sel+"_right norepeat",style:{backgroundImage:"url('"+(0,_formUtil.appendDefaultPath)(style[sel+"_bgright"])+"')",width:style[sel+"_bgrightwidth"]+"px"}})));if(k!==tabArr.length-1){tabHeadBar.push(_react2.default.createElement('div',{className:'t_sep norepeat',style:{width:style.image_sepwidth+"px"}}));}//拼接标签页内容
tabContent.push(_react2.default.createElement('div',{className:'tab_content'+(isprint==1&&print_show_allTabs==1?" print-force-show-tab":""),id:tabid+"_content",style:tabid===tabShowSymbol?{}:{display:"none"}},_react2.default.createElement(_MainLayout2.default,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_MainLayout@7yvwso@'+tabid,symbol:tabid})));});return _react2.default.createElement('div',{className:'tab_area tabarea_'+cellMark},_react2.default.createElement('div',{className:'tab_top'},_react2.default.createElement('div',{className:'tab_movebtn tab_turnleft',style:{display:"none"},onClick:this.turnBar.bind(this,"left")}),_react2.default.createElement('div',{className:'tab_head',style:{width:"100%"}},_react2.default.createElement('div',{className:'t_area xrepeat',ref:'tabBar',style:{backgroundImage:"url("+(0,_formUtil.appendDefaultPath)(style.image_bg)+")",width:"100%"}},tabHeadBar)),_react2.default.createElement('div',{className:'tab_movebtn tab_turnright',style:{display:"none"},onClick:this.turnBar.bind(this,"right")})),_react2.default.createElement('div',{className:'tab_bottom',style:contentStyle},tabContent));}},{key:'changeTab',value:function changeTab(selectedTabId){var _props3=this.props,cellMark=_props3.cellMark,layoutStore=_props3.layoutStore;layoutStore.controlVariableMap('tabarea_'+cellMark+'_showid',selectedTabId);}},{key:'turnBar',value:function turnBar(flag){var tab_head=jQuery(this.refs.tabBar).parent();if(flag==="left")tab_head.scrollLeft(tab_head.scrollLeft()-80);else if(flag==="right")tab_head.scrollLeft(tab_head.scrollLeft()+80);}}]);return TabLayout;}(_react2.default.Component))||_class)||_class);exports.default=TabLayout;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(55);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _SystemElement=__webpack_require__(603);var _SystemElement2=_interopRequireDefault(_SystemElement);var _InputElement=__webpack_require__(610);var _InputElement2=_interopRequireDefault(_InputElement);var _TextareaElement=__webpack_require__(612);var _TextareaElement2=_interopRequireDefault(_TextareaElement);var _BrowserElement=__webpack_require__(616);var _BrowserElement2=_interopRequireDefault(_BrowserElement);var _CheckElement=__webpack_require__(618);var _CheckElement2=_interopRequireDefault(_CheckElement);var _SelectElement=__webpack_require__(619);var _SelectElement2=_interopRequireDefault(_SelectElement);var _FileElement=__webpack_require__(620);var _FileElement2=_interopRequireDefault(_FileElement);var _SpecialElement=__webpack_require__(621);var _SpecialElement2=_interopRequireDefault(_SpecialElement);var _WeaFna=__webpack_require__(622);var _WeaFna2=_interopRequireDefault(_WeaFna);var _LocationElement=__webpack_require__(623);var _LocationElement2=_interopRequireDefault(_LocationElement);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _index=__webpack_require__(626);var _index2=_interopRequireDefault(_index);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _ConflictDisplayPanel=__webpack_require__(627);var _ConflictDisplayPanel2=_interopRequireDefault(_ConflictDisplayPanel);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FileContent=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(FileContent,_React$Component);function FileContent(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,FileContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=FileContent.__proto__||(0,_getPrototypeOf2.default)(FileContent)).call.apply(_ref,[this].concat(args))),_this),_this.handleConflict=function(event,fieldMark){var globalStore=_this.props.globalStore;var conflictFieldMap=globalStore.conflictFieldMap;var fieldData=conflictFieldMap.get(fieldMark)&&conflictFieldMap.get(fieldMark);var pos={posX:event.pageX,posY:event.pageY};var panel=document.getElementById('conflict-panel-box');var str='';if(!panel){panel=document.createElement('div');panel.setAttribute('id','conflict-panel-box');document.body.appendChild(panel);}else{$('#conflict-panel-box').css({visibility:'visible'});}if(fieldData.specialObj){str+=fieldData.specialobj&&fieldData.specialobj[0].name||'';//浏览按钮值拼成文本串
}else{str+=fieldData.value;}ReactDOM.render(_react2.default.createElement(_ConflictDisplayPanel2.default,{clickPos:pos,onOk:_this.onOk.bind(_this,fieldMark),onCancel:_this.onCancel.bind(_this,fieldMark),content:str}),panel);},_this.onOk=function(fieldMark){var globalStore=_this.props.globalStore;var conflictFieldMap=globalStore.conflictFieldMap,changeConflictFieldMap=globalStore.changeConflictFieldMap;var fieldData=conflictFieldMap.get(fieldMark);WfForm.changeFieldValue(fieldMark,fieldData);changeConflictFieldMap((0,_defineProperty3.default)({},fieldMark,(0,_extends3.default)({},fieldData,{hasConfirm:true})));},_this.onCancel=function(fieldMark){var globalStore=_this.props.globalStore;var changeConflictFieldMap=globalStore.changeConflictFieldMap,conflictFieldMap=globalStore.conflictFieldMap;var fieldData=conflictFieldMap.get(fieldMark);changeConflictFieldMap((0,_defineProperty3.default)({},fieldMark,(0,_extends3.default)({},fieldData,{hasConfirm:true})));},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(FileContent,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,symbol=_props.symbol,cellObj=_props.cellObj,isDetail=_props.isDetail,rowIndex=_props.rowIndex,layoutStore=_props.layoutStore;var fieldid=cellObj.field.toString();var fieldMark=isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;layoutStore.initFieldObj(symbol,fieldMark);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,symbol=_props2.symbol,rowIndex=_props2.rowIndex,cellObj=_props2.cellObj;var fieldid=cellObj.field.toString();if(symbol.indexOf("detail_")>-1)DetailUtil.syncLockedRowHeight(fieldid,rowIndex);}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,symbol=_props3.symbol,cellObj=_props3.cellObj,isDetail=_props3.isDetail,rowIndex=_props3.rowIndex,globalStore=_props3.globalStore,layoutStore=_props3.layoutStore;var fieldid=cellObj.field.toString();var JSComplete=globalStore.JSComplete,conflictFieldMap=globalStore.conflictFieldMap;var fieldAttrMap=layoutStore.fieldAttrMap,mainData=layoutStore.mainData,detailMap=layoutStore.detailMap,variableMap=layoutStore.variableMap;var fieldAttr=fieldAttrMap.get(fieldid);var fieldMark=isDetail?'field'+fieldid+'_'+rowIndex:'field'+fieldid;var fontSize=_.get(cellObj,["font","font-size"])||"9pt";var promptRequired=variableMap.get("promptRequiredField")===fieldMark;//是否提示必填
var showError=conflictFieldMap.has(fieldMark)&&!conflictFieldMap.get(fieldMark).hasConfirm;//字段冲突显示提醒
var fieldObj=null;var detailData=null;var rowInfo=null;var detailKeyid=-1;if(isDetail){if(isNaN(rowIndex))return _react2.default.createElement('span',null,'\u65E0\u6548\u8BBE\u7F6E\uFF0C\u660E\u7EC6\u5B57\u6BB5\u9700\u7F6E\u4E8E\u8868\u5934\u8868\u5C3E\u6807\u793A\u4E4B\u95F4\u884C');var detailObj=detailMap.get(symbol);detailData=detailObj.detailData;rowInfo=detailObj.rowInfo.get('row_'+rowIndex);detailKeyid=rowInfo.get("keyid")||0;fieldObj=FieldUtil.getDetailFieldObj(fieldMark,symbol);}else{fieldObj=FieldUtil.getMainFieldObj(fieldMark);}var _fieldObj=fieldObj,value=_fieldObj.value,variable=_fieldObj.variable;var forceRender=variable.has("forceRender")?variable.get("forceRender"):"";//仅为强制render
//计算字段类型(支持动态切换字段类型)
var htmltype=fieldAttr.htmltype||0;var detailtype=fieldAttr.detailtype||0;if(variable.has("changeFieldType")&&variable.get("changeFieldType").indexOf("-")>0){var typeArr=variable.get("changeFieldType").split("-");htmltype=parseInt(typeArr[0]);detailtype=parseInt(typeArr[1]);}//当前字段的只读、必填属性
var viewAttr=FieldUtil.getFieldCurViewAttr(fieldMark,fieldObj);if(viewAttr===-101)return _react2.default.createElement('span',null,'\u6B64\u4E3A\u660E\u7EC6\u5B57\u6BB5\uFF0C\u88AB\u8BC6\u522B\u5728\u4E3B\u5E03\u5C40\u4E2D\uFF0C\u8BF7\u8C03\u6574\u6A21\u677F\u89E3\u51B3');//字段值,特殊字符转换
var fieldValue=FieldUtil.restoreSpeicalChar(fieldid,value.toString(),htmltype,detailtype,viewAttr);//拼接字段组件基础参数
var baseProps={JSComplete:JSComplete,fieldid:fieldid,rowIndex:rowIndex,isDetail:isDetail,viewAttr:viewAttr,detailtype:detailtype};baseProps.value=fieldValue;baseProps.fieldName=fieldMark;baseProps.fieldlabel=fieldAttr.fieldlabel;baseProps.defaultFocus=promptRequired===true;baseProps.style=htmltype===2&&detailtype===2?{}:{"font-size":fontSize};if(htmltype===6){//附件字段特殊处理(标签页切换过程中需要render附件组件)
//const fileVisible = judgeFieldExistVisibleArea(conf, fieldid);
var fileVisible=true;baseProps.display=fileVisible;}//财务模块组件
var fnaInfo=layoutStore.fnaInfo;if(fnaInfo.belFna===true&&_.has(fnaInfo,["fnaCompFields",fieldid])){var fnaParam=_.get(fnaInfo,["fnaCompFields",fieldid]);var baseParam=globalStore.baseParam,commonParam=globalStore.commonParam;var wfInfo=(0,_extends3.default)({},baseParam,{nodetype:commonParam.nodetype});return _react2.default.createElement(_WeaFna2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFna@akicfb',fieldid:fieldid,rowIndex:rowIndex,fnaParam:fnaParam//后台接口封装的财务字段属性
,wfInfo:wfInfo//流程基础信息
,fieldObj:fieldAttr//字段信息
,viewAttr:viewAttr,fieldValue:fieldValue,detailKeyid:detailKeyid});}//判断是否加密组件
if(fieldAttr.encryptFlag>0){return _react2.default.createElement(_index2.default,{value:fieldValue,fieldAttr:fieldAttr,fieldObj:fieldObj});}var elementProps={baseProps:baseProps,fieldMark:fieldMark,fieldAttr:fieldAttr,symbol:symbol,rowIndex:rowIndex,cellObj:cellObj,fieldObj:fieldObj};var proxyProps={fieldid:fieldid,rowIndex:rowIndex,fieldMark:fieldMark,viewAttr:viewAttr,fieldValue:fieldValue,fieldValueObj:fieldObj};var getElement=function getElement(){var el=_react2.default.createElement('span',{className:'default'});if(parseInt(fieldid)<0){//系统字段
el=_react2.default.createElement(_SystemElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_SystemElement@ixouin'},elementProps));}else if(htmltype===1){el=_react2.default.createElement(_InputElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_InputElement@jmkms7'},elementProps));}else if(htmltype===2){el=_react2.default.createElement(_TextareaElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_TextareaElement@xs3gug'},elementProps));}else if(htmltype===3){el=_react2.default.createElement(_BrowserElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_BrowserElement@2mq6lm'},elementProps));}else if(htmltype===4){el=_react2.default.createElement(_CheckElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_CheckElement@oyy2bn'},elementProps));}else if(htmltype===5){el=_react2.default.createElement(_SelectElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_SelectElement@gubx9o'},elementProps));}else if(htmltype===6){el=_react2.default.createElement(_FileElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_FileElement@nkmov4'},elementProps));}else if(htmltype===7){el=_react2.default.createElement(_SpecialElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_SpecialElement@ajooer'},elementProps));}else if(htmltype===8){}else if(htmltype===9){//位置字段
el=_react2.default.createElement(_LocationElement2.default,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_LocationElement@a13n3v'},elementProps));}return el;};var result=[];var proxyCompFn=WfForm.getCustomProxyCompFn('FieldContent_'+fieldid);if(proxyCompFn===null){var proxyComp=WfForm.renderCustomComp(fieldMark,viewAttr,1,elementProps);var afterComp=WfForm.renderCustomComp(fieldMark,viewAttr,2);result.push(proxyComp==null?getElement():proxyComp);if(afterComp!==null)result.push(afterComp);}else{result.push(proxyCompFn(proxyProps,getElement));}var content=_react2.default.createElement(_react2.default.Fragment,null,showError?_react2.default.createElement('div',{className:'show-error'},result):result,JSComplete&&showError&&_react2.default.createElement('div',{className:'error-icon-div',onClick:function onClick(event){event.stopPropagation();_this2.handleConflict(event,fieldMark);}},_react2.default.createElement('i',{className:'icon-coms02-Warning'})));return content;}}]);return FileContent;}(_react2.default.Component))||_class)||_class);exports.default=FileContent;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _index=__webpack_require__(604);var _index2=_interopRequireDefault(_index);var _SecLevelField=__webpack_require__(609);var _SecLevelField2=_interopRequireDefault(_SecLevelField);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SystemElement=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SystemElement,_React$Component);function SystemElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,SystemElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=SystemElement.__proto__||(0,_getPrototypeOf2.default)(SystemElement)).call.apply(_ref,[this].concat(args))),_this),_this.doChangeEvent=function(value){var _this$props=_this.props,globalStore=_this$props.globalStore,layoutStore=_this$props.layoutStore,fieldMark=_this$props.fieldMark,baseProps=_this$props.baseProps;var fieldValue=baseProps.value;layoutStore.changeSingleFieldValue(fieldMark,{value:value});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(SystemElement,[{key:'render',value:function render(){var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore,fieldMark=_props.fieldMark,fieldObj=_props.fieldObj;var baseProps=this.props.baseProps;if(baseProps.fieldid=="-10")//密级字段
return _react2.default.createElement(_SecLevelField2.default,{viewAttr:baseProps.viewAttr});var commonParam=globalStore.commonParam,markInfo=globalStore.markInfo;var containSignInput=layoutStore.containSignInput,propFileCfg=layoutStore.propFileCfg;var _propFileCfg$closeAut=propFileCfg.closeAutoComplete,closeAutoComplete=_propFileCfg$closeAut===undefined?'0':_propFileCfg$closeAut,_propFileCfg$autocomp=propFileCfg.autocomplete_change_name,autocomplete_change_name=_propFileCfg$autocomp===undefined?'0':_propFileCfg$autocomp;var requestType=commonParam.requestType;baseProps.fieldName=FieldUtil.convertSystemFieldName(fieldMark);baseProps.specialobj=fieldObj.specialobj||[];baseProps.closeAutoComplete=closeAutoComplete;baseProps.autocomplete_change_name=autocomplete_change_name;//扩展组件参数
var variable=fieldObj.variable;if(baseProps.viewAttr!==1){//文本类型字段空值显示的默认值
baseProps.emptyShowContent=variable.get("emptyShowContent")||"";}return _react2.default.createElement(_index2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSystemField@tuxsa6',requestType:requestType,markInfo:markInfo,containSignInput:containSignInput,onChange:this.doChangeEvent},baseProps));}}]);return SystemElement;}(_react2.default.Component))||_class)||_class);exports.default=SystemElement;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);__webpack_require__(605);var _convert=__webpack_require__(6);var _index=__webpack_require__(271);var _index2=_interopRequireDefault(_index);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _FormSignInput=__webpack_require__(273);var _FormSignInput2=_interopRequireDefault(_FormSignInput);var _mobx=__webpack_require__(9);var _signUtil=__webpack_require__(58);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.getAutographValue=function(){if(window.saveAutograph){var requestlog=window.saveAutograph(false);_this.setState({AutographValue:requestlog});}};_this.doChangeEvent=function(e){_this.setState({value:e.target.value});_this.props.onChange&&_this.props.onChange(e.target.value);};_this.doChangeValue=function(val){_this.setState({value:val});_this.props.onChange&&_this.props.onChange(val);};_this.doChangeValueEventck=function(){var datas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var ischangeremark=arguments[1];//WfForm.updateRemarkInfo(datas);
if(ischangeremark){var val=datas.remark;_this.setState({value:val});_this.props.onChange&&_this.props.onChange(val);}};var _this$props$markInfo=_this.props.markInfo,markInfo=_this$props$markInfo===undefined?{}:_this$props$markInfo;var _markInfo$workflowReq=markInfo.workflowRequestLogId,workflowRequestLogId=_markInfo$workflowReq===undefined?"":_markInfo$workflowReq;_this.state={value:props.value?props.value:'',AutographValue:workflowRequestLogId};return _this;}(0,_createClass3.default)(main,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,fieldid=_props.fieldid,specialobj=_props.specialobj;if(fieldid==-2)this.setState({leveldata:(0,_mobx.toJS)(specialobj)});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _nextProps$markInfo=nextProps.markInfo,markInfo=_nextProps$markInfo===undefined?{}:_nextProps$markInfo;var _markInfo$workflowReq2=markInfo.workflowRequestLogId,workflowRequestLogId=_markInfo$workflowReq2===undefined?"":_markInfo$workflowReq2;var _props$markInfo=this.props.markInfo,markInfo_last=_props$markInfo===undefined?{}:_props$markInfo;var _markInfo_last$workfl=markInfo_last.workflowRequestLogId,workflowRequestLogId_last=_markInfo_last$workfl===undefined?"":_markInfo_last$workfl;if(this.state.value!==nextProps.value){this.setState({value:nextProps.value});}if(workflowRequestLogId!=workflowRequestLogId_last){this.setState({AutographValue:workflowRequestLogId});}}},{key:'changeRemarkInfo',value:function changeRemarkInfo(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var changeSubmitParam=this.props.changeSubmitParam;changeSubmitParam&&changeSubmitParam(params);}// shouldComponentUpdate(nextProps, nextState) {
//     if (this.props.fieldid == -4) {
//         return !_.isEqual(this.props.markInfo, nextProps.markInfo) ||
//             this.props.requestType !== nextProps.requestType ||
//             this.state.value !== nextState.value ||
//             this.state.value !== nextProps.value;
//     } else {
//         return this.state.value !== nextProps.value ||
//             this.props.viewAttr !== nextProps.viewAttr ||
//             this.props.defaultFocus !== nextProps.defaultFocus;
//     }
// }
/**
     * fieldid 值说明：
     * -1 ： 请求标题
     * -2：  紧急程度
     * -3：  短信提醒
     * -4：  签字意见
     * -5：  微信提醒
     * -9： 打印次数
     */},{key:'render',value:function render(){var _this2=this;var _getAntd=(0,_convert.getAntd)(),Radio=_getAntd.Radio;var _getEcCom=(0,_convert.getEcCom)(),WeaSelect=_getEcCom.WeaSelect;var RadioGroup=Radio.Group;var _state=this.state,value=_state.value,AutographValue=_state.AutographValue;var _props2=this.props,viewAttr=_props2.viewAttr,fieldid=_props2.fieldid,fieldName=_props2.fieldName,_props2$markInfo=_props2.markInfo,markInfo=_props2$markInfo===undefined?{}:_props2$markInfo,requestType=_props2.requestType,defaultFocus=_props2.defaultFocus,containSignInput=_props2.containSignInput,fieldlabel=_props2.fieldlabel,_props2$closeAutoComp=_props2.closeAutoComplete,closeAutoComplete=_props2$closeAutoComp===undefined?'0':_props2$closeAutoComp,_props2$autocomplete_=_props2.autocomplete_change_name,autocomplete_change_name=_props2$autocomplete_===undefined?'0':_props2$autocomplete_,emptyShowContent=_props2.emptyShowContent;var isview=viewAttr===1;var el=void 0;var req="";var remarkDivStyle={};if(fieldid==-1){if(isview){el=React.createElement('span',{dangerouslySetInnerHTML:{__html:value}});}else{return React.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaWfInput@uup5ai',viewAttr:viewAttr,fieldid:'-1',fieldName:fieldName,isDetail:false,detailtype:1,format:{},length:1000,fieldlabel:fieldlabel,defaultFocus:defaultFocus,value:value,style:{'height':'100%','width':'90%'},closeAutoComplete:closeAutoComplete,autocomplete_change_name:autocomplete_change_name,emptyShowContent:emptyShowContent,onChange:this.doChangeValue});}}else if(fieldid==-2){var leveldata=this.state.leveldata;if(isview){var item=leveldata.filter(function(itm){return itm.id==value;});try{el=React.createElement('span',null,item[0].customname);}catch(e){}}else{var radioArr=[];leveldata&&leveldata.map(function(item,index){radioArr.push(React.createElement(Radio,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Radio@ive0mt@'+index,value:item.id},item.customname));});el=React.createElement(RadioGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_RadioGroup@pdngi5',onChange:this.doChangeEvent,value:value},radioArr);}}else if(fieldid==-3){value=value==''?'0':value;var map3={'0':(0,_convert.getLabel)(17583,'不短信提醒'),'1':(0,_convert.getLabel)(17584,'离线短信提醒'),'2':(0,_convert.getLabel)(17585,'在线短信提醒')};if(isview){el=React.createElement('span',null,map3[value]);}else{var _radioArr=[];_.forIn(map3,function(v,k){_radioArr.push(React.createElement(Radio,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Radio@wh3gq9@'+k,value:k},v));});el=React.createElement(RadioGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_RadioGroup@iknvn1',onChange:this.doChangeEvent,value:value},_radioArr);}}else if(fieldid==-4){//签字意见相关
var _markInfo$hasLoadMark=markInfo.hasLoadMarkInfo,hasLoadMarkInfo=_markInfo$hasLoadMark===undefined?false:_markInfo$hasLoadMark,_markInfo$remarkInfo=markInfo.remarkInfo,remarkInfo=_markInfo$remarkInfo===undefined?{}:_markInfo$remarkInfo,_markInfo$isSignMustI=markInfo.isSignMustInput,isSignMustInput=_markInfo$isSignMustI===undefined?'':_markInfo$isSignMustI,_markInfo$signMustInp=markInfo.signMustInputTypes,signMustInputTypes=_markInfo$signMustInp===undefined?[]:_markInfo$signMustInp,_markInfo$isFormSigna=markInfo.isFormSignature,isFormSignature=_markInfo$isFormSigna===undefined?"":_markInfo$isFormSigna;var remarkMustInput=(0,_signUtil.needMustInputDot)();;if(requestType>0&&hasLoadMarkInfo&&containSignInput&&this.props.JSComplete===true){var requiredSpan=void 0;if(remarkMustInput){var _value=value;_value=_value.replace(/&lt;/ig,"<");_value=_value.replace(/&gt;/ig,">");_value=_value.replace(/<br>/ig,"");_value=_value.replace(/<p>/ig,"").replace(/<\/p>/ig,"").replace(/ /ig,"").replace(/&nbsp;/ig,"").replace(/<br \/>/ig,"");req="wf-form-textarea";remarkDivStyle['padding-right']="12px";requiredSpan=React.createElement('span',{className:'wf-textarea-required'},_.trim(_value).length===0&&isFormSignature!=1||isFormSignature==1&&(AutographValue==-3||AutographValue==-2||AutographValue==-1)?React.createElement('img',{src:(window.ecologyContentPath||'')+'/images/BacoError_wev9.png',align:'absmiddle'}):"");}el=[React.createElement(_FormSignInput2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FormSignInput@23odbt@signinput',isInForm:true,key:'_formCellSignInput',onChangeEvent:this.doChangeValueEventck,onAutographBlur:this.getAutographValue}),requiredSpan];}}else if(fieldid==-5){value=value==''?'0':value;var map5={'0':(0,_convert.getLabel)(19782,'不提醒'),'1':(0,_convert.getLabel)(15148,'提醒')};if(isview){el=React.createElement('span',null,map5[value]);}else{var _radioArr2=[];_.forIn(map5,function(v,k){_radioArr2.push(React.createElement(Radio,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Radio@a92u50@'+k,value:k},v));});el=React.createElement(RadioGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_RadioGroup@39gqxc',onChange:this.doChangeEvent,value:value},_radioArr2);}}else if(fieldid==-9){el=React.createElement('span',null,_.trim(value).length===0?"0":value);}return React.createElement('div',{className:'wf-system-field '+req,style:remarkDivStyle},el,React.createElement('input',{type:'hidden',name:fieldName,id:fieldName,value:value}));}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SecLevelField=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SecLevelField,_React$Component);function SecLevelField(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,SecLevelField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=SecLevelField.__proto__||(0,_getPrototypeOf2.default)(SecLevelField)).call.apply(_ref,[this].concat(args))),_this),_this.doChange=function(v){_this.props.layoutStore.changeSingleFieldValue("field-10",{value:v});},_this.getShowOnlyContent=function(){var _this$props=_this.props,viewAttr=_this$props.viewAttr,globalStore=_this$props.globalStore;var _globalStore$secLevel=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel===undefined?{}:_globalStore$secLevel;var _secLevelInfo$secVali=secLevelInfo.secValidityMap,secValidityMap=_secLevelInfo$secVali===undefined?{}:_secLevelInfo$secVali,_secLevelInfo$secVali2=secLevelInfo.secValidityDefaultMap,secValidityDefaultMap=_secLevelInfo$secVali2===undefined?{}:_secLevelInfo$secVali2;var value=secLevelInfo.secLevel||"";var showOnlySecValidity=secValidityMap[value]||"";var content=FieldUtil.getSecLevelName(value);if(value==1||value==2){if(secValidityDefaultMap[value]=="0"){//显示密级和保密期限
content+=''+(showOnlySecValidity?'★':"")+showOnlySecValidity;}else{//仅显示密级
}}return _react2.default.createElement('span',{id:'field-10span'},content);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(SecLevelField,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaSelect=_getEcCom.WeaSelect,WeaInput=_getEcCom.WeaInput;var _props=this.props,viewAttr=_props.viewAttr,globalStore=_props.globalStore;var _globalStore$secLevel2=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel2===undefined?{}:_globalStore$secLevel2,setSecLevelInfo=globalStore.setSecLevelInfo,JSComplete=globalStore.JSComplete;var _secLevelInfo$secVali3=secLevelInfo.secValidityMap,secValidityMap=_secLevelInfo$secVali3===undefined?{}:_secLevelInfo$secVali3,secValidity=secLevelInfo.secValidity;var value=secLevelInfo.secLevel||"";var canEdit=secLevelInfo.canSecChange&&viewAttr>1?3:1;if(canEdit===1)return this.getShowOnlyContent();var showSecValidity=value==2||value==1;var options=[];var fieldObj=FieldUtil.getMainFieldObj("field-10");var variable=fieldObj.variable;var optionRange=variable.has("optionRange")?variable.get("optionRange"):null;var filterOptionRange=variable.has("filterOptionRange")?variable.get("filterOptionRange"):null;var itemList=(0,_mobx.toJS)(secLevelInfo.secLevelOption);itemList&&itemList.map(function(item){if(optionRange!==null&&_.indexOf(optionRange,item.key)===-1)//选择框联动控制范围
return true;if(filterOptionRange!==null&&_.indexOf(filterOptionRange,item.key)>-1)//接口控制remove选项
return true;options.push(item);});if(options&&options.length>0&&options.filter(function(o){return o.key==value;}).length==0&&value!==""){value="";this.doChange("");}return _react2.default.createElement(_react.Fragment,null,_react2.default.createElement(WeaSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@gt5c9l',viewAttr:canEdit,onChange:this.doChange,options:options,value:value,style:{minWidth:"60px",marginRight:showSecValidity?"10px":""}}),showSecValidity&&WeaInput&&_react2.default.createElement(WeaInput,{helpfulTip:(0,_convert.getLabel)(528340,"保密期限填写格式：3个月、10年、20年、长期…不能是纯数字"),helpfulTipProps:{style:{right:"-34px",position:"absolute",top:"8px"}},placeholder:(0,_convert.getLabel)(530018,"请输入保密期限"),id:'field-10',style:{width:"100px"},value:secValidity,viewAttr:canEdit,onChange:function onChange(val){setSecLevelInfo({secValidity:val});secValidityMap[value]=val;}}));}}]);return SecLevelField;}(_react2.default.Component))||_class)||_class);exports.default=SecLevelField;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _CodeElement=__webpack_require__(611);var _CodeElement2=_interopRequireDefault(_CodeElement);var _index=__webpack_require__(271);var _index2=_interopRequireDefault(_index);var _formUtil=__webpack_require__(11);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InputElement=(_dec=(0,_mobxReact.inject)('layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(InputElement,_React$Component);function InputElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,InputElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=InputElement.__proto__||(0,_getPrototypeOf2.default)(InputElement)).call.apply(_ref,[this].concat(args))),_this),_this.doChangeEvent=function(value){var _this$props=_this.props,layoutStore=_this$props.layoutStore,fieldMark=_this$props.fieldMark;layoutStore.changeSingleFieldValue(fieldMark,{value:value});},_this.doDisablePromptEvent=function(){var fieldMark=_this.props.fieldMark;(0,_formUtil.showPrompt)(fieldMark,2);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(InputElement,[{key:'render',value:function render(){var _props=this.props,layoutStore=_props.layoutStore,fieldMark=_props.fieldMark,fieldAttr=_props.fieldAttr,symbol=_props.symbol,rowIndex=_props.rowIndex,cellObj=_props.cellObj,fieldObj=_props.fieldObj;var baseProps=this.props.baseProps;var variable=fieldObj.variable;var specialobj=fieldObj.specialobj?mobx.toJS(fieldObj.specialobj):{};var fieldid=baseProps.fieldid;//判断是否为流程编号
var codeInfo=layoutStore.codeInfo,linkageCfg=layoutStore.linkageCfg,_layoutStore$propFile=layoutStore.propFileCfg,propFileCfg=_layoutStore$propFile===undefined?{}:_layoutStore$propFile;var closeAutoComplete=propFileCfg.closeAutoComplete,_propFileCfg$autocomp=propFileCfg.autocomplete_change_name,autocomplete_change_name=_propFileCfg$autocomp===undefined?'0':_propFileCfg$autocomp;var isUse=codeInfo.isUse,fieldCode=codeInfo.fieldCode;if(isUse&&fieldCode===fieldid){return _react2.default.createElement(_CodeElement2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_CodeElement@2bygal'},this.props));}//扩展组件参数
if(baseProps.viewAttr!==1){//文本类型字段空值显示的默认值
baseProps.emptyShowContent=variable.get("emptyShowContent")||"";}if("showhtml"in specialobj){baseProps.showhtml=specialobj.showhtml;//文本显示值
}var qfws=fieldAttr.qfws,length=fieldAttr.length,detailtype=fieldAttr.detailtype;var format=cellObj.format||{};var transtype=parseInt(_.get(linkageCfg,["transTypeCfg",fieldid])||0);//字段赋值转格式，模拟用格式化实现
var enableInput=!this.judgeBelRowCalAssignField();//判断当前字段是否为行规则计算赋值字段，不允许修改
if(transtype===1){//转金额大写
format={numberType:101};}else if(transtype===2){//转金额千分位，模拟数值格式化
format={numberType:2,decimals:qfws,formatPattern:2,thousands:1};}if("financial"in cellObj){//财务格式优先级最高
var financial=cellObj.financial||"";if(financial.indexOf("2-")>-1){var finaNum=parseInt(financial.split("-")[1]||"3");format={numberType:100,finaNum:finaNum};}else if(financial==="3"){//转金额大写
format={numberType:101};}else if(financial==="4"){//转金额千分位，模拟数值格式化两位
if(detailtype==1){format={numberType:2,decimals:2,formatPattern:2,thousands:1};}else{format={numberType:2,decimals:qfws,formatPattern:2,thousands:1};}}}return _react2.default.createElement(_index2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaWfInput@kl6eki',length:length,qfws:qfws,onChange:this.doChangeEvent,format:format,enableInput:enableInput,onDisablePrompt:this.doDisablePromptEvent},baseProps,{closeAutoComplete:closeAutoComplete,autocomplete_change_name:autocomplete_change_name}));}//判断字段是否属于明细行规则赋值字段
},{key:'judgeBelRowCalAssignField',value:function judgeBelRowCalAssignField(){var _props2=this.props,layoutStore=_props2.layoutStore,baseProps=_props2.baseProps,fieldAttr=_props2.fieldAttr;var linkageCfg=layoutStore.linkageCfg,cellInfo=layoutStore.cellInfo;var fieldid=baseProps.fieldid;if(!baseProps.isDetail||!_.has(linkageCfg,["rowCalCfg","rowCalAssignInfo",fieldid]))return false;var isValid=true;_.get(linkageCfg,["rowCalCfg","rowCalAssignInfo",fieldid]).map(function(id){if(!_.has(cellInfo,["fieldCellInfo",id])||fieldAttr.viewattr<=0)isValid=false;//取值字段不在模板上认为是无效行规则
});return isValid;}}]);return InputElement;}(_react2.default.Component))||_class)||_class);exports.default=InputElement;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _formUtil=__webpack_require__(11);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}//流程编号
var WeaWfCode=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(WeaWfCode,_React$Component);function WeaWfCode(props){(0,_classCallCheck3.default)(this,WeaWfCode);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaWfCode.__proto__||(0,_getPrototypeOf2.default)(WeaWfCode)).call(this,props));_this.doChangeEvent=function(e){var value=e.target.value;var _this$props=_this.props,layoutStore=_this$props.layoutStore,fieldMark=_this$props.fieldMark;layoutStore.changeSingleFieldValue(fieldMark,{value:value});};_this.generateCode=function(){var _this$props2=_this.props,layoutStore=_this$props2.layoutStore,fieldMark=_this$props2.fieldMark;var canSaveFlag=_this.state.canSaveFlag;var params=_this.getRelateParams();params.operation="CreateCodeAgain";if(!canSaveFlag)return;_this.setState({canSaveFlag:false});API_REQ.createWfCode(params).then(function(data){var codeValue=data.wfcode;layoutStore.changeSingleFieldValue(fieldMark,{value:codeValue});_this.syncTitleRequestMark(codeValue);_this.setState({canSaveFlag:true});});};_this.changeCode=function(e){var fieldMark=_this.props.fieldMark;var value=e.target.value;var params=_this.getRelateParams();params.operation="ChangeCode";params.returnCodeStr=value;API_REQ.createWfCode(params).then(function(data){var codeValue=data.wfcode;_this.syncTitleRequestMark(codeValue);});};_this.chooseReservedCode=function(){var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;var _this$props3=_this.props,layoutStore=_this$props3.layoutStore,fieldMark=_this$props3.fieldMark;var canChoiceFlag=_this.state.canChoiceFlag;var params=_this.getRelateParams();var workflowid=params.workflowid,formid=params.formid,isbill=params.isbill;if(!canChoiceFlag)return;_this.setState({canChoiceFlag:false});API_REQ.loadWfCodeFieldValueInfo(params).then(function(data){var chooseParams=(0,_extends3.default)({},data,{isRoute:true,isFromForm:1,workflowId:workflowid});var url=(window.ecologyContentPath||'')+'/spa/workflow/static4engine/engine.html#/main/workflowengine/path/codeMaintenance/reserveCode?'+(0,_formUtil.buildUrlStr)(chooseParams);var dialog=WeaTools.createDialog({title:(0,_convert.getLabel)(22785,'选择预留号'),moduleName:"workflow",url:url,style:{width:800,height:600},callback:function callback(con){params.codeSeqReservedIdAndCode=con.id+"~~wfcodecon~~"+con.reservedCode;params.operation="chooseReservedCode";API_REQ.createWfCode(params).then(function(data){var codeValue=data.wfcode;layoutStore.changeSingleFieldValue(fieldMark,{value:codeValue});_this.syncTitleRequestMark(codeValue);});},onCancel:function onCancel(){}});dialog.show();_this.setState({canChoiceFlag:true});});};_this.newReservedCode=function(){var _getEcCom2=(0,_convert.getEcCom)(),WeaTools=_getEcCom2.WeaTools;var fieldMark=_this.props.fieldMark;var canAddFlag=_this.state.canAddFlag;var params=_this.getRelateParams();var workflowid=params.workflowid,formid=params.formid,isbill=params.isbill;if(!canAddFlag)return;_this.setState({canAddFlag:false});API_REQ.loadWfCodeFieldValueInfo(params).then(function(data){var createParams=(0,_extends3.default)({},params,data,{isRoute:true,isFromForm:1,workflowId:workflowid});var url=(window.ecologyContentPath||'')+'/spa/workflow/static4engine/engine.html#/main/workflowengine/path/codeMaintenance/addReserveCode?'+(0,_formUtil.buildUrlStr)(createParams);var dialog=WeaTools.createDialog({title:(0,_convert.getLabel)(22783,'新建预留号'),moduleName:"workflow",url:url,style:{width:600,height:600},callback:function callback(datas){},onCancel:function onCancel(){}});dialog.show();_this.setState({canAddFlag:true});});};_this.state={canSaveFlag:true,canChoiceFlag:true,canAddFlag:true};return _this;}(0,_createClass3.default)(WeaWfCode,[{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var commonParam=globalStore.commonParam,urlParams=globalStore.urlParams;var iscreate=commonParam.iscreate;var codeInfo=layoutStore.codeInfo;var codefields=codeInfo.codefields,hasHistoryCode=codeInfo.hasHistoryCode;var _props2=this.props,fieldMark=_props2.fieldMark,fieldAttr=_props2.fieldAttr,symbol=_props2.symbol,fieldObj=_props2.fieldObj;var baseProps=this.props.baseProps;var value=baseProps.value,viewAttr=baseProps.viewAttr;var isShowBtn=!hasHistoryCode&&iscreate!="1"&&!commonParam.belongTest&&urlParams.isPreView!=="1";if(viewAttr===1){return _react2.default.createElement('span',null,_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:value}}),_react2.default.createElement('input',{type:'hidden',id:fieldMark,name:fieldMark,value:value}));}else{var isRequired=viewAttr===3&&_.trim(value).length===0;var minWidth=isShowBtn?"250px":"60px";return _react2.default.createElement('div',{className:'wf-code wf-form-input'},_react2.default.createElement('input',{className:'wf-input wf-input-main',style:{minWidth:minWidth},value:value,type:'text',onChange:this.doChangeEvent,onBlur:this.changeCode}),_react2.default.createElement('span',{id:fieldMark+'span',className:'wf-input-required'},isRequired?_react2.default.createElement('img',{src:(window.ecologyContentPath||'')+'/images/BacoError_wev9.png',align:'absmiddle'}):""),isShowBtn&&_react2.default.createElement('div',{style:{marginTop:"5px"}},_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@xt2czr',size:'small',onClick:this.generateCode},(0,_convert.getLabel)(22784,'重新生成编号')),_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@d2xasp',size:'small',onClick:this.chooseReservedCode},(0,_convert.getLabel)(22785,'选择预留号')),_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@jidk5r',size:'small',onClick:this.newReservedCode},(0,_convert.getLabel)(22783,'新建预留号'))),_react2.default.createElement('input',{type:'hidden',id:fieldMark,name:fieldMark,value:value}));}}},{key:'getRelateParams',value:function getRelateParams(){var _props3=this.props,globalStore=_props3.globalStore,layoutStore=_props3.layoutStore;var codeInfo=layoutStore.codeInfo;var codefields=codeInfo.codefields;var baseParam=globalStore.baseParam,commonParam=globalStore.commonParam;var params=(0,_extends3.default)({},baseParam,{creater:commonParam.creater,creatertype:commonParam.creatertype});codefields&&codefields.map(function(field){var fieldid=''+field.split("_")[0];params["field"+fieldid]=FieldUtil.getRelateFieldValue(fieldid,-1);});return params;}},{key:'syncTitleRequestMark',value:function syncTitleRequestMark(mark){jQuery("#requestmarkSpan").text(mark);}}]);return WeaWfCode;}(_react2.default.Component))||_class)||_class);exports.default=WeaWfCode;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _index=__webpack_require__(613);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TextareaElement=(_dec=(0,_mobxReact.inject)('layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(TextareaElement,_React$Component);function TextareaElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,TextareaElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=TextareaElement.__proto__||(0,_getPrototypeOf2.default)(TextareaElement)).call.apply(_ref,[this].concat(args))),_this),_this.doChangeEvent=function(value){var _this$props=_this.props,layoutStore=_this$props.layoutStore,fieldMark=_this$props.fieldMark;layoutStore.changeSingleFieldValue(fieldMark,{value:value});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(TextareaElement,[{key:'render',value:function render(){var _props=this.props,fieldMark=_props.fieldMark,fieldAttr=_props.fieldAttr,symbol=_props.symbol,rowIndex=_props.rowIndex,cellObj=_props.cellObj,fieldObj=_props.fieldObj;var baseProps=this.props.baseProps;var variable=fieldObj.variable;if(baseProps.viewAttr!==1){//可编辑空值显示的默认值
baseProps.emptyShowContent=variable.get("emptyShowContent")||"";}var textheight="textheight"in fieldAttr?fieldAttr.textheight:4;var length="length"in fieldAttr?fieldAttr.length:4000;var fielddbtype=fieldAttr.fielddbtype;return _react2.default.createElement(_index2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTextarea@c5kpha',textheight:textheight,length:length,fielddbtype:fielddbtype,onChange:this.doChangeEvent},baseProps));}}]);return TextareaElement;}(_react2.default.Component))||_class)||_class);exports.default=TextareaElement;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;__webpack_require__(614);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _WfRichText=__webpack_require__(615);var _WfRichText2=_interopRequireDefault(_WfRichText);var _inputUtil=__webpack_require__(81);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=(_temp=_class=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.doFocusEvent=function(e){_this.setState({isonfocus:true});};_this.doBlurEvent=function(e){_this.setState({isonfocus:false});_this.props.onChange&&_this.props.onChange(e.target.value);};_this.doKeyDown=function(e){e.stopPropagation();//阻止冒泡，form有keyDowm事件禁止enter键
};_this.setTextAreaValue=function(e){var _this$props=_this.props,fieldlabel=_this$props.fieldlabel,fielddbtype=_this$props.fielddbtype;var value=e.target.value;//text 不限制长度
if('text'!==fielddbtype&&'clob'!==fielddbtype){var valLen=(0,_inputUtil.realLength)(value);var length=4000;var specialChar=value.match(/\"| /ig);if(specialChar)length=length-specialChar.length*5;//后台转译成6个字符
specialChar=value.match(/&|<|>|\n/ig);if(specialChar)//后台转译成4个字符
length=length-specialChar.length*3;if(length&&valLen>length){var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;message.warning(''+fieldlabel+(0,_convert.getLabel)(386376,'字段值长度不能超过4000')+'('+(0,_convert.getLabel)(124962,'1个中文字符等于3个长度')+')');value=(0,_inputUtil.checkLength)(value,valLen,length);}}_this.setState({value:value});};_this.doRichTextChangeEvent=function(value){_this.setState({value:value});_this.props.onChange&&_this.props.onChange(value);};_this.state={value:props.value?props.value:"",isonfocus:false};return _this;}(0,_createClass3.default)(main,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.value!==nextProps.value){this.setState({value:nextProps.value});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(this.props.defaultFocus&&this.props.defaultFocus!==nextProps.defaultFocus)//延时失去焦点时不渲染组件
return false;return nextProps.value!==this.props.value||nextProps.viewAttr!==this.props.viewAttr||nextProps.JSComplete!==this.props.JSComplete||this.state.value!==nextState.value||this.state.isonfocus!==nextState.isonfocus||nextProps.defaultFocus!==this.props.defaultFocus||nextProps.emptyShowContent!==this.props.emptyShowContent;}},{key:'componentDidUpdate',value:function componentDidUpdate(){var value=this.state.value;var _props=this.props,defaultFocus=_props.defaultFocus,detailtype=_props.detailtype,viewAttr=_props.viewAttr,fieldName=_props.fieldName;if(defaultFocus&&viewAttr===3){if(detailtype==2){this.refs[fieldName]&&this.refs[fieldName].ckfocus();}else{//存在=0情况作为多行文本处理
var input=this.refs.inputEle.refs.input;if(input!=document.activeElement){input.focus();var index=(0,_common.trim)(value).length;input.setSelectionRange(index,index);//光标定位到最后
}}}}},{key:'render',value:function render(){var _getAntd2=(0,_convert.getAntd)(),Input=_getAntd2.Input,message=_getAntd2.message;var _state=this.state,_state$value=_state.value,value=_state$value===undefined?"":_state$value,isonfocus=_state.isonfocus;var _props2=this.props,viewAttr=_props2.viewAttr,fieldid=_props2.fieldid,detailtype=_props2.detailtype,textheight=_props2.textheight,length=_props2.length,fieldName=_props2.fieldName,style=_props2.style;var newStyle=(0,_extends3.default)({},style);var emptyShowContent=this.props.emptyShowContent;if(viewAttr===2||viewAttr===3)newStyle.paddingRight="12px";var styleInfo={'word-break':'break-all','word-wrap':'break-word','width':'100%'};var requiredSpan=null;if(viewAttr!==1){var _value=value.replace(/<p>/ig,'').replace(/<\/p>/ig,'').replace(/ /ig,"").replace(/&nbsp;/ig,"").replace(/<br \/>/ig,"");var isRequired=viewAttr===3&&(0,_common.trim)(_value).length===0;requiredSpan=React.createElement('span',{id:fieldName+'span',className:'wf-textarea-required'},isRequired?React.createElement('img',{src:(window.ecologyContentPath||'')+'/images/BacoError_wev9.png',align:'absmiddle'}):"");}if(detailtype===2){var needRenderCK=viewAttr>1||!!(window.FORM_CK_REF&&window.FORM_CK_REF['field'+fieldid]);return React.createElement('div',{className:'wf-form-textarea',style:newStyle},viewAttr===1&&React.createElement('div',{className:'wf-form-textarea-html-show',ref:'htmlShowDiv',style:{overflowX:"auto",overflowY:"hidden",maxWidth:"calc(100% - 4px)"},dangerouslySetInnerHTML:{__html:value}}),needRenderCK&&React.createElement('div',{style:{"display":viewAttr>1?"block":"none"},className:'wea-wf-richtext-div'},React.createElement(_WfRichText2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfRichText@d94ueo',placeholder:emptyShowContent,editorId:fieldName,value:value,ref:fieldName,textheight:textheight,onChange:this.doRichTextChangeEvent})),requiredSpan);}else{if(viewAttr===1){return React.createElement('span',{className:'wf-form-textarea'},React.createElement('span',{style:newStyle,id:fieldName+"span",dangerouslySetInnerHTML:{__html:value}}),React.createElement('input',{type:'hidden',id:fieldName,name:fieldName,value:value}));}else{//支持可编辑无值时显示灰色默认值
emptyShowContent=emptyShowContent||"";if(!isonfocus&&emptyShowContent!==""&&value===""){styleInfo["color"]="#A5A5A5";// if(Util.getBrowserVersion() === "IE9"){
value=emptyShowContent;// }
}else{styleInfo["color"]="";}return React.createElement('div',{className:'wf-form-textarea',style:newStyle},React.createElement(Input,{ecId:(this&&this.props&&this.props.ecId||'')+'_Input@rulaza',ref:'inputEle',type:'textarea',value:value// placeholder={emptyShowContent}
,id:fieldName,name:fieldName,rows:textheight,className:'wf-form-textarea-'+fieldid,style:styleInfo,onFocus:this.doFocusEvent,onBlur:this.doBlurEvent,onKeyDown:this.doKeyDown,onChange:this.setTextAreaValue}),requiredSpan);}}}}]);return main;}(React.Component),_class.defaultProps={detailtype:1,style:{},viewAttr:2},_temp);exports.default=main;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.doOnChangeEvent=function(value){_this.props.onChange&&_this.props.onChange(value);};_this.buttonBtnChange=function(){var name=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var ids=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var list=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var type=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var editorId=_this.props.editorId;var html=[];if(name==='Upload'){if(type==='image'){list.map(function(item){var imglink='/weaver/weaver.file.FileDownload?fileid='+item.fileidCode;html.push('<img src=\''+imglink+'\' />&#8203;');});}}return html.join('');};_this.doStatusChange=function(status){if(status==="ready"){var editorId=_this.props.editorId;window.FORM_CK_REF[editorId]=_this.refs[editorId];}};if(!window.FORM_CK_REF){window.FORM_CK_REF={};}return _this;}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaRichText=_getEcCom.WeaRichText;var _props=this.props,editorId=_props.editorId,_props$ls=_props.ls,ls=_props$ls===undefined?false:_props$ls,_props$extentsConfig=_props.extentsConfig,extentsConfig=_props$extentsConfig===undefined?[]:_props$extentsConfig,value=_props.value,_props$textheight=_props.textheight,textheight=_props$textheight===undefined?4:_props$textheight,_props$placeholder=_props.placeholder,placeholder=_props$placeholder===undefined?"":_props$placeholder;var ckConfig={};ckConfig.toolbar=[['Source','-','Bold','Italic','Underline','Strike','-','Format','Font','FontSize','lineheight','TextColor','BGColor','-','NumberedList','BulletedList','-','Outdent','Indent','-','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','-','Link','Unlink','-','Table','-','Iframe','HorizontalRule','SpecialChar','-','CopyFormatting','RemoveFormat','PasteText','Undo','Redo','Maximize','Image']];//		 	            { name: 'document', items: [ 'Source'] },
//		 	            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', ] },
//		 	            { name: 'styles', items: [ 'Format','Font', 'FontSize' ] },
//		 	            { name: 'colors', items: [ 'TextColor','BGColor' ] },
//		 	            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent','-','JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
//		 	            { name: 'links', items: [ 'Link', 'Unlink' ] },
//						{ name: 'tools', items: [ 'Maximize' ] },
//		 	            { name: 'insert', items: [ 'Table', '-','Iframe','HorizontalRule','SpecialChar','-','CopyFormatting', 'RemoveFormat','PasteText'] },
//		 	            { name: 'clipboard' ,items:['Undo', 'Redo']}
//		ckConfig.toolbar = [
//			            { name: 'all', items: [ 'Source','-',
//												'Bold', 'Italic', 'Underline', 'Strike','-',
//												'Format','Font', 'FontSize','-',
//												'TextColor','BGColor' ,'-',
//												'NumberedList', 'BulletedList', '-',
//												'Outdent', 'Indent','-',
//												'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-',
//												'Link', 'Unlink' ,'-',
//												'Image', 'Table', '-',
//												'Iframe','HorizontalRule','SpecialChar','-',
//												'CopyFormatting', 'RemoveFormat','PasteText','-',
//												'Undo', 'Redo']},
//			        ];
// ckConfig.extraPlugins = 'autoautogrow';
ckConfig.height=40*textheight;// ckConfig['autoGrow_maxHeight'] = 40 * textheight;
ckConfig.removePlugins='resize';ckConfig.uploadUrl='/api/doc/upload/uploadFile';ckConfig.fontSize_defaultLabel='12';// ckConfig.font_names = '仿宋_GB2312/FangSong_GB2312;宋体/SimSun;微软雅黑/Microsoft YaHei;楷体/KaiTi;黑体/SimHei;Arial/Arial, Helvetica, sans-serif;新宋体/NSimSun;楷体_GB2312/KaiTi_GB2312;';
ckConfig.font_defaultLabel='微软雅黑';// ckConfig.fontSize_sizes = '8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;48/48px;72/72px';
ckConfig.startupFocus=false;ckConfig.placeholder=placeholder;var ckprops={id:editorId,ref:editorId,ls:ls,ckConfig:ckConfig,value:value,scrollContainer:'.wea-new-top-req-content',placeholder:placeholder};return React.createElement(WeaRichText,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRichText@7gavv2'},ckprops,{onBlur:this.doOnChangeEvent,onToolsChange:this.buttonBtnChange,onStatusChange:this.doStatusChange}));}},{key:'ckfocus',value:function ckfocus(){var editorId=this.props.editorId;this.refs[editorId].getEditor().focus();}}]);return Main;}(React.Component);exports.default=Main;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _single=__webpack_require__(617);var _single2=_interopRequireDefault(_single);var _objectAssign=__webpack_require__(88);var _objectAssign2=_interopRequireDefault(_objectAssign);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _invoiceUtil=__webpack_require__(132);var _otherModule=__webpack_require__(274);var OtherModule=_interopRequireWildcard(_otherModule);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BrowserElement=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BrowserElement,_React$Component);function BrowserElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,BrowserElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=BrowserElement.__proto__||(0,_getPrototypeOf2.default)(BrowserElement)).call.apply(_ref,[this].concat(args))),_this),_this.doChangeEvent=function(value){var _this$props=_this.props,fieldMark=_this$props.fieldMark,layoutStore=_this$props.layoutStore;layoutStore.changeSingleFieldValue(fieldMark,{value:value});},_this.doBrowChangeEvent=function(ids,names,datas){var valueInfo={value:ids||'',specialobj:datas||[]};var _this$props2=_this.props,fieldMark=_this$props2.fieldMark,rowIndex=_this$props2.rowIndex,fieldAttr=_this$props2.fieldAttr,baseProps=_this$props2.baseProps,layoutStore=_this$props2.layoutStore;var fieldid=baseProps.fieldid,isDetail=baseProps.isDetail,detailtype=baseProps.detailtype;var variable={};if(detailtype===141){//人力资源条件值转换
valueInfo.value=FieldUtil.spellResourceCondition(datas);}layoutStore.changeSingleFieldValue(fieldMark,valueInfo,variable);//触发浏览按钮变更事件
Util.doDefinitionCallBackFun(fieldid,rowIndex,ids,datas,fieldAttr);},_this.beforeCheck=function(success,fail){var _this$props3=_this.props,baseProps=_this$props3.baseProps,layoutStore=_this$props3.layoutStore;var _this$props$globalSto=_this.props.globalStore.secLevelInfo,secLevelInfo=_this$props$globalSto===undefined?{}:_this$props$globalSto;var secLevel=secLevelInfo.secLevel,isOpenSec=secLevelInfo.isOpenSec;var fieldid=baseProps.fieldid,detailtype=baseProps.detailtype;var odocInfo=layoutStore.odocInfo;if(detailtype===9&&"docFieldId"in odocInfo&&odocInfo.docFieldId.toString()===fieldid){if(window.oDocUtil.haveSecretLevel){if(window.oDocUtil.haveSecretLevel()){success();}}else{success();}}else if(isOpenSec&&(detailtype==9||detailtype==37||detailtype==16||detailtype==152||detailtype==171)){var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;if(secLevel==""){message.error(secLevelInfo.tip,3);}else{success();}}else{success();}},_this.doSapBrowChangeEvent=function(datas){var fieldMark=_this.props.fieldMark;var clearObj={};clearObj[fieldMark]={value:"",specialobj:[]};var changeDatas=_.isEmpty(datas)?clearObj:{};datas&&datas.map(function(item){changeDatas=(0,_extends3.default)({},changeDatas,item);});_this.props.layoutStore.changeMoreFieldData(changeDatas);},_this.onBrowerClick=function(){var _this$props4=_this.props,fieldMark=_this$props4.fieldMark,baseProps=_this$props4.baseProps;var value=baseProps.value;var _this$props$globalSto2=_this.props.globalStore.invoiceCloudInfo,invoiceCloudInfo=_this$props$globalSto2===undefined?{}:_this$props$globalSto2;if(!invoiceCloudInfo.token)return;var valueobj=_this.getECID_FID();var fun=function fun(fid){window.invoiceBrowser=ecCom.WeaTools.createDialog({title:(0,_convert.getLabel)(516434,'我的票夹'),url:_this.getInvoiceCloudUrl(fieldMark,fid),icon:"icon-coms-workflow",iconBgcolor:"#0079DE",style:{width:"800px",height:500},callback:function callback(datas){// 数据通信
},onCancel:function onCancel(){// 关闭通信
window.invoiceBrowser=null;}},undefined,function(dialog){// 由于组件异步化可能导致第一次没有加载到组件，所以需要在回调中调用
dialog.show();});};if(valueobj.ecid.length>0&&valueobj.cloudId.length<=0){(0,_invoiceUtil.getInvoiceFid)({method:"cloudId",ids:valueobj.ecid.join(",")}).then(function(res){var status=res.status,targetIds=res.targetIds;if(status==1){fun(targetIds.split(","));}else{// 接口出错
}});}else if(valueobj.ecid.length>0&&valueobj.cloudId.length>0){fun(valueobj.cloudId);}else{fun([]);}},_this.getInvoiceCloudUrl=function(fieldMark,fid){var _this$props$globalSto3=_this.props.globalStore.invoiceCloudInfo,invoiceCloudInfo=_this$props$globalSto3===undefined?{}:_this$props$globalSto3;var baseProps=_this.props.baseProps;var detailtype=baseProps.detailtype,value=baseProps.value;var comp={seq:{fieldMark:fieldMark},// 可选，宿主生成的请求id，组件不处理该参数，仅在组件给宿主回传数据时原样返回
name:"SelectInvoice",// 必传，组件名，参考下方“组件列表”中的说明
param:{// 可选，宿主传过来的参数，具体格式参考下方“组件列表”中的说明
hideHeader:true,multi:detailtype===293?true:false,fids:fid||[],fidsModule:1}};var languageidweaver=window.localStorage.getItem('languageidweaver')||"7";var url=invoiceCloudInfo.jsUrl+'/corpInvoice/#/component?token='+invoiceCloudInfo.token+'&src=EC&dev=0&baseUrl='+invoiceCloudInfo.baseUrl+'&comp='+encodeURIComponent((0,_stringify2.default)(comp))+'&lang='+languageidweaver;return url;},_this.getECID_FID=function(){var fieldObj=_this.props.fieldObj;var specialobj=fieldObj.specialobj?mobx.toJS(fieldObj.specialobj):[];var ecid=[];var cloudId=[];if(specialobj.length>0){specialobj.map(function(item){if(item.prop&&item.prop.cloudId){cloudId.push(item.prop.cloudId);}if(item.id){ecid.push(item.id);}});}return{ecid:ecid,cloudId:cloudId};},_this.clickAddBtn=function(){var _this$props5=_this.props,globalStore=_this$props5.globalStore,layoutStore=_this$props5.layoutStore,fieldMark=_this$props5.fieldMark,cellObj=_this$props5.cellObj,baseProps=_this$props5.baseProps;var fieldid=cellObj.field.toString();var commonParam=globalStore.commonParam,_globalStore$secLevel=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel===undefined?{}:_globalStore$secLevel;var odocInfo=layoutStore.odocInfo;var detailtype=baseProps.detailtype;if(detailtype===9||detailtype===37){if("docFieldId"in odocInfo&&odocInfo.docFieldId.toString()===fieldid){//公文字段创建直接切换到正文Tab
if(commonParam.belongTest){var _getAntd2=(0,_convert.getAntd)(),Modal=_getAntd2.Modal;Modal.warning({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(386200,"流程测试暂不支持创建公文!"),okText:(0,_convert.getLabel)(83446,'\u786E\u5B9A')});return;}else{var needSwitch=window.oDocUtil.clickAddOdoc();if(needSwitch)WfForm.switchTab("odoc");}}else{//创建文档
OtherModule.createDoc(fieldMark,(0,_extends3.default)({},commonParam,{secLevelInfo:secLevelInfo,secretLevel:secLevelInfo.secLevel}));}}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(BrowserElement,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaBrowser=_getEcCom.WeaBrowser,WeaDatePicker=_getEcCom.WeaDatePicker,WeaTimePicker=_getEcCom.WeaTimePicker;var _props=this.props,fieldMark=_props.fieldMark,fieldAttr=_props.fieldAttr,symbol=_props.symbol,rowIndex=_props.rowIndex,cellObj=_props.cellObj,fieldObj=_props.fieldObj;var baseProps=this.props.baseProps;var viewAttr=baseProps.viewAttr,fieldid=baseProps.fieldid,fieldName=baseProps.fieldName,isDetail=baseProps.isDetail,detailtype=baseProps.detailtype;var _fieldAttr$browseratt=fieldAttr.browserattr,browserattr=_fieldAttr$browseratt===undefined?{}:_fieldAttr$browseratt;var _browserattr$browserP=browserattr.browserParams,browserParams=_browserattr$browserP===undefined?{}:_browserattr$browserP;var specialobj=fieldObj.specialobj?mobx.toJS(fieldObj.specialobj):[];var browserProp=this.getBrowserProp(detailtype,fieldAttr.fielddbtype);browserProp.type=detailtype;browserProp.replaceDatas=specialobj;browserProp.disabledConditionCache=true;//每次都走conditon接口
var defaultSearch=browserParams.defaultSearch||mobx.toJS(browserParams).defaultSearch;if(defaultSearch=='true'){browserProp.defaultAtSearch=true;//判断人力 有搜索条件则给组件传值，进页面的时候执行一次搜索
}this.extendBrowserProp(browserProp,fieldid,isDetail,detailtype);this.extendDateProp(baseProps);var inputStyle={};if(viewAttr!==1&&symbol.indexOf("mc_")>-1){inputStyle["min-width"]="150px";}browserProp.inputStyle=inputStyle;if(detailtype!==34)//请假类型
browserProp.resize=viewAttr!==1;var el=void 0;// 针对人力资源条件做特殊兼容，改变值后强制reRender
if(fieldAttr.htmltype===3&&fieldAttr.detailtype==141&&fieldAttr.fieldid!=''){baseProps.key="wf-hrm-condition"+new Date().getTime()+Math.random();}if(detailtype===2||detailtype===402||detailtype===403){el=_react2.default.createElement(WeaDatePicker,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDatePicker@ungkn5'},baseProps,{onChange:this.doChangeEvent}));}else if(detailtype===290){el=_react2.default.createElement(WeaDatePicker,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDatePicker@011nck'},baseProps,{onChange:this.doChangeEvent,showTime:true,format:"yyyy-MM-dd HH:mm"}));}else if(detailtype===19){baseProps.value=FieldUtil.convertTimeValue(baseProps.value);//时间值补零
if(baseProps.value.length>5){baseProps.formatPattern=1;baseProps.format="HH:mm:ss";}el=_react2.default.createElement(WeaTimePicker,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTimePicker@vjvgsn'},baseProps,{onChange:this.doChangeEvent}));}else if(detailtype===118||detailtype===124||detailtype===125||detailtype===126){//只读，特殊字段处理： 空会议室使用情况、计划、目标、报告
var linkUrl=browserProp.linkUrl;var valueSpan='';specialobj.map(function(v){if(linkUrl){valueSpan=valueSpan+('<a href=\''+linkUrl+v.id+'\' target=\'_new\'>'+v.name+'</a> ');}else{valueSpan=valueSpan+v.name+' ';}});if(detailtype===118){//会议室使用情况
valueSpan='<a class=\'wf-RoomPlan\' href=\''+(window.ecologyContentPath||'')+'/spa/meeting/static/index.html#/main/meeting/RoomPlan\' target=\'_new\'>'+(0,_convert.getLabel)(15881,'会议室使用情况')+'</a>';}el=_react2.default.createElement('div',null,_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:valueSpan}}),_react2.default.createElement('input',{type:'hidden',name:fieldName,id:fieldName,value:baseProps.value}));}else if(detailtype===226){var weaBrowserProps=(0,_extends3.default)({},(0,_objectAssign2.default)({},browserProp,baseProps));el=_react2.default.createElement(_single2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSapBrowser@mkc69m',weaBrowserProps:weaBrowserProps,onChange:this.doSapBrowChangeEvent});}else{//知识组需求，可编辑文档字段添加两个参数
if((detailtype===9||detailtype===37)&&(viewAttr===2||viewAttr===3)&&browserProp.linkUrl&&browserProp.linkUrl.indexOf("?")>-1){var _linkUrl=browserProp.linkUrl;browserProp.linkUrl=_linkUrl.substring(0,_linkUrl.indexOf("?")+1)+('formFieldAttr=2&formFieldId='+fieldid+'&')+_linkUrl.substring(_linkUrl.indexOf("?")+1);}el=_react2.default.createElement(WeaBrowser,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@j1zg9h'},(0,_objectAssign2.default)({},browserProp,baseProps),{selectSize:'default',onChange:this.doBrowChangeEvent// onAssociativeDataChange={this.doAssociativeDataChange}
,addOnClick:this.clickAddBtn,onBeforeFocusCheck:this.beforeCheck}));}return el;}//获取浏览框相关的表单字段值
},{key:'getBrowserProp',value:function getBrowserProp(detailtype,fielddbtype){var _props2=this.props,rowIndex=_props2.rowIndex,cellObj=_props2.cellObj,globalStore=_props2.globalStore,layoutStore=_props2.layoutStore;var _globalStore$secLevel2=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel2===undefined?{}:_globalStore$secLevel2;var isOpenSec=secLevelInfo.isOpenSec,secLevel=secLevelInfo.secLevel;var _globalStore$commonPa=globalStore.commonParam,isprint=_globalStore$commonPa.isprint,_globalStore$commonPa2=_globalStore$commonPa.useInvoiceCloud,useInvoiceCloud=_globalStore$commonPa2===undefined?false:_globalStore$commonPa2;var isCusBrow=detailtype===161||detailtype===162||detailtype===256||detailtype===257;var browKey=isCusBrow?detailtype+"_"+fielddbtype:detailtype.toString();var browserInfo=layoutStore.browserInfo,fieldAttrMap=layoutStore.fieldAttrMap,odocInfo=layoutStore.odocInfo;var browProp=_.cloneDeep(browserInfo[browKey]||{});if(_.isEmpty(browProp))return browProp;browProp=(0,_extends3.default)({},browProp,browProp.otherParams||{});var relateFieldValue={};browProp.relateFieldid&&browProp.relateFieldid.map(function(field){var fieldid=field.split("_")[0];var isDetail=field.split("_")[1]==="1";var fieldAttr=fieldAttrMap.get(fieldid);var key=fieldAttr.fieldname;if(key){if(isDetail)key=fieldAttr.tableName+"_"+key;if(isCusBrow)//避免自定义浏览框依赖字段fieldname与其它参数重复
key=key.toLowerCase()+'_'+_.get(browProp,["dataParams","currenttime"]);relateFieldValue[key]=FieldUtil.getRelateFieldValue(fieldid,rowIndex);}});var dataParams=browProp.dataParams||{};dataParams=(0,_extends3.default)({},dataParams,relateFieldValue);browProp.dataParams=dataParams;if(detailtype===256||detailtype===257){browProp['asynLoadAll']=false;}var curfieldid=cellObj.field.toString();if((detailtype===9||detailtype===37)&&"docFieldId"in odocInfo&&odocInfo.docFieldId.toString()===curfieldid){//正文点击切换Tab
var isSupportIweboffice2015App=false;if(odocInfo.openIwebOffice2015NewModel){if(odocInfo.isIwebOffice2015Compatible){var isSupport=this.isSupportIweOffice2015App();if(isSupport){isSupportIweboffice2015App=true;}}else{if(window.navigator.userAgent.indexOf('Chrome')>-1){isSupportIweboffice2015App=true;}}}//且正文只读时、若开启预览服务，走预览服务查看正文
if(odocInfo&&odocInfo.docParam&&odocInfo.docParam.isEdit!='1'&&(odocInfo.docParam.wpsView||odocInfo.docParam.yozoView||odocInfo.zbview||odocInfo.lightReadView)){isSupportIweboffice2015App=false;}browProp.onLinkClick=function(){if(odocInfo.openWpsJSAPI&&odocInfo.extendName.indexOf('doc')>-1){window.beforeWpsOnlineEdit.createDoc();}else if(isSupportIweboffice2015App&&odocInfo.extendName.indexOf('doc')>-1){oDocUtil.openIWebOffice2015App();}else{WfForm.switchTab("odoc");}};browProp.hideOps=odocInfo.newTextNodes===true;browProp.hideSelect=odocInfo.newTextNodes===true;}if(parseInt(isprint)!==1&&(detailtype===87||detailtype===184)){browProp.extraElement=_react2.default.createElement('span',null,_react2.default.createElement('a',{className:'wf-RoomPlan',href:(window.ecologyContentPath||'')+'/spa/meeting/static/index.html#/main/meeting/RoomPlan',target:'_new'},(0,_convert.getLabel)(15881,'会议室使用情况')));}if(useInvoiceCloud==true&&(detailtype===292||detailtype===293)){browProp.onBrowerClick=this.onBrowerClick;}return browProp;}//判断当前浏览器是否支持金格插件（金格目前回复只需判断谷歌107版本以上）
},{key:'isSupportIweOffice2015App',value:function isSupportIweOffice2015App(){var userAgent=window.navigator.userAgent;var isSupport=false;try{if(/AppleWebKit\/([\d.]+)/.test(userAgent)){// 匹配Webkit内核（Chrome、Safari浏览器）
if(/Chrome\/([\d.]+)/.test(userAgent)){// 匹配Chrome浏览器
var version=parseFloat(RegExp.$1);if(version>107){isSupport=true;}}}}catch(error){if(window.console){console.log('error',error);}}return isSupport;}},{key:'getBrowserDataDefinition',//浏览数据定义获取表单字段数据
value:function getBrowserDataDefinition(relateFields,detailtype){var rowIndex=this.props.rowIndex;var relateFieldValue={};relateFields.map(function(field){var fieldid=field.split("_")[0];if(detailtype===161||detailtype===162){}else{relateFieldValue['field'+fieldid]=FieldUtil.getRelateFieldValue(fieldid,rowIndex);}});relateFieldValue=(0,_extends3.default)({},relateFieldValue,FieldUtil.getRelateFieldShowName(relateFields,rowIndex));return relateFieldValue;}//设置浏览框表单参数
},{key:'extendBrowserProp',value:function extendBrowserProp(browserProp,fieldid,isDetail,detailtype){var _props3=this.props,globalStore=_props3.globalStore,fieldAttr=_props3.fieldAttr,baseProps=_props3.baseProps,fieldObj=_props3.fieldObj,rowIndex=_props3.rowIndex,layoutStore=_props3.layoutStore;var fielddbtype=fieldAttr.fielddbtype,_fieldAttr$browseratt2=fieldAttr.browserattr,browserattr=_fieldAttr$browseratt2===undefined?{}:_fieldAttr$browseratt2;var relateFieldid=browserattr.relateFieldid,sqlWhereField=browserattr.sqlWhereField,_browserattr$browserP2=browserattr.browserParams,browserParams=_browserattr$browserP2===undefined?{}:_browserattr$browserP2;var _browserParams$tabs=browserParams.tabs,tabs=_browserParams$tabs===undefined?[]:_browserParams$tabs,_browserParams$hasAdd=browserParams.hasAddGroup,hasAddGroup=_browserParams$hasAdd===undefined?false:_browserParams$hasAdd;var odocInfo=layoutStore.odocInfo;if(tabs.length>0){browserProp.tabs=mobx.toJS(tabs);}//delete browserParams.tabs;
var viewAttr=baseProps.viewAttr;var variable=fieldObj.variable;var commonParam=globalStore.commonParam,_globalStore$secLevel3=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel3===undefined?{}:_globalStore$secLevel3;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,formid=commonParam.formid,isbill=commonParam.isbill,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,wfTestStr=commonParam.wfTestStr,creater=commonParam.creater;if(hasAddGroup&&detailtype===17&&!isDetail){browserProp.hasAddGroup=true;}if(detailtype===1||detailtype===17){browserProp.isShowGroup=!isDetail;browserProp.canSelectAllUser=commonParam.allowAllPersonGroup;}if(detailtype===141){browserProp.isShowSecLevel=browserParams.isShowSecLevel;}//设置文档浏览框添加按钮及公文浏览框条件
var isWorkflowDoc=commonParam.isWorkflowDoc||false;var flowDocFieldId=commonParam.flowDocFieldId||0;if(viewAttr>1&&detailtype===9&&!isDetail&&isWorkflowDoc&&flowDocFieldId==fieldid){// if (_.trim(baseProps.value).length === 0)
if(odocInfo.docParam.isStartNode&&odocInfo.docParam.reUploadText){browserProp.hasAddBtn=true;//正文添加按钮
}else if(_.trim(baseProps.value).length===0){browserProp.hasAddBtn=true;//正文添加按钮
}browserProp.dataParams.isWord="1";}if(viewAttr>1&&detailtype===37){browserProp.hasAddBtn=true;}if(viewAttr==1){browserProp.simpleRO=true;}//请求接口参数相关扩展
var tempConditionDataParams=browserProp.conditionDataParams||{};var dataParams=browserProp.dataParams||{};var relateFieldDatas=relateFieldid?this.getBrowserDataDefinition(relateFieldid,detailtype):{};var completeParams=browserProp.completeParams||{};var customDataParam=variable.has("customDataParam")?variable.get("customDataParam"):{};var reqinfo={wfid:workflowid,billid:formid,isbill:isbill,requestid:requestid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,wf_isagent:commonParam.isagent,wf_beagenter:commonParam.beagenter,wfTestStr:wfTestStr,fieldid:fieldid,viewtype:isDetail?"1":"0",fromModule:"workflow",wfCreater:creater,disabledConditionCache:true};if(detailtype===226){//SAP浏览按钮
reqinfo=(0,_extends3.default)({},reqinfo,{fielddbtype:fielddbtype,rowIndex:rowIndex});browserProp.searchParams={issearch:true};}var browParams=(0,_objectAssign2.default)({},tempConditionDataParams,completeParams,dataParams,reqinfo,browserParams,relateFieldDatas,customDataParam);if(secLevelInfo&&secLevelInfo.isOpenSec){browParams.secretLevel=secLevelInfo.secLevel;}browserProp.conditionDataParams=browParams;browserProp.completeParams=browParams;browserProp.dataParams=browParams;browserProp.destDataParams=(0,_extends3.default)({},browserProp.destDataParams||{},browParams,{fromModule:"workflow"});if(detailtype===16||detailtype===152||detailtype===171||detailtype===238)browserProp.linkUrl=browserProp.linkUrl+'&fieldid='+fieldid+'&requestid=';//前端自定义浏览框属性覆盖
var customBrowserProp=variable.has("customBrowserProp")?variable.get("customBrowserProp"):{};for(var key in customBrowserProp){browserProp[key]=customBrowserProp[key];}}},{key:'extendDateProp',value:function extendDateProp(baseProps){var detailtype=baseProps.detailtype;if(detailtype!==2&&detailtype!==19&&detailtype!==290&&detailtype!==402&&detailtype!==403)return;var _props4=this.props,cellObj=_props4.cellObj,fieldObj=_props4.fieldObj;var format=cellObj.format||{};var variable=fieldObj.variable;baseProps.formatPattern=format["formatPattern"]||"";baseProps.noInput=true;if(detailtype===2){baseProps.startValue=variable.get("startDate")||"";baseProps.endValue=variable.get("endDate")||"";}switch(detailtype){case 402:baseProps.format="YYYY";break;case 403:baseProps.format="YYYY-MM";break;default:"";}}}]);return BrowserElement;}(_react2.default.Component))||_class)||_class);exports.default=BrowserElement;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _source=__webpack_require__(24);var _source2=_interopRequireDefault(_source);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaSapBrowser=function(_React$Component){(0,_inherits3.default)(WeaSapBrowser,_React$Component);function WeaSapBrowser(){(0,_classCallCheck3.default)(this,WeaSapBrowser);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaSapBrowser.__proto__||(0,_getPrototypeOf2.default)(WeaSapBrowser)).call(this));_this.doBrowserChange=function(_ids,_names,_datas){var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;var _this$props=_this.props,weaBrowserProps=_this$props.weaBrowserProps,onChange=_this$props.onChange;var _ref=weaBrowserProps||{},fieldid=_ref.fieldid,rowIndex=_ref.rowIndex,dataParams=_ref.dataParams;var fielddbtype=dataParams.fielddbtype,requestid=dataParams.requestid;var params={fromNodeorReport:"0",fieldid:fieldid,rowIndex:rowIndex,requestid:requestid,fielddbtype:fielddbtype};params["datas"]=(0,_stringify2.default)(_datas);WeaTools.callApi('/api/SapIntegration/browser/getSapBrowserWfFieldId','POST',params).then(function(result){var wfDatas={};if(result.fieldIds){result.fieldIds.forEach(function(item,index){var items=item.split("_");var fieldid=items[0];wfDatas["field"+fieldid]=wfform.getFieldValue("field"+fieldid);});}params["wfid"]=wfform.getBaseInfo().workflowid;params["wfDatas"]=(0,_stringify2.default)(wfDatas);WeaTools.callApi('/api/SapIntegration/browser/assignToBill','POST',params).then(function(result){_this.triggerLink(result);onChange&&onChange(result.datas);});});//此接口由SAP模块提供，将浏览按钮选中数据转换为流程识别的数据
};_this.triggerLink=function(v){var changeDatas={};var addRowInfo=[];var linkageSql=[];if(_.isEmpty(v))return true;var changeValue=v["changeValue"];//字段联动,主表联动明细
var addRows=v["addDetailRow"];!_.isEmpty(addRows)&&_.forIn(addRows,function(rowDatas,detailMark){rowDatas&&rowDatas.map(function(rowData){addRowInfo.push({detailMark:detailMark,rowData:rowData});});});addRowInfo.map(function(item,index){var detailIndex=DetailUtil.addRow(item.detailMark,item.rowData,true,false);});};return _this;}(0,_createClass3.default)(WeaSapBrowser,[{key:'render',value:function render(){var _getEcCom2=(0,_convert.getEcCom)(),WeaBrowser=_getEcCom2.WeaBrowser,WeaTools=_getEcCom2.WeaTools;var weaBrowserProps=this.props.weaBrowserProps;var _weaBrowserProps$data=weaBrowserProps.dataParams,displaySearchAdInBar=_weaBrowserProps$data.displaySearchAdInBar,scrollx=_weaBrowserProps$data.scrollx,browTitle=_weaBrowserProps$data.browTitle,enableSearchValidFirst=_weaBrowserProps$data.enableSearchValidFirst;return _react2.default.createElement(WeaBrowser,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@dv69jt'},weaBrowserProps,{onChange:this.doBrowserChange,sap:true,title:browTitle,displaySearchAdInBar:displaySearchAdInBar,enableSearchValidFirst:enableSearchValidFirst,scrollx:true}));}}]);return WeaSapBrowser;}(_react2.default.Component);exports.default=WeaSapBrowser;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckElement=(_dec=(0,_mobxReact.inject)('layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(CheckElement,_React$Component);function CheckElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,CheckElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=CheckElement.__proto__||(0,_getPrototypeOf2.default)(CheckElement)).call.apply(_ref,[this].concat(args))),_this),_this.doChangeEvent=function(value){var _this$props=_this.props,layoutStore=_this$props.layoutStore,fieldMark=_this$props.fieldMark;layoutStore.changeSingleFieldValue(fieldMark,{value:value});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(CheckElement,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaCheckbox=_getEcCom.WeaCheckbox;var _props=this.props,fieldMark=_props.fieldMark,fieldAttr=_props.fieldAttr,symbol=_props.symbol,rowIndex=_props.rowIndex,cellObj=_props.cellObj,fieldObj=_props.fieldObj;var baseProps=this.props.baseProps;if(baseProps.value==="")baseProps.value="0";return _react2.default.createElement(WeaCheckbox,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@s855yi'},baseProps,{onChange:this.doChangeEvent}));}}]);return CheckElement;}(_react2.default.Component))||_class)||_class);exports.default=CheckElement;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SelectElement=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SelectElement,_React$Component);function SelectElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,SelectElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=SelectElement.__proto__||(0,_getPrototypeOf2.default)(SelectElement)).call.apply(_ref,[this].concat(args))),_this),_this.doChangeEvent=function(value){var _this$props=_this.props,layoutStore=_this$props.layoutStore,fieldMark=_this$props.fieldMark;layoutStore.changeSingleFieldValue(fieldMark,{value:value});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(SelectElement,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaSelect=_getEcCom.WeaSelect;var _props=this.props,layoutStore=_props.layoutStore,globalStore=_props.globalStore;var variableMap=layoutStore.variableMap;var commonParam=globalStore.commonParam;var _props2=this.props,fieldMark=_props2.fieldMark,fieldAttr=_props2.fieldAttr,symbol=_props2.symbol,rowIndex=_props2.rowIndex,cellObj=_props2.cellObj,fieldObj=_props2.fieldObj;var baseProps=this.props.baseProps;var variable=fieldObj.variable;var fieldid=baseProps.fieldid,detailtype=baseProps.detailtype,viewAttr=baseProps.viewAttr,value=baseProps.value;if(detailtype===0){//系统单据默认为选择框
detailtype=1;}//打印模式下radio框只显示选中值
if(commonParam.isprint==="1"&&detailtype===3&&variableMap.get('radioPrintText_'+fieldid)===true){detailtype=1;}baseProps.detailtype=detailtype;var optionRange=variable.has("optionRange")?variable.get("optionRange"):null;var filterOptionRange=variable.has("filterOptionRange")?variable.get("filterOptionRange"):null;var options=[];if(detailtype===1)//下拉选择框才需要空选项
options.push({'key':'','showname':''});if(fieldAttr.htmltype!==5){//字段类型变更为选择框情况
var changeFieldTypeSelectOption=mobx.toJS(variable.get("changeFieldTypeSelectOption"))||[];options=options.concat(changeFieldTypeSelectOption);}else{var selectattr=fieldAttr.selectattr;var itemList=selectattr.selectitemlist;itemList&&itemList.map(function(item){var selectvalue=item.selectvalue.toString();//必须转字符串
if(item.cancel===1&&(viewAttr===1&&!(','+value+',').includes(','+selectvalue+',')||viewAttr===2||viewAttr===3))return true;if(optionRange!==null&&_.indexOf(optionRange,selectvalue)===-1)//选择框联动控制范围
return true;if(filterOptionRange!==null&&_.indexOf(filterOptionRange,selectvalue)>-1)//接口控制remove选项
return true;options.push({"key":selectvalue,"showname":item.selectname});});baseProps.fieldshowtypes=selectattr.fieldshowtypes;}baseProps.options=options;// baseProps.widthMatchOptions = true;
baseProps.dropdownMatchSelectWidth=false;if(viewAttr!==1)baseProps.style=(0,_extends3.default)({},baseProps.style,{'min-width':(baseProps.isDetail?55:100)+'px'});var value_arr=baseProps.value.split(",");if(options&&options.length>0&&options.filter(function(o){return value_arr.includes(o.key);}).length==0&&value!==""){baseProps.value="";this.doChangeEvent("");}return _react2.default.createElement(WeaSelect,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@vm269g'},baseProps,{supportCancel:viewAttr===2,onChange:this.doChangeEvent}));}}]);return SelectElement;}(_react2.default.Component))||_class)||_class);exports.default=SelectElement;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FileElement=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(FileElement,_React$Component);function FileElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,FileElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=FileElement.__proto__||(0,_getPrototypeOf2.default)(FileElement)).call.apply(_ref,[this].concat(args))),_this),_this.fileChangeEvent=function(ids,filedatas){var _this$props=_this.props,layoutStore=_this$props.layoutStore,fieldMark=_this$props.fieldMark,fieldObj=_this$props.fieldObj,rowIndex=_this$props.rowIndex,baseProps=_this$props.baseProps;var specialobj=fieldObj.specialobj||{};specialobj.filedatas=filedatas;layoutStore.changeSingleFieldValue(fieldMark,{value:ids.join(","),specialobj:specialobj});},_this.onUploading=function(type){var valueInfo=null;var _this$props2=_this.props,layoutStore=_this$props2.layoutStore,fieldMark=_this$props2.fieldMark,fieldObj=_this$props2.fieldObj,rowIndex=_this$props2.rowIndex,baseProps=_this$props2.baseProps;var fieldid=baseProps.fieldid,isDetail=baseProps.isDetail;var fieldVars={};//type = true 标记改字段值为空 type = false 标记该字段值不为空 这个时候不需要更新状态
if(type=="false"&&fieldObj.value==""){valueInfo={value:"-1"};}else if(type=="true"){valueInfo={value:""};}if(type!="false"&&type!="true"){var _fieldObj$variable=fieldObj.variable,variable=_fieldObj$variable===undefined?{}:_fieldObj$variable;var fileUploadStatus=variable.fileUploadStatus;if(fileUploadStatus!='error'){fieldVars.fileUploadStatus=type;}}layoutStore.changeSingleFieldValue(fieldMark,valueInfo,fieldVars);if(isDetail){DetailUtil.syncLockedRowHeight(fieldid,rowIndex);}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(FileElement,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaUpload=_getEcCom.WeaUpload;var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore,fieldMark=_props.fieldMark,fieldAttr=_props.fieldAttr,symbol=_props.symbol,rowIndex=_props.rowIndex,cellObj=_props.cellObj,fieldObj=_props.fieldObj;var baseProps=this.props.baseProps;var isDetail=baseProps.isDetail,fieldName=baseProps.fieldName,value=baseProps.value,viewAttr=baseProps.viewAttr,fieldid=baseProps.fieldid;var detailtype=fieldAttr.detailtype,fileattr=fieldAttr.fileattr;var specialobj=fieldObj.specialobj?mobx.toJS(fieldObj.specialobj):{};var filedatas=specialobj.filedatas,showBatchLoad=specialobj.showBatchLoad;//计算附件上传目录  catelogType = 0:固定目录 1：选择目录
var category="";var errorMsg="";var catelogType=fileattr.catelogType,docCategory=fileattr.docCategory,selectedCateLog=fileattr.selectedCateLog,maxUploadSize=fileattr.maxUploadSize,fileSecFormat=fileattr.fileSecFormat;if(catelogType===0){if(_.trim(docCategory).length>0){category=_.trim(docCategory);}else{errorMsg=(0,_convert.getLabel)(83157,"附件上传目录未设置!");}}else{var selectedCatalog=this.getFileSelectedCatalog();if(selectedCatalog.errorMsg){errorMsg=selectedCatalog.errorMsg;}else{category=selectedCatalog&&selectedCatalog.docCategory;maxUploadSize=selectedCatalog&&selectedCatalog.maxUploadSize;}}var commonParam=globalStore.commonParam,_globalStore$secLevel=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel===undefined?{}:_globalStore$secLevel,variableMap=globalStore.variableMap;var workflowid=commonParam.workflowid,requestid=commonParam.requestid,authStr=commonParam.authStr,authSignatureStr=commonParam.authSignatureStr,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,wfTestStr=commonParam.wfTestStr,isprint=commonParam.isprint,nodetype=commonParam.nodetype,currentUserid=commonParam.currentUserid;var listType=detailtype===2?"img":"list";var urlParams='&authStr='+authStr+'&authSignatureStr='+authSignatureStr+'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype='+f_weaver_belongto_usertype+'&wfTestStr='+wfTestStr;var uploadUrl='/api/doc/upload/uploadFile2Doc?category='+category+'&workflowid='+workflowid+'&listType='+listType+'&wfTestStr='+wfTestStr;if(!(wfTestStr&&wfTestStr.length>0)){//非流程测试情况，追加uploadSrc和loginuserid参数，目的是后端拦截当前是否切换账号
uploadUrl+='&uploadSrc=wfform&loginuserid='+currentUserid;}baseProps.showBatchLoad=isDetail?false:showBatchLoad;baseProps.showClearAll=!isDetail;baseProps.uploadUrl=uploadUrl;baseProps.maxUploadSize=maxUploadSize;baseProps.category=category;filedatas&&filedatas.map(function(item){if(viewAttr>1&&layoutStore.propFileCfg.files_link_onlyview==="1"){//formFieldId=${fieldid}&formFieldAttr=2 控制当前这个附件文档是否可编辑 后续需要修改为接口,临时处理
item.filelink=item.filelink+'&isEdit=1&formFieldId='+fieldid+'&formFieldAttr=2';}});baseProps.datas=filedatas;baseProps.btnSize=isDetail?"small":"default";baseProps.autoUpload=isDetail;baseProps.listType=listType;baseProps.uploadId=fieldName;baseProps.errorMsg=errorMsg;if(showBatchLoad&&!isDetail){var batchLoadUrl='/weaver/weaver.file.FileDownload?fieldvalue='+value+'&download=1&downloadBatch=1&desrequestid=0&requestid='+requestid+urlParams;baseProps.batchLoadUrl=batchLoadUrl;}//字段是否开启拖拽， 后台是否开启拖拽，文件是否可编辑
var _fieldAttr$issortable=fieldAttr.issortable,issortable=_fieldAttr$issortable===undefined?true:_fieldAttr$issortable,_fieldAttr$isresetnam=fieldAttr.isresetname,isresetname=_fieldAttr$isresetnam===undefined?true:_fieldAttr$isresetnam,_fieldAttr$isshowcler=fieldAttr.isshowclerarall,isshowclerarall=_fieldAttr$isshowcler===undefined?false:_fieldAttr$isshowcler,_fieldAttr$isautouplo=fieldAttr.isautoupload,isautoupload=_fieldAttr$isautouplo===undefined?true:_fieldAttr$isautouplo;//是否显示清楚全部
baseProps.showClearAll=isshowclerarall;baseProps.issortable=issortable;baseProps.editable=isresetname;baseProps.autoUpload=isautoupload;//自动上传
baseProps.datas=baseProps.datas?baseProps.datas:[];if(isautoupload){//自动上传则存为草稿 ,同时需要不丢失其他属性
baseProps.uploadParams=(0,_extends3.default)({isFirstUploadFile:"9"},baseProps.uploadParams);//流程草稿
}//#1180906
// 概述：表单附件上传字段，上传格式需进行前后端同时校验
// 文件上传加上字段id属性，以对上传文件的格式进行前后端校验
baseProps.uploadParams=(0,_extends3.default)({},baseProps.uploadParams,{fieldId:fieldid},{workflowId:workflowid});if(fileattr.imgHeight===0){fileattr.imgHeight=50;}if(fileattr.imgWidth===0){fileattr.imgWidth=50;}return _react2.default.createElement(WeaUpload,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaUpload@li5935',ref:fieldName,uploadId:fieldName},(0,_extends3.default)({},fileattr,baseProps),{needCalculateWidth:isprint!="1",onChange:this.fileChangeEvent,onUploading:this.onUploading,casProtect:secLevelInfo.isOpenSec,secLevel:secLevelInfo.secLevel,secLevelInfo:secLevelInfo.tip,showSecLevel:secLevelInfo.isOpenSec&&fileattr.showSecLevel,allowEditSec:nodetype==0&&baseProps.viewAttr>1,secLevelDisplayFormat:fileSecFormat.toString()//0显示密级和保密期限  1仅显示密级  不传则不显示
,needCheckSec:false}));}//获取附件字段对应的选择框目录信息
},{key:'getFileSelectedCatalog',value:function getFileSelectedCatalog(){var _props2=this.props,layoutStore=_props2.layoutStore,rowIndex=_props2.rowIndex,fieldAttr=_props2.fieldAttr;var _ref2=fieldAttr||{},fileattr=_ref2.fileattr;var fieldAttrMap=layoutStore.fieldAttrMap;var selectedFieldid=fileattr.selectedCateLog;if(fileattr.catelogType!==1||!selectedFieldid||!fieldAttrMap.has(selectedFieldid))//附件字段非选择框控制目录
return{};var selectedFieldValue=FieldUtil.getRelateFieldValue(selectedFieldid,rowIndex);var selectedFieldAttr=fieldAttrMap.get(selectedFieldid);var fieldlabel=selectedFieldAttr.fieldlabel,selectattr=selectedFieldAttr.selectattr;var selectedCatalog={};if(selectedFieldid!==""&&selectedFieldValue!==""){selectattr&&selectattr.selectitemlist.map(function(v){if(v&&v.selectvalue.toString()===selectedFieldValue.toString())selectedCatalog={docCategory:v.docCategory,maxUploadSize:v.maxUploadSize||5};});}else{selectedCatalog.errorMsg=(0,_convert.getLabel)(125389,'请先选择')+'\u201C'+fieldlabel+'\u201D';}return selectedCatalog;}}]);return FileElement;}(_react2.default.Component))||_class)||_class);exports.default=FileElement;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _fieldUtil=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SpecialElement=function(_React$Component){(0,_inherits3.default)(SpecialElement,_React$Component);function SpecialElement(){(0,_classCallCheck3.default)(this,SpecialElement);return(0,_possibleConstructorReturn3.default)(this,(SpecialElement.__proto__||(0,_getPrototypeOf2.default)(SpecialElement)).apply(this,arguments));}(0,_createClass3.default)(SpecialElement,[{key:'componentDidMount',value:function componentDidMount(){var fieldAttr=this.props.fieldAttr;var detailtype=fieldAttr.detailtype,specialattr=fieldAttr.specialattr;//特殊字段--链接含JS情况下通过Append方式渲染
if(detailtype===1){var displayname=specialattr.displayname||"";var linkaddress=specialattr.linkaddress||"";jQuery(this.refs.specialFieldSpan).append("<a href='"+linkaddress+"' target='_blank'>"+displayname+"</a>");}}},{key:'render',value:function render(){var fieldAttr=this.props.fieldAttr;var detailtype=fieldAttr.detailtype,specialattr=fieldAttr.specialattr;var specialFieldDom=void 0;if(detailtype===1){// const displayname = fieldObj&&fieldObj.get("specialattr") ? fieldObj.getIn(["specialattr","displayname"]) : "";
// const linkaddress = fieldObj&&fieldObj.get("specialattr") ? fieldObj.getIn(["specialattr","linkaddress"]) : "";
// specialFieldDom = <a href={linkaddress} target="_blank" dangerouslySetInnerHTML={{__html: displayname}}></a>
}else if(detailtype===0||detailtype===2){//老表单有type为0的描述性文字
var descriptivetext=specialattr.descriptivetext||"";specialFieldDom=_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:(0,_fieldUtil.convertSpecialChar)(descriptivetext,true)}});}return _react2.default.createElement('span',{className:'specialField',ref:'specialFieldSpan'},specialFieldDom);}}]);return SpecialElement;}(_react2.default.Component);exports.default=SpecialElement;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaFna=function(_React$Component){(0,_inherits3.default)(WeaFna,_React$Component);function WeaFna(){(0,_classCallCheck3.default)(this,WeaFna);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaFna.__proto__||(0,_getPrototypeOf2.default)(WeaFna)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(WeaFna,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('fna',_fileConfig.fnaFiles,init);}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(hasLoad){var _WeaFna=window.weaFnaSpecial.WeaFna;return _react2.default.createElement(_WeaFna,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFna@h6qoi0'},this.props));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@ot92tc'});}}}]);return WeaFna;}(_react2.default.Component);exports.default=WeaFna;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _index=__webpack_require__(624);var _index2=_interopRequireDefault(_index);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LocationElement=(_dec=(0,_mobxReact.inject)('globalStore','locationMapStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(LocationElement,_React$Component);function LocationElement(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,LocationElement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=LocationElement.__proto__||(0,_getPrototypeOf2.default)(LocationElement)).call.apply(_ref,[this].concat(args))),_this),_this.showLocalMapDialog=function(fieldObj){var _this$props=_this.props,locationMapStore=_this$props.locationMapStore,globalStore=_this$props.globalStore;locationMapStore.setLocationInfos(fieldObj);locationMapStore.setCancelEvent(function(){globalStore.controlDialogVisible(type.LOCATION_MAP,false);});globalStore.controlDialogVisible(type.LOCATION_MAP,true);//需最后显示弹窗
},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(LocationElement,[{key:'render',value:function render(){var _props=this.props,fieldMark=_props.fieldMark,fieldAttr=_props.fieldAttr,symbol=_props.symbol,fieldObj=_props.fieldObj;var _props2=this.props,globalStore=_props2.globalStore,baseProps=_props2.baseProps;var commonParam=globalStore.commonParam,markInfo=globalStore.markInfo,_globalStore$urlParam=globalStore.urlParams,urlParams=_globalStore$urlParam===undefined?{}:_globalStore$urlParam;var requestType=commonParam.requestType;baseProps.fieldName=FieldUtil.convertSystemFieldName(fieldMark);baseProps.isPrint=urlParams.isprint;return _react2.default.createElement(_index2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLocationField@shb810'},baseProps,{fieldObj:fieldObj,openDialogFunc:this.showLocalMapDialog}));}}]);return LocationElement;}(_react2.default.Component))||_class)||_class);exports.default=LocationElement;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);__webpack_require__(625);var _convert=__webpack_require__(6);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var main=function(_React$Component){(0,_inherits3.default)(main,_React$Component);function main(props){(0,_classCallCheck3.default)(this,main);var _this=(0,_possibleConstructorReturn3.default)(this,(main.__proto__||(0,_getPrototypeOf2.default)(main)).call(this,props));_this.state={value:props.value?props.value:''};return _this;}(0,_createClass3.default)(main,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.value!==nextProps.value){this.setState({value:nextProps.value});}}},{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Row=_getAntd.Row,Col=_getAntd.Col,Card=_getAntd.Card,Table=_getAntd.Table;var _props=this.props,fieldObj=_props.fieldObj,openDialogFunc=_props.openDialogFunc,JSComplete=_props.JSComplete,isPrint=_props.isPrint;var specialobj=fieldObj.specialobj?mobx.toJS(fieldObj.specialobj):[];var tableData=[];var expandedRowKeys=[];var tableColumn=[{title:(0,_convert.getLabel)(502315,'流转顺序'),dataIndex:'num',key:'num',width:'8%'},{title:(0,_convert.getLabel)(33417,'节点'),dataIndex:'operator',key:'operator',width:'16%'},{title:React.createElement('div',{className:'column-location'},React.createElement('span',null,(0,_convert.getLabel)(500932,'位置信息')),!isPrint=='1'&&React.createElement('span',{className:'column-location-showmap',onClick:function onClick(){openDialogFunc(fieldObj);}},(0,_convert.getLabel)(384395,'查看地图'))),dataIndex:'time',key:'time',width:'20%',colSpan:4},{title:'',dataIndex:'location',key:'location',width:'56%',colSpan:0}];specialobj.map(function(obj){var rowDetail=[];obj.locationList.map(function(location){rowDetail.push({num:'',key:'rowDetail_'+obj.flowNum,operator:location.userName+"/"+location.userDep,time:location.time,location:location.address});});var nodeRowData={num:obj.flowNum,key:'rowDataHead_'+obj.flowNum,operator:obj.nodeName,nodeid:obj.nodeId,children:[{num:'',key:'rowDetailHead_'+obj.flowNum,operator:(0,_convert.getLabel)(17482,'操作人'),time:(0,_convert.getLabel)(387601,'操作时间'),location:(0,_convert.getLabel)(22981,'位置'),children:rowDetail}]};expandedRowKeys.push('rowDataHead_'+obj.flowNum);expandedRowKeys.push('rowDetailHead_'+obj.flowNum);tableData.push(nodeRowData);});return React.createElement('div',null,specialobj.length>0&&JSComplete?React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@hpikxz',span:24,style:{border:'1px solid #e9e9e9',position:"relative"}},React.createElement(Table,{ecId:(this&&this.props&&this.props.ecId||'')+'_Table@l4p65v',className:'wf-location-field',pagination:false,columns:tableColumn,dataSource:tableData,expandedRowKeys:expandedRowKeys,size:'middle'})):React.createElement('span',null,(0,_convert.getLabel)(126181,'暂无位置信息')));}}]);return main;}(React.Component);exports.default=main;

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Encrypt=function(_React$Component){(0,_inherits3.default)(Encrypt,_React$Component);function Encrypt(){(0,_classCallCheck3.default)(this,Encrypt);var _this=(0,_possibleConstructorReturn3.default)(this,(Encrypt.__proto__||(0,_getPrototypeOf2.default)(Encrypt)).call(this));_this.onClick=function(v){var fieldObj=_this.props.fieldObj;fieldObj&&fieldObj.changeDecryptValue(v);};return _this;}(0,_createClass3.default)(Encrypt,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaInputEncrypt=_getEcCom.WeaInputEncrypt;var _props=this.props,value=_props.value,fieldAttr=_props.fieldAttr,fieldObj=_props.fieldObj;var type=fieldAttr.htmltype===2?'TEXTAREA':'';var decryptValue=fieldObj&&fieldObj.decryptValue;var hideEye=fieldAttr.encryptFlag===3;return _react2.default.createElement(WeaInputEncrypt,{value:value,decryptValue:decryptValue,onClick:this.onClick,type:type,noDesensitization:hideEye});}}]);return Encrypt;}(_react2.default.Component);exports.default=Encrypt;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(87);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ConflictDisplayPanel=function(_React$Component){(0,_inherits3.default)(ConflictDisplayPanel,_React$Component);function ConflictDisplayPanel(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,ConflictDisplayPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=ConflictDisplayPanel.__proto__||(0,_getPrototypeOf2.default)(ConflictDisplayPanel)).call.apply(_ref,[this].concat(args))),_this),_this.onOk=function(){var onOk=_this.props.onOk;if(typeof onOk=='function')onOk();_this.closePanel();},_this.onCancel=function(){var onCancel=_this.props.onCancel;if(typeof onCancel=='function')onCancel();_this.closePanel();},_this.closePanel=function(){$('#conflict-panel-box').css({visibility:'hidden'});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(ConflictDisplayPanel,[{key:'componentDidMount',value:function componentDidMount(){this.setPanelPosition();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.setPanelPosition();}//设置操作者信息面板的相对位置
},{key:'setPanelPosition',value:function setPanelPosition(){var _props=this.props,_props$clickPos=_props.clickPos,posX=_props$clickPos.posX,posY=_props$clickPos.posY,content=_props.content;var panel=document.getElementById('conflict-panel-box');if(!panel)return;var container=document.getElementsByClassName('wea-new-top-req-content')[0];var panelWd=panel.offsetWidth;var panelHg=panel.offsetHeight;var maxWd=document.documentElement.clientWidth;var maxHg=document.documentElement.clientHeight;//处理边缘防撞
if(posX+panelWd>=maxWd){panel.style.left=maxWd-panelWd-10+'px';}else{panel.style.left=posX+10+'px';}if(posY+panelHg>=maxHg){panel.style.top=maxHg-panelHg-10+'px';}else{panel.style.top=posY+10+'px';}}},{key:'render',value:function render(){var _props2=this.props,_props2$clickPos=_props2.clickPos,posX=_props2$clickPos.posX,posY=_props2$clickPos.posY,content=_props2.content;return _react2.default.createElement(_react2.default.Fragment,{ecId:(this&&this.props&&this.props.ecId||'')+'_undefined@qt1byo'},_react2.default.createElement('div',{className:'conflict-panel-container'},_react2.default.createElement('div',{className:'panel-header'},_react2.default.createElement('p',null,'\u60A8\u6B64\u6B21\u7684\u4FEE\u6539'),_react2.default.createElement('div',{className:'close-btn',onClick:this.closePanel},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@rgipux',type:'cross'}))),_react2.default.createElement('div',{className:'panel-body'},content),_react2.default.createElement('div',{className:'panel-footer'},_react2.default.createElement('div',{className:'btn active',onClick:this.onOk},'\u786E\u8BA4\u4FEE\u6539'),_react2.default.createElement('div',{className:'btn',onClick:this.onCancel},'\u5FFD\u7565'))));}}]);return ConflictDisplayPanel;}(_react2.default.Component);exports.default=ConflictDisplayPanel;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SystemField=(_dec=(0,_mobxReact.inject)('layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(SystemField,_React$Component);function SystemField(){(0,_classCallCheck3.default)(this,SystemField);return(0,_possibleConstructorReturn3.default)(this,(SystemField.__proto__||(0,_getPrototypeOf2.default)(SystemField)).call(this));}(0,_createClass3.default)(SystemField,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){return false;}},{key:'render',value:function render(){var _props=this.props,cellObj=_props.cellObj,layoutStore=_props.layoutStore;var etype=cellObj.etype;var fieldid=cellObj.field&&cellObj.field.toString();var cellInfo=layoutStore.cellInfo;var _ref=cellInfo.sysFieldInfo||{},_ref$workflowname=_ref.workflowname,workflowname=_ref$workflowname===undefined?"":_ref$workflowname,_ref$workflowtypename=_ref.workflowtypename,workflowtypename=_ref$workflowtypename===undefined?"":_ref$workflowtypename,_ref$workflowdesc=_ref.workflowdesc,workflowdesc=_ref$workflowdesc===undefined?"":_ref$workflowdesc;var text="";if(etype=="28"){text=cellObj.evalue;}else if(etype=="29"){if(fieldid=="1")text=workflowname;else if(fieldid=="2")text=workflowtypename;else if(fieldid=="3")text=workflowdesc;}text=text.replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/(\r\n|\r|\n)/g,"</br>");text=text.replace(/ /g,"&nbsp;");return _react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:''+text}});}}]);return SystemField;}(_react2.default.Component))||_class)||_class);exports.default=SystemField;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _set=__webpack_require__(130);var _set2=_interopRequireDefault(_set);var _from=__webpack_require__(124);var _from2=_interopRequireDefault(_from);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InsertScanCode=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(InsertScanCode,_React$Component);function InsertScanCode(props){(0,_classCallCheck3.default)(this,InsertScanCode);var _this=(0,_possibleConstructorReturn3.default)(this,(InsertScanCode.__proto__||(0,_getPrototypeOf2.default)(InsertScanCode)).call(this,props));_this.calculateRelateValue=function(scancodeData){if(scancodeData==""){return"";}var result=scancodeData;//常用参数
var commonPara=['requestid','requestname'];commonPara.map(function(item){var repalceReg='\\$'+item+'\\$';if(item==="requestid"){result=result.replace(new RegExp(repalceReg,"gm"),_interface2.default.getBaseInfo().requestid);}else{result=result.replace(new RegExp(repalceReg,"gm"),_interface2.default.getFieldValue("field-1")+"");}});//匹配固定参数
var patt=/\$[^(\$\=\[)]+\$/g;;var fieldnames=result.match(patt);//$fieldname$
//需要去重
fieldnames=(0,_from2.default)(new _set2.default(fieldnames));_.forEach(fieldnames,function(value){var fieldname=value.substring(1,value.length-1);//fieldname
var fieldid=_interface2.default.convertFieldNameToId(fieldname);var repalceReg='\\$'+fieldname+'\\$';result=result.replace(new RegExp(repalceReg,"gm"),_interface2.default.getFieldValue(fieldid));});return result;};_this.state={codetype:"",relatefield:"",scancodeData:"",hidetext:"",url:""};return _this;}(0,_createClass3.default)(InsertScanCode,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,jsonparam=_props.jsonparam,otherparam=_props.otherparam;var isPreView=otherparam.isPreView;//兼容老的扫描码 如果scancodeSrc没有 或者为空  则为老数据
var scancodeData="";if(jsonparam.relatefield&&(typeof jsonparam.scancodeData==="undefined"||jsonparam.scancodeData==="")){var fieldarr=jsonparam.relatefield.split(',');_.forEach(fieldarr,function(value){if(value==="requestid"||value==="requestname"){scancodeData+='$'+value+'$';}else{var fieldname=_interface2.default.getFieldInfo(value).fieldname;scancodeData+='$'+fieldname+'$';}});}else{scancodeData=jsonparam.scancodeData?jsonparam.scancodeData:"";//对应数据
}var codetype=jsonparam.codetype?jsonparam.codetype:"";//1:二维码 2：条形码
var hidetext=jsonparam.hidetext?jsonparam.hidetext:"";//条形码是否显示数据文本
var msg=this.calculateRelateValue(scancodeData);if(isPreView==="1")msg="preview";//处理url中含有# 和%的问题
msg=msg.replace(new RegExp("%","gm"),"p_weaver_p");msg=msg.replace(new RegExp("#","gm"),"n_weaver_n");msg=msg.replace(new RegExp("<","gm"),"li_weaver_li");msg=msg.replace(new RegExp(">","gm"),"b_weaver_b");msg=msg.replace(new RegExp("&","gm"),"and_weaver_and");msg=msg.replace(new RegExp("=","gm"),"eq_weaver_eq");msg=msg.replace(new RegExp("\\+","gm"),"add_weaver_add");var url="";if(codetype==='1'){url=(window.ecologyContentPath||'')+'/workflow/createQRCode?firstParam=1';if(msg==="")msg="空";msg=encodeURI(msg);url+="&msg="+msg;}else if(codetype==='2'&&_.trim(msg)!==""){if(/.*[\u4e00-\u9fa5]+.*$/.test(msg)){//校验字符串是否包含中文
url=(window.ecologyContentPath||'')+'/workflow/exceldesign/image/illegalBarCode_wev8.png';}else{url=(window.ecologyContentPath||'')+'/workflow/createWfBarCode?firstParam=1';url+="&type=code128&qz=6&msg="+msg;if(Number(hidetext)===1){url+="&hrp=none";}}}this.setState({codetype:codetype,hidetext:hidetext,url:url});}},{key:'render',value:function render(){var _this2=this;var otherparam=this.props.otherparam;var _state=this.state,url=_state.url,codetype=_state.codetype;var iscreate=otherparam.iscreate;var typeclass=codetype==='1'?"qrcodeimg":"barcodeimg";var showflag=!(iscreate==='1'&&codetype==='2')&&url!=="";return _react2.default.createElement('div',null,showflag&&_react2.default.createElement('img',{className:'scancode '+typeclass,ref:"insertscancode",onLoad:function onLoad(){window.scancodeOperate.readyAdjustSize(_this2.refs.insertscancode);},src:url}));}}]);return InsertScanCode;}(_react2.default.Component))||_class;exports.default=InsertScanCode;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _set=__webpack_require__(130);var _set2=_interopRequireDefault(_set);var _from=__webpack_require__(124);var _from2=_interopRequireDefault(_from);var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _parseLayout=__webpack_require__(68);var Parse=_interopRequireWildcard(_parseLayout);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InsertIframe=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(InsertIframe,_React$Component);function InsertIframe(props){(0,_classCallCheck3.default)(this,InsertIframe);var _this=(0,_possibleConstructorReturn3.default)(this,(InsertIframe.__proto__||(0,_getPrototypeOf2.default)(InsertIframe)).call(this,props));_this.sysFieldName={requestname:"field-1",requestlevel:"field-2",signinput:"field-4",dycs:"field-9",mj:"field-10"};_this.iframeParams={set_id:"",set_name:"",set_src:"",set_style:{},temp_src:"",//用于存储未替换动态遍历的src
dynamicFieldnames:[],//动态改变的字段fieldname
iframeAuto:{},//自适应高度时用的参数
loadHeight:{}//loding的高度
};_this.setIframeParams=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var keys=(0,_keys2.default)(data);keys.forEach(function(key){_this.iframeParams[key]=data[key];});};_this.analyzeDynamicField=function(dynamicFieldnames){var fieldarr=[];_.forEach(dynamicFieldnames,function(value){var repalceReg='\\$\\['+value+'\\]\\$';var fieldid=_interface2.default.convertFieldNameToId(value);fieldarr.push(fieldid);});return fieldarr.join(',');};_this.analyzeField=function(src){//常用参数
var commonPara=['requestid','workflowid','nodeid','formid'];commonPara.map(function(item){var repalceReg='\\$'+item+'\\$';src=src.replace(new RegExp(repalceReg,"gm"),_interface2.default.getBaseInfo()[item]);});//匹配固定参数
var patt=/(\$\[[^\]]+\]\$)|(\$[^$\[\]]+\$)/g;var fixedFieldnames=src.match(patt);//需要去重
fixedFieldnames=(0,_from2.default)(new _set2.default(fixedFieldnames));for(var i=0;i<fixedFieldnames.length;i++){var fieldname=fixedFieldnames[i];fieldname=fieldname.substr(0,fieldname.length-1);fieldname=fieldname.substr(1,fieldname.length-1);var fieldid=_interface2.default.convertFieldNameToId(fieldname);//系统字段处理[requestname,requestlevel,signinput,dycs,mj]field-1  field-2  field-4  field-9   field-10
if(_this.sysFieldName[fieldname]&&fieldid===""){fieldid=_this.sysFieldName[fieldname];}var repalceReg='\\$'+fieldname+'\\$';src=src.replace(new RegExp(repalceReg,"gm"),_interface2.default.getFieldValue(fieldid));}//保存替换过固定参数的src  动态参数改变时 基于此src 再次替换
_this.setIframeParams({temp_src:src});//匹配动态参数 $[]$  绑定事件
var reg=/[^\$\[\]]+(?=\])/g;var dynamicFieldnames=src.match(reg);//需要去重
dynamicFieldnames=(0,_from2.default)(new _set2.default(dynamicFieldnames));_this.setIframeParams({dynamicFieldnames:dynamicFieldnames});//先替换一次动态参数
src=Parse.getDynamicFieldValueSrc(dynamicFieldnames,src);//console.log("src=" + src)
return src;};_this.analyzeStyle=function(style){if(style.trim().length==0){return{};}//先去掉所有空格
style=style.replace(/\s+/g,"");//如果以;结尾 ->去掉
if(_this.confirmEnding(style,";")){style=style.substr(0,style.length-1);}//拼接为json字符串
style='{'+style.replace(/;/g,',')+'}';//console.log(style);
//用双引号包括 key和value  不然解析不出来
style=style.replace(/(?:\s*['"]*)?([a-zA-Z0-9_-]+)(?:['"]*\s*)?:/g,"\"$1\":");style=style.replace(/":/g,"\":\"").replace(/,"/g,"\",\"").replace(/}/g,"\"}");//console.log("jsonArr=" + JSON.parse(style));
return JSON.parse(style);};_this.confirmEnding=function(str,target){var start=str.length-target.length;var arr=str.substr(start,target.length);if(arr==target){return true;}return false;};_this.state={showIframe:false};return _this;}(0,_createClass3.default)(InsertIframe,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,jsonparam=_props.jsonparam,cellMark=_props.cellMark;var set_id=jsonparam.set_id?jsonparam.set_id:"";var set_name=jsonparam.set_name?jsonparam.set_name:"";var set_src=jsonparam.set_src?jsonparam.set_src:"";var set_height=jsonparam.set_height?jsonparam.set_height:"";var set_style=jsonparam.set_style?jsonparam.set_style:"";var height={};if(set_height==="auto"||set_height===""){height={height:"0px"};this.setIframeParams({loadHeight:{height:"100px",lineHeight:"100px"}});this.setIframeParams({iframeAuto:{adjustheight:'y',eachcount:0}});}else{height={height:set_height+"px"};this.setIframeParams({loadHeight:{height:set_height+"px",lineHeight:set_height+"px"}});}var styleObj=this.analyzeStyle(set_style);var style=(0,_extends3.default)({width:"100%"},height,styleObj);var src=this.analyzeField(set_src);this.setIframeParams({set_src:src,set_id:set_id,set_name:set_name,set_style:style});}},{key:'componentDidMount',value:function componentDidMount(){//console.log("-------------componentDidMount------------");
var _iframeParams=this.iframeParams,temp_src=_iframeParams.temp_src,dynamicFieldnames=_iframeParams.dynamicFieldnames;var fieldstr=this.analyzeDynamicField(dynamicFieldnames);var iframeref=this.refs.insertiframe;//字段值改变时触发
_interface2.default.bindFieldChangeEvent(fieldstr,function(obj,id,value){//console.log("WfForm.bindFieldChangeEvent--", obj, id, value);
var src=Parse.getDynamicFieldValueSrc(dynamicFieldnames,temp_src);jQuery(iframeref).attr("src",src);});}//解析动态字段fieldname为fieldidstr
//解析字段
//解析style字符串为对象
//判断str是否以target结尾
},{key:'render',value:function render(){var _this2=this;var showIframe=this.state.showIframe;var _iframeParams2=this.iframeParams,set_id=_iframeParams2.set_id,set_name=_iframeParams2.set_name,set_style=_iframeParams2.set_style,set_src=_iframeParams2.set_src,loadHeight=_iframeParams2.loadHeight,iframeAuto=_iframeParams2.iframeAuto;var hideLodingStyle=showIframe?{dispaly:"none"}:{};var hideIframeStyle=showIframe?{}:{height:"0px"};return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'iframeLoading',style:(0,_extends3.default)({},loadHeight,hideLodingStyle)},_react2.default.createElement('span',null,_react2.default.createElement('img',{src:'/images/loading2_wev8.gif',align:'absmiddle'})),_react2.default.createElement('span',null,(0,_convert.getLabel)(125516,"内容加载中，请稍候..."))),_react2.default.createElement('iframe',(0,_extends3.default)({src:set_src,id:set_id,name:set_name,ref:"insertiframe",onLoad:function onLoad(){_this2.setState({showIframe:true});window.iframeOperate.loadingOver(_this2.refs.insertiframe);},frameBorder:'0',scrolling:'auto',style:(0,_extends3.default)({},set_style,hideIframeStyle)},iframeAuto)));}}]);return InsertIframe;}(_react2.default.Component))||_class;exports.default=InsertIframe;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FnaInvoiceIdentify=function(_React$Component){(0,_inherits3.default)(FnaInvoiceIdentify,_React$Component);function FnaInvoiceIdentify(){(0,_classCallCheck3.default)(this,FnaInvoiceIdentify);var _this=(0,_possibleConstructorReturn3.default)(this,(FnaInvoiceIdentify.__proto__||(0,_getPrototypeOf2.default)(FnaInvoiceIdentify)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(FnaInvoiceIdentify,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('fna',_fileConfig.fnaFiles,init);}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;var _props=this.props,symbol=_props.symbol,commonParam=_props.commonParam;if(hasLoad){var FnaInvoiceIdentifyPage=window.weaFna.com.FnaInvoiceIdentifyPage;return _react2.default.createElement(FnaInvoiceIdentifyPage,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_FnaInvoiceIdentifyPage@libdru'},this.props,{commonParam:commonParam,symbol:symbol}));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@qvuoea'});}}}]);return FnaInvoiceIdentify;}(_react2.default.Component);exports.default=FnaInvoiceIdentify;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CustomContent=function(_React$Component){(0,_inherits3.default)(CustomContent,_React$Component);function CustomContent(){(0,_classCallCheck3.default)(this,CustomContent);return(0,_possibleConstructorReturn3.default)(this,(CustomContent.__proto__||(0,_getPrototypeOf2.default)(CustomContent)).apply(this,arguments));}(0,_createClass3.default)(CustomContent,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){return false;//此组件存储代码块及custompage信息，不做render判断，只通过操作DOM方式append
}},{key:"render",value:function render(){return React.createElement("div",{id:"customScriptDiv"});}}]);return CustomContent;}(React.Component);exports.default=CustomContent;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var HiddenArea=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(HiddenArea,_React$Component);function HiddenArea(){(0,_classCallCheck3.default)(this,HiddenArea);return(0,_possibleConstructorReturn3.default)(this,(HiddenArea.__proto__||(0,_getPrototypeOf2.default)(HiddenArea)).apply(this,arguments));}(0,_createClass3.default)(HiddenArea,[{key:'render',value:function render(){var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var JSComplete=globalStore.JSComplete,submitParam=globalStore.submitParam;var fieldAttrMap=layoutStore.fieldAttrMap,mainData=layoutStore.mainData,detailMap=layoutStore.detailMap,cellInfo=layoutStore.cellInfo,propFileCfg=layoutStore.propFileCfg;var fieldCellInfo=cellInfo.fieldCellInfo||{};var arr=[];_.forIn(submitParam,function(v,k){arr.push(_react2.default.createElement('input',{type:'hidden',id:k,name:k,value:v}));});//字段不在模板上需生成隐藏域
fieldAttrMap.forEach(function(attr,fieldid){if(fieldid in fieldCellInfo)return true;if(attr.isDetail){//明细字段˛
var detailObj=detailMap.get(attr.tableMark);var allRowIndexStr=detailObj.allRowIndexStr,detailData=detailObj.detailData,currentPageRowIndexStr=detailObj.currentPageRowIndexStr,rowInfoArr=detailObj.rowInfoArr;var detail_hideArea_control=propFileCfg.detail_hideArea_control;//优化明细表数据量大时渲染卡顿问题
var detail_optimize_enablenum=detail_hideArea_control>0?detail_hideArea_control:100;var rowIndexStr=rowInfoArr.length>detail_optimize_enablenum?currentPageRowIndexStr:allRowIndexStr;rowIndexStr.split(",").map(function(rowIndex){var fieldKey='field'+fieldid+'_'+rowIndex;var fieldValue=detailData.has(fieldKey)?detailData.get(fieldKey).value:"";arr.push(_react2.default.createElement('input',{type:'hidden',id:fieldKey,name:fieldKey,value:fieldValue}));});}else{var fieldKey='field'+fieldid;var fieldValue=mainData.has(fieldKey)?mainData.get(fieldKey).value:"";if(parseInt(fieldid)<0)fieldKey=FieldUtil.convertSystemFieldName(fieldKey);arr.push(_react2.default.createElement('input',{type:'hidden',id:fieldKey,name:fieldKey,value:fieldValue}));}});//明细相关隐藏域
detailMap.forEach(function(detailObj,detailMark){var detailIndex=parseInt(detailMark.substring(7))-1;var indexnum=detailObj.indexnum,deldtlid=detailObj.deldtlid,rowInfo=detailObj.rowInfo;var submitdtlid="";var nodesnum=0;rowInfo.forEach(function(info,rowKey){nodesnum++;var rowIndex=rowKey.substring(4);submitdtlid+=rowIndex+",";if(info.has("keyid"))arr.push(_react2.default.createElement('input',{type:'hidden',name:'dtl_id_'+detailIndex+'_'+rowIndex,value:info.get("keyid")}));});arr.push(_react2.default.createElement('input',{type:'hidden',id:'nodesnum'+detailIndex,name:'nodesnum'+detailIndex,value:nodesnum}));arr.push(_react2.default.createElement('input',{type:'hidden',id:'indexnum'+detailIndex,name:'indexnum'+detailIndex,value:indexnum}));arr.push(_react2.default.createElement('input',{type:'hidden',id:'submitdtlid'+detailIndex,name:'submitdtlid'+detailIndex,value:submitdtlid}));arr.push(_react2.default.createElement('input',{type:'hidden',id:'deldtlid'+detailIndex,name:'deldtlid'+detailIndex,value:deldtlid}));});return _react2.default.createElement('div',{'class':'hiddenArea',style:{display:"none"}},arr);}}]);return HiddenArea;}(_react2.default.Component))||_class)||_class);exports.default=HiddenArea;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PromptBox=function(_React$Component){(0,_inherits3.default)(PromptBox,_React$Component);function PromptBox(props){(0,_classCallCheck3.default)(this,PromptBox);var _this=(0,_possibleConstructorReturn3.default)(this,(PromptBox.__proto__||(0,_getPrototypeOf2.default)(PromptBox)).call(this,props));_this.state={visible:false,top:0,left:0};return _this;}(0,_createClass3.default)(PromptBox,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this2=this;var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;if(!nextProps.visible||!nextProps.mark){//直接隐藏即可
this.setState({visible:false});return;}if(this.props.mark!==nextProps.mark||this.props.promptType!==nextProps.promptType){var promptType=nextProps.promptType;var mark=nextProps.mark;var isFieldOnlyShow=nextProps.isFieldOnlyShow;var locateObj=void 0;if(promptType===1||promptType===2)locateObj=jQuery("[data-fieldmark='"+mark+"']");else if(promptType===3)locateObj=jQuery("table#oTable"+(parseInt(mark.substring(7))-1));var existLocateObj=locateObj.size()>0;var scrollObj=jQuery(".wf-req-form-scroll");if(existLocateObj&&locateObj.is(":visible")&&!isFieldOnlyShow){//定位元素可见
var totalOffsetTop=locateObj.offset().top+scrollObj.scrollTop();var promptOffsetTop=locateObj.offset().top+locateObj.height()+38;//控制竖向滚动条，将定位DOM放置在可视区域
if(promptOffsetTop<=jQuery("div.wea-new-top-req").height()+20||promptOffsetTop>=jQuery(window).height()){var setOffsetTop=jQuery(window).height()/2-locateObj.height()-60;//设置字段区域底部距离浏览器顶部偏移一半
scrollObj.scrollTop(totalOffsetTop-setOffsetTop);//滚动至可视区域
}//控制明细字段横向滚动条，将定位DOM放置在可视区域
if((promptType===1||promptType===2)&&mark.indexOf("_")>-1){var excelDetailContent=locateObj.closest(".excelDetailContent");var excelDetailTableDiv=locateObj.closest("div.excelDetailTableDiv");if(excelDetailTableDiv.size()>0&&excelDetailTableDiv.attr("data-allowxscroll")==="true"){//开启明细横向滚动条
var detailDivOffsetLeft=excelDetailTableDiv.offset().left;var relativeOffsetLeft=locateObj.offset().left+excelDetailContent.scrollLeft()-detailDivOffsetLeft;//相对明细区域的左偏移
var locateOffsetLeft=locateObj.offset().left;if(locateOffsetLeft<=detailDivOffsetLeft||locateOffsetLeft>=detailDivOffsetLeft+excelDetailTableDiv.width()){//不在可见区域
excelDetailContent.scrollLeft(relativeOffsetLeft-excelDetailTableDiv.width()/2);}}}window.setTimeout(function(){//明细控制滚动条需要时间，稍微延时
var top=totalOffsetTop+locateObj.height()-jQuery("div.wea-new-top-req").height()-jQuery("div.wf-req-top-notice").height();var left=locateObj.offset().left+scrollObj.scrollLeft()-scrollObj.offset().left;_this2.setState({visible:true,top:top,left:left});},20);}else{//定位元素不可见
var noticeInfo="";if(promptType===1){noticeInfo=isFieldOnlyShow?(0,_convert.getLabel)(507230,"未获取到值,请检查表单填写情况！"):(0,_convert.getLabel)(386149,"字段未填值,字段内容被隐藏！");}else if(promptType===3){if(!existLocateObj)noticeInfo=(0,_convert.getLabel)(386150,"未新增数据,明细表未放在模板上！");else noticeInfo=(0,_convert.getLabel)(386151,"未新增数据,明细区域被隐藏！");}if(noticeInfo!==""){message.warning(React.createElement("span",null,React.createElement("span",{className:"prompt-content-label"},"\"",nextProps.lableText,"\""),React.createElement("span",{className:"prompt-content-info"},noticeInfo)),2);}this.setState({visible:false});}}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return this.state.visible!==nextState.visible||this.state.top!==nextState.top||this.state.left!==nextState.left;}},{key:"render",value:function render(){var _getAntd2=(0,_convert.getAntd)(),Icon=_getAntd2.Icon,message=_getAntd2.message;var _props=this.props,lableText=_props.lableText,promptType=_props.promptType;var display=this.state.visible===true?"":"none";var promptContent="";if(promptType===1)promptContent=(0,_convert.getLabel)(21423,"未填写");else if(promptType===2)promptContent=(0,_convert.getLabel)(386152,"为行规则赋值字段，修改无效");else if(promptType===3)promptContent=(0,_convert.getLabel)(383709,"未新增数据");return React.createElement("div",{className:"prompt-box",ref:"promptbox",style:{display:display,top:this.state.top,left:this.state.left}},React.createElement("div",{className:"prompt-arrow"}),React.createElement("div",{className:"prompt-content"},React.createElement(Icon,{ecId:(this&&this.props&&this.props.ecId||'')+"_Icon@ig9qqz",type:"exclamation-circle"}),React.createElement("span",{className:"prompt-content-label",dangerouslySetInnerHTML:{__html:"\""+lableText+"\""}}),React.createElement("span",{className:"prompt-content-info"},promptContent)));}}]);return PromptBox;}(React.Component);exports.default=PromptBox;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _MainLayout=__webpack_require__(133);var _MainLayout2=_interopRequireDefault(_MainLayout);var _LogList=__webpack_require__(276);var _LogList2=_interopRequireDefault(_LogList);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _formUtil=__webpack_require__(11);var FormUtil=_interopRequireWildcard(_formUtil);var _asyncLoad=__webpack_require__(14);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ReqPrint=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(ReqPrint,_React$Component);function ReqPrint(){(0,_classCallCheck3.default)(this,ReqPrint);return(0,_possibleConstructorReturn3.default)(this,(ReqPrint.__proto__||(0,_getPrototypeOf2.default)(ReqPrint)).call(this));}(0,_createClass3.default)(ReqPrint,[{key:'componentDidMount',value:function componentDidMount(){var globalStore=this.props.globalStore;jQuery("body").css("overflow",globalStore.urlParams.isBatchPrint==="true"?"hidden":"auto");jQuery("#container").css("padding","6px 10px");jQuery("#container").css("height","auto");(0,_asyncLoad.controlAsyncLoad)();GlobalUtil.loadCaculateResource();var browserVersion=globalStore.browserVersion;if(browserVersion&&browserVersion.indexOf("IE")>-1)jQuery(".wf-req-print").append('<object id="WebBrowser" classid="CLSID:8856F961-340A-11D0-A96B-00C04FD705A2" height="0" width="0"></object>');}},{key:'componentDidUpdate',value:function componentDidUpdate(preProps){(0,_asyncLoad.controlAsyncLoad)();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var globalStore=this.props.globalStore;globalStore.resetStore();}},{key:'render',value:function render(){var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var JSComplete=globalStore.JSComplete,commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu,variableMap=globalStore.variableMap,controlVariableMap=globalStore.controlVariableMap,_globalStore$urlParam=globalStore.urlParams,urlParams=_globalStore$urlParam===undefined?{}:_globalStore$urlParam;var forward=rightMenu.forward;var dataJson=layoutStore.dataJson,propFileCfg=layoutStore.propFileCfg;var hasLoad=!_.isEmpty(commonParam)&&!_.isEmpty(dataJson);var printLogList=hasLoad?FormUtil.judgePrintLogList():false;var _getEcCom=(0,_convert.getEcCom)(),WeaCustomNew=_getEcCom.WeaCustomNew;var isBatchPrint=urlParams.isBatchPrint;var batch_print_control_width=propFileCfg.batch_print_control_width;var canControlWidth=parseInt(batch_print_control_width)>100;var logListsStyle=isBatchPrint&&canControlWidth?{maxWidth:parseInt(batch_print_control_width)+"px",margin:"0 auto"}:{};var coms=_react2.default.createElement('div',{className:'wf-req-print'},_react2.default.createElement('div',{className:'wf-req-form',style:{margin:"0 auto",marginBottom:'20px'}},hasLoad&&_react2.default.createElement(_MainLayout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MainLayout@fu3w5c',symbol:'main'})),_react2.default.createElement('div',{className:'wf-req-loglist',style:logListsStyle},printLogList&&JSComplete&&_react2.default.createElement(_LogList2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LogList@i3gvqp',commonParam:commonParam,forward:forward,controlVariableMap:controlVariableMap,isRelaodLogList:variableMap.get('isRelaodLogList'),reloadLogListParams:variableMap.get('reloadLogListParams')})));return JSComplete?_react2.default.createElement(WeaCustomNew,null,coms):coms;}}]);return ReqPrint;}(_react2.default.Component))||_class)||_class);exports.default=ReqPrint;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class,_class2,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _reactRouter=__webpack_require__(188);var _convert=__webpack_require__(6);var _FormContent=__webpack_require__(637);var _FormContent2=_interopRequireDefault(_FormContent);var _index=__webpack_require__(279);var _index2=_interopRequireDefault(_index);var _SecondAuthInfo=__webpack_require__(280);var _SecondAuthInfo2=_interopRequireDefault(_SecondAuthInfo);var _StatusAsync=__webpack_require__(651);var _StatusAsync2=_interopRequireDefault(_StatusAsync);var _smartGuessAsync=__webpack_require__(652);var _smartGuessAsync2=_interopRequireDefault(_smartGuessAsync);var _index3=__webpack_require__(654);var _index4=_interopRequireDefault(_index3);var _index5=__webpack_require__(657);var _index6=_interopRequireDefault(_index5);var _index7=__webpack_require__(658);var _index8=_interopRequireDefault(_index7);var _index9=__webpack_require__(661);var _index10=_interopRequireDefault(_index9);var _index11=__webpack_require__(664);var _index12=_interopRequireDefault(_index11);var _requestWithdraw=__webpack_require__(667);var _requestWithdraw2=_interopRequireDefault(_requestWithdraw);var _index13=__webpack_require__(669);var _index14=_interopRequireDefault(_index13);var _index15=__webpack_require__(672);var _index16=_interopRequireDefault(_index15);var _index17=__webpack_require__(674);var _index18=_interopRequireDefault(_index17);var _conformRule=__webpack_require__(251);var _conformRule2=_interopRequireDefault(_conformRule);var _SecondAuthDialog=__webpack_require__(677);var _SecondAuthDialog2=_interopRequireDefault(_SecondAuthDialog);var _SecondAuthDetailDialog=__webpack_require__(678);var _SecondAuthDetailDialog2=_interopRequireDefault(_SecondAuthDetailDialog);var _secondAuthType=__webpack_require__(47);var secondAuthTypes=_interopRequireWildcard(_secondAuthType);var _Resource=__webpack_require__(679);var _Resource2=_interopRequireDefault(_Resource);var _Share=__webpack_require__(680);var _Share2=_interopRequireDefault(_Share);var _ModifyLog=__webpack_require__(681);var _ModifyLog2=_interopRequireDefault(_ModifyLog);var _Forward=__webpack_require__(682);var _Forward2=_interopRequireDefault(_Forward);var _HrmEmployeeSetting=__webpack_require__(683);var _HrmEmployeeSetting2=_interopRequireDefault(_HrmEmployeeSetting);var _SendSms=__webpack_require__(684);var _SendSms2=_interopRequireDefault(_SendSms);var _SendEmail=__webpack_require__(685);var _SendEmail2=_interopRequireDefault(_SendEmail);var _Portal=__webpack_require__(275);var _BatchSubmit=__webpack_require__(686);var _BatchSubmit2=_interopRequireDefault(_BatchSubmit);var _ForwardBack=__webpack_require__(687);var _ForwardBack2=_interopRequireDefault(_ForwardBack);var _Communication=__webpack_require__(688);var _Communication2=_interopRequireDefault(_Communication);var _index19=__webpack_require__(689);var _index20=_interopRequireDefault(_index19);var _NodeInfoDialog=__webpack_require__(282);var _NodeInfoDialog2=_interopRequireDefault(_NodeInfoDialog);var _index21=__webpack_require__(692);var _index22=_interopRequireDefault(_index21);var _RemindSet=__webpack_require__(708);var _RemindSet2=_interopRequireDefault(_RemindSet);var _FollowTypeSelect=__webpack_require__(709);var _FollowTypeSelect2=_interopRequireDefault(_FollowTypeSelect);var _ContinuationProcess=__webpack_require__(284);var _ContinuationProcess2=_interopRequireDefault(_ContinuationProcess);var _OdocModelAndSensitive=__webpack_require__(278);var _OdocModelAndSensitive2=_interopRequireDefault(_OdocModelAndSensitive);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);__webpack_require__(256);var _asyncLoad=__webpack_require__(14);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _rightBtn=__webpack_require__(85);var rightBtn=_interopRequireWildcard(_rightBtn);var _otherModule=__webpack_require__(274);var OtherModule=_interopRequireWildcard(_otherModule);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _analyzeData=__webpack_require__(56);var AI=_interopRequireWildcard(_analyzeData);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _invoiceUtil=__webpack_require__(132);var _linkageControl=__webpack_require__(84);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _getEcCom=(0,_convert.getEcCom)(),WeaReqTop=_getEcCom.WeaReqTop,WeaRightMenu=_getEcCom.WeaRightMenu,WeaErrorPage=_getEcCom.WeaErrorPage,WeaTools=_getEcCom.WeaTools,WeaCustomNew=_getEcCom.WeaCustomNew;//智能预测流程图
//流程提交确认弹框
//合规提醒弹框
//新建邮件
// import OdocTemplateListCom from '../../public/wea-odoc-mouldList';//公文流程套红节点添加套红模板列表
//正文页签下展示公文范文及正文敏感词
var ReqIndex=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore','shareStore','followSelectStore'),_dec(_class=(0,_mobxReact.observer)(_class=(_temp=_class2=function(_React$Component){(0,_inherits3.default)(ReqIndex,_React$Component);function ReqIndex(props){(0,_classCallCheck3.default)(this,ReqIndex);return(0,_possibleConstructorReturn3.default)(this,(ReqIndex.__proto__||(0,_getPrototypeOf2.default)(ReqIndex)).call(this,props));}(0,_createClass3.default)(ReqIndex,[{key:'componentDidMount',value:function componentDidMount(){jQuery("body").attr("class","bodyOverflowHidden");//附件删除、明细删除等动作会清除掉body上的CSS，class不会清除，why?
Util.bindResizeEvent();//解决流程图tab和正文tab高度不能自适应问题1
Util.bindTagTypeShowEvent();//控制流程关注标签弹框是否展示
(0,_linkageControl.initVerifiySource)();(0,_asyncLoad.controlAsyncLoad)();GlobalUtil.loadCaculateResource();}},{key:'componentDidUpdate',value:function componentDidUpdate(preProps){(0,_asyncLoad.controlAsyncLoad)();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var globalStore=this.props.globalStore;var _globalStore$commonPa=globalStore.commonParam,commonParam=_globalStore$commonPa===undefined?{}:_globalStore$commonPa;var useInvoiceCloud=commonParam.useInvoiceCloud;globalStore.resetStore();if(useInvoiceCloud==true){(0,_invoiceUtil.unbindOnMessage)();}}},{key:'render',value:function render(){var _this2=this;var _getEcCom2=(0,_convert.getEcCom)(),WeaShowUrl=_getEcCom2.WeaShowUrl,WeaCollect=_getEcCom2.WeaCollect,WeaDialog=_getEcCom2.WeaDialog,WeaShare=_getEcCom2.WeaShare;var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore,shareStore=_props.shareStore,followSelectStore=_props.followSelectStore;var JSComplete=globalStore.JSComplete,loading=globalStore.loading,tabKey=globalStore.tabKey,commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu,dialogVisible=globalStore.dialogVisible,variableMap=globalStore.variableMap,promptInfo=globalStore.promptInfo,odocIframeUrl=globalStore.odocIframeUrl,_globalStore$promptIn=globalStore.promptInfos,promptInfos=_globalStore$promptIn===undefined?[]:_globalStore$promptIn,secondAuthInfo=globalStore.secondAuthInfo,urlParams=globalStore.urlParams,btnDisabled=globalStore.btnDisabled,apiBtnDisabled=globalStore.apiBtnDisabled,continuationProcessInfo=globalStore.continuationProcessInfo;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,titlename=commonParam.titlename,isshared=commonParam.isshared,helpdocid=commonParam.helpdocid,hasNewCommunication=commonParam.hasNewCommunication,btnLabelName=commonParam.btnLabelName;var _rightMenu$isImportDe=rightMenu.isImportDetail,isImportDetail=_rightMenu$isImportDe===undefined?false:_rightMenu$isImportDe;var _shareStore$msginfo=shareStore.msginfo,msginfo=_shareStore$msginfo===undefined?[]:_shareStore$msginfo,shareParams=shareStore.shareParams,_shareStore$joinerPar=shareStore.joinerParams,joinerParams=_shareStore$joinerPar===undefined?{}:_shareStore$joinerPar;var showAI=urlParams.showAI;var dataJson=layoutStore.dataJson,odocInfo=layoutStore.odocInfo;var containOdocTab=odocInfo.docFlag===true;var hasLoad=!_.isEmpty(commonParam)&&!_.isEmpty(dataJson);var forceRender=variableMap.get("forceRenderReq")||0;//勿刪,控制强制渲染组件
var formTab='',picTab='',statusTab='',odocTab='',resourceTab='',communicationTab='',shareTab='';if(btnLabelName){formTab=btnLabelName.formTab;picTab=btnLabelName.picTab;statusTab=btnLabelName.statusTab;odocTab=btnLabelName.odocTab;resourceTab=btnLabelName.resourceTab;communicationTab=btnLabelName.communicationTab;shareTab=btnLabelName.shareTab;}var dropMenuProps={};dropMenuProps.showUrlDialog=function(){globalStore.controlVariableMap("menu_showUrl",true);};if(hasLoad&&helpdocid>0)dropMenuProps.helpParams={helpDocid:helpdocid};var showOdocTag=true;var showOdocMouldList=false;var showModelAndSensitive=false;if(containOdocTab){var docParam=odocInfo.docParam,docFlag=odocInfo.docFlag,docFieldId=odocInfo.docFieldId;if(!!docParam){var isTextInForm=docParam.isTextInForm;var isColumnShow=docParam.isColumnShow;var isTextInFormCanEdit=docParam.isTextInFormCanEdit;var docfiletype=docParam.docfiletype;var docid=docParam.docid;if((isTextInForm||isColumnShow>0)&&isTextInFormCanEdit>0&&docid>0&&(docfiletype=='2'||docfiletype=='3'||docfiletype=='7'||docfiletype=='6'||docfiletype=='12'||docfiletype=='13'||docfiletype=='14')){showOdocTag=false;}showOdocMouldList=docParam.isShowSelectOtherMould==true&&docParam.hasUsedTemplet!='1'?true:false;showModelAndSensitive=docParam.isEdit=='1'&&(docParam.reTextToModel=='1'||docParam.textShowSenWords=='1'||docParam.showTextSearch=='1'||showOdocMouldList)?true:false;if(!showModelAndSensitive&&tabKey=='odoc'&&document.getElementsByClassName("req-workflow-odoc").length>0){//套红确认后且无需展示敏感词列表时，正文宽度与wf-req-odoc保持一致
document.getElementsByClassName("req-workflow-odoc")[0].style.width=jQuery(".wf-req-odoc").width()+'px';}}}var tabDatas=[{title:formTab,key:"form"},{title:picTab,key:"pic"},{title:statusTab,key:"status"}];var isSupportIweboffice2015App=false;if(odocInfo.openIwebOffice2015NewModel){if(odocInfo.isIwebOffice2015Compatible){var isSupport=this.isSupportIweOffice2015App();if(isSupport){isSupportIweboffice2015App=true;}}else{if(window.navigator.userAgent.indexOf('Chrome')>-1){isSupportIweboffice2015App=true;}}}////且正文只读时、若开启预览服务，放出正文tab页签、走预览服务查看正文，
if(odocInfo&&odocInfo.docParam&&odocInfo.docParam.isEdit!='1'&&(odocInfo.docParam.wpsView||odocInfo.docParam.yozoView||odocInfo.zbview||odocInfo.lightReadView)){isSupportIweboffice2015App=false;}if(containOdocTab&&showOdocTag&&!commonParam.belongTest&&!isSupportIweboffice2015App){if(odocInfo.opentextdefaultnode&&!wfform.getOdocConfig().docParam.isEdit=='1'){tabDatas.unshift({title:odocTab,key:"odoc"});}else{tabDatas.push({title:odocTab,key:"odoc"});}}if(requestid>0&&!_.isEmpty(commonParam))tabDatas.push({title:resourceTab,key:"resource"});if(requestid>0&&isshared=='1'&&!commonParam.belongTest)tabDatas.push({title:shareTab,key:"share"});if(requestid>0&&commonParam.isOpenCommunication==1){tabDatas.push({titleText:communicationTab,title:_react2.default.createElement('div',{className:'form-tab-communication'},_react2.default.createElement('span',null,communicationTab),_react2.default.createElement('span',{className:hasNewCommunication&&!variableMap.has("haveClick_communication")?"form-tab-communication-dot":"form-tab-communication-dotHide"})),key:'communication'});}if(variableMap.has('customTabs')){var customTabs=mobx.toJS(variableMap.get('customTabs'));tabDatas=tabDatas.concat(customTabs);}if(containOdocTab){tabDatas=this.loadOdocCusTabDatas(tabDatas);}//允许拦截接口做排序、重命名
typeof window.WfForm.overrideTabDatas==="function"&&(tabDatas=window.WfForm.overrideTabDatas(tabDatas));var showDropIcon={showDropIcon:true};var rightMenuDisabled=false;if(tabKey=="odoc"){showDropIcon={className:"workflowForm_odoc"};rightMenuDisabled=true;}var titleContent=variableMap.has("attention_titlename")&&typeof variableMap.get("attention_titlename")!="undefined"?titlename+variableMap.get("attention_titlename"):titlename;var wfImportParams=Util.getWfImportParams();return _react2.default.createElement('div',{className:'wf-req'},continuationProcessInfo.loaded&&continuationProcessInfo.showSwitchBar&&_react2.default.createElement(_ContinuationProcess2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_ContinuationProcess@d7pw1v',continuationProcessInfo:continuationProcessInfo}),JSComplete&&WeaShowUrl&&_react2.default.createElement(WeaShowUrl,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaShowUrl@3magwr',urlVisible:variableMap.get("menu_showUrl")||false,onCancel:function onCancel(){return globalStore.controlVariableMap("menu_showUrl",false);}}),JSComplete&&WeaCollect&&!commonParam.belongTest&&_react2.default.createElement(WeaCollect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCollect@jph3y1',favouritetype:'2',favname:Util.getPageTitle(),objid:requestid,visible:variableMap.get("menu_showCollect")||false,onClose:function onClose(){return globalStore.controlVariableMap("menu_showCollect",false);}}),_react2.default.createElement('div',{className:'wf-req-topprompt wf-req-top-notice'},_react2.default.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_TopPrompt@75z8xz',promptInfos:promptInfos,secondAuthInfo:mobx.toJS(secondAuthInfo)})),_react2.default.createElement(WeaRightMenu,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@1ok9r0',width:165},dropMenuProps,{datas:this.getRightMenu(),disabled:rightMenuDisabled}),_react2.default.createElement(WeaReqTop,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaReqTop@mf7fy7',title:_react2.default.createElement('div',{dangerouslySetInnerHTML:{__html:titleContent}}),loading:loading,icon:_react2.default.createElement('i',{className:'icon-coms-workflow'}),iconBgcolor:'#0079DE',buttons:this.getTopButtons(),tabDatas:tabDatas,selectedKey:tabKey,onChange:function onChange(key){return Util.switchFormTab(key);}},showDropIcon,{dropMenuProps:dropMenuProps,dropMenuDatas:this.getRightMenu()}),hasLoad&&_react2.default.createElement(WeaCustomNew,null,_react2.default.createElement(_FormContent2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FormContent@g9f33k'})),_react2.default.createElement('div',{className:'wf-req-picture',style:{display:tabKey==='pic'?'block':'none',height:'100%'}},_react2.default.createElement(_smartGuessAsync2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SmartGuessWfMap@a1t2z6',commonParam:commonParam})),_react2.default.createElement('div',{className:'wf-append-iframe',style:{display:tabKey.indexOf('custom_iframe_')>-1?'block':'none'}},_react2.default.createElement('iframe',{className:'custom-tab-iframe',src:'',style:{border:0,width:'100%',height:'100%'}})),JSComplete&&variableMap.has("haveClick_status")&&_react2.default.createElement('div',{className:'wf-req-status',style:{display:tabKey==='status'?'block':'none'}},_react2.default.createElement(_StatusAsync2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Status@kxpv8k',requestid:requestid})),containOdocTab&&_react2.default.createElement('div',{className:'wf-req-odoc',style:{display:'block',height:tabKey=='odoc'?'calc(100% - 20px)':'1px',overflow:tabKey=='odoc'?'':'hidden'}},_react2.default.createElement('div',{className:showModelAndSensitive?'setOdocModelAndSensitiveIframeWidth iframeDiv':'iframeDiv',style:{height:tabKey=='odoc'?'calc(100% - 20px)':'1px',overflow:tabKey=='odoc'?'':'hidden'}},_react2.default.createElement('iframe',{className:'req-workflow-odoc',src:odocIframeUrl,style:{border:0,width:'100%',height:'100%'}})),showModelAndSensitive&&_react2.default.createElement(_OdocModelAndSensitive2.default,{commonParam:commonParam,odocInfo:odocInfo,tabKey:'odoc'})),variableMap.has("haveClick_resource")&&_react2.default.createElement('div',{className:'wf-req-resources',style:{display:tabKey==='resource'?'block':'none'}},_react2.default.createElement(_Resource2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Resource@pabu9i',commonParam:commonParam})),variableMap.has("haveClick_share")&&_react2.default.createElement('div',{className:'wf-req-share',style:{display:tabKey==='share'?'block':'none'}},_react2.default.createElement(_Share2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Share@l6g5w4',commonParam:commonParam})),variableMap.has("haveClick_communication")&&tabKey==='communication'&&_react2.default.createElement('div',{className:'wf-req-comunication'},_react2.default.createElement(_Communication2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Communication@352a9d',commonParam:commonParam})),hasLoad&&JSComplete&&commonParam.existSynergy&&_react2.default.createElement(_Portal.Synergy,{ecId:(this&&this.props&&this.props.ecId||'')+'_Synergy@of09v0',pathname:'/workflow/req',workflowid:workflowid,requestid:requestid?requestid.toString():"-1"}))),isImportDetail&&dialogVisible.has(type.IMPORT_WF_DETAIL_MODAL)&&dialogVisible.get(type.IMPORT_WF_DETAIL_MODAL)&&_react2.default.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_ImportDetail@32jsho'}),dialogVisible.has('isShowForwardDialog')&&_react2.default.createElement(_Forward2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Forward@re3y0m',forwardParams:variableMap.get('forwardParams'),callBackActions:variableMap.get('callBackActions')}),dialogVisible.has(type.CHOOSE_EXCEPTION_OPERATOR)&&_react2.default.createElement(_index8.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_EhOperator@j688ak',visible:dialogVisible.get(type.CHOOSE_EXCEPTION_OPERATOR)}),dialogVisible.has(type.REJECT_CHOOSE)&&dialogVisible.get(type.REJECT_CHOOSE)&&_react2.default.createElement(_index10.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_RejectChoose@ltios8',visible:dialogVisible.get(type.REJECT_CHOOSE)}),dialogVisible.has(type.ENSURE_SUBMIT)&&dialogVisible.get(type.ENSURE_SUBMIT)&&_react2.default.createElement(_index18.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_EnsureSubmit@xm5aok',promptInfo:promptInfo,store:globalStore,visible:dialogVisible.get(type.ENSURE_SUBMIT)}),dialogVisible.has(type.CONFORM_RULE)&&dialogVisible.get(type.CONFORM_RULE)&&_react2.default.createElement(_conformRule2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_EnsureSubmit@ConformRuleDialog',store:globalStore,visible:true}),dialogVisible.has(type.SELECT_NEXTFLOW)&&dialogVisible.get(type.SELECT_NEXTFLOW)&&_react2.default.createElement(_index20.default,{nodeAttribute:commonParam.currentNodeAttribute,ecId:(this&&this.props&&this.props.ecId||'')+'_SelectNextFlow@1p6jvx',visible:dialogVisible.get(type.SELECT_NEXTFLOW)}),dialogVisible.has(type.SELECT_NEXTFLOW_NODEINFO)&&dialogVisible.get(type.SELECT_NEXTFLOW_NODEINFO)&&_react2.default.createElement(_NodeInfoDialog2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SelectNextFlowNodeInfo@ajf8rg',visible:dialogVisible.get(type.SELECT_NEXTFLOW_NODEINFO)}),dialogVisible.has(type.LOCATION_MAP)&&dialogVisible.get(type.LOCATION_MAP)&&_react2.default.createElement(_index22.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LocationMap@b75rkb',visible:dialogVisible.get(type.LOCATION_MAP)}),dialogVisible.has(type.OVERTIME_SETTING)&&dialogVisible.get(type.OVERTIME_SETTING)&&_react2.default.createElement(_index12.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_OverTimeSetting@sv2j06',visible:dialogVisible.get(type.OVERTIME_SETTING)}),dialogVisible.has(type.WORKFLOW_WITHDRAW)&&dialogVisible.get(type.WORKFLOW_WITHDRAW)&&_react2.default.createElement(_requestWithdraw2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_RequestWithdraw@aq0kt6',visible:dialogVisible.get(type.WORKFLOW_WITHDRAW)}),dialogVisible.has(type.SEND_SMS)&&variableMap.has(type.SEND_SMS_PARAMS)&&_react2.default.createElement(_SendSms2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SendSms@29g2yo',visible:dialogVisible.get(type.SEND_SMS),params:variableMap.get(type.SEND_SMS_PARAMS),closeFun:function closeFun(){globalStore.controlDialogVisible(type.SEND_SMS,false);}}),dialogVisible.has(type.SEND_MAIL)&&variableMap.has(type.SEND_MAIL_PARAMS)&&//<SendSms visible={dialogVisible.get(type.SEND_SMS)} params={variableMap.get(type.SEND_SMS_PARAMS)} closeFun={() => { globalStore.controlDialogVisible(type.SEND_SMS, false) }} />
_react2.default.createElement(_SendEmail2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SendEmail@ll5o1u',visible:dialogVisible.get(type.SEND_MAIL),fwquery:variableMap.get(type.SEND_MAIL_PARAMS),closeFun:function closeFun(){globalStore.controlDialogVisible(type.SEND_MAIL,false);}}),dialogVisible.has(type.PRINT_LOG)&&dialogVisible.get(type.PRINT_LOG)&&_react2.default.createElement(_index14.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_PrintLog@msbdn5',visible:dialogVisible.get(type.PRINT_LOG)}),dialogVisible.has(type.DO_SUPERVISE)&&dialogVisible.get(type.DO_SUPERVISE)&&_react2.default.createElement(_BatchSubmit2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_BatchSubmit@9l3t01',visible:dialogVisible.get(type.DO_SUPERVISE)}),dialogVisible.has(type.FORWARD_BACK)&&dialogVisible.get(type.FORWARD_BACK)&&_react2.default.createElement(_ForwardBack2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_ForwardBack@896sbt',visible:dialogVisible.get(type.FORWARD_BACK),requestid:requestid,callBackActions:variableMap.get('callBackActions')}),variableMap.has(type.HANDLE_REMIND)&&_react2.default.createElement(_RemindSet2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_RemindSet@rb8ode',requestId:requestid,workflowId:workflowid,submitType:variableMap.get(type.SUBMIT_TYPE),callBackActions:variableMap.get('callBackActions')}),dialogVisible.has(type.FORM_MODIFY_LOG)&&_react2.default.createElement(_ModifyLog2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_ModifyLog@xul55i',commonParam:commonParam,visible:dialogVisible.get(type.FORM_MODIFY_LOG),closeFun:function closeFun(){globalStore.controlDialogVisible(type.FORM_MODIFY_LOG,false);}}),dialogVisible.has(type.HRM_EMPLOYEE_SETTING)&&_react2.default.createElement(_HrmEmployeeSetting2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_HrmEmployeeSetting@vno1d5',hrmid:dialogVisible.get(type.HRM_EMPLOYEE_SETTING),closeFun:function closeFun(){globalStore.controlDialogVisible(type.HRM_EMPLOYEE_SETTING,false);}}),dialogVisible.has(secondAuthTypes.SECOND_AUTH_DIALOG)&&_react2.default.createElement(_SecondAuthDialog2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SecondAuthDialog@vg0tpx',visible:dialogVisible.get(secondAuthTypes.SECOND_AUTH_DIALOG)}),dialogVisible.has(secondAuthTypes.AUTH_DETAIL_DIALOG)&&_react2.default.createElement(_SecondAuthDetailDialog2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_SecondAuthDetail@8l0w9b',visible:dialogVisible.get(secondAuthTypes.AUTH_DETAIL_DIALOG)}),dialogVisible.has(type.FREE_FLOW_SET)&&_react2.default.createElement(_index16.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FreeFlowSet@ftdvh8',visible:dialogVisible.get(type.FREE_FLOW_SET),openType:'flowset'}),//流程分享
WeaShare&&_react2.default.createElement(WeaShare,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaShare@ovf4rs',visible:dialogVisible.has(type.SHARE_WORKFLOW)&&dialogVisible.get(type.SHARE_WORKFLOW),onVisibleChange:function onVisibleChange(){globalStore.controlDialogVisible(type.SHARE_WORKFLOW,false);},msginfo:msginfo,shareParams:shareParams},joinerParams)),//流程导入功能
(0,_stringify2.default)(wfImportParams)!=="{}"&&_react2.default.createElement(_index6.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_ImportWf@hjqdds',loading:btnDisabled||apiBtnDisabled,menuName:wfImportParams.menuName,workflowid:wfImportParams.workflowid,formid:wfImportParams.formid,isbill:wfImportParams.isbill,userId:wfImportParams.userId}),window.location.href.indexOf("showE8")>-1&&_react2.default.createElement('div',{className:'back_to_old_req',onMouseEnter:function onMouseEnter(){return globalStore.controlVariableMap("showE8",true);},onMouseLeave:function onMouseLeave(){return globalStore.controlVariableMap("showE8",false);},onClick:function onClick(){openFullWindowHaveBarForWFList(_this2.getE8Url());}},_react2.default.createElement('div',{style:{display:variableMap.get("showE8")?"block":"none"}},_react2.default.createElement('p',null,'E8'),_react2.default.createElement('p',null,(0,_convert.getLabel)(19071,'模式')))),showAI==="1"&&_react2.default.createElement('div',{className:'back_to_old_req',onMouseEnter:function onMouseEnter(){return globalStore.controlVariableMap("showAI",true);},onMouseLeave:function onMouseLeave(){return globalStore.controlVariableMap("showAI",false);},onClick:function onClick(){return AI.openAIPage();}},_react2.default.createElement('div',{style:{display:variableMap.get("showAI")?"block":"none"}},_react2.default.createElement('p',null,'\u667A\u80FD'),_react2.default.createElement('p',null,'\u5206\u6790'))),_react2.default.createElement('iframe',{id:'WfFormFileDownload',name:'WfFormFileDownload',src:'',style:{display:'none'}}),_react2.default.createElement('div',{className:'popShow',style:{position:'absolute',top:followSelectStore.clickPotion.y,left:followSelectStore.clickPotion.x}},_react2.default.createElement(_FollowTypeSelect2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FollowTypeSelect@bo2474',commonParam:commonParam,curStore:followSelectStore,location:this.props.location,refresh:globalStore.getFormAttentionTag})));}},{key:'loadOdocCusTabDatas',value:function loadOdocCusTabDatas(tabDatas){var newTabDatas=tabDatas;var globalStore=this.props.globalStore;var odocCustomTabs=globalStore.odocCustomTabs,isDefaultOpenOdoc=globalStore.isDefaultOpenOdoc,commonParam=globalStore.commonParam;var requestid=commonParam.requestid;if(odocCustomTabs.length>0){newTabDatas=this.initCusTabDatas(odocCustomTabs,isDefaultOpenOdoc,requestid,tabDatas);//有自定义tab则进行页签过滤以及页签切换
}return newTabDatas;}},{key:'initCusTabDatas',value:function initCusTabDatas(customTabs,isDefaultOpenOdoc,requestid,tabDatas){//页签过滤重写
var oldTabArr=[];var notOdocCusTabs=[];//非公文后台表单页签管理添加的页签默认放置最后
for(var i=0;i<tabDatas.length;i++){if(tabDatas[i].key.indexOf("custom_iframe")>=0){notOdocCusTabs.push(tabDatas[i]);}else{oldTabArr.push(tabDatas[i].key);}}var newCusTabs=[];var firstTabItem={};for(var _i=0;_i<customTabs.length;_i++){var item=customTabs[_i];if(item.tabType==0){if(oldTabArr.indexOf(item.key)>=0){newCusTabs.push(item);}else if(item.key=="custom_iframe_haoqian"){newCusTabs.push(item);}}else{newCusTabs.push(item);}if(newCusTabs.length>0){firstTabItem=newCusTabs[0];}}var newTabDatas=newCusTabs.concat(notOdocCusTabs);return newTabDatas;var timer=setInterval(function(){try{if(isDefaultOpenOdoc==true||requestid==""||requestid<1){clearInterval(timer);}else if(WfForm.getBaseInfo&&WfForm.getBaseInfo().workflowid&&WfForm.getBaseInfo().workflowid>0&&jQuery(".wea-new-top-req-content").length>0&&jQuery(".custom-tab-iframe").length>0){WfForm.getGlobalStore().setTabKey(firstTabItem.key);if(firstTabItem.key=="custom_iframe_haoqian"){var context_height=jQuery(".wea-new-top-req-content").height();jQuery(".wf-append-iframe").css({"display":"block","height":context_height});jQuery(".custom-tab-iframe").css({display:"none"});if(jQuery(".custom-haoqian-iframe").length<=0){jQuery(".wf-append-iframe").append('<iframe class="custom-haoqian-iframe" src="'+firstTabItem.url+'" style="width:100%;height:100%;border:none"></iframe>');}else{jQuery(".custom-haoqian-iframe").css({display:"block"});}clearInterval(timer);}else{if(window.openSignApproval&&window.openSignApproval==true){clearInterval(timer);return;}if(firstTabItem.tabType==0){//第一个页签为标准页签直接切换，否则通过返回的URL进行iframe加载
WfForm.switchTab(firstTabItem.key);clearInterval(timer);}else{var url=firstTabItem.url;var _context_height=jQuery(".wea-new-top-req-content").height();jQuery(".wf-append-iframe").css({"display":"block","height":_context_height});if(jQuery(".custom-tab-iframe").length>0){var lastSrc=jQuery(".custom-tab-iframe")[0].src;jQuery(".custom-tab-iframe")[0].src=url;var newSrc=url.split("?")[0];if(lastSrc.indexOf(newSrc)>=0){jQuery(".custom-tab-iframe")[0].contentWindow.location.reload();}clearInterval(timer);}}}}}catch(e){clearInterval(timer);}},500);}},{key:'getE8Url',value:function getE8Url(){var globalStore=this.props.globalStore;var commonParam=globalStore.commonParam;var workflowid=commonParam.workflowid,requestid=commonParam.requestid;if(commonParam.iscreate=="1")return'/workflow/request/AddRequest.jsp?workflowid='+workflowid+'&haveVerifyForward=true';else return'/workflow/request/ViewRequest.jsp?requestid='+requestid+'&haveVerifyForward=true';}//判断当前浏览器是否支持金格插件（金格目前回复只需判断谷歌107版本以上）
},{key:'isSupportIweOffice2015App',value:function isSupportIweOffice2015App(){var userAgent=window.navigator.userAgent;var isSupport=false;try{if(/AppleWebKit\/([\d.]+)/.test(userAgent)){// 匹配Webkit内核（Chrome、Safari浏览器）
if(/Chrome\/([\d.]+)/.test(userAgent)){// 匹配Chrome浏览器
var version=parseFloat(RegExp.$1);if(version>107){isSupport=true;}}}}catch(error){if(window.console){console.log('error',error);}}return isSupport;}},{key:'getTopButtons',value:function getTopButtons(){var _this3=this;var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var _props2=this.props,globalStore=_props2.globalStore,layoutStore=_props2.layoutStore;var btnDisabled=globalStore.btnDisabled,apiBtnDisabled=globalStore.apiBtnDisabled,tabKey=globalStore.tabKey,_globalStore$rightMen=globalStore.rightMenu,rightMenu=_globalStore$rightMen===undefined?{}:_globalStore$rightMen,commonParam=globalStore.commonParam,promptInfo=globalStore.promptInfo,variableMap=globalStore.variableMap;var propFileCfg=layoutStore.propFileCfg;var haveLocked=promptInfo&&promptInfo.prompttype==="editlock"&&promptInfo.haveLocked===true;//被锁定
if(tabKey==="odoc"){return OtherModule.getoDocTopButtons(layoutStore.odocInfo);}var __Load_Script_Complete__=variableMap.get("__Load_Script_Complete__")||false;var hide=propFileCfg.rightbtn_enable_after_script==1&&!__Load_Script_Complete__;var btnArr=[];var _rightMenu$rightMenus=rightMenu.rightMenus,rightMenus=_rightMenu$rightMenus===undefined?[]:_rightMenu$rightMenus,_rightMenu$topBtnCoun=rightMenu.topBtnCount,topBtnCount=_rightMenu$topBtnCoun===undefined?4:_rightMenu$topBtnCoun;rightMenus instanceof Array&&rightMenus.map(function(m,index){var type=m.type,menuName=m.menuName,menuIcon=m.menuIcon,menuFun=m.menuFun,isTop=m.isTop,isLockShow=m.isLockShow,isTest=m.isTest;if(haveLocked&&!isLockShow)return true;if(isTop=="1"&&btnArr.length<topBtnCount){btnArr.push(_react2.default.createElement(Button,{ecId:(_this3&&_this3.props&&_this3.props.ecId||'')+'_Button@2oxqe7@'+index,type:'primary',title:menuName,disabled:btnDisabled||apiBtnDisabled||hide,onClick:function onClick(){_this3.doRightMenuClick(m,isTest);}},_react2.default.createElement('div',{className:'wf-req-top-button'},menuName)));}});return btnArr;}},{key:'getRightMenu',value:function getRightMenu(){var _this4=this;var _props3=this.props,globalStore=_props3.globalStore,layoutStore=_props3.layoutStore;var JSComplete=globalStore.JSComplete,btnDisabled=globalStore.btnDisabled,apiBtnDisabled=globalStore.apiBtnDisabled,tabKey=globalStore.tabKey,rightMenu=globalStore.rightMenu,commonParam=globalStore.commonParam,promptInfo=globalStore.promptInfo,addInnerChangeBtn=globalStore.addInnerChangeBtn,setInnerChangeDialog=globalStore.setInnerChangeDialog,variableMap=globalStore.variableMap;var propFileCfg=layoutStore.propFileCfg;var haveLocked=promptInfo&&promptInfo.prompttype==="editlock"&&promptInfo.haveLocked===true;//被锁定
var __Load_Script_Complete__=variableMap.get("__Load_Script_Complete__")||false;var hide=propFileCfg.rightbtn_enable_after_script==1&&!__Load_Script_Complete__;var btnArr=[];if(tabKey==="share"||tabKey==="odoc")return btnArr;var rightMenus=rightMenu&&rightMenu.rightMenus||[];rightMenus instanceof Array&&rightMenus.map(function(m,index){var type=m.type,menuName=m.menuName,menuIcon=m.menuIcon,menuFun=m.menuFun,isLockShow=m.isLockShow,isTest=m.isTest;if(!Util.isShowRightBtn(m))return true;if(haveLocked&&!isLockShow)return true;var workflowid=commonParam.workflowid,formid=commonParam.formid,isbill=commonParam.isbill,belongTest=commonParam.belongTest;if(belongTest&&menuFun.indexOf("doImportWorkflow")>-1)return true;btnArr.push({key:type+'_'+index,icon:_react2.default.createElement('i',{className:menuIcon}),content:menuName,onClick:function onClick(key){_this4.doRightMenuClick(m,isTest);},disabled:btnDisabled||apiBtnDisabled||hide});});addInnerChangeBtn&&btnArr.push({key:'innerChange',icon:_react2.default.createElement('i',{className:'icon-coms-danweishezhi'}),content:(0,_convert.getLabel)('515700','内部交换'),onClick:function onClick(key){// this.showInnerChangeDialog('', isTest);
setInnerChangeDialog(true);},disabled:false});//添加showAI智能分析按钮
var showAI=globalStore.commonParam.showAI;showAI==1&&this.addShowAiBtn(btnArr);!commonParam.belongTest&&btnArr.push({key:'wf-collect',icon:_react2.default.createElement('i',{className:'icon-coms-Collection'}),content:(0,_convert.getLabel)("28111","收藏"),onClick:function onClick(key){JSComplete&&globalStore.controlVariableMap("menu_showCollect",true);},disabled:false});return btnArr;}},{key:'addShowAiBtn',value:function addShowAiBtn(btnArr){btnArr.push({key:'form_analysis',icon:_react2.default.createElement('i',{className:'icon-coms-Line'}),content:(0,_convert.getLabel)("532397","表单智能分析"),onClick:function onClick(key){AI.openAIPage();},disabled:false});}},{key:'doRightMenuClick',value:function doRightMenuClick(btnInfo,isTest){var commonParam=this.props.globalStore.commonParam;if(commonParam.belongTest&&!isTest){//流程测试禁用的按钮
var _getAntd2=(0,_convert.getAntd)(),Modal=_getAntd2.Modal;Modal.warning({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(386161,"此操作暂不支持流程测试!"),okText:(0,_convert.getLabel)(83446,'\u786E\u5B9A')});return;}//let fn = menuFun.indexOf('this') >= 0 ? `${menuFun.split('this')[0]})` : menuFun;
//eval(key.indexOf("BTN_CUSTOMIZE") > -1 ? fn : `rightBtn.${fn}`);
GlobalUtil.executeRightBtnClick(btnInfo,rightBtn);}}]);return ReqIndex;}(_react2.default.Component),_class2.contextTypes={router:_reactRouter.routerShape},_temp))||_class)||_class);exports.default=WeaTools.tryCatch(_react2.default,function(props){return _react2.default.createElement(WeaErrorPage,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_WeaErrorPage@6ctqth',msg:props.error?props.error:(0,_convert.getLabel)(385218,'对不起，该页面异常，请联系管理员！')});},{error:""})(ReqIndex);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;//一文双屏可编辑展示公文范文及正文敏感词
var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _MainLayout=__webpack_require__(133);var _MainLayout2=_interopRequireDefault(_MainLayout);var _Intervention=__webpack_require__(638);var _Intervention2=_interopRequireDefault(_Intervention);var _freeWorkflowSimple=__webpack_require__(640);var _freeWorkflowSimple2=_interopRequireDefault(_freeWorkflowSimple);var _LogList=__webpack_require__(276);var _LogList2=_interopRequireDefault(_LogList);var _FormSignInput=__webpack_require__(273);var _FormSignInput2=_interopRequireDefault(_FormSignInput);var _RemindTypelist=__webpack_require__(641);var _RemindTypelist2=_interopRequireDefault(_RemindTypelist);var _convert=__webpack_require__(6);var _detailUtil=__webpack_require__(22);var DetailUtil=_interopRequireWildcard(_detailUtil);var _OdocModelAndSensitive=__webpack_require__(278);var _OdocModelAndSensitive2=_interopRequireDefault(_OdocModelAndSensitive);var _getWindow=__webpack_require__(253);var _getWindow2=_interopRequireDefault(_getWindow);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormContent=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(FormContent,_React$Component);function FormContent(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,FormContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=FormContent.__proto__||(0,_getPrototypeOf2.default)(FormContent)).call.apply(_ref,[this].concat(args))),_this),_this.hiddenConflictPanel=function(e){if($('#conflict-panel-box').css('visibility')=='visible'){$('#conflict-panel-box').css({visibility:'hidden'});}},_this.doScrollYEvent=function(){if(_this.scrollEventFn)window.clearTimeout(_this.scrollEventFn);var that=_this;_this.scrollEventFn=window.setTimeout(function(){window.formImgLazyLoad(jQuery('.wf-req-form-scroll'));//图片懒加载
DetailUtil.fixedDetailHead(jQuery(_this));//明细表头固定
window.WfForm.triggerScrollEvent();that.hiddenConflictPanel();},30);},_this.shrink=function(e,float){_this.controlWrapWidth();_this.controlContentWidth(e.target.parentNode,float);},_this.controlContentWidth=function(nowDom,float){var brother=float==="left"?"right":"left";var layoutStore=_this.props.layoutStore;var odocInfo=layoutStore.odocInfo;var docParam=odocInfo.docParam;var documentTextPosition=docParam.documentTextPosition,documentTextProportion=docParam.documentTextProportion;var docIsInNowDom=documentTextPosition==float.substring(0,1);var brotherDom=document.querySelector(".wf-req-form-"+brother);//设置的是wf-req-form-scroll的父层级
if(nowDom.style.width=="100%"){//点击收起动作执行
nowDom.style.width=docIsInNowDom?documentTextProportion+"%":100-documentTextProportion+"%";brotherDom.style.width=docIsInNowDom?100-documentTextProportion+"%":documentTextProportion+"%";}else{//点击展开动作执行
nowDom.style.width="0px";brotherDom.style.width="100%";}},_this.controlWrapWidth=function(isInit){var formArea=void 0;if(jQuery(".wf-req-form-main").parents(".wf-req-form-right").length>0){formArea=jQuery(".wf-req-form-main").parents(".wf-req-form-right");}else{formArea=jQuery(".wf-req-form-main").parents(".wf-req-form-left");}var layoutWidth=parseFloat(jQuery("table.excelMainTable").width());var wrapperDiv=jQuery("div.wf-req-form-main");if(!isInit&&formArea.width()!=0&&formArea.width()<_getWindow2.default.getTop().document.body.offsetWidth){//表单所在区域是半屏的时候，给他设置为全屏
wrapperDiv.css("width","auto");wrapperDiv.parent().css("overflow-x","unset");}else{//表单所在区域不是半屏的时候（全屏/折叠），设置给他设置为半屏
var layoutDom=void 0;if(jQuery("table.excelMainTable")&&jQuery("table.excelMainTable")[0]){layoutDom=jQuery("table.excelMainTable")[0];}if(layoutDom&&layoutDom.style.width==="100%"&&layoutWidth<=jQuery(".wf-req-form").width()){//表格为百分比列宽或px列宽结合百分比列宽使用
}else if(jQuery(".wf-req-form").width()<layoutWidth){//白色背景区域比表格实际宽度窄的时候处理
jQuery(".wf-req-form").css("minWidth",layoutWidth);}else{wrapperDiv.width("unset");wrapperDiv.parent().css("overflow-x","unset");}}},_this.onIframeHover=function(){if(document.querySelector(".wf-req-form-left")&&document.querySelector(".wf-req-form-right")){document.querySelector(".wf-req-form-left").addEventListener("mouseover",function(){document.querySelector(".wf-req-form-left .wf-req-form-left-shrink").style.display="block";});document.querySelector(".wf-req-form-right").addEventListener("mouseover",function(){document.querySelector(".wf-req-form-right .wf-req-form-right-shrink").style.display="block";});document.querySelector(".wf-req-form-left").addEventListener("mouseout",function(){if(this.style.width!="100%")document.querySelector(".wf-req-form-left .wf-req-form-left-shrink").style.display="none";});document.querySelector(".wf-req-form-right").addEventListener("mouseout",function(){if(this.style.width!="100%")document.querySelector(".wf-req-form-right .wf-req-form-right-shrink").style.display="none";});}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(FormContent,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props$globalStore=this.props.globalStore,jumpTab=_props$globalStore.jumpTab,urlParams=_props$globalStore.urlParams,commonParam=_props$globalStore.commonParam;var odocInfo=this.props.layoutStore.odocInfo;jumpTab(urlParams,commonParam);this.onIframeHover();if(odocInfo.docFlag&&odocInfo.docFieldId){//一文双屏
var layoutWidth=parseFloat(jQuery("table.excelMainTable").width());if(jQuery(".wf-req-form").width()<=layoutWidth){//白色背景区域比表格实际宽度窄的时候处理
jQuery(".wf-req-form").css("minWidth",layoutWidth);}var timer=setTimeout(function(){_this2.controlWrapWidth(true);window.clearTimeout(timer);},1500);}}},{key:'renderMain',value:function renderMain(){var _props=this.props,globalStore=_props.globalStore,layoutStore=_props.layoutStore;var JSComplete=globalStore.JSComplete,commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu,variableMap=globalStore.variableMap,markInfo=globalStore.markInfo,controlVariableMap=globalStore.controlVariableMap,remindInfo=globalStore.remindInfo,setTabKey=globalStore.setTabKey;var containSignInput=layoutStore.containSignInput,propFileCfg=layoutStore.propFileCfg;var requestid=commonParam.requestid,requestType=commonParam.requestType,isHideArea=commonParam.isHideArea,intervenorright=commonParam.intervenorright,margin=commonParam.margin,showDefaultSign=commonParam.showDefaultSign,showDefaultLogList=commonParam.showDefaultLogList,showFreeWfSimpleCom=commonParam.showFreeWfSimpleCom,isviewonly=commonParam.isviewonly,belongTest=commonParam.belongTest;var forward=rightMenu.forward;if(!(showDefaultSign==="1"&&(!containSignInput&&requestType>0||intervenorright>0)&&markInfo&&markInfo['hasLoadMarkInfo'])){if(belongTest){try{window.parent.window.workflowAutoTestUtil.returnStatus('signInputReady',requestid);}catch(e){if(window.console)console.log(e);}}}return _react2.default.createElement('div',{className:'wf-req-form-scroll',onScroll:this.doScrollYEvent,onClick:this.hiddenConflictPanel},_react2.default.createElement('div',{className:'wf-req-form-main'},_react2.default.createElement(_RemindTypelist2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_RemindTypelist@cifq6n'},mobx.toJS(remindInfo),{callbackFun:function callbackFun(v){globalStore.changeSubmitParam({remindTypes:v});globalStore.updateRemindInfo((0,_extends3.default)({},mobx.toJS(remindInfo),{value:v}));}})),_react2.default.createElement('div',{className:'wf-req-form-wrapper',style:{margin:margin}},_react2.default.createElement('div',{className:'wf-req-form',style:{margin:"0 auto",marginBottom:'20px'}},_react2.default.createElement(_MainLayout2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MainLayout@kdmfyn',symbol:'main'})),JSComplete&&intervenorright>0&&_react2.default.createElement(_Intervention2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_ReqIntervention@xwzzmi'}),JSComplete&&showFreeWfSimpleCom==1&&_react2.default.createElement(_freeWorkflowSimple2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FreeWorkflowSimple@ijveh0'}),_react2.default.createElement('div',{className:'wf-req-signinput'},showDefaultSign==="1"&&(!containSignInput&&requestType>0||intervenorright>0)&&markInfo&&markInfo['hasLoadMarkInfo']&&_react2.default.createElement(_FormSignInput2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_FormSignInput@l68rdx',isInForm:false})),_react2.default.createElement('div',{className:'wf-req-loglist'},showDefaultLogList==="1"&&requestType!=2&&isHideArea!="1"&&_react2.default.createElement(_LogList2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_LogList@uegmgi',commonParam:commonParam,setTabKey:setTabKey,forward:forward,controlVariableMap:controlVariableMap,variableMap:variableMap,isRelaodLogList:variableMap.get('isRelaodLogList'),reloadLogListParams:variableMap.get('reloadLogListParams')})),window.location.pathname.indexOf('/spa/workflow/')>-1&&propFileCfg.show_duration_log==="1"&&_react2.default.createElement('div',{className:'test-page-load-duration'},_react2.default.createElement('span',{className:'test-page-load-duration-total'},(0,_convert.getLabel)('527647','首屏加载总耗时:'),_react2.default.createElement('span',{style:{fontWeight:800}},window.REQ_LOAD_DURATION/1000||0),' ',(0,_convert.getLabel)(527648,'秒'),_react2.default.createElement('div',{className:'test-page-load-duration-detail'},_react2.default.createElement('p',null,(0,_convert.getLabel)(21586,'请求id'),': ',requestid),_react2.default.createElement('p',null,(0,_convert.getLabel)(386155,'js加载耗时'),': ',window.JS_LOAD_DURATION||0,' ',(0,_convert.getLabel)(26287,'毫秒')),_react2.default.createElement('p',null,(0,_convert.getLabel)(386156,'中转耗时'),': ',window.Route_DURATION||0,' ',(0,_convert.getLabel)(26287,'毫秒')),_react2.default.createElement('p',null,(0,_convert.getLabel)(386157,'异步js耗时'),': ',window.ASYNC_DURATION||0,' ',(0,_convert.getLabel)(26287,'毫秒')),_react2.default.createElement('p',null,(0,_convert.getLabel)(386158,'服务端耗时'),': ',window.SERVER_DURATION||0,' ',(0,_convert.getLabel)(26287,'毫秒')),_react2.default.createElement('p',null,(0,_convert.getLabel)(386159,'接口耗时'),': ',window.API_DURATION||0,' ',(0,_convert.getLabel)(26287,'毫秒')),_react2.default.createElement('p',null,(0,_convert.getLabel)(386160,'渲染耗时'),': ',window.DISPATCH_DURATION||0,' ',(0,_convert.getLabel)(26287,'毫秒'))))))));}},{key:'renderOdoc',value:function renderOdoc(iframeSrc,showModelAndSensitive,documentTextPosition,commonParam,odocInfo){return _react2.default.createElement('div',{className:'wf-req-form-odoc'},documentTextPosition=="r"&&showModelAndSensitive&&_react2.default.createElement(_OdocModelAndSensitive2.default,{commonParam:commonParam,odocInfo:odocInfo,tabKey:'form'}),_react2.default.createElement('iframe',{className:'wf-req-form-odoc-iframe',allowfullscreen:true,allow:'fullscreen',src:iframeSrc,style:{border:0,width:showModelAndSensitive?'calc(100% - 51px)':'100%',height:'100%'}}),documentTextPosition=="l"&&showModelAndSensitive&&_react2.default.createElement(_OdocModelAndSensitive2.default,{commonParam:commonParam,odocInfo:odocInfo,tabKey:'form'}));}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,globalStore=_props2.globalStore,layoutStore=_props2.layoutStore;var tabKey=globalStore.tabKey,commonParam=globalStore.commonParam;var odocInfo=layoutStore.odocInfo,mainData=layoutStore.mainData;var arr=[];var isTextInFormCanEdit=void 0;var hasDocid=void 0;if(WfForm.getOdocConfig()&&WfForm.getOdocConfig().docParam){if(WfForm.getOdocConfig().docParam.isTextInFormCanEdit)isTextInFormCanEdit=WfForm.getOdocConfig().docParam.isTextInFormCanEdit;if(WfForm.getOdocConfig().docParam.hasDocid)hasDocid=WfForm.getOdocConfig().docParam.hasDocid;}if(odocInfo.docFlag&&odocInfo.docFieldId){//一文双屏
var docFieldId=odocInfo.docFieldId,docParam=odocInfo.docParam,srcUrl=odocInfo.srcUrl;var isColumnShow=docParam.isColumnShow,documentTextPosition=docParam.documentTextPosition,documentTextProportion=docParam.documentTextProportion;var docFieldInitValue=mainData.get('field'+docFieldId)&&mainData.get('field'+docFieldId).variable.get("initValue");var _commonParam$authStr=commonParam.authStr,authStr=_commonParam$authStr===undefined?"":_commonParam$authStr,_commonParam$authSign=commonParam.authSignatureStr,authSignatureStr=_commonParam$authSign===undefined?"":_commonParam$authSign;var doc_srcUrl=srcUrl+"&authStr="+authStr+"&authSignatureStr="+authSignatureStr;if(isColumnShow==="1"&&!!hasDocid){var oDocLeft=documentTextPosition=="l";var showModelAndSensitive=isTextInFormCanEdit?docParam.isEdit=='1'&&(docParam.reTextToModel=='1'||docParam.textShowSenWords=='1'||docParam.showTextSearch=='1')?true:false:false;var mainStyle={width:100-documentTextProportion+'%',height:"100%"};var odocStyle={width:documentTextProportion+'%',height:"100%"};odocStyle['border-'+(oDocLeft?"right":"left")]="1px #989A9C solid";odocStyle.float=oDocLeft?"left":"right";mainStyle.float=oDocLeft?"right":"left";arr.push(_react2.default.createElement('div',{style:mainStyle,className:'wf-req-form-'+mainStyle.float},_react2.default.createElement('div',{className:'wf-req-form-'+mainStyle.float+'-shrink',onClick:function onClick(e){_this3.shrink(e,mainStyle.float);}}),this.renderMain()));arr.push(_react2.default.createElement('div',{style:odocStyle,className:'wf-req-form-'+odocStyle.float},_react2.default.createElement('div',{className:'wf-req-form-'+odocStyle.float+'-shrink',onClick:function onClick(e){_this3.shrink(e,odocStyle.float);}}),this.renderOdoc(doc_srcUrl,showModelAndSensitive,documentTextPosition,commonParam,odocInfo)));}}if(arr.length==0)arr.push(this.renderMain());if(isTextInFormCanEdit){return _react2.default.createElement('div',{className:'wf-req-form-content',style:{height:tabKey==='form'?'100%':'1px',width:tabKey==='form'?'100%':'1px'}},arr);}else{return _react2.default.createElement('div',{className:'wf-req-form-content',style:{display:tabKey==='form'?'block':'none'}},arr);}}}]);return FormContent;}(_react2.default.Component))||_class)||_class);exports.default=FormContent;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _index=__webpack_require__(277);var _index2=_interopRequireDefault(_index);var _convert=__webpack_require__(6);var _index3=__webpack_require__(49);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_index3.inject)('globalStore'),_dec(_class=(0,_index3.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);// this.state = {
//     Intervenorid_viewAttr:3,
//     Intervenorid_crm_viewAttr:3
// };
var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.cahngeViewAttr=function(){var _this$props$globalSto=_this.props.globalStore,changeSubmitParam=_this$props$globalSto.changeSubmitParam,submitParam=_this$props$globalSto.submitParam,controlVariableMap=_this$props$globalSto.controlVariableMap;var _submitParam$Interven=submitParam.Intervenorid,Intervenorid=_submitParam$Interven===undefined?"":_submitParam$Interven,_submitParam$Interven2=submitParam.Intervenorid_crm,Intervenorid_crm=_submitParam$Interven2===undefined?"":_submitParam$Interven2,_submitParam$SignType=submitParam.SignType,SignType=_submitParam$SignType===undefined?'':_submitParam$SignType;var ismandatory=(Intervenorid==undefined||Intervenorid=="")&&(Intervenorid_crm==undefined||Intervenorid_crm=="");if(SignType=='2'){//依次逐个处理
//清空客户操作者并隐藏
var updateinfo={};updateinfo.Intervenorid_crm='';changeSubmitParam(updateinfo);controlVariableMap("Intervenorid_crm_replaceDatas",[]);ismandatory=Intervenorid==undefined||Intervenorid=="";}if(ismandatory){controlVariableMap("Intervenorid_viewAttr",3);controlVariableMap("Intervenorid_crm_viewAttr",3);}else{controlVariableMap("Intervenorid_viewAttr",2);controlVariableMap("Intervenorid_crm_viewAttr",2);}};return _this;}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Row=_getAntd.Row,Col=_getAntd.Col;var _getEcCom=(0,_convert.getEcCom)(),WeaBrowser=_getEcCom.WeaBrowser,WeaSelect=_getEcCom.WeaSelect;var _props$globalStore=this.props.globalStore,_props$globalStore$in=_props$globalStore.invertionInfo,invertionInfo=_props$globalStore$in===undefined?{}:_props$globalStore$in,_props$globalStore$va=_props$globalStore.variableMap,variableMap=_props$globalStore$va===undefined?{}:_props$globalStore$va;var _mobx$toJS=mobx.toJS(invertionInfo),title=_mobx$toJS.title,_mobx$toJS$items=_mobx$toJS.items,items=_mobx$toJS$items===undefined?[]:_mobx$toJS$items,_mobx$toJS$enableInte=_mobx$toJS.enableInterSpan,enableInterSpan=_mobx$toJS$enableInte===undefined?'':_mobx$toJS$enableInte,replacedatas=_mobx$toJS.replacedatas,replacedatas_crm=_mobx$toJS.replacedatas_crm;var _mobx$toJS2=mobx.toJS(variableMap),_mobx$toJS2$Interveno=_mobx$toJS2.Intervenorid_replaceDatas,Intervenorid_replaceDatas=_mobx$toJS2$Interveno===undefined?[]:_mobx$toJS2$Interveno,_mobx$toJS2$Interveno2=_mobx$toJS2.Intervenorid_crm_replaceDatas,Intervenorid_crm_replaceDatas=_mobx$toJS2$Interveno2===undefined?[]:_mobx$toJS2$Interveno2,Intervenorid_viewAttr=_mobx$toJS2.Intervenorid_viewAttr,Intervenorid_crm_viewAttr=_mobx$toJS2.Intervenorid_crm_viewAttr;var com=this.getInterventionContent(items,enableInterSpan,Intervenorid_replaceDatas,Intervenorid_crm_replaceDatas,Intervenorid_viewAttr,Intervenorid_crm_viewAttr);return React.createElement('div',{className:'wf-req-intervenor'},React.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfGroup@5jio6n',title:title,needTigger:false,groupBodyComponent:com}));}},{key:'getInterventionContent',value:function getInterventionContent(){var items=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var enableInterSpan=arguments[1];var _replacedatas=arguments[2];var _replacedatas_crm=arguments[3];var _this2=this;var Intervenorid_viewAttr=arguments[4];var Intervenorid_crm_viewAttr=arguments[5];var _getAntd2=(0,_convert.getAntd)(),Row=_getAntd2.Row,Col=_getAntd2.Col;var _getEcCom2=(0,_convert.getEcCom)(),WeaBrowser=_getEcCom2.WeaBrowser,WeaSelect=_getEcCom2.WeaSelect;var _props$globalStore$su=this.props.globalStore.submitParam,submitParam=_props$globalStore$su===undefined?{}:_props$globalStore$su;var SignType=submitParam.SignType||'0';var random=Math.random();return React.createElement('div',null,items.map(function(){var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var domKey=(0,_typeof3.default)(item.domkey)==="object"?item.domkey[0]:item.domkey;var labelcol=item.labelcol,fieldcol=item.fieldcol,label=item.label,conditionType=item.conditionType,_item$domkey=item.domkey,domkey=_item$domkey===undefined?[]:_item$domkey,_item$browserConditio=item.browserConditionParam,browserConditionParam=_item$browserConditio===undefined?{}:_item$browserConditio,_item$options=item.options,options=_item$options===undefined?[]:_item$options,_item$viewAttr=item.viewAttr,viewAttr=_item$viewAttr===undefined?2:_item$viewAttr;var com='';if(conditionType==='SELECT'){com=React.createElement(WeaSelect,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaSelect@e1gk1h@'+domKey,options:options,style:{'minWidth':'120px'},viewAttr:viewAttr,widthMatchOptions:false,fieldName:domkey[0],onChange:_this2.doSelectChangeEvent.bind(_this2,domkey[0])});}else if(conditionType==='BROWSER'){var inputStyle={"width":'300px'};var _browserConditionPara=browserConditionParam.replaceDatas,replaceDatas=_browserConditionPara===undefined?[]:_browserConditionPara;var _viewAttr=3;//if(_replacedatas){
if(domkey=="Intervenorid_crm"){browserConditionParam.replaceDatas=_replacedatas_crm;_viewAttr=Intervenorid_viewAttr;}else{browserConditionParam.replaceDatas=_replacedatas;_viewAttr=Intervenorid_crm_viewAttr;}//}
com=React.createElement(WeaBrowser,(0,_extends3.default)({ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaBrowser@af46pi@'+domKey},browserConditionParam,{viewAttr:_viewAttr,key:random,replaceNotCtrl:true,layout:document.body,inputStyle:inputStyle,fieldName:domkey[0],onChange:_this2.doBrowserChangeEvent.bind(_this2,domkey[0])}));}return domkey=='Intervenorid_crm'&&SignType=='2'?React.createElement('span',null):React.createElement(Row,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Row@tq7seb@'+domKey},React.createElement(Col,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Col@tlicya@'+domKey,span:labelcol},label),React.createElement(Col,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Col@7l4j3b@'+domKey,span:fieldcol},com,domkey[0]=='enableIntervenor'&&React.createElement('span',{style:{"color":"#FF4848","marginLeft":"5px"}},enableInterSpan)));}));}},{key:'doSelectChangeEvent',value:function doSelectChangeEvent(domkey,v){var _props$globalStore2=this.props.globalStore,changeSubmitParam=_props$globalStore2.changeSubmitParam,getInterventionUser=_props$globalStore2.getInterventionUser,controlVariableMap=_props$globalStore2.controlVariableMap,submitParam=_props$globalStore2.submitParam;var _submitParam$SignType2=submitParam.SignType,SignType=_submitParam$SignType2===undefined?'':_submitParam$SignType2;var updateinfo={};updateinfo[domkey]=v;changeSubmitParam(updateinfo);if(domkey=='submitNodeId'){if(v){var arr=v.split("_");var selnodeid=arr[0];var selnodetype=arr[1];getInterventionUser({nodeid:selnodeid,'nodetype':selnodetype,'SignType':SignType});}}if(domkey=='SignType'){this.cahngeViewAttr();}}},{key:'doBrowserChangeEvent',value:function doBrowserChangeEvent(domkey,ids,names,data){var _props$globalStore3=this.props.globalStore,changeSubmitParam=_props$globalStore3.changeSubmitParam,submitParam=_props$globalStore3.submitParam,controlVariableMap=_props$globalStore3.controlVariableMap;var updateinfo={};updateinfo[domkey]=ids;changeSubmitParam(updateinfo);controlVariableMap(domkey+"_replaceDatas",data);this.cahngeViewAttr();}}]);return Main;}(React.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _convert=__webpack_require__(6);var _index=__webpack_require__(49);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_index.inject)('globalStore','freeWflowSimpleStore'),_dec(_class=(0,_index.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.getSearchs=function(){var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools,WeaFormItem=_getEcCom.WeaFormItem,WeaSearchGroup=_getEcCom.WeaSearchGroup;var _getComsMobx=(0,_convert.getComsMobx)(),WeaSwitch=_getComsMobx.WeaSwitch;var _this$props=_this.props,freeWflowSimpleStore=_this$props.freeWflowSimpleStore,globalStore=_this$props.globalStore;var form=freeWflowSimpleStore.form,conditioninfo=freeWflowSimpleStore.conditioninfo;var _globalStore$secLevel=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel===undefined?{}:_globalStore$secLevel;if(!form)return;var formParams=form.getFormParams();var group=[];form.isFormInit&&mobx.toJS(conditioninfo).map(function(c,ecindex){var items=[];c.items.map(function(field){var col=1;var domKey=(0,_typeof3.default)(field.domkey)==="object"?field.domkey[0]:field.domkey;if(formParams.isToNewAddSign&&formParams.isToNewAddSign==2){if(field.domkey[0]==="isToNewAddSign"){items.push({com:React.createElement(WeaFormItem,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_WeaFormItem@rhwoi2@'+domKey,label:''+field.label,labelCol:{span:4,offset:4},ratio1to5:true,error:form.getError(field),tipPosition:'bottom',wrapperCol:{span:16}},React.createElement(WeaSwitch,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_WeaSwitch@oz5jy4@'+domKey,fieldConfig:field,form:form,onChange:_this.onChange})),col:col,hide:form.isHide(field,function(keys,allParams){return false;})});}}else{if(field.domkey[0]=="nodeOperator"&&secLevelInfo.isOpenSec){console.log("field",field);field.browserConditionParam.completeParams.secretLevel=secLevelInfo.secLevel;field.browserConditionParam.dataParams.secretLevel=secLevelInfo.secLevel;field.browserConditionParam.destDataParams.secretLevel=secLevelInfo.secLevel;field.onBeforeFocusCheck=_this.beforeCheck;}if(field.domkey[0]=='approvalSettings'){var tmpOptions=field.options;var _formParams$approvalS=formParams.approvalSettings,approvalSettings=_formParams$approvalS===undefined?'':_formParams$approvalS;var checkOne=approvalSettings.indexOf('1')>-1;var checkTwo=approvalSettings.indexOf('2')>-1;tmpOptions=tmpOptions.map(function(item){if(item.key=='3'||item.key=='4'){item.disabled=!checkOne;}if(item.key=='2'){item.disabled=checkOne;}if(item.key=='5'){item.disabled=!checkTwo;}if(item.key=='6'||item.key=='7'){item.disabled=!checkOne&&!checkTwo;}return item;});field.options=tmpOptions;}items.push({com:React.createElement(WeaFormItem,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_WeaFormItem@jcngon@'+domKey,label:''+field.label,labelCol:{span:4,offset:4},ratio1to5:true,error:form.getError(field),tipPosition:'bottom',wrapperCol:{span:field.domkey[0]==="nodeOperator"||field.domkey[0]==="endTransfer"?8:16}},React.createElement(WeaSwitch,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_WeaSwitch@7s2p43@'+domKey,fieldConfig:field,form:form,onChange:_this.onChange})),col:col,hide:form.isHide(field,function(keys,allParams){return false;})});}});group.push(React.createElement(WeaSearchGroup,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_WeaSearchGroup@e0bjiu@'+ecindex,needTigger:false,title:c.title,showGroup:c.defaultshow,items:items}));});return group;};_this.onChange=function(v,c){var _this$props$freeWflow=_this.props.freeWflowSimpleStore,changeForm=_this$props$freeWflow.changeForm,form=_this$props$freeWflow.form,chengeSubmitParams=_this$props$freeWflow.chengeSubmitParams,setState=_this$props$freeWflow.setState,updateFormFields=_this$props$freeWflow.updateFormFields;if(v["isToNewAddSign"]){changeForm(c.value);}else{var formParams=form.getFormParams();if(formParams.isToNewAddSign==1){setState({toNewFormData:form.getFormDatas()});}var submitParams={};if(v&&v.hasOwnProperty("nodeOperator")){submitParams.operatorids=v.nodeOperator.value||"";}else if(v&&v.hasOwnProperty("countersignAttribute")){submitParams.countersignAttribute=v.countersignAttribute.value||"";}else if(v&&v.hasOwnProperty("endTransfer")){submitParams.isFlowToNext=v.endTransfer.value||"";}else if(v&&v.hasOwnProperty('approvalSettings')){var val=v.approvalSettings.value||'';var temp_val=['1','2','3','4','5','6','7'];var temp_checked={};temp_val.map(function(vkey){temp_checked[vkey]=val.indexOf(vkey)>-1;});if(temp_checked['1']==true){temp_checked['2']=true;}else{temp_checked['3']=false;temp_checked['4']=false;}if(temp_checked['2']==false){temp_checked['5']=false;}if(temp_checked['1']==false&&temp_checked['2']==false){temp_checked['6']=false;temp_checked['7']=false;}val='';temp_val.map(function(vkey){if(temp_checked[vkey]==true){if(val==''){val=vkey;}else{val+=','+vkey;}}});updateFormFields({approvalSettings:val});submitParams.approvalSettings=val;}chengeSubmitParams(submitParams);}};_this.beforeCheck=function(success,fail){var _this$props$globalSto=_this.props.globalStore.secLevelInfo,secLevelInfo=_this$props$globalSto===undefined?{}:_this$props$globalSto;var secLevel=secLevelInfo.secLevel,isOpenSec=secLevelInfo.isOpenSec;var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;if(secLevel==""){message.error(secLevelInfo.tip,3);}else{success();}};return _this;}(0,_createClass3.default)(Main,[{key:'componentWillMount',value:function componentWillMount(){var loadCondition=this.props.freeWflowSimpleStore.loadCondition;var _props$globalStore$ba=this.props.globalStore.baseParam,baseParam=_props$globalStore$ba===undefined?{}:_props$globalStore$ba;setTimeout(function(){//刚加载表单的时候全量组件库还没加载，此时会报WeaForm取不到的错
loadCondition(baseParam);},1000);}},{key:'componentDidMount',value:function componentDidMount(){$('#container').bind('click',function(e){jQuery(".wf-req-freeWorkflowSimple").css("border","1px solid #ddd");});}},{key:'render',value:function render(){return React.createElement('div',{className:'wf-req-freeWorkflowSimple'},this.getSearchs());}}]);return Main;}(React.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _loadjs=__webpack_require__(83);var _loadjs2=_interopRequireDefault(_loadjs);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RemindTypelist=function(_React$Component){(0,_inherits3.default)(RemindTypelist,_React$Component);function RemindTypelist(){(0,_classCallCheck3.default)(this,RemindTypelist);var _this=(0,_possibleConstructorReturn3.default)(this,(RemindTypelist.__proto__||(0,_getPrototypeOf2.default)(RemindTypelist)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(RemindTypelist,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(hasLoad){var _RemindTypelist=window.weaWorkflowPublic.RemindTypelist;return _react2.default.createElement(_RemindTypelist,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_RemindTypelist@lmh4ky'},this.props));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@lae9c7'});}}}]);return RemindTypelist;}(_react2.default.Component);exports.default=RemindTypelist;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){this.bindEvent();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.bindEvent();}},{key:'bindEvent',value:function bindEvent(){jQuery('.wf-error-msg-detail .condition').each(function(){var _a=jQuery(this).attr('index');if(!jQuery.isEmptyObject(_a)){jQuery(this).hover(function(){jQuery('#condit'+_a).css('display','block');jQuery('#condit'+_a).css('left',window.event.clientX);},function(){jQuery('#condit'+_a).css('display','none');});}});}},{key:'render',value:function render(){var _props=this.props,title=_props.title,detail=_props.detail,bottom=_props.bottom;return _react2.default.createElement('div',{className:'wf-error-msg'},_react2.default.createElement('div',{className:'wf-error-msg-left'},_react2.default.createElement('i',{className:'icon-coms02-Warning-01'})),_react2.default.createElement('div',{className:'wf-error-msg-right'},_react2.default.createElement('div',{className:'wf-error-msg-title'},title),detail&&_react2.default.createElement('div',{className:'wf-error-msg-detail',dangerouslySetInnerHTML:{__html:detail}}),bottom&&_react2.default.createElement('div',{className:'wf-error-msg-bottom',dangerouslySetInnerHTML:{__html:bottom}})));}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this));_this.state={showAll:false};return _this;}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _this2=this;var showAll=this.state.showAll;var _props=this.props,isSuccess=_props.isSuccess,title=_props.title,titlesuffix=_props.titlesuffix,operators=_props.operators;return _react2.default.createElement('div',{className:'wf-confirm-msg'},_react2.default.createElement('div',{className:'wf-confirm-msg-content'},_react2.default.createElement('div',{className:'wf-confirm-msg-title'},title,_react2.default.createElement('span',{className:'wf-confirm-msg-titlesuffix',dangerouslySetInnerHTML:{__html:titlesuffix}})),_react2.default.createElement('div',{className:'wf-confirm-msg-operators'},_react2.default.createElement('div',{className:'wf-confirm-msg-receiver-title'},(0,_convert.getLabel)(15525,'接收人'),'\uFF1A'),_react2.default.createElement('div',{className:'wf-confirm-msg-receiver-users'},isSuccess&&operators&&operators.map(function(item,index){if(index>=20&&!showAll)return null;return _this2.getOperatorObj(item);}),isSuccess&&operators.length>20&&showAll&&_react2.default.createElement('i',{className:'icon-coms-up',onClick:this.controlShowAll.bind(this,false)}),isSuccess&&operators.length>20&&!showAll&&_react2.default.createElement('i',{className:'icon-coms-down',onClick:this.controlShowAll.bind(this,true)}),!isSuccess&&_react2.default.createElement('span',{className:'wf-confirm-msg-user'},titlesuffix)))));}},{key:'getOperatorObj',value:function getOperatorObj(item){var obj=new Array();if(!!item.beagentid){//存在代理
obj.push(_react2.default.createElement('a',{className:'wea-hrm-card',href:'javaScript:openhrm('+item.beagentid+')',onClick:function onClick(event){return window.pointerXY(event);}},item.beagentname));obj.push(_react2.default.createElement('span',{className:'wf-confirm-msg-connect-symbol'},'->'));}obj.push(_react2.default.createElement('a',{className:'wea-hrm-card',href:'javaScript:openhrm('+item.operatorid+')',onClick:function onClick(event){return window.pointerXY(event);}},item.operatorname));return _react2.default.createElement('span',{className:'wf-confirm-msg-user'},obj);}},{key:'controlShowAll',value:function controlShowAll(bool){this.setState({showAll:bool});}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _props=this.props,msg=_props.msg,haveLocked=_props.haveLocked;var bgcolor=haveLocked?"#FFFCD8":"#E7F9FF";var icon=haveLocked?"icon-coms-locking":"icon-coms-Prompt";return _react2.default.createElement('div',{className:'wf-lock-msg',style:{backgroundColor:bgcolor}},_react2.default.createElement('div',{className:'wf-lock-msg-content'},_react2.default.createElement('i',{className:icon}),_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:msg}})));}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).apply(this,arguments));}(0,_createClass3.default)(Main,[{key:'render',value:function render(){return _react2.default.createElement('span',null,'SubmitInfo');}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:"render",value:function render(){var _props=this.props,userid=_props.userid,username=_props.username,usertype=_props.usertype,time=_props.time,template=_props.template;String.prototype.replaceAll=function(s1,s2){return this.replace(new RegExp(s1,"gm"),s2);};var msg=template.replaceAll("\\${user}","<span class=\"wf-reject-msg-user\"><a href=\"javaScript:openhrm("+userid+")\" onClick=\"javaScript:window.pointerXY(event)\">"+username+"</a></span>");if(usertype==1){msg=template.replaceAll("\\${user}","<span class=\"wf-reject-msg-user\"><a target=\"_blank\" href=\"/spa/crm/static/index.html#/main/crm/customerView?customerId="+userid+"\" >"+username+"</a></span>");}if(usertype==2){msg=template.replaceAll("\\${user}","<span class=\"wf-reject-msg-user\">"+username+"</span>");}msg=msg.replace("${time}","<span class=\"wf-reject-msg-time\">"+time+"</span>");return _react2.default.createElement("div",{className:"wf-reject-msg"},_react2.default.createElement("span",null,_react2.default.createElement("i",{className:"icon-coms02-Warning-01"})),_react2.default.createElement("span",{dangerouslySetInnerHTML:{__html:msg}}));}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(279);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _props=this.props,userid=_props.userid,username=_props.username,time=_props.time,template=_props.template,otherPromptInfo=_props.otherPromptInfo;String.prototype.replaceAll=function(s1,s2){return this.replace(new RegExp(s1,"gm"),s2);};var msg=template.replaceAll("\\${user}",'<span class="wf-reject-msg-user"><a href="javaScript:openhrm('+userid+')" onClick="javaScript:window.pointerXY(event)">'+username+'</a></span>');msg=msg.replace("${time}",'<span class="wf-reject-msg-time">'+time+'</span>');return _react2.default.createElement('div',null,_react2.default.createElement(_index2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Index@zbzgix'},otherPromptInfo)),_react2.default.createElement('div',{className:'wf-reject-msg'},_react2.default.createElement('span',null,_react2.default.createElement('i',{className:'icon-coms02-Warning-01'})),_react2.default.createElement('span',{dangerouslySetInnerHTML:{__html:msg}})));}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _convert=__webpack_require__(6);var _mobxReact=__webpack_require__(8);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)("showContentStore"),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this));_this.state={showAll:false};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var _getEcCom=(0,_convert.getEcCom)(),WeaTools=_getEcCom.WeaTools;var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;var ls=WeaTools.ls;var _props=this.props,_props$isAutoApprove=_props.isAutoApprove,isAutoApprove=_props$isAutoApprove===undefined?false:_props$isAutoApprove,showContentStore=_props.showContentStore,_props$requestid=_props.requestid,requestid=_props$requestid===undefined?'':_props$requestid,_props$nodeid=_props.nodeid,nodeid=_props$nodeid===undefined?'':_props$nodeid,_props$sessionkey=_props.sessionkey,sessionkey=_props$sessionkey===undefined?'':_props$sessionkey;var changeSpining4True=showContentStore.changeSpining4True,startInterval=showContentStore.startInterval;if(isAutoApprove){changeSpining4True();startInterval(requestid,nodeid,sessionkey);}if(!isAutoApprove){if(ls&&ls.getJSONObj(sessionkey)==null){ls&&ls.set(sessionkey,{showMessage:1});message&&message.success((0,_convert.getLabel)(530822,'流程处理成功'));}}}},{key:'render',value:function render(){var _props2=this.props,_props2$isAutoApprove=_props2.isAutoApprove,isAutoApprove=_props2$isAutoApprove===undefined?false:_props2$isAutoApprove,showContentStore=_props2.showContentStore,_props2$requestid=_props2.requestid,requestid=_props2$requestid===undefined?'':_props2$requestid,_props2$nodeid=_props2.nodeid,nodeid=_props2$nodeid===undefined?'':_props2$nodeid;var spinning=showContentStore.spinning;return _react2.default.createElement('div',null,isAutoApprove&&spinning?this.getContent(spinning):this.getContent(false));}},{key:'getContent',value:function getContent(spinning){var _this2=this;var _getAntd2=(0,_convert.getAntd)(),Spin=_getAntd2.Spin;var showAll=this.state.showAll;var _props3=this.props,nextNodeNames=_props3.nextNodeNames,_props3$operators=_props3.operators,operators=_props3$operators===undefined?[]:_props3$operators,_props3$nextNodeids=_props3.nextNodeids,nextNodeids=_props3$nextNodeids===undefined?'':_props3$nextNodeids,showContentStore=_props3.showContentStore,isAutoApprove=_props3.isAutoApprove;var _showContentStore$aut=showContentStore.auto2NextNodeNames,auto2NextNodeNames=_showContentStore$aut===undefined?"":_showContentStore$aut,_showContentStore$aut2=showContentStore.auto2Operators,auto2Operators=_showContentStore$aut2===undefined?[]:_showContentStore$aut2,_showContentStore$aut3=showContentStore.auto2NextNodeids,auto2NextNodeids=_showContentStore$aut3===undefined?"":_showContentStore$aut3;var nextNodeNamess="";var nextNodeOperatorss="";var nextNodeidss="";if(isAutoApprove&&!spinning&&auto2NextNodeNames!=""){nextNodeNamess=auto2NextNodeNames;nextNodeOperatorss=auto2Operators;nextNodeidss=auto2NextNodeids;}else{nextNodeNamess=nextNodeNames;nextNodeOperatorss=operators;nextNodeidss=nextNodeids;}return _react2.default.createElement('div',{className:'wf-confirm-msg'},Spin&&_react2.default.createElement(Spin,{tip:(0,_convert.getLabel)(530824,'当前流程后续节点存在系统自动处理情况，节点信息正在更新，请稍候...'),spinning:spinning}),!spinning&&_react2.default.createElement('div',{className:'wf-confirm-msg-content'},(nextNodeidss!=''||nextNodeNamess!='')&&_react2.default.createElement('div',{className:'wf-confirm-msg-title'},_react2.default.createElement('div',{className:'wf-confirm-msg-receiver-title'},(0,_convert.getLabel)(530823,'流程到达节点'),': ',nextNodeNamess)),nextNodeOperatorss&&nextNodeOperatorss.length>0&&_react2.default.createElement('div',{className:'wf-confirm-msg-operators'},_react2.default.createElement('div',{className:'wf-confirm-msg-receiver-title'},(0,_convert.getLabel)(15525,'接收人'),'\uFF1A'),_react2.default.createElement('div',{className:'wf-confirm-msg-receiver-users',style:{width:"92%"}},nextNodeOperatorss&&nextNodeOperatorss.map(function(item,index){if(index>=20&&!showAll)return null;return _this2.getOperatorObj(item);}),nextNodeOperatorss.length>20&&!showAll&&_react2.default.createElement('i',{className:'icon-coms-down',onClick:this.controlShowAll.bind(this,true)})),_react2.default.createElement('div',{style:{left:"96%",position:"absolute"}},nextNodeOperatorss.length>20&&showAll&&_react2.default.createElement('i',{className:'icon-coms-up',onClick:this.controlShowAll.bind(this,false)})))));}},{key:'getOperatorObj',value:function getOperatorObj(item){var obj=new Array();if(Number(item.operatortype)==0){if(!!item.beagentid&&item.operatorid){//存在代理
obj.push(_react2.default.createElement('a',{className:'wea-hrm-card',href:'javaScript:openhrm('+item.beagentid+')',onClick:function onClick(event){return window.pointerXY(event);}},item.beagentname));obj.push(_react2.default.createElement('span',{className:'wf-confirm-msg-connect-symbol'},'->'));}item.operatorid&&obj.push(_react2.default.createElement('a',{className:'wea-hrm-card',href:'javaScript:openhrm('+item.operatorid+')',onClick:function onClick(event){return window.pointerXY(event);}},item.operatorname));}else if(Number(item.operatortype)==2){obj.push(_react2.default.createElement('span',null,item.operatorname));}else{obj.push(_react2.default.createElement('a',{target:'_blank',href:'/spa/crm/static/index.html#/main/crm/customerView?customerId='+item.operatorid},item.operatorname));}return _react2.default.createElement('span',{className:'wf-confirm-msg-user'},obj);}},{key:'controlShowAll',value:function controlShowAll(bool){this.setState({showAll:bool});}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _secondAuthUtil=__webpack_require__(86);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);var _formUtil=__webpack_require__(11);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)("globalStore"),_dec(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.scrollDom=function(){var _this$props$globalSto=_this.props.globalStore,tabKey=_this$props$globalSto.tabKey,setTabKey=_this$props$globalSto.setTabKey;if(tabKey!=="form"){setTabKey("form");setTimeout(function(){(0,_formUtil.scrollDom)(".wf-req-freeWorkflowSimple",true,(0,_convert.getLabel)(520577,"请确认流转设定设置"));},500);}else{(0,_formUtil.scrollDom)(".wf-req-freeWorkflowSimple",true,(0,_convert.getLabel)(520577,"请确认流转设定设置"));}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:'wf-freeWFsimple-msg'},_react2.default.createElement('i',{className:'icon-coms-Prompt'}),_react2.default.createElement('span',{className:'wf-freeWFsimple-msg-text'},(0,_convert.getLabel)(514309,"提交流程前请先确认流转设定设置"),'\uFF0C'),_react2.default.createElement('a',{href:'javascript:void(0);',onClick:this.scrollDom},(0,_convert.getLabel)(512307,"查看详情")));}}]);return Main;}(_react2.default.Component))||_class);exports.default=Main;

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactAsyncComponent=__webpack_require__(189);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reactAsyncComponent.asyncComponent)({resolve:function resolve(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 730));},LoadingComponent:function LoadingComponent(){return _react2.default.createElement(_Loading2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Loading@kx6o0i'});}});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactAsyncComponent=__webpack_require__(189);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reactAsyncComponent.asyncComponent)({resolve:function resolve(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 731));},LoadingComponent:function LoadingComponent(){return _react2.default.createElement(_Loading2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Loading@84a3hy'});}});

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var _ecCom=__webpack_require__(51);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Panel=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Panel,_React$Component);function Panel(){(0,_classCallCheck3.default)(this,Panel);return(0,_possibleConstructorReturn3.default)(this,(Panel.__proto__||(0,_getPrototypeOf2.default)(Panel)).apply(this,arguments));}(0,_createClass3.default)(Panel,[{key:'componentDidMount',value:function componentDidMount(){this.setPanelPosition();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.setPanelPosition();}//设置操作者信息面板的相对位置
},{key:'setPanelPosition',value:function setPanelPosition(){var _props=this.props,clickposX=_props.clickposX,clickposY=_props.clickposY;var panel=document.getElementById('wfFrontOperator-container');var wrapBox=document.getElementById('container');var wrapBoxWidth=wrapBox.offsetWidth;var wrapBoxHeight=wrapBox.offsetHeight;var objWidth=panel.offsetWidth;var objHeight=panel.offsetHeight;//操作者面板边缘防撞
if(clickposX+objWidth>wrapBoxWidth){panel.style.left=wrapBoxWidth-objWidth-5+'px';}else{panel.style.left=clickposX+'px';}if(clickposY+objHeight>wrapBoxHeight){panel.style.top=wrapBoxHeight-objHeight-20+'px';}else{panel.style.top=clickposY+'px';}}//拼接a标签的href地址
},{key:'createUrl',value:function createUrl(obj){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var _props2=this.props,store=_props2.store,info=_props2.info,isGroup=_props2.isGroup,isFromMobile=_props2.isFromMobile;var workflowid=_base2.default.globalStore.commonParam.workflowid;var str='';var targetUrl=(window.ecologyContentPath||'')+'/spa/workflow/static4engine/engine.html#/main/workflowengine/path/pathSet/group?workflowId='+workflowid+'&nodeid='+info.nodeid+'&nodetype='+info.nodeType+'&groupid=';if(isFromMobile){return'javascript:void(0)';}if(type=='notOperate'&&isGroup){var groupId=parseInt(info.nodeOperatorName.split('#')[2].replace('_',''));str+=targetUrl+=groupId;}else if(obj.type&&obj.type!==0&&!(type=='notOperate'&&info.nodeType==2)){//客户？
str='/spa/crm/static/index.html#/main/crm/customerView?customerId='+info.nodeOperatorGropId;}else{str+='javaScript:openhrm('+obj.id+');';}return str;}//a标签打开链接跳转的方式
},{key:'openFunc',value:function openFunc(obj,type){var info=this.props.info;if(type=='notOperate'&&info.nodeType==2){str='_blank';}}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,store=_props3.store,setoperator=_props3.setoperator,info=_props3.info,_props3$isForOperator=_props3.isForOperator,isForOperator=_props3$isForOperator===undefined?false:_props3$isForOperator,_props3$isForLineInfo=_props3.isForLineInfo,isForLineInfo=_props3$isForLineInfo===undefined?false:_props3$isForLineInfo,isGroup=_props3.isGroup;var lineInfo=store.lineInfo,operatorInfo=store.operatorInfo;return _react2.default.createElement(_react2.default.Fragment,{ecId:(this&&this.props&&this.props.ecId||'')+'_undefined@b0pqsu'},_react2.default.createElement(_ecCom.WeaPopoverHrm,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPopoverHrm@8rnkvx'},_react2.default.createElement('div',{className:'wfFrontOperator-header'},getLabel('99','操作者')),isForOperator&&operatorInfo.length!==0&&!isGroup&&_react2.default.createElement('div',{id:'wfFrontOperator-main'},info.nodeType!==3&&operatorInfo[0].notOperators.length!==0&&_react2.default.createElement('div',{className:'operatorItem'},_react2.default.createElement('div',{className:'notOperate'},getLabel('28500','未操作')),operatorInfo[0].notOperators.map(function(item){if(item.type==2){return _react2.default.createElement('a',{style:{cursor:'default'}},item.name);}else{if(item.hasAgent){return[_react2.default.createElement('a',{href:_this2.createUrl(item,'notOperate'),target:_this2.openFunc(item,'notOperate'),onClick:function onClick(e){return window.pointerXY(e);}},item.name),'->',_react2.default.createElement('a',{href:_this2.createUrl(item,'notOperate'),target:_this2.openFunc(item,'notOperate'),onClick:function onClick(e){return window.pointerXY(e);}},item.agent.name)];}else{return _react2.default.createElement('a',{href:_this2.createUrl(item,'notOperate'),target:_this2.openFunc(item,'notOperate'),onClick:function onClick(e){return window.pointerXY(e);}},item.name);}}})),info.nodeType!==3&&operatorInfo[0].viewers.length!==0&&_react2.default.createElement('div',{className:'operatorItem'},_react2.default.createElement('div',{className:'checked'},getLabel('18006','已查看')),operatorInfo[0].viewers.map(function(item){if(item.type==2){return _react2.default.createElement('a',{style:{cursor:'default'}},item.name);}else{if(item.hasAgent){return[_react2.default.createElement('a',{href:_this2.createUrl(item),onClick:function onClick(e){return window.pointerXY(e);}},item.name),'->',_react2.default.createElement('a',{href:_this2.createUrl(item.agent),onClick:function onClick(e){return window.pointerXY(e);}},item.agent.name)];}else{return _react2.default.createElement('a',{href:_this2.createUrl(item),onClick:function onClick(e){return window.pointerXY(e);}},' ',item.name);}}})),operatorInfo[0].operators.length!==0&&_react2.default.createElement('div',{className:'operatorItem'},info.nodeType!==3&&_react2.default.createElement('div',{className:'operated'},getLabel(28499,'已操作')),operatorInfo[0].operators.map(function(item){if(item.type==2){return _react2.default.createElement('a',{style:{cursor:'default'}},item.name);}else{if(item.hasAgent){return[_react2.default.createElement('a',{href:_this2.createUrl(item),onClick:function onClick(e){return window.pointerXY(e);}},item.name),'->',_react2.default.createElement('a',{href:_this2.createUrl(item.agent),onClick:function onClick(e){return window.pointerXY(e);}},item.agent.name)];}else{return _react2.default.createElement('a',{href:_this2.createUrl(item),onClick:function onClick(e){return window.pointerXY(e);}},' ',item.name);}}}))),isForOperator&&operatorInfo.length==0&&isGroup&&_react2.default.createElement('div',{id:'wfFrontOperator-main'},_react2.default.createElement('div',{className:'operatorItem'},_react2.default.createElement('a',{href:this.createUrl({},'notOperate'),target:'_blank'},setoperator(info.nodeOperatorName)))),isForOperator&&operatorInfo.length==0&&!isGroup&&info.nodeType!=2&&_react2.default.createElement('div',{id:'wfFrontOperator-main'},_react2.default.createElement('div',{className:'operatorItem'},_react2.default.createElement('p',null,getLabel('81558','正在加载数据，请稍后'))))));}}]);return Panel;}(_react2.default.Component))||_class;exports.default=Panel;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _mobxReact=__webpack_require__(8);__webpack_require__(655);var _convert=__webpack_require__(6);var _index=__webpack_require__(277);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(656);var _index4=_interopRequireDefault(_index3);var _common=__webpack_require__(10);var _formUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * 明细导入
 */var Main=(_dec=(0,_mobxReact.inject)('globalStore','importFieldLinkageStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);// /////
function Main(props){(0,_classCallCheck3.default)(this,Main);var _this2=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this2.cancelEvent=function(){var controlDialogVisible=_this2.props.globalStore.controlDialogVisible;controlDialogVisible('importWfDetailModal',false);_this2.refs.group1.setShowGroup(true);_this2.refs.group2.setShowGroup(true);_this2.refs.group3.setShowGroup(true);$('.download-temp').find('input[name=excelfile]').val('');};_this2.IMportDialog=function(){var _this2$props=_this2.props,globalStore=_this2$props.globalStore,importFieldLinkageStore=_this2$props.importFieldLinkageStore;var JSComplete=globalStore.JSComplete,_globalStore$commonPa=globalStore.commonParam,commonParam=_globalStore$commonPa===undefined?{}:_globalStore$commonPa,_globalStore$loading=globalStore.loading,loading=_globalStore$loading===undefined?false:_globalStore$loading,dialogVisible=globalStore.dialogVisible;var _this2$state=_this2.state,filename=_this2$state.filename,isShowDemoModal=_this2$state.isShowDemoModal;var _getEcCom=(0,_convert.getEcCom)(),WeaTable=_getEcCom.WeaTable,WeaDialog=_getEcCom.WeaDialog;var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var successFlage=void 0;_this2.state.submitBackData.successData==0?successFlage=false:successFlage=true;var columns=[{title:'sheet',dataIndex:'title',key:'title',sorter:true,width:'18%'},{title:(0,_convert.getLabel)(27592,'行'),dataIndex:'row',key:'row',sorter:true,width:'10%'},{title:(0,_convert.getLabel)(18621,'列'),dataIndex:'col',key:'col',width:'10%'},{title:(0,_convert.getLabel)(24960,'提示信息'),dataIndex:'info',width:'52%',key:'info',render:function render(text,record){return React.createElement('sapn',{style:{color:'red',fontSize:'12px'}},text);}}];return React.createElement(WeaDialog,{visible:_this2.state.importResultDialogVisible,loadCss:true,initLoadCss:true,parentClassName:'wea-import-wf-detail',style:{width:'700px',height:'400px'},hasScroll:true,maskClosable:false,onCancel:_this2.importResultSure,icon:'icon-coms-workflow',iconBgcolor:'#0079DE',title:(0,_convert.getLabel)(82341,'导入结果'),buttons:[React.createElement(Button,{type:'primary',size:'large',onClick:function onClick(){_this2.importResultSure();}},(0,_convert.getLabel)(826,'确定'))]},React.createElement('div',{style:{position:'relative',top:'45%',transform:'translateY(-50%)',padding:'0 20px'}},React.createElement('div',{style:{textAlign:'center',height:'100%',marginBottom:'20px',display:'flex',justifyContent:'center'}},!successFlage?React.createElement('div',{style:{color:'#FF0000',fontSize:'30px'}},React.createElement('i',{className:'icon-coms-Clear'})):React.createElement('div',{style:{color:'#54D3A4',fontSize:'30px'}},React.createElement('i',{className:'icon-coms02-icon-Completion'})),React.createElement('div',{style:{lineHeight:'40px',fontSize:'12px'}},'  \xA0\xA0 ',_this2.state.submitBackData.msg)),React.createElement('div',null,_this2.state.submitBackData.msg2&&React.createElement('div',{style:{marginBottom:'10px'}},React.createElement('span',{style:{fontSize:'12px',color:'#FF0000'}},_this2.state.submitBackData.msg2)),_this2.state.submitBackData.dataSource.length!=0&&React.createElement(WeaTable,{columns:columns,dataSource:_this2.state.submitBackData.dataSource,childrenColumnName:'subList',pagination:false,scroll:{y:150},needScroll:true}))));};_this2.importSetting=function(flage){var _this2$props2=_this2.props,importFieldLinkageStore=_this2$props2.importFieldLinkageStore,globalStore=_this2$props2.globalStore;var getDetailExpSetFn=importFieldLinkageStore.getDetailExpSetFn,changeSettingDialogVisibleFn=importFieldLinkageStore.changeSettingDialogVisibleFn;var _globalStore$commonPa2=globalStore.commonParam,commonParam=_globalStore$commonPa2===undefined?{}:_globalStore$commonPa2;var workflowid=commonParam.workflowid;changeSettingDialogVisibleFn(flage);// 弹框显影方法
var parm={workflowid:workflowid};flage==true&&getDetailExpSetFn(parm);};_this2.getSearchs=function(){var importFieldLinkageStore=_this2.props.importFieldLinkageStore;var conditions=importFieldLinkageStore.conditions,fixedForm=importFieldLinkageStore.fixedForm;var _getEcCom2=(0,_convert.getEcCom)(),WeaSearchGroup=_getEcCom2.WeaSearchGroup,WeaFormItem=_getEcCom2.WeaFormItem,WeaSwitch=_getEcCom2.WeaSwitch;var group=[];fixedForm&&fixedForm.isFormInit&&conditions.map(function(c){group.push(React.createElement(WeaSearchGroup,{needTigger:true,title:c.title,showGroup:c.defaultshow,items:c.items.map(function(field){return{com:React.createElement(WeaFormItem,{label:field.label// labelCol={{ span: `${field.labelcol}` }}
// wrapperCol={{ span: `${field.fieldcol}` }}
,labelCol:{span:9,offset:3},wrapperCol:{span:9}},React.createElement(WeaSwitch,{fieldConfig:field,form:fixedForm})),col:1};})}));});return group;};_this2.saveimportSetting=function(){var _getAntd2=(0,_convert.getAntd)(),Modal=_getAntd2.Modal,message=_getAntd2.message;var _this2$props3=_this2.props,importFieldLinkageStore=_this2$props3.importFieldLinkageStore,globalStore=_this2$props3.globalStore;var fixedForm=importFieldLinkageStore.fixedForm,saveDetailExpSetFn=importFieldLinkageStore.saveDetailExpSetFn;var _globalStore$commonPa3=globalStore.commonParam,commonParam=_globalStore$commonPa3===undefined?{}:_globalStore$commonPa3;var requestid=commonParam.requestid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,workflowid=commonParam.workflowid;var parm=fixedForm.getFormParams();parm.workflowid=workflowid;saveDetailExpSetFn(parm);// 调保存接口
};_this2.importResultSure=function(){var _this2$props4=_this2.props,globalStore=_this2$props4.globalStore,importFieldLinkageStore=_this2$props4.importFieldLinkageStore;var _globalStore$commonPa4=globalStore.commonParam,commonParam=_globalStore$commonPa4===undefined?{}:_globalStore$commonPa4,controlDialogVisible=globalStore.controlDialogVisible;var requestid=commonParam.requestid,ismode=commonParam.ismode;globalStore.setLoading(false);controlDialogVisible('importWfDetailModal',false);setTimeout(function(){if(importFieldLinkageStore.isFormula=='1'&&ismode==2){(0,_formUtil.reloadRequestPage)({requestid:requestid,importDetail:'1'});}else{(0,_formUtil.reloadRequestPage)({requestid:requestid});}},500);_this2.setState({importResultDialogVisible:false});};_this2.submitEvent=function(){var _this=_this2;var _getAntd3=(0,_convert.getAntd)(),Modal=_getAntd3.Modal,message=_getAntd3.message;var fileid=_this2.state.fileid;var _this2$props5=_this2.props,globalStore=_this2$props5.globalStore,importFieldLinkageStore=_this2$props5.importFieldLinkageStore;var _getEcCom3=(0,_convert.getEcCom)(),WeaTools=_getEcCom3.WeaTools;var _globalStore$commonPa5=globalStore.commonParam,commonParam=_globalStore$commonPa5===undefined?{}:_globalStore$commonPa5,controlDialogVisible=globalStore.controlDialogVisible;var workflowid=commonParam.workflowid,requestid=commonParam.requestid,ismode=commonParam.ismode,modeid=commonParam.modeid,formid=commonParam.formid,isbill=commonParam.isbill,nodeid=commonParam.nodeid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,wfTestStr=commonParam.wfTestStr;globalStore.setLoading(true);var params={requestid:requestid,ismode:ismode,modeid:modeid,formid:formid,isbill:isbill,nodeid:nodeid,src:'save',isfromE9:1,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,wfTestStr:wfTestStr,isFieldTrigger:importFieldLinkageStore.isFieldTrigger,fileid:fileid};WeaTools.callApi('/api/workflow/reqform/doImportDetail','POST',params).then(function(reVal){if(reVal.message!=undefined&&reVal.message!=''&&JSON.parse(reVal.message).Parsing==true){_this.setState({submitBackData:JSON.parse(reVal.message),importResultDialogVisible:true});globalStore.setLoading(false);}else{globalStore.setLoading(false);Modal.warning({title:(0,_convert.getLabel)(28535,'信息提示'),content:reVal.msg||(0,_convert.getLabel)(528080,'解析模板失败')});}// if (!reVal.noRight) {
//     const {message = ''} = reVal;
//     Modal.warning({
//         content: message.replace(/\\n/g, ''),
//         okText: getLabel(826,'确定'),
//         showClose: false,
//         onOk() {
//             controlDialogVisible('importWfDetailModal', false);
//             setTimeout(function () {
//                 if (importFieldLinkageStore.isFormula == "1" && ismode == 2) {
//                     reloadRequestPage({requestid, "importDetail": "1"});
//                 } else {
//                     reloadRequestPage({requestid});
//                 }
//             },500)
//         }
//     });
// } else {
//     globalStore.setLoading(false);
// }
});};_this2.doFileChangeEvent=function(e){var fileInfo=e.currentTarget.files[0];var _fileInfo$name=fileInfo.name,name=_fileInfo$name===undefined?'':_fileInfo$name,_fileInfo$type=fileInfo.type,type=_fileInfo$type===undefined?'':_fileInfo$type;_this2.setState({filename:name,type:type});};_this2.state={filename:'',isShowDemoModal:false,fileid:'',importResultDialogVisible:false,submitBackData:{msg:'',totalData:0,successData:0,Parsing:true,failData:0,dataSource:[]}};return _this2;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var importFieldLinkageStore=this.props.importFieldLinkageStore;var workflowid=this.props.globalStore.commonParam.workflowid;importFieldLinkageStore.riggerFieldLinkageCfg({});importFieldLinkageStore.riggerFormulaCfg({workflowid:workflowid});importFieldLinkageStore.getExportFieldType({workflowid:workflowid});}},{key:'render',value:function render(){var _this3=this;var _getAntd4=(0,_convert.getAntd)(),Modal=_getAntd4.Modal,Row=_getAntd4.Row,Col=_getAntd4.Col,Button=_getAntd4.Button,message=_getAntd4.message;var _getEcCom4=(0,_convert.getEcCom)(),WeaTools=_getEcCom4.WeaTools,WeaDialog=_getEcCom4.WeaDialog,WeaCheckbox=_getEcCom4.WeaCheckbox,WeaUpload=_getEcCom4.WeaUpload,WeaSelect=_getEcCom4.WeaSelect;var warning=Modal.warning;var _props=this.props,globalStore=_props.globalStore,importFieldLinkageStore=_props.importFieldLinkageStore;var JSComplete=globalStore.JSComplete,_globalStore$commonPa6=globalStore.commonParam,commonParam=_globalStore$commonPa6===undefined?{}:_globalStore$commonPa6,_globalStore$loading2=globalStore.loading,loading=_globalStore$loading2===undefined?false:_globalStore$loading2,dialogVisible=globalStore.dialogVisible;var _state=this.state,filename=_state.filename,isShowDemoModal=_state.isShowDemoModal,fileid=_state.fileid;var workflowid=commonParam.workflowid,requestid=commonParam.requestid,ismode=commonParam.ismode,modeid=commonParam.modeid,formid=commonParam.formid,isbill=commonParam.isbill,nodeid=commonParam.nodeid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,wfTestStr=commonParam.wfTestStr,workflowname=commonParam.workflowname;var visible=false;var SettingDialogVisible=importFieldLinkageStore.SettingDialogVisible;if(dialogVisible.has('importWfDetailModal')){visible=dialogVisible.get('importWfDetailModal');}var exportFieldOptions=[{key:'0',showname:(0,_convert.getLabel)('528205','仅导出可编辑列'),selected:importFieldLinkageStore.exportFieldType=='0'},{key:'1',showname:(0,_convert.getLabel)('528206','导出全部可见列'),selected:importFieldLinkageStore.exportFieldType=='1'}];var downloadTemplate=React.createElement('a',{onClick:this.downloadTemplate.bind(this,(window.ecologyContentPath||'')+'/api/workflow/reqform/dowloadTemplate?requestid='+requestid+'&workflowid='+workflowid+'&nodeid='+nodeid+'&modeid='+modeid+'&_t='+new Date().getTime()),target:'_blank'},''+workflowname+(0,_convert.getLabel)(64,'模板'));var fieldTriggerCom=React.createElement(WeaCheckbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@6n82h9',value:importFieldLinkageStore.isFieldTrigger,display:'switch',onChange:function onChange(v){var para={isFieldTrigger:v===''?importFieldLinkageStore.isFieldTrigger:v};importFieldLinkageStore.updateIsFieldTrigger(para);},helpfulTip:(0,_convert.getLabel)(512580,'明细导入时执行字段联动将直接修改数据库值')});var fieldFormulaCom=React.createElement(WeaCheckbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@191wfn',value:importFieldLinkageStore.isFormula,display:'switch',onChange:function onChange(v){var para={isFormula:v===''?importFieldLinkageStore.isFormula:v,workflowid:workflowid};importFieldLinkageStore.updateIsFormula(para);},helpfulTip:(0,_convert.getLabel)(514695,'启用后，触发动作为“值改变时”的明细表公式会在导入后执行，注意执行公式后需保存表单数据才会入库。')});var downloadTemp=React.createElement('div',{className:'download-temp'},React.createElement(Row,null,React.createElement(Col,{span:10,style:{height:'28px',lineHeight:'28px'}},React.createElement(_index4.default,null),(0,_convert.getLabel)(530028,'模板导出列设置')+'\uFF1A'),React.createElement(Col,{span:14,style:{height:'28px',lineHeight:'28px'}},React.createElement(WeaSelect,{options:exportFieldOptions,value:importFieldLinkageStore.exportFieldType,detailtype:3,viewAttr:2,onChange:function onChange(v,showname){importFieldLinkageStore.updateExportFieldType({workflowid:workflowid,exportFieldType:v});}}))),React.createElement(Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@0fuyyu'},React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@ubscpl',span:10,style:{height:'28px',lineHeight:'28px'}},React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@rggef0',value:'2'}),(0,_convert.getLabel)(28576,'下载模板')+'\uFF1A'),React.createElement(Col,{span:14,style:{height:'28px',lineHeight:'28px'},className:'file-url'},React.createElement('div',{style:{width:'250px',float:'left'}},React.createElement('div',{className:'download-temp_name',title:workflowname},downloadTemplate)),React.createElement('div',{style:{lineHeight:'28px',height:'28px',marginLeft:'15px',display:"inlineBlock",float:'left'}},React.createElement(Button,{type:'ghost',size:'large',onClick:function onClick(){_this3.importSetting(true);}},(0,_convert.getLabel)(529991,'字段格式设置'))))),React.createElement(Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@habu81'},React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@t6y2cu',span:10,style:{height:'28px',lineHeight:'28px'}},React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@mdqutl',value:'3'}),(0,_convert.getLabel)(16630,'上传Excel')+'\uFF1A'),React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@txo9np',span:14},React.createElement('div',{style:{width:'100%'}},React.createElement(WeaUpload,{uploadUrl:'/api/doc/upload/uploadFile',category:'string',multiSelection:false,maxFilesNumber:1,limitType:'xls,xlsx',viewAttr:3,maxUploadSize:5,isDetail:true,showClearAll:false,requiredInfo:(0,_convert.getLabel)(522554,'未选择任何文件'),prohibitType:'rar',onChange:function onChange(data,list,listT,listB){// unde
console.log('list',list);if(list.length>0){_this3.setState({fileid:list[0].fileid});}else if(list.length==0){_this3.setState({fileid:''});}console.log('data',data);},onUploading:function onUploading(status){return console.log('主表 status: ',status);},sortable:false,showFilesize:false,editable:false})))),React.createElement(Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@712rqa'},React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@92lgq6',span:10,style:{height:'28px',lineHeight:'28px'}},React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@gqvi2k',value:'4'}),(0,_convert.getLabel)(512581,'导入时执行明细表字段联动')+'\uFF1A'),React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@gug8q1',span:14,style:{height:'28px',lineHeight:'28px'},className:'file-url'},fieldTriggerCom)),ismode==2&&React.createElement(Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@be7cgx'},React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@3zo4uy',span:10,style:{height:'28px',lineHeight:'28px'}},React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@dq0gt1',value:'5'}),(0,_convert.getLabel)(514693,'导入时执行明细表公式')+'\uFF1A'),React.createElement(Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@1haor3',span:14,style:{height:'28px',lineHeight:'28px'},className:'file-url'},fieldFormulaCom)));var steps=React.createElement('div',{className:'steps'},React.createElement('ul',null,React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@6ru2j6',value:'1'}),(0,_convert.getLabel)(27578,'请先下载'),React.createElement('span',{className:'template-download-url'},downloadTemplate),(0,_convert.getLabel)(386198,'进行填写导入明细内容，第一行为表单明细字段的名称。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@g3icja',value:'2'}),(0,_convert.getLabel)(514843,'上传Excel”中选择填写好的Excel文件，并点击操作菜单中的“明细导入”按钮。'))));var precautions=React.createElement('div',null,React.createElement('ul',null,React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@guekyh',value:'1'}),(0,_convert.getLabel)(27582,'导入明细数据时会将原有明细内容删除，导入新的模板中内容。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@mzg3ky',value:'2'}),(0,_convert.getLabel)(27583,'只有可编辑的字段才能进行导入，如果查看的字段有默认值的会自动加上默认值。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@o2uqeq',value:'3'}),(0,_convert.getLabel)(27584,'模板中第一行为表单明细字段名称，从第二行开始导入明细数据。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@vi95yh',value:'4'}),(0,_convert.getLabel)(27585,'明细数据之间不能有空行。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@sulll2',value:'5'}),(0,_convert.getLabel)(27586,'如果有多个明细时模板中会有多个SHEET，一个明细一个SHEET。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@81t46m',value:'6'}),(0,_convert.getLabel)(27587,'数字类型字段不要有特殊格式，例如：科学计数法，千分位，货币符号等。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@2tqlo2',value:'7'}),(0,_convert.getLabel)(515445,'浏览类型字段直接输入名称，也可同时输入名称+"##"+主键，例如：ID为20的人员“张三”，可输入“张三”、“##20”或“张三##20”。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@tyk1ck',value:'8'}),(0,_convert.getLabel)(27589,'check类型字段输入“1/0”或“是/否”。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@ex20jd',value:'9'}),(0,_convert.getLabel)(514546,'下拉框、复选框、单选框类型字段直接输入选项显示名称。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@ru8v1q',value:'10'}),(0,_convert.getLabel)(514547,'多选浏览框或复选框填写多个值以英文半角逗号“,”分隔。')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@7iga95',value:'11'}),(0,_convert.getLabel)(531076,'人力资源字段支持编号导入，填写格式为：“workcode_具体编号”或者“名称workcode_具体编号”')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@eysqs3',value:'12'}),(0,_convert.getLabel)(531077,'部门字段支持编号导入，填写格式为：“deptcode_具体编号”或者“名称deptcode_具体编号”')),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@qq0ahx',value:'13'}),importFieldLinkageStore.tips13),React.createElement('li',null,React.createElement(_index4.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfCircleIcon@5qo2ml',value:'14'}),(0,_convert.getLabel)(515450,'支持行列规则(普通模式和HTML模式)、字段联动，不支持模板模式下的单元格公式计算，不支持属性联动。'))));return React.createElement('div',null,React.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@vanu6k',visible:visible,loadCss:true,initLoadCss:true,parentClassName:'wea-import-wf-detail',style:{width:'871px',height:'500px'},hasScroll:true,maskClosable:false,onCancel:this.cancelEvent,icon:'icon-coms-workflow',iconBgcolor:'#0079DE',title:(0,_convert.getLabel)(26255,'明细导入'),buttons:[React.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@ba8v57@dimport',type:'primary',size:'large',disabled:loading||fileid=='',onClick:this.submitEvent},(0,_convert.getLabel)(26255,'明细导入')),React.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@rmuv9t@close',type:'ghost',size:'large',disabled:loading,onClick:this.cancelEvent},(0,_convert.getLabel)(309,'关闭'))]},React.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfGroup@yem50k',ref:'group1',title:(0,_convert.getLabel)(28576,'下载模板'),groupBodyComponent:downloadTemp}),React.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfGroup@8g8ead',ref:'group2',title:(0,_convert.getLabel)(27577,'操作步骤'),groupBodyComponent:steps}),React.createElement(_index2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfGroup@sqzhcu',ref:'group3',title:(0,_convert.getLabel)(15736,'使用注意事项'),groupBodyComponent:precautions})),React.createElement(WeaDialog,{visible:SettingDialogVisible,loadCss:true,initLoadCss:true,parentClassName:'wea-import-wf-detail',style:{width:'600px',height:'190px'},hasScroll:true,maskClosable:false,onCancel:function onCancel(){_this3.importSetting(false);},icon:'icon-coms-workflow',iconBgcolor:'#0079DE',title:(0,_convert.getLabel)(529991,'字段格式设置'),buttons:[React.createElement(Button,{type:'primary',size:'large',onClick:function onClick(){_this3.saveimportSetting();}},(0,_convert.getLabel)(86,'保存')),React.createElement(Button,{type:'ghost',size:'large',onClick:function onClick(){_this3.importSetting(false);}},(0,_convert.getLabel)(309,'关闭'))]},this.getSearchs()),this.IMportDialog());}},{key:'cancelEvent',value:function cancelEvent(){var controlDialogVisible=this.props.globalStore.controlDialogVisible;controlDialogVisible('importWfDetailModal',false);this.refs.group1.setShowGroup(true);this.refs.group2.setShowGroup(true);this.refs.group3.setShowGroup(true);$('.download-temp').find('input[name=excelfile]').val('');}},{key:'openDemo',value:function openDemo(){this.setState({isShowDemoModal:true});}},{key:'downloadTemplate',value:function downloadTemplate(url){jQuery('#WfFormFileDownload').attr('src',url);}}]);return Main;}(React.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);return(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _props=this.props,_props$background=_props.background,background=_props$background===undefined?'#D8D8D8':_props$background,_props$fontSize=_props.fontSize,fontSize=_props$fontSize===undefined?'12px':_props$fontSize,_props$color=_props.color,color=_props$color===undefined?'#333':_props$color,_props$width=_props.width,width=_props$width===undefined?'20px':_props$width,_props$height=_props.height,height=_props$height===undefined?'20px':_props$height,_props$value=_props.value,value=_props$value===undefined?'1':_props$value;var _style={background:background,fontSize:fontSize,color:color,width:width,height:height,borderRadius:'50%',textAlign:'center',lineHeight:height,display:'inline-block',marginRight:'18px'};return React.createElement('span',{style:_style},value);}}]);return Main;}(React.Component);exports.default=Main;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _index=__webpack_require__(49);var _formUtil=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_index.inject)('globalStore'),_dec(_class=(0,_index.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.doSureEvent=function(){var _getAntd=(0,_convert.getAntd)(),Modal=_getAntd.Modal;var warning=Modal.warning;var browser=window.ImportWfBrowser;var newRequestid=browser.get()?browser.get().id:'';if((0,_common.trim)(newRequestid).length>0){browser.closeModal&&browser.closeModal();(0,_formUtil.requestImport)(newRequestid);}else{warning({content:(0,_convert.getLabel)(20149,"请至少选择一条记录。"),okText:(0,_convert.getLabel)(83446,'确定'),showClose:false,onOk:function onOk(){}});}};_this.doCancelEvent=function(){var browser=window.ImportWfBrowser;browser.closeModal();};return _this;}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getAntd2=(0,_convert.getAntd)(),Modal=_getAntd2.Modal,Button=_getAntd2.Button;var _getEcCom=(0,_convert.getEcCom)(),WeaBrowser=_getEcCom.WeaBrowser;var _props=this.props,globalStore=_props.globalStore,menuName=_props.menuName,_props$workflowid=_props.workflowid,workflowid=_props$workflowid===undefined?-1:_props$workflowid,formid=_props.formid,isbill=_props.isbill,userId=_props.userId,_props$loading=_props.loading,loading=_props$loading===undefined?false:_props$loading;var JSComplete=globalStore.JSComplete;var bottomBtn=[React.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@16pejj@confirm',type:'primary',loading:loading,size:'large',onClick:this.doSureEvent},(0,_convert.getLabel)(83446,'确定')),React.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@t3gzn1@cancel',size:'large',loading:loading,onClick:this.doCancelEvent},(0,_convert.getLabel)(31129,'取消'))];var f_weaver_belongto_userid=globalStore.commonParam.f_weaver_belongto_userid||"";var f_weaver_belongto_usertype=globalStore.commonParam.f_weaver_belongto_usertype||"";var conditionDataParams={importWfBrow:'1',workflowid:workflowid};var dataParams={importWfBrow:'1',formid:formid,isbill:isbill,f_weaver_belongto_usertype:f_weaver_belongto_usertype,f_weaver_belongto_userid:f_weaver_belongto_userid};return React.createElement(WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@z92i9l',type:"16",title:(0,_convert.getLabel)(24270,"导入流程"),isSingle:true,icon:"icon-coms-workflow",iconColor:"#fff",iconBgcolor:"#0079DE",viewAttr:2,customized:true,hasAdvanceSerach:true,hasRadio:true,ref:function ref(ImportWfBrowser){return window.ImportWfBrowser=ImportWfBrowser;},dataParams:dataParams,conditionDataParams:conditionDataParams,buttons:bottomBtn});}}]);return Main;}(React.Component))||_class)||_class);exports.default=Main;var openImportWfWindow=function openImportWfWindow(url){var redirectUrl=url;var width=780;var height=590;var left=(window.screen.availWidth-780)/2;var top=(window.screen.availHeight-590)/2;var szFeatures="top="+top+",";szFeatures+="left="+left+",";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";//channelmode
window.open(redirectUrl,"",szFeatures);};window.openImportWfWindow=openImportWfWindow;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _Content=__webpack_require__(659);var _Content2=_interopRequireDefault(_Content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('ehOperatorStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doCancel=function(){var ehOperatorStore=_this.props.ehOperatorStore;ehOperatorStore.doCancel();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var visible=this.props.visible;return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@xn91r7',visible:visible,loadCss:true,initLoadCss:true,title:(0,_convert.getLabel)(384721,'请选择下一节点操作者'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:this.doCancel,style:{width:"600px",height:"290px"},layout:jQuery('.wf-req')[0]},_react2.default.createElement(_Content2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Content@kjd8m4'},this.props)));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);__webpack_require__(660);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('ehOperatorStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doConfirm=function(){var ehOperatorStore=_this.props.ehOperatorStore;var ehform=ehOperatorStore.ehform;var _ehform$getFormParams=ehform.getFormParams(),relationship=_ehform$getFormParams.relationship,operators=_ehform$getFormParams.operators;ehform.validateForm().then(function(f){if(f.isValid){var ehparams={eh_setoperator:"y",isFirstSubmit:1};ehparams=(0,_extends3.default)({},ehparams,{eh_relationship:relationship,eh_operators:operators});ehOperatorStore.callBackEvent(ehparams);}else{f.showErrors();}});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var ehOperatorStore=this.props.ehOperatorStore;ehOperatorStore.doInit();}},{key:'render',value:function render(){var _this2=this;var _getEcCom=(0,_convert.getEcCom)(),WeaFormItem=_getEcCom.WeaFormItem,WeaSearchGroup=_getEcCom.WeaSearchGroup,WeaRightMenu=_getEcCom.WeaRightMenu,WeaDialogFooter=_getEcCom.WeaDialogFooter;var _getComsMobx=(0,_convert.getComsMobx)(),WeaSwitch=_getComsMobx.WeaSwitch;var ehOperatorStore=this.props.ehOperatorStore;var fields=ehOperatorStore.fields,ehform=ehOperatorStore.ehform;var formParams=ehform&&ehform.getFormParams();var items=[];ehform&&ehform.isFormInit&&fields.map(function(field){var domKey=(0,_typeof3.default)(field.domkey)==="object"?field.domkey[0]:field.domkey;items.push({com:_react2.default.createElement(WeaFormItem,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaFormItem@s8un66@'+domKey,label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol},error:ehform.getError(field),tipPosition:'bottom'},_react2.default.createElement(WeaSwitch,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaSwitch@9db84w@'+domKey,fieldConfig:field,form:ehform,formParams:formParams})),col:1});});return _react2.default.createElement('div',{className:'wf-eh-choose-operator'},_react2.default.createElement('div',{className:'wf-eh-choose-operator-content'},_react2.default.createElement(WeaRightMenu,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@l3c9mi'},this.getMoreBtns()),_react2.default.createElement(WeaSearchGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSearchGroup@jynzqx',needTigger:false,showGroup:true,items:items}))),_react2.default.createElement(WeaDialogFooter,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialogFooter@8benav',buttons:this.getButtons(),moreBtn:this.getMoreBtns()}));}},{key:'getButtons',value:function getButtons(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var buttons=[];buttons.push(_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@gemfk8@confirm',type:'primary',onClick:this.doConfirm},(0,_convert.getLabel)(83446,'确定')));return buttons;}},{key:'getMoreBtns',value:function getMoreBtns(){var _this3=this;var btns=[];btns.push({key:'0',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:(0,_convert.getLabel)(83446,'确定'),onClick:function onClick(key){return _this3.doConfirm();}});return{datas:btns};}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _Content=__webpack_require__(662);var _Content2=_interopRequireDefault(_Content);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('rejectStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doCancel=function(){var rejectStore=_this.props.rejectStore;rejectStore.cancelEvent();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var _props=this.props,visible=_props.visible,rejectStore=_props.rejectStore;var _rejectStore$basePara=rejectStore.baseParams,baseParams=_rejectStore$basePara===undefined?{}:_rejectStore$basePara;var dialogHeight="500px";//只需要选择退回后再提交到达节点时，dialog的高度缩小
if(!(baseParams.isrejectremind=="1"&&baseParams.ischangrejectnode=="1")&&baseParams.isselectrejectnode==="0"&&baseParams.isSubmitDirectNode=="2"){dialogHeight="200px";}return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@faydjt',visible:visible,loadCss:true,initLoadCss:true,title:(0,_convert.getLabel)(84508,'退回设置'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:this.doCancel,style:{width:"720px",height:dialogHeight},layout:jQuery('.wf-req')[0]},_react2.default.createElement(_Content2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Content@5qg60o'},this.props)));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(663);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('rejectStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doConfirm=function(){var rejectStore=_this.props.rejectStore;var rejectNodeList=rejectStore.rejectNodeList,result=rejectStore.result;if(rejectNodeList.length>0&&!result.rejectNodeKey){message.warning((0,_convert.getLabel)(26436,"请选择退回节点"));return;}rejectStore.confirmEvent(mobx.toJS(result));},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var rejectStore=this.props.rejectStore;rejectStore.doInit();}},{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button,message=_getAntd.message;var _getEcCom=(0,_convert.getEcCom)(),WeaTable=_getEcCom.WeaTable,WeaSearchGroup=_getEcCom.WeaSearchGroup,WeaHelpfulTip=_getEcCom.WeaHelpfulTip,WeaDialogFooter=_getEcCom.WeaDialogFooter,WeaRightMenu=_getEcCom.WeaRightMenu,WeaFormItem=_getEcCom.WeaFormItem,WeaSelect=_getEcCom.WeaSelect,WeaBrowser=_getEcCom.WeaBrowser;var rejectStore=this.props.rejectStore;var _rejectStore$rejectNo=rejectStore.rejectNodeList,rejectNodeList=_rejectStore$rejectNo===undefined?[]:_rejectStore$rejectNo,_rejectStore$remindNo=rejectStore.remindNodeList,remindNodeList=_rejectStore$remindNo===undefined?[]:_rejectStore$remindNo,_rejectStore$isSubmit=rejectStore.isSubmitDirectOptions,isSubmitDirectOptions=_rejectStore$isSubmit===undefined?[]:_rejectStore$isSubmit,showAllRejectNodeOperators=rejectStore.showAllRejectNodeOperators;return _react2.default.createElement('div',{className:'wf-reject-choose'},_react2.default.createElement('div',{className:'wf-reject-choose-content'},_react2.default.createElement(WeaRightMenu,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@qgh9yr'},this.getMoreBtns()),rejectNodeList.length>0&&this.renderNodeTable(),remindNodeList.length>0&&this.renderRemindTable(),isSubmitDirectOptions.length>0&&this.renderSubmitDirectSelect())),_react2.default.createElement(WeaDialogFooter,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialogFooter@0069er',buttons:this.getButtons(),moreBtn:this.getMoreBtns()}));}},{key:'renderNodeTable',value:function renderNodeTable(){var _this2=this;var _getAntd2=(0,_convert.getAntd)(),Button=_getAntd2.Button,message=_getAntd2.message;var _getEcCom2=(0,_convert.getEcCom)(),WeaTable=_getEcCom2.WeaTable,WeaSearchGroup=_getEcCom2.WeaSearchGroup,WeaHelpfulTip=_getEcCom2.WeaHelpfulTip,WeaDialogFooter=_getEcCom2.WeaDialogFooter,WeaRightMenu=_getEcCom2.WeaRightMenu,WeaFormItem=_getEcCom2.WeaFormItem,WeaSelect=_getEcCom2.WeaSelect,WeaBrowser=_getEcCom2.WeaBrowser;var rejectStore=this.props.rejectStore;var rejectNodeList=rejectStore.rejectNodeList,result=rejectStore.result,rejectNodeOperators=rejectStore.rejectNodeOperators,showAllRejectNodeOperators=rejectStore.showAllRejectNodeOperators,setShowAllRejectNodeOperators=rejectStore.setShowAllRejectNodeOperators;var columns=[{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(15070,'节点名称')),key:"nodename",dataIndex:"nodename",width:"45%"},{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(99,'操作者')),key:"operator",dataIndex:"operator",width:"55%"}];var datas=[];rejectNodeList&&rejectNodeList.map(function(item){var row=mobx.toJS(item);var operators=mobx.toJS(rejectNodeOperators[row.key]);var show=showAllRejectNodeOperators[row.key];row=(0,_extends3.default)({},row,{operator:_this2.getOperatorCom(operators,show,function(){setShowAllRejectNodeOperators(row.key);})});if(row.key.indexOf("_1")>-1||row.key.indexOf("_3")>-1){row.nodename=_react2.default.createElement('div',null,_react2.default.createElement('span',null,row.nodename),_react2.default.createElement(WeaHelpfulTip,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaHelpfulTip@v2p8ia@'+row.key,title:(0,_convert.getLabel)(126503,"将流程退回至上一次分叉后的状态，即到达上一次所有走过分支的第一个节点")}));}else if(row.key.indexOf("_2")>-1){row.nodename=_react2.default.createElement('div',null,_react2.default.createElement('span',null,row.nodename),_react2.default.createElement(WeaHelpfulTip,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaHelpfulTip@fn3ars@'+row.key,title:(0,_convert.getLabel)(126504,"将流程退回至上一次分叉合并前的状态，即到达上一次所有走过分支的最后一个节点")}));}datas.push(row);});var rowSelection={type:"radio",selectedRowKeys:[result.rejectNodeKey],onChange:function onChange(selectedRowKeys,selectedRows){var _ref2=selectedRows&&selectedRows[0]||{},key=_ref2.key;rejectStore.appendResult({rejectNodeKey:key});}};return _react2.default.createElement(WeaSearchGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSearchGroup@4ij3dz',className:'notitleLineGroup',needTigger:true,title:(0,_convert.getLabel)(26436,"请选择退回节点"),showGroup:true},_react2.default.createElement(WeaTable,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTable@i5uv38',columns:columns,dataSource:datas,rowSelection:rowSelection,pagination:false}));}},{key:'renderRemindTable',value:function renderRemindTable(){var _this3=this;var _getAntd3=(0,_convert.getAntd)(),Button=_getAntd3.Button,message=_getAntd3.message;var _getEcCom3=(0,_convert.getEcCom)(),WeaTable=_getEcCom3.WeaTable,WeaSearchGroup=_getEcCom3.WeaSearchGroup,WeaHelpfulTip=_getEcCom3.WeaHelpfulTip,WeaDialogFooter=_getEcCom3.WeaDialogFooter,WeaRightMenu=_getEcCom3.WeaRightMenu,WeaFormItem=_getEcCom3.WeaFormItem,WeaSelect=_getEcCom3.WeaSelect,WeaBrowser=_getEcCom3.WeaBrowser;var rejectStore=this.props.rejectStore;var remindNodeList=rejectStore.remindNodeList,result=rejectStore.result,remindNodeOperators=rejectStore.remindNodeOperators,showAllRemindNodeOperators=rejectStore.showAllRemindNodeOperators,setShowAllRemindNodeOperators=rejectStore.setShowAllRemindNodeOperators;var remindNodeid=result.remindNodeid||"";var columns=[{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(15070,'节点名称')),key:"nodename",dataIndex:"nodename",width:"45%"},{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(99,'操作者')),key:"operator",dataIndex:"operator",width:"55%"}];var datas=[];remindNodeList&&remindNodeList.map(function(item){var row=mobx.toJS(item);var operators=mobx.toJS(remindNodeOperators[item.key]);var show=showAllRemindNodeOperators[item.key];row=(0,_extends3.default)({},row,{operator:_this3.getOperatorCom(operators,show,function(){setShowAllRemindNodeOperators(item.key);})});datas.push(row);});var rowSelection={selectedRowKeys:remindNodeid.split(","),onChange:function onChange(selectedRowKeys,selectedRows){var keys="";selectedRows&&selectedRows.map(function(item){keys+=","+item.key;});rejectStore.appendResult({remindNodeid:keys});}};return _react2.default.createElement(WeaSearchGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSearchGroup@337h7t',needTigger:true,className:'notitleLineGroup',title:(0,_convert.getLabel)(24465,'提醒节点'),showGroup:true},_react2.default.createElement(WeaTable,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTable@9s3qx3',columns:columns,dataSource:datas,rowSelection:rowSelection,pagination:false}));}},{key:'renderSubmitDirectSelect',value:function renderSubmitDirectSelect(){var _getAntd4=(0,_convert.getAntd)(),Button=_getAntd4.Button,message=_getAntd4.message;var _getEcCom4=(0,_convert.getEcCom)(),WeaTable=_getEcCom4.WeaTable,WeaSearchGroup=_getEcCom4.WeaSearchGroup,WeaHelpfulTip=_getEcCom4.WeaHelpfulTip,WeaDialogFooter=_getEcCom4.WeaDialogFooter,WeaRightMenu=_getEcCom4.WeaRightMenu,WeaFormItem=_getEcCom4.WeaFormItem,WeaSelect=_getEcCom4.WeaSelect,WeaBrowser=_getEcCom4.WeaBrowser;var rejectStore=this.props.rejectStore;var isSubmitDirectOptions=rejectStore.isSubmitDirectOptions;return _react2.default.createElement(WeaSearchGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSearchGroup@9owy77',needTigger:true,title:(0,_convert.getLabel)(384066,'退回后再提交的处理方式'),showGroup:true,center:true},_react2.default.createElement(WeaFormItem,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@054r3o',label:(0,_convert.getLabel)(386382,"请选择"),labelCol:{span:9},wrapperCol:{span:15}},_react2.default.createElement(WeaSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@a4axws',options:mobx.toJS(isSubmitDirectOptions),detailtype:3,onChange:function onChange(v){rejectStore.appendResult({isSubmitDirect:v});}})));}},{key:'getButtons',value:function getButtons(){var _getAntd5=(0,_convert.getAntd)(),Button=_getAntd5.Button,message=_getAntd5.message;var _getEcCom5=(0,_convert.getEcCom)(),WeaTable=_getEcCom5.WeaTable,WeaSearchGroup=_getEcCom5.WeaSearchGroup,WeaHelpfulTip=_getEcCom5.WeaHelpfulTip,WeaDialogFooter=_getEcCom5.WeaDialogFooter,WeaRightMenu=_getEcCom5.WeaRightMenu,WeaFormItem=_getEcCom5.WeaFormItem,WeaSelect=_getEcCom5.WeaSelect,WeaBrowser=_getEcCom5.WeaBrowser;var buttons=[];buttons.push(_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@h8obgl@confirm',type:'primary',onClick:this.doConfirm},(0,_convert.getLabel)(83446,'确定')));return buttons;}},{key:'getMoreBtns',value:function getMoreBtns(){var _this4=this;var btns=[];btns.push({key:'0',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:(0,_convert.getLabel)(83446,'确定'),onClick:function onClick(key){return _this4.doConfirm();}});return{datas:btns};}},{key:'getOperatorCom',//渲染操作者列
value:function getOperatorCom(){var operators=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var show=arguments[1];var func=arguments[2];var _getAntd6=(0,_convert.getAntd)(),Button=_getAntd6.Button,message=_getAntd6.message;var _getEcCom6=(0,_convert.getEcCom)(),WeaTable=_getEcCom6.WeaTable,WeaSearchGroup=_getEcCom6.WeaSearchGroup,WeaHelpfulTip=_getEcCom6.WeaHelpfulTip,WeaDialogFooter=_getEcCom6.WeaDialogFooter,WeaRightMenu=_getEcCom6.WeaRightMenu,WeaFormItem=_getEcCom6.WeaFormItem,WeaSelect=_getEcCom6.WeaSelect,WeaBrowser=_getEcCom6.WeaBrowser;var showList=operators.length<=6||show?operators:operators.slice(0,6);return _react2.default.createElement('div',{className:'operators'},_react2.default.createElement('div',{className:'browserDiv'},_react2.default.createElement(WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@cw21oz',type:'17',isSingle:false,replaceDatas:showList,viewAttr:'1'})),operators.length>5&&_react2.default.createElement('span',{className:'iconSpan',title:show?(0,_convert.getLabel)(26985,'收起'):(0,_convert.getLabel)(20234,'显示全部'),onClick:function onClick(){func&&func();}},_react2.default.createElement('em',{className:show?"icon-coms-up":"icon-coms-down"})));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _Content=__webpack_require__(665);var _Content2=_interopRequireDefault(_Content);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('overTimeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doCancel=function(){var overTimeStore=_this.props.overTimeStore;overTimeStore.closeEvent();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var visible=this.props.visible;return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@iy57rr',visible:visible,loadCss:true,initLoadCss:true,title:(0,_convert.getLabel)(18818,'超时设置'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:this.doCancel,style:{width:"550px",height:"520px"}},_react2.default.createElement(_Content2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Content@0eq8o0'},this.props)));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(666);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('overTimeStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doSave=function(){var overTimeStore=_this.props.overTimeStore;overTimeStore.doSave();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var overTimeStore=this.props.overTimeStore;overTimeStore.doInit();}},{key:'render',value:function render(){var _this2=this;var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var _getEcCom=(0,_convert.getEcCom)(),WeaTable=_getEcCom.WeaTable,WeaDialogFooter=_getEcCom.WeaDialogFooter,WeaInputNumber=_getEcCom.WeaInputNumber,WeaRightMenu=_getEcCom.WeaRightMenu;var overTimeStore=this.props.overTimeStore;var nodeList=overTimeStore.nodeList,nodeDatas=overTimeStore.nodeDatas;var columns=[{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(15070,'节点名称')),key:"nodename",dataIndex:"nodename",width:"30%"},{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(385076,'节点超时设置')),key:"setting",dataIndex:"setting",width:"60%"}];var dataSource=[];nodeList.length>0&&nodeList.map(function(key){dataSource.push({key:key,nodename:_react2.default.createElement('span',null,nodeDatas["nodename_"+key]),setting:_react2.default.createElement('div',{className:'wf-overtime-setarea'},_react2.default.createElement(WeaInputNumber,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaInputNumber@lpwo2c@'+key,min:0,max:999,value:nodeDatas['nodepasshour_'+key],onChange:function onChange(v){overTimeStore.changeDatas('nodepasshour_'+key,v);}}),_react2.default.createElement('div',{className:'wf-overtime-hour-text'},(0,_convert.getLabel)(391,'小时')),_react2.default.createElement(WeaInputNumber,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaInputNumber@5wxwvi@'+key,min:0,max:60,value:nodeDatas['nodepassminute_'+key],onChange:function onChange(v){overTimeStore.changeDatas('nodepassminute_'+key,v);}}),_react2.default.createElement('div',{className:'wf-overtime-minute-text'},(0,_convert.getLabel)(15049,'分钟')))});});return _react2.default.createElement('div',{className:'wf-overtime-setting'},_react2.default.createElement('div',{className:'wf-overtime-table'},_react2.default.createElement(WeaRightMenu,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@qz5yub'},this.getMoreBtns()),_react2.default.createElement(WeaTable,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTable@cwky1c',columns:columns,dataSource:dataSource,pagination:false}))),_react2.default.createElement(WeaDialogFooter,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialogFooter@id2dv4',buttons:this.getButtons(),moreBtn:this.getMoreBtns()}));}},{key:'getButtons',value:function getButtons(){var _getAntd2=(0,_convert.getAntd)(),Button=_getAntd2.Button;var buttons=[];buttons.push(_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@28wr2o@save',type:'primary',onClick:this.doSave},(0,_convert.getLabel)(86,'保存')));return buttons;}},{key:'getMoreBtns',value:function getMoreBtns(){var _this3=this;var btns=[];btns.push({key:'0',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:(0,_convert.getLabel)(86,'保存'),onClick:function onClick(key){return _this3.doSave();}});return{datas:btns};}},{key:'doCancel',value:function doCancel(){var overTimeStore=this.props.overTimeStore;overTimeStore.closeEvent();}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _trim=__webpack_require__(112);var _trim2=_interopRequireDefault(_trim);var _fileConfig=__webpack_require__(668);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('requestWithdrawStore','globalStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this));_this.doCancel=function(){var requestWithdrawStore=_this.props.requestWithdrawStore;requestWithdrawStore.closeEvent();};_this.doSubmit=function(){var remark=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button,Popover=_getAntd.Popover,message=_getAntd.message,Modal=_getAntd.Modal;var requestWithdrawStore=_this.props.requestWithdrawStore;var _requestWithdrawStore=requestWithdrawStore.allowRemind,allowRemind=_requestWithdrawStore===undefined?0:_requestWithdrawStore,_requestWithdrawStore2=requestWithdrawStore.recallNodeName,recallNodeName=_requestWithdrawStore2===undefined?"":_requestWithdrawStore2,_requestWithdrawStore3=requestWithdrawStore.remarkRequired,remarkRequired=_requestWithdrawStore3===undefined?'1':_requestWithdrawStore3;if(remarkRequired=='0'||_this.chekcremark(remark)){var that=_this;Modal.confirm({content:that.getConfirmContent(allowRemind,recallNodeName),okText:(0,_convert.getLabel)(83446,'\u786E\u5B9A'),cancelText:(0,_convert.getLabel)(31129,'\u53D6\u6D88'),onOk:function onOk(){requestWithdrawStore.doSubmit(remark);},onCancel:function onCancel(){}});}else{Modal.warning({content:_react2.default.createElement('p',{id:'lqy',style:{'textAlign':'center'}},(0,_convert.getLabel)(26013,"请填写签字意见！")),okText:(0,_convert.getLabel)(83446,"确定"),onOk:function onOk(){}});}};_this.chekcremark=function(remarkcontent){var _remarkcontent=remarkcontent;_remarkcontent=_remarkcontent.replace(/<p>/ig,'').replace(/<\/p>/ig,'').replace(/ /ig,"").replace(/&nbsp;/ig,"").replace(/<br \/>/ig,"");_remarkcontent=_remarkcontent.replace(/\\n/ig,"");if((0,_trim2.default)(_remarkcontent).length===0){return false;}return true;};_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(!hasLoad){return _react2.default.createElement('p',null);}var _props=this.props,globalStore=_props.globalStore,visible=_props.visible,requestWithdrawStore=_props.requestWithdrawStore;var WfBatchSubmit=window.weaWorkflowPublic.WfBatchSubmit;var _globalStore$rightMen=globalStore.rightMenu,rightMenu=_globalStore$rightMen===undefined?{}:_globalStore$rightMen,_globalStore$commonPa=globalStore.commonParam,commonParam=_globalStore$commonPa===undefined?{}:_globalStore$commonPa,_globalStore$submitPa=globalStore.submitParam,submitParam=_globalStore$submitPa===undefined?{}:_globalStore$submitPa;var _rightMenu$rightMenuN=rightMenu.rightMenuNames,rightMenuNames=_rightMenu$rightMenuN===undefined?{}:_rightMenu$rightMenuN;var loading=requestWithdrawStore.loading,setState=requestWithdrawStore.setState;var onSubmitText=rightMenuNames['WF_WITHDRAW_0']||(0,_convert.getLabel)(513318,'撤回');setState({'lastOperateDate':submitParam.lastOperateDate});setState({'lastOperateTime':submitParam.lastOperateTime});setState({'currentdate':submitParam.currentdate});setState({'currenttime':submitParam.currenttime});return _react2.default.createElement(WfBatchSubmit,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfBatchSubmit@0m957p',onSubmit:this.doSubmit,onCancel:this.doCancel,loading:loading,visible:visible,onSubmitText:onSubmitText,iconClassName:'icon-coms-Revocation'});}},{key:'getBottomBtns',value:function getBottomBtns(){var _getAntd2=(0,_convert.getAntd)(),Button=_getAntd2.Button;var btns=[_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@e6sunp@call',type:'primary',disabled:false,onClick:this.doSubmit},(0,_convert.getLabel)(513318,'撤回'))];return btns;}},{key:'getMoreBtns',value:function getMoreBtns(){var _this3=this;var btns={datas:[],collectParams:{favname:(0,_convert.getLabel)(513318,'撤回'),favouritetype:2,objid:0,importantlevel:1}};btns.datas.push({key:'1',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:(0,_convert.getLabel)(513318,'撤回'),disabled:false,onClick:function onClick(key){return _this3.doSubmit();}});return btns;}},{key:'getConfirmContent',value:function getConfirmContent(allowRemind,nodename){var _getEcCom=(0,_convert.getEcCom)(),WeaCheckbox=_getEcCom.WeaCheckbox;var requestWithdrawStore=this.props.requestWithdrawStore;var isRemind=requestWithdrawStore.isRemind;var text=(0,_convert.getLabel)(516798,'确定要将流程撤回到“$nodename$”节点吗?');text=text.replace('$nodename$',nodename);text=text.replace('$nodeName $',nodename);//英文环境下翻译偏差
if(allowRemind==1){return _react2.default.createElement('div',{style:{'word-wrap':'break-word','word-break':'keep-all'}},text,_react2.default.createElement('div',{style:{marginTop:'20px'}},_react2.default.createElement('span',{style:{marginRight:10,fontSize:'12px'}},_react2.default.createElement(WeaCheckbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@pgt9ie',value:isRemind,onChange:function onChange(value){requestWithdrawStore.setIsRemind(value);}}),'\xA0\xA0',(0,_convert.getLabel)(515992,'通知已提交流程的操作者'))));}else{return _react2.default.createElement('div',{style:{'word-wrap':'break-word','word-break':'keep-all'}},text);}}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.emailFiles=exports.smsFiles=exports.workflowPublicFiles=undefined;var _ecCom=__webpack_require__(51);var staticVersion="?v"+(_ecCom.WeaTools&&_ecCom.WeaTools.ls&&_ecCom.WeaTools.ls.getStr("staticVersion")||0);var workflowPublicFiles=exports.workflowPublicFiles=["/spa/workflow/static4public/index.js"+staticVersion,"css!/spa/workflow/static4public/index.css"+staticVersion];var smsFiles=exports.smsFiles=["/spa/smallApp/static/index.js"+staticVersion,"css!/spa/smallApp/static/index.css"+staticVersion];var emailFiles=exports.emailFiles=["/spa/email/static/index.js"+staticVersion,"css!/spa/email/static/index.css"+staticVersion];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _Content=__webpack_require__(670);var _Content2=_interopRequireDefault(_Content);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('printLogStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doCancel=function(){var printLogStore=_this.props.printLogStore;printLogStore.closeEvent();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var visible=this.props.visible;return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@w5x0da',visible:visible,loadCss:true,initLoadCss:true,title:(0,_convert.getLabel)(21533,'打印日志'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:this.doCancel,style:{width:"1000px",height:"520px"},layout:jQuery('.wf-req')[0]},_react2.default.createElement(_Content2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Content@limsl7'},this.props)));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(671);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('printLogStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.switchTab=function(tabKey){var printLogStore=_this.props.printLogStore;printLogStore.switchTab(tabKey);printLogStore.doSearch();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var printLogStore=this.props.printLogStore;printLogStore.loadBaseInfo();printLogStore.doSearch();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var printLogStore=this.props.printLogStore;printLogStore.resetStatus();}},{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var _getEcCom=(0,_convert.getEcCom)(),WeaDialogFooter=_getEcCom.WeaDialogFooter,WeaTab=_getEcCom.WeaTab,WeaSearchGroup=_getEcCom.WeaSearchGroup,WeaFormItem=_getEcCom.WeaFormItem,WeaRightMenu=_getEcCom.WeaRightMenu;var _getComsMobx=(0,_convert.getComsMobx)(),WeaSwitch=_getComsMobx.WeaSwitch,WeaTableNew=_getComsMobx.WeaTableNew;var printLogStore=this.props.printLogStore;var tabKey=printLogStore.tabKey,topTab=printLogStore.topTab,showSearchAd=printLogStore.showSearchAd,form=printLogStore.form,tableStore=printLogStore.tableStore;var formParams=form&&form.getFormParams()||{};var WeaTable=WeaTableNew.WeaTable;return _react2.default.createElement('div',{className:'wf-form-print-log'},_react2.default.createElement('div',{className:'wf-form-print-log-list'},_react2.default.createElement(WeaRightMenu,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@smhjch'},this.getMoreBtns()),_react2.default.createElement(WeaTab,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTab@p22nkx',buttonsAd:this.getAdButtons(),searchType:['advanced'],setShowSearchAd:function setShowSearchAd(bool){printLogStore.setShowSearchAd(bool);},hideSearchAd:function hideSearchAd(){return printLogStore.setShowSearchAd(false);},searchsAd:this.getAdConditions(),advanceHeight:170,showSearchAd:showSearchAd,datas:mobx.toJS(topTab),selectedKey:tabKey,onSearch:function onSearch(v){printLogStore.doSearch();},onSearchChange:function onSearchChange(v){printLogStore.appendFormFields({requestname:{value:v}});},keyParam:'viewcondition'//主键
,onChange:this.switchTab}),_react2.default.createElement(WeaTable,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTable@s4gp63',comsWeaTableStore:tableStore,hasOrder:true,needScroll:true}))),_react2.default.createElement(WeaDialogFooter,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialogFooter@dhl3bl',buttons:this.getButtons(),moreBtn:this.getMoreBtns()}));}},{key:'getAdConditions',value:function getAdConditions(){var _this2=this;var _getEcCom2=(0,_convert.getEcCom)(),WeaDialogFooter=_getEcCom2.WeaDialogFooter,WeaTab=_getEcCom2.WeaTab,WeaSearchGroup=_getEcCom2.WeaSearchGroup,WeaFormItem=_getEcCom2.WeaFormItem,WeaRightMenu=_getEcCom2.WeaRightMenu;var _getComsMobx2=(0,_convert.getComsMobx)(),WeaSwitch=_getComsMobx2.WeaSwitch,WeaTableNew=_getComsMobx2.WeaTableNew;var printLogStore=this.props.printLogStore;var conditions=printLogStore.conditions,form=printLogStore.form;var group=[];var items=[];var isFormInit=form&&form.isFormInit||false;var formParams=form&&form.getFormParams()||{};isFormInit&&conditions.map(function(field){var domKey=(0,_typeof3.default)(field.domkey)==="object"?field.domkey[0]:field.domkey;items.push({com:_react2.default.createElement(WeaFormItem,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaFormItem@sxe6si@'+domKey,label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},_react2.default.createElement(WeaSwitch,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaSwitch@3dvrrz@'+domKey,fieldConfig:field,form:form,formParams:formParams})),colSpan:1});});isFormInit&&group.push(_react2.default.createElement(WeaSearchGroup,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSearchGroup@wtkbg5@group1',needTigger:false,showGroup:true,items:items}));return _react2.default.createElement('div',null,group);}},{key:'getAdButtons',value:function getAdButtons(){var _getAntd2=(0,_convert.getAntd)(),Button=_getAntd2.Button;var printLogStore=this.props.printLogStore;var doSearch=printLogStore.doSearch,setShowSearchAd=printLogStore.setShowSearchAd,clearFormFields=printLogStore.clearFormFields;return[_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@7n8hsu@search',type:'primary',onClick:function onClick(){doSearch();setShowSearchAd(false);}},(0,_convert.getLabel)(197,'搜索')),_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@yfwt58@reset',type:'ghost',onClick:function onClick(){clearFormFields();}},(0,_convert.getLabel)(2022,'重置')),_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@om56ot@cancel}',type:'ghost',onClick:function onClick(){setShowSearchAd(false);}},(0,_convert.getLabel)(31129,'取消'))];}},{key:'getButtons',value:function getButtons(){var buttons=[];return buttons;}},{key:'getMoreBtns',value:function getMoreBtns(){var btns=[];return{datas:btns};}},{key:'doCancel',value:function doCancel(){var printLogStore=this.props.printLogStore;printLogStore.closeEvent();}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _freeFlowSet=__webpack_require__(673);var _freeFlowSet2=_interopRequireDefault(_freeFlowSet);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.dialogClose=function(){_base2.default.globalStore.controlDialogVisible(type.FREE_FLOW_SET,false);},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var _props=this.props,visible=_props.visible,_props$openType=_props.openType,openType=_props$openType===undefined?'flowset':_props$openType;var dialogWidth=window.innerWidth*0.9;var dialogHeight=window.innerHeight*0.9;return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@1uv73p',visible:visible,loadCss:true,initLoadCss:true,title:'流转设定',icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:function onCancel(){_base2.default.globalStore.controlDialogVisible(type.FREE_FLOW_SET,false);},style:{width:dialogWidth,height:dialogHeight},maxHeight:10000},_react2.default.createElement(_freeFlowSet2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Content@zlr4b7'},this.props)));}}]);return Main;}(_react2.default.Component))||_class;exports.default=Main;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _index=__webpack_require__(49);var _mobx=__webpack_require__(9);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FreeFlowSet=(_dec=(0,_index.inject)("globalStore"),_dec(_class=(0,_index.observer)(_class=function(_React$Component){(0,_inherits3.default)(FreeFlowSet,_React$Component);function FreeFlowSet(){(0,_classCallCheck3.default)(this,FreeFlowSet);var _this=(0,_possibleConstructorReturn3.default)(this,(FreeFlowSet.__proto__||(0,_getPrototypeOf2.default)(FreeFlowSet)).call(this));_this.buildUrlStr=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var str="";_.forIn(params,function(value,key){str+='&'+key+'='+value;});if(str!=="")str=str.substring(1);return str;};_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(FreeFlowSet,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var WorkflowNewDesignStore=window.weaWorkflowPublic.WorkflowNewDesignStore;var store=new WorkflowNewDesignStore();_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _props=this.props,globalStore=_props.globalStore,openType=_props.openType;var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;var commonParam=globalStore.commonParam,rightMenu=globalStore.rightMenu;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,nodeid=commonParam.nodeid,iscreate=commonParam.iscreate,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype;var iscnodefree=rightMenu.iscnodefree,isFree=rightMenu.isFree,freewftype=rightMenu.freewftype,_rightMenu$freeNode=rightMenu.freeNode,freeNode=_rightMenu$freeNode===undefined?{}:_rightMenu$freeNode,isAllowNodeFreeFlow=rightMenu.isAllowNodeFreeFlow;var chartParams={requestid:requestid,workflowid:workflowid,nodeid:nodeid,isAllowNodeFreeFlow:isAllowNodeFreeFlow,isFree:isFree,'isFlowModel':0,'isReadOnlyModel':false};var picUrl=(window.ecologyContentPath||'')+'/workflow/workflowDesign/readOnly-index.html?'+this.buildUrlStr(chartParams)+'&showE9Pic=1&isFromWfForm=true';if(hasLoad){var FreeFlowDesignContainer=window.weaWorkflowPublic.FreeFlowDesignContainer;if(openType==='modelset'){return _react2.default.createElement(FreeFlowDesignContainer,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_FreeFlowDesignContainer@9p5k27',workflowNewDesignStore:store},chartParams,this.props));}else{return _react2.default.createElement('div',{className:'free-designer-frame',style:{height:'100%'}},_react2.default.createElement('iframe',{src:picUrl,style:{width:'100%',height:'100%'}}));}}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@i6l1th'});}}//拼接url链接
}]);return FreeFlowSet;}(_react2.default.Component))||_class)||_class);exports.default=FreeFlowSet;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _Content=__webpack_require__(675);var _Content2=_interopRequireDefault(_Content);var _ecCom=__webpack_require__(51);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Main=(_dec=(0,_mobxReact.inject)('ensureSubmitStore'),_dec(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.confirm=function(){var confirmEvent=_this.props.ensureSubmitStore.confirmEvent;confirmEvent();},_this.cancel=function(){var ensureSubmitStore=_this.props.ensureSubmitStore;ensureSubmitStore.cancelEvent();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'getButtons',value:function getButtons(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var buttons=[_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@clsmcg@confirm',type:'primary',onClick:this.confirm},getLabel(382958,'确定')),_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@g2o1lv@cancel',type:'primary',onClick:this.cancel},getLabel(31129,'取消'))];return buttons;}},{key:'render',value:function render(){var _this2=this;var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var _props=this.props,visible=_props.visible,promptInfo=_props.promptInfo;return _react2.default.createElement(_ecCom.WeaPopoverHrm,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPopoverHrm@g9w5ql'},_react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@zoh2co',visible:visible,title:getLabel(131329,'信息确认'),icon:'icon-coms02-Warning',iconBgcolor:'#F2A945',onCancel:function onCancel(){_this2.cancel();},buttons:this.getButtons(),style:{width:"400px"},className:'ensure-submit-dialog'},_react2.default.createElement(_Content2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Content@6k0tgy',promptInfo:promptInfo})));}}]);return Main;}(_react2.default.Component))||_class);exports.default=Main;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);__webpack_require__(676);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);var _formUtil=__webpack_require__(11);var FormUtil=_interopRequireWildcard(_formUtil);var _ecCom=__webpack_require__(51);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.jumpWfMap=function(){_base2.default.globalStore.setTabKey('pic');_base2.default.globalStore.controlDialogVisible(type.ENSURE_SUBMIT,false);if(_base2.default.globalStore.submitParam.requestid!=-1){_base2.default.smartGuessWfStore.openForecastFunc(true);FormUtil.switchFormTab('pic',false);//跳转tab
_base2.default.smartGuessWfStore.clickSmartBtn();}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'getOperator',value:function getOperator(operators,str){var operatorArr=operators;if(operatorArr.length>10){operatorArr=operatorArr.slice(0,10);}return _react2.default.createElement('p',{className:'operator-text'},_react2.default.createElement('span',{className:'next-operator'},getLabel(515204,'下一节点操作者:'),' '),operatorArr.length>0&&operatorArr.map(function(item,index){var hasAgent=item.isbeAgent=='true'?true:false;var operatorStr=item.operatorname;var operatortype=item.operatortype;if(index==9){operatorStr=item.operatorname+'...';}if(operatortype==2){return _react2.default.createElement('div',null,_react2.default.createElement('span',{style:{marginLeft:hasAgent?'0':'10px'},className:'operator'},operatorStr));}return _react2.default.createElement('div',null,hasAgent&&_react2.default.createElement('a',{href:'javaScript:openhrm('+item.beagentid+');',onClick:function onClick(e){return window.pointerXY(e);},className:'operator',style:{marginLeft:'10px'}},item.beagentname+'->'),_react2.default.createElement('a',{href:'javaScript:openhrm('+item.operatorid+');',onClick:function onClick(e){return window.pointerXY(e);},style:{marginLeft:hasAgent?'0':'10px'},className:'operator'},operatorStr));}),operatorArr.length==0&&_react2.default.createElement('span',{style:{marginLeft:'5px'}},str));}//跳转至流程图Tab 
},{key:'render',value:function render(){var promptInfo=this.props.promptInfo;var _base$globalStore$com=_base2.default.globalStore.commonParam,isFree=_base$globalStore$com.isFree,_base$globalStore$com2=_base$globalStore$com.openAutoForecast,openAutoForecast=_base$globalStore$com2===undefined?'0':_base$globalStore$com2;var canGetNextNode=false;if(promptInfo.isSuccess){canGetNextNode=true;}var str=promptInfo.titlesuffix||' ';while(str&&str.indexOf('span')>-1){str=str.replace('<span>','').replace('</span>',' ');}var nextNodeStr=str;return _react2.default.createElement('div',{className:'content-box',style:{fontSize:'14px'}},_react2.default.createElement('p',{style:{paddingBottom:'5px'}},getLabel(22161,'确定要提交吗？')),canGetNextNode?_react2.default.createElement('p',{className:'next-node-name',style:{paddingBottom:'5px'}},getLabel(515203,'下一节点'),'  ',nextNodeStr):_react2.default.createElement('p',null,getLabel(515207,'下一节点无法预知')),canGetNextNode&&promptInfo.operators&&promptInfo.operators.length>0&&this.getOperator(promptInfo.operators),canGetNextNode&&!promptInfo.operators||canGetNextNode&&promptInfo.operators.length==0&&this.getOperator([],nextNodeStr),isFree!='1'&&openAutoForecast=='1'&&_react2.default.createElement('a',{className:'forcast-link',onClick:this.jumpWfMap,style:{fontSize:'12px'}},getLabel(515205,'点击这里查看后续流转预测'),_react2.default.createElement('i',{className:'icon-coms-right'})));}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _mobxReact=__webpack_require__(8);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);var _signUtil=__webpack_require__(58);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.onAuthSuccess=function(result){var globalStore=_base2.default.globalStore,secondAuthStore=_base2.default.secondAuthStore;// globalStore.changeSubmitParam({isAuthSuccess: 1});  //二次验证成功
globalStore.controlDialogVisible(authTypes.SECOND_AUTH_DIALOG,false);//关闭窗口
var callbackFunc=secondAuthStore.callbackFunc,callbackParam=secondAuthStore.callbackParam;var isProtectDialog=result.isProtectDialog,secondAuthType=result.secondAuthType;if(isProtectDialog==1){//数据保护：CA或者契约锁数据保护
secondAuthStore.setDialogResult({isProtectSuccess:1});//数据保护成功
}else if(isProtectDialog==10){//CA认证 + CA数据保护 或者 契约锁认证 + 契约锁数据保护
secondAuthStore.setDialogResult({isProtectSuccess:1});//数据保护成功
secondAuthStore.setDialogResult({isAuthSuccess:1});//二次验证成功
}else{//二次验证：CA或者契约锁验证
secondAuthStore.setDialogResult({isAuthSuccess:1});//二次验证成功
}//契约锁验证，保存印章信息
if(secondAuthType==authTypes.QYS){var qysSealId=result.sealId,qysSealImg=result.sealImg,qysCertDetails=result.certDetails,_result$sealSpec=result.sealSpec,sealSpec=_result$sealSpec===undefined?{}:_result$sealSpec;// 契约锁印章，印章id信息,certDetails：印章信息，json字符串
var _sealSpec$width=sealSpec.width,qyswidth=_sealSpec$width===undefined?0:_sealSpec$width,_sealSpec$height=sealSpec.height,qysheight=_sealSpec$height===undefined?0:_sealSpec$height;qyswidth*=2.8346;qysheight*=2.8346;var params=secondAuthStore.params;secondAuthStore.setParams((0,_extends3.default)({},params,{qysSealId:qysSealId,qysSealImg:qysSealImg,qysCertDetails:(0,_stringify2.default)((0,_extends3.default)({},qysCertDetails,{qyswidth:qyswidth,qysheight:qysheight}))}));}if(callbackFunc&&typeof callbackFunc=="function"){callbackFunc.call({},callbackParam);//调用提交流程的方法
}};_this.onAuthFail=function(){}//nothing to do
//关闭窗口
;_this.onClose=function(){var globalStore=_base2.default.globalStore,secondAuthStore=_base2.default.secondAuthStore;globalStore.controlDialogVisible(authTypes.SECOND_AUTH_DIALOG,false);//重置与弹出框以及验证结果相关的参数
secondAuthStore.resetStore();};_this.state={hasLoad:false,store:null};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var init=function init(){var SecondAuthStore=window.weaWorkflowPublic.SecondAuthStore;//公共组件的store，与本组件的secondAuthStore不同，请注意
_this2.setState({hasLoad:true,store:SecondAuthStore});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}//验证成功后的回调方法
//验证失败后的回调方法
},{key:"render",value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;var globalStore=_base2.default.globalStore,secondAuthStore=_base2.default.secondAuthStore;var params=secondAuthStore.params,protectType=secondAuthStore.protectType,isProtectDialog=secondAuthStore.isProtectDialog;var secondAuthType=secondAuthStore.secondAuthType;var visible=this.props.visible;var _params$authKey=params.authKey,authKey=_params$authKey===undefined?"":_params$authKey,_params$signUrl=params.signUrl,signUrl=_params$signUrl===undefined?"":_params$signUrl,_params$sourcestr=params.sourcestr,sourcestr=_params$sourcestr===undefined?"":_params$sourcestr;if(isProtectDialog==1){secondAuthType=protectType;}if(hasLoad){var _window$weaWorkflowPu=window.weaWorkflowPublic,SecondAuthCom=_window$weaWorkflowPu.SecondAuthCom,QYSUkey=_window$weaWorkflowPu.QYSUkey;store.setAuthData({authKey:authKey,secondAuthType:secondAuthType,isProtectDialog:isProtectDialog,signUrl:signUrl});return _react2.default.createElement(SecondAuthCom,{ecId:(this&&this.props&&this.props.ecId||'')+"_SecondAuthCom@jqw08m",visible:visible,secondAuthStore:store,onSuccess:this.onAuthSuccess,onFail:this.onAuthFail,onClose:this.onClose});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+"_Loading@d4j862"});}}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _mobxReact=__webpack_require__(8);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.onClose=function(){var globalStore=_base2.default.globalStore;globalStore.controlDialogVisible(authTypes.AUTH_DETAIL_DIALOG,false);};_this.state={hasLoad:false,store:null};return _this;}(0,_createClass3.default)(Main,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var init=function init(){var SecondAuthStore=window.weaWorkflowPublic.SecondAuthStore;//公共组件的store，与本组件的secondAuthStore不同，请注意
_this2.setState({hasLoad:true,store:SecondAuthStore});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}//关闭窗口
},{key:"render",value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;var _base$globalStore=_base2.default.globalStore,dialogVisible=_base$globalStore.dialogVisible,commonParam=_base$globalStore.commonParam;var visible=this.props.visible;if(hasLoad){store.setCommonParam(commonParam);var SecondAuthDetailCom=window.weaWorkflowPublic.SecondAuthDetailCom;return _react2.default.createElement(SecondAuthDetailCom,{ecId:(this&&this.props&&this.props.ecId||'')+"_SecondAuthDetailCom@6dydvt",visible:visible,secondAuthStore:store,commonParam:commonParam,onClose:this.onClose});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+"_Loading@s3qxtv"});}}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Resource=function(_React$Component){(0,_inherits3.default)(Resource,_React$Component);function Resource(){(0,_classCallCheck3.default)(this,Resource);var _this=(0,_possibleConstructorReturn3.default)(this,(Resource.__proto__||(0,_getPrototypeOf2.default)(Resource)).call(this));_this.state={hasLoad:false,store:null};return _this;}(0,_createClass3.default)(Resource,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var WfFormResourceStore=window.weaWorkflowPublic.WfFormResourceStore;var store=new WfFormResourceStore();_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var commonParam=this.props.commonParam;var WfFormResourceCom=window.weaWorkflowPublic.WfFormResourceCom;return _react2.default.createElement(WfFormResourceCom,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfFormResourceCom@ks9ly1',wfFormResourceStore:store,commonParam:commonParam});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@i7q8kt'});}}}]);return Resource;}(_react2.default.Component);exports.default=Resource;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Share=function(_React$Component){(0,_inherits3.default)(Share,_React$Component);function Share(){(0,_classCallCheck3.default)(this,Share);var _this=(0,_possibleConstructorReturn3.default)(this,(Share.__proto__||(0,_getPrototypeOf2.default)(Share)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(Share,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var WfFormShareStore=window.weaWorkflowPublic.WfFormShareStore;var store=new WfFormShareStore();_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var WfFormShare=window.weaWorkflowPublic.WfFormShare;var commonParam=this.props.commonParam;var requestid=commonParam.requestid,workflowid=commonParam.workflowid,nodeid=commonParam.nodeid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype;var formParams={requestid:requestid,workflowid:workflowid,currentnodeid:nodeid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype};return _react2.default.createElement(WfFormShare,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfFormShare@0jyohv',formParams:formParams,wfShareStore:store});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@i1735l'});}}}]);return Share;}(_react2.default.Component);exports.default=Share;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ModifyLog=function(_React$Component){(0,_inherits3.default)(ModifyLog,_React$Component);function ModifyLog(){(0,_classCallCheck3.default)(this,ModifyLog);var _this=(0,_possibleConstructorReturn3.default)(this,(ModifyLog.__proto__||(0,_getPrototypeOf2.default)(ModifyLog)).call(this));_this.state={hasLoad:false,store:null};return _this;}(0,_createClass3.default)(ModifyLog,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var WfFormModifyLogStore=window.weaWorkflowPublic.WfFormModifyLogStore;var store=new WfFormModifyLogStore();_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var WfFormModifyLogCom=window.weaWorkflowPublic.WfFormModifyLogCom;var _props=this.props,commonParam=_props.commonParam,closeFun=_props.closeFun,visible=_props.visible;var requestid=commonParam.requestid,nodeid=commonParam.nodeid,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype,wfmonitor=commonParam.wfmonitor,intervenorright=commonParam.intervenorright;store.appendBaseParams({requestid:requestid,nodeid:nodeid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype,ismonitor:wfmonitor?"1":"0",intervenorright:intervenorright},visible);store.setCloseDialogFun(closeFun);return _react2.default.createElement(WfFormModifyLogCom,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfFormModifyLogCom@x6lmn5',wfFormModifyLogStore:store});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@ghakby'});}}}]);return ModifyLog;}(_react2.default.Component);exports.default=ModifyLog;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _index=__webpack_require__(49);var _mobx=__webpack_require__(9);var _secondAuthUtil=__webpack_require__(86);var _fieldUtil=__webpack_require__(17);var FieldUtil=_interopRequireWildcard(_fieldUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Forward=(_dec=(0,_index.inject)("globalStore","secondAuthStore"),_dec(_class=function(_React$Component){(0,_inherits3.default)(Forward,_React$Component);function Forward(){(0,_classCallCheck3.default)(this,Forward);var _this=(0,_possibleConstructorReturn3.default)(this,(Forward.__proto__||(0,_getPrototypeOf2.default)(Forward)).call(this));_this.onClose=function(){};_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(Forward,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var WFForwardStore=window.weaWorkflowPublic.WFForwardStore;var store=new WFForwardStore();_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var _props=this.props,_props$forwardParams=_props.forwardParams,forwardParams=_props$forwardParams===undefined?{}:_props$forwardParams,_props$callBackAction=_props.callBackActions,callBackActions=_props$callBackAction===undefined?{}:_props$callBackAction;var WfForward=window.weaWorkflowPublic.WfForward;var remark_list=this.props.globalStore.variableMap.get("remark_list")||(_mobx.observable.map?_mobx.observable.map({}):(0,_mobx.asMap)({}));var _props2=this.props,globalStore=_props2.globalStore,secondAuthStore=_props2.secondAuthStore;var submitParam=globalStore.submitParam,_globalStore$secLevel=globalStore.secLevelInfo,secLevelInfo=_globalStore$secLevel===undefined?{}:_globalStore$secLevel,variableMap=globalStore.variableMap;var workflowid=submitParam.workflowid,nodeid=submitParam.nodeid,requestid=submitParam.requestid,f_weaver_belongto_userid=submitParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=submitParam.f_weaver_belongto_usertype;var secondAuthParam={workflowid:workflowid,nodeid:nodeid,requestid:requestid,f_weaver_belongto_userid:f_weaver_belongto_userid,f_weaver_belongto_usertype:f_weaver_belongto_usertype};var secLevel=FieldUtil.getRelateFieldValue(-10,-1)||"";var secLevelName=FieldUtil.getSecLevelName(secLevel);var allowEditFileSec=!(requestid&&requestid>0);forwardParams['secLevelInfo']=(0,_extends3.default)({},secLevelInfo,{secLevel:secLevel,secLevelName:secLevelName,allowEditFileSec:allowEditFileSec});store.setShowForward(forwardParams,callBackActions);store.setRemarkList(remark_list);store.setSecondAuthParams(secondAuthParam,secondAuthStore,_secondAuthUtil.filterRequest4Forward,this.onClose,_secondAuthUtil.showAuthDialog);return _react2.default.createElement(WfForward,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfForward@li9hf0',wfForwardStore:store,globalStore:this.props.globalStore});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@ypb089'});}}}]);return Forward;}(_react2.default.Component))||_class);exports.default=Forward;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var HrmEmployeeSetting=function(_React$Component){(0,_inherits3.default)(HrmEmployeeSetting,_React$Component);function HrmEmployeeSetting(){(0,_classCallCheck3.default)(this,HrmEmployeeSetting);var _this=(0,_possibleConstructorReturn3.default)(this,(HrmEmployeeSetting.__proto__||(0,_getPrototypeOf2.default)(HrmEmployeeSetting)).call(this));_this.state={hasLoad:false,store:null};return _this;}(0,_createClass3.default)(HrmEmployeeSetting,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var closeFun=_this2.props.closeFun;var HrmNewEmployeeSetStore=window.weaHrmEnginePublic.HrmNewEmployeeSetStore;var store=new HrmNewEmployeeSetStore();store.setCloseDialogFun(closeFun);_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('hrm',_fileConfig.hrmFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var hrmid=this.props.hrmid;var HrmNewEmployeeSet=window.weaHrmEnginePublic.HrmNewEmployeeSet;if(hrmid===false){store.setVisible(false);}else{store.setHrmId(hrmid);store.setVisible(true);}return _react2.default.createElement(HrmNewEmployeeSet,{ecId:(this&&this.props&&this.props.ecId||'')+'_HrmNewEmployeeSet@6w8oow',hrmNewEmployeeSetStore:store});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@1oe54e'});}}}]);return HrmEmployeeSetting;}(_react2.default.Component);exports.default=HrmEmployeeSetting;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SendSms=function(_React$Component){(0,_inherits3.default)(SendSms,_React$Component);function SendSms(){(0,_classCallCheck3.default)(this,SendSms);var _this=(0,_possibleConstructorReturn3.default)(this,(SendSms.__proto__||(0,_getPrototypeOf2.default)(SendSms)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(SendSms,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('sms',_fileConfig.smsFiles,init);}},{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var hasLoad=this.state.hasLoad;if(hasLoad){var _SendSms=window.weaSmallApp.com.SendSms;var _props=this.props,visible=_props.visible,params=_props.params,_closeFun=_props.closeFun;return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@l2fnqh',visible:visible,title:(0,_convert.getLabel)(16635,'发送短信'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',className:'wf-send-sms',maskClosable:false,onCancel:function onCancel(){_closeFun();},style:{width:"800px",height:"450px"}},_react2.default.createElement(_SendSms,{ecId:(this&&this.props&&this.props.ecId||'')+'_SendSms@zrpr3s',isCus:true,params:params,closeFun:function closeFun(){_closeFun();}}));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@fubg94'});}}}]);return SendSms;}(_react2.default.Component);exports.default=SendSms;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _ecCom=__webpack_require__(51);var _fileConfig=__webpack_require__(18);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var SendEmail=function(_React$Component){(0,_inherits3.default)(SendEmail,_React$Component);function SendEmail(){(0,_classCallCheck3.default)(this,SendEmail);var _this=(0,_possibleConstructorReturn3.default)(this,(SendEmail.__proto__||(0,_getPrototypeOf2.default)(SendEmail)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(SendEmail,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('email',_fileConfig.emailFiles,init);}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(hasLoad){var _ref=window.weaEmail.components||{},_SendEmail=_ref.EmailNewForDialog;var _props=this.props,_props$visible=_props.visible,visible=_props$visible===undefined?false:_props$visible,_props$fwquery=_props.fwquery,fwquery=_props$fwquery===undefined?{}:_props$fwquery,_props$closeFun=_props.closeFun,closeFun=_props$closeFun===undefined?function(){}:_props$closeFun;return _react2.default.createElement(_SendEmail,{ecId:(this&&this.props&&this.props.ecId||'')+'_SendEmail@i0gfzw',visible:visible,fwquery:fwquery,fromCb:true,style:{'height':'500px'},onCancel:function onCancel(){closeFun();}});}else{return _react2.default.createElement('div',null);}}}]);return SendEmail;}(_react2.default.Component);exports.default=SendEmail;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _convert=__webpack_require__(6);var _req=__webpack_require__(15);var _type=__webpack_require__(27);var _formUtil=__webpack_require__(11);var _signUtil=__webpack_require__(58);var SignUtil=_interopRequireWildcard(_signUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BatchSubmit=(_dec=(0,_mobxReact.inject)('globalStore','layoutStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BatchSubmit,_React$Component);function BatchSubmit(){(0,_classCallCheck3.default)(this,BatchSubmit);var _this=(0,_possibleConstructorReturn3.default)(this,(BatchSubmit.__proto__||(0,_getPrototypeOf2.default)(BatchSubmit)).call(this));_this.doSupervise=function(){var remark=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;var globalStore=_this.props.globalStore;var baseParam=globalStore.baseParam,batchControlVariableMap=globalStore.batchControlVariableMap,_globalStore$markInfo=globalStore.markInfo,markInfo=_globalStore$markInfo===undefined?{}:_globalStore$markInfo;var isSignMustInput=markInfo.isSignMustInput;var requestid=baseParam.requestid,f_weaver_belongto_userid=baseParam.f_weaver_belongto_userid;var tempRequestid=requestid.toString()+"_"+f_weaver_belongto_userid.toString();var flag=true;if(isSignMustInput=='1'||isSignMustInput=='2'&&SignUtil.verifyRemarkMustInput('supervise')){flag=SignUtil.chekcremark(remark);}if(flag){var params={requestids:tempRequestid,remark:remark};message.loading((0,_convert.getLabel)(387110,'督办中...，请稍候'),0);(0,_req.doSupervise)(params).then(function(data){message.destroy();if(data.result){message.success((0,_convert.getLabel)(387108,'督办成功'));_this.onCancel();//刷新签字意见列表
var reloadLogListParams={pgnumber:1,atmet:'',maxrequestlogid:0};batchControlVariableMap({'isRelaodLogList':true,'reloadLogListParams':reloadLogListParams});//刷新督办列表
(0,_formUtil.reloadListPage)();}else{message.error((0,_convert.getLabel)(387109,'督办失败'));}});}else{var _getAntd2=(0,_convert.getAntd)(),_message=_getAntd2.message;_message.warning((0,_convert.getLabel)(386186,'"签字意见"未填写'),2);}};_this.onCancel=function(){_this.props.globalStore.controlDialogVisible(_type.DO_SUPERVISE,false);};_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(BatchSubmit,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){_this2.setState({hasLoad:true});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var WfBatchSubmit=window.weaWorkflowPublic.WfBatchSubmit;var _props=this.props,globalStore=_props.globalStore,visible=_props.visible;var _globalStore$rightMen=globalStore.rightMenu,rightMenu=_globalStore$rightMen===undefined?{}:_globalStore$rightMen;var _rightMenu$rightMenuN=rightMenu.rightMenuNames,rightMenuNames=_rightMenu$rightMenuN===undefined?{}:_rightMenu$rightMenuN;var onSubmitText=rightMenuNames['SUPERVISE_0']||(0,_convert.getLabel)(21223,'督办');return _react2.default.createElement(WfBatchSubmit,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfBatchSubmit@d41okx',onSubmit:this.doSupervise,onCancel:this.onCancel,visible:visible,onSubmitText:onSubmitText,iconClassName:'icon-coms-daiban'});}else{return _react2.default.createElement('div',null);}}//督办
//关闭
}]);return BatchSubmit;}(_react2.default.Component))||_class)||_class);exports.default=BatchSubmit;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _index=__webpack_require__(49);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ForwardBack=(_dec=(0,_index.inject)('globalStore'),_dec(_class=function(_React$Component){(0,_inherits3.default)(ForwardBack,_React$Component);function ForwardBack(){(0,_classCallCheck3.default)(this,ForwardBack);var _this=(0,_possibleConstructorReturn3.default)(this,(ForwardBack.__proto__||(0,_getPrototypeOf2.default)(ForwardBack)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(ForwardBack,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var WfForwardBackStore=window.weaWorkflowPublic.WfForwardBackStore;var store=new WfForwardBackStore();_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var _props=this.props,visible=_props.visible,requestid=_props.requestid,callBackActions=_props.callBackActions,globalStore=_props.globalStore;var _globalStore$commonPa=globalStore.commonParam,commonParam=_globalStore$commonPa===undefined?{}:_globalStore$commonPa;var _commonParam$f_weaver=commonParam.f_weaver_belongto_userid,f_weaver_belongto_userid=_commonParam$f_weaver===undefined?'':_commonParam$f_weaver,_commonParam$f_weaver2=commonParam.f_weaver_belongto_usertype,f_weaver_belongto_usertype=_commonParam$f_weaver2===undefined?'':_commonParam$f_weaver2;store.setShowForwardBack(visible,requestid,f_weaver_belongto_userid,f_weaver_belongto_usertype);store.setCallBackAction(callBackActions);var WfForwardBack=window.weaWorkflowPublic.WfForwardBack;return _react2.default.createElement(WfForwardBack,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfForwardBack@81r7bw',wfForwardBackStore:store,globalStore:globalStore});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@gtf35n'});}}}]);return ForwardBack;}(_react2.default.Component))||_class);exports.default=ForwardBack;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _loadjs=__webpack_require__(83);var _loadjs2=_interopRequireDefault(_loadjs);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);var _index=__webpack_require__(49);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Communication=(_dec=(0,_index.inject)("globalStore"),_dec(_class=function(_React$Component){(0,_inherits3.default)(Communication,_React$Component);function Communication(){(0,_classCallCheck3.default)(this,Communication);var _this=(0,_possibleConstructorReturn3.default)(this,(Communication.__proto__||(0,_getPrototypeOf2.default)(Communication)).call(this));_this.state={hasLoad:false,store:null};return _this;}(0,_createClass3.default)(Communication,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var WfFormCommunicationStore=window.weaWorkflowPublic.WfFormCommunicationStore;var store=new WfFormCommunicationStore();_this2.setState({hasLoad:true,store:store});};var initCommunication=function initCommunication(){_loadjs2.default.isDefined('communicationFiles')?_loadjs2.default.ready('communicationFiles',init):(0,_loadjs2.default)(_fileConfig.communicationFiles,'communicationFiles',init);};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,initCommunication);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var _props=this.props,commonParam=_props.commonParam,signReplyInfo=_props.signReplyInfo,clearReplyInfo=_props.clearReplyInfo;var WfFormCommunicationCom=window.weaWorkflowPublic.WfFormCommunicationCom;var _props$globalStore$se=this.props.globalStore.secLevelInfo,secLevelInfo=_props$globalStore$se===undefined?{}:_props$globalStore$se;return _react2.default.createElement(WfFormCommunicationCom,{ecId:(this&&this.props&&this.props.ecId||'')+'_WfFormCommunicationCom@j7ap5n',signReplyInfo:signReplyInfo,clearReplyInfo:clearReplyInfo,WfFormCommunicationStore:store,commonParam:commonParam,secLevelInfo:secLevelInfo});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@plkjph'});}}}]);return Communication;}(_react2.default.Component))||_class);exports.default=Communication;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);var _Content=__webpack_require__(690);var _Content2=_interopRequireDefault(_Content);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('selectNextFlowStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doCancel=function(){var selectNextFlowStore=_this.props.selectNextFlowStore;selectNextFlowStore.cancelEvent();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var _props=this.props,visible=_props.visible,selectNextFlowStore=_props.selectNextFlowStore,nodeAttribute=_props.nodeAttribute;var _selectNextFlowStore$=selectNextFlowStore.baseParams,baseParams=_selectNextFlowStore$===undefined?{}:_selectNextFlowStore$;var dialogHeight=nodeAttribute=='1'?'580px':'350px';return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@h5ci52',visible:visible,loadCss:true,initLoadCss:true,title:(0,_convert.getLabel)(384721,'请选择下一节点操作者'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:this.doCancel,style:{width:'720px',height:dialogHeight},layout:jQuery('.wf-req')[0]},_react2.default.createElement(_Content2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Content@ewn8dx'},this.props)));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(281);var _convert=__webpack_require__(6);var _NodeInfoDialog=__webpack_require__(282);var _NodeInfoDialog2=_interopRequireDefault(_NodeInfoDialog);var _type=__webpack_require__(27);var type=_interopRequireWildcard(_type);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('globalStore','selectNextFlowStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this));_this.onNodeBrowserChange=function(ids,names,datas){var selectNextFlowStore=_this.props.selectNextFlowStore;var changeNextNode=selectNextFlowStore.changeNextNode,updateFormByNodeInfo=selectNextFlowStore.updateFormByNodeInfo,nextNodeIds=selectNextFlowStore.nextNodeIds,nodeInfoMap=selectNextFlowStore.nodeInfoMap;var newNextNodeIds='';datas.map(function(data){//已选择节点不是分叉中间节点，用最后一个节点替换当前选择的节点
if(nodeInfoMap[nextNodeIds]&&nodeInfoMap[nextNodeIds].nodeAttribute!=2){newNextNodeIds=','+data.id;//替换
}else{newNextNodeIds+=','+data.id;//增加
}});if(newNextNodeIds!=''){newNextNodeIds=newNextNodeIds.substring(1);}changeNextNode(newNextNodeIds);};_this.doConfirm=function(){var selectNextFlowStore=_this.props.selectNextFlowStore;var form=selectNextFlowStore.form,nextNodeIds=selectNextFlowStore.nextNodeIds,nodeAttribute=selectNextFlowStore.nodeAttribute,nodeInfoMap=selectNextFlowStore.nodeInfoMap,branchNodesMap=selectNextFlowStore.branchNodesMap,mustPassNodeIds=selectNextFlowStore.mustPassNodeIds;var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message,Modal=_getAntd.Modal;var that=_this;var formParams=form.getFormParams();var showErrorTip=function showErrorTip(){Modal.warning({title:(0,_convert.getLabel)(131329,' 信息确认'),content:(0,_convert.getLabel)(384146,'必要信息不完整，红色*为必填项')+'\uFF01',okText:(0,_convert.getLabel)(83446,'确定'),onOk:function onOk(){}});};//验证节点必填
if((!nextNodeIds||nextNodeIds=='')&&_this.refs.nodeError){showErrorTip();return;}//验证操作者必填
var checkNodeIds=nextNodeIds.split(',');var operatorCheck=true;checkNodeIds.map(function(nextNodeId,index){if((!formParams['nodeOperator_'+index]||formParams['nodeOperator_'+index]=='')&&_this.refs[''+('operatorError_'+'nodeOperator_')+index]){operatorCheck=false;}});if(!operatorCheck){showErrorTip();return;}//分叉起始点，指定流转不是主干节点的情况下，检查是否选择了必须经过的分支
if(nodeAttribute=='1'&&!(checkNodeIds.length==1&&nodeInfoMap[checkNodeIds[0]].nodeAttribute!='2')){var mustPassCheck=true;mustPassNodeIds&&mustPassNodeIds.map(function(id){if(!_this.checkSameElement(checkNodeIds,branchNodesMap[id])){mustPassCheck=false;}});if(!mustPassCheck){Modal.warning({content:(0,_convert.getLabel)(528903,"请选择必须通过的分支上的节点"),okText:(0,_convert.getLabel)(83446,"确定"),onOk:function onOk(){}});return;}}form.validateForm().then(function(f){if(f.isValid){var result=selectNextFlowStore.getResultParams();that.setState({isSubmit:true});message.loading((0,_convert.getLabel)(83922,'正在提交流程,请稍候...'),0);selectNextFlowStore.confirmEvent(result);}else{showErrorTip();// f.showErrors();
}});};_this.checkSameElement=function(nodeList,checkList){var result=false;checkList&&checkList.map(function(v1){if(nodeList&&nodeList.indexOf(v1)>-1){result=true;}});return result;};_this.showNodeInfoDialog=function(){var _this$props=_this.props,globalStore=_this$props.globalStore,selectNextFlowStore=_this$props.selectNextFlowStore;selectNextFlowStore.setNodeInfoConfirmEvent(function(rejectParams){globalStore.controlDialogVisible(type.SELECT_NEXTFLOW_NODEINFO,false);});selectNextFlowStore.setNodeInfoCancelEvent(function(){globalStore.controlDialogVisible(type.SELECT_NEXTFLOW_NODEINFO,false);});globalStore.controlDialogVisible(type.SELECT_NEXTFLOW_NODEINFO,true);// 需最后显示弹窗
};_this.state={isSubmit:false};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var selectNextFlowStore=this.props.selectNextFlowStore;selectNextFlowStore.doInit();}},{key:'render',value:function render(){var _getAntd2=(0,_convert.getAntd)(),Button=_getAntd2.Button,message=_getAntd2.message;var _getEcCom=(0,_convert.getEcCom)(),WeaDialogFooter=_getEcCom.WeaDialogFooter,WeaRightMenu=_getEcCom.WeaRightMenu,WeaSearchGroup=_getEcCom.WeaSearchGroup,WeaFormItem=_getEcCom.WeaFormItem,BaseWeaAssociativeSearch=_getEcCom.BaseWeaAssociativeSearch,WeaError=_getEcCom.WeaError;var _getComsMobx=(0,_convert.getComsMobx)(),WeaSwitch=_getComsMobx.WeaSwitch;var selectNextFlowStore=this.props.selectNextFlowStore;var form=selectNextFlowStore.form,condition=selectNextFlowStore.condition;return _react2.default.createElement('div',{className:'wf-select-next-flow'},_react2.default.createElement('div',{className:'wf-select-next-flow-content'},_react2.default.createElement(WeaRightMenu,this.getMoreBtns(),this.getConditions())),_react2.default.createElement(WeaDialogFooter,{buttons:this.getButtons(),moreBtn:this.getMoreBtns()}),_react2.default.createElement(_NodeInfoDialog2.default,{selectNextFlowStore:selectNextFlowStore}));}},{key:'getConditions',value:function getConditions(){var _this2=this;var _getAntd3=(0,_convert.getAntd)(),Button=_getAntd3.Button,message=_getAntd3.message;var _getEcCom2=(0,_convert.getEcCom)(),WeaDialogFooter=_getEcCom2.WeaDialogFooter,WeaRightMenu=_getEcCom2.WeaRightMenu,WeaSearchGroup=_getEcCom2.WeaSearchGroup,WeaFormItem=_getEcCom2.WeaFormItem,WeaBrowser=_getEcCom2.WeaBrowser,WeaError=_getEcCom2.WeaError;var _getComsMobx2=(0,_convert.getComsMobx)(),WeaSwitch=_getComsMobx2.WeaSwitch;var selectNextFlowStore=this.props.selectNextFlowStore;var form=selectNextFlowStore.form,nextNodeIds=selectNextFlowStore.nextNodeIds,_selectNextFlowStore$=selectNextFlowStore.nodeInfoMap,nodeInfoMap=_selectNextFlowStore$===undefined?{}:_selectNextFlowStore$,_selectNextFlowStore$2=selectNextFlowStore.baseParams,baseParams=_selectNextFlowStore$2===undefined?{}:_selectNextFlowStore$2,nodeScope=selectNextFlowStore.nodeScope,operatorChangeDisable=selectNextFlowStore.operatorChangeDisable,groupList=selectNextFlowStore.groupList,nodeAttribute=selectNextFlowStore.nodeAttribute,branchNodesMap=selectNextFlowStore.branchNodesMap;var groups=[];var isFormInit=form&&form.isFormInit||false;var formParams=form&&form.getFormParams()||{};// 获取节点浏览按钮的显示数据
var replaceDatas=[];//选择分叉中间点时，要过滤已选择分支的其他分叉中间点
var notNodes='';nextNodeIds.split(',').map(function(key){var nodeInfo=nodeInfoMap[key];branchNodesMap&&(0,_keys2.default)(branchNodesMap).map(function(branchMapKey){if(branchNodesMap[branchMapKey]&&branchNodesMap[branchMapKey].indexOf(key)>-1){notNodes+=","+branchNodesMap[branchMapKey].join(',');}});if(nodeInfo){replaceDatas.push({id:key,name:nodeInfo.nodeName});}});var completeParams={workflowid:baseParams.workflowid,noNeedActiveWfId:'1',nodes:nodeScope};if(notNodes!=''){notNodes=notNodes.substring(1);completeParams['notNodes']=notNodes;completeParams['nodeattribute']='2';}groupList.map(function(group,index){var items=[];var condition=mobx.toJS(group.items);var title=group.title;isFormInit&&condition.map(function(field){if(field.domkey[0].indexOf('nextNode')>-1){items.push({com:_react2.default.createElement(WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol}},_react2.default.createElement('div',{className:'form-selectNextFlow-nodeBrowser'},_react2.default.createElement(WeaError,{tipPosition:'bottom',ref:field.viewAttr==3?'nodeError':'nodeErrorNoUSE',error:(0,_convert.getLabel)(390821,'"下一节点" 未填写')},_react2.default.createElement(WeaBrowser,{type:'workflowNode',completeParams:completeParams,onBrowerClick:_this2.showNodeInfoDialog,isSingle:nodeAttribute!='1',replaceDatas:replaceDatas,onChange:_this2.onNodeBrowserChange,viewAttr:field.viewAttr})))),colSpan:1});}else{if(field.domkey[0].indexOf('nodeOperator_')>-1){// 选择节点， 操作者为必填， 没选择节点， 操作者为可编辑
field.viewAttr=!nextNodeIds||nextNodeIds==''?2:3;}if(operatorChangeDisable=='1'&&(field.domkey[0].indexOf('nodeOperator')>-1||field.domkey[0].indexOf('ccOperator')>-1)){// 禁止修改操作者
field.viewAttr=1;}items.push({com:_react2.default.createElement(WeaFormItem,{label:''+field.label,labelCol:{span:''+field.labelcol},wrapperCol:{span:''+field.fieldcol},colon:field.domkey[0].indexOf('canSubmit_')==-1,error:form.getError(field),tipPosition:'bottom',className:'form-selectnextflow-item-'+field.domkey[0]},field.domkey[0].indexOf('nodeOperator_')==-1?_react2.default.createElement(WeaSwitch,{fieldConfig:field,form:form,formParams:formParams}):_react2.default.createElement('div',{className:'form-selectNextFlow-nodeBrowser'},_react2.default.createElement(WeaError,{tipPosition:'bottom',ref:field.viewAttr==3?'operatorError_'+field.domkey[0]:'operatorErrorNoUSE',error:'"'+field.label+'" '+(0,_convert.getLabel)(21423,'未填写')},_react2.default.createElement(WeaSwitch,{fieldConfig:field,form:form,formParams:formParams})))),colSpan:1,hide:form.isHide(field,function(keys,allParams){var key=keys[0];if(key.indexOf('SignType_')>-1||key.indexOf('canSubmit_')>-1){// 禁止修改操作者，会签方式隐藏
return operatorChangeDisable=='1';}return false;})});}});isFormInit&&groups.push(_react2.default.createElement(WeaSearchGroup,{title:nodeAttribute=='1'?title:'',needTigger:nodeAttribute=='1',showGroup:true,items:items,col:1}));});return _react2.default.createElement('div',null,groups);}},{key:'getButtons',value:function getButtons(){var _getAntd4=(0,_convert.getAntd)(),Button=_getAntd4.Button,message=_getAntd4.message;var _getEcCom3=(0,_convert.getEcCom)(),WeaDialogFooter=_getEcCom3.WeaDialogFooter,WeaRightMenu=_getEcCom3.WeaRightMenu,WeaSearchGroup=_getEcCom3.WeaSearchGroup,WeaFormItem=_getEcCom3.WeaFormItem,BaseWeaAssociativeSearch=_getEcCom3.BaseWeaAssociativeSearch,WeaError=_getEcCom3.WeaError;var buttons=[];buttons.push(_react2.default.createElement(Button,{type:'primary',disabled:this.state.isSubmit,onClick:this.doConfirm},(0,_convert.getLabel)(83446,'确定')));return buttons;}},{key:'getMoreBtns',value:function getMoreBtns(){var _this3=this;var btns=[];btns.push({key:'0',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:(0,_convert.getLabel)(83446,'确定'),disabled:this.state.isSubmit,onClick:function onClick(key){return _this3.doConfirm();}});return{datas:btns};}//检查两个列表是否有共同的元素
}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _keys=__webpack_require__(25);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);__webpack_require__(281);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('selectNextFlowStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.doConfirm=function(){var selectNextFlowStore=_this.props.selectNextFlowStore;var nodeInfoConfirmEvent=selectNextFlowStore.nodeInfoConfirmEvent,appendNextNodeInfo=selectNextFlowStore.appendNextNodeInfo,updateFormByNodeInfo=selectNextFlowStore.updateFormByNodeInfo,setNextNodeIds=selectNextFlowStore.setNextNodeIds;if(_this.checkSelectedNodes(_this.state.nextNodeIds)){setNextNodeIds(_this.state.nextNodeIds.join(','));updateFormByNodeInfo();nodeInfoConfirmEvent();}};_this.state={nextNodeIds:[]};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var selectNextFlowStore=this.props.selectNextFlowStore;// selectNextFlowStore.getNodeInfo();
if(selectNextFlowStore.nextNodeIds!=''){this.setState({nextNodeIds:selectNextFlowStore.nextNodeIds.split(',')});}}},{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button,message=_getAntd.message;var _getEcCom=(0,_convert.getEcCom)(),WeaTable=_getEcCom.WeaTable,WeaSearchGroup=_getEcCom.WeaSearchGroup,WeaHelpfulTip=_getEcCom.WeaHelpfulTip,WeaDialogFooter=_getEcCom.WeaDialogFooter,WeaRightMenu=_getEcCom.WeaRightMenu,WeaFormItem=_getEcCom.WeaFormItem,WeaSelect=_getEcCom.WeaSelect,WeaBrowser=_getEcCom.WeaBrowser,WeaPopoverHrm=_getEcCom.WeaPopoverHrm;var selectNextFlowStore=this.props.selectNextFlowStore;var _selectNextFlowStore$=selectNextFlowStore.nodeInfo,nodeInfo=_selectNextFlowStore$===undefined?[]:_selectNextFlowStore$;return _react2.default.createElement('div',{className:'wf-select-node-choose'},_react2.default.createElement('div',{className:'wf-select-node-choose-content'},_react2.default.createElement(WeaRightMenu,this.getMoreBtns(),this.renderNodeTable())),_react2.default.createElement(WeaDialogFooter,{buttons:this.getButtons(),moreBtn:this.getMoreBtns()}),_react2.default.createElement(WeaPopoverHrm,null));}},{key:'renderNodeTable',value:function renderNodeTable(){var _this2=this;var _getAntd2=(0,_convert.getAntd)(),Button=_getAntd2.Button,message=_getAntd2.message;var _getEcCom2=(0,_convert.getEcCom)(),WeaTable=_getEcCom2.WeaTable,WeaSearchGroup=_getEcCom2.WeaSearchGroup,WeaHelpfulTip=_getEcCom2.WeaHelpfulTip,WeaDialogFooter=_getEcCom2.WeaDialogFooter,WeaRightMenu=_getEcCom2.WeaRightMenu,WeaFormItem=_getEcCom2.WeaFormItem,WeaSelect=_getEcCom2.WeaSelect,WeaBrowser=_getEcCom2.WeaBrowser,WeaPopoverHrm=_getEcCom2.WeaPopoverHrm;var selectNextFlowStore=this.props.selectNextFlowStore;var nodeInfo=selectNextFlowStore.nodeInfo,showAllNodeOperators=selectNextFlowStore.showAllNodeOperators,setShowAllNodeOperators=selectNextFlowStore.setShowAllNodeOperators,nextNodeInfo=selectNextFlowStore.nextNodeInfo,nodeAttribute=selectNextFlowStore.nodeAttribute;var columns=[{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(15070,'节点名称')),key:'nodeName',dataIndex:'nodeName',width:'45%'},{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(99,'操作者')),key:'operator',dataIndex:'operator',width:'55%'}];var datas=[];nodeInfo&&nodeInfo.map(function(item){var row=mobx.toJS(item);// let operators = row.operator;
var operators=item.operators;var show=showAllNodeOperators[row.id];row=(0,_extends3.default)({},row,{operator:operators&&operators.length>0?_this2.getOperatorCom(operators,show,function(){setShowAllNodeOperators(row.id);}):row.operatorGroupStr});datas.push(row);});var that=this;var rowSelection={type:'radio',selectedRowKeys:this.state.nextNodeIds,onChange:function onChange(selectedRowKeys,selectedRows){that.setState({nextNodeIds:selectedRowKeys});}};// 当前节点为分叉中间点，显示节点属性，列表为多选
if(nodeAttribute=='1'){columns=[{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(15070,'节点名称')),key:'nodeName',dataIndex:'nodeName',width:'30%'},{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(21393,'节点属性')),key:'nodeAttributeName',dataIndex:'nodeAttributeName',width:'20%'},{title:_react2.default.createElement('span',null,(0,_convert.getLabel)(99,'操作者')),key:'operator',dataIndex:'operator',width:'50%'}];rowSelection.type='checkbox';}return _react2.default.createElement(WeaTable,{columns:columns,dataSource:datas,rowSelection:rowSelection,pagination:false,onRowClick:function onRowClick(record){var nextNodeIdstmp=that.state.nextNodeIds;if(rowSelection.type=='radio'){rowSelection.selectedRowKeys=[record.key];that.setState({nextNodeIds:[record.key]});}else{if(nextNodeIdstmp.indexOf(record.key)>-1){nextNodeIdstmp.remove(record.key);rowSelection.selectedRowKeys=nextNodeIdstmp;that.setState({nextNodeIds:nextNodeIdstmp});}else{nextNodeIdstmp.push(record.key);rowSelection.selectedRowKeys=nextNodeIdstmp;that.setState({nextNodeIds:nextNodeIdstmp});}}}});}},{key:'getButtons',value:function getButtons(){var _getAntd3=(0,_convert.getAntd)(),Button=_getAntd3.Button,message=_getAntd3.message;var _getEcCom3=(0,_convert.getEcCom)(),WeaTable=_getEcCom3.WeaTable,WeaSearchGroup=_getEcCom3.WeaSearchGroup,WeaHelpfulTip=_getEcCom3.WeaHelpfulTip,WeaDialogFooter=_getEcCom3.WeaDialogFooter,WeaRightMenu=_getEcCom3.WeaRightMenu,WeaFormItem=_getEcCom3.WeaFormItem,WeaSelect=_getEcCom3.WeaSelect,WeaBrowser=_getEcCom3.WeaBrowser,WeaPopoverHrm=_getEcCom3.WeaPopoverHrm;var buttons=[];buttons.push(_react2.default.createElement(Button,{type:'primary',onClick:this.doConfirm},(0,_convert.getLabel)(83446,'确定')));return buttons;}},{key:'getMoreBtns',value:function getMoreBtns(){var _this3=this;var btns=[];btns.push({key:'0',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:(0,_convert.getLabel)(83446,'确定'),onClick:function onClick(key){return _this3.doConfirm();}});return{datas:btns};}},{key:'checkSelectedNodes',// 检查选择的节点类型
value:function checkSelectedNodes(checkNodeIds){var selectNextFlowStore=this.props.selectNextFlowStore;var _getAntd4=(0,_convert.getAntd)(),Modal=_getAntd4.Modal;var nodeInfoMap=selectNextFlowStore.nodeInfoMap,branchNodesMap=selectNextFlowStore.branchNodesMap;if(checkNodeIds.length>1){var isAllTrunkNode=true;//是否全是主干节点
var isAllDiffBranchNode=true;//是否全为不同分支分叉中间点
var branchMarks=[];checkNodeIds.map(function(nodeid){//为主干节点
if(nodeInfoMap[nodeid]&&nodeInfoMap[nodeid].nodeAttribute!='2'){isAllDiffBranchNode=false;}else{//分叉中间点
isAllTrunkNode=false;(0,_keys2.default)(branchNodesMap).map(function(key){if(branchNodesMap[key].indexOf(nodeid)>-1){if(branchMarks.indexOf(key)>-1){//节点在相同的分支
isAllDiffBranchNode=false;}else{//记录分支标识
branchMarks.push(key);}}});}});//选择的节点全为主干节点，且选择了多个
if(isAllTrunkNode){Modal.warning({content:(0,_convert.getLabel)(525840,"非分叉中间点只能选择一个"),okText:(0,_convert.getLabel)(83446,"确定"),onOk:function onOk(){}});return false;}//不全为不同分支分叉中间点
if(!isAllDiffBranchNode){Modal.warning({content:(0,_convert.getLabel)(525841,"选择的多个节点必须为不同分支的分叉中间点"),okText:(0,_convert.getLabel)(83446,"确定"),onOk:function onOk(){}});return false;}}return true;}// 渲染操作者列
},{key:'getOperatorCom',value:function getOperatorCom(){var operators=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var show=arguments[1];var func=arguments[2];var showList=operators.length<=5||show?operators:operators.slice(0,5);var operatorLink=[];for(var i=0;i<showList.length;i++){var operatorItem=showList[i];if(operatorItem.agent){// 存在代理
operatorLink.push(_react2.default.createElement('span',{style:{marginRight:'10px'}},_react2.default.createElement('a',{href:'javaScript:openhrm('+operatorItem.id+');',onClick:function onClick(e){window.pointerXY(e);},title:operatorItem.name},operatorItem.name),'->',_react2.default.createElement('a',{href:'javaScript:openhrm('+operatorItem.agent.id+');',onClick:function onClick(e){window.pointerXY(e);},title:operatorItem.agent.name},operatorItem.agent.name),_react2.default.createElement('span',null)));}else{operatorLink.push(_react2.default.createElement('span',{style:{marginRight:'10px'}},_react2.default.createElement('a',{href:'javaScript:openhrm('+operatorItem.id+');',onClick:function onClick(e){window.pointerXY(e);},title:operatorItem.name},operatorItem.name),_react2.default.createElement('span',null)));}}return _react2.default.createElement('div',{className:'operators'},_react2.default.createElement('div',{className:'browserDiv'},operatorLink),operators.length>=6&&_react2.default.createElement('span',{className:'iconSpan',title:show?(0,_convert.getLabel)(26985,'收起'):(0,_convert.getLabel)(20234,'显示全部'),onClick:function onClick(){func&&func();}},_react2.default.createElement('em',{className:show?'icon-coms-up':'icon-coms-down'})));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _Content=__webpack_require__(693);var _Content2=_interopRequireDefault(_Content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('locationMapStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call.apply(_ref,[this].concat(args))),_this),_this.doCancel=function(){var locationMapStore=_this.props.locationMapStore;locationMapStore.cancelEvent();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Main,[{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaDialog=_getEcCom.WeaDialog;var visible=this.props.visible;var dialogHeight="624px";return _react2.default.createElement(WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@n39dvd',visible:visible,loadCss:true,initLoadCss:true,title:(0,_convert.getLabel)(502317,'查看轨迹'),icon:'icon-coms-workflow',iconBgcolor:'#0079DE',maskClosable:false,onCancel:this.doCancel,style:{width:"850px",height:dialogHeight}},_react2.default.createElement(_Content2.default,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Content@78s2k3'},this.props)));}}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _reactAmap=__webpack_require__(694);__webpack_require__(707);var _mobx=__webpack_require__(9);var mobx=_interopRequireWildcard(_mobx);var _convert=__webpack_require__(6);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=(_dec=(0,_mobxReact.inject)('locationMapStore'),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(props){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this,props));_this.getCurrentMap=function(){var currentMapType='';if(_this.refs.map){currentMapType=_this.refs.map.getMap();_this.setState({currentMapType:currentMapType});}};_this.generateMarkInfo=function(specialobj){var _this$state=_this.state,showFlowNum=_this$state.showFlowNum,showInfoWindowId=_this$state.showInfoWindowId,currentMapType=_this$state.currentMapType;var markInfo=[],MapMarker=null,MapPolyline=null,linePath=[],MapInfoWindow=null;var clickMarker=function clickMarker(id){return{click:function click(){_this.setState({showInfoWindowId:id});}};};if(currentMapType=='gaode'){MapMarker=_reactAmap.Marker;MapPolyline=_reactAmap.Polyline;MapInfoWindow=_reactAmap.InfoWindow;}else{MapMarker=_this.refs.map&&_this.refs.map.getGoogleMapFuncs().newMarker;MapPolyline=_this.refs.map&&_this.refs.map.getGoogleMapFuncs().newPolyline;MapInfoWindow=_this.refs.map&&_this.refs.map.getGoogleMapFuncs().newInfoWindow;}specialobj.map(function(obj,index){var cls='wea-wf-location-infoWin';(showFlowNum==0||obj.flowNum==showFlowNum)&&showFlowNum!=-1&&obj.locationList.map(function(location,locindex){var uniquekey=index+'_'+locindex;var content='<div class=\'wea-map-marker\'><span class=\'icon-coms02-Positioning\'><span class=\'path1\'></span><span class=\'path2\'></span></span></div>';// let content = `<div class='wea-map-marker'><span class='icon-coms-position'></span></div>`;
// <span className="icon-coms02-Positioning"><span className="path1"></span><span className="path2"></span></span>
linePath.push({latitude:location.lat,longitude:location.lng});markInfo.push(_react2.default.createElement(MapMarker,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Marker@9scje9@'+uniquekey,position:{latitude:location.lat,longitude:location.lng},content:content,events:clickMarker(location.id),offset:[-10,-21]}));markInfo.push(_react2.default.createElement(MapInfoWindow,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_InfoWindow@w1wg2c@'+uniquekey,position:{latitude:location.lat,longitude:location.lng},visible:showInfoWindowId==location.id,offset:[-2,-32],isCustom:true},_react2.default.createElement('div',{className:cls},_react2.default.createElement('div',{className:cls+'-top'},_react2.default.createElement('span',{className:cls+'-top-title',title:location.nodeName},location.nodeName),_react2.default.createElement('div',{className:'rodal-close',onClick:function onClick(){_this.setState({showInfoWindowId:0});}})),_react2.default.createElement('div',{className:cls+'-contanier'},_react2.default.createElement('div',{className:cls+'-msg'},_react2.default.createElement('img',{src:location.imgUrl}),_react2.default.createElement('div',{className:cls+'-msg-base'},_react2.default.createElement('div',{className:cls+'-msg-base-info'},_react2.default.createElement('span',{className:cls+'-msg-base-info-name',title:location.userName},location.userName),_react2.default.createElement('span',{className:cls+'-msg-base-info-dep',title:location.userDep},location.userDep)),_react2.default.createElement('div',{className:cls+'-msg-base-time',title:location.time},location.time))),_react2.default.createElement('div',{className:cls+'-addr',title:(0,_convert.getLabel)(110,'地址')+':'+location.address},(0,_convert.getLabel)(110,'地址')+':'+location.address)))));});});markInfo.push(_react2.default.createElement(MapPolyline,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Polyline@5yuiy1@1',path:linePath,style:{strokeColor:'#61a8f5',strokeOpacity:1,strokeWeight:2,strokeStyle:"solid"}}));return markInfo;};_this.getRightCom=function(specialobj){var _this$state2=_this.state,showFlowNum=_this$state2.showFlowNum,searchNodeName=_this$state2.searchNodeName,instance=_this$state2.instance;var _getAntd=(0,_convert.getAntd)(),Col=_getAntd.Col,Row=_getAntd.Row;var _getEcCom=(0,_convert.getEcCom)(),WeaInputSearch=_getEcCom.WeaInputSearch,WeaCheckbox=_getEcCom.WeaCheckbox;var content=[];specialobj.map(function(obj,index){(searchNodeName==''||obj.nodeName.indexOf(searchNodeName)>-1)&&content.push(_react2.default.createElement(Row,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Row@ovd73t@'+index,className:showFlowNum==obj.flowNum?"node-content node-content-select":"node-content",onClick:function onClick(){_this.setState({showFlowNum:obj.flowNum});setTimeout(function(){instance.setFitView&&instance.setFitView();},100);}},_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@mvkech@'+index,span:2}),_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@zzo5nj@'+index,span:10},_react2.default.createElement('span',null,obj.flowNum)),_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@xyos4e@'+index,className:'nodeNameCol',span:10},obj.nodeName)));});return _react2.default.createElement('div',{className:'rightcom'},_react2.default.createElement(WeaInputSearch,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_WeaInputSearch@3w09n6',onSearchChange:function onSearchChange(value){_this.setState({searchNodeName:value});}}),_react2.default.createElement(Row,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Row@rw23vt',className:'form-title'},_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@pqzqkd',span:2}),_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@6d2ka5',span:10,className:'flownum-col',title:(0,_convert.getLabel)(502315,'流转顺序')},(0,_convert.getLabel)(502315,'流转顺序')),_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@d695nr',span:10,title:(0,_convert.getLabel)(15586,'节点')},(0,_convert.getLabel)(15586,'节点'))),_react2.default.createElement('div',{className:'rightcom-content'},content),_react2.default.createElement(Row,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Row@o5mau6',className:'node-content show-all-location'},_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@h8mzfl',span:2}),_react2.default.createElement(Col,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_Col@p7etex',span:22},_react2.default.createElement(WeaCheckbox,{ecId:(_this&&_this.props&&_this.props.ecId||'')+'_WeaCheckbox@1uq0al',id:'showAll',content:(0,_convert.getLabel)(126402,'查看所有位置轨迹'),value:showFlowNum==0,onChange:function onChange(value){if(value==="1"){_this.setState({showFlowNum:0,showInfoWindowId:0});setTimeout(function(){instance.setFitView&&instance.setFitView();},100);}else{_this.setState({showFlowNum:-1,showInfoWindowId:0});}}}))));};_this.state={showFlowNum:0,//显示的流转序号
showInfoWindowId:0,//地图上的节点信息显示id
searchNodeName:'',//搜索的节点名称
instance:{},currentMapType:'gaode'};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){this.getCurrentMap();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.getCurrentMap();}},{key:'render',value:function render(){var _this2=this;var _getEcCom2=(0,_convert.getEcCom)(),WeaMap=_getEcCom2.WeaMap,WeaDialogFooter=_getEcCom2.WeaDialogFooter,WeaLeftRightLayout=_getEcCom2.WeaLeftRightLayout,WeaCheckbox=_getEcCom2.WeaCheckbox,WeaInputSearch=_getEcCom2.WeaInputSearch;var _getAntd2=(0,_convert.getAntd)(),Col=_getAntd2.Col,Row=_getAntd2.Row;var locationMapStore=this.props.locationMapStore;var _locationMapStore$loc=locationMapStore.locationInfos,locationInfos=_locationMapStore$loc===undefined?[]:_locationMapStore$loc;var specialobj=locationInfos.specialobj?mobx.toJS(locationInfos.specialobj):[];var markInfo=this.generateMarkInfo(specialobj);var rightcom=this.getRightCom(specialobj);var instance=this.state.instance;var events={created:function created(instance){_this2.setState({instance:instance});},complete:function complete(){instance.setFitView();}};return _react2.default.createElement('div',{className:'wf-location-map'},_react2.default.createElement(WeaLeftRightLayout,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLeftRightLayout@5nrt1q',isNew:true,leftWidth:633,leftCom:_react2.default.createElement('div',{style:{height:564,width:633}},_react2.default.createElement(WeaMap,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMap@fhkzo5',ref:function ref(_ref){return _this2.map=_ref;},resizeEnable:true,events:events},markInfo)),showBtn:false},rightcom),_react2.default.createElement(WeaDialogFooter,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialogFooter@ika87c',buttons:[],moreBtn:this.getMoreBtns()}));}},{key:'getMoreBtns',value:function getMoreBtns(){var btns=[];return{datas:btns};}//生成地图覆盖物结构
//获取右侧列表组件
}]);return Main;}(_react2.default.Component))||_class)||_class);exports.default=Main;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MouseTool = exports.Marker = exports.GroundImage = exports.InfoWindow = exports.PolyEditor = exports.Polyline = exports.Polygon = exports.CircleEditor = exports.Circle = exports.Markers = exports.Map = undefined;
var _map = __webpack_require__(695);
var _map2 = _interopRequireDefault(_map);
var _marker = __webpack_require__(698);
var _marker2 = _interopRequireDefault(_marker);
var _markers = __webpack_require__(699);
var _markers2 = _interopRequireDefault(_markers);
var _circle = __webpack_require__(700);
var _circle2 = _interopRequireDefault(_circle);
var _polygon = __webpack_require__(701);
var _polygon2 = _interopRequireDefault(_polygon);
var _polyline = __webpack_require__(702);
var _polyline2 = _interopRequireDefault(_polyline);
var _infowindow = __webpack_require__(703);
var _infowindow2 = _interopRequireDefault(_infowindow);
var _groundimage = __webpack_require__(704);
var _groundimage2 = _interopRequireDefault(_groundimage);
var _circleeditor = __webpack_require__(705);
var _circleeditor2 = _interopRequireDefault(_circleeditor);
var _polyeditor = __webpack_require__(190);
var _polyeditor2 = _interopRequireDefault(_polyeditor);
var _mousetool = __webpack_require__(706);
var _mousetool2 = _interopRequireDefault(_mousetool);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.Map = _map2.default;
exports.Markers = _markers2.default;
exports.Circle = _circle2.default;
exports.CircleEditor = _circleeditor2.default;
exports.Polygon = _polygon2.default;
exports.Polyline = _polyline2.default;
exports.PolyEditor = _polyeditor2.default;
exports.InfoWindow = _infowindow2.default;
exports.GroundImage = _groundimage2.default;
exports.Marker = _marker2.default;
exports.MouseTool = _mousetool2.default;
exports.default = {
    Map: _map2.default,
    Markers: _markers2.default,
    Circle: _circle2.default,
    CircleEditor: _circleeditor2.default,
    Polygon: _polygon2.default,
    Polyline: _polyline2.default,
    PolyEditor: _polyeditor2.default,
    InfoWindow: _infowindow2.default,
    GroundImage: _groundimage2.default,
    Marker: _marker2.default,
    MouseTool: _mousetool2.default
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; };
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _APILoader = __webpack_require__(696);
var _APILoader2 = _interopRequireDefault(_APILoader);
var _isFun = __webpack_require__(137);
var _isFun2 = _interopRequireDefault(_isFun);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _common = __webpack_require__(69);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) {
    if (keys.indexOf(i) >= 0)
        continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
        continue;
    target[i] = obj[i];
} return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var Component = _react2.default.Component;
var Children = _react2.default.Children;
var containerStyle = {
    width: '100%',
    height: '100%'
};
var wrapperStyle = {
    width: '100%',
    height: '100%',
    position: 'relative'
    // Native supported dynamic props by Amap
};
var NativeDynamicProps = ['layers', 'zoom', 'center', 'labelzIndex',
    // 'lang', native error in JSSDK when 3D viewMode
    'mapStyle', 'features', 'cursor', 'pitch'];
/*
 * Props below can set by 'setStatus' altogether
 */
var StatusDynamicProps = ['animateEnable', 'doubleClickZoom', 'dragEnable', 'isHotspot', 'jogEnable', 'keyboardEnable', 'resizeEnable', 'rotateEnable', 'scrollWheel', 'touchZoom', 'zoomEnable'];
var StaticProps = ['view', 'zooms', 'showIndoorMap', 'indoorMap', 'expandZoomRange', 'showBuildingBlock', 'viewMode', 'pitchEnable', 'buildingAnimation', 'skyColor'];
var CreateProps = NativeDynamicProps.concat(StatusDynamicProps, StaticProps);
// const reservedPropName = [
//   'amapkey',
//   'version',
//   'useAMapUI',
//   'onInstanceCreated',
//   'events',
//   'loading',
//   'plugins'
// ]
var defaultOpts = {
    MapType: {
        showRoad: false,
        showTraffic: false,
        defaultType: 0
    },
    ToolBar: {
        position: 'RB',
        noIpLocate: true,
        locate: true,
        liteStyle: true,
        autoPosition: false
    },
    OverView: {},
    ControlBar: {}
};
var BaseMap = function (_Component) {
    _inherits(BaseMap, _Component);
    function BaseMap(props) {
        _classCallCheck(this, BaseMap);
        var _this = _possibleConstructorReturn(this, (BaseMap.__proto__ || Object.getPrototypeOf(BaseMap)).call(this, props));
        _this.state = {
            mapLoaded: false
        };
        var self = _this;
        _this.setterMap = {
            zoom: function zoom(val) {
                self.map.setZoom(val);
            },
            cursor: function cursor(val) {
                self.map.setDefaultCursor(val);
            },
            labelzIndex: function labelzIndex(val) {
                self.map.setlabelzIndex(val);
            }
        };
        _this.converterMap = {
            center: _common.toLnglat
        };
        if (typeof window !== 'undefined') {
            _this.pluginMap = {};
            new _APILoader2.default({
                key: props.amapkey,
                useAMapUI: props.useAMapUI,
                version: props.version,
                protocol: props.protocol
            }).load().then(function () {
                _this.createInstance();
                if (!_this.state.mapLoaded) {
                    _this.setState({
                        mapLoaded: true
                    });
                }
            });
        }
        return _this;
    }
    _createClass(BaseMap, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (this.state.mapLoaded) {
                    this.updateMapProps(this.props, nextProps);
                }
            }
        }, {
            key: 'renderChildren',
            value: function renderChildren() {
                var _this2 = this;
                return Children.map(this.props.children, function (child) {
                    if (child) {
                        var cType = child.type;
                        /* 针对下面两种组件不注入地图相关属性
                         * 1. 明确声明不需要注入的
                         * 2. DOM 元素
                         */
                        if (cType.preventAmap || typeof cType === 'string') {
                            return child;
                        }
                        return _react2.default.cloneElement(child, {
                            __map__: _this2.map
                        });
                    }
                    return child;
                });
            }
        }, {
            key: 'createInstance',
            value: function createInstance() {
                if (!this.map) {
                    var options = this.buildCreateOptions();
                    this.map = new window.AMap.Map(this.mapWrapper, options);
                    // install map plugins
                    this.setPlugins(this.props);
                    this.props.onInstanceCreated && this.props.onInstanceCreated();
                }
            }
        }, {
            key: 'buildCreateOptions',
            value: function buildCreateOptions() {
                var _this3 = this;
                var props = this.props;
                var options = {};
                CreateProps.forEach(function (key) {
                    if (key in props) {
                        options[key] = _this3.getSetterValue(key, props);
                    }
                });
                return options;
            }
        }, {
            key: 'updateMapProps',
            value: function updateMapProps(prevProps, nextProps) {
                var _this4 = this;
                var nextMapStatus = {};
                var statusChangeFlag = false;
                var statusPropExist = false;
                StatusDynamicProps.forEach(function (key) {
                    if (key in nextProps) {
                        statusPropExist = true;
                        if (_this4.detectPropChanged(key, prevProps, nextProps)) {
                            statusChangeFlag = true;
                            nextMapStatus[key] = nextProps[key];
                        }
                    }
                });
                statusChangeFlag && this.map.setStatus(nextMapStatus);
                if (statusPropExist && 'status' in nextProps) {
                    _log2.default.warning('\u4EE5\u4E0B\u8FD9\u4E9B\u5C5E\u6027\u53EF\u4EE5\u5355\u72EC\u63D0\u4F9B\u8FDB\u884C\u914D\u7F6E\uFF0C\u4E5F\u53EF\u4EE5\u7EDF\u4E00\u4F5C\u4E3A\u2018status\u2019\u5C5E\u6027\u914D\u7F6E\uFF1B\u4F46\u662F\u8BF7\u4E0D\u8981\u540C\u65F6\u4F7F\u7528\u8FD9\u4E24\u79CD\u65B9\u5F0F\u3002\n\uFF08' + StatusDynamicProps.join(', ') + '\uFF09');
                }
                StaticProps.forEach(function (key) {
                    if (key in nextProps) {
                        if (_this4.detectPropChanged(key, prevProps, nextProps)) {
                            _log2.default.warning('\'' + key + '\' \u662F\u4E00\u4E2A\u9759\u6001\u5C5E\u6027\uFF0C\u5730\u56FE\u5B9E\u4F8B\u521B\u5EFA\u6210\u529F\u540E\u65E0\u6CD5\u4FEE\u6539');
                        }
                    }
                });
                this.setPlugins(nextProps);
            }
        }, {
            key: 'getSetterValue',
            value: function getSetterValue(key, props) {
                if (key in this.converterMap) {
                    return this.converterMap[key](props[key]);
                }
                return props[key];
            }
        }, {
            key: 'detectPropChanged',
            value: function detectPropChanged(key, prevProps, nextProps) {
                return prevProps[key] !== nextProps[key];
            }
        }, {
            key: 'setPlugins',
            value: function setPlugins(props) {
                var _this5 = this;
                var pluginList = ['Scale', 'ToolBar', 'MapType', 'OverView', 'ControlBar'];
                if ('plugins' in props) {
                    var plugins = props.plugins;
                    if (plugins && plugins.length) {
                        plugins.forEach(function (p) {
                            var name = void 0, config = void 0, visible = void 0;
                            if (typeof p === 'string') {
                                name = p;
                                config = null;
                                visible = true;
                            }
                            else {
                                name = p.name;
                                config = p.options || {};
                                visible = 'visible' in config && typeof config.visible === 'boolean' ? config.visible : true;
                                delete config.visible;
                            }
                            var idx = pluginList.indexOf(name);
                            if (idx === -1) {
                                _log2.default.warning('\u6CA1\u6709 \u2018' + name + '\u2019 \u8FD9\u4E2A\u63D2\u4EF6\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u62FC\u5199\u9519\u8BEF');
                            }
                            else {
                                if (visible) {
                                    pluginList.splice(idx, 1);
                                    _this5.installPlugin(name, config);
                                }
                            }
                        });
                    }
                }
                this.removeOrDisablePlugins(pluginList);
            }
        }, {
            key: 'removeOrDisablePlugins',
            value: function removeOrDisablePlugins(plugins) {
                var _this6 = this;
                if (plugins && plugins.length) {
                    plugins.forEach(function (p) {
                        if (p in _this6.pluginMap) {
                            // ControlBar has no 'hide' method
                            if (p === 'ControlBar') {
                                _this6.map.removeControl(_this6.pluginMap[p]);
                                delete _this6.pluginMap[p];
                            }
                            else {
                                _this6.pluginMap[p].hide();
                            }
                        }
                    });
                }
            }
        }, {
            key: 'installPlugin',
            value: function installPlugin(name, opts) {
                opts = opts || {};
                switch (name) {
                    case 'Scale':
                    case 'ToolBar':
                    case 'OverView':
                    case 'MapType':
                        this.setMapPlugin(name, opts);
                        break;
                    case 'ControlBar':
                        this.setControlBar(opts);
                        break;
                    default:
                    // do nothing
                }
            }
        }, {
            key: 'setMapPlugin',
            value: function setMapPlugin(name, opts) {
                var _this7 = this;
                if (this.pluginMap[name]) {
                    this.pluginMap[name].show();
                }
                else {
                    var onCreated = opts.onCreated, restOpts = _objectWithoutProperties(opts, ['onCreated']);
                    var initOpts = _extends({}, defaultOpts[name], restOpts);
                    this.map.plugin(['AMap.' + name], function () {
                        _this7.pluginMap[name] = new window.AMap[name](initOpts);
                        _this7.map.addControl(_this7.pluginMap[name]);
                        if ((0, _isFun2.default)(onCreated)) {
                            onCreated(_this7.pluginMap[name]);
                        }
                    });
                }
            }
        }, {
            key: 'setControlBar',
            value: function setControlBar(opts) {
                var _this8 = this;
                if (this.pluginMap.ControlBar) {
                    // do nothing
                }
                else {
                    var onCreated = opts.onCreated, restOpts = _objectWithoutProperties(opts, ['onCreated']);
                    var initOpts = _extends({}, defaultOpts.ControlBar, restOpts);
                    this.map.plugin(['AMap.ControlBar'], function () {
                        _this8.pluginMap.ControlBar = new window.AMap.ControlBar(initOpts);
                        _this8.map.addControl(_this8.pluginMap.ControlBar);
                        if ((0, _isFun2.default)(onCreated)) {
                            onCreated(_this8.pluginMap.ControlBar);
                        }
                    });
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this9 = this;
                return _react2.default.createElement('div', { style: wrapperStyle }, _react2.default.createElement('div', { ref: function ref(div) {
                        _this9.mapWrapper = div;
                    }, style: containerStyle }, this.state.mapLoaded ? null : this.props.loading || null), _react2.default.createElement('div', null, this.state.mapLoaded ? this.renderChildren() : null));
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.map;
            }
        }]);
    return BaseMap;
}(Component);
exports.default = (0, _withPropsReactive2.default)(BaseMap);


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; };
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
var DEFAULT_CONFIG = {
    v: '1.4.0',
    hostAndPath: 'webapi.amap.com/maps',
    key: 'f97efc35164149d0c0f299e7a8adb3d2',
    callback: '__amap_init_callback',
    useAMapUI: false
};
var mainPromise = null;
var amapuiPromise = null;
var amapuiInited = false;
var APILoader = function () {
    function APILoader(_ref) {
        var key = _ref.key, useAMapUI = _ref.useAMapUI, version = _ref.version, protocol = _ref.protocol;
        _classCallCheck(this, APILoader);
        this.config = _extends({}, DEFAULT_CONFIG, { useAMapUI: useAMapUI, protocol: protocol });
        if (typeof window !== 'undefined') {
            if (key) {
                this.config.key = key;
            }
            else if ('amapkey' in window) {
                this.config.key = window.amapkey;
            }
        }
        if (version) {
            this.config.v = version;
        }
        this.protocol = protocol || window.location.protocol;
        if (this.protocol.indexOf(':') === -1) {
            this.protocol += ':';
        }
    }
    _createClass(APILoader, [{
            key: 'getScriptSrc',
            value: function getScriptSrc(cfg) {
                return this.protocol + '//' + cfg.hostAndPath + '?v=' + cfg.v + '&key=' + cfg.key + '&callback=' + cfg.callback;
            }
        }, {
            key: 'buildScriptTag',
            value: function buildScriptTag(src) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.defer = true;
                script.src = src;
                return script;
            }
        }, {
            key: 'getAmapuiPromise',
            value: function getAmapuiPromise() {
                var script = this.buildScriptTag(this.protocol + '//webapi.amap.com/ui/1.0/main-async.js');
                var p = new Promise(function (resolve) {
                    script.onload = function () {
                        resolve();
                    };
                });
                document.body.appendChild(script);
                return p;
            }
        }, {
            key: 'getMainPromise',
            value: function getMainPromise() {
                var _this = this;
                var script = this.buildScriptTag(this.getScriptSrc(this.config));
                var p = new Promise(function (resolve) {
                    window[_this.config.callback] = function () {
                        resolve();
                        delete window[_this.config.callback];
                    };
                });
                document.body.appendChild(script);
                return p;
            }
        }, {
            key: 'load',
            value: function load() {
                if (typeof window === 'undefined') {
                    return null;
                }
                var useAMapUI = this.config.useAMapUI;
                mainPromise = mainPromise || this.getMainPromise();
                if (useAMapUI) {
                    amapuiPromise = amapuiPromise || this.getAmapuiPromise();
                }
                return new Promise(function (resolve) {
                    mainPromise.then(function () {
                        if (useAMapUI && amapuiPromise) {
                            amapuiPromise.then(function () {
                                if (window.initAMapUI && !amapuiInited) {
                                    window.initAMapUI();
                                    if (typeof useAMapUI === 'function') {
                                        useAMapUI();
                                    }
                                    amapuiInited = true;
                                }
                                resolve();
                            });
                        }
                        else {
                            resolve();
                        }
                    });
                });
            }
        }]);
    return APILoader;
}();
exports.default = APILoader;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var toCapitalString = function toCapitalString(str) {
    return str[0].toUpperCase() + str.slice(1, str.length);
};
exports.default = toCapitalString;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _reactDom = __webpack_require__(48);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _markerUtils = __webpack_require__(283);
var _common = __webpack_require__(69);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var Marker = function (_React$Component) {
    _inherits(Marker, _React$Component);
    function Marker(props) {
        _classCallCheck(this, Marker);
        var _this = _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                var self = _this;
                _this.setterMap = {
                    visible: function visible(val) {
                        if (val) {
                            self.marker && self.marker.show();
                        }
                        else {
                            self.marker && self.marker.hide();
                        }
                    },
                    zIndex: function zIndex(val) {
                        self.marker && self.marker.setzIndex(val);
                    }
                };
                _this.converterMap = {
                    position: _common.toLnglat,
                    offset: _common.toPixel
                };
                _this.map = props.__map__;
                _this.element = _this.map.getContainer();
                setTimeout(function () {
                    _this.createMarker(props);
                }, 13);
            }
        }
        return _this;
    }
    _createClass(Marker, [{
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                return false;
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (this.map) {
                    this.refreshMarkerLayout(nextProps);
                }
            }
        }, {
            key: 'createMarker',
            value: function createMarker(props) {
                var options = this.buildCreateOptions(props);
                this.marker = new window.AMap.Marker(options);
                this.marker.render = function (marker) {
                    return function (component) {
                        (0, _markerUtils.renderMarkerComponent)(component, marker);
                    };
                }(this.marker);
                this.props.onInstanceCreated && this.props.onInstanceCreated();
                this.setMarkerLayout(props);
                this.setChildComponent(props);
            }
            // 在创建实例时根据传入配置，设置初始化选项
        }, {
            key: 'buildCreateOptions',
            value: function buildCreateOptions(props) {
                var _this2 = this;
                var opts = {};
                _markerUtils.MarkerAllProps.forEach(function (key) {
                    if (key in props) {
                        opts[key] = _this2.getSetterParam(key, props[key]);
                    }
                });
                opts.map = this.map;
                return opts;
            }
            // 初始化标记的外观
        }, {
            key: 'setMarkerLayout',
            value: function setMarkerLayout(props) {
                if ('render' in props || 'children' in props && props.children) {
                    this.createContentWrapper();
                    if ('className' in props && props.className) {
                        // https://github.com/ElemeFE/react-amap/issues/40
                        this.contentWrapper.className = props.className;
                    }
                }
            }
        }, {
            key: 'createContentWrapper',
            value: function createContentWrapper() {
                this.contentWrapper = document.createElement('div');
                this.marker.setContent(this.contentWrapper);
            }
        }, {
            key: 'setChildComponent',
            value: function setChildComponent(props) {
                if (this.contentWrapper) {
                    if ('className' in props && props.className) {
                        // https://github.com/ElemeFE/react-amap/issues/40
                        this.contentWrapper.className = props.className;
                    }
                    if ('render' in props) {
                        (0, _markerUtils.renderMarkerComponent)(props.render, this.marker);
                    }
                    else if ('children' in props) {
                        var child = props.children;
                        var childType = typeof child === 'undefined' ? 'undefined' : _typeof(child);
                        if (childType !== 'undefined' && this.contentWrapper) {
                            (0, _reactDom.render)(_react2.default.createElement('div', null, child), this.contentWrapper);
                        }
                    }
                }
            }
        }, {
            key: 'refreshMarkerLayout',
            value: function refreshMarkerLayout(nextProps) {
                this.setChildComponent(nextProps);
            }
        }, {
            key: 'getSetterParam',
            value: function getSetterParam(key, val) {
                if (key in this.converterMap) {
                    return this.converterMap[key](val);
                }
                return val;
            }
        }, {
            key: 'render',
            value: function render() {
                return null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.marker;
            }
        }]);
    return Marker;
}(_react2.default.Component);
exports.default = (0, _withPropsReactive2.default)(Marker);


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _reactDom = __webpack_require__(48);
var _isFun = __webpack_require__(137);
var _isFun2 = _interopRequireDefault(_isFun);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _markerUtils = __webpack_require__(283);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
if (typeof window !== 'undefined') {
    var styleText = '.amap_markers_pop_window{\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: #fff;\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n.amap_markers_pop_window::before{\n    content: \' \';\n    display: block;\n    position: absolute;\n    bottom: -12px;\n    left: 50%;\n    margin-left: -7px;\n    width: 0;\n    height: 0;\n    border-top: 12px solid #ddd;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n}\n.amap_markers_pop_window::after{\n    content: \' \';\n    display: block;\n    position: absolute;\n    bottom: -11px;\n    left: 50%;\n    margin-left: -6px;\n    width: 0;\n    height: 0;\n    border-top: 11px solid #fff;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n}\n.amap_markers_pop_window_item{\n    cursor:pointer;\n    width: 40px;\n    height: 50px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n}\n.amap_markers_pop_window_item span{\n    pointer-events: none;\n}\n.amap_markers_window_overflow_warning{\n    text-align: center;\n    width: 100%;\n    margin: 5px 0;\n    color: #666;\n}';
    var headEl = document.head || document.getElementsByTagName('head')[0];
    var styleEl = document.createElement('style');
    styleEl.type = 'text/css';
    styleEl.textContent = styleText;
    headEl.appendChild(styleEl);
}
var Component = _react2.default.Component;
var SCALE = 0.8;
var SIZE_WIDTH = 32 * SCALE;
var SIZE_HEIGHT = 46 * SCALE - 2;
var SIZE_HOVER_WIDTH = 46 * SCALE;
var SIZE_HOVER_HEIGHT = 66 * SCALE - 2;
var MAX_INFO_MARKERS = 42;
var defaultOpts = {
    useCluster: false,
    markersCache: [],
    markerIDCache: []
};
var ClusterProps = ['gridSize', 'minClusterSize', 'maxZoom', 'averageCenter', 'styles', 'zoomOnClick', 'renderCluserMarker'];
var IdKey = '__react_amap__';
/*
 * props
 * {
 *  useCluster(boolean)是否使用聚合点
 *  markers(array<>)坐标列表
 *  __map__ 父级组件传过来的地图实例
 *  __ele__ 父级组件传过来的地图容器
 * }
 */
var Markers = function (_Component) {
    _inherits(Markers, _Component);
    function Markers(props) {
        _classCallCheck(this, Markers);
        var _this = _possibleConstructorReturn(this, (Markers.__proto__ || Object.getPrototypeOf(Markers)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                _this.map = props.__map__;
                _this.element = _this.map.getContainer();
                _this.markersCache = defaultOpts.markersCache;
                _this.useCluster = null;
                _this.markerIDCache = defaultOpts.markerIDCache;
                _this.resetOffset = new window.AMap.Pixel(-SIZE_WIDTH / 2, -SIZE_HEIGHT);
                _this.hoverOffset = new window.AMap.Pixel(-SIZE_HOVER_WIDTH / 2, -SIZE_HOVER_HEIGHT);
                _this.createMarkers(props);
            }
        }
        return _this;
    }
    _createClass(Markers, [{
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                return false;
            }
        }, {
            key: 'createMarkers',
            value: function createMarkers(props) {
                var _this2 = this;
                var markers = props.markers || [];
                var mapMarkers = [];
                var markerReactChildDOM = {};
                markers.length && markers.forEach(function (raw, idx) {
                    var options = _this2.buildCreateOptions(props, raw, idx);
                    options.map = _this2.map;
                    var markerContent = null;
                    if ((0, _isFun2.default)(props.render)) {
                        // $FlowFixMe
                        var markerChild = props.render(raw);
                        if (markerChild !== false) {
                            var div = document.createElement('div');
                            div.setAttribute(IdKey, '1');
                            markerContent = div;
                            markerReactChildDOM[idx] = markerChild;
                        }
                    }
                    if (!markerContent) {
                        markerContent = document.createElement('div');
                        var img = document.createElement('img');
                        img.src = '//webapi.amap.com/theme/v1.3/markers/n/mark_bs.png';
                        markerContent.appendChild(img);
                    }
                    options.content = markerContent;
                    var marker = new window.AMap.Marker(options);
                    marker.on('click', function (e) {
                        _this2.onMarkerClick(e);
                    });
                    marker.on('mouseover', function (e) {
                        _this2.onMarkerHover(e);
                    });
                    marker.on('mouseout', function (e) {
                        _this2.onMarkerHoverOut(e);
                    });
                    marker.render = function (marker) {
                        return function (component) {
                            return (0, _markerUtils.renderMarkerComponent)(component, marker);
                        };
                    }(marker);
                    _this2.bindMarkerEvents(marker);
                    mapMarkers.push(marker);
                });
                this.markersCache = mapMarkers;
                this.markerReactChildDOM = markerReactChildDOM;
                this.exposeMarkerInstance();
                this.checkClusterSettings(props);
            }
        }, {
            key: 'checkClusterSettings',
            value: function checkClusterSettings(props) {
                var _this3 = this;
                if (props.useCluster) {
                    this.loadClusterPlugin(props.useCluster).then(function (cluster) {
                        cluster.setMarkers(_this3.markersCache);
                    });
                }
                else {
                    if (this.mapCluster) {
                        var markers = this.mapCluster.getMarkers();
                        this.mapCluster.clearMarkers();
                        markers.forEach(function (marker) {
                            marker.setMap(_this3.map);
                        });
                    }
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.map) {
                    this.setMarkerChild();
                }
            }
        }, {
            key: 'setMarkerChild',
            value: function setMarkerChild() {
                var _this4 = this;
                Object.keys(this.markerReactChildDOM).forEach(function (idx) {
                    var dom = _this4.markersCache[idx].getContent();
                    var child = _this4.markerReactChildDOM[idx];
                    _this4.renderMarkerChild(dom, child);
                });
            }
        }, {
            key: 'renderMarkerChild',
            value: function renderMarkerChild(dom, child) {
                (0, _reactDom.render)(_react2.default.createElement('div', null, child), dom);
            }
        }, {
            key: 'buildCreateOptions',
            value: function buildCreateOptions(props, raw, idx) {
                var result = {};
                // 强制用户通过 render 函数来定义外观
                // const disabledKeys = ['label', 'icon', 'content'];
                // 还是不强制好，通过覆盖的方式来(如果有 render，覆盖 content/icon);
                var disabledKeys = ['extData'];
                _markerUtils.MarkerAllProps.forEach(function (key) {
                    if (key in raw && disabledKeys.indexOf(key) === -1) {
                        result[key] = (0, _markerUtils.getPropValue)(key, raw[key]);
                    }
                    else if (key in props) {
                        if ((0, _isFun2.default)(props[key])) {
                            var tmpValue = props[key].call(null, raw, idx);
                            result[key] = (0, _markerUtils.getPropValue)(key, tmpValue);
                        }
                        else {
                            result[key] = (0, _markerUtils.getPropValue)(key, props[key]);
                        }
                    }
                });
                result.extData = raw;
                return result;
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (this.map) {
                    this.refreshMarkersLayout(nextProps);
                }
            }
        }, {
            key: 'refreshMarkersLayout',
            value: function refreshMarkersLayout(nextProps) {
                var markerChanged = nextProps.markers !== this.props.markers;
                var clusterChanged = !!this.props.useCluster !== !!nextProps.useCluster;
                if (markerChanged) {
                    this.markersCache.length && this.markersCache.forEach(function (marker) {
                        if (marker) {
                            marker.setMap(null);
                            marker = null;
                        }
                    });
                    this.markersCache = defaultOpts.markersCache;
                    this.createMarkers(nextProps);
                    this.setMarkerChild();
                }
                if (markerChanged || clusterChanged) {
                    if (this.markersWindow) {
                        this.markersWindow.close();
                    }
                }
                if (clusterChanged) {
                    this.checkClusterSettings(nextProps);
                }
            }
        }, {
            key: 'loadClusterPlugin',
            value: function loadClusterPlugin(clusterConfig) {
                var _this5 = this;
                if (this.mapCluster) {
                    return Promise.resolve(this.mapCluster);
                }
                var config = typeof clusterConfig === 'boolean' ? {} : clusterConfig;
                return new Promise(function (resolve) {
                    _this5.map.plugin(['AMap.MarkerClusterer'], function () {
                        resolve(_this5.createClusterPlugin(config));
                    });
                });
            }
        }, {
            key: 'createClusterPlugin',
            value: function createClusterPlugin(config) {
                var options = {};
                // const style = {
                //   url: clusterIcon,
                //   size: new window.AMap.Size(56, 56),
                //   offset: new window.AMap.Pixel(-28, -28)
                // };
                var defalutOptions = {
                    minClusterSize: 2,
                    zoomOnClick: false,
                    maxZoom: 18,
                    gridSize: 60,
                    // styles: [style, style, style],
                    averageCenter: true
                };
                ClusterProps.forEach(function (key) {
                    if (key in config) {
                        options[key] = config[key];
                    }
                    else {
                        options[key] = defalutOptions[key];
                    }
                });
                this.mapCluster = new window.AMap.MarkerClusterer(this.map, [], options);
                var events = {};
                if ('events' in config) {
                    events = config.events;
                    if ('created' in events) {
                        events.created(this.mapCluster);
                    }
                }
                this.initClusterMarkerWindow();
                this.bindClusterEvent(events);
                return this.mapCluster;
            }
        }, {
            key: 'onMarkerClick',
            value: function onMarkerClick(e) {
                var marker = e.target;
                this.triggerMarkerClick(e, marker);
            }
        }, {
            key: 'onMarkerHover',
            value: function onMarkerHover(e) {
                e.target.setTop(true);
                this.setMarkerHovered(e, e.target);
            }
        }, {
            key: 'onMarkerHoverOut',
            value: function onMarkerHoverOut(e) {
                e.target.setTop(false);
                this.setMarkerHoverOut(e, e.target);
            }
        }, {
            key: 'onWindowMarkerClick',
            value: function onWindowMarkerClick(element) {
                var marker = element.markerRef;
                this.triggerMarkerClick(null, marker);
            }
        }, {
            key: 'onWindowMarkerHover',
            value: function onWindowMarkerHover(element) {
                var marker = element.markerRef;
                this.setMarkerHovered(null, marker);
            }
        }, {
            key: 'onWindowMarkerHoverOut',
            value: function onWindowMarkerHoverOut(element) {
                var marker = element.markerRef;
                this.setMarkerHoverOut(null, marker);
            }
        }, {
            key: 'setMarkerHovered',
            value: function setMarkerHovered(e, marker) {
                this.triggerMarkerHover(e, marker);
            }
        }, {
            key: 'setMarkerHoverOut',
            value: function setMarkerHoverOut(e, marker) {
                this.triggerMarkerHoverOut(e, marker);
            }
        }, {
            key: 'triggerMarkerClick',
            value: function triggerMarkerClick(e, marker) {
                // const raw = marker.getExtData();
                var events = this.props.events || {};
                if ((0, _isFun2.default)(events.click)) {
                    events.click(e, marker);
                }
            }
        }, {
            key: 'triggerMarkerHover',
            value: function triggerMarkerHover(e, marker) {
                // const raw = marker.getExtData();
                var events = this.props.events || {};
                if ((0, _isFun2.default)(events.mouseover)) {
                    events.mouseover(e, marker);
                }
            }
        }, {
            key: 'triggerMarkerHoverOut',
            value: function triggerMarkerHoverOut(e, marker) {
                // const raw = marker.getExtData();
                var events = this.props.events || {};
                if ((0, _isFun2.default)(events.mouseout)) {
                    events.mouseout(e, marker);
                }
            }
        }, {
            key: 'initClusterMarkerWindow',
            value: function initClusterMarkerWindow() {
                this.markersWindow = new window.AMap.InfoWindow({
                    isCustom: true,
                    autoMove: true,
                    closeWhenClickMap: true,
                    content: '<span>loading...</span>',
                    showShadow: false,
                    offset: new window.AMap.Pixel(0, -20)
                });
                this.markersDOM = document.createElement('div');
                this.markersDOM.className = 'amap_markers_pop_window';
                this.markersWindow.setContent(this.markersDOM);
            }
        }, {
            key: 'bindClusterEvent',
            value: function bindClusterEvent(events) {
                var _this6 = this;
                this.mapCluster.on('click', function (e) {
                    if (_this6.props.useCluster && _this6.props.useCluster.zoomOnClick) {
                        //
                    }
                    else {
                        var returnValue = true;
                        if ((0, _isFun2.default)(events.click)) {
                            returnValue = events.click(e);
                        }
                        if (returnValue !== false) {
                            _this6.showMarkersInfoWindow(e);
                        }
                    }
                });
            }
        }, {
            key: 'showMarkersInfoWindow',
            value: function showMarkersInfoWindow(e) {
                var _this7 = this;
                var pos = e.lnglat;
                var markers = e.markers;
                this.markersDOM.innerHTML = '';
                if (markers && markers.length) {
                    var length = markers.length;
                    if (length > MAX_INFO_MARKERS) {
                        markers = markers.slice(0, MAX_INFO_MARKERS);
                    }
                    markers.forEach(function (m) {
                        var contentDOM = m.getContent();
                        var itemDOM = document.createElement('div');
                        itemDOM.className = 'window_marker_item';
                        itemDOM.appendChild(contentDOM);
                        itemDOM.markerRef = m;
                        itemDOM.addEventListener('click', _this7.onWindowMarkerClick.bind(_this7, itemDOM), true);
                        itemDOM.addEventListener('mouseover', _this7.onWindowMarkerHover.bind(_this7, itemDOM), true);
                        itemDOM.addEventListener('mouseout', _this7.onWindowMarkerHoverOut.bind(_this7, itemDOM), true);
                        _this7.markersDOM.appendChild(itemDOM);
                    });
                    if (length > MAX_INFO_MARKERS) {
                        var warning = document.createElement('div');
                        warning.className = 'amap_markers_window_overflow_warning';
                        warning.innerText = '更多坐标请放大地图查看';
                        this.markersDOM.appendChild(warning);
                    }
                }
                this.markersWindow.open(this.map, pos);
            }
        }, {
            key: 'exposeMarkerInstance',
            value: function exposeMarkerInstance() {
                if ('events' in this.props) {
                    var events = this.props.events || {};
                    if ((0, _isFun2.default)(events.created)) {
                        events.created(this.markersCache);
                    }
                }
            }
        }, {
            key: 'bindMarkerEvents',
            value: function bindMarkerEvents(marker) {
                var events = this.props.events || {};
                var list = Object.keys(events);
                var preserveEv = ['click', 'mouseover', 'mouseout', 'created'];
                list.length && list.forEach(function (evName) {
                    if (preserveEv.indexOf(evName) === -1) {
                        marker.on(evName, events[evName]);
                    }
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return null;
            }
        }]);
    return Markers;
}(Component);
exports.default = Markers;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _common = __webpack_require__(69);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 * }
 */
var configurableProps = ['center', 'radius', 'draggable', 'extData',
    /* 原生的接口中并没有这些对象，这是本组件的扩展 */
    'visible', 'style'];
var allProps = configurableProps.concat(['zIndex', 'bubble']);
var Circle = function (_React$Component) {
    _inherits(Circle, _React$Component);
    function Circle(props) {
        _classCallCheck(this, Circle);
        var _this = _possibleConstructorReturn(this, (Circle.__proto__ || Object.getPrototypeOf(Circle)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                var self = _this;
                _this.setterMap = {
                    visible: function visible(val) {
                        if (self.mapCircle) {
                            if (val) {
                                self.mapCircle.show();
                            }
                            else {
                                self.mapCircle.hide();
                            }
                        }
                    },
                    style: function style(val) {
                        self.mapCircle && self.mapCircle.setOptions(val);
                    }
                };
                _this.converterMap = {
                    center: _common.toLnglat
                };
                _this.state = {
                    loaded: false
                };
                _this.map = props.__map__;
                _this.element = _this.map.getContainer();
                _this.createInstance(props).then(function () {
                    _this.setState({
                        loaded: true
                    });
                    _this.props.onInstanceCreated && _this.props.onInstanceCreated();
                });
            }
        }
        return _this;
    }
    _createClass(Circle, [{
            key: 'createInstance',
            value: function createInstance(props) {
                var options = this.buildCreateOptions(props);
                options.map = this.map;
                this.mapCircle = new window.AMap.Circle(options);
                return Promise.resolve(this.mapCircle);
            }
        }, {
            key: 'buildCreateOptions',
            value: function buildCreateOptions(props) {
                var _this2 = this;
                var options = {};
                allProps.forEach(function (key) {
                    if (key in props) {
                        if (key === 'style' && props.style !== undefined) {
                            var styleItem = Object.keys(props.style);
                            styleItem.forEach(function (item) {
                                // $FlowFixMe
                                options[item] = props.style[item];
                            });
                        }
                        else {
                            options[key] = _this2.getSetterValue(key, props);
                        }
                    }
                });
                return options;
            }
        }, {
            key: 'getSetterValue',
            value: function getSetterValue(key, props) {
                if (key in this.converterMap) {
                    return this.converterMap[key](props[key]);
                }
                return props[key];
            }
        }, {
            key: 'renderEditor',
            value: function renderEditor(children) {
                if (!children) {
                    return null;
                }
                if (_react2.default.Children.count(children) !== 1) {
                    return null;
                }
                return _react2.default.cloneElement(_react2.default.Children.only(children), {
                    __circle__: this.mapCircle,
                    __map__: this.map,
                    __ele__: this.element
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return this.state.loaded ? this.renderEditor(this.props.children) : null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.mapCircle;
            }
        }]);
    return Circle;
}(_react2.default.Component);
exports.default = (0, _withPropsReactive2.default)(Circle);


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _polyeditor = __webpack_require__(190);
var _polyeditor2 = _interopRequireDefault(_polyeditor);
var _common = __webpack_require__(69);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 *
 * }
 */
var configurableProps = ['path', 'draggable', 'extData',
    /* 本插件扩展的属性*/
    'style', 'visible'];
var allProps = configurableProps.concat(['zIndex', 'bubble']);
var Polygon = function (_Component) {
    _inherits(Polygon, _Component);
    function Polygon(props) {
        _classCallCheck(this, Polygon);
        var _this = _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                var self = _this;
                _this.setterMap = {
                    visible: function visible(val) {
                        if (val) {
                            self.polygon && self.polygon.show();
                        }
                        else {
                            self.polygon && self.polygon.hide();
                        }
                    },
                    style: function style(val) {
                        self.polygon.setOptions(val);
                    }
                };
                _this.converterMap = {
                    path: function path(val) {
                        return self.buildPathValue(val);
                    }
                };
                _this.state = {
                    loaded: false
                };
                _this.map = props.__map__;
                _this.element = _this.map.getContainer();
                setTimeout(function () {
                    _this.initMapPolygon(props);
                }, 13);
            }
        }
        return _this;
    }
    _createClass(Polygon, [{
            key: 'initMapPolygon',
            value: function initMapPolygon(props) {
                var options = this.buildCreateOptions(props);
                options.map = this.map;
                this.polygon = new window.AMap.Polygon(options);
                this.setState({
                    loaded: true
                });
                this.props.onInstanceCreated && this.props.onInstanceCreated();
            }
        }, {
            key: 'buildCreateOptions',
            value: function buildCreateOptions(props) {
                var _this2 = this;
                var options = {};
                allProps.forEach(function (key) {
                    if (key in props) {
                        if (key === 'style' && props.style) {
                            var styleItem = Object.keys(props.style);
                            styleItem.forEach(function (item) {
                                // $FlowFixMe
                                options[item] = props.style[item];
                            });
                            // visible 做特殊处理
                        }
                        else if (key !== 'visible') {
                            options[key] = _this2.getSetterValue(key, props[key]);
                        }
                    }
                });
                return options;
            }
        }, {
            key: 'detectPropChanged',
            value: function detectPropChanged(key, nextProps) {
                return this.props[key] !== nextProps[key];
            }
        }, {
            key: 'getSetterValue',
            value: function getSetterValue(key, value) {
                if (key in this.converterMap) {
                    return this.converterMap[key](value);
                }
                return value;
            }
        }, {
            key: 'buildPathValue',
            value: function buildPathValue(path) {
                var _this3 = this;
                if (path.length) {
                    var firstNode = path[0];
                    if (typeof firstNode[0] === 'number') {
                        return path.map(function (p) {
                            return (0, _common.toLnglat)(p);
                        });
                    }
                    if ('getLng' in firstNode) {
                        return path;
                    }
                    if ('longitude' in firstNode || 'lng' in firstNode) {
                        return path.map(function (p) {
                            return (0, _common.toLnglat)(p);
                        });
                    }
                    if ('length' in firstNode && firstNode.length) {
                        // $FlowFixMe
                        return path.map(function (ring) {
                            return _this3.buildPathValue(ring);
                        });
                    }
                }
                return [];
            }
        }, {
            key: 'renderEditor',
            value: function renderEditor(children) {
                if (!children) {
                    return null;
                }
                if (_react2.default.Children.count(children) !== 1) {
                    return null;
                }
                var child = _react2.default.Children.only(children);
                if (child.type === _polyeditor2.default) {
                    return _react2.default.cloneElement(child, {
                        __poly__: this.polygon,
                        __map__: this.map
                    });
                }
                return null;
            }
        }, {
            key: 'render',
            value: function render() {
                return this.state.loaded ? this.renderEditor(this.props.children) : null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.polygon;
            }
        }]);
    return Polygon;
}(_react.Component);
exports.default = (0, _withPropsReactive2.default)(Polygon);


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _polyeditor = __webpack_require__(190);
var _polyeditor2 = _interopRequireDefault(_polyeditor);
var _common = __webpack_require__(69);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var Component = _react2.default.Component;
var configurableProps = ['path', 'extData', 'draggable',
    /* 扩展属性*/
    'visible', 'style'];
var allProps = configurableProps.concat(['zIndex', 'bubble', 'showDir']);
var Polyline = function (_Component) {
    _inherits(Polyline, _Component);
    function Polyline(props) {
        _classCallCheck(this, Polyline);
        var _this = _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                var self = _this;
                _this.setterMap = {
                    visible: function visible(val) {
                        if (val) {
                            self.polyline && self.polyline.show();
                        }
                        else {
                            self.polyline && self.polyline.hide();
                        }
                    },
                    style: function style(val) {
                        self.polyline.setOptions(val);
                    }
                };
                _this.converterMap = {
                    path: function path(val) {
                        return self.buildPathValue(val);
                    }
                };
                _this.state = {
                    loaded: false
                };
                _this.map = props.__map__;
                _this.element = _this.map.getContainer();
                setTimeout(function () {
                    _this.createMapPolyline(props);
                }, 13);
            }
        }
        return _this;
    }
    _createClass(Polyline, [{
            key: 'createMapPolyline',
            value: function createMapPolyline(props) {
                var options = this.buildCreateOptions(props);
                options.map = this.map;
                this.polyline = new window.AMap.Polyline(options);
                this.setState({
                    loaded: true
                });
                this.props.onInstanceCreated && this.props.onInstanceCreated();
            }
        }, {
            key: 'buildCreateOptions',
            value: function buildCreateOptions(props) {
                var _this2 = this;
                var options = {};
                allProps.forEach(function (key) {
                    if (key in props) {
                        if (key === 'style' && props.style) {
                            var styleItem = Object.keys(props.style);
                            styleItem.forEach(function (item) {
                                // $FlowFixMe
                                options[item] = props.style[item];
                            });
                            // visible 做特殊处理
                        }
                        else if (key !== 'visible') {
                            options[key] = _this2.getSetterValue(key, props[key]);
                        }
                    }
                });
                return options;
            }
        }, {
            key: 'detectPropChanged',
            value: function detectPropChanged(key, nextProps) {
                return this.props[key] !== nextProps[key];
            }
        }, {
            key: 'getSetterValue',
            value: function getSetterValue(key, value) {
                if (key in this.converterMap) {
                    return this.converterMap[key](value);
                }
                return value;
            }
        }, {
            key: 'buildPathValue',
            value: function buildPathValue(path) {
                if (path.length) {
                    if ('getLng' in path[0]) {
                        return path;
                    }
                    return path.map(function (p) {
                        return (0, _common.toLnglat)(p);
                    });
                }
                return path;
            }
        }, {
            key: 'renderEditor',
            value: function renderEditor(children) {
                if (!children) {
                    return null;
                }
                if (_react2.default.Children.count(children) !== 1) {
                    return null;
                }
                var child = _react2.default.Children.only(children);
                if (child.type === _polyeditor2.default) {
                    return _react2.default.cloneElement(child, {
                        __poly__: this.polyline,
                        __map__: this.map
                    });
                }
                return null;
            }
        }, {
            key: 'render',
            value: function render() {
                return this.state.loaded ? this.renderEditor(this.props.children) : null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.polyline;
            }
        }]);
    return Polyline;
}(Component);
exports.default = (0, _withPropsReactive2.default)(Polyline);


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _reactDom = __webpack_require__(48);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _common = __webpack_require__(69);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 * }
 */
var Component = _react2.default.Component;
var configurableProps = ['content', 'position', 'size',
    /* 以下属性是本插件的扩展 */
    'visible',
    /* 这个 setOffset  方法高德并没有明确在文档中列出来，不确定会不会撤销 */
    'offset'];
var allProps = configurableProps.concat(['isCustom', 'autoMove', 'closeWhenClickMap', 'showShadow']);
var InfoWindow = function (_Component) {
    _inherits(InfoWindow, _Component);
    function InfoWindow(props) {
        _classCallCheck(this, InfoWindow);
        var _this = _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                var self = _this;
                _this.setterMap = {
                    visible: function visible(val) {
                        if (val) {
                            self.showWindow();
                            self.setClassName(self.props);
                            self.setChild(self.props);
                        }
                        else {
                            self.closeWindow();
                        }
                    }
                };
                _this.converterMap = {
                    size: _common.toSize,
                    offset: _common.toPixel,
                    position: _common.toLnglat
                };
                _this.map = props.__map__;
                _this.isCustom = true;
                setTimeout(function () {
                    _this.createInfoWindow(props);
                }, 13);
            }
        }
        return _this;
    }
    _createClass(InfoWindow, [{
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                return false;
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (this.map) {
                    this.refreshWindowLayout(nextProps);
                }
            }
        }, {
            key: 'createInfoWindow',
            value: function createInfoWindow(props) {
                var options = this.buildCreateOptions(props);
                this.infoWindow = new window.AMap.InfoWindow(options);
                this.props.onInstanceCreated && this.props.onInstanceCreated();
            }
        }, {
            key: 'refreshWindowLayout',
            value: function refreshWindowLayout(nextProps) {
                this.setChild(nextProps);
                this.setClassName(nextProps);
            }
        }, {
            key: 'checkPropChanged',
            value: function checkPropChanged(key, nextProps) {
                return this.props[key] !== nextProps[key];
            }
        }, {
            key: 'showWindow',
            value: function showWindow() {
                this.infoWindow.open(this.map, this.infoWindow.getPosition());
            }
        }, {
            key: 'closeWindow',
            value: function closeWindow() {
                this.infoWindow.close();
            }
        }, {
            key: 'buildCreateOptions',
            value: function buildCreateOptions(props) {
                var _this2 = this;
                var options = {};
                // 如果开发者没有设置 isCustom 属性，默认设置为 false
                if ('isCustom' in props) {
                    options.isCustom = !!props.isCustom;
                }
                else {
                    options.isCustom = false;
                }
                if ('content' in props) {
                    options.content = props.content;
                }
                else {
                    this.infoDOM = document.createElement('div');
                    options.content = this.infoDOM;
                }
                allProps.forEach(function (key) {
                    if (key in props) {
                        if (['visible', 'isCustom', 'content'].indexOf(key) === -1) {
                            options[key] = _this2.getSetterValue(key, props[key]);
                        }
                    }
                });
                return options;
            }
        }, {
            key: 'getSetterValue',
            value: function getSetterValue(key, value) {
                if (key in this.converterMap) {
                    return this.converterMap[key](value);
                }
                return value;
            }
        }, {
            key: 'setChild',
            value: function setChild(props) {
                var child = props.children;
                if (this.infoDOM && child) {
                    (0, _reactDom.render)(_react2.default.createElement('div', null, child), this.infoDOM);
                }
                else {
                    if (props.children) {
                        console.warn('因为你设置 isCustom 为 true，InfoWindow 的 Children 被忽略');
                    }
                }
            }
        }, {
            key: 'setClassName',
            value: function setClassName(props) {
                if (this.infoDOM) {
                    var baseClsValue = '';
                    // 刷新 className
                    if ('className' in props && props.className) {
                        baseClsValue += props.className;
                    }
                    else if (props.isCustom === true) {
                        baseClsValue += 'amap_markers_pop_window';
                    }
                    this.infoDOM.className = baseClsValue;
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.infoWindow;
            }
        }]);
    return InfoWindow;
}(Component);
exports.default = (0, _withPropsReactive2.default)(InfoWindow);


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/*
 * props
 * {
 *  __map__ 父级组件传过来的地图实例
 * }
 */
var defaultOpts = {
    clickable: false,
    opacity: 1,
    visible: true
};
var GroundImage = function (_React$Component) {
    _inherits(GroundImage, _React$Component);
    function GroundImage(props) {
        _classCallCheck(this, GroundImage);
        var _this = _possibleConstructorReturn(this, (GroundImage.__proto__ || Object.getPrototypeOf(GroundImage)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                var self = _this;
                _this.setterMap = {
                    visible: function visible(val) {
                        if (val) {
                            self.image && self.image.show();
                        }
                        else {
                            self.image && self.image.hide();
                        }
                    },
                    src: function src(val) {
                        self.image.setImageUrl(val);
                    }
                };
                _this.converterMap = {
                    bounds: function bounds(val) {
                        return self.buildBounds(val);
                    }
                };
                _this.map = props.__map__;
                _this.element = _this.map.getContainer();
                setTimeout(function () {
                    _this.createGroundImage(props);
                }, 13);
            }
        }
        return _this;
    }
    _createClass(GroundImage, [{
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                return false;
            }
        }, {
            key: 'checkPropsChanged',
            value: function checkPropsChanged(nextProps, key) {
                return this.props[key] !== nextProps[key];
            }
        }, {
            key: 'createGroundImage',
            value: function createGroundImage(props) {
                var src = void 0, bounds = void 0, opacity = void 0, clickable = void 0;
                if ('src' in props) {
                    src = props.src;
                }
                else {
                    _log2.default.warning('SRC_REQUIRED', true);
                }
                if ('bounds' in props) {
                    bounds = this.buildBounds(props.bounds);
                }
                else {
                    _log2.default.warning('BOUNDS_REQUIRED', true);
                }
                if ('clickable' in props) {
                    clickable = props.clickable;
                }
                else {
                    clickable = defaultOpts.clickable;
                }
                if ('opacity' in props) {
                    opacity = props.opacity;
                }
                else {
                    opacity = defaultOpts.opacity;
                }
                this.image = new window.AMap.GroundImage(src, bounds, {
                    map: this.map,
                    clickable: clickable,
                    opacity: opacity
                });
                this.props.onInstanceCreated && this.props.onInstanceCreated();
            }
        }, {
            key: 'buildBounds',
            value: function buildBounds(rawBounds) {
                if (!rawBounds) {
                    return rawBounds;
                }
                if ('getSouthWest' in rawBounds) {
                    return rawBounds;
                }
                var bounds = new window.AMap.Bounds(new window.AMap.LngLat(rawBounds.sw.longitude, rawBounds.sw.latitude), new window.AMap.LngLat(rawBounds.ne.longitude, rawBounds.ne.latitude));
                return bounds;
            }
        }, {
            key: 'render',
            value: function render() {
                return null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.image;
            }
        }]);
    return GroundImage;
}(_react2.default.Component);
exports.default = (0, _withPropsReactive2.default)(GroundImage);


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
var _isFun = __webpack_require__(137);
var _isFun2 = _interopRequireDefault(_isFun);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var CircleEditor = function (_React$Component) {
    _inherits(CircleEditor, _React$Component);
    function CircleEditor(props) {
        _classCallCheck(this, CircleEditor);
        var _this = _possibleConstructorReturn(this, (CircleEditor.__proto__ || Object.getPrototypeOf(CircleEditor)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!(props.__map__ && props.__circle__)) {
                _log2.default.warning('CIRCLE_INSTANCE_REQUIRED');
            }
            else {
                _this.map = props.__map__;
                _this.element = _this.map.getContainer();
                _this.circle = props.__circle__;
                _this.editorActive = false;
                _this.onPropsUpdate(props);
            }
        }
        return _this;
    }
    _createClass(CircleEditor, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (this.map) {
                    this.onPropsUpdate(nextProps);
                }
            }
        }, {
            key: 'onPropsUpdate',
            value: function onPropsUpdate(props) {
                if ('active' in props && props.active === false) {
                    this.toggleActive(false, props);
                }
                else {
                    this.toggleActive(true, props);
                }
            }
        }, {
            key: 'toggleActive',
            value: function toggleActive(active, props) {
                if (active) {
                    if (!this.editorActive) {
                        this.activeEditor(props);
                    }
                }
                else {
                    if (this.editorActive) {
                        this.inactiveEditor();
                    }
                }
            }
        }, {
            key: 'activeEditor',
            value: function activeEditor(props) {
                var _this2 = this;
                this.loadCircleEditor(props).then(function (editor) {
                    _this2.editorActive = true;
                    editor.open();
                });
            }
        }, {
            key: 'inactiveEditor',
            value: function inactiveEditor() {
                this.editorActive = false;
                if (this.circleEditor) {
                    this.circleEditor.close();
                }
            }
        }, {
            key: 'loadCircleEditor',
            value: function loadCircleEditor(props) {
                var _this3 = this;
                if (this.circleEditor) {
                    return Promise.resolve(this.circleEditor);
                }
                return new Promise(function (resolve) {
                    _this3.map.plugin(['AMap.CircleEditor'], function () {
                        resolve(_this3.createEditorInstance(props));
                    });
                });
            }
        }, {
            key: 'createEditorInstance',
            value: function createEditorInstance(props) {
                this.circleEditor = new window.AMap.CircleEditor(this.map, this.circle);
                var events = this.exposeEditorInstance(props);
                events && this.bindEditorEvents(events);
                return this.circleEditor;
            }
        }, {
            key: 'exposeEditorInstance',
            value: function exposeEditorInstance(props) {
                if ('events' in props) {
                    var _events = props.events || {};
                    if ((0, _isFun2.default)(_events.created)) {
                        _events.created(this.circleEditor);
                    }
                    delete _events.created;
                    return _events;
                }
                return false;
            }
        }, {
            key: 'bindEditorEvents',
            value: function bindEditorEvents(events) {
                var _this4 = this;
                var list = Object.keys(events);
                list.length && list.forEach(function (evName) {
                    _this4.circleEditor.on(evName, events[evName]);
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return null;
            }
        }]);
    return CircleEditor;
}(_react2.default.Component);
exports.default = CircleEditor;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(1);
var _react2 = _interopRequireDefault(_react);
var _withPropsReactive = __webpack_require__(50);
var _withPropsReactive2 = _interopRequireDefault(_withPropsReactive);
var _log = __webpack_require__(40);
var _log2 = _interopRequireDefault(_log);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var MouseTool = function (_React$Component) {
    _inherits(MouseTool, _React$Component);
    function MouseTool(props) {
        _classCallCheck(this, MouseTool);
        var _this = _possibleConstructorReturn(this, (MouseTool.__proto__ || Object.getPrototypeOf(MouseTool)).call(this, props));
        if (typeof window !== 'undefined') {
            if (!props.__map__) {
                _log2.default.warning('MAP_INSTANCE_REQUIRED');
            }
            else {
                _this.map = props.__map__;
                _this.loadToolInstance().then(function () {
                    _this.props.onInstanceCreated && _this.props.onInstanceCreated();
                });
            }
        }
        return _this;
    }
    _createClass(MouseTool, [{
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                return false;
            }
        }, {
            key: 'loadToolInstance',
            value: function loadToolInstance() {
                var _this2 = this;
                return new Promise(function (resolve) {
                    _this2.map.plugin(['AMap.MouseTool'], function () {
                        _this2.tool = new window.AMap.MouseTool(_this2.map);
                        resolve();
                    });
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return null;
            }
        }, {
            key: 'instance',
            get: function get() {
                return this.tool;
            }
        }]);
    return MouseTool;
}(_react2.default.Component);
exports.default = (0, _withPropsReactive2.default)(MouseTool);


/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RemindSet=function(_React$Component){(0,_inherits3.default)(RemindSet,_React$Component);function RemindSet(){(0,_classCallCheck3.default)(this,RemindSet);var _this=(0,_possibleConstructorReturn3.default)(this,(RemindSet.__proto__||(0,_getPrototypeOf2.default)(RemindSet)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(RemindSet,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var RemindSetStore=window.weaWorkflowPublic.RemindSetStore;var store=new RemindSetStore();_this2.setState({hasLoad:true,store:store});};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);}},{key:'render',value:function render(){var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;if(hasLoad){var _RemindSet=window.weaWorkflowPublic.RemindSet;var _props=this.props,requestId=_props.requestId,workflowId=_props.workflowId,submitType=_props.submitType,callBackActions=_props.callBackActions;store.setParams({requestId:requestId,workflowId:workflowId,submitType:submitType});store.setCallBackActions(callBackActions);return _react2.default.createElement(_RemindSet,{ecId:(this&&this.props&&this.props.ecId||'')+'_RemindSet@v5c2sk',store:store});}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@j2a95y'});}}}]);return RemindSet;}(_react2.default.Component);exports.default=RemindSet;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _asyncLoad=__webpack_require__(14);var asyncLoad=_interopRequireWildcard(_asyncLoad);var _fileConfig=__webpack_require__(18);var _index=__webpack_require__(49);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TagTypeSelect=(0,_index.observer)(_class=function(_React$Component){(0,_inherits3.default)(TagTypeSelect,_React$Component);function TagTypeSelect(){(0,_classCallCheck3.default)(this,TagTypeSelect);var _this=(0,_possibleConstructorReturn3.default)(this,(TagTypeSelect.__proto__||(0,_getPrototypeOf2.default)(TagTypeSelect)).call(this));_this.addBtnClick=function(value){var _this$state=_this.state,hasLoad=_this$state.hasLoad,store=_this$state.store;var saveAttentionTypeSet=store.saveAttentionTypeSet,getAttentionTypeSet=store.getAttentionTypeSet;var curStore=_this.props.curStore;saveAttentionTypeSet({showname:value,src:'saveData2',id:curStore.FollowRequestid});};_this.onVisibleChange=function(v){var curStore=_this.props.curStore;curStore.followTypeSelectShow=false;};_this.followMakeSure=function(){//点击确定之后刷新列表
var curStore=_this.props.curStore;var _this$props=_this.props,location=_this$props.location,refresh=_this$props.refresh;var urlParams=location.query||{};refresh();curStore.followTypeSelectShow=false;};_this.state={hasLoad:false,store:null};return _this;}(0,_createClass3.default)(TagTypeSelect,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var init=function init(){var FollowTypeSettingStore=window.weaWorkflowPublic.FollowTypeSettingStore;var store=new FollowTypeSettingStore();_this2.setState({hasLoad:true,store:store});window.followTypeSettingStore=store;//抛出store给unitll用
};asyncLoad.asyncLoadModule('workflowPublic',_fileConfig.workflowPublicFiles,init);this.timerID=setTimeout(function(){$(".wf_attention_div_btn").on("mouseover mouseout",function(event){var str=$(this).attr('id').substr($(this).attr('id').indexOf('_'));if(event.type=="mouseover"){jQuery("#attentionSpan"+str).css("display","inline-block");}else if(event.type=="mouseout"){jQuery("#attentionSpan"+str).css("display","none");}});},1000);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.timerID=setTimeout(function(){$(".wf_attention_div_btn").on("mouseover mouseout",function(event){var str=$(this).attr('id').substr($(this).attr('id').indexOf('_'));if(event.type=="mouseover"){jQuery("#attentionSpan"+str).css("display","inline-block");}else if(event.type=="mouseout"){jQuery("#attentionSpan"+str).css("display","none");}});},1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timerID);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,hasLoad=_state.hasLoad,store=_state.store;var _props=this.props,curStore=_props.curStore,commonParam=_props.commonParam;if(hasLoad){var _TagTypeSelect=window.weaWorkflowPublic.TagTypeSelect;return _react2.default.createElement(_TagTypeSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_TagTypeSelect@btuws9',followTypeSettingStore:store,button:''//自定义dom
,FollowRequestid:commonParam.requestid||"",visible:curStore.followTypeSelectShow,onVisibleChange:this.onVisibleChange,addBtn:this.addBtnClick,placement:'bottom',makeSureCallBack:function makeSureCallBack(){_this3.followMakeSure();}});}else{return _react2.default.createElement('div',null);}}}]);return TagTypeSelect;}(_react2.default.Component))||_class;exports.default=TagTypeSelect;

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _convert=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ReqNoRight=function(_React$Component){(0,_inherits3.default)(ReqNoRight,_React$Component);function ReqNoRight(){(0,_classCallCheck3.default)(this,ReqNoRight);return(0,_possibleConstructorReturn3.default)(this,(ReqNoRight.__proto__||(0,_getPrototypeOf2.default)(ReqNoRight)).apply(this,arguments));}(0,_createClass3.default)(ReqNoRight,[{key:'componentDidMount',value:function componentDidMount(){document.title=(0,_convert.getLabel)(504627,'无权限');}},{key:'render',value:function render(){var _getEcCom=(0,_convert.getEcCom)(),WeaAlertPage=_getEcCom.WeaAlertPage;var paddingTop=(jQuery(window).height()-420)/2;var _props$location=this.props.location,location=_props$location===undefined?{}:_props$location;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var msg=(0,_convert.getLabel)(2012,'对不起，您暂时没有权限！');if(query.isSecNoRight=='1'){msg=(0,_convert.getLabel)(501082,'对不起，您的人员密级不足以查看该内容');}else if(query.isDelete&&query.isDelete!='undefined'){msg=(0,_convert.getLabel)(501606,'对不起，该流程已删除');}else if(query.isTest&&query.isTest!='undefined'){msg=(0,_convert.getLabel)(522931,'当前流程为测试状态，暂无法显示！');}return _react2.default.createElement(WeaAlertPage,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaAlertPage@1j4q0p',iconSize:200,style:{paddingTop:paddingTop}},_react2.default.createElement('div',{style:{fontSize:"16px",color:"#FFBB0E"}},msg,' '));}}]);return ReqNoRight;}(_react2.default.Component);exports.default=ReqNoRight;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _loadjs=__webpack_require__(83);var _loadjs2=_interopRequireDefault(_loadjs);var _fileConfig=__webpack_require__(18);var file=_interopRequireWildcard(_fileConfig);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=function(_React$Component){(0,_inherits3.default)(Main,_React$Component);function Main(){(0,_classCallCheck3.default)(this,Main);var _this=(0,_possibleConstructorReturn3.default)(this,(Main.__proto__||(0,_getPrototypeOf2.default)(Main)).call(this));_this.state={hasLoad:false};return _this;}(0,_createClass3.default)(Main,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//按顺序加载依赖的异步JS
var fileList=file.antdFiles.concat(file.ecComFiles);(0,_loadjs2.default)(fileList,{async:false,success:function success(){_this2.setState({hasLoad:true});}});}},{key:'render',value:function render(){var hasLoad=this.state.hasLoad;if(hasLoad){var location=this.props.location||{};var isBatch=location.query&&location.query.isBatch=="1";var Print=isBatch?__webpack_require__(713).default:__webpack_require__(714).default;return _react2.default.createElement(Print,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_Print@rz9egp'},this.props));}else{return _react2.default.createElement(_Loading2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Loading@hby7ea'});}}}]);return Main;}(_react2.default.Component);exports.default=Main;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BatchPrint=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(BatchPrint,_React$Component);function BatchPrint(){(0,_classCallCheck3.default)(this,BatchPrint);return(0,_possibleConstructorReturn3.default)(this,(BatchPrint.__proto__||(0,_getPrototypeOf2.default)(BatchPrint)).call(this));}(0,_createClass3.default)(BatchPrint,[{key:'getUrlStr',value:function getUrlStr(){var location=this.props.location;var urlParams=location.query||{};var range=["ismonitor"];var urlStr="";for(var key in urlParams){if(_.includes(range,key))urlStr+='&'+key+'='+urlParams[key];}return urlStr;}},{key:'render',value:function render(){var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var _getEcCom=(0,_convert.getEcCom)(),WeaRightMenu=_getEcCom.WeaRightMenu;var location=this.props.location||{};var printstr=location.query&&location.query.printstr;var printArr=printstr.split(",");var urlStr=this.getUrlStr();var printrequestids="";printArr.length>0&&printArr.map(function(item){var itemArr=item.split("|");var requestid=itemArr[0];if(itemArr.length===2){printrequestids+=","+requestid;}});if(printrequestids!=="")printrequestids=printrequestids.substring(1);window.batchPrintRequestidNum=printArr.length;window.batchPrintRequestids=printrequestids;return _react2.default.createElement('div',{className:'wf-batch-print'},printArr.length>0&&printArr.map(function(item,index){var itemArr=item.split("|");var requestid=itemArr[0];var modeid=itemArr[1];if(itemArr.length===2){var src=(window.ecologyContentPath||'')+'/workflow/request/PrintRequestSPA.jsp?isBatchPrint=true&ismode=2&modeid='+modeid+'&requestid='+requestid+urlStr;return _react2.default.createElement('div',{className:'wf-batch-print-item',style:{textAlign:"center",pageBreakBefore:index==0?"avoid":"always"}},_react2.default.createElement('iframe',{id:"request_"+requestid,src:src,style:{border:0,width:'100%',height:'100%'}}));}}));}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];btns.push({key:"print",icon:_react2.default.createElement('i',{className:'icon-coms-Print'}),content:(0,_convert.getLabel)(-1,'打印'),onClick:function onClick(key){window.print();}});return btns;}}]);return BatchPrint;}(_react2.default.Component))||_class;exports.default=BatchPrint;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(3);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(0);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(2);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(4);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(5);var _inherits3=_interopRequireDefault(_inherits2);var _dec,_class;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(8);var _convert=__webpack_require__(6);var _formUtil=__webpack_require__(11);var _req=__webpack_require__(15);var API_REQ=_interopRequireWildcard(_req);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);__webpack_require__(715);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PrintReq=(_dec=(0,_mobxReact.inject)("printReqStore"),_dec(_class=(0,_mobxReact.observer)(_class=function(_React$Component){(0,_inherits3.default)(PrintReq,_React$Component);function PrintReq(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,PrintReq);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=PrintReq.__proto__||(0,_getPrototypeOf2.default)(PrintReq)).call.apply(_ref,[this].concat(args))),_this),_this.doConfirm=function(){var browserVersion=(0,_formUtil.getBrowserVersion)();var printReqStore=_this.props.printReqStore;var templateKey=printReqStore.templateKey,urlParams=printReqStore.urlParams;var ismode=templateKey&&templateKey.split("_")[0]||"";if(browserVersion==="Chrome"&&parseInt(ismode)!==1){var reqIframe=document.getElementById("reqIframe");var printFn=function printFn(){var timeout=isNaN(parseInt(reqIframe.contentWindow.WfForm.printTimeout||""))?500:parseInt(reqIframe.contentWindow.WfForm.printTimeout);window.setTimeout(function(){if(reqIframe.contentWindow.WfForm){reqIframe.contentWindow.WfForm.changeFieldValue("field-9",{"value":parseInt(reqIframe.contentWindow.WfForm.getFieldValue("field-9"))+1});//代码块对页面打印次数加1，保证打印次数一致
}//未弹出页面需生成打印日志
API_REQ.generatePrintLog(urlParams);reqIframe.focus();reqIframe.contentWindow.print();},timeout);};var eventList=reqIframe.contentWindow.WfForm.eventList;GlobalUtil.verifyCustomRegisterEvent(_interface2.default.OPER_PRINTPREVIEW,printFn,undefined,eventList);}else{var printUrl=_this.buildIframeSrc();window.location.href=printUrl;}},_this.doCancel=function(){try{window.close();}catch(e){}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(PrintReq,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,printReqStore=_props.printReqStore,_props$location=_props.location,location=_props$location===undefined?{}:_props$location;printReqStore.loadTemplates(location.query);window.printReqStore=printReqStore;}},{key:'render',value:function render(){var _this2=this;var _getAntd=(0,_convert.getAntd)(),Button=_getAntd.Button;var printReqStore=this.props.printReqStore;var needChoose=printReqStore.needChoose,urlParams=printReqStore.urlParams,templates=printReqStore.templates,templateKey=printReqStore.templateKey,printBtnDisabled=printReqStore.printBtnDisabled;return _react2.default.createElement('div',{className:'wf-printReq'},_react2.default.createElement('div',{className:'wf-printReq-left'},_react2.default.createElement('div',{className:'wf-printReq-left-top'},_react2.default.createElement('span',null,(0,_convert.getLabel)(386164,'请选择打印模板'),':')),_react2.default.createElement('div',{className:'wf-printReq-left-items'},templates.map(function(item){return _react2.default.createElement('div',{className:'wf-printReq-left-item'},_react2.default.createElement('input',{type:'radio',name:'templateKey',checked:templateKey===item.key,onClick:_this2.chooseTemplate.bind(_this2,item.key,item.ismode)}),_react2.default.createElement('span',null,item.name));})),_react2.default.createElement('div',{className:'wf-printReq-left-bottom'},_react2.default.createElement(Button,{disabled:printBtnDisabled,ecId:(this&&this.props&&this.props.ecId||'')+'_Button@qxudwp',type:'primary',onClick:this.doConfirm},(0,_convert.getLabel)(83446,'确定')),_react2.default.createElement(Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@grimu0',type:'default',onClick:this.doCancel},(0,_convert.getLabel)(201,'取消')))),_react2.default.createElement('div',{className:'wf-printReq-right'},_react2.default.createElement('iframe',{id:'reqIframe',src:this.buildIframeSrc(true),style:{border:0,width:'100%',height:'100%'}})));}},{key:'buildIframeSrc',value:function buildIframeSrc(){var isPreView=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var printReqStore=this.props.printReqStore;var urlParams=printReqStore.urlParams,templateKey=printReqStore.templateKey;var iframeSrc="about:blank";if(templateKey!==""){var arr=templateKey.split("_");var iframeParams=(0,_extends3.default)({},urlParams,{ismode:arr[0],modeid:arr[1],isPreView:isPreView},{mulPrintMode:1});iframeSrc=(window.ecologyContentPath||'')+'/workflow/request/PrintRequestSPA.jsp?'+(0,_formUtil.buildUrlStr)(iframeParams);}return iframeSrc;}},{key:'chooseTemplate',value:function chooseTemplate(key,ismode){var printReqStore=this.props.printReqStore;var templateKey=printReqStore.templateKey;printReqStore.chooseTemplate(key);if(ismode==1){printReqStore.setPrintBtnDisabled(true);}else if(key!==templateKey){printReqStore.setPrintBtnDisabled(false);}}}]);return PrintReq;}(_react2.default.Component))||_class)||_class);exports.default=PrintReq;

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _reactAsyncComponent=__webpack_require__(189);var _Loading=__webpack_require__(19);var _Loading2=_interopRequireDefault(_Loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reactAsyncComponent.asyncComponent)({resolve:function resolve(){return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 732));},LoadingComponent:function LoadingComponent(){return _react2.default.createElement(_Loading2.default,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Loading@4q29hz'});}});

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(718);__webpack_require__(719);__webpack_require__(720);__webpack_require__(721);__webpack_require__(722);

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _stores=__webpack_require__(176);var _stores2=_interopRequireDefault(_stores);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}window.attentionUtil=function(){return{doAttentionType:function doAttentionType(requestid){var e=window.event||window.event;var offset=jQuery(".wf_attention_span_typeset").offset();var followSelectStore=_stores2.default.followSelectStore;// followSelectStore.setClickPotion({'x':e.clientX,'y':e.clientY})
followSelectStore.setClickPotion({'x':offset.left,'y':offset.top+10});followSelectStore.followTypeSelectShow=true;followSelectStore.FollowRequestid=requestid;},doAttention:function doAttention(requestid,id,rand){var divId="attentionDiv_"+requestid+"_"+id+"_"+rand;var spanId="attentionSpan_"+requestid+"_"+id+"_"+rand;if(jQuery("#"+divId).find("span").length==0){jQuery("#"+divId).addClass("wf_attention_div_btn_selected");jQuery("#"+divId).append("<span id='"+spanId+"' class='wf_attention_span_delbtn' onclick=\"attentionUtil.doDel("+requestid+","+id+",'"+rand+"')\">X</span>");}else{jQuery("#"+divId).removeClass("wf_attention_div_btn_selected");jQuery("#"+spanId).remove();}},doDel:function doDel(requestid,id,rand){window.followTypeSettingStore.reqid=requestid;window.followTypeSettingStore.saveAttention({src:'del',requestids:requestid,ids:id,rand:rand},"single");}};}();

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _convert=__webpack_require__(6);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var openFullWindowHaveBar=function openFullWindowHaveBar(url){var width=window.screen.availWidth-10;var height=window.screen.availHeight-50;var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";window.open(url,"",szFeatures);};window.openFullWindowHaveBar=openFullWindowHaveBar;var openUnFullWindow=function openUnFullWindow(url,width,height,top,left){var szFeatures="top="+top+",";szFeatures+="left="+left+",";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";window.open(url,"",szFeatures);};window.openUnFullWindow=openUnFullWindow;var openFullWindowHaveBarForWFList=function openFullWindowHaveBarForWFList(url,requestid){try{document.getElementById("wflist_"+requestid+"span").innerHTML="";}catch(e){}var redirectUrl=url;var width=window.screen.availWidth-10;var height=window.screen.availHeight-50;var szFeatures="top=0,";szFeatures+="left=0,";szFeatures+="width="+width+",";szFeatures+="height="+height+",";szFeatures+="directories=no,";szFeatures+="status=yes,toolbar=no,location=no,";szFeatures+="menubar=no,";szFeatures+="scrollbars=yes,";szFeatures+="resizable=yes";// channelmode
window.open(redirectUrl,"",szFeatures);};window.openFullWindowHaveBarForWFList=openFullWindowHaveBarForWFList;//图片懒加载
window.formImgLazyLoad=function(container){var _base$layoutStore$pro=_base2.default.layoutStore.propFileCfg,propFileCfg=_base$layoutStore$pro===undefined?{}:_base$layoutStore$pro;var _propFileCfg$handwrit=propFileCfg.handwriting_download_switch,handwriting_download_switch=_propFileCfg$handwrit===undefined?"0":_propFileCfg$handwrit;if(!!!container||container.length===0)return;// 获取父元素的高度
var contHeight=container.outerHeight();var contWidth=container.outerWidth();// 获取父元素相对于文档页顶部的距离，这边要注意了，分为以下两种情况；
if(container.get(0)===window){// 第一种情况父元素为window，获取浏览器滚动条已滚动的距离；$(window)没有offset()方法；
var contop=$(window).scrollTop();var conleft=$(window).scrollLeft();}else{// 第二种情况父元素为非window元素，获取它的滚动条滚动的距离；
var contop=container.offset().top;var conleft=container.offset().left;}container.find("img[original-src]").each(function(){//对象顶部与文档顶部之间的距离，如果它小于父元素底部与文档顶部的距离，则说明垂直方向上已经进入可视区域了；
//console.log("jQuery(this).offset().top--",jQuery(this).offset().top,"contop--",contop,"contHeight--",contHeight)
var post=jQuery(this).offset().top-(contop+contHeight);//对象底部与文档顶部之间的距离，如果它大于父元素顶部与文档顶部的距离，则说明垂直方向上已经进入可视区域了；
var posb=jQuery(this).offset().top+jQuery(this).height()-contop;// 水平方向上同理；
var posl=jQuery(this).offset().left-(conleft+contWidth);var posr=jQuery(this).offset().left+jQuery(this).width()-conleft;//console.log("jQuery(this).is(':visible')",jQuery(this).is(':visible'),"post--",post,"posb--",posb,"posl--",posl,"posr--",posr);
if(post<0&&posb>0&&posl<0&&posr>0){var originalSrc=jQuery(this).attr("original-src");if(originalSrc!=""){jQuery(this).removeAttr("src").attr("src",originalSrc).removeAttr("original-src");jQuery(this).removeAttr("style").attr("style",jQuery(this).attr("original-style")).removeAttr("original-style");jQuery(this).attr("width",jQuery(this).attr("original-width")).removeAttr("original-width");jQuery(this).attr("height",jQuery(this).attr("original-height")).removeAttr("original-height");jQuery(this).attr("onload",jQuery(this).attr("original-onload")).removeAttr("original-onload");jQuery(this).attr("onresize",jQuery(this).attr("original-onresize")).removeAttr("original-onresize");//签章图片和手写签批图片不能预览
var handwritingPre=handwriting_download_switch==1&&jQuery(this).attr("name")=="handWrittenSign";if(!jQuery(this).hasClass("signatureImg")&&!handwritingPre){//不是个性化签章和手写签批可以预览
//绑定图片预览事件
jQuery(this).addClass("formImgPlay");jQuery(this).bind("click",function(){window.imageCarousel(this);});}else{//禁止预览和拖拽
jQuery(this).on('mousedown',function(e){e.preventDefault();});jQuery(this).attr("draggable",false);}if(jQuery(this).hasClass("handWrittenSign")){GlobalUtil.handWritingHander(this);}}}});};//相关交流中的图片加载
window.communicateImgLoad=function(container){var _base$layoutStore$pro2=_base2.default.layoutStore.propFileCfg,propFileCfg=_base$layoutStore$pro2===undefined?{}:_base$layoutStore$pro2;var _propFileCfg$handwrit2=propFileCfg.handwriting_download_switch,handwriting_download_switch=_propFileCfg$handwrit2===undefined?"0":_propFileCfg$handwrit2;if(!!!container||container.length===0)return;// 获取父元素的高度
var contHeight=container.outerHeight();var contWidth=container.outerWidth();// 获取父元素相对于文档页顶部的距离，这边要注意了，分为以下两种情况；
if(container.get(0)===window){// 第一种情况父元素为window，获取浏览器滚动条已滚动的距离；$(window)没有offset()方法；
var contop=$(window).scrollTop();var conleft=$(window).scrollLeft();}else{// 第二种情况父元素为非window元素，获取它的滚动条滚动的距离；
var contop=container.offset().top;var conleft=container.offset().left;}container.find("img[original-src]").each(function(){//对象顶部与文档顶部之间的距离，如果它小于父元素底部与文档顶部的距离，则说明垂直方向上已经进入可视区域了；
//console.log("jQuery(this).offset().top--",jQuery(this).offset().top,"contop--",contop,"contHeight--",contHeight)
var post=jQuery(this).offset().top-(contop+contHeight);//对象底部与文档顶部之间的距离，如果它大于父元素顶部与文档顶部的距离，则说明垂直方向上已经进入可视区域了；
var posb=jQuery(this).offset().top+jQuery(this).height()-contop;// 水平方向上同理；
var posl=jQuery(this).offset().left-(conleft+contWidth);var posr=jQuery(this).offset().left+jQuery(this).width()-conleft;//console.log("jQuery(this).is(':visible')",jQuery(this).is(':visible'),"post--",post,"posb--",posb,"posl--",posl,"posr--",posr);
if(post<0&&posb>0&&posl<0&&posr>0){var originalSrc=jQuery(this).attr("original-src");if(originalSrc!=""){jQuery(this).removeAttr("src").attr("src",originalSrc).removeAttr("original-src");if(jQuery(this).attr("original-style")){jQuery(this).removeAttr("style").attr("style",jQuery(this).attr("original-style")).removeAttr("original-style");}if(jQuery(this).attr("original-width")){jQuery(this).attr("width",jQuery(this).attr("original-width")).removeAttr("original-width");}if(jQuery(this).attr("original-height")){jQuery(this).attr("height",jQuery(this).attr("original-height")).removeAttr("original-height");}jQuery(this).attr("onload",jQuery(this).attr("original-onload")).removeAttr("original-onload");jQuery(this).attr("onresize",jQuery(this).attr("original-onresize")).removeAttr("original-onresize");//签章图片和手写签批图片不能预览
var handwritingPre=handwriting_download_switch==1&&jQuery(this).attr("name")=="handWrittenSign";if(!jQuery(this).hasClass("signatureImg")&&!handwritingPre){//不是个性化签章和手写签批可以预览
//绑定图片预览事件
jQuery(this).addClass("formImgPlay");jQuery(this).bind("click",function(){window.imageCarousel(this);});}else{//禁止预览和拖拽
jQuery(this).on('mousedown',function(e){e.preventDefault();});jQuery(this).attr("draggable",false);}if(jQuery(this).hasClass("handWrittenSign")){GlobalUtil.handWritingHander(this);}}}});};//图片放大轮播
window.imageCarousel=function(imgObj){var imgPool=[];var indexNum=0;var curImgSrc=!!jQuery(imgObj).attr("data-imgsrc")?jQuery(imgObj).attr("data-imgsrc"):jQuery(imgObj).attr("src");var hasCalaulate=false;jQuery(".formImgPlay").each(function(){var imgsrc=!!jQuery(this).attr("data-imgsrc")?jQuery(this).attr("data-imgsrc"):jQuery(this).attr("src");if(!!imgsrc){imgPool.push(imgsrc);if(curImgSrc===imgsrc&&jQuery(imgObj).closest(".excelMainTable").length===jQuery(this).closest(".excelMainTable").length){hasCalaulate=true;}else{if(!hasCalaulate)indexNum++;}}});IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);};//系统提醒工作流需要相关JS
var errorNoticeUtil={handleResetBtn:function handleResetBtn(){var url=jQuery('#wfSErrorResetBtn').attr('href');var title=jQuery('#wfSErrorResetBtn').attr('title');var type=jQuery('#wfSErrorResetBtn').attr('type');jQuery('#wfSErrorResetBtn').attr('href','javascript:void(0)').removeAttr('target').removeAttr('title');jQuery('#wfSErrorResetBtn').attr('onclick',"errorNoticeUtil.resetWorkflowCfg('"+url+"','"+title+"','"+type+"')");jQuery("#wfSErrorResetBtn").removeAttr('style');},resetWorkflowCfg:function resetWorkflowCfg(url,title,type){if(type=='3'){openFullWindowHaveBar(url);return;}else if(type=='1'||type=='2'){url=(window.ecologyContentPath||'')+'/spa/workflow/static4engine/engine.html#/main/workflowengine/path/pathSet/pathDetail/flowSet/nodeInfo?needBaseTab=false&showLeftTree=false&workflowId='+url;openFullWindowHaveBar(url);}},triggerSystemWorkflow:function triggerSystemWorkflow(prefix,url,title,loginuserid,type){var globalStore=window.WfForm.getGlobalStore();var _globalStore$commonPa=globalStore.commonParam,requestid=_globalStore$commonPa.requestid,belongTest=_globalStore$commonPa.belongTest;if(belongTest){var _getAntd=(0,_convert.getAntd)(),Modal=_getAntd.Modal;Modal.warning({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(386161,"此操作暂不支持流程测试!"),okText:(0,_convert.getLabel)(83446,'\u786E\u5B9A')});return;}prefix=prefix.replace(/~0~/g,"<span class='importantInfo'>");prefix=prefix.replace(/~1~/g,"</span>");prefix=prefix.replace(/~2~/g,"<span class='importantDetailInfo'>");var infohtml=jQuery('.wf-error-msg-detail').html();if(!infohtml){infohtml="";}else{infohtml='<div class="wf-error-msg-detail">'+infohtml+'</div>';}var botfix=type=="3"?(0,_convert.getLabel)(18913,"流程干预"):(0,_convert.getLabel)(126558,"进行设置");var messagedetail=infohtml+'<span>'+prefix+'\uFF0C\u8BF7<a id="wfSErrorResetBtn" href="'+url+'" title="'+title+'" type="'+type+'"> \u70B9\u51FB\u8FD9\u91CC </a>'+botfix+'</span>';jQuery.ajax({type:'post',url:(window.ecologyContentPath||'')+'/workflow/request/TriggerRemindWorkflow.jsp?_random='+new Date().getTime(),data:{remark:messagedetail,loginuserid:loginuserid,requestid:requestid},error:function error(XMLHttpRequest,textStatus,errorThrown){var _getAntd2=(0,_convert.getAntd)(),Modal=_getAntd2.Modal;Modal.error({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(22397,'发送失败'),okText:(0,_convert.getLabel)(83446,'确定')});},success:function success(data,textStatus){var _getAntd3=(0,_convert.getAntd)(),Modal=_getAntd3.Modal;Modal.success({title:(0,_convert.getLabel)(131329,'信息确认'),content:(0,_convert.getLabel)(516558,'已成功向提醒人发送提醒流程'),okText:(0,_convert.getLabel)(83446,'确定')});}});}};window.errorNoticeUtil=errorNoticeUtil;//错误提示，后台设置链接
window.resetWorkflow=errorNoticeUtil.resetWorkflowCfg;//生成系统提醒流程
window.triggerSystemWorkflow=errorNoticeUtil.triggerSystemWorkflow;//Iframe区域相关方法
window.iframeOperate=function(){function showIframeArea(vthis){jQuery(vthis).closest("td").find(".iframeLoading").hide();jQuery(vthis).show();}//Iframe区域高度自适应高度
function autoAdjustHeight(vthis){var iframeObj=jQuery(vthis);var funObj=function funObj(){autoAdjustHeight(vthis);};var eachcount=parseInt(iframeObj.attr("eachcount"));if(eachcount>10){iframeObj.css("height","100px");return;}if(window.customAutoAdjustHeight&&typeof window.customAutoAdjustHeight=="function"){window.customAutoAdjustHeight(vthis);}else{var contextObj=iframeObj[0].contentWindow.document;var bodyContentHeight=contextObj.body.scrollHeight;//if(window.console) console.log("scrollHeight:"+bodyContentHeight+"  |offsetHeight:"+contextObj.body.offsetHeight)
if(bodyContentHeight==0){iframeObj.attr("eachcount",eachcount+1);window.setTimeout(funObj,500);}else{iframeObj.css("height",bodyContentHeight+"px");}}}return{//Iframe区域onload事件
loadingOver:function loadingOver(vthis){if(jQuery(vthis).attr("adjustheight")=="y"){window.setTimeout(function(){showIframeArea(vthis);autoAdjustHeight(vthis);},800);}else{showIframeArea(vthis);}}};}();//二维码、条形码相关方法
window.scancodeOperate=function(){function adjustSize_scancode(vthis){try{var parentHeight=vthis.closest("td").height();var curHeight=vthis.height();//if(window.console)console.log("二维码/条形码宽度调整:"+parentHeight+"  |  "+curHeight);
if(parseInt(parentHeight)-parseInt(curHeight)>8)//td高度会包含图片高度及上边框高度，避免死循环触发
vthis.css("height",parentHeight);}catch(e){}}return{//ready触发自适应单元格大小（针对所在行存在高度渐变时，故绑定个resize）
readyAdjustSize:function readyAdjustSize(obj){var vthis=jQuery(obj);vthis.resize(function(){adjustSize_scancode(vthis);});adjustSize_scancode(vthis);}};}();window.handWritingHander=function(vthis){if(vthis)GlobalUtil.handWritingHander(vthis);};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _jquery=__webpack_require__(127);var _jquery2=_interopRequireDefault(_jquery);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_jquery2.default.prototype.val=function(base){return function(){var tid=(0,_jquery2.default)(this).attr("id");if(!tid){var selector=(0,_jquery2.default)(this).selector;if(selector.indexOf('#')===0){tid=selector.substring(1);}}var isSetting=arguments.length>0,val=isSetting?arguments[0]:null;//调用jq原方法
if(isSetting&&typeof base=="function"){base.call(this,val);}else{if(__judgeBelFormField(tid)){//获取redux中的值
return window.WfForm.getFieldValue(tid);}return base.call(this);}if(__judgeBelFormField(tid)){//更新redux的值
window.WfForm.changeFieldValue(tid,{value:val});}return this;};}(_jquery2.default.prototype.val);//原方法作为参数传入
_jquery2.default.prototype.html=function(base){return function(){var tid=this.attr("id");var isSetting=arguments.length>0,htmlStr=isSetting?arguments[0]:null;//调用jq原方法
if(isSetting&&typeof base=="function"){base.call(this,htmlStr);if(!!tid&&tid.length>8&&tid.substring(tid.length-4)==="span"){var fieldMark=tid.substring(0,tid.length-4);var fieldObj=(0,_jquery2.default)("#"+fieldMark);if(fieldObj.length>0&&__judgeBelFormField(fieldMark)){window.WfForm.changeFieldValue(fieldMark,{value:fieldObj.val(),showhtml:htmlStr});}}}else{return base.call(this);}return this;};}(_jquery2.default.prototype.html);//原方法作为参数传入
/**
 * 严格判断DOM对象是否是表单字段
 */function __judgeBelFormField(tid){var bel=false;if(!!tid&&new RegExp("^field\\d+(_\\d+)?$").test(tid)&&typeof window.WfForm.getFieldInfo==="function"){var fieldid=tid.indexOf("_")>-1?tid.substring(5,tid.indexOf("_")):tid.substring(5);if(window.WfForm.getFieldInfo(fieldid)!==null)bel=true;}return bel;}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(29);var _stringify2=_interopRequireDefault(_stringify);var _loadjs=__webpack_require__(83);var _loadjs2=_interopRequireDefault(_loadjs);var _secondAuth=__webpack_require__(249);var _convert=__webpack_require__(6);var _secondAuthType=__webpack_require__(47);var authTypes=_interopRequireWildcard(_secondAuthType);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _getEcCom=(0,_convert.getEcCom)(),WeaLocaleProvider=_getEcCom.WeaLocaleProvider;var getLabel=WeaLocaleProvider.getLabel;/**
 * 格式化日期的工具类方法
 * @param fmt
 */var formatDate4QysUkey=function formatDate4QysUkey(date,fmt){var that=date;var o={"M+":that.getMonth()+1,//月份
"d+":that.getDate(),//日
"h+":that.getHours(),//小时
"m+":that.getMinutes(),//分
"s+":that.getSeconds(),//秒
"q+":Math.floor((that.getMonth()+3)/3),//季度
"S":that.getMilliseconds()//毫秒
};if(/(y+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,(that.getFullYear()+"").substr(4-RegExp.$1.length));}for(var k in o){if(new RegExp("("+k+")").test(fmt)){fmt=fmt.replace(RegExp.$1,RegExp.$1.length==1?o[k]:("00"+o[k]).substr((""+o[k]).length));}}return fmt;};var QYSUKeyUtil=function(){/**
     * 契约锁ukey的js库
     */var resourceFiles=["/workflow/qyskey/HTML.SDK.js"];/**
     * 契约锁html签章实例
     */var qysHtmlInstance=null;/**
     *  异步加载契约锁js sdk资源
     */var ayncLoadResource=function ayncLoadResource(callback,para){var callbackFn=function callbackFn(){callback&&callback(para);};_loadjs2.default.isDefined('qysHtml4Ukey')?_loadjs2.default.ready('qysHtml4Ukey',callbackFn):(0,_loadjs2.default)(resourceFiles,'qysHtml4Ukey',callbackFn);};var showMessage=function showMessage(txt){};/**
     * 异步加载契约锁js sdk资源，然后弹出认证窗口
     */var showSignWin0=function showSignWin0(store){if(qysHtmlInstance==null){qysHtmlInstance=new window.QysHtml(showMessage);}var params=store.params,secondAuthType=store.secondAuthType,protectType=store.protectType,isProtectDialog=store.isProtectDialog,callbackFunc=store.callbackFunc,callbackParam=store.callbackParam;var _params$authKey=params.authKey,authKey=_params$authKey===undefined?"":_params$authKey,_params$sourcestr=params.sourcestr,sourcestr=_params$sourcestr===undefined?"":_params$sourcestr;/**
         * 签署成功的回调方法
         */var completeSign=function completeSign(result){result=JSON.parse(result);var _result=result,p7=_result.p7,timeStamp=_result.timeStamp,apperance=_result.apperance;/**
             *************** 做流程的提交操作********************
             */var data={plaintext:sourcestr,p7:p7};var _getAntd=(0,_convert.getAntd)(),message=_getAntd.message;//调用js SDK接口获取证书等信息
var verifyResult=qysHtmlInstance.verify((0,_stringify2.default)(data));var _verifyResult$result=verifyResult.result,vresult=_verifyResult$result===undefined?{}:_verifyResult$result,_verifyResult$code=verifyResult.code,code=_verifyResult$code===undefined?0:_verifyResult$code,_verifyResult$message=verifyResult.message,msg=_verifyResult$message===undefined?"":_verifyResult$message;if(code!=0){message.error(!!msg?msg:getLabel(389490,"认证失败"));return;}var _vresult$cert=vresult.cert,cert=_vresult$cert===undefined?{}:_vresult$cert;var _cert$validity=cert.validity,validity=_cert$validity===undefined?{}:_cert$validity;//参数按照顺序，分别是证书编号，所有者，证书颁发机构
var seriNo=cert.sn,corpName=cert.companyName,tenantName=cert.organizationName,caType=cert.certIssuer;//证书有效期
var dateFmt="yyyy-MM-dd hh:mm:ss";var notBefore=validity.notBefore,notAfter=validity.notAfter;var startTime=formatDate4QysUkey(notBefore,dateFmt);var endTime=formatDate4QysUkey(notAfter,dateFmt);var date=new Date(timeStamp);var signTime=formatDate4QysUkey(date,dateFmt);//选择的印章信息(base64格式的图片信息）
var qysSealImg=apperance.sealImg,position=apperance.position;var _position$width=position.width,qyswidth=_position$width===undefined?0:_position$width,_position$height=position.height,qysheight=_position$height===undefined?0:_position$height;var qysCertDetails={seriNo:seriNo,tenantName:tenantName,caType:caType,startTime:startTime,endTime:endTime,signTime:signTime,qyswidth:qyswidth,qysheight:qysheight,corpName:corpName};var checkSuccess=function checkSuccess(){if(isProtectDialog==1){store.setDialogResult({isProtectSuccess:1});//数据保护成功
}else if(isProtectDialog==10){//CA认证 + CA数据保护 或者 契约锁认证 + 契约锁数据保护
store.setDialogResult({isProtectSuccess:1});//数据保护成功
store.setDialogResult({isAuthSuccess:1});//二次验证成功
}else{//二次验证：CA或者契约锁验证
store.setDialogResult({isAuthSuccess:1});//二次验证成功
}//契约锁验证或者数据保护，保存印章信息
if(secondAuthType==authTypes.QYS||isProtectDialog==1&&protectType==authTypes.QYS){var _params=store.params;store.setParams((0,_extends3.default)({},_params,{qysSealId:0,qysSealImg:qysSealImg,qysCertDetails:(0,_stringify2.default)(qysCertDetails)}));}if(callbackFunc&&typeof callbackFunc=="function"){callbackFunc.call({},callbackParam);//调用提交流程的方法
store.setSecondAuthPop();//表示当前流程已成功进行过一次验证
}};/**
             ***************************** 将验证的结果存入数据库*******************
             */if(isProtectDialog==1||isProtectDialog==10){//如果是数据保护，则先保存加密数据，否则直接提交流程
(0,_secondAuth.saveCAAuthResult)({authKey:authKey,signValue:p7}).then(function(response){var success=response.success;if(success==1){//保存成功
checkSuccess();//提交流程
}else{message.error(getLabel(389490,"认证失败"));}});}else{checkSuccess();//提交流程
}};var para={plaintext:sourcestr,position:{x:'50%',y:'50%'}};qysHtmlInstance.selectSeal((0,_stringify2.default)(para),completeSign);};return{showSignWin:function showSignWin(store){ayncLoadResource(showSignWin0,store);}};}();window.QYSUKeyUtil=QYSUKeyUtil;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WfForm_PC=undefined;var _typeof2=__webpack_require__(35);var _typeof3=_interopRequireDefault(_typeof2);var _extends2=__webpack_require__(7);var _extends3=_interopRequireDefault(_extends2);var _base=__webpack_require__(12);var _base2=_interopRequireDefault(_base);var _interface=__webpack_require__(39);var _interface2=_interopRequireDefault(_interface);var _rightBtn=__webpack_require__(85);var rightBtn=_interopRequireWildcard(_rightBtn);var _convert=__webpack_require__(6);var _common=__webpack_require__(10);var _=_interopRequireWildcard(_common);var _globalUtil=__webpack_require__(30);var GlobalUtil=_interopRequireWildcard(_globalUtil);var _submit=__webpack_require__(57);var SubmitUtil=_interopRequireWildcard(_submit);var _formUtil=__webpack_require__(11);var Util=_interopRequireWildcard(_formUtil);var _signUtil=__webpack_require__(58);var _CellType=__webpack_require__(136);var _CellType2=_interopRequireDefault(_CellType);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WfForm_PC=exports.WfForm_PC={showMessage:function showMessage(msg){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var duration=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1.5;var message=window.antd.message;if(type===1)//警告
message.warning(msg,duration);else if(type===2)//错误
message.error(msg,duration);else if(type===3)//成功
message.success(msg,duration);else//普通信息
message.info(msg,duration);},showConfirm:function showConfirm(content,okEvent,cancelEvent){var otherInfo=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var _getAntd=(0,_convert.getAntd)(),Modal=_getAntd.Modal;Modal.confirm({title:otherInfo.title||(0,_convert.getLabel)(131329,'信息确认'),content:React.createElement("div",{dangerouslySetInnerHTML:{__html:content}}),okText:otherInfo.okText||(0,_convert.getLabel)(826,'确定'),cancelText:otherInfo.cancelText||(0,_convert.getLabel)(201,'取消'),onOk:function onOk(){typeof okEvent==="function"&&okEvent();},onCancel:function onCancel(){typeof cancelEvent==="function"&&cancelEvent();}});},getSignRemark:function getSignRemark(){return window.CK_REF&&window.CK_REF.remark?window.CK_REF.remark.getData():"";},/**
     * 设置签字意见
     * @param {html} 要插入的内容
     * @param {position} 要插入的位置
     * @param {isClear} 默认为false替换意见内容，true追加意见内容
     * @param {callback} 插入成功后的回调函数
     */setSignRemark:function setSignRemark(html){var isClear=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var isAfter=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var callback=arguments[3];var _base$globalStore=_base2.default.globalStore,commonParam=_base$globalStore.commonParam,changeSubmitParam=_base$globalStore.changeSubmitParam;var _commonParam$isHideIn=commonParam.isHideInput,isHideInput=_commonParam$isHideIn===undefined?"":_commonParam$isHideIn;if(isHideInput==1){changeSubmitParam({remark:html});return;}var fun=function fun(html,isClear,isAfter,callback){var _base$globalStore2=_base2.default.globalStore,controlVariableMap=_base$globalStore2.controlVariableMap,variableMap=_base$globalStore2.variableMap;var isShowSignInput=variableMap.has("isShowSignInput")?variableMap.get("isShowSignInput"):false;//不展开签字意见框可能会设置不生效，ck需要先初始化
if(!isShowSignInput){controlVariableMap("isShowSignInput",true);}if(window.CK_REF&&window.CK_REF.remark){var markInfo=_base2.default.globalStore.markInfo;var use_textarea_signinput=markInfo.use_textarea_signinput;var value="";if(use_textarea_signinput==1){value=window.CK_REF?window.CK_REF.remark.getEditor().getData():"";value=(0,_signUtil.convertSpecialChar)(value);value=isClear?html:isAfter?value+html:html+value;changeSubmitParam({remark:value});window.CK_REF.remark.setState({value:value});if(typeof callback==="function"){callback();}}else{value=window.CK_REF?window.CK_REF.remark.getEditor().getData():"";window.CK_REF.remark.insertHTML(html,isAfter?"last":"first",isClear,callback);html='<p>'+html+"</p>";value=isClear?html:isAfter?value+html:html+value;changeSubmitParam({remark:value});}if(window.REMARK_CK_REF&&window.REMARK_CK_REF.refs&&window.REMARK_CK_REF.refs.signInput&&window.REMARK_CK_REF.refs.signInput.doOnChangeEvent){window.REMARK_CK_REF.refs.signInput.doOnChangeEvent(value);}}else{setTimeout(function(){fun(html,isClear,isAfter,callback);},200);}};fun(html,isClear,isAfter,callback);},reloadPage:function reloadPage(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var requestid=_base2.default.globalStore.commonParam.requestid;var newParams=(0,_extends3.default)({requestid:requestid},params);(0,_formUtil.reloadRequestPage)(newParams);},reloadListPage:_formUtil.reloadListPage,downLoadFile:function downLoadFile(fileid){var commonParam=_base2.default.globalStore.commonParam;var requestid=commonParam.requestid,authStr=commonParam.authStr,authSignatureStr=commonParam.authSignatureStr,f_weaver_belongto_userid=commonParam.f_weaver_belongto_userid,f_weaver_belongto_usertype=commonParam.f_weaver_belongto_usertype;var url="/weaver/weaver.file.FileDownload?fileid="+fileid+"&download=1"+"&fromrequest=1";url+='&requestid='+requestid+'&authStr='+authStr+'&authSignatureStr='+authSignatureStr+'&f_weaver_belongto_userid='+f_weaver_belongto_userid+'&f_weaver_belongto_usertype='+f_weaver_belongto_usertype;var ua=window.navigator.userAgent;if(Number(ua.replace(/^.*Chrome\/([\d]+).*$/,"$1"))>=73){window.open(url);}else{jQuery("iframe#WfFormFileDownload").attr("src","about:blank").attr("src",url+'&random='+new Date().getTime());}},changeOdocConfig:function changeOdocConfig(info){_base2.default.layoutStore.setOdocInfo(info);},switchTab:function switchTab(key){(0,_formUtil.switchFormTab)(key);},doSave:function doSave(){this.doRightBtnEvent("BTN_WFSAVE");},doSubmit:function doSubmit(){var needwfback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"1";return SubmitUtil.doSubmitForm({actiontype:"requestOperation",src:"submit",needwfback:needwfback});},doIntervenor:function doIntervenor(){this.doRightBtnEvent("BTN_DOINTERVENOR");},doIntervenor4AutoTest:function doIntervenor4AutoTest(){rightBtn.doIntervenor();},doRightBtnEvent:function doRightBtnEvent(arg1){try{var rightMenu=mobx.toJS(_base2.default.globalStore.rightMenu.rightMenus);var btnObj=void 0;rightMenu&&rightMenu.map(function(item){if(typeof arg1==="string"&&arg1===item.type)btnObj=item;else if((typeof arg1==='undefined'?'undefined':(0,_typeof3.default)(arg1))==="object"&&arg1.type===item.type&&arg1.menuFun===item.menuFun&&arg1.menuName===item.menuName)btnObj=item;});if(btnObj!==null){GlobalUtil.executeRightBtnClick(btnObj,rightBtn);}}catch(e){}},rightBtn:rightBtn,recordNewDocid:function recordNewDocid(docid){//记录流程新建的文档id
},generateFieldContentComp:function generateFieldContentComp(fieldMark){var index=fieldMark.indexOf("_");var fieldid=index>-1?fieldMark.substring(5,index):fieldMark.substring(5);var rowIndex=index>-1?fieldMark.substring(index+1):-1;var fieldInfo=_interface2.default.getFieldInfo(fieldid);var symbol=fieldInfo.tableMark||"";if(symbol!==""){var detailProps=symbol.indexOf("detail")>-1?{rowIndex:rowIndex}:{};var cellObj={id:"0,0",etype:"3",field:fieldid};return React.createElement(_CellType2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_CellType@bpd2lq',symbol:symbol,cellObj:cellObj,detailProps:detailProps});}return React.createElement('span',null,'Field Not Exist');},appendSubmitParam:function appendSubmitParam(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_.forIn(obj,function(v,k){if(_.indexOf(GlobalUtil.importantParamRange,k)>-1)delete obj[k];});_base2.default.globalStore.changeSubmitParam(obj);},getFirstRequiredEmptyField:function getFirstRequiredEmptyField(){return SubmitUtil.verifyRequiredEmptyField();},verifyFormRequired:function verifyFormRequired(){var mustAddDetail=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var fieldRequired=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var flag=true;//校验并提示，必须新增空明细
if(mustAddDetail){flag=SubmitUtil.verifyMustAddDetail();}//校验并提升，第一个必填字段
if(fieldRequired&&flag){var emptyField=this.getFirstRequiredEmptyField();if(emptyField!==""){flag=false;window.setTimeout(function(){Util.showPrompt(emptyField,1);//明细可能需要切页，延时提示
},50);}}return flag;}};var WfForm=(0,_extends3.default)({},_interface2.default,WfForm_PC);window.WfForm=WfForm;window.wfform=WfForm;/**
 * 重写E8浏览按钮赋值的函数
 * @param fieldMark  字段标示
 * @param isMustInput 无效参数
 * @param data 修改的数据，JSON含id及name
 * @param _options 修改方式，替换/追加值
 */window._writeBackData=function(fieldMark,isMustInput,data,_options){try{if((typeof data==='undefined'?'undefined':(0,_typeof3.default)(data))!=="object")return;var _id=data.id||"";var _name=data.name||"";var options=jQuery.extend({replace:false,isSingle:true},_options);var value="";var specialobj=new Array();if(options.isSingle||options.replace){//替换值
value=_id;if(value!=="")specialobj.push({id:_id,name:_name});}else{//追加值
if(_id===""||_name==="")return;var curBrowValue=WfForm.getFieldValueObj(fieldMark)||{};value=(curBrowValue.value||"")+","+_id;specialobj=(curBrowValue.specialobj||new Array()).concat([{id:_id,name:_name}]);}WfForm.changeFieldValue(fieldMark,{value:value,specialobj:specialobj});}catch(e){if(window.console)console.log("_writeBackData Exception:"+e);}};

/***/ }),
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports) {

/*
    MIT License http://www.opensource.org/licenses/mit-license.php
    Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
    var list = [];
    // return the list of modules as css string
    list.toString = function toString() {
        return this.map(function (item) {
            var content = cssWithMappingToString(item, useSourceMap);
            if (item[2]) {
                return "@media " + item[2] + "{" + content + "}";
            }
            else {
                return content;
            }
        }).join("");
    };
    // import a list of modules into the list
    list.i = function (modules, mediaQuery) {
        if (typeof modules === "string")
            modules = [[null, modules, ""]];
        var alreadyImportedModules = {};
        for (var i = 0; i < this.length; i++) {
            var id = this[i][0];
            if (typeof id === "number")
                alreadyImportedModules[id] = true;
        }
        for (i = 0; i < modules.length; i++) {
            var item = modules[i];
            // skip already imported module
            // this implementation is not 100% perfect for weird media query combinations
            //  when a module is imported multiple times with different media queries.
            //  I hope this will never occur (Hey this way we have smaller bundles)
            if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
                if (mediaQuery && !item[2]) {
                    item[2] = mediaQuery;
                }
                else if (mediaQuery) {
                    item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
                }
                list.push(item);
            }
        }
    };
    return list;
};
function cssWithMappingToString(item, useSourceMap) {
    var content = item[1] || '';
    var cssMapping = item[3];
    if (!cssMapping) {
        return content;
    }
    if (useSourceMap && typeof btoa === 'function') {
        var sourceMapping = toComment(cssMapping);
        var sourceURLs = cssMapping.sources.map(function (source) {
            return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
        });
        return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
    }
    return [content].join('\n');
}
// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
    var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
    return '/*# ' + data + ' */';
}


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(490);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js?v=17e87248